export const settlements = [
  {
    "1":{
      "name":"\u041d\u041e\u0420\u0418\u041b\u042c\u0421\u041a",
      "longitude":88.200517,
      "latitude":69.3498394
    },
    "2":{
      "name":"\u0410\u0427\u0418\u041d\u0421\u041a",
      "longitude":90.4953964,
      "latitude":56.2694846
    },
    "3":{
      "name":"\u041a\u0420\u0410\u0421\u041d\u041e\u042f\u0420\u0421\u041a",
      "longitude":92.8725147,
      "latitude":56.0090968
    },
    "4":{
      "name":"\u041a\u0410\u041d\u0421\u041a",
      "longitude":95.706787,
      "latitude":56.205997
    },
    "5":{
      "name":"\u041a\u042b\u0417\u042b\u041b",
      "longitude":94.423325,
      "latitude":51.706715
    },
    "6":{
      "name":"\u041a\u0415\u041c\u0415\u0420\u041e\u0412\u041e",
      "longitude":86.087234,
      "latitude":55.355125
    },
    "7":{
      "name":"\u041b\u0415\u041d\u0418\u041d\u0421\u041a-\u041a\u0423\u0417\u041d\u0415\u0426\u041a\u0418\u0419",
      "longitude":86.166115,
      "latitude":54.665443
    },
    "8":{
      "name":"\u041a\u0418\u0421\u0415\u041b\u0401\u0412\u0421\u041a",
      "longitude":86.6354771,
      "latitude":54.0049872
    },
    "9":{
      "name":"\u041f\u0420\u041e\u041a\u041e\u041f\u042c\u0415\u0412\u0421\u041a",
      "longitude":86.737663,
      "latitude":53.890972
    },
    "10":{
      "name":"\u041d\u041e\u0412\u041e\u041a\u0423\u0417\u041d\u0415\u0426\u041a",
      "longitude":87.136101,
      "latitude":53.757607
    },
    "11":{
      "name":"\u041c\u0415\u0416\u0414\u0423\u0420\u0415\u0427\u0415\u041d\u0421\u041a",
      "longitude":88.0703443,
      "latitude":53.6863763
    },
    "12":{
      "name":"\u0410\u0411\u0410\u041a\u0410\u041d",
      "longitude":91.438873,
      "latitude":53.71529
    },
    "13":{
      "name":"\u0427\u0418\u0422\u0410",
      "longitude":113.500893,
      "latitude":52.033409
    },
    "14":{
      "name":"\u041e\u041c\u0421\u041a",
      "longitude":73.371529,
      "latitude":54.991375
    },
    "15":{
      "name":"\u0421\u0415\u0412\u0415\u0420\u0421\u041a",
      "longitude":84.881012,
      "latitude":56.603161
    },
    "16":{
      "name":"\u0422\u041e\u041c\u0421\u041a",
      "longitude":84.952324,
      "latitude":56.488712
    },
    "17":{
      "name":"\u041d\u041e\u0412\u041e\u0421\u0418\u0411\u0418\u0420\u0421\u041a",
      "longitude":82.9234509,
      "latitude":55.0282171
    },
    "18":{
      "name":"\u0411\u0415\u0420\u0414\u0421\u041a",
      "longitude":83.1068095,
      "latitude":54.75795
    },
    "19":{
      "name":"\u0411\u0420\u0410\u0422\u0421\u041a",
      "longitude":101.611282,
      "latitude":56.1633
    },
    "20":{
      "name":"\u0410\u041d\u0413\u0410\u0420\u0421\u041a",
      "longitude":103.8822032,
      "latitude":52.5308164
    },
    "21":{
      "name":"\u0418\u0420\u041a\u0423\u0422\u0421\u041a",
      "longitude":104.29201318326395,
      "latitude":52.28603309596527
    },
    "22":{
      "name":"\u0420\u0423\u0411\u0426\u041e\u0412\u0421\u041a",
      "longitude":81.216377,
      "latitude":51.527691
    },
    "23":{
      "name":"\u0411\u0410\u0420\u041d\u0410\u0423\u041b",
      "longitude":83.778412,
      "latitude":53.347378
    },
    "24":{
      "name":"\u0411\u0418\u0419\u0421\u041a",
      "longitude":85.2148673,
      "latitude":52.5394905
    },
    "25":{
      "name":"\u0423\u041b\u0410\u041d-\u0423\u0414\u042d",
      "longitude":107.5836959,
      "latitude":51.8357642
    },
    "26":{
      "name":"\u041a\u043e\u0440\u0433\u043e\u043d",
      "longitude":84.0439538,
      "latitude":51.0962984
    },
    "27":{
      "name":"\u0423\u0441\u0442\u044c-\u041a\u0443\u043c\u0438\u0440",
      "longitude":84.2868999,
      "latitude":51.0320863
    },
    "28":{
      "name":"\u0422\u0430\u043b\u0438\u0446\u0430",
      "longitude":84.3075025,
      "latitude":51.0372887
    },
    "29":{
      "name":"\u0422\u044e\u0434\u0440\u0430\u043b\u0430",
      "longitude":84.4891514,
      "latitude":50.9894894
    },
    "30":{
      "name":"\u041a\u0430\u0439\u0441\u044b\u043d",
      "longitude":84.5920139,
      "latitude":50.9493629
    },
    "31":{
      "name":"\u041a\u0430\u0440\u0430\u0433\u0430\u0439",
      "longitude":84.6189308,
      "latitude":50.39577
    },
    "32":{
      "name":"\u041a\u043e\u0437\u0443\u043b\u044c",
      "longitude":84.6896652,
      "latitude":50.9729098
    },
    "33":{
      "name":"\u0427\u0451\u0440\u043d\u044b\u0439 \u0410\u043d\u0443\u0439",
      "longitude":84.7276667,
      "latitude":51.3581364
    },
    "34":{
      "name":"\u041a\u0435\u043b\u0435\u0439",
      "longitude":84.7513736,
      "latitude":51.1751049
    },
    "35":{
      "name":"\u0423\u0441\u0442\u044c-\u041c\u0443\u0442\u0430",
      "longitude":84.7540343,
      "latitude":51.2264657
    },
    "36":{
      "name":"\u041e\u0437\u0435\u0440\u043d\u043e\u0435",
      "longitude":84.7620856,
      "latitude":51.0030743
    },
    "37":{
      "name":"\u0422\u0443\u0440\u043e\u0442\u0430",
      "longitude":84.7713486,
      "latitude":51.3143419
    },
    "38":{
      "name":"\u041c\u0435\u043d\u0434\u0443\u0440-\u0421\u043e\u043a\u043a\u043e\u043d",
      "longitude":84.8132539,
      "latitude":50.7960745
    },
    "39":{
      "name":"\u0411\u0430\u043d\u043d\u043e\u0435",
      "longitude":84.8716164,
      "latitude":50.3773821
    },
    "40":{
      "name":"\u042f\u043a\u043e\u043d\u0443\u0440",
      "longitude":84.8760395,
      "latitude":51.0350778
    },
    "41":{
      "name":"\u0411\u0435\u043b\u044b\u0439 \u0410\u043d\u0443\u0439",
      "longitude":84.8918872,
      "latitude":51.234327
    },
    "42":{
      "name":"\u041a\u044b\u0440\u043b\u044b\u043a",
      "longitude":84.9467182,
      "latitude":50.8059343
    },
    "43":{
      "name":"\u0421\u0443\u0433\u0430\u0448",
      "longitude":84.9589062,
      "latitude":50.5683012
    },
    "44":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u0411\u0435\u043b\u043e\u0430\u043d\u0443\u0439",
      "longitude":84.9837796,
      "latitude":51.1453616
    },
    "45":{
      "name":"\u041e\u0440\u043e",
      "longitude":85.0024675,
      "latitude":50.9112056
    },
    "46":{
      "name":"\u0422\u0430\u043b\u0434\u0430",
      "longitude":85.0182152,
      "latitude":50.5007073
    },
    "47":{
      "name":"\u042f\u0431\u043e\u0433\u0430\u043d",
      "longitude":85.0717762,
      "latitude":50.9092277
    },
    "48":{
      "name":"\u0418\u043b\u044c\u0438\u043d\u043a\u0430",
      "longitude":85.1084067,
      "latitude":51.4437736
    },
    "49":{
      "name":"\u0410\u043c\u0443\u0440",
      "longitude":85.1193237,
      "latitude":50.4002565
    },
    "50":{
      "name":"\u0411\u0430\u0440\u0430\u0433\u0430\u0448",
      "longitude":85.2010339,
      "latitude":51.2778898
    },
    "51":{
      "name":"\u042e\u0441\u0442\u0438\u043a",
      "longitude":85.2344437,
      "latitude":50.3590412
    },
    "52":{
      "name":"\u0411\u0435\u0448-\u041e\u0437\u0451\u043a",
      "longitude":85.2451524,
      "latitude":51.1232971
    },
    "53":{
      "name":"\u0428\u044b\u0440\u0433\u0430\u0439\u0442\u0443",
      "longitude":85.2916326,
      "latitude":51.2022756
    },
    "54":{
      "name":"\u041c\u0443\u0445\u043e\u0440-\u0427\u0435\u0440\u0433\u0430",
      "longitude":85.3499976,
      "latitude":51.407388
    },
    "55":{
      "name":"\u0422\u044e\u0433\u0443\u0440\u044e\u043a",
      "longitude":85.4039713,
      "latitude":50.3029947
    },
    "56":{
      "name":"\u0423\u043b\u0443\u0441\u0447\u0435\u0440\u0433\u0430",
      "longitude":85.4552236,
      "latitude":51.5148158
    },
    "57":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u044f\u044f \u0427\u0435\u0440\u0433\u0430",
      "longitude":85.458634,
      "latitude":51.3731497
    },
    "58":{
      "name":"\u041a\u0430\u0439\u0442\u0430\u043d\u0430\u043a",
      "longitude":85.4650823,
      "latitude":50.1559671
    },
    "59":{
      "name":"\u041e\u0433\u043d\u0435\u0432\u043a\u0430",
      "longitude":85.5137476,
      "latitude":50.2298209
    },
    "60":{
      "name":"\u0411\u0435\u0440\u0435\u0437\u043e\u0432\u043a\u0430",
      "longitude":85.53669,
      "latitude":50.243942
    },
    "61":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u0427\u0435\u0440\u0433\u0430",
      "longitude":85.5528456,
      "latitude":51.3431804
    },
    "62":{
      "name":"\u0415\u043b\u043e",
      "longitude":85.5591644,
      "latitude":50.7689085
    },
    "63":{
      "name":"\u0427\u0435\u0440\u0433\u0430",
      "longitude":85.569199,
      "latitude":51.570702
    },
    "64":{
      "name":"\u041a\u0430\u044f\u0440\u043b\u044b\u043a",
      "longitude":85.5774494,
      "latitude":50.6847582
    },
    "65":{
      "name":"\u041e\u0437\u0451\u0440\u043d\u043e\u0435",
      "longitude":85.5787024,
      "latitude":50.9079045
    },
    "66":{
      "name":"\u041a\u0430\u0440\u0430 \u041a\u043e\u0431\u044b",
      "longitude":85.5796641,
      "latitude":50.8150607
    },
    "67":{
      "name":"\u0414\u044a\u0435\u043a\u0442\u0438\u0435\u043a",
      "longitude":85.6090424,
      "latitude":51.2719675
    },
    "68":{
      "name":"\u041c\u044b\u044e\u0442\u0430",
      "longitude":85.6216874,
      "latitude":51.4177279
    },
    "69":{
      "name":"\u0422\u0435\u043d\u044c\u0433\u0430",
      "longitude":85.652866,
      "latitude":50.8382213
    },
    "70":{
      "name":"\u0411\u0430\u0448\u0442\u0430\u043b\u0430",
      "longitude":85.6595324,
      "latitude":50.2871581
    },
    "71":{
      "name":"\u0410\u043a\u0442\u0435\u043b",
      "longitude":85.6657777,
      "latitude":51.5192977
    },
    "72":{
      "name":"\u041a\u0430\u043c\u043b\u0430\u043a",
      "longitude":85.6668291,
      "latitude":51.6240334
    },
    "73":{
      "name":"\u041e\u043a\u0442\u044f\u0431\u0440\u044c\u0441\u043a\u043e\u0435",
      "longitude":85.7249679,
      "latitude":50.2409338
    },
    "74":{
      "name":"\u0428\u0438\u0431\u0430",
      "longitude":85.7382164,
      "latitude":50.848423
    },
    "75":{
      "name":"\u0412\u0435\u0440\u0445-\u0423\u0439\u043c\u043e\u043d",
      "longitude":85.739822,
      "latitude":50.212151
    },
    "76":{
      "name":"\u0423\u0441\u0442\u044c-\u041c\u0443\u043d\u044b",
      "longitude":85.762192,
      "latitude":51.722095
    },
    "77":{
      "name":"\u0423\u0441\u0442\u044c-\u0421\u0435\u043c\u0430",
      "longitude":85.762215,
      "latitude":51.641487
    },
    "78":{
      "name":"\u0412\u0435\u0440\u0445 \u0411\u0430\u0440\u0430\u043d\u0433\u043e\u043b",
      "longitude":85.7657043,
      "latitude":51.6539683
    },
    "79":{
      "name":"\u0422\u0430\u043b\u0434\u0430",
      "longitude":85.7673747,
      "latitude":50.8417939
    },
    "80":{
      "name":"\u041c\u0430\u043d\u0436\u0435\u0440\u043e\u043a",
      "longitude":85.7774361,
      "latitude":51.8310511
    },
    "81":{
      "name":"\u041a\u0443\u043b\u0430\u0434\u0430",
      "longitude":85.7802725,
      "latitude":50.6906609
    },
    "82":{
      "name":"\u0411\u0430\u0440\u0430\u043d\u0433\u043e\u043b",
      "longitude":85.781784,
      "latitude":51.678883
    },
    "83":{
      "name":"\u0427\u0435\u0440\u0435\u043c\u0448\u0430\u043d\u043a\u0430",
      "longitude":85.782997,
      "latitude":51.870026
    },
    "84":{
      "name":"\u041e\u0437\u0451\u0440\u043d\u043e\u0435",
      "longitude":85.7990141,
      "latitude":51.814701
    },
    "85":{
      "name":"\u0422\u0438\u0445\u043e\u043d\u044c\u043a\u0430\u044f",
      "longitude":85.8012916,
      "latitude":50.2020537
    },
    "86":{
      "name":"\u0411\u043e\u043e\u0447\u0438",
      "longitude":85.8172551,
      "latitude":50.7405218
    },
    "87":{
      "name":"\u0411\u0430\u0440\u0445\u0430\u0442\u043e\u0432\u043e",
      "longitude":85.8303114,
      "latitude":50.9184572
    },
    "88":{
      "name":"\u0427\u0435\u043f\u043e\u0448",
      "longitude":85.8317792,
      "latitude":51.5883105
    },
    "89":{
      "name":"\u0413\u043e\u0440\u0431\u0443\u043d\u043e\u0432\u043e",
      "longitude":85.8375549,
      "latitude":50.2226565
    },
    "90":{
      "name":"\u0414\u0443\u0431\u0440\u043e\u0432\u043a\u0430",
      "longitude":85.839424,
      "latitude":51.928261
    },
    "91":{
      "name":"\u0421\u043e\u0443\u0437\u0433\u0430",
      "longitude":85.849403,
      "latitude":51.886547
    },
    "92":{
      "name":"\u041a\u0430\u0440\u043b\u0443\u0448\u043a\u0430",
      "longitude":85.8515045,
      "latitude":51.9814669
    },
    "93":{
      "name":"\u0420\u044b\u0431\u0430\u043b\u043a\u0430",
      "longitude":85.8618254,
      "latitude":51.9166112
    },
    "94":{
      "name":"\u0422\u0435\u0440\u0435\u043a\u0442\u0430",
      "longitude":85.8739998,
      "latitude":50.2937144
    },
    "95":{
      "name":"\u0422\u0443\u0435\u043a\u0442\u0430",
      "longitude":85.8811841,
      "latitude":50.8388397
    },
    "96":{
      "name":"\u041f\u043e\u0434\u0433\u043e\u0440\u043d\u043e\u0435",
      "longitude":85.8883698,
      "latitude":52.0326576
    },
    "97":{
      "name":"\u0410\u0441\u043a\u0430\u0442",
      "longitude":85.897095,
      "latitude":51.537136
    },
    "98":{
      "name":"\u0412\u0435\u0440\u0445-\u0410\u043f\u0448\u0443\u044f\u0445\u0442\u0430",
      "longitude":85.9036885,
      "latitude":51.2340429
    },
    "99":{
      "name":"\u0411\u0438\u0447\u0438\u043a\u0442\u0443-\u0411\u043e\u043e\u043c",
      "longitude":85.9099912,
      "latitude":50.7914897
    },
    "100":{
      "name":"\u0423\u0437\u043d\u0435\u0437\u044f",
      "longitude":85.9424926,
      "latitude":51.5254227
    },
    "101":{
      "name":"\u0410\u043d\u043e\u0441",
      "longitude":85.944695,
      "latitude":51.500214
    },
    "102":{
      "name":"\u041a\u0430\u0440\u0430\u043a\u043e\u043b",
      "longitude":85.9461955,
      "latitude":50.8143273
    },
    "103":{
      "name":"\u0427\u0435\u043d\u0434\u0435\u043a",
      "longitude":85.9555126,
      "latitude":50.2652825
    },
    "104":{
      "name":"\u041c\u0443\u043b\u044c\u0442\u0430",
      "longitude":85.9588012,
      "latitude":50.1691036
    },
    "105":{
      "name":"\u041a\u0443\u0440\u043e\u0442\u0430",
      "longitude":85.9691123,
      "latitude":50.8140968
    },
    "106":{
      "name":"\u0417\u0430\u043c\u0443\u043b\u044c\u0442\u0430",
      "longitude":85.9730399,
      "latitude":50.1810709
    },
    "107":{
      "name":"\u041d\u0438\u0436\u043d\u044f\u044f \u0422\u0430\u043b\u0434\u0430",
      "longitude":85.9732179,
      "latitude":50.8590793
    },
    "108":{
      "name":"\u0410\u044e\u043b\u0430",
      "longitude":85.9761739,
      "latitude":51.4370615
    },
    "109":{
      "name":"\u042d\u043b\u0435\u043a\u043c\u043e\u043d\u0430\u0440",
      "longitude":85.993034,
      "latitude":51.457378
    },
    "110":{
      "name":"\u041a\u044b\u0437\u044b\u043b-\u041e\u0437\u0451\u043a",
      "longitude":85.9949911,
      "latitude":51.8924438
    },
    "111":{
      "name":"\u041a\u0430\u0441\u043f\u0430",
      "longitude":85.9978897,
      "latitude":51.1136002
    },
    "112":{
      "name":"\u0411\u0435\u0448\u043f\u0435\u043b\u044c\u0442\u0438\u0440",
      "longitude":86.0003208,
      "latitude":51.6313743
    },
    "113":{
      "name":"\u0410\u043b\u0444\u0451\u0440\u043e\u0432\u043e",
      "longitude":86.0028308,
      "latitude":51.9723343
    },
    "114":{
      "name":"\u0424\u0438\u043b\u0438\u0430\u043b",
      "longitude":86.0300647,
      "latitude":51.8392488
    },
    "115":{
      "name":"\u0428\u0430\u0448\u0438\u043a\u043c\u0430\u043d",
      "longitude":86.0566622,
      "latitude":50.7885879
    },
    "116":{
      "name":"\u0411\u0438\u0440\u044e\u043b\u044f",
      "longitude":86.0574061,
      "latitude":51.7795599
    },
    "117":{
      "name":"\u0412\u0435\u0440\u0445-\u041a\u0430\u0440\u0430\u0433\u0443\u0436",
      "longitude":86.057404,
      "latitude":52.054863
    },
    "118":{
      "name":"\u0422\u043e\u043b\u0433\u043e\u0435\u043a",
      "longitude":86.058212,
      "latitude":51.340599
    },
    "119":{
      "name":"\u0415\u043b\u0430\u043d\u0434\u0430",
      "longitude":86.092484,
      "latitude":51.222984
    },
    "120":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0439 \u041a\u0443\u044e\u043c",
      "longitude":86.09481,
      "latitude":51.56797
    },
    "121":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":86.1124715,
      "latitude":51.7400112
    },
    "122":{
      "name":"\u041e\u0440\u043e\u043a\u0442\u043e\u0439",
      "longitude":86.1134838,
      "latitude":51.0554047
    },
    "123":{
      "name":"\u041a\u0430\u0440\u0430\u0441\u0443\u043a",
      "longitude":86.141335,
      "latitude":51.850983
    },
    "124":{
      "name":"\u041a\u0430\u0442\u0430\u043d\u0434\u0430",
      "longitude":86.1769294,
      "latitude":50.1674347
    },
    "125":{
      "name":"\u0421\u0443\u0445\u043e\u0439 \u041a\u0430\u0440\u0430\u0441\u0443\u043a",
      "longitude":86.2009004,
      "latitude":51.9015226
    },
    "126":{
      "name":"\u041a\u0443\u044e\u0441",
      "longitude":86.23381,
      "latitude":51.02697
    },
    "127":{
      "name":"\u042d\u0434\u0438\u0433\u0430\u043d",
      "longitude":86.2606135,
      "latitude":51.1100258
    },
    "128":{
      "name":"\u0421\u0443\u0433\u0443\u043b",
      "longitude":86.2676864,
      "latitude":51.9440709
    },
    "129":{
      "name":"\u0425\u0430\u0431\u0430\u0440\u043e\u0432\u043a\u0430",
      "longitude":86.2880597,
      "latitude":50.6853699
    },
    "130":{
      "name":"\u0422\u044e\u043d\u0433\u0443\u0440",
      "longitude":86.3112599,
      "latitude":50.1608392
    },
    "131":{
      "name":"\u041a\u0443\u0447\u0435\u0440\u043b\u0430",
      "longitude":86.3245335,
      "latitude":50.1442076
    },
    "132":{
      "name":"\u041f\u0430\u0441\u043f\u0430\u0443\u043b",
      "longitude":86.346281,
      "latitude":51.9376061
    },
    "133":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u042f\u043b\u043e\u043c\u0430\u043d",
      "longitude":86.41597,
      "latitude":50.488804
    },
    "134":{
      "name":"\u041b\u0435\u0432\u0438\u043d\u043a\u0430",
      "longitude":86.4227353,
      "latitude":51.9837905
    },
    "135":{
      "name":"\u041a\u0443\u043f\u0447\u0435\u0433\u0435\u043d\u044c",
      "longitude":86.4253135,
      "latitude":50.6200073
    },
    "136":{
      "name":"\u0418\u043d\u044f",
      "longitude":86.627296,
      "latitude":50.454182
    },
    "137":{
      "name":"\u0418\u043d\u0435\u0433\u0435\u043d\u044c",
      "longitude":86.6968659,
      "latitude":50.3189127
    },
    "138":{
      "name":"\u041a\u0430\u0440\u0430\u043a\u043e\u043a\u0448\u0430",
      "longitude":86.6986068,
      "latitude":51.7664579
    },
    "139":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u041a\u0443\u0437\u044f",
      "longitude":86.7244747,
      "latitude":51.6986713
    },
    "140":{
      "name":"\u0421\u0451\u0439\u043a\u0430",
      "longitude":86.7347285,
      "latitude":51.882322
    },
    "141":{
      "name":"\u041e\u0437\u0435\u0440\u043e-\u041a\u0443\u0440\u0435\u0435\u0432\u043e",
      "longitude":86.751414,
      "latitude":52.4655521
    },
    "142":{
      "name":"\u042b\u043d\u044b\u0440\u0433\u0430",
      "longitude":86.79284,
      "latitude":51.8257768
    },
    "143":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u0441\u0435\u043b\u044c\u0441\u043a",
      "longitude":86.7943324,
      "latitude":51.8098691
    },
    "144":{
      "name":"\u0423\u0441\u043a\u0443\u0447",
      "longitude":86.9054117,
      "latitude":52.0363379
    },
    "145":{
      "name":"\u0414\u043c\u0438\u0442\u0440\u0438\u0435\u0432\u043a\u0430",
      "longitude":86.914474,
      "latitude":52.440552
    },
    "146":{
      "name":"\u0423\u0439\u043c\u0435\u043d\u044c",
      "longitude":86.9208461,
      "latitude":51.6573297
    },
    "147":{
      "name":"\u0418\u043e\u0434\u0440\u043e",
      "longitude":86.9765744,
      "latitude":50.3981337
    },
    "148":{
      "name":"\u0412\u0435\u0440\u0445-\u0411\u0438\u0439\u0441\u043a",
      "longitude":87.0911951,
      "latitude":52.0378376
    },
    "149":{
      "name":"\u0423\u0441\u0442\u044c-\u041f\u044b\u0436\u0430",
      "longitude":87.0915004,
      "latitude":51.8591327
    },
    "150":{
      "name":"\u041d\u043e\u0432\u043e\u0442\u0440\u043e\u0438\u0446\u043a",
      "longitude":87.1002871,
      "latitude":51.7599278
    },
    "151":{
      "name":"\u041a\u0435\u0431\u0435\u0437\u0435\u043d\u044c",
      "longitude":87.103081,
      "latitude":51.908039
    },
    "152":{
      "name":"\u0422\u043e\u043d\u0434\u043e\u0448\u043a\u0430",
      "longitude":87.1124508,
      "latitude":52.1201912
    },
    "153":{
      "name":"\u0410\u0440\u0442\u044b\u0431\u0430\u0448",
      "longitude":87.2517352,
      "latitude":51.7899858
    },
    "154":{
      "name":"\u0418\u043e\u0433\u0430\u0447",
      "longitude":87.253296,
      "latitude":51.784008
    },
    "155":{
      "name":"\u041a\u0430\u044f\u0448\u043a\u0430\u043d",
      "longitude":87.3605257,
      "latitude":52.3761057
    },
    "156":{
      "name":"\u0411\u0435\u043b\u044f\u0448\u0438",
      "longitude":87.42392,
      "latitude":49.708313
    },
    "157":{
      "name":"\u0427\u0438\u0431\u0438\u0442",
      "longitude":87.5060451,
      "latitude":50.31562
    },
    "158":{
      "name":"\u0410\u043a\u0442\u0430\u0448",
      "longitude":87.6028375,
      "latitude":50.3127248
    },
    "159":{
      "name":"\u041a\u0443\u0440\u043c\u0430\u0447-\u0411\u0430\u0439\u0433\u043e\u043b",
      "longitude":87.6589396,
      "latitude":52.1251372
    },
    "160":{
      "name":"\u0411\u0430\u043b\u044b\u043a\u0447\u0430",
      "longitude":87.7192822,
      "latitude":51.2844011
    },
    "161":{
      "name":"\u041f\u0430\u0441\u043f\u0430\u0440\u0442\u0430",
      "longitude":87.8815929,
      "latitude":50.8354928
    },
    "162":{
      "name":"\u0427\u0438\u0431\u0438\u043b\u044f",
      "longitude":87.91877,
      "latitude":50.621716
    },
    "163":{
      "name":"\u041a\u0443\u0440\u0430\u0439",
      "longitude":87.935722,
      "latitude":50.232323
    },
    "164":{
      "name":"\u041a\u044b\u0437\u044b\u043b-\u0422\u0430\u0448",
      "longitude":87.939804,
      "latitude":50.214592
    },
    "165":{
      "name":"\u0411\u0430\u043b\u044b\u043a\u0442\u0443\u044e\u043b\u044c",
      "longitude":88.041569,
      "latitude":50.7599549
    },
    "166":{
      "name":"\u041c\u0430\u0439\u0441\u043a",
      "longitude":88.145279,
      "latitude":52.330456
    },
    "167":{
      "name":"\u0411\u0435\u043b\u044c\u0442\u0438\u0440",
      "longitude":88.165741,
      "latitude":49.975143
    },
    "168":{
      "name":"\u0421\u0430\u0440\u0430\u0442\u0430\u043d",
      "longitude":88.2633266,
      "latitude":50.5219274
    },
    "169":{
      "name":"\u0427\u0430\u0433\u0430\u043d-\u0423\u0437\u0443\u043d",
      "longitude":88.3622738,
      "latitude":50.1020921
    },
    "170":{
      "name":"\u041e\u0440\u0442\u043e\u043b\u044b\u043a",
      "longitude":88.5003607,
      "latitude":50.0354722
    },
    "171":{
      "name":"\u041c\u0443\u0445\u043e\u0440-\u0422\u0430\u0440\u0445\u0430\u0442\u0430",
      "longitude":88.533943,
      "latitude":49.9879
    },
    "172":{
      "name":"\u041d\u043e\u0432\u044b\u0439 \u0411\u0435\u043b\u044c\u0442\u0438\u0440",
      "longitude":88.6026582,
      "latitude":49.9300519
    },
    "173":{
      "name":"\u0422\u0435\u043b\u0435\u043d\u0433\u0438\u0442-\u0421\u043e\u0440\u0442\u043e\u0433\u043e\u0439",
      "longitude":88.7512753,
      "latitude":50.0113215
    },
    "174":{
      "name":"\u042f\u0437\u0443\u043b\u0430",
      "longitude":88.7741393,
      "latitude":50.6166643
    },
    "175":{
      "name":"\u0422\u043e\u0431\u0435\u043b\u0435\u0440",
      "longitude":88.7945208,
      "latitude":49.9145513
    },
    "176":{
      "name":"\u0416\u0430\u043d\u0430-\u0410\u0443\u043b",
      "longitude":88.922668,
      "latitude":49.842999
    },
    "177":{
      "name":"\u041a\u043e\u043a\u043e\u0440\u044f",
      "longitude":89.001228,
      "latitude":49.913734
    },
    "178":{
      "name":"\u0422\u0430\u0448\u0430\u043d\u0442\u0430",
      "longitude":89.192589,
      "latitude":49.717453
    },
    "179":{
      "name":"\u0414\u0438\u043a\u0441\u043e\u043d",
      "longitude":80.5123816,
      "latitude":73.5083894
    },
    "180":{
      "name":"\u041d\u043e\u0441\u043e\u043a",
      "longitude":82.347794,
      "latitude":70.163818
    },
    "181":{
      "name":"\u041a\u0430\u0440\u0430\u0443\u043b",
      "longitude":83.209244,
      "latitude":70.069992
    },
    "182":{
      "name":"\u0422\u0443\u0445\u0430\u0440\u0434",
      "longitude":84.336929,
      "latitude":69.293747
    },
    "183":{
      "name":"\u0423\u0441\u0442\u044c-\u041f\u043e\u0440\u0442",
      "longitude":84.407906,
      "latitude":69.663567
    },
    "184":{
      "name":"\u041a\u0435\u043b\u043b\u043e\u0433",
      "longitude":86.27655,
      "latitude":62.485683
    },
    "185":{
      "name":"\u041f\u043e\u0442\u0430\u043f\u043e\u0432\u043e",
      "longitude":86.2789108,
      "latitude":68.6836525
    },
    "186":{
      "name":"\u0424\u0430\u0440\u043a\u043e\u0432\u043e",
      "longitude":86.9762142,
      "latitude":65.7169203
    },
    "187":{
      "name":"\u0421\u043d\u0435\u0436\u043d\u043e\u0433\u043e\u0440\u0441\u043a",
      "longitude":87.790344,
      "latitude":68.095169
    },
    "188":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0435\u0438\u043c\u0431\u0430\u0442\u0441\u043a",
      "longitude":87.9639337,
      "latitude":63.1569728
    },
    "189":{
      "name":"\u0421\u044b\u043c",
      "longitude":88.3629839,
      "latitude":60.3491261
    },
    "190":{
      "name":"\u0421\u0432\u0435\u0442\u043b\u043e\u0433\u043e\u0440\u0441\u043a",
      "longitude":88.370033,
      "latitude":66.940491
    },
    "191":{
      "name":"\u0421\u0430\u043d\u0434\u0430\u043a\u0447\u0435\u0441",
      "longitude":88.5032855,
      "latitude":61.3038766
    },
    "192":{
      "name":"\u0418\u043d\u0433\u043e\u043b\u044c",
      "longitude":88.710587,
      "latitude":55.516315
    },
    "193":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":88.78997,
      "latitude":55.564251
    },
    "194":{
      "name":"\u0413\u043e\u0440\u044f\u0447\u0435\u0433\u043e\u0440\u0441\u043a",
      "longitude":88.915428,
      "latitude":55.405281
    },
    "195":{
      "name":"\u041f\u043e\u0432\u0430\u0440\u0435\u043d\u043a\u0438\u043d\u043e",
      "longitude":88.950058,
      "latitude":57.067268
    },
    "196":{
      "name":"\u0414\u0432\u0438\u043d\u043a\u0430",
      "longitude":88.971016,
      "latitude":56.483829
    },
    "197":{
      "name":"\u0411\u0435\u0437\u044b\u043c\u044f\u043d\u043a\u0430",
      "longitude":89.0004938,
      "latitude":59.305684
    },
    "198":{
      "name":"\u0412\u0435\u0440\u0445-\u0427\u0435\u0442\u0441\u043a",
      "longitude":89.064262,
      "latitude":56.922562
    },
    "199":{
      "name":"\u0414\u0443\u0431\u0438\u043d\u0438\u043d\u043e",
      "longitude":89.109779,
      "latitude":55.670662
    },
    "200":{
      "name":"\u0425\u043e\u043b\u043c\u043e\u0433\u043e\u0440\u0441\u043a\u043e\u0435",
      "longitude":89.131393,
      "latitude":55.46183
    },
    "201":{
      "name":"\u0411\u0435\u0440\u0435\u0448",
      "longitude":89.154678,
      "latitude":55.482769
    },
    "202":{
      "name":"\u041b\u0435\u043e\u043d\u0442\u044c\u0435\u0432\u043a\u0430",
      "longitude":89.16024,
      "latitude":56.606274
    },
    "203":{
      "name":"\u0420\u043e\u0434\u043d\u0438\u043a\u0438",
      "longitude":89.198967,
      "latitude":55.645168
    },
    "204":{
      "name":"\u0410\u0436\u0438\u043d\u0441\u043a\u043e\u0435",
      "longitude":89.212158,
      "latitude":55.549683
    },
    "205":{
      "name":"\u041f\u0430\u0440\u043d\u0430\u044f",
      "longitude":89.230446,
      "latitude":55.287418
    },
    "206":{
      "name":"\u041a\u0430\u0448\u0442\u0430\u043d",
      "longitude":89.248352,
      "latitude":56.117229
    },
    "207":{
      "name":"\u0422\u0435\u043c\u0440\u0430",
      "longitude":89.270065,
      "latitude":55.434406
    },
    "208":{
      "name":"\u0417\u0430\u0440\u0435\u0447\u0435\u043d\u043a\u0430",
      "longitude":89.2883,
      "latitude":56.582932
    },
    "209":{
      "name":"\u0413\u043b\u044f\u0434\u0435\u043d",
      "longitude":89.297432,
      "latitude":55.496422
    },
    "210":{
      "name":"\u0427\u0438\u043d\u0434\u0430\u0442",
      "longitude":89.300613,
      "latitude":57.377537
    },
    "211":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0435 \u041e\u0437\u0435\u0440\u043e",
      "longitude":89.318443,
      "latitude":55.189583
    },
    "212":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u0443\u0440\u0441\u043a",
      "longitude":89.318787,
      "latitude":55.759022
    },
    "213":{
      "name":"\u042e\u0440\u044c\u0435\u0432\u043a\u0430",
      "longitude":89.322311,
      "latitude":56.315815
    },
    "214":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":89.343414,
      "latitude":56.009918
    },
    "215":{
      "name":"\u041c\u0430\u043b\u043e\u0435 \u041e\u0437\u0435\u0440\u043e",
      "longitude":89.344162,
      "latitude":55.126801
    },
    "216":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u041a\u043e\u0441\u0443\u043b\u044c",
      "longitude":89.349327,
      "latitude":56.133965
    },
    "217":{
      "name":"\u0421\u043a\u0440\u0438\u043f\u0430\u0447\u0438",
      "longitude":89.383156,
      "latitude":55.790306
    },
    "218":{
      "name":"\u041a\u0440\u0430\u0441\u0438\u043d\u043a\u0430",
      "longitude":89.389305,
      "latitude":56.852524
    },
    "219":{
      "name":"\u041c\u0430\u0439\u0441\u043a\u043e\u0435",
      "longitude":89.420494,
      "latitude":60.019062
    },
    "220":{
      "name":"\u041b\u0430\u0437\u0430\u0440\u0435\u0432\u043e",
      "longitude":89.448631,
      "latitude":56.444084
    },
    "221":{
      "name":"\u0428\u0443\u0448\u044c",
      "longitude":89.451073,
      "latitude":55.596157
    },
    "222":{
      "name":"\u041d\u043e\u0432\u043e\u0430\u043b\u0442\u0430\u0442\u043a\u0430",
      "longitude":89.474472,
      "latitude":55.730236
    },
    "223":{
      "name":"\u041e\u0440\u0430\u043a\u0438",
      "longitude":89.51181,
      "latitude":55.324841
    },
    "224":{
      "name":"\u0411\u0435\u043b\u043e\u043e\u0437\u0451\u0440\u043a\u0430",
      "longitude":89.545105,
      "latitude":55.651161
    },
    "225":{
      "name":"\u0410\u0448\u043f\u0430\u043d",
      "longitude":89.569847,
      "latitude":55.374088
    },
    "226":{
      "name":"\u0411\u0435\u0440\u0435\u0437\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":89.584602,
      "latitude":55.846169
    },
    "227":{
      "name":"\u0411\u043e\u0433\u043e\u0442\u043e\u043b",
      "longitude":89.587463,
      "latitude":56.170795
    },
    "228":{
      "name":"\u0427\u0430\u0439\u043a\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":89.614594,
      "latitude":56.35244
    },
    "229":{
      "name":"\u0412\u043e\u0440\u043e\u0433\u043e\u0432\u043e",
      "longitude":89.616098,
      "latitude":61.0277303
    },
    "230":{
      "name":"\u041d\u043e\u0432\u043e\u043c\u0438\u0442\u0440\u043e\u043f\u043e\u043b\u044c\u043a\u0430",
      "longitude":89.641861,
      "latitude":56.535225
    },
    "231":{
      "name":"\u041c\u0435\u0434\u044f\u043a\u043e\u0432\u043e",
      "longitude":89.656403,
      "latitude":56.28384
    },
    "232":{
      "name":"\u0417\u043e\u0442\u0438\u043d\u043e",
      "longitude":89.6914992,
      "latitude":60.8934259
    },
    "233":{
      "name":"\u041b\u043e\u043a\u0448\u0438\u043d\u043e",
      "longitude":89.692909,
      "latitude":55.470497
    },
    "234":{
      "name":"\u041e\u0437\u0435\u0440\u043e \u0423\u0447\u0443\u043c",
      "longitude":89.702888,
      "latitude":55.082218
    },
    "235":{
      "name":"\u041a\u0443\u043b\u0443\u043d",
      "longitude":89.779221,
      "latitude":55.33215
    },
    "236":{
      "name":"\u0417\u043b\u0430\u0442\u043e\u0440\u0443\u043d\u043e\u0432\u0441\u043a",
      "longitude":89.807533,
      "latitude":55.132473
    },
    "237":{
      "name":"\u0412\u0430\u0433\u0438\u043d\u043e",
      "longitude":89.809402,
      "latitude":56.351032
    },
    "238":{
      "name":"\u041f\u0430\u0432\u043b\u043e\u0432\u043a\u0430",
      "longitude":89.837509,
      "latitude":55.966049
    },
    "239":{
      "name":"\u0412\u043b\u0430\u0434\u0438\u043c\u0438\u0440\u043e\u0432\u043a\u0430",
      "longitude":89.842171,
      "latitude":56.171562
    },
    "240":{
      "name":"\u041f\u0440\u0438\u043b\u0443\u0436\u044c\u0435",
      "longitude":89.847488,
      "latitude":55.169796
    },
    "241":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":89.899994,
      "latitude":55.589893
    },
    "242":{
      "name":"\u0412\u0430\u0441\u0438\u043b\u044c\u0435\u0432\u043a\u0430",
      "longitude":89.908745,
      "latitude":55.425472
    },
    "243":{
      "name":"\u041f\u0440\u043e\u0442\u043e\u0447\u043d\u044b\u0439",
      "longitude":89.916382,
      "latitude":57.508343
    },
    "244":{
      "name":"\u0425\u0430\u043d\u0442\u0430\u0439\u0441\u043a\u043e\u0435 \u041e\u0437\u0435\u0440\u043e",
      "longitude":89.98658,
      "latitude":68.219597
    },
    "245":{
      "name":"\u0422\u0443\u0440\u0433\u0443\u0436\u0430\u043d",
      "longitude":90.004211,
      "latitude":55.130207
    },
    "246":{
      "name":"\u041a\u0440\u0438\u0442\u043e\u0432\u043e",
      "longitude":90.004562,
      "latitude":56.240002
    },
    "247":{
      "name":"\u041a\u0440\u0443\u0442\u043e\u044f\u0440",
      "longitude":90.007217,
      "latitude":55.570072
    },
    "248":{
      "name":"\u041a\u0440\u0438\u0432\u043b\u044f\u043a",
      "longitude":90.021027,
      "latitude":60.29945
    },
    "249":{
      "name":"\u0423\u0441\u0442\u044c-\u0418\u0437\u044b\u043a\u0447\u0443\u043b\u044c",
      "longitude":90.021706,
      "latitude":55.495125
    },
    "250":{
      "name":"\u0411\u043e\u0440",
      "longitude":90.024033,
      "latitude":61.596855
    },
    "251":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u0417\u0430\u0432\u043e\u0434",
      "longitude":90.02449,
      "latitude":56.181721
    },
    "252":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u0430\u044f \u0421\u043e\u043f\u043a\u0430",
      "longitude":90.036812,
      "latitude":55.702316
    },
    "253":{
      "name":"\u0415\u043b\u044c\u043d\u0438\u043a",
      "longitude":90.03936,
      "latitude":55.937218
    },
    "254":{
      "name":"\u0418\u043b\u044c\u0438\u043d\u043a\u0430",
      "longitude":90.040512,
      "latitude":55.287849
    },
    "255":{
      "name":"\u041a\u0438\u0431\u0438\u0442\u0435\u043d\u044c",
      "longitude":90.052391,
      "latitude":55.800148
    },
    "256":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u0430\u044f \u0420\u0435\u0447\u043a\u0430",
      "longitude":90.058777,
      "latitude":56.228275
    },
    "257":{
      "name":"\u0418\u0437\u044b\u043a\u0447\u0443\u043b\u044c",
      "longitude":90.062454,
      "latitude":55.448582
    },
    "258":{
      "name":"\u0410\u043b\u0442\u0430\u0442",
      "longitude":90.064133,
      "latitude":56.063797
    },
    "259":{
      "name":"\u0413\u043b\u044f\u0434\u0435\u043d\u044c",
      "longitude":90.140793,
      "latitude":55.775406
    },
    "260":{
      "name":"\u0410\u043d\u0442\u0440\u043e\u043f\u043e\u0432\u043e",
      "longitude":90.146675,
      "latitude":55.815945
    },
    "261":{
      "name":"\u041d\u043e\u0432\u044b\u0439 \u0413\u043e\u0440\u043e\u0434\u043e\u043a",
      "longitude":90.1794946,
      "latitude":59.830962
    },
    "262":{
      "name":"\u0421\u043e\u0445\u043d\u043e\u0432\u043a\u0430",
      "longitude":90.182671,
      "latitude":55.961445
    },
    "263":{
      "name":"\u041a\u0438\u0440\u0447\u0438\u0436",
      "longitude":90.20295,
      "latitude":57.136925
    },
    "264":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u0410\u0434\u0430\u0434\u044b\u043c",
      "longitude":90.212006,
      "latitude":55.907665
    },
    "265":{
      "name":"\u042f\u0440\u0446\u0435\u0432\u043e",
      "longitude":90.222351,
      "latitude":60.24379
    },
    "266":{
      "name":"\u0411\u044b\u0447\u043a\u0438",
      "longitude":90.2511358,
      "latitude":56.5574201
    },
    "267":{
      "name":"\u041f\u0440\u0435\u0434\u0433\u043e\u0440\u043d\u044b\u0439",
      "longitude":90.255341,
      "latitude":55.63942
    },
    "268":{
      "name":"\u042f\u0433\u0430",
      "longitude":90.264107,
      "latitude":55.499271
    },
    "269":{
      "name":"\u041f\u0440\u0438\u0440\u0435\u0447\u0435\u043d\u0441\u043a",
      "longitude":90.271561,
      "latitude":55.211536
    },
    "270":{
      "name":"\u0414\u043e\u0440\u043e\u0445\u043e\u0432\u043e",
      "longitude":90.27504,
      "latitude":56.032375
    },
    "271":{
      "name":"\u041a\u043e\u043b\u044c\u0446\u043e\u0432\u043e",
      "longitude":90.280991,
      "latitude":55.785603
    },
    "272":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u044f\u044f \u0411\u0435\u0440\u0435\u0437\u043e\u0432\u043a\u0430",
      "longitude":90.286591,
      "latitude":55.687668
    },
    "273":{
      "name":"\u0411\u0435\u043b\u044b\u0439 \u042f\u0440",
      "longitude":90.316277,
      "latitude":56.287903
    },
    "274":{
      "name":"\u0410\u0440\u0430\u0431\u043a\u0430\u0435\u0432\u043e",
      "longitude":90.323479,
      "latitude":55.083023
    },
    "275":{
      "name":"\u041c\u0430\u0437\u0443\u043b\u044c\u0441\u043a\u0438\u0439",
      "longitude":90.325066,
      "latitude":56.208691
    },
    "276":{
      "name":"\u0421\u0442\u0430\u0440\u0430\u044f \u041a\u0443\u0437\u0443\u0440\u0431\u0430",
      "longitude":90.361252,
      "latitude":55.218552
    },
    "277":{
      "name":"\u0421\u0440\u0435\u0434\u043d\u044f\u044f \u0411\u0435\u0440\u0451\u0437\u043e\u0432\u043a\u0430",
      "longitude":90.366371,
      "latitude":55.747974
    },
    "278":{
      "name":"\u0423\u0434\u0430\u0447\u043d\u043e\u0435",
      "longitude":90.377283,
      "latitude":56.679838
    },
    "279":{
      "name":"\u0421\u043e\u043b\u0433\u043e\u043d",
      "longitude":90.379555,
      "latitude":55.524128
    },
    "280":{
      "name":"\u0421\u0442\u0435\u043f\u043d\u043e\u0439",
      "longitude":90.427856,
      "latitude":55.700928
    },
    "281":{
      "name":"\u041f\u0440\u0438\u0447\u0443\u043b\u044b\u043c\u0441\u043a\u0438\u0439",
      "longitude":90.429695,
      "latitude":56.387722
    },
    "282":{
      "name":"\u041c\u0430\u043b\u044b\u0439 \u0423\u043b\u0443\u0439",
      "longitude":90.432739,
      "latitude":56.122009
    },
    "283":{
      "name":"\u041f\u0440\u0435\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u0441\u043a\u0438\u0439",
      "longitude":90.436195,
      "latitude":55.93396
    },
    "284":{
      "name":"\u0416\u0433\u0443\u0442\u043e\u0432\u043e",
      "longitude":90.436264,
      "latitude":55.672482
    },
    "285":{
      "name":"\u0417\u0430\u0447\u0443\u043b\u044b\u043c\u043a\u0430",
      "longitude":90.4561979,
      "latitude":56.888825
    },
    "286":{
      "name":"\u0422\u0430\u0440\u0445\u0430\u043d\u043a\u0430",
      "longitude":90.461548,
      "latitude":55.594379
    },
    "287":{
      "name":"\u041c\u0435\u0434\u0432\u0435\u0434\u0441\u043a",
      "longitude":90.491364,
      "latitude":55.687687
    },
    "288":{
      "name":"\u041a\u043b\u044e\u0447\u0438",
      "longitude":90.493248,
      "latitude":56.164299
    },
    "289":{
      "name":"\u0421\u0443\u0447\u043a\u043e\u0432\u043e",
      "longitude":90.500293,
      "latitude":56.5727248
    },
    "290":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u0421\u0430\u043b\u044b\u0440\u044c",
      "longitude":90.522827,
      "latitude":56.311993
    },
    "291":{
      "name":"\u041c\u0430\u043b\u044b\u0439 \u0418\u043c\u044b\u0448",
      "longitude":90.526726,
      "latitude":55.220963
    },
    "292":{
      "name":"\u041f\u043e\u043b\u0435\u0432\u043e\u0435",
      "longitude":90.536217,
      "latitude":57.350273
    },
    "293":{
      "name":"\u0418\u043b\u044c\u0438\u043d\u043a\u0430",
      "longitude":90.542389,
      "latitude":55.886326
    },
    "294":{
      "name":"\u041a\u0430\u0440\u043b\u043e\u0432\u043a\u0430",
      "longitude":90.55397,
      "latitude":56.218834
    },
    "295":{
      "name":"\u0413\u043e\u0440\u043d\u044b\u0439",
      "longitude":90.5552951,
      "latitude":56.2416248
    },
    "296":{
      "name":"\u0421\u043e\u0441\u043d\u043e\u0432\u044b\u0439 \u0411\u043e\u0440",
      "longitude":90.5558211,
      "latitude":56.6211344
    },
    "297":{
      "name":"\u041c\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":90.575844,
      "latitude":56.279224
    },
    "298":{
      "name":"\u041f\u0440\u0435\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043a\u0430",
      "longitude":90.5770657,
      "latitude":56.3565278
    },
    "299":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u0423\u043b\u0443\u0439",
      "longitude":90.57975,
      "latitude":56.656811
    },
    "300":{
      "name":"\u041c\u043e\u0441\u043a\u043e\u0432\u043a\u0430",
      "longitude":90.583694,
      "latitude":55.633049
    },
    "301":{
      "name":"\u0418\u043d\u0442\u0438\u043a\u0443\u043b\u044c",
      "longitude":90.590324,
      "latitude":54.955624
    },
    "302":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u0415\u043b\u043e\u0432\u043a\u0430",
      "longitude":90.6446568,
      "latitude":56.4956013
    },
    "303":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u0430\u044f \u041f\u043e\u043b\u044f\u043d\u0430",
      "longitude":90.6602124,
      "latitude":55.9534619
    },
    "304":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u044b\u0439 \u041b\u043e\u0433",
      "longitude":90.662605,
      "latitude":55.160599
    },
    "305":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u0421\u0435\u0440\u0435\u0436",
      "longitude":90.671219,
      "latitude":56.000298
    },
    "306":{
      "name":"\u042f\u0441\u0442\u0440\u0435\u0431\u043e\u0432\u043e",
      "longitude":90.673477,
      "latitude":56.138691
    },
    "307":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u043a\u0430",
      "longitude":90.6737279,
      "latitude":56.7999154
    },
    "308":{
      "name":"\u0410\u0440\u0435\u0444\u044c\u0435\u0432\u043e",
      "longitude":90.674637,
      "latitude":57.028027
    },
    "309":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u044b\u0439",
      "longitude":90.679634,
      "latitude":56.242836
    },
    "310":{
      "name":"\u0421\u0430\u0445\u0430\u043f\u0442\u0430",
      "longitude":90.687187,
      "latitude":55.757648
    },
    "311":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u043f\u0430\u0432\u043b\u043e\u0432\u043a\u0430",
      "longitude":90.710175,
      "latitude":55.389595
    },
    "312":{
      "name":"\u0422\u043e\u043b\u0441\u0442\u044b\u0439 \u041c\u044b\u0441",
      "longitude":90.753609,
      "latitude":54.966999
    },
    "313":{
      "name":"\u041b\u0430\u043f\u0448\u0438\u0445\u0430",
      "longitude":90.758537,
      "latitude":56.453716
    },
    "314":{
      "name":"\u0411\u0430\u0440\u0430\u0438\u0442",
      "longitude":90.758591,
      "latitude":55.158764
    },
    "315":{
      "name":"\u041f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":90.765564,
      "latitude":56.292179
    },
    "316":{
      "name":"\u041d\u043e\u0432\u043e\u043d\u0438\u043a\u043e\u043b\u044c\u0441\u043a",
      "longitude":90.7655715,
      "latitude":56.6668693
    },
    "317":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":90.767502,
      "latitude":55.107368
    },
    "318":{
      "name":"\u0411\u043e\u0431\u0440\u043e\u0432\u043a\u0430",
      "longitude":90.8142908,
      "latitude":56.6209582
    },
    "319":{
      "name":"\u041d\u043e\u0432\u043e\u043d\u0430\u0437\u0438\u043c\u043e\u0432\u043e",
      "longitude":90.8200784,
      "latitude":59.5707365
    },
    "320":{
      "name":"\u0422\u0430\u0440\u0443\u0442\u0438\u043d\u043e",
      "longitude":90.835228,
      "latitude":56.295097
    },
    "321":{
      "name":"\u0421\u0432\u0435\u0442\u043b\u043e\u043b\u043e\u0431\u043e\u0432\u043e",
      "longitude":90.849915,
      "latitude":55.091137
    },
    "322":{
      "name":"\u041c\u0430\u043a\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":90.877945,
      "latitude":58.187645
    },
    "323":{
      "name":"\u041c\u0430\u0442\u0430\u043b\u0430\u0441\u0441\u044b",
      "longitude":90.878441,
      "latitude":57.15197
    },
    "324":{
      "name":"\u041e\u0440\u043b\u043e\u0432\u043a\u0430",
      "longitude":90.924736,
      "latitude":56.89267
    },
    "325":{
      "name":"\u0413\u0440\u0443\u0437\u0435\u043d\u043a\u0430",
      "longitude":90.959686,
      "latitude":55.480099
    },
    "326":{
      "name":"\u041f\u043e\u0434\u0441\u043e\u0441\u043d\u043e\u0435",
      "longitude":91.00647,
      "latitude":55.842262
    },
    "327":{
      "name":"\u041b\u0435\u0433\u043e\u0441\u0442\u0430\u0435\u0432\u043e",
      "longitude":91.030128,
      "latitude":55.133102
    },
    "328":{
      "name":"\u0410\u043d\u0430\u0448",
      "longitude":91.049149,
      "latitude":54.86969
    },
    "329":{
      "name":"\u041d\u043e\u0432\u043e\u0447\u0435\u0440\u043d\u043e\u0440\u0435\u0447\u0435\u043d\u0441\u043a\u0438\u0439",
      "longitude":91.08831,
      "latitude":56.268379
    },
    "330":{
      "name":"\u041a\u043e\u0436\u0430\u043d\u044b",
      "longitude":91.093132,
      "latitude":55.354282
    },
    "331":{
      "name":"\u0428\u0430\u0434\u0440\u0438\u043d\u043e",
      "longitude":91.107185,
      "latitude":55.877411
    },
    "332":{
      "name":"\u0420\u043e\u0432\u043d\u043e\u0435",
      "longitude":91.121803,
      "latitude":55.510571
    },
    "333":{
      "name":"\u0421\u0443\u043b\u043e\u043c\u0430\u0439",
      "longitude":91.1809827,
      "latitude":61.6137378
    },
    "334":{
      "name":"\u0427\u0438\u0441\u0442\u043e\u0435 \u041f\u043e\u043b\u0435",
      "longitude":91.181557,
      "latitude":55.24762
    },
    "335":{
      "name":"\u041a\u044b\u0442\u0430\u0442",
      "longitude":91.2025412,
      "latitude":56.803285
    },
    "336":{
      "name":"\u041a\u043e\u043c\u0430",
      "longitude":91.206848,
      "latitude":55.009888
    },
    "337":{
      "name":"\u0411\u0430\u043b\u0430\u0445\u0442\u043e\u043d",
      "longitude":91.233818,
      "latitude":55.983154
    },
    "338":{
      "name":"\u0422\u044e\u043b\u044c\u043a\u043e\u0432\u043e",
      "longitude":91.254005,
      "latitude":55.359093
    },
    "339":{
      "name":"\u0411\u0435\u043b\u043b\u044b\u043a",
      "longitude":91.3348796,
      "latitude":54.5493081
    },
    "340":{
      "name":"\u0427\u0438\u0441\u0442\u044b\u0435 \u041f\u0440\u0443\u0434\u044b",
      "longitude":91.351685,
      "latitude":55.450474
    },
    "341":{
      "name":"\u0410\u043b\u0442\u0430\u0442",
      "longitude":91.3935477,
      "latitude":57.491625
    },
    "342":{
      "name":"\u0427\u0443\u043b\u044b\u043c",
      "longitude":91.398033,
      "latitude":55.251724
    },
    "343":{
      "name":"\u0421\u0443\u0440\u0438\u043a\u043e\u0432\u043e",
      "longitude":91.4008658,
      "latitude":56.9860299
    },
    "344":{
      "name":"\u041b\u0430\u0437\u0443\u0440\u043d\u044b\u0439",
      "longitude":91.414825,
      "latitude":56.157696
    },
    "345":{
      "name":"\u041a\u0443\u043b\u044c\u0447\u0435\u043a",
      "longitude":91.415001,
      "latitude":54.911186
    },
    "346":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u0421\u044b\u0434\u0430",
      "longitude":91.420883,
      "latitude":54.395
    },
    "347":{
      "name":"\u0415\u043b\u043e\u0432\u043a\u0430",
      "longitude":91.452087,
      "latitude":55.522758
    },
    "348":{
      "name":"\u0420\u0430\u0441\u0441\u0432\u0435\u0442",
      "longitude":91.470993,
      "latitude":57.000469
    },
    "349":{
      "name":"\u041d\u0438\u043a\u0438\u0442\u0438\u043d\u043e",
      "longitude":91.4840642,
      "latitude":53.0153045
    },
    "350":{
      "name":"\u0421\u0438\u0437\u0430\u044f",
      "longitude":91.511802,
      "latitude":53.0011599
    },
    "351":{
      "name":"\u041a\u0435\u0434\u0440\u043e\u0432\u044b\u0439",
      "longitude":91.535675,
      "latitude":56.280407
    },
    "352":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0438\u0435 \u0421\u044b\u0440\u044b",
      "longitude":91.549423,
      "latitude":55.5158
    },
    "353":{
      "name":"\u041b\u0435\u0431\u044f\u0436\u044c\u0435",
      "longitude":91.5766543,
      "latitude":54.1929805
    },
    "354":{
      "name":"\u0428\u0443\u043d\u0435\u0440\u044b",
      "longitude":91.585464,
      "latitude":53.127377
    },
    "355":{
      "name":"\u0411\u044b\u0441\u0442\u0440\u0430\u044f",
      "longitude":91.5879932,
      "latitude":53.7282037
    },
    "356":{
      "name":"\u0421\u0435\u043b\u0438\u0432\u0430\u043d\u0438\u0445\u0430",
      "longitude":91.607178,
      "latitude":53.689816
    },
    "357":{
      "name":"\u0417\u0435\u043b\u0451\u043d\u044b\u0439 \u0411\u043e\u0440",
      "longitude":91.615334,
      "latitude":53.618069
    },
    "358":{
      "name":"\u041a\u043e\u0441\u0430\u0447\u0438",
      "longitude":91.63707,
      "latitude":56.136925
    },
    "359":{
      "name":"\u0422\u043e\u043f\u043e\u043b\u044c\u043a\u0438",
      "longitude":91.6449846,
      "latitude":53.6647118
    },
    "360":{
      "name":"\u0412\u043e\u0441\u0442\u043e\u0447\u043d\u043e\u0435",
      "longitude":91.6588259,
      "latitude":54.0922647
    },
    "361":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u041a\u0435\u0442\u044c",
      "longitude":91.659691,
      "latitude":57.328171
    },
    "362":{
      "name":"\u041e\u043f\u044b\u0442\u043d\u043e\u0435 \u041f\u043e\u043b\u0435",
      "longitude":91.6670746,
      "latitude":53.6758344
    },
    "363":{
      "name":"\u0411\u0435\u043b\u043e\u044f\u0440\u0441\u043a",
      "longitude":91.6770395,
      "latitude":54.3886449
    },
    "364":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u043e-\u041f\u0435\u0442\u0440\u043e\u0432\u043a\u0430",
      "longitude":91.6824534,
      "latitude":53.9336025
    },
    "365":{
      "name":"\u0428\u0438\u0448\u043c\u0430\u0440\u0435\u0432\u043e",
      "longitude":91.688057,
      "latitude":59.083046
    },
    "366":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u0430\u044f",
      "longitude":91.690887,
      "latitude":55.306755
    },
    "367":{
      "name":"\u041a\u043e\u0440\u0442\u0443\u0437",
      "longitude":91.7003789,
      "latitude":54.4927748
    },
    "368":{
      "name":"\u0427\u0430\u0439\u0434\u0430",
      "longitude":91.7085602,
      "latitude":57.4313639
    },
    "369":{
      "name":"\u0416\u0443\u043a\u043e\u0432\u043a\u0430",
      "longitude":91.71244,
      "latitude":56.095398
    },
    "370":{
      "name":"\u0421\u0430\u043b\u0431\u0430",
      "longitude":91.7167267,
      "latitude":54.6812042
    },
    "371":{
      "name":"\u0417\u0430\u0440\u0435\u0447\u043d\u044b\u0439",
      "longitude":91.723724,
      "latitude":56.042652
    },
    "372":{
      "name":"\u0423\u0441\u0442\u044c-\u041f\u0438\u0442",
      "longitude":91.759964,
      "latitude":58.984028
    },
    "373":{
      "name":"\u0421\u0443\u0445\u043e\u0434\u043e\u043b",
      "longitude":91.7744987,
      "latitude":53.7834297
    },
    "374":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u041c\u0438\u043d\u0443\u0441\u0430",
      "longitude":91.779358,
      "latitude":53.725357
    },
    "375":{
      "name":"\u041b\u0443\u0433\u0430\u0432\u0441\u043a\u043e\u0435",
      "longitude":91.7924454,
      "latitude":53.5233563
    },
    "376":{
      "name":"\u041d\u043e\u0432\u043e\u0442\u0440\u043e\u0438\u0446\u043a\u043e\u0435",
      "longitude":91.7964129,
      "latitude":53.8713374
    },
    "377":{
      "name":"\u041e\u0437\u0435\u0440\u043e \u0422\u0430\u0433\u0430\u0440\u0441\u043a\u043e\u0435",
      "longitude":91.797536,
      "latitude":53.5985363
    },
    "378":{
      "name":"\u041a\u0430\u043f\u0442\u044b\u0440\u0435\u0432\u043e",
      "longitude":91.8025341,
      "latitude":53.1907232
    },
    "379":{
      "name":"\u0413\u043e\u0440\u043e\u0434\u043e\u043a",
      "longitude":91.8025517,
      "latitude":53.9270389
    },
    "380":{
      "name":"\u0418\u043b\u044c\u0438\u0447\u0451\u0432\u043e",
      "longitude":91.8414527,
      "latitude":53.2752148
    },
    "381":{
      "name":"\u041e\u0433\u0443\u0440",
      "longitude":91.859886,
      "latitude":55.355312
    },
    "382":{
      "name":"\u0421\u0430\u044f\u043d\u0441\u043a",
      "longitude":91.8791707,
      "latitude":54.1520135
    },
    "383":{
      "name":"\u0414\u043e\u0431\u0440\u043e\u043c\u044b\u0441\u043b\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":91.8792535,
      "latitude":54.4943277
    },
    "384":{
      "name":"\u041a\u0435\u0442\u0441\u043a\u0438\u0439",
      "longitude":91.88115,
      "latitude":57.5817002
    },
    "385":{
      "name":"\u041a\u043e\u043c\u0430\u0440\u043e\u0432\u043a\u0430",
      "longitude":91.8820853,
      "latitude":57.5639176
    },
    "386":{
      "name":"\u0410\u043b\u0442\u0430\u043d",
      "longitude":91.8880364,
      "latitude":53.2420406
    },
    "387":{
      "name":"\u041f\u043e\u0434\u0433\u043e\u0440\u043d\u043e\u0435",
      "longitude":91.8901848,
      "latitude":58.1137379
    },
    "388":{
      "name":"\u0427\u0430\u043b\u0431\u044b\u0448\u0435\u0432\u043e",
      "longitude":91.8916255,
      "latitude":58.0527211
    },
    "389":{
      "name":"\u041f\u0440\u0438\u043c\u043e\u0440\u0441\u043a",
      "longitude":91.892891,
      "latitude":55.20636
    },
    "390":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":91.8952842,
      "latitude":54.2943796
    },
    "391":{
      "name":"\u041d\u0438\u0436\u043d\u044f\u044f \u041a\u043e\u044f",
      "longitude":91.9138795,
      "latitude":53.4573744
    },
    "392":{
      "name":"\u0417\u043d\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":91.915726,
      "latitude":53.535999
    },
    "393":{
      "name":"\u0421\u0443\u0431\u0431\u043e\u0442\u0438\u043d\u043e",
      "longitude":91.9205511,
      "latitude":53.0708276
    },
    "394":{
      "name":"\u041a\u0430\u0432\u043a\u0430\u0437\u0441\u043a\u043e\u0435",
      "longitude":91.928261,
      "latitude":53.965584
    },
    "395":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u0425\u0430\u0431\u044b\u043a",
      "longitude":91.9414139,
      "latitude":54.4254565
    },
    "396":{
      "name":"\u041f\u043b\u043e\u0442\u0431\u0438\u0449\u0435",
      "longitude":91.9559915,
      "latitude":58.4425159
    },
    "397":{
      "name":"\u041c\u0430\u043b\u043e\u0431\u0435\u043b\u0430\u044f",
      "longitude":91.9634378,
      "latitude":58.2312979
    },
    "398":{
      "name":"\u0417\u0430\u0440\u043d\u0438\u0447\u043d\u044b\u0439",
      "longitude":91.9717131,
      "latitude":53.2440173
    },
    "399":{
      "name":"\u0421\u0440\u0435\u0434\u043d\u044f\u044f \u0428\u0443\u0448\u044c",
      "longitude":91.974863,
      "latitude":53.0399251
    },
    "400":{
      "name":"\u0418\u0434\u0436\u0430",
      "longitude":91.97683,
      "latitude":53.187931
    },
    "401":{
      "name":"\u0417\u0435\u043b\u0435\u0434\u0435\u0435\u0432\u043e",
      "longitude":91.9805087,
      "latitude":56.0737914
    },
    "402":{
      "name":"\u041c\u0430\u0439\u0441\u043a\u043e\u0435 \u0423\u0442\u0440\u043e",
      "longitude":91.995653,
      "latitude":54.38944
    },
    "403":{
      "name":"\u0418\u043a\u0448\u0443\u0440\u043c\u0430",
      "longitude":92.0028763,
      "latitude":57.6387242
    },
    "404":{
      "name":"\u041a\u0430\u0437\u0430\u043d\u0446\u0435\u0432\u043e",
      "longitude":92.005074,
      "latitude":53.407478
    },
    "405":{
      "name":"\u041f\u0440\u0438\u0442\u0443\u0431\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":92.0089836,
      "latitude":53.9008369
    },
    "406":{
      "name":"\u0420\u043e\u043c\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":92.0154141,
      "latitude":54.7273053
    },
    "407":{
      "name":"\u0422\u0443\u0431\u0438\u043d\u0441\u043a",
      "longitude":92.0333559,
      "latitude":54.07867
    },
    "408":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u041d\u0438\u0447\u043a\u0430",
      "longitude":92.034261,
      "latitude":53.6293354
    },
    "409":{
      "name":"\u041f\u043e\u0433\u043e\u0434\u0430\u0435\u0432\u043e",
      "longitude":92.049866,
      "latitude":58.699722
    },
    "410":{
      "name":"\u0423\u0441\u0442\u044c-\u041a\u0435\u043c\u044c",
      "longitude":92.0546481,
      "latitude":58.5426684
    },
    "411":{
      "name":"\u041d\u043e\u0432\u043e\u0431\u0435\u0440\u0451\u0437\u043e\u0432\u043a\u0430",
      "longitude":92.0564916,
      "latitude":54.5319957
    },
    "412":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u0422\u0435\u043b\u0435\u043a",
      "longitude":92.063203,
      "latitude":54.2926693
    },
    "413":{
      "name":"\u041f\u0440\u0438\u0445\u043e\u043b\u043c\u044c\u0435",
      "longitude":92.0780892,
      "latitude":53.7970327
    },
    "414":{
      "name":"\u041c\u0430\u043b\u044b\u0439 \u0425\u0430\u0431\u044b\u043a",
      "longitude":92.0785375,
      "latitude":54.4394971
    },
    "415":{
      "name":"\u041e\u0437\u0451\u0440\u043d\u043e\u0435",
      "longitude":92.0808486,
      "latitude":58.4647693
    },
    "416":{
      "name":"\u041f\u043e\u0434\u0442\u0451\u0441\u043e\u0432\u043e",
      "longitude":92.090935,
      "latitude":58.604252
    },
    "417":{
      "name":"\u0421\u0438\u043d\u0435\u0431\u043e\u0440\u0441\u043a",
      "longitude":92.0960198,
      "latitude":53.4847301
    },
    "418":{
      "name":"\u041a\u0443\u0440\u0435\u0436",
      "longitude":92.1037642,
      "latitude":54.2104117
    },
    "419":{
      "name":"\u0413\u0430\u043b\u0430\u043a\u0442\u0438\u043e\u043d\u043e\u0432\u043e",
      "longitude":92.1122018,
      "latitude":54.1376661
    },
    "420":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u0418\u043d\u044f",
      "longitude":92.11554,
      "latitude":53.77042
    },
    "421":{
      "name":"\u041a\u0443\u0437\u044c\u043c\u043e\u0432\u043a\u0430",
      "longitude":92.1162251,
      "latitude":62.3137069
    },
    "422":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u041d\u0438\u0447\u043a\u0430",
      "longitude":92.1333876,
      "latitude":53.6668742
    },
    "423":{
      "name":"\u0412\u043e\u0441\u0442\u043e\u0447\u043d\u043e\u0435",
      "longitude":92.1358577,
      "latitude":53.5767904
    },
    "424":{
      "name":"\u0415\u043a\u0430\u0442\u0435\u0440\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":92.1569969,
      "latitude":54.5528593
    },
    "425":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u044f\u044f \u041a\u043e\u044f",
      "longitude":92.1617626,
      "latitude":53.4968924
    },
    "426":{
      "name":"\u0421\u0438\u0431\u0438\u0440\u044c",
      "longitude":92.164375,
      "latitude":54.3972409
    },
    "427":{
      "name":"\u0422\u0440\u043e\u0438\u0446\u0430",
      "longitude":92.1754903,
      "latitude":57.7736065
    },
    "428":{
      "name":"\u0427\u0435\u0440\u0435\u043c\u0443\u0448\u043a\u0438",
      "longitude":92.1843382,
      "latitude":55.176267
    },
    "429":{
      "name":"\u0416\u0435\u0431\u043b\u0430\u0445\u0442\u044b",
      "longitude":92.1848207,
      "latitude":53.3197004
    },
    "430":{
      "name":"\u0422\u0435\u0441\u044c",
      "longitude":92.186226,
      "latitude":53.866264
    },
    "431":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":92.1918424,
      "latitude":53.3845764
    },
    "432":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u0418\u043d\u044f",
      "longitude":92.209198,
      "latitude":53.802078
    },
    "433":{
      "name":"\u0411\u0443\u0448\u0443\u0439",
      "longitude":92.2100797,
      "latitude":57.4663114
    },
    "434":{
      "name":"\u041c\u0438\u0433\u043d\u0430",
      "longitude":92.2229672,
      "latitude":53.1361286
    },
    "435":{
      "name":"\u041a\u0430\u0447\u0430",
      "longitude":92.2271559,
      "latitude":56.0970001
    },
    "436":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":92.2301047,
      "latitude":54.0465469
    },
    "437":{
      "name":"\u0421\u0435\u043c\u0435\u043d\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":92.2359133,
      "latitude":53.1993513
    },
    "438":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u044c\u0441\u043a\u043e\u0435",
      "longitude":92.2409329,
      "latitude":54.4869995
    },
    "439":{
      "name":"\u0415\u043f\u0438\u0448\u0438\u043d\u043e",
      "longitude":92.2476557,
      "latitude":58.4880802
    },
    "440":{
      "name":"\u0426\u0435\u043d\u0442\u0440\u0430\u043b\u044c\u043d\u044b\u0439",
      "longitude":92.261102,
      "latitude":54.3656495
    },
    "441":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0435\u043f\u0430\u0448\u0438\u043d\u043e",
      "longitude":92.2635944,
      "latitude":58.4124243
    },
    "442":{
      "name":"\u0415\u043d\u0438\u0441\u0435\u0439\u0441\u043a-4",
      "longitude":92.2663586,
      "latitude":58.4463452
    },
    "443":{
      "name":"\u041f\u0438\u0440\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":92.272644,
      "latitude":57.624046
    },
    "444":{
      "name":"\u041d\u043e\u0432\u043e\u043f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":92.2752864,
      "latitude":54.1223257
    },
    "445":{
      "name":"\u0428\u0430\u043b\u043e\u0431\u043e\u043b\u0438\u043d\u043e",
      "longitude":92.286148,
      "latitude":53.939526
    },
    "446":{
      "name":"\u041a\u0430\u043c\u0435\u043d\u043d\u044b\u0439 \u042f\u0440",
      "longitude":92.2982865,
      "latitude":56.1158041
    },
    "447":{
      "name":"\u041a\u043e\u043b\u043c\u0430\u043a\u043e\u0432\u043e",
      "longitude":92.3002679,
      "latitude":53.7127399
    },
    "448":{
      "name":"\u0421\u043e\u043b\u043e\u0443\u0445\u0430",
      "longitude":92.3027588,
      "latitude":57.7555502
    },
    "449":{
      "name":"\u0414\u0443\u0431\u0435\u043d\u0441\u043a\u043e\u0435",
      "longitude":92.3069978,
      "latitude":53.4648939
    },
    "450":{
      "name":"\u041f\u043e\u0442\u0430\u043f\u043e\u0432\u043e",
      "longitude":92.3114533,
      "latitude":58.4352374
    },
    "451":{
      "name":"\u041f\u0430\u043c\u044f\u0442\u0438 13 \u0411\u043e\u0440\u0446\u043e\u0432",
      "longitude":92.318954,
      "latitude":56.21492
    },
    "452":{
      "name":"\u041a\u0443\u0440\u0433\u0430\u043d\u0447\u0438\u043a\u0438",
      "longitude":92.3247627,
      "latitude":53.9767793
    },
    "453":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u0421\u0430\u043b\u0431\u0430",
      "longitude":92.3268561,
      "latitude":54.2319987
    },
    "454":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":92.3442039,
      "latitude":53.3133787
    },
    "455":{
      "name":"\u041d\u043e\u0432\u043e\u043e\u0437\u0451\u0440\u043d\u044b\u0439",
      "longitude":92.417535,
      "latitude":53.24405
    },
    "456":{
      "name":"\u0422\u0438\u0433\u0440\u0438\u0446\u043a\u043e\u0435",
      "longitude":92.4181981,
      "latitude":53.5969971
    },
    "457":{
      "name":"\u0413\u043e\u0440\u043e\u0434\u0438\u0449\u0435",
      "longitude":92.4372362,
      "latitude":58.2929738
    },
    "458":{
      "name":"\u0416\u0435\u0440\u043b\u044b\u043a",
      "longitude":92.437729,
      "latitude":53.752277
    },
    "459":{
      "name":"\u0428\u043e\u0448\u0438\u043d\u043e",
      "longitude":92.44072,
      "latitude":53.818592
    },
    "460":{
      "name":"\u0420\u0430\u0437\u044a\u0435\u0437\u0436\u0435\u0435",
      "longitude":92.4416384,
      "latitude":53.1192331
    },
    "461":{
      "name":"\u041f\u043e\u0439\u043b\u043e\u0432\u043e",
      "longitude":92.449766,
      "latitude":53.85728
    },
    "462":{
      "name":"\u0414\u0435\u0442\u043b\u043e\u0432\u043e",
      "longitude":92.4521105,
      "latitude":54.0910988
    },
    "463":{
      "name":"\u0410\u0440\u0435\u0439\u0441\u043a\u043e\u0435",
      "longitude":92.452278,
      "latitude":56.09734
    },
    "464":{
      "name":"\u041a\u0440\u0443\u0442\u0430\u044f",
      "longitude":92.4662205,
      "latitude":56.2363913
    },
    "465":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0439 \u0421\u0443\u044d\u0442\u0443\u043a",
      "longitude":92.4665764,
      "latitude":53.3462666
    },
    "466":{
      "name":"\u0423\u0441\u0442\u044c-\u041c\u0430\u043d\u0430",
      "longitude":92.4767763,
      "latitude":55.9398167
    },
    "467":{
      "name":"\u041a\u0438\u0440\u0438\u043a\u043e\u0432\u043e",
      "longitude":92.4802048,
      "latitude":57.5803214
    },
    "468":{
      "name":"\u041e\u0439\u0441\u043a\u0438\u0439",
      "longitude":92.493988,
      "latitude":53.24609
    },
    "469":{
      "name":"\u041a\u043e\u0447\u0435\u0440\u0433\u0438\u043d\u043e",
      "longitude":92.498428,
      "latitude":53.817822
    },
    "470":{
      "name":"\u041c\u0430\u043d\u0441\u043a\u0438\u0439",
      "longitude":92.5015495,
      "latitude":55.897891
    },
    "471":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u044c\u0441\u043a\u043e\u0435",
      "longitude":92.5151351,
      "latitude":56.3776066
    },
    "472":{
      "name":"\u041d\u043e\u0432\u043e\u0442\u0440\u043e\u0438\u0446\u043a\u043e\u0435",
      "longitude":92.5368078,
      "latitude":54.5429372
    },
    "473":{
      "name":"\u041c\u0438\u043d\u0438\u043d\u043e",
      "longitude":92.5400938,
      "latitude":56.0508005
    },
    "474":{
      "name":"\u0415\u043b\u043e\u0432\u043e\u0435",
      "longitude":92.5415493,
      "latitude":56.1428702
    },
    "475":{
      "name":"\u041e\u0442\u0440\u043e\u043a",
      "longitude":92.5505089,
      "latitude":54.4471031
    },
    "476":{
      "name":"\u041e\u0432\u0441\u044f\u043d\u043a\u0430",
      "longitude":92.562515,
      "latitude":55.961285
    },
    "477":{
      "name":"\u0411\u0430\u0439\u0434\u043e\u0432\u043e",
      "longitude":92.5643256,
      "latitude":54.0097484
    },
    "478":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0438\u0435 \u041a\u043d\u044b\u0448\u0438",
      "longitude":92.5716217,
      "latitude":54.2501936
    },
    "479":{
      "name":"\u042d\u043b\u0438\u0442\u0430",
      "longitude":92.5720813,
      "latitude":56.0896885
    },
    "480":{
      "name":"\u041e\u0439\u0445\u0430",
      "longitude":92.5756974,
      "latitude":53.8659063
    },
    "481":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u043c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":92.581993,
      "latitude":56.56889
    },
    "482":{
      "name":"\u0421\u043b\u0438\u0437\u043d\u0435\u0432\u043e",
      "longitude":92.5880449,
      "latitude":55.9574932
    },
    "483":{
      "name":"\u041c\u0430\u0440\u0438\u043d\u0438\u043d\u043e",
      "longitude":92.5918256,
      "latitude":54.0175494
    },
    "484":{
      "name":"\u0422\u0430\u0441\u043a\u0438\u043d\u043e",
      "longitude":92.5944199,
      "latitude":53.7135109
    },
    "485":{
      "name":"\u041c\u0443\u0440\u0438\u043d\u043e",
      "longitude":92.5959955,
      "latitude":53.8390051
    },
    "486":{
      "name":"\u0421\u0430\u043b\u0431\u0430",
      "longitude":92.6,
      "latitude":53.2379951
    },
    "487":{
      "name":"\u0411\u0440\u0430\u0433\u0438\u043d\u043e",
      "longitude":92.6039058,
      "latitude":54.1100989
    },
    "488":{
      "name":"\u041d\u043e\u0432\u043e\u043f\u043e\u043b\u0442\u0430\u0432\u043a\u0430",
      "longitude":92.6187064,
      "latitude":53.3260741
    },
    "489":{
      "name":"\u0412\u044b\u0441\u043e\u043a\u043e\u0433\u043e\u0440\u0441\u043a\u0438\u0439",
      "longitude":92.6213127,
      "latitude":58.1683266
    },
    "490":{
      "name":"\u0422\u0435\u044f",
      "longitude":92.6306,
      "latitude":60.373081
    },
    "491":{
      "name":"\u0410\u0431\u0430\u043b\u0430\u043a\u043e\u0432\u043e",
      "longitude":92.6391156,
      "latitude":58.0827072
    },
    "492":{
      "name":"\u0411\u0443\u0440\u043d\u044b\u0439",
      "longitude":92.6443074,
      "latitude":61.8153623
    },
    "493":{
      "name":"\u0413\u0430\u0440\u0435\u0432\u043e\u0435",
      "longitude":92.6484618,
      "latitude":56.6445632
    },
    "494":{
      "name":"\u0411\u0443\u0433\u0430\u0447\u0435\u0432\u043e",
      "longitude":92.6543547,
      "latitude":56.0456629
    },
    "495":{
      "name":"\u0412\u0435\u0441\u0451\u043b\u0430\u044f \u0413\u043e\u0440\u0430",
      "longitude":92.6666123,
      "latitude":56.1894195
    },
    "496":{
      "name":"\u0411\u0435\u043b\u044b\u0439 \u042f\u0440",
      "longitude":92.6691744,
      "latitude":53.8396028
    },
    "497":{
      "name":"\u041c\u0438\u043d\u0438\u043d\u043e",
      "longitude":92.6956189,
      "latitude":56.0733284
    },
    "498":{
      "name":"\u041e\u0442\u043d\u043e\u0448\u043a\u0430",
      "longitude":92.7101939,
      "latitude":57.3798389
    },
    "499":{
      "name":"\u0410\u0431\u0430\u043b\u0430\u043a\u043e\u0432\u043e",
      "longitude":92.72598,
      "latitude":58.1112655
    },
    "500":{
      "name":"\u0427\u0435\u0440\u0435\u043c\u0443\u0448\u043a\u0430",
      "longitude":92.726852,
      "latitude":53.532482
    },
    "501":{
      "name":"\u0422\u0430\u043b\u043e\u0435",
      "longitude":92.7461012,
      "latitude":56.48294
    },
    "502":{
      "name":"\u041c\u043e\u0441\u0442\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":92.7513073,
      "latitude":56.7607379
    },
    "503":{
      "name":"\u0414\u0440\u043e\u043a\u0438\u043d\u043e",
      "longitude":92.7554055,
      "latitude":56.0952596
    },
    "504":{
      "name":"\u041b\u043e\u0433\u043e\u0432\u043e\u0439",
      "longitude":92.7604132,
      "latitude":56.1253118
    },
    "505":{
      "name":"\u041b\u0435\u0431\u0435\u0434\u0435\u0432\u043a\u0430",
      "longitude":92.7634271,
      "latitude":53.5907951
    },
    "506":{
      "name":"\u0422\u0432\u043e\u0440\u043e\u0433\u043e\u0432\u043e",
      "longitude":92.76889,
      "latitude":56.137268
    },
    "507":{
      "name":"\u0422\u0430\u043b\u0430\u0436\u0430\u043d\u043a\u0430",
      "longitude":92.7715637,
      "latitude":57.5159353
    },
    "508":{
      "name":"\u0417\u043e\u043b\u043e\u0442\u0430\u044f \u0413\u043e\u0440\u043a\u0430",
      "longitude":92.7804285,
      "latitude":56.4592715
    },
    "509":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0435 \u041a\u043b\u044e\u0447\u0438",
      "longitude":92.7862515,
      "latitude":56.9275014
    },
    "510":{
      "name":"\u0420\u043e\u0449\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":92.7884448,
      "latitude":53.8781844
    },
    "511":{
      "name":"\u0412\u0435\u0440\u0445-\u041a\u0430\u0437\u0430\u043d\u043a\u0430",
      "longitude":92.7904906,
      "latitude":57.0479328
    },
    "512":{
      "name":"\u0421\u0430\u0433\u0430\u0439\u0441\u043a\u043e\u0435",
      "longitude":92.793053,
      "latitude":53.646313
    },
    "513":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":92.8057372,
      "latitude":53.9317288
    },
    "514":{
      "name":"\u0423\u0434\u0436\u0435\u0439",
      "longitude":92.814102,
      "latitude":53.739208
    },
    "515":{
      "name":"\u0423\u0441\u0442\u044c-\u0410\u0432\u0430\u043c",
      "longitude":92.824127,
      "latitude":71.113937
    },
    "516":{
      "name":"\u0423\u0441\u0442\u044e\u0433",
      "longitude":92.838127,
      "latitude":56.371014
    },
    "517":{
      "name":"\u0410\u0440\u0435\u0439",
      "longitude":92.8411815,
      "latitude":56.2333152
    },
    "518":{
      "name":"\u041c\u0430\u0442\u0432\u0435\u0435\u0432\u043a\u0430",
      "longitude":92.8446824,
      "latitude":57.5297177
    },
    "519":{
      "name":"\u0413\u0440\u0438\u0433\u043e\u0440\u044c\u0435\u0432\u043a\u0430",
      "longitude":92.8449585,
      "latitude":53.2242739
    },
    "520":{
      "name":"\u0421\u043e\u043b\u043e\u043d\u0446\u044b",
      "longitude":92.8492582,
      "latitude":56.0675351
    },
    "521":{
      "name":"\u0412\u043e\u0440\u043e\u043a\u043e\u0432\u043a\u0430",
      "longitude":92.853264,
      "latitude":57.595745
    },
    "522":{
      "name":"\u0411\u0443\u0433\u0443\u0440\u0442\u0430\u043a",
      "longitude":92.8672675,
      "latitude":53.8106363
    },
    "523":{
      "name":"\u0421\u0442\u0430\u0440\u0430\u044f \u041a\u043e\u043f\u044c",
      "longitude":92.890633,
      "latitude":53.653343
    },
    "524":{
      "name":"\u0428\u0443\u0432\u0430\u0435\u0432\u043e",
      "longitude":92.8960311,
      "latitude":56.1879537
    },
    "525":{
      "name":"\u0411\u043e\u0440\u0441\u043a",
      "longitude":92.904335,
      "latitude":56.441799
    },
    "526":{
      "name":"\u0421\u0443\u0445\u0430\u044f \u0411\u0430\u043b\u043a\u0430",
      "longitude":92.90464,
      "latitude":56.137848
    },
    "527":{
      "name":"\u041a\u0430\u0447\u0443\u043b\u044c\u043a\u0430",
      "longitude":92.9111927,
      "latitude":53.7628549
    },
    "528":{
      "name":"\u041a\u0443\u0440\u0441\u043a\u043e\u0435",
      "longitude":92.91226,
      "latitude":53.9864945
    },
    "529":{
      "name":"\u0428\u0438\u043b\u0438\u043d\u043a\u0430",
      "longitude":92.9175189,
      "latitude":56.5354881
    },
    "530":{
      "name":"\u0415\u0440\u0443\u0434\u0430",
      "longitude":92.9177675,
      "latitude":59.880324
    },
    "531":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u0418\u0440\u0431\u0430",
      "longitude":92.932541,
      "latitude":54.080906
    },
    "532":{
      "name":"\u041c\u043e\u0442\u043e\u0440\u0441\u043a\u043e\u0435",
      "longitude":92.938141,
      "latitude":53.404842
    },
    "533":{
      "name":"\u0422\u0430\u043d\u0437\u044b\u0431\u0435\u0439",
      "longitude":92.94384,
      "latitude":53.130917
    },
    "534":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u0430\u0440\u0433\u0438\u043d\u043e",
      "longitude":92.949288,
      "latitude":58.0205104
    },
    "535":{
      "name":"\u0422\u0430\u0441\u043a\u0438\u043d\u043e",
      "longitude":92.9529985,
      "latitude":56.3184611
    },
    "536":{
      "name":"\u0421\u043e\u0432\u0445\u043e\u0437 \u00ab\u0421\u0438\u0431\u0438\u0440\u044f\u043a\u00bb",
      "longitude":92.9536307,
      "latitude":56.2627282
    },
    "537":{
      "name":"\u0428\u0430\u0440\u044c\u0435",
      "longitude":92.9668668,
      "latitude":56.1805104
    },
    "538":{
      "name":"\u041c\u0435\u0436\u043e\u0432\u043e",
      "longitude":92.9733246,
      "latitude":56.7514977
    },
    "539":{
      "name":"\u0421\u0442\u0430\u0440\u0446\u0435\u0432\u043e",
      "longitude":92.9834366,
      "latitude":56.1653984
    },
    "540":{
      "name":"\u0410\u0439\u0442\u0430\u0442",
      "longitude":92.98719,
      "latitude":57.009253
    },
    "541":{
      "name":"\u041c\u0438\u043d\u0434\u0435\u0440\u043b\u0430",
      "longitude":92.998474,
      "latitude":56.437431
    },
    "542":{
      "name":"\u041b\u0430\u043a\u0438\u043d\u043e",
      "longitude":93.0074441,
      "latitude":56.7979609
    },
    "543":{
      "name":"\u041d\u0438\u0436\u043d\u0435\u0443\u0441\u0438\u043d\u0441\u043a\u043e\u0435",
      "longitude":93.0111013,
      "latitude":52.2592124
    },
    "544":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0435\u0443\u0441\u0438\u043d\u0441\u043a\u043e\u0435",
      "longitude":93.025047,
      "latitude":52.240841
    },
    "545":{
      "name":"\u0428\u0430\u043f\u043a\u0438\u043d\u043e",
      "longitude":93.039426,
      "latitude":57.8938979
    },
    "546":{
      "name":"\u041a\u0443\u0437\u043d\u0435\u0446\u043e\u0432\u043e",
      "longitude":93.047523,
      "latitude":55.945637
    },
    "547":{
      "name":"\u0428\u0438\u043b\u0430",
      "longitude":93.047783,
      "latitude":56.552422
    },
    "548":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u041a\u0430\u043b\u0430\u043c\u0438",
      "longitude":93.05249,
      "latitude":60.171886
    },
    "549":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u041f\u0430\u0445\u0430\u0440\u044c",
      "longitude":93.065236,
      "latitude":56.2848219
    },
    "550":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0439 \u041a\u0443\u0436\u0435\u0431\u0430\u0440",
      "longitude":93.0785223,
      "latitude":53.5350091
    },
    "551":{
      "name":"\u041f\u0435\u0441\u0447\u0430\u043d\u043a\u0430",
      "longitude":93.0818319,
      "latitude":56.0831621
    },
    "552":{
      "name":"\u0414\u0443\u0434\u043e\u0432\u043a\u0430",
      "longitude":93.089176,
      "latitude":57.4575376
    },
    "553":{
      "name":"\u0416\u0435\u0440\u0431\u0430\u0442\u0438\u0445\u0430",
      "longitude":93.103439,
      "latitude":53.863697
    },
    "554":{
      "name":"\u041a\u0443\u0431\u0435\u043a\u043e\u0432\u043e",
      "longitude":93.1142225,
      "latitude":56.1483926
    },
    "555":{
      "name":"\u041c\u0430\u043b\u044b\u0439 \u041a\u0430\u043d\u0442\u0430\u0442",
      "longitude":93.1175479,
      "latitude":56.9517279
    },
    "556":{
      "name":"\u0428\u0438\u0440\u044b\u0448\u0442\u044b\u043a",
      "longitude":93.118492,
      "latitude":53.352016
    },
    "557":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u041a\u0430\u043d\u0442\u0430\u0442",
      "longitude":93.1313419,
      "latitude":57.0501731
    },
    "558":{
      "name":"\u0411\u0430\u0440\u0442\u0430\u0442",
      "longitude":93.1390729,
      "latitude":56.7217234
    },
    "559":{
      "name":"\u0420\u0430\u0437\u0434\u043e\u043b\u044c\u043d\u043e\u0435",
      "longitude":93.1440233,
      "latitude":57.2371125
    },
    "560":{
      "name":"\u0415\u0440\u043c\u043e\u043b\u0430\u0435\u0432\u0441\u043a\u0438\u0439 \u0417\u0430\u0442\u043e\u043d",
      "longitude":93.145233,
      "latitude":56.143478
    },
    "561":{
      "name":"\u0420\u043e\u0436\u0434\u0435\u0441\u0442\u0432\u0435\u043d\u0441\u043a\u043e\u0435",
      "longitude":93.145859,
      "latitude":57.618469
    },
    "562":{
      "name":"\u0415\u0440\u043c\u043e\u043b\u0430\u0435\u0432\u043e",
      "longitude":93.150597,
      "latitude":56.130852
    },
    "563":{
      "name":"\u0422\u0438\u0433\u0438\u043d\u043e",
      "longitude":93.15387,
      "latitude":56.808899
    },
    "564":{
      "name":"\u0422\u0430\u043b\u043e\u0432\u043a\u0430",
      "longitude":93.154689,
      "latitude":57.1585285
    },
    "565":{
      "name":"\u0417\u044b\u043a\u043e\u0432\u043e",
      "longitude":93.164253,
      "latitude":55.959805
    },
    "566":{
      "name":"\u0418\u043c\u0438\u0441\u0441\u043a\u043e\u0435",
      "longitude":93.1644157,
      "latitude":53.9054967
    },
    "567":{
      "name":"\u041f\u044f\u0442\u043a\u043e\u0432\u043e",
      "longitude":93.1944186,
      "latitude":57.4110214
    },
    "568":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0435 \u041a\u0443\u0440\u044f\u0442\u044b",
      "longitude":93.1954708,
      "latitude":53.780933
    },
    "569":{
      "name":"\u041c\u043e\u043a\u0440\u0443\u0448\u0438\u043d\u0441\u043a\u043e\u0435",
      "longitude":93.1969242,
      "latitude":57.5193527
    },
    "570":{
      "name":"\u041f\u043e\u0434\u0441\u043e\u043f\u043a\u0438",
      "longitude":93.20546,
      "latitude":56.423412
    },
    "571":{
      "name":"\u0427\u0435\u043b\u043d\u043e\u043a\u0438",
      "longitude":93.2086477,
      "latitude":57.5767983
    },
    "572":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u041a\u0443\u0436\u0435\u0431\u0430\u0440",
      "longitude":93.2415549,
      "latitude":53.3686118
    },
    "573":{
      "name":"\u0416\u0443\u0440\u0430\u0432\u043b\u0435\u0432\u043e",
      "longitude":93.2505345,
      "latitude":54.1606213
    },
    "574":{
      "name":"\u041c\u0430\u0433\u0430\u043d\u0441\u043a",
      "longitude":93.263618,
      "latitude":55.865284
    },
    "575":{
      "name":"\u0412\u043e\u0437\u043d\u0435\u0441\u0435\u043d\u043a\u0430",
      "longitude":93.264992,
      "latitude":56.002419
    },
    "576":{
      "name":"\u0415\u043b\u043e\u0432\u043a\u0430",
      "longitude":93.2694573,
      "latitude":56.7556672
    },
    "577":{
      "name":"\u0413\u0430\u043b\u0430\u043d\u0438\u043d\u043e",
      "longitude":93.2707862,
      "latitude":57.6204506
    },
    "578":{
      "name":"\u0415\u0441\u0430\u0443\u043b\u043e\u0432\u043e",
      "longitude":93.271797,
      "latitude":56.142456
    },
    "579":{
      "name":"\u041a\u043e\u0440\u0434\u043e\u0432\u043e",
      "longitude":93.280478,
      "latitude":54.0943365
    },
    "580":{
      "name":"\u0411\u0435\u0440\u0435\u0437\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":93.2823303,
      "latitude":55.8066885
    },
    "581":{
      "name":"\u0422\u0435\u0440\u0435\u043d\u0442\u044c\u0435\u0432\u043e",
      "longitude":93.296623,
      "latitude":56.11422
    },
    "582":{
      "name":"\u041a\u043e\u043c\u0430\u0440\u043e\u0432\u043e",
      "longitude":93.2994325,
      "latitude":56.901013
    },
    "583":{
      "name":"\u0417\u0430\u0445\u0430\u0440\u043e\u0432\u043a\u0430",
      "longitude":93.3010756,
      "latitude":57.8017099
    },
    "584":{
      "name":"\u0420\u043e\u0441\u0441\u0438\u0439\u043a\u0430",
      "longitude":93.3169055,
      "latitude":57.0529829
    },
    "585":{
      "name":"\u041c\u043e\u043c\u043e\u0442\u043e\u0432\u043e",
      "longitude":93.3190621,
      "latitude":57.6250033
    },
    "586":{
      "name":"\u041a\u0438\u043d\u0434\u044f\u043a\u043e\u0432\u043e",
      "longitude":93.3250542,
      "latitude":56.0641577
    },
    "587":{
      "name":"\u041f\u0430\u043a\u0443\u043b\u044c",
      "longitude":93.3283113,
      "latitude":56.847007
    },
    "588":{
      "name":"\u0427\u0435\u043b\u043d\u043e\u043a\u043e\u0432\u043e",
      "longitude":93.329056,
      "latitude":56.042835
    },
    "589":{
      "name":"\u041c\u043e\u0436\u0430\u0440\u043a\u0430",
      "longitude":93.3352738,
      "latitude":53.9645711
    },
    "590":{
      "name":"\u0427\u0430\u0441\u0442\u043e\u043e\u0441\u0442\u0440\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":93.339455,
      "latitude":56.197365
    },
    "591":{
      "name":"\u041f\u0438\u0441\u043a\u0443\u043d\u043e\u0432\u043a\u0430",
      "longitude":93.3413439,
      "latitude":57.5550538
    },
    "592":{
      "name":"\u0411\u0443\u0437\u0438\u043c",
      "longitude":93.358047,
      "latitude":56.504944
    },
    "593":{
      "name":"\u0411\u0430\u0440\u0445\u0430\u0442\u043e\u0432\u043e",
      "longitude":93.359413,
      "latitude":56.044079
    },
    "594":{
      "name":"\u0422\u0430\u0440\u0442\u0430\u0442",
      "longitude":93.3745756,
      "latitude":56.1701822
    },
    "595":{
      "name":"\u041a\u043e\u0448\u0443\u0440\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":93.394783,
      "latitude":54.300556
    },
    "596":{
      "name":"\u0421\u0435\u0434\u0435\u043b\u044c\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":93.40061589049061,
      "latitude":56.52268590033301
    },
    "597":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u0423\u043d\u0433\u0443\u0442",
      "longitude":93.404961,
      "latitude":55.421055
    },
    "598":{
      "name":"\u0412\u044b\u0441\u043e\u0442\u0438\u043d\u043e",
      "longitude":93.4008703294754,
      "latitude":56.549764638263476
    },
    "599":{
      "name":"\u041f\u043e\u0434\u0433\u043e\u0440\u043d\u044b\u0439",
      "longitude":93.432945,
      "latitude":56.122833
    },
    "600":{
      "name":"\u0414\u043e\u0434\u043e\u043d\u043e\u0432\u043e",
      "longitude":93.436493,
      "latitude":56.273659
    },
    "601":{
      "name":"\u0410\u0440\u0442\u0451\u043c\u043e\u0432\u0441\u043a",
      "longitude":93.437813,
      "latitude":54.349564
    },
    "602":{
      "name":"\u041f\u0440\u0435\u0434\u0438\u0432\u0438\u043d\u0441\u043a",
      "longitude":93.4391071,
      "latitude":57.0652229
    },
    "603":{
      "name":"\u042e\u043a\u0441\u0435\u0435\u0432\u043e",
      "longitude":93.4399691,
      "latitude":56.8443285
    },
    "604":{
      "name":"\u0410\u0440\u0430\u0434\u0430\u043d",
      "longitude":93.4426151,
      "latitude":52.5745347
    },
    "605":{
      "name":"\u0429\u0435\u0442\u0438\u043d\u043a\u0438\u043d\u043e",
      "longitude":93.4431635,
      "latitude":54.5399173
    },
    "606":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0438\u0435 \u041f\u0440\u0443\u0434\u044b",
      "longitude":93.4515587,
      "latitude":56.3937019
    },
    "607":{
      "name":"\u041d\u043e\u0432\u044b\u0439 \u041f\u0443\u0442\u044c",
      "longitude":93.4598073,
      "latitude":56.1677532
    },
    "608":{
      "name":"\u0411\u0440\u044f\u043d\u043a\u0430",
      "longitude":93.47525,
      "latitude":59.107403
    },
    "609":{
      "name":"\u041c\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":93.4781915,
      "latitude":56.5879906
    },
    "610":{
      "name":"\u0428\u0438\u0432\u0435\u0440\u0430",
      "longitude":93.4863656,
      "latitude":56.3215109
    },
    "611":{
      "name":"\u041c\u0438\u043d\u0433\u0443\u043b\u044c",
      "longitude":93.4864671,
      "latitude":56.458013
    },
    "612":{
      "name":"\u0422\u0430\u044f\u0442\u044b",
      "longitude":93.494598,
      "latitude":53.773319
    },
    "613":{
      "name":"\u041a\u043e\u043b\u0431\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":93.5027594,
      "latitude":55.1633035
    },
    "614":{
      "name":"\u0422\u044e\u0445\u0442\u044f\u0442",
      "longitude":93.5175302,
      "latitude":53.9250653
    },
    "615":{
      "name":"\u041d\u0430\u0445\u0432\u0430\u043b\u044c\u0441\u043a\u043e\u0435",
      "longitude":93.571243,
      "latitude":56.673904
    },
    "616":{
      "name":"\u041d\u043e\u0432\u043e\u0442\u0440\u043e\u0438\u0446\u043a\u043e\u0435",
      "longitude":93.5716166,
      "latitude":57.6006942
    },
    "617":{
      "name":"\u041f\u0430\u0432\u043b\u043e\u0432\u0449\u0438\u043d\u0430",
      "longitude":93.572222,
      "latitude":56.7425503
    },
    "618":{
      "name":"\u041d\u043e\u0432\u043e\u0430\u043d\u0433\u0430\u0440\u0441\u043a",
      "longitude":93.5837762,
      "latitude":58.1026125
    },
    "619":{
      "name":"\u0412\u0435\u0442\u0432\u0438\u0441\u0442\u044b\u0439",
      "longitude":93.59687,
      "latitude":55.8931415
    },
    "620":{
      "name":"\u041d\u043e\u0432\u043e\u043d\u0438\u043a\u043e\u043b\u044c\u0441\u043a",
      "longitude":93.610976,
      "latitude":55.783842
    },
    "621":{
      "name":"\u0412\u0430\u043d\u0433\u0430\u0448",
      "longitude":93.61451,
      "latitude":59.971928
    },
    "622":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u043c\u0430\u043d\u0441\u043a",
      "longitude":93.6223592,
      "latitude":55.8547649
    },
    "623":{
      "name":"\u0410\u0442\u0430\u043c\u0430\u043d\u043e\u0432\u043e",
      "longitude":93.6211941777867,
      "latitude":56.39827015322315
    },
    "624":{
      "name":"\u0427\u0438\u0431\u0438\u0436\u0435\u043a",
      "longitude":93.645981,
      "latitude":54.400734
    },
    "625":{
      "name":"\u041d\u0430\u0440\u0432\u0430",
      "longitude":93.6462767,
      "latitude":55.4023626
    },
    "626":{
      "name":"\u0425\u043b\u043e\u043f\u0442\u0443\u043d\u043e\u0432\u043e",
      "longitude":93.65008787377718,
      "latitude":56.46979273632914
    },
    "627":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u043f\u0430\u0432\u043b\u043e\u0432\u043a\u0430",
      "longitude":93.6653927,
      "latitude":53.9019866
    },
    "628":{
      "name":"\u041e\u0440\u0435\u0448\u043d\u043e\u0435",
      "longitude":93.6700342,
      "latitude":55.3002181
    },
    "629":{
      "name":"\u041a\u0430\u043c\u0430\u0440\u0447\u0430\u0433\u0430",
      "longitude":93.6839028,
      "latitude":55.8083208
    },
    "630":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":93.6852895,
      "latitude":57.3784226
    },
    "631":{
      "name":"\u041a\u043e\u043d\u043e\u043d\u043e\u0432\u043e",
      "longitude":93.712807,
      "latitude":56.505638
    },
    "632":{
      "name":"\u041d\u0438\u0436\u043d\u044f\u044f \u0415\u0441\u0430\u0443\u043b\u043e\u0432\u043a\u0430",
      "longitude":93.7174912,
      "latitude":55.7856477
    },
    "633":{
      "name":"\u0427\u0435\u0440\u0435\u043c\u0448\u0430\u043d\u043a\u0430",
      "longitude":93.7393209,
      "latitude":53.8788347
    },
    "634":{
      "name":"\u0422\u0435\u0440\u0442\u0435\u0436",
      "longitude":93.7539053,
      "latitude":55.8793438
    },
    "635":{
      "name":"\u041a\u0443\u043b\u0430\u043a\u043e\u0432\u043e",
      "longitude":93.7542114,
      "latitude":58.0952163
    },
    "636":{
      "name":"\u0421\u0442\u0435\u043f\u043d\u043e\u0439 \u0411\u0430\u0434\u0436\u0435\u0439",
      "longitude":93.7554071,
      "latitude":55.2029371
    },
    "637":{
      "name":"\u0428\u0430\u043b\u0438\u043d\u0441\u043a\u043e\u0435",
      "longitude":93.764816,
      "latitude":55.719715
    },
    "638":{
      "name":"\u0413\u0443\u043b\u044f\u0435\u0432\u043a\u0430",
      "longitude":93.7700088,
      "latitude":53.84256
    },
    "639":{
      "name":"\u041a\u0438\u044f\u0439",
      "longitude":93.7716802,
      "latitude":55.5169213
    },
    "640":{
      "name":"\u041a\u0430\u0437\u0430\u043d\u043a\u0430",
      "longitude":93.7807876,
      "latitude":57.3424554
    },
    "641":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u044f\u044f \u0415\u0441\u0430\u0443\u043b\u043e\u0432\u043a\u0430",
      "longitude":93.7886919,
      "latitude":55.676098
    },
    "642":{
      "name":"\u0422\u0443\u0442\u043e\u043d\u0447\u0430\u043d\u044b",
      "longitude":93.7979341,
      "latitude":64.2092694
    },
    "643":{
      "name":"\u0416\u0430\u0440\u043e\u0432\u0441\u043a",
      "longitude":93.9052874,
      "latitude":53.7739745
    },
    "644":{
      "name":"\u0412\u044b\u0435\u0437\u0436\u0438\u0439 \u041b\u043e\u0433",
      "longitude":93.9302261,
      "latitude":54.975382
    },
    "645":{
      "name":"\u0420\u043e\u0449\u0430",
      "longitude":93.949668,
      "latitude":55.8437568
    },
    "646":{
      "name":"\u041c\u0430\u043d\u0430",
      "longitude":93.9542463,
      "latitude":54.9557406
    },
    "647":{
      "name":"\u0411\u0430\u043b\u0430\u0439",
      "longitude":93.9854802,
      "latitude":55.870255
    },
    "648":{
      "name":"\u041a\u043e\u0436\u0435\u043b\u0430\u043a",
      "longitude":93.9993995,
      "latitude":55.3358999
    },
    "649":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u043c\u0430\u0439\u0441\u043a",
      "longitude":94.0964083,
      "latitude":58.0160752
    },
    "650":{
      "name":"\u0417\u0430\u043f\u0430\u0441\u043d\u043e\u0439 \u0418\u043c\u0431\u0435\u0436",
      "longitude":94.127151,
      "latitude":55.559559
    },
    "651":{
      "name":"\u041c\u0438\u043d\u0430",
      "longitude":94.13781,
      "latitude":54.977322
    },
    "652":{
      "name":"\u0421\u0443\u0445\u043e\u043d\u043e\u0439",
      "longitude":94.1706276,
      "latitude":55.609986
    },
    "653":{
      "name":"\u0421\u0443\u0448\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":94.2119142,
      "latitude":55.7779708
    },
    "654":{
      "name":"\u041f\u0430\u0440\u0442\u0438\u0437\u0430\u043d\u0441\u043a",
      "longitude":94.2401778,
      "latitude":58.6841302
    },
    "655":{
      "name":"\u0421\u043e\u043b\u043e\u043d\u0435\u0447\u043d\u043e-\u0422\u0430\u043b\u043e\u0435",
      "longitude":94.241776,
      "latitude":55.295036
    },
    "656":{
      "name":"\u041e\u043b\u044c\u0433\u0438\u043d\u043e",
      "longitude":94.3060927,
      "latitude":55.8659167
    },
    "657":{
      "name":"\u0412\u0435\u0440\u0448\u0438\u043d\u043e-\u0420\u044b\u0431\u043d\u043e\u0435",
      "longitude":94.3342563,
      "latitude":55.2849858
    },
    "658":{
      "name":"\u041c\u0430\u0448\u0443\u043a\u043e\u0432\u043a\u0430",
      "longitude":94.3870054,
      "latitude":57.7964584
    },
    "659":{
      "name":"\u041f\u0430\u0440\u0442\u0438\u0437\u0430\u043d\u0441\u043a\u043e\u0435",
      "longitude":94.393066,
      "latitude":55.499271
    },
    "660":{
      "name":"\u0413\u0440\u043e\u043c\u0430\u0434\u0441\u043a",
      "longitude":94.398573,
      "latitude":55.9004671
    },
    "661":{
      "name":"\u0422\u043e\u043b\u0441\u0442\u0438\u0445\u0438\u043d\u043e",
      "longitude":94.4526439,
      "latitude":55.6861578
    },
    "662":{
      "name":"\u041d\u043e\u0432\u043e\u043f\u044f\u0442\u043d\u0438\u0446\u043a\u043e\u0435",
      "longitude":94.4824412,
      "latitude":55.8508334
    },
    "663":{
      "name":"\u0412\u043e\u0441\u0442\u043e\u0447\u043d\u043e\u0435",
      "longitude":94.4864606,
      "latitude":55.6288742
    },
    "664":{
      "name":"\u0423\u043d\u0436\u0430",
      "longitude":94.4912471,
      "latitude":57.2149723
    },
    "665":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":94.4939611,
      "latitude":55.2596866
    },
    "666":{
      "name":"\u0421\u0442\u043e\u0439\u0431\u0430",
      "longitude":94.4960755,
      "latitude":55.5002204
    },
    "667":{
      "name":"\u0423\u0441\u043f\u0435\u043d\u043a\u0430",
      "longitude":94.49881,
      "latitude":55.924328
    },
    "668":{
      "name":"\u0420\u044b\u0431\u043d\u043e\u0435",
      "longitude":94.5117575,
      "latitude":58.1311345
    },
    "669":{
      "name":"\u0421\u0438\u0432\u043e\u0445\u0438\u043d\u043e",
      "longitude":94.5182985,
      "latitude":57.0942662
    },
    "670":{
      "name":"\u0411\u0435\u043b\u044c\u0441\u043a",
      "longitude":94.5216538,
      "latitude":58.1708145
    },
    "671":{
      "name":"\u0412\u043e\u043b\u043e\u0447\u0430\u043d\u043a\u0430",
      "longitude":94.540245,
      "latitude":70.975899
    },
    "672":{
      "name":"\u0418\u043d\u043d\u043e\u043a\u0435\u043d\u0442\u044c\u0435\u0432\u043a\u0430",
      "longitude":94.5508201,
      "latitude":55.4126258
    },
    "673":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":94.5579701,
      "latitude":55.9929136
    },
    "674":{
      "name":"\u0420\u0430\u0437\u0434\u043e\u043b\u0438\u043d\u0441\u043a",
      "longitude":94.618317,
      "latitude":58.41917
    },
    "675":{
      "name":"\u0410\u0432\u0434\u0430",
      "longitude":94.6206492,
      "latitude":55.7378276
    },
    "676":{
      "name":"\u0411\u043e\u0433\u0443\u0441\u043b\u0430\u0432\u043a\u0430",
      "longitude":94.637047,
      "latitude":55.4833921
    },
    "677":{
      "name":"\u0421\u0443\u0445\u043e\u0432\u043e",
      "longitude":94.6445747,
      "latitude":57.06438
    },
    "678":{
      "name":"\u042e\u0436\u043d\u043e-\u0415\u043d\u0438\u0441\u0435\u0439\u0441\u043a",
      "longitude":94.647484,
      "latitude":58.789608
    },
    "679":{
      "name":"\u041f\u043e\u043b\u0438\u0433\u0443\u0441",
      "longitude":94.6579826,
      "latitude":61.9894286
    },
    "680":{
      "name":"\u0412\u044b\u0441\u043e\u0442\u0438\u043d\u043e",
      "longitude":94.6618989,
      "latitude":56.0340629
    },
    "681":{
      "name":"\u041a\u0443\u043b\u0438\u0436\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":94.6866606,
      "latitude":55.277985
    },
    "682":{
      "name":"\u041d\u0430\u043b\u043e\u0431\u0438\u043d\u043e",
      "longitude":94.6902597,
      "latitude":55.9056212
    },
    "683":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u0410\u0440\u0431\u0430\u0439",
      "longitude":94.6946897,
      "latitude":55.1822616
    },
    "684":{
      "name":"\u0423\u0441\u0442\u044c-\u041a\u0430\u043d\u0434\u044b\u0433\u0430",
      "longitude":94.7380314,
      "latitude":55.5416881
    },
    "685":{
      "name":"\u041f\u0435\u0440\u0435\u044f\u0441\u043b\u043e\u0432\u043a\u0430",
      "longitude":94.7430638,
      "latitude":55.673071
    },
    "686":{
      "name":"\u0421\u0440\u0435\u0434\u043d\u044f\u044f \u0410\u0433\u0438\u043d\u043a\u0430",
      "longitude":94.748075,
      "latitude":55.3219934
    },
    "687":{
      "name":"\u0423\u0440\u0430\u043b",
      "longitude":94.748611,
      "latitude":55.906376
    },
    "688":{
      "name":"\u041c\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":94.76634,
      "latitude":55.1286102
    },
    "689":{
      "name":"\u0420\u044b\u0431\u043d\u043e\u0435",
      "longitude":94.7694872,
      "latitude":55.7759822
    },
    "690":{
      "name":"\u0414\u0432\u0443\u0440\u0435\u0447\u043d\u043e\u0435",
      "longitude":94.7701486,
      "latitude":55.7097174
    },
    "691":{
      "name":"\u0423\u043d\u0435\u0440",
      "longitude":94.7840042,
      "latitude":55.4412673
    },
    "692":{
      "name":"\u0418\u0440\u0448\u0430",
      "longitude":94.797691,
      "latitude":55.927376
    },
    "693":{
      "name":"\u041d\u043e\u0432\u0430\u044f",
      "longitude":94.8005336,
      "latitude":55.8724581
    },
    "694":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u0433\u043e\u0440\u044c\u0435\u0432\u043a\u0430",
      "longitude":94.8274611,
      "latitude":55.576099
    },
    "695":{
      "name":"\u0422\u0440\u043e\u0438\u0446\u043a",
      "longitude":94.8398886,
      "latitude":57.4155086
    },
    "696":{
      "name":"\u0428\u0435\u043b\u043e\u043c\u043a\u0438",
      "longitude":94.8617755,
      "latitude":56.8017128
    },
    "697":{
      "name":"\u041a\u0438\u0440\u0441\u0430\u043d\u0442\u044c\u0435\u0432\u043e",
      "longitude":94.8842747,
      "latitude":57.7416196
    },
    "698":{
      "name":"\u0425\u0430\u043d\u0434\u0430\u043b\u0430",
      "longitude":94.9159976,
      "latitude":57.12773
    },
    "699":{
      "name":"\u0423\u043b\u044e\u043a\u043e\u043b\u044c",
      "longitude":94.923889,
      "latitude":56.7061603
    },
    "700":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u041a\u0430\u043c\u0430\u043b\u0430",
      "longitude":94.9426974,
      "latitude":56.0886241
    },
    "701":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u0418\u043b\u044c\u0431\u0438\u043d",
      "longitude":94.9436177,
      "latitude":55.1770361
    },
    "702":{
      "name":"\u0412\u043e\u0437\u043d\u0435\u0441\u0435\u043d\u043a\u0430",
      "longitude":94.9453934,
      "latitude":55.0597832
    },
    "703":{
      "name":"\u0411\u043e\u0440\u043e\u0434\u0438\u043d\u043e",
      "longitude":94.9679723,
      "latitude":55.8714578
    },
    "704":{
      "name":"\u041c\u0435\u0436\u043e\u0432\u043e",
      "longitude":94.982389,
      "latitude":55.5437555
    },
    "705":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u0430\u043c\u0430\u043b\u0430",
      "longitude":94.9872319,
      "latitude":55.9729227
    },
    "706":{
      "name":"\u0422\u0430\u0451\u0436\u043d\u043e\u0435",
      "longitude":94.996941,
      "latitude":56.254204
    },
    "707":{
      "name":"\u0422\u0438\u043d\u0441\u043a\u0430\u044f",
      "longitude":95.0377077,
      "latitude":55.4198249
    },
    "708":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u041a\u0443\u0440\u044b\u0448",
      "longitude":95.0455472,
      "latitude":56.2144777
    },
    "709":{
      "name":"\u041d\u0430\u0433\u043e\u0440\u043d\u043e\u0435",
      "longitude":95.0584022,
      "latitude":55.3194937
    },
    "710":{
      "name":"\u0413\u043b\u0430\u0434\u043a\u043e\u0432\u043e",
      "longitude":95.081596,
      "latitude":55.210724
    },
    "711":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u044f\u044f \u0423\u0440\u044f",
      "longitude":95.0822803,
      "latitude":55.6737235
    },
    "712":{
      "name":"\u0414\u0435\u043d\u0438\u0441\u043e\u0432\u043e",
      "longitude":95.094667,
      "latitude":56.8530522
    },
    "713":{
      "name":"\u0415\u043b\u0438\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":95.097582,
      "latitude":55.592025
    },
    "714":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":95.1084792,
      "latitude":56.4822839
    },
    "715":{
      "name":"\u041e\u0440\u044c\u0451",
      "longitude":95.1148376,
      "latitude":55.0064798
    },
    "716":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":95.1356363,
      "latitude":56.6938174
    },
    "717":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0438\u0435 \u041a\u043b\u044e\u0447\u0438",
      "longitude":95.1756416,
      "latitude":55.9508053
    },
    "718":{
      "name":"\u041c\u043e\u043a\u0440\u0443\u0448\u0430",
      "longitude":95.1875341,
      "latitude":56.4224758
    },
    "719":{
      "name":"\u0412\u0435\u0441\u0451\u043b\u043e\u0435",
      "longitude":95.1926728,
      "latitude":57.0816798
    },
    "720":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u0421\u043e\u043b\u044f\u043d\u043a\u0430",
      "longitude":95.2025853,
      "latitude":56.0063708
    },
    "721":{
      "name":"\u0422\u0435\u0440\u0441\u043a\u043e\u0435",
      "longitude":95.2034686,
      "latitude":56.2138031
    },
    "722":{
      "name":"\u0425\u0430\u0435\u0440\u0438\u043d\u043e",
      "longitude":95.2035459,
      "latitude":56.3396067
    },
    "723":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":95.2041092,
      "latitude":55.4339905
    },
    "724":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":95.2301771,
      "latitude":55.4488292
    },
    "725":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e-\u0415\u0440\u0448\u0430",
      "longitude":95.2681805,
      "latitude":56.6286757
    },
    "726":{
      "name":"\u0423\u0441\u0442\u044c-\u042f\u0440\u0443\u043b\u044c",
      "longitude":95.2793842,
      "latitude":55.8042924
    },
    "727":{
      "name":"\u0422\u0443\u0433\u0430\u0447",
      "longitude":95.288056,
      "latitude":55.1357839
    },
    "728":{
      "name":"\u0423\u0441\u043e\u043b\u043a\u0430",
      "longitude":95.3211407,
      "latitude":56.7793854
    },
    "729":{
      "name":"\u0411\u043e\u0448\u043d\u044f\u043a\u043e\u0432\u043e",
      "longitude":95.3282041,
      "latitude":56.1147684
    },
    "730":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u0435 \u041c\u0430\u044f",
      "longitude":95.3487816,
      "latitude":55.6098065
    },
    "731":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0439 \u0422\u0430\u043d\u0430\u0439",
      "longitude":95.3628863,
      "latitude":56.752651
    },
    "732":{
      "name":"\u0421\u0443\u0445\u0430\u044f \u0420\u0435\u0447\u043a\u0430",
      "longitude":95.3662127,
      "latitude":56.2013153
    },
    "733":{
      "name":"\u0423\u0441\u043f\u0435\u043d\u043a\u0430",
      "longitude":95.3742193,
      "latitude":55.2912303
    },
    "734":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":95.3804606,
      "latitude":55.5648271
    },
    "735":{
      "name":"\u0413\u0435\u043e\u0440\u0433\u0438\u0435\u0432\u043a\u0430",
      "longitude":95.4071936,
      "latitude":56.5130937
    },
    "736":{
      "name":"\u0423\u0441\u0442\u044c-\u041a\u0430\u043d\u0430\u0447\u0443\u043b\u044c",
      "longitude":95.421129,
      "latitude":55.8651896
    },
    "737":{
      "name":"\u0418\u0437\u0443\u043c\u0440\u0443\u0434\u043d\u044b\u0439",
      "longitude":95.4225845,
      "latitude":55.6542159
    },
    "738":{
      "name":"\u041d\u0430\u0433\u043e\u0440\u043d\u0430\u044f",
      "longitude":95.4324662,
      "latitude":55.6722869
    },
    "739":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u041c\u0430\u044f\u043a",
      "longitude":95.4382282,
      "latitude":56.2026184
    },
    "740":{
      "name":"\u041e\u0440\u0434\u0436\u043e\u043d\u0438\u043a\u0438\u0434\u0437\u0435",
      "longitude":95.458481,
      "latitude":58.456604
    },
    "741":{
      "name":"\u0424\u0438\u043b\u0438\u043c\u043e\u043d\u043e\u0432\u043e",
      "longitude":95.461113,
      "latitude":56.201477
    },
    "742":{
      "name":"\u0427\u0443\u0445\u043b\u043e\u043c\u0438\u043d\u043e",
      "longitude":95.4661193,
      "latitude":55.7976101
    },
    "743":{
      "name":"\u0410\u0441\u0442\u0430\u0444\u044c\u0435\u0432\u043a\u0430",
      "longitude":95.4719291,
      "latitude":56.3969159
    },
    "744":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u0423\u0440\u044f",
      "longitude":95.482086,
      "latitude":56.026051
    },
    "745":{
      "name":"\u0424\u0430\u043d\u0430\u0447\u0435\u0442",
      "longitude":95.4869723,
      "latitude":57.1454287
    },
    "746":{
      "name":"\u041a\u0443\u0440\u0430\u0439",
      "longitude":95.4915724,
      "latitude":56.6872028
    },
    "747":{
      "name":"\u041e\u0440\u043b\u043e\u0432\u043a\u0430",
      "longitude":95.501343,
      "latitude":56.935833
    },
    "748":{
      "name":"\u0422\u0430\u0439\u043d\u0430",
      "longitude":95.5040715,
      "latitude":56.4407927
    },
    "749":{
      "name":"\u042e\u0434\u0438\u043d\u043e",
      "longitude":95.5043234,
      "latitude":55.6685791
    },
    "750":{
      "name":"\u0410\u043d\u0446\u0438\u0440\u044c",
      "longitude":95.5381308,
      "latitude":56.2534217
    },
    "751":{
      "name":"\u0421\u043e\u0442\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":95.5420466,
      "latitude":56.3436364
    },
    "752":{
      "name":"\u0422\u0443\u043c\u0430\u043a\u043e\u0432\u043e",
      "longitude":95.5613828,
      "latitude":55.7939558
    },
    "753":{
      "name":"\u041c\u0435\u043b\u044c\u043d\u0438\u0447\u043d\u043e\u0435",
      "longitude":95.59079,
      "latitude":55.605072
    },
    "754":{
      "name":"\u0420\u0443\u0434\u044f\u043d\u043e\u0435",
      "longitude":95.6183696,
      "latitude":56.5013584
    },
    "755":{
      "name":"\u0412\u0435\u0440\u0445-\u0410\u043c\u043e\u043d\u0430\u0448",
      "longitude":95.624789,
      "latitude":55.9050721
    },
    "756":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u043a\u0430",
      "longitude":95.629143,
      "latitude":56.617229
    },
    "757":{
      "name":"\u0411\u0435\u0440\u0435\u0436\u043a\u0438",
      "longitude":95.6365629,
      "latitude":56.2311259
    },
    "758":{
      "name":"\u041c\u0430\u043b\u043e\u0432\u043a\u0430",
      "longitude":95.6563793,
      "latitude":55.6807249
    },
    "759":{
      "name":"\u0422\u0430\u043b\u043e\u0435",
      "longitude":95.6648973,
      "latitude":55.4089041
    },
    "760":{
      "name":"\u0428\u0430\u0445\u0442\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":95.6848695,
      "latitude":56.293691
    },
    "761":{
      "name":"\u0427\u0435\u0447\u0435\u0443\u043b",
      "longitude":95.7173697,
      "latitude":56.1310472
    },
    "762":{
      "name":"\u0421\u0442\u0435\u043f\u043d\u044f\u043a\u0438",
      "longitude":95.7291595,
      "latitude":55.9558882
    },
    "763":{
      "name":"\u0410\u0440\u0435\u0444\u044c\u0435\u0432\u043a\u0430",
      "longitude":95.7312072,
      "latitude":56.3576182
    },
    "764":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u043f\u0430\u0432\u043b\u043e\u0432\u043a\u0430-1",
      "longitude":95.7436634,
      "latitude":55.6801696
    },
    "765":{
      "name":"\u0421\u0442\u0435\u043f\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":95.767585,
      "latitude":55.1743158
    },
    "766":{
      "name":"\u0417\u0435\u043b\u0451\u043d\u044b\u0439 \u041b\u0443\u0433",
      "longitude":95.7686033,
      "latitude":56.1636835
    },
    "767":{
      "name":"\u0411\u044b\u0447\u043a\u043e\u0432\u043a\u0430",
      "longitude":95.7714595,
      "latitude":55.6353431
    },
    "768":{
      "name":"\u041f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":95.779541,
      "latitude":56.903278
    },
    "769":{
      "name":"\u041d\u043e\u0432\u044b\u0439 \u041f\u0443\u0442\u044c",
      "longitude":95.782951,
      "latitude":56.185532
    },
    "770":{
      "name":"\u0411\u043b\u0430\u0433\u043e\u0432\u0435\u0449\u0435\u043d\u043a\u0430",
      "longitude":95.8085052,
      "latitude":55.4432606
    },
    "771":{
      "name":"\u0417\u0430\u043e\u0437\u0451\u0440\u043a\u0430",
      "longitude":95.8171397,
      "latitude":56.7144195
    },
    "772":{
      "name":"\u0410\u0448\u043a\u0430\u0443\u043b",
      "longitude":95.8211824,
      "latitude":56.1068137
    },
    "773":{
      "name":"\u0422\u0430\u0440\u0430\u0439",
      "longitude":95.8365367,
      "latitude":55.8612048
    },
    "774":{
      "name":"\u0410\u043c\u043e\u043d\u0430\u0448",
      "longitude":95.8405721,
      "latitude":55.9035802
    },
    "775":{
      "name":"\u0411\u0440\u0430\u0436\u043d\u043e\u0435",
      "longitude":95.859383,
      "latitude":56.063446
    },
    "776":{
      "name":"\u0410\u0433\u0443\u043b",
      "longitude":95.8874405,
      "latitude":55.5041068
    },
    "777":{
      "name":"\u041a\u0430\u0440\u0430\u043f\u0441\u0435\u043b\u044c",
      "longitude":95.8884259,
      "latitude":56.2153603
    },
    "778":{
      "name":"\u0421\u043e\u043a\u043e\u043b\u043e\u0432\u043a\u0430",
      "longitude":95.9015174,
      "latitude":56.4266589
    },
    "779":{
      "name":"\u0421\u0430\u043c\u043e\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":95.9020494,
      "latitude":56.8353719
    },
    "780":{
      "name":"\u0414\u0430\u043b\u0430\u0439",
      "longitude":95.9022088,
      "latitude":56.2947426
    },
    "781":{
      "name":"\u041a\u0443\u0447\u0435\u0440\u0434\u0430\u0435\u0432\u043a\u0430",
      "longitude":95.927705,
      "latitude":55.9448144
    },
    "782":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u044c\u0441\u043a",
      "longitude":95.951298,
      "latitude":56.7747446
    },
    "783":{
      "name":"\u0423\u0441\u0442\u044c\u044f\u043d\u0441\u043a",
      "longitude":96.016266,
      "latitude":56.522594
    },
    "784":{
      "name":"\u0414\u0435\u043d\u0438\u0441\u043e\u0432\u043a\u0430",
      "longitude":96.064444,
      "latitude":56.5795079
    },
    "785":{
      "name":"\u041d\u043e\u0432\u043e\u043f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":96.1097307,
      "latitude":56.3562021
    },
    "786":{
      "name":"\u041d\u0438\u0436\u043d\u0435\u0442\u0435\u0440\u044f\u043d\u0441\u043a",
      "longitude":96.15786,
      "latitude":58.503815
    },
    "787":{
      "name":"\u041d\u043e\u0432\u043e\u0433\u043e\u0440\u043e\u0434\u043a\u0430",
      "longitude":96.163349,
      "latitude":56.460006
    },
    "788":{
      "name":"\u042e\u0436\u043d\u043e-\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":96.181023,
      "latitude":55.851036
    },
    "789":{
      "name":"\u041d\u043e\u0432\u043e\u043d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":96.1907477,
      "latitude":55.7890537
    },
    "790":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u043f\u0430\u0432\u043b\u043e\u0432\u043a\u0430",
      "longitude":96.2119862,
      "latitude":56.6189756
    },
    "791":{
      "name":"\u0410\u043f\u0430\u043d\u043e-\u041a\u043b\u044e\u0447\u0438",
      "longitude":96.221741,
      "latitude":56.862183
    },
    "792":{
      "name":"\u042e\u0440\u0443\u0431\u0447\u0451\u043d-5",
      "longitude":96.2403792,
      "latitude":60.4310103
    },
    "793":{
      "name":"\u041c\u0430\u043d\u0437\u044f",
      "longitude":96.2623016,
      "latitude":58.491356
    },
    "794":{
      "name":"\u0421\u0442\u0435\u043f\u0430\u043d\u043e\u0432\u043e",
      "longitude":96.2988977,
      "latitude":56.2238153
    },
    "795":{
      "name":"\u041d\u043e\u0432\u043e\u0443\u0441\u043f\u0435\u043d\u043a\u0430",
      "longitude":96.3227404,
      "latitude":56.7706757
    },
    "796":{
      "name":"\u041a\u0430\u0441\u044c\u044f\u043d\u043e\u0432\u043e",
      "longitude":96.3546485,
      "latitude":56.054909
    },
    "797":{
      "name":"\u0417\u0430\u043b\u0438\u043f\u044c\u0435",
      "longitude":96.370374,
      "latitude":56.6704083
    },
    "798":{
      "name":"\u0421\u0443\u043b\u0435\u043c\u043a\u0430",
      "longitude":96.3840453,
      "latitude":56.2046465
    },
    "799":{
      "name":"\u0411\u0430\u0439\u043a\u0438\u0442",
      "longitude":96.385361,
      "latitude":61.678383
    },
    "800":{
      "name":"\u0421\u0442\u0440\u0435\u0442\u0435\u043d\u043a\u0430",
      "longitude":96.4000046,
      "latitude":56.4644767
    },
    "801":{
      "name":"\u0422\u0443\u0440\u043e\u0432\u043e",
      "longitude":96.4172404,
      "latitude":56.6521721
    },
    "802":{
      "name":"\u0415\u043b\u044c\u043d\u0438\u043a\u0438",
      "longitude":96.4172579,
      "latitude":55.7417533
    },
    "803":{
      "name":"\u041f\u043e\u0447\u0435\u0442",
      "longitude":96.422195,
      "latitude":57.192383
    },
    "804":{
      "name":"\u0423\u0447\u0430\u043c\u0438",
      "longitude":96.445068,
      "latitude":63.812748
    },
    "805":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u0418\u043d\u0433\u0430\u0448",
      "longitude":96.4455267,
      "latitude":56.2084252
    },
    "806":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":96.5124752,
      "latitude":56.3115186
    },
    "807":{
      "name":"\u041d\u043e\u0432\u043e\u0430\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":96.5795577,
      "latitude":56.4221837
    },
    "808":{
      "name":"\u0425\u0430\u0439\u0440\u044e\u0437\u043e\u0432\u043a\u0430",
      "longitude":96.6221543,
      "latitude":55.7920117
    },
    "809":{
      "name":"\u041f\u0430\u0432\u043b\u043e\u0432\u043a\u0430",
      "longitude":96.6228384,
      "latitude":56.0852939
    },
    "810":{
      "name":"\u0422\u0430\u043a\u0443\u0447\u0435\u0442",
      "longitude":96.6980743,
      "latitude":57.6175579
    },
    "811":{
      "name":"\u0410\u0440\u0442\u044e\u0433\u0438\u043d\u043e",
      "longitude":96.7373664,
      "latitude":58.5033752
    },
    "812":{
      "name":"\u041f\u043e\u0439\u043c\u043e-\u0422\u0438\u043d\u044b",
      "longitude":96.738109,
      "latitude":56.0754092
    },
    "813":{
      "name":"\u0421\u043e\u043a\u043e\u043b\u043e\u0432\u043a\u0430",
      "longitude":96.7464014,
      "latitude":56.3741332
    },
    "814":{
      "name":"\u0414\u043e\u043b\u0433\u0438\u0439 \u041c\u043e\u0441\u0442",
      "longitude":96.806709,
      "latitude":56.74707
    },
    "815":{
      "name":"\u0422\u0438\u043d\u044b",
      "longitude":96.8497647,
      "latitude":56.1298002
    },
    "816":{
      "name":"\u0422\u0438\u043d\u0441\u043a\u043e\u0439",
      "longitude":96.912376,
      "latitude":56.146004
    },
    "817":{
      "name":"\u041e\u0441\u0438\u043d\u043e\u0432\u044b\u0439 \u041c\u044b\u0441",
      "longitude":96.9143418,
      "latitude":57.5679609
    },
    "818":{
      "name":"\u041f\u0438\u043d\u0447\u0443\u0433\u0430",
      "longitude":96.9354914,
      "latitude":58.3720368
    },
    "819":{
      "name":"\u041a\u0443\u0447\u0435\u0440\u043e\u0432\u043e",
      "longitude":96.962008,
      "latitude":56.311517
    },
    "820":{
      "name":"\u041a\u0443\u044e\u043c\u0431\u0430",
      "longitude":96.975212,
      "latitude":60.960072
    },
    "821":{
      "name":"\u0412\u043e\u0437\u043d\u0435\u0441\u0435\u043d\u043a\u0430",
      "longitude":96.9972948,
      "latitude":56.971481
    },
    "822":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":97.010858,
      "latitude":56.3402501
    },
    "823":{
      "name":"\u0425\u0430\u043d\u0434\u0430\u043b\u044c\u0441\u043a",
      "longitude":97.1261731,
      "latitude":57.0917272
    },
    "824":{
      "name":"\u0410\u043d\u0433\u0430\u0440\u0441\u043a\u0438\u0439",
      "longitude":97.145955,
      "latitude":58.4381343
    },
    "825":{
      "name":"\u0411\u0435\u043b\u044f\u043a\u0438",
      "longitude":97.202237,
      "latitude":58.8649503
    },
    "826":{
      "name":"\u0411\u0435\u043b\u044c\u043d\u044f\u043a\u0438",
      "longitude":97.2395364,
      "latitude":56.241349
    },
    "827":{
      "name":"\u041a\u0443\u0440\u0434\u043e\u044f\u043a\u0438",
      "longitude":97.2513289,
      "latitude":56.0892518
    },
    "828":{
      "name":"\u0422\u0430\u0451\u0436\u043d\u044b\u0439",
      "longitude":97.307556,
      "latitude":58.075111
    },
    "829":{
      "name":"\u041a\u0430\u043d\u0438\u0444\u043e\u043b\u044c\u043d\u044b\u0439",
      "longitude":97.3244924,
      "latitude":56.2694334
    },
    "830":{
      "name":"\u0427\u0443\u043d\u043e\u044f\u0440",
      "longitude":97.3263487,
      "latitude":57.4495181
    },
    "831":{
      "name":"\u041a\u0430\u0440\u0430\u0431\u0443\u043b\u0430",
      "longitude":97.389473,
      "latitude":58.032879
    },
    "832":{
      "name":"\u0421\u0443\u0440\u0438\u043d\u0434\u0430",
      "longitude":97.408539,
      "latitude":62.556477
    },
    "833":{
      "name":"\u041f\u043e\u043a\u0430\u0442\u0435\u0435\u0432\u043e",
      "longitude":97.4119931,
      "latitude":56.9973844
    },
    "834":{
      "name":"\u041d\u043e\u0432\u043e\u0445\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":97.4197364,
      "latitude":57.7533657
    },
    "835":{
      "name":"\u0413\u0440\u0435\u043c\u0443\u0447\u0438\u0439",
      "longitude":97.442589,
      "latitude":58.406101
    },
    "836":{
      "name":"\u041e\u043a\u0442\u044f\u0431\u0440\u044c\u0441\u043a\u0438\u0439",
      "longitude":97.522934,
      "latitude":57.443951
    },
    "837":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u0433\u043e\u0440\u044c\u0435\u0432\u0441\u043a\u0438\u0439",
      "longitude":97.5287064,
      "latitude":58.409848
    },
    "838":{
      "name":"\u041f\u043e\u043a\u0430\u043d\u0430\u0435\u0432\u043a\u0430",
      "longitude":97.660767,
      "latitude":56.517387
    },
    "839":{
      "name":"\u0422\u0438\u043b\u0438\u0447\u0435\u0442\u044c",
      "longitude":97.707365,
      "latitude":56.682048
    },
    "840":{
      "name":"\u041a\u0435\u0436\u0435\u043a",
      "longitude":97.7848807,
      "latitude":57.8195231
    },
    "841":{
      "name":"\u0428\u0438\u0432\u0435\u0440\u0441\u043a\u0438\u0439",
      "longitude":97.8043089,
      "latitude":58.4198407
    },
    "842":{
      "name":"\u041e\u0448\u0430\u0440\u043e\u0432\u043e",
      "longitude":98.3129065,
      "latitude":60.3733178
    },
    "843":{
      "name":"\u041d\u0435\u0432\u043e\u043d\u043a\u0430",
      "longitude":98.3244912,
      "latitude":58.4244732
    },
    "844":{
      "name":"\u0425\u0440\u0435\u0431\u0442\u043e\u0432\u044b\u0439",
      "longitude":98.6193261,
      "latitude":58.5834763
    },
    "845":{
      "name":"\u0413\u043e\u0432\u043e\u0440\u043a\u043e\u0432\u043e",
      "longitude":98.7227975,
      "latitude":58.6016648
    },
    "846":{
      "name":"\u0417\u0430\u043b\u0435\u0434\u0435\u0435\u0432\u043e",
      "longitude":98.817421,
      "latitude":58.670349
    },
    "847":{
      "name":"\u0418\u0440\u0431\u0430",
      "longitude":98.9915319,
      "latitude":58.0972481
    },
    "848":{
      "name":"\u0422\u0430\u0433\u0430\u0440\u0430",
      "longitude":99.0013117,
      "latitude":58.7237617
    },
    "849":{
      "name":"\u041c\u0438\u0440\u044e\u0433\u0430",
      "longitude":99.3652817,
      "latitude":60.3080775
    },
    "850":{
      "name":"\u041a\u0430\u0442\u044b\u0440\u044b\u043a",
      "longitude":99.3844909,
      "latitude":71.2741932
    },
    "851":{
      "name":"\u042f\u0440\u043a\u0438\u043d\u043e",
      "longitude":99.3962526,
      "latitude":59.1289942
    },
    "852":{
      "name":"\u0418\u043c\u0431\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":99.6131285,
      "latitude":58.1035374
    },
    "853":{
      "name":"\u0425\u0435\u0442\u0430",
      "longitude":99.6524644,
      "latitude":71.5634237
    },
    "854":{
      "name":"\u041d\u0438\u0434\u044b\u043c",
      "longitude":99.9175066,
      "latitude":64.1145202
    },
    "855":{
      "name":"\u0411\u043e\u043b\u0442\u0443\u0440\u0438\u043d\u043e",
      "longitude":100.076194,
      "latitude":58.3065189
    },
    "856":{
      "name":"\u0427\u0438\u0440\u0438\u043d\u0434\u0430",
      "longitude":100.41082,
      "latitude":67.542549
    },
    "857":{
      "name":"\u0422\u0430\u0451\u0436\u043d\u044b\u0439",
      "longitude":100.4825824,
      "latitude":58.6610554
    },
    "858":{
      "name":"\u041c\u0443\u0442\u043e\u0440\u0430\u0439",
      "longitude":100.4826283,
      "latitude":61.326463
    },
    "859":{
      "name":"\u041d\u0435\u0434\u043e\u043a\u0443\u0440\u0430",
      "longitude":100.6210033,
      "latitude":58.5752438
    },
    "860":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u041a\u0435\u0436\u043c\u0430",
      "longitude":101.2160931,
      "latitude":59.007947
    },
    "861":{
      "name":"\u041d\u043e\u0432\u0430\u044f",
      "longitude":101.2288092,
      "latitude":71.7480948
    },
    "862":{
      "name":"\u041a\u0440\u0435\u0441\u0442\u044b",
      "longitude":102.123001,
      "latitude":71.914948
    },
    "863":{
      "name":"\u0415\u0441\u0441\u0435\u0439",
      "longitude":102.186325,
      "latitude":68.464638
    },
    "864":{
      "name":"\u0421\u0442\u0440\u0435\u043b\u043a\u0430-\u0427\u0443\u043d\u044f",
      "longitude":102.7989591,
      "latitude":61.7389896
    },
    "865":{
      "name":"\u0427\u0435\u043c\u0434\u0430\u043b\u044c\u0441\u043a",
      "longitude":103.324638,
      "latitude":59.629391
    },
    "866":{
      "name":"\u041a\u0438\u0441\u043b\u043e\u043a\u0430\u043d",
      "longitude":103.95089,
      "latitude":63.58852
    },
    "867":{
      "name":"\u042d\u043a\u043e\u043d\u0434\u0430",
      "longitude":105.328712,
      "latitude":65.75399
    },
    "868":{
      "name":"\u042e\u043a\u0442\u0430",
      "longitude":105.6568364,
      "latitude":63.3831793
    },
    "869":{
      "name":"\u041d\u043e\u0432\u043e\u0440\u044b\u0431\u043d\u0430\u044f",
      "longitude":105.79924,
      "latitude":72.833984
    },
    "870":{
      "name":"\u0421\u044b\u043d\u0434\u0430\u0441\u0441\u043a\u043e",
      "longitude":108.207542,
      "latitude":73.260483
    },
    "871":{
      "name":"\u041f\u043e\u043f\u0438\u0433\u0430\u0439",
      "longitude":110.7882575,
      "latitude":71.8895161
    },
    "872":{
      "name":"\u041a\u0430\u0440\u0430-\u0425\u043e\u043b\u044c",
      "longitude":89.7635383,
      "latitude":51.2812549
    },
    "873":{
      "name":"\u041a\u044b\u0437\u044b\u043b-\u0425\u0430\u044f",
      "longitude":89.8706419,
      "latitude":50.0483456
    },
    "874":{
      "name":"\u0411\u0430\u0439-\u0422\u0430\u043b",
      "longitude":90.0583621,
      "latitude":50.9109348
    },
    "875":{
      "name":"\u041a\u044b\u0437\u044b\u043b-\u0414\u0430\u0433",
      "longitude":90.1068754,
      "latitude":51.0397186
    },
    "876":{
      "name":"\u0425\u0435\u043c\u0447\u0438\u043a",
      "longitude":90.187257,
      "latitude":51.0179155
    },
    "877":{
      "name":"\u0422\u044d\u044d\u043b\u0438",
      "longitude":90.2043058,
      "latitude":51.0110954
    },
    "878":{
      "name":"\u0414\u0440\u0443\u0436\u0431\u0430",
      "longitude":90.2180158,
      "latitude":51.0078721
    },
    "879":{
      "name":"\u0425\u043e\u043d\u0434\u0435\u043b\u0435\u043d",
      "longitude":90.3056838,
      "latitude":51.2528323
    },
    "880":{
      "name":"\u0428\u0443\u0439",
      "longitude":90.3405632,
      "latitude":50.886521
    },
    "881":{
      "name":"\u0410\u043a\u0441\u044b-\u0411\u0430\u0440\u043b\u044b\u043a",
      "longitude":90.4021823,
      "latitude":51.1175678
    },
    "882":{
      "name":"\u042d\u0440\u0433\u0438-\u0411\u0430\u0440\u043b\u044b\u043a",
      "longitude":90.4042675,
      "latitude":50.9346854
    },
    "883":{
      "name":"\u0411\u0430\u0440\u043b\u044b\u043a",
      "longitude":90.541542,
      "latitude":51.1348844
    },
    "884":{
      "name":"\u0411\u0438\u0436\u0438\u043a\u0442\u0438\u0433-\u0425\u0430\u044f",
      "longitude":90.6385447,
      "latitude":51.0998154
    },
    "885":{
      "name":"\u0422\u043e\u043e\u043b\u0430\u0439\u043b\u044b\u0433",
      "longitude":90.6561789,
      "latitude":50.531638
    },
    "886":{
      "name":"\u0428\u0435\u043a\u043f\u044d\u044d\u0440",
      "longitude":90.6817543,
      "latitude":51.1683632
    },
    "887":{
      "name":"\u0414\u043e\u043d-\u0422\u0435\u0440\u0435\u0437\u0438\u043d",
      "longitude":90.7030085,
      "latitude":51.2144574
    },
    "888":{
      "name":"\u0410\u044f\u043d\u0433\u0430\u0442\u044b",
      "longitude":90.8429369,
      "latitude":50.9934854
    },
    "889":{
      "name":"\u0410\u043b\u0434\u0430\u043d-\u041c\u0430\u0430\u0434\u044b\u0440",
      "longitude":90.9751627,
      "latitude":51.2965803
    },
    "890":{
      "name":"\u0427\u044b\u0440\u0433\u0430\u043a\u044b",
      "longitude":91.0065595,
      "latitude":51.0626072
    },
    "891":{
      "name":"\u0425\u043e\u0440\u0443\u043c-\u0414\u0430\u0433",
      "longitude":91.0480747,
      "latitude":51.2823568
    },
    "892":{
      "name":"\u0427\u044b\u0440\u0430\u0430-\u0411\u0430\u0436\u044b",
      "longitude":91.0529139,
      "latitude":51.1684485
    },
    "893":{
      "name":"\u042d\u043b\u0434\u0438\u0433-\u0425\u0435\u043c",
      "longitude":91.1070559,
      "latitude":50.8703093
    },
    "894":{
      "name":"\u0410\u043a-\u0414\u0430\u0448",
      "longitude":91.1281674,
      "latitude":51.3410954
    },
    "895":{
      "name":"\u0411\u043e\u0440\u0430-\u0422\u0430\u0439\u0433\u0430",
      "longitude":91.146738,
      "latitude":51.4044258
    },
    "896":{
      "name":"\u0421\u0443\u0433-\u0410\u043a\u0441\u044b",
      "longitude":91.278786,
      "latitude":51.402248
    },
    "897":{
      "name":"\u0428\u0435\u043c\u0438",
      "longitude":91.2914366,
      "latitude":51.1566992
    },
    "898":{
      "name":"\u041a\u0430\u0440\u0430-\u0427\u044b\u0440\u0430\u0430",
      "longitude":91.3184404,
      "latitude":51.4169104
    },
    "899":{
      "name":"\u0421\u0430\u0433\u043b\u044b",
      "longitude":91.3298518,
      "latitude":50.4934482
    },
    "900":{
      "name":"\u041a\u044b\u0437\u044b\u043b-\u0422\u0430\u0439\u0433\u0430",
      "longitude":91.3890933,
      "latitude":51.4806993
    },
    "901":{
      "name":"\u0411\u0430\u044f\u043d-\u0422\u0430\u043b\u0430",
      "longitude":91.430771,
      "latitude":51.4573557
    },
    "902":{
      "name":"\u0422\u0435\u0432\u0435-\u0425\u0430\u044f",
      "longitude":91.4509672,
      "latitude":51.3658128
    },
    "903":{
      "name":"\u0418\u0448\u043a\u0438\u043d",
      "longitude":91.4749089,
      "latitude":51.5669621
    },
    "904":{
      "name":"\u0425\u0430\u0439\u044b\u0440\u0430\u043a\u0430\u043d",
      "longitude":91.5614388,
      "latitude":51.2961671
    },
    "905":{
      "name":"\u0418\u0439\u043c\u0435",
      "longitude":91.5933809,
      "latitude":51.5782693
    },
    "906":{
      "name":"\u0425\u043e\u043d\u0434\u0435\u0440\u0433\u0435\u0439",
      "longitude":91.6193587,
      "latitude":51.1280656
    },
    "907":{
      "name":"\u0411\u043e\u0440\u0430-\u0428\u0430\u0439",
      "longitude":91.6659795,
      "latitude":50.7192346
    },
    "908":{
      "name":"\u0411\u0430\u0436\u044b\u043d-\u0410\u043b\u0430\u0430\u043a",
      "longitude":91.7340114,
      "latitude":51.2293018
    },
    "909":{
      "name":"\u0428\u0430\u043d\u0447\u044b",
      "longitude":91.9618584,
      "latitude":51.6060807
    },
    "910":{
      "name":"\u0421\u043e\u043b\u0447\u0443\u0440",
      "longitude":92.031431,
      "latitude":50.7489479
    },
    "911":{
      "name":"\u0425\u0430\u043d\u0434\u0430\u0433\u0430\u0439\u0442\u044b",
      "longitude":92.0726451,
      "latitude":50.7330745
    },
    "912":{
      "name":"\u0410\u043a-\u0414\u0443\u0440\u0443\u0433",
      "longitude":92.2074823,
      "latitude":51.3995087
    },
    "913":{
      "name":"\u0411\u0443\u043b\u0443\u043d-\u0422\u0435\u0440\u0435\u043a",
      "longitude":92.2654182,
      "latitude":51.4769681
    },
    "914":{
      "name":"\u0427\u0430\u0430-\u0425\u043e\u043b\u044c",
      "longitude":92.3348586,
      "latitude":51.5141315
    },
    "915":{
      "name":"\u0418\u0448\u0442\u0438\u0438-\u0425\u0435\u043c",
      "longitude":92.4753913,
      "latitude":51.3205615
    },
    "916":{
      "name":"\u0410\u0440\u044b\u0433-\u0423\u0437\u0443\u0443",
      "longitude":92.5956837,
      "latitude":51.4225518
    },
    "917":{
      "name":"\u042d\u0439\u043b\u0438\u0433-\u0425\u0435\u043c",
      "longitude":92.6727561,
      "latitude":51.6130028
    },
    "918":{
      "name":"\u0414\u0443\u0441-\u0414\u0430\u0433",
      "longitude":92.682277,
      "latitude":50.8132729
    },
    "919":{
      "name":"\u0410\u0440\u044b\u0441\u043a\u0430\u043d",
      "longitude":92.7097671,
      "latitude":51.406536
    },
    "920":{
      "name":"\u0427\u0430\u0430-\u0421\u0443\u0443\u0440",
      "longitude":92.7598487,
      "latitude":50.8233451
    },
    "921":{
      "name":"\u0422\u043e\u0440\u0433\u0430\u043b\u044b\u0433",
      "longitude":92.8239747,
      "latitude":51.3301908
    },
    "922":{
      "name":"\u0427\u043e\u0434\u0443\u0440\u0430\u0430",
      "longitude":92.884032,
      "latitude":51.3752608
    },
    "923":{
      "name":"\u0410\u0440\u044b\u0433-\u0411\u0430\u0436\u044b",
      "longitude":93.0547938,
      "latitude":51.4458735
    },
    "924":{
      "name":"\u0425\u0430\u0439\u044b\u0440\u0430\u043a\u0430\u043d",
      "longitude":93.140133,
      "latitude":51.5644653
    },
    "925":{
      "name":"\u0410\u043a-\u0427\u044b\u0440\u0430\u0430",
      "longitude":93.2379767,
      "latitude":50.6973582
    },
    "926":{
      "name":"\u0425\u043e\u043b\u0447\u0443\u043a",
      "longitude":93.2771986,
      "latitude":51.0748276
    },
    "927":{
      "name":"\u0418\u0439\u0438-\u0422\u0430\u043b",
      "longitude":93.337079,
      "latitude":51.5656919
    },
    "928":{
      "name":"\u0410\u043a-\u0422\u0430\u043b",
      "longitude":93.4071913,
      "latitude":51.1743221
    },
    "929":{
      "name":"\u0422\u0430\u0440\u043b\u0430\u0433",
      "longitude":93.4099547,
      "latitude":52.0673346
    },
    "930":{
      "name":"\u0422\u0435\u0440\u043b\u0438\u0433-\u0425\u0430\u044f",
      "longitude":93.5235071,
      "latitude":51.7104566
    },
    "931":{
      "name":"\u0411\u0430\u044f\u043d-\u041a\u043e\u043b",
      "longitude":93.5542113,
      "latitude":51.57916
    },
    "932":{
      "name":"\u0410\u0440\u0436\u0430\u0430\u043d",
      "longitude":93.6053528,
      "latitude":52.0592442
    },
    "933":{
      "name":"\u0425\u0430\u0434\u044b\u043d",
      "longitude":93.6290708,
      "latitude":51.9561678
    },
    "934":{
      "name":"\u0421\u0430\u0439\u043b\u044b\u0433",
      "longitude":93.6846541,
      "latitude":51.1235704
    },
    "935":{
      "name":"\u041e-\u0428\u044b\u043d\u0430\u0430",
      "longitude":93.7471198,
      "latitude":50.6583627
    },
    "936":{
      "name":"\u0427\u0430\u043b-\u041a\u0435\u0436\u0438\u0433",
      "longitude":93.9343032,
      "latitude":51.2966733
    },
    "937":{
      "name":"\u041d\u0430\u0439\u044b\u0440\u0430\u043b",
      "longitude":93.9396681,
      "latitude":52.1510599
    },
    "938":{
      "name":"\u042d\u043b\u0435\u0433\u0435\u0441\u0442",
      "longitude":93.9628826,
      "latitude":51.3638133
    },
    "939":{
      "name":"\u0423\u044e\u043a",
      "longitude":94.0316506,
      "latitude":52.0776634
    },
    "940":{
      "name":"\u041a\u043e\u0447\u0435\u0442\u043e\u0432\u043e",
      "longitude":94.0612703,
      "latitude":51.345228
    },
    "941":{
      "name":"\u0423\u0441\u0442\u044c-\u042d\u043b\u0435\u0433\u0435\u0441\u0442",
      "longitude":94.0993685,
      "latitude":51.5641892
    },
    "942":{
      "name":"\u0421\u0443\u0448",
      "longitude":94.1625176,
      "latitude":52.0630166
    },
    "943":{
      "name":"\u042d\u044d\u0440\u0431\u0435\u043a",
      "longitude":94.2090227,
      "latitude":51.6508488
    },
    "944":{
      "name":"\u0423\u0441\u043f\u0435\u043d\u043a\u0430",
      "longitude":94.2477472,
      "latitude":51.2344759
    },
    "945":{
      "name":"\u0421\u0435\u0441\u0435\u0440\u043b\u0438\u0433",
      "longitude":94.258762,
      "latitude":51.8768916
    },
    "946":{
      "name":"\u0421\u0443\u043a\u043f\u0430\u043a",
      "longitude":94.2671278,
      "latitude":51.6473874
    },
    "947":{
      "name":"\u041c\u0435\u0436\u0435\u0433\u0435\u0439",
      "longitude":94.3219435,
      "latitude":51.2555542
    },
    "948":{
      "name":"\u0425\u043e\u043b\u044c-\u041e\u043e\u0436\u0443",
      "longitude":94.4130714,
      "latitude":50.7394457
    },
    "949":{
      "name":"\u041a\u0430\u0440\u0430-\u0425\u0430\u0430\u043a",
      "longitude":94.4604279,
      "latitude":51.8863432
    },
    "950":{
      "name":"\u0411\u0430\u0439-\u0425\u0430\u0430\u043a",
      "longitude":94.4651991,
      "latitude":51.1601031
    },
    "951":{
      "name":"\u0414\u0443\u0440\u0433\u0435\u043d",
      "longitude":94.5006472,
      "latitude":51.1490635
    },
    "952":{
      "name":"\u0421\u043e\u0441\u043d\u043e\u0432\u043a\u0430",
      "longitude":94.5236342,
      "latitude":51.1453988
    },
    "953":{
      "name":"\u0425\u0443\u0442",
      "longitude":94.5529206,
      "latitude":52.6119734
    },
    "954":{
      "name":"\u0427\u0435\u0440\u0431\u0438",
      "longitude":94.5928084,
      "latitude":51.888064
    },
    "955":{
      "name":"\u0410\u043a-\u042d\u0440\u0438\u043a",
      "longitude":94.6152832,
      "latitude":50.5142008
    },
    "956":{
      "name":"\u0411\u0435\u0440\u0442-\u0414\u0430\u0433",
      "longitude":94.7941167,
      "latitude":50.6253442
    },
    "957":{
      "name":"\u0426\u0435\u043b\u0438\u043d\u043d\u043e\u0435",
      "longitude":94.8057351,
      "latitude":51.3288301
    },
    "958":{
      "name":"\u0421\u0443\u0433-\u0411\u0430\u0436\u044b",
      "longitude":94.8554704,
      "latitude":51.6560787
    },
    "959":{
      "name":"\u0411\u0435\u043b\u044c\u0434\u0438\u0440-\u0410\u0440\u044b\u0433",
      "longitude":94.9732734,
      "latitude":50.5733792
    },
    "960":{
      "name":"\u0421\u0430\u043c\u0430\u0433\u0430\u043b\u0442\u0430\u0439",
      "longitude":95.001846,
      "latitude":50.599998
    },
    "961":{
      "name":"\u0411\u0443\u0440\u0435\u043d-\u0425\u0435\u043c",
      "longitude":95.0071514,
      "latitude":51.6519455
    },
    "962":{
      "name":"\u0428\u0430\u043c\u0431\u0430\u043b\u044b\u0433",
      "longitude":95.0914385,
      "latitude":51.2406402
    },
    "963":{
      "name":"\u0411\u0430\u0439-\u0414\u0430\u0433",
      "longitude":95.1019495,
      "latitude":50.3013082
    },
    "964":{
      "name":"\u042d\u0440\u0437\u0438\u043d",
      "longitude":95.1582961,
      "latitude":50.2599782
    },
    "965":{
      "name":"\u0411\u0430\u043b\u0433\u0430\u0437\u044b\u043d",
      "longitude":95.1670684,
      "latitude":50.9964468
    },
    "966":{
      "name":"\u041a\u0443\u043d\u0434\u0443\u0441-\u0422\u0443\u0433",
      "longitude":95.1798664,
      "latitude":51.5734175
    },
    "967":{
      "name":"\u041a\u044b\u0437\u044b\u043b-\u0410\u0440\u044b\u0433",
      "longitude":95.1963496,
      "latitude":50.9292407
    },
    "968":{
      "name":"\u0411\u0443\u043b\u0443\u043d-\u0411\u0430\u0436\u044b",
      "longitude":95.2137767,
      "latitude":50.2671627
    },
    "969":{
      "name":"\u0421\u043e\u0439",
      "longitude":95.2275229,
      "latitude":51.003366
    },
    "970":{
      "name":"\u0412\u043b\u0430\u0434\u0438\u043c\u0438\u0440\u043e\u0432\u043a\u0430",
      "longitude":95.3055046,
      "latitude":50.9977926
    },
    "971":{
      "name":"\u0428\u0443\u0443\u0440\u043c\u0430\u043a",
      "longitude":95.3271335,
      "latitude":50.6532098
    },
    "972":{
      "name":"\u0411\u043e\u044f\u0440\u043e\u0432\u043a\u0430",
      "longitude":95.3540499,
      "latitude":51.5380167
    },
    "973":{
      "name":"\u041c\u043e\u0440\u0435\u043d",
      "longitude":95.3711059,
      "latitude":50.3155303
    },
    "974":{
      "name":"\u0418\u043b\u044c\u0438\u043d\u043a\u0430",
      "longitude":95.4779459,
      "latitude":51.1141651
    },
    "975":{
      "name":"\u041a\u043e\u043a-\u0425\u0430\u0430\u043a",
      "longitude":95.4860581,
      "latitude":51.511767
    },
    "976":{
      "name":"\u0421\u044b\u0441\u0442\u044b\u0433-\u0425\u0435\u043c",
      "longitude":95.50383,
      "latitude":52.666992
    },
    "977":{
      "name":"\u0411\u0443\u0440\u0435\u043d-\u0411\u0430\u0439-\u0425\u0430\u0430\u043a",
      "longitude":95.55685,
      "latitude":51.2449768
    },
    "978":{
      "name":"\u041d\u0430\u0440\u044b\u043d",
      "longitude":95.5698333,
      "latitude":50.1998486
    },
    "979":{
      "name":"\u0414\u0435\u0440\u0437\u0438\u0433-\u0410\u043a\u0441\u044b",
      "longitude":95.6081696,
      "latitude":51.456125
    },
    "980":{
      "name":"\u0423\u0441\u0442\u044c-\u0411\u0443\u0440\u0435\u043d",
      "longitude":95.6560897,
      "latitude":51.4138176
    },
    "981":{
      "name":"\u042b\u0440\u0431\u0430\u043d",
      "longitude":95.7278747,
      "latitude":52.7137562
    },
    "982":{
      "name":"\u0421\u0438\u0437\u0438\u043c",
      "longitude":95.9441084,
      "latitude":51.3192221
    },
    "983":{
      "name":"\u0418\u0439",
      "longitude":96.0338107,
      "latitude":52.5695197
    },
    "984":{
      "name":"\u0421\u0430\u043b\u0434\u0430\u043c",
      "longitude":96.0951619,
      "latitude":52.480453
    },
    "985":{
      "name":"\u0422\u043e\u043e\u0440\u0430-\u0425\u0435\u043c",
      "longitude":96.117896,
      "latitude":52.4679232
    },
    "986":{
      "name":"\u0410\u0434\u044b\u0440-\u041a\u0435\u0436\u0438\u0433",
      "longitude":96.241468,
      "latitude":52.4497728
    },
    "987":{
      "name":"\u041a\u0430\u0447\u044b\u043a",
      "longitude":96.4202883,
      "latitude":49.9353978
    },
    "988":{
      "name":"\u0411\u0435\u043b\u0434\u0438\u0440-\u0427\u0430\u0437\u044b",
      "longitude":97.1076072,
      "latitude":50.592116
    },
    "989":{
      "name":"\u0427\u0430\u0437\u044b\u043b\u0430\u0440\u044b",
      "longitude":97.4257898,
      "latitude":52.7542023
    },
    "990":{
      "name":"\u0422\u0430\u043b",
      "longitude":97.4838841,
      "latitude":50.3578383
    },
    "991":{
      "name":"\u041a\u0443\u043d\u0433\u0443\u0440\u0442\u0443\u0433",
      "longitude":97.5254386,
      "latitude":50.5986817
    },
    "992":{
      "name":"\u041e\u0442\u0442\u0443\u043a-\u0414\u0430\u0448",
      "longitude":97.8117949,
      "latitude":50.5987114
    },
    "993":{
      "name":"\u042e\u0440\u0433\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":84.641525,
      "latitude":55.693752
    },
    "994":{
      "name":"\u0421\u043e\u043a\u043e\u043b\u044c\u043d\u0438\u043a\u0438",
      "longitude":84.6424486,
      "latitude":55.8635303
    },
    "995":{
      "name":"\u041b\u0435\u0431\u044f\u0436\u044c\u0435-\u0410\u0441\u0430\u043d\u043e\u0432\u043e",
      "longitude":84.6468135,
      "latitude":55.7442178
    },
    "996":{
      "name":"\u041c\u0430\u043a\u0443\u0440\u0438\u043d\u043e",
      "longitude":84.6622089,
      "latitude":56.035164
    },
    "997":{
      "name":"\u0417\u0430\u043e\u0437\u0451\u0440\u043d\u044b\u0439",
      "longitude":84.717761,
      "latitude":55.8912032
    },
    "998":{
      "name":"\u041f\u0440\u043e\u0441\u043a\u043e\u043a\u043e\u0432\u043e",
      "longitude":84.724236,
      "latitude":55.838284
    },
    "999":{
      "name":"\u0411\u0435\u0437\u043c\u0435\u043d\u043e\u0432\u043e",
      "longitude":84.7535348,
      "latitude":55.836388
    },
    "1000":{
      "name":"\u042e\u0440\u0433\u0430 2-\u044f",
      "longitude":84.7755623,
      "latitude":55.6729622
    },
    "1001":{
      "name":"\u041b\u0438\u043d\u0435\u0439\u043d\u044b\u0439",
      "longitude":84.7761858,
      "latitude":55.4727253
    },
    "1002":{
      "name":"\u0421\u0430\u0440\u0441\u0430\u0437",
      "longitude":84.825694,
      "latitude":55.6913113
    },
    "1003":{
      "name":"\u041c\u0430\u043b\u044c\u0446\u0435\u0432\u043e",
      "longitude":84.8266683,
      "latitude":55.9570185
    },
    "1004":{
      "name":"\u0410\u0440\u043b\u044e\u043a",
      "longitude":84.8542761,
      "latitude":55.4347314
    },
    "1005":{
      "name":"\u0401\u043b\u0433\u0438\u043d\u043e",
      "longitude":84.8583344,
      "latitude":55.915786
    },
    "1006":{
      "name":"\u0417\u0435\u043b\u0435\u0434\u0435\u0435\u0432\u043e",
      "longitude":84.8767856,
      "latitude":56.0394794
    },
    "1007":{
      "name":"\u0422\u043e\u043c\u0438\u043b\u043e\u0432\u043e",
      "longitude":84.8862442,
      "latitude":55.990389
    },
    "1008":{
      "name":"\u0422\u0430\u043b\u0430\u044f",
      "longitude":84.8934553,
      "latitude":55.7870061
    },
    "1009":{
      "name":"\u0412\u0430\u0440\u044e\u0445\u0438\u043d\u043e",
      "longitude":84.8956684,
      "latitude":56.1048235
    },
    "1010":{
      "name":"\u041e\u0437\u0435\u0440\u043a\u0438",
      "longitude":84.8998964,
      "latitude":54.9896844
    },
    "1011":{
      "name":"\u0417\u0438\u043c\u043d\u0438\u043a",
      "longitude":84.925949,
      "latitude":55.661999
    },
    "1012":{
      "name":"\u041f\u044f\u0442\u043a\u043e\u0432\u043e",
      "longitude":84.9471598,
      "latitude":55.8545622
    },
    "1013":{
      "name":"\u041f\u043e\u043b\u043e\u043c\u043e\u0448\u043d\u043e\u0435",
      "longitude":84.9599296,
      "latitude":55.7391859
    },
    "1014":{
      "name":"\u041f\u043e\u043f\u0435\u0440\u0435\u0447\u043d\u043e\u0435",
      "longitude":84.982834,
      "latitude":55.504913
    },
    "1015":{
      "name":"\u0422\u0443\u0442\u0430\u043b\u044c\u0441\u043a\u0430\u044f",
      "longitude":84.9874266,
      "latitude":55.7516627
    },
    "1016":{
      "name":"\u0410\u0431\u044b\u0448\u0435\u0432\u043e",
      "longitude":84.994672,
      "latitude":55.0629203
    },
    "1017":{
      "name":"\u0423\u0441\u0442\u044c-\u0421\u043e\u0441\u043d\u043e\u0432\u043e",
      "longitude":84.9946836,
      "latitude":55.2267306
    },
    "1018":{
      "name":"\u0421\u0430\u043b\u043e\u043c\u0430\u0442\u043e\u0432\u043e",
      "longitude":85.020668,
      "latitude":55.928406
    },
    "1019":{
      "name":"\u041f\u0430\u0434\u0443\u043d\u0441\u043a\u0430\u044f",
      "longitude":85.047272,
      "latitude":55.034611
    },
    "1020":{
      "name":"\u0416\u0443\u0440\u0430\u0432\u043b\u0451\u0432\u043e",
      "longitude":85.0642041,
      "latitude":54.7837082
    },
    "1021":{
      "name":"\u041b\u0435\u043d\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":85.065834,
      "latitude":56.025146
    },
    "1022":{
      "name":"\u0413\u043e\u043b\u0443\u0431\u0435\u0432\u043e",
      "longitude":85.0740683,
      "latitude":54.8508059
    },
    "1023":{
      "name":"\u0412\u0430\u0441\u044c\u043a\u043e\u0432\u043e",
      "longitude":85.089447,
      "latitude":55.049778
    },
    "1024":{
      "name":"\u0420\u0435\u0447\u043d\u043e\u0439",
      "longitude":85.1052802,
      "latitude":55.6915434
    },
    "1025":{
      "name":"\u0428\u0430\u0445\u0442\u0451\u0440",
      "longitude":85.1250358,
      "latitude":55.8113459
    },
    "1026":{
      "name":"\u041f\u0430\u0448\u043a\u043e\u0432\u043e",
      "longitude":85.1425802,
      "latitude":56.0487661
    },
    "1027":{
      "name":"\u0422\u0430\u0440\u0430\u0441\u043e\u0432\u043e",
      "longitude":85.1490068,
      "latitude":54.8843768
    },
    "1028":{
      "name":"\u0412\u0430\u0433\u0430\u043d\u043e\u0432\u043e",
      "longitude":85.173269,
      "latitude":54.7013661
    },
    "1029":{
      "name":"\u0423\u0441\u0442\u044c-\u041a\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":85.1881335,
      "latitude":55.0037911
    },
    "1030":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u0441\u0451\u043b\u043a\u0430",
      "longitude":85.204369,
      "latitude":55.865311
    },
    "1031":{
      "name":"\u0412\u0435\u0440\u0445-\u041f\u0430\u0434\u0443\u043d\u0441\u043a\u0438\u0439",
      "longitude":85.2064545,
      "latitude":55.1554678
    },
    "1032":{
      "name":"\u0412\u0435\u0440\u0445-\u0422\u0430\u0439\u043c\u0435\u043d\u043a\u0430",
      "longitude":85.211964,
      "latitude":55.6554946
    },
    "1033":{
      "name":"\u041e\u043f\u0430\u0440\u0438\u043d\u043e",
      "longitude":85.2227914,
      "latitude":55.4322159
    },
    "1034":{
      "name":"\u0428\u0438\u0448\u0438\u043d\u043e",
      "longitude":85.2255802,
      "latitude":55.368246
    },
    "1035":{
      "name":"\u0411\u043e\u0442\u044c\u0435\u0432\u043e",
      "longitude":85.228798,
      "latitude":55.937004
    },
    "1036":{
      "name":"\u0417\u044b\u0440\u044f\u043d\u043a\u0430",
      "longitude":85.2316876,
      "latitude":55.71586
    },
    "1037":{
      "name":"\u0422\u0438\u0442\u043e\u0432\u043e",
      "longitude":85.251778,
      "latitude":55.022217
    },
    "1038":{
      "name":"\u0411\u0435\u043b\u044f\u043d\u0438\u043d\u043e",
      "longitude":85.253611,
      "latitude":55.5380529
    },
    "1039":{
      "name":"\u041c\u0430\u0433\u0438\u0441\u0442\u0440\u0430\u043b\u044c\u043d\u044b\u0439",
      "longitude":85.289016,
      "latitude":55.1813834
    },
    "1040":{
      "name":"\u0428\u0443\u0440\u0438\u043d\u043a\u0430",
      "longitude":85.2907962,
      "latitude":54.8322776
    },
    "1041":{
      "name":"\u041b\u0438\u0442\u0432\u0438\u043d\u043e\u0432\u043e",
      "longitude":85.2976845,
      "latitude":55.835997
    },
    "1042":{
      "name":"\u041f\u044c\u044f\u043d\u043e\u0432\u043e",
      "longitude":85.307716,
      "latitude":54.929699
    },
    "1043":{
      "name":"\u0420\u0430\u0437\u0434\u043e\u043b\u044c\u0435",
      "longitude":85.3172318,
      "latitude":55.4857093
    },
    "1044":{
      "name":"\u041d\u043e\u0432\u043e\u0440\u043e\u043c\u0430\u043d\u043e\u0432\u043e",
      "longitude":85.341263,
      "latitude":55.66267
    },
    "1045":{
      "name":"\u041b\u0438\u0442\u0432\u0438\u043d\u043e\u0432\u043e",
      "longitude":85.3424157,
      "latitude":55.8419352
    },
    "1046":{
      "name":"\u0426\u0435\u043d\u0442\u0440\u0430\u043b\u044c\u043d\u044b\u0439",
      "longitude":85.3431063,
      "latitude":55.2465055
    },
    "1047":{
      "name":"\u0414\u0443\u0431\u0440\u043e\u0432\u043a\u0430",
      "longitude":85.3465927,
      "latitude":55.9224372
    },
    "1048":{
      "name":"\u041f\u0440\u043e\u0433\u0440\u0435\u0441\u0441",
      "longitude":85.3506213,
      "latitude":54.7574182
    },
    "1049":{
      "name":"\u0410\u043a\u0430\u0446\u0438\u044f",
      "longitude":85.3637949,
      "latitude":55.7367594
    },
    "1050":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u041a\u043e\u0440\u0447\u0443\u0433\u0430\u043d",
      "longitude":85.3922526,
      "latitude":55.2090768
    },
    "1051":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u0435",
      "longitude":85.395073,
      "latitude":54.608673
    },
    "1052":{
      "name":"\u041a\u043e\u043a\u0443\u0439",
      "longitude":85.401833,
      "latitude":54.578209
    },
    "1053":{
      "name":"\u042f\u0448\u043a\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":85.4024903,
      "latitude":55.8751611
    },
    "1054":{
      "name":"\u0410\u0440\u0438\u043d\u0438\u0447\u0435\u0432\u043e",
      "longitude":85.406494,
      "latitude":54.550442
    },
    "1055":{
      "name":"\u0423\u0440\u0441\u043a",
      "longitude":85.407219,
      "latitude":54.456802
    },
    "1056":{
      "name":"\u0412\u043b\u0430\u0441\u043a\u043e\u0432\u043e",
      "longitude":85.4133367,
      "latitude":55.7568247
    },
    "1057":{
      "name":"\u0420\u0430\u0441\u0441\u0432\u0435\u0442",
      "longitude":85.4265235,
      "latitude":55.3546898
    },
    "1058":{
      "name":"\u041e\u043a\u0443\u043d\u0435\u0432\u043e",
      "longitude":85.4299083,
      "latitude":54.9513359
    },
    "1059":{
      "name":"\u0423\u0441\u0442\u044c-\u0422\u0430\u0440\u0441\u044c\u043c\u0430",
      "longitude":85.4341463,
      "latitude":55.0021393
    },
    "1060":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u0438\u043d\u0441\u043a\u043e\u0435",
      "longitude":85.452217,
      "latitude":54.795383
    },
    "1061":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0435\u044f\u043c\u043d\u043e\u0435",
      "longitude":85.4914282,
      "latitude":55.5805408
    },
    "1062":{
      "name":"\u041f\u0430\u0447\u0430",
      "longitude":85.4929336,
      "latitude":55.7061539
    },
    "1063":{
      "name":"\u0422\u0430\u0451\u0436\u043d\u044b\u0439",
      "longitude":85.5043874,
      "latitude":56.1044404
    },
    "1064":{
      "name":"\u0417\u0430\u0440\u0443\u0431\u0438\u043d\u043e",
      "longitude":85.52668,
      "latitude":55.45784
    },
    "1065":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043e-\u0420\u043e\u0434\u0438\u043e\u043d\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":85.5362809,
      "latitude":54.8927673
    },
    "1066":{
      "name":"\u041a\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":85.5435454,
      "latitude":54.840696
    },
    "1067":{
      "name":"\u041a\u0443\u0437\u0435\u043b\u044c",
      "longitude":85.5468517,
      "latitude":56.008781
    },
    "1068":{
      "name":"\u041c\u043e\u043a\u0440\u043e\u0443\u0441\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":85.5656614,
      "latitude":55.1783362
    },
    "1069":{
      "name":"\u041c\u0430\u043b\u044b\u0439 \u041a\u043e\u0440\u0447\u0443\u0433\u0430\u043d",
      "longitude":85.5790155,
      "latitude":55.237611
    },
    "1070":{
      "name":"\u041b\u0435\u0431\u0435\u0434\u0438",
      "longitude":85.5858385,
      "latitude":55.0410351
    },
    "1071":{
      "name":"\u041e\u043a\u0442\u044f\u0431\u0440\u044c\u0441\u043a\u0438\u0439",
      "longitude":85.5940321,
      "latitude":55.3209983
    },
    "1072":{
      "name":"\u0428\u0430\u0431\u0430\u043d\u043e\u0432\u043e",
      "longitude":85.615562,
      "latitude":54.674416
    },
    "1073":{
      "name":"\u0423\u0444\u0438\u043c\u0446\u0435\u0432\u043e",
      "longitude":85.6274749,
      "latitude":54.9865111
    },
    "1074":{
      "name":"\u0413\u043e\u0440\u0441\u043a\u0438\u043d\u043e",
      "longitude":85.634682,
      "latitude":54.466091
    },
    "1075":{
      "name":"\u041a\u043e\u043b\u043c\u043e\u0433\u043e\u0440\u043e\u0432\u043e",
      "longitude":85.662025,
      "latitude":55.637383
    },
    "1076":{
      "name":"\u041a\u0435\u0434\u0440\u043e\u0432\u044b\u0439",
      "longitude":85.6734571,
      "latitude":56.1141431
    },
    "1077":{
      "name":"\u0413\u043b\u0443\u0431\u043e\u043a\u043e\u0435",
      "longitude":85.71026,
      "latitude":55.5253966
    },
    "1078":{
      "name":"\u0415\u0440\u0435\u043c\u0438\u043d\u043e",
      "longitude":85.7106294,
      "latitude":54.901095
    },
    "1079":{
      "name":"\u0421\u043e\u0441\u043d\u043e\u0432\u043a\u0430",
      "longitude":85.728386,
      "latitude":54.290611
    },
    "1080":{
      "name":"\u041d\u043e\u0432\u043e\u043f\u0435\u0441\u0442\u0435\u0440\u0435\u0432\u043e",
      "longitude":85.7433213,
      "latitude":54.4474064
    },
    "1081":{
      "name":"\u0422\u043e\u043f\u043a\u0438",
      "longitude":85.7662135,
      "latitude":55.334955
    },
    "1082":{
      "name":"\u0422\u0440\u0435\u0449\u0435\u0432\u0441\u043a\u0438\u0439",
      "longitude":85.767207,
      "latitude":55.125449
    },
    "1083":{
      "name":"\u041a\u0430\u043b\u0438\u043d\u043a\u0438\u043d\u043e",
      "longitude":85.7744631,
      "latitude":54.9256452
    },
    "1084":{
      "name":"\u041c\u0443\u0441\u043e\u0445\u0440\u0430\u043d\u043e\u0432\u043e",
      "longitude":85.779839,
      "latitude":54.710529
    },
    "1085":{
      "name":"\u041c\u043e\u0440\u043e\u0437\u043e\u0432\u043e",
      "longitude":85.7820791,
      "latitude":54.9052669
    },
    "1086":{
      "name":"\u041a\u0430\u043c\u044b\u0448\u0438\u043d\u043e",
      "longitude":85.796303,
      "latitude":54.61713
    },
    "1087":{
      "name":"\u0423\u0441\u0442\u044c-\u0425\u043c\u0435\u043b\u0435\u0432\u043a\u0430",
      "longitude":85.805107,
      "latitude":55.620613
    },
    "1088":{
      "name":"\u0411\u043b\u0430\u0433\u043e\u0434\u0430\u0442\u043d\u044b\u0439",
      "longitude":85.811966,
      "latitude":55.401524
    },
    "1089":{
      "name":"\u041f\u043e\u0440-\u0418\u0441\u043a\u0438\u0442\u0438\u043c",
      "longitude":85.8180908,
      "latitude":55.059562
    },
    "1090":{
      "name":"\u0422\u0430\u043b\u043e\u0432\u043a\u0430",
      "longitude":85.831711,
      "latitude":55.959728
    },
    "1091":{
      "name":"\u041a\u0443\u043b\u0435\u0431\u0430\u043a\u0438\u043d\u043e",
      "longitude":85.836197,
      "latitude":54.409882
    },
    "1092":{
      "name":"\u0417\u0432\u0451\u0437\u0434\u043d\u044b\u0439",
      "longitude":85.846062,
      "latitude":55.456921
    },
    "1093":{
      "name":"\u0427\u0435\u0440\u0435\u043c\u0438\u0447\u043a\u0438\u043d\u043e",
      "longitude":85.8591103,
      "latitude":55.1575307
    },
    "1094":{
      "name":"\u0412\u043e\u0437\u0432\u044b\u0448\u0435\u043d\u043a\u0430",
      "longitude":85.859764,
      "latitude":54.569763
    },
    "1095":{
      "name":"\u041a\u0430\u043c\u044b\u0448\u043d\u0430\u044f",
      "longitude":85.863792,
      "latitude":55.334999
    },
    "1096":{
      "name":"\u0411\u0430\u0439\u0440\u0430\u043a",
      "longitude":85.869025,
      "latitude":54.8680575
    },
    "1097":{
      "name":"\u041d\u043e\u0432\u043e\u043f\u043e\u043a\u0430\u0441\u044c\u043c\u0430",
      "longitude":85.8868809,
      "latitude":54.7061004
    },
    "1098":{
      "name":"\u042f\u0441\u043d\u043e\u0433\u043e\u0440\u0441\u043a\u0438\u0439",
      "longitude":85.891579,
      "latitude":55.345409
    },
    "1099":{
      "name":"\u041c\u0430\u0437\u0443\u0440\u043e\u0432\u043e",
      "longitude":85.892815,
      "latitude":55.332935
    },
    "1100":{
      "name":"\u0421\u043e\u0440\u0435\u0432\u043d\u043e\u0432\u0430\u043d\u0438\u0435",
      "longitude":85.8968368,
      "latitude":55.0542176
    },
    "1101":{
      "name":"\u0427\u0435\u0440\u0451\u043c\u0443\u0448\u043a\u0438",
      "longitude":85.915787,
      "latitude":55.611546
    },
    "1102":{
      "name":"\u0422\u0440\u0443\u0434",
      "longitude":85.9204845,
      "latitude":54.8619133
    },
    "1103":{
      "name":"\u041c\u043e\u0437\u0436\u0443\u0445\u0430",
      "longitude":85.924171,
      "latitude":55.420567
    },
    "1104":{
      "name":"\u041c\u0438\u0440\u043d\u044b\u0439",
      "longitude":85.924988,
      "latitude":54.612045
    },
    "1105":{
      "name":"\u0429\u0435\u0433\u043b\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":85.92514,
      "latitude":55.564667
    },
    "1106":{
      "name":"\u041f\u043b\u043e\u0442\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":85.939255,
      "latitude":55.022854
    },
    "1107":{
      "name":"\u0423\u0440-\u0411\u0435\u0434\u0430\u0440\u0438",
      "longitude":85.94165,
      "latitude":54.44289
    },
    "1108":{
      "name":"\u041f\u0440\u0438\u0433\u043e\u0440\u043e\u0434\u043d\u044b\u0439",
      "longitude":85.94915,
      "latitude":55.34964
    },
    "1109":{
      "name":"\u0411\u0430\u0440\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":85.950188,
      "latitude":55.638813
    },
    "1110":{
      "name":"\u041b\u0435\u0431\u0435\u0434\u044f\u043d\u043a\u0430",
      "longitude":85.953499,
      "latitude":56.136898
    },
    "1111":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u0421\u0430\u043b\u0430\u0438\u0440\u043a\u0430",
      "longitude":85.954163,
      "latitude":54.331799
    },
    "1112":{
      "name":"\u0412\u0435\u0440\u0445\u043e\u0442\u043e\u043c\u0441\u043a\u043e\u0435",
      "longitude":85.954659,
      "latitude":55.469341
    },
    "1113":{
      "name":"\u0427\u043a\u0430\u043b\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":85.956734,
      "latitude":54.690117
    },
    "1114":{
      "name":"\u0412\u043e\u0437\u043d\u0435\u0441\u0435\u043d\u043a\u0430",
      "longitude":85.9589362,
      "latitude":56.3188296
    },
    "1115":{
      "name":"\u0429\u0435\u0440\u0431\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":85.9790358,
      "latitude":56.1797225
    },
    "1116":{
      "name":"\u041d\u043e\u0432\u043e-\u0423\u0440\u0441\u043a\u0438\u0439",
      "longitude":85.98069,
      "latitude":54.487534
    },
    "1117":{
      "name":"\u041f\u043e\u0434\u0433\u043e\u0440\u043d\u043e\u0435",
      "longitude":85.999931,
      "latitude":54.489502
    },
    "1118":{
      "name":"\u0420\u0430\u0437\u0434\u043e\u043b\u044c\u043d\u044b\u0439",
      "longitude":86.001625,
      "latitude":54.291389
    },
    "1119":{
      "name":"\u041d\u0438\u043a\u0438\u0442\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":86.006111,
      "latitude":54.585873
    },
    "1120":{
      "name":"\u042f\u0433\u0443\u043d\u043e\u0432\u043e",
      "longitude":86.010689,
      "latitude":55.248917
    },
    "1121":{
      "name":"\u041f\u0440\u043e\u0442\u043e\u043f\u043e\u043f\u043e\u0432\u043e",
      "longitude":86.0154088,
      "latitude":54.8731843
    },
    "1122":{
      "name":"\u041b\u0435\u0441\u043d\u043e\u0439",
      "longitude":86.032967,
      "latitude":54.235229
    },
    "1123":{
      "name":"\u0414\u0440\u0430\u0447\u0435\u043d\u0438\u043d\u043e",
      "longitude":86.037697,
      "latitude":54.761208
    },
    "1124":{
      "name":"\u0425\u0443\u0434\u044f\u0448\u043e\u0432\u043e",
      "longitude":86.040161,
      "latitude":54.816643
    },
    "1125":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u0430\u044f \u0413\u043e\u0440\u043a\u0430",
      "longitude":86.0440318,
      "latitude":56.1083239
    },
    "1126":{
      "name":"\u041d\u043e\u0432\u043e\u0433\u043e\u0440\u043e\u0434\u0435\u0446",
      "longitude":86.044296,
      "latitude":54.606956
    },
    "1127":{
      "name":"\u041d\u043e\u0432\u043e\u0438\u0441\u043a\u0438\u0442\u0438\u043c\u0441\u043a",
      "longitude":86.054596,
      "latitude":55.301994
    },
    "1128":{
      "name":"348-\u0433\u043e \u041a\u0432\u0430\u0440\u0442\u0430\u043b\u0430",
      "longitude":86.0703364,
      "latitude":56.0148189
    },
    "1129":{
      "name":"\u041a\u0430\u0439\u043b\u0430",
      "longitude":86.0753983,
      "latitude":56.2214029
    },
    "1130":{
      "name":"\u0412\u043e\u0441\u0445\u043e\u0434\u044f\u0449\u0438\u0439",
      "longitude":86.076897,
      "latitude":54.682083
    },
    "1131":{
      "name":"\u0415\u0433\u043e\u0437\u043e\u0432\u043e",
      "longitude":86.080162,
      "latitude":54.687725
    },
    "1132":{
      "name":"\u041a\u043b\u0435\u0439\u0437\u0430\u0432\u043e\u0434\u0430",
      "longitude":86.0848176,
      "latitude":54.6890203
    },
    "1133":{
      "name":"\u041a\u043e\u043b\u044b\u0447\u0435\u0432\u043e",
      "longitude":86.0960801,
      "latitude":55.0122109
    },
    "1134":{
      "name":"\u0423\u043b\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":86.1038386,
      "latitude":56.4084317
    },
    "1135":{
      "name":"\u0411\u0435\u0437\u043b\u0435\u0441\u043d\u044b\u0439",
      "longitude":86.1089156,
      "latitude":56.1439951
    },
    "1136":{
      "name":"\u0421\u0443\u0445\u0430\u044f \u0420\u0435\u0447\u043a\u0430",
      "longitude":86.118065,
      "latitude":55.239616
    },
    "1137":{
      "name":"\u041b\u0435\u043d\u0438\u043d\u0433\u0440\u0430\u0434\u0441\u043a\u0438\u0439",
      "longitude":86.125961,
      "latitude":55.20134
    },
    "1138":{
      "name":"\u041a\u043b\u0435\u0439\u0437\u0430\u0432\u043e\u0434\u0430",
      "longitude":86.1287949,
      "latitude":54.7001665
    },
    "1139":{
      "name":"\u0421\u0432\u0435\u0440\u0434\u043b\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":86.138451,
      "latitude":54.583015
    },
    "1140":{
      "name":"\u041a\u0430\u043c\u0435\u043d\u043d\u044b\u0439 \u041a\u043b\u044e\u0447",
      "longitude":86.14579,
      "latitude":54.104118
    },
    "1141":{
      "name":"\u041a\u0443\u0437\u0431\u0430\u0441\u0441\u043a\u0438\u0439",
      "longitude":86.154114,
      "latitude":55.145493
    },
    "1142":{
      "name":"\u0420\u0430\u0437\u0432\u0435\u0434\u0447\u0438\u043a",
      "longitude":86.16552,
      "latitude":55.731522
    },
    "1143":{
      "name":"\u0421\u0443\u0434\u0436\u0435\u043d\u043a\u0430",
      "longitude":86.1683557,
      "latitude":56.1143787
    },
    "1144":{
      "name":"\u0422\u0443\u0440\u0430\u0442",
      "longitude":86.1768881,
      "latitude":56.0842356
    },
    "1145":{
      "name":"\u0429\u0435\u0431\u0437\u0430\u0432\u043e\u0434",
      "longitude":86.177834,
      "latitude":54.197178
    },
    "1146":{
      "name":"\u0411\u0430\u0440\u0430\u0447\u0430\u0442\u044b",
      "longitude":86.191116,
      "latitude":54.975975
    },
    "1147":{
      "name":"\u0411\u0435\u043a\u043e\u0432\u043e",
      "longitude":86.194893,
      "latitude":54.367714
    },
    "1148":{
      "name":"\u041c\u0435\u0442\u0430\u043b\u043b\u043f\u043b\u043e\u0449\u0430\u0434\u043a\u0430",
      "longitude":86.198402,
      "latitude":55.317013
    },
    "1149":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u0431\u0430\u0447\u0430\u0442\u044b",
      "longitude":86.206093,
      "latitude":54.237862
    },
    "1150":{
      "name":"\u0421\u0443\u0445\u043e\u0432\u043e",
      "longitude":86.208717,
      "latitude":55.358959
    },
    "1151":{
      "name":"\u0427\u0435\u043b\u0443\u0445\u043e\u0435\u0432\u043e",
      "longitude":86.213242,
      "latitude":54.371429
    },
    "1152":{
      "name":"\u0410\u043d\u0434\u0440\u0435\u0435\u0432\u043a\u0430",
      "longitude":86.213356,
      "latitude":55.444168
    },
    "1153":{
      "name":"\u0418\u0448\u0438\u043c",
      "longitude":86.221596,
      "latitude":56.513992
    },
    "1154":{
      "name":"\u0416\u0443\u0440\u0430\u0432\u043b\u0435\u0432\u043e",
      "longitude":86.224922,
      "latitude":55.36821
    },
    "1155":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u0442\u0440\u043e\u0439\u043a\u0430",
      "longitude":86.225311,
      "latitude":55.249348
    },
    "1156":{
      "name":"\u041d\u043e\u0432\u044b\u0439",
      "longitude":86.229576,
      "latitude":54.840572
    },
    "1157":{
      "name":"\u0421\u043a\u0430\u0440\u044e\u043f\u0438\u043d\u043e",
      "longitude":86.232101,
      "latitude":54.963547
    },
    "1158":{
      "name":"\u0414\u0435\u043c\u044c\u044f\u043d\u043e\u0432\u043a\u0430",
      "longitude":86.243301,
      "latitude":54.747231
    },
    "1159":{
      "name":"\u0417\u0430\u0440\u0435\u0447\u043d\u043e\u0435",
      "longitude":86.2454949,
      "latitude":54.3121892
    },
    "1160":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u043e",
      "longitude":86.247391,
      "latitude":55.233673
    },
    "1161":{
      "name":"\u041a\u043e\u043d\u0451\u0432\u043e",
      "longitude":86.24791,
      "latitude":54.530586
    },
    "1162":{
      "name":"\u0421\u0443\u0434\u0436\u0435\u043d\u043a\u0430",
      "longitude":86.2516182,
      "latitude":56.1832397
    },
    "1163":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":86.251663,
      "latitude":54.470654
    },
    "1164":{
      "name":"\u0428\u0435\u0441\u0442\u0430\u043a\u0438",
      "longitude":86.252815,
      "latitude":54.210114
    },
    "1165":{
      "name":"\u0415\u043b\u044b\u043a\u0430\u0435\u0432\u043e",
      "longitude":86.255035,
      "latitude":55.299999
    },
    "1166":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0435 \u041a\u043b\u044e\u0447\u0438",
      "longitude":86.263359,
      "latitude":54.997761
    },
    "1167":{
      "name":"\u0410\u0440\u0442\u044b\u0448\u0442\u0430",
      "longitude":86.270058,
      "latitude":54.116268
    },
    "1168":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u0433\u043e\u0440\u0441\u043a\u0438\u0439",
      "longitude":86.296455,
      "latitude":54.52832
    },
    "1169":{
      "name":"\u0421\u0438\u043b\u0438\u043d\u043e",
      "longitude":86.297424,
      "latitude":55.270569
    },
    "1170":{
      "name":"\u041e\u0441\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":86.303604,
      "latitude":55.389694
    },
    "1171":{
      "name":"\u0423\u0431\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":86.309639,
      "latitude":54.479538
    },
    "1172":{
      "name":"\u0411\u0435\u0440\u0435\u0433\u043e\u0432\u0430\u044f",
      "longitude":86.316956,
      "latitude":55.148563
    },
    "1173":{
      "name":"\u041d\u043e\u0432\u043e\u0433\u0435\u043e\u0440\u0433\u0438\u0435\u0432\u043a\u0430",
      "longitude":86.317245,
      "latitude":54.698189
    },
    "1174":{
      "name":"\u0411\u0430\u0440\u0437\u0430\u0441",
      "longitude":86.317558,
      "latitude":55.72924
    },
    "1175":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u044f\u0440\u043a\u0430",
      "longitude":86.323273,
      "latitude":54.648109
    },
    "1176":{
      "name":"\u0427\u0443\u0441\u043e\u0432\u0438\u0442\u0438\u043d\u043e",
      "longitude":86.333199,
      "latitude":54.838352
    },
    "1177":{
      "name":"\u0421\u043c\u043e\u043b\u0438\u043d\u043e",
      "longitude":86.34317,
      "latitude":55.1782
    },
    "1178":{
      "name":"\u041d\u043e\u0432\u043e\u0431\u0430\u0447\u0430\u0442\u044b",
      "longitude":86.347168,
      "latitude":54.256969
    },
    "1179":{
      "name":"\u041c\u043e\u0445\u043e\u0432\u043e",
      "longitude":86.347221,
      "latitude":54.587914
    },
    "1180":{
      "name":"\u0428\u0435\u0432\u0435\u043b\u0438",
      "longitude":86.34861,
      "latitude":55.073467
    },
    "1181":{
      "name":"\u0421\u0435\u0440\u0433\u0435\u0435\u0432\u043a\u0430",
      "longitude":86.3559409,
      "latitude":56.3835206
    },
    "1182":{
      "name":"\u0413\u0440\u0430\u043c\u043e\u0442\u0435\u0438\u043d\u043e",
      "longitude":86.3563926,
      "latitude":54.5255113
    },
    "1183":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":86.360275,
      "latitude":54.047287
    },
    "1184":{
      "name":"\u0421\u043d\u0435\u0436\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":86.372208,
      "latitude":54.440605
    },
    "1185":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u0447\u0435\u0440\u0432\u043e\u0432\u043e",
      "longitude":86.375137,
      "latitude":55.165092
    },
    "1186":{
      "name":"\u041f\u0430\u043d\u0444\u0438\u043b\u043e\u0432\u043e",
      "longitude":86.380577,
      "latitude":54.946575
    },
    "1187":{
      "name":"\u041c\u0430\u0440\u044c\u0435\u0432\u043a\u0430",
      "longitude":86.3888646,
      "latitude":56.2976015
    },
    "1188":{
      "name":"\u0417\u0435\u043b\u0451\u043d\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":86.389099,
      "latitude":55.003395
    },
    "1189":{
      "name":"\u0412\u0438\u0448\u043d\u0451\u0432\u043a\u0430",
      "longitude":86.399742,
      "latitude":54.412445
    },
    "1190":{
      "name":"\u0422\u0440\u0443\u0434\u0430\u0440\u043c\u0435\u0439\u0441\u043a\u0438\u0439",
      "longitude":86.408707,
      "latitude":54.129562
    },
    "1191":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u043f\u0435\u0441\u0442\u0435\u0440\u0435\u0432\u043e",
      "longitude":86.417503,
      "latitude":54.501209
    },
    "1192":{
      "name":"\u041a\u043e\u0440\u043e\u0442\u043a\u043e\u0432\u043e",
      "longitude":86.438202,
      "latitude":54.460793
    },
    "1193":{
      "name":"\u042f\u044f-\u0411\u043e\u0440\u0438\u043a",
      "longitude":86.4572598,
      "latitude":56.2733039
    },
    "1194":{
      "name":"\u0412\u0435\u0440\u0445-\u0427\u0443\u043c\u044b\u0448",
      "longitude":86.4657558,
      "latitude":53.9621039
    },
    "1195":{
      "name":"\u041d\u043e\u0432\u043e\u043d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":86.4667718,
      "latitude":56.1700024
    },
    "1196":{
      "name":"\u0411\u0435\u043a\u0435\u0442",
      "longitude":86.4741505,
      "latitude":56.3612716
    },
    "1197":{
      "name":"\u041f\u043b\u043e\u0442\u043d\u0438\u043a\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":86.481636,
      "latitude":55.013847
    },
    "1198":{
      "name":"\u041c\u0435\u043d\u0447\u0435\u0440\u0435\u043f",
      "longitude":86.481743,
      "latitude":54.42601
    },
    "1199":{
      "name":"\u0422\u043e\u043c\u0441\u043a\u043e\u0435",
      "longitude":86.491745,
      "latitude":53.610046
    },
    "1200":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u0442\u0440\u043e\u0439\u043a\u0430",
      "longitude":86.492264,
      "latitude":53.864063
    },
    "1201":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u041a\u0435\u0440\u043b\u0435\u0433\u0435\u0448",
      "longitude":86.494141,
      "latitude":53.895531
    },
    "1202":{
      "name":"\u0417\u0430\u0440\u0438\u043d\u0441\u043a\u043e\u0435",
      "longitude":86.505211,
      "latitude":54.596119
    },
    "1203":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u043a\u0430",
      "longitude":86.50972,
      "latitude":55.114231
    },
    "1204":{
      "name":"\u041f\u043e\u043c\u043e\u0440\u0446\u0435\u0432\u043e",
      "longitude":86.521919,
      "latitude":54.396828
    },
    "1205":{
      "name":"\u041a\u043e\u043b\u044b\u043e\u043d",
      "longitude":86.552055,
      "latitude":56.475079
    },
    "1206":{
      "name":"\u041a\u0430\u0440\u0430\u0433\u0430\u0439\u043b\u0430",
      "longitude":86.555199,
      "latitude":54.1721
    },
    "1207":{
      "name":"\u0411\u043e\u0440\u0438\u0441\u043e\u0432\u043e",
      "longitude":86.55851,
      "latitude":54.808437
    },
    "1208":{
      "name":"\u0421\u0432\u043e\u0431\u043e\u0434\u043d\u044b\u0439",
      "longitude":86.560562,
      "latitude":53.879818
    },
    "1209":{
      "name":"\u0422\u0438\u0445\u043e\u043d\u043e\u0432\u043a\u0430",
      "longitude":86.578629,
      "latitude":54.235355
    },
    "1210":{
      "name":"\u041f\u0435\u0440\u0435\u0445\u043b\u044f\u0439",
      "longitude":86.581581,
      "latitude":54.880028
    },
    "1211":{
      "name":"\u0421\u043c\u044b\u0448\u043b\u044f\u0435\u0432\u043e",
      "longitude":86.583237,
      "latitude":53.823025
    },
    "1212":{
      "name":"\u0421\u0438\u0434\u043e\u0440\u0451\u043d\u043a\u043e\u0432\u043e",
      "longitude":86.600815,
      "latitude":54.375546
    },
    "1213":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u0430\u0444\u043e\u043d\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":86.605751,
      "latitude":53.844315
    },
    "1214":{
      "name":"\u0412\u0435\u0440\u0445-\u0415\u0433\u043e\u0441",
      "longitude":86.606064,
      "latitude":53.925385
    },
    "1215":{
      "name":"\u041a\u0430\u0440\u0430\u0433\u0430\u0439\u043b\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":86.611023,
      "latitude":54.14595
    },
    "1216":{
      "name":"\u0418\u0436\u043c\u043e\u0440\u043a\u0430 2-\u044f",
      "longitude":86.631409,
      "latitude":56.158791
    },
    "1217":{
      "name":"\u0422\u0451\u043f\u043b\u0430\u044f \u0420\u0435\u0447\u043a\u0430",
      "longitude":86.658897,
      "latitude":56.346031
    },
    "1218":{
      "name":"\u041a\u043e\u043d\u043e\u0432\u0430\u043b\u043e\u0432\u043e",
      "longitude":86.660156,
      "latitude":54.354179
    },
    "1219":{
      "name":"\u0423\u0440\u043e\u043f",
      "longitude":86.677559,
      "latitude":54.52309
    },
    "1220":{
      "name":"\u0422\u0430\u0440\u0430\u0434\u0430\u043d\u043e\u0432\u043e",
      "longitude":86.679214,
      "latitude":54.752506
    },
    "1221":{
      "name":"\u0411\u0443\u0440\u043b\u0430\u043a\u0438",
      "longitude":86.689301,
      "latitude":54.144283
    },
    "1222":{
      "name":"\u041f\u043e\u0447\u0438\u0442\u0430\u043d\u043a\u0430",
      "longitude":86.698494,
      "latitude":56.284737
    },
    "1223":{
      "name":"\u0415\u0432\u0442\u0438\u043d\u043e",
      "longitude":86.70076,
      "latitude":54.354439
    },
    "1224":{
      "name":"\u041a\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":86.705849,
      "latitude":54.799759
    },
    "1225":{
      "name":"\u0414\u0443\u043d\u0430\u0439-\u041a\u043b\u044e\u0447",
      "longitude":86.707985,
      "latitude":54.468292
    },
    "1226":{
      "name":"\u041d\u043e\u0432\u044b\u0439 \u041a\u0430\u0440\u0430\u043a\u0430\u043d",
      "longitude":86.708687,
      "latitude":54.393536
    },
    "1227":{
      "name":"\u0411\u0430\u043d\u043d\u043e\u0432\u043e",
      "longitude":86.711746,
      "latitude":55.085411
    },
    "1228":{
      "name":"\u0421\u0435\u0432\u0441\u043a",
      "longitude":86.719025,
      "latitude":54.054279
    },
    "1229":{
      "name":"\u041a\u0430\u043c\u0435\u043d\u043d\u044b\u0439",
      "longitude":86.719566,
      "latitude":54.955471
    },
    "1230":{
      "name":"\u0421\u0430\u0440\u044b-\u0427\u0443\u043c\u044b\u0448",
      "longitude":86.720901,
      "latitude":53.24052
    },
    "1231":{
      "name":"\u0418\u043d\u0434\u0443\u0441\u0442\u0440\u0438\u044f",
      "longitude":86.72274,
      "latitude":53.830406
    },
    "1232":{
      "name":"\u041f\u043e\u0441\u0442\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":86.770088,
      "latitude":56.243198
    },
    "1233":{
      "name":"\u041a\u0430\u0440\u0430\u043a\u0430\u043d",
      "longitude":86.771339,
      "latitude":54.390175
    },
    "1234":{
      "name":"\u041e\u043a\u0442\u044f\u0431\u0440\u044c\u0441\u043a\u0438\u0439",
      "longitude":86.78302,
      "latitude":54.266342
    },
    "1235":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u043b\u0430\u0432\u044f\u043d\u043a\u0430",
      "longitude":86.784912,
      "latitude":56.534817
    },
    "1236":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u043e",
      "longitude":86.795563,
      "latitude":53.701546
    },
    "1237":{
      "name":"\u0418\u043d\u044e\u0448\u043a\u0430",
      "longitude":86.802017,
      "latitude":54.606499
    },
    "1238":{
      "name":"\u0421\u0432\u044f\u0442\u043e\u0441\u043b\u0430\u0432\u043a\u0430",
      "longitude":86.815193,
      "latitude":56.44006
    },
    "1239":{
      "name":"\u0428\u043a\u043e\u043b\u044c\u043d\u044b\u0439",
      "longitude":86.821915,
      "latitude":54.003143
    },
    "1240":{
      "name":"\u041a\u043e\u0441\u0442\u0435\u043d\u043a\u043e\u0432\u043e",
      "longitude":86.827049,
      "latitude":53.636299
    },
    "1241":{
      "name":"\u041c\u0435\u0436\u0434\u0443\u0433\u043e\u0440\u043d\u043e\u0435",
      "longitude":86.831528,
      "latitude":54.930344
    },
    "1242":{
      "name":"\u041d\u043e\u0432\u044b\u0439 \u0421\u0432\u0435\u0442",
      "longitude":86.831627,
      "latitude":55.826855
    },
    "1243":{
      "name":"\u041a\u043b\u044e\u0447\u0438",
      "longitude":86.84819,
      "latitude":54.7757
    },
    "1244":{
      "name":"\u041a\u043e\u043b\u044c\u0447\u0435\u0433\u0438\u0437",
      "longitude":86.866653,
      "latitude":54.1213
    },
    "1245":{
      "name":"\u0422\u0435\u0440\u0435\u043d\u0442\u044c\u0435\u0432\u0441\u043a\u0430\u044f",
      "longitude":86.868286,
      "latitude":54.066822
    },
    "1246":{
      "name":"\u0410\u0440\u0441\u0435\u043d\u043e\u0432\u043e",
      "longitude":86.876198,
      "latitude":54.803707
    },
    "1247":{
      "name":"\u0422\u0440\u043e\u0438\u0446\u043a\u043e\u0435",
      "longitude":86.885109,
      "latitude":56.058857
    },
    "1248":{
      "name":"\u041f\u043b\u043e\u0434\u043e\u043f\u0438\u0442\u043e\u043c\u043d\u0438\u043a",
      "longitude":86.888985,
      "latitude":53.988255
    },
    "1249":{
      "name":"\u0421\u043e\u043a\u043e\u043b\u043e\u0432\u043e",
      "longitude":86.896828,
      "latitude":54.194633
    },
    "1250":{
      "name":"\u0428\u0430\u0440\u0430\u043f",
      "longitude":86.902702,
      "latitude":53.91296
    },
    "1251":{
      "name":"\u041b\u0443\u0447\u0448\u0435\u0432\u043e",
      "longitude":86.9048769,
      "latitude":53.8395088
    },
    "1252":{
      "name":"\u041f\u0435\u0440\u043c\u044f\u043a\u0438",
      "longitude":86.912712,
      "latitude":54.462101
    },
    "1253":{
      "name":"\u041a\u043e\u0442\u0438\u043d\u043e",
      "longitude":86.918686,
      "latitude":54.246418
    },
    "1254":{
      "name":"\u042f\u0441\u043d\u0430\u044f \u041f\u043e\u043b\u044f\u043d\u0430",
      "longitude":86.926056,
      "latitude":53.98996
    },
    "1255":{
      "name":"\u041a\u0430\u043b\u0430\u0447\u0435\u0432\u043e",
      "longitude":86.934181,
      "latitude":53.788517
    },
    "1256":{
      "name":"\u0420\u0430\u0441\u0441\u0432\u0435\u0442",
      "longitude":86.935822,
      "latitude":53.724277
    },
    "1257":{
      "name":"\u0412\u043e\u0441\u043a\u0440\u0435\u0441\u0435\u043d\u043a\u0430",
      "longitude":86.946114,
      "latitude":56.134521
    },
    "1258":{
      "name":"\u0422\u0435\u0440\u0435\u043d\u0442\u044c\u0435\u0432\u0441\u043a\u043e\u0435",
      "longitude":86.946999,
      "latitude":54.098316
    },
    "1259":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u042f\u0440",
      "longitude":86.949387,
      "latitude":55.903286
    },
    "1260":{
      "name":"\u0411\u0443\u043d\u0433\u0443\u0440",
      "longitude":86.986267,
      "latitude":53.742912
    },
    "1261":{
      "name":"\u041a\u0430\u0440\u0430\u043b\u0434\u0430",
      "longitude":86.989746,
      "latitude":54.390499
    },
    "1262":{
      "name":"\u0411\u0435\u043d\u0436\u0435\u0440\u0435\u043f 1-\u0439",
      "longitude":86.997871,
      "latitude":53.324463
    },
    "1263":{
      "name":"\u0417\u0430\u0433\u043e\u0440\u0441\u043a\u0438\u0439",
      "longitude":87.008606,
      "latitude":53.758934
    },
    "1264":{
      "name":"\u0421\u0435\u0432\u0435\u0440\u043d\u044b\u0439",
      "longitude":87.010345,
      "latitude":53.935837
    },
    "1265":{
      "name":"\u041c\u0438\u0440",
      "longitude":87.01107,
      "latitude":53.737267
    },
    "1266":{
      "name":"\u041c\u0435\u0442\u0430\u043b\u043b\u0443\u0440\u0433\u043e\u0432",
      "longitude":87.029922,
      "latitude":53.899036
    },
    "1267":{
      "name":"\u041b\u044b\u0441",
      "longitude":87.038979,
      "latitude":53.153645
    },
    "1268":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u0422\u0430\u043b\u0434\u0430",
      "longitude":87.058716,
      "latitude":54.165207
    },
    "1269":{
      "name":"\u0411\u0435\u0440\u0438\u043a\u0443\u043b\u044c",
      "longitude":87.06189,
      "latitude":56.209278
    },
    "1270":{
      "name":"\u0410\u043d\u0438\u0441\u0438\u043c\u043e\u0432\u043e",
      "longitude":87.063347,
      "latitude":54.048965
    },
    "1271":{
      "name":"\u041a\u0438\u0440\u0441\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":87.063622,
      "latitude":56.50074
    },
    "1272":{
      "name":"\u041a\u0440\u0430\u0441\u0443\u043b\u0438\u043d\u043e",
      "longitude":87.081032,
      "latitude":54.025478
    },
    "1273":{
      "name":"\u0422\u0430\u0440\u0433\u0430\u0439\u0441\u043a\u0438\u0439 \u0434\u043e\u043c \u043e\u0442\u0434\u044b\u0445\u0430",
      "longitude":87.1038436,
      "latitude":53.5575721
    },
    "1274":{
      "name":"\u0421\u0442\u0435\u043f\u043d\u043e\u0439",
      "longitude":87.118156,
      "latitude":53.954166
    },
    "1275":{
      "name":"\u041c\u0430\u043b\u043e\u043f\u0435\u0441\u0447\u0430\u043d\u043a\u0430",
      "longitude":87.12056,
      "latitude":56.432613
    },
    "1276":{
      "name":"\u041d\u0435\u0434\u043e\u0440\u0435\u0437\u043e\u0432\u043e",
      "longitude":87.121033,
      "latitude":54.004021
    },
    "1277":{
      "name":"\u0411\u0435\u0434\u0430\u0440\u0435\u0432\u043e",
      "longitude":87.12661,
      "latitude":53.855629
    },
    "1278":{
      "name":"\u0421\u043e\u0441\u043d\u043e\u0432\u043a\u0430",
      "longitude":87.152794,
      "latitude":53.667896
    },
    "1279":{
      "name":"\u0418\u043b\u044c\u0438\u043d\u043a\u0430",
      "longitude":87.163513,
      "latitude":53.900764
    },
    "1280":{
      "name":"\u0421\u0438\u043c\u0431\u0438\u0440\u043a\u0430",
      "longitude":87.170036,
      "latitude":56.043968
    },
    "1281":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":87.172012,
      "latitude":53.475719
    },
    "1282":{
      "name":"\u0411\u0435\u043b\u043e\u0433\u043e\u0440\u043e\u0434\u043a\u0430",
      "longitude":87.172188,
      "latitude":56.290577
    },
    "1283":{
      "name":"\u0427\u0438\u0447\u0435\u0440\u0431\u0430\u0435\u0432\u043e",
      "longitude":87.176262,
      "latitude":53.993416
    },
    "1284":{
      "name":"\u0415\u0440\u0443\u043d\u0430\u043a\u043e\u0432\u043e",
      "longitude":87.189011,
      "latitude":54.001217
    },
    "1285":{
      "name":"\u041a\u0443\u0437\u0435\u0434\u0435\u0435\u0432\u043e",
      "longitude":87.189774,
      "latitude":53.336449
    },
    "1286":{
      "name":"\u041a\u0443\u0440\u0442\u0443\u043a\u043e\u0432\u043e",
      "longitude":87.206154,
      "latitude":53.639267
    },
    "1287":{
      "name":"\u041a\u0440\u0443\u0433\u043b\u0435\u043d\u044c\u043a\u043e\u0435",
      "longitude":87.209396,
      "latitude":53.812115
    },
    "1288":{
      "name":"\u0423\u0441\u043f\u0435\u043d\u043a\u0430",
      "longitude":87.220848,
      "latitude":54.081867
    },
    "1289":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0435 \u041e\u0440\u043b\u044b",
      "longitude":87.231705,
      "latitude":56.172802
    },
    "1290":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":87.2617703,
      "latitude":55.8797373
    },
    "1291":{
      "name":"\u0410\u0448\u043c\u0430\u0440\u0438\u043d\u043e",
      "longitude":87.262169,
      "latitude":53.631451
    },
    "1292":{
      "name":"\u0422\u044e\u043c\u0435\u043d\u0435\u0432\u043e",
      "longitude":87.26358,
      "latitude":56.242439
    },
    "1293":{
      "name":"\u0415\u043b\u0430\u043d\u044c",
      "longitude":87.265854,
      "latitude":53.706509
    },
    "1294":{
      "name":"\u041f\u043e\u0441\u0442\u043e\u044f\u043d\u043d\u044b\u0439",
      "longitude":87.2716446,
      "latitude":53.5449712
    },
    "1295":{
      "name":"\u041a\u0430\u0437\u0430\u043d\u043a\u043e\u0432\u043e",
      "longitude":87.273628,
      "latitude":53.999435
    },
    "1296":{
      "name":"\u041a\u043e\u043d\u0434\u043e\u043c\u0430",
      "longitude":87.274208,
      "latitude":52.821659
    },
    "1297":{
      "name":"\u041c\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":87.284531,
      "latitude":53.40292
    },
    "1298":{
      "name":"\u0417\u0430\u0440\u0435\u0447\u043d\u044b\u0439",
      "longitude":87.303146,
      "latitude":53.598549
    },
    "1299":{
      "name":"\u0421\u0430\u0440\u0431\u0430\u043b\u0430",
      "longitude":87.312462,
      "latitude":53.460785
    },
    "1300":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u0430\u044f \u041e\u0440\u043b\u043e\u0432\u043a\u0430",
      "longitude":87.330635,
      "latitude":53.585495
    },
    "1301":{
      "name":"\u0422\u0435\u0440\u0435\u0445\u0438\u043d\u043e",
      "longitude":87.3348475,
      "latitude":53.9925328
    },
    "1302":{
      "name":"\u0421\u0438\u0434\u043e\u0440\u043e\u0432\u043e",
      "longitude":87.342735,
      "latitude":53.961102
    },
    "1303":{
      "name":"\u041a\u043e\u043b\u0435\u0443\u043b",
      "longitude":87.345764,
      "latitude":56.515823
    },
    "1304":{
      "name":"\u0427\u0438\u0441\u0442\u043e\u0433\u043e\u0440\u0441\u043a\u0438\u0439",
      "longitude":87.377029,
      "latitude":53.967369
    },
    "1305":{
      "name":"\u0411\u043b\u0430\u0433\u043e\u0432\u0435\u0449\u0435\u043d\u043a\u0430",
      "longitude":87.38681,
      "latitude":56.380539
    },
    "1306":{
      "name":"\u0410\u0442\u0430\u043c\u0430\u043d\u043e\u0432\u043e",
      "longitude":87.393791,
      "latitude":53.785049
    },
    "1307":{
      "name":"\u0422\u0430\u043b\u044c\u0436\u0438\u043d\u043e",
      "longitude":87.406693,
      "latitude":53.760323
    },
    "1308":{
      "name":"\u0421\u043b\u0430\u0432\u0438\u043d\u043e",
      "longitude":87.410324,
      "latitude":54.032951
    },
    "1309":{
      "name":"\u0411\u0430\u0435\u0432\u043a\u0430",
      "longitude":87.413681,
      "latitude":53.725246
    },
    "1310":{
      "name":"\u0423\u0441\u043c\u0430\u043d\u043a\u0430",
      "longitude":87.4164101,
      "latitude":55.9547936
    },
    "1311":{
      "name":"\u0422\u0430\u0439\u0436\u0438\u043d\u0430",
      "longitude":87.437691,
      "latitude":53.674171
    },
    "1312":{
      "name":"\u0413\u0435\u043e\u0440\u0433\u0438\u0435\u0432\u043a\u0430",
      "longitude":87.4540584,
      "latitude":54.2991283
    },
    "1313":{
      "name":"\u0422\u0430\u0451\u0436\u043d\u043e-\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":87.466362,
      "latitude":56.532303
    },
    "1314":{
      "name":"\u0411\u0435\u043b\u044b\u0439 \u042d\u0442\u0430\u043f",
      "longitude":87.4705339,
      "latitude":54.118747
    },
    "1315":{
      "name":"\u0411\u0430\u0440\u0437\u0430\u0441",
      "longitude":87.4773915,
      "latitude":54.1485621
    },
    "1316":{
      "name":"\u0411\u043e\u0440\u043e\u0432\u043a\u043e\u0432\u043e",
      "longitude":87.498199,
      "latitude":53.791348
    },
    "1317":{
      "name":"\u0410\u043c\u0437\u0430\u0441",
      "longitude":87.5423069,
      "latitude":53.0147248
    },
    "1318":{
      "name":"\u0411\u0435\u0437\u0440\u0443\u043a\u043e\u0432\u043e",
      "longitude":87.552422,
      "latitude":53.778408
    },
    "1319":{
      "name":"\u0422\u0435\u043d\u0433\u0443\u043b\u044b",
      "longitude":87.552467,
      "latitude":56.382576
    },
    "1320":{
      "name":"\u041e\u0441\u0438\u043d\u043e\u0432\u043e\u0435 \u041f\u043b\u0435\u0441\u043e",
      "longitude":87.554848,
      "latitude":54.211418
    },
    "1321":{
      "name":"\u041a\u0430\u043b\u0430\u0440\u044b",
      "longitude":87.5729454,
      "latitude":52.9184794
    },
    "1322":{
      "name":"\u0412\u0435\u0440\u0445-\u0427\u0435\u0431\u0443\u043b\u0430",
      "longitude":87.610344,
      "latitude":56.0294
    },
    "1323":{
      "name":"\u0411\u0430\u0437\u0430\u043d\u0447\u0430",
      "longitude":87.61187,
      "latitude":52.888298
    },
    "1324":{
      "name":"\u0411\u0435\u0440\u0435\u043d\u0437\u0430\u0441",
      "longitude":87.6182002,
      "latitude":53.7224178
    },
    "1325":{
      "name":"\u041e\u0431\u043e\u044f\u043d\u043e\u0432\u043a\u0430",
      "longitude":87.62458,
      "latitude":56.358444
    },
    "1326":{
      "name":"\u041a\u0430\u043b\u0438\u043d\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":87.638901,
      "latitude":56.195591
    },
    "1327":{
      "name":"\u0426\u0435\u043d\u0442\u0440\u0430\u043b\u044c\u043d\u044b\u0439",
      "longitude":87.648727,
      "latitude":55.21376
    },
    "1328":{
      "name":"\u041f\u043e\u0434\u043e\u0431\u0430\u0441",
      "longitude":87.662628,
      "latitude":53.76976
    },
    "1329":{
      "name":"\u0410\u043b\u0442\u0430\u043c\u0430\u0448",
      "longitude":87.679642,
      "latitude":52.545834
    },
    "1330":{
      "name":"\u041c\u0430\u043b\u044b\u0439 \u0410\u043d\u0442\u0438\u0431\u0435\u0441",
      "longitude":87.701164,
      "latitude":56.283062
    },
    "1331":{
      "name":"\u0411\u043e\u0440\u043e\u0434\u0438\u043d\u043e",
      "longitude":87.7484839,
      "latitude":53.7391116
    },
    "1332":{
      "name":"\u0421\u043f\u0430\u0441\u0441\u043a",
      "longitude":87.754295,
      "latitude":52.748081
    },
    "1333":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u0410\u043d\u0442\u0438\u0431\u0435\u0441",
      "longitude":87.755768,
      "latitude":56.306705
    },
    "1334":{
      "name":"\u0423\u0441\u0442\u044c-\u0427\u0435\u0431\u0443\u043b\u0430",
      "longitude":87.7659717,
      "latitude":56.1267188
    },
    "1335":{
      "name":"\u0427\u0443\u043c\u0430\u0439",
      "longitude":87.773697,
      "latitude":55.738312
    },
    "1336":{
      "name":"\u0427\u0443\u0433\u0443\u043d\u0430\u0448",
      "longitude":87.775978,
      "latitude":52.889339
    },
    "1337":{
      "name":"\u041d\u043e\u0432\u043e\u0438\u0432\u0430\u043d\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":87.7947773,
      "latitude":55.8598129
    },
    "1338":{
      "name":"1-\u0439",
      "longitude":87.8168376,
      "latitude":56.0256656
    },
    "1339":{
      "name":"\u041f\u0440\u0438\u0441\u0442\u0430\u043d\u044c 2-\u044f",
      "longitude":87.823303,
      "latitude":56.20586
    },
    "1340":{
      "name":"\u041a\u0443\u0440\u0430\u043a\u043e\u0432\u043e",
      "longitude":87.8454082,
      "latitude":55.7502709
    },
    "1341":{
      "name":"\u0414\u043c\u0438\u0442\u0440\u0438\u0435\u0432\u043a\u0430",
      "longitude":87.909805,
      "latitude":56.032875
    },
    "1342":{
      "name":"\u0410\u043b\u0447\u0435\u0434\u0430\u0442",
      "longitude":87.913458,
      "latitude":55.9849751
    },
    "1343":{
      "name":"\u041f\u0440\u0438\u043c\u0435\u0442\u043a\u0438\u043d\u043e",
      "longitude":87.916405,
      "latitude":56.232849
    },
    "1344":{
      "name":"\u0423\u0441\u0442\u044c-\u0421\u0435\u0440\u0442\u0430",
      "longitude":87.9944142,
      "latitude":56.0062967
    },
    "1345":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u043c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":88.0146924,
      "latitude":56.1753932
    },
    "1346":{
      "name":"\u041a\u043b\u044e\u0447\u0435\u0432\u043e\u0439",
      "longitude":88.0153866,
      "latitude":52.6286601
    },
    "1347":{
      "name":"\u041c\u0430\u043a\u0430\u0440\u0430\u043a\u0441\u043a\u0438\u0439",
      "longitude":88.048836,
      "latitude":55.595734
    },
    "1348":{
      "name":"\u041f\u0438\u0445\u0442\u043e\u0432\u043a\u0430",
      "longitude":88.076248,
      "latitude":56.652843
    },
    "1349":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430 2-\u044f",
      "longitude":88.092201,
      "latitude":56.287209
    },
    "1350":{
      "name":"\u041a\u0443\u0440\u0441\u043a-\u0421\u043c\u043e\u043b\u0435\u043d\u043a\u0430",
      "longitude":88.0981211,
      "latitude":55.9572973
    },
    "1351":{
      "name":"\u0411\u0435\u0440\u0438\u043a\u0443\u043b\u044c\u0441\u043a\u0438\u0439",
      "longitude":88.117325,
      "latitude":55.518356
    },
    "1352":{
      "name":"\u0421\u0443\u0441\u043b\u043e\u0432\u043e",
      "longitude":88.119827,
      "latitude":56.219307
    },
    "1353":{
      "name":"\u041a\u0443\u043b\u0438\u043a\u043e\u0432\u043a\u0430",
      "longitude":88.1312322,
      "latitude":55.7957086
    },
    "1354":{
      "name":"\u041b\u0435\u0431\u044f\u0436\u0438\u0439",
      "longitude":88.159012,
      "latitude":56.383942
    },
    "1355":{
      "name":"\u041a\u043e\u043c\u0441\u043e\u043c\u043e\u043b\u044c\u0441\u043a",
      "longitude":88.182556,
      "latitude":55.632576
    },
    "1356":{
      "name":"\u041b\u0438\u0441\u0442\u0432\u044f\u043d\u043a\u0430",
      "longitude":88.2036733,
      "latitude":55.9242252
    },
    "1357":{
      "name":"\u041c\u0430\u0439\u0437\u0430\u0441",
      "longitude":88.2045587,
      "latitude":53.6226188
    },
    "1358":{
      "name":"\u041a\u043e\u043b\u0431\u0430",
      "longitude":88.2131147,
      "latitude":55.8264795
    },
    "1359":{
      "name":"\u0423\u0441\u0442\u044c-\u041a\u043e\u043b\u0431\u0430",
      "longitude":88.3025503,
      "latitude":55.8824606
    },
    "1360":{
      "name":"\u0423\u0442\u0438\u043d\u043a\u0430",
      "longitude":88.3347496,
      "latitude":55.7408909
    },
    "1361":{
      "name":"\u0412\u0430\u043b\u0435\u0440\u044c\u044f\u043d\u043e\u0432\u043a\u0430",
      "longitude":88.3897542,
      "latitude":56.0109784
    },
    "1362":{
      "name":"\u041b\u0438\u0441\u0442\u0432\u044f\u043d\u043a\u0430",
      "longitude":88.396622,
      "latitude":56.069378
    },
    "1363":{
      "name":"\u0414\u0432\u043e\u0440\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":88.409667,
      "latitude":55.7953226
    },
    "1364":{
      "name":"\u0422\u0440\u0435\u0442\u044c\u044f\u043a\u043e\u0432\u043e",
      "longitude":88.4423887,
      "latitude":55.7952663
    },
    "1365":{
      "name":"\u0423\u0441\u0442\u044c-\u041a\u0430\u0431\u044b\u0440\u0437\u0430",
      "longitude":88.445816,
      "latitude":52.824162
    },
    "1366":{
      "name":"\u041f\u043e\u043b\u0443\u0442\u043e\u0440\u043d\u0438\u043a",
      "longitude":88.4691302,
      "latitude":55.3190171
    },
    "1367":{
      "name":"\u0411\u0435\u043b\u043e\u0433\u043e\u0440\u0441\u043a",
      "longitude":88.486359,
      "latitude":55.018394
    },
    "1368":{
      "name":"\u041d\u043e\u0432\u043e\u0432\u043e\u0441\u0442\u043e\u0447\u043d\u044b\u0439",
      "longitude":88.5423612,
      "latitude":56.1579077
    },
    "1369":{
      "name":"\u0422\u0435\u0431\u0430",
      "longitude":88.5504161,
      "latitude":53.6440023
    },
    "1370":{
      "name":"\u0421\u0442\u0443\u043f\u0438\u0448\u0438\u043d\u043e",
      "longitude":88.5518026,
      "latitude":56.2101649
    },
    "1371":{
      "name":"\u041f\u0440\u0435\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043a\u0430",
      "longitude":88.5670804,
      "latitude":56.0375514
    },
    "1372":{
      "name":"\u0422\u044f\u0436\u0438\u043d\u043e-\u0412\u0435\u0440\u0448\u0438\u043d\u043a\u0430",
      "longitude":88.5929061,
      "latitude":55.91932
    },
    "1373":{
      "name":"\u0413\u0435\u043e\u0440\u0433\u0438\u0435\u0432\u043a\u0430",
      "longitude":88.6182128,
      "latitude":56.2697328
    },
    "1374":{
      "name":"\u041e\u0440\u0442\u043e\u043d",
      "longitude":88.6217456,
      "latitude":53.2056078
    },
    "1375":{
      "name":"\u0422\u0430\u043c\u0431\u0430\u0440",
      "longitude":88.6233854,
      "latitude":55.5900116
    },
    "1376":{
      "name":"\u0414\u0430\u043d\u0438\u043b\u043e\u0432\u043a\u0430",
      "longitude":88.6446,
      "latitude":56.3102206
    },
    "1377":{
      "name":"\u0422\u0438\u0441\u0443\u043b\u044c",
      "longitude":88.6841535,
      "latitude":56.0748379
    },
    "1378":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u0411\u0430\u0440\u0430\u043d\u0434\u0430\u0442",
      "longitude":88.754021,
      "latitude":55.758247
    },
    "1379":{
      "name":"\u0410\u043a\u0438\u043c\u043e-\u0410\u043d\u043d\u0435\u043d\u043a\u0430",
      "longitude":88.7967634,
      "latitude":56.0794363
    },
    "1380":{
      "name":"\u041c\u0430\u043b\u043e\u043f\u0438\u0447\u0443\u0433\u0438\u043d\u043e",
      "longitude":88.8767576,
      "latitude":55.8519267
    },
    "1381":{
      "name":"\u041d\u043e\u0432\u043e\u043f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":88.9459371,
      "latitude":55.9535489
    },
    "1382":{
      "name":"\u041d\u043e\u0432\u043e\u043c\u0430\u0440\u044c\u0438\u043d\u043a\u0430",
      "longitude":89.013915,
      "latitude":56.0878653
    },
    "1383":{
      "name":"\u0421\u0435\u0440\u0435\u0431\u0440\u044f\u043a\u043e\u0432\u043e",
      "longitude":89.0188932,
      "latitude":55.6933824
    },
    "1384":{
      "name":"\u0418\u0442\u0430\u0442\u0441\u043a\u0438\u0439",
      "longitude":89.032578,
      "latitude":56.068081
    },
    "1385":{
      "name":"\u041d\u043e\u0432\u043e\u043f\u043e\u0434\u0437\u043e\u0440\u043d\u043e\u0432\u043e",
      "longitude":89.0988874,
      "latitude":55.8636807
    },
    "1386":{
      "name":"\u041a\u0443\u0431\u0438\u0442\u0435\u0442",
      "longitude":89.1348751,
      "latitude":55.9441929
    },
    "1387":{
      "name":"\u0427\u0443\u043b\u044b\u043c",
      "longitude":89.2083193,
      "latitude":56.045594
    },
    "1388":{
      "name":"\u0421\u0442\u0430\u0440\u044b\u0439 \u0423\u0440\u044e\u043f",
      "longitude":89.3361234,
      "latitude":55.8350601
    },
    "1389":{
      "name":"\u041f\u0440\u0438\u0438\u0441\u043a\u043e\u0432\u043e\u0435",
      "longitude":88.695641,
      "latitude":54.653049
    },
    "1390":{
      "name":"\u041e\u0440\u0434\u0436\u043e\u043d\u0438\u043a\u0438\u0434\u0437\u0435\u0432\u0441\u043a\u043e\u0435",
      "longitude":88.963654,
      "latitude":54.777313
    },
    "1391":{
      "name":"\u0411\u0430\u043b\u044b\u043a\u0441\u0430",
      "longitude":89.137718,
      "latitude":53.416523
    },
    "1392":{
      "name":"\u0413\u0430\u0439\u0434\u0430\u0440\u043e\u0432\u0441\u043a",
      "longitude":89.1717794,
      "latitude":54.6221899
    },
    "1393":{
      "name":"\u0421\u0430\u0440\u0430\u043b\u0430",
      "longitude":89.2425,
      "latitude":54.863907
    },
    "1394":{
      "name":"\u041a\u043e\u043c\u043c\u0443\u043d\u0430\u0440",
      "longitude":89.290825,
      "latitude":54.350353
    },
    "1395":{
      "name":"\u0427\u0451\u0440\u043d\u043e\u0435 \u041e\u0437\u0435\u0440\u043e",
      "longitude":89.4291398,
      "latitude":54.6869463
    },
    "1396":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u0422\u0430\u0448\u0442\u044b\u043f",
      "longitude":89.44495,
      "latitude":52.8110468
    },
    "1397":{
      "name":"\u0415\u0444\u0440\u0435\u043c\u043a\u0438\u043d\u043e",
      "longitude":89.447456,
      "latitude":54.467525
    },
    "1398":{
      "name":"\u041f\u043e\u0434\u043a\u0430\u043c\u0435\u043d\u044c",
      "longitude":89.448189,
      "latitude":54.821259
    },
    "1399":{
      "name":"\u041c\u0430\u0442\u0443\u0440",
      "longitude":89.45974,
      "latitude":52.654572
    },
    "1400":{
      "name":"\u0411\u0435\u043b\u044b\u0439 \u0411\u0430\u043b\u0430\u0445\u0447\u0438\u043d",
      "longitude":89.47953,
      "latitude":54.555183
    },
    "1401":{
      "name":"\u0410\u043d\u0447\u0443\u043b",
      "longitude":89.48201,
      "latitude":52.808495
    },
    "1402":{
      "name":"\u0411\u0435\u0440\u0435\u043d\u0436\u0430\u043a",
      "longitude":89.482201,
      "latitude":54.140209
    },
    "1403":{
      "name":"\u0411\u0438\u0441\u043a\u0430\u043c\u0436\u0430",
      "longitude":89.528656,
      "latitude":53.450871
    },
    "1404":{
      "name":"\u0423\u0441\u0442\u0438\u043d\u043a\u0438\u043d\u043e",
      "longitude":89.561111,
      "latitude":54.907589
    },
    "1405":{
      "name":"\u0412\u0435\u0440\u0448\u0438\u043d\u0430 \u0422\u0451\u0438",
      "longitude":89.562622,
      "latitude":53.26786
    },
    "1406":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u044f\u044f \u0421\u0435\u044f",
      "longitude":89.700256,
      "latitude":52.682571
    },
    "1407":{
      "name":"\u041c\u0430\u043b\u044b\u0439 \u041a\u043e\u0431\u0435\u0436\u0438\u043a\u043e\u0432",
      "longitude":89.731331,
      "latitude":54.541687
    },
    "1408":{
      "name":"\u0418\u044e\u0441",
      "longitude":89.758881,
      "latitude":54.700157
    },
    "1409":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0435 \u0421\u0438\u0440\u044b",
      "longitude":89.7616369,
      "latitude":52.7535232
    },
    "1410":{
      "name":"\u041a\u043e\u0431\u044f\u043a\u043e\u0432\u043e",
      "longitude":89.775406,
      "latitude":54.795418
    },
    "1411":{
      "name":"\u041e\u0442\u0442\u044b",
      "longitude":89.780022,
      "latitude":52.961269
    },
    "1412":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u0421\u0435\u044f",
      "longitude":89.796463,
      "latitude":52.742954
    },
    "1413":{
      "name":"\u0424\u044b\u0440\u043a\u0430\u043b",
      "longitude":89.815819,
      "latitude":54.63015
    },
    "1414":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u0421\u0435\u044f",
      "longitude":89.8326332,
      "latitude":52.7536753
    },
    "1415":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0439 \u041a\u0443\u0440\u043b\u0443\u0433\u0430\u0448",
      "longitude":89.8343187,
      "latitude":52.7790742
    },
    "1416":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u0418\u043c\u0435\u043a",
      "longitude":89.844406,
      "latitude":52.873665
    },
    "1417":{
      "name":"\u041a\u043e\u043f\u044c\u0451\u0432\u043e",
      "longitude":89.847221,
      "latitude":55.03561
    },
    "1418":{
      "name":"\u0423\u0441\u0442\u044c-\u0427\u0443\u043b\u044c",
      "longitude":89.867302,
      "latitude":52.959057
    },
    "1419":{
      "name":"\u0425\u0430\u0440\u043e\u0439",
      "longitude":89.8766903,
      "latitude":52.9020882
    },
    "1420":{
      "name":"\u0421\u043e\u043b\u0451\u043d\u043e\u043e\u0437\u0451\u0440\u043d\u043e\u0435",
      "longitude":89.878975,
      "latitude":54.729546
    },
    "1421":{
      "name":"\u0411\u0438\u0440\u0438\u043a\u0447\u0443\u043b\u044c",
      "longitude":89.884003,
      "latitude":53.327736
    },
    "1422":{
      "name":"\u0423\u0441\u0442\u044c-\u0425\u043e\u0439\u0437\u0430",
      "longitude":89.912445,
      "latitude":53.136806
    },
    "1423":{
      "name":"\u0426\u0435\u043b\u0438\u043d\u043d\u043e\u0435",
      "longitude":89.913689,
      "latitude":54.58194
    },
    "1424":{
      "name":"\u0418\u043c\u0435\u043a",
      "longitude":89.927124,
      "latitude":52.850498
    },
    "1425":{
      "name":"\u0422\u0443\u0438\u043c",
      "longitude":89.944397,
      "latitude":54.339775
    },
    "1426":{
      "name":"\u041c\u0430\u043b\u044b\u0439 \u0421\u043f\u0438\u0440\u0438\u043d",
      "longitude":89.944855,
      "latitude":54.440174
    },
    "1427":{
      "name":"\u041a\u044b\u0437\u043b\u0430\u0441",
      "longitude":89.956627,
      "latitude":53.116982
    },
    "1428":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0439 \u0418\u043c\u0435\u043a",
      "longitude":89.958496,
      "latitude":52.827698
    },
    "1429":{
      "name":"\u0411\u0443\u0442\u0440\u0430\u0445\u0442\u044b",
      "longitude":89.988907,
      "latitude":52.812019
    },
    "1430":{
      "name":"\u041d\u0438\u0436\u043d\u044f\u044f \u0422\u0451\u044f",
      "longitude":90.042847,
      "latitude":52.931854
    },
    "1431":{
      "name":"\u041a\u0430\u0437\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":90.048378,
      "latitude":53.214287
    },
    "1432":{
      "name":"\u0421\u0430\u0444\u0440\u043e\u043d\u043e\u0432",
      "longitude":90.057327,
      "latitude":53.045673
    },
    "1433":{
      "name":"\u041d\u043e\u0432\u043e\u043c\u0430\u0440\u044c\u044f\u0441\u043e\u0432\u043e",
      "longitude":90.121277,
      "latitude":55.07449
    },
    "1434":{
      "name":"\u041a\u043e\u043b\u043e\u0434\u0435\u0437\u043d\u044b\u0439",
      "longitude":90.14344,
      "latitude":54.482887
    },
    "1435":{
      "name":"\u0416\u0435\u043c\u0447\u0443\u0436\u043d\u044b\u0439",
      "longitude":90.156975,
      "latitude":54.495186
    },
    "1436":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u0410\u0441\u043a\u0438\u0437",
      "longitude":90.17955,
      "latitude":53.163086
    },
    "1437":{
      "name":"\u041f\u043e\u043b\u0442\u0430\u043a\u043e\u0432",
      "longitude":90.18573,
      "latitude":52.955486
    },
    "1438":{
      "name":"\u0421\u043e\u043d\u0441\u043a\u043e\u0435",
      "longitude":90.216064,
      "latitude":54.16127
    },
    "1439":{
      "name":"\u0423\u0441\u0442\u044c-\u0422\u0430\u0448\u0442\u044b\u043f",
      "longitude":90.244148,
      "latitude":52.881306
    },
    "1440":{
      "name":"\u0423\u0441\u0442\u044c-\u0411\u044e\u0440",
      "longitude":90.246674,
      "latitude":53.832451
    },
    "1441":{
      "name":"\u0423\u0441\u0442\u044c-\u0415\u0441\u044c",
      "longitude":90.252899,
      "latitude":52.955238
    },
    "1442":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u041c\u043e\u043d\u043e\u043a",
      "longitude":90.284157,
      "latitude":52.869522
    },
    "1443":{
      "name":"\u0410\u0440\u0431\u0430\u0442\u044b",
      "longitude":90.287102,
      "latitude":52.698696
    },
    "1444":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u044f\u044f \u0411\u0430\u0437\u0430",
      "longitude":90.294716,
      "latitude":53.245544
    },
    "1445":{
      "name":"\u041c\u0430\u043b\u044b\u0435 \u0410\u0440\u0431\u0430\u0442\u044b",
      "longitude":90.316284,
      "latitude":52.715145
    },
    "1446":{
      "name":"\u0415\u0440\u0431\u0438\u043d\u0441\u043a\u0430\u044f",
      "longitude":90.3168234,
      "latitude":53.974978
    },
    "1447":{
      "name":"\u041d\u0438\u0436\u043d\u044f\u044f \u0411\u0430\u0437\u0430",
      "longitude":90.347763,
      "latitude":53.216244
    },
    "1448":{
      "name":"\u0411\u043e\u0440\u0435\u0446",
      "longitude":90.37207,
      "latitude":54.464703
    },
    "1449":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0438\u0435 \u0410\u0440\u0431\u0430\u0442\u044b",
      "longitude":90.375443,
      "latitude":52.713818
    },
    "1450":{
      "name":"\u0427\u0430\u0440\u043a\u043e\u0432",
      "longitude":90.3795084,
      "latitude":53.7023163
    },
    "1451":{
      "name":"\u0421\u043e\u043d",
      "longitude":90.386726,
      "latitude":54.388302
    },
    "1452":{
      "name":"\u0414\u0436\u0438\u0440\u0438\u043c",
      "longitude":90.388298,
      "latitude":54.808208
    },
    "1453":{
      "name":"\u0412\u043b\u0430\u0441\u044c\u0435\u0432\u043e",
      "longitude":90.396004,
      "latitude":54.463825
    },
    "1454":{
      "name":"\u0411\u0435\u043b\u044c\u0442\u0438\u0440\u0441\u043a\u043e\u0435",
      "longitude":90.399498,
      "latitude":53.025295
    },
    "1455":{
      "name":"\u0410\u043f\u0447\u0438\u043d\u0430\u0435\u0432",
      "longitude":90.425102,
      "latitude":53.045708
    },
    "1456":{
      "name":"\u041f\u0443\u0448\u043d\u043e\u0435",
      "longitude":90.484009,
      "latitude":54.227364
    },
    "1457":{
      "name":"\u0411\u043e\u043d\u0434\u0430\u0440\u0435\u0432\u043e",
      "longitude":90.495697,
      "latitude":52.934788
    },
    "1458":{
      "name":"\u0412\u043e\u0440\u043e\u0442\u0430",
      "longitude":90.5195388,
      "latitude":54.7052482
    },
    "1459":{
      "name":"\u041b\u0443\u0433\u043e\u0432\u0430\u044f",
      "longitude":90.571342,
      "latitude":53.15678
    },
    "1460":{
      "name":"\u041f\u0443\u043b\u0430\u043d\u043a\u043e\u043b\u044c",
      "longitude":90.602264,
      "latitude":53.390011
    },
    "1461":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u0415\u0440\u0431\u0430",
      "longitude":90.6222,
      "latitude":54.255283
    },
    "1462":{
      "name":"\u041a\u043e\u0439\u0431\u0430\u043b\u044b",
      "longitude":90.652451,
      "latitude":53.161961
    },
    "1463":{
      "name":"\u0423\u0441\u0442\u044c-\u041a\u0430\u043c\u044b\u0448\u0442\u0430",
      "longitude":90.703941,
      "latitude":53.35376
    },
    "1464":{
      "name":"\u0417\u0430\u0440\u0435\u0447\u043d\u0430\u044f",
      "longitude":90.7093604,
      "latitude":54.5844869
    },
    "1465":{
      "name":"\u0412\u0435\u0441\u0435\u043d\u043d\u0435\u0435",
      "longitude":90.710983,
      "latitude":53.618706
    },
    "1466":{
      "name":"\u041a\u0430\u0442\u0430\u043d\u043e\u0432",
      "longitude":90.712387,
      "latitude":53.238533
    },
    "1467":{
      "name":"\u0422\u0430\u0431\u0430\u0442",
      "longitude":90.718742,
      "latitude":52.948189
    },
    "1468":{
      "name":"\u0421\u0430\u0440\u0430\u0433\u0430\u0448",
      "longitude":90.74099,
      "latitude":54.771664
    },
    "1469":{
      "name":"\u041a\u0443\u0439\u0431\u044b\u0448\u0435\u0432\u043e",
      "longitude":90.777634,
      "latitude":53.195202
    },
    "1470":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u043c\u0430\u0439\u0441\u043a\u043e\u0435",
      "longitude":90.7833781,
      "latitude":54.583716
    },
    "1471":{
      "name":"\u0411\u0443\u0434\u0435\u043d\u043e\u0432\u043a\u0430",
      "longitude":90.828674,
      "latitude":52.991718
    },
    "1472":{
      "name":"\u0428\u0430\u043b\u0433\u0438\u043d\u043e\u0432",
      "longitude":90.941658,
      "latitude":53.348732
    },
    "1473":{
      "name":"\u0412\u0435\u0440\u0448\u0438\u043d\u043e-\u0411\u0438\u0434\u0436\u0430",
      "longitude":90.966454,
      "latitude":53.980663
    },
    "1474":{
      "name":"\u0417\u043d\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":90.983704,
      "latitude":54.363499
    },
    "1475":{
      "name":"\u0414\u043e\u043c\u043e\u0436\u0430\u043a\u043e\u0432",
      "longitude":91.033585,
      "latitude":53.441132
    },
    "1476":{
      "name":"\u041d\u043e\u0432\u043e\u0442\u0440\u043e\u0438\u0446\u043a\u043e\u0435",
      "longitude":91.050529,
      "latitude":53.151272
    },
    "1477":{
      "name":"\u0410\u0440\u0448\u0430\u043d\u043e\u0432\u043e",
      "longitude":91.064278,
      "latitude":53.411091
    },
    "1478":{
      "name":"\u0422\u043e\u043b\u0447\u0435\u044f",
      "longitude":91.077179,
      "latitude":54.05938
    },
    "1479":{
      "name":"\u0422\u0440\u043e\u0438\u0446\u043a\u043e\u0435",
      "longitude":91.091789,
      "latitude":54.280178
    },
    "1480":{
      "name":"\u041c\u043e\u0441\u043a\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":91.110077,
      "latitude":53.929935
    },
    "1481":{
      "name":"\u041a\u0443\u0440\u0433\u0430\u043d\u043d\u0430\u044f",
      "longitude":91.1226957,
      "latitude":53.790793
    },
    "1482":{
      "name":"\u0411\u043e\u0440\u043e\u0434\u0438\u043d\u043e",
      "longitude":91.129494,
      "latitude":54.098881
    },
    "1483":{
      "name":"\u0420\u0430\u0439\u043a\u043e\u0432",
      "longitude":91.175919,
      "latitude":53.52449
    },
    "1484":{
      "name":"\u0421\u0430\u0431\u0438\u043d\u043a\u0430",
      "longitude":91.182098,
      "latitude":53.09034
    },
    "1485":{
      "name":"\u0421\u043e\u043b\u043d\u0435\u0447\u043d\u043e\u0435",
      "longitude":91.182915,
      "latitude":53.688675
    },
    "1486":{
      "name":"\u0421\u0430\u0440\u0442\u044b\u043a\u043e\u0432",
      "longitude":91.183556,
      "latitude":53.471912
    },
    "1487":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u043e\u0437\u0451\u0440\u043d\u043e\u0435",
      "longitude":91.2148749,
      "latitude":53.6493356
    },
    "1488":{
      "name":"\u041a\u0438\u0440\u0431\u0430",
      "longitude":91.221893,
      "latitude":53.281242
    },
    "1489":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u0443\u0440\u0441\u043a",
      "longitude":91.259888,
      "latitude":53.109344
    },
    "1490":{
      "name":"\u041f\u0440\u0438\u0433\u043e\u0440\u0441\u043a",
      "longitude":91.263443,
      "latitude":53.90966
    },
    "1491":{
      "name":"\u0411\u043e\u0433\u043e\u0441\u043b\u043e\u0432\u043a\u0430",
      "longitude":91.272728,
      "latitude":52.9762
    },
    "1492":{
      "name":"\u041a\u0430\u043b\u044b",
      "longitude":91.28344,
      "latitude":53.074226
    },
    "1493":{
      "name":"\u0421\u0430\u043f\u043e\u0433\u043e\u0432",
      "longitude":91.285347,
      "latitude":53.620724
    },
    "1494":{
      "name":"\u0418\u0437\u044b\u0445\u0441\u043a\u0438\u0435 \u041a\u043e\u043f\u0438",
      "longitude":91.28968,
      "latitude":53.550091
    },
    "1495":{
      "name":"\u0422\u0430\u0448\u0435\u0431\u0430",
      "longitude":91.297379,
      "latitude":53.675846
    },
    "1496":{
      "name":"\u041d\u043e\u0432\u043e\u043d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":91.298203,
      "latitude":53.191898
    },
    "1497":{
      "name":"\u0417\u0435\u043b\u0451\u043d\u043e\u0435",
      "longitude":91.313568,
      "latitude":53.774803
    },
    "1498":{
      "name":"\u0422\u0435\u043f\u043b\u0438\u0447\u043d\u044b\u0439",
      "longitude":91.332916,
      "latitude":53.786877
    },
    "1499":{
      "name":"\u0427\u0430\u043f\u0430\u0435\u0432\u043e",
      "longitude":91.344978,
      "latitude":53.654575
    },
    "1500":{
      "name":"\u0420\u0430\u0441\u0446\u0432\u0435\u0442",
      "longitude":91.3531147,
      "latitude":53.7861168
    },
    "1501":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u043f\u043e\u043b\u044c\u0435",
      "longitude":91.369179,
      "latitude":53.428658
    },
    "1502":{
      "name":"\u041a\u0430\u043b\u0438\u043d\u0438\u043d\u043e",
      "longitude":91.402077,
      "latitude":53.755917
    },
    "1503":{
      "name":"\u0421\u043e\u0432\u0435\u0442\u0441\u043a\u0430\u044f \u0425\u0430\u043a\u0430\u0441\u0438\u044f",
      "longitude":91.433891,
      "latitude":54.112991
    },
    "1504":{
      "name":"\u041a\u0430\u0439\u0431\u0430\u043b\u044b",
      "longitude":91.471825,
      "latitude":53.657898
    },
    "1505":{
      "name":"\u041d\u043e\u0432\u043e\u0435\u043d\u0438\u0441\u0435\u0439\u043a\u0430",
      "longitude":91.507805,
      "latitude":53.163784
    },
    "1506":{
      "name":"\u041f\u043e\u0434\u0441\u0438\u043d\u0435\u0435",
      "longitude":91.545029,
      "latitude":53.664356
    },
    "1507":{
      "name":"\u041b\u0443\u043a\u044c\u044f\u043d\u043e\u0432\u043a\u0430",
      "longitude":91.557571,
      "latitude":53.413704
    },
    "1508":{
      "name":"\u041d\u043e\u0432\u043e\u043c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":91.566116,
      "latitude":53.254532
    },
    "1509":{
      "name":"\u041d\u043e\u0432\u043e\u0440\u043e\u0441\u0441\u0438\u0439\u0441\u043a\u043e\u0435",
      "longitude":91.59906,
      "latitude":53.378452
    },
    "1510":{
      "name":"\u041b\u0435\u0442\u043d\u0438\u043a",
      "longitude":91.64135,
      "latitude":53.507832
    },
    "1511":{
      "name":"\u041e\u0447\u0443\u0440\u044b",
      "longitude":91.650909,
      "latitude":53.167343
    },
    "1512":{
      "name":"\u0410\u043b\u0442\u0430\u0439",
      "longitude":91.808655,
      "latitude":53.43866
    },
    "1513":{
      "name":"\u041a\u0438\u0440\u043e\u0432\u043e",
      "longitude":91.886078,
      "latitude":53.342438
    },
    "1514":{
      "name":"\u0423\u0441\u0442\u044c-\u0423\u0440\u043b\u0443\u043a",
      "longitude":107.804169,
      "latitude":49.945618
    },
    "1515":{
      "name":"\u0423\u0440\u043b\u0443\u043a",
      "longitude":107.88958,
      "latitude":50.055202
    },
    "1516":{
      "name":"\u0416\u0438\u043d\u0434\u043e 1-\u0435",
      "longitude":107.9845129,
      "latitude":49.9451718
    },
    "1517":{
      "name":"\u0416\u0438\u043d\u0434\u043e\u043a\u043e\u043d",
      "longitude":108.0552203,
      "latitude":50.0745482
    },
    "1518":{
      "name":"\u041a\u043e\u043d\u043a\u0438\u043d\u043e",
      "longitude":108.0733486,
      "latitude":49.8057128
    },
    "1519":{
      "name":"\u0425\u0438\u043b\u043a\u043e\u0442\u043e\u0439",
      "longitude":108.076218,
      "latitude":49.921173
    },
    "1520":{
      "name":"\u041f\u0435\u0441\u043a\u0438",
      "longitude":108.1211071,
      "latitude":50.770521
    },
    "1521":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u0417\u0430\u0440\u0434\u0430\u043c\u0430",
      "longitude":108.1670701,
      "latitude":50.7923287
    },
    "1522":{
      "name":"\u0421\u0442\u0430\u0440\u0430\u044f \u0417\u0430\u0440\u0434\u0430\u043c\u0430",
      "longitude":108.1805495,
      "latitude":50.7537695
    },
    "1523":{
      "name":"\u0413\u0443\u0442\u0430\u0439",
      "longitude":108.1968883,
      "latitude":49.996642
    },
    "1524":{
      "name":"\u0410\u043b\u044c\u0431\u0438\u0442\u0443\u0439",
      "longitude":108.22593,
      "latitude":50.14068
    },
    "1525":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0439 \u041d\u0430\u0440\u044b\u043c",
      "longitude":108.23655,
      "latitude":50.08754
    },
    "1526":{
      "name":"\u0411\u0443\u0440\u0441\u043e\u043c\u043e\u043d",
      "longitude":108.258736,
      "latitude":50.180317
    },
    "1527":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u0430\u044f \u0414\u043e\u043b\u0438\u043d\u0430",
      "longitude":108.2649915,
      "latitude":50.8211829
    },
    "1528":{
      "name":"\u041d\u043e\u0432\u043e\u043d\u0438\u043a\u043e\u043b\u044c\u0441\u043a\u043e\u0435",
      "longitude":108.30989,
      "latitude":50.8439
    },
    "1529":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u0428\u0435\u0440\u0433\u043e\u043b\u044c\u0434\u0436\u0438\u043d",
      "longitude":108.323357,
      "latitude":50.194931
    },
    "1530":{
      "name":"\u0421\u043e\u0445\u043e\u0442\u043e\u0439",
      "longitude":108.3511372,
      "latitude":50.812179
    },
    "1531":{
      "name":"\u041a\u043e\u0442\u044b\u0439",
      "longitude":108.3782078,
      "latitude":50.12032
    },
    "1532":{
      "name":"\u041c\u0430\u043b\u0435\u0442\u0430",
      "longitude":108.424332,
      "latitude":50.837921
    },
    "1533":{
      "name":"\u041c\u0430\u0440\u0433\u0438\u043d\u0442\u0443\u0439",
      "longitude":108.46417,
      "latitude":50.14155
    },
    "1534":{
      "name":"\u041f\u0440\u0438\u0438\u0441\u043a \u0411\u043e\u043b\u044c\u0448\u0430\u044f \u0420\u0435\u0447\u043a\u0430",
      "longitude":108.4682,
      "latitude":50.1328
    },
    "1535":{
      "name":"\u042d\u0442\u044b\u0442\u044d\u0439",
      "longitude":108.47483,
      "latitude":50.29798
    },
    "1536":{
      "name":"\u0425\u0430\u0440\u0430\u0443\u0437",
      "longitude":108.4757664,
      "latitude":51.2487743
    },
    "1537":{
      "name":"\u0410\u043b\u0435\u043d\u0442\u0443\u0439",
      "longitude":108.4764545,
      "latitude":50.8827262
    },
    "1538":{
      "name":"\u041e\u0431\u043e\u0440",
      "longitude":108.548419,
      "latitude":50.9679647
    },
    "1539":{
      "name":"\u041c\u043e\u0441\u0442\u043e\u0432\u043a\u0430",
      "longitude":108.5523609,
      "latitude":50.3126284
    },
    "1540":{
      "name":"\u0423\u0441\u0442\u044c-\u041e\u0431\u043e\u0440",
      "longitude":108.574211,
      "latitude":50.930923
    },
    "1541":{
      "name":"\u0411\u0430\u0439\u0445\u043e\u0440",
      "longitude":108.5850019,
      "latitude":50.2961383
    },
    "1542":{
      "name":"\u0413\u0440\u0435\u043c\u044f\u0447\u0430",
      "longitude":108.632689,
      "latitude":50.3273861
    },
    "1543":{
      "name":"\u041a\u0430\u0442\u0430\u0435\u0432\u043e",
      "longitude":108.661354,
      "latitude":50.947624
    },
    "1544":{
      "name":"\u041a\u0430\u043d\u0434\u043e\u0431\u0430\u0435\u0432\u043e",
      "longitude":108.7111822,
      "latitude":50.963981
    },
    "1545":{
      "name":"\u0410\u0440\u0445\u0430\u043d\u0433\u0435\u043b\u044c\u0441\u043a\u043e\u0435",
      "longitude":108.7488141,
      "latitude":50.3233406
    },
    "1546":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u0427\u0438\u043a\u043e\u0439",
      "longitude":108.75798,
      "latitude":50.364742
    },
    "1547":{
      "name":"\u041e\u0440\u0441\u0443\u043a",
      "longitude":108.8116228,
      "latitude":50.9581175
    },
    "1548":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":108.8173522,
      "latitude":50.3448844
    },
    "1549":{
      "name":"\u041c\u0430\u043b\u043e\u0430\u0440\u0445\u0430\u043d\u0433\u0435\u043b\u044c\u0441\u043a",
      "longitude":108.833371,
      "latitude":50.3955588
    },
    "1550":{
      "name":"\u041c\u0435\u043d\u0437\u0430",
      "longitude":108.854622,
      "latitude":49.430981
    },
    "1551":{
      "name":"\u0423\u043a\u044b\u0440",
      "longitude":108.8777873,
      "latitude":49.4647198
    },
    "1552":{
      "name":"\u0411\u0430\u0440\u0430\u0445\u043e\u0435\u0432\u043e",
      "longitude":108.9114416,
      "latitude":50.426639
    },
    "1553":{
      "name":"\u041a\u0430\u0442\u0430\u043d\u0433\u0430\u0440",
      "longitude":108.960846,
      "latitude":51.012379
    },
    "1554":{
      "name":"\u041a\u043e\u0440\u043e\u0442\u043a\u043e\u0432\u043e",
      "longitude":108.9707397,
      "latitude":50.4450789
    },
    "1555":{
      "name":"\u0411\u0430\u043b\u044f\u0433\u0430-\u041a\u0430\u0442\u0430\u043d\u0433\u0430\u0440",
      "longitude":108.9755419,
      "latitude":51.1100929
    },
    "1556":{
      "name":"\u0428\u043e\u043d\u0443\u0439",
      "longitude":108.9789131,
      "latitude":49.6451393
    },
    "1557":{
      "name":"\u0411\u044b\u043a\u043e\u0432\u043e",
      "longitude":109.0152903,
      "latitude":50.4188624
    },
    "1558":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u043a\u043e\u0432\u043e",
      "longitude":109.0270658,
      "latitude":50.4511982
    },
    "1559":{
      "name":"\u041a\u0443\u043b\u0438",
      "longitude":109.0450563,
      "latitude":51.1348311
    },
    "1560":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0435 \u0420\u0435\u0447\u043a\u0438",
      "longitude":109.1024435,
      "latitude":50.464158
    },
    "1561":{
      "name":"\u0417\u0443\u0433\u043c\u0430\u0440\u0430",
      "longitude":109.217911,
      "latitude":51.18541
    },
    "1562":{
      "name":"\u0424\u043e\u043c\u0438\u0447\u0451\u0432\u043e",
      "longitude":109.265047,
      "latitude":50.509118
    },
    "1563":{
      "name":"\u0422\u043e\u043b\u0431\u0430\u0433\u0430",
      "longitude":109.328285,
      "latitude":51.205585
    },
    "1564":{
      "name":"\u0417\u0430\u0445\u0430\u0440\u043e\u0432\u043e",
      "longitude":109.3804336,
      "latitude":50.5359725
    },
    "1565":{
      "name":"\u041e\u0441\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":109.4598393,
      "latitude":50.557375
    },
    "1566":{
      "name":"\u0410\u0446\u0430",
      "longitude":109.5521042,
      "latitude":50.4872286
    },
    "1567":{
      "name":"\u0425\u043e\u0445\u043e\u0442\u0443\u0439",
      "longitude":109.563087,
      "latitude":51.283916
    },
    "1568":{
      "name":"\u0428\u0438\u043c\u0431\u0438\u043b\u0438\u043a",
      "longitude":109.5757564,
      "latitude":50.5641659
    },
    "1569":{
      "name":"\u0423\u0448\u043e\u0442\u044b",
      "longitude":109.64566,
      "latitude":51.315639
    },
    "1570":{
      "name":"\u0417\u0430\u043a\u0443\u043b\u044c\u0442\u0430",
      "longitude":109.739746,
      "latitude":51.359848
    },
    "1571":{
      "name":"\u0428\u044d\u043b\u044d",
      "longitude":109.7876555,
      "latitude":51.3810411
    },
    "1572":{
      "name":"\u0411\u0430\u0434\u0430",
      "longitude":109.86763,
      "latitude":51.391209
    },
    "1573":{
      "name":"\u0422\u044d\u0440\u044d\u043f\u0445\u044d\u043d",
      "longitude":109.8975475,
      "latitude":51.3542528
    },
    "1574":{
      "name":"\u0417\u0443\u0440\u0443\u043d",
      "longitude":109.9706328,
      "latitude":51.4023705
    },
    "1575":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u0420\u0435\u0447\u043a\u0430",
      "longitude":109.9828414,
      "latitude":50.5767766
    },
    "1576":{
      "name":"\u0413\u043b\u0438\u043d\u043a\u0430",
      "longitude":110.04628,
      "latitude":51.426929
    },
    "1577":{
      "name":"\u0417\u0430\u0448\u0443\u043b\u0430\u043d",
      "longitude":110.0681673,
      "latitude":50.5365396
    },
    "1578":{
      "name":"\u0410\u0444\u043e\u043d\u044c\u043a\u0438\u043d\u043e",
      "longitude":110.1138075,
      "latitude":50.5726553
    },
    "1579":{
      "name":"\u0427\u0435\u0440\u0435\u043c\u0445\u043e\u0432\u043e",
      "longitude":110.158401,
      "latitude":50.580055
    },
    "1580":{
      "name":"\u0416\u0438\u043f\u0445\u0435\u0433\u0435\u043d",
      "longitude":110.1650237,
      "latitude":51.4596241
    },
    "1581":{
      "name":"\u0421\u0442\u0435\u043a\u043b\u043e\u0437\u0430\u0432\u043e\u0434",
      "longitude":110.2512967,
      "latitude":50.583641
    },
    "1582":{
      "name":"\u042f\u043c\u0430\u0440\u043e\u0432\u043a\u0430",
      "longitude":110.251656,
      "latitude":50.61385
    },
    "1583":{
      "name":"\u0423\u0441\u0442\u044c-\u042f\u043c\u0430\u0440\u043e\u0432\u043a\u0430",
      "longitude":110.2688187,
      "latitude":50.5859999
    },
    "1584":{
      "name":"\u0421\u043e\u0441\u043d\u043e\u0432\u043a\u0430",
      "longitude":110.3069408,
      "latitude":51.4291403
    },
    "1585":{
      "name":"\u042f\u0434\u0440\u0438\u0445\u0438\u043d\u043e",
      "longitude":110.3426747,
      "latitude":50.6036067
    },
    "1586":{
      "name":"\u042d\u043d\u0433\u043e\u0440\u043e\u043a",
      "longitude":110.350311,
      "latitude":50.9783626
    },
    "1587":{
      "name":"\u0421\u0435\u043c\u0438\u043e\u0437\u0451\u0440\u044c\u0435",
      "longitude":110.4476231,
      "latitude":49.8204395
    },
    "1588":{
      "name":"\u0416\u0438\u043b\u043a\u0438\u043d \u0425\u0443\u0442\u043e\u0440",
      "longitude":110.5419704,
      "latitude":51.3723678
    },
    "1589":{
      "name":"\u0425\u0438\u043b\u043e\u0433\u043e\u0441\u043e\u043d",
      "longitude":110.6386059,
      "latitude":51.1525481
    },
    "1590":{
      "name":"\u041b\u0438\u043d\u0451\u0432\u043e \u041e\u0437\u0435\u0440\u043e",
      "longitude":110.6540103,
      "latitude":51.3628117
    },
    "1591":{
      "name":"\u0413\u044b\u0440\u0448\u0435\u043b\u0443\u043d",
      "longitude":110.66243,
      "latitude":51.399441
    },
    "1592":{
      "name":"\u0423\u043b\u044f\u0441\u0442\u0443\u0439",
      "longitude":110.6879335,
      "latitude":51.2133523
    },
    "1593":{
      "name":"\u0410\u043b\u0435\u043d\u0442\u0443\u0439\u043a\u0430",
      "longitude":110.8036594,
      "latitude":51.4125764
    },
    "1594":{
      "name":"\u0425\u0443\u0448\u0435\u043d\u0433\u0430",
      "longitude":110.921417,
      "latitude":51.43705
    },
    "1595":{
      "name":"\u0414\u0430\u0439\u0433\u0443\u0440",
      "longitude":111.0564186,
      "latitude":51.4855001
    },
    "1596":{
      "name":"\u0425\u0430\u0440\u0430\u0433\u0443\u043d",
      "longitude":111.176079,
      "latitude":51.554287
    },
    "1597":{
      "name":"\u0410\u0440\u0435\u0439",
      "longitude":111.2469651,
      "latitude":50.970478
    },
    "1598":{
      "name":"\u0428\u0443\u043c\u0443\u043d\u0434\u0430",
      "longitude":111.2997867,
      "latitude":49.4983471
    },
    "1599":{
      "name":"\u0428\u0435\u0431\u0430\u0440\u0442\u0443\u0439 2-\u0439",
      "longitude":111.3866951,
      "latitude":51.0292707
    },
    "1600":{
      "name":"\u0410\u0440\u0435\u043d\u0443\u0440",
      "longitude":111.4202837,
      "latitude":51.3773904
    },
    "1601":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u0430\u043b\u0438\u044f",
      "longitude":111.4252758,
      "latitude":50.9771027
    },
    "1602":{
      "name":"\u041b\u0435\u043d\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":111.5191916,
      "latitude":50.8445712
    },
    "1603":{
      "name":"\u0410\u043b\u0442\u0430\u043d",
      "longitude":111.531548,
      "latitude":49.510048
    },
    "1604":{
      "name":"\u0422\u0430\u043d\u0433\u0430",
      "longitude":111.5503067,
      "latitude":50.9888294
    },
    "1605":{
      "name":"\u0411\u0438\u043b\u044e\u0442\u0443\u0439",
      "longitude":111.6914181,
      "latitude":49.5893105
    },
    "1606":{
      "name":"\u0417\u0430\u0433\u0430\u0440\u0438\u043d\u043e",
      "longitude":111.698799,
      "latitude":51.682377
    },
    "1607":{
      "name":"\u0411\u044b\u043b\u044b\u0440\u0430",
      "longitude":111.722565,
      "latitude":49.689995
    },
    "1608":{
      "name":"\u0414\u0435\u0448\u0443\u043b\u0430\u043d",
      "longitude":111.7788131,
      "latitude":50.9793805
    },
    "1609":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u0441\u043a\u043e\u0435",
      "longitude":111.7831262,
      "latitude":51.0534122
    },
    "1610":{
      "name":"\u041d\u043e\u0432\u044b\u0435 \u041a\u043b\u044e\u0447\u0438",
      "longitude":111.7946062,
      "latitude":50.9902324
    },
    "1611":{
      "name":"\u0423\u043a\u0443\u0440\u0438\u043a",
      "longitude":111.818197,
      "latitude":51.6753747
    },
    "1612":{
      "name":"\u041d\u0430\u0434\u0451\u0436\u043d\u044b\u0439",
      "longitude":111.8224233,
      "latitude":50.0281952
    },
    "1613":{
      "name":"\u0428\u0435\u0445\u043e\u043b\u0430\u043d",
      "longitude":111.9328068,
      "latitude":51.0329432
    },
    "1614":{
      "name":"\u0413\u043e\u0440\u0435\u043a\u0430\u0446\u0430\u043d",
      "longitude":111.9431978,
      "latitude":51.1256725
    },
    "1615":{
      "name":"\u041a\u044b\u0440\u0430",
      "longitude":111.971039,
      "latitude":49.578625
    },
    "1616":{
      "name":"\u0413\u043e\u0440\u0435\u043a\u0430",
      "longitude":111.9883651,
      "latitude":51.0727242
    },
    "1617":{
      "name":"\u041c\u043e\u0440\u0434\u043e\u0439",
      "longitude":112.0241747,
      "latitude":49.6965452
    },
    "1618":{
      "name":"\u0410\u0431\u043b\u0430\u0442\u0443\u043a\u0430\u043d",
      "longitude":112.1269673,
      "latitude":51.2443734
    },
    "1619":{
      "name":"\u0414\u043e\u0440\u043e\u043d\u0438\u043d\u0441\u043a\u043e\u0435",
      "longitude":112.1425838,
      "latitude":51.1256516
    },
    "1620":{
      "name":"\u041b\u044e\u0431\u043e\u0432\u044c",
      "longitude":112.1521173,
      "latitude":49.6398149
    },
    "1621":{
      "name":"\u0413\u0430\u0432\u0430\u043d\u044c",
      "longitude":112.1756656,
      "latitude":49.468145
    },
    "1622":{
      "name":"\u0410\u0431\u043b\u0430\u0442\u0443\u0439\u0441\u043a\u0438\u0439 \u0411\u043e\u0440",
      "longitude":112.2189455,
      "latitude":51.1868252
    },
    "1623":{
      "name":"\u0413\u043e\u043d\u0433\u043e\u0442\u0430",
      "longitude":112.255531,
      "latitude":51.776855
    },
    "1624":{
      "name":"\u0411\u0430\u043b\u044c\u0437\u043e\u0439",
      "longitude":112.3644339,
      "latitude":51.356352
    },
    "1625":{
      "name":"\u0425\u0430\u043f\u0447\u0435\u0440\u0430\u043d\u0433\u0430",
      "longitude":112.386902,
      "latitude":49.6991
    },
    "1626":{
      "name":"\u0422\u044b\u0440\u0438\u043d",
      "longitude":112.3999872,
      "latitude":49.5645664
    },
    "1627":{
      "name":"\u0410\u0440\u0442\u0430",
      "longitude":112.4018631,
      "latitude":51.2520796
    },
    "1628":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u0421\u0442\u0430\u043d",
      "longitude":112.4800244,
      "latitude":49.7698302
    },
    "1629":{
      "name":"\u0423\u043b\u0451\u0442\u044b",
      "longitude":112.485115,
      "latitude":51.35854
    },
    "1630":{
      "name":"\u042f\u0433\u043e\u0434\u043d\u044b\u0439",
      "longitude":112.493866,
      "latitude":51.90424
    },
    "1631":{
      "name":"\u0422\u0430\u0440\u0431\u0430\u043b\u044c\u0434\u0436\u0435\u0439",
      "longitude":112.5156441,
      "latitude":49.7354486
    },
    "1632":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0439 \u0421\u0442\u0430\u043d",
      "longitude":112.5289479,
      "latitude":49.7559696
    },
    "1633":{
      "name":"\u0421\u043e\u0445\u043e\u043d\u0434\u043e",
      "longitude":112.535202,
      "latitude":51.817394
    },
    "1634":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u0423\u043b\u044c\u0445\u0443\u043d",
      "longitude":112.5452557,
      "latitude":49.5839354
    },
    "1635":{
      "name":"\u0425\u0430\u0434\u0430\u043a\u0442\u0430",
      "longitude":112.5705332,
      "latitude":51.427184
    },
    "1636":{
      "name":"\u0418\u0440\u0433\u0435\u043d\u044c",
      "longitude":112.578735,
      "latitude":51.983963
    },
    "1637":{
      "name":"\u0422\u0443\u0440\u0433\u0443\u0442\u0443\u0439",
      "longitude":112.643875,
      "latitude":51.843033
    },
    "1638":{
      "name":"\u0411\u0435\u043a\u043b\u0435\u043c\u0438\u0448\u0435\u0432\u043e",
      "longitude":112.672441,
      "latitude":52.1216376
    },
    "1639":{
      "name":"\u041c\u0430\u043d\u0433\u0443\u0442",
      "longitude":112.6769115,
      "latitude":49.6958425
    },
    "1640":{
      "name":"\u0428\u0430\u043a\u0448\u0430",
      "longitude":112.721649,
      "latitude":52.111599
    },
    "1641":{
      "name":"\u0427\u0435\u0440\u0435\u043c\u0445\u043e\u0432\u043e",
      "longitude":112.7245812,
      "latitude":51.458884
    },
    "1642":{
      "name":"\u041a\u0443\u0440\u0443\u043b\u0433\u0430",
      "longitude":112.7626648,
      "latitude":50.1162148
    },
    "1643":{
      "name":"\u042f\u0431\u043b\u043e\u043d\u043e\u0432\u043e",
      "longitude":112.763557,
      "latitude":51.839775
    },
    "1644":{
      "name":"\u0423\u043b\u044c\u0445\u0443\u043d-\u041f\u0430\u0440\u0442\u0438\u044f",
      "longitude":112.7648106,
      "latitude":49.8575038
    },
    "1645":{
      "name":"\u0410\u0440\u0430\u0445\u043b\u0435\u0439",
      "longitude":112.831795,
      "latitude":52.162918
    },
    "1646":{
      "name":"\u0422\u0430\u0442\u0430\u0443\u0440\u043e\u0432\u043e",
      "longitude":112.9317478,
      "latitude":51.6000517
    },
    "1647":{
      "name":"\u041a\u0443\u043a\u0430",
      "longitude":112.95372,
      "latitude":51.729156
    },
    "1648":{
      "name":"\u041d\u0430\u0440\u0430\u0441\u0443\u043d",
      "longitude":112.9764691,
      "latitude":50.089349
    },
    "1649":{
      "name":"\u0418\u0432\u0430\u043d-\u041e\u0437\u0435\u0440\u043e",
      "longitude":112.9885459,
      "latitude":52.2599151
    },
    "1650":{
      "name":"\u0414\u043e\u043c\u043d\u043e-\u041a\u043b\u044e\u0447\u0438",
      "longitude":112.9971221,
      "latitude":51.9620246
    },
    "1651":{
      "name":"\u041b\u0435\u0441\u043d\u0430\u044f",
      "longitude":113.0001041,
      "latitude":51.7667417
    },
    "1652":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e-\u041f\u0430\u0432\u043b\u043e\u0432\u0441\u043a",
      "longitude":113.0108817,
      "latitude":49.6807749
    },
    "1653":{
      "name":"\u0416\u0438\u043f\u043a\u043e\u0432\u0449\u0438\u043d\u0430",
      "longitude":113.0126093,
      "latitude":51.801984
    },
    "1654":{
      "name":"\u0413\u043e\u043b\u0443\u0431\u0438\u0447\u043d\u0430\u044f",
      "longitude":113.0423002,
      "latitude":51.6116419
    },
    "1655":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u041a\u0443\u043a\u0430",
      "longitude":113.059143,
      "latitude":51.788258
    },
    "1656":{
      "name":"\u0421\u0442\u0430\u0440\u0430\u044f \u041a\u0443\u043a\u0430",
      "longitude":113.0662433,
      "latitude":51.7601182
    },
    "1657":{
      "name":"\u041b\u0435\u0441\u043d\u043e\u0439 \u0413\u043e\u0440\u043e\u0434\u043e\u043a",
      "longitude":113.067932,
      "latitude":51.7332
    },
    "1658":{
      "name":"\u041b\u0435\u043d\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":113.078735,
      "latitude":51.130802
    },
    "1659":{
      "name":"\u0418\u043d\u0433\u043e\u0434\u0430",
      "longitude":113.1005414,
      "latitude":51.8516301
    },
    "1660":{
      "name":"\u0411\u044b\u0442\u044d\u0432",
      "longitude":113.1310072,
      "latitude":50.1524157
    },
    "1661":{
      "name":"\u041a\u043e\u043b\u043e\u0447\u043d\u043e\u0435 2-\u0435",
      "longitude":113.1380001,
      "latitude":51.9759085
    },
    "1662":{
      "name":"\u0422\u0443\u0440\u0433\u0435\u043d",
      "longitude":113.1393062,
      "latitude":49.7600017
    },
    "1663":{
      "name":"\u0414\u043e\u043c\u043d\u0430",
      "longitude":113.157509,
      "latitude":51.896191
    },
    "1664":{
      "name":"\u041a\u043e\u043b\u043e\u0447\u043d\u043e\u0435 1-\u0435",
      "longitude":113.1633578,
      "latitude":51.9622539
    },
    "1665":{
      "name":"\u0410\u043c\u043e\u0434\u043e\u0432\u043e",
      "longitude":113.2024554,
      "latitude":51.8753606
    },
    "1666":{
      "name":"\u0423\u0440\u0435\u0439\u0441\u043a",
      "longitude":113.221527,
      "latitude":50.298187
    },
    "1667":{
      "name":"\u0421\u0438\u0432\u044f\u043a\u043e\u0432\u043e",
      "longitude":113.2317888,
      "latitude":51.8946568
    },
    "1668":{
      "name":"\u0414\u0432\u043e\u0440\u0446\u044b",
      "longitude":113.256323,
      "latitude":52.0503956
    },
    "1669":{
      "name":"\u0420\u0443\u0434\u043d\u0438\u043a \u041a\u0430\u0434\u0430\u043b\u0430",
      "longitude":113.2677883,
      "latitude":52.0395354
    },
    "1670":{
      "name":"\u0412\u043e\u0441\u0442\u043e\u0447\u043d\u044b\u0439",
      "longitude":113.2706377,
      "latitude":51.9870516
    },
    "1671":{
      "name":"\u0423\u043b\u0430\u0447\u0430",
      "longitude":113.2740812,
      "latitude":50.4010227
    },
    "1672":{
      "name":"\u0410\u0440\u0430-\u0418\u043b\u044f",
      "longitude":113.2768426,
      "latitude":50.9407101
    },
    "1673":{
      "name":"\u0417\u0430\u0441\u0442\u0435\u043f\u044c",
      "longitude":113.2837917,
      "latitude":52.0973495
    },
    "1674":{
      "name":"\u0410\u043a\u0448\u0430",
      "longitude":113.285149,
      "latitude":50.280815
    },
    "1675":{
      "name":"\u0410\u044d\u0440\u043e\u043f\u043e\u0440\u0442",
      "longitude":113.3030049,
      "latitude":52.0192183
    },
    "1676":{
      "name":"\u041a\u0430\u0434\u0430\u043b\u0430",
      "longitude":113.332902,
      "latitude":52.0186843
    },
    "1677":{
      "name":"\u0415\u0440\u0451\u043c\u0438\u043d\u043e",
      "longitude":113.3365349,
      "latitude":51.9600304
    },
    "1678":{
      "name":"\u041a\u0430\u0434\u0430\u043b\u0430",
      "longitude":113.3459287,
      "latitude":52.0097742
    },
    "1679":{
      "name":"\u0422\u043e\u0445\u0442\u043e\u0440",
      "longitude":113.3532467,
      "latitude":50.0807623
    },
    "1680":{
      "name":"\u042d\u043d\u0435\u0440\u0433\u0435\u0442\u0438\u043a\u043e\u0432",
      "longitude":113.3534389,
      "latitude":52.0646848
    },
    "1681":{
      "name":"\u0422\u0435\u043a\u0441\u0442\u0438\u043b\u044c\u0449\u0438\u043a\u043e\u0432",
      "longitude":113.3885621,
      "latitude":52.070444
    },
    "1682":{
      "name":"\u041e\u043b\u0435\u043d\u0433\u0443\u0439",
      "longitude":113.412376,
      "latitude":51.30574
    },
    "1683":{
      "name":"\u0423\u0433\u0434\u0430\u043d",
      "longitude":113.4128899,
      "latitude":52.1058278
    },
    "1684":{
      "name":"\u0417\u0430\u0441\u043e\u043f\u043a\u0430",
      "longitude":113.41585,
      "latitude":52.0106333
    },
    "1685":{
      "name":"\u0412\u0435\u0440\u0445-\u041d\u0430\u0440\u044b\u043c",
      "longitude":113.4418618,
      "latitude":51.5824026
    },
    "1686":{
      "name":"\u0411\u0438\u043e\u0444\u0430\u0431\u0440\u0438\u043a\u0430",
      "longitude":113.4430672,
      "latitude":52.1221157
    },
    "1687":{
      "name":"\u0417\u0430\u0440\u0435\u0447\u043d\u044b\u0439",
      "longitude":113.447585,
      "latitude":52.1056119
    },
    "1688":{
      "name":"\u0421\u044b\u043f\u0447\u0435\u0433\u0443\u0440",
      "longitude":113.4492923,
      "latitude":51.353262
    },
    "1689":{
      "name":"\u0423\u0433\u0434\u0430\u043d",
      "longitude":113.4553691,
      "latitude":52.1561655
    },
    "1690":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u0443\u0440\u0433\u0430\u0442\u0430\u0439",
      "longitude":113.4569989,
      "latitude":50.3108561
    },
    "1691":{
      "name":"\u0410\u043b\u0445\u0430\u043d\u0430\u0439",
      "longitude":113.472755,
      "latitude":50.730034
    },
    "1692":{
      "name":"\u041a\u0430\u0448\u0442\u0430\u043a",
      "longitude":113.4853208,
      "latitude":52.0905951
    },
    "1693":{
      "name":"\u0411\u0435\u0440\u0435\u0433\u043e\u0432\u043e\u0439",
      "longitude":113.488892,
      "latitude":52.197083
    },
    "1694":{
      "name":"\u042f\u0441\u043d\u044b\u0439",
      "longitude":113.4938275,
      "latitude":52.1279608
    },
    "1695":{
      "name":"\u0412\u0435\u0440\u0445-\u0427\u0438\u0442\u0430",
      "longitude":113.50386,
      "latitude":52.227592
    },
    "1696":{
      "name":"\u0421\u043c\u043e\u043b\u0435\u043d\u043a\u0430",
      "longitude":113.519203,
      "latitude":52.140629
    },
    "1697":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u044f\u0440\u043e\u0432\u043e",
      "longitude":113.5318872,
      "latitude":50.9590673
    },
    "1698":{
      "name":"\u041a\u0430\u0440\u043f\u043e\u0432\u043a\u0430",
      "longitude":113.535004,
      "latitude":52.207947
    },
    "1699":{
      "name":"\u0428\u0438\u0448\u043a\u0438\u043d\u043e",
      "longitude":113.583679,
      "latitude":52.308483
    },
    "1700":{
      "name":"\u0414\u0443\u043b\u044c\u0434\u0443\u0440\u0433\u0430",
      "longitude":113.589348,
      "latitude":50.675007
    },
    "1701":{
      "name":"\u0411\u0430\u043b\u044c\u0437\u0438\u043d\u043e",
      "longitude":113.5935158,
      "latitude":51.0480485
    },
    "1702":{
      "name":"\u0418\u043b\u044f",
      "longitude":113.5948246,
      "latitude":50.8371246
    },
    "1703":{
      "name":"\u0417\u0430\u0431\u0430\u0439\u043a\u0430\u043b\u044c\u0441\u043a\u0438\u0439",
      "longitude":113.598137,
      "latitude":52.140156
    },
    "1704":{
      "name":"\u0415\u043b\u0438\u0437\u0430\u0432\u0435\u0442\u0438\u043d\u043e",
      "longitude":113.605797,
      "latitude":51.658268
    },
    "1705":{
      "name":"\u0423\u0437\u043e\u043d",
      "longitude":113.6067934,
      "latitude":50.5783646
    },
    "1706":{
      "name":"\u0423\u0431\u0443\u0440-\u0422\u043e\u0445\u0442\u043e\u0440",
      "longitude":113.6278874,
      "latitude":50.1075573
    },
    "1707":{
      "name":"\u041a\u0430\u043b\u0430\u043d\u0433\u0430",
      "longitude":113.667686,
      "latitude":51.1167452
    },
    "1708":{
      "name":"\u0423\u0441\u0442\u044c-\u0418\u043b\u044f",
      "longitude":113.715806,
      "latitude":50.3985636
    },
    "1709":{
      "name":"\u041e\u0440\u043e\u0439",
      "longitude":113.7430721,
      "latitude":50.1697204
    },
    "1710":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":113.7455332,
      "latitude":51.765561
    },
    "1711":{
      "name":"\u0411\u0443\u0440\u0433\u0435\u043d\u044c",
      "longitude":113.776291,
      "latitude":52.420975
    },
    "1712":{
      "name":"\u0422\u044b\u0440\u0433\u0435\u0442\u0443\u0439",
      "longitude":113.79258,
      "latitude":51.446392
    },
    "1713":{
      "name":"\u0422\u0430\u043f\u0442\u0430\u043d\u0430\u0439",
      "longitude":113.810265,
      "latitude":50.776756
    },
    "1714":{
      "name":"\u041c\u043e\u0433\u043e\u0439\u0442\u0443\u0439",
      "longitude":113.8458973,
      "latitude":50.3465246
    },
    "1715":{
      "name":"\u041d\u043e\u0432\u043e\u0434\u043e\u0440\u043e\u043d\u0438\u043d\u0441\u043a",
      "longitude":113.863693,
      "latitude":51.534649
    },
    "1716":{
      "name":"\u0428\u0430\u0440\u0430-\u0413\u043e\u0440\u043e\u0445\u043e\u043d",
      "longitude":113.879233,
      "latitude":51.4008853
    },
    "1717":{
      "name":"\u0427\u0438\u043d\u0434\u0430\u043b\u0435\u0439",
      "longitude":113.8978085,
      "latitude":50.5733238
    },
    "1718":{
      "name":"\u041c\u0430\u043a\u043a\u0430\u0432\u0435\u0435\u0432\u043e",
      "longitude":113.960785,
      "latitude":51.747688
    },
    "1719":{
      "name":"\u0422\u0430\u043d\u0445\u0430",
      "longitude":113.9695221,
      "latitude":51.993883
    },
    "1720":{
      "name":"\u0416\u0438\u043c\u0431\u0438\u0440\u0430",
      "longitude":114.013763,
      "latitude":51.517796
    },
    "1721":{
      "name":"\u041a\u0443\u0440\u0430\u043d\u0436\u0430",
      "longitude":114.038277,
      "latitude":50.444984
    },
    "1722":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u0422\u0443\u0440\u0430",
      "longitude":114.079239,
      "latitude":51.633308
    },
    "1723":{
      "name":"\u0425\u043e\u0439\u0442\u043e-\u0410\u0433\u0430",
      "longitude":114.085152,
      "latitude":51.094105
    },
    "1724":{
      "name":"\u041d\u043e\u0432\u043e\u0442\u0440\u043e\u0438\u0446\u043a",
      "longitude":114.089333,
      "latitude":51.992844
    },
    "1725":{
      "name":"\u0421\u043e\u043b\u043e\u043d\u0446\u043e\u0432\u043e",
      "longitude":114.0931811,
      "latitude":51.553308
    },
    "1726":{
      "name":"\u0422\u043e\u043a\u0447\u0438\u043d",
      "longitude":114.131912,
      "latitude":50.513649
    },
    "1727":{
      "name":"\u0422\u0443\u0442-\u0425\u0430\u043b\u0442\u0443\u0439",
      "longitude":114.1680564,
      "latitude":50.4595465
    },
    "1728":{
      "name":"\u0418\u043b\u044c\u0438\u043d\u043a\u0430",
      "longitude":114.1754956,
      "latitude":52.0661649
    },
    "1729":{
      "name":"\u0417\u0443\u0442\u043a\u0443\u043b\u0435\u0439",
      "longitude":114.187119,
      "latitude":50.661808
    },
    "1730":{
      "name":"\u0421\u0430\u0445\u044e\u0440\u0442\u0430",
      "longitude":114.2224831,
      "latitude":51.0264599
    },
    "1731":{
      "name":"\u041a\u0430\u0434\u0430\u0445\u0442\u0430",
      "longitude":114.250565,
      "latitude":51.610931
    },
    "1732":{
      "name":"\u042e\u0436\u043d\u044b\u0439 \u0410\u0440\u0433\u0430\u043b\u0435\u0439",
      "longitude":114.257805,
      "latitude":51.140713
    },
    "1733":{
      "name":"\u0423\u0440\u0434\u0430-\u0410\u0433\u0430",
      "longitude":114.2926926,
      "latitude":51.0085337
    },
    "1734":{
      "name":"\u0421\u0442\u0430\u0440\u044b\u0439 \u0414\u0443\u0440\u0443\u043b\u0433\u0443\u0439",
      "longitude":114.296715,
      "latitude":50.480053
    },
    "1735":{
      "name":"\u041c\u0430\u044f\u043a\u0438",
      "longitude":114.330475,
      "latitude":51.476059
    },
    "1736":{
      "name":"\u041e\u043b\u0435\u043d\u0442\u0443\u0439",
      "longitude":114.3560204,
      "latitude":51.4667997
    },
    "1737":{
      "name":"\u0427\u0435\u043b\u0443\u0442\u0430\u0439",
      "longitude":114.3697149,
      "latitude":51.2193425
    },
    "1738":{
      "name":"\u041f\u043e\u0434\u043b\u0435\u0441\u043d\u043e\u0435",
      "longitude":114.3852173,
      "latitude":51.7025017
    },
    "1739":{
      "name":"\u0410\u0442\u0430\u043c\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":114.4112539,
      "latitude":51.6636059
    },
    "1740":{
      "name":"\u041d\u043e\u0432\u044b\u0439 \u0414\u0443\u0440\u0443\u043b\u0433\u0443\u0439",
      "longitude":114.4113427,
      "latitude":50.3460112
    },
    "1741":{
      "name":"\u0421\u0443\u0434\u0443\u043d\u0442\u0443\u0439",
      "longitude":114.4670111,
      "latitude":50.7604364
    },
    "1742":{
      "name":"\u0410\u043c\u0438\u0442\u0445\u0430\u0448\u0430",
      "longitude":114.4696338,
      "latitude":51.0821034
    },
    "1743":{
      "name":"\u0410\u0434\u0440\u0438\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":114.519371,
      "latitude":51.566547
    },
    "1744":{
      "name":"\u0413\u0443\u043d\u044d\u0439",
      "longitude":114.5524836,
      "latitude":50.5198691
    },
    "1745":{
      "name":"\u041a\u0430\u0439\u0434\u0430\u043b\u043e\u0432\u043e",
      "longitude":114.574501,
      "latitude":51.635742
    },
    "1746":{
      "name":"\u0423\u0441\u0442\u044c-\u041b\u0438\u0441\u043a\u0430",
      "longitude":114.5872035,
      "latitude":50.4335503
    },
    "1747":{
      "name":"\u0426\u043e\u043a\u0442\u043e-\u0425\u0430\u043d\u0433\u0438\u043b",
      "longitude":114.6264399,
      "latitude":50.9041616
    },
    "1748":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0435\u0432\u0438\u043a",
      "longitude":114.6602953,
      "latitude":50.4896586
    },
    "1749":{
      "name":"\u0414\u043e\u0433\u043e\u0439",
      "longitude":114.661697,
      "latitude":51.355373
    },
    "1750":{
      "name":"\u041d\u043e\u0432\u043e\u043e\u0440\u043b\u043e\u0432\u0441\u043a",
      "longitude":114.729599,
      "latitude":51.066452
    },
    "1751":{
      "name":"\u041f\u043e\u0441\u0435\u043b\u044c\u0435",
      "longitude":114.746623,
      "latitude":51.7139062
    },
    "1752":{
      "name":"\u0410\u0433\u0430-\u0425\u0430\u043d\u0433\u0438\u043b",
      "longitude":114.750259,
      "latitude":51.185596
    },
    "1753":{
      "name":"\u0423\u0440\u0442\u0430-\u0425\u0430\u0440\u0433\u0430\u043d\u0430",
      "longitude":114.7582896,
      "latitude":50.3959519
    },
    "1754":{
      "name":"\u0423\u0440\u0443\u043b\u044c\u0433\u0430",
      "longitude":114.800743,
      "latitude":51.764462
    },
    "1755":{
      "name":"\u041a\u0443\u0431\u0443\u0445\u0430\u0439",
      "longitude":114.8087092,
      "latitude":50.4972404
    },
    "1756":{
      "name":"\u0423\u0448\u0430\u0440\u0431\u0430\u0439",
      "longitude":114.830505,
      "latitude":51.399696
    },
    "1757":{
      "name":"\u041e\u0440\u043b\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":114.8534215,
      "latitude":51.0382866
    },
    "1758":{
      "name":"\u041d\u0430\u0440\u044b\u043d-\u0422\u0430\u043b\u0430\u0447\u0430",
      "longitude":114.862022,
      "latitude":51.930378
    },
    "1759":{
      "name":"\u0411\u0443\u0439\u043b\u044d\u0441\u0430\u043d",
      "longitude":114.871094,
      "latitude":50.244946
    },
    "1760":{
      "name":"\u0411\u0443\u0434\u0443\u043b\u0430\u043d",
      "longitude":114.912468,
      "latitude":50.5563347
    },
    "1761":{
      "name":"\u0421\u0440\u0435\u0434\u043d\u044f\u044f \u0422\u0430\u043b\u0430\u0447\u0430",
      "longitude":114.9212919,
      "latitude":51.8432723
    },
    "1762":{
      "name":"\u0423\u0440\u043e\u043d\u0430\u0439",
      "longitude":114.9402735,
      "latitude":51.2133793
    },
    "1763":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u044f\u044f \u0422\u0430\u043b\u0430\u0447\u0430",
      "longitude":115.014473,
      "latitude":51.935135
    },
    "1764":{
      "name":"\u0417\u0443\u0433\u0430\u043b\u0430\u0439",
      "longitude":115.024513,
      "latitude":51.46933
    },
    "1765":{
      "name":"\u0425\u0430\u0440\u0433\u0430\u043d\u0430\u0448\u0430",
      "longitude":115.0473044,
      "latitude":51.2629272
    },
    "1766":{
      "name":"\u0426\u0430\u0433\u0430\u043d-\u0427\u0435\u043b\u0443\u0442\u0430\u0439",
      "longitude":115.084145,
      "latitude":51.069057
    },
    "1767":{
      "name":"\u0421\u0430\u0432\u0432\u0438\u043d\u043e",
      "longitude":115.0853859,
      "latitude":51.7662138
    },
    "1768":{
      "name":"\u0411\u0430\u0439\u043d-\u0426\u0430\u0433\u0430\u043d",
      "longitude":115.0867368,
      "latitude":50.3104118
    },
    "1769":{
      "name":"\u0410\u0440\u0430-\u0411\u0443\u043b\u0430\u043a",
      "longitude":115.0874095,
      "latitude":51.1990015
    },
    "1770":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u0426\u0430\u0441\u0443\u0447\u0435\u0439",
      "longitude":115.090736,
      "latitude":50.510666
    },
    "1771":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0439 \u0426\u0430\u0441\u0443\u0447\u0435\u0439",
      "longitude":115.118385,
      "latitude":50.510593
    },
    "1772":{
      "name":"\u0411\u0438\u043b\u044c\u0447\u0438\u0440\u0442\u0443\u0439",
      "longitude":115.1562529,
      "latitude":51.0639633
    },
    "1773":{
      "name":"\u041a\u0443\u043d\u043a\u0443\u0440",
      "longitude":115.1693344,
      "latitude":50.5795662
    },
    "1774":{
      "name":"\u0410\u0433\u0430",
      "longitude":115.179909,
      "latitude":51.185352
    },
    "1775":{
      "name":"\u0413\u0430\u043b\u043a\u0438\u043d\u043e",
      "longitude":115.1863183,
      "latitude":51.7764469
    },
    "1776":{
      "name":"\u0412\u0435\u0440\u0445-\u0423\u0441\u0443\u0433\u043b\u0438",
      "longitude":115.188309,
      "latitude":52.690086
    },
    "1777":{
      "name":"\u0425\u0430\u0440\u0430-\u0428\u0438\u0431\u0438\u0440\u044c",
      "longitude":115.191803,
      "latitude":51.534863
    },
    "1778":{
      "name":"\u0423\u0441\u0443\u0433\u043b\u0438",
      "longitude":115.264076,
      "latitude":52.649963
    },
    "1779":{
      "name":"\u0418\u043a\u0430\u0440\u0430\u043b",
      "longitude":115.2921229,
      "latitude":50.5341091
    },
    "1780":{
      "name":"\u0411\u0435\u0440\u0435\u044f",
      "longitude":115.3115079,
      "latitude":51.617448
    },
    "1781":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u0430\u044f \u0418\u043c\u0430\u043b\u043a\u0430",
      "longitude":115.3127028,
      "latitude":50.2619281
    },
    "1782":{
      "name":"\u0411\u0430\u0439\u0446\u0435\u0442\u0443\u0439",
      "longitude":115.3222356,
      "latitude":51.897846
    },
    "1783":{
      "name":"\u0423\u0441\u0442\u044c-\u0418\u043c\u0430\u043b\u043a\u0430",
      "longitude":115.3393698,
      "latitude":50.0957006
    },
    "1784":{
      "name":"\u0423\u043b\u0430\u043d-\u0421\u0430\u0440\u0442\u0430",
      "longitude":115.3916849,
      "latitude":51.3146021
    },
    "1785":{
      "name":"\u0421\u0442\u0435\u043f\u044c",
      "longitude":115.402542,
      "latitude":51.008972
    },
    "1786":{
      "name":"\u0427\u0438\u043d\u0434\u0430\u043d\u0442 1-\u0439",
      "longitude":115.4119623,
      "latitude":50.576072
    },
    "1787":{
      "name":"\u0426\u0430\u0433\u0430\u043d-\u041e\u043b\u0430",
      "longitude":115.481148,
      "latitude":51.360119
    },
    "1788":{
      "name":"\u0420\u0430\u0437\u043c\u0430\u0445\u043d\u0438\u043d\u043e",
      "longitude":115.486786,
      "latitude":51.777271
    },
    "1789":{
      "name":"\u041d\u043e\u043c\u043e\u043a\u043e\u043d\u043e\u0432\u043e",
      "longitude":115.4963003,
      "latitude":51.6374348
    },
    "1790":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u0417\u0430\u0440\u044f",
      "longitude":115.5607564,
      "latitude":50.3614692
    },
    "1791":{
      "name":"\u0421\u0442\u0430\u0440\u044b\u0439 \u0427\u0438\u043d\u0434\u0430\u043d\u0442",
      "longitude":115.5626367,
      "latitude":50.5588116
    },
    "1792":{
      "name":"\u0428\u0438\u0432\u0430\u043d\u0434\u0430",
      "longitude":115.5661637,
      "latitude":51.7206911
    },
    "1793":{
      "name":"\u041e\u043d\u043e\u043d\u0441\u043a",
      "longitude":115.5707034,
      "latitude":50.9856973
    },
    "1794":{
      "name":"\u041e\u043b\u043e\u0432\u043e\u0440\u0443\u0434\u043d\u0438\u043a",
      "longitude":115.5871938,
      "latitude":50.9674469
    },
    "1795":{
      "name":"\u0423\u0441\u0442\u044c-\u041d\u0430\u0440\u0438\u043d",
      "longitude":115.615166,
      "latitude":51.405544
    },
    "1796":{
      "name":"\u041a\u0443\u043b\u0438\u043d\u0434\u0430",
      "longitude":115.6161042,
      "latitude":50.9567816
    },
    "1797":{
      "name":"\u0426\u0443\u0433\u043e\u043b",
      "longitude":115.624397,
      "latitude":51.046543
    },
    "1798":{
      "name":"\u0422\u0443\u043d\u0433\u043e\u043a\u043e\u0447\u0435\u043d",
      "longitude":115.6279401,
      "latitude":53.5352035
    },
    "1799":{
      "name":"\u041e\u0440\u0442\u0443\u0439",
      "longitude":115.635109,
      "latitude":50.816471
    },
    "1800":{
      "name":"\u041a\u0443\u0441\u043e\u0447\u0430",
      "longitude":115.63826,
      "latitude":50.703457
    },
    "1801":{
      "name":"\u0421\u0440\u0435\u0434\u043d\u044f\u044f \u041a\u0438\u044f",
      "longitude":115.6411525,
      "latitude":51.9938806
    },
    "1802":{
      "name":"\u041d\u0443\u0440\u0438\u043d\u0441\u043a",
      "longitude":115.663399,
      "latitude":51.083088
    },
    "1803":{
      "name":"\u0423\u0441\u0442\u044c-\u0411\u043e\u0440\u0437\u044f",
      "longitude":115.6743355,
      "latitude":50.6052552
    },
    "1804":{
      "name":"\u0421\u043e\u043b\u043d\u0446\u0435\u0432\u043e",
      "longitude":115.6749442,
      "latitude":51.7535097
    },
    "1805":{
      "name":"\u041a\u0443\u043b\u0443\u0441\u0443\u0442\u0430\u0439",
      "longitude":115.6830319,
      "latitude":50.2342453
    },
    "1806":{
      "name":"\u0421\u043e\u043b\u043e\u0432\u044c\u0451\u0432\u0441\u043a",
      "longitude":115.701576,
      "latitude":49.896633
    },
    "1807":{
      "name":"\u041d\u0435\u043b\u044f\u0442\u044b",
      "longitude":115.702751,
      "latitude":56.49205
    },
    "1808":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0439 \u0421\u0442\u0430\u043d",
      "longitude":115.7121232,
      "latitude":52.2911685
    },
    "1809":{
      "name":"\u041c\u0430\u043b\u044b\u0439 \u0421\u043e\u043b\u043e\u0432\u044c\u0451\u0432\u0441\u043a",
      "longitude":115.7557906,
      "latitude":49.8968236
    },
    "1810":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u0428\u0430\u0440\u0430\u043d\u0430\u0439",
      "longitude":115.7663745,
      "latitude":51.0791656
    },
    "1811":{
      "name":"\u0425\u043e\u043b\u0443\u0439-\u0411\u0430\u0437\u0430",
      "longitude":115.7684732,
      "latitude":50.4904983
    },
    "1812":{
      "name":"\u0423\u0441\u0442\u044c-\u041d\u043e\u0436\u043e\u0432\u0430\u044f",
      "longitude":115.7725355,
      "latitude":51.4687312
    },
    "1813":{
      "name":"\u0427\u0438\u0440\u043e\u043d",
      "longitude":115.777247,
      "latitude":51.6252291
    },
    "1814":{
      "name":"\u0411\u043e\u0433\u043e\u043c\u044f\u0433\u043a\u043e\u0432\u043e",
      "longitude":115.7894684,
      "latitude":51.9925647
    },
    "1815":{
      "name":"\u0423\u043b\u044c\u044f\u043d\u043e\u0432\u043a\u0430",
      "longitude":115.791364,
      "latitude":52.0605525
    },
    "1816":{
      "name":"\u042f\u0441\u043d\u0430\u044f",
      "longitude":115.802956,
      "latitude":50.830166
    },
    "1817":{
      "name":"\u0421\u0440\u0435\u0434\u043d\u0438\u0439 \u0428\u0430\u0440\u0430\u043d\u0430\u0439",
      "longitude":115.8233769,
      "latitude":51.0907751
    },
    "1818":{
      "name":"\u041a\u044b\u043a\u0435\u0440",
      "longitude":115.8244362,
      "latitude":53.1674604
    },
    "1819":{
      "name":"\u0411\u0443\u0442\u0438\u0445\u0430",
      "longitude":115.8282074,
      "latitude":52.3266982
    },
    "1820":{
      "name":"\u041a\u0438\u0440\u043e\u0447\u0430",
      "longitude":115.8331668,
      "latitude":51.59576
    },
    "1821":{
      "name":"\u0423\u0441\u0442\u044c-\u0410\u0433\u0430",
      "longitude":115.837768,
      "latitude":51.5364398
    },
    "1822":{
      "name":"\u0411\u043e\u0440\u0436\u0438\u0433\u0430\u043d\u0442\u0430\u0439",
      "longitude":115.848457,
      "latitude":51.211895
    },
    "1823":{
      "name":"\u0421\u0443\u0445\u0430\u0439\u0442\u0443\u0439",
      "longitude":115.859067,
      "latitude":52.2537179
    },
    "1824":{
      "name":"\u041a\u0430\u0437\u0430\u043d\u043e\u0432\u043e",
      "longitude":115.87035,
      "latitude":51.7722661
    },
    "1825":{
      "name":"\u0415\u0434\u0438\u043d\u0435\u043d\u0438\u0435",
      "longitude":115.8858847,
      "latitude":51.1716708
    },
    "1826":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u044f\u044f \u0425\u0438\u043b\u0430",
      "longitude":115.889604,
      "latitude":52.089388
    },
    "1827":{
      "name":"\u0425\u0430\u0440\u0430-\u0411\u044b\u0440\u043a\u0430",
      "longitude":115.9205916,
      "latitude":50.9534777
    },
    "1828":{
      "name":"\u0417\u043e\u043b\u043e\u0442\u0443\u0445\u0438\u043d\u043e",
      "longitude":115.9262561,
      "latitude":52.1374617
    },
    "1829":{
      "name":"\u0412\u0430\u0441\u0438\u043b\u044c\u0435\u0432\u043a\u0430",
      "longitude":115.9396394,
      "latitude":52.0289537
    },
    "1830":{
      "name":"\u041c\u0438\u0442\u0440\u043e\u0444\u0430\u043d\u043e\u0432\u043e",
      "longitude":115.950718,
      "latitude":51.8198145
    },
    "1831":{
      "name":"\u0411\u044b\u0440\u043a\u0430",
      "longitude":115.95195,
      "latitude":50.741375
    },
    "1832":{
      "name":"\u041e\u043d\u043e\u043d\u0441\u043a\u043e\u0435",
      "longitude":115.9540582,
      "latitude":51.477927
    },
    "1833":{
      "name":"\u041a\u0430\u0440\u0430\u043a\u0441\u0430\u0440",
      "longitude":115.9560541,
      "latitude":51.2643136
    },
    "1834":{
      "name":"\u041b\u0430\u0445\u0430",
      "longitude":115.9567239,
      "latitude":50.4904399
    },
    "1835":{
      "name":"\u0423\u0441\u0442\u044c-\u0422\u0435\u043b\u0435\u043d\u0433\u0443\u0439",
      "longitude":115.9644093,
      "latitude":51.54726
    },
    "1836":{
      "name":"\u0423\u0440\u0442\u0443\u0439\u0441\u043a\u0438\u0439",
      "longitude":115.9681577,
      "latitude":50.7280634
    },
    "1837":{
      "name":"\u041d\u043e\u0432\u043e\u0435",
      "longitude":115.9786,
      "latitude":51.341755
    },
    "1838":{
      "name":"\u041e\u0441\u0442\u0440\u043e\u0432\u043a\u0438",
      "longitude":115.9798412,
      "latitude":52.0751155
    },
    "1839":{
      "name":"\u041c\u0430\u043a\u0430\u0440\u043e\u0432\u043e",
      "longitude":116.012627,
      "latitude":51.490631
    },
    "1840":{
      "name":"\u0414\u0436\u0438\u0434\u0430",
      "longitude":116.0436032,
      "latitude":51.4491212
    },
    "1841":{
      "name":"\u041c\u0438\u0440\u043d\u0430\u044f",
      "longitude":116.044701,
      "latitude":50.756752
    },
    "1842":{
      "name":"\u0418\u043b\u0438\u043c",
      "longitude":116.0576079,
      "latitude":52.2111545
    },
    "1843":{
      "name":"\u0417\u0430\u0440\u044f",
      "longitude":116.0583487,
      "latitude":51.148688
    },
    "1844":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u0422\u0435\u043b\u0435\u043d\u0433\u0443\u0439",
      "longitude":116.0618665,
      "latitude":51.6398231
    },
    "1845":{
      "name":"\u041e\u043b\u0435\u043a\u0430\u043d",
      "longitude":116.0663964,
      "latitude":52.3666874
    },
    "1846":{
      "name":"\u041a\u0438\u0431\u0430\u0441\u043e\u0432\u043e",
      "longitude":116.075722,
      "latitude":51.864914
    },
    "1847":{
      "name":"\u041a\u0443\u0430\u043d\u0434\u0430",
      "longitude":116.0826644,
      "latitude":56.3256949
    },
    "1848":{
      "name":"\u041d\u043e\u0432\u043e\u0431\u0435\u0440\u0451\u0437\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":116.099998,
      "latitude":52.116669
    },
    "1849":{
      "name":"\u0422\u0430\u0441\u044b\u0440\u0445\u043e\u0439",
      "longitude":116.107139,
      "latitude":50.4079652
    },
    "1850":{
      "name":"\u041d\u0438\u0436\u043d\u044f\u044f \u0425\u0438\u043b\u0430",
      "longitude":116.1502925,
      "latitude":52.0576593
    },
    "1851":{
      "name":"\u041c\u0438\u0440\u0441\u0430\u043d\u043e\u0432\u043e",
      "longitude":116.162361,
      "latitude":51.889057
    },
    "1852":{
      "name":"\u0411\u0435\u0437\u0440\u0435\u0447\u043d\u0430\u044f",
      "longitude":116.176285,
      "latitude":50.731003
    },
    "1853":{
      "name":"\u041a\u0440\u0443\u043f\u044f\u043d\u043a\u0430",
      "longitude":116.1775003,
      "latitude":52.4754054
    },
    "1854":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u041b\u0443\u0433",
      "longitude":116.2042725,
      "latitude":52.4213714
    },
    "1855":{
      "name":"\u0417\u044e\u043b\u044c\u0437\u044f",
      "longitude":116.204521,
      "latitude":52.534538
    },
    "1856":{
      "name":"\u041f\u043e\u0431\u0435\u0434\u0430",
      "longitude":116.2095562,
      "latitude":51.0628819
    },
    "1857":{
      "name":"\u041e\u043b\u0438\u043d\u0441\u043a",
      "longitude":116.2160761,
      "latitude":52.3946197
    },
    "1858":{
      "name":"\u0423\u043b\u0430\u043d-\u0426\u0430\u0446\u044b\u043a",
      "longitude":116.2227462,
      "latitude":50.8612763
    },
    "1859":{
      "name":"\u0423\u043d\u0434\u0438\u043d\u043e-\u041f\u043e\u0441\u0435\u043b\u044c\u0435",
      "longitude":116.238205,
      "latitude":51.421551
    },
    "1860":{
      "name":"\u0410\u0440\u0435\u043d\u0434\u0430",
      "longitude":116.2383908,
      "latitude":51.2855426
    },
    "1861":{
      "name":"\u0423\u043b\u044f\u0442\u0443\u0439",
      "longitude":116.241806,
      "latitude":51.168884
    },
    "1862":{
      "name":"\u0428\u0438\u0432\u0438\u044f",
      "longitude":116.2579792,
      "latitude":51.3317631
    },
    "1863":{
      "name":"\u041f\u0440\u0438\u043e\u0437\u0451\u0440\u043d\u043e\u0435",
      "longitude":116.2737783,
      "latitude":50.4856233
    },
    "1864":{
      "name":"\u0411\u0435\u043b\u043e\u043c\u0435\u0441\u0442\u043d\u043e\u0432\u043e",
      "longitude":116.2779702,
      "latitude":52.1684517
    },
    "1865":{
      "name":"\u0410\u0440\u0431\u0430\u0433\u0430\u0440",
      "longitude":116.280457,
      "latitude":51.943813
    },
    "1866":{
      "name":"\u0410\u043f\u0440\u0435\u043b\u043a\u043e\u0432\u043e",
      "longitude":116.281807,
      "latitude":51.877331
    },
    "1867":{
      "name":"\u0417\u044e\u043b\u044c\u0437\u0438\u043a\u0430\u043d",
      "longitude":116.2840923,
      "latitude":52.6726325
    },
    "1868":{
      "name":"\u0417\u043d\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":116.2927282,
      "latitude":52.1797462
    },
    "1869":{
      "name":"\u0425\u0430\u0434\u0430-\u0411\u0443\u043b\u0430\u043a",
      "longitude":116.302849,
      "latitude":50.646523
    },
    "1870":{
      "name":"\u0410\u043d\u0434\u0440\u043e\u043d\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":116.3127576,
      "latitude":51.725675
    },
    "1871":{
      "name":"\u0411\u0443\u0440\u0443\u043b\u044f\u0442\u0443\u0439",
      "longitude":116.3210044,
      "latitude":51.0870904
    },
    "1872":{
      "name":"\u041a\u0430\u043d\u0433\u0438\u043b",
      "longitude":116.329071,
      "latitude":52.2452824
    },
    "1873":{
      "name":"\u041c\u0430\u0442\u0443\u0441\u043e\u0432\u043e",
      "longitude":116.3535187,
      "latitude":51.4727754
    },
    "1874":{
      "name":"\u041f\u0440\u0430\u0432\u044b\u0435 \u041a\u0443\u043c\u0430\u043a\u0438",
      "longitude":116.3576464,
      "latitude":52.0749548
    },
    "1875":{
      "name":"\u041a\u043e\u043c\u043a\u0430\u0439",
      "longitude":116.3592289,
      "latitude":51.1900481
    },
    "1876":{
      "name":"\u041a\u043e\u0442\u0435\u043b\u044c\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":116.3605474,
      "latitude":51.7432713
    },
    "1877":{
      "name":"\u041b\u0435\u0432\u044b\u0435 \u041a\u0443\u043c\u0430\u043a\u0438",
      "longitude":116.3749622,
      "latitude":52.0579972
    },
    "1878":{
      "name":"\u0427\u0438\u043d\u0434\u0430\u043d\u0442 2-\u0439",
      "longitude":116.3773817,
      "latitude":50.3758726
    },
    "1879":{
      "name":"\u0421\u0430\u0440\u0431\u0430\u043a\u0442\u0443\u0439",
      "longitude":116.3795154,
      "latitude":51.4568473
    },
    "1880":{
      "name":"\u0421\u0435\u043d\u043d\u0430\u044f",
      "longitude":116.3871813,
      "latitude":52.0445405
    },
    "1881":{
      "name":"\u041a\u0443\u043b\u0430\u043a\u043e\u0432\u043e",
      "longitude":116.3992393,
      "latitude":51.7769233
    },
    "1882":{
      "name":"\u0414\u043e\u043b\u0433\u043e\u043a\u044b\u0447\u0430",
      "longitude":116.4182276,
      "latitude":51.0702562
    },
    "1883":{
      "name":"\u041d\u043e\u0432\u043e\u0438\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":116.4187477,
      "latitude":51.4925298
    },
    "1884":{
      "name":"\u041a\u043b\u044e\u0447\u0435\u0432\u0430\u044f",
      "longitude":116.4289073,
      "latitude":51.0293481
    },
    "1885":{
      "name":"\u0411\u0438\u0448\u0438\u0433\u0438\u043d\u043e",
      "longitude":116.4398555,
      "latitude":51.8530073
    },
    "1886":{
      "name":"\u041f\u0435\u0448\u043a\u043e\u0432\u043e",
      "longitude":116.4486532,
      "latitude":51.8245628
    },
    "1887":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u043e",
      "longitude":116.4499888,
      "latitude":52.1574208
    },
    "1888":{
      "name":"\u041f\u0440\u0430\u0432\u043e-\u041f\u0435\u0448\u043a\u043e\u0432\u043e",
      "longitude":116.4737591,
      "latitude":51.8189383
    },
    "1889":{
      "name":"\u043a\u0432\u0430\u0440\u0442\u0430\u043b \u0411\u043e\u0440\u0437\u044f-2",
      "longitude":116.4751212,
      "latitude":50.3770112
    },
    "1890":{
      "name":"\u041c\u0430\u043a\u0435\u0435\u0432\u043a\u0430",
      "longitude":116.5040535,
      "latitude":51.9908529
    },
    "1891":{
      "name":"\u0421\u0430\u0432\u0432\u0430\u0442\u0435\u0435\u0432\u043e",
      "longitude":116.5061952,
      "latitude":51.8673353
    },
    "1892":{
      "name":"\u0417\u0430\u0440\u0435\u0447\u043d\u044b\u0439",
      "longitude":116.510123,
      "latitude":52.0324098
    },
    "1893":{
      "name":"\u0411\u0430\u0440\u0430\u043d\u043e\u0432\u0441\u043a",
      "longitude":116.5137855,
      "latitude":51.4864601
    },
    "1894":{
      "name":"\u041d\u043e\u0432\u044b\u0439 \u041e\u043b\u043e\u0432",
      "longitude":116.5203011,
      "latitude":52.6078429
    },
    "1895":{
      "name":"\u041a\u0430\u043b\u0430\u043d\u0433\u0443\u0439",
      "longitude":116.520874,
      "latitude":51.010525
    },
    "1896":{
      "name":"\u0423\u0441\u0442\u044c-\u041a\u0430\u0440\u0435\u043d\u0433\u0430",
      "longitude":116.522041,
      "latitude":54.44278
    },
    "1897":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u0423\u043c\u044b\u043a\u044d\u0439",
      "longitude":116.5445076,
      "latitude":52.1382447
    },
    "1898":{
      "name":"\u0411\u0443\u043b\u0443\u043c",
      "longitude":116.5508672,
      "latitude":50.8642565
    },
    "1899":{
      "name":"\u0425\u0430\u0434\u0430-\u0411\u0443\u043b\u0430\u043a",
      "longitude":116.5561848,
      "latitude":50.6104309
    },
    "1900":{
      "name":"\u041a\u0430\u0434\u0430\u044f",
      "longitude":116.5617573,
      "latitude":52.5518253
    },
    "1901":{
      "name":"\u041d\u0430\u0433\u043e\u0440\u043d\u044b\u0439",
      "longitude":116.5629382,
      "latitude":52.0182476
    },
    "1902":{
      "name":"\u042e\u0436\u043d\u043e\u0435",
      "longitude":116.5745565,
      "latitude":50.2510324
    },
    "1903":{
      "name":"\u041d\u043e\u0432\u043e\u0431\u043e\u0440\u0437\u0438\u043d\u0441\u043a\u043e\u0435",
      "longitude":116.5751785,
      "latitude":50.3004022
    },
    "1904":{
      "name":"\u0410\u043d\u0442\u0438\u044f",
      "longitude":116.5774426,
      "latitude":50.9516108
    },
    "1905":{
      "name":"\u0421\u043e\u043a\u0442\u0443\u0439",
      "longitude":116.5910544,
      "latitude":50.2518838
    },
    "1906":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0439 \u041a\u043e\u043a\u0443\u0439",
      "longitude":116.6202512,
      "latitude":51.5447101
    },
    "1907":{
      "name":"\u0422\u0443\u0440\u0433\u0430",
      "longitude":116.6257923,
      "latitude":51.0515383
    },
    "1908":{
      "name":"\u0411\u043e\u0440\u043e\u0434\u0438\u043d\u0441\u043a",
      "longitude":116.6282635,
      "latitude":52.9081268
    },
    "1909":{
      "name":"\u041a\u0430\u043b\u0438\u043d\u0438\u043d\u043e",
      "longitude":116.65815,
      "latitude":51.899109
    },
    "1910":{
      "name":"\u0421\u0442\u0430\u0440\u044b\u0439 \u041e\u043b\u043e\u0432",
      "longitude":116.6644108,
      "latitude":52.4578921
    },
    "1911":{
      "name":"\u0425\u0430\u0440\u0430\u043d\u043e\u0440",
      "longitude":116.678108,
      "latitude":50.116627
    },
    "1912":{
      "name":"\u041b\u0435\u0441\u043e\u0443\u0447\u0430\u0441\u0442\u043e\u043a \u0421\u0430\u0440\u0430\u043d\u043d\u0430\u044f",
      "longitude":116.6799123,
      "latitude":51.4349484
    },
    "1913":{
      "name":"\u041a\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":116.6885367,
      "latitude":51.5950828
    },
    "1914":{
      "name":"\u0423\u0440\u0433\u0443\u0447\u0430\u043d",
      "longitude":116.6923562,
      "latitude":51.7576292
    },
    "1915":{
      "name":"\u0428\u0438\u0432\u043a\u0438",
      "longitude":116.7032684,
      "latitude":51.9188951
    },
    "1916":{
      "name":"\u0423\u0441\u0442\u044c-\u0413\u043e\u0440\u0431\u0438\u0446\u0430",
      "longitude":116.7301957,
      "latitude":52.818651
    },
    "1917":{
      "name":"\u0410\u043b\u0435\u0443\u0440",
      "longitude":116.7320868,
      "latitude":52.0849742
    },
    "1918":{
      "name":"\u041b\u043e\u0436\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":116.7324391,
      "latitude":51.6155262
    },
    "1919":{
      "name":"\u0417\u043e\u043b\u043e\u0442\u043e\u0440\u0435\u0447\u0435\u043d\u0441\u043a",
      "longitude":116.744385,
      "latitude":51.055717
    },
    "1920":{
      "name":"\u0411\u0443\u0442\u043e\u0440\u0438\u043d\u043e",
      "longitude":116.7457221,
      "latitude":51.6265566
    },
    "1921":{
      "name":"\u0411\u0430\u0439\u0433\u0443\u043b",
      "longitude":116.7500792,
      "latitude":52.246717
    },
    "1922":{
      "name":"\u041d\u043e\u0432\u043e\u0438\u043b\u044c\u0438\u043d\u0441\u043a",
      "longitude":116.7593395,
      "latitude":52.5129797
    },
    "1923":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0435 \u041a\u043b\u044e\u0447\u0438",
      "longitude":116.7647652,
      "latitude":51.9627312
    },
    "1924":{
      "name":"\u041f\u043e\u0434\u043e\u0439\u043d\u0438\u0446\u044b\u043d\u043e",
      "longitude":116.7920807,
      "latitude":51.6508304
    },
    "1925":{
      "name":"\u041f\u0435\u0440\u0435\u0434\u043d\u044f\u044f \u0411\u044b\u0440\u043a\u0430",
      "longitude":116.7947676,
      "latitude":50.7284826
    },
    "1926":{
      "name":"\u0411\u0430\u0433\u0443\u043b\u044c\u043d\u044b\u0439",
      "longitude":116.8016541,
      "latitude":52.4066602
    },
    "1927":{
      "name":"\u041e\u043d\u043e\u0445\u043e\u0432\u043e",
      "longitude":116.8138944,
      "latitude":51.6326074
    },
    "1928":{
      "name":"\u0411\u0443\u0445\u0442\u0430",
      "longitude":116.8169544,
      "latitude":52.9246271
    },
    "1929":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0435 \u041a\u043b\u044e\u0447\u0438",
      "longitude":116.8178917,
      "latitude":51.9928284
    },
    "1930":{
      "name":"\u0411\u043e\u0447\u043a\u0430\u0440\u0451\u0432\u043e",
      "longitude":116.8366351,
      "latitude":51.669312
    },
    "1931":{
      "name":"\u0414\u0430\u0443\u0440\u0438\u044f",
      "longitude":116.8470203,
      "latitude":49.926261
    },
    "1932":{
      "name":"\u041a\u043b\u044e\u0447\u0435\u0432\u0441\u043a\u043e\u0435",
      "longitude":116.850632,
      "latitude":50.375137
    },
    "1933":{
      "name":"\u041a\u043e\u043c\u0441\u043e\u043c\u043e\u043b\u044c\u0441\u043a\u043e\u0435",
      "longitude":116.863316,
      "latitude":52.3511551
    },
    "1934":{
      "name":"\u0410\u0440\u0435\u0434\u0430",
      "longitude":116.8633563,
      "latitude":52.3275766
    },
    "1935":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u041a\u043e\u043a\u0443\u0439",
      "longitude":116.8638003,
      "latitude":51.6558382
    },
    "1936":{
      "name":"\u0401\u043b\u043a\u0438\u043d\u043e",
      "longitude":116.8830494,
      "latitude":51.6930223
    },
    "1937":{
      "name":"\u041a\u0443\u043c\u0430\u043a\u0430\u043d\u0434\u0430",
      "longitude":116.8981216,
      "latitude":52.7104435
    },
    "1938":{
      "name":"\u0423\u043d\u0434\u0430",
      "longitude":116.9125751,
      "latitude":51.7099381
    },
    "1939":{
      "name":"\u0411\u0438\u043b\u0438\u043a\u0442\u0443\u0439",
      "longitude":116.9159476,
      "latitude":50.7225033
    },
    "1940":{
      "name":"\u041c\u0438\u043b\u044c\u0433\u0438\u0434\u0443\u043d",
      "longitude":116.919785,
      "latitude":52.661884
    },
    "1941":{
      "name":"\u041b\u0435\u0441\u043a\u043e\u0432\u043e",
      "longitude":116.9303235,
      "latitude":51.7496759
    },
    "1942":{
      "name":"\u041d\u0438\u0436\u043d\u0435\u0435 \u0413\u0438\u0440\u044e\u043d\u0438\u043d\u043e",
      "longitude":116.9793311,
      "latitude":51.1960613
    },
    "1943":{
      "name":"\u0423\u0442\u0430\u043d",
      "longitude":116.985054,
      "latitude":52.574669
    },
    "1944":{
      "name":"\u0416\u0435\u0442\u043a\u043e\u0432\u043e",
      "longitude":117.0057761,
      "latitude":51.3061353
    },
    "1945":{
      "name":"\u0429\u0435\u0431\u0451\u043d\u043e\u0447\u043d\u044b\u0439 \u0417\u0430\u0432\u043e\u0434",
      "longitude":117.0078438,
      "latitude":52.2427866
    },
    "1946":{
      "name":"\u0423\u043a\u0443\u0440\u0435\u0439",
      "longitude":117.0173119,
      "latitude":52.3475462
    },
    "1947":{
      "name":"\u041d\u0438\u0436\u043d\u044f\u044f \u041a\u0443\u044d\u043d\u0433\u0430",
      "longitude":117.0219254,
      "latitude":52.0901271
    },
    "1948":{
      "name":"\u041a\u0430\u0437\u0430\u043a\u043e\u0432\u0441\u043a\u0438\u0439 \u041f\u0440\u043e\u043c\u044b\u0441\u0435\u043b",
      "longitude":117.022308,
      "latitude":51.769009
    },
    "1949":{
      "name":"\u0413\u0430\u0443\u0440",
      "longitude":117.023781,
      "latitude":52.446098
    },
    "1950":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0435 \u041a\u0430\u0437\u0430\u043a\u043e\u0432\u043e",
      "longitude":117.0284853,
      "latitude":51.7430829
    },
    "1951":{
      "name":"\u041b\u043e\u0436\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":117.0425162,
      "latitude":51.3677254
    },
    "1952":{
      "name":"\u0428\u0438\u0432\u0438\u044f-\u041d\u0430\u0434\u0435\u043b\u044f\u0435\u0432\u043e",
      "longitude":117.0469444,
      "latitude":52.2969575
    },
    "1953":{
      "name":"\u0414\u0443\u043d\u0430\u0435\u0432\u043e",
      "longitude":117.0499787,
      "latitude":52.0674978
    },
    "1954":{
      "name":"\u0410\u043b\u0435\u0443\u0440",
      "longitude":117.056239,
      "latitude":52.5547715
    },
    "1955":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u044f\u044f \u041a\u0443\u044d\u043d\u0433\u0430",
      "longitude":117.05881,
      "latitude":52.1338274
    },
    "1956":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u0412\u0435\u043b\u0438\u043a\u0430\u043d",
      "longitude":117.0613724,
      "latitude":50.0765751
    },
    "1957":{
      "name":"\u0410\u0440\u0430\u0431\u0430\u0442\u0443\u043a",
      "longitude":117.0706473,
      "latitude":50.1582504
    },
    "1958":{
      "name":"\u0423\u0441\u0442\u044c-\u041e\u0437\u0451\u0440\u043d\u0430\u044f",
      "longitude":117.0912443,
      "latitude":50.7034194
    },
    "1959":{
      "name":"\u0411\u0438\u043b\u0438\u0442\u0443\u0439",
      "longitude":117.0998597,
      "latitude":49.8270983
    },
    "1960":{
      "name":"\u0413\u0440\u043e\u0431\u043e\u0432\u043e",
      "longitude":117.1204887,
      "latitude":51.6507622
    },
    "1961":{
      "name":"\u041a\u0443\u0440\u0443\u043d\u0437\u0443\u043b\u0430\u0439",
      "longitude":117.121254,
      "latitude":50.93829
    },
    "1962":{
      "name":"\u0410\u043b\u0438\u044f",
      "longitude":117.1271873,
      "latitude":51.6263006
    },
    "1963":{
      "name":"\u041a\u043e\u043b\u043e\u0431\u043e\u0432\u043e",
      "longitude":117.1509659,
      "latitude":51.7659394
    },
    "1964":{
      "name":"\u0423\u043b\u0435\u0439",
      "longitude":117.1530997,
      "latitude":52.6502826
    },
    "1965":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0439 \u0418\u043b\u044c\u0434\u0438\u043a\u0430\u043d",
      "longitude":117.1543534,
      "latitude":51.6133632
    },
    "1966":{
      "name":"\u0426\u0430\u0433\u0430\u043d-\u041e\u043b\u0443\u0439",
      "longitude":117.157631,
      "latitude":50.470581
    },
    "1967":{
      "name":"\u0410\u043a\u0443\u0440\u0430\u0439",
      "longitude":117.159813,
      "latitude":50.761539
    },
    "1968":{
      "name":"\u0416\u0443\u0440\u0430\u0432\u043b\u0451\u0432\u043e",
      "longitude":117.165265,
      "latitude":51.5343354
    },
    "1969":{
      "name":"\u0418\u043a\u0448\u0438\u0446\u0430",
      "longitude":117.196617,
      "latitude":52.470169
    },
    "1970":{
      "name":"\u0423\u0441\u0442\u044c-\u042f\u0433\u044c\u0451",
      "longitude":117.212012,
      "latitude":51.7471423
    },
    "1971":{
      "name":"\u0416\u0438\u0434\u043a\u0430",
      "longitude":117.2183428,
      "latitude":51.7691166
    },
    "1972":{
      "name":"\u0411\u043e\u043b\u043e\u0442\u043e\u0432\u043e",
      "longitude":117.2374826,
      "latitude":52.0847304
    },
    "1973":{
      "name":"\u041a\u0443\u0440\u043b\u044b\u0447",
      "longitude":117.248329,
      "latitude":52.3741235
    },
    "1974":{
      "name":"\u0411\u0443\u0448\u0443\u043b\u0435\u0439",
      "longitude":117.2717623,
      "latitude":52.7489812
    },
    "1975":{
      "name":"\u0428\u043e\u043d\u043e\u043a\u0442\u0443\u0439",
      "longitude":117.2764819,
      "latitude":50.770595
    },
    "1976":{
      "name":"\u0411\u0430\u044f\u043d",
      "longitude":117.3019561,
      "latitude":52.1044532
    },
    "1977":{
      "name":"\u041e\u043d\u043e\u043d-\u0411\u043e\u0440\u0437\u044f",
      "longitude":117.3244845,
      "latitude":51.0650561
    },
    "1978":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u0422\u0435\u0440\u0433\u0435\u043d\u044c",
      "longitude":117.3522881,
      "latitude":51.7371671
    },
    "1979":{
      "name":"\u041a\u0443\u043b\u0430\u043d",
      "longitude":117.3550651,
      "latitude":52.4007842
    },
    "1980":{
      "name":"\u041a\u043e\u043a\u0435\u0440\u0442\u0430\u0439",
      "longitude":117.3581874,
      "latitude":52.1251144
    },
    "1981":{
      "name":"\u0423\u0441\u0442\u044c-\u041d\u0430\u0440\u0438\u043d\u0437\u043e\u0440",
      "longitude":117.360412,
      "latitude":52.2661547
    },
    "1982":{
      "name":"\u0421\u0435\u043b\u0435\u043a\u0446\u0438\u043e\u043d\u043d\u0430\u044f",
      "longitude":117.3689661,
      "latitude":51.8119122
    },
    "1983":{
      "name":"\u0428\u0430\u0440\u0430\u043d\u0447\u0430",
      "longitude":117.3703754,
      "latitude":50.9324879
    },
    "1984":{
      "name":"\u041a\u0443\u0442\u0443\u0433\u0430\u0439",
      "longitude":117.374275,
      "latitude":50.854218
    },
    "1985":{
      "name":"\u0421\u0440\u0435\u0434\u043d\u0438\u0439 \u041a\u0430\u043b\u0430\u0440",
      "longitude":117.379738,
      "latitude":55.861233
    },
    "1986":{
      "name":"\u0413\u043b\u0438\u043d\u044f\u043d\u043a\u0430",
      "longitude":117.4048873,
      "latitude":51.6594915
    },
    "1987":{
      "name":"\u0428\u0438\u0432\u0438\u044f",
      "longitude":117.4285303,
      "latitude":51.8900529
    },
    "1988":{
      "name":"\u041c\u044b\u0433\u0436\u0430",
      "longitude":117.4294929,
      "latitude":52.344813
    },
    "1989":{
      "name":"\u0412\u0435\u0440\u0445-\u042f\u0433\u044c\u0451",
      "longitude":117.4349594,
      "latitude":51.623283
    },
    "1990":{
      "name":"\u0414\u0430\u044f",
      "longitude":117.4454788,
      "latitude":51.7950371
    },
    "1991":{
      "name":"\u0414\u0435\u043b\u044e\u043d",
      "longitude":117.4484929,
      "latitude":52.2115874
    },
    "1992":{
      "name":"\u041a\u043b\u0438\u043d",
      "longitude":117.4601998,
      "latitude":50.9938467
    },
    "1993":{
      "name":"\u0423\u0441\u0442\u044c-\u041a\u0443\u0440\u043b\u044b\u0447",
      "longitude":117.46078,
      "latitude":52.16497
    },
    "1994":{
      "name":"\u0421\u0442\u0435\u043f\u043d\u043e\u0439",
      "longitude":117.4663332,
      "latitude":50.0142742
    },
    "1995":{
      "name":"\u041a\u043e\u043d\u0434\u0443\u0439",
      "longitude":117.4763701,
      "latitude":50.5570742
    },
    "1996":{
      "name":"\u041a\u0438\u0440\u0438\u043b\u043b\u0438\u0445\u0430",
      "longitude":117.484459,
      "latitude":50.930374
    },
    "1997":{
      "name":"\u0427\u0438\u043a\u0438\u0447\u0435\u0439",
      "longitude":117.4935283,
      "latitude":52.3680648
    },
    "1998":{
      "name":"\u0410\u0434\u043e\u043c",
      "longitude":117.5123607,
      "latitude":52.4386735
    },
    "1999":{
      "name":"\u041a\u0443\u043f\u0440\u044f\u043a\u043e\u0432\u043e",
      "longitude":117.540526,
      "latitude":51.6880449
    },
    "2000":{
      "name":"\u0414\u0430\u044f\u043a\u043e\u043d",
      "longitude":117.5446418,
      "latitude":51.8244522
    },
    "2001":{
      "name":"\u0428\u0435\u043b\u043e\u043f\u0443\u0433\u0438\u043d\u043e",
      "longitude":117.564728,
      "latitude":51.649864
    },
    "2002":{
      "name":"\u0418\u0448\u0438\u043a\u0430\u043d",
      "longitude":117.5681835,
      "latitude":51.9680794
    },
    "2003":{
      "name":"\u0410\u043b\u0438\u044f",
      "longitude":117.6156041,
      "latitude":52.3169241
    },
    "2004":{
      "name":"\u041a\u043e\u0432\u044b\u043b\u0438",
      "longitude":117.616409,
      "latitude":50.372738
    },
    "2005":{
      "name":"\u041d\u0435\u043a\u0440\u0430\u0441\u043e\u0432\u043e",
      "longitude":117.6363383,
      "latitude":52.0216078
    },
    "2006":{
      "name":"\u041c\u0438\u0440\u043e\u043d\u043e\u0432\u043e",
      "longitude":117.6452781,
      "latitude":51.9790935
    },
    "2007":{
      "name":"\u041a\u043e\u043f\u0443\u043d\u044c",
      "longitude":117.6510465,
      "latitude":51.8745455
    },
    "2008":{
      "name":"\u0411\u043e\u0433\u0434\u0430\u043d\u043e\u0432\u043e",
      "longitude":117.6525359,
      "latitude":51.994658
    },
    "2009":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":117.6543476,
      "latitude":51.0144819
    },
    "2010":{
      "name":"\u0411\u0430\u043d\u0449\u0438\u043a\u043e\u0432\u043e",
      "longitude":117.65633,
      "latitude":51.58445
    },
    "2011":{
      "name":"\u041c\u0430\u043b\u044b\u0448\u0435\u0432\u043e",
      "longitude":117.6679549,
      "latitude":51.5388709
    },
    "2012":{
      "name":"\u041d\u0438\u0436\u043d\u044f\u044f \u0428\u0430\u0445\u0442\u0430\u043c\u0430",
      "longitude":117.6877465,
      "latitude":51.3911086
    },
    "2013":{
      "name":"\u0423\u043d\u0434\u0438\u043d\u0441\u043a\u0438\u0435 \u041a\u0430\u0432\u044b\u043a\u0443\u0447\u0438",
      "longitude":117.6971073,
      "latitude":51.4427024
    },
    "2014":{
      "name":"\u041c\u043e\u0440\u0433\u0443\u043b",
      "longitude":117.7105367,
      "latitude":52.2614
    },
    "2015":{
      "name":"\u041c\u0430\u043d\u044c\u043a\u043e\u0432\u043e",
      "longitude":117.7137791,
      "latitude":50.8579893
    },
    "2016":{
      "name":"\u0427\u043e\u043d\u0433\u0443\u043b\u044c",
      "longitude":117.7248752,
      "latitude":51.9528123
    },
    "2017":{
      "name":"\u0421\u0440\u0435\u0434\u043d\u044f\u044f \u0428\u0430\u0445\u0442\u0430\u043c\u0430",
      "longitude":117.7365118,
      "latitude":51.3446566
    },
    "2018":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u0422\u043e\u043d\u0442\u043e\u0439",
      "longitude":117.7600675,
      "latitude":51.8288755
    },
    "2019":{
      "name":"\u041d\u043e\u0432\u044b\u0439 \u0410\u043a\u0430\u0442\u0443\u0439",
      "longitude":117.776878,
      "latitude":51.048714
    },
    "2020":{
      "name":"\u0421\u043e\u043a\u0442\u0443\u0439-\u041c\u0438\u043b\u043e\u0437\u0430\u043d",
      "longitude":117.781151,
      "latitude":50.075806
    },
    "2021":{
      "name":"\u0421\u0442\u0430\u0440\u044b\u0439 \u0410\u043a\u0430\u0442\u0443\u0439",
      "longitude":117.783187,
      "latitude":51.0321376
    },
    "2022":{
      "name":"\u041c\u0430\u043b\u044b\u0439 \u0422\u043e\u043d\u0442\u043e\u0439",
      "longitude":117.7881675,
      "latitude":51.8359604
    },
    "2023":{
      "name":"\u0411\u0430\u0437\u0430\u043d\u043e\u0432\u043e",
      "longitude":117.789215,
      "latitude":50.952305
    },
    "2024":{
      "name":"\u0412\u0430\u0441\u0438\u043b\u044c\u0435\u0432\u0441\u043a\u0438\u0439 \u0425\u0443\u0442\u043e\u0440",
      "longitude":117.80233,
      "latitude":50.526073
    },
    "2025":{
      "name":"\u0410\u0431\u0430\u0433\u0430\u0439\u0442\u0443\u0439",
      "longitude":117.829453,
      "latitude":49.585087
    },
    "2026":{
      "name":"\u0416\u0443\u0440\u0430\u0432\u043b\u0451\u0432\u043e",
      "longitude":117.831276,
      "latitude":50.907158
    },
    "2027":{
      "name":"\u0414\u0435\u0440\u0435\u0432\u0446\u043e\u0432\u043e",
      "longitude":117.834168,
      "latitude":51.8762043
    },
    "2028":{
      "name":"\u041c\u043e\u043b\u043e\u0434\u043e\u0432\u0441\u043a",
      "longitude":117.8730211,
      "latitude":52.2612911
    },
    "2029":{
      "name":"\u041c\u0430\u0440\u0433\u0443\u0446\u0435\u043a",
      "longitude":117.889397,
      "latitude":50.40424
    },
    "2030":{
      "name":"\u0412\u0435\u0440\u0448\u0438\u043d\u043e-\u0428\u0430\u0445\u0442\u0430\u043c\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":117.889755,
      "latitude":51.299221
    },
    "2031":{
      "name":"\u0420\u0443\u0434\u043d\u0438\u043a \u0410\u0431\u0430\u0433\u0430\u0439\u0442\u0443\u0439",
      "longitude":117.891159,
      "latitude":49.70787
    },
    "2032":{
      "name":"\u041c\u0430\u043d\u043a\u0435\u0447\u0443\u0440",
      "longitude":117.909172,
      "latitude":50.654545
    },
    "2033":{
      "name":"\u0423\u043b\u044c\u044f\u043a\u0430\u043d",
      "longitude":117.92777,
      "latitude":53.1573227
    },
    "2034":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u0441\u043a\u0438\u0439 \u0417\u0430\u0432\u043e\u0434",
      "longitude":117.934097,
      "latitude":50.923641
    },
    "2035":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u0410\u043b\u0435\u043d\u0443\u0439",
      "longitude":117.9702248,
      "latitude":51.1414764
    },
    "2036":{
      "name":"\u041f\u043e\u0447\u0435\u043a\u0443\u0439",
      "longitude":117.9901454,
      "latitude":50.5302567
    },
    "2037":{
      "name":"\u041b\u043e\u043c\u044b",
      "longitude":117.9989232,
      "latitude":52.2854657
    },
    "2038":{
      "name":"\u041a\u043b\u0438\u0447\u043a\u0430",
      "longitude":117.999504,
      "latitude":50.442791
    },
    "2039":{
      "name":"\u041a\u043e\u043a\u0443\u0439 2-\u0439",
      "longitude":118.000053,
      "latitude":51.055096
    },
    "2040":{
      "name":"\u0411\u0440\u0443\u0441\u0438\u043b\u043e\u0432\u043a\u0430",
      "longitude":118.013557,
      "latitude":49.677666
    },
    "2041":{
      "name":"\u0415\u0440\u0430\u043b\u0433\u0430",
      "longitude":118.070536,
      "latitude":52.3132274
    },
    "2042":{
      "name":"\u041c\u0443\u043b\u0438\u043d\u043e",
      "longitude":118.07362,
      "latitude":50.5448595
    },
    "2043":{
      "name":"\u0423\u0440\u044e\u043c",
      "longitude":118.1099274,
      "latitude":53.1688275
    },
    "2044":{
      "name":"\u0426\u0435\u043b\u0438\u043d\u043d\u044b\u0439",
      "longitude":118.109993,
      "latitude":50.265282
    },
    "2045":{
      "name":"\u0411\u043e\u0440\u0438",
      "longitude":118.1110964,
      "latitude":52.4741638
    },
    "2046":{
      "name":"\u0423\u0440\u0443\u043b\u044e\u043d\u0433\u0443\u0439",
      "longitude":118.1119506,
      "latitude":50.2695464
    },
    "2047":{
      "name":"\u0411\u0443\u0442\u0443\u043d\u0442\u0430\u0439",
      "longitude":118.1189781,
      "latitude":50.6575569
    },
    "2048":{
      "name":"\u0424\u0438\u0440\u0441\u043e\u0432\u043e",
      "longitude":118.127373,
      "latitude":52.313564
    },
    "2049":{
      "name":"\u041d\u043e\u0432\u043e\u0438\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":118.1576761,
      "latitude":50.3735603
    },
    "2050":{
      "name":"\u041a\u0443\u0434\u0435\u044f",
      "longitude":118.162353,
      "latitude":52.3863377
    },
    "2051":{
      "name":"\u0411\u043e\u0445\u0442\u043e",
      "longitude":118.1812478,
      "latitude":51.0646071
    },
    "2052":{
      "name":"\u0413\u0430\u0437\u0438\u043c\u0443\u0440\u0441\u043a\u0438\u0435 \u041a\u0430\u0432\u044b\u043a\u0443\u0447\u0438",
      "longitude":118.1830273,
      "latitude":51.3615071
    },
    "2053":{
      "name":"\u0422\u0440\u0443\u0431\u0430\u0447\u0451\u0432\u043e",
      "longitude":118.2014274,
      "latitude":51.4048849
    },
    "2054":{
      "name":"\u0414\u043e\u0433\u044c\u0451",
      "longitude":118.2233101,
      "latitude":51.4940393
    },
    "2055":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u044f\u0440\u043e\u0432\u043e",
      "longitude":118.2337253,
      "latitude":51.2549003
    },
    "2056":{
      "name":"\u0427\u0438\u043d\u0434\u0430\u0433\u0430\u0442\u0430\u0439",
      "longitude":118.2366243,
      "latitude":50.7643285
    },
    "2057":{
      "name":"\u0427\u0430\u0440\u0430",
      "longitude":118.260986,
      "latitude":56.902946
    },
    "2058":{
      "name":"\u0421\u0440\u0435\u0434\u043d\u0435\u0430\u0440\u0433\u0443\u043d\u0441\u043a",
      "longitude":118.261604,
      "latitude":49.746487
    },
    "2059":{
      "name":"\u0423\u043a\u0442\u044b\u0447\u0430",
      "longitude":118.268976,
      "latitude":52.3317101
    },
    "2060":{
      "name":"\u041a\u043e\u0440\u0430\u0431\u043b\u044c",
      "longitude":118.2898088,
      "latitude":51.5281974
    },
    "2061":{
      "name":"\u0418\u0433\u0434\u043e\u0447\u0430",
      "longitude":118.3145898,
      "latitude":51.5680835
    },
    "2062":{
      "name":"\u041a\u0443\u0437\u043d\u0435\u0446\u043e\u0432\u043e",
      "longitude":118.315002,
      "latitude":51.098988
    },
    "2063":{
      "name":"\u041a\u044e\u0441\u0442\u044c-\u041a\u0435\u043c\u0434\u0430",
      "longitude":118.318939,
      "latitude":56.965942
    },
    "2064":{
      "name":"\u041f\u0430\u0432\u043b\u043e\u0432\u0441\u043a",
      "longitude":118.3256457,
      "latitude":51.5094874
    },
    "2065":{
      "name":"\u0421\u0435\u043b\u0438\u043d\u0434\u0430",
      "longitude":118.3292337,
      "latitude":50.5642415
    },
    "2066":{
      "name":"\u0413\u0430\u0437\u0438\u043c\u0443\u0440\u0441\u043a\u0438\u0439 \u0417\u0430\u0432\u043e\u0434",
      "longitude":118.3349104,
      "latitude":51.5511167
    },
    "2067":{
      "name":"\u042f\u043c\u043a\u0443\u043d",
      "longitude":118.3364545,
      "latitude":51.5272337
    },
    "2068":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u0422\u0430\u0441\u0443\u0440\u043a\u0430\u0439",
      "longitude":118.3466555,
      "latitude":50.4296105
    },
    "2069":{
      "name":"\u0428\u0430\u0440\u0430",
      "longitude":118.34743,
      "latitude":50.8362681
    },
    "2070":{
      "name":"\u041a\u043e\u043a\u0443\u0439 1-\u0439",
      "longitude":118.3490677,
      "latitude":51.1790363
    },
    "2071":{
      "name":"\u0421\u0430\u0432\u0432\u043e-\u0411\u043e\u0440\u0437\u044f",
      "longitude":118.3494711,
      "latitude":50.6981955
    },
    "2072":{
      "name":"\u042e\u0431\u0438\u043b\u0435\u0439\u043d\u044b\u0439",
      "longitude":118.357712,
      "latitude":50.268307
    },
    "2073":{
      "name":"\u0423\u0448\u043c\u0443\u043d",
      "longitude":118.3613183,
      "latitude":51.6800464
    },
    "2074":{
      "name":"\u041a\u0430\u043b\u0434\u0430\u0433\u0430",
      "longitude":118.3644938,
      "latitude":51.6318376
    },
    "2075":{
      "name":"\u0414\u0436\u0435\u043b\u043e\u043d\u0434\u0430",
      "longitude":118.3825182,
      "latitude":53.2672623
    },
    "2076":{
      "name":"\u041a\u0430\u0439\u043b\u0430\u0441\u0442\u0443\u0439",
      "longitude":118.397873,
      "latitude":49.832508
    },
    "2077":{
      "name":"\u0428\u0430\u0440\u0430\u043a\u0430\u043d",
      "longitude":118.4110106,
      "latitude":50.8486719
    },
    "2078":{
      "name":"\u0423\u0441\u0442\u044c-\u0422\u0430\u0441\u0443\u0440\u043a\u0430\u0439",
      "longitude":118.4119418,
      "latitude":50.3569863
    },
    "2079":{
      "name":"\u041a\u0443\u043d\u0433\u0430\u0440\u0430",
      "longitude":118.4405825,
      "latitude":51.8007671
    },
    "2080":{
      "name":"\u0422\u0430\u0439\u043d\u0430",
      "longitude":118.4566692,
      "latitude":51.5876618
    },
    "2081":{
      "name":"\u041a\u0443\u0440\u044e\u043c\u0434\u044e\u043a\u0430\u043d",
      "longitude":118.4753366,
      "latitude":51.807773
    },
    "2082":{
      "name":"\u0421\u0431\u0435\u0433\u0430",
      "longitude":118.5076519,
      "latitude":53.3113585
    },
    "2083":{
      "name":"\u041c\u0430\u043d\u0433\u0438\u0434\u0430\u0439",
      "longitude":118.5109478,
      "latitude":52.3774776
    },
    "2084":{
      "name":"\u0423\u0440\u0443\u043b\u044e\u043d\u0433\u0443\u0439",
      "longitude":118.5179769,
      "latitude":50.4647288
    },
    "2085":{
      "name":"\u0411\u0443\u0440\u0443\u043a\u0430\u043d",
      "longitude":118.5275271,
      "latitude":51.8404355
    },
    "2086":{
      "name":"\u0411\u044b\u0440\u043a\u0430",
      "longitude":118.554016,
      "latitude":50.645126
    },
    "2087":{
      "name":"\u0410\u0440\u0433\u0443\u043d",
      "longitude":118.5622579,
      "latitude":52.384919
    },
    "2088":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0438\u0435 \u0411\u043e\u0442\u044b",
      "longitude":118.5627033,
      "latitude":52.3970582
    },
    "2089":{
      "name":"\u0411\u0443\u0440\u0430",
      "longitude":118.5658259,
      "latitude":51.8434984
    },
    "2090":{
      "name":"\u0411\u043e\u0433\u043e\u0441\u043b\u043e\u0432\u0441\u043a",
      "longitude":118.5810476,
      "latitude":50.9007766
    },
    "2091":{
      "name":"\u0414\u043e\u043d\u043e",
      "longitude":118.5984314,
      "latitude":50.8941563
    },
    "2092":{
      "name":"\u041a\u0430\u043f\u0446\u0435\u0433\u0430\u0439\u0442\u0443\u0439",
      "longitude":118.598541,
      "latitude":49.956806
    },
    "2093":{
      "name":"\u041a\u0443\u0439\u0442\u0443\u043d",
      "longitude":118.609795,
      "latitude":50.240829
    },
    "2094":{
      "name":"\u0427\u0430\u043b\u0431\u0443\u0447\u0438",
      "longitude":118.624583,
      "latitude":52.4524653
    },
    "2095":{
      "name":"\u0414\u043e\u0441\u0430\u0442\u0443\u0439",
      "longitude":118.6354534,
      "latitude":50.3932605
    },
    "2096":{
      "name":"\u041d\u043e\u0432\u043e\u0448\u0438\u0440\u043e\u043a\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":118.6508177,
      "latitude":51.5742586
    },
    "2097":{
      "name":"\u041f\u043e\u0433\u0430\u0434\u0430\u0435\u0432\u043e",
      "longitude":118.6668724,
      "latitude":50.3335274
    },
    "2098":{
      "name":"\u0428\u0438\u043b\u043a\u0438\u043d\u0441\u043a\u0438\u0439 \u0417\u0430\u0432\u043e\u0434",
      "longitude":118.6675793,
      "latitude":52.5708999
    },
    "2099":{
      "name":"\u0428\u0438\u0440\u043e\u043a\u0430\u044f",
      "longitude":118.6942333,
      "latitude":51.5986281
    },
    "2100":{
      "name":"\u0418\u0442\u0430\u043a\u0430",
      "longitude":118.711655,
      "latitude":53.888115
    },
    "2101":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u043b\u043e\u043d\u0447\u0430\u043a\u043e\u0432\u043e",
      "longitude":118.7255286,
      "latitude":52.6072634
    },
    "2102":{
      "name":"\u0411\u043e\u0433\u0434\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":118.7547,
      "latitude":50.007072
    },
    "2103":{
      "name":"\u0418\u043a\u0430\u0431\u044c\u044f",
      "longitude":118.771309,
      "latitude":56.998291
    },
    "2104":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u041a\u0430\u043b\u0433\u0443\u043a\u0430\u043d",
      "longitude":118.780876,
      "latitude":50.817596
    },
    "2105":{
      "name":"\u041b\u0443\u0433\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":118.8189627,
      "latitude":52.0553076
    },
    "2106":{
      "name":"\u0423\u0441\u0442\u044c-\u041a\u0430\u0440\u0441\u043a",
      "longitude":118.821434,
      "latitude":52.71125
    },
    "2107":{
      "name":"\u0427\u0430\u043f\u043e-\u041e\u043b\u043e\u0433\u043e",
      "longitude":118.822693,
      "latitude":57.073608
    },
    "2108":{
      "name":"\u0422\u0430\u043b\u043c\u0430\u043d-\u0411\u043e\u0440\u0437\u044f",
      "longitude":118.8415379,
      "latitude":50.5602187
    },
    "2109":{
      "name":"\u0421\u043e\u043b\u043e\u043d\u0446\u044b",
      "longitude":118.8496021,
      "latitude":51.4558576
    },
    "2110":{
      "name":"\u0411\u0430\u0442\u0430\u043a\u0430\u043d",
      "longitude":118.858429,
      "latitude":52.073296
    },
    "2111":{
      "name":"\u041c\u043e\u043a\u043b\u0430\u043a\u0430\u043d",
      "longitude":118.877335,
      "latitude":54.730373
    },
    "2112":{
      "name":"\u0413\u043e\u0440\u0434\u0430",
      "longitude":118.8857367,
      "latitude":50.1689529
    },
    "2113":{
      "name":"\u041a\u0430\u043b\u0433\u0430",
      "longitude":118.899208,
      "latitude":50.92355
    },
    "2114":{
      "name":"\u0420\u0443\u0434\u043d\u0438\u043a \u0421\u043e\u043b\u043e\u043d\u0435\u0447\u043d\u044b\u0439",
      "longitude":118.9026976,
      "latitude":51.530074
    },
    "2115":{
      "name":"\u041b\u0443\u0436\u0430\u043d\u043a\u0438",
      "longitude":118.903981,
      "latitude":52.7608743
    },
    "2116":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0439 \u041a\u0430\u043b\u0433\u0443\u043a\u0430\u043d",
      "longitude":118.9142304,
      "latitude":50.7421556
    },
    "2117":{
      "name":"\u0417\u0430\u043a\u0430\u043c\u0435\u043d\u043d\u0430\u044f",
      "longitude":118.9193921,
      "latitude":52.0799261
    },
    "2118":{
      "name":"\u0423\u043b\u0430\u043d",
      "longitude":118.929457,
      "latitude":50.4772739
    },
    "2119":{
      "name":"\u0414\u0443\u0440\u043e\u0439",
      "longitude":118.930763,
      "latitude":50.007519
    },
    "2120":{
      "name":"\u041a\u043e\u0437\u043b\u043e\u0432\u043e",
      "longitude":118.933492,
      "latitude":51.2064593
    },
    "2121":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0435 \u041a\u0443\u043b\u0430\u0440\u043a\u0438",
      "longitude":118.946477,
      "latitude":52.8329948
    },
    "2122":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0435 \u041a\u0443\u043b\u0430\u0440\u043a\u0438",
      "longitude":118.9535798,
      "latitude":52.8676011
    },
    "2123":{
      "name":"\u041f\u043e\u0433\u0440\u0430\u043d\u0438\u0447\u043d\u044b\u0439",
      "longitude":118.9615277,
      "latitude":50.5938426
    },
    "2124":{
      "name":"\u041c\u043e\u043b\u043e\u0434\u0451\u0436\u043d\u044b\u0439",
      "longitude":118.993279,
      "latitude":50.282852
    },
    "2125":{
      "name":"\u0427\u0443\u043f\u0440\u043e\u0432\u043e",
      "longitude":118.9969839,
      "latitude":50.986373
    },
    "2126":{
      "name":"\u0427\u0438\u043d\u0433\u0438\u043b\u044c\u0442\u0443\u0439",
      "longitude":119.0367609,
      "latitude":50.796375
    },
    "2127":{
      "name":"\u0423\u0441\u0442\u044c-\u0427\u0451\u0440\u043d\u0430\u044f",
      "longitude":119.052237,
      "latitude":52.9225225
    },
    "2128":{
      "name":"\u042f\u0432\u043b\u0435\u043d\u043a\u0430",
      "longitude":119.0822786,
      "latitude":51.0374197
    },
    "2129":{
      "name":"\u041d\u043e\u0432\u043e\u0446\u0443\u0440\u0443\u0445\u0430\u0439\u0442\u0443\u0439",
      "longitude":119.116844,
      "latitude":50.393013
    },
    "2130":{
      "name":"\u0428\u0438\u0432\u0438\u044f",
      "longitude":119.1197586,
      "latitude":50.8869944
    },
    "2131":{
      "name":"\u041a\u0443\u0440\u043b\u0435\u044f",
      "longitude":119.120784,
      "latitude":52.1851597
    },
    "2132":{
      "name":"\u0417\u0430\u043f\u043e\u043a\u0440\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":119.1727152,
      "latitude":50.8202651
    },
    "2133":{
      "name":"\u041a\u0443\u0442\u0438",
      "longitude":119.1890535,
      "latitude":50.0915977
    },
    "2134":{
      "name":"\u0417\u043e\u043b\u043e\u0442\u043e\u043d\u043e\u0448\u0430",
      "longitude":119.1967014,
      "latitude":51.2892235
    },
    "2135":{
      "name":"\u0413\u043e\u0440\u0431\u0438\u0446\u0430",
      "longitude":119.2145221,
      "latitude":53.0990835
    },
    "2136":{
      "name":"\u0427\u0430\u043b\u0434\u043e\u043d\u043a\u0430",
      "longitude":119.2190009,
      "latitude":53.7823478
    },
    "2137":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u0417\u0435\u0440\u0435\u043d\u0442\u0443\u0439",
      "longitude":119.2260197,
      "latitude":51.3642375
    },
    "2138":{
      "name":"\u0427\u0430\u0448\u0438\u043d\u043e-\u0418\u043b\u044c\u0434\u0438\u043a\u0430\u043d",
      "longitude":119.2434658,
      "latitude":51.0693421
    },
    "2139":{
      "name":"\u0423\u0441\u0442\u044c-\u041d\u0430\u0447\u0438\u043d",
      "longitude":119.2445905,
      "latitude":52.3689352
    },
    "2140":{
      "name":"\u0417\u043e\u0440\u0433\u043e\u043b",
      "longitude":119.2707134,
      "latitude":50.6056829
    },
    "2141":{
      "name":"\u0411\u0430\u0439\u043a\u0430",
      "longitude":119.2954431,
      "latitude":51.2555987
    },
    "2142":{
      "name":"\u041a\u0443\u0434\u0435\u0447\u0430",
      "longitude":119.2963776,
      "latitude":53.4638332
    },
    "2143":{
      "name":"\u041a\u0430\u0434\u0430\u044f",
      "longitude":119.300064,
      "latitude":50.933846
    },
    "2144":{
      "name":"\u041f\u043e\u043f\u0435\u0440\u0435\u0447\u043d\u044b\u0439 \u0417\u0435\u0440\u0435\u043d\u0442\u0443\u0439",
      "longitude":119.3055735,
      "latitude":51.3761758
    },
    "2145":{
      "name":"\u0414\u0430\u0432\u0435\u043d\u0434\u0430",
      "longitude":119.317032,
      "latitude":53.555576
    },
    "2146":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u0446\u0443\u0440\u0443\u0445\u0430\u0439\u0442\u0443\u0439",
      "longitude":119.330727,
      "latitude":50.19923
    },
    "2147":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":119.433414,
      "latitude":51.1171785
    },
    "2148":{
      "name":"\u0413\u0435\u043e\u0440\u0433\u0438\u0435\u0432\u043a\u0430",
      "longitude":119.4432564,
      "latitude":51.3689514
    },
    "2149":{
      "name":"\u0411\u0443\u0440\u0430",
      "longitude":119.4480294,
      "latitude":50.7524062
    },
    "2150":{
      "name":"\u041a\u043b\u044e\u0447\u0435\u0432\u0441\u043a\u0438\u0439",
      "longitude":119.453285,
      "latitude":53.533886
    },
    "2151":{
      "name":"\u0423\u0440\u043e\u0432\u0441\u043a\u0438\u0435 \u041a\u043b\u044e\u0447\u0438",
      "longitude":119.4586962,
      "latitude":51.6878946
    },
    "2152":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":119.459515,
      "latitude":51.2613027
    },
    "2153":{
      "name":"\u0421\u0440\u0435\u0434\u043d\u044f\u044f \u0411\u043e\u0440\u0437\u044f",
      "longitude":119.4840598,
      "latitude":50.911028
    },
    "2154":{
      "name":"\u0413\u043e\u0440\u043d\u044b\u0439 \u0417\u0435\u0440\u0435\u043d\u0442\u0443\u0439",
      "longitude":119.519913,
      "latitude":51.215183
    },
    "2155":{
      "name":"\u0417\u0435\u0440\u0435\u043d",
      "longitude":119.5452383,
      "latitude":52.0333975
    },
    "2156":{
      "name":"\u041a\u0430\u043a\u0442\u043e\u043b\u0433\u0430",
      "longitude":119.5911085,
      "latitude":52.7780857
    },
    "2157":{
      "name":"\u0428\u0438\u0440\u043e\u043a\u0430\u044f",
      "longitude":119.598931,
      "latitude":51.3701988
    },
    "2158":{
      "name":"\u041d\u0435\u0440\u0447\u0438\u043d\u0441\u043a\u0438\u0439 \u0417\u0430\u0432\u043e\u0434",
      "longitude":119.616234,
      "latitude":51.30904
    },
    "2159":{
      "name":"\u0421\u043e\u043b\u043e\u043d\u0435\u0447\u043d\u0430\u044f",
      "longitude":119.6394139,
      "latitude":51.4014306
    },
    "2160":{
      "name":"\u0411\u0443\u043b\u0434\u0443\u0440\u0443\u0439 1-\u0439",
      "longitude":119.6599343,
      "latitude":51.0229651
    },
    "2161":{
      "name":"\u0411\u0443\u043b\u0434\u0443\u0440\u0443\u0439 2-\u0439",
      "longitude":119.7025043,
      "latitude":51.0790137
    },
    "2162":{
      "name":"\u0427\u0430\u043b\u0431\u0443\u0447\u0438-\u041a\u0438\u043b\u0433\u0430",
      "longitude":119.7099185,
      "latitude":51.145084
    },
    "2163":{
      "name":"\u0413\u043e\u0440\u0431\u0443\u043d\u043e\u0432\u043a\u0430",
      "longitude":119.7598031,
      "latitude":51.2298047
    },
    "2164":{
      "name":"\u041e\u043b\u043e\u0447\u0438",
      "longitude":119.899811,
      "latitude":51.35376
    },
    "2165":{
      "name":"\u0417\u0430\u0440\u0435\u0447\u043d\u043e\u0435",
      "longitude":119.931732,
      "latitude":54.45797
    },
    "2166":{
      "name":"\u0422\u0443\u043f\u0438\u043a",
      "longitude":119.94368,
      "latitude":54.426773
    },
    "2167":{
      "name":"\u0418\u0448\u0430\u0433\u0430",
      "longitude":119.9712692,
      "latitude":51.479275
    },
    "2168":{
      "name":"\u0414\u043e\u043c\u0430\u0441\u043e\u0432\u043e",
      "longitude":119.993689,
      "latitude":51.5424973
    },
    "2169":{
      "name":"\u0410\u0440\u0433\u0443\u043d\u0441\u043a",
      "longitude":120.0219722,
      "latitude":51.5761111
    },
    "2170":{
      "name":"\u0427\u0430\u0441\u043e\u0432\u0430\u044f",
      "longitude":120.0494612,
      "latitude":53.4875463
    },
    "2171":{
      "name":"\u0422\u0430\u043f\u0442\u0443\u0433\u0430\u0440\u044b",
      "longitude":120.0680487,
      "latitude":53.684151
    },
    "2172":{
      "name":"\u0421\u0440\u0435\u0434\u043d\u044f\u044f",
      "longitude":120.0930422,
      "latitude":51.6832534
    },
    "2173":{
      "name":"\u0410\u043d\u0438\u043a\u0438\u043d\u043e",
      "longitude":120.3330408,
      "latitude":53.4358195
    },
    "2174":{
      "name":"\u0421\u0435\u043c\u0438\u043e\u0437\u0451\u0440\u043d\u044b\u0439",
      "longitude":120.3654341,
      "latitude":53.7104662
    },
    "2175":{
      "name":"\u0421\u0440\u0435\u0434\u043d\u044f\u044f \u041e\u043b\u0451\u043a\u043c\u0430",
      "longitude":120.547829,
      "latitude":55.425037
    },
    "2176":{
      "name":"\u0417\u0430\u043a\u0430\u043c\u0435\u043d\u044c",
      "longitude":120.7098294,
      "latitude":52.212195
    },
    "2177":{
      "name":"\u0413\u0443\u043b\u044f",
      "longitude":120.997459,
      "latitude":54.671566
    },
    "2178":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u0411\u0438\u0447\u0430",
      "longitude":70.456322,
      "latitude":57.937202
    },
    "2179":{
      "name":"\u0417\u0430\u0433\u0432\u0430\u0437\u0434\u0438\u043d\u043e",
      "longitude":70.5743885,
      "latitude":57.817139
    },
    "2180":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u0411\u0438\u0447\u0430",
      "longitude":70.622459,
      "latitude":57.873371
    },
    "2181":{
      "name":"\u041a\u0438\u0441\u043b\u044f\u043a\u0438",
      "longitude":70.631897,
      "latitude":55.344563
    },
    "2182":{
      "name":"\u041a\u0430\u0439\u043b\u044b",
      "longitude":70.691887,
      "latitude":57.29081
    },
    "2183":{
      "name":"\u0421\u0430\u0443\u0440\u0433\u0430\u0447\u0438",
      "longitude":70.7158491,
      "latitude":57.7469252
    },
    "2184":{
      "name":"\u041c\u0430\u043d\u0433\u0443\u0442",
      "longitude":70.770058,
      "latitude":55.780849
    },
    "2185":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0435\u043f\u0435\u0441\u0447\u0430\u043d\u043a\u0430",
      "longitude":70.808037,
      "latitude":55.527
    },
    "2186":{
      "name":"\u041f\u0430\u043d\u043e\u0432\u043e",
      "longitude":70.8267065,
      "latitude":57.7971902
    },
    "2187":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u0422\u0435\u0431\u0435\u043d\u0434\u044f",
      "longitude":70.8421108,
      "latitude":57.7290721
    },
    "2188":{
      "name":"\u041e\u0440\u0435\u0445\u043e\u0432\u043e",
      "longitude":70.8494343,
      "latitude":57.4557996
    },
    "2189":{
      "name":"\u0417\u0438\u043c\u0438\u043d\u043e",
      "longitude":70.8683746,
      "latitude":56.2794241
    },
    "2190":{
      "name":"\u0421\u043b\u043e\u0431\u043e\u0434\u0447\u0438\u043a\u0438",
      "longitude":70.934387,
      "latitude":57.501663
    },
    "2191":{
      "name":"\u0421\u043a\u043e\u0440\u043e\u0434\u0443\u043c",
      "longitude":70.9353764,
      "latitude":57.7978351
    },
    "2192":{
      "name":"\u041f\u0430\u043d\u043e\u0432\u043e",
      "longitude":70.9636,
      "latitude":56.351177
    },
    "2193":{
      "name":"\u0418\u0441\u043a\u0440\u0430",
      "longitude":70.9782521,
      "latitude":55.923589
    },
    "2194":{
      "name":"\u041a\u043d\u044f\u0437\u0435\u0432\u043e",
      "longitude":70.9952477,
      "latitude":55.3445376
    },
    "2195":{
      "name":"\u0420\u044b\u0436\u043a\u043e\u0432\u043e",
      "longitude":70.999825,
      "latitude":55.99752
    },
    "2196":{
      "name":"\u041f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":71.0014247,
      "latitude":55.5218518
    },
    "2197":{
      "name":"\u0420\u043e\u0441\u043b\u0430\u0432\u043a\u0430",
      "longitude":71.03154,
      "latitude":54.9457142
    },
    "2198":{
      "name":"\u0411\u043b\u0430\u0433\u043e\u0432\u0435\u0449\u0435\u043d\u043a\u0430",
      "longitude":71.0491115,
      "latitude":54.8872393
    },
    "2199":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u0442\u0430\u0440\u043e\u0432\u043a\u0430",
      "longitude":71.0544813,
      "latitude":55.0733788
    },
    "2200":{
      "name":"\u041a\u0440\u043e\u043c\u044b",
      "longitude":71.0800069,
      "latitude":54.7681892
    },
    "2201":{
      "name":"\u0421\u0435\u0432\u0435\u0440\u043d\u044b\u0439",
      "longitude":71.0938768,
      "latitude":54.9943791
    },
    "2202":{
      "name":"\u041d\u043e\u0432\u043e\u0438\u043b\u044c\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":71.1145364,
      "latitude":54.2354743
    },
    "2203":{
      "name":"\u041a\u0430\u0441\u043a\u0430\u0442",
      "longitude":71.1303665,
      "latitude":54.7985361
    },
    "2204":{
      "name":"\u041a\u043e\u043c\u0441\u043e\u043c\u043e\u043b\u044c\u0441\u043a\u0438\u0439",
      "longitude":71.1396817,
      "latitude":54.8751624
    },
    "2205":{
      "name":"\u0422\u044e\u0440\u043c\u0435\u0442\u044f\u043a\u0438",
      "longitude":71.1473594,
      "latitude":57.5790781
    },
    "2206":{
      "name":"\u041b\u0435\u0441\u043d\u043e\u0439",
      "longitude":71.1506868,
      "latitude":54.9688643
    },
    "2207":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u044c\u0441\u043a",
      "longitude":71.1704456,
      "latitude":57.7400147
    },
    "2208":{
      "name":"\u042e\u0436\u043d\u044b\u0439",
      "longitude":71.185461,
      "latitude":57.6603033
    },
    "2209":{
      "name":"\u0410\u0448\u0435\u0432\u0430\u043d\u044b",
      "longitude":71.1900858,
      "latitude":57.6330234
    },
    "2210":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u0422\u0430\u0432\u0430",
      "longitude":71.195152,
      "latitude":57.496265
    },
    "2211":{
      "name":"\u0422\u043e\u043b\u043e\u043a\u043e\u043d\u0446\u0435\u0432\u043e",
      "longitude":71.202385,
      "latitude":56.450352
    },
    "2212":{
      "name":"\u041a\u0443\u0434\u0440\u044f\u0435\u0432\u043a\u0430",
      "longitude":71.2318296,
      "latitude":54.747984
    },
    "2213":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u044c\u0441\u043a",
      "longitude":71.2387779,
      "latitude":56.4925913
    },
    "2214":{
      "name":"\u0422\u0435\u0440\u043f\u0435\u043d\u044c\u0435",
      "longitude":71.2462555,
      "latitude":54.2507719
    },
    "2215":{
      "name":"\u041f\u0443\u0442\u044c \u0421\u043e\u0446\u0438\u0430\u043b\u0438\u0437\u043c\u0430",
      "longitude":71.263229,
      "latitude":55.755714
    },
    "2216":{
      "name":"\u0421\u043e\u043b\u043d\u0446\u0435\u0432\u043a\u0430",
      "longitude":71.287582,
      "latitude":54.990009
    },
    "2217":{
      "name":"\u0421\u043e\u043b\u043e\u0432\u044c\u0451\u0432\u043a\u0430",
      "longitude":71.2890145,
      "latitude":54.4794586
    },
    "2218":{
      "name":"\u041c\u0435\u0434\u0432\u0435\u0436\u044c\u0435",
      "longitude":71.2902544,
      "latitude":55.1871748
    },
    "2219":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u0432\u043a\u0430",
      "longitude":71.3253847,
      "latitude":55.0087479
    },
    "2220":{
      "name":"\u0423\u0442\u0443\u0441\u043a\u0443\u043d",
      "longitude":71.3286651,
      "latitude":57.7366112
    },
    "2221":{
      "name":"\u0423\u043a\u0440\u0430\u0438\u043d\u043a\u0430",
      "longitude":71.332848,
      "latitude":54.653961
    },
    "2222":{
      "name":"\u0416\u0438\u0440\u043d\u043e\u0432\u043a\u0430",
      "longitude":71.3333413,
      "latitude":55.3859767
    },
    "2223":{
      "name":"\u0412\u043e\u0434\u044f\u043d\u043e\u0435",
      "longitude":71.343147,
      "latitude":55.007309
    },
    "2224":{
      "name":"\u041b\u0435\u043d\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":71.3496155,
      "latitude":54.8405243
    },
    "2225":{
      "name":"\u0412\u043e\u043b\u044c\u043d\u043e\u0435",
      "longitude":71.3573897,
      "latitude":54.2860993
    },
    "2226":{
      "name":"\u0411\u043e\u0440\u043e\u0432\u043e\u0435",
      "longitude":71.3597082,
      "latitude":54.772024
    },
    "2227":{
      "name":"\u0421\u0432\u044f\u0442\u043e\u0433\u043e\u0440\u0441\u043a",
      "longitude":71.3799035,
      "latitude":54.3879541
    },
    "2228":{
      "name":"\u042f\u043c\u0430\u043d",
      "longitude":71.393486,
      "latitude":56.044758
    },
    "2229":{
      "name":"\u041d\u043e\u0432\u043e\u0434\u043e\u043d\u043a\u0430",
      "longitude":71.4043273,
      "latitude":54.653961
    },
    "2230":{
      "name":"\u041c\u0443\u0440\u0430\u0432\u044c\u0451\u0432\u043a\u0430",
      "longitude":71.4106376,
      "latitude":55.6712831
    },
    "2231":{
      "name":"\u0421\u0442\u0430\u0440\u0438\u043d\u043a\u0430",
      "longitude":71.4126567,
      "latitude":55.7424837
    },
    "2232":{
      "name":"\u041c\u044f\u0441\u043d\u0438\u043a\u0438",
      "longitude":71.4164566,
      "latitude":54.5842343
    },
    "2233":{
      "name":"\u0414\u043e\u0431\u0440\u044f\u043d\u043a\u0430",
      "longitude":71.427723,
      "latitude":54.2194286
    },
    "2234":{
      "name":"\u0411\u043e\u0435\u0432\u043e\u0439",
      "longitude":71.447296,
      "latitude":54.933403
    },
    "2235":{
      "name":"\u041b\u0443\u0431\u044f\u043d\u0441\u043a",
      "longitude":71.4504005,
      "latitude":54.4738968
    },
    "2236":{
      "name":"\u042f\u0440\u043a\u043e\u0432\u043e",
      "longitude":71.4598692,
      "latitude":57.649836
    },
    "2237":{
      "name":"\u041d\u043e\u0432\u043e\u0440\u043e\u0436\u0434\u0435\u0441\u0442\u0432\u0435\u043d\u043a\u0430",
      "longitude":71.4612713,
      "latitude":55.0951862
    },
    "2238":{
      "name":"\u0413\u043e\u0444\u043d\u0443\u043d\u0433\u0441\u0442\u0430\u043b\u044c",
      "longitude":71.4966317,
      "latitude":54.9620961
    },
    "2239":{
      "name":"\u0412\u043e\u0440\u043e\u043d\u0446\u043e\u0432\u043a\u0430",
      "longitude":71.500679,
      "latitude":54.32745
    },
    "2240":{
      "name":"\u041f\u0443\u0447\u043a\u043e\u0432\u043e",
      "longitude":71.5088353,
      "latitude":54.9331847
    },
    "2241":{
      "name":"\u0424\u043e\u043c\u0438\u0445\u0430",
      "longitude":71.5097024,
      "latitude":55.4723898
    },
    "2242":{
      "name":"\u0410\u043a\u0441\u0435\u043d\u043e\u0432\u043e",
      "longitude":71.5134569,
      "latitude":57.690324
    },
    "2243":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0439\u043f\u043e\u043b\u044c",
      "longitude":71.5179221,
      "latitude":54.868198
    },
    "2244":{
      "name":"\u0411\u0430\u0440\u0440\u0438\u043a\u0430\u0434\u0430",
      "longitude":71.5396757,
      "latitude":54.7835299
    },
    "2245":{
      "name":"\u0418\u043b\u044c\u0447\u0435\u0431\u0430\u0433\u0430",
      "longitude":71.5405615,
      "latitude":57.6174312
    },
    "2246":{
      "name":"\u0410\u043f\u043e\u043b\u043b\u043e\u043d\u043e\u0432\u043a\u0430",
      "longitude":71.542999,
      "latitude":55.168213
    },
    "2247":{
      "name":"\u0428\u0438\u043f\u0443\u043d\u043e\u0432\u043e",
      "longitude":71.5511908,
      "latitude":56.2567578
    },
    "2248":{
      "name":"\u041c\u0430\u0440\u0433\u0435\u043d\u0430\u0443",
      "longitude":71.566658,
      "latitude":54.919445
    },
    "2249":{
      "name":"\u041d\u0438\u043a\u043e\u043d\u043e\u0432\u043a\u0430",
      "longitude":71.595085,
      "latitude":54.303505
    },
    "2250":{
      "name":"\u041b\u043e\u0440\u0438\u0441-\u041c\u0435\u043b\u0438\u043a\u043e\u0432\u043e",
      "longitude":71.59684,
      "latitude":55.583809
    },
    "2251":{
      "name":"\u041a\u0438\u0442\u0435\u0440\u043c\u0430",
      "longitude":71.625198,
      "latitude":56.095715
    },
    "2252":{
      "name":"\u0423\u0442\u0438\u0447\u044c\u0435",
      "longitude":71.6400412,
      "latitude":55.3170207
    },
    "2253":{
      "name":"\u041c\u0438\u0440\u043e\u043b\u044e\u0431\u043e\u0432\u043a\u0430",
      "longitude":71.646194,
      "latitude":54.866489
    },
    "2254":{
      "name":"\u0417\u0432\u0435\u0437\u0434\u0438\u043d\u043e",
      "longitude":71.662933,
      "latitude":54.965183
    },
    "2255":{
      "name":"\u041e\u043b\u044c\u0433\u0438\u043d\u043e",
      "longitude":71.678612,
      "latitude":54.266537
    },
    "2256":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u0433\u043e\u0440\u043a\u0430",
      "longitude":71.6792491,
      "latitude":54.5676764
    },
    "2257":{
      "name":"\u041a\u0430\u0439\u0441\u044b",
      "longitude":71.6978957,
      "latitude":57.6600774
    },
    "2258":{
      "name":"\u041a\u043e\u0447\u043a\u043e\u0432\u0430\u0442\u0441\u043a\u0438\u0439",
      "longitude":71.6981637,
      "latitude":55.4521322
    },
    "2259":{
      "name":"\u0422\u0430\u0432\u0438\u043d\u0441\u043a",
      "longitude":71.7093985,
      "latitude":57.5879459
    },
    "2260":{
      "name":"\u0420\u043e\u0434\u043d\u0430\u044f \u0414\u043e\u043b\u0438\u043d\u0430",
      "longitude":71.746185,
      "latitude":54.865433
    },
    "2261":{
      "name":"\u0423\u0442\u044c\u043c\u0430",
      "longitude":71.7540915,
      "latitude":57.5762237
    },
    "2262":{
      "name":"\u0411\u043e\u0433\u043e\u0434\u0443\u0445\u043e\u0432\u043a\u0430",
      "longitude":71.7631824,
      "latitude":55.4820243
    },
    "2263":{
      "name":"\u0411\u0435\u043b\u044c\u0434\u0435\u0436 \u2116 3",
      "longitude":71.769707,
      "latitude":54.391434
    },
    "2264":{
      "name":"\u041a\u043e\u0440\u043d\u0435\u0435\u0432\u043a\u0430",
      "longitude":71.77296,
      "latitude":54.9197813
    },
    "2265":{
      "name":"\u0427\u0435\u0440\u0435\u043c\u043d\u043e\u0432\u043a\u0430",
      "longitude":71.7747205,
      "latitude":55.4177698
    },
    "2266":{
      "name":"\u0413\u0435\u043e\u0440\u0433\u0438\u0435\u0432\u043a\u0430",
      "longitude":71.775018,
      "latitude":54.2985684
    },
    "2267":{
      "name":"\u041e\u0433\u043b\u0443\u0445\u0438\u043d\u043e",
      "longitude":71.784355,
      "latitude":55.86145
    },
    "2268":{
      "name":"\u0428\u0435\u0432\u0447\u0435\u043d\u043a\u043e",
      "longitude":71.79081,
      "latitude":54.814659
    },
    "2269":{
      "name":"\u0412\u0435\u0441\u0451\u043b\u044b\u0439",
      "longitude":71.7990592,
      "latitude":54.9664494
    },
    "2270":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u0430\u0440\u0430\u0441\u0443\u043a",
      "longitude":71.8081456,
      "latitude":56.2655388
    },
    "2271":{
      "name":"\u0414\u043e\u0431\u0440\u043e\u0435 \u041f\u043e\u043b\u0435",
      "longitude":71.816505,
      "latitude":54.875927
    },
    "2272":{
      "name":"\u041d\u0430\u043b\u0438\u043c\u043e\u0432\u043e",
      "longitude":71.8192073,
      "latitude":55.6400236
    },
    "2273":{
      "name":"\u0415\u043a\u0430\u0442\u0435\u0440\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":71.827614,
      "latitude":54.91774
    },
    "2274":{
      "name":"\u041a\u0438\u043f",
      "longitude":71.8471551,
      "latitude":57.5458389
    },
    "2275":{
      "name":"\u042f\u0440\u043e\u0441\u043b\u0430\u0432\u043a\u0430",
      "longitude":71.860281,
      "latitude":55.9894035
    },
    "2276":{
      "name":"\u0411\u0435\u043b\u044c\u0434\u0435\u0436 \u2116 12",
      "longitude":71.8817226,
      "latitude":54.392242
    },
    "2277":{
      "name":"\u0413\u0432\u043e\u0437\u0434\u0435\u0432\u043a\u0430",
      "longitude":71.88266,
      "latitude":54.581463
    },
    "2278":{
      "name":"\u041d\u0435\u0439\u0444\u0435\u043b\u044c\u0434",
      "longitude":71.88266,
      "latitude":54.937847
    },
    "2279":{
      "name":"\u041b\u0438\u0441\u0442\u0432\u044f\u0433\u0438",
      "longitude":71.9109675,
      "latitude":57.235567
    },
    "2280":{
      "name":"\u0412\u043e\u043b\u0447\u0430\u043d\u043a\u0430",
      "longitude":71.917394,
      "latitude":54.9652572
    },
    "2281":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":71.921577,
      "latitude":54.843067
    },
    "2282":{
      "name":"\u041d\u043e\u0432\u043e\u0446\u0430\u0440\u0438\u0446\u044b\u043d\u043e",
      "longitude":71.941666,
      "latitude":54.663315
    },
    "2283":{
      "name":"\u041a\u043e\u043a\u043e\u043d\u043e\u0432\u043a\u0430",
      "longitude":71.95049,
      "latitude":54.3116064
    },
    "2284":{
      "name":"\u0420\u043e\u0437\u0435\u043d\u0442\u0430\u043b\u044c",
      "longitude":71.9506466,
      "latitude":54.9088071
    },
    "2285":{
      "name":"\u041a\u043b\u0430\u0443\u0441",
      "longitude":71.950829,
      "latitude":54.925709
    },
    "2286":{
      "name":"\u0422\u0443\u043c\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":71.9530396,
      "latitude":55.0954904
    },
    "2287":{
      "name":"\u0414\u0440\u0430\u0433\u0443\u043d\u0441\u043a\u0438\u0439",
      "longitude":71.9546699,
      "latitude":55.3274445
    },
    "2288":{
      "name":"\u0416\u0430\u043d\u0430\u0430\u0443\u043b",
      "longitude":71.9587279,
      "latitude":54.7361487
    },
    "2289":{
      "name":"\u0412\u0430\u043b\u0443\u0435\u0432\u043a\u0430",
      "longitude":72.0193627,
      "latitude":55.6964366
    },
    "2290":{
      "name":"\u0418\u043b\u044c\u0438\u0447\u0435\u0432\u043a\u0430",
      "longitude":72.025002,
      "latitude":55.04845
    },
    "2291":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u0443\u0441\u043e\u0432\u043e",
      "longitude":72.0255412,
      "latitude":55.8627372
    },
    "2292":{
      "name":"\u0410\u0442\u0440\u0430\u0447\u0438",
      "longitude":72.0261745,
      "latitude":55.9555689
    },
    "2293":{
      "name":"\u0415\u0440\u0435\u043c\u0435\u0435\u0432\u043a\u0430",
      "longitude":72.04921,
      "latitude":54.286747
    },
    "2294":{
      "name":"\u041c\u0438\u0440\u043e\u043d\u043e\u0432\u043a\u0430",
      "longitude":72.054184,
      "latitude":55.058266
    },
    "2295":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u0435 \u0417\u043d\u0430\u043c\u044f",
      "longitude":72.0568756,
      "latitude":55.0889378
    },
    "2296":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":72.0770311,
      "latitude":55.347893
    },
    "2297":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u0432\u043e",
      "longitude":72.0822242,
      "latitude":57.5277981
    },
    "2298":{
      "name":"\u042d\u043b\u0438\u0442\u0430",
      "longitude":72.113762,
      "latitude":54.910904
    },
    "2299":{
      "name":"\u0421\u0435\u0432\u0435\u0440\u043d\u043e\u0435",
      "longitude":72.1218281,
      "latitude":54.9895705
    },
    "2300":{
      "name":"\u0414\u043e\u043c\u0431\u0430\u0439",
      "longitude":72.1585081,
      "latitude":54.7639593
    },
    "2301":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":72.170639,
      "latitude":55.078976
    },
    "2302":{
      "name":"\u041c\u0430\u043a\u0441\u0438\u043c\u043e\u0432\u043a\u0430",
      "longitude":72.1810067,
      "latitude":54.5254243
    },
    "2303":{
      "name":"\u0425\u0443\u0442\u043e\u0440\u0430",
      "longitude":72.1962136,
      "latitude":56.222854
    },
    "2304":{
      "name":"\u0411\u0430\u0431\u0435\u0436",
      "longitude":72.209045,
      "latitude":54.635021
    },
    "2305":{
      "name":"\u041e\u043a\u0442\u044f\u0431\u0440\u044c\u0441\u043a\u0438\u0439",
      "longitude":72.2131391,
      "latitude":55.8173385
    },
    "2306":{
      "name":"\u041a\u0443\u0437\u043d\u0435\u0446\u043e\u0432\u043e",
      "longitude":72.2135613,
      "latitude":57.5848691
    },
    "2307":{
      "name":"\u0422\u0440\u043e\u0438\u0446\u043a",
      "longitude":72.2345752,
      "latitude":55.7015102
    },
    "2308":{
      "name":"\u0423\u0442\u0443\u0437\u044b",
      "longitude":72.2542288,
      "latitude":57.514595
    },
    "2309":{
      "name":"\u041b\u0430\u0440\u0433\u0430",
      "longitude":72.2639027,
      "latitude":54.5224481
    },
    "2310":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u043a\u0430\u0442\u043e\u0432\u043a\u0430",
      "longitude":72.284157,
      "latitude":54.336384
    },
    "2311":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u044c\u0441\u043a\u043e\u0435",
      "longitude":72.2851446,
      "latitude":55.6112753
    },
    "2312":{
      "name":"\u0422\u0430\u043b\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":72.2920933,
      "latitude":54.4473103
    },
    "2313":{
      "name":"\u0423\u0440\u043e\u0436\u0430\u0439\u043d\u044b\u0439",
      "longitude":72.2950704,
      "latitude":55.0728275
    },
    "2314":{
      "name":"\u041e\u0442\u0440\u0430\u0434\u043d\u043e\u0435",
      "longitude":72.296303,
      "latitude":54.802719
    },
    "2315":{
      "name":"\u0412\u0435\u0441\u0435\u043b\u0430\u044f \u041f\u043e\u043b\u044f\u043d\u0430",
      "longitude":72.3079297,
      "latitude":55.3771103
    },
    "2316":{
      "name":"\u041f\u0438\u043a\u0435\u0442\u043d\u043e\u0435",
      "longitude":72.314781,
      "latitude":54.95187
    },
    "2317":{
      "name":"\u041c\u043e\u0441\u043a\u0430\u043b\u0435\u043d\u0441\u043a\u0438\u0439",
      "longitude":72.329659,
      "latitude":54.888092
    },
    "2318":{
      "name":"\u041d\u043e\u0432\u044b\u0439 \u041a\u043e\u0448\u043a\u0443\u043b\u044c",
      "longitude":72.3367716,
      "latitude":55.9914489
    },
    "2319":{
      "name":"\u041f\u0440\u043e\u043b\u0435\u0442\u0430\u0440\u0441\u043a\u0438\u0439",
      "longitude":72.3511864,
      "latitude":55.2141688
    },
    "2320":{
      "name":"\u0410\u0440\u0442\u0430\u043a\u0448\u0438\u043b",
      "longitude":72.3706304,
      "latitude":54.7272212
    },
    "2321":{
      "name":"\u0417\u0430\u0440\u044f \u0421\u0432\u043e\u0431\u043e\u0434\u044b",
      "longitude":72.3803048,
      "latitude":54.9818204
    },
    "2322":{
      "name":"\u0421\u0442\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":72.3818452,
      "latitude":56.8576767
    },
    "2323":{
      "name":"\u0411\u0435\u043b\u044b\u0439 \u042f\u0440",
      "longitude":72.3898028,
      "latitude":57.5890028
    },
    "2324":{
      "name":"\u0421\u0430\u0436\u0438\u043d\u043e",
      "longitude":72.3914524,
      "latitude":55.8933024
    },
    "2325":{
      "name":"\u041b\u0443\u0433\u043e\u0432\u043e\u0439",
      "longitude":72.39688,
      "latitude":55.1196499
    },
    "2326":{
      "name":"\u0423\u044e\u0442\u043d\u043e\u0435",
      "longitude":72.4201141,
      "latitude":54.8760154
    },
    "2327":{
      "name":"\u041a\u0430\u0431\u044b\u0440\u0434\u0430\u043a",
      "longitude":72.4363427,
      "latitude":56.1169704
    },
    "2328":{
      "name":"\u0428\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":72.4542015,
      "latitude":55.2039749
    },
    "2329":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u0438\u0435\u0432\u043a\u0430",
      "longitude":72.4549628,
      "latitude":55.2605975
    },
    "2330":{
      "name":"\u0415\u043a\u0430\u0442\u0435\u0440\u0438\u043d\u043e\u0441\u043b\u0430\u0432\u043a\u0430",
      "longitude":72.4625158,
      "latitude":54.3443249
    },
    "2331":{
      "name":"\u041e\u0440\u043b\u043e\u0432\u043a\u0430",
      "longitude":72.464752,
      "latitude":55.027702
    },
    "2332":{
      "name":"\u0421\u0435\u0432\u0435\u0440\u043d\u043e\u0435",
      "longitude":72.4869675,
      "latitude":54.6993288
    },
    "2333":{
      "name":"\u041e\u0440\u0435\u0445\u043e\u0432\u043e",
      "longitude":72.4881522,
      "latitude":53.9832588
    },
    "2334":{
      "name":"\u0411\u0440\u0435\u0437\u0438\u0446\u043a",
      "longitude":72.4945492,
      "latitude":54.1902691
    },
    "2335":{
      "name":"\u0426\u0432\u0435\u0442\u043a\u043e\u0432\u043e",
      "longitude":72.5008663,
      "latitude":54.0811035
    },
    "2336":{
      "name":"\u0426\u0435\u043d\u0442\u0440\u0430\u043b\u044c\u043d\u043e-\u041b\u044e\u0431\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":72.5038905,
      "latitude":55.1255485
    },
    "2337":{
      "name":"\u041a\u0443\u0442\u0443\u0437\u043e\u0432\u043a\u0430",
      "longitude":72.519051,
      "latitude":54.465439
    },
    "2338":{
      "name":"\u0427\u0435\u0440\u043d\u0435\u0446\u043e\u0432\u043a\u0430",
      "longitude":72.519094,
      "latitude":56.5507239
    },
    "2339":{
      "name":"\u0420\u043e\u0432\u043d\u0430\u044f \u041f\u043e\u043b\u044f\u043d\u0430",
      "longitude":72.5192585,
      "latitude":55.1051449
    },
    "2340":{
      "name":"\u041c\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":72.5254726,
      "latitude":55.6395146
    },
    "2341":{
      "name":"\u041c\u0430\u0440\u044c\u044f\u043d\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":72.5297397,
      "latitude":54.9212881
    },
    "2342":{
      "name":"\u0421\u043c\u043e\u043b\u044f\u043d\u043e\u0432\u043a\u0430",
      "longitude":72.5336325,
      "latitude":55.264004
    },
    "2343":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u043a\u043e\u0432\u043a\u0430",
      "longitude":72.5350779,
      "latitude":55.4306156
    },
    "2344":{
      "name":"\u0411\u0430\u0439\u0431\u044b",
      "longitude":72.540398,
      "latitude":57.461323
    },
    "2345":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u0420\u043e\u0449\u0430",
      "longitude":72.5449841,
      "latitude":54.7952184
    },
    "2346":{
      "name":"\u0426\u0435\u043d\u0442\u0440\u0430\u043b\u044c\u043d\u043e\u0435",
      "longitude":72.5503129,
      "latitude":54.6427808
    },
    "2347":{
      "name":"\u0428\u0435\u0440\u0435\u043c\u0435\u0442\u044c\u0435\u0432\u043a\u0430",
      "longitude":72.559074,
      "latitude":54.8497249
    },
    "2348":{
      "name":"\u0421\u043e\u043b\u043d\u0446\u0435\u0432\u043e",
      "longitude":72.5709586,
      "latitude":54.2949564
    },
    "2349":{
      "name":"\u0416\u0435\u043b\u0430\u043d\u043d\u043e\u0435",
      "longitude":72.575775,
      "latitude":54.166344
    },
    "2350":{
      "name":"\u0411\u043e\u0440\u0438\u0441\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":72.5847612,
      "latitude":54.6244997
    },
    "2351":{
      "name":"\u041f\u0440\u043e\u0442\u043e\u043f\u043e\u043f\u043e\u0432\u043a\u0430",
      "longitude":72.60994,
      "latitude":55.099388
    },
    "2352":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u0441\u043e\u043b\u0434\u0430\u0442\u0441\u043a\u043e\u0435",
      "longitude":72.613777,
      "latitude":56.202625
    },
    "2353":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u043a\u0430",
      "longitude":72.625572,
      "latitude":55.047794
    },
    "2354":{
      "name":"\u0410\u0451\u0432",
      "longitude":72.6306616,
      "latitude":56.9288028
    },
    "2355":{
      "name":"\u0423\u0441\u043e\u0432\u043a\u0430",
      "longitude":72.6502582,
      "latitude":54.9150122
    },
    "2356":{
      "name":"\u0411\u043e\u0433\u043e\u043b\u044e\u0431\u043e\u0432\u043a\u0430",
      "longitude":72.6512196,
      "latitude":54.8020146
    },
    "2357":{
      "name":"\u0417\u0430\u043c\u0435\u043b\u0435\u0442\u0435\u043d\u043e\u0432\u043a\u0430",
      "longitude":72.651633,
      "latitude":55.2344806
    },
    "2358":{
      "name":"\u0418\u0437\u044e\u043c\u043e\u0432\u043a\u0430",
      "longitude":72.6527077,
      "latitude":54.6734615
    },
    "2359":{
      "name":"\u0411\u043e\u0433\u043e\u043b\u044e\u0431\u043e\u0432\u043a\u0430",
      "longitude":72.6604807,
      "latitude":55.305557
    },
    "2360":{
      "name":"\u0416\u0443\u0440\u0430\u0432\u043b\u0435\u0432\u043a\u0430",
      "longitude":72.6638693,
      "latitude":57.5025602
    },
    "2361":{
      "name":"\u0415\u043a\u0430\u0442\u0435\u0440\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":72.6653535,
      "latitude":57.6034678
    },
    "2362":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u044f\u0440\u043a\u0430",
      "longitude":72.667145,
      "latitude":54.384167
    },
    "2363":{
      "name":"\u0411\u0435\u043b\u043e\u0433\u043b\u0430\u0437\u043e\u0432\u043e",
      "longitude":72.6681888,
      "latitude":56.0540122
    },
    "2364":{
      "name":"\u041f\u043e\u0431\u043e\u0447\u0438\u043d\u043e",
      "longitude":72.677376,
      "latitude":54.195236
    },
    "2365":{
      "name":"\u041f\u0435\u0442\u0435\u043b\u0438\u043d\u043e",
      "longitude":72.6922008,
      "latitude":57.4291359
    },
    "2366":{
      "name":"\u041a\u0432\u0430\u0441\u043e\u0432\u043a\u0430",
      "longitude":72.699097,
      "latitude":55.276981
    },
    "2367":{
      "name":"\u041c\u0430\u043a\u0441\u0438\u043c\u043e\u0432\u043a\u0430",
      "longitude":72.7024844,
      "latitude":55.643515
    },
    "2368":{
      "name":"\u0411\u0435\u043a\u0438\u0448\u0435\u0432\u043e",
      "longitude":72.705856,
      "latitude":55.581596
    },
    "2369":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":72.709828,
      "latitude":54.6631981
    },
    "2370":{
      "name":"\u041d\u0430\u0433\u0438\u0431\u0438\u043d\u043e",
      "longitude":72.710426,
      "latitude":55.763302
    },
    "2371":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u0432\u043a\u0430",
      "longitude":72.7107127,
      "latitude":54.9666036
    },
    "2372":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":72.713356,
      "latitude":54.943783
    },
    "2373":{
      "name":"1-\u0435 \u041a\u043e\u043c\u0438\u0441\u0441\u0430\u0440\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":72.7256119,
      "latitude":54.5036733
    },
    "2374":{
      "name":"\u0412\u0430\u0441\u0438\u043b\u044c\u0435\u0432\u043a\u0430",
      "longitude":72.748573,
      "latitude":54.909664
    },
    "2375":{
      "name":"\u041a\u0430\u0437\u0430\u043d\u043a\u0430",
      "longitude":72.7515853,
      "latitude":55.2692755
    },
    "2376":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":72.7547461,
      "latitude":54.5606016
    },
    "2377":{
      "name":"\u0422\u0430\u0432\u0440\u0438\u0447\u0430\u043d\u043a\u0430",
      "longitude":72.7679239,
      "latitude":55.4580207
    },
    "2378":{
      "name":"\u0421\u0442\u0430\u0440\u0430\u044f \u0428\u0430\u0440\u0430\u043f\u043e\u0432\u043a\u0430",
      "longitude":72.774124,
      "latitude":54.969559
    },
    "2379":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u0428\u0430\u0440\u0430\u043f\u043e\u0432\u043a\u0430",
      "longitude":72.777687,
      "latitude":54.980877
    },
    "2380":{
      "name":"\u041c\u0430\u0442\u044e\u0448\u0438\u043d\u043e",
      "longitude":72.7779371,
      "latitude":55.2669703
    },
    "2381":{
      "name":"\u0411\u0435\u043b\u043e\u0441\u0442\u043e\u043a",
      "longitude":72.7823507,
      "latitude":54.1684586
    },
    "2382":{
      "name":"\u0421\u0435\u0432\u0435\u0440\u043e-\u041b\u044e\u0431\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":72.790131,
      "latitude":55.194275
    },
    "2383":{
      "name":"\u0422\u0430\u0448\u0435\u0442\u043a\u0430\u043d\u044b",
      "longitude":72.7998727,
      "latitude":57.4085848
    },
    "2384":{
      "name":"\u0411\u0435\u043b\u043e\u0433\u0440\u0438\u0432\u043a\u0430",
      "longitude":72.8269699,
      "latitude":56.6260838
    },
    "2385":{
      "name":"\u0421\u0442\u0435\u043f\u043d\u043e\u0435",
      "longitude":72.827377,
      "latitude":55.031963
    },
    "2386":{
      "name":"\u041a\u0430\u0440\u0430-\u0422\u0435\u0440\u0435\u043a",
      "longitude":72.8398681,
      "latitude":54.8571661
    },
    "2387":{
      "name":"\u041a\u043e\u043d\u0435\u0437\u0430\u0432\u043e\u0434\u0441\u043a\u0438\u0439",
      "longitude":72.84861,
      "latitude":54.94849
    },
    "2388":{
      "name":"\u0413\u043e\u043b\u0435\u043d\u043a\u0438",
      "longitude":72.854859,
      "latitude":54.9175859
    },
    "2389":{
      "name":"\u041a\u043e\u0440\u0448\u0443\u043d\u043e\u0432\u043a\u0430",
      "longitude":72.867068,
      "latitude":56.0054012
    },
    "2390":{
      "name":"16 \u041f\u0430\u0440\u0442\u0441\u044a\u0435\u0437\u0434",
      "longitude":72.8756823,
      "latitude":55.098742
    },
    "2391":{
      "name":"\u0426\u0432\u0435\u0442\u043d\u043e\u043f\u043e\u043b\u044c\u0435",
      "longitude":72.876732,
      "latitude":54.490437
    },
    "2392":{
      "name":"\u0424\u0438\u0440\u0441\u0442\u043e\u0432\u043e",
      "longitude":72.8831184,
      "latitude":57.0391981
    },
    "2393":{
      "name":"\u0422\u0440\u0443\u0431\u0435\u0446\u043a\u043e\u0435",
      "longitude":72.902847,
      "latitude":54.609833
    },
    "2394":{
      "name":"\u0423\u0432\u0430\u043b\u043e-\u042f\u0434\u0440\u0438\u043d\u043e",
      "longitude":72.9051959,
      "latitude":55.3735474
    },
    "2395":{
      "name":"\u0421\u0435\u0433\u0438\u0437\u0431\u0430\u0439",
      "longitude":72.913513,
      "latitude":54.769199
    },
    "2396":{
      "name":"\u0415\u0440\u043c\u0438\u043b\u043e\u0432\u043a\u0430",
      "longitude":72.9146926,
      "latitude":57.6353162
    },
    "2397":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u042f\u0440",
      "longitude":72.923889,
      "latitude":55.240089
    },
    "2398":{
      "name":"\u041f\u044f\u0442\u0438\u043b\u0435\u0442\u043a\u0430",
      "longitude":72.9355863,
      "latitude":54.936873
    },
    "2399":{
      "name":"\u0424\u0451\u0434\u043e\u0440\u043e\u0432\u043a\u0430",
      "longitude":72.936684,
      "latitude":55.080925
    },
    "2400":{
      "name":"\u041a\u0430\u043c\u044b\u0448\u043b\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":72.9445483,
      "latitude":55.116098
    },
    "2401":{
      "name":"\u0420\u043e\u0437\u0430 \u0414\u043e\u043b\u0438\u043d\u0430",
      "longitude":72.946907,
      "latitude":54.473461
    },
    "2402":{
      "name":"\u041a\u0443\u0442\u044b\u0440\u043b\u044b",
      "longitude":72.9571301,
      "latitude":56.2055425
    },
    "2403":{
      "name":"\u0423\u0440\u0430\u043b\u044b",
      "longitude":72.9641197,
      "latitude":57.0711792
    },
    "2404":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":72.9649352,
      "latitude":55.6667083
    },
    "2405":{
      "name":"\u0411\u043e\u0440\u043e\u0434\u0438\u043d\u043a\u0430",
      "longitude":72.9696384,
      "latitude":57.4654737
    },
    "2406":{
      "name":"\u041f\u0440\u0438\u0432\u0430\u043b\u044c\u043d\u043e\u0435",
      "longitude":72.992996,
      "latitude":54.689003
    },
    "2407":{
      "name":"\u0411\u0430\u043a\u0448\u0435\u0435\u0432\u043e",
      "longitude":72.9967791,
      "latitude":57.4003186
    },
    "2408":{
      "name":"\u0410\u0432\u043b\u044b",
      "longitude":72.9981264,
      "latitude":55.3219567
    },
    "2409":{
      "name":"\u041b\u044e\u0431\u0438\u043d\u043e-\u041c\u0430\u043b\u043e\u0440\u043e\u0441\u0441\u044b",
      "longitude":73.000114,
      "latitude":55.202602
    },
    "2410":{
      "name":"\u0421\u0435\u0440\u0435\u0431\u0440\u043e\u043f\u043e\u043b\u044c\u0435",
      "longitude":73.012047,
      "latitude":54.434582
    },
    "2411":{
      "name":"\u0414\u041e\u041b \u0438\u043c. \u042e.\u0410. \u0413\u0430\u0433\u0430\u0440\u0438\u043d\u0430",
      "longitude":73.0196451,
      "latitude":55.2892572
    },
    "2412":{
      "name":"\u0427\u0435\u0440\u043d\u043e\u043b\u0443\u0447\u044c\u0435",
      "longitude":73.0239806,
      "latitude":55.2449588
    },
    "2413":{
      "name":"\u0411\u0430\u0437\u0430 \u043e\u0442\u0434\u044b\u0445\u0430 \"\u0418\u0440\u0442\u044b\u0448\"",
      "longitude":73.0275071,
      "latitude":55.2510929
    },
    "2414":{
      "name":"\u041b\u0443\u0437\u0438\u043d\u043e",
      "longitude":73.027802,
      "latitude":54.948967
    },
    "2415":{
      "name":"\u0427\u0435\u0440\u043d\u043e\u043b\u0443\u0447\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":73.028519,
      "latitude":55.282883
    },
    "2416":{
      "name":"\u041d\u043e\u0432\u043e\u0430\u0440\u0445\u0430\u043d\u0433\u0435\u043b\u043a\u0430",
      "longitude":73.0302731,
      "latitude":55.3527027
    },
    "2417":{
      "name":"\u041c\u0435\u043b\u044c\u043d\u0438\u0447\u043d\u043e\u0435",
      "longitude":73.0407741,
      "latitude":55.0240771
    },
    "2418":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u0432\u043a\u0430",
      "longitude":73.047379,
      "latitude":54.959862
    },
    "2419":{
      "name":"\u041f\u0440\u0435\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043e\u0432\u043a\u0430",
      "longitude":73.0488915,
      "latitude":55.5377711
    },
    "2420":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":73.0498824,
      "latitude":57.5800671
    },
    "2421":{
      "name":"\u041b\u0443\u043a\u044c\u044f\u043d\u043e\u0432\u043a\u0430",
      "longitude":73.0593247,
      "latitude":54.3133827
    },
    "2422":{
      "name":"\u041f\u0440\u0438\u0448\u0438\u0431",
      "longitude":73.065971,
      "latitude":54.432041
    },
    "2423":{
      "name":"\u041d\u043e\u0432\u043e\u0442\u0440\u043e\u0438\u0446\u043a",
      "longitude":73.067069,
      "latitude":55.7831711
    },
    "2424":{
      "name":"\u041c\u0438\u0440\u043d\u0430\u044f \u0414\u043e\u043b\u0438\u043d\u0430",
      "longitude":73.074554,
      "latitude":54.900494
    },
    "2425":{
      "name":"\u0427\u0435\u0431\u0430\u043a\u043b\u044b",
      "longitude":73.0751028,
      "latitude":57.0911705
    },
    "2426":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u043a\u0430",
      "longitude":73.075363,
      "latitude":54.795788
    },
    "2427":{
      "name":"\u041a\u0438\u0442\u0430\u0439\u043b\u044b",
      "longitude":73.0763272,
      "latitude":55.2182431
    },
    "2428":{
      "name":"\u0411\u0430\u0436\u0435\u043d\u043e\u0432\u043e",
      "longitude":73.0932523,
      "latitude":55.6331885
    },
    "2429":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u044f\u0440\u043a\u0430",
      "longitude":73.095306,
      "latitude":55.325813
    },
    "2430":{
      "name":"\u041f\u043e\u043f\u043e\u0432\u043a\u0430",
      "longitude":73.103104,
      "latitude":54.862507
    },
    "2431":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432 \u041c\u044b\u0441",
      "longitude":73.1069193,
      "latitude":57.3860515
    },
    "2432":{
      "name":"\u041a\u0443\u0434\u0443\u043a-\u0427\u0438\u043b\u0438\u043a",
      "longitude":73.1110626,
      "latitude":54.5085996
    },
    "2433":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u0430\u044f \u0413\u043e\u0440\u043a\u0430",
      "longitude":73.1218119,
      "latitude":55.125488
    },
    "2434":{
      "name":"\u0414\u0440\u0443\u0436\u0438\u043d\u043e",
      "longitude":73.1353452,
      "latitude":55.0201263
    },
    "2435":{
      "name":"\u041f\u0430\u0445\u043e\u043c\u043e\u0432\u043a\u0430",
      "longitude":73.144035,
      "latitude":54.677902
    },
    "2436":{
      "name":"\u0421\u043e\u0441\u043d\u043e\u0432\u043a\u0430",
      "longitude":73.1477928,
      "latitude":54.8169229
    },
    "2437":{
      "name":"\u0422\u0430\u0441\u043a\u0430\u0442\u043b\u044b",
      "longitude":73.1496386,
      "latitude":56.2406421
    },
    "2438":{
      "name":"\u0413\u043e\u0440\u044f\u0447\u0438\u0439 \u041a\u043b\u044e\u0447",
      "longitude":73.1508843,
      "latitude":55.0318045
    },
    "2439":{
      "name":"\u0412\u0435\u0440\u0431\u043b\u044e\u0436\u044c\u0435",
      "longitude":73.1548487,
      "latitude":55.3954732
    },
    "2440":{
      "name":"\u0411\u0443\u043d\u044f\u043a\u043e\u0432\u043a\u0430",
      "longitude":73.1603192,
      "latitude":54.131062
    },
    "2441":{
      "name":"\u0421\u043e\u0441\u043d\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":73.160698,
      "latitude":54.598995
    },
    "2442":{
      "name":"\u041f\u043e\u043b\u0438\u0442\u043e\u0442\u0434\u0435\u043b",
      "longitude":73.1609436,
      "latitude":55.2107482
    },
    "2443":{
      "name":"\u041d\u043e\u0432\u043e\u0442\u0440\u043e\u0438\u0446\u043a\u043e\u0435",
      "longitude":73.161186,
      "latitude":55.269352
    },
    "2444":{
      "name":"\u0414\u0435\u0441\u043f\u043e\u0434\u0437\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":73.1702605,
      "latitude":55.709365
    },
    "2445":{
      "name":"\u041a\u043e\u044f\u043d\u0431\u0430\u0439",
      "longitude":73.1729682,
      "latitude":54.4501384
    },
    "2446":{
      "name":"\u0420\u0435\u0431\u0440\u043e\u0432\u043a\u0430",
      "longitude":73.176346,
      "latitude":54.921623
    },
    "2447":{
      "name":"\u0411\u043b\u0430\u0433\u043e\u0434\u0430\u0440\u043e\u0432\u043a\u0430",
      "longitude":73.1813103,
      "latitude":54.0728605
    },
    "2448":{
      "name":"\u041f\u0440\u0438\u0432\u0435\u0442\u043d\u0430\u044f",
      "longitude":73.1905037,
      "latitude":54.9617136
    },
    "2449":{
      "name":"\u0425\u0430\u0440\u0438\u043d\u043e",
      "longitude":73.1947159,
      "latitude":55.1582
    },
    "2450":{
      "name":"\u0413\u0435\u043d\u0435\u0440\u0430\u043b\u043e\u0432\u043a\u0430",
      "longitude":73.198631,
      "latitude":54.24984
    },
    "2451":{
      "name":"\u0422\u0430\u0439\u0447\u0438",
      "longitude":73.2063277,
      "latitude":57.3285298
    },
    "2452":{
      "name":"\u041a\u043b\u044e\u0447\u0438",
      "longitude":73.2161244,
      "latitude":55.1539697
    },
    "2453":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u041a\u0430\u0440\u0431\u0443\u0448",
      "longitude":73.226563,
      "latitude":54.893501
    },
    "2454":{
      "name":"\u041d\u0438\u0436\u043d\u044f\u044f \u0418\u043b\u044c\u0438\u043d\u043a\u0430",
      "longitude":73.236115,
      "latitude":55.3786338
    },
    "2455":{
      "name":"\u041c\u0430\u0433\u0438\u0441\u0442\u0440\u0430\u043b\u044c\u043d\u044b\u0439",
      "longitude":73.243011,
      "latitude":54.928009
    },
    "2456":{
      "name":"\u041f\u0443\u0442\u0438\u043d\u0446\u0435\u0432\u043e",
      "longitude":73.249901,
      "latitude":54.79686
    },
    "2457":{
      "name":"\u041d\u0438\u0436\u043d\u0435\u0438\u0440\u0442\u044b\u0448\u0441\u043a\u043e\u0435",
      "longitude":73.2513897,
      "latitude":55.445982
    },
    "2458":{
      "name":"\u0417\u0435\u043b\u0451\u043d\u043e\u0435 \u041f\u043e\u043b\u0435",
      "longitude":73.2519294,
      "latitude":54.5218489
    },
    "2459":{
      "name":"\u041d\u0430\u0434\u0435\u0436\u0434\u0438\u043d\u043e",
      "longitude":73.2572752,
      "latitude":55.1942334
    },
    "2460":{
      "name":"\u0422\u0430\u043b\u0431\u0430\u043a\u0443\u043b\u044c",
      "longitude":73.2637681,
      "latitude":56.3503205
    },
    "2461":{
      "name":"\u0413\u0430\u043d\u043d\u043e\u0432\u043a\u0430",
      "longitude":73.2640887,
      "latitude":54.1086972
    },
    "2462":{
      "name":"\u041d\u0435\u0432\u0435\u0440\u043e\u0432\u043a\u0430",
      "longitude":73.2961905,
      "latitude":54.4574244
    },
    "2463":{
      "name":"\u0422\u0440\u043e\u0438\u0446\u043a\u043e\u0435",
      "longitude":73.296219,
      "latitude":54.858746
    },
    "2464":{
      "name":"\u041d\u043e\u0432\u043e\u043e\u043c\u0441\u043a\u0438\u0439",
      "longitude":73.299973,
      "latitude":54.841866
    },
    "2465":{
      "name":"\u041a\u0430\u043b\u0430\u0447\u0435\u0432\u043e",
      "longitude":73.3245357,
      "latitude":54.7678238
    },
    "2466":{
      "name":"\u041a\u0440\u0430\u0439\u0447\u0438\u043a\u043e\u0432\u043e",
      "longitude":73.3252131,
      "latitude":56.2686025
    },
    "2467":{
      "name":"\u041a\u0430\u043b\u0438\u043d\u0438\u043d\u043e",
      "longitude":73.3300684,
      "latitude":53.6216534
    },
    "2468":{
      "name":"\u041a\u043e\u0448\u043a\u0430\u0440\u0435\u0432\u043e",
      "longitude":73.330505,
      "latitude":54.742424
    },
    "2469":{
      "name":"\u0423\u0432\u0430\u043b\u044c\u043d\u0430\u044f \u0411\u0438\u0442\u0438\u044f",
      "longitude":73.3333903,
      "latitude":55.4905023
    },
    "2470":{
      "name":"\u0414\u0430\u0447\u043d\u044b\u0439",
      "longitude":73.346344,
      "latitude":55.251934
    },
    "2471":{
      "name":"\u041e\u043c\u0441\u043a\u0438\u0439",
      "longitude":73.3482544,
      "latitude":55.1042423
    },
    "2472":{
      "name":"\u041b\u0438\u043f\u043e\u0432 \u041a\u0443\u0442",
      "longitude":73.3644624,
      "latitude":54.2244444
    },
    "2473":{
      "name":"\u041a\u0440\u0443\u0447",
      "longitude":73.368927,
      "latitude":54.749557
    },
    "2474":{
      "name":"\u0417\u0432\u043e\u043d\u0430\u0440\u0451\u0432 \u041a\u0443\u0442",
      "longitude":73.372215,
      "latitude":54.691441
    },
    "2475":{
      "name":"\u0423\u0441\u0442\u044c-\u0428\u0438\u0448",
      "longitude":73.3777302,
      "latitude":57.3250962
    },
    "2476":{
      "name":"\u042e\u0440\u044c\u0435\u0432\u043a\u0430",
      "longitude":73.391388,
      "latitude":54.025852
    },
    "2477":{
      "name":"\u0413\u0430\u0443\u0444",
      "longitude":73.392029,
      "latitude":54.785969
    },
    "2478":{
      "name":"\u0411\u0435\u0440\u0435\u0437\u044f\u043d\u043a\u0430",
      "longitude":73.3966752,
      "latitude":55.1857769
    },
    "2479":{
      "name":"\u0411\u043e\u0433\u043e\u0434\u0443\u0445\u043e\u0432\u043a\u0430",
      "longitude":73.400829,
      "latitude":54.0784257
    },
    "2480":{
      "name":"\u0421\u0442\u0440\u043e\u043a\u0438\u043d\u043e",
      "longitude":73.4055615,
      "latitude":56.3653482
    },
    "2481":{
      "name":"\u041d\u043e\u0432\u043e\u0431\u0435\u043b\u043e\u0437\u0451\u0440\u043e\u0432\u043a\u0430",
      "longitude":73.4247063,
      "latitude":54.5829778
    },
    "2482":{
      "name":"\u0417\u0430\u0432\u044c\u044f\u043b\u043e\u0432\u043e",
      "longitude":73.4359584,
      "latitude":57.1461496
    },
    "2483":{
      "name":"\u041f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":73.4397136,
      "latitude":55.378315
    },
    "2484":{
      "name":"\u041b\u0435\u0436\u0430\u043d\u043a\u0430",
      "longitude":73.441528,
      "latitude":55.466969
    },
    "2485":{
      "name":"\u041f\u0443\u0448\u043a\u0438\u043d\u043e",
      "longitude":73.4717054,
      "latitude":55.0936844
    },
    "2486":{
      "name":"\u0429\u0435\u0440\u0431\u0430\u043a\u0438",
      "longitude":73.4730222,
      "latitude":56.0159916
    },
    "2487":{
      "name":"\u0425\u043b\u0435\u0431\u043e\u0434\u0430\u0440\u043e\u0432\u043a\u0430",
      "longitude":73.4765923,
      "latitude":53.7719396
    },
    "2488":{
      "name":"\u0427\u0435\u0440\u043d\u0438\u0433\u043e\u0432\u043a\u0430",
      "longitude":73.482519,
      "latitude":54.5879809
    },
    "2489":{
      "name":"\u0428\u0443\u0445\u043e\u0432\u043e",
      "longitude":73.4837348,
      "latitude":57.2346138
    },
    "2490":{
      "name":"\u042f\u0432\u043b\u0435\u043d\u043e-\u041f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":73.5123445,
      "latitude":54.1137072
    },
    "2491":{
      "name":"\u041d\u043e\u0432\u043e\u044f\u0433\u043e\u0434\u043d\u043e\u0435",
      "longitude":73.5136779,
      "latitude":57.3544341
    },
    "2492":{
      "name":"\u0420\u0430\u043a\u0438\u0442\u0438\u043d\u043a\u0430",
      "longitude":73.5187221,
      "latitude":54.896515
    },
    "2493":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u0435\u043b\u0435\u0446\u043a",
      "longitude":73.5223376,
      "latitude":54.6488492
    },
    "2494":{
      "name":"\u041a\u0430\u043c\u044b\u0448\u0438\u043d\u043e",
      "longitude":73.5269937,
      "latitude":54.7611064
    },
    "2495":{
      "name":"\u0425\u043e\u0440\u043e\u0448\u043a\u0438",
      "longitude":73.5285774,
      "latitude":54.2698973
    },
    "2496":{
      "name":"\u0411\u0435\u043b\u043e\u0443\u0441\u043e\u0432\u043a\u0430",
      "longitude":73.5329823,
      "latitude":54.0458087
    },
    "2497":{
      "name":"\u041d\u043e\u0432\u043e\u043c\u043e\u0441\u043a\u043e\u0432\u043a\u0430",
      "longitude":73.5362153,
      "latitude":55.0197659
    },
    "2498":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u0432\u043a\u0430",
      "longitude":73.5443615,
      "latitude":55.2565045
    },
    "2499":{
      "name":"\u041c\u043e\u0440\u043e\u0437\u043e\u0432\u043a\u0430",
      "longitude":73.545181,
      "latitude":54.924221
    },
    "2500":{
      "name":"\u041f\u043e\u0434\u0433\u043e\u0440\u043e\u0434\u043a\u0430",
      "longitude":73.5482295,
      "latitude":55.1439936
    },
    "2501":{
      "name":"\u0412\u0435\u0441\u0451\u043b\u044b\u0435 \u0420\u043e\u0449\u0438",
      "longitude":73.5493018,
      "latitude":54.518023
    },
    "2502":{
      "name":"\u0421\u043b\u043e\u0431\u043e\u0434\u0430",
      "longitude":73.5549886,
      "latitude":57.1255926
    },
    "2503":{
      "name":"\u042f\u0441\u043d\u0430\u044f \u041f\u043e\u043b\u044f\u043d\u0430",
      "longitude":73.566063,
      "latitude":54.312298
    },
    "2504":{
      "name":"\u041b\u044e\u0431\u043e\u043c\u0438\u0440\u043e\u0432\u043a\u0430",
      "longitude":73.5752977,
      "latitude":54.4363048
    },
    "2505":{
      "name":"\u0413\u043b\u0438\u043d\u043a\u0438\u043d\u043e",
      "longitude":73.5796507,
      "latitude":54.2662278
    },
    "2506":{
      "name":"\u0425\u0432\u043e\u0439\u043d\u044b\u0439",
      "longitude":73.5807548,
      "latitude":55.1095636
    },
    "2507":{
      "name":"\u0420\u043e\u0441\u0442\u043e\u0432\u043a\u0430",
      "longitude":73.580765,
      "latitude":55.019558
    },
    "2508":{
      "name":"\u0418\u0440\u0442\u044b\u0448\u0441\u043a\u0438\u0439",
      "longitude":73.5873907,
      "latitude":54.8163172
    },
    "2509":{
      "name":"\u041e\u043a\u0442\u044f\u0431\u0440\u044c\u0441\u043a\u043e\u0435",
      "longitude":73.5989288,
      "latitude":55.5544981
    },
    "2510":{
      "name":"\u0423\u0441\u0442\u044c-\u0417\u0430\u043e\u0441\u0442\u0440\u043e\u0432\u043a\u0430",
      "longitude":73.603821,
      "latitude":54.762009
    },
    "2511":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u041f\u0443\u0442\u044c",
      "longitude":73.6083506,
      "latitude":55.6448954
    },
    "2512":{
      "name":"\u0425\u043e\u0445\u043b\u043e\u0432\u043e",
      "longitude":73.6187995,
      "latitude":55.8765953
    },
    "2513":{
      "name":"\u0425\u0430\u0440\u043b\u0430\u043c\u043e\u0432\u043e",
      "longitude":73.621384,
      "latitude":54.689373
    },
    "2514":{
      "name":"\u0410\u043d\u0434\u0440\u0435\u0435\u0432\u043a\u0430",
      "longitude":73.6241327,
      "latitude":55.0438666
    },
    "2515":{
      "name":"\u0438\u043c\u0435\u043d\u0438 \u041a\u043e\u043c\u0438\u0441\u0441\u0430\u0440\u043e\u0432\u0430",
      "longitude":73.6377101,
      "latitude":54.7341958
    },
    "2516":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u0430\u043d\u0436\u0430\u0440\u043e\u0432\u043a\u0430",
      "longitude":73.644697,
      "latitude":53.6703959
    },
    "2517":{
      "name":"\u041e\u043a\u0442\u044f\u0431\u0440\u044c\u0441\u043a\u0438\u0439",
      "longitude":73.6513155,
      "latitude":54.9228823
    },
    "2518":{
      "name":"\u0427\u0435\u0440\u0435\u0434\u043e\u0432\u043e",
      "longitude":73.655572,
      "latitude":57.0152034
    },
    "2519":{
      "name":"\u041c\u0438\u043b\u043e\u0433\u0440\u0430\u0434\u043e\u0432\u043a\u0430",
      "longitude":73.6688491,
      "latitude":54.0943349
    },
    "2520":{
      "name":"\u0423\u043b\u044c\u044f\u043d\u043e\u0432\u043a\u0430",
      "longitude":73.6713836,
      "latitude":54.9713973
    },
    "2521":{
      "name":"\u0411\u043e\u0440\u043e\u0434\u0438\u043d\u043a\u0430",
      "longitude":73.678169,
      "latitude":55.298382
    },
    "2522":{
      "name":"\u0420\u043e\u0437\u043e\u0432\u043a\u0430",
      "longitude":73.6784938,
      "latitude":54.7091528
    },
    "2523":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":73.687264,
      "latitude":55.6746903
    },
    "2524":{
      "name":"\u0421\u0442\u0440\u0435\u043b\u0430",
      "longitude":73.701393,
      "latitude":54.570621
    },
    "2525":{
      "name":"\u0410\u043d\u0434\u0440\u0435\u0435\u0432\u0441\u043a\u0438\u0439",
      "longitude":73.7110231,
      "latitude":55.091936
    },
    "2526":{
      "name":"\u0421\u0435\u0440\u0435\u0431\u0440\u044f\u043a\u043e\u0432\u043a\u0430",
      "longitude":73.7214323,
      "latitude":54.8683788
    },
    "2527":{
      "name":"\u041b\u043e\u0433\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":73.7300194,
      "latitude":54.2773346
    },
    "2528":{
      "name":"\u0411\u043e\u0433\u043e\u0441\u043b\u043e\u0432\u043a\u0430",
      "longitude":73.730513,
      "latitude":55.0332885
    },
    "2529":{
      "name":"\u041a\u0430\u0440\u043f\u043e\u0432\u043a\u0430",
      "longitude":73.737312,
      "latitude":54.510391
    },
    "2530":{
      "name":"\u0411\u043e\u0436\u0435\u0434\u0430\u0440\u043e\u0432\u043a\u0430",
      "longitude":73.7443866,
      "latitude":54.1857287
    },
    "2531":{
      "name":"\u0421\u0435\u043c\u044f\u043d\u043e\u0432\u043a\u0430",
      "longitude":73.7517396,
      "latitude":54.2653759
    },
    "2532":{
      "name":"\u0421\u0435\u043c\u0451\u043d\u043e\u0432\u043a\u0430",
      "longitude":73.752472,
      "latitude":57.137356
    },
    "2533":{
      "name":"\u041a\u0430\u043b\u0438\u043d\u0438\u043d\u043e",
      "longitude":73.7539052,
      "latitude":54.8544562
    },
    "2534":{
      "name":"\u0410\u043b\u0430\u0431\u043e\u0442\u0430",
      "longitude":73.76545,
      "latitude":53.950451
    },
    "2535":{
      "name":"\u041a\u043e\u043f\u0435\u0439\u043a\u0438\u043d\u043e",
      "longitude":73.7692831,
      "latitude":54.6480244
    },
    "2536":{
      "name":"\u041d\u043e\u0432\u043e\u043b\u043e\u0433\u0438\u043d\u043e\u0432\u043e",
      "longitude":73.7750465,
      "latitude":56.4950006
    },
    "2537":{
      "name":"\u0414\u0435\u043c\u044c\u044f\u043d\u043e\u0432\u043a\u0430",
      "longitude":73.788361,
      "latitude":55.420059
    },
    "2538":{
      "name":"\u041d\u0430\u0431\u0435\u0440\u0435\u0436\u043d\u044b\u0439",
      "longitude":73.7905504,
      "latitude":54.6681758
    },
    "2539":{
      "name":"\u0420\u0435\u0447\u043d\u043e\u0439",
      "longitude":73.8043231,
      "latitude":54.6746019
    },
    "2540":{
      "name":"\u0421\u043e\u0443\u0441\u043a\u0430\u043d\u043e\u0432\u043e",
      "longitude":73.8258763,
      "latitude":56.9773113
    },
    "2541":{
      "name":"\u0414\u0435\u0432\u044f\u0442\u0435\u0440\u0438\u043a\u043e\u0432\u043a\u0430",
      "longitude":73.827072,
      "latitude":55.252132
    },
    "2542":{
      "name":"\u0410\u043d\u0434\u0440\u0435\u0435\u0432\u043a\u0430",
      "longitude":73.8272932,
      "latitude":55.7171135
    },
    "2543":{
      "name":"\u041b\u0430\u043c\u0430\u043d\u043e\u0432\u043e",
      "longitude":73.8312402,
      "latitude":56.2923599
    },
    "2544":{
      "name":"\u0422\u0438\u0445\u0432\u0438\u043d\u043a\u0430",
      "longitude":73.831848,
      "latitude":54.357952
    },
    "2545":{
      "name":"\u041a\u0430\u0447\u0443\u043a\u043e\u0432\u043e",
      "longitude":73.8409778,
      "latitude":57.1976057
    },
    "2546":{
      "name":"\u0411\u0440\u0430\u0436\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":73.8420362,
      "latitude":56.5122174
    },
    "2547":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u043a\u0430",
      "longitude":73.8658585,
      "latitude":55.9185677
    },
    "2548":{
      "name":"\u0410\u0447\u0430\u0438\u0440",
      "longitude":73.872101,
      "latitude":54.659481
    },
    "2549":{
      "name":"\u041b\u043e\u0436\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":73.8760305,
      "latitude":56.8922654
    },
    "2550":{
      "name":"\u0421\u0442\u0435\u043f\u043d\u043e\u0435",
      "longitude":73.8775629,
      "latitude":54.0470656
    },
    "2551":{
      "name":"\u0427\u0435\u0431\u0430\u043a\u043b\u044b",
      "longitude":73.8781295,
      "latitude":55.966574
    },
    "2552":{
      "name":"\u0421\u044b\u0440\u043e\u043f\u044f\u0442\u0441\u043a\u043e\u0435",
      "longitude":73.87896,
      "latitude":55.047356
    },
    "2553":{
      "name":"\u041d\u0435\u043c\u0438\u0440\u043e\u0432\u043a\u0430",
      "longitude":73.8813686,
      "latitude":54.9249982
    },
    "2554":{
      "name":"\u0413\u0435\u043e\u0440\u0433\u0438\u0435\u0432\u043a\u0430",
      "longitude":73.8823909,
      "latitude":55.5842965
    },
    "2555":{
      "name":"\u0421\u043e\u043b\u043d\u0435\u0447\u043d\u043e\u0435",
      "longitude":73.8909611,
      "latitude":53.7716707
    },
    "2556":{
      "name":"\u041b\u0443\u0433\u043e\u0432\u043e\u0435",
      "longitude":73.8990815,
      "latitude":54.6216188
    },
    "2557":{
      "name":"\u0410\u043d\u0438\u043a\u0438\u043d\u043e",
      "longitude":73.901282,
      "latitude":56.5301607
    },
    "2558":{
      "name":"\u041a\u0438\u0441\u0435\u043b\u0435\u0432\u043e",
      "longitude":73.9037177,
      "latitude":57.1183895
    },
    "2559":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":73.9114429,
      "latitude":55.1499097
    },
    "2560":{
      "name":"\u0421\u0443\u0445\u043e\u0435",
      "longitude":73.929,
      "latitude":55.4241771
    },
    "2561":{
      "name":"\u041f\u0430\u0432\u043b\u043e\u0434\u0430\u0440\u043e\u0432\u043a\u0430",
      "longitude":73.9400741,
      "latitude":55.2657876
    },
    "2562":{
      "name":"\u0427\u0430\u043f\u0430\u0435\u0432\u043e",
      "longitude":73.9463044,
      "latitude":56.2279346
    },
    "2563":{
      "name":"\u0411\u043e\u0433\u0434\u0430\u043d\u043e\u0432\u043e",
      "longitude":73.9595605,
      "latitude":55.7008813
    },
    "2564":{
      "name":"\u041a\u043e\u0440\u0441\u0438\u043d\u043e",
      "longitude":73.9636934,
      "latitude":56.5700214
    },
    "2565":{
      "name":"\u0420\u0430\u0437\u0434\u043e\u043b\u044c\u043d\u043e\u0435",
      "longitude":73.9676678,
      "latitude":54.08555
    },
    "2566":{
      "name":"\u0412\u0441\u0442\u0430\u0432\u0441\u043a\u043e\u0435",
      "longitude":73.9701981,
      "latitude":56.8592035
    },
    "2567":{
      "name":"\u0411\u043e\u043b\u043e\u0433\u043e\u0435",
      "longitude":73.9783741,
      "latitude":53.8524384
    },
    "2568":{
      "name":"\u0427\u0435\u0440\u043d\u0438\u0433\u043e\u0432\u043a\u0430",
      "longitude":73.996826,
      "latitude":54.879818
    },
    "2569":{
      "name":"\u0410\u0447\u0430\u0438\u0440\u0441\u043a\u0438\u0439",
      "longitude":73.9995788,
      "latitude":54.6052535
    },
    "2570":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0438\u0435 \u0422\u0443\u0440\u0430\u043b\u044b",
      "longitude":74.0008169,
      "latitude":56.7552857
    },
    "2571":{
      "name":"\u042e\u0436\u043d\u043e\u0435",
      "longitude":74.021515,
      "latitude":54.008953
    },
    "2572":{
      "name":"\u0411\u043e\u0440\u043a\u0438",
      "longitude":74.031397,
      "latitude":55.026563
    },
    "2573":{
      "name":"\u041e\u0442\u0434\u0435\u043b\u0435\u043d\u0438\u0435 \u2116 1 \u041e\u043f\u044b\u0442\u043d\u043e\u0433\u043e \u0425\u043e\u0437\u044f",
      "longitude":74.032688,
      "latitude":54.4399238
    },
    "2574":{
      "name":"\u0422\u0440\u0443\u0431\u0447\u0435\u0432\u043a\u0430",
      "longitude":74.0340301,
      "latitude":55.8485774
    },
    "2575":{
      "name":"\u0411\u0435\u043b\u044c\u0441\u0435\u043d\u0434\u044b-\u041a\u0430\u0437\u0430\u0445",
      "longitude":74.0354467,
      "latitude":55.3569066
    },
    "2576":{
      "name":"\u041d\u043e\u0432\u043e\u043f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":74.0371135,
      "latitude":55.7091335
    },
    "2577":{
      "name":"\u0427\u0435\u0440\u043d\u043e\u0433\u043b\u0430\u0437\u043e\u0432\u043a\u0430",
      "longitude":74.03884,
      "latitude":54.345721
    },
    "2578":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":74.0393759,
      "latitude":55.5200461
    },
    "2579":{
      "name":"\u0420\u043e\u0442\u043e\u0432\u043a\u0430",
      "longitude":74.0451489,
      "latitude":53.7764079
    },
    "2580":{
      "name":"\u0426\u0432\u0435\u0442\u043e\u0447\u043d\u043e\u0435",
      "longitude":74.0494306,
      "latitude":53.6640958
    },
    "2581":{
      "name":"\u041f\u0430\u0448\u0435\u043d\u043d\u0430\u044f \u0420\u043e\u0449\u0430",
      "longitude":74.06200301743044,
      "latitude":54.207753397701204
    },
    "2582":{
      "name":"\u041f\u043e\u0431\u0435\u0434\u0438\u0442\u0435\u043b\u044c",
      "longitude":74.067703,
      "latitude":54.779404
    },
    "2583":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u0441\u043a\u0438\u0439",
      "longitude":74.0683806,
      "latitude":55.5366778
    },
    "2584":{
      "name":"\u0422\u0438\u0445\u043e\u0440\u0435\u0446\u043a\u043e\u0435",
      "longitude":74.0708305,
      "latitude":54.4114708
    },
    "2585":{
      "name":"\u041e\u0440\u043b\u043e\u0432\u043e",
      "longitude":74.0722808,
      "latitude":56.6600964
    },
    "2586":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u043a\u0430\u0440\u0430\u0441\u0443\u043a",
      "longitude":74.0745873,
      "latitude":55.810663
    },
    "2587":{
      "name":"\u0411\u0443\u0442\u0430\u043a\u043e\u0432\u043e",
      "longitude":74.086128,
      "latitude":57.047527
    },
    "2588":{
      "name":"\u0416\u0430\u0442\u0432\u0430",
      "longitude":74.086449,
      "latitude":54.360023
    },
    "2589":{
      "name":"\u041f\u0440\u0438\u0438\u0440\u0442\u044b\u0448\u044c\u0435",
      "longitude":74.094917,
      "latitude":54.533592
    },
    "2590":{
      "name":"\u041d\u043e\u0432\u043e\u0443\u0440\u0430\u043b\u044c\u0441\u043a\u0438\u0439",
      "longitude":74.125267,
      "latitude":54.360226
    },
    "2591":{
      "name":"\u041d\u0435\u043a\u0440\u0430\u0441\u043e\u0432\u043a\u0430",
      "longitude":74.1270663,
      "latitude":54.8874579
    },
    "2592":{
      "name":"\u0420\u043e\u0449\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":74.1335629,
      "latitude":55.1050751
    },
    "2593":{
      "name":"\u041f\u043e\u043a\u0440\u043e\u0432\u043e-\u0418\u0440\u0442\u044b\u0448\u0441\u043a\u043e\u0435",
      "longitude":74.1438107,
      "latitude":54.5574578
    },
    "2594":{
      "name":"\u0411\u043e\u0433\u0434\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":74.1458855,
      "latitude":55.0377849
    },
    "2595":{
      "name":"\u041f\u043e\u043b\u043e\u0433\u0440\u0443\u0434\u043e\u0432\u043e",
      "longitude":74.162514,
      "latitude":57.117008
    },
    "2596":{
      "name":"\u0421\u043e\u0441\u043d\u043e\u0432\u043a\u0430",
      "longitude":74.1708238,
      "latitude":54.9234385
    },
    "2597":{
      "name":"\u0421\u044f\u0433\u0430\u0435\u0432\u043a\u0430",
      "longitude":74.1740351,
      "latitude":55.6106434
    },
    "2598":{
      "name":"\u041c\u0430\u043a\u0441\u0438\u043c\u0430 \u0413\u043e\u0440\u044c\u043a\u043e\u0433\u043e",
      "longitude":74.1846033,
      "latitude":57.0970238
    },
    "2599":{
      "name":"\u042e\u0440\u044c\u0435\u0432\u043e",
      "longitude":74.199768,
      "latitude":55.154942
    },
    "2600":{
      "name":"\u041d\u043e\u0432\u043e\u0443\u0440\u0430\u043b\u044c\u0441\u043a\u043e\u0435",
      "longitude":74.2081151,
      "latitude":54.2471668
    },
    "2601":{
      "name":"\u0418\u043d\u0433\u0430\u043b\u044b",
      "longitude":74.2191009,
      "latitude":55.8483434
    },
    "2602":{
      "name":"\u0423\u043b\u0435\u043d\u043a\u0443\u043b\u044c",
      "longitude":74.2253828,
      "latitude":56.3528608
    },
    "2603":{
      "name":"\u0411\u0430\u0441-\u0410\u0433\u0430\u0448",
      "longitude":74.2358813,
      "latitude":53.9080133
    },
    "2604":{
      "name":"\u0420\u043e\u0449\u0438\u043d\u043e",
      "longitude":74.2371879,
      "latitude":55.4562027
    },
    "2605":{
      "name":"\u0411\u043e\u0431\u0440\u0438\u043d\u043a\u0430",
      "longitude":74.2379083,
      "latitude":54.1192051
    },
    "2606":{
      "name":"\u0423\u0434\u0430\u0440\u043d\u044b\u0439",
      "longitude":74.2394801,
      "latitude":55.1874116
    },
    "2607":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u0430\u044f \u041f\u043e\u043b\u044f\u043d\u0430",
      "longitude":74.2402578,
      "latitude":55.2723517
    },
    "2608":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u0435\u043b\u044c\u0435",
      "longitude":74.243912,
      "latitude":54.867672
    },
    "2609":{
      "name":"\u0414\u043e\u0431\u0440\u043e\u0432\u043e\u043b\u044c\u0441\u043a",
      "longitude":74.2520587,
      "latitude":53.6439885
    },
    "2610":{
      "name":"\u0411\u0430\u0439\u0434\u0430\u043b\u0438\u043d",
      "longitude":74.2639241,
      "latitude":54.3923846
    },
    "2611":{
      "name":"\u0427\u0435\u043a\u0440\u0443\u0448\u0435\u0432\u043e",
      "longitude":74.269045,
      "latitude":56.9199865
    },
    "2612":{
      "name":"2-\u044f \u0424\u043e\u043c\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":74.270332,
      "latitude":54.801914
    },
    "2613":{
      "name":"\u0410\u0442\u0438\u0440\u043a\u0430",
      "longitude":74.2723217,
      "latitude":57.2542208
    },
    "2614":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":74.276314,
      "latitude":54.761314
    },
    "2615":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0435\u0438\u043b\u044c\u0438\u043d\u043a\u0430",
      "longitude":74.283791,
      "latitude":54.542915
    },
    "2616":{
      "name":"\u0413\u0435\u043e\u0440\u0433\u0438\u0435\u0432\u043a\u0430",
      "longitude":74.302216,
      "latitude":55.073986
    },
    "2617":{
      "name":"\u041a\u043e\u043b\u044c\u0442\u044e\u0433\u0438\u043d\u043e",
      "longitude":74.3112889,
      "latitude":56.6881115
    },
    "2618":{
      "name":"\u0426\u0435\u043b\u0438\u043d\u043d\u043e\u0435",
      "longitude":74.3150849,
      "latitude":53.9496295
    },
    "2619":{
      "name":"\u041a\u0443\u0440\u043d\u043e\u0441\u043e\u0432\u043e",
      "longitude":74.3158147,
      "latitude":56.1226815
    },
    "2620":{
      "name":"\u0421\u0435\u0440\u0435\u0431\u0440\u044f\u043d\u043e\u0435",
      "longitude":74.329918,
      "latitude":55.707008
    },
    "2621":{
      "name":"\u0421\u0438\u0431\u0438\u0440\u0441\u043a\u043e\u0435",
      "longitude":74.3361003,
      "latitude":53.7375484
    },
    "2622":{
      "name":"\u041f\u0440\u0438\u0441\u0442\u0430\u043d\u0441\u043a\u043e\u0435",
      "longitude":74.3458071,
      "latitude":54.4662964
    },
    "2623":{
      "name":"\u0421\u0430\u043c\u0441\u043e\u043d\u043e\u0432\u043e",
      "longitude":74.352623,
      "latitude":56.973103
    },
    "2624":{
      "name":"\u0421\u043b\u0430\u0432\u044f\u043d\u043a\u0430",
      "longitude":74.5290353,
      "latitude":54.1794225
    },
    "2625":{
      "name":"\u0418\u0440\u0442\u044b\u0448",
      "longitude":74.377518,
      "latitude":54.488911
    },
    "2626":{
      "name":"\u0420\u044f\u043c\u043e\u0432\u043a\u0430",
      "longitude":74.3794993,
      "latitude":55.9858453
    },
    "2627":{
      "name":"\u0412\u0435\u0441\u0435\u043b\u044b\u0439 \u041f\u0440\u0438\u0432\u0430\u043b",
      "longitude":74.3836522,
      "latitude":54.8778883
    },
    "2628":{
      "name":"\u042f\u0433\u043e\u0442\u043e\u0432\u043e",
      "longitude":74.3937285,
      "latitude":56.4059867
    },
    "2629":{
      "name":"\u0418\u043d\u0434\u0435\u0439\u043a\u0430",
      "longitude":74.416342,
      "latitude":54.9622635
    },
    "2630":{
      "name":"\u041c\u043e\u0433\u0438\u043b\u044c\u043d\u043e-\u0421\u0442\u0430\u0440\u043e\u0436\u0438\u043b\u044c\u0441\u043a",
      "longitude":74.4198465,
      "latitude":55.9017305
    },
    "2631":{
      "name":"\u041c\u043e\u0433\u0438\u043b\u044c\u043d\u043e-\u041f\u043e\u0441\u0435\u043b\u044c\u0441\u043a\u043e\u0435",
      "longitude":74.4334901,
      "latitude":55.9083403
    },
    "2632":{
      "name":"\u0410\u0441\u0442\u044b\u0440\u043e\u0432\u043a\u0430",
      "longitude":74.4340215,
      "latitude":55.3602984
    },
    "2633":{
      "name":"\u0411\u0435\u0440\u0434\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":74.4371679,
      "latitude":54.4135551
    },
    "2634":{
      "name":"\u041a\u0443\u043b\u0438\u043a\u043e\u0432\u043e",
      "longitude":74.454369,
      "latitude":55.044426
    },
    "2635":{
      "name":"\u041f\u043e\u0447\u0435\u043a\u0443\u0435\u0432\u043e",
      "longitude":74.4623073,
      "latitude":56.5161028
    },
    "2636":{
      "name":"\u0426\u0430\u0440\u0438\u0446\u044b\u043d\u043e",
      "longitude":74.4886687,
      "latitude":54.8271764
    },
    "2637":{
      "name":"\u041f\u043e\u0431\u0435\u0434\u0430",
      "longitude":74.4895861,
      "latitude":54.0492697
    },
    "2638":{
      "name":"\u041f\u0430\u0443\u0442\u043e\u0432\u043a\u0430",
      "longitude":74.4933324,
      "latitude":55.4906272
    },
    "2639":{
      "name":"\u0427\u0435\u0440\u043b\u0430\u043a\u0441\u043a\u043e\u0435",
      "longitude":74.503654,
      "latitude":53.778271
    },
    "2640":{
      "name":"\u0424\u0440\u0443\u043d\u0437\u0435",
      "longitude":74.5089106,
      "latitude":56.825578
    },
    "2641":{
      "name":"\u0411\u0430\u0436\u0435\u043d\u043e\u0432\u043e",
      "longitude":74.5114792,
      "latitude":57.0583458
    },
    "2642":{
      "name":"\u0417\u0430\u043b\u0438\u0432\u0438\u043d\u043e",
      "longitude":74.513741,
      "latitude":56.792255
    },
    "2643":{
      "name":"\u041c\u0430\u0440\u0442\u044e\u0448\u0435\u0432\u043e",
      "longitude":74.5159246,
      "latitude":57.1167445
    },
    "2644":{
      "name":"\u0427\u0435\u0440\u043d\u044f\u0435\u0432\u043e",
      "longitude":74.5227973,
      "latitude":56.694627
    },
    "2645":{
      "name":"\u0421\u0435\u043c\u0451\u043d\u043e\u0432\u043a\u0430",
      "longitude":74.5228383,
      "latitude":54.6244092
    },
    "2646":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u0434\u0443\u0431\u043a\u0430",
      "longitude":74.5304652,
      "latitude":55.0783064
    },
    "2647":{
      "name":"\u041a\u0430\u0440\u0430\u0437\u044e\u043a",
      "longitude":74.554817,
      "latitude":54.070599
    },
    "2648":{
      "name":"\u0420\u0443\u0441\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":74.5559422,
      "latitude":54.1256557
    },
    "2649":{
      "name":"\u0411\u043e\u0442\u0432\u0438\u043d\u043e",
      "longitude":74.5561653,
      "latitude":56.2806931
    },
    "2650":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u043c\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":74.563553,
      "latitude":55.857418
    },
    "2651":{
      "name":"\u0418\u043c\u0448\u0435\u0433\u0430\u043b",
      "longitude":74.564835,
      "latitude":57.355339
    },
    "2652":{
      "name":"\u0428\u0438\u043f\u0438\u0446\u044b\u043d\u043e",
      "longitude":74.5666183,
      "latitude":56.0173564
    },
    "2653":{
      "name":"\u0415\u043a\u0430\u0442\u0435\u0440\u0438\u043d\u0438\u043d\u0441\u043a\u043e\u0435",
      "longitude":74.579773,
      "latitude":56.877277
    },
    "2654":{
      "name":"\u0417\u0430\u0440\u0435\u0447\u043d\u043e\u0435",
      "longitude":74.588073,
      "latitude":54.3254404
    },
    "2655":{
      "name":"\u041c\u0435\u0436\u0434\u0443\u0440\u0435\u0447\u044c\u0435",
      "longitude":74.5925199,
      "latitude":56.8168164
    },
    "2656":{
      "name":"\u041e\u0441\u043e\u043a\u0438\u043d\u043e",
      "longitude":74.6105563,
      "latitude":54.8917533
    },
    "2657":{
      "name":"\u0421\u043e\u043b\u044f\u043d\u043e\u0435",
      "longitude":74.6130458,
      "latitude":54.3722162
    },
    "2658":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u042f\u0440",
      "longitude":74.6132038,
      "latitude":56.1456048
    },
    "2659":{
      "name":"\u041d\u043e\u0432\u043e\u043b\u043e\u0433\u0438\u043d\u043e\u0432\u043e",
      "longitude":74.6132405,
      "latitude":56.5815935
    },
    "2660":{
      "name":"\u0412\u043e\u0441\u043a\u0440\u0435\u0441\u0435\u043d\u043a\u0430",
      "longitude":74.620895,
      "latitude":55.083611
    },
    "2661":{
      "name":"\u0422\u0443\u0440\u0433\u0435\u043d\u0435\u0432\u043a\u0430",
      "longitude":74.6319049,
      "latitude":55.0738054
    },
    "2662":{
      "name":"\u0418\u0437\u0443\u043c\u0440\u0443\u0434\u043d\u043e\u0435",
      "longitude":74.6366754,
      "latitude":54.2182217
    },
    "2663":{
      "name":"\u0412\u0435\u043b\u0438\u043a\u043e\u0440\u0443\u0441\u0441\u043a\u043e\u0435",
      "longitude":74.637012,
      "latitude":54.6520171
    },
    "2664":{
      "name":"\u0410\u0442\u0430\u043a",
      "longitude":74.6411715,
      "latitude":56.8041697
    },
    "2665":{
      "name":"\u041a\u0435\u0434\u0440\u043e\u0432\u044b\u0439",
      "longitude":74.646722,
      "latitude":57.3718194
    },
    "2666":{
      "name":"\u0413\u0440\u0438\u043d\u0441\u043a\u043e\u0435",
      "longitude":74.6499746,
      "latitude":54.3152145
    },
    "2667":{
      "name":"\u0423\u0441\u0442\u044c-\u0422\u0430\u0440\u0430",
      "longitude":74.6550321,
      "latitude":56.6741209
    },
    "2668":{
      "name":"\u041d\u043e\u0432\u043e\u0440\u043e\u0441\u0441\u0438\u0439\u043a\u0430",
      "longitude":74.6691203,
      "latitude":54.1143205
    },
    "2669":{
      "name":"\u0415\u0432\u0433\u0430\u0449\u0438\u043d\u043e",
      "longitude":74.675644,
      "latitude":56.424458
    },
    "2670":{
      "name":"\u0414\u0440\u043e\u0431\u044b\u0448\u0435\u0432\u043e",
      "longitude":74.6757916,
      "latitude":53.9862578
    },
    "2671":{
      "name":"\u0415\u043b\u0438\u0437\u0430\u0432\u0435\u0442\u0438\u043d\u043a\u0430",
      "longitude":74.6765646,
      "latitude":54.2591971
    },
    "2672":{
      "name":"\u0422\u0430\u043a\u043c\u044b\u043a",
      "longitude":74.6833556,
      "latitude":56.2496044
    },
    "2673":{
      "name":"\u0420\u0435\u0448\u0435\u0442\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":74.702164,
      "latitude":56.298401
    },
    "2674":{
      "name":"\u0413\u043b\u0443\u0445\u043e\u0432\u043a\u0430",
      "longitude":74.71199,
      "latitude":55.086632
    },
    "2675":{
      "name":"\u0415\u0440\u043c\u0430\u043a\u043e\u0432\u043a\u0430",
      "longitude":74.7205637,
      "latitude":57.0418938
    },
    "2676":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u042f\u0440",
      "longitude":74.7238311,
      "latitude":54.1408184
    },
    "2677":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u0432\u043a\u0430",
      "longitude":74.7366598,
      "latitude":55.1004626
    },
    "2678":{
      "name":"\u041a\u0430\u0440\u0442\u0430\u0448\u043e\u0432\u043e",
      "longitude":74.7385314,
      "latitude":56.1168745
    },
    "2679":{
      "name":"\u0412\u0430\u0441\u0438\u0441\u0441",
      "longitude":74.7436822,
      "latitude":57.3601876
    },
    "2680":{
      "name":"\u0410\u0440\u0442\u044b\u043d",
      "longitude":74.751274,
      "latitude":56.152332
    },
    "2681":{
      "name":"\u0420\u0435\u043f\u0438\u043d\u043a\u0430",
      "longitude":74.7527586,
      "latitude":54.6041389
    },
    "2682":{
      "name":"\u041f\u0440\u0438\u0432\u043e\u043b\u044c\u043d\u043e\u0435",
      "longitude":74.7598872,
      "latitude":54.4145638
    },
    "2683":{
      "name":"\u0421\u0438\u0442\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":74.7834049,
      "latitude":55.6656041
    },
    "2684":{
      "name":"\u0411\u043e\u0433\u0434\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":74.7848032,
      "latitude":54.0881767
    },
    "2685":{
      "name":"\u0417\u043e\u043b\u043e\u0442\u0443\u0445\u0438\u043d\u043e",
      "longitude":74.7954851,
      "latitude":54.4322986
    },
    "2686":{
      "name":"\u041f\u0443\u0442\u044c \u041b\u0435\u043d\u0438\u043d\u0430",
      "longitude":74.804802,
      "latitude":54.248398
    },
    "2687":{
      "name":"\u0421\u043e\u0440\u043e\u0447\u0438\u043d\u043e",
      "longitude":74.8115811,
      "latitude":55.1094965
    },
    "2688":{
      "name":"\u041b\u0430\u0433\u0443\u0448\u0438\u043d\u043e",
      "longitude":74.8251618,
      "latitude":54.9454408
    },
    "2689":{
      "name":"\u0421\u043c\u0438\u0440\u043d\u043e\u0432\u043a\u0430",
      "longitude":74.8342962,
      "latitude":55.4762504
    },
    "2690":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":74.8532078,
      "latitude":53.9720607
    },
    "2691":{
      "name":"\u041a\u0430\u043c\u044b\u0448\u0438\u043d\u043e-\u041a\u0443\u0440\u0441\u043a\u043e\u0435",
      "longitude":74.8539989,
      "latitude":55.9672694
    },
    "2692":{
      "name":"\u041d\u043e\u0432\u044b\u0439 \u0421\u0432\u0435\u0442",
      "longitude":74.8565379,
      "latitude":55.1186076
    },
    "2693":{
      "name":"\u0421\u0435\u0440\u0433\u0435\u0435\u0432\u043a\u0430",
      "longitude":74.875534,
      "latitude":54.8138229
    },
    "2694":{
      "name":"\u041d\u0430\u0433\u043e\u0440\u043d\u043e\u0435",
      "longitude":74.8873957,
      "latitude":56.7285814
    },
    "2695":{
      "name":"\u0414\u043e\u043a\u0443\u0447\u0430\u0435\u0432\u043a\u0430",
      "longitude":74.8964797,
      "latitude":55.1781362
    },
    "2696":{
      "name":"\u0415\u0433\u043e\u0440\u043e\u0432\u043a\u0430",
      "longitude":74.8981415,
      "latitude":57.1683685
    },
    "2697":{
      "name":"\u0417\u043e\u043b\u043e\u0442\u0430\u044f \u041d\u0438\u0432\u0430",
      "longitude":74.900017,
      "latitude":54.895344
    },
    "2698":{
      "name":"\u0423\u043d\u0430\u0440\u0430",
      "longitude":74.9004197,
      "latitude":57.0555515
    },
    "2699":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0435\u0433\u0440\u0438\u0432\u0441\u043a\u043e\u0435",
      "longitude":74.910225,
      "latitude":53.914665
    },
    "2700":{
      "name":"\u0411\u0435\u0440\u0435\u0433\u043e\u0432\u043e\u0435",
      "longitude":74.9137427,
      "latitude":53.9478727
    },
    "2701":{
      "name":"\u0425\u043e\u0440\u0442\u0438\u0446\u044b",
      "longitude":74.917068,
      "latitude":55.586838
    },
    "2702":{
      "name":"\u041c\u043e\u0445\u043e\u0432\u043e\u0439 \u041f\u0440\u0438\u0432\u0430\u043b",
      "longitude":74.9244979,
      "latitude":56.0357043
    },
    "2703":{
      "name":"\u041c\u0430\u043a\u0430\u0440\u043a\u0438\u043d\u043e",
      "longitude":74.9351871,
      "latitude":54.4433564
    },
    "2704":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u0410\u0442\u043c\u0430\u0441",
      "longitude":74.9354682,
      "latitude":54.0658059
    },
    "2705":{
      "name":"\u041c\u0430\u043b\u044b\u0439 \u0410\u0442\u043c\u0430\u0441",
      "longitude":74.9355799,
      "latitude":53.9922852
    },
    "2706":{
      "name":"\u0410\u043b\u043a\u0443\u043b",
      "longitude":74.9447718,
      "latitude":53.9412046
    },
    "2707":{
      "name":"\u041f\u043e\u0440\u0435\u0447\u044c\u0435",
      "longitude":74.9449999,
      "latitude":56.5791861
    },
    "2708":{
      "name":"\u041a\u043e\u0441\u0442\u0438\u043d\u043e",
      "longitude":74.9482674,
      "latitude":56.172302
    },
    "2709":{
      "name":"\u0410\u043d\u0442\u043e\u043d\u043e\u0432\u043a\u0430",
      "longitude":74.9539826,
      "latitude":55.3486206
    },
    "2710":{
      "name":"\u0421\u043e\u043b\u043e\u0432\u0435\u0446\u043a\u043e\u0435",
      "longitude":74.9957682,
      "latitude":55.3133043
    },
    "2711":{
      "name":"\u041a\u0430\u0440\u0430\u043c\u0430\u043d",
      "longitude":74.9976563,
      "latitude":53.8543348
    },
    "2712":{
      "name":"\u0415\u0440\u043c\u0430\u043a",
      "longitude":75.0136051,
      "latitude":53.9454121
    },
    "2713":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u041e\u043a\u0442\u044f\u0431\u0440\u044c",
      "longitude":75.0146464,
      "latitude":54.1328053
    },
    "2714":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":75.016314,
      "latitude":54.2589123
    },
    "2715":{
      "name":"\u0413\u043b\u0443\u0445\u043e\u043d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":75.0315202,
      "latitude":55.2874188
    },
    "2716":{
      "name":"\u0411\u0435\u0440\u0433\u0430\u043c\u0430\u043a",
      "longitude":75.053276,
      "latitude":56.413803
    },
    "2717":{
      "name":"\u042e\u0436\u043d\u043e-\u041f\u043e\u0434\u043e\u043b\u044c\u0441\u043a",
      "longitude":75.0559459,
      "latitude":54.414883
    },
    "2718":{
      "name":"\u0422\u0430\u0442\u0430\u0440\u043a\u0430",
      "longitude":75.0638202,
      "latitude":53.9627235
    },
    "2719":{
      "name":"\u041c\u0430\u044f\u043a",
      "longitude":75.064514,
      "latitude":54.5586627
    },
    "2720":{
      "name":"\u041a\u0443\u043a\u0430\u0440\u043a\u0430",
      "longitude":75.0665331,
      "latitude":56.9407239
    },
    "2721":{
      "name":"\u041d\u043e\u0432\u043e\u0442\u0440\u043e\u0438\u0446\u043a",
      "longitude":75.0777789,
      "latitude":55.7913949
    },
    "2722":{
      "name":"\u041b\u0438\u0441\u0438\u043d\u043e",
      "longitude":75.0895564,
      "latitude":56.3986059
    },
    "2723":{
      "name":"\u041b\u044c\u0432\u043e\u0432\u043a\u0430",
      "longitude":75.0919245,
      "latitude":55.0420233
    },
    "2724":{
      "name":"\u041b\u0438\u0442\u043a\u043e\u0432\u043a\u0430",
      "longitude":75.105873,
      "latitude":57.342171
    },
    "2725":{
      "name":"\u041b\u044e\u0431\u0438\u043c\u043e\u0432\u043a\u0430",
      "longitude":75.1117261,
      "latitude":54.6683803
    },
    "2726":{
      "name":"\u041e\u0440\u043b\u043e\u0432\u043a\u0430",
      "longitude":75.1343616,
      "latitude":55.1933594
    },
    "2727":{
      "name":"\u0425\u043e\u043c\u0443\u0442\u0438\u043d\u043a\u0430",
      "longitude":75.1392035,
      "latitude":55.4969176
    },
    "2728":{
      "name":"\u0413\u0443\u0440\u043e\u0432\u043e",
      "longitude":75.1547496,
      "latitude":56.3045427
    },
    "2729":{
      "name":"\u041a\u043e\u043a\u0448\u0435\u043d\u0435\u0432\u043e",
      "longitude":75.1615566,
      "latitude":56.3870842
    },
    "2730":{
      "name":"\u041a\u0440\u0430\u0441\u043e\u0432\u043a\u0430",
      "longitude":75.168221,
      "latitude":54.925247
    },
    "2731":{
      "name":"\u041d\u043e\u0432\u043e\u0443\u0439\u043a\u0430",
      "longitude":75.1983577,
      "latitude":57.0309621
    },
    "2732":{
      "name":"\u041a\u0430\u0431\u0430\u043d\u044c\u0435",
      "longitude":75.2073631,
      "latitude":54.9993201
    },
    "2733":{
      "name":"\u0420\u044f\u0437\u0430\u043d\u044b",
      "longitude":75.209,
      "latitude":56.571251
    },
    "2734":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":75.214714,
      "latitude":55.129902
    },
    "2735":{
      "name":"\u041f\u0435\u0440\u0432\u044b\u0439 \u0428\u0430\u0433",
      "longitude":75.2564144,
      "latitude":54.0687057
    },
    "2736":{
      "name":"\u0413\u043e\u043b\u0443\u0431\u043e\u0432\u043a\u0430",
      "longitude":75.2672394,
      "latitude":56.8804031
    },
    "2737":{
      "name":"\u041a\u043e\u0432\u0430\u043b\u0435\u0432\u043e",
      "longitude":75.278119,
      "latitude":55.0954379
    },
    "2738":{
      "name":"\u0414\u0443\u0440\u043d\u043e\u0432\u043e",
      "longitude":75.4102676,
      "latitude":56.2956754
    },
    "2739":{
      "name":"\u041c\u044b\u0441",
      "longitude":75.42848780474176,
      "latitude":56.3501982840876
    },
    "2740":{
      "name":"\u041a\u0440\u0435\u0441\u0442\u0438\u043a\u0438",
      "longitude":75.436485,
      "latitude":54.628708
    },
    "2741":{
      "name":"\u0415\u0432\u043b\u0430\u043d\u0442\u044c\u0435\u0432\u043a\u0430",
      "longitude":75.4645396,
      "latitude":56.9294052
    },
    "2742":{
      "name":"\u041a\u0443\u043b\u043e\u043c\u0437\u0438\u043d\u043e",
      "longitude":75.4667271,
      "latitude":54.8325258
    },
    "2743":{
      "name":"\u041c\u0435\u0434\u0435\u0442",
      "longitude":75.539387,
      "latitude":54.1831127
    },
    "2744":{
      "name":"\u0427\u0438\u0441\u0442\u043e\u0432\u043e",
      "longitude":75.5533146,
      "latitude":54.6804795
    },
    "2745":{
      "name":"\u041a\u043e\u043d\u0434\u0440\u0430\u0442\u044c\u0435\u0432\u043e",
      "longitude":75.5700445,
      "latitude":56.4587457
    },
    "2746":{
      "name":"\u0414\u0436\u0430\u0440\u0442\u0430\u0440\u0433\u0443\u043b\u044c",
      "longitude":75.5740345,
      "latitude":54.3810072
    },
    "2747":{
      "name":"\u0411\u0430\u043a\u0438\u043d\u043e",
      "longitude":75.6693971,
      "latitude":56.8300027
    },
    "2748":{
      "name":"\u0423\u0448\u0430\u043a\u043e\u0432\u043e",
      "longitude":75.68688737833563,
      "latitude":56.36510244026156
    },
    "2749":{
      "name":"\u041a\u0435\u0439\u0437\u0435\u0441",
      "longitude":75.734657,
      "latitude":56.936356
    },
    "2750":{
      "name":"\u041a\u0443\u0440\u0433\u0430\u043d\u043a\u0430",
      "longitude":75.8235397,
      "latitude":56.4430373
    },
    "2751":{
      "name":"\u041b\u0435\u0431\u0435\u0434\u0438\u043d\u043a\u0430",
      "longitude":75.8406454,
      "latitude":56.9209409
    },
    "2752":{
      "name":"\u041d\u0438\u0437\u043e\u0432\u043e\u0435",
      "longitude":75.860832,
      "latitude":56.395493
    },
    "2753":{
      "name":"\u041a\u0430\u0440\u0431\u044b\u0437\u0430",
      "longitude":75.918427,
      "latitude":56.588669
    },
    "2754":{
      "name":"\u0420\u0430\u0433\u043e\u0437\u0438\u043d\u043e",
      "longitude":75.9393579,
      "latitude":56.9370605
    },
    "2755":{
      "name":"\u0421\u0430\u0440\u0430\u0442\u043e\u0432\u043a\u0430",
      "longitude":75.9434827,
      "latitude":57.0762912
    },
    "2756":{
      "name":"\u0415\u043b\u044c\u043d\u0438\u0447\u043d\u043e\u0435",
      "longitude":76.1551364,
      "latitude":56.9216264
    },
    "2757":{
      "name":"\u041d\u043e\u0432\u044b\u0439 \u0412\u0430\u0441\u044e\u0433\u0430\u043d",
      "longitude":76.502968,
      "latitude":58.576908
    },
    "2758":{
      "name":"\u041a\u0430\u0442\u044b\u043b\u044c\u0433\u0430",
      "longitude":76.7220858,
      "latitude":59.0682965
    },
    "2759":{
      "name":"\u0421\u0435\u0432\u0435\u0440\u043d\u044b\u0439",
      "longitude":77.176849,
      "latitude":60.680233
    },
    "2760":{
      "name":"\u041c\u0430\u0439\u0441\u043a",
      "longitude":77.2222909,
      "latitude":57.8111957
    },
    "2761":{
      "name":"\u041d\u043e\u0432\u044b\u0439 \u0422\u0435\u0432\u0440\u0438\u0437",
      "longitude":77.531815,
      "latitude":59.141102
    },
    "2762":{
      "name":"\u0421\u0440\u0435\u0434\u043d\u0438\u0439 \u0412\u0430\u0441\u044e\u0433\u0430\u043d",
      "longitude":78.238243,
      "latitude":59.223167
    },
    "2763":{
      "name":"\u041b\u0443\u043a\u0430\u0448\u043a\u0438\u043d \u042f\u0440",
      "longitude":78.395966,
      "latitude":60.328899
    },
    "2764":{
      "name":"\u041c\u044b\u043b\u044c\u0434\u0436\u0438\u043d\u043e",
      "longitude":78.454674,
      "latitude":58.992275
    },
    "2765":{
      "name":"\u0432\u0430\u0445\u0442.\u043f.\u041b\u0443\u0433\u0438\u043d\u0435\u0446\u043a\u0438\u0439",
      "longitude":78.8759211,
      "latitude":58.1611298
    },
    "2766":{
      "name":"\u041d\u0430\u0437\u0438\u043d\u043e",
      "longitude":78.939453,
      "latitude":60.127083
    },
    "2767":{
      "name":"\u041d\u043e\u0432\u043e\u043d\u0438\u043a\u043e\u043b\u044c\u0441\u043a\u043e\u0435",
      "longitude":79.210281,
      "latitude":59.764801
    },
    "2768":{
      "name":"\u041e\u043a\u0442\u044f\u0431\u0440\u044c\u0441\u043a\u0438\u0439",
      "longitude":79.406624,
      "latitude":59.485847
    },
    "2769":{
      "name":"\u041f\u0443\u0434\u0438\u043d\u043e",
      "longitude":79.446182,
      "latitude":57.571121
    },
    "2770":{
      "name":"\u0421\u0442\u0430\u0440\u0430\u044f \u0411\u0435\u0440\u0451\u0437\u043e\u0432\u043a\u0430",
      "longitude":79.548805,
      "latitude":58.983143
    },
    "2771":{
      "name":"\u0412\u0435\u0440\u0442\u0438\u043a\u043e\u0441",
      "longitude":79.680962,
      "latitude":59.382378
    },
    "2772":{
      "name":"\u0423\u0441\u0442\u044c-\u0422\u044b\u043c",
      "longitude":80.024078,
      "latitude":59.439648
    },
    "2773":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u0413\u0440\u0438\u0432\u0430",
      "longitude":80.244484,
      "latitude":58.927742
    },
    "2774":{
      "name":"\u0422\u044b\u043c\u0441\u043a",
      "longitude":80.2977876,
      "latitude":59.3757885
    },
    "2775":{
      "name":"\u0417\u0430\u0432\u044c\u044f\u043b\u043e\u0432\u043e",
      "longitude":80.3888718,
      "latitude":59.198017
    },
    "2776":{
      "name":"\u041a\u0438\u0435\u0432\u0441\u043a\u0438\u0439",
      "longitude":80.393082,
      "latitude":59.770733
    },
    "2777":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u044e\u0433\u0438\u043d\u043e",
      "longitude":80.484955,
      "latitude":59.002155
    },
    "2778":{
      "name":"\u041d\u043e\u0432\u043e\u044e\u0433\u0438\u043d\u043e",
      "longitude":80.569611,
      "latitude":58.991562
    },
    "2779":{
      "name":"\u0421\u0442\u0430\u0440\u0438\u0446\u0430",
      "longitude":80.5747933,
      "latitude":58.1379744
    },
    "2780":{
      "name":"\u041a\u0438\u043d\u0434\u0430\u043b",
      "longitude":80.5821,
      "latitude":59.153996
    },
    "2781":{
      "name":"\u041d\u0435\u0433\u043e\u0442\u043a\u0430",
      "longitude":80.644218,
      "latitude":59.726353
    },
    "2782":{
      "name":"\u041b\u043e\u0437\u0443\u043d\u0433\u0430",
      "longitude":80.67511,
      "latitude":58.986984
    },
    "2783":{
      "name":"\u0411\u043e\u043d\u0434\u0430\u0440\u043a\u0430",
      "longitude":80.735779,
      "latitude":59.031776
    },
    "2784":{
      "name":"5-\u0439 \u043a\u0438\u043b\u043e\u043c\u0435\u0442\u0440",
      "longitude":80.8024023,
      "latitude":59.0630876
    },
    "2785":{
      "name":"\u041d\u0435\u0444\u0442\u044f\u043d\u0438\u043a\u043e\u0432",
      "longitude":80.836067,
      "latitude":59.046715
    },
    "2786":{
      "name":"\u0413\u0435\u043e\u043b\u043e\u0433\u0438\u0447\u0435\u0441\u043a\u0438\u0439",
      "longitude":80.846413,
      "latitude":59.034485
    },
    "2787":{
      "name":"\u041f\u0430\u0432\u043b\u043e\u0432\u043e",
      "longitude":80.918602,
      "latitude":59.002262
    },
    "2788":{
      "name":"\u041f\u0430\u0448\u043d\u044f",
      "longitude":80.923843,
      "latitude":58.985752
    },
    "2789":{
      "name":"\u0421\u043e\u0441\u043d\u043e\u0432\u043a\u0430",
      "longitude":81.2987425,
      "latitude":59.1216147
    },
    "2790":{
      "name":"\u0417\u0430\u0432\u043e\u0434\u0441\u043a\u043e\u0439",
      "longitude":81.3163398,
      "latitude":58.6749581
    },
    "2791":{
      "name":"\u0412\u044b\u0441\u043e\u043a\u0438\u0439 \u042f\u0440",
      "longitude":81.3224449,
      "latitude":58.7625493
    },
    "2792":{
      "name":"\u041f\u0440\u043e\u043a\u043e\u043f",
      "longitude":81.3516952,
      "latitude":58.7066838
    },
    "2793":{
      "name":"\u041f\u0430\u0440\u0431\u0438\u0433",
      "longitude":81.406067,
      "latitude":57.230362
    },
    "2794":{
      "name":"\u0422\u043e\u043b\u043c\u0430\u0447\u0435\u0432\u043e",
      "longitude":81.4415832,
      "latitude":58.7086125
    },
    "2795":{
      "name":"\u0411\u0443\u0433\u0440\u044b",
      "longitude":81.4779906,
      "latitude":58.6840329
    },
    "2796":{
      "name":"\u041a\u043e\u0441\u0442\u0430\u0440\u0435\u0432\u043e",
      "longitude":81.479884,
      "latitude":58.7187507
    },
    "2797":{
      "name":"\u041a\u0438\u0440\u0437\u0430\u0432\u043e\u0434",
      "longitude":81.4925027,
      "latitude":58.681218
    },
    "2798":{
      "name":"\u0421\u0443\u0445\u0443\u0448\u0438\u043d\u043e",
      "longitude":81.5167268,
      "latitude":58.6750186
    },
    "2799":{
      "name":"\u0428\u043f\u0430\u043b\u043e\u0437\u0430\u0432\u043e\u0434",
      "longitude":81.555504,
      "latitude":58.932831
    },
    "2800":{
      "name":"\u0422\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":81.5777226,
      "latitude":58.9795552
    },
    "2801":{
      "name":"\u041c\u0430\u043b\u043e\u0435 \u041d\u0435\u0441\u0442\u0435\u0440\u043e\u0432\u043e",
      "longitude":81.5795938,
      "latitude":58.6601838
    },
    "2802":{
      "name":"\u041d\u0430\u0440\u044b\u043c",
      "longitude":81.601074,
      "latitude":58.928993
    },
    "2803":{
      "name":"\u041b\u0443\u0433\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":81.6412073,
      "latitude":58.9010733
    },
    "2804":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u0435\u043b\u044c\u0446\u0435\u0432\u043e",
      "longitude":81.6924959,
      "latitude":58.6368731
    },
    "2805":{
      "name":"\u041c\u043e\u043b\u043e\u0434\u0435\u0436\u043d\u044b\u0439",
      "longitude":81.7237868,
      "latitude":59.9252916
    },
    "2806":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u044f\u044f \u0427\u0438\u0433\u0430\u0440\u0430",
      "longitude":81.8129072,
      "latitude":58.5651206
    },
    "2807":{
      "name":"\u041a\u0440\u044b\u043b\u043e\u0432\u043a\u0430",
      "longitude":81.898788,
      "latitude":57.452362
    },
    "2808":{
      "name":"\u0412\u044b\u0441\u043e\u043a\u0438\u0439 \u042f\u0440",
      "longitude":81.913658,
      "latitude":57.323238
    },
    "2809":{
      "name":"\u041d\u0430\u043f\u0430\u0441",
      "longitude":82.004333,
      "latitude":59.889999
    },
    "2810":{
      "name":"\u0412\u0430\u0432\u0438\u043b\u043e\u0432\u043a\u0430",
      "longitude":82.028336,
      "latitude":57.054386
    },
    "2811":{
      "name":"\u041f\u0430\u0441\u0435\u043a\u0430",
      "longitude":82.0545745,
      "latitude":58.5002338
    },
    "2812":{
      "name":"\u0418\u043d\u043a\u0438\u043d\u043e",
      "longitude":82.126717,
      "latitude":58.48243
    },
    "2813":{
      "name":"\u0413\u043e\u0440\u0435\u043b\u043e\u0432\u043a\u0430",
      "longitude":82.2203491,
      "latitude":57.4766938
    },
    "2814":{
      "name":"\u041a\u043e\u043f\u044b\u043b\u043e\u0432\u043a\u0430",
      "longitude":82.269485,
      "latitude":58.674797
    },
    "2815":{
      "name":"\u0423\u0441\u0442\u044c-\u0411\u0430\u043a\u0447\u0430\u0440",
      "longitude":82.319565,
      "latitude":57.610844
    },
    "2816":{
      "name":"\u041d\u043e\u0432\u044b\u0435 \u041a\u043b\u044e\u0447\u0438",
      "longitude":82.3404002,
      "latitude":57.6192339
    },
    "2817":{
      "name":"\u041f\u043e\u0440\u043e\u0442\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":82.345993,
      "latitude":57.005028
    },
    "2818":{
      "name":"\u0422\u0440\u0435\u0442\u044c\u044f \u0422\u0438\u0433\u0430",
      "longitude":82.3763504,
      "latitude":57.4944703
    },
    "2819":{
      "name":"\u0418\u0432\u0430\u043d\u043a\u0438\u043d\u043e",
      "longitude":82.4292547,
      "latitude":58.4410019
    },
    "2820":{
      "name":"\u0412\u0430\u0440\u0433\u0430\u0442\u0451\u0440",
      "longitude":82.4447936,
      "latitude":57.675592
    },
    "2821":{
      "name":"\u0421\u0442\u0440\u0435\u043b\u044c\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":82.445621,
      "latitude":57.7135513
    },
    "2822":{
      "name":"\u041b\u0435\u0441\u043e\u0443\u0447\u0430\u0441\u0442\u043e\u043a \u0427\u0430\u044f",
      "longitude":82.4652038,
      "latitude":57.7057451
    },
    "2823":{
      "name":"\u041a\u0443\u0440\u0436\u0438\u043d\u043e",
      "longitude":82.565392,
      "latitude":58.908764
    },
    "2824":{
      "name":"\u0427\u0430\u0438\u043d\u0441\u043a",
      "longitude":82.595982,
      "latitude":57.9288357
    },
    "2825":{
      "name":"\u0427\u0435\u0440\u0451\u043c\u0443\u0448\u043a\u0438",
      "longitude":82.609952,
      "latitude":57.7736177
    },
    "2826":{
      "name":"\u042d\u043b\u0438\u0442\u043d\u043e\u0435",
      "longitude":82.6118403,
      "latitude":57.7597924
    },
    "2827":{
      "name":"\u0413\u0440\u0438\u0433\u043e\u0440\u044c\u0435\u0432\u043a\u0430",
      "longitude":82.6250582,
      "latitude":57.7560376
    },
    "2828":{
      "name":"\u0423\u0441\u0442\u044c-\u0427\u0430\u044f",
      "longitude":82.6352339,
      "latitude":58.2712065
    },
    "2829":{
      "name":"\u041c\u0438\u043d\u0435\u0435\u0432\u043a\u0430",
      "longitude":82.63584,
      "latitude":57.8249757
    },
    "2830":{
      "name":"\u041d\u043e\u0432\u043e\u0433\u043e\u0440\u043d\u043e\u0435",
      "longitude":82.6391883,
      "latitude":58.2495626
    },
    "2831":{
      "name":"\u0413\u0440\u0438\u0448\u043a\u0438\u043d\u043e",
      "longitude":82.6475904,
      "latitude":58.0395966
    },
    "2832":{
      "name":"\u041c\u0443\u0448\u043a\u0438\u043d\u043e",
      "longitude":82.6564688,
      "latitude":57.8055418
    },
    "2833":{
      "name":"\u041a\u0438\u0440\u043f\u0438\u0447\u043d\u043e\u0435",
      "longitude":82.6575742,
      "latitude":57.7682153
    },
    "2834":{
      "name":"\u0418\u0433\u043d\u0430\u0448\u043a\u0438\u043d\u043e",
      "longitude":82.7441934,
      "latitude":58.0783504
    },
    "2835":{
      "name":"\u0415\u0440\u043c\u0438\u043b\u043e\u0432\u043a\u0430",
      "longitude":82.7514528,
      "latitude":57.7134671
    },
    "2836":{
      "name":"\u041c\u043e\u0433\u0438\u043b\u044c\u043d\u044b\u0439 \u041c\u044b\u0441",
      "longitude":82.8110932,
      "latitude":58.1201214
    },
    "2837":{
      "name":"\u0427\u0430\u0436\u0435\u043c\u0442\u043e",
      "longitude":82.820007,
      "latitude":58.062641
    },
    "2838":{
      "name":"\u0411\u0435\u0440\u0435\u0437\u043e\u0432\u043a\u0430",
      "longitude":82.826145,
      "latitude":59.3624889
    },
    "2839":{
      "name":"\u0422\u043e\u0433\u0443\u0440",
      "longitude":82.829697,
      "latitude":58.358292
    },
    "2840":{
      "name":"\u0421\u0443\u0445\u043e\u0439 \u041b\u043e\u0433",
      "longitude":82.8337753,
      "latitude":57.6996863
    },
    "2841":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u043e\u0440\u043e\u0442\u043a\u0438\u043d\u043e",
      "longitude":82.8767347,
      "latitude":58.0029332
    },
    "2842":{
      "name":"\u041e\u0437\u0451\u0440\u043d\u043e\u0435",
      "longitude":82.9012929,
      "latitude":58.226754
    },
    "2843":{
      "name":"\u0414\u0430\u043b\u044c\u043d\u0435\u0435",
      "longitude":82.9391583,
      "latitude":58.7195711
    },
    "2844":{
      "name":"\u0421\u0443\u0433\u043e\u0442",
      "longitude":82.9767117,
      "latitude":57.9880846
    },
    "2845":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u0435\u043b\u043e\u0432\u043e",
      "longitude":82.9987551,
      "latitude":58.3980744
    },
    "2846":{
      "name":"\u0427\u0435\u043c\u043e\u043d\u0434\u0430\u0435\u0432\u043a\u0430",
      "longitude":83.0061983,
      "latitude":57.7426139
    },
    "2847":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u0430\u0431\u0440\u0430\u043c\u043a\u0438\u043d\u043e",
      "longitude":83.0581977,
      "latitude":57.9659045
    },
    "2848":{
      "name":"\u041c\u0430\u0440\u0430\u043a\u0441\u0430 1-\u044f",
      "longitude":83.0689573,
      "latitude":58.3818398
    },
    "2849":{
      "name":"\u0427\u0443\u0433\u0443\u043d\u043a\u0430",
      "longitude":83.0756921,
      "latitude":58.2914064
    },
    "2850":{
      "name":"\u041f\u043b\u043e\u0442\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":83.0803571,
      "latitude":56.8575642
    },
    "2851":{
      "name":"\u041a\u043e\u043b\u043e\u043c\u0438\u043d\u0441\u043a\u0438\u0435 \u0413\u0440\u0438\u0432\u044b",
      "longitude":83.1457896,
      "latitude":57.7962504
    },
    "2852":{
      "name":"\u041b\u0435\u0431\u043e\u0442\u0451\u0440",
      "longitude":83.178349,
      "latitude":57.8787863
    },
    "2853":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u0421\u0430\u0440\u043e\u0432\u043a\u0430",
      "longitude":83.2506021,
      "latitude":58.1032319
    },
    "2854":{
      "name":"\u041f\u0430\u0432\u043b\u043e\u0432 \u041c\u044b\u0441",
      "longitude":83.2540048,
      "latitude":58.4103873
    },
    "2855":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u043e\u043b\u043e\u043c\u0438\u043d\u043e",
      "longitude":83.2696374,
      "latitude":57.8284961
    },
    "2856":{
      "name":"\u0425\u043c\u0435\u043b\u0451\u0432\u043a\u0430",
      "longitude":83.329514,
      "latitude":56.285652
    },
    "2857":{
      "name":"\u0415\u043b\u0433\u0430\u0439",
      "longitude":83.334297,
      "latitude":56.25124
    },
    "2858":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u0422\u044e\u0432\u0438\u043d\u043a\u0430",
      "longitude":83.3412315,
      "latitude":57.5694089
    },
    "2859":{
      "name":"\u0411\u0435\u043b\u043e\u044f\u0440\u043e\u0432\u043a\u0430",
      "longitude":83.3430722,
      "latitude":58.4227649
    },
    "2860":{
      "name":"\u0411\u0430\u0437\u043e\u0439",
      "longitude":83.363556,
      "latitude":55.747101
    },
    "2861":{
      "name":"\u041e\u0431\u0441\u043a\u043e\u0435",
      "longitude":83.3865388,
      "latitude":57.7406433
    },
    "2862":{
      "name":"\u041a\u043d\u044f\u0437\u0435\u0432\u043a\u0430",
      "longitude":83.3877243,
      "latitude":57.505461
    },
    "2863":{
      "name":"\u041d\u043e\u0432\u043e\u0443\u0441\u043f\u0435\u043d\u043a\u0430",
      "longitude":83.420128,
      "latitude":56.383095
    },
    "2864":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u042e\u0432\u0430\u043b\u0430",
      "longitude":83.424271,
      "latitude":56.292034
    },
    "2865":{
      "name":"\u041f\u0430\u043b\u043e\u0447\u043a\u0430",
      "longitude":84.610641,
      "latitude":58.378704
    },
    "2866":{
      "name":"\u041a\u043e\u0436\u0435\u0432\u043d\u0438\u043a\u043e\u0432\u043e-\u043d\u0430-\u0428\u0435\u0433\u0430\u0440\u043a\u0435",
      "longitude":83.426651,
      "latitude":56.440834
    },
    "2867":{
      "name":"\u041a\u043e\u043b\u0431\u0438\u043d\u043a\u0430",
      "longitude":83.4325064,
      "latitude":57.5137704
    },
    "2868":{
      "name":"\u0422\u0435\u0440\u0441\u0430\u043b\u0433\u0430\u0439",
      "longitude":83.441238,
      "latitude":56.383476
    },
    "2869":{
      "name":"\u0421\u0442\u0430\u0440\u0430\u044f \u042e\u0432\u0430\u043b\u0430",
      "longitude":83.441788,
      "latitude":56.311939
    },
    "2870":{
      "name":"\u041f\u0435\u0441\u043e\u0447\u043d\u043e\u0434\u0443\u0431\u0440\u043e\u0432\u043a\u0430",
      "longitude":83.453773,
      "latitude":56.406845
    },
    "2871":{
      "name":"\u0421\u0430\u0440\u0430\u0444\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":83.4565766,
      "latitude":57.7134205
    },
    "2872":{
      "name":"\u0412\u043e\u0440\u043e\u043d\u043e\u0432\u043a\u0430",
      "longitude":83.464707,
      "latitude":56.8255473
    },
    "2873":{
      "name":"\u041c\u0443\u043b\u043b\u043e\u0432\u0430",
      "longitude":83.482178,
      "latitude":56.449005
    },
    "2874":{
      "name":"\u041c\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":83.4824458,
      "latitude":57.3685456
    },
    "2875":{
      "name":"\u0422\u0443\u043d\u0433\u0443\u0441\u043e\u0432\u043e",
      "longitude":83.484917,
      "latitude":57.620281
    },
    "2876":{
      "name":"\u041e\u0441\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":83.495827,
      "latitude":55.955612
    },
    "2877":{
      "name":"\u0427\u0438\u043b\u0438\u043d\u043e",
      "longitude":83.527153,
      "latitude":55.835213
    },
    "2878":{
      "name":"\u0411\u043e\u0440\u0437\u0443\u043d\u043e\u0432\u043a\u0430",
      "longitude":83.553787,
      "latitude":56.139809
    },
    "2879":{
      "name":"\u0422\u0430\u0442\u044c\u044f\u043d\u043e\u0432\u043a\u0430",
      "longitude":83.56221,
      "latitude":56.82198
    },
    "2880":{
      "name":"\u041d\u0430\u0440\u0433\u0430",
      "longitude":83.563866,
      "latitude":57.682804
    },
    "2881":{
      "name":"\u041c\u0430\u0440\u043a\u0435\u043b\u043e\u0432\u043e",
      "longitude":83.5649495,
      "latitude":56.7040831
    },
    "2882":{
      "name":"\u0410\u043d\u0430\u0441\u0442\u0430\u0441\u044c\u0435\u0432\u043a\u0430",
      "longitude":83.575279,
      "latitude":56.77383
    },
    "2883":{
      "name":"\u0413\u044b\u043d\u0433\u0430\u0437\u043e\u0432\u043e",
      "longitude":83.5796008,
      "latitude":56.6401559
    },
    "2884":{
      "name":"\u041c\u043e\u0433\u043e\u0447\u0438\u043d\u043e",
      "longitude":83.583992,
      "latitude":57.709698
    },
    "2885":{
      "name":"\u0411\u0430\u0442\u0443\u0440\u0438\u043d\u043e",
      "longitude":83.591179,
      "latitude":55.696346
    },
    "2886":{
      "name":"\u041c\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":83.599564,
      "latitude":56.091309
    },
    "2887":{
      "name":"\u0415\u0440\u0435\u0441\u0442\u043d\u0430\u044f",
      "longitude":83.603714,
      "latitude":55.872597
    },
    "2888":{
      "name":"\u0413\u0440\u0438\u0448\u0438\u043d\u043e",
      "longitude":83.6076691,
      "latitude":57.5318726
    },
    "2889":{
      "name":"\u0411\u0430\u0431\u0430\u0440\u044b\u043a\u0438\u043d\u043e",
      "longitude":83.6150403,
      "latitude":56.5514235
    },
    "2890":{
      "name":"\u041c\u0430\u0439\u043a\u043e\u0432\u043e",
      "longitude":83.6363616,
      "latitude":57.6374205
    },
    "2891":{
      "name":"\u0417\u0430\u0439\u0446\u0435\u0432\u043e",
      "longitude":83.672813,
      "latitude":56.286415
    },
    "2892":{
      "name":"\u041f\u0443\u0434\u043e\u0432\u043a\u0430",
      "longitude":83.6884394,
      "latitude":57.2328722
    },
    "2893":{
      "name":"\u0413\u0443\u0440\u0435\u0432\u043a\u0430",
      "longitude":83.6949549,
      "latitude":57.3452152
    },
    "2894":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u0435\u0440\u0433\u0435\u0435\u0432\u043a\u0430",
      "longitude":83.721184,
      "latitude":56.143631
    },
    "2895":{
      "name":"\u041c\u043e\u043d\u0430\u0441\u0442\u044b\u0440\u043a\u0430",
      "longitude":83.723793,
      "latitude":56.943867
    },
    "2896":{
      "name":"\u0415\u043b\u043e\u0432\u043a\u0430",
      "longitude":83.73143,
      "latitude":55.944759
    },
    "2897":{
      "name":"\u0422\u0435\u043a\u0430",
      "longitude":83.759628,
      "latitude":56.185471
    },
    "2898":{
      "name":"\u041d\u043e\u0432\u043e\u0438\u0441\u043b\u0430\u043c\u0431\u0443\u043b\u044c",
      "longitude":83.7932528,
      "latitude":57.4085479
    },
    "2899":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u0440\u0438\u0432\u043e\u0448\u0435\u0438\u043d\u043e",
      "longitude":83.7953845,
      "latitude":57.3132424
    },
    "2900":{
      "name":"\u0418\u0433\u0440\u0435\u043a\u043e\u0432\u043e",
      "longitude":83.8001156,
      "latitude":57.7494751
    },
    "2901":{
      "name":"\u0412\u043e\u0440\u043e\u043d\u043e\u0432\u043e",
      "longitude":83.805969,
      "latitude":56.008984
    },
    "2902":{
      "name":"\u0421\u043e\u043a\u043e\u043b\u043e\u0432\u043a\u0430",
      "longitude":83.8283952,
      "latitude":57.496837
    },
    "2903":{
      "name":"\u0411\u0430\u0442\u043a\u0430\u0442",
      "longitude":83.861298,
      "latitude":56.551414
    },
    "2904":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u042f\u0440",
      "longitude":83.862213,
      "latitude":56.084995
    },
    "2905":{
      "name":"\u041d\u043e\u0432\u043e\u043f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":83.8685069,
      "latitude":56.3217456
    },
    "2906":{
      "name":"\u0410\u0440\u043a\u0430\u0434\u044c\u0435\u0432\u043e",
      "longitude":83.870567,
      "latitude":56.288452
    },
    "2907":{
      "name":"\u0414\u0435\u0441\u044f\u0442\u043e\u0432\u043e",
      "longitude":83.880524,
      "latitude":56.423561
    },
    "2908":{
      "name":"\u0412\u043e\u043b\u043e\u0434\u0438\u043d\u043e",
      "longitude":83.8948281,
      "latitude":57.0976659
    },
    "2909":{
      "name":"\u041d\u043e\u0432\u043e\u043d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":83.90131,
      "latitude":57.1207314
    },
    "2910":{
      "name":"\u0412\u043e\u0437\u043d\u0435\u0441\u0435\u043d\u043a\u0430",
      "longitude":83.9035828,
      "latitude":56.7190263
    },
    "2911":{
      "name":"\u0421\u0430\u0444\u0440\u043e\u043d\u043e\u0432\u043a\u0430",
      "longitude":83.9160571,
      "latitude":56.3589472
    },
    "2912":{
      "name":"\u0421\u0443\u043b\u0437\u0430\u0442",
      "longitude":83.9233743,
      "latitude":57.7958674
    },
    "2913":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u0432\u043a\u0430",
      "longitude":83.9271005,
      "latitude":57.1926569
    },
    "2914":{
      "name":"\u0416\u0430\u0440\u043a\u043e\u0432\u043a\u0430",
      "longitude":83.9325936,
      "latitude":56.8648443
    },
    "2915":{
      "name":"\u0423\u0440\u0442\u0430\u043c",
      "longitude":83.934677,
      "latitude":56.133099
    },
    "2916":{
      "name":"\u0416\u0443\u043a\u043e\u0432\u043e",
      "longitude":83.9420287,
      "latitude":57.400239
    },
    "2917":{
      "name":"\u0415\u043b\u0438\u0437\u0430\u0440\u044c\u0435\u0432\u043e",
      "longitude":83.9590295,
      "latitude":57.3001115
    },
    "2918":{
      "name":"\u041a\u0430\u0440\u0433\u0430\u043b\u0430",
      "longitude":83.960686,
      "latitude":56.6208
    },
    "2919":{
      "name":"\u0420\u044b\u0431\u0430\u043b\u043e\u0432\u043e",
      "longitude":84.0108651,
      "latitude":57.1384072
    },
    "2920":{
      "name":"\u0413\u0443\u0441\u0435\u0432\u043e",
      "longitude":84.0215728,
      "latitude":56.8869035
    },
    "2921":{
      "name":"\u0415\u0433\u043e\u0440\u043e\u0432\u043e",
      "longitude":84.0536087,
      "latitude":57.18309
    },
    "2922":{
      "name":"\u041d\u0430\u0449\u0451\u043a\u043e\u0432\u043e",
      "longitude":84.069954,
      "latitude":56.530502
    },
    "2923":{
      "name":"\u041d\u043e\u0432\u043e\u0438\u043b\u044c\u0438\u043d\u043a\u0430",
      "longitude":84.0856025,
      "latitude":56.9853337
    },
    "2924":{
      "name":"\u041a\u0438\u0440\u0435\u0435\u0432\u0441\u043a",
      "longitude":84.090408,
      "latitude":56.36853
    },
    "2925":{
      "name":"\u0418\u0448\u0442\u0430\u043d",
      "longitude":84.1284531,
      "latitude":57.1581487
    },
    "2926":{
      "name":"\u041e\u0441\u044c\u043a\u0438\u043d\u043e",
      "longitude":84.153412,
      "latitude":56.513073
    },
    "2927":{
      "name":"\u041f\u043e\u0431\u0435\u0434\u0430",
      "longitude":84.166733,
      "latitude":56.526524
    },
    "2928":{
      "name":"\u041b\u0435\u0431\u0435\u0434\u0438\u043d\u043a\u0430",
      "longitude":84.1919872,
      "latitude":56.5265322
    },
    "2929":{
      "name":"\u0422\u0440\u0443\u0431\u0430\u0447\u0435\u0432\u043e",
      "longitude":84.2440659,
      "latitude":56.674354
    },
    "2930":{
      "name":"\u041f\u043e\u0434\u043e\u0431\u0430",
      "longitude":84.2457626,
      "latitude":57.0318827
    },
    "2931":{
      "name":"\u0411\u0443\u0448\u0443\u0435\u0432\u043e",
      "longitude":84.2903175,
      "latitude":56.9006769
    },
    "2932":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0435\u0435 \u0421\u0435\u0447\u0435\u043d\u043e\u0432\u043e",
      "longitude":84.350838,
      "latitude":56.431194
    },
    "2933":{
      "name":"\u0427\u0435\u0440\u043d\u044b\u0448\u0451\u0432\u043a\u0430",
      "longitude":84.361647,
      "latitude":56.5399672
    },
    "2934":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u044c\u0441\u043a\u043e\u0435",
      "longitude":84.3663414,
      "latitude":57.1915683
    },
    "2935":{
      "name":"\u0425\u0430\u0440\u0441\u043a",
      "longitude":84.3721506,
      "latitude":57.8791205
    },
    "2936":{
      "name":"\u041c\u0430\u043b\u043e\u0431\u0440\u0430\u0433\u0438\u043d\u043e",
      "longitude":84.379624,
      "latitude":56.8494243
    },
    "2937":{
      "name":"\u041f\u043e\u043b\u043e\u0432\u0438\u043d\u043a\u0430",
      "longitude":84.3803838,
      "latitude":56.7054188
    },
    "2938":{
      "name":"\u041a\u0430\u0440\u043d\u0430\u0443\u0445\u043e\u0432\u043e",
      "longitude":84.3978758,
      "latitude":57.0651016
    },
    "2939":{
      "name":"\u041b\u0430\u0432\u0440\u043e\u0432\u043e",
      "longitude":84.42218,
      "latitude":56.439819
    },
    "2940":{
      "name":"\u041a\u0430\u0440\u0431\u044b\u0448\u0435\u0432\u043e",
      "longitude":84.449371,
      "latitude":56.488102
    },
    "2941":{
      "name":"\u0417\u043e\u043b\u043e\u0442\u0443\u0448\u043a\u0430",
      "longitude":84.4789073,
      "latitude":57.7869631
    },
    "2942":{
      "name":"\u041a\u043e\u0437\u044e\u043b\u0438\u043d\u043e",
      "longitude":84.503326,
      "latitude":56.8075073
    },
    "2943":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u042f\u0440",
      "longitude":84.5039413,
      "latitude":57.1455792
    },
    "2944":{
      "name":"\u0420\u044b\u0431\u0430\u043b\u043e\u0432\u043e",
      "longitude":84.518204,
      "latitude":56.508194
    },
    "2945":{
      "name":"\u041d\u0435\u043b\u044e\u0431\u0438\u043d\u043e",
      "longitude":84.555923,
      "latitude":56.561172
    },
    "2946":{
      "name":"\u041d\u0430\u0433\u043e\u0440\u043d\u044b\u0439 \u0418\u0448\u0442\u0430\u043d",
      "longitude":84.560336,
      "latitude":56.748145
    },
    "2947":{
      "name":"\u041c\u0430\u043b\u043e-\u0416\u0438\u0440\u043e\u0432\u043e",
      "longitude":85.989624,
      "latitude":56.796688
    },
    "2948":{
      "name":"\u0413\u0443\u0431\u0438\u043d\u043e",
      "longitude":84.625992,
      "latitude":56.588463
    },
    "2949":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043a\u0438\u043d\u043e",
      "longitude":84.629532,
      "latitude":56.485256
    },
    "2950":{
      "name":"\u041e\u0440\u043b\u043e\u0432\u043a\u0430",
      "longitude":84.653862,
      "latitude":56.811905
    },
    "2951":{
      "name":"\u041c\u043e\u0440\u044f\u043a\u043e\u0432\u0441\u043a\u0438\u0439 \u0417\u0430\u0442\u043e\u043d",
      "longitude":84.653976,
      "latitude":56.696075
    },
    "2952":{
      "name":"\u041a\u0443\u0434\u0440\u0438\u043d\u0441\u043a\u0438\u0439 \u0423\u0447\u0430\u0441\u0442\u043e\u043a",
      "longitude":84.667549,
      "latitude":56.537655
    },
    "2953":{
      "name":"\u0421\u0443\u0439\u0433\u0430",
      "longitude":84.731628,
      "latitude":57.868862
    },
    "2954":{
      "name":"\u0417\u043e\u0440\u043a\u0430\u043b\u044c\u0446\u0435\u0432\u043e",
      "longitude":84.743027,
      "latitude":56.522221
    },
    "2955":{
      "name":"\u041f\u043e\u0440\u043e\u0441\u0438\u043d\u043e",
      "longitude":84.760414,
      "latitude":56.550472
    },
    "2956":{
      "name":"\u0411\u043e\u0440\u0438\u043a\u0438",
      "longitude":84.782341,
      "latitude":56.556252
    },
    "2957":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u0432\u043e",
      "longitude":84.803391,
      "latitude":56.534683
    },
    "2958":{
      "name":"\u041a\u0430\u043d\u0434\u0438\u043d\u043a\u0430",
      "longitude":84.823906,
      "latitude":56.296127
    },
    "2959":{
      "name":"\u0414\u0437\u0435\u0440\u0436\u0438\u043d\u0441\u043a\u043e\u0435",
      "longitude":84.845261,
      "latitude":56.518383
    },
    "2960":{
      "name":"\u041a\u0443\u0440\u043b\u0435\u043a",
      "longitude":84.852257,
      "latitude":56.214279
    },
    "2961":{
      "name":"\u041a\u0438\u0441\u043b\u043e\u0432\u043a\u0430",
      "longitude":84.869949,
      "latitude":56.419777
    },
    "2962":{
      "name":"\u041a\u0430\u0444\u0442\u0430\u043d\u0447\u0438\u043a\u043e\u0432\u043e",
      "longitude":84.871429,
      "latitude":56.342319
    },
    "2963":{
      "name":"\u0411\u0430\u0440\u0430\u0431\u0438\u043d\u043a\u0430",
      "longitude":84.872757,
      "latitude":56.326679
    },
    "2964":{
      "name":"\u0422\u0438\u043c\u0438\u0440\u044f\u0437\u0435\u0432\u0441\u043a\u043e\u0435",
      "longitude":84.878471,
      "latitude":56.489021
    },
    "2965":{
      "name":"\u041a\u0430\u043b\u0442\u0430\u0439",
      "longitude":84.879135,
      "latitude":56.278866
    },
    "2966":{
      "name":"\u041b\u044b\u0441\u0430\u044f \u0413\u043e\u0440\u0430",
      "longitude":84.8807683,
      "latitude":57.8514398
    },
    "2967":{
      "name":"\u0422\u0430\u0445\u0442\u0430\u043c\u044b\u0448\u0435\u0432\u043e",
      "longitude":84.88166,
      "latitude":56.379612
    },
    "2968":{
      "name":"\u042d\u0443\u0448\u0442\u0430",
      "longitude":84.891838,
      "latitude":56.529686
    },
    "2969":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0439 \u0421\u043a\u043b\u0430\u0434",
      "longitude":84.9100794,
      "latitude":56.5085835
    },
    "2970":{
      "name":"\u0427\u0451\u0440\u043d\u0430\u044f \u0420\u0435\u0447\u043a\u0430",
      "longitude":84.911087,
      "latitude":56.399586
    },
    "2971":{
      "name":"\u0421\u0438\u043d\u0438\u0439 \u0423\u0442\u0451\u0441",
      "longitude":84.9216804,
      "latitude":56.3368961
    },
    "2972":{
      "name":"\u0412\u0435\u0440\u0448\u0438\u043d\u0438\u043d\u043e",
      "longitude":84.926575,
      "latitude":56.225468
    },
    "2973":{
      "name":"\u042f\u0440\u0441\u043a\u043e\u0435",
      "longitude":84.936867,
      "latitude":56.156025
    },
    "2974":{
      "name":"\u041a\u043e\u043b\u0430\u0440\u043e\u0432\u043e",
      "longitude":84.940498,
      "latitude":56.335175
    },
    "2975":{
      "name":"\u0411\u0430\u0442\u0443\u0440\u0438\u043d\u043e",
      "longitude":84.974373,
      "latitude":56.257439
    },
    "2976":{
      "name":"\u0411\u0430\u0441\u0430\u043d\u0434\u0430\u0439\u043a\u0430",
      "longitude":84.9814968,
      "latitude":56.4110674
    },
    "2977":{
      "name":"\u0410\u043d\u0438\u043a\u0438\u043d\u043e",
      "longitude":84.9893495,
      "latitude":56.409311
    },
    "2978":{
      "name":"\u041a\u0443\u0437\u043e\u0432\u043b\u0435\u0432\u043e",
      "longitude":85.005905,
      "latitude":56.57378
    },
    "2979":{
      "name":"\u041f\u0440\u043e\u0441\u0442\u043e\u0440\u043d\u044b\u0439",
      "longitude":85.0130329,
      "latitude":56.4149614
    },
    "2980":{
      "name":"\u041a\u043b\u044e\u0447\u0438",
      "longitude":85.0284142,
      "latitude":56.404613
    },
    "2981":{
      "name":"\u041b\u0443\u0447\u0430\u043d\u043e\u0432\u043e",
      "longitude":85.054466,
      "latitude":56.357693
    },
    "2982":{
      "name":"\u0421\u0442\u0435\u043a\u043b\u043e\u0437\u0430\u0432\u043e\u0434",
      "longitude":85.0579888,
      "latitude":56.3648483
    },
    "2983":{
      "name":"\u0410\u043f\u0440\u0435\u043b\u044c",
      "longitude":85.0729427,
      "latitude":56.3887438
    },
    "2984":{
      "name":"\u041f\u043e\u0437\u0434\u043d\u0435\u0435\u0432\u043e",
      "longitude":85.077408,
      "latitude":56.410686
    },
    "2985":{
      "name":"\u041c\u0430\u0433\u0430\u0434\u0430\u0435\u0432\u043e",
      "longitude":85.079394,
      "latitude":56.3728584
    },
    "2986":{
      "name":"\u0422\u0440\u0443\u0431\u0430\u0447\u0435\u0432\u043e",
      "longitude":85.0998587,
      "latitude":56.4285128
    },
    "2987":{
      "name":"\u041a\u043e\u043f\u044b\u043b\u043e\u0432\u043e",
      "longitude":85.1028656,
      "latitude":56.6067869
    },
    "2988":{
      "name":"\u041d\u0430\u0443\u043c\u043e\u0432\u043a\u0430",
      "longitude":85.10714,
      "latitude":56.760071
    },
    "2989":{
      "name":"\u041b\u043e\u0441\u043a\u0443\u0442\u043e\u0432\u043e",
      "longitude":85.109108,
      "latitude":56.378063
    },
    "2990":{
      "name":"\u041c\u0438\u0440\u043d\u044b\u0439",
      "longitude":85.116737,
      "latitude":56.441978
    },
    "2991":{
      "name":"\u041d\u0435\u043a\u0440\u0430\u0441\u043e\u0432\u043e",
      "longitude":85.1352385,
      "latitude":56.3441696
    },
    "2992":{
      "name":"\u0410\u043a\u0441\u0451\u043d\u043e\u0432\u043e",
      "longitude":85.139511,
      "latitude":56.324608
    },
    "2993":{
      "name":"\u041d\u043e\u0432\u043e\u043c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":85.143005,
      "latitude":56.5406
    },
    "2994":{
      "name":"\u0411\u043e\u0433\u0430\u0448\u0451\u0432\u043e",
      "longitude":85.147224,
      "latitude":56.366276
    },
    "2995":{
      "name":"\u041d\u0443\u043b\u0435\u0432\u043e\u0439 \u041f\u0438\u043a\u0435\u0442",
      "longitude":85.152977,
      "latitude":57.77922800000001
    },
    "2996":{
      "name":"\u041e\u0432\u0440\u0430\u0436\u043d\u043e\u0435",
      "longitude":85.1567733,
      "latitude":56.2318581
    },
    "2997":{
      "name":"\u041c\u0430\u043b\u043e\u0435 \u041f\u0440\u043e\u0442\u043e\u043f\u043e\u043f\u043e\u0432\u043e",
      "longitude":85.161209,
      "latitude":56.426544
    },
    "2998":{
      "name":"\u041a\u043e\u0440\u043d\u0438\u043b\u043e\u0432\u043e",
      "longitude":85.170868,
      "latitude":56.495255
    },
    "2999":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0435 \u041f\u0440\u043e\u0442\u043e\u043f\u043e\u043f\u043e\u0432\u043e",
      "longitude":85.17971,
      "latitude":56.418282
    },
    "3000":{
      "name":"\u0411\u0435\u043b\u043e\u0443\u0441\u043e\u0432\u043e",
      "longitude":85.182785,
      "latitude":56.305416
    },
    "3001":{
      "name":"\u0411\u0430\u0442\u0443\u0440\u0438\u043d\u043e",
      "longitude":85.188324,
      "latitude":57.757053
    },
    "3002":{
      "name":"\u0421\u0430\u0444\u0440\u043e\u043d\u043e\u0432\u043e",
      "longitude":85.1951428,
      "latitude":56.4514171
    },
    "3003":{
      "name":"\u0420\u0430\u0441\u0441\u0432\u0435\u0442",
      "longitude":85.200081,
      "latitude":56.625328
    },
    "3004":{
      "name":"\u0410\u044d\u0440\u043e\u043f\u043e\u0440\u0442",
      "longitude":85.205238,
      "latitude":56.389336
    },
    "3005":{
      "name":"\u041b\u0438\u0441\u0438\u0446\u0430",
      "longitude":85.226944,
      "latitude":58.699844
    },
    "3006":{
      "name":"\u042f\u0433\u043e\u0434\u043d\u043e\u0435",
      "longitude":85.232315,
      "latitude":58.254745
    },
    "3007":{
      "name":"\u041b\u044f\u0437\u0433\u0438\u043d\u043e",
      "longitude":85.233185,
      "latitude":56.484398
    },
    "3008":{
      "name":"\u0412\u043e\u0440\u043e\u043d\u0438\u043d\u043e",
      "longitude":85.255806,
      "latitude":56.557327
    },
    "3009":{
      "name":"\u041f\u0435\u0442\u0443\u0445\u043e\u0432\u043e",
      "longitude":85.2664647,
      "latitude":56.3233471
    },
    "3010":{
      "name":"\u0413\u0430\u0440\u044c",
      "longitude":85.271667,
      "latitude":57.09639
    },
    "3011":{
      "name":"\u0421\u0443\u0445\u0430\u0440\u0435\u0432\u043e",
      "longitude":85.2793394,
      "latitude":56.2951613
    },
    "3012":{
      "name":"\u0417\u0430\u0440\u0435\u0447\u043d\u044b\u0439",
      "longitude":85.3210918,
      "latitude":56.6525464
    },
    "3013":{
      "name":"\u041c\u043e\u043b\u043e\u0434\u0451\u0436\u043d\u044b\u0439",
      "longitude":85.322189,
      "latitude":56.677029
    },
    "3014":{
      "name":"\u041c\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":85.343315,
      "latitude":56.698982
    },
    "3015":{
      "name":"\u0417\u0430\u0440\u0435\u0447\u043d\u044b\u0439",
      "longitude":85.3545271,
      "latitude":56.2918272
    },
    "3016":{
      "name":"\u0421\u0435\u043c\u0438\u043b\u0443\u0436\u043a\u0438",
      "longitude":85.364891,
      "latitude":56.6157
    },
    "3017":{
      "name":"\u041c\u0435\u0436\u0435\u043d\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":85.367683,
      "latitude":56.358738
    },
    "3018":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":85.386749,
      "latitude":56.74192
    },
    "3019":{
      "name":"\u0421\u0430\u0439\u0433\u0430",
      "longitude":85.427574,
      "latitude":58.024899
    },
    "3020":{
      "name":"\u041e\u043a\u0442\u044f\u0431\u0440\u044c\u0441\u043a\u043e\u0435",
      "longitude":85.4428792,
      "latitude":56.7292253
    },
    "3021":{
      "name":"\u0421\u0443\u0445\u043e\u0440\u0435\u0447\u044c\u0435",
      "longitude":85.4645583,
      "latitude":56.477506
    },
    "3022":{
      "name":"\u0423\u0441\u0442\u044c-\u042e\u043b",
      "longitude":85.4760525,
      "latitude":57.7409586
    },
    "3023":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u043f\u0430\u0448\u0435\u043d\u0441\u043a",
      "longitude":85.484489,
      "latitude":57.572613
    },
    "3024":{
      "name":"\u0411\u0430\u0441\u0430\u043d\u0434\u0430\u0439\u043a\u0430",
      "longitude":85.4869,
      "latitude":56.283859
    },
    "3025":{
      "name":"\u0425\u0430\u043b\u0434\u0435\u0435\u0432\u043e",
      "longitude":85.587982,
      "latitude":56.631714
    },
    "3026":{
      "name":"\u041c\u0430\u043a\u0437\u044b\u0440",
      "longitude":85.603065,
      "latitude":58.620972
    },
    "3027":{
      "name":"\u0418\u0442\u0430\u0442\u043a\u0430",
      "longitude":85.603767,
      "latitude":56.823124
    },
    "3028":{
      "name":"\u0422\u043e\u043c\u0441\u043a\u043e\u0435",
      "longitude":85.61834,
      "latitude":56.84264
    },
    "3029":{
      "name":"\u0410\u043b\u044c\u043c\u044f\u043a\u043e\u0432\u043e",
      "longitude":85.6893467,
      "latitude":57.6172155
    },
    "3030":{
      "name":"\u0410\u043f\u0441\u0430\u0433\u0430\u0447\u0435\u0432\u043e",
      "longitude":85.7835338,
      "latitude":57.5856849
    },
    "3031":{
      "name":"\u0423\u043b\u0443-\u042e\u043b",
      "longitude":85.7929652,
      "latitude":57.7107009
    },
    "3032":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0435 \u0421\u043e\u043a\u043e\u043b\u044b",
      "longitude":85.793633,
      "latitude":56.877575
    },
    "3033":{
      "name":"\u041c\u043e\u0438\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":85.808388,
      "latitude":56.937557
    },
    "3034":{
      "name":"\u041f\u043e\u0434\u043b\u043e\u043c\u0441\u043a",
      "longitude":85.810333,
      "latitude":56.648956
    },
    "3035":{
      "name":"\u0424\u0438\u043b\u0438\u043c\u043e\u043d\u043e\u0432\u043a\u0430",
      "longitude":85.817871,
      "latitude":57.177773
    },
    "3036":{
      "name":"\u0426\u0432\u0435\u0442\u043a\u043e\u0432\u043a\u0430",
      "longitude":85.839249,
      "latitude":56.805428
    },
    "3037":{
      "name":"\u041a\u043b\u044e\u043a\u0432\u0438\u043d\u043a\u0430",
      "longitude":85.857155,
      "latitude":58.53862
    },
    "3038":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u041a\u043e\u0440\u0434\u043e\u043d",
      "longitude":85.865646,
      "latitude":57.374809
    },
    "3039":{
      "name":"\u041d\u043e\u0432\u043e\u043d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":85.869026,
      "latitude":57.299557
    },
    "3040":{
      "name":"\u041d\u043e\u0432\u043e\u0430\u0440\u0445\u0430\u043d\u0433\u0435\u043b\u044c\u0441\u043a\u043e\u0435",
      "longitude":85.890915,
      "latitude":56.71246
    },
    "3041":{
      "name":"\u041b\u0430\u0442\u0430\u0442",
      "longitude":85.911514,
      "latitude":56.749184
    },
    "3042":{
      "name":"\u041a\u0430\u0437\u0430\u043d\u043a\u0430",
      "longitude":85.921555,
      "latitude":57.088993
    },
    "3043":{
      "name":"\u0420\u043e\u043c\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":85.936508,
      "latitude":56.45499
    },
    "3044":{
      "name":"\u041d\u043e\u0432\u0438\u043a\u043e\u0432\u043a\u0430",
      "longitude":85.959297,
      "latitude":56.925964
    },
    "3045":{
      "name":"\u0421\u0432\u0435\u0442\u043b\u044b\u0439",
      "longitude":85.969597,
      "latitude":56.93552
    },
    "3046":{
      "name":"\u0422\u0443\u0440\u0443\u043d\u0442\u0430\u0435\u0432\u043e",
      "longitude":85.973747,
      "latitude":56.645527
    },
    "3047":{
      "name":"\u041f\u0435\u0440\u043e\u0432\u043a\u0430",
      "longitude":85.975204,
      "latitude":56.690311
    },
    "3048":{
      "name":"\u041d\u043e\u0432\u043e\u0440\u043e\u0436\u0434\u0435\u0441\u0442\u0432\u0435\u043d\u0441\u043a\u043e\u0435",
      "longitude":85.997566,
      "latitude":56.487888
    },
    "3049":{
      "name":"\u0426\u0435\u043d\u0442\u0440\u0430\u043b\u044c\u043d\u044b\u0439",
      "longitude":86.001638,
      "latitude":58.9490562
    },
    "3050":{
      "name":"\u041a\u043e\u043c\u0441\u043e\u043c\u043e\u043b\u044c\u0441\u043a",
      "longitude":86.026436,
      "latitude":57.410019
    },
    "3051":{
      "name":"\u0411\u0430\u043b\u0430\u0433\u0430\u0447\u0435\u0432\u043e",
      "longitude":86.0269398,
      "latitude":57.3743382
    },
    "3052":{
      "name":"\u0421\u0442\u0430\u0440\u043e-\u041a\u0443\u0441\u043a\u043e\u0432\u043e",
      "longitude":86.040001,
      "latitude":57.067257
    },
    "3053":{
      "name":"\u0421\u0430\u0445\u0430\u043b\u0438\u043d\u043a\u0430",
      "longitude":86.0484481,
      "latitude":57.3140053
    },
    "3054":{
      "name":"\u0422\u0430\u0437\u044b\u0440\u0431\u0430\u043a",
      "longitude":86.0497721,
      "latitude":57.3788664
    },
    "3055":{
      "name":"\u0426\u0430\u0440\u0438\u0446\u044b\u043d\u043a\u0430",
      "longitude":86.0592646,
      "latitude":57.231034
    },
    "3056":{
      "name":"\u041d\u043e\u0432\u043e-\u041a\u0443\u0441\u043a\u043e\u0432\u043e",
      "longitude":86.065926,
      "latitude":57.052601
    },
    "3057":{
      "name":"\u0410\u0440\u0433\u0430\u0442-\u042e\u043b",
      "longitude":86.0696937,
      "latitude":57.8521919
    },
    "3058":{
      "name":"\u0422\u0438\u0445\u043e\u043c\u0438\u0440\u043e\u0432\u043a\u0430",
      "longitude":86.0721887,
      "latitude":56.9308222
    },
    "3059":{
      "name":"\u0414\u0440\u0443\u0436\u043d\u044b\u0439",
      "longitude":86.073906,
      "latitude":58.761368
    },
    "3060":{
      "name":"\u0412\u043e\u0437\u043d\u0435\u0441\u0435\u043d\u043a\u0430",
      "longitude":86.0747552,
      "latitude":57.2020818
    },
    "3061":{
      "name":"\u0421\u0435\u0440\u0433\u0435\u0435\u0432\u043e",
      "longitude":86.0776753,
      "latitude":57.2719391
    },
    "3062":{
      "name":"\u0418\u0442\u0430\u0442\u043a\u0430",
      "longitude":86.0886266,
      "latitude":56.938588
    },
    "3063":{
      "name":"\u042f\u0433\u043e\u0434\u043d\u043e\u0435",
      "longitude":86.090385,
      "latitude":56.803173
    },
    "3064":{
      "name":"\u0415\u0436\u0438",
      "longitude":86.1146683,
      "latitude":57.156059
    },
    "3065":{
      "name":"\u041c\u0430\u0437\u0430\u043b\u043e\u0432\u043e",
      "longitude":86.126656,
      "latitude":56.595417
    },
    "3066":{
      "name":"\u0423\u0441\u043f\u0435\u043d\u043a\u0430",
      "longitude":86.1425633,
      "latitude":57.1390759
    },
    "3067":{
      "name":"\u0412\u043e\u0440\u043e\u043d\u0438\u043d\u043e-\u042f\u044f",
      "longitude":86.1765599,
      "latitude":56.8759418
    },
    "3068":{
      "name":"\u0420\u043e\u0436\u0434\u0435\u0441\u0442\u0432\u0435\u043d\u043a\u0430",
      "longitude":86.1842341,
      "latitude":57.312428
    },
    "3069":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0435-\u0416\u0438\u0440\u043e\u0432\u043e",
      "longitude":86.1880612,
      "latitude":56.8109724
    },
    "3070":{
      "name":"\u041d\u043e\u0432\u044b\u0439",
      "longitude":86.198645,
      "latitude":57.1089184
    },
    "3071":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0435-\u0414\u043e\u0440\u043e\u0445\u043e\u0432\u043e",
      "longitude":86.198914,
      "latitude":56.889816
    },
    "3072":{
      "name":"\u0423\u0437\u0435\u043d\u044c",
      "longitude":86.2068934,
      "latitude":57.2987048
    },
    "3073":{
      "name":"\u041f\u043e\u0431\u0435\u0434\u0430",
      "longitude":86.256775,
      "latitude":56.94735
    },
    "3074":{
      "name":"\u0411\u0435\u043b\u044f\u0439",
      "longitude":86.2636506,
      "latitude":57.0508964
    },
    "3075":{
      "name":"\u0421\u0435\u043c\u0451\u043d\u043e\u0432\u043a\u0430",
      "longitude":86.286728,
      "latitude":56.873623
    },
    "3076":{
      "name":"\u041b\u043e\u043c\u043e\u0432\u0438\u0446\u043a-2",
      "longitude":86.3055987,
      "latitude":57.127664
    },
    "3077":{
      "name":"\u041a\u0440\u0443\u0442\u043e\u043b\u043e\u0436\u043d\u043e\u0435",
      "longitude":86.3251252,
      "latitude":57.0397623
    },
    "3078":{
      "name":"\u0422\u043e\u0440\u0431\u0435\u0435\u0432\u043e",
      "longitude":86.3411326,
      "latitude":57.0247521
    },
    "3079":{
      "name":"\u041c\u0438\u0448\u0443\u0442\u0438\u043d\u043e",
      "longitude":86.343628,
      "latitude":56.717613
    },
    "3080":{
      "name":"\u0422\u0438\u043d\u0434\u0435\u0440\u043b\u0438\u043d\u043a\u0430",
      "longitude":86.379084,
      "latitude":56.9924728
    },
    "3081":{
      "name":"\u0422\u0443\u0435\u043d\u0434\u0430\u0442",
      "longitude":86.3991522,
      "latitude":57.1339074
    },
    "3082":{
      "name":"\u0413\u0440\u043e\u043c\u044b\u0448\u0435\u0432\u043a\u0430",
      "longitude":86.420876,
      "latitude":56.596073
    },
    "3083":{
      "name":"\u041a\u0430\u043b\u043c\u0430\u043a\u0438",
      "longitude":86.4308686,
      "latitude":56.9893434
    },
    "3084":{
      "name":"\u0414\u0443\u0431\u0440\u043e\u0432\u043a\u0430",
      "longitude":86.446457,
      "latitude":56.72995
    },
    "3085":{
      "name":"\u0426\u044b\u0433\u0430\u043d\u043e\u0432\u043e",
      "longitude":86.466156,
      "latitude":56.868717
    },
    "3086":{
      "name":"\u041a\u0443\u044f\u043d\u043e\u0432\u043e",
      "longitude":86.4674324,
      "latitude":56.949108
    },
    "3087":{
      "name":"\u041d\u043e\u0432\u043e\u043c\u0430\u0440\u0438\u0438\u043d\u043a\u0430",
      "longitude":86.503349,
      "latitude":57.137726
    },
    "3088":{
      "name":"\u0423\u0439\u0434\u0430\u043d\u043e\u0432\u043e",
      "longitude":86.5494866,
      "latitude":56.9333763
    },
    "3089":{
      "name":"\u0411\u0435\u0440\u043b\u0438\u043d\u043a\u0430",
      "longitude":86.552155,
      "latitude":56.832485
    },
    "3090":{
      "name":"\u041f\u0440\u0438\u0447\u0443\u043b\u044b\u043c\u0441\u043a\u0438\u0439",
      "longitude":86.5691495,
      "latitude":56.8410301
    },
    "3091":{
      "name":"\u041a\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":86.6027445,
      "latitude":57.1272913
    },
    "3092":{
      "name":"\u0413\u043e\u0440\u043e\u0434\u043e\u043a",
      "longitude":86.6478467,
      "latitude":56.9162338
    },
    "3093":{
      "name":"\u041e\u0440\u0435\u0445\u043e\u0432\u043e",
      "longitude":86.687546,
      "latitude":57.220161
    },
    "3094":{
      "name":"\u0411\u043e\u0433\u043e\u0441\u043b\u043e\u0432\u043a\u0430",
      "longitude":86.724182,
      "latitude":56.803886
    },
    "3095":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u043a\u0430",
      "longitude":86.7565083,
      "latitude":57.006642
    },
    "3096":{
      "name":"\u0421\u0442\u0435\u043f\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":86.769531,
      "latitude":58.636868
    },
    "3097":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":86.807343,
      "latitude":56.708427
    },
    "3098":{
      "name":"\u0418\u043b\u043e\u0432\u043a\u0430",
      "longitude":86.820847,
      "latitude":56.889511
    },
    "3099":{
      "name":"\u041c\u0430\u043a\u0441\u0438\u043c\u043a\u0438\u043d \u042f\u0440",
      "longitude":86.8212875,
      "latitude":58.6785322
    },
    "3100":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u044f\u0440\u043a\u0430",
      "longitude":86.834068,
      "latitude":56.815266
    },
    "3101":{
      "name":"\u041f\u0440\u0443\u0448\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":86.9080327,
      "latitude":56.8862105
    },
    "3102":{
      "name":"\u0412\u044b\u0441\u043e\u043a\u043e\u0435",
      "longitude":86.909538,
      "latitude":56.604626
    },
    "3103":{
      "name":"\u0422\u0430\u0432\u043b\u044b",
      "longitude":86.9232678,
      "latitude":56.5949152
    },
    "3104":{
      "name":"\u0427\u0435\u0440\u0434\u0430\u0442\u044b",
      "longitude":86.933632,
      "latitude":56.954346
    },
    "3105":{
      "name":"\u041e\u043a\u0443\u043d\u0435\u0435\u0432\u043e",
      "longitude":86.987801,
      "latitude":56.772156
    },
    "3106":{
      "name":"\u0428\u0438\u043d\u044f\u0435\u0432\u043e",
      "longitude":87.028679,
      "latitude":56.666519
    },
    "3107":{
      "name":"\u041a\u0443\u0447\u0443\u043a\u043e\u0432\u043e",
      "longitude":87.0314768,
      "latitude":56.9704429
    },
    "3108":{
      "name":"\u0411\u0435\u043b\u043e\u0432\u043e\u0434\u043e\u0432\u043a\u0430",
      "longitude":87.073021,
      "latitude":56.597076
    },
    "3109":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u0430\u044f \u0413\u043e\u0440\u043a\u0430",
      "longitude":87.2356258,
      "latitude":57.1061707
    },
    "3110":{
      "name":"\u0427\u0451\u0440\u043d\u044b\u0439 \u042f\u0440",
      "longitude":87.3157177,
      "latitude":57.0457049
    },
    "3111":{
      "name":"\u0411\u0435\u0440\u0435\u0433\u0430\u0435\u0432\u043e",
      "longitude":87.5486325,
      "latitude":57.2056643
    },
    "3112":{
      "name":"\u0423\u0441\u0442\u044c-\u041e\u0437\u0451\u0440\u043d\u043e\u0435",
      "longitude":87.7239958,
      "latitude":58.9054839
    },
    "3113":{
      "name":"\u041a\u0430\u0442\u0430\u0439\u0433\u0430",
      "longitude":87.930588,
      "latitude":58.744049
    },
    "3114":{
      "name":"\u0427\u0435\u0442\u044c-\u041a\u043e\u043d\u0442\u043e\u0440\u043a\u0430",
      "longitude":88.1183725,
      "latitude":57.0605209
    },
    "3115":{
      "name":"\u0426\u0435\u043d\u0442\u0440\u043e\u043f\u043e\u043b\u0438\u0433\u043e\u043d",
      "longitude":88.281715,
      "latitude":57.418991
    },
    "3116":{
      "name":"\u041d\u043e\u0432\u043e\u0448\u0443\u043c\u0438\u043b\u043e\u0432\u043e",
      "longitude":88.5111013,
      "latitude":57.4204933
    },
    "3117":{
      "name":"\u0411\u0435\u043b\u044b\u0439 \u042f\u0440",
      "longitude":88.7660617,
      "latitude":57.5006853
    },
    "3118":{
      "name":"\u0415\u043b\u0430\u043d\u043a\u0430",
      "longitude":75.294067,
      "latitude":55.625153
    },
    "3119":{
      "name":"\u0423\u0441\u043a\u044e\u043b\u044c",
      "longitude":75.354065,
      "latitude":55.333885
    },
    "3120":{
      "name":"\u0423\u0432\u0430\u043b\u044c\u0441\u043a\u043e\u0435",
      "longitude":75.373253,
      "latitude":55.473545
    },
    "3121":{
      "name":"\u041d\u043e\u0432\u043e\u043f\u0435\u0440\u0432\u043e\u043c\u0430\u0439\u0441\u043a\u043e\u0435",
      "longitude":75.405014,
      "latitude":55.140121
    },
    "3122":{
      "name":"\u041a\u043e\u0437\u0438\u043d\u043e",
      "longitude":75.489632,
      "latitude":55.515091
    },
    "3123":{
      "name":"\u041d\u0435\u0443\u0434\u0430\u0447\u0438\u043d\u043e",
      "longitude":75.507233,
      "latitude":55.135757
    },
    "3124":{
      "name":"\u041d\u0438\u043a\u0443\u043b\u0438\u043d\u043e",
      "longitude":75.520653,
      "latitude":55.046822
    },
    "3125":{
      "name":"\u0417\u0443\u0431\u043e\u0432\u043a\u0430",
      "longitude":75.527527,
      "latitude":54.848797
    },
    "3126":{
      "name":"\u041f\u043e\u0431\u0435\u0434\u0430",
      "longitude":75.551895,
      "latitude":55.644604
    },
    "3127":{
      "name":"\u0414\u043c\u0438\u0442\u0440\u0438\u0435\u0432\u043a\u0430",
      "longitude":75.6069572,
      "latitude":55.1636116
    },
    "3128":{
      "name":"\u0429\u0435\u0440\u0431\u0430\u043a\u0438",
      "longitude":75.676186,
      "latitude":55.546898
    },
    "3129":{
      "name":"\u042f\u0440\u043a\u0443\u043b\u044c",
      "longitude":75.678429,
      "latitude":55.993145
    },
    "3130":{
      "name":"\u041a\u043e\u0437\u043b\u043e\u0432\u043a\u0430",
      "longitude":75.696579,
      "latitude":55.239323
    },
    "3131":{
      "name":"\u041b\u043e\u043f\u0430\u0442\u0438\u043d\u043e",
      "longitude":75.727188,
      "latitude":55.390049
    },
    "3132":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":75.737129,
      "latitude":54.815506
    },
    "3133":{
      "name":"\u041a\u0443\u0448\u0430\u0433\u0438",
      "longitude":75.750587,
      "latitude":55.672108
    },
    "3134":{
      "name":"\u0420\u043e\u0436\u0434\u0435\u0441\u0442\u0432\u0435\u043d\u043a\u0430",
      "longitude":75.766174,
      "latitude":55.139385
    },
    "3135":{
      "name":"\u0411\u043e\u0433\u043e\u0441\u043b\u043e\u0432\u043a\u0430",
      "longitude":75.840401,
      "latitude":55.516739
    },
    "3136":{
      "name":"\u041a\u043e\u043d\u0441\u0442\u0430\u043d\u0442\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":75.865402,
      "latitude":54.935707
    },
    "3137":{
      "name":"\u041a\u0430\u0437\u0430\u0447\u0438\u0439 \u041c\u044b\u0441",
      "longitude":75.877525,
      "latitude":55.508488
    },
    "3138":{
      "name":"\u0421\u0435\u0432\u0435\u0440\u043e\u0442\u0430\u0442\u0430\u0440\u0441\u043a\u043e\u0435",
      "longitude":75.895645,
      "latitude":55.183365
    },
    "3139":{
      "name":"\u0418\u0448\u0438\u043c\u0441\u043a\u0430\u044f",
      "longitude":75.901863,
      "latitude":54.725471
    },
    "3140":{
      "name":"\u041f\u043e\u043b\u044c\u044f\u043d\u043e\u0432\u043e",
      "longitude":75.904327,
      "latitude":54.558567
    },
    "3141":{
      "name":"\u041e\u0440\u043b\u043e\u0432\u043a\u0430",
      "longitude":75.9429665,
      "latitude":54.8722367
    },
    "3142":{
      "name":"\u041d\u043e\u0432\u043e\u043d\u0438\u043a\u043e\u043b\u044c\u0441\u043a",
      "longitude":75.984055,
      "latitude":55.71666
    },
    "3143":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u0438\u043b\u0438\u0448",
      "longitude":75.987877,
      "latitude":55.946007
    },
    "3144":{
      "name":"\u041d\u043e\u0432\u043e\u043f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":76.00472162072752,
      "latitude":55.19024035763238
    },
    "3145":{
      "name":"\u041d\u043e\u0432\u043e\u0442\u0440\u043e\u0438\u0446\u043a",
      "longitude":75.99482,
      "latitude":55.339283
    },
    "3146":{
      "name":"\u041c\u0430\u043b\u043e\u043a\u0440\u0430\u0441\u043d\u043e\u044f\u0440\u043a\u0430",
      "longitude":76.010971,
      "latitude":56.4645
    },
    "3147":{
      "name":"\u041a\u0430\u043c\u044b\u0448\u0435\u0432\u043e",
      "longitude":76.027687,
      "latitude":55.623947
    },
    "3148":{
      "name":"\u0423\u0433\u0443\u0439",
      "longitude":76.045006,
      "latitude":56.028999
    },
    "3149":{
      "name":"\u0420\u043e\u043c\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":76.048569,
      "latitude":54.648792
    },
    "3150":{
      "name":"\u041a\u0430\u0437\u0430\u0442\u043a\u0443\u043b\u044c",
      "longitude":76.053322,
      "latitude":55.030777
    },
    "3151":{
      "name":"\u041a\u0438\u0435\u0432\u043a\u0430",
      "longitude":76.068405,
      "latitude":55.257275
    },
    "3152":{
      "name":"\u042f\u0440\u043a\u0443\u043b\u044c-\u041c\u0430\u0442\u044e\u0448\u043a\u0438\u043d\u043e",
      "longitude":76.093445,
      "latitude":55.844444
    },
    "3153":{
      "name":"\u041a\u043e\u0447\u043d\u0435\u0432\u043a\u0430",
      "longitude":76.124832,
      "latitude":55.480732
    },
    "3154":{
      "name":"\u041e\u043a\u0442\u044f\u0431\u0440\u044c\u0441\u043a\u0438\u0439",
      "longitude":76.136307,
      "latitude":55.940319
    },
    "3155":{
      "name":"\u0423\u0441\u043f\u0435\u043d\u043a\u0430",
      "longitude":76.168175,
      "latitude":54.884937
    },
    "3156":{
      "name":"\u041e\u043b\u044c\u0433\u0438\u043d\u043e",
      "longitude":76.172417,
      "latitude":54.78223
    },
    "3157":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u0440\u0430\u0441\u043d\u043e\u0435",
      "longitude":76.18959,
      "latitude":54.337364
    },
    "3158":{
      "name":"\u041d\u043e\u0432\u043e\u043c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":76.19014,
      "latitude":55.080952
    },
    "3159":{
      "name":"\u0421\u0435\u0440\u0433\u0435\u0435\u0432\u043a\u0430",
      "longitude":76.206795,
      "latitude":56.454567
    },
    "3160":{
      "name":"\u041f\u0430\u0432\u043b\u043e\u0432\u043a\u0430",
      "longitude":76.222099,
      "latitude":54.490189
    },
    "3161":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0435\u0440\u0435\u0447\u044c\u0435",
      "longitude":76.232895,
      "latitude":56.566631
    },
    "3162":{
      "name":"\u0412\u0430\u0440\u0432\u0430\u0440\u043e\u0432\u043a\u0430",
      "longitude":76.2576421,
      "latitude":54.3956522
    },
    "3163":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u044f\u0440\u043a\u0430",
      "longitude":76.305443,
      "latitude":55.535286
    },
    "3164":{
      "name":"\u0417\u0430\u043b\u0438\u0432\u0438\u043d\u043e",
      "longitude":76.33252,
      "latitude":56.453327
    },
    "3165":{
      "name":"\u0422\u0430\u0431\u0443\u043b\u0433\u0430",
      "longitude":76.333282,
      "latitude":54.904236
    },
    "3166":{
      "name":"\u041e\u0440\u043b\u043e\u0432\u043a\u0430",
      "longitude":76.3347846,
      "latitude":56.939608
    },
    "3167":{
      "name":"\u0421\u0435\u043b\u0438\u043a\u043b\u0430",
      "longitude":76.347557,
      "latitude":55.769127
    },
    "3168":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u041a\u0443\u043b\u044b\u043d\u0434\u0430",
      "longitude":76.377663,
      "latitude":54.920231
    },
    "3169":{
      "name":"\u0412\u043e\u0437\u043d\u0435\u0441\u0435\u043d\u043a\u0430",
      "longitude":76.385101,
      "latitude":55.61211
    },
    "3170":{
      "name":"\u0415\u0440\u0435\u043c\u0438\u043d\u043e",
      "longitude":76.39872,
      "latitude":56.610477
    },
    "3171":{
      "name":"\u041d\u043e\u0432\u043e\u043b\u043e\u0436\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":76.417221,
      "latitude":56.506069
    },
    "3172":{
      "name":"\u0427\u0435\u0440\u043d\u043e\u0432\u043a\u0430",
      "longitude":76.459496,
      "latitude":56.777809
    },
    "3173":{
      "name":"\u0423\u0441\u043c\u0430\u043d\u043a\u0430",
      "longitude":76.481041,
      "latitude":56.293644
    },
    "3174":{
      "name":"\u0415\u043b\u0438\u0437\u0430\u0432\u0435\u0442\u0438\u043d\u043a\u0430",
      "longitude":76.490723,
      "latitude":54.750904
    },
    "3175":{
      "name":"\u042f\u0431\u043b\u043e\u043d\u0435\u0432\u043a\u0430",
      "longitude":76.521919,
      "latitude":54.710808
    },
    "3176":{
      "name":"\u0412\u0430\u0440\u0430\u043a\u0441\u0438\u043d\u043e",
      "longitude":76.522682,
      "latitude":56.510044
    },
    "3177":{
      "name":"\u0412\u043e\u0440\u043e\u0431\u044c\u0451\u0432\u043e",
      "longitude":76.534836,
      "latitude":56.125954
    },
    "3178":{
      "name":"\u0421\u0438\u0431\u0438\u0440\u0446\u0435\u0432\u043e 1-\u0435",
      "longitude":76.539017,
      "latitude":55.595795
    },
    "3179":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u043f\u0430\u0432\u043b\u043e\u0432\u043a\u0430 2-\u044f",
      "longitude":76.558105,
      "latitude":55.978115
    },
    "3180":{
      "name":"\u0429\u0435\u0433\u043b\u043e\u0432\u043e",
      "longitude":76.564423,
      "latitude":55.349564
    },
    "3181":{
      "name":"\u0416\u0443\u0440\u0430\u0432\u043a\u0430",
      "longitude":76.57132,
      "latitude":54.622936
    },
    "3182":{
      "name":"\u041e\u0447\u043a\u0438\u043d\u043e",
      "longitude":76.600677,
      "latitude":54.721859
    },
    "3183":{
      "name":"\u0417\u0435\u043c\u043b\u044f\u043d\u0430\u044f \u0417\u0430\u0438\u043c\u043a\u0430",
      "longitude":76.616425,
      "latitude":55.171658
    },
    "3184":{
      "name":"\u041f\u0435\u0441\u0447\u0430\u043d\u043e\u0435 \u041e\u0437\u0435\u0440\u043e",
      "longitude":76.64666,
      "latitude":55.027233
    },
    "3185":{
      "name":"\u041c\u0435\u043d\u044c\u0448\u0438\u043a\u043e\u0432\u043e",
      "longitude":76.692268,
      "latitude":55.929646
    },
    "3186":{
      "name":"\u041d\u043e\u0432\u043e\u043f\u0435\u0441\u0447\u0430\u043d\u043e\u0435",
      "longitude":76.697464,
      "latitude":54.840313
    },
    "3187":{
      "name":"\u0427\u0430\u0440\u0433\u0430\u0440\u044b",
      "longitude":76.69825,
      "latitude":55.794205
    },
    "3188":{
      "name":"\u041a\u043e\u043b\u0431\u0430\u0441\u0430",
      "longitude":76.699158,
      "latitude":56.889893
    },
    "3189":{
      "name":"\u041d\u043e\u0432\u044b\u0439 \u0422\u0430\u0440\u0442\u0430\u0441",
      "longitude":76.715065,
      "latitude":55.672279
    },
    "3190":{
      "name":"\u0422\u0440\u043e\u0438\u0446\u043a\u043e\u0435",
      "longitude":76.719742,
      "latitude":54.94886
    },
    "3191":{
      "name":"\u041c\u0430\u043b\u044b\u0439 \u0422\u0435\u0431\u0438\u0441",
      "longitude":76.720139,
      "latitude":55.486511
    },
    "3192":{
      "name":"\u0411\u0430\u0440\u0430\u0431\u043e-\u042e\u0434\u0438\u043d\u043e",
      "longitude":76.728958,
      "latitude":54.54348
    },
    "3193":{
      "name":"\u0417\u0430\u0440\u0435\u0447\u044c\u0435",
      "longitude":76.72908,
      "latitude":55.706982
    },
    "3194":{
      "name":"\u041c\u0435\u0442\u0435\u043b\u0435\u0432\u043e",
      "longitude":76.73822,
      "latitude":54.093178
    },
    "3195":{
      "name":"\u0421\u0442\u0430\u0440\u044b\u0439 \u0422\u0430\u0440\u0442\u0430\u0441",
      "longitude":76.743515,
      "latitude":55.610928
    },
    "3196":{
      "name":"\u041f\u0430\u0432\u043b\u043e\u0432\u043e",
      "longitude":76.787781,
      "latitude":56.147499
    },
    "3197":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u0435",
      "longitude":76.813454,
      "latitude":55.536861
    },
    "3198":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u0441\u0435\u043b\u044c\u0435",
      "longitude":76.817749,
      "latitude":55.461124
    },
    "3199":{
      "name":"\u041c\u043e\u0445\u043e\u0432\u043e\u0435",
      "longitude":76.817863,
      "latitude":55.295074
    },
    "3200":{
      "name":"\u041a\u043b\u044e\u0447\u0435\u0432\u0430\u044f",
      "longitude":76.837975,
      "latitude":55.71822
    },
    "3201":{
      "name":"\u0412\u0438\u0448\u043d\u0435\u0432\u043a\u0430",
      "longitude":76.843376,
      "latitude":53.982479
    },
    "3202":{
      "name":"\u0428\u0438\u043f\u0438\u0446\u044b\u043d\u043e",
      "longitude":76.855186,
      "latitude":54.522568
    },
    "3203":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u0435\u043b\u044c\u0435",
      "longitude":76.885658,
      "latitude":54.17075
    },
    "3204":{
      "name":"\u0412\u0435\u0440\u0445-\u041c\u0430\u0439\u0437\u0430\u0441",
      "longitude":76.889801,
      "latitude":56.684181
    },
    "3205":{
      "name":"\u0411\u043b\u044e\u0434\u0447\u0430\u043d\u0441\u043a\u043e\u0435",
      "longitude":76.891884,
      "latitude":55.112907
    },
    "3206":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u043a\u0430",
      "longitude":76.930824,
      "latitude":56.794441
    },
    "3207":{
      "name":"\u0417\u044b\u043a\u043e\u0432\u043e",
      "longitude":76.939186,
      "latitude":55.668819
    },
    "3208":{
      "name":"\u0411\u043b\u0430\u0433\u043e\u0432\u0435\u0449\u0435\u043d\u043a\u0430",
      "longitude":76.944069,
      "latitude":53.925667
    },
    "3209":{
      "name":"\u041e\u0437\u0435\u0440\u043e-\u041a\u0430\u0440\u0430\u0447\u0438",
      "longitude":76.944824,
      "latitude":55.336124
    },
    "3210":{
      "name":"\u0423\u0441\u0442\u044c-\u0418\u0437\u0435\u0441",
      "longitude":76.946419,
      "latitude":55.928474
    },
    "3211":{
      "name":"\u041d\u043e\u0432\u044b\u0439 \u041c\u0430\u0439\u0437\u0430\u0441",
      "longitude":76.954453,
      "latitude":56.571964
    },
    "3212":{
      "name":"\u041d\u043e\u0432\u043e\u044f\u0440\u043a\u0443\u043b\u044c",
      "longitude":76.964294,
      "latitude":55.365322
    },
    "3213":{
      "name":"\u0422\u0430\u0440\u043c\u0430\u043a\u0443\u043b\u044c",
      "longitude":76.972878,
      "latitude":55.307568
    },
    "3214":{
      "name":"\u041e\u0437\u0435\u0440\u043e-\u041a\u0430\u0440\u0430\u0447\u0438",
      "longitude":76.973167,
      "latitude":55.35207
    },
    "3215":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u043f\u0430\u0432\u043b\u043e\u0432\u043a\u0430 1-\u044f",
      "longitude":76.991653,
      "latitude":55.805836
    },
    "3216":{
      "name":"\u0421\u043e\u0432\u0435\u0442\u0441\u043a\u0438\u0439",
      "longitude":77.028885,
      "latitude":54.028252
    },
    "3217":{
      "name":"\u0422\u0443\u0440\u0443\u043d\u043e\u0432\u043a\u0430",
      "longitude":77.032089,
      "latitude":55.64209
    },
    "3218":{
      "name":"\u041a\u0438\u0440\u0433\u0438\u043d\u0446\u0435\u0432\u043e",
      "longitude":77.034821,
      "latitude":54.237869
    },
    "3219":{
      "name":"\u041d\u043e\u0432\u043e\u0444\u0435\u043a\u043b\u0438\u043d\u043e",
      "longitude":77.036087,
      "latitude":55.129803
    },
    "3220":{
      "name":"\u0421\u0442\u0430\u0440\u0430\u044f \u041f\u0440\u0435\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043a\u0430",
      "longitude":77.047523,
      "latitude":55.50111
    },
    "3221":{
      "name":"\u0421\u0442\u0430\u0440\u044b\u0435 \u041a\u0430\u0440\u0430\u0447\u0438",
      "longitude":77.048927,
      "latitude":55.495968
    },
    "3222":{
      "name":"\u041d\u043e\u0432\u043e\u043f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":77.059166,
      "latitude":54.642452
    },
    "3223":{
      "name":"\u0421\u0438\u0431\u0438\u0440\u0446\u0435\u0432\u043e 2-\u0435",
      "longitude":77.076309,
      "latitude":56.022701
    },
    "3224":{
      "name":"\u041c\u0435\u0434\u044f\u043a\u043e\u0432\u043e",
      "longitude":77.087288,
      "latitude":54.129219
    },
    "3225":{
      "name":"\u041d\u043e\u0432\u043e\u043f\u0440\u0435\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043a\u0430",
      "longitude":77.093353,
      "latitude":55.339912
    },
    "3226":{
      "name":"\u041a\u0430\u043c\u044b\u0448\u0438\u043d\u043e",
      "longitude":77.118454,
      "latitude":54.239155
    },
    "3227":{
      "name":"\u0423\u0440\u0435\u0437",
      "longitude":77.119736,
      "latitude":55.919487
    },
    "3228":{
      "name":"\u0421\u0442\u0435\u043a\u043b\u044f\u043d\u043d\u043e\u0435",
      "longitude":77.142822,
      "latitude":54.355637
    },
    "3229":{
      "name":"\u0422\u0435\u0440\u0435\u043d\u0433\u0443\u043b\u044c",
      "longitude":77.160271,
      "latitude":53.827644
    },
    "3230":{
      "name":"\u041a\u0440\u0443\u0442\u0438\u0445\u0430",
      "longitude":77.165085,
      "latitude":56.817802
    },
    "3231":{
      "name":"\u041d\u043e\u0432\u044b\u0435 \u041a\u0443\u043b\u0438\u043a\u0438",
      "longitude":77.182671,
      "latitude":56.145264
    },
    "3232":{
      "name":"\u041a\u043e\u0448\u043a\u0443\u043b\u044c",
      "longitude":77.184082,
      "latitude":55.289734
    },
    "3233":{
      "name":"\u041a\u0443\u043b\u044f\u0431\u0430",
      "longitude":77.188881,
      "latitude":56.521778
    },
    "3234":{
      "name":"\u041f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":77.222984,
      "latitude":55.56152
    },
    "3235":{
      "name":"\u041e\u0442\u0440\u0435\u0447\u0435\u043d\u0441\u043a\u043e\u0435",
      "longitude":77.227417,
      "latitude":55.118225
    },
    "3236":{
      "name":"\u041e\u0441\u0438\u043d\u0446\u0435\u0432\u043e",
      "longitude":77.231178,
      "latitude":55.497696
    },
    "3237":{
      "name":"\u0421\u0438\u0431\u0438\u0440\u0441\u043a\u0438\u0439",
      "longitude":77.232292,
      "latitude":54.517609
    },
    "3238":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":77.239647,
      "latitude":54.009651
    },
    "3239":{
      "name":"\u0423\u0441\u0442\u044c-\u041b\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":77.278984,
      "latitude":55.675861
    },
    "3240":{
      "name":"\u0428\u0438\u043f\u0438\u0446\u044b\u043d\u043e",
      "longitude":77.290054,
      "latitude":56.07473
    },
    "3241":{
      "name":"\u0422\u0430\u0433\u0430\u043d",
      "longitude":77.292007,
      "latitude":54.954865
    },
    "3242":{
      "name":"\u0417\u044f\u0442\u044c\u043a\u043e\u0432\u043a\u0430",
      "longitude":77.327522,
      "latitude":54.278442
    },
    "3243":{
      "name":"\u0427\u0430\u0438\u043d\u043a\u0430",
      "longitude":77.337463,
      "latitude":54.517754
    },
    "3244":{
      "name":"\u0424\u0438\u043b\u043e\u0448\u0435\u043d\u043a\u0430",
      "longitude":77.357162,
      "latitude":56.245991
    },
    "3245":{
      "name":"\u042f\u0440\u043a\u0443\u043b\u044c",
      "longitude":77.373901,
      "latitude":54.637623
    },
    "3246":{
      "name":"\u041d\u043e\u0432\u043e\u043d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":77.423798,
      "latitude":54.440216
    },
    "3247":{
      "name":"\u041a\u0430\u0437\u0430\u043d\u043a\u0430",
      "longitude":77.430634,
      "latitude":53.983753
    },
    "3248":{
      "name":"\u041f\u043e\u0433\u043e\u0440\u0435\u043b\u043a\u0430",
      "longitude":77.442673,
      "latitude":55.446445
    },
    "3249":{
      "name":"\u0410\u043d\u0434\u0440\u0435\u0435\u0432\u043a\u0430",
      "longitude":77.445992,
      "latitude":53.843163
    },
    "3250":{
      "name":"\u0422\u0435\u0431\u0438\u0441\u0441\u043a\u043e\u0435",
      "longitude":77.458611,
      "latitude":55.340923
    },
    "3251":{
      "name":"\u0420\u043e\u0436\u0434\u0435\u0441\u0442\u0432\u0435\u043d\u043a\u0430",
      "longitude":77.47673,
      "latitude":55.355267
    },
    "3252":{
      "name":"\u0412\u0435\u0440\u0445-\u0422\u0430\u0440\u043a\u0430",
      "longitude":77.494278,
      "latitude":56.622429
    },
    "3253":{
      "name":"\u0422\u0435\u0431\u0438\u0441",
      "longitude":77.51017,
      "latitude":55.301907
    },
    "3254":{
      "name":"\u0411\u0435\u043b\u043e\u0432\u043e",
      "longitude":77.517822,
      "latitude":55.04546
    },
    "3255":{
      "name":"\u0421\u0442\u0443\u0434\u0451\u043d\u043e\u0435",
      "longitude":77.531433,
      "latitude":53.613796
    },
    "3256":{
      "name":"\u041c\u0438\u043d\u0438\u043d\u043e",
      "longitude":77.534836,
      "latitude":56.171734
    },
    "3257":{
      "name":"\u0412\u043e\u0437\u043d\u0435\u0441\u0435\u043d\u043a\u0430",
      "longitude":77.547646,
      "latitude":54.14222
    },
    "3258":{
      "name":"\u041a\u0443\u0437\u043d\u0435\u0446\u043e\u0432\u043a\u0430",
      "longitude":77.552986,
      "latitude":53.911385
    },
    "3259":{
      "name":"\u0420\u043e\u0436\u0434\u0435\u0441\u0442\u0432\u0435\u043d\u043a\u0430",
      "longitude":77.563797,
      "latitude":54.288879
    },
    "3260":{
      "name":"\u041f\u0435\u0442\u0440\u0443\u0448\u0438\u043d\u043e",
      "longitude":77.572243,
      "latitude":53.838558
    },
    "3261":{
      "name":"\u0428\u0430\u0438\u0442\u0438\u043a",
      "longitude":77.584572,
      "latitude":54.648167
    },
    "3262":{
      "name":"\u041d\u043e\u0432\u043e\u0438\u0447\u0438\u043d\u0441\u043a\u043e\u0435",
      "longitude":77.622528,
      "latitude":55.662266
    },
    "3263":{
      "name":"\u041b\u043e\u0437\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":77.625778,
      "latitude":54.100494
    },
    "3264":{
      "name":"\u041a\u043e\u043f\u043a\u0443\u043b\u044c",
      "longitude":77.636642,
      "latitude":54.391872
    },
    "3265":{
      "name":"\u041f\u043e\u043f\u043e\u0432\u043a\u0430",
      "longitude":77.649765,
      "latitude":53.738373
    },
    "3266":{
      "name":"\u041a\u0430\u0437\u0430\u043d\u0446\u0435\u0432\u043e",
      "longitude":77.681488,
      "latitude":55.075672
    },
    "3267":{
      "name":"\u041a\u0430\u043c\u0430",
      "longitude":77.714478,
      "latitude":55.876114
    },
    "3268":{
      "name":"\u041c\u0435\u0436\u043e\u0432\u043a\u0430",
      "longitude":77.738838,
      "latitude":56.643597
    },
    "3269":{
      "name":"\u041c\u0438\u0440\u043e\u043d\u043e\u0432\u043a\u0430",
      "longitude":77.747231,
      "latitude":53.844803
    },
    "3270":{
      "name":"\u0421\u0442\u0440\u0435\u0442\u0438\u043d\u043a\u0430",
      "longitude":77.7484121,
      "latitude":54.0496653
    },
    "3271":{
      "name":"\u0412\u043e\u0440\u043e\u043d\u043e\u0432\u043a\u0430",
      "longitude":77.751717,
      "latitude":54.345104
    },
    "3272":{
      "name":"\u041f\u0430\u0432\u043b\u043e\u0432\u043a\u0430",
      "longitude":77.757042,
      "latitude":53.432838
    },
    "3273":{
      "name":"\u0410\u0441\u0442\u0440\u043e\u0434\u044b\u043c",
      "longitude":77.76664,
      "latitude":53.644268
    },
    "3274":{
      "name":"\u041d\u043e\u0432\u043e\u0440\u043e\u0437\u0438\u043d\u043e",
      "longitude":77.781166,
      "latitude":54.649052
    },
    "3275":{
      "name":"\u0422\u044b\u0447\u043a\u0438\u043d\u043e",
      "longitude":77.78521,
      "latitude":54.107166
    },
    "3276":{
      "name":"\u041e\u043c\u044c",
      "longitude":77.786224,
      "latitude":55.424648
    },
    "3277":{
      "name":"\u0427\u0443\u043c\u0430\u0448\u043a\u0438",
      "longitude":77.791283,
      "latitude":54.468666
    },
    "3278":{
      "name":"\u0411\u0443\u043b\u0430\u0442\u043e\u0432\u043e",
      "longitude":77.796364,
      "latitude":55.519726
    },
    "3279":{
      "name":"\u041e\u043a\u0442\u044f\u0431\u0440\u044c\u0441\u043a\u043e\u0435",
      "longitude":77.804672,
      "latitude":53.513443
    },
    "3280":{
      "name":"\u0422\u0440\u043e\u0438\u0446\u043a\u043e\u0435",
      "longitude":77.82058,
      "latitude":53.72477
    },
    "3281":{
      "name":"\u0411\u043e\u0433\u0430\u0442\u0438\u0445\u0430",
      "longitude":77.822441,
      "latitude":54.711185
    },
    "3282":{
      "name":"\u041d\u043e\u0432\u043e\u043d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":77.829422,
      "latitude":54.796612
    },
    "3283":{
      "name":"\u041a\u0432\u0430\u0448\u043d\u0438\u043d\u043e",
      "longitude":77.837303,
      "latitude":55.010712
    },
    "3284":{
      "name":"\u0417\u044e\u0437\u044f",
      "longitude":77.854271,
      "latitude":55.09177
    },
    "3285":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u0432\u043a\u0430",
      "longitude":77.859123,
      "latitude":54.265553
    },
    "3286":{
      "name":"\u041f\u043e\u043b\u043e\u0432\u0438\u043d\u043d\u043e\u0435",
      "longitude":77.860687,
      "latitude":55.236923
    },
    "3287":{
      "name":"\u041a\u0430\u043b\u0430\u0447\u0438",
      "longitude":77.879082,
      "latitude":53.590782
    },
    "3288":{
      "name":"\u041d\u043e\u0432\u043e\u0438\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":77.897743,
      "latitude":53.461269
    },
    "3289":{
      "name":"\u0421\u0430\u0432\u043a\u0438\u043d\u043e",
      "longitude":77.902786,
      "latitude":53.903275
    },
    "3290":{
      "name":"\u0420\u0430\u0441\u0441\u043a\u0430\u0437\u043e\u0432\u043e",
      "longitude":77.922684,
      "latitude":53.667519
    },
    "3291":{
      "name":"\u0412\u0435\u0440\u0445-\u041a\u0440\u0430\u0441\u043d\u043e\u044f\u0440\u043a\u0430",
      "longitude":77.923141,
      "latitude":56.367542
    },
    "3292":{
      "name":"\u041e\u0437\u0451\u0440\u043d\u043e\u0435 \u041f\u0440\u0438\u0432\u043e\u043b\u044c\u0435",
      "longitude":77.930527,
      "latitude":53.801224
    },
    "3293":{
      "name":"\u0423\u0441\u0442\u044c\u044f\u043d\u0446\u0435\u0432\u043e",
      "longitude":77.939293,
      "latitude":55.293018
    },
    "3294":{
      "name":"\u0421\u043e\u0440\u043e\u0447\u0438\u0445\u0430",
      "longitude":77.946991,
      "latitude":53.73138
    },
    "3295":{
      "name":"\u041a\u0438\u0440\u0437\u0438\u043d\u0441\u043a\u043e\u0435",
      "longitude":77.957703,
      "latitude":55.340206
    },
    "3296":{
      "name":"\u041b\u044f\u0433\u0443\u0448\u044c\u0435",
      "longitude":77.984741,
      "latitude":54.403564
    },
    "3297":{
      "name":"\u041e\u0437\u0451\u0440\u043d\u043e\u0435-\u0422\u0438\u0442\u043e\u0432\u043e",
      "longitude":77.993584,
      "latitude":53.753647
    },
    "3298":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u043b\u044e\u0447\u0438",
      "longitude":78.002693,
      "latitude":54.244106
    },
    "3299":{
      "name":"\u0412\u0435\u0440\u0445-\u0418\u0447\u0430",
      "longitude":78.018295,
      "latitude":55.727604
    },
    "3300":{
      "name":"\u0422\u043e\u043f\u043e\u043b\u0435\u0432\u043a\u0430",
      "longitude":78.041077,
      "latitude":54.813728
    },
    "3301":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":78.047157,
      "latitude":53.645222
    },
    "3302":{
      "name":"\u0411\u043b\u0430\u0433\u043e\u0434\u0430\u0442\u043d\u043e\u0435",
      "longitude":78.050858,
      "latitude":53.844585
    },
    "3303":{
      "name":"\u041b\u0443\u043a\u043e\u0448\u0438\u043d\u043e",
      "longitude":78.075218,
      "latitude":54.318527
    },
    "3304":{
      "name":"\u041e\u0441\u0442\u044f\u0446\u043a",
      "longitude":78.079613,
      "latitude":56.708874
    },
    "3305":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u041f\u0430\u0445\u0430\u0440\u044c",
      "longitude":78.081734,
      "latitude":55.266823
    },
    "3306":{
      "name":"\u041d\u043e\u0432\u043e\u044f\u0440\u043a\u043e\u0432\u043e",
      "longitude":78.086517,
      "latitude":54.927784
    },
    "3307":{
      "name":"\u0411\u0430\u0434\u0430\u0436\u043a\u0438",
      "longitude":78.1247259,
      "latitude":55.1877526
    },
    "3308":{
      "name":"\u0412\u0435\u0441\u043d\u044f\u043d\u043a\u0430",
      "longitude":78.125664,
      "latitude":55.546314
    },
    "3309":{
      "name":"\u041f\u0430\u043b\u0435\u0446\u043a\u043e\u0435",
      "longitude":78.143257,
      "latitude":54.117863
    },
    "3310":{
      "name":"\u0413\u0440\u0430\u0436\u0434\u0430\u043d\u0446\u0435\u0432\u043e",
      "longitude":78.165695,
      "latitude":56.357346
    },
    "3311":{
      "name":"\u041d\u043e\u0432\u043e\u0447\u0430\u043d\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":78.178185,
      "latitude":54.950142
    },
    "3312":{
      "name":"\u0413\u0436\u0430\u0442\u0441\u043a",
      "longitude":78.179413,
      "latitude":55.702034
    },
    "3313":{
      "name":"\u0428\u0438\u043b\u043e\u0432\u043e-\u041a\u0443\u0440\u044c\u044f",
      "longitude":78.183037,
      "latitude":53.80785
    },
    "3314":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u043f\u0430\u0441\u0441\u043a",
      "longitude":78.186302,
      "latitude":55.114559
    },
    "3315":{
      "name":"\u042e\u043d\u044b\u0439 \u041f\u0438\u043e\u043d\u0435\u0440",
      "longitude":78.192482,
      "latitude":55.151848
    },
    "3316":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":78.212799,
      "latitude":53.702694
    },
    "3317":{
      "name":"\u0428\u0443\u0431\u0438\u043d\u0441\u043a\u043e\u0435",
      "longitude":78.215561,
      "latitude":55.325039
    },
    "3318":{
      "name":"\u0410\u0431\u0440\u0430\u043c\u043e\u0432\u043e",
      "longitude":78.22184,
      "latitude":55.437435
    },
    "3319":{
      "name":"\u041b\u0435\u043f\u043e\u043a\u0443\u0440\u043e\u0432\u043e",
      "longitude":78.230911,
      "latitude":54.239708
    },
    "3320":{
      "name":"\u041a\u043e\u0436\u0435\u0432\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":78.2531084,
      "latitude":55.0135225
    },
    "3321":{
      "name":"\u041e\u0441\u0442\u0430\u043d\u0438\u043d\u043a\u0430",
      "longitude":78.26532,
      "latitude":56.720875
    },
    "3322":{
      "name":"\u041d\u0430\u0433\u043e\u0440\u043d\u043e\u0435",
      "longitude":78.271965,
      "latitude":55.426979
    },
    "3323":{
      "name":"\u041d\u043e\u0432\u043e\u0440\u043e\u0441\u0441\u0438\u0439\u0441\u043a\u043e\u0435",
      "longitude":78.278557,
      "latitude":54.347057
    },
    "3324":{
      "name":"\u0411\u0438\u0430\u0437\u0430",
      "longitude":78.302055,
      "latitude":56.594597
    },
    "3325":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u041e\u0441\u0442\u0440\u043e\u0432",
      "longitude":78.310982,
      "latitude":54.112408
    },
    "3326":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u0443\u0440\u0443\u043f\u043a\u0430\u0435\u0432\u043a\u0430",
      "longitude":78.327118,
      "latitude":55.101437
    },
    "3327":{
      "name":"\u041c\u043e\u0440\u043e\u0437\u043e\u0432\u043a\u0430",
      "longitude":78.334526,
      "latitude":53.921417
    },
    "3328":{
      "name":"\u0427\u0443\u043b\u044b\u043c",
      "longitude":78.334602,
      "latitude":54.56353
    },
    "3329":{
      "name":"\u041a\u043e\u043c\u0441\u043e\u043c\u043e\u043b\u044c\u0441\u043a\u0438\u0439",
      "longitude":78.341759,
      "latitude":55.54467
    },
    "3330":{
      "name":"\u0410\u0443\u043b-\u0411\u0435\u0440\u0433\u0443\u043b\u044c",
      "longitude":78.358383,
      "latitude":55.605766
    },
    "3331":{
      "name":"\u0427\u0435\u0440\u043d\u043e\u043a\u0443\u0440\u044c\u044f",
      "longitude":78.374512,
      "latitude":53.849899
    },
    "3332":{
      "name":"\u041f\u0435\u0442\u0440\u0430\u043a\u0438",
      "longitude":78.377716,
      "latitude":54.758919
    },
    "3333":{
      "name":"\u041a\u0443\u043a\u0430\u0440\u043a\u0430",
      "longitude":78.402504,
      "latitude":54.208897
    },
    "3334":{
      "name":"\u041a\u0430\u0440\u043c\u0430\u043a\u043b\u0430",
      "longitude":78.407921,
      "latitude":54.963764
    },
    "3335":{
      "name":"\u0412\u0438\u0442\u0438\u043d\u0441\u043a",
      "longitude":78.412582,
      "latitude":56.297817
    },
    "3336":{
      "name":"\u0421\u0435\u0440\u0433\u0438\u043d\u043e",
      "longitude":78.426849,
      "latitude":55.787617
    },
    "3337":{
      "name":"\u0421\u0440\u0435\u0434\u043d\u0435\u0438\u0447\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":78.445183,
      "latitude":55.895538
    },
    "3338":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u0449\u0435\u0440\u0431\u0430\u043a\u043e\u0432\u043e",
      "longitude":78.456367,
      "latitude":55.36911
    },
    "3339":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0439 \u0423\u0440\u044e\u043c",
      "longitude":78.470512,
      "latitude":54.525696
    },
    "3340":{
      "name":"\u0411\u0435\u043b\u043e\u0435",
      "longitude":78.471031,
      "latitude":53.935505
    },
    "3341":{
      "name":"\u0418\u0440\u0431\u0438\u0437\u0438\u043d\u043e",
      "longitude":78.47216,
      "latitude":54.040543
    },
    "3342":{
      "name":"\u041a\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":78.494576,
      "latitude":53.712082
    },
    "3343":{
      "name":"\u0411\u0435\u0440\u0433\u0443\u043b\u044c",
      "longitude":78.495499,
      "latitude":56.607479
    },
    "3344":{
      "name":"\u0425\u043e\u0440\u043e\u0448\u0435\u0435",
      "longitude":78.504364,
      "latitude":53.5896
    },
    "3345":{
      "name":"\u041b\u044f\u043d\u0438\u043d\u043e",
      "longitude":78.512711,
      "latitude":54.368759
    },
    "3346":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":78.513062,
      "latitude":54.886375
    },
    "3347":{
      "name":"\u041d\u043e\u0432\u043e\u0443\u043b\u044c\u044f\u043d\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":78.530273,
      "latitude":55.398048
    },
    "3348":{
      "name":"\u041c\u0430\u043b\u0430\u043d\u0434\u0438\u043d\u043e",
      "longitude":78.541595,
      "latitude":54.807224
    },
    "3349":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u043e\u0437\u043b\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":78.54528,
      "latitude":55.269753
    },
    "3350":{
      "name":"\u0427\u0435\u0431\u0430\u043a\u0438",
      "longitude":78.547653,
      "latitude":56.324432
    },
    "3351":{
      "name":"\u041e\u0442\u0440\u0430\u0434\u043d\u0435\u043d\u0441\u043a\u043e\u0435",
      "longitude":78.5495,
      "latitude":55.52837
    },
    "3352":{
      "name":"\u0420\u043e\u0436\u0434\u0435\u0441\u0442\u0432\u0435\u043d\u0441\u043a\u0438\u0439",
      "longitude":78.577538,
      "latitude":54.099194
    },
    "3353":{
      "name":"\u0412\u0435\u0440\u0445-\u0423\u0440\u044e\u043c",
      "longitude":78.587952,
      "latitude":54.492649
    },
    "3354":{
      "name":"\u0422\u0430\u0441\u043a\u0430\u0435\u0432\u043e",
      "longitude":78.600731,
      "latitude":55.094349
    },
    "3355":{
      "name":"\u0417\u0443\u0431\u043a\u043e\u0432\u043e",
      "longitude":78.656296,
      "latitude":53.724369
    },
    "3356":{
      "name":"\u0417\u0443\u0431\u043a\u043e\u0432\u043e",
      "longitude":78.660782,
      "latitude":53.778336
    },
    "3357":{
      "name":"\u041d\u043e\u0432\u043e\u0442\u0440\u043e\u0438\u0446\u043a",
      "longitude":78.677933,
      "latitude":56.189171
    },
    "3358":{
      "name":"\u0412\u0435\u0441\u0435\u043b\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":78.703827,
      "latitude":53.988678
    },
    "3359":{
      "name":"\u0421\u0432\u0435\u0442\u043b\u043e\u0435",
      "longitude":78.716454,
      "latitude":54.19347
    },
    "3360":{
      "name":"\u0413\u043e\u0440\u0431\u0443\u043d\u043e\u0432\u043e",
      "longitude":78.720894,
      "latitude":55.512699
    },
    "3361":{
      "name":"\u041d\u043e\u0432\u044b\u0439 \u0411\u0430\u0433\u0430\u043d\u0451\u043d\u043e\u043a",
      "longitude":78.726402,
      "latitude":53.868198
    },
    "3362":{
      "name":"\u0426\u0432\u0435\u0442\u043d\u0438\u043a\u0438",
      "longitude":78.753174,
      "latitude":54.705029
    },
    "3363":{
      "name":"\u0421\u0430\u0440\u044b\u0431\u0430\u043b\u044b\u043a",
      "longitude":78.76664,
      "latitude":54.830956
    },
    "3364":{
      "name":"\u041b\u043e\u0442\u043e\u0448\u043d\u043e\u0435",
      "longitude":78.78418,
      "latitude":54.13763
    },
    "3365":{
      "name":"\u041a\u043e\u043d\u0441\u0442\u0430\u043d\u0442\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":78.802719,
      "latitude":55.637108
    },
    "3366":{
      "name":"\u0427\u0443\u0432\u0430\u0448\u0438",
      "longitude":78.816666,
      "latitude":56.398643
    },
    "3367":{
      "name":"\u0423\u043b\u044c\u044f\u043d\u043e\u0432\u043a\u0430",
      "longitude":78.818611,
      "latitude":53.743202
    },
    "3368":{
      "name":"\u0424\u0451\u0434\u043e\u0440\u043e\u0432\u043a\u0430",
      "longitude":78.834679,
      "latitude":56.074955
    },
    "3369":{
      "name":"\u0411\u0430\u043a\u043c\u0430\u0441\u0438\u0445\u0430",
      "longitude":78.835938,
      "latitude":55.152081
    },
    "3370":{
      "name":"\u041d\u0438\u0436\u043d\u0435\u0447\u0435\u0440\u0435\u043c\u043e\u0448\u043d\u043e\u0435",
      "longitude":78.897125,
      "latitude":53.95768
    },
    "3371":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0439 \u0427\u0443\u043b\u044b\u043c",
      "longitude":78.933685,
      "latitude":54.610977
    },
    "3372":{
      "name":"\u041a\u043e\u043d\u0434\u0443\u0441\u043b\u0430",
      "longitude":78.936943,
      "latitude":55.444569
    },
    "3373":{
      "name":"\u0410\u043a\u0441\u0451\u043d\u0438\u0445\u0430",
      "longitude":78.942459,
      "latitude":53.715843
    },
    "3374":{
      "name":"\u041a\u043e\u043d\u0451\u0432\u043e",
      "longitude":79.003204,
      "latitude":54.234505
    },
    "3375":{
      "name":"\u041b\u043e\u0431\u0438\u043d\u043e",
      "longitude":79.027725,
      "latitude":53.862038
    },
    "3376":{
      "name":"\u041a\u043e\u0436\u0443\u0440\u043b\u0430",
      "longitude":79.032433,
      "latitude":55.335751
    },
    "3377":{
      "name":"\u041b\u043e\u043a\u0442\u0451\u043d\u043e\u043a",
      "longitude":79.034554,
      "latitude":53.959328
    },
    "3378":{
      "name":"\u0427\u0443\u043c\u0430\u043a\u043e\u0432\u043e",
      "longitude":79.051338,
      "latitude":55.686729
    },
    "3379":{
      "name":"\u0423\u0448\u043a\u043e\u0432\u043e",
      "longitude":79.069199,
      "latitude":55.684029
    },
    "3380":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u043a\u0430",
      "longitude":79.076385,
      "latitude":54.898087
    },
    "3381":{
      "name":"\u041a\u043e\u0440\u0434\u043e\u043d",
      "longitude":79.087364,
      "latitude":56.441681
    },
    "3382":{
      "name":"\u0412\u0435\u0440\u0445-\u041a\u0430\u0440\u0433\u0430\u0442",
      "longitude":79.091942,
      "latitude":54.79694
    },
    "3383":{
      "name":"\u041a\u0443\u043b\u044c\u0447\u0430",
      "longitude":79.10881,
      "latitude":55.536221
    },
    "3384":{
      "name":"\u0411\u0430\u043a\u043b\u0443\u0448\u0438",
      "longitude":79.119644,
      "latitude":54.378872
    },
    "3385":{
      "name":"\u041a\u043e\u043b\u044b\u0431\u0435\u043b\u044c\u043a\u0430",
      "longitude":79.144791,
      "latitude":54.066292
    },
    "3386":{
      "name":"\u041a\u0430\u0437\u0430\u043d\u0430\u043a",
      "longitude":79.160789,
      "latitude":54.183975
    },
    "3387":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e-\u041d\u0435\u0432\u0441\u043a\u043e\u0435",
      "longitude":79.176933,
      "latitude":55.261948
    },
    "3388":{
      "name":"\u041a\u0430\u0439\u0433\u043e\u0440\u043e\u0434\u0441\u043a\u0438\u0439",
      "longitude":79.194077,
      "latitude":53.980347
    },
    "3389":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u0433\u043e\u0440\u043d\u043e\u0441\u0442\u0430\u043b\u0435\u0432\u043e",
      "longitude":79.230797,
      "latitude":54.663452
    },
    "3390":{
      "name":"\u0418\u043b\u044c\u0438\u043d\u043a\u0430",
      "longitude":79.233513,
      "latitude":54.52475
    },
    "3391":{
      "name":"\u041f\u043e\u043b\u043e\u0432\u0438\u043d\u043d\u043e\u0435",
      "longitude":79.237946,
      "latitude":53.743317
    },
    "3392":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u0425\u0443\u0442\u043e\u0440",
      "longitude":79.261597,
      "latitude":53.96286
    },
    "3393":{
      "name":"\u041d\u043e\u0432\u043e\u0433\u0430\u043d\u0434\u0438\u0447\u0435\u0432\u043e",
      "longitude":79.292931,
      "latitude":55.006645
    },
    "3394":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u0451\u043b\u043e\u0432\u043e",
      "longitude":79.296608,
      "latitude":55.396591
    },
    "3395":{
      "name":"\u041a\u0440\u0443\u0433\u043b\u043e\u043e\u0437\u0451\u0440\u043d\u043e\u0435",
      "longitude":79.297859,
      "latitude":55.081085
    },
    "3396":{
      "name":"\u0411\u043e\u0440\u0438\u0441\u043e\u0433\u043b\u0435\u0431\u043a\u0430",
      "longitude":79.313156,
      "latitude":55.270214
    },
    "3397":{
      "name":"\u041a\u0443\u043d\u0434\u0440\u0430\u043d",
      "longitude":79.318283,
      "latitude":54.905655
    },
    "3398":{
      "name":"\u041f\u043e\u043b\u043e\u0439\u043a\u0430",
      "longitude":79.321495,
      "latitude":54.201042
    },
    "3399":{
      "name":"\u0417\u043e\u043d\u043e\u0432\u043e",
      "longitude":79.326996,
      "latitude":55.729355
    },
    "3400":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":79.356705,
      "latitude":55.590782
    },
    "3401":{
      "name":"\u041e\u0440\u0435\u0445\u043e\u0432 \u041b\u043e\u0433",
      "longitude":79.390999,
      "latitude":53.840603
    },
    "3402":{
      "name":"\u0412\u043e\u043b\u0447\u0430\u043d\u043a\u0430",
      "longitude":79.401978,
      "latitude":54.431187
    },
    "3403":{
      "name":"\u0413\u0435\u0440\u0431\u0430\u0435\u0432\u043e",
      "longitude":79.415321,
      "latitude":53.985466
    },
    "3404":{
      "name":"\u0411\u0430\u043b\u043c\u0430\u043d",
      "longitude":79.424332,
      "latitude":55.803299
    },
    "3405":{
      "name":"\u0421\u0443\u0437\u0434\u0430\u043b\u043a\u0430",
      "longitude":79.4518893,
      "latitude":54.5808575
    },
    "3406":{
      "name":"\u0428\u0430\u0433\u0430\u043b\u043a\u0430",
      "longitude":79.485764,
      "latitude":54.295567
    },
    "3407":{
      "name":"\u0421\u0430\u0434\u043e\u0432\u044b\u0439",
      "longitude":79.494835,
      "latitude":53.747803
    },
    "3408":{
      "name":"\u041c\u043e\u0445\u043d\u0430\u0442\u044b\u0439 \u041b\u043e\u0433",
      "longitude":79.587837,
      "latitude":54.023464
    },
    "3409":{
      "name":"\u0420\u0430\u0438\u0441\u0438\u043d\u043e",
      "longitude":79.591187,
      "latitude":55.18771
    },
    "3410":{
      "name":"\u0412\u043b\u0430\u0434\u0438\u043c\u0438\u0440\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":79.595558,
      "latitude":55.373367
    },
    "3411":{
      "name":"\u0422\u0440\u0430\u0432\u043d\u043e\u0435",
      "longitude":79.618347,
      "latitude":54.243736
    },
    "3412":{
      "name":"\u041e\u043a\u0442\u044f\u0431\u0440\u044c\u0441\u043a\u0438\u0439",
      "longitude":79.642044,
      "latitude":53.958359
    },
    "3413":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u043f\u0430\u0432\u043b\u043e\u0432\u043a\u0430",
      "longitude":79.647827,
      "latitude":54.016838
    },
    "3414":{
      "name":"\u041f\u0435\u0448\u043a\u043e\u0432\u043e",
      "longitude":79.68457,
      "latitude":55.641239
    },
    "3415":{
      "name":"\u042f\u0440\u043a\u0438",
      "longitude":79.721565,
      "latitude":54.791409
    },
    "3416":{
      "name":"\u041e\u0440\u043b\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":79.729774,
      "latitude":55.50901
    },
    "3417":{
      "name":"\u041c\u0430\u0439\u0441\u043a\u043e\u0435",
      "longitude":79.757904,
      "latitude":54.075275
    },
    "3418":{
      "name":"\u0423\u0442\u044f\u043d\u043a\u0430",
      "longitude":79.778992,
      "latitude":54.712242
    },
    "3419":{
      "name":"\u0427\u0435\u0440\u043d\u0430\u043a\u0438",
      "longitude":79.816261,
      "latitude":54.075924
    },
    "3420":{
      "name":"\u041a\u0443\u0440\u044c\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":79.852211,
      "latitude":53.956211
    },
    "3421":{
      "name":"\u041c\u0430\u0440\u0448\u0430\u043d\u0441\u043a\u043e\u0435",
      "longitude":79.863052,
      "latitude":55.038452
    },
    "3422":{
      "name":"\u0415\u0440\u043c\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":79.907204,
      "latitude":55.318672
    },
    "3423":{
      "name":"\u0422\u0440\u043e\u0438\u0446\u043a\u0438\u0439",
      "longitude":79.92907,
      "latitude":54.00798
    },
    "3424":{
      "name":"\u0411\u0443\u043a\u0440\u0435\u0435\u0432\u043e \u041f\u043b\u0451\u0441\u043e",
      "longitude":79.939095,
      "latitude":54.136028
    },
    "3425":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u0430\u044f \u0413\u0440\u0438\u0432\u0430",
      "longitude":79.941467,
      "latitude":54.768711
    },
    "3426":{
      "name":"\u0421\u043e\u0433\u043e\u0440\u043d\u043e\u0435",
      "longitude":79.947029,
      "latitude":54.297451
    },
    "3427":{
      "name":"\u0418\u043d\u0434\u0435\u0440\u044c",
      "longitude":79.974983,
      "latitude":54.546394
    },
    "3428":{
      "name":"\u041d\u043e\u0432\u043e\u0434\u0443\u0431\u0440\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":79.976006,
      "latitude":55.70137
    },
    "3429":{
      "name":"\u0427\u0435\u0440\u043d\u043e\u0432\u043a\u0430",
      "longitude":79.99936156594485,
      "latitude":54.15413500110771
    },
    "3430":{
      "name":"\u041a\u0430\u0440\u0433\u0430\u043d",
      "longitude":80.04892,
      "latitude":55.348675
    },
    "3431":{
      "name":"\u041a\u0440\u0435\u0449\u0435\u043d\u0441\u043a\u043e\u0435",
      "longitude":80.050156,
      "latitude":55.857986
    },
    "3432":{
      "name":"\u0427\u0451\u0440\u043d\u044b\u0439 \u041c\u044b\u0441",
      "longitude":80.073952,
      "latitude":55.540298
    },
    "3433":{
      "name":"\u0413\u0430\u0432\u0440\u0438\u043b\u043e\u0432\u043a\u0430",
      "longitude":80.1456975,
      "latitude":55.1635131
    },
    "3434":{
      "name":"\u041d\u0430\u0431\u0435\u0440\u0435\u0436\u043d\u043e\u0435",
      "longitude":80.1802045,
      "latitude":55.1749389
    },
    "3435":{
      "name":"\u041a\u043e\u043c\u0430\u0440\u044c\u0435",
      "longitude":80.217545,
      "latitude":54.420795
    },
    "3436":{
      "name":"\u0420\u0435\u0448\u0451\u0442\u044b",
      "longitude":80.2208511545641,
      "latitude":54.2156685265184
    },
    "3437":{
      "name":"\u041a\u043e\u043b\u044c\u0446\u043e\u0432\u043a\u0430",
      "longitude":80.22242,
      "latitude":54.985043
    },
    "3438":{
      "name":"\u041e\u0437\u0435\u0440\u043a\u0438 6-\u0435",
      "longitude":80.250786,
      "latitude":54.63929
    },
    "3439":{
      "name":"\u0415\u0440\u043c\u0430\u043a\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":80.311142,
      "latitude":54.12743
    },
    "3440":{
      "name":"\u041c\u0430\u043c\u043e\u043d\u0442\u043e\u0432\u043e\u0435",
      "longitude":80.326759,
      "latitude":54.663334
    },
    "3441":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u0442\u0440\u043e\u0438\u0446\u043a",
      "longitude":80.377411,
      "latitude":55.092178
    },
    "3442":{
      "name":"\u041d\u043e\u0432\u044b\u0435 \u0420\u0435\u0448\u0435\u0442\u044b",
      "longitude":80.389839,
      "latitude":54.126144
    },
    "3443":{
      "name":"\u041c\u0443\u0441\u044b",
      "longitude":80.4282,
      "latitude":55.453838
    },
    "3444":{
      "name":"\u0421\u0443\u043c\u044b",
      "longitude":80.442612,
      "latitude":54.81551
    },
    "3445":{
      "name":"\u0424\u043e\u0440\u043f\u043e\u0441\u0442-\u041a\u0430\u0440\u0433\u0430\u0442",
      "longitude":80.443481,
      "latitude":55.274643
    },
    "3446":{
      "name":"\u0410\u043b\u0430\u0431\u0443\u0433\u0430",
      "longitude":80.465996,
      "latitude":54.670513
    },
    "3447":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u0430\u044f \u0421\u0438\u0431\u0438\u0440\u044c",
      "longitude":80.492607,
      "latitude":54.32272
    },
    "3448":{
      "name":"\u041d\u043e\u0432\u043e\u0446\u0435\u043b\u0438\u043d\u043d\u043e\u0435",
      "longitude":80.516174,
      "latitude":54.355244
    },
    "3449":{
      "name":"\u0416\u0443\u043b\u0430\u043d\u043a\u0430",
      "longitude":80.604317,
      "latitude":54.366016
    },
    "3450":{
      "name":"\u041a\u043e\u043a\u043e\u0448\u0438\u043d\u043e",
      "longitude":80.622002,
      "latitude":55.154854
    },
    "3451":{
      "name":"\u0412\u0435\u0440\u0445-\u041a\u0430\u0440\u0433\u0430\u0442",
      "longitude":80.65448,
      "latitude":55.370548
    },
    "3452":{
      "name":"\u0417\u043e\u043b\u043e\u0442\u0430\u044f \u0413\u0440\u0438\u0432\u0430",
      "longitude":80.687691,
      "latitude":54.998051
    },
    "3453":{
      "name":"\u0421\u0435\u0440\u0435\u0431\u0440\u044f\u043d\u0441\u043a\u043e\u0435",
      "longitude":80.6987,
      "latitude":54.875412
    },
    "3454":{
      "name":"\u0412\u043e\u0437\u0434\u0432\u0438\u0436\u0435\u043d\u0441\u043a\u0438\u0439",
      "longitude":80.732483,
      "latitude":54.647243
    },
    "3455":{
      "name":"\u0420\u0435\u0441\u043f\u0443\u0431\u043b\u0438\u043a\u0430\u043d\u0441\u043a\u0438\u0439",
      "longitude":80.785522,
      "latitude":54.26918
    },
    "3456":{
      "name":"\u0427\u0443\u043b\u044b\u043c-3",
      "longitude":80.7928204,
      "latitude":55.1091523
    },
    "3457":{
      "name":"\u0411\u044b\u0441\u0442\u0440\u0443\u0445\u0430",
      "longitude":80.879433,
      "latitude":54.436958
    },
    "3458":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":80.956017,
      "latitude":54.586369
    },
    "3459":{
      "name":"\u0418\u0442\u043a\u0443\u043b\u044c",
      "longitude":81.024162,
      "latitude":55.080929
    },
    "3460":{
      "name":"\u0423\u0436\u0430\u043d\u0438\u0445\u0430",
      "longitude":81.035873,
      "latitude":54.676704
    },
    "3461":{
      "name":"\u041d\u043e\u0432\u043e\u0438\u0442\u043a\u0443\u043b\u044c\u0441\u043a\u043e\u0435",
      "longitude":81.06308,
      "latitude":55.049568
    },
    "3462":{
      "name":"\u041a\u0443\u043b\u0438\u043a\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":81.078217,
      "latitude":55.300179
    },
    "3463":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":81.145386,
      "latitude":54.509335
    },
    "3464":{
      "name":"\u041f\u0440\u043e\u043b\u0435\u0442\u0430\u0440\u0441\u043a\u0438\u0439",
      "longitude":81.159912,
      "latitude":54.382755
    },
    "3465":{
      "name":"\u0411\u0430\u0437\u043e\u0432\u043e",
      "longitude":81.230156,
      "latitude":54.536777
    },
    "3466":{
      "name":"\u0412\u0435\u0440\u0445-\u0410\u043b\u0435\u0443\u0441",
      "longitude":81.268394,
      "latitude":54.175667
    },
    "3467":{
      "name":"\u041a\u0430\u0431\u0438\u043d\u0435\u0442\u043d\u043e\u0435",
      "longitude":81.292206,
      "latitude":55.097595
    },
    "3468":{
      "name":"\u0428\u0430\u0439\u0434\u0443\u0440\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":81.318024,
      "latitude":54.411098
    },
    "3469":{
      "name":"\u0423\u0441\u0442\u044e\u0436\u0430\u043d\u0438\u043d\u043e",
      "longitude":81.318047,
      "latitude":54.185104
    },
    "3470":{
      "name":"\u0427\u0438\u043a\u043c\u0430\u043d",
      "longitude":81.339096,
      "latitude":54.775677
    },
    "3471":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0435\u043d\u0438\u043a\u043e\u043b\u044c\u0441\u043a\u043e\u0435",
      "longitude":81.468613,
      "latitude":54.602081
    },
    "3472":{
      "name":"\u041e\u0441\u0438\u043d\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":81.477379,
      "latitude":54.821667
    },
    "3473":{
      "name":"\u0424\u0438\u043b\u0438\u043f\u043f\u043e\u0432\u043e",
      "longitude":81.523811,
      "latitude":54.319366
    },
    "3474":{
      "name":"\u041f\u0435\u043d\u0435\u043a",
      "longitude":81.559555,
      "latitude":55.497463
    },
    "3475":{
      "name":"\u0421\u043f\u0438\u0440\u0438\u043d\u043e",
      "longitude":81.561874,
      "latitude":54.135445
    },
    "3476":{
      "name":"\u0420\u043e\u0433\u0430\u043b\u0451\u0432\u043e",
      "longitude":81.591957,
      "latitude":54.342033
    },
    "3477":{
      "name":"\u0427\u0438\u043d\u0433\u0438\u0441",
      "longitude":81.622541,
      "latitude":54.1259518
    },
    "3478":{
      "name":"\u0414\u0443\u043f\u043b\u0435\u043d\u0441\u043a\u0430\u044f",
      "longitude":81.623779,
      "latitude":55.090389
    },
    "3479":{
      "name":"\u041a\u0438\u0440\u0437\u0430",
      "longitude":81.654251,
      "latitude":54.240887
    },
    "3480":{
      "name":"\u041e\u0432\u0447\u0438\u043d\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":81.684494,
      "latitude":55.197777
    },
    "3481":{
      "name":"\u0421\u0443\u0448\u0438\u0445\u0430",
      "longitude":81.713242,
      "latitude":54.379593
    },
    "3482":{
      "name":"\u0423\u0441\u0442\u044c-\u041b\u0443\u043a\u043e\u0432\u043a\u0430",
      "longitude":81.731529,
      "latitude":54.385818
    },
    "3483":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":81.748001,
      "latitude":54.524258
    },
    "3484":{
      "name":"\u0423\u0441\u0442\u044c-\u0425\u043c\u0435\u043b\u0451\u0432\u043a\u0430",
      "longitude":81.773415,
      "latitude":54.271305
    },
    "3485":{
      "name":"\u0428\u0430\u0439\u0434\u0443\u0440\u043e\u0432\u043e",
      "longitude":81.797646,
      "latitude":54.011723
    },
    "3486":{
      "name":"\u0422\u0430\u0440\u0430\u0434\u0430\u043d\u043e\u0432\u043e",
      "longitude":81.845871,
      "latitude":53.769127
    },
    "3487":{
      "name":"\u0412\u0430\u0433\u0430\u0439\u0446\u0435\u0432\u043e",
      "longitude":81.862457,
      "latitude":54.364994
    },
    "3488":{
      "name":"\u041c\u0430\u043b\u043e\u0438\u0440\u043c\u0435\u043d\u043a\u0430",
      "longitude":81.893097,
      "latitude":54.537918
    },
    "3489":{
      "name":"\u0424\u0435\u0434\u043e\u0441\u0438\u0445\u0430",
      "longitude":81.894478,
      "latitude":54.786552
    },
    "3490":{
      "name":"\u041a\u043b\u044e\u0447\u0438\u043a\u0438",
      "longitude":81.899345,
      "latitude":53.899864
    },
    "3491":{
      "name":"\u041d\u0438\u0436\u043d\u0435\u043a\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":81.907921,
      "latitude":54.314812
    },
    "3492":{
      "name":"\u041a\u0430\u0440\u0433\u0430\u043f\u043e\u043b\u043e\u0432\u043e",
      "longitude":81.936028,
      "latitude":53.752834
    },
    "3493":{
      "name":"\u041b\u0435\u0441\u043d\u0430\u044f \u041f\u043e\u043b\u044f\u043d\u0430",
      "longitude":81.940422,
      "latitude":55.042
    },
    "3494":{
      "name":"\u0427\u0435\u0440\u043d\u0430\u043a\u043e\u0432\u043e",
      "longitude":81.940468,
      "latitude":54.377594
    },
    "3495":{
      "name":"\u0412\u0435\u0440\u0445-\u0427\u0438\u043a",
      "longitude":81.942657,
      "latitude":54.649696
    },
    "3496":{
      "name":"\u041d\u043e\u0432\u043e\u043c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":81.954414,
      "latitude":55.205528
    },
    "3497":{
      "name":"\u0426\u0435\u043b\u0438\u043d\u043d\u043e\u0435",
      "longitude":81.99662,
      "latitude":54.811588
    },
    "3498":{
      "name":"\u041d\u043e\u0432\u044b\u0439 \u0428\u0430\u0440\u0430\u043f",
      "longitude":82.036324,
      "latitude":54.410988
    },
    "3499":{
      "name":"\u0417\u0435\u043c\u043b\u0435\u0434\u0435\u043b\u0435\u0446",
      "longitude":82.042282,
      "latitude":53.864155
    },
    "3500":{
      "name":"\u041c\u0430\u043b\u044b\u0448\u0435\u0432\u043e",
      "longitude":82.052925,
      "latitude":53.742188
    },
    "3501":{
      "name":"\u0411\u0435\u043b\u043e\u0431\u043e\u0440\u043e\u0434\u043e\u0432\u043e",
      "longitude":82.054642,
      "latitude":55.065739
    },
    "3502":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u043a\u0430",
      "longitude":82.057228,
      "latitude":54.609203
    },
    "3503":{
      "name":"\u041c\u0438\u0440\u043d\u044b\u0439",
      "longitude":82.080734,
      "latitude":54.945011
    },
    "3504":{
      "name":"\u041c\u044b\u0448\u043b\u0430\u043d\u043a\u0430",
      "longitude":82.088959,
      "latitude":54.016327
    },
    "3505":{
      "name":"\u041a\u0440\u0443\u0442\u043e\u043b\u043e\u0433\u043e\u0432\u043e",
      "longitude":82.091835,
      "latitude":55.30724
    },
    "3506":{
      "name":"\u041f\u043e\u0432\u0430\u0440\u0435\u043d\u043a\u0430",
      "longitude":82.1128325,
      "latitude":54.8241485
    },
    "3507":{
      "name":"\u041a\u043e\u0437\u0438\u0445\u0430",
      "longitude":82.12133,
      "latitude":54.561604
    },
    "3508":{
      "name":"\u0411\u043e\u0431\u0440\u043e\u0432\u043a\u0430",
      "longitude":82.135208,
      "latitude":53.92474
    },
    "3509":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u042f\u0440",
      "longitude":82.15686,
      "latitude":54.453373
    },
    "3510":{
      "name":"\u0414\u0440\u0443\u0436\u043d\u044b\u0439",
      "longitude":82.15918,
      "latitude":54.97438
    },
    "3511":{
      "name":"\u041a\u0443\u043c\u044b\u0441\u043d\u044b\u0439",
      "longitude":82.174484,
      "latitude":55.044643
    },
    "3512":{
      "name":"\u041f\u043b\u043e\u0442\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":82.217896,
      "latitude":54.597088
    },
    "3513":{
      "name":"\u0428\u0430\u0433\u0430\u043b\u043e\u0432\u043e",
      "longitude":82.218918,
      "latitude":54.91256
    },
    "3514":{
      "name":"\u0412\u0435\u0440\u0445-\u0418\u0440\u043c\u0435\u043d\u044c",
      "longitude":82.244164,
      "latitude":54.566437
    },
    "3515":{
      "name":"\u0422\u0440\u043e\u0438\u0446\u043a",
      "longitude":82.245804,
      "latitude":55.129101
    },
    "3516":{
      "name":"\u0411\u043e\u043b\u0442\u043e\u0432\u043e",
      "longitude":82.265205,
      "latitude":54.026859
    },
    "3517":{
      "name":"\u0411\u0435\u0434\u0440\u0438\u043d\u043e",
      "longitude":82.267639,
      "latitude":53.987228
    },
    "3518":{
      "name":"\u0411\u0438\u0442\u043a\u0438",
      "longitude":82.27327,
      "latitude":54.204201
    },
    "3519":{
      "name":"\u0421\u0432\u0435\u0442\u043b\u044b\u0439",
      "longitude":82.285179,
      "latitude":55.012493
    },
    "3520":{
      "name":"\u0412\u0435\u0440\u0445-\u0421\u0443\u0437\u0443\u043d",
      "longitude":82.294952,
      "latitude":53.681107
    },
    "3521":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u0440\u0435\u043c\u043b\u0451\u0432\u0441\u043a\u043e\u0435",
      "longitude":82.314896,
      "latitude":55.197346
    },
    "3522":{
      "name":"\u041d\u043e\u0432\u043e\u043f\u0438\u0447\u0443\u0433\u043e\u0432\u043e",
      "longitude":82.349693,
      "latitude":54.61031
    },
    "3523":{
      "name":"\u041b\u0435\u0441\u043d\u0438\u043a\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":82.36042,
      "latitude":53.593983
    },
    "3524":{
      "name":"\u041f\u043e\u043d\u043e\u043c\u0430\u0440\u0435\u0432\u043a\u0430",
      "longitude":82.365372,
      "latitude":56.137455
    },
    "3525":{
      "name":"\u041c\u0435\u0440\u0435\u0442\u044c",
      "longitude":82.397125,
      "latitude":53.574917
    },
    "3526":{
      "name":"\u0421\u0438\u0434\u043e\u0440\u043e\u0432\u043a\u0430",
      "longitude":82.408691,
      "latitude":55.444237
    },
    "3527":{
      "name":"\u041d\u043e\u0432\u043e\u0442\u044b\u0440\u044b\u0448\u043a\u0438\u043d\u043e",
      "longitude":82.410477,
      "latitude":55.284389
    },
    "3528":{
      "name":"\u0417\u0430\u043a\u043e\u0432\u0440\u044f\u0436\u0438\u043d\u043e",
      "longitude":82.424141,
      "latitude":54.03175
    },
    "3529":{
      "name":"\u041c\u0430\u044e\u0440\u043e\u0432\u043e",
      "longitude":82.426704,
      "latitude":54.31744
    },
    "3530":{
      "name":"\u041d\u043e\u0432\u043e\u0448\u0438\u043b\u043e\u0432\u043e",
      "longitude":82.432091,
      "latitude":54.715679
    },
    "3531":{
      "name":"\u0424\u0430\u043a\u0435\u043b \u0420\u0435\u0432\u043e\u043b\u044e\u0446\u0438\u0438",
      "longitude":82.442276,
      "latitude":54.478268
    },
    "3532":{
      "name":"\u0427\u0438\u043a",
      "longitude":82.4427018,
      "latitude":54.9944056
    },
    "3533":{
      "name":"\u0417\u0430\u0432\u044c\u044f\u043b\u043e\u0432\u043e",
      "longitude":82.448395,
      "latitude":54.505348
    },
    "3534":{
      "name":"\u0421\u0435\u043d\u0447\u0430\u043d\u043a\u0430",
      "longitude":82.4537988,
      "latitude":54.8408864
    },
    "3535":{
      "name":"\u041f\u0440\u043e\u043a\u0443\u0434\u0441\u043a\u043e\u0435",
      "longitude":82.4593467,
      "latitude":55.0101158
    },
    "3536":{
      "name":"\u0411\u0443\u043d\u044c\u043a\u043e\u0432\u043e",
      "longitude":82.4844871,
      "latitude":55.0629392
    },
    "3537":{
      "name":"\u0427\u0438\u0441\u0442\u043e\u043f\u043e\u043b\u044c\u0435",
      "longitude":82.4972386,
      "latitude":54.9656824
    },
    "3538":{
      "name":"\u0420\u0435\u0447\u043d\u0438\u043a",
      "longitude":82.5098853,
      "latitude":54.8970649
    },
    "3539":{
      "name":"\u0411\u0435\u0440\u0435\u0433\u043e\u0432\u043e\u0435",
      "longitude":82.509918,
      "latitude":54.655838
    },
    "3540":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u043c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":82.5179361,
      "latitude":54.9959079
    },
    "3541":{
      "name":"\u042e\u0436\u0438\u043d\u043e",
      "longitude":82.519745,
      "latitude":55.487583
    },
    "3542":{
      "name":"\u0428\u0430\u0440\u0447\u0438\u043d\u043e",
      "longitude":82.53228,
      "latitude":54.267941
    },
    "3543":{
      "name":"\u041a\u0430\u0442\u043a\u043e\u0432\u043e",
      "longitude":82.5393992,
      "latitude":55.1251275
    },
    "3544":{
      "name":"\u041f\u0430\u0439\u0432\u0438\u043d\u043e",
      "longitude":82.5528655,
      "latitude":54.8416541
    },
    "3545":{
      "name":"\u0421\u043e\u043a\u043e\u043b\u043e\u0432\u043e",
      "longitude":82.5611107,
      "latitude":55.2012537
    },
    "3546":{
      "name":"\u0412\u043e\u0440\u043e\u0431\u044c\u0435\u0432\u043e",
      "longitude":82.568306,
      "latitude":55.311062
    },
    "3547":{
      "name":"\u0411\u044b\u0441\u0442\u0440\u043e\u0432\u043a\u0430",
      "longitude":82.578629,
      "latitude":54.536373
    },
    "3548":{
      "name":"\u0425\u043e\u043b\u043e\u0434\u043d\u043e\u0435",
      "longitude":82.583435,
      "latitude":54.115444
    },
    "3549":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":82.5847296,
      "latitude":54.9343119
    },
    "3550":{
      "name":"\u0428\u0438\u043f\u0443\u043d\u043e\u0432\u043e",
      "longitude":82.597343,
      "latitude":54.003105
    },
    "3551":{
      "name":"\u042f\u0440\u043a\u043e\u0432\u043e",
      "longitude":82.6035041,
      "latitude":54.8062688
    },
    "3552":{
      "name":"\u0411\u043e\u0440\u043e\u0432\u043e\u0435",
      "longitude":82.634216,
      "latitude":54.692944
    },
    "3553":{
      "name":"\u0421\u043e\u0432\u0435\u0442\u0441\u043a\u0438\u0439",
      "longitude":82.678215,
      "latitude":54.451546
    },
    "3554":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u0433\u043b\u0438\u043d\u043d\u043e\u0435",
      "longitude":82.7041201,
      "latitude":54.9716723
    },
    "3555":{
      "name":"\u041f\u0438\u0445\u0442\u043e\u0432\u043a\u0430",
      "longitude":82.711868,
      "latitude":55.989109
    },
    "3556":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u041e\u0451\u0448",
      "longitude":82.715936,
      "latitude":55.2894615
    },
    "3557":{
      "name":"\u041f\u0440\u0435\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043a\u0430",
      "longitude":82.718483,
      "latitude":54.365505
    },
    "3558":{
      "name":"\u0422\u043e\u043b\u043c\u0430\u0447\u0451\u0432\u043e",
      "longitude":82.7365758,
      "latitude":54.9828438
    },
    "3559":{
      "name":"\u041a\u0440\u0443\u043f\u0441\u043a\u043e\u0439",
      "longitude":82.7382445,
      "latitude":54.8303568
    },
    "3560":{
      "name":"\u0411\u043e\u044f\u0440\u043a\u0430",
      "longitude":82.74057,
      "latitude":55.617168
    },
    "3561":{
      "name":"\u041c\u0430\u0440\u0443\u0441\u0438\u043d\u043e",
      "longitude":82.7567523,
      "latitude":55.0384524
    },
    "3562":{
      "name":"\u041a\u0443\u0440\u0438\u043b\u043e\u0432\u043a\u0430",
      "longitude":82.764656,
      "latitude":54.214832
    },
    "3563":{
      "name":"\u041f\u0440\u0438\u043e\u0431\u0441\u043a\u0438\u0439",
      "longitude":82.7710683,
      "latitude":55.0691851
    },
    "3564":{
      "name":"\u041a\u0443\u0434\u0440\u044f\u0448\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":82.7722973,
      "latitude":55.0978396
    },
    "3565":{
      "name":"\u0410\u043c\u0431\u0430",
      "longitude":82.772499,
      "latitude":55.437855
    },
    "3566":{
      "name":"\u0421\u043a\u0430\u043b\u0430",
      "longitude":82.772743,
      "latitude":55.379478
    },
    "3567":{
      "name":"\u0412\u0435\u0440\u0445-\u0422\u0443\u043b\u0430",
      "longitude":82.7739688,
      "latitude":54.8824491
    },
    "3568":{
      "name":"8 \u041c\u0430\u0440\u0442\u0430",
      "longitude":82.8067234,
      "latitude":54.9150847
    },
    "3569":{
      "name":"\u0413\u043e\u0440\u0435\u0432\u043a\u0430",
      "longitude":82.811096,
      "latitude":54.424938
    },
    "3570":{
      "name":"\u0422\u0443\u043b\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":82.83269,
      "latitude":54.9133924
    },
    "3571":{
      "name":"\u0411\u0443\u0440\u043c\u0438\u0441\u0442\u0440\u043e\u0432\u043e",
      "longitude":82.8328767,
      "latitude":54.6345591
    },
    "3572":{
      "name":"\u041c\u043e\u0447\u0438\u0449\u0435",
      "longitude":82.8482862,
      "latitude":55.1472168
    },
    "3573":{
      "name":"\u041b\u0435\u043d\u0438\u043d\u0441\u043a\u043e\u0435",
      "longitude":82.8513507,
      "latitude":54.8176197
    },
    "3574":{
      "name":"\u0428\u0443\u0440\u044b\u0433\u0438\u043d\u043e",
      "longitude":82.86483,
      "latitude":54.075077
    },
    "3575":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u042f\u0440",
      "longitude":82.9044631,
      "latitude":55.2187277
    },
    "3576":{
      "name":"\u041d\u043e\u0432\u043e\u043b\u043e\u043a\u0442\u0438",
      "longitude":82.908226,
      "latitude":54.392899
    },
    "3577":{
      "name":"\u0412\u0435\u0440\u0445-\u041c\u0438\u043b\u044c\u0442\u044e\u0448\u0438",
      "longitude":82.909431,
      "latitude":54.303646
    },
    "3578":{
      "name":"\u041a\u0443\u0431\u043e\u0432\u0430\u044f",
      "longitude":82.9160306,
      "latitude":55.2607219
    },
    "3579":{
      "name":"\u0412\u044c\u044e\u043d\u044b",
      "longitude":82.917862,
      "latitude":55.516602
    },
    "3580":{
      "name":"\u0423\u043b\u044b\u0431\u0438\u043d\u043e",
      "longitude":82.9267798,
      "latitude":54.5756546
    },
    "3581":{
      "name":"\u041e\u0437\u0451\u0440\u043d\u044b\u0439",
      "longitude":82.9377299,
      "latitude":55.1324517
    },
    "3582":{
      "name":"\u0421\u0442\u0435\u043f\u043d\u043e\u0439",
      "longitude":82.942383,
      "latitude":54.503788
    },
    "3583":{
      "name":"\u0421\u043e\u0441\u043d\u043e\u0432\u043a\u0430",
      "longitude":82.9460448,
      "latitude":55.2350512
    },
    "3584":{
      "name":"\u042d\u043b\u0438\u0442\u043d\u044b\u0439",
      "longitude":82.9473911,
      "latitude":54.913334
    },
    "3585":{
      "name":"\u0421\u043e\u0441\u043d\u043e\u0432\u043a\u0430",
      "longitude":82.9559289,
      "latitude":54.6818979
    },
    "3586":{
      "name":"\u0421\u0430\u0434\u043e\u0432\u044b\u0439",
      "longitude":82.9661333,
      "latitude":55.1372818
    },
    "3587":{
      "name":"\u041a\u0430\u0440\u0430\u0441\u0435\u0432\u043e",
      "longitude":82.999095,
      "latitude":54.1713361
    },
    "3588":{
      "name":"\u041c\u0438\u0447\u0443\u0440\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":83.0063581,
      "latitude":54.8830941
    },
    "3589":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u043c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":83.0081115,
      "latitude":54.5752931
    },
    "3590":{
      "name":"\u0418\u043d\u044f-\u0412\u043e\u0441\u0442\u043e\u0447\u043d\u0430\u044f",
      "longitude":83.0088654,
      "latitude":55.1128321
    },
    "3591":{
      "name":"\u042e\u043d\u044b\u0439 \u041b\u0435\u043d\u0438\u043d\u0435\u0446",
      "longitude":83.0127337,
      "latitude":54.8919262
    },
    "3592":{
      "name":"\u041a\u043e\u0440\u043e\u043b\u0451\u0432\u043a\u0430",
      "longitude":83.025383,
      "latitude":56.035179
    },
    "3593":{
      "name":"\u041a\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":83.0508282,
      "latitude":55.1002573
    },
    "3594":{
      "name":"\u0412\u043e\u0441\u0445\u043e\u0434",
      "longitude":83.0531315,
      "latitude":55.0817897
    },
    "3595":{
      "name":"\u041d\u043e\u0432\u043e\u0432\u043e\u0441\u043a\u0440\u0435\u0441\u0435\u043d\u043a\u0430",
      "longitude":83.059692,
      "latitude":54.095501
    },
    "3596":{
      "name":"\u0421\u0442\u0435\u043f\u043d\u043e\u0439",
      "longitude":83.0650964,
      "latitude":55.2332836
    },
    "3597":{
      "name":"\u0412\u0438\u0442\u0430\u043c\u0438\u043d\u043a\u0430",
      "longitude":83.1066378,
      "latitude":55.1347155
    },
    "3598":{
      "name":"\u0421\u043e\u0432\u0435\u0442\u0441\u043a\u0438\u0439",
      "longitude":83.1149972,
      "latitude":55.1290482
    },
    "3599":{
      "name":"\u041c\u043e\u0447\u0438\u0449\u0435",
      "longitude":83.1180475,
      "latitude":55.1563637
    },
    "3600":{
      "name":"\u041c\u0438\u0447\u0443\u0440\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":83.1196885,
      "latitude":54.741153
    },
    "3601":{
      "name":"\u041d\u043e\u0432\u043e\u043b\u0443\u0433\u043e\u0432\u043e\u0435",
      "longitude":83.1208214,
      "latitude":54.9785707
    },
    "3602":{
      "name":"\u0420\u0430\u0437\u0434\u043e\u043b\u044c\u043d\u043e\u0435",
      "longitude":83.1222097,
      "latitude":55.0562063
    },
    "3603":{
      "name":"\u0410\u0433\u0440\u043e\u043b\u0435\u0441",
      "longitude":83.1344161,
      "latitude":54.7566809
    },
    "3604":{
      "name":"\u041c\u0430\u044f\u043a",
      "longitude":83.1373471,
      "latitude":54.6952608
    },
    "3605":{
      "name":"\u041a\u0430\u0438\u043d\u0441\u043a\u0430\u044f \u0417\u0430\u0438\u043c\u043a\u0430",
      "longitude":83.1448232,
      "latitude":54.871989
    },
    "3606":{
      "name":"\u041b\u0435\u043d\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":83.1489895,
      "latitude":55.1414482
    },
    "3607":{
      "name":"\u041a\u0440\u0443\u0442\u0438\u0448\u043a\u0430",
      "longitude":83.150841,
      "latitude":54.180782
    },
    "3608":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":83.166752,
      "latitude":54.5830618
    },
    "3609":{
      "name":"\u041e\u043a\u0442\u044f\u0431\u0440\u044c\u0441\u043a\u0438\u0439",
      "longitude":83.1757585,
      "latitude":55.1730637
    },
    "3610":{
      "name":"\u0414\u043e\u0440\u043e\u0433\u0438\u043d\u0430 \u0417\u0430\u0438\u043c\u043a\u0430",
      "longitude":83.181229,
      "latitude":54.344009
    },
    "3611":{
      "name":"\u0411\u0435\u0440\u0434\u044c",
      "longitude":83.1826883,
      "latitude":54.742159
    },
    "3612":{
      "name":"\u0411\u0430\u0440\u044b\u0448\u0435\u0432\u043e",
      "longitude":83.1882987,
      "latitude":54.9622004
    },
    "3613":{
      "name":"\u041a\u0430\u043d\u0434\u0430\u0443\u0440\u043e\u0432\u043e",
      "longitude":83.194389,
      "latitude":55.675274
    },
    "3614":{
      "name":"\u0411\u0435\u043b\u043e\u044f\u0440\u043a\u0430",
      "longitude":83.199577,
      "latitude":55.415203
    },
    "3615":{
      "name":"\u0414\u0432\u0443\u0440\u0435\u0447\u044c\u0435",
      "longitude":83.2069002,
      "latitude":54.9576118
    },
    "3616":{
      "name":"\u0418\u0437\u0434\u0440\u0435\u0432\u0430\u044f",
      "longitude":83.209215,
      "latitude":54.9785507
    },
    "3617":{
      "name":"\u041c\u043e\u0440\u043e\u0437\u043e\u0432\u043e",
      "longitude":83.2178159,
      "latitude":54.7661423
    },
    "3618":{
      "name":"\u0420\u043e\u0449\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":83.2179023,
      "latitude":54.6362689
    },
    "3619":{
      "name":"\u0411\u0430\u0440\u043b\u0430\u043a",
      "longitude":83.2197282,
      "latitude":55.212267
    },
    "3620":{
      "name":"\u041a\u0440\u0430\u0445\u0430\u043b\u044c",
      "longitude":83.2229782,
      "latitude":54.9686792
    },
    "3621":{
      "name":"\u041b\u0435\u0431\u0435\u0434\u0435\u0432\u043a\u0430",
      "longitude":83.2315641,
      "latitude":54.6733786
    },
    "3622":{
      "name":"\u0413\u0443\u0441\u0438\u043d\u044b\u0439 \u0411\u0440\u043e\u0434",
      "longitude":83.2388845,
      "latitude":55.0658463
    },
    "3623":{
      "name":"\u0423\u0441\u043f\u0435\u043d\u043a\u0430",
      "longitude":83.239403,
      "latitude":55.437393
    },
    "3624":{
      "name":"\u0411\u0430\u0440\u043b\u0430\u043a\u0441\u043a\u0438\u0439",
      "longitude":83.2407183,
      "latitude":55.168276
    },
    "3625":{
      "name":"\u0418\u0437\u0434\u0440\u0435\u0432\u0430\u044f",
      "longitude":83.2459288,
      "latitude":54.9864402
    },
    "3626":{
      "name":"\u0413\u0440\u0438\u0431\u043d\u043e\u0439",
      "longitude":83.248863,
      "latitude":54.286129
    },
    "3627":{
      "name":"\u041a\u043e\u0439\u043d\u0438\u0445\u0430",
      "longitude":83.2528105,
      "latitude":54.5678406
    },
    "3628":{
      "name":"\u041d\u043e\u0432\u043e\u0442\u0440\u043e\u0438\u0446\u043a",
      "longitude":83.270737,
      "latitude":55.599991
    },
    "3629":{
      "name":"\u0422\u0430\u043b\u044c\u043c\u0435\u043d\u043a\u0430",
      "longitude":83.2747819,
      "latitude":54.70626
    },
    "3630":{
      "name":"\u0427\u0435\u0440\u043d\u043e\u0440\u0435\u0447\u0435\u043d\u0441\u043a\u0438\u0439",
      "longitude":83.2749944,
      "latitude":54.6520319
    },
    "3631":{
      "name":"\u042f\u0440\u043a\u0438",
      "longitude":83.276329,
      "latitude":54.14872
    },
    "3632":{
      "name":"\u0416\u0435\u0440\u0435\u0431\u0446\u043e\u0432\u043e",
      "longitude":83.2770201,
      "latitude":55.1145037
    },
    "3633":{
      "name":"\u0416\u0435\u043b\u0435\u0437\u043d\u043e\u0434\u043e\u0440\u043e\u0436\u043d\u044b\u0439",
      "longitude":83.2837292,
      "latitude":54.9865994
    },
    "3634":{
      "name":"\u0428\u0438\u0431\u043a\u043e\u0432\u043e",
      "longitude":83.288345,
      "latitude":54.49353
    },
    "3635":{
      "name":"\u0414\u0443\u0431\u0440\u043e\u0432\u0438\u043d\u043e",
      "longitude":83.292892,
      "latitude":55.471161
    },
    "3636":{
      "name":"\u0411\u044b\u043a\u043e\u0432\u043e",
      "longitude":83.2943001,
      "latitude":54.9336508
    },
    "3637":{
      "name":"\u0414\u043e\u0440\u043e\u0433\u0438\u043d\u043e",
      "longitude":83.317009,
      "latitude":54.362015
    },
    "3638":{
      "name":"\u0421\u043e\u043a\u0443\u0440",
      "longitude":83.3208502,
      "latitude":55.2138096
    },
    "3639":{
      "name":"\u0415\u0432\u0441\u0438\u043d\u043e",
      "longitude":83.322159,
      "latitude":54.417175
    },
    "3640":{
      "name":"\u041f\u044f\u0442\u0438\u043b\u0435\u0442\u043a\u0430",
      "longitude":83.3288565,
      "latitude":54.2412141
    },
    "3641":{
      "name":"\u0428\u0435\u043b\u043a\u043e\u0432\u0438\u0447\u0438\u0445\u0430",
      "longitude":83.3377663,
      "latitude":54.9840713
    },
    "3642":{
      "name":"\u0415\u043c\u0435\u043b\u044c\u044f\u043d\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":83.3402358,
      "latitude":55.2517228
    },
    "3643":{
      "name":"\u0411\u0435\u0440\u0435\u0437\u043e\u0432\u043a\u0430",
      "longitude":83.3433466,
      "latitude":54.9941162
    },
    "3644":{
      "name":"\u041a\u0435\u0440\u0430\u043c\u043a\u043e\u043c\u0431\u0438\u043d\u0430\u0442",
      "longitude":83.343796,
      "latitude":54.433292
    },
    "3645":{
      "name":"\u0415\u0432\u0441\u0438\u043d\u043e",
      "longitude":83.3479109,
      "latitude":54.5129689
    },
    "3646":{
      "name":"\u041c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":83.36319,
      "latitude":54.188618
    },
    "3647":{
      "name":"\u0421\u043c\u043e\u043b\u0435\u043d\u0441\u043a\u0438\u0439",
      "longitude":83.3635663,
      "latitude":55.1974324
    },
    "3648":{
      "name":"\u041f\u0440\u0438\u0432\u043e\u043b\u044c\u043d\u044b\u0439",
      "longitude":83.364906,
      "latitude":54.121769
    },
    "3649":{
      "name":"\u0411\u0435\u0437\u043c\u0435\u043d\u043e\u0432\u043e",
      "longitude":83.388893,
      "latitude":54.076656
    },
    "3650":{
      "name":"\u0421\u0442\u0430\u0440\u044b\u0439 \u0418\u0441\u043a\u0438\u0442\u0438\u043c",
      "longitude":83.3917519,
      "latitude":54.6115673
    },
    "3651":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0439 \u041a\u043e\u0451\u043d",
      "longitude":83.396286,
      "latitude":54.815178
    },
    "3652":{
      "name":"\u041f\u043b\u043e\u0442\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":83.397324,
      "latitude":55.036011
    },
    "3653":{
      "name":"\u041f\u0443\u0448\u043d\u043e\u0439",
      "longitude":83.406944,
      "latitude":54.237465
    },
    "3654":{
      "name":"\u0418\u0441\u043a\u0440\u0430",
      "longitude":83.409195,
      "latitude":54.186043
    },
    "3655":{
      "name":"\u0428\u0430\u0434\u0440\u0438\u043d\u043e",
      "longitude":83.414215,
      "latitude":54.459206
    },
    "3656":{
      "name":"\u042e\u0436\u043d\u044b\u0439",
      "longitude":83.42205,
      "latitude":54.01062
    },
    "3657":{
      "name":"\u0411\u0430\u0440\u0430\u0431\u043a\u0430",
      "longitude":83.430481,
      "latitude":54.659492
    },
    "3658":{
      "name":"\u0412\u043e\u0441\u0442\u043e\u0447\u043d\u0430\u044f",
      "longitude":83.430832,
      "latitude":55.035954
    },
    "3659":{
      "name":"\u0423\u0440\u0433\u0443\u043d",
      "longitude":83.42754094346262,
      "latitude":54.50424927528644
    },
    "3660":{
      "name":"\u041e\u0431\u0441\u043a\u043e\u0439",
      "longitude":83.445213,
      "latitude":55.47443
    },
    "3661":{
      "name":"\u0411\u043e\u0447\u043a\u0430\u0440\u0435\u0432\u043e",
      "longitude":83.4617279,
      "latitude":54.2492351
    },
    "3662":{
      "name":"\u0420\u0435\u043f\u044c\u0435\u0432\u043e",
      "longitude":83.463028,
      "latitude":55.064449
    },
    "3663":{
      "name":"\u041b\u0438\u0441\u0442\u0432\u044f\u043d\u0441\u043a\u0438\u0439",
      "longitude":83.48613,
      "latitude":54.442276
    },
    "3664":{
      "name":"\u0422\u0430\u0448\u0430\u0440\u0430",
      "longitude":83.495399,
      "latitude":55.517941
    },
    "3665":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u041a\u043e\u0451\u043d",
      "longitude":83.507347,
      "latitude":54.868355
    },
    "3666":{
      "name":"\u0417\u0438\u043c\u043e\u0432\u044c\u0435",
      "longitude":83.54393,
      "latitude":54.23177
    },
    "3667":{
      "name":"\u0413\u043e\u0440\u043d\u044b\u0439",
      "longitude":83.543968,
      "latitude":55.327282
    },
    "3668":{
      "name":"\u041c\u0435\u0434\u0432\u0435\u0434\u0441\u043a\u043e\u0435",
      "longitude":83.553047,
      "latitude":54.402504
    },
    "3669":{
      "name":"\u041d\u043e\u0432\u043e\u043c\u043e\u0448\u043a\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":83.589935,
      "latitude":55.331535
    },
    "3670":{
      "name":"\u041c\u043e\u0442\u043a\u043e\u0432\u043e",
      "longitude":83.605278,
      "latitude":55.129715
    },
    "3671":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u0433\u043e\u0440\u0441\u043a\u0438\u0439",
      "longitude":83.614517,
      "latitude":55.391056
    },
    "3672":{
      "name":"\u041c\u043e\u0448\u043d\u0438\u043d\u043e",
      "longitude":83.630013,
      "latitude":55.232655
    },
    "3673":{
      "name":"\u0411\u0435\u043b\u043e\u0432\u043e",
      "longitude":83.632385,
      "latitude":54.538097
    },
    "3674":{
      "name":"\u041b\u044c\u043d\u0438\u0445\u0430",
      "longitude":83.632507,
      "latitude":55.119781
    },
    "3675":{
      "name":"\u041b\u0435\u043a\u0430\u0440\u0441\u0442\u0432\u0435\u043d\u043d\u043e\u0435",
      "longitude":83.649857,
      "latitude":55.002598
    },
    "3676":{
      "name":"\u0413\u0443\u0441\u0435\u043b\u044c\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":83.692986,
      "latitude":54.519867
    },
    "3677":{
      "name":"\u041a\u0430\u0440\u043f\u044b\u0441\u0430\u043a",
      "longitude":83.712883,
      "latitude":55.039745
    },
    "3678":{
      "name":"\u041b\u0438\u0441\u0442\u0432\u044f\u043d\u043a\u0430",
      "longitude":83.716469,
      "latitude":54.151337
    },
    "3679":{
      "name":"\u0423\u0441\u0442\u044c-\u0427\u0435\u043c",
      "longitude":83.729034,
      "latitude":54.662395
    },
    "3680":{
      "name":"\u0420\u0430\u0434\u0443\u0433\u0430",
      "longitude":83.734474,
      "latitude":55.497631
    },
    "3681":{
      "name":"\u041e\u0433\u043d\u0435\u0432\u0430 \u0417\u0430\u0438\u043c\u043a\u0430",
      "longitude":83.740364,
      "latitude":54.287239
    },
    "3682":{
      "name":"\u0421\u0430\u0440\u0430\u043f\u0443\u043b\u043a\u0430",
      "longitude":83.750015,
      "latitude":55.158222
    },
    "3683":{
      "name":"\u041d\u043e\u0432\u043e\u0431\u0438\u0431\u0435\u0435\u0432\u043e",
      "longitude":83.7505327,
      "latitude":55.6966012
    },
    "3684":{
      "name":"\u0411\u0443\u0433\u043e\u0442\u0430\u043a",
      "longitude":83.7693546,
      "latitude":55.1450361
    },
    "3685":{
      "name":"\u0411\u0443\u0433\u043e\u0442\u0430\u043a",
      "longitude":83.808083,
      "latitude":55.147881
    },
    "3686":{
      "name":"\u041b\u0435\u0433\u043e\u0441\u0442\u0430\u0435\u0432\u043e",
      "longitude":83.819496,
      "latitude":54.642929
    },
    "3687":{
      "name":"\u0422\u043e\u043c\u0438\u043b\u043e\u0432\u043e",
      "longitude":83.838936,
      "latitude":55.216259
    },
    "3688":{
      "name":"\u041e\u044f\u0448",
      "longitude":83.846123,
      "latitude":55.550598
    },
    "3689":{
      "name":"\u0423\u0441\u0442\u044c-\u041a\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":83.847878,
      "latitude":54.99646
    },
    "3690":{
      "name":"\u041a\u0440\u0443\u0433\u043b\u0438\u043a\u043e\u0432\u043e",
      "longitude":83.855682,
      "latitude":55.838856
    },
    "3691":{
      "name":"\u041c\u043e\u0441\u0442\u044b",
      "longitude":83.85585,
      "latitude":54.770237
    },
    "3692":{
      "name":"\u0411\u0430\u043b\u0442\u0430",
      "longitude":83.87484,
      "latitude":55.513691
    },
    "3693":{
      "name":"\u0428\u0438\u0440\u043e\u043a\u0438\u0439 \u042f\u0440",
      "longitude":83.875763,
      "latitude":55.470303
    },
    "3694":{
      "name":"\u0413\u043e\u0440\u043d\u044b\u0439",
      "longitude":83.878761,
      "latitude":55.118286
    },
    "3695":{
      "name":"\u0411\u0430\u0439\u043a\u0430\u043b",
      "longitude":83.887138,
      "latitude":55.637905
    },
    "3696":{
      "name":"\u0411\u0443\u0440\u0430\u043d\u043e\u0432\u043e",
      "longitude":83.894394,
      "latitude":54.204353
    },
    "3697":{
      "name":"\u0423\u0447\u0430\u0441\u0442\u043e\u043a-\u0411\u0430\u043b\u0442\u0430",
      "longitude":83.931267,
      "latitude":55.430286
    },
    "3698":{
      "name":"\u0427\u0435\u043c\u0441\u043a\u043e\u0435",
      "longitude":83.953316,
      "latitude":54.849239
    },
    "3699":{
      "name":"\u041d\u0438\u043a\u043e\u043d\u043e\u0432\u043e",
      "longitude":83.973312,
      "latitude":54.436977
    },
    "3700":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u043e",
      "longitude":83.98011,
      "latitude":54.513268
    },
    "3701":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u043e\u0441\u0435\u0434\u043e\u0432\u043e",
      "longitude":83.984161,
      "latitude":54.644833
    },
    "3702":{
      "name":"\u041f\u0435\u043d\u044c\u043a\u043e\u0432\u043e",
      "longitude":83.988861,
      "latitude":54.336498
    },
    "3703":{
      "name":"\u0412\u043b\u0430\u0434\u0438\u043c\u0438\u0440\u043e\u0432\u043a\u0430",
      "longitude":83.999741,
      "latitude":54.963802
    },
    "3704":{
      "name":"\u0421\u0432\u0435\u0442\u043b\u0430\u044f \u041f\u043e\u043b\u044f\u043d\u0430",
      "longitude":84.030617,
      "latitude":55.488674
    },
    "3705":{
      "name":"\u0411\u043e\u0440\u043a\u043e\u0432\u043e",
      "longitude":84.058327,
      "latitude":54.224659
    },
    "3706":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u0427\u0435\u0431\u0443\u043b\u0430",
      "longitude":84.06855,
      "latitude":55.559055
    },
    "3707":{
      "name":"\u041a\u0430\u0439\u043b\u044b",
      "longitude":84.082893,
      "latitude":55.29488
    },
    "3708":{
      "name":"\u0411\u043e\u0440\u0446\u043e\u0432\u043e",
      "longitude":84.087227,
      "latitude":55.150513
    },
    "3709":{
      "name":"\u041f\u0430\u0439\u0432\u0438\u043d\u043e",
      "longitude":84.12188,
      "latitude":54.40274
    },
    "3710":{
      "name":"\u0412\u0435\u0440\u0445-\u0418\u043a\u0438",
      "longitude":84.1332887,
      "latitude":54.603889
    },
    "3711":{
      "name":"\u0417\u043b\u0430\u0442\u043e\u0443\u0441\u0442",
      "longitude":84.142738,
      "latitude":55.259163
    },
    "3712":{
      "name":"\u041a\u0430\u0440\u0430\u0441\u0435\u0432\u043e",
      "longitude":84.159157,
      "latitude":55.721443
    },
    "3713":{
      "name":"\u0427\u0443\u043f\u0438\u043d\u043e",
      "longitude":84.161758,
      "latitude":54.399105
    },
    "3714":{
      "name":"\u041a\u0440\u0438\u0432\u043e\u044f\u0448",
      "longitude":84.180214,
      "latitude":55.506416
    },
    "3715":{
      "name":"\u0414\u0435\u0440\u0433\u0430\u0443\u0441\u043e\u0432\u043e",
      "longitude":84.182976,
      "latitude":54.872314
    },
    "3716":{
      "name":"\u0415\u0433\u043e\u0440\u043e\u0432\u043a\u0430",
      "longitude":84.217545,
      "latitude":55.62146
    },
    "3717":{
      "name":"\u041a\u0443\u0434\u0435\u043b\u044c\u043d\u044b\u0439 \u041a\u043b\u044e\u0447",
      "longitude":84.255737,
      "latitude":55.157078
    },
    "3718":{
      "name":"\u0417\u0443\u0434\u043e\u0432\u043e",
      "longitude":84.260231,
      "latitude":55.824898
    },
    "3719":{
      "name":"\u042f\u043d\u0447\u0435\u043d\u043a\u043e\u0432\u043e",
      "longitude":84.261627,
      "latitude":55.286083
    },
    "3720":{
      "name":"\u041a\u0438\u0440\u044f\u043a\u043e\u0432\u043e",
      "longitude":84.261978,
      "latitude":55.812714
    },
    "3721":{
      "name":"\u041c\u0430\u043c\u043e\u043d\u043e\u0432\u043e",
      "longitude":84.263512,
      "latitude":54.309383
    },
    "3722":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u0418\u0437\u044b\u0440\u0430\u043a",
      "longitude":84.270218,
      "latitude":54.514095
    },
    "3723":{
      "name":"\u0411\u0430\u0436\u0438\u043d\u0441\u043a",
      "longitude":84.276398,
      "latitude":54.372646
    },
    "3724":{
      "name":"\u041a\u0443\u0434\u0440\u0438\u043d\u043e",
      "longitude":84.29525,
      "latitude":55.248798
    },
    "3725":{
      "name":"\u041a\u0443\u043d\u0447\u0443\u0440\u0443\u043a",
      "longitude":84.295929,
      "latitude":55.919682
    },
    "3726":{
      "name":"\u0413\u0443\u0442\u043e\u0432\u043e",
      "longitude":84.296738,
      "latitude":55.273827
    },
    "3727":{
      "name":"\u0411\u043e\u0440",
      "longitude":84.309021,
      "latitude":55.669182
    },
    "3728":{
      "name":"\u041b\u0435\u0431\u0435\u0434\u0435\u0432\u043e",
      "longitude":84.344116,
      "latitude":54.917683
    },
    "3729":{
      "name":"\u0412\u0430\u0440\u043b\u0430\u043c\u043e\u0432\u043e",
      "longitude":84.361465,
      "latitude":55.808899
    },
    "3730":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":84.364975,
      "latitude":54.435261
    },
    "3731":{
      "name":"\u0412\u0430\u0441\u0441\u0438\u043d\u043e",
      "longitude":84.375412,
      "latitude":55.056667
    },
    "3732":{
      "name":"\u041d\u0435\u0447\u0430\u0435\u0432\u0441\u043a\u0438\u0439",
      "longitude":84.380035,
      "latitude":55.209885
    },
    "3733":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u0422\u043e\u043c\u043a\u0430",
      "longitude":84.417191,
      "latitude":54.28994
    },
    "3734":{
      "name":"\u041f\u043e\u0439\u043c\u0435\u043d\u043d\u043e\u0435",
      "longitude":84.42067,
      "latitude":55.057507
    },
    "3735":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u0427\u0451\u0440\u043d\u0430\u044f",
      "longitude":84.421837,
      "latitude":55.964317
    },
    "3736":{
      "name":"\u0411\u0430\u0440\u0430\u0442\u0430\u0435\u0432\u043a\u0430",
      "longitude":84.449059,
      "latitude":55.618763
    },
    "3737":{
      "name":"\u041a\u0430\u043c\u0435\u043d\u043d\u0430\u044f \u0413\u043e\u0440\u0430",
      "longitude":84.449203,
      "latitude":55.069672
    },
    "3738":{
      "name":"\u0414\u0438\u0432\u0438\u043d\u043a\u0430",
      "longitude":84.473923,
      "latitude":55.696388
    },
    "3739":{
      "name":"\u0420\u0443\u0441\u0441\u043a\u043e-\u0421\u0435\u043c\u0435\u043d\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":84.484245,
      "latitude":55.279877
    },
    "3740":{
      "name":"\u0422\u0443\u0440\u043d\u0430\u0435\u0432\u043e",
      "longitude":84.51368,
      "latitude":55.775116
    },
    "3741":{
      "name":"\u0421\u0443\u0440\u043a\u043e\u0432\u043e",
      "longitude":84.516861,
      "latitude":55.308056
    },
    "3742":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0435\u0440\u0435\u0447\u043a\u0430",
      "longitude":84.530533,
      "latitude":55.56694
    },
    "3743":{
      "name":"\u0421\u0443\u0435\u043d\u0433\u0430",
      "longitude":84.539413,
      "latitude":54.403503
    },
    "3744":{
      "name":"\u0415\u043b\u0431\u0430\u043d\u044c",
      "longitude":84.593826,
      "latitude":54.318886
    },
    "3745":{
      "name":"\u0415\u0433\u043e\u0440\u044c\u0435\u0432\u0441\u043a\u043e\u0435",
      "longitude":84.597885,
      "latitude":54.498913
    },
    "3746":{
      "name":"\u041a\u043e\u0440\u043d\u0438\u043b\u043e\u0432\u043e",
      "longitude":84.60041,
      "latitude":55.515568
    },
    "3747":{
      "name":"\u0410\u0447\u0430",
      "longitude":84.617424,
      "latitude":55.642166
    },
    "3748":{
      "name":"\u0417\u0430\u0440\u0435\u0447\u043d\u043e\u0435",
      "longitude":84.621788,
      "latitude":55.155621
    },
    "3749":{
      "name":"\u041a\u043e\u0443\u0440\u0430\u043a",
      "longitude":84.676628,
      "latitude":54.828789
    },
    "3750":{
      "name":"\u041a\u0438\u0438\u043a",
      "longitude":84.691559,
      "latitude":55.244522
    },
    "3751":{
      "name":"\u0414\u0443\u0431\u0440\u043e\u0432\u043a\u0430",
      "longitude":84.721375,
      "latitude":54.464409
    },
    "3752":{
      "name":"\u0417\u0430\u0432\u044c\u044f\u043b\u043e\u0432\u043e",
      "longitude":84.728462,
      "latitude":55.068684
    },
    "3753":{
      "name":"\u041c\u0438\u0440\u043d\u044b\u0439",
      "longitude":84.749237,
      "latitude":54.725227
    },
    "3754":{
      "name":"\u0428\u0430\u0445\u0442\u0430",
      "longitude":84.754791,
      "latitude":55.094715
    },
    "3755":{
      "name":"\u041a\u0443\u0440\u0443\u043d\u0434\u0443\u0441",
      "longitude":84.790718,
      "latitude":55.057735
    },
    "3756":{
      "name":"\u042e\u0440\u0442\u044b",
      "longitude":84.809662,
      "latitude":54.853699
    },
    "3757":{
      "name":"\u0411\u0435\u0440\u0435\u0437\u0438\u043a\u043e\u0432\u043e",
      "longitude":84.814629,
      "latitude":55.041721
    },
    "3758":{
      "name":"\u0413\u0440\u0435\u043c\u044f\u0447\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":84.833778,
      "latitude":54.960495
    },
    "3759":{
      "name":"\u0421\u0442\u0435\u043f\u043d\u043e\u0433\u0443\u0442\u043e\u0432\u043e",
      "longitude":84.967766,
      "latitude":54.846779
    },
    "3760":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u044f\u044f \u0413\u0443\u0442\u0430\u0440\u0430",
      "longitude":96.975929,
      "latitude":54.217838
    },
    "3761":{
      "name":"\u0412\u0435\u043d\u0433\u0435\u0440\u043a\u0430",
      "longitude":97.268463,
      "latitude":55.803421
    },
    "3762":{
      "name":"\u0415\u043b\u0430\u043d\u043a\u0430",
      "longitude":97.40757,
      "latitude":55.7624396
    },
    "3763":{
      "name":"\u041f\u043e\u043b\u043e\u0432\u0438\u043d\u043e-\u0427\u0435\u0440\u0435\u043c\u0445\u043e\u0432\u043e",
      "longitude":97.623337,
      "latitude":56.068188
    },
    "3764":{
      "name":"\u042e\u0440\u0442\u044b",
      "longitude":97.635185,
      "latitude":56.048733
    },
    "3765":{
      "name":"\u0420\u043e\u0436\u0434\u0435\u0441\u0442\u0432\u0435\u043d\u043a\u0430",
      "longitude":97.640671,
      "latitude":55.793201
    },
    "3766":{
      "name":"\u0417\u0430\u0440\u0435\u0447\u043d\u043e\u0435",
      "longitude":97.654861,
      "latitude":55.9681149
    },
    "3767":{
      "name":"\u0428\u0435\u043b\u0430\u0435\u0432\u043e",
      "longitude":97.694885,
      "latitude":56.928532
    },
    "3768":{
      "name":"\u0428\u0435\u043b\u0435\u0445\u043e\u0432\u043e",
      "longitude":97.702019,
      "latitude":55.72134
    },
    "3769":{
      "name":"\u041c\u0438\u0440\u043d\u044b\u0439",
      "longitude":97.705086,
      "latitude":56.880692
    },
    "3770":{
      "name":"\u041d\u043e\u0432\u043e\u0431\u0438\u0440\u044e\u0441\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":97.709785,
      "latitude":56.957432
    },
    "3771":{
      "name":"\u0422\u0430\u043c\u0442\u0430\u0447\u0435\u0442",
      "longitude":97.730148,
      "latitude":57.270702
    },
    "3772":{
      "name":"\u0422\u0430\u043b\u0430\u044f",
      "longitude":97.75074,
      "latitude":55.590462
    },
    "3773":{
      "name":"\u0422\u0438\u043c\u0438\u0440\u044f\u0437\u0435\u0432\u0430",
      "longitude":97.753441,
      "latitude":55.943954
    },
    "3774":{
      "name":"\u0413\u043e\u0440\u0435\u0432\u0430\u044f",
      "longitude":97.763092,
      "latitude":57.17701
    },
    "3775":{
      "name":"\u0421\u0435\u0440\u0433\u0438\u043d\u0430",
      "longitude":97.807602,
      "latitude":55.666451
    },
    "3776":{
      "name":"\u0421\u043e\u043b\u044f\u043d\u0430\u044f",
      "longitude":97.81839,
      "latitude":55.53397
    },
    "3777":{
      "name":"\u041f\u0435\u044f",
      "longitude":97.836357,
      "latitude":56.897892
    },
    "3778":{
      "name":"\u0427\u0435\u0440\u0447\u0435\u0442",
      "longitude":97.859726,
      "latitude":56.724964
    },
    "3779":{
      "name":"\u0411\u0438\u0440\u044e\u0441\u0430",
      "longitude":97.891251,
      "latitude":55.989468
    },
    "3780":{
      "name":"\u0411\u0435\u0440\u0435\u0437\u043e\u0432\u043a\u0430",
      "longitude":98.027908,
      "latitude":55.862331
    },
    "3781":{
      "name":"\u0422\u0440\u0435\u043c\u0438\u043d\u0430",
      "longitude":98.056694,
      "latitude":56.720852
    },
    "3782":{
      "name":"\u0421\u0442\u0430\u0440\u044b\u0439 \u0410\u043a\u0443\u043b\u044c\u0448\u0435\u0442",
      "longitude":98.069771,
      "latitude":56.015911
    },
    "3783":{
      "name":"\u041f\u043e\u043b\u0438\u043d\u0447\u0435\u0442",
      "longitude":98.109406,
      "latitude":57.346577
    },
    "3784":{
      "name":"\u0414\u0436\u043e\u0433\u0438\u043d\u043e",
      "longitude":98.162132,
      "latitude":56.647503
    },
    "3785":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":98.179672,
      "latitude":55.792164
    },
    "3786":{
      "name":"\u0415\u043b\u0430\u043d\u043a\u0430",
      "longitude":98.206055,
      "latitude":55.411625
    },
    "3787":{
      "name":"\u0410\u043b\u044b\u0433\u0434\u0436\u0435\u0440",
      "longitude":98.216751,
      "latitude":53.638992
    },
    "3788":{
      "name":"\u041d\u0438\u0436\u043d\u044f\u044f \u0417\u0430\u0438\u043c\u043a\u0430",
      "longitude":98.230812,
      "latitude":56.144611
    },
    "3789":{
      "name":"\u041d\u0435\u0440\u0445\u0430",
      "longitude":98.272202,
      "latitude":53.849503
    },
    "3790":{
      "name":"\u0411\u043e\u0440\u0438\u0441\u043e\u0432\u043e",
      "longitude":98.295174,
      "latitude":56.163815
    },
    "3791":{
      "name":"\u0428\u0438\u0442\u043a\u0438\u043d\u043e",
      "longitude":98.351799,
      "latitude":56.370895
    },
    "3792":{
      "name":"\u0411\u0443\u0437\u044b\u043a\u0430\u043d\u043e\u0432\u043e",
      "longitude":98.38266,
      "latitude":56.575027
    },
    "3793":{
      "name":"\u0420\u0430\u0437\u0433\u043e\u043d",
      "longitude":98.3882542,
      "latitude":55.7164029
    },
    "3794":{
      "name":"\u041f\u0443\u043b\u044f\u0435\u0432\u0430",
      "longitude":98.411445,
      "latitude":56.1672518
    },
    "3795":{
      "name":"\u041a\u0432\u0438\u0442\u043e\u043a",
      "longitude":98.4766571,
      "latitude":56.0757053
    },
    "3796":{
      "name":"\u041d\u0435\u0432\u0435\u043b\u044c\u0441\u043a\u0430\u044f",
      "longitude":98.5353653,
      "latitude":56.1186971
    },
    "3797":{
      "name":"\u0411\u0440\u0443\u0441\u043e\u0432\u043e",
      "longitude":98.54277,
      "latitude":57.206364
    },
    "3798":{
      "name":"\u0421\u0442\u0430\u0440\u044b\u0439 \u0410\u043b\u0437\u0430\u043c\u0430\u0439",
      "longitude":98.607155,
      "latitude":55.592758
    },
    "3799":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u043c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":98.607964,
      "latitude":55.4478
    },
    "3800":{
      "name":"\u0417\u0430\u043c\u0437\u043e\u0440",
      "longitude":98.649635,
      "latitude":55.37077
    },
    "3801":{
      "name":"\u0415\u043a\u0443\u043d\u0447\u0435\u0442",
      "longitude":98.65696,
      "latitude":57.077816
    },
    "3802":{
      "name":"\u041a\u0430\u043c\u044b\u0448\u0435\u0442",
      "longitude":98.79557,
      "latitude":55.2057
    },
    "3803":{
      "name":"\u041a\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":98.829536,
      "latitude":54.931534
    },
    "3804":{
      "name":"\u0423\u043a",
      "longitude":98.8598725,
      "latitude":55.0796891
    },
    "3805":{
      "name":"\u041a\u0443\u0440\u044f\u0442\u044b",
      "longitude":98.943245,
      "latitude":54.93972
    },
    "3806":{
      "name":"\u041f\u043e\u0434\u0433\u043e\u0440\u043d\u044b\u0439",
      "longitude":98.993065,
      "latitude":54.855701
    },
    "3807":{
      "name":"\u0411\u0443\u043d\u0431\u0443\u0439",
      "longitude":99.022583,
      "latitude":56.39061
    },
    "3808":{
      "name":"\u041f\u0430\u0440\u0447\u0443\u043c",
      "longitude":99.031776,
      "latitude":56.167034
    },
    "3809":{
      "name":"\u041c\u0435\u043b\u044c\u043d\u0438\u0446\u0430",
      "longitude":99.078537,
      "latitude":54.846825
    },
    "3810":{
      "name":"\u0420\u0443\u0431\u0430\u0445\u0438\u043d\u0430",
      "longitude":99.087715,
      "latitude":54.870121
    },
    "3811":{
      "name":"\u0412\u043e\u0437\u043d\u0435\u0441\u0435\u043d\u0441\u043a\u0438\u0439",
      "longitude":99.104095,
      "latitude":54.897758
    },
    "3812":{
      "name":"\u041a\u0430\u0442\u0430\u0440\u043c\u0430",
      "longitude":99.1052688,
      "latitude":55.6666398
    },
    "3813":{
      "name":"\u041a\u0430\u043c\u0435\u043d\u0441\u043a",
      "longitude":99.117363,
      "latitude":56.17572
    },
    "3814":{
      "name":"\u0428\u0443\u043c\u0441\u043a\u0438\u0439",
      "longitude":99.131134,
      "latitude":54.831242
    },
    "3815":{
      "name":"\u0417\u0430\u0432\u043e\u0434\u0441\u043a\u043e\u0439",
      "longitude":99.1790124,
      "latitude":56.1550689
    },
    "3816":{
      "name":"\u0421\u043e\u043b\u043e\u043d\u0446\u044b",
      "longitude":99.190849,
      "latitude":54.66901
    },
    "3817":{
      "name":"\u041d\u043e\u0432\u043e\u0431\u0430\u043b\u0442\u0443\u0440\u0438\u043d\u0430",
      "longitude":99.206848,
      "latitude":56.181107
    },
    "3818":{
      "name":"\u041f\u043e\u0440\u043e\u0433",
      "longitude":99.251122,
      "latitude":54.555862
    },
    "3819":{
      "name":"\u041d\u043e\u0432\u043e\u0447\u0443\u043d\u043a\u0430",
      "longitude":99.271118,
      "latitude":56.11293
    },
    "3820":{
      "name":"\u041f\u0438\u043e\u043d\u0435\u0440\u0441\u043a\u0438\u0439",
      "longitude":99.3559594,
      "latitude":56.0916508
    },
    "3821":{
      "name":"\u0425\u043e\u043d\u044f\u043a\u0438",
      "longitude":99.366508,
      "latitude":56.067703
    },
    "3822":{
      "name":"\u0427\u0435\u0445\u043e\u0432\u043e",
      "longitude":99.382545,
      "latitude":54.470417
    },
    "3823":{
      "name":"\u0410\u0442\u0430\u0433\u0430\u0439",
      "longitude":99.388611,
      "latitude":55.101635
    },
    "3824":{
      "name":"\u0428\u0438\u0440\u043e\u043a\u043e\u0432\u043e",
      "longitude":99.396248,
      "latitude":55.433296
    },
    "3825":{
      "name":"\u0417\u0430\u0440\u0435\u0447\u044c\u0435",
      "longitude":99.407772,
      "latitude":55.5323281
    },
    "3826":{
      "name":"\u0411\u0438\u0434\u043e\u0433\u0430",
      "longitude":99.452141,
      "latitude":56.053963
    },
    "3827":{
      "name":"\u041c\u0443\u0445\u0438\u043d\u043e",
      "longitude":99.501274,
      "latitude":55.820286
    },
    "3828":{
      "name":"\u041a\u043e\u0441\u0442\u0438\u043d\u043e",
      "longitude":99.52066,
      "latitude":55.616886
    },
    "3829":{
      "name":"\u0427\u0435\u0440\u0432\u044f\u043d\u043a\u0430",
      "longitude":99.546501,
      "latitude":57.656265
    },
    "3830":{
      "name":"\u041f\u0430\u0440\u0435\u043d\u0434\u0430",
      "longitude":99.576599,
      "latitude":55.927601
    },
    "3831":{
      "name":"\u0412\u0435\u0441\u0451\u043b\u044b\u0439",
      "longitude":99.589111,
      "latitude":55.934856
    },
    "3832":{
      "name":"\u0425\u0443\u0434\u043e\u0435\u043b\u0430\u043d\u0441\u043a\u043e\u0435",
      "longitude":99.640022,
      "latitude":54.703819
    },
    "3833":{
      "name":"\u041a\u0430\u0442\u0430\u0440\u0431\u0435\u0439",
      "longitude":99.68351,
      "latitude":54.368462
    },
    "3834":{
      "name":"\u0418\u0448\u0438\u0434\u0435\u0439",
      "longitude":99.717751,
      "latitude":54.121017
    },
    "3835":{
      "name":"\u0418\u0437\u044b\u043a\u0430\u043d",
      "longitude":99.769447,
      "latitude":56.127575
    },
    "3836":{
      "name":"\u0412\u0435\u0440\u0448\u0438\u043d\u0430",
      "longitude":99.816895,
      "latitude":54.628647
    },
    "3837":{
      "name":"\u0428\u0435\u0431\u0435\u0440\u0442\u0430",
      "longitude":99.848778,
      "latitude":54.622334
    },
    "3838":{
      "name":"\u0428\u0435\u0431\u0435\u0440\u0442\u0430",
      "longitude":99.88401,
      "latitude":54.64365
    },
    "3839":{
      "name":"\u0414\u0430\u0443\u0440",
      "longitude":99.890221,
      "latitude":54.753757
    },
    "3840":{
      "name":"\u0410\u0440\u0448\u0430\u043d",
      "longitude":99.91507,
      "latitude":53.931004
    },
    "3841":{
      "name":"\u0422\u0430\u0440\u0433\u0438\u0437",
      "longitude":99.957504,
      "latitude":56.168278
    },
    "3842":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0439 \u0411\u0443\u0440\u0431\u0443\u043a",
      "longitude":99.980865,
      "latitude":54.258102
    },
    "3843":{
      "name":"\u0418\u0440\u0433\u0435\u0439",
      "longitude":99.995773,
      "latitude":54.558327
    },
    "3844":{
      "name":"\u0418\u043a\u0435\u0439",
      "longitude":100.078819,
      "latitude":54.191528
    },
    "3845":{
      "name":"\u0418\u0437\u0435\u0433\u043e\u043b",
      "longitude":100.122345,
      "latitude":54.310204
    },
    "3846":{
      "name":"\u0411\u0443\u0434\u0430\u0433\u043e\u0432\u043e",
      "longitude":100.131393,
      "latitude":54.626862
    },
    "3847":{
      "name":"\u0410\u043b\u0433\u0430\u0442\u0443\u0439",
      "longitude":100.195076,
      "latitude":54.394363
    },
    "3848":{
      "name":"\u0423\u043c\u044b\u0433\u0430\u043d",
      "longitude":100.226196,
      "latitude":54.752075
    },
    "3849":{
      "name":"\u0415\u0434\u043e\u0433\u043e\u043d",
      "longitude":100.237511,
      "latitude":54.253338
    },
    "3850":{
      "name":"\u0421\u043e\u0441\u043d\u043e\u0432\u043a\u0430",
      "longitude":100.24057,
      "latitude":56.126873
    },
    "3851":{
      "name":"\u041c\u0443\u0433\u0443\u043d",
      "longitude":100.249489,
      "latitude":54.471943
    },
    "3852":{
      "name":"\u0412\u043b\u0430\u0434\u0438\u043c\u0438\u0440\u043e\u0432\u043a\u0430",
      "longitude":100.3069,
      "latitude":54.174667
    },
    "3853":{
      "name":"\u0423\u0442\u0430\u0439",
      "longitude":100.317459,
      "latitude":54.637779
    },
    "3854":{
      "name":"\u0411\u0443\u043b\u044e\u0448\u043a\u0438\u043d\u0430",
      "longitude":100.399368,
      "latitude":54.582111
    },
    "3855":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u0430\u044f \u0414\u0443\u0431\u0440\u0430\u0432\u0430",
      "longitude":100.409599,
      "latitude":54.666004
    },
    "3856":{
      "name":"\u041a\u043e\u0442\u0438\u043a",
      "longitude":100.45549,
      "latitude":54.649178
    },
    "3857":{
      "name":"\u041f\u0435\u0440\u0444\u0438\u043b\u043e\u0432\u043e",
      "longitude":100.485413,
      "latitude":54.408112
    },
    "3858":{
      "name":"\u0421\u0438\u0431\u0438\u0440\u044f\u043a",
      "longitude":100.509789,
      "latitude":54.721199
    },
    "3859":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0439 \u041c\u0430\u043d\u0443\u0442",
      "longitude":100.527519,
      "latitude":54.466053
    },
    "3860":{
      "name":"\u0423\u0441\u0442\u044c-\u041a\u0443\u043b\u044c\u0441\u043a",
      "longitude":100.572281,
      "latitude":54.881248
    },
    "3861":{
      "name":"\u041a\u0430\u0440\u0434\u043e\u0439",
      "longitude":100.581085,
      "latitude":55.212307
    },
    "3862":{
      "name":"\u0423\u0439\u0433\u0430\u0442",
      "longitude":100.592644,
      "latitude":54.081966
    },
    "3863":{
      "name":"\u0411\u0430\u0434\u0430\u0440",
      "longitude":100.600601,
      "latitude":54.396923
    },
    "3864":{
      "name":"\u0410\u0444\u0430\u043d\u0430\u0441\u044c\u0435\u0432\u0430",
      "longitude":100.61718,
      "latitude":54.639477
    },
    "3865":{
      "name":"\u0426\u0435\u043b\u0438\u043d\u043d\u044b\u0435 \u0417\u0435\u043c\u043b\u0438",
      "longitude":100.62854,
      "latitude":54.69915
    },
    "3866":{
      "name":"\u0413\u0443\u0440\u0430\u043d",
      "longitude":100.64447,
      "latitude":54.760704
    },
    "3867":{
      "name":"\u0415\u0440\u043c\u0430\u043a\u0438",
      "longitude":100.655853,
      "latitude":54.636894
    },
    "3868":{
      "name":"\u0415\u0432\u0434\u043e\u043a\u0438\u043c\u043e\u0432\u0430",
      "longitude":100.656883,
      "latitude":54.275639
    },
    "3869":{
      "name":"\u0418\u043b\u0438\u0440",
      "longitude":100.679825,
      "latitude":55.223484
    },
    "3870":{
      "name":"\u041f\u0440\u0438\u0431\u0440\u0435\u0436\u043d\u044b\u0439",
      "longitude":100.682037,
      "latitude":55.207047
    },
    "3871":{
      "name":"\u041d\u0438\u043a\u0438\u0442\u0430\u0435\u0432\u043e",
      "longitude":100.693245,
      "latitude":54.63261
    },
    "3872":{
      "name":"\u0422\u044d\u043c\u044c",
      "longitude":100.732552,
      "latitude":55.33279
    },
    "3873":{
      "name":"\u0413\u0430\u0434\u0430\u043b\u0435\u0439",
      "longitude":100.737839,
      "latitude":54.405487
    },
    "3874":{
      "name":"\u0410\u0437\u0435\u0439",
      "longitude":100.7681115,
      "latitude":54.5094862
    },
    "3875":{
      "name":"\u0411\u0430\u0440\u0447\u0438\u043c",
      "longitude":100.798897,
      "latitude":55.368851
    },
    "3876":{
      "name":"\u0411\u0443\u0440\u0445\u0443\u043d",
      "longitude":100.825851,
      "latitude":54.823437
    },
    "3877":{
      "name":"\u0425\u0443\u0434\u043e\u0431\u043e\u043a",
      "longitude":100.866714,
      "latitude":55.470188
    },
    "3878":{
      "name":"\u0422\u0443\u0440\u043c\u0430",
      "longitude":100.886108,
      "latitude":56.193722
    },
    "3879":{
      "name":"\u0428\u0443\u0431\u0430",
      "longitude":100.898682,
      "latitude":54.447048
    },
    "3880":{
      "name":"\u0428\u0435\u0440\u0430\u0433\u0443\u043b",
      "longitude":100.910881,
      "latitude":54.461205
    },
    "3881":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":100.922203,
      "latitude":55.424618
    },
    "3882":{
      "name":"\u0410\u043b\u044c\u0431\u0438\u043d",
      "longitude":100.949966,
      "latitude":54.963291
    },
    "3883":{
      "name":"\u041e\u043a\u0442\u044f\u0431\u0440\u044c\u0441\u043a\u0438\u0439-2",
      "longitude":100.975662,
      "latitude":54.901703
    },
    "3884":{
      "name":"\u0422\u0430\u043d\u0433\u0443\u0439",
      "longitude":101.034973,
      "latitude":55.382172
    },
    "3885":{
      "name":"\u041f\u043e\u043a\u043e\u0441\u043d\u043e\u0435",
      "longitude":101.051109,
      "latitude":55.522079
    },
    "3886":{
      "name":"\u041d\u043e\u0432\u043e\u0435 \u041f\u0440\u0438\u0440\u0435\u0447\u044c\u0435",
      "longitude":101.060829,
      "latitude":55.078537
    },
    "3887":{
      "name":"\u0421\u043e\u0441\u043d\u043e\u0432\u044b\u0439",
      "longitude":101.093002,
      "latitude":55.543449
    },
    "3888":{
      "name":"\u041a\u0430\u0440\u0430\u0437\u0435\u0439",
      "longitude":101.112846,
      "latitude":54.360008
    },
    "3889":{
      "name":"\u0410\u043c\u0443\u0440",
      "longitude":101.118279,
      "latitude":54.215088
    },
    "3890":{
      "name":"\u0423\u0445\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":101.125244,
      "latitude":54.406502
    },
    "3891":{
      "name":"\u0414\u043e\u0431\u0447\u0443\u0440",
      "longitude":101.149712,
      "latitude":55.342484
    },
    "3892":{
      "name":"\u0422\u0443\u043b\u044e\u0448\u043a\u0430",
      "longitude":101.157021,
      "latitude":54.464375
    },
    "3893":{
      "name":"\u0422\u0443\u043b\u044e\u0448\u043a\u0430",
      "longitude":101.178055,
      "latitude":54.454567
    },
    "3894":{
      "name":"\u0411\u0430\u043c\u0431\u0443\u0439",
      "longitude":101.205025,
      "latitude":56.097321
    },
    "3895":{
      "name":"\u041a\u0443\u0437\u043d\u0435\u0446\u043e\u0432\u043a\u0430",
      "longitude":101.239784,
      "latitude":56.086643
    },
    "3896":{
      "name":"\u0427\u0435\u0431\u043e\u0442\u0430\u0440\u0438\u0445\u0430",
      "longitude":101.240768,
      "latitude":54.381275
    },
    "3897":{
      "name":"\u041a\u0443\u043d\u0434\u0443\u0439",
      "longitude":101.266533,
      "latitude":54.339046
    },
    "3898":{
      "name":"\u0422\u0430\u0440\u043c\u0430",
      "longitude":101.293152,
      "latitude":55.980961
    },
    "3899":{
      "name":"\u0421\u0435\u0434\u0430\u043d\u043e\u0432\u043e",
      "longitude":101.309441,
      "latitude":56.980728
    },
    "3900":{
      "name":"\u0417\u0443\u043b\u0443\u043c\u0430\u0439",
      "longitude":101.319046,
      "latitude":53.688736
    },
    "3901":{
      "name":"\u041b\u0435\u0440\u043c\u043e\u043d\u0442\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":101.363464,
      "latitude":54.303246
    },
    "3902":{
      "name":"\u041a\u043e\u0431\u044c",
      "longitude":101.373009,
      "latitude":55.432377
    },
    "3903":{
      "name":"\u041a\u043e\u0431\u043b\u044f\u043a\u043e\u0432\u043e",
      "longitude":101.434746,
      "latitude":56.587486
    },
    "3904":{
      "name":"\u0410\u043b\u043a\u0438\u043d",
      "longitude":101.443024,
      "latitude":54.48835
    },
    "3905":{
      "name":"\u0421\u0430\u0445\u0430\u0440\u043e\u0432\u043e",
      "longitude":101.484322,
      "latitude":56.500397
    },
    "3906":{
      "name":"\u041b\u0435\u043e\u043d\u043e\u0432\u0430",
      "longitude":101.525055,
      "latitude":55.570152
    },
    "3907":{
      "name":"\u0421\u0442\u0435\u043d\u0438\u0445\u0430",
      "longitude":101.5302195,
      "latitude":56.1995493
    },
    "3908":{
      "name":"\u0411\u0430\u0441\u0430\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":101.546066,
      "latitude":53.78334
    },
    "3909":{
      "name":"\u0425\u043e\u0440-\u0422\u0430\u0433\u043d\u0430",
      "longitude":101.549599,
      "latitude":53.418232
    },
    "3910":{
      "name":"\u041d\u043e\u0432\u043e\u0434\u043e\u043b\u043e\u043d\u043e\u0432\u043e",
      "longitude":101.556442,
      "latitude":55.848602
    },
    "3911":{
      "name":"\u0411\u0443\u0440\u0443\u043a",
      "longitude":101.559204,
      "latitude":54.511364
    },
    "3912":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u041a\u0430\u0448\u0435\u043b\u0430\u043a",
      "longitude":101.560181,
      "latitude":54.07011
    },
    "3913":{
      "name":"\u041c\u0438\u043d\u0433\u0430\u0442\u0443\u0439",
      "longitude":101.564636,
      "latitude":54.735386
    },
    "3914":{
      "name":"\u0411\u0443\u0440\u043d\u0438\u043d\u0441\u043a\u0430\u044f \u0412\u0438\u0445\u043e\u0440\u044f",
      "longitude":101.595863,
      "latitude":56.364792
    },
    "3915":{
      "name":"\u0425\u0430\u0440\u0438\u043a",
      "longitude":101.617957,
      "latitude":54.1801438
    },
    "3916":{
      "name":"\u0411\u0430\u0442\u0430\u043c\u0430",
      "longitude":101.624802,
      "latitude":53.8717
    },
    "3917":{
      "name":"\u0410\u043d\u0434\u0440\u044e\u0448\u0438\u043d\u043e",
      "longitude":101.633698,
      "latitude":54.363422
    },
    "3918":{
      "name":"\u0427\u0435\u0440\u0435\u043c\u0448\u0430\u043d\u043a\u0430",
      "longitude":101.649506,
      "latitude":53.285324
    },
    "3919":{
      "name":"\u041f\u043e\u0434\u044a\u0435\u043b\u0430\u043d\u043a\u0430",
      "longitude":101.651772,
      "latitude":57.087006
    },
    "3920":{
      "name":"\u0425\u0430\u0440\u0438\u043a",
      "longitude":101.6640015,
      "latitude":54.242396
    },
    "3921":{
      "name":"\u041f\u043e\u0440\u043e\u0436\u0441\u043a\u0438\u0439",
      "longitude":101.672607,
      "latitude":56.085613
    },
    "3922":{
      "name":"\u041b\u0435\u043d\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":101.680862,
      "latitude":54.088623
    },
    "3923":{
      "name":"\u041a\u043b\u044e\u0447\u0438-\u0411\u0443\u043b\u0430\u043a",
      "longitude":101.682663,
      "latitude":55.523014
    },
    "3924":{
      "name":"\u041c\u0430\u0441\u043b\u044f\u043d\u043e\u0433\u043e\u0440\u0441\u043a",
      "longitude":101.693863,
      "latitude":53.570919
    },
    "3925":{
      "name":"\u0421\u0430\u0434\u043e\u0432\u044b\u0439",
      "longitude":101.70694,
      "latitude":54.197208
    },
    "3926":{
      "name":"\u0411\u0430\u0440\u043b\u0443\u043a",
      "longitude":101.723244,
      "latitude":54.536263
    },
    "3927":{
      "name":"\u041a\u0430\u043b\u0442\u0443\u043a",
      "longitude":101.736954,
      "latitude":55.677616
    },
    "3928":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0435\u043e\u043a\u0438\u043d\u0441\u043a\u043e\u0435",
      "longitude":101.742897,
      "latitude":55.74287
    },
    "3929":{
      "name":"\u0418\u0433\u043d\u0438\u043d\u043e",
      "longitude":101.754646,
      "latitude":54.088028
    },
    "3930":{
      "name":"\u041a\u0443\u043c\u0435\u0439\u043a\u0430",
      "longitude":101.77755,
      "latitude":55.536179
    },
    "3931":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u0442\u0440\u043e\u0439\u043a\u0430",
      "longitude":101.8260917,
      "latitude":52.9797658
    },
    "3932":{
      "name":"\u041d\u043e\u0432\u043e\u043b\u0435\u0442\u043d\u0438\u043a\u0438",
      "longitude":101.843872,
      "latitude":53.616024
    },
    "3933":{
      "name":"\u0426\u0435\u043d\u0442\u0440\u0430\u043b\u044c\u043d\u044b\u0439 \u0425\u0430\u0437\u0430\u043d",
      "longitude":101.8577188,
      "latitude":53.8936522
    },
    "3934":{
      "name":"\u041a\u0430\u0440\u044b\u043c\u0441\u043a",
      "longitude":101.858429,
      "latitude":54.104836
    },
    "3935":{
      "name":"\u0425\u0430\u0440\u0430\u043d\u0436\u0438\u043d\u043e",
      "longitude":101.888435,
      "latitude":55.400692
    },
    "3936":{
      "name":"\u0422\u0430\u0433\u043d\u0430",
      "longitude":101.888924,
      "latitude":53.589287
    },
    "3937":{
      "name":"\u041a\u0443\u0432\u0430\u0442\u043a\u0430",
      "longitude":101.961838,
      "latitude":55.499912
    },
    "3938":{
      "name":"\u041a\u0438\u043c\u0438\u043b\u044c\u0442\u0435\u0439",
      "longitude":101.9636,
      "latitude":54.13253
    },
    "3939":{
      "name":"\u0421\u0443\u0445\u043e\u0439",
      "longitude":101.9693515,
      "latitude":56.2578832
    },
    "3940":{
      "name":"\u0423\u0441\u043b\u043e\u043d",
      "longitude":101.970596,
      "latitude":53.931408
    },
    "3941":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u0422\u0435\u043b\u044c\u0431\u0430",
      "longitude":101.991493,
      "latitude":54.77993
    },
    "3942":{
      "name":"\u0423\u044f\u043d",
      "longitude":101.996315,
      "latitude":54.344711
    },
    "3943":{
      "name":"\u0421\u0430\u043c\u0430\u0440\u0430",
      "longitude":102.010262,
      "latitude":53.850513
    },
    "3944":{
      "name":"\u041c\u043e\u0438\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":102.011177,
      "latitude":53.526173
    },
    "3945":{
      "name":"\u0423\u0441\u0442\u044c-\u041a\u0430\u0434\u0430",
      "longitude":102.014137,
      "latitude":54.50058
    },
    "3946":{
      "name":"\u041f\u0435\u0440\u0435\u0432\u043e\u0437",
      "longitude":102.041805,
      "latitude":54.1069614
    },
    "3947":{
      "name":"\u041e\u043d\u043e\u0442",
      "longitude":102.051758,
      "latitude":52.738377
    },
    "3948":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u042f\u0440",
      "longitude":102.052689,
      "latitude":54.385429
    },
    "3949":{
      "name":"\u0411\u0430\u0440\u0433\u0430\u0434\u0430\u0439",
      "longitude":102.056564,
      "latitude":54.199245
    },
    "3950":{
      "name":"\u041d\u0430\u0440\u0430\u0442\u0430\u0439",
      "longitude":102.057121,
      "latitude":55.025089
    },
    "3951":{
      "name":"\u0423\u0445\u0442\u0443\u0439",
      "longitude":102.075218,
      "latitude":53.953384
    },
    "3952":{
      "name":"\u041f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":102.080872,
      "latitude":53.877644
    },
    "3953":{
      "name":"\u041c\u043e\u0440\u0434\u0438\u043d\u043e",
      "longitude":102.084167,
      "latitude":53.980991
    },
    "3954":{
      "name":"\u041e\u0437\u0451\u0440\u043d\u044b\u0439",
      "longitude":102.085129,
      "latitude":55.876957
    },
    "3955":{
      "name":"\u0411\u0430\u0431\u0430\u0433\u0430\u0439",
      "longitude":102.101654,
      "latitude":53.27319
    },
    "3956":{
      "name":"\u0417\u044f\u0431\u0430",
      "longitude":102.1248752,
      "latitude":56.3784046
    },
    "3957":{
      "name":"\u041d\u043e\u0440\u044b",
      "longitude":102.13018,
      "latitude":53.961788
    },
    "3958":{
      "name":"\u042d\u0434\u0443\u0447\u0430\u043d\u043a\u0430",
      "longitude":102.149864,
      "latitude":57.364388
    },
    "3959":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u0417\u0430\u0438\u043c\u043a\u0430",
      "longitude":102.152016,
      "latitude":53.546452
    },
    "3960":{
      "name":"\u0422\u0440\u043e\u0438\u0446\u043a",
      "longitude":102.16494,
      "latitude":53.466053
    },
    "3961":{
      "name":"\u0411\u043e\u0440\u043e\u0432\u0441\u043a\u043e\u0439",
      "longitude":102.168732,
      "latitude":56.489738
    },
    "3962":{
      "name":"\u041f\u0430\u043d\u0430\u0433\u0438\u043d\u043e",
      "longitude":102.194244,
      "latitude":54.633091
    },
    "3963":{
      "name":"\u0412\u0435\u0440\u0435\u043d\u043a\u0430",
      "longitude":102.220886,
      "latitude":53.687454
    },
    "3964":{
      "name":"\u0410\u043b\u044f\u0442\u044b",
      "longitude":102.224495,
      "latitude":53.212936
    },
    "3965":{
      "name":"\u0425\u0430\u0440\u0430\u0439\u0433\u0443\u043d",
      "longitude":102.225105,
      "latitude":54.066307
    },
    "3966":{
      "name":"\u0421\u043e\u0440\u0442\u044b",
      "longitude":102.227203,
      "latitude":53.473728
    },
    "3967":{
      "name":"\u0415\u0440\u0448\u043e\u0432\u043e",
      "longitude":102.236855,
      "latitude":57.149803
    },
    "3968":{
      "name":"\u0425\u0430\u043d\u0436\u0438\u043d\u043e\u0432\u043e",
      "longitude":102.240112,
      "latitude":53.619801
    },
    "3969":{
      "name":"\u041c\u043e\u0439\u0433\u0430\u043d",
      "longitude":102.241623,
      "latitude":53.341774
    },
    "3970":{
      "name":"\u0421\u0430\u044f\u043d\u0441\u043a\u043e\u0435",
      "longitude":102.255501,
      "latitude":53.075642
    },
    "3971":{
      "name":"\u0411\u0443\u0440\u044f",
      "longitude":102.295441,
      "latitude":54.274807
    },
    "3972":{
      "name":"\u0425\u043e\u043b\u043c\u043e\u0433\u043e\u0439",
      "longitude":102.303017,
      "latitude":53.489853
    },
    "3973":{
      "name":"\u0422\u044b\u0440\u0435\u0442\u044c 1-\u044f",
      "longitude":102.308937,
      "latitude":53.673069
    },
    "3974":{
      "name":"\u0422\u044b\u043d\u043a\u043e\u0431\u044c",
      "longitude":102.316589,
      "latitude":55.413361
    },
    "3975":{
      "name":"\u0422\u044b\u0440\u0435\u0442\u044c 2-\u044f",
      "longitude":102.319092,
      "latitude":53.721817
    },
    "3976":{
      "name":"\u0424\u0438\u043b\u0438\u043f\u043f\u043e\u0432\u0441\u043a",
      "longitude":102.322441,
      "latitude":53.951824
    },
    "3977":{
      "name":"\u041d\u0430\u0440\u0430\u0442\u0430\u0439",
      "longitude":102.32666,
      "latitude":56.126045
    },
    "3978":{
      "name":"\u0418\u0432\u0430\u043d\u0438\u0447\u0435\u0441\u043a\u043e\u0435",
      "longitude":102.3380041,
      "latitude":53.1992856
    },
    "3979":{
      "name":"\u041e\u0442\u0440\u0430\u0434\u043d\u0430\u044f",
      "longitude":102.3515091,
      "latitude":53.2407884
    },
    "3980":{
      "name":"\u0420\u043e\u043c\u0430\u043d\u0435\u043d\u043a\u0438\u043d\u0430",
      "longitude":102.353104,
      "latitude":53.394627
    },
    "3981":{
      "name":"\u0413\u043e\u043b\u0443\u043c\u0435\u0442\u044c",
      "longitude":102.365631,
      "latitude":53.043526
    },
    "3982":{
      "name":"\u0411\u0430\u0434\u0430\u0440\u043c\u0438\u043d\u0441\u043a",
      "longitude":102.383209,
      "latitude":57.767334
    },
    "3983":{
      "name":"\u0421\u043f\u043b\u0430\u0432\u043d\u0430\u044f",
      "longitude":102.4115868,
      "latitude":52.7714993
    },
    "3984":{
      "name":"\u0422\u0430\u043b\u044c\u043d\u0438\u043a\u0438",
      "longitude":102.412865,
      "latitude":52.780735
    },
    "3985":{
      "name":"\u0411\u0443\u0440\u044f\u0442\u0441\u043a\u0430\u044f",
      "longitude":102.4375,
      "latitude":53.354591
    },
    "3986":{
      "name":"\u041a\u0435\u0436\u0435\u043c\u0441\u043a\u0438\u0439",
      "longitude":102.43856,
      "latitude":56.55991
    },
    "3987":{
      "name":"\u041d\u043e\u0432\u043e\u0447\u0435\u0440\u0435\u043c\u0445\u043e\u0432\u043e",
      "longitude":102.46447,
      "latitude":53.400261
    },
    "3988":{
      "name":"\u041a\u0443\u0439\u0442\u0430",
      "longitude":102.472908,
      "latitude":53.815445
    },
    "3989":{
      "name":"\u041d\u0438\u0436\u043d\u044f\u044f \u0418\u0440\u0435\u0442\u044c",
      "longitude":102.488068,
      "latitude":52.987518
    },
    "3990":{
      "name":"\u0421\u0435\u043c\u0435\u043d\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":102.503681,
      "latitude":53.7281151
    },
    "3991":{
      "name":"\u0417\u043e\u043d\u044b",
      "longitude":102.539146,
      "latitude":53.316158
    },
    "3992":{
      "name":"\u0410\u043b\u0430\u0440\u044c",
      "longitude":102.5419388,
      "latitude":53.0692156
    },
    "3993":{
      "name":"\u0411\u0430\u0436\u0438\u0440",
      "longitude":102.547386,
      "latitude":53.589699
    },
    "3994":{
      "name":"\u0428\u0430\u0440\u0430\u0442\u044b",
      "longitude":102.571022,
      "latitude":53.825382
    },
    "3995":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0435\u0431\u0430\u044f\u043d\u043e\u0432\u0441\u043a\u0430\u044f",
      "longitude":102.581902,
      "latitude":53.903168
    },
    "3996":{
      "name":"\u0422\u0430\u043d\u0433\u0443\u0442\u044b",
      "longitude":102.590889,
      "latitude":53.771774
    },
    "3997":{
      "name":"\u0426\u0435\u043b\u0438\u043d\u043d\u044b\u0439",
      "longitude":102.59343,
      "latitude":53.641693
    },
    "3998":{
      "name":"\u0418\u0440\u043a\u0443\u0442\u0441\u043a-45",
      "longitude":102.6183964,
      "latitude":53.4223441
    },
    "3999":{
      "name":"\u0412\u043b\u0430\u0434\u0438\u043c\u0438\u0440",
      "longitude":102.654579,
      "latitude":53.47488
    },
    "4000":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u0441\u043a",
      "longitude":102.659027,
      "latitude":53.341831
    },
    "4001":{
      "name":"\u041c\u0430\u043c\u044b\u0440\u044c",
      "longitude":102.659042,
      "latitude":56.581013
    },
    "4002":{
      "name":"\u0417\u0430\u0440\u0435\u0447\u043d\u044b\u0439",
      "longitude":102.674767,
      "latitude":53.682514
    },
    "4003":{
      "name":"\u041d\u044b\u0433\u0434\u0430",
      "longitude":102.6843834,
      "latitude":53.0170964
    },
    "4004":{
      "name":"\u0418\u0434\u0435\u0430\u043b",
      "longitude":102.693001,
      "latitude":53.160336
    },
    "4005":{
      "name":"\u0425\u0430\u0440\u0451\u0442\u044b",
      "longitude":102.71949,
      "latitude":53.820587
    },
    "4006":{
      "name":"\u041d\u0435\u0432\u043e\u043d",
      "longitude":102.724205,
      "latitude":58.054462
    },
    "4007":{
      "name":"\u0422\u0430\u0442\u0445\u0430\u043b-\u041e\u043d\u0433\u043e\u0439",
      "longitude":102.728485,
      "latitude":53.695568
    },
    "4008":{
      "name":"\u041c\u0430\u043d\u0438\u043b\u043e\u0432\u0441\u043a\u0430\u044f",
      "longitude":102.7361196,
      "latitude":53.4995983
    },
    "4009":{
      "name":"\u0422\u0430\u0440\u043d\u043e\u043f\u043e\u043b\u044c",
      "longitude":102.768257,
      "latitude":54.047421
    },
    "4010":{
      "name":"\u0414\u0430\u043b\u044c\u043d\u0438\u0439",
      "longitude":102.789879,
      "latitude":57.356705
    },
    "4011":{
      "name":"\u0422\u0443\u043d\u0433\u0443\u0441\u043a\u0430",
      "longitude":102.794365,
      "latitude":52.646187
    },
    "4012":{
      "name":"\u041d\u0443\u043a\u0443\u0442\u044b",
      "longitude":102.804146,
      "latitude":53.718685
    },
    "4013":{
      "name":"\u041d\u0435\u043d\u044b",
      "longitude":102.808151,
      "latitude":53.093803
    },
    "4014":{
      "name":"\u041a\u0435\u0443\u043b\u044c",
      "longitude":102.809959,
      "latitude":58.434563
    },
    "4015":{
      "name":"\u0428\u0430\u0440\u0430\u0433\u0443\u043b",
      "longitude":102.8197244,
      "latitude":53.947887
    },
    "4016":{
      "name":"\u0417\u0430\u0431\u0438\u0442\u0443\u0439",
      "longitude":102.830383,
      "latitude":53.277187
    },
    "4017":{
      "name":"\u0412\u043e\u0440\u043e\u0442-\u041e\u043d\u0433\u043e\u0439",
      "longitude":102.83075,
      "latitude":53.66222
    },
    "4018":{
      "name":"\u041d\u043e\u0432\u043e\u043b\u0435\u043d\u0438\u043d\u043e",
      "longitude":102.841759,
      "latitude":53.813335
    },
    "4019":{
      "name":"\u041f\u0430\u0440\u0444\u0435\u043d\u043e\u0432\u043e",
      "longitude":102.846817,
      "latitude":52.991405
    },
    "4020":{
      "name":"\u041c\u0435\u0442\u043b\u044f\u0435\u0432\u0430",
      "longitude":102.852898,
      "latitude":54.123158
    },
    "4021":{
      "name":"\u041c\u043e\u0433\u043e\u0451\u043d\u043e\u043a",
      "longitude":102.8656509,
      "latitude":53.3926133
    },
    "4022":{
      "name":"\u0420\u0435\u0447\u0443\u0448\u043a\u0430",
      "longitude":102.870552,
      "latitude":56.530998
    },
    "4023":{
      "name":"\u041c\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":102.872719,
      "latitude":53.219189
    },
    "4024":{
      "name":"\u041b\u043e\u0445\u043e\u0432\u043e",
      "longitude":102.890854,
      "latitude":53.053963
    },
    "4025":{
      "name":"\u0411\u0438\u0440\u0438\u0442",
      "longitude":102.902298,
      "latitude":54.06955
    },
    "4026":{
      "name":"\u0422\u0430\u0431\u0430\u0440\u0441\u0443\u043a",
      "longitude":102.9099651,
      "latitude":53.4377725
    },
    "4027":{
      "name":"\u0410\u043b\u0442\u0430\u0440\u0438\u043a",
      "longitude":102.923538,
      "latitude":53.485115
    },
    "4028":{
      "name":"\u0416\u043c\u0443\u0440\u043e\u0432\u0430",
      "longitude":102.924294,
      "latitude":53.133961
    },
    "4029":{
      "name":"\u041a\u043e\u0437\u043b\u043e\u0432\u0430",
      "longitude":102.934654,
      "latitude":53.033672
    },
    "4030":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u0421\u0443\u0445\u0430\u044f",
      "longitude":102.9462133,
      "latitude":53.4731383
    },
    "4031":{
      "name":"\u041d\u043e\u0432\u043e\u0433\u0440\u043e\u043c\u043e\u0432\u043e",
      "longitude":102.959656,
      "latitude":53.180691
    },
    "4032":{
      "name":"\u0417\u0430\u0441\u043b\u0430\u0432\u0441\u043a\u0430\u044f",
      "longitude":102.968651,
      "latitude":54.218609
    },
    "4033":{
      "name":"\u041e\u043a\u0442\u044f\u0431\u0440\u044c\u0441\u043a\u0438\u0439",
      "longitude":102.981071,
      "latitude":52.413078
    },
    "4034":{
      "name":"\u041a\u0443\u043c\u0430\u0440\u0435\u0439\u043a\u0430",
      "longitude":102.985222,
      "latitude":54.477516
    },
    "4035":{
      "name":"\u0428\u0443\u043c\u0438\u043b\u043e\u0432\u043e",
      "longitude":103.010559,
      "latitude":55.948437
    },
    "4036":{
      "name":"\u0415\u0433\u043e\u0440\u043e\u0432\u0441\u043a\u0430\u044f",
      "longitude":103.016266,
      "latitude":53.303528
    },
    "4037":{
      "name":"\u0420\u044b\u0441\u0435\u0432\u043e",
      "longitude":103.018036,
      "latitude":53.20351
    },
    "4038":{
      "name":"\u0417\u0430\u043a\u0443\u043b\u0435\u0439",
      "longitude":103.031242,
      "latitude":53.690289
    },
    "4039":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u0411\u0443\u043b\u0430\u0439",
      "longitude":103.039993,
      "latitude":53.032913
    },
    "4040":{
      "name":"\u0428\u0430\u0440\u0430\u0433\u0430\u0439",
      "longitude":103.067802,
      "latitude":54.327625
    },
    "4041":{
      "name":"\u041a\u043e\u043d\u043e\u0432\u0430\u043b\u043e\u0432\u043e",
      "longitude":103.070488,
      "latitude":53.983513
    },
    "4042":{
      "name":"\u0411\u0435\u043b\u043e\u0431\u043e\u0440\u043e\u0434\u043e\u0432\u0430",
      "longitude":103.075027,
      "latitude":53.220524
    },
    "4043":{
      "name":"\u0411\u0435\u043b\u044c\u0441\u043a",
      "longitude":103.080444,
      "latitude":52.868198
    },
    "4044":{
      "name":"\u0410\u0442\u0430\u043b\u0430\u043d\u043a\u0430",
      "longitude":103.085815,
      "latitude":54.832138
    },
    "4045":{
      "name":"\u0410\u043f\u0445\u0443\u043b\u044c\u0442\u0430",
      "longitude":103.0910395,
      "latitude":53.3436653
    },
    "4046":{
      "name":"\u041a\u0430\u0439\u043c\u043e\u043d\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":103.097481,
      "latitude":56.381199
    },
    "4047":{
      "name":"\u0411\u0430\u0445\u0442\u0430\u0439",
      "longitude":103.107544,
      "latitude":53.503895
    },
    "4048":{
      "name":"\u0412\u0438\u0434\u0438\u043c",
      "longitude":103.108955,
      "latitude":56.40934
    },
    "4049":{
      "name":"\u0427\u0438\u0441\u0442\u043e\u043f\u043e\u043b\u044f\u043d\u0441\u043a\u0438\u0439",
      "longitude":103.114693,
      "latitude":56.384834
    },
    "4050":{
      "name":"\u041c\u0435\u043b\u044c\u0445\u0438\u0442\u0443\u0439",
      "longitude":103.1258376,
      "latitude":53.6525542
    },
    "4051":{
      "name":"\u041d\u0435\u043b\u044c\u0445\u0430\u0439",
      "longitude":103.1303437,
      "latitude":53.3576861
    },
    "4052":{
      "name":"\u0421\u0432\u0435\u0442\u043b\u043e\u043b\u043e\u0431\u043e\u0432\u043e",
      "longitude":103.131607,
      "latitude":54.283699
    },
    "4053":{
      "name":"\u0410\u043b\u0435\u0445\u0438\u043d\u043e",
      "longitude":103.131927,
      "latitude":53.074924
    },
    "4054":{
      "name":"\u0418\u0433\u0436\u0435\u0439",
      "longitude":103.143242,
      "latitude":54.021702
    },
    "4055":{
      "name":"\u041a\u0430\u0440\u0430\u0445\u0443\u043d",
      "longitude":103.158012,
      "latitude":55.590092
    },
    "4056":{
      "name":"\u0428\u0430\u0445\u0442\u0435\u0440\u0441\u043a\u0438\u0439",
      "longitude":103.1693695,
      "latitude":53.1523166
    },
    "4057":{
      "name":"\u0420\u0430\u0437\u0434\u043e\u043b\u044c\u0435",
      "longitude":103.202187,
      "latitude":52.44846
    },
    "4058":{
      "name":"\u0425\u0430\u0439\u0442\u0430",
      "longitude":103.2028416,
      "latitude":52.8111827
    },
    "4059":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u0432\u043a\u0430",
      "longitude":103.203522,
      "latitude":53.057293
    },
    "4060":{
      "name":"\u0417\u0430\u043c\u043e\u0440\u0441\u043a\u0438\u0439",
      "longitude":103.212479,
      "latitude":57.082741
    },
    "4061":{
      "name":"\u0425\u0443\u0434\u043e\u0440\u043e\u0436\u043a\u0438\u043d\u0430",
      "longitude":103.2320823,
      "latitude":52.9668996
    },
    "4062":{
      "name":"\u041f\u0440\u0438\u0431\u043e\u0439\u043d\u044b\u0439",
      "longitude":103.233376,
      "latitude":55.634979
    },
    "4063":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u043c\u0430\u0439\u0441\u043a\u043e\u0435",
      "longitude":103.242035,
      "latitude":53.762451
    },
    "4064":{
      "name":"\u0422\u0438\u0431\u0435\u043b\u044c\u0442\u0438",
      "longitude":103.245132,
      "latitude":51.769886
    },
    "4065":{
      "name":"\u0410\u043d\u043e\u0441\u043e\u0432\u043e",
      "longitude":103.246239,
      "latitude":54.651222
    },
    "4066":{
      "name":"\u0423\u0437\u043a\u0438\u0439 \u041b\u0443\u0433",
      "longitude":103.250519,
      "latitude":52.90337
    },
    "4067":{
      "name":"\u041a\u043b\u044e\u0447\u0438",
      "longitude":103.262756,
      "latitude":54.536774
    },
    "4068":{
      "name":"\u0422\u0430\u043b\u044c\u044f\u043d\u044b",
      "longitude":103.263046,
      "latitude":52.195301
    },
    "4069":{
      "name":"\u041c\u0435\u043b\u044c\u0445\u0438\u0442\u0443\u0439",
      "longitude":103.2647912,
      "latitude":53.6595148
    },
    "4070":{
      "name":"\u0417\u0435\u0440\u043d\u043e\u0432\u043e\u0435",
      "longitude":103.267532,
      "latitude":53.055489
    },
    "4071":{
      "name":"\u0411\u0440\u0443\u0441\u043d\u0438\u0447\u043d\u044b\u0439",
      "longitude":103.272614,
      "latitude":57.271759
    },
    "4072":{
      "name":"\u0422\u044b\u0440\u0433\u0435\u0442\u0443\u0439",
      "longitude":103.2727096,
      "latitude":53.3515033
    },
    "4073":{
      "name":"\u0422\u0443\u0431\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":103.281677,
      "latitude":57.640209
    },
    "4074":{
      "name":"\u0423\u0441\u043e\u043b\u044c\u0435-7",
      "longitude":103.2853181,
      "latitude":52.8971039
    },
    "4075":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":103.288483,
      "latitude":52.3385461
    },
    "4076":{
      "name":"\u042e\u0433\u043e\u043b\u043e\u043a",
      "longitude":103.2942691,
      "latitude":54.1850351
    },
    "4077":{
      "name":"\u0425\u0430\u0434\u0430\u0445\u0430\u043d",
      "longitude":103.295738,
      "latitude":53.552933
    },
    "4078":{
      "name":"\u0425\u043e\u043b\u043c\u0443\u0448\u0438\u043d\u043e",
      "longitude":103.308968,
      "latitude":52.876358
    },
    "4079":{
      "name":"\u041b\u043e\u0431\u0430\u0433\u0430\u0439",
      "longitude":103.328682,
      "latitude":53.950272
    },
    "4080":{
      "name":"\u041c\u043e\u043b\u044c\u043a\u0430",
      "longitude":103.334816,
      "latitude":53.882797
    },
    "4081":{
      "name":"\u0411\u0430\u043b\u0430\u0433\u0430\u043d\u043a\u0430",
      "longitude":103.338448,
      "latitude":54.06382
    },
    "4082":{
      "name":"\u041c\u043e\u0433\u043e\u0439",
      "longitude":103.3507302,
      "latitude":52.8232972
    },
    "4083":{
      "name":"\u0410\u043d\u0433\u0430\u0440\u0441\u043a\u0438\u0439",
      "longitude":103.360718,
      "latitude":53.462643
    },
    "4084":{
      "name":"\u041a\u0438\u0436\u0430",
      "longitude":103.364227,
      "latitude":54.126362
    },
    "4085":{
      "name":"\u041f\u043e\u0434\u0432\u043e\u043b\u043e\u0447\u043d\u043e\u0435",
      "longitude":103.367096,
      "latitude":55.206703
    },
    "4086":{
      "name":"\u041f\u043e\u0434\u0430\u0442\u043e\u0432\u0441\u043a\u0430\u044f",
      "longitude":103.367653,
      "latitude":53.878651
    },
    "4087":{
      "name":"\u041a\u0430\u043c\u0435\u043d\u043d\u043e-\u0410\u043d\u0433\u0430\u0440\u0441\u043a",
      "longitude":103.371658,
      "latitude":53.283585
    },
    "4088":{
      "name":"\u041a\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":103.372589,
      "latitude":53.167347
    },
    "4089":{
      "name":"\u041c\u0430\u043b\u044b\u0448\u0435\u0432\u043a\u0430",
      "longitude":103.38813,
      "latitude":53.734394
    },
    "4090":{
      "name":"\u0421\u043e\u0441\u043d\u043e\u0432\u043a\u0430",
      "longitude":103.391724,
      "latitude":52.820263
    },
    "4091":{
      "name":"\u0411\u0435\u0440\u0435\u0437\u043e\u0432\u043a\u0430",
      "longitude":103.3951641,
      "latitude":52.9850576
    },
    "4092":{
      "name":"\u0421\u0435\u0440\u0435\u0434\u043a\u0438\u043d\u0430",
      "longitude":103.404587,
      "latitude":53.439339
    },
    "4093":{
      "name":"\u041a\u043e\u0447\u0435\u0440\u0438\u043a\u043e\u0432\u0430",
      "longitude":103.411964,
      "latitude":52.940857
    },
    "4094":{
      "name":"\u041a\u0430\u0437\u0430\u0447\u044c\u0435",
      "longitude":103.432106,
      "latitude":53.334488
    },
    "4095":{
      "name":"\u0411\u044b\u0441\u0442\u0440\u0430\u044f",
      "longitude":103.437126,
      "latitude":51.741268
    },
    "4096":{
      "name":"\u0420\u0430\u0441\u0441\u0432\u0435\u0442",
      "longitude":103.4412724,
      "latitude":53.5617815
    },
    "4097":{
      "name":"\u0421\u043e\u0446\u0433\u043e\u0440\u043e\u0434\u043e\u043a",
      "longitude":103.457893,
      "latitude":56.462746
    },
    "4098":{
      "name":"\u0422\u0430\u0439\u0442\u0443\u0440\u043a\u0430",
      "longitude":103.465416,
      "latitude":52.870564
    },
    "4099":{
      "name":"\u041a\u0443\u043b\u0442\u0443\u043a",
      "longitude":103.473274,
      "latitude":52.567574
    },
    "4100":{
      "name":"\u0420\u0430\u0434\u0438\u0449\u0435\u0432",
      "longitude":103.48951,
      "latitude":57.2262
    },
    "4101":{
      "name":"\u0411\u0443\u0440\u0435\u0442\u044c",
      "longitude":103.506523,
      "latitude":52.968006
    },
    "4102":{
      "name":"\u0411\u0443\u0440\u0435\u0442\u044c",
      "longitude":103.5085272,
      "latitude":52.9911848
    },
    "4103":{
      "name":"\u041c\u0430\u043b\u044c\u0442\u0430",
      "longitude":103.516983,
      "latitude":52.83741
    },
    "4104":{
      "name":"\u0421\u0440\u0435\u0434\u043d\u044f\u044f \u041c\u0443\u044f",
      "longitude":103.520622,
      "latitude":54.333561
    },
    "4105":{
      "name":"\u041c\u043e\u0440\u043e\u0437\u043e\u0432\u0430",
      "longitude":103.521011,
      "latitude":53.197083
    },
    "4106":{
      "name":"\u041d\u043e\u0432\u043e\u0436\u0438\u043b\u043a\u0438\u043d\u043e",
      "longitude":103.553528,
      "latitude":52.556091
    },
    "4107":{
      "name":"\u041d\u043e\u0432\u043e\u043c\u0430\u043b\u044c\u0442\u0438\u043d\u0441\u043a",
      "longitude":103.55442,
      "latitude":52.869415
    },
    "4108":{
      "name":"\u0423\u043d\u0433\u0438\u043d",
      "longitude":103.5767845,
      "latitude":53.6953138
    },
    "4109":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0435\u0436\u0438\u043b\u043a\u0438\u043d\u0430",
      "longitude":103.589752,
      "latitude":52.540329
    },
    "4110":{
      "name":"\u0411\u0435\u0440\u0435\u0437\u043d\u044f\u043a\u0438",
      "longitude":103.595596,
      "latitude":56.940708
    },
    "4111":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u0423\u0434\u0430",
      "longitude":103.6126523,
      "latitude":54.0290334
    },
    "4112":{
      "name":"\u0423\u0441\u0442\u044c-\u0410\u043b\u0442\u0430\u043d",
      "longitude":103.6216023,
      "latitude":53.5236376
    },
    "4113":{
      "name":"\u0425\u0430\u043d\u0434\u0430\u0433\u0430\u0439",
      "longitude":103.6241356,
      "latitude":53.166532
    },
    "4114":{
      "name":"\u0418\u0433\u0438\u0440\u043c\u0430",
      "longitude":103.632339,
      "latitude":56.982262
    },
    "4115":{
      "name":"\u0421\u0430\u0432\u0432\u0430\u0442\u0435\u0435\u0432\u043a\u0430",
      "longitude":103.641243,
      "latitude":52.331409
    },
    "4116":{
      "name":"\u042f\u043d\u0433\u0435\u043b\u044c",
      "longitude":103.649101,
      "latitude":57.079296
    },
    "4117":{
      "name":"\u0412\u043e\u0440\u043e\u0431\u044c\u0435\u0432\u043a\u0430",
      "longitude":103.671509,
      "latitude":53.003517
    },
    "4118":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u0415\u043b\u0430\u043d\u044c",
      "longitude":103.673737,
      "latitude":52.575985
    },
    "4119":{
      "name":"\u041d\u043e\u0432\u043e\u0438\u043b\u0438\u043c\u0441\u043a",
      "longitude":103.683479,
      "latitude":57.296459
    },
    "4120":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u0418\u0434\u0430",
      "longitude":103.688416,
      "latitude":53.176395
    },
    "4121":{
      "name":"\u041e\u043b\u043e\u043d\u043a\u0438",
      "longitude":103.703964,
      "latitude":52.899155
    },
    "4122":{
      "name":"\u0427\u0438\u0447\u043a\u043e\u0432\u0430",
      "longitude":103.708954,
      "latitude":54.187416
    },
    "4123":{
      "name":"\u041a\u0443\u043b\u0442\u0443\u043a",
      "longitude":103.7115374,
      "latitude":51.725563
    },
    "4124":{
      "name":"\u0411\u0438\u043b\u044c\u0447\u0438\u0440",
      "longitude":103.7136642,
      "latitude":53.5632542
    },
    "4125":{
      "name":"\u0423\u0441\u0442\u044c-\u0422\u0430\u0440\u0430\u0441\u0430",
      "longitude":103.721252,
      "latitude":53.17857
    },
    "4126":{
      "name":"\u041f\u0440\u0438\u043c\u043e\u0440\u0441\u043a\u0438\u0439",
      "longitude":103.7232724,
      "latitude":53.5855437
    },
    "4127":{
      "name":"\u041d\u043e\u0432\u043e\u043e\u0434\u0438\u043d\u0441\u043a",
      "longitude":103.723587,
      "latitude":52.308372
    },
    "4128":{
      "name":"\u041e\u0434\u0438\u043d\u0441\u043a",
      "longitude":103.725082,
      "latitude":52.463116
    },
    "4129":{
      "name":"\u0422\u0435\u043b\u044c\u043c\u0430",
      "longitude":103.7300028,
      "latitude":52.6688942
    },
    "4130":{
      "name":"\u041d\u043e\u0432\u043e-\u041b\u0435\u043d\u0438\u043d\u043e",
      "longitude":103.739332,
      "latitude":53.6545382
    },
    "4131":{
      "name":"\u0416\u0435\u043b\u0435\u0437\u043d\u043e\u0434\u043e\u0440\u043e\u0436\u043d\u044b\u0439",
      "longitude":103.7504844,
      "latitude":52.6739651
    },
    "4132":{
      "name":"\u0420\u0443\u0434\u043d\u043e\u0433\u043e\u0440\u0441\u043a",
      "longitude":103.750557,
      "latitude":57.268295
    },
    "4133":{
      "name":"\u0410\u043d\u0433\u0430\u0441\u043e\u043b\u043a\u0430",
      "longitude":103.751709,
      "latitude":51.750439
    },
    "4134":{
      "name":"\u0421\u0443\u0445\u043e\u0439 \u0420\u0443\u0447\u0435\u0439",
      "longitude":103.755997,
      "latitude":51.642773
    },
    "4135":{
      "name":"\u0422\u0430\u0440\u0430\u0441\u0430",
      "longitude":103.776764,
      "latitude":53.08847
    },
    "4136":{
      "name":"\u0418\u0440\u0445\u0438\u0434\u0435\u0439",
      "longitude":103.802948,
      "latitude":53.433506
    },
    "4137":{
      "name":"\u041c\u0430\u0439\u0441\u043a\u0430\u044f",
      "longitude":103.8058811,
      "latitude":53.4136424
    },
    "4138":{
      "name":"\u0428\u0430\u043c\u0430\u043d\u043a\u0430",
      "longitude":103.8238712,
      "latitude":52.0714259
    },
    "4139":{
      "name":"\u0411\u0438\u043b\u0438\u043a\u0442\u0443\u0439",
      "longitude":103.8259013,
      "latitude":52.6025688
    },
    "4140":{
      "name":"\u041a\u0443\u0442\u0430\u043d\u043a\u0430",
      "longitude":103.8362937,
      "latitude":53.6354737
    },
    "4141":{
      "name":"\u041e\u0431\u0443\u0441\u0430",
      "longitude":103.8375534,
      "latitude":53.7216452
    },
    "4142":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":103.838371,
      "latitude":52.793709
    },
    "4143":{
      "name":"\u0417\u0430\u0433\u043b\u0438\u043a",
      "longitude":103.865021,
      "latitude":53.40028
    },
    "4144":{
      "name":"\u0425\u0430\u0440\u0430\u0442\u0438\u0440\u0433\u0435\u043d",
      "longitude":103.874062,
      "latitude":53.153706
    },
    "4145":{
      "name":"\u0425\u0430\u0440\u0430\u0439",
      "longitude":103.8794668,
      "latitude":53.4010203
    },
    "4146":{
      "name":"\u041c\u043e\u0440\u043e\u0437\u0430",
      "longitude":103.8871853,
      "latitude":53.3774094
    },
    "4147":{
      "name":"\u041c\u043e\u0442\u044b",
      "longitude":103.8999355,
      "latitude":52.0771095
    },
    "4148":{
      "name":"\u041f\u043e\u0434\u043a\u0430\u043c\u0435\u043d\u043d\u0430\u044f",
      "longitude":103.907631,
      "latitude":51.966953
    },
    "4149":{
      "name":"\u041b\u0443\u0437\u0433\u0438\u043d\u0430",
      "longitude":103.9115977,
      "latitude":53.370158
    },
    "4150":{
      "name":"\u0425\u043e\u0445\u043e\u0440\u0441\u043a",
      "longitude":103.933266,
      "latitude":53.162514
    },
    "4151":{
      "name":"\u0421\u0443\u0432\u043e\u0440\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":103.942688,
      "latitude":56.497715
    },
    "4152":{
      "name":"\u0412\u0432\u0435\u0434\u0435\u043d\u0449\u0438\u043d\u0430",
      "longitude":103.944534,
      "latitude":52.206264
    },
    "4153":{
      "name":"\u0427\u0438\u0441\u0442\u044b\u0435 \u041a\u043b\u044e\u0447\u0438",
      "longitude":103.9486557,
      "latitude":52.1797733
    },
    "4154":{
      "name":"\u041c\u043e\u043b\u044c\u0442\u0430",
      "longitude":103.953751,
      "latitude":53.437878
    },
    "4155":{
      "name":"\u0417\u043e\u0440\u0438\u043d\u043e-\u0411\u044b\u043a\u043e\u0432\u043e",
      "longitude":103.957123,
      "latitude":52.718857
    },
    "4156":{
      "name":"\u0428\u0435\u0441\u0442\u0430\u043a\u043e\u0432\u043e",
      "longitude":103.962311,
      "latitude":56.49424
    },
    "4157":{
      "name":"\u0418\u0436\u0438\u043b\u0445\u0430",
      "longitude":103.962669,
      "latitude":53.156338
    },
    "4158":{
      "name":"\u0425\u043e\u043a\u0442\u0430",
      "longitude":103.9766248,
      "latitude":53.4664392
    },
    "4159":{
      "name":"\u0423\u0441\u0442\u044c-\u0411\u0430\u043b\u0435\u0439",
      "longitude":103.99173,
      "latitude":52.630695
    },
    "4160":{
      "name":"\u0420\u0443\u0441\u0441\u043a\u0438\u0435 \u042f\u043d\u0433\u0443\u0442\u044b",
      "longitude":103.9925271,
      "latitude":53.3462093
    },
    "4161":{
      "name":"\u0413\u043e\u0440\u043e\u0445\u043e\u0432\u043e",
      "longitude":104.009148,
      "latitude":52.794445
    },
    "4162":{
      "name":"\u041e\u043d\u0433\u043e\u0439",
      "longitude":104.031771,
      "latitude":53.5125128
    },
    "4163":{
      "name":"\u0411\u0430\u0440\u0443\u0439",
      "longitude":104.052505,
      "latitude":52.826271
    },
    "4164":{
      "name":"\u0417\u0443\u0439",
      "longitude":104.052849,
      "latitude":52.454632
    },
    "4165":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u0415\u043b\u0430\u043d\u043a\u0430",
      "longitude":104.055283,
      "latitude":52.36591
    },
    "4166":{
      "name":"\u0413\u0440\u044f\u0437\u043d\u0443\u0448\u043a\u0430",
      "longitude":104.0554461,
      "latitude":53.3215754
    },
    "4167":{
      "name":"\u0423\u0442\u0443\u043b\u0438\u043a",
      "longitude":104.056648,
      "latitude":51.545807
    },
    "4168":{
      "name":"\u0411\u0430\u043a\u043b\u0430\u0448\u0438",
      "longitude":104.057533,
      "latitude":52.232819
    },
    "4169":{
      "name":"\u041e\u043b\u0445\u0430",
      "longitude":104.111282,
      "latitude":52.162579
    },
    "4170":{
      "name":"\u041c\u0430\u043a\u0441\u0438\u043c\u043e\u0432\u0449\u0438\u043d\u0430",
      "longitude":104.121521,
      "latitude":52.274918
    },
    "4171":{
      "name":"\u0423\u043a\u044b\u0440",
      "longitude":104.140984,
      "latitude":53.142639
    },
    "4172":{
      "name":"\u0421\u043c\u043e\u043b\u0435\u043d\u0449\u0438\u043d\u0430",
      "longitude":104.142426,
      "latitude":52.250034
    },
    "4173":{
      "name":"\u0415\u043d\u0438\u0441\u0435\u0439",
      "longitude":104.1517935,
      "latitude":53.3574974
    },
    "4174":{
      "name":"\u0423\u0441\u0442\u044c-\u041a\u0443\u0434\u0430",
      "longitude":104.155693,
      "latitude":52.438747
    },
    "4175":{
      "name":"\u041c\u0430\u043c\u043e\u043d\u044b",
      "longitude":104.155769,
      "latitude":52.303055
    },
    "4176":{
      "name":"\u0421\u0430\u0439\u0433\u0443\u0442\u044b",
      "longitude":104.16967,
      "latitude":52.841663
    },
    "4177":{
      "name":"\u041c\u043e\u0441\u043a\u043e\u0432\u0449\u0438\u043d\u0430",
      "longitude":104.172409,
      "latitude":52.51482
    },
    "4178":{
      "name":"\u041a\u043e\u0440\u0448\u0443\u043d\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":104.194206,
      "latitude":56.491352
    },
    "4179":{
      "name":"\u041c\u0430\u0440\u0438\u0442\u0443\u0439",
      "longitude":104.216431,
      "latitude":51.788239
    },
    "4180":{
      "name":"\u0421\u0442\u043e\u043b\u0431\u043e\u0432\u0430",
      "longitude":104.22036,
      "latitude":52.428207
    },
    "4181":{
      "name":"\u0422\u0438\u0445\u043e\u043d\u043e\u0432\u043a\u0430",
      "longitude":104.224136,
      "latitude":53.175423
    },
    "4182":{
      "name":"\u0428\u0438\u0440\u044f\u0435\u0432\u0430",
      "longitude":104.227882,
      "latitude":52.555904
    },
    "4183":{
      "name":"\u0421\u043e\u043b\u0437\u0430\u043d",
      "longitude":104.229004,
      "latitude":51.497353
    },
    "4184":{
      "name":"\u0423\u0440\u0438\u043a",
      "longitude":104.232002,
      "latitude":52.460522
    },
    "4185":{
      "name":"\u0421\u0435\u0440\u0433\u0438\u0435\u0432 \u041f\u043e\u0441\u0430\u0434",
      "longitude":104.2349241,
      "latitude":52.245746
    },
    "4186":{
      "name":"\u041b\u044b\u043b\u043e\u0432\u0449\u0438\u043d\u0430",
      "longitude":104.239113,
      "latitude":52.516556
    },
    "4187":{
      "name":"\u0425\u0440\u0435\u0431\u0442\u043e\u0432\u0430\u044f",
      "longitude":104.247116,
      "latitude":56.709171
    },
    "4188":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u043e\u0432 \u041f\u043e\u0441\u0430\u0434",
      "longitude":104.2485961,
      "latitude":52.226718
    },
    "4189":{
      "name":"\u041d\u043e\u0432\u043e-\u0418\u0440\u043a\u0443\u0442\u0441\u043a\u0438\u0439",
      "longitude":104.2495261,
      "latitude":52.24443
    },
    "4190":{
      "name":"\u041f\u043e\u0441\u0435\u043b\u043e\u043a \u0411\u0435\u0440\u0435\u0437\u043e\u0432\u044b\u0439",
      "longitude":104.2545887,
      "latitude":52.2240007
    },
    "4191":{
      "name":"\u0413\u043e\u0440\u044f\u0448\u0438\u043d\u0430",
      "longitude":104.258148,
      "latitude":52.578304
    },
    "4192":{
      "name":"\u0413\u0440\u0430\u043d\u043e\u0432\u0449\u0438\u043d\u0430",
      "longitude":104.287514,
      "latitude":52.462086
    },
    "4193":{
      "name":"\u041a\u0430\u0440\u043b\u0443\u043a",
      "longitude":104.299187,
      "latitude":52.422604
    },
    "4194":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u0422\u043e\u043f\u043a\u0430",
      "longitude":104.314789,
      "latitude":52.345726
    },
    "4195":{
      "name":"\u0414\u0443\u043d\u0434\u0430\u0439",
      "longitude":104.347702,
      "latitude":53.218575
    },
    "4196":{
      "name":"\u0425\u043e\u043c\u0443\u0442\u043e\u0432\u043e",
      "longitude":104.368851,
      "latitude":52.467205
    },
    "4197":{
      "name":"\u0413\u043e\u0440\u043d\u044b\u0439",
      "longitude":104.371986,
      "latitude":52.397247
    },
    "4198":{
      "name":"\u041f\u0430\u0434\u044c \u041c\u0435\u043b\u044c\u043d\u0438\u0447\u043d\u0430\u044f",
      "longitude":104.379089,
      "latitude":52.160809
    },
    "4199":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u0420\u0430\u0437\u0432\u043e\u0434\u043d\u0430\u044f",
      "longitude":104.393051,
      "latitude":52.246651
    },
    "4200":{
      "name":"\u0414\u0437\u0435\u0440\u0436\u0438\u043d\u0441\u043a",
      "longitude":104.3955895,
      "latitude":52.2791595
    },
    "4201":{
      "name":"\u041a\u0443\u0434\u0430",
      "longitude":104.400177,
      "latitude":52.441486
    },
    "4202":{
      "name":"\u041c\u0443\u0440\u0438\u043d\u043e",
      "longitude":104.40567,
      "latitude":51.476582
    },
    "4203":{
      "name":"\u041c\u0438\u043b\u043e\u0432\u0438\u0434\u044b",
      "longitude":104.4202952,
      "latitude":52.2767476
    },
    "4204":{
      "name":"\u041c\u043e\u043b\u043e\u0434\u0435\u0436\u043d\u044b\u0439",
      "longitude":104.4210811,
      "latitude":52.234554
    },
    "4205":{
      "name":"\u0412\u0435\u0440\u0448\u0438\u043d\u0430",
      "longitude":104.421989,
      "latitude":53.249458
    },
    "4206":{
      "name":"\u041f\u043e\u0437\u0434\u043d\u044f\u043a\u043e\u0432\u0430",
      "longitude":104.440132,
      "latitude":52.488602
    },
    "4207":{
      "name":"\u0413\u0430\u043b\u043a\u0438",
      "longitude":104.444382,
      "latitude":52.62265
    },
    "4208":{
      "name":"\u0415\u0433\u043e\u0440\u043e\u0432\u0449\u0438\u043d\u0430",
      "longitude":104.44883,
      "latitude":52.663048
    },
    "4209":{
      "name":"\u041f\u0438\u0432\u043e\u0432\u0430\u0440\u0438\u0445\u0430",
      "longitude":104.4531348,
      "latitude":52.2699526
    },
    "4210":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u044c\u0441\u043a",
      "longitude":104.454811,
      "latitude":52.754917
    },
    "4211":{
      "name":"\u041d\u043e\u0432\u043e\u043b\u0438\u0441\u0438\u0445\u0430",
      "longitude":104.455139,
      "latitude":52.23579
    },
    "4212":{
      "name":"\u041e\u0451\u043a",
      "longitude":104.460915,
      "latitude":52.589935
    },
    "4213":{
      "name":"\u041f\u0430\u0442\u0440\u043e\u043d\u044b",
      "longitude":104.472176,
      "latitude":52.160618
    },
    "4214":{
      "name":"\u041f\u043b\u0438\u0448\u043a\u0438\u043d\u043e",
      "longitude":104.488022,
      "latitude":52.346455
    },
    "4215":{
      "name":"\u0411\u0443\u0442\u044b\u0440\u043a\u0438",
      "longitude":104.500084,
      "latitude":52.564507
    },
    "4216":{
      "name":"\u041a\u043e\u0442\u044b",
      "longitude":104.503273,
      "latitude":52.551437
    },
    "4217":{
      "name":"\u0421\u043e\u0441\u043d\u043e\u0432\u044b\u0439 \u0411\u043e\u0440",
      "longitude":104.504318,
      "latitude":52.657845
    },
    "4218":{
      "name":"\u0416\u0435\u0440\u0434\u043e\u0432\u043a\u0430",
      "longitude":104.537582,
      "latitude":52.653606
    },
    "4219":{
      "name":"\u041a\u044b\u0446\u0438\u0433\u0438\u0440\u043e\u0432\u043a\u0430",
      "longitude":104.549751,
      "latitude":52.727467
    },
    "4220":{
      "name":"\u0427\u0435\u0440\u0435\u043c\u0443\u0448\u043a\u0430",
      "longitude":104.567924,
      "latitude":52.643532
    },
    "4221":{
      "name":"\u0411\u0443\u0440\u0434\u0430\u043a\u043e\u0432\u043a\u0430",
      "longitude":104.577599,
      "latitude":52.096851
    },
    "4222":{
      "name":"\u0425\u0443\u0434\u044f\u043a\u043e\u0432\u0430",
      "longitude":104.581711,
      "latitude":52.272141
    },
    "4223":{
      "name":"\u0411\u0443\u043b\u0443\u0441\u0430",
      "longitude":104.602234,
      "latitude":52.796963
    },
    "4224":{
      "name":"\u041d\u0438\u0436\u043d\u044f\u044f \u0418\u0434\u044b\u0433\u0430",
      "longitude":104.625572,
      "latitude":52.904926
    },
    "4225":{
      "name":"\u0420\u0435\u0432\u044f\u043a\u0438\u043d\u0430",
      "longitude":104.625786,
      "latitude":52.588421
    },
    "4226":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u043d\u0435\u0436\u043d\u0430\u044f",
      "longitude":104.627136,
      "latitude":51.468632
    },
    "4227":{
      "name":"\u041a\u0430\u043f\u0441\u0430\u043b",
      "longitude":104.641083,
      "latitude":52.686939
    },
    "4228":{
      "name":"\u0421\u0435\u043c\u0438\u0433\u043e\u0440\u0441\u043a",
      "longitude":104.644386,
      "latitude":56.67691
    },
    "4229":{
      "name":"\u0425\u0430\u0440\u0430\u0437\u0430\u0440\u0433\u0430\u0439",
      "longitude":104.671829,
      "latitude":52.960999
    },
    "4230":{
      "name":"\u041a\u0443\u044f\u0434\u0430",
      "longitude":104.676498,
      "latitude":52.613335
    },
    "4231":{
      "name":"\u041a\u0443\u043b\u0443\u043d\u043a\u0443\u043d",
      "longitude":104.683456,
      "latitude":52.838436
    },
    "4232":{
      "name":"\u041b\u0443\u043a\u0438\u043d\u043e\u0432\u043e",
      "longitude":104.701721,
      "latitude":54.190529
    },
    "4233":{
      "name":"\u041a\u0443\u043a\u0443\u043d\u0443\u0442",
      "longitude":104.7182837,
      "latitude":52.9897258
    },
    "4234":{
      "name":"\u0422\u0438\u043c\u043e\u0448\u0438\u043d\u043e",
      "longitude":104.727089,
      "latitude":54.395344
    },
    "4235":{
      "name":"\u0417\u0430\u0445\u0430\u043b",
      "longitude":104.733131,
      "latitude":52.602913
    },
    "4236":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u0420\u0435\u0447\u043a\u0430",
      "longitude":104.735489,
      "latitude":51.950333
    },
    "4237":{
      "name":"\u0414\u0430\u043b\u044c\u043d\u044f\u044f \u0417\u0430\u043a\u043e\u0440\u0430",
      "longitude":104.737274,
      "latitude":54.657925
    },
    "4238":{
      "name":"\u0415\u043b\u043e\u0432\u043a\u0430",
      "longitude":104.782265,
      "latitude":52.61272
    },
    "4239":{
      "name":"\u0410\u043b\u0443\u0436\u0438\u043d\u043e",
      "longitude":104.784767,
      "latitude":52.707413
    },
    "4240":{
      "name":"\u0421\u0432\u0435\u0440\u0434\u043b\u043e\u0432\u043e",
      "longitude":104.79287,
      "latitude":52.587147
    },
    "4241":{
      "name":"\u0411\u0430\u0439\u043a\u0430\u043b",
      "longitude":104.808372,
      "latitude":51.870476
    },
    "4242":{
      "name":"\u0422\u0443\u0433\u0443\u0442\u0443\u0439",
      "longitude":104.812332,
      "latitude":52.683163
    },
    "4243":{
      "name":"\u0417\u043d\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":104.837624,
      "latitude":54.700729
    },
    "4244":{
      "name":"\u0411\u043e\u0437\u043e\u0439",
      "longitude":104.852341,
      "latitude":52.931728
    },
    "4245":{
      "name":"\u041b\u0438\u0441\u0442\u0432\u044f\u043d\u043a\u0430",
      "longitude":104.86058,
      "latitude":51.85693
    },
    "4246":{
      "name":"\u0413\u0430\u0445\u0430\u043d\u044b",
      "longitude":104.8718906,
      "latitude":53.0476648
    },
    "4247":{
      "name":"\u0411\u0430\u0439\u0442\u043e\u0433",
      "longitude":104.87397,
      "latitude":53.143944
    },
    "4248":{
      "name":"\u0413\u043e\u0440\u044f\u0447\u0438\u0439 \u041a\u043b\u044e\u0447",
      "longitude":104.908379,
      "latitude":52.27615
    },
    "4249":{
      "name":"\u0425\u0430\u0440\u0430\u043d\u0443\u0442",
      "longitude":104.939827,
      "latitude":52.763023
    },
    "4250":{
      "name":"\u0410\u0445\u0438\u043d\u044b",
      "longitude":104.978508,
      "latitude":53.261059
    },
    "4251":{
      "name":"\u0425\u0430\u0431\u0430\u0440\u043e\u0432\u0441\u043a\u0430\u044f",
      "longitude":105.003227,
      "latitude":53.099957
    },
    "4252":{
      "name":"\u041a\u043e\u0440\u0441\u0443\u043a",
      "longitude":105.007935,
      "latitude":52.791546
    },
    "4253":{
      "name":"\u041e\u043b\u043e\u0439",
      "longitude":105.038986,
      "latitude":52.905327
    },
    "4254":{
      "name":"\u0420\u0443\u0447\u0435\u0439",
      "longitude":105.054573,
      "latitude":56.854488
    },
    "4255":{
      "name":"\u0425\u0430\u0440\u0430\u0442",
      "longitude":105.064949,
      "latitude":52.753265
    },
    "4256":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u041a\u0443\u043a\u0443\u0442",
      "longitude":105.071518,
      "latitude":52.734234
    },
    "4257":{
      "name":"\u0421\u0442\u0430\u0440\u044b\u0439 \u041e\u043b\u043e\u0439",
      "longitude":105.0769673,
      "latitude":52.9135905
    },
    "4258":{
      "name":"\u041d\u043e\u0432\u043e\u043d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u0441\u043a",
      "longitude":105.086311,
      "latitude":53.151459
    },
    "4259":{
      "name":"\u0423\u0441\u0442\u044c-\u0418\u043b\u0433\u0430",
      "longitude":105.08744,
      "latitude":55.007313
    },
    "4260":{
      "name":"\u041e\u0442\u043e\u043d\u0445\u043e\u0439",
      "longitude":105.121262,
      "latitude":52.95163
    },
    "4261":{
      "name":"\u0420\u0443\u0434\u043e\u0432\u043a\u0430",
      "longitude":105.209496,
      "latitude":54.747204
    },
    "4262":{
      "name":"\u041e\u043b\u044c\u0437\u043e\u043d\u044b",
      "longitude":105.2176846,
      "latitude":52.9481971
    },
    "4263":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u0432\u043e",
      "longitude":105.226715,
      "latitude":54.496094
    },
    "4264":{
      "name":"\u0425\u0430\u0442\u0430\u0440-\u0425\u0430\u0434\u0430\u0439",
      "longitude":105.229935,
      "latitude":52.842155
    },
    "4265":{
      "name":"\u0422\u0443\u0442\u0443\u0440\u0430",
      "longitude":105.230515,
      "latitude":54.785072
    },
    "4266":{
      "name":"\u042f\u043d\u0442\u0430\u043b\u044c",
      "longitude":105.249344,
      "latitude":56.846062
    },
    "4267":{
      "name":"\u0411\u0430\u0434\u0430\u0433\u0443\u0439",
      "longitude":105.291603,
      "latitude":53.022617
    },
    "4268":{
      "name":"\u041d\u0430\u0433\u0430\u043b\u044b\u043a",
      "longitude":105.309425,
      "latitude":53.106422
    },
    "4269":{
      "name":"\u041c\u0430\u043b\u043e\u0435 \u0413\u043e\u043b\u043e\u0443\u0441\u0442\u043d\u043e\u0435",
      "longitude":105.332695,
      "latitude":52.298336
    },
    "4270":{
      "name":"\u0417\u0430\u0433\u0430\u0442\u0443\u0439",
      "longitude":105.339348,
      "latitude":52.889641
    },
    "4271":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0435 \u0413\u043e\u043b\u043e\u0443\u0441\u0442\u043d\u043e\u0435",
      "longitude":105.408424,
      "latitude":52.037273
    },
    "4272":{
      "name":"\u0411\u0435\u043b\u043e\u0443\u0441\u043e\u0432\u043e",
      "longitude":105.463806,
      "latitude":54.024658
    },
    "4273":{
      "name":"\u041b\u044e\u0440\u044b",
      "longitude":105.466766,
      "latitude":53.000267
    },
    "4274":{
      "name":"\u041f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":105.534851,
      "latitude":53.082943
    },
    "4275":{
      "name":"\u0412\u0435\u0440\u0445\u043e\u043b\u0435\u043d\u0441\u043a",
      "longitude":105.570412,
      "latitude":54.101086
    },
    "4276":{
      "name":"\u041a\u043e\u043b\u043e\u043d\u043a\u043e\u0432\u043e",
      "longitude":105.5718337,
      "latitude":56.7861546
    },
    "4277":{
      "name":"\u0411\u0430\u0439\u0448\u0430",
      "longitude":105.626816,
      "latitude":53.373363
    },
    "4278":{
      "name":"\u0427\u0438\u043a\u0430\u043d",
      "longitude":105.650169,
      "latitude":54.900478
    },
    "4279":{
      "name":"\u041f\u043e\u043b\u043e\u0432\u0438\u043d\u043a\u0430",
      "longitude":105.653152,
      "latitude":53.130608
    },
    "4280":{
      "name":"\u0422\u0443\u0440\u0433\u0435\u043d\u0435\u0432\u043a\u0430",
      "longitude":105.668358,
      "latitude":53.026764
    },
    "4281":{
      "name":"\u0412\u0430\u0441\u0438\u043b\u044c\u0435\u0432\u043a\u0430",
      "longitude":105.750882,
      "latitude":53.0774708
    },
    "4282":{
      "name":"\u0425\u043e\u0433\u043e\u0442",
      "longitude":105.869621,
      "latitude":53.242523
    },
    "4283":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u044f\u0440",
      "longitude":105.929581,
      "latitude":53.945835
    },
    "4284":{
      "name":"\u0410\u0440\u0433\u0443\u043d",
      "longitude":105.931244,
      "latitude":53.368996
    },
    "4285":{
      "name":"\u041d\u0438\u043a\u0438\u043b\u0435\u0439",
      "longitude":105.962364,
      "latitude":53.674522
    },
    "4286":{
      "name":"\u041a\u0430\u0440\u043b\u0443\u043a",
      "longitude":105.987892,
      "latitude":53.424271
    },
    "4287":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0438\u0435 \u0413\u043e\u043b\u044b",
      "longitude":106.001862,
      "latitude":53.872181
    },
    "4288":{
      "name":"\u0425\u0430\u0440\u0431\u0430\u0442\u043e\u0432\u043e",
      "longitude":106.00219,
      "latitude":53.745239
    },
    "4289":{
      "name":"\u0422\u043e\u043b\u0441\u0442\u044b\u0439 \u041c\u044b\u0441",
      "longitude":106.020079,
      "latitude":56.8179312
    },
    "4290":{
      "name":"\u041c\u0430\u043d\u0437\u0443\u0440\u043a\u0430",
      "longitude":106.060333,
      "latitude":53.487743
    },
    "4291":{
      "name":"\u0411\u0443\u0433\u0443\u043b\u044c\u0434\u0435\u0439\u043a\u0430",
      "longitude":106.072304,
      "latitude":52.549667
    },
    "4292":{
      "name":"\u0417\u0430\u0440\u0435\u0447\u043d\u043e\u0435",
      "longitude":106.1059961,
      "latitude":53.4103563
    },
    "4293":{
      "name":"\u0411\u0443\u0442\u0430\u043a\u043e\u0432\u043e",
      "longitude":106.113258,
      "latitude":54.052864
    },
    "4294":{
      "name":"\u041f\u043e\u0434\u044b\u043c\u0430\u0445\u0438\u043d\u043e",
      "longitude":106.178253,
      "latitude":56.975853
    },
    "4295":{
      "name":"\u0410\u043d\u0433\u0430",
      "longitude":106.190826,
      "latitude":53.981197
    },
    "4296":{
      "name":"\u041a\u0430\u0437\u0430\u0440\u043a\u0438",
      "longitude":106.19738,
      "latitude":56.999363
    },
    "4297":{
      "name":"\u041a\u0443\u0440\u0435\u0442\u044c",
      "longitude":106.204536,
      "latitude":52.820736
    },
    "4298":{
      "name":"\u0412\u0435\u0440\u0448\u0438\u043d\u0430 \u0422\u0443\u0442\u0443\u0440\u044b",
      "longitude":106.206078,
      "latitude":54.434906
    },
    "4299":{
      "name":"\u0411\u0438\u0440\u044e\u043b\u044c\u043a\u0430",
      "longitude":106.325554,
      "latitude":53.865189
    },
    "4300":{
      "name":"\u0417\u0430\u043b\u043e\u0433",
      "longitude":106.3872811,
      "latitude":53.9364477
    },
    "4301":{
      "name":"\u0417\u0432\u0451\u0437\u0434\u043d\u044b\u0439",
      "longitude":106.505241,
      "latitude":56.747498
    },
    "4302":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u0422\u0430\u0440\u0435\u043b\u044c",
      "longitude":106.622009,
      "latitude":53.756737
    },
    "4303":{
      "name":"\u0428\u0430\u0440\u0430-\u0422\u043e\u0433\u043e\u0442",
      "longitude":106.713257,
      "latitude":53.004662
    },
    "4304":{
      "name":"\u041d\u0438\u044f",
      "longitude":106.803078,
      "latitude":56.553173
    },
    "4305":{
      "name":"\u041b\u0435\u0441\u043e\u0443\u0447\u0430\u0441\u0442\u043e\u043a \u0425\u0430\u043d\u0434\u0430",
      "longitude":107.0085822,
      "latitude":55.1248774
    },
    "4306":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0435\u043c\u0430\u0440\u043a\u043e\u0432\u043e",
      "longitude":107.025002,
      "latitude":57.324944
    },
    "4307":{
      "name":"\u041d\u0435\u0431\u0435\u043b\u044c",
      "longitude":107.068428,
      "latitude":56.372726
    },
    "4308":{
      "name":"\u0417\u0430\u044f\u0440\u043d\u043e\u0432\u043e",
      "longitude":107.09066,
      "latitude":57.335533
    },
    "4309":{
      "name":"\u041d\u0435\u0431\u0435\u043b\u044c",
      "longitude":107.1061814,
      "latitude":56.3552687
    },
    "4310":{
      "name":"\u0422\u0438\u043f\u0443\u0439",
      "longitude":107.2326754,
      "latitude":55.41435
    },
    "4311":{
      "name":"\u0425\u0443\u0436\u0438\u0440",
      "longitude":107.345734,
      "latitude":53.192001
    },
    "4312":{
      "name":"\u041a\u043b\u044e\u0447\u0438",
      "longitude":107.492271,
      "latitude":56.198742
    },
    "4313":{
      "name":"\u041a\u0430\u0437\u0430\u0447\u0438\u043d\u0441\u043a\u043e\u0435",
      "longitude":107.567009,
      "latitude":56.271587
    },
    "4314":{
      "name":"\u041e\u043d\u0433\u0443\u0440\u0435\u043d",
      "longitude":107.591805,
      "latitude":53.632732
    },
    "4315":{
      "name":"\u041a\u0430\u0440\u0430\u043c",
      "longitude":107.602669,
      "latitude":55.144192
    },
    "4316":{
      "name":"\u041e\u043a\u0443\u043d\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":107.692711,
      "latitude":56.022797
    },
    "4317":{
      "name":"\u0423\u043b\u044c\u043a\u0430\u043d",
      "longitude":107.796234,
      "latitude":55.898624
    },
    "4318":{
      "name":"\u041c\u0430\u043a\u0430\u0440\u043e\u0432\u043e",
      "longitude":107.8226456,
      "latitude":57.483761
    },
    "4319":{
      "name":"\u041a\u0440\u0438\u0432\u0430\u044f \u041b\u0443\u043a\u0430",
      "longitude":107.828651,
      "latitude":57.598648
    },
    "4320":{
      "name":"\u041a\u0440\u0438\u0432\u043e\u0448\u0430\u043f\u043a\u0438\u043d\u043e",
      "longitude":108.00312,
      "latitude":57.749043
    },
    "4321":{
      "name":"\u0415\u0440\u0431\u043e\u0433\u0430\u0447\u0451\u043d",
      "longitude":108.009712,
      "latitude":61.275021
    },
    "4322":{
      "name":"\u041f\u0440\u0435\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043a\u0430",
      "longitude":108.093475,
      "latitude":60.023071
    },
    "4323":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0435\u043c\u0430\u0440\u0442\u044b\u043d\u043e\u0432\u043e",
      "longitude":108.173943,
      "latitude":56.887745
    },
    "4324":{
      "name":"\u041d\u0435\u043f\u0430",
      "longitude":108.230072,
      "latitude":59.244469
    },
    "4325":{
      "name":"\u0411\u0443\u0431\u043d\u043e\u0432\u043a\u0430",
      "longitude":108.237206,
      "latitude":57.754318
    },
    "4326":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u0441\u043a",
      "longitude":108.349243,
      "latitude":57.840553
    },
    "4327":{
      "name":"\u041f\u043e\u0434\u0432\u043e\u043b\u043e\u0448\u0438\u043d\u043e",
      "longitude":108.42588,
      "latitude":58.248753
    },
    "4328":{
      "name":"\u041a\u0443\u043d\u0435\u0440\u043c\u0430",
      "longitude":108.450508,
      "latitude":55.76088
    },
    "4329":{
      "name":"\u0410\u043b\u044b\u043c\u043e\u0432\u043a\u0430",
      "longitude":108.577133,
      "latitude":57.962002
    },
    "4330":{
      "name":"\u042e\u0431\u0438\u043b\u0435\u0439\u043d\u044b\u0439",
      "longitude":108.844482,
      "latitude":58.129013
    },
    "4331":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u043f\u0430\u0432\u043b\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":108.969841,
      "latitude":58.208157
    },
    "4332":{
      "name":"\u041a\u043e\u0440\u0448\u0443\u043d\u043e\u0432\u043e",
      "longitude":110.14315,
      "latitude":58.595627
    },
    "4333":{
      "name":"\u0412\u0438\u0437\u0438\u0440\u043d\u044b\u0439",
      "longitude":111.254478,
      "latitude":58.893734
    },
    "4334":{
      "name":"\u0413\u043e\u0440\u043d\u043e-\u0427\u0443\u0439\u0441\u043a\u0438\u0439",
      "longitude":111.756447,
      "latitude":57.64352
    },
    "4335":{
      "name":"\u0421\u043e\u0433\u0434\u0438\u043e\u043d\u0434\u043e\u043d",
      "longitude":112.162773,
      "latitude":57.691994
    },
    "4336":{
      "name":"\u041b\u0443\u0433\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":112.8805867,
      "latitude":58.0642429
    },
    "4337":{
      "name":"\u0412\u0438\u0442\u0438\u043c\u0441\u043a\u0438\u0439",
      "longitude":113.262604,
      "latitude":58.219967
    },
    "4338":{
      "name":"\u041c\u0430\u043c\u0430\u043a\u0430\u043d",
      "longitude":114.018379,
      "latitude":57.817467
    },
    "4339":{
      "name":"\u0411\u0430\u043b\u0430\u0445\u043d\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":114.277977,
      "latitude":58.010555
    },
    "4340":{
      "name":"\u041c\u0430\u0440\u0430\u043a\u0430\u043d",
      "longitude":114.589676,
      "latitude":58.699581
    },
    "4341":{
      "name":"\u0410\u0440\u0442\u0451\u043c\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":114.628464,
      "latitude":58.205444
    },
    "4342":{
      "name":"\u041a\u0440\u043e\u043f\u043e\u0442\u043a\u0438\u043d",
      "longitude":115.300003,
      "latitude":58.503822
    },
    "4343":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u0435\u043b\u044c\u0441\u043a\u043e\u0435",
      "longitude":78.148651,
      "latitude":53.51746
    },
    "4344":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":78.1601485,
      "latitude":53.2450884
    },
    "4345":{
      "name":"\u041e\u0440\u0435\u0445\u043e\u0432\u043e",
      "longitude":78.2079218,
      "latitude":53.1309923
    },
    "4346":{
      "name":"\u041f\u0440\u0438\u0442\u044b\u043a\u0430",
      "longitude":78.2388944,
      "latitude":53.2645649
    },
    "4347":{
      "name":"\u0411\u0443\u0440\u043b\u0430",
      "longitude":78.3306842,
      "latitude":53.3364288
    },
    "4348":{
      "name":"\u041f\u0430\u0440\u0442\u0438\u0437\u0430\u043d\u0441\u043a\u043e\u0435",
      "longitude":78.3515271,
      "latitude":53.3459537
    },
    "4349":{
      "name":"\u041d\u043e\u0432\u043e\u0430\u043d\u0434\u0440\u0435\u0435\u0432\u043a\u0430",
      "longitude":78.3803152,
      "latitude":53.0404751
    },
    "4350":{
      "name":"\u0413\u0443\u0441\u0438\u043d\u0430\u044f \u041b\u044f\u0433\u0430",
      "longitude":78.39662,
      "latitude":53.4073133
    },
    "4351":{
      "name":"\u041f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":78.4038821,
      "latitude":52.9645039
    },
    "4352":{
      "name":"\u0413\u0440\u0430\u043d\u0438\u0447\u043d\u043e\u0435",
      "longitude":78.4323929,
      "latitude":52.8020678
    },
    "4353":{
      "name":"\u041a\u0430\u043c\u044b\u0448\u0435\u043d\u043a\u0430",
      "longitude":78.4438877,
      "latitude":52.7594817
    },
    "4354":{
      "name":"\u0411\u0443\u0440\u0441\u043e\u043b\u044c",
      "longitude":78.447762,
      "latitude":53.167122
    },
    "4355":{
      "name":"\u041d\u043e\u0432\u043e\u043f\u0435\u0441\u0447\u0430\u043d\u043e\u0435",
      "longitude":78.525757,
      "latitude":53.407501
    },
    "4356":{
      "name":"\u0421\u0435\u043b\u0435\u043a\u0446\u0438\u043e\u043d\u043d\u043e\u0435",
      "longitude":78.5954156,
      "latitude":52.9807137
    },
    "4357":{
      "name":"\u0410\u0440\u0445\u0430\u043d\u0433\u0435\u043b\u044c\u0441\u043a\u043e\u0435",
      "longitude":78.6461432,
      "latitude":53.0865182
    },
    "4358":{
      "name":"\u0421\u043b\u0430\u0432\u0433\u043e\u0440\u043e\u0434\u0441\u043a\u043e\u0435",
      "longitude":78.6484845,
      "latitude":53.0225426
    },
    "4359":{
      "name":"\u041f\u0440\u0438\u0433\u043e\u0440\u043e\u0434\u043d\u043e\u0435",
      "longitude":78.687943,
      "latitude":53.0024302
    },
    "4360":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":78.6949385,
      "latitude":52.7136103
    },
    "4361":{
      "name":"\u041b\u0435\u0441\u043d\u043e\u0435",
      "longitude":78.7106722,
      "latitude":53.5264264
    },
    "4362":{
      "name":"\u041f\u0438\u043e\u043d\u0435\u0440 \u0422\u0440\u0443\u0434\u0430",
      "longitude":79.0868506,
      "latitude":53.5470713
    },
    "4363":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":78.721214,
      "latitude":53.221813
    },
    "4364":{
      "name":"\u0423\u0441\u0442\u044c\u044f\u043d\u043a\u0430",
      "longitude":78.7421093,
      "latitude":53.451325
    },
    "4365":{
      "name":"\u0413\u0440\u0438\u0448\u043a\u043e\u0432\u043a\u0430",
      "longitude":78.750702,
      "latitude":53.14864
    },
    "4366":{
      "name":"\u0410\u043b\u0442\u0430\u0439\u0441\u043a\u043e\u0435",
      "longitude":78.761589,
      "latitude":52.785633
    },
    "4367":{
      "name":"\u041a\u0430\u043c\u044b\u0448\u0438",
      "longitude":78.780266,
      "latitude":53.336258
    },
    "4368":{
      "name":"\u0417\u0430\u0431\u0430\u0432\u043d\u043e\u0435",
      "longitude":78.79203,
      "latitude":52.831821
    },
    "4369":{
      "name":"\u0422\u0430\u0431\u0443\u043d\u044b",
      "longitude":78.792534,
      "latitude":52.769409
    },
    "4370":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0435\u0440\u043e\u043c\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":78.8637759,
      "latitude":52.9923021
    },
    "4371":{
      "name":"\u0423\u0434\u0430\u043b\u044c\u043d\u043e\u0435",
      "longitude":78.8646412,
      "latitude":52.8189717
    },
    "4372":{
      "name":"\u041e\u043a\u0442\u044f\u0431\u0440\u044c\u0441\u043a\u0438\u0439",
      "longitude":78.877045,
      "latitude":52.564869
    },
    "4373":{
      "name":"\u0422\u043e\u043f\u043e\u043b\u044c\u043d\u043e\u0435",
      "longitude":78.8881758,
      "latitude":53.5442171
    },
    "4374":{
      "name":"\u0421\u0430\u043c\u0431\u043e\u0440",
      "longitude":78.8970184,
      "latitude":52.7740262
    },
    "4375":{
      "name":"\u041d\u043e\u0432\u043e\u043f\u0435\u0442\u0440\u043e\u0432\u043a\u0430",
      "longitude":78.9144959,
      "latitude":52.5336642
    },
    "4376":{
      "name":"\u041f\u043e\u0434\u0441\u043e\u0441\u043d\u043e\u0432\u043e",
      "longitude":78.916634,
      "latitude":53.371777
    },
    "4377":{
      "name":"\u041a\u0443\u0440\u0441\u043a",
      "longitude":78.9225201,
      "latitude":52.4431763
    },
    "4378":{
      "name":"\u0428\u0443\u043c\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":78.92395,
      "latitude":53.258389
    },
    "4379":{
      "name":"\u041a\u0443\u0441\u0430\u043a",
      "longitude":78.936996,
      "latitude":53.222637
    },
    "4380":{
      "name":"\u0412\u0430\u0441\u0438\u043b\u044c\u0447\u0443\u043a\u0438",
      "longitude":78.952232,
      "latitude":52.27457
    },
    "4381":{
      "name":"\u041c\u044b\u0448\u043a\u0438\u043d\u043e",
      "longitude":78.965624,
      "latitude":52.5823042
    },
    "4382":{
      "name":"\u0421\u0435\u043c\u0451\u043d\u043e\u0432\u043a\u0430",
      "longitude":78.9803302,
      "latitude":53.0909677
    },
    "4383":{
      "name":"\u0413\u0430\u043b\u044c\u0431\u0448\u0442\u0430\u0434\u0442",
      "longitude":78.988144,
      "latitude":53.225803
    },
    "4384":{
      "name":"\u041c\u0438\u0440\u0430\u0431\u0438\u043b\u0438\u0442",
      "longitude":79.0237651,
      "latitude":52.5635322
    },
    "4385":{
      "name":"\u0420\u0435\u0434\u043a\u0430\u044f \u0414\u0443\u0431\u0440\u0430\u0432\u0430",
      "longitude":79.041542,
      "latitude":53.280098
    },
    "4386":{
      "name":"\u0411\u043e\u0433\u0430\u0442\u0441\u043a\u043e\u0435",
      "longitude":79.051984,
      "latitude":53.4683252
    },
    "4387":{
      "name":"\u0412\u043e\u0437\u0434\u0432\u0438\u0436\u0435\u043d\u043a\u0430",
      "longitude":79.0662673,
      "latitude":52.7576699
    },
    "4388":{
      "name":"\u041a\u043e\u043d\u0441\u0442\u0430\u043d\u0442\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":79.0721965,
      "latitude":52.6179794
    },
    "4389":{
      "name":"\u0412\u0438\u043d\u043e\u0433\u0440\u0430\u0434\u043e\u0432\u043a\u0430",
      "longitude":79.0831102,
      "latitude":52.4622941
    },
    "4390":{
      "name":"\u041d\u043e\u0432\u043e\u0444\u0451\u0434\u043e\u0440\u043e\u0432\u043a\u0430",
      "longitude":79.1156426,
      "latitude":53.6642724
    },
    "4391":{
      "name":"\u0421\u0430\u0440\u0430\u0442\u043e\u0432\u043a\u0430",
      "longitude":79.1224039,
      "latitude":52.8799005
    },
    "4392":{
      "name":"\u041f\u0440\u043e\u0442\u0430\u0441\u043e\u0432\u043e",
      "longitude":79.171829,
      "latitude":53.423397
    },
    "4393":{
      "name":"\u041d\u043e\u0432\u043e\u0432\u043e\u0437\u043d\u0435\u0441\u0435\u043d\u043a\u0430",
      "longitude":79.180575,
      "latitude":53.1366425
    },
    "4394":{
      "name":"\u0421\u0435\u0440\u0435\u0431\u0440\u043e\u043f\u043e\u043b\u044c",
      "longitude":79.20443,
      "latitude":52.883896
    },
    "4395":{
      "name":"\u0425\u043e\u0440\u043e\u0448\u0435\u0435",
      "longitude":79.213791,
      "latitude":52.939808
    },
    "4396":{
      "name":"\u041f\u043e\u043b\u0435\u0432\u043e\u0435",
      "longitude":79.2287848,
      "latitude":53.3835077
    },
    "4397":{
      "name":"\u0426\u0435\u043b\u0438\u043d\u043d\u044b\u0439",
      "longitude":79.2330146,
      "latitude":52.2564531
    },
    "4398":{
      "name":"\u041e\u0440\u043b\u043e\u0432\u043e",
      "longitude":79.2379171,
      "latitude":53.3184179
    },
    "4399":{
      "name":"\u0421\u043c\u0438\u0440\u043d\u0435\u043d\u044c\u043a\u043e\u0435",
      "longitude":79.24379,
      "latitude":52.527794
    },
    "4400":{
      "name":"\u041d\u043e\u0432\u043e\u0438\u043b\u044c\u0438\u043d\u043a\u0430",
      "longitude":79.260155,
      "latitude":53.560623
    },
    "4401":{
      "name":"\u0417\u043b\u0430\u0442\u043e\u043f\u043e\u043b\u044c",
      "longitude":79.263321,
      "latitude":52.627815
    },
    "4402":{
      "name":"\u0421\u0435\u0432\u0435\u0440\u043a\u0430",
      "longitude":79.271057,
      "latitude":52.126987
    },
    "4403":{
      "name":"\u0418\u0441\u0442\u0438\u043c\u0438\u0441",
      "longitude":79.2914701,
      "latitude":52.3682809
    },
    "4404":{
      "name":"\u041b\u0435\u0431\u0435\u0434\u0438\u043d\u043e",
      "longitude":79.2989979,
      "latitude":52.7862204
    },
    "4405":{
      "name":"\u0421\u0435\u043c\u0451\u043d\u043e\u0432\u043a\u0430",
      "longitude":79.322151,
      "latitude":52.55624
    },
    "4406":{
      "name":"\u0420\u0430\u0441\u0441\u0432\u0435\u0442",
      "longitude":79.3256078,
      "latitude":53.5016467
    },
    "4407":{
      "name":"\u041d\u043e\u0432\u043e\u043f\u043e\u043b\u0442\u0430\u0432\u0430",
      "longitude":79.3382532,
      "latitude":52.4132456
    },
    "4408":{
      "name":"\u0423\u0441\u043f\u0435\u043d\u043a\u0430",
      "longitude":79.3487449,
      "latitude":52.9253833
    },
    "4409":{
      "name":"\u0414\u0435\u0433\u0442\u044f\u0440\u043a\u0430",
      "longitude":79.357559,
      "latitude":53.344326
    },
    "4410":{
      "name":"\u041f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":79.3641106,
      "latitude":52.0468272
    },
    "4411":{
      "name":"\u0415\u043b\u0438\u0437\u0430\u0432\u0435\u0442\u0433\u0440\u0430\u0434",
      "longitude":79.366707,
      "latitude":52.784294
    },
    "4412":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":79.4148067,
      "latitude":51.9260024
    },
    "4413":{
      "name":"\u0423\u0442\u044f\u043d\u043a\u0430",
      "longitude":79.4569075,
      "latitude":53.596362
    },
    "4414":{
      "name":"\u0411\u0430\u0441\u0442\u0430\u043d",
      "longitude":79.4707278,
      "latitude":51.8623659
    },
    "4415":{
      "name":"\u0417\u043d\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":79.4826029,
      "latitude":53.1612894
    },
    "4416":{
      "name":"\u041c\u0430\u0440\u0442\u043e\u0432\u043a\u0430",
      "longitude":79.5209468,
      "latitude":53.4421711
    },
    "4417":{
      "name":"\u0425\u0430\u0431\u0430\u0440\u044b",
      "longitude":79.537766,
      "latitude":53.624283
    },
    "4418":{
      "name":"\u0422\u0435\u043b\u044c\u043c\u0430\u043d\u0441\u043a\u0438\u0439",
      "longitude":79.5463261,
      "latitude":52.7967706
    },
    "4419":{
      "name":"\u041f\u0435\u0442\u0443\u0445\u0438",
      "longitude":79.5470709,
      "latitude":52.2388349
    },
    "4420":{
      "name":"\u0410\u043d\u0430\u043d\u044c\u0435\u0432\u043a\u0430",
      "longitude":79.578979,
      "latitude":52.57793
    },
    "4421":{
      "name":"\u041e\u0440\u043b\u0435\u0430\u043d",
      "longitude":79.5979979,
      "latitude":52.6851948
    },
    "4422":{
      "name":"\u042f\u0433\u043e\u0442\u0438\u043d\u043e",
      "longitude":79.6304808,
      "latitude":52.7457026
    },
    "4423":{
      "name":"\u041c\u0430\u043b\u043e\u043f\u0430\u0432\u043b\u043e\u0432\u043a\u0430",
      "longitude":79.6311707,
      "latitude":53.4331163
    },
    "4424":{
      "name":"\u042f\u0441\u043d\u0430\u044f \u041f\u043e\u043b\u044f\u043d\u0430",
      "longitude":79.6323698,
      "latitude":53.5192928
    },
    "4425":{
      "name":"\u0417\u0435\u043b\u0451\u043d\u0430\u044f \u041f\u043e\u043b\u044f\u043d\u0430",
      "longitude":79.6339451,
      "latitude":52.4022801
    },
    "4426":{
      "name":"\u041d\u043e\u0432\u043e\u0432\u0430\u0441\u0438\u043b\u044c\u0435\u0432\u043a\u0430",
      "longitude":79.6405938,
      "latitude":53.3935986
    },
    "4427":{
      "name":"\u041d\u0430\u0437\u0430\u0440\u043e\u0432\u043a\u0430",
      "longitude":79.6424053,
      "latitude":52.0273027
    },
    "4428":{
      "name":"\u0414\u043e\u0431\u0440\u043e\u0432\u043e\u043b\u044c\u0449\u0438\u043d\u0430",
      "longitude":79.6460996,
      "latitude":53.292923
    },
    "4429":{
      "name":"\u0421\u0432\u0435\u0440\u0434\u043b\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":79.6741434,
      "latitude":53.3274952
    },
    "4430":{
      "name":"\u0424\u0435\u0434\u043e\u0442\u043e\u0432\u043a\u0430",
      "longitude":79.67543,
      "latitude":52.350822
    },
    "4431":{
      "name":"\u041a\u043e\u0440\u043e\u0442\u043e\u044f\u043a",
      "longitude":79.688622,
      "latitude":53.759254
    },
    "4432":{
      "name":"\u041f\u043e\u043b\u0443\u044f\u043c\u043a\u0438",
      "longitude":79.699286,
      "latitude":52.0751853
    },
    "4433":{
      "name":"\u0426\u0435\u043b\u0438\u043d\u043d\u044b\u0439",
      "longitude":79.7040901,
      "latitude":53.767878
    },
    "4434":{
      "name":"\u0438\u043c\u0435\u043d\u0438 \u0412\u043b\u0430\u0434\u0438\u043c\u0438\u0440\u0430 \u0418\u043b\u044c\u0438\u0447\u0430",
      "longitude":79.7107358,
      "latitude":53.2383392
    },
    "4435":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":79.7155613,
      "latitude":51.3753705
    },
    "4436":{
      "name":"\u0420\u0430\u0437\u0443\u043c\u043e\u0432\u043a\u0430",
      "longitude":79.7251321,
      "latitude":52.5541752
    },
    "4437":{
      "name":"\u041c\u0438\u0447\u0443\u0440\u0438\u043d\u0441\u043a\u043e\u0435",
      "longitude":79.7359757,
      "latitude":53.477089
    },
    "4438":{
      "name":"\u0423\u0441\u0442\u044c-\u041a\u0443\u0440\u044c\u044f",
      "longitude":79.7383732,
      "latitude":53.6649952
    },
    "4439":{
      "name":"\u041d\u043e\u0432\u043e\u043f\u043b\u043e\u0442\u0430\u0432\u0430",
      "longitude":79.75116,
      "latitude":53.517361
    },
    "4440":{
      "name":"\u041c\u0430\u0440\u043a\u043e\u0432\u043a\u0430",
      "longitude":79.7686117,
      "latitude":52.4284275
    },
    "4441":{
      "name":"\u041c\u0430\u043b\u0438\u043d\u043e\u0432\u043e\u0435 \u041e\u0437\u0435\u0440\u043e",
      "longitude":79.770782,
      "latitude":51.675251
    },
    "4442":{
      "name":"\u0410\u0449\u0435\u0433\u0443\u043b\u044c",
      "longitude":79.7789191,
      "latitude":52.128604
    },
    "4443":{
      "name":"\u041a\u0430\u0438\u043f",
      "longitude":79.7841574,
      "latitude":52.2478896
    },
    "4444":{
      "name":"\u041f\u0430\u0432\u043b\u043e\u0432\u043a\u0430",
      "longitude":79.7945565,
      "latitude":51.3946384
    },
    "4445":{
      "name":"\u041d\u0435\u0447\u0430\u0435\u0432\u043a\u0430",
      "longitude":79.795676,
      "latitude":53.3501366
    },
    "4446":{
      "name":"\u0421\u043c\u0438\u0440\u043d\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":79.8104526,
      "latitude":53.8040653
    },
    "4447":{
      "name":"\u0412\u0430\u0441\u0438\u043b\u044c\u0435\u0432\u043a\u0430",
      "longitude":79.8306973,
      "latitude":53.5779805
    },
    "4448":{
      "name":"\u041f\u043e\u043f\u0435\u0440\u0435\u0447\u043d\u043e\u0435",
      "longitude":79.8372034,
      "latitude":53.4675005
    },
    "4449":{
      "name":"\u0421\u0435\u0440\u043f \u0438 \u041c\u043e\u043b\u043e\u0442",
      "longitude":79.8568742,
      "latitude":53.6687951
    },
    "4450":{
      "name":"\u0420\u0430\u043a\u0438\u0442\u044b",
      "longitude":79.8837791,
      "latitude":51.8467565
    },
    "4451":{
      "name":"\u041d\u0438\u0436\u043d\u044f\u044f \u0421\u0443\u0435\u0442\u043a\u0430",
      "longitude":79.89518,
      "latitude":53.225769
    },
    "4452":{
      "name":"\u041f\u043b\u0451\u0441\u043e-\u041a\u0443\u0440\u044c\u044f",
      "longitude":79.9101083,
      "latitude":53.6298396
    },
    "4453":{
      "name":"\u041e\u043a\u0442\u044f\u0431\u0440\u044c\u0441\u043a\u0438\u0439",
      "longitude":79.9234545,
      "latitude":53.3211078
    },
    "4454":{
      "name":"\u0423\u0440\u044b\u0432\u0430\u0435\u0432\u043e",
      "longitude":79.9405078,
      "latitude":53.7977019
    },
    "4455":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0439 \u041a\u0443\u0447\u0443\u043a",
      "longitude":79.9411564,
      "latitude":52.7141051
    },
    "4456":{
      "name":"\u0417\u044f\u0442\u044c\u043a\u043e\u0432\u0430 \u0420\u0435\u0447\u043a\u0430",
      "longitude":79.9461837,
      "latitude":53.4738395
    },
    "4457":{
      "name":"\u0420\u0430\u0437\u0434\u043e\u043b\u044c\u043d\u043e\u0435",
      "longitude":79.950834,
      "latitude":52.4957597
    },
    "4458":{
      "name":"\u0428\u0430\u0442\u0430\u043b\u043e\u0432\u043a\u0430",
      "longitude":79.9588978,
      "latitude":52.3975712
    },
    "4459":{
      "name":"\u041c\u0435\u043b\u044c\u043d\u0438\u043a\u043e\u0432\u043a\u0430",
      "longitude":79.9631118,
      "latitude":53.1513832
    },
    "4460":{
      "name":"\u041c\u0438\u0440\u043d\u044b\u0439",
      "longitude":79.9644874,
      "latitude":51.4229018
    },
    "4461":{
      "name":"\u0428\u0430\u0434\u0440\u0443\u0445\u0430",
      "longitude":79.9644932,
      "latitude":51.1652597
    },
    "4462":{
      "name":"\u0428\u0438\u043c\u043e\u043b\u0438\u043d\u043e",
      "longitude":79.979637,
      "latitude":53.000111
    },
    "4463":{
      "name":"\u041e\u0441\u0438\u043d\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":80.0253253,
      "latitude":53.2529573
    },
    "4464":{
      "name":"\u0412\u0435\u0440\u0445-\u0421\u0443\u0435\u0442\u043a\u0430",
      "longitude":80.05072,
      "latitude":53.303879
    },
    "4465":{
      "name":"\u0417\u044b\u043a\u043e\u0432\u043e",
      "longitude":80.0769278,
      "latitude":53.8273487
    },
    "4466":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u043e\u0440\u043c\u0438\u0445\u0430",
      "longitude":80.0837484,
      "latitude":52.1676641
    },
    "4467":{
      "name":"\u0411\u043e\u0440\u043e\u043d\u0441\u043a\u0438\u0439",
      "longitude":80.090034,
      "latitude":53.17149
    },
    "4468":{
      "name":"\u042f\u0440\u043e\u0441\u043b\u0430\u0432\u0446\u0435\u0432 \u041b\u043e\u0433",
      "longitude":80.0918309,
      "latitude":52.2731563
    },
    "4469":{
      "name":"\u041f\u0440\u0435\u0433\u0440\u0430\u0434\u0438\u043d\u043a\u0430",
      "longitude":80.0956612,
      "latitude":52.8080526
    },
    "4470":{
      "name":"\u0422\u043e\u043f\u043e\u043b\u044c\u043d\u043e\u0435",
      "longitude":80.105412,
      "latitude":50.9360575
    },
    "4471":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":80.1103783,
      "latitude":52.0743214
    },
    "4472":{
      "name":"\u0414\u043e\u043b\u0438\u043d\u043a\u0430",
      "longitude":80.114754,
      "latitude":53.029842
    },
    "4473":{
      "name":"\u0411\u043e\u0440-\u0424\u043e\u0440\u043f\u043e\u0441\u0442",
      "longitude":80.1181888,
      "latitude":51.8763927
    },
    "4474":{
      "name":"\u0421\u0443\u0432\u043e\u0440\u043e\u0432\u043a\u0430",
      "longitude":80.12183,
      "latitude":52.802063
    },
    "4475":{
      "name":"\u0411\u0435\u043b\u0435\u043d\u044c\u043a\u043e\u0435",
      "longitude":80.130067,
      "latitude":50.9908536
    },
    "4476":{
      "name":"\u0417\u0435\u043b\u0451\u043d\u044b\u0439 \u041b\u0443\u0433",
      "longitude":80.139314,
      "latitude":52.3748329
    },
    "4477":{
      "name":"\u0411\u0435\u0440\u0435\u0433\u043e\u0432\u043e\u0435",
      "longitude":80.1394249,
      "latitude":53.761292
    },
    "4478":{
      "name":"\u041d\u043e\u0432\u043e\u0442\u0440\u043e\u0438\u0446\u043a",
      "longitude":80.1488182,
      "latitude":52.6536596
    },
    "4479":{
      "name":"\u041a\u0440\u0438\u0432\u043e\u0435",
      "longitude":80.1557585,
      "latitude":53.6834223
    },
    "4480":{
      "name":"\u0412\u0435\u043b\u0438\u0436\u0430\u043d\u043a\u0430",
      "longitude":80.1592086,
      "latitude":53.8651376
    },
    "4481":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u0443\u043b\u0443\u043d\u0434\u0438\u043d\u043a\u0430",
      "longitude":80.1608862,
      "latitude":53.0458179
    },
    "4482":{
      "name":"\u041c\u0438\u0440\u043d\u044b\u0439",
      "longitude":80.1648179,
      "latitude":52.5587813
    },
    "4483":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":80.173584,
      "latitude":52.957729
    },
    "4484":{
      "name":"\u0411\u043e\u0440\u0438\u0441\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":80.1816475,
      "latitude":53.5570418
    },
    "4485":{
      "name":"\u041b\u0430\u043f\u0442\u0435\u0432 \u041b\u043e\u0433",
      "longitude":80.1859039,
      "latitude":51.062905
    },
    "4486":{
      "name":"\u0423\u0433\u043b\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":80.188408,
      "latitude":51.363693
    },
    "4487":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":80.1995712,
      "latitude":53.2303601
    },
    "4488":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":80.2131564,
      "latitude":53.1823476
    },
    "4489":{
      "name":"\u041a\u043e\u043c\u0438\u043d\u0442\u0435\u0440\u043d",
      "longitude":80.2149654,
      "latitude":52.1755193
    },
    "4490":{
      "name":"\u0411\u043e\u0440\u0438\u0441\u043e\u0432\u043a\u0430",
      "longitude":80.230732,
      "latitude":51.1318917
    },
    "4491":{
      "name":"\u0422\u0430\u0442\u044c\u044f\u043d\u043e\u0432\u043a\u0430",
      "longitude":80.23439,
      "latitude":52.980358
    },
    "4492":{
      "name":"\u0423\u0441\u0442\u044c-\u0412\u043e\u043b\u0447\u0438\u0445\u0430",
      "longitude":80.2510172,
      "latitude":51.8989539
    },
    "4493":{
      "name":"\u0413\u043b\u044f\u0434\u0435\u043d\u044c",
      "longitude":80.257599,
      "latitude":52.763313
    },
    "4494":{
      "name":"\u0413\u043b\u044f\u0434\u0435\u043d\u044c-3",
      "longitude":80.2611076,
      "latitude":52.7298925
    },
    "4495":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":80.266343,
      "latitude":53.7481589
    },
    "4496":{
      "name":"\u041e\u0437\u0451\u0440\u043d\u043e-\u041a\u0443\u0437\u043d\u0435\u0446\u043e\u0432\u0441\u043a\u0438\u0439 \u041b\u0435\u0441\u0445\u043e\u0437",
      "longitude":80.2668106,
      "latitude":51.548166
    },
    "4497":{
      "name":"\u041b\u0443\u043a\u043e\u0432\u043a\u0430",
      "longitude":80.2725621,
      "latitude":53.9171105
    },
    "4498":{
      "name":"\u0413\u043b\u044f\u0434\u0435\u043d\u044c-2",
      "longitude":80.278282,
      "latitude":52.78878
    },
    "4499":{
      "name":"\u041f\u044f\u0442\u043a\u043e\u0432 \u041b\u043e\u0433",
      "longitude":80.2809581,
      "latitude":52.2227193
    },
    "4500":{
      "name":"\u041d\u043e\u0432\u043e\u0443\u0433\u043b\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":80.2871945,
      "latitude":51.4468609
    },
    "4501":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u0410\u043b\u0442\u0430\u0439",
      "longitude":80.298961,
      "latitude":52.2878506
    },
    "4502":{
      "name":"\u0412\u0435\u0440\u0445-\u041f\u0430\u0439\u0432\u0430",
      "longitude":80.3104533,
      "latitude":53.4035438
    },
    "4503":{
      "name":"\u0417\u044f\u0442\u044c\u043a\u043e\u0432\u043e",
      "longitude":80.3409389,
      "latitude":53.5972512
    },
    "4504":{
      "name":"\u041d\u0438\u0436\u043d\u0435\u043f\u0430\u0439\u0432\u0430",
      "longitude":80.351873,
      "latitude":53.3207334
    },
    "4505":{
      "name":"\u0421\u0442\u0435\u043f\u043d\u043e\u0439 \u041a\u0443\u0447\u0443\u043a",
      "longitude":80.3535351,
      "latitude":52.6006901
    },
    "4506":{
      "name":"\u0412\u0430\u043b\u043e\u0432\u043e\u0439 \u041a\u043e\u0440\u0434\u043e\u043d",
      "longitude":80.3561622,
      "latitude":51.7861562
    },
    "4507":{
      "name":"\u041e\u0437\u0451\u0440\u043d\u043e-\u041a\u0443\u0437\u043d\u0435\u0446\u043e\u0432\u043e",
      "longitude":80.3583254,
      "latitude":51.5144008
    },
    "4508":{
      "name":"\u0421\u0438\u043c\u043e\u043d\u043e\u0432\u043e",
      "longitude":80.382612,
      "latitude":51.6866245
    },
    "4509":{
      "name":"\u041f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":80.3883307,
      "latitude":52.766777
    },
    "4510":{
      "name":"\u0426\u0435\u043d\u0442\u0440\u0430\u043b\u044c\u043d\u043e\u0435",
      "longitude":80.4112056,
      "latitude":52.300648
    },
    "4511":{
      "name":"\u041b\u0435\u043d\u044c\u043a\u0438",
      "longitude":80.429916,
      "latitude":52.938488
    },
    "4512":{
      "name":"\u0412\u044f\u0447\u0435\u0441\u043b\u0430\u0432\u043a\u0430",
      "longitude":80.4387734,
      "latitude":52.8179921
    },
    "4513":{
      "name":"\u041d\u0430\u0443\u043c\u043e\u0432\u043a\u0430",
      "longitude":80.4390241,
      "latitude":51.0282993
    },
    "4514":{
      "name":"\u041a\u0440\u0443\u0433\u043b\u043e\u0435",
      "longitude":80.4461259,
      "latitude":51.291007
    },
    "4515":{
      "name":"\u041a\u0430\u044f\u0443\u0448\u043a\u0430",
      "longitude":80.4569781,
      "latitude":52.4914697
    },
    "4516":{
      "name":"\u0412\u043e\u0437\u043d\u0435\u0441\u0435\u043d\u043a\u0430",
      "longitude":80.4575129,
      "latitude":52.3405099
    },
    "4517":{
      "name":"\u041f\u043e\u0434\u043e\u0439\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":80.4682618,
      "latitude":53.8671827
    },
    "4518":{
      "name":"\u0421\u0442\u0435\u043f\u043d\u043e\u0435",
      "longitude":80.4814275,
      "latitude":52.6333028
    },
    "4519":{
      "name":"\u041f\u0440\u0430\u0432\u0434\u0430",
      "longitude":80.5007859,
      "latitude":52.0893585
    },
    "4520":{
      "name":"\u0420\u043e\u043c\u0430\u043d\u043e\u0432\u043e",
      "longitude":80.5050291,
      "latitude":53.9663265
    },
    "4521":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":80.539665,
      "latitude":52.895592
    },
    "4522":{
      "name":"\u041a\u0443\u0439\u0431\u044b\u0448\u0435\u0432\u043e",
      "longitude":80.5727482,
      "latitude":51.3536119
    },
    "4523":{
      "name":"\u0412\u0435\u0440\u0445-\u0427\u0443\u043c\u0430\u043d\u043a\u0430",
      "longitude":80.5932998,
      "latitude":53.4034175
    },
    "4524":{
      "name":"\u041d\u0438\u0436\u043d\u0435\u0447\u0443\u043c\u0430\u043d\u043a\u0430",
      "longitude":80.594182,
      "latitude":53.2247968
    },
    "4525":{
      "name":"\u041a\u0430\u043c\u044b\u0448\u0435\u043d\u043a\u0430",
      "longitude":80.6041963,
      "latitude":52.7023047
    },
    "4526":{
      "name":"\u0427\u0435\u0440\u043d\u0430\u0432\u043a\u0430",
      "longitude":80.609512,
      "latitude":52.664013
    },
    "4527":{
      "name":"\u0412\u0442\u043e\u0440\u044b\u0435 \u041a\u043e\u0440\u043e\u0441\u0442\u0435\u043b\u0438",
      "longitude":80.6198483,
      "latitude":51.4014774
    },
    "4528":{
      "name":"\u0412\u044b\u0441\u043e\u043a\u0430\u044f \u0413\u0440\u0438\u0432\u0430",
      "longitude":80.6453315,
      "latitude":53.9176684
    },
    "4529":{
      "name":"\u0412\u043e\u0441\u0442\u0440\u043e\u0432\u043e",
      "longitude":80.6455227,
      "latitude":52.1478176
    },
    "4530":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u0428\u0435\u043b\u043a\u043e\u0432\u043a\u0430",
      "longitude":80.6506472,
      "latitude":51.4191969
    },
    "4531":{
      "name":"\u041a\u043e\u0447\u043a\u0438",
      "longitude":80.6550895,
      "latitude":52.3896372
    },
    "4532":{
      "name":"\u041f\u0440\u0438\u0431\u043e\u0440\u043e\u0432\u043e\u0435",
      "longitude":80.679415,
      "latitude":52.1572564
    },
    "4533":{
      "name":"\u0424\u0438\u043b\u0438\u043f\u043f\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":80.6850888,
      "latitude":53.6336928
    },
    "4534":{
      "name":"\u0413\u043b\u0443\u0431\u043e\u043a\u043e\u0435",
      "longitude":80.68885,
      "latitude":52.990131
    },
    "4535":{
      "name":"\u0422\u0443\u043c\u0430\u043d\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":80.6891083,
      "latitude":52.8559552
    },
    "4536":{
      "name":"\u0420\u0430\u043a\u0438\u0442\u044b",
      "longitude":80.7033331,
      "latitude":51.4509886
    },
    "4537":{
      "name":"\u041f\u043b\u043e\u0442\u0430\u0432\u0430",
      "longitude":80.7377931,
      "latitude":53.460623
    },
    "4538":{
      "name":"\u0421\u0438\u0434\u043e\u0440\u043e\u0432\u043a\u0430",
      "longitude":80.7499973,
      "latitude":52.5479257
    },
    "4539":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u0428\u0435\u043b\u043a\u043e\u0432\u043a\u0430",
      "longitude":80.7516965,
      "latitude":51.4966826
    },
    "4540":{
      "name":"\u0412\u043e\u043b\u0447\u043d\u043e-\u0411\u0443\u0440\u043b\u0438\u043d\u0441\u043a\u043e\u0435",
      "longitude":80.7696,
      "latitude":54.051731
    },
    "4541":{
      "name":"\u041f\u043e\u043f\u0435\u0440\u0435\u0447\u043d\u043e\u0435",
      "longitude":80.7702245,
      "latitude":53.56418
    },
    "4542":{
      "name":"\u0427\u0438\u0441\u0442\u043e\u043e\u0437\u0451\u0440\u043a\u0430",
      "longitude":80.775673,
      "latitude":52.77
    },
    "4543":{
      "name":"\u041f\u0440\u044b\u0433\u0430\u043d\u043a\u0430",
      "longitude":80.7943442,
      "latitude":53.960872
    },
    "4544":{
      "name":"\u0428\u0443\u0431\u0438\u043d\u043a\u0430",
      "longitude":80.7955189,
      "latitude":51.6061945
    },
    "4545":{
      "name":"\u0421\u043e\u043b\u043e\u043d\u043e\u0432\u043a\u0430",
      "longitude":80.8031108,
      "latitude":52.2203046
    },
    "4546":{
      "name":"\u041c\u0430\u043b\u0438\u043d\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":80.8051217,
      "latitude":52.9665559
    },
    "4547":{
      "name":"\u041f\u0435\u0440\u0435\u0448\u0435\u0435\u0447\u043d\u044b\u0439",
      "longitude":80.8410474,
      "latitude":51.7219135
    },
    "4548":{
      "name":"\u041b\u0435\u0431\u044f\u0436\u044c\u0435",
      "longitude":80.84909,
      "latitude":51.6910713
    },
    "4549":{
      "name":"\u0414\u0443\u0431\u0440\u043e\u0432\u0438\u043d\u043e",
      "longitude":80.8754131,
      "latitude":52.6836229
    },
    "4550":{
      "name":"\u041d\u043e\u0432\u043e\u044f\u0440\u043a\u0438",
      "longitude":80.8756283,
      "latitude":53.59529
    },
    "4551":{
      "name":"\u041a\u0440\u0443\u0433\u043b\u043e-\u0421\u0435\u043c\u0435\u043d\u0446\u044b",
      "longitude":80.8965192,
      "latitude":51.5305565
    },
    "4552":{
      "name":"\u041c\u0430\u043b\u043e\u0432\u043e\u043b\u0447\u0430\u043d\u043a\u0430",
      "longitude":80.9036511,
      "latitude":54.072589
    },
    "4553":{
      "name":"\u041c\u0430\u043b\u044b\u0448\u0435\u0432 \u041b\u043e\u0433",
      "longitude":80.9174807,
      "latitude":52.1553854
    },
    "4554":{
      "name":"\u0417\u0430\u0432\u044c\u044f\u043b\u043e\u0432\u043e",
      "longitude":80.920074,
      "latitude":52.838428
    },
    "4555":{
      "name":"\u0422\u043e\u043b\u0441\u0442\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":80.936771,
      "latitude":53.6803275
    },
    "4556":{
      "name":"\u0421\u0438\u0442\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":80.9407571,
      "latitude":53.1328107
    },
    "4557":{
      "name":"\u0425\u0430\u0440\u0438\u0442\u043e\u043d\u043e\u0432\u043e",
      "longitude":80.9420525,
      "latitude":53.0288735
    },
    "4558":{
      "name":"\u0421\u0435\u043b\u0438\u0432\u0451\u0440\u0441\u0442\u043e\u0432\u043e",
      "longitude":80.9549348,
      "latitude":52.2959412
    },
    "4559":{
      "name":"\u0413\u0440\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":80.9700793,
      "latitude":52.4106365
    },
    "4560":{
      "name":"\u041f\u0440\u043e\u0441\u043b\u0430\u0443\u0445\u0430",
      "longitude":80.9707663,
      "latitude":53.3380692
    },
    "4561":{
      "name":"\u0422\u0430\u043c\u0431\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":80.9843796,
      "latitude":52.6526919
    },
    "4562":{
      "name":"\u0417\u0430\u043a\u043b\u0430\u0434\u043d\u043e\u0435",
      "longitude":80.9969935,
      "latitude":52.5831383
    },
    "4563":{
      "name":"\u041f\u043e\u0434\u0431\u043e\u0440\u043d\u044b\u0439",
      "longitude":81.0037093,
      "latitude":53.998866
    },
    "4564":{
      "name":"\u0411\u0443\u044f\u043d",
      "longitude":81.004657,
      "latitude":53.8215683
    },
    "4565":{
      "name":"\u0421\u0440\u043e\u0441\u0442\u044b",
      "longitude":81.0121083,
      "latitude":51.8940598
    },
    "4566":{
      "name":"\u0414\u043e\u043b\u0433\u0430\u043d\u043a\u0430",
      "longitude":81.0401398,
      "latitude":54.1363865
    },
    "4567":{
      "name":"\u0421\u0432\u0435\u0442\u043b\u043e\u0435",
      "longitude":81.0549843,
      "latitude":52.9081232
    },
    "4568":{
      "name":"\u041a\u043e\u0440\u043d\u0438\u043b\u043e\u0432\u043e",
      "longitude":81.0653599,
      "latitude":53.5219297
    },
    "4569":{
      "name":"\u0413\u0438\u043b\u0451\u0432-\u041b\u043e\u0433",
      "longitude":81.0839156,
      "latitude":52.7740079
    },
    "4570":{
      "name":"\u0413\u0438\u043b\u0451\u0432\u043a\u0430",
      "longitude":81.105789,
      "latitude":52.860867
    },
    "4571":{
      "name":"\u0412\u0435\u0441\u0435\u043b\u043e\u044f\u0440\u0441\u043a",
      "longitude":81.1067348,
      "latitude":51.2858452
    },
    "4572":{
      "name":"\u041f\u0430\u043a\u043b\u0438\u043d\u043e",
      "longitude":81.1075008,
      "latitude":53.1416739
    },
    "4573":{
      "name":"\u041f\u0443\u0448\u043a\u0438\u043d\u043e",
      "longitude":81.1175374,
      "latitude":51.5284304
    },
    "4574":{
      "name":"\u041e\u043a\u0442\u044f\u0431\u0440\u044c\u0441\u043a\u0438\u0439",
      "longitude":81.1237407,
      "latitude":53.7140063
    },
    "4575":{
      "name":"\u041a\u0443\u0439\u0431\u044b\u0448\u0435\u0432\u043e",
      "longitude":81.1326084,
      "latitude":51.5785555
    },
    "4576":{
      "name":"\u041a\u043e\u043b\u043e\u0441",
      "longitude":81.137423,
      "latitude":51.424238
    },
    "4577":{
      "name":"\u0422\u0438\u0442\u043e\u0432\u043a\u0430",
      "longitude":81.1413638,
      "latitude":52.0085812
    },
    "4578":{
      "name":"\u041c\u0438\u0447\u0443\u0440\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":81.154625,
      "latitude":51.463699
    },
    "4579":{
      "name":"\u0411\u0443\u0440\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":81.15769,
      "latitude":52.4375426
    },
    "4580":{
      "name":"\u041d\u043e\u0432\u0435\u043d\u044c\u043a\u043e\u0435",
      "longitude":81.1581611,
      "latitude":51.0596632
    },
    "4581":{
      "name":"\u041d\u043e\u0432\u043e\u0430\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":81.1635281,
      "latitude":51.3746167
    },
    "4582":{
      "name":"\u0412\u0435\u0442\u0440\u0435\u043d\u043d\u043e-\u0422\u0435\u043b\u0435\u0443\u0442\u0441\u043a\u043e\u0435",
      "longitude":81.171779,
      "latitude":53.4602729
    },
    "4583":{
      "name":"\u041a\u0443\u043b\u0443\u043d\u0434\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":81.1774654,
      "latitude":53.2275868
    },
    "4584":{
      "name":"\u0417\u0435\u043b\u0451\u043d\u0430\u044f \u0414\u0443\u0431\u0440\u0430\u0432\u0430",
      "longitude":81.184067,
      "latitude":51.459007
    },
    "4585":{
      "name":"\u0410\u043d\u0434\u0440\u043e\u043d\u043e\u0432\u043e",
      "longitude":81.1860556,
      "latitude":53.31869
    },
    "4586":{
      "name":"\u0411\u043e\u0440\u043e\u0432\u043e\u0435",
      "longitude":81.1873738,
      "latitude":54.031538
    },
    "4587":{
      "name":"\u0414\u043e\u043b\u0433\u043e\u0432\u043e",
      "longitude":81.1889273,
      "latitude":52.3467592
    },
    "4588":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u043c\u0430\u0439\u0441\u043a\u043e\u0435",
      "longitude":81.1927471,
      "latitude":51.7376971
    },
    "4589":{
      "name":"\u0417\u0430\u043a\u043e\u0432\u0440\u044f\u0448\u0438\u043d\u043e",
      "longitude":81.1959431,
      "latitude":53.8946914
    },
    "4590":{
      "name":"\u041f\u0440\u0438\u043e\u0437\u0451\u0440\u043d\u044b\u0439",
      "longitude":81.2023519,
      "latitude":51.5730507
    },
    "4591":{
      "name":"\u041b\u043e\u043a\u043e\u0442\u044c",
      "longitude":81.20356,
      "latitude":51.18935
    },
    "4592":{
      "name":"\u041c\u0435\u043b\u044c\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":81.208969,
      "latitude":52.204197
    },
    "4593":{
      "name":"\u041e\u0432\u0435\u0447\u043a\u0438\u043d\u043e",
      "longitude":81.210309,
      "latitude":52.9973187
    },
    "4594":{
      "name":"\u041c\u043e\u0440\u043c\u044b\u0448\u0438",
      "longitude":81.2110603,
      "latitude":52.4529541
    },
    "4595":{
      "name":"\u041a\u0440\u0443\u0442\u0438\u0445\u0430",
      "longitude":81.2120244,
      "latitude":53.96353
    },
    "4596":{
      "name":"\u0422\u043e\u043a\u0430\u0440\u0451\u0432\u043e",
      "longitude":81.2149102,
      "latitude":52.0594419
    },
    "4597":{
      "name":"\u0420\u0435\u043c\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":81.2229439,
      "latitude":51.1299502
    },
    "4598":{
      "name":"\u041f\u043e\u043b\u043e\u0432\u0438\u043d\u043a\u0438\u043d\u043e",
      "longitude":81.237383,
      "latitude":51.4171649
    },
    "4599":{
      "name":"\u0427\u0435\u0440\u0435\u043c\u0448\u0430\u043d\u043a\u0430",
      "longitude":81.2525154,
      "latitude":53.2590329
    },
    "4600":{
      "name":"\u0413\u0440\u044f\u0437\u043d\u043e\u0432\u043e",
      "longitude":81.2686009,
      "latitude":53.3794723
    },
    "4601":{
      "name":"\u0421\u0430\u043c\u0430\u0440\u043a\u0430",
      "longitude":81.2692096,
      "latitude":51.3708958
    },
    "4602":{
      "name":"\u0421\u043e\u0432\u0435\u0442\u0441\u043a\u0438\u0439 \u041f\u0443\u0442\u044c",
      "longitude":81.2784805,
      "latitude":51.1313517
    },
    "4603":{
      "name":"\u0411\u0435\u0437\u0440\u0443\u043a\u0430\u0432\u043a\u0430",
      "longitude":81.2812285,
      "latitude":51.5824483
    },
    "4604":{
      "name":"\u0412\u044b\u043c\u043f\u0435\u043b",
      "longitude":81.2820095,
      "latitude":51.5033849
    },
    "4605":{
      "name":"\u0417\u0430\u0440\u043d\u0438\u0446\u0430",
      "longitude":81.2846748,
      "latitude":51.6345953
    },
    "4606":{
      "name":"\u0413\u043e\u043d\u043e\u0445\u043e\u0432\u043e",
      "longitude":81.292145,
      "latitude":52.940624
    },
    "4607":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u043a\u0430",
      "longitude":81.297073,
      "latitude":51.561043
    },
    "4608":{
      "name":"\u0417\u0430\u0445\u0430\u0440\u043e\u0432\u043e",
      "longitude":81.324776,
      "latitude":51.6544923
    },
    "4609":{
      "name":"\u0422\u0438\u0448\u0438\u043d\u043a\u0430",
      "longitude":81.3258239,
      "latitude":51.8042523
    },
    "4610":{
      "name":"\u041a\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":81.332676,
      "latitude":51.4973758
    },
    "4611":{
      "name":"\u0414\u0440\u0435\u0441\u0432\u044f\u043d\u043a\u0430",
      "longitude":81.3335607,
      "latitude":53.8814468
    },
    "4612":{
      "name":"\u041c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":81.3545182,
      "latitude":52.7679378
    },
    "4613":{
      "name":"\u0410\u043a\u0441\u0451\u043d\u043e\u0432\u043a\u0430",
      "longitude":81.3610916,
      "latitude":51.8552458
    },
    "4614":{
      "name":"\u0421\u0430\u043c\u0430\u0440\u043a\u0430",
      "longitude":81.535645,
      "latitude":50.907642
    },
    "4615":{
      "name":"\u0413\u0443\u0441\u0435\u043b\u0435\u0442\u043e\u0432\u043e",
      "longitude":81.3757541,
      "latitude":52.55972
    },
    "4616":{
      "name":"\u041d\u043e\u0432\u043e\u0440\u043e\u0441\u0441\u0438\u0439\u0441\u043a\u0438\u0439",
      "longitude":81.3804312,
      "latitude":51.8397511
    },
    "4617":{
      "name":"\u0421\u043e\u043b\u043e\u043d\u043e\u0432\u043a\u0430",
      "longitude":81.394409,
      "latitude":51.982964
    },
    "4618":{
      "name":"\u0411\u043e\u0431\u043a\u043e\u0432\u043e",
      "longitude":81.3969389,
      "latitude":51.6673817
    },
    "4619":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u043a\u043b\u044e\u0438\u0445\u0430",
      "longitude":81.3983315,
      "latitude":51.5387626
    },
    "4620":{
      "name":"\u041c\u0430\u043c\u043e\u043d\u0442\u043e\u0432\u043e",
      "longitude":81.4032339,
      "latitude":51.7484248
    },
    "4621":{
      "name":"\u0420\u044b\u0431\u043d\u043e\u0435",
      "longitude":81.409435,
      "latitude":53.5684235
    },
    "4622":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":81.4136401,
      "latitude":51.0737042
    },
    "4623":{
      "name":"\u0428\u043c\u0438\u0434\u0442\u0430",
      "longitude":81.4190615,
      "latitude":51.797588
    },
    "4624":{
      "name":"\u041a\u043b\u044e\u0447\u0438",
      "longitude":81.4197216,
      "latitude":53.4469433
    },
    "4625":{
      "name":"\u041f\u043b\u043e\u0442\u0438\u043d\u043d\u0430\u044f",
      "longitude":81.423851,
      "latitude":53.792915
    },
    "4626":{
      "name":"\u0412\u044b\u043b\u043a\u043e\u0432\u043e",
      "longitude":81.4240998,
      "latitude":53.0866339
    },
    "4627":{
      "name":"\u041a\u0430\u0437\u0430\u043d\u0446\u0435\u0432\u043e",
      "longitude":81.437065,
      "latitude":52.660732
    },
    "4628":{
      "name":"\u0420\u0430\u0441\u0441\u0432\u0435\u0442",
      "longitude":81.4425123,
      "latitude":52.7349976
    },
    "4629":{
      "name":"\u0411\u0443\u0433\u0440\u044b",
      "longitude":81.4436902,
      "latitude":51.2941392
    },
    "4630":{
      "name":"\u041f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":81.4459615,
      "latitude":51.1833006
    },
    "4631":{
      "name":"\u0438\u043c\u0435\u043d\u0438 \u041a\u0430\u043b\u0438\u043d\u0438\u043d\u0430",
      "longitude":81.4464182,
      "latitude":51.6456131
    },
    "4632":{
      "name":"\u0413\u0440\u0438\u0448\u0435\u043d\u0441\u043a\u043e\u0435",
      "longitude":81.4476558,
      "latitude":53.0081958
    },
    "4633":{
      "name":"\u041a\u043e\u0440\u043e\u043b\u0451\u0432\u0441\u043a\u0438\u0439",
      "longitude":81.4557956,
      "latitude":53.1765435
    },
    "4634":{
      "name":"\u041a\u0430\u0442\u043a\u043e\u0432\u043e",
      "longitude":81.4581278,
      "latitude":51.6542298
    },
    "4635":{
      "name":"\u0421\u0442\u043e\u043b\u0431\u043e\u0432\u043e",
      "longitude":81.471969,
      "latitude":53.9219355
    },
    "4636":{
      "name":"\u041d\u043e\u0432\u043e\u043d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":81.4726134,
      "latitude":51.3523167
    },
    "4637":{
      "name":"\u0423\u043a\u0440\u0430\u0438\u043d\u043a\u0430",
      "longitude":81.4748512,
      "latitude":52.8460349
    },
    "4638":{
      "name":"\u041f\u043e\u0442\u0435\u0440\u044f\u0435\u0432\u043a\u0430",
      "longitude":81.4840404,
      "latitude":51.4520414
    },
    "4639":{
      "name":"10 \u043b\u0435\u0442 \u041e\u043a\u0442\u044f\u0431\u0440\u044f",
      "longitude":81.4865646,
      "latitude":52.0151382
    },
    "4640":{
      "name":"\u041f\u043e\u043b\u043e\u043c\u043e\u0448\u043d\u043e\u0435",
      "longitude":81.4901292,
      "latitude":52.2803848
    },
    "4641":{
      "name":"\u0427\u0451\u0440\u043d\u0430\u044f \u041a\u0443\u0440\u044c\u044f",
      "longitude":81.5011248,
      "latitude":52.5524233
    },
    "4642":{
      "name":"\u041a\u0438\u0440\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":81.5014986,
      "latitude":51.0124234
    },
    "4643":{
      "name":"\u0420\u043e\u043c\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":81.508347,
      "latitude":51.379841
    },
    "4644":{
      "name":"\u0413\u0435\u043e\u0440\u0433\u0438\u0435\u0432\u043a\u0430",
      "longitude":81.5109242,
      "latitude":51.1391777
    },
    "4645":{
      "name":"\u041f\u0430\u0432\u043b\u043e\u0432\u043a\u0430",
      "longitude":81.5124826,
      "latitude":52.079937
    },
    "4646":{
      "name":"\u0423\u0441\u043f\u0435\u043d\u043a\u0430",
      "longitude":81.527756,
      "latitude":50.971458
    },
    "4647":{
      "name":"\u0410\u043b\u043b\u0430\u043a",
      "longitude":81.5309582,
      "latitude":53.8046828
    },
    "4648":{
      "name":"\u0417\u043e\u043b\u043e\u0442\u0443\u0445\u0430",
      "longitude":81.5323198,
      "latitude":50.8107284
    },
    "4649":{
      "name":"\u0412\u0438\u0448\u043d\u0451\u0432\u043a\u0430",
      "longitude":81.5394357,
      "latitude":51.3569983
    },
    "4650":{
      "name":"\u041e\u0437\u0438\u043c\u0430\u044f",
      "longitude":81.5401075,
      "latitude":51.8470265
    },
    "4651":{
      "name":"\u0413\u043e\u043d\u043e\u0445\u043e\u0432\u043e",
      "longitude":81.5429875,
      "latitude":53.6450153
    },
    "4652":{
      "name":"\u041a\u0440\u0435\u0441\u0442\u044c\u044f\u043d\u043a\u0430",
      "longitude":81.5639671,
      "latitude":52.4249011
    },
    "4653":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u044f\u0440\u0441\u043a\u043e\u0435",
      "longitude":81.598297,
      "latitude":51.749565
    },
    "4654":{
      "name":"\u0423\u0441\u0442\u044c\u044f\u043d\u043a\u0430",
      "longitude":81.5997697,
      "latitude":51.1450936
    },
    "4655":{
      "name":"\u0422\u0440\u0443\u0431\u0430\u0447\u0435\u0432\u043e",
      "longitude":81.6123324,
      "latitude":53.099216
    },
    "4656":{
      "name":"\u0421\u0432\u043e\u0431\u043e\u0434\u043d\u044b\u0439",
      "longitude":81.6130173,
      "latitude":53.2926006
    },
    "4657":{
      "name":"\u041a\u043e\u043c\u0441\u043e\u043c\u043e\u043b\u044c\u0441\u043a\u0438\u0439",
      "longitude":81.6192728,
      "latitude":52.9708166
    },
    "4658":{
      "name":"\u041a\u0430\u0440\u043f\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":81.6194442,
      "latitude":53.2111084
    },
    "4659":{
      "name":"\u041b\u0443\u0433\u043e\u0432\u043e\u0435",
      "longitude":81.6229817,
      "latitude":53.5133383
    },
    "4660":{
      "name":"\u0422\u0440\u043e\u0438\u043d\u043a\u0430",
      "longitude":81.6277986,
      "latitude":51.505275
    },
    "4661":{
      "name":"\u0415\u0440\u043c\u0430\u0447\u0438\u0445\u0430",
      "longitude":81.633485,
      "latitude":53.0352483
    },
    "4662":{
      "name":"\u0421\u0443\u0441\u043b\u043e\u0432\u043e",
      "longitude":81.6398124,
      "latitude":52.6101229
    },
    "4663":{
      "name":"\u0417\u0430\u0432\u043e\u0434\u0441\u043a\u043e\u0439",
      "longitude":81.640499,
      "latitude":53.3003261
    },
    "4664":{
      "name":"\u0421\u0430\u0440\u0430\u0442\u043e\u0432\u043a\u0430",
      "longitude":81.643456,
      "latitude":51.381512
    },
    "4665":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u043c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":81.658798,
      "latitude":52.916584
    },
    "4666":{
      "name":"\u0412\u0435\u0440\u0445-\u0410\u043b\u043b\u0430\u043a",
      "longitude":81.6594357,
      "latitude":53.8926576
    },
    "4667":{
      "name":"\u041f\u043e\u043b\u043e\u043c\u043e\u0448\u043d\u043e\u0435",
      "longitude":81.6626797,
      "latitude":51.8137896
    },
    "4668":{
      "name":"\u041c\u0430\u043b\u044b\u0435 \u0411\u0443\u0442\u044b\u0440\u043a\u0438",
      "longitude":81.664546,
      "latitude":52.7288285
    },
    "4669":{
      "name":"\u041a\u043e\u0440\u0447\u0438\u043d\u043e",
      "longitude":81.6825825,
      "latitude":52.9892817
    },
    "4670":{
      "name":"\u041e\u0431\u0441\u043a\u043e\u0435",
      "longitude":81.6837499,
      "latitude":53.6584453
    },
    "4671":{
      "name":"\u0414\u0430\u043b\u044c\u043d\u0438\u0439",
      "longitude":81.6868876,
      "latitude":51.4792669
    },
    "4672":{
      "name":"\u0415\u0440\u043c\u043e\u0448\u0438\u0445\u0430",
      "longitude":81.6921109,
      "latitude":50.7819754
    },
    "4673":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":81.6958159,
      "latitude":51.1352145
    },
    "4674":{
      "name":"\u041c\u0435\u0437\u0435\u043d\u0446\u0435\u0432\u043e",
      "longitude":81.6961644,
      "latitude":53.3579747
    },
    "4675":{
      "name":"\u041b\u043e\u0431\u0430\u043d\u0438\u0445\u0430",
      "longitude":81.7011391,
      "latitude":52.2291618
    },
    "4676":{
      "name":"\u041a\u043e\u0440\u043e\u0431\u0435\u0439\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":81.702759,
      "latitude":52.413185
    },
    "4677":{
      "name":"\u041d\u043e\u0432\u043e\u0432\u043e\u0437\u043d\u0435\u0441\u0435\u043d\u043a\u0430",
      "longitude":81.7044689,
      "latitude":51.5371066
    },
    "4678":{
      "name":"\u041f\u043e\u0434\u0433\u043e\u0440\u043d\u044b\u0439",
      "longitude":81.7060124,
      "latitude":53.4958497
    },
    "4679":{
      "name":"\u041a\u043b\u0435\u043f\u0435\u0447\u0438\u0445\u0430",
      "longitude":81.706398,
      "latitude":52.154049
    },
    "4680":{
      "name":"\u041e\u043a\u0442\u044f\u0431\u0440\u044c\u0441\u043a\u0438\u0439",
      "longitude":81.7113784,
      "latitude":51.282503
    },
    "4681":{
      "name":"\u0412\u043e\u0437\u043d\u0435\u0441\u0435\u043d\u0441\u043a\u0438\u0439",
      "longitude":81.7163925,
      "latitude":53.2136192
    },
    "4682":{
      "name":"\u0438\u043c\u0435\u043d\u0438 \u041c\u0430\u043c\u043e\u043d\u0442\u043e\u0432\u0430",
      "longitude":81.7189229,
      "latitude":51.9290359
    },
    "4683":{
      "name":"\u041e\u0441\u0442\u0440\u043e\u0432\u043d\u043e\u0435",
      "longitude":81.7190696,
      "latitude":52.6866439
    },
    "4684":{
      "name":"\u0425\u043b\u0435\u0431\u043e\u0440\u043e\u0431",
      "longitude":81.7225897,
      "latitude":52.0058684
    },
    "4685":{
      "name":"\u041c\u0430\u0445\u0430\u043d\u043e\u0432\u043e",
      "longitude":81.7269298,
      "latitude":51.8081214
    },
    "4686":{
      "name":"\u0410\u043d\u0434\u0440\u0435\u0435\u0432\u043a\u0430",
      "longitude":81.7360282,
      "latitude":52.4313749
    },
    "4687":{
      "name":"\u041a\u0440\u0443\u0442\u043e\u0439 \u042f\u0440",
      "longitude":81.7402546,
      "latitude":51.9177325
    },
    "4688":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0435\u0432\u0438\u043a",
      "longitude":81.7416824,
      "latitude":51.8438902
    },
    "4689":{
      "name":"\u0428\u0430\u0440\u0447\u0438\u043d\u043e",
      "longitude":81.7462556,
      "latitude":53.1426822
    },
    "4690":{
      "name":"\u0412\u0442\u043e\u0440\u0430\u044f \u041a\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":81.7533824,
      "latitude":51.0506382
    },
    "4691":{
      "name":"\u0423\u0440\u044b\u0432\u043a\u0438",
      "longitude":81.7680631,
      "latitude":53.0411409
    },
    "4692":{
      "name":"\u041c\u0430\u0441\u0430\u043b\u044c\u0441\u043a\u0438\u0439",
      "longitude":81.7961438,
      "latitude":50.9572081
    },
    "4693":{
      "name":"\u041a\u0440\u044e\u0447\u043a\u0438",
      "longitude":81.7989755,
      "latitude":50.8483243
    },
    "4694":{
      "name":"\u0411\u0443\u043a\u0430\u043d\u0441\u043a\u043e\u0435",
      "longitude":81.7998955,
      "latitude":52.7977829
    },
    "4695":{
      "name":"\u0413\u0438\u043b\u0451\u0432\u043e",
      "longitude":81.8036723,
      "latitude":51.1264001
    },
    "4696":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u043a\u0430",
      "longitude":81.811844,
      "latitude":53.242908
    },
    "4697":{
      "name":"12 \u043b\u0435\u0442 \u041e\u043a\u0442\u044f\u0431\u0440\u044f",
      "longitude":81.8239722,
      "latitude":51.7180673
    },
    "4698":{
      "name":"\u041a\u0440\u0443\u0442\u0438\u0448\u043a\u0430",
      "longitude":81.8303487,
      "latitude":53.4630871
    },
    "4699":{
      "name":"\u0417\u0435\u0440\u043a\u0430\u043b\u044b",
      "longitude":81.8356823,
      "latitude":52.4847683
    },
    "4700":{
      "name":"\u0421\u043e\u0441\u043d\u043e\u0432\u043a\u0430",
      "longitude":81.8497086,
      "latitude":53.2509358
    },
    "4701":{
      "name":"\u041a\u043e\u0442\u043b\u044f\u0440\u043e\u0432\u043a\u0430",
      "longitude":81.8506574,
      "latitude":52.1114429
    },
    "4702":{
      "name":"\u041f\u043e\u0441\u043f\u0435\u043b\u0438\u0445\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":81.8535884,
      "latitude":51.8732192
    },
    "4703":{
      "name":"\u0411\u0430\u0442\u0430\u043b\u043e\u0432\u043e",
      "longitude":81.8697167,
      "latitude":52.2137362
    },
    "4704":{
      "name":"\u041f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":81.8706766,
      "latitude":52.7718513
    },
    "4705":{
      "name":"\u0427\u0430\u0439\u043a\u0438\u043d\u043e",
      "longitude":81.8759625,
      "latitude":53.500803
    },
    "4706":{
      "name":"\u0422\u0440\u0430\u0432\u043d\u043e\u0435",
      "longitude":81.876678,
      "latitude":52.586426
    },
    "4707":{
      "name":"\u0421\u0442\u0435\u043f\u043d\u043e\u0439",
      "longitude":81.8887044,
      "latitude":50.9727843
    },
    "4708":{
      "name":"\u0424\u0430\u043a\u0435\u043b \u0421\u043e\u0446\u0438\u0430\u043b\u0438\u0437\u043c\u0430",
      "longitude":81.8917648,
      "latitude":51.9969607
    },
    "4709":{
      "name":"\u0422\u0440\u0435\u0442\u044c\u044f\u043a\u043e\u0432\u043e",
      "longitude":81.89695,
      "latitude":50.867939
    },
    "4710":{
      "name":"\u041a\u0443\u043b\u0438\u043a\u043e\u0432\u043e",
      "longitude":81.8970726,
      "latitude":53.2014546
    },
    "4711":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u044c\u0441\u043a",
      "longitude":81.9095449,
      "latitude":51.3592308
    },
    "4712":{
      "name":"\u0422\u0430\u043b\u043e\u0432\u043a\u0430",
      "longitude":81.9130063,
      "latitude":51.4466851
    },
    "4713":{
      "name":"\u0412\u0430\u0432\u0438\u043b\u043e\u043d\u0441\u043a\u0438\u0439",
      "longitude":81.913322,
      "latitude":51.959633
    },
    "4714":{
      "name":"\u041a\u0430\u0434\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":81.9189895,
      "latitude":52.8648055
    },
    "4715":{
      "name":"\u0421\u0430\u0434\u043e\u0432\u044b\u0439",
      "longitude":81.9212601,
      "latitude":50.9837412
    },
    "4716":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u043c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":81.9217251,
      "latitude":50.8771351
    },
    "4717":{
      "name":"\u041f\u043e\u0440\u043e\u0436\u043d\u0435\u0435",
      "longitude":81.9263305,
      "latitude":52.2699041
    },
    "4718":{
      "name":"\u0411\u044b\u043a\u043e\u0432\u043e",
      "longitude":81.9286625,
      "latitude":53.5342806
    },
    "4719":{
      "name":"\u0428\u0443\u043c\u0438\u043b\u0438\u0445\u0430",
      "longitude":81.943306,
      "latitude":53.12096
    },
    "4720":{
      "name":"\u042e\u0434\u0438\u0445\u0430",
      "longitude":81.9446752,
      "latitude":53.4322124
    },
    "4721":{
      "name":"\u041a\u0443\u0437\u044c\u043c\u0438\u043d\u043a\u0430",
      "longitude":81.9496398,
      "latitude":51.3101102
    },
    "4722":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":81.962182,
      "latitude":50.8158838
    },
    "4723":{
      "name":"\u041a\u043e\u0440\u0431\u043e\u043b\u0438\u0445\u0430",
      "longitude":81.964317,
      "latitude":51.101025
    },
    "4724":{
      "name":"\u041c\u0430\u043a\u0430\u0440\u043e\u0432\u043e",
      "longitude":81.997636,
      "latitude":53.2936144
    },
    "4725":{
      "name":"\u0420\u043e\u0434\u0438\u043d\u043e",
      "longitude":81.9988797,
      "latitude":52.3760139
    },
    "4726":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u0430\u043b\u0435\u0439\u0441\u043a\u043e\u0435",
      "longitude":81.999641,
      "latitude":51.006229
    },
    "4727":{
      "name":"\u041d\u043e\u0432\u043e\u0438\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":82.0040907,
      "latitude":52.3202251
    },
    "4728":{
      "name":"\u0423\u0440\u043b\u0430\u043f\u043e\u0432\u043e",
      "longitude":82.0053968,
      "latitude":52.568065
    },
    "4729":{
      "name":"\u041a\u0443\u0437\u043d\u0435\u0446\u043e\u0432\u043e",
      "longitude":82.0154199,
      "latitude":51.6795806
    },
    "4730":{
      "name":"\u0415\u043a\u0430\u0442\u0435\u0440\u0438\u043d\u0438\u043d\u0441\u043a\u043e\u0435",
      "longitude":82.015732,
      "latitude":50.909134
    },
    "4731":{
      "name":"\u0423\u0441\u0442\u044c-\u041c\u043e\u0441\u0438\u0445\u0430",
      "longitude":82.017128,
      "latitude":53.251949
    },
    "4732":{
      "name":"\u0425\u043b\u043e\u043f\u0443\u043d\u043e\u0432\u043e",
      "longitude":82.0266789,
      "latitude":52.0717768
    },
    "4733":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":82.027911,
      "latitude":51.5741767
    },
    "4734":{
      "name":"\u041a\u043e\u0441\u0442\u0438\u043d \u041b\u043e\u0433",
      "longitude":82.029297,
      "latitude":52.662003
    },
    "4735":{
      "name":"\u041d\u043e\u0432\u043e\u0433\u0430\u043b\u044c\u0446\u043e\u0432\u043a\u0430",
      "longitude":82.0409438,
      "latitude":50.9740719
    },
    "4736":{
      "name":"\u0413\u0435\u043e\u0440\u0433\u0438\u0435\u0432\u043a\u0430",
      "longitude":82.050636,
      "latitude":52.860229
    },
    "4737":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":82.0623647,
      "latitude":51.8783542
    },
    "4738":{
      "name":"\u041a\u0438\u043f\u0440\u0438\u043d\u043e",
      "longitude":82.0709698,
      "latitude":53.528975
    },
    "4739":{
      "name":"\u041f\u043e\u0434\u0441\u0442\u0435\u043f\u043d\u043e\u0435",
      "longitude":82.0793586,
      "latitude":52.9652233
    },
    "4740":{
      "name":"\u041a\u0430\u0440\u0430\u043c\u044b\u0448\u0435\u0432\u043e",
      "longitude":82.0852951,
      "latitude":51.1720333
    },
    "4741":{
      "name":"\u041b\u043e\u043f\u0430\u0442\u0438\u043d\u043a\u0430",
      "longitude":82.1020604,
      "latitude":50.9164323
    },
    "4742":{
      "name":"\u0421\u0430\u043a\u043c\u0430\u0440\u0438\u043d\u043e",
      "longitude":82.1147434,
      "latitude":53.5341786
    },
    "4743":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u0430\u043c\u044b\u0448\u0435\u043d\u043a\u0430",
      "longitude":82.12328,
      "latitude":50.9339887
    },
    "4744":{
      "name":"\u0413\u043e\u0440\u044c\u043a\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":82.133429,
      "latitude":52.0773475
    },
    "4745":{
      "name":"\u041c\u043e\u043b\u043e\u0434\u0451\u0436\u043d\u044b\u0439",
      "longitude":82.1366103,
      "latitude":52.9986763
    },
    "4746":{
      "name":"\u0411\u043e\u0431\u0440\u043e\u0432\u043a\u0430",
      "longitude":82.1380849,
      "latitude":52.4153432
    },
    "4747":{
      "name":"\u0413\u0430\u0432\u0440\u0438\u043b\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":82.1461567,
      "latitude":51.9704392
    },
    "4748":{
      "name":"\u0421\u0430\u0432\u0432\u0443\u0448\u043a\u0430",
      "longitude":82.146446,
      "latitude":51.352718
    },
    "4749":{
      "name":"\u041f\u043b\u043e\u0441\u043a\u043e\u0435",
      "longitude":82.147416,
      "latitude":50.8517614
    },
    "4750":{
      "name":"\u041f\u0430\u043d\u043e\u0432\u043e",
      "longitude":82.152328,
      "latitude":52.987579
    },
    "4751":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u043c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":82.1577436,
      "latitude":52.3081846
    },
    "4752":{
      "name":"\u0421\u0435\u043b\u0435\u0437\u043d\u0451\u0432\u043e",
      "longitude":82.1630333,
      "latitude":53.4973671
    },
    "4753":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":82.1749286,
      "latitude":53.3768161
    },
    "4754":{
      "name":"\u0411\u043e\u0440\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":82.1791916,
      "latitude":52.6477195
    },
    "4755":{
      "name":"\u0411\u044b\u043a\u043e\u0432\u043e",
      "longitude":82.1797866,
      "latitude":52.1400649
    },
    "4756":{
      "name":"\u041d\u043e\u0432\u043e\u0444\u0438\u0440\u0441\u043e\u0432\u043e",
      "longitude":82.1867384,
      "latitude":51.7507678
    },
    "4757":{
      "name":"\u0412\u0435\u0440\u0445-\u0411\u043e\u0440\u043e\u0432\u043b\u044f\u043d\u043a\u0430",
      "longitude":82.200424,
      "latitude":53.183949
    },
    "4758":{
      "name":"\u041e\u043c\u0443\u0442\u0441\u043a\u043e\u0435",
      "longitude":82.2082622,
      "latitude":53.474999
    },
    "4759":{
      "name":"\u0411\u0430\u0440\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":82.2092659,
      "latitude":51.0485627
    },
    "4760":{
      "name":"\u0428\u0438\u043f\u0443\u043d\u043e\u0432\u043e",
      "longitude":82.223137,
      "latitude":52.15966
    },
    "4761":{
      "name":"\u042f\u0441\u043d\u0430\u044f \u041f\u043e\u043b\u044f\u043d\u0430",
      "longitude":82.2235976,
      "latitude":53.2231442
    },
    "4762":{
      "name":"\u0412\u043e\u0440\u043e\u043d\u0438\u0445\u0430",
      "longitude":82.2265079,
      "latitude":52.7543167
    },
    "4763":{
      "name":"\u0412\u0435\u0440\u0445-\u041a\u0443\u0447\u0443\u043a",
      "longitude":82.2405149,
      "latitude":53.3503343
    },
    "4764":{
      "name":"\u041a\u0430\u0441\u043c\u0430\u043b\u0438\u043d\u043a\u0430",
      "longitude":82.4697671,
      "latitude":53.1225411
    },
    "4765":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u0451\u043b\u043e\u0432\u043a\u0430",
      "longitude":82.2414295,
      "latitude":53.4710797
    },
    "4766":{
      "name":"\u0411\u0435\u0441\u043f\u0430\u043b\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":82.2450757,
      "latitude":51.1945706
    },
    "4767":{
      "name":"\u041c\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":82.254697,
      "latitude":52.4772939
    },
    "4768":{
      "name":"\u0411\u0435\u043b\u043e\u0432\u043e",
      "longitude":82.260605,
      "latitude":52.952583
    },
    "4769":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u0437\u043d\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":82.2667977,
      "latitude":51.6852511
    },
    "4770":{
      "name":"\u041a\u0430\u043b\u043c\u044b\u0446\u043a\u0438\u0435 \u041c\u044b\u0441\u044b",
      "longitude":82.268517,
      "latitude":51.89164
    },
    "4771":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u043a\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":82.2791488,
      "latitude":50.9687436
    },
    "4772":{
      "name":"\u0423\u0441\u0442\u044c-\u0422\u0430\u043b\u043e\u0432\u043a\u0430",
      "longitude":82.2877047,
      "latitude":51.4896309
    },
    "4773":{
      "name":"\u0420\u0435\u0431\u0440\u0438\u0445\u0430",
      "longitude":82.291664,
      "latitude":53.01086
    },
    "4774":{
      "name":"\u0427\u0435\u0440\u0435\u043f\u0430\u043d\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":82.3045154,
      "latitude":51.1951922
    },
    "4775":{
      "name":"\u0418\u043b\u044c\u0438\u043d\u043a\u0430",
      "longitude":82.3221877,
      "latitude":53.454866
    },
    "4776":{
      "name":"\u0413\u0430\u043b\u044c\u0446\u043e\u0432\u043a\u0430",
      "longitude":82.3303973,
      "latitude":51.0683733
    },
    "4777":{
      "name":"\u0420\u0435\u0431\u0440\u0438\u0445\u0430",
      "longitude":82.344826,
      "latitude":53.07626
    },
    "4778":{
      "name":"\u0411\u0430\u0440\u0447\u0438\u0445\u0430",
      "longitude":82.3532381,
      "latitude":52.2418149
    },
    "4779":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u042f\u0440",
      "longitude":82.3631945,
      "latitude":52.1903429
    },
    "4780":{
      "name":"\u0418\u043b\u044c\u0438\u043d\u043a\u0430",
      "longitude":82.3641495,
      "latitude":51.9498576
    },
    "4781":{
      "name":"\u041a\u0430\u0437\u0430\u043d\u0446\u0435\u0432\u043e",
      "longitude":82.367813,
      "latitude":51.364876
    },
    "4782":{
      "name":"\u0428\u0438\u043f\u0443\u043d\u0438\u0445\u0430",
      "longitude":82.3770396,
      "latitude":50.9337827
    },
    "4783":{
      "name":"\u0415\u043b\u044c\u0446\u043e\u0432\u043a\u0430",
      "longitude":82.3920581,
      "latitude":51.9061704
    },
    "4784":{
      "name":"\u0411\u0430\u0442\u0443\u0440\u043e\u0432\u043e",
      "longitude":82.395454,
      "latitude":53.426689
    },
    "4785":{
      "name":"\u041f\u0435\u043d\u044c\u043a\u0438",
      "longitude":82.3962501,
      "latitude":52.9360957
    },
    "4786":{
      "name":"\u041d\u0435\u0447\u0443\u043d\u0430\u0435\u0432\u043e",
      "longitude":82.3978725,
      "latitude":52.2660452
    },
    "4787":{
      "name":"\u041e\u0437\u0451\u0440\u043a\u0438",
      "longitude":82.4055742,
      "latitude":51.8005673
    },
    "4788":{
      "name":"\u041d\u043e\u0432\u043e\u0430\u043b\u0435\u0439\u0441\u043a\u043e\u0435",
      "longitude":82.4115526,
      "latitude":50.8423649
    },
    "4789":{
      "name":"\u041a\u043b\u044e\u0447\u0435\u0432\u043a\u0430",
      "longitude":82.4226622,
      "latitude":53.0244139
    },
    "4790":{
      "name":"\u0412\u0435\u0440\u0445-\u0410\u043b\u0435\u0439\u043a\u0430",
      "longitude":82.4431297,
      "latitude":50.8548956
    },
    "4791":{
      "name":"\u041d\u043e\u0432\u044b\u0439 \u041f\u0443\u0442\u044c",
      "longitude":82.447202,
      "latitude":52.171896
    },
    "4792":{
      "name":"\u041a\u0430\u0447\u0443\u0441\u043e\u0432\u043e",
      "longitude":82.4557165,
      "latitude":51.949508
    },
    "4793":{
      "name":"\u0411\u043e\u0440\u043e\u0432\u043b\u044f\u043d\u043a\u0430",
      "longitude":82.459816,
      "latitude":53.181347
    },
    "4794":{
      "name":"\u041a\u0443\u0447\u0443\u043a",
      "longitude":82.4664732,
      "latitude":53.4439858
    },
    "4795":{
      "name":"\u0411\u0435\u0441\u0442\u0443\u0436\u0435\u0432\u043e",
      "longitude":82.4688999,
      "latitude":52.042702
    },
    "4796":{
      "name":"\u0421\u0435\u043c\u0435\u043d\u043e\u0432\u043a\u0430",
      "longitude":82.4741786,
      "latitude":50.9550829
    },
    "4797":{
      "name":"\u041c\u043e\u0445\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":82.4763739,
      "latitude":52.622707
    },
    "4798":{
      "name":"\u041c\u0435\u0442\u0435\u043b\u0438",
      "longitude":82.481713,
      "latitude":52.0767465
    },
    "4799":{
      "name":"\u0420\u043e\u0436\u043d\u0435\u0432 \u041b\u043e\u0433",
      "longitude":82.4835431,
      "latitude":52.8599497
    },
    "4800":{
      "name":"\u041a\u0430\u0431\u0430\u043a\u043e\u0432\u043e",
      "longitude":82.4838676,
      "latitude":52.3060229
    },
    "4801":{
      "name":"\u0422\u0440\u0443\u0441\u043e\u0432\u043e",
      "longitude":82.484271,
      "latitude":51.7050215
    },
    "4802":{
      "name":"\u041a\u0443\u0437\u043d\u0435\u0447\u0438\u0445\u0430",
      "longitude":82.4913411,
      "latitude":51.9923021
    },
    "4803":{
      "name":"\u041f\u043b\u043e\u0441\u043a\u043e\u0441\u0435\u043c\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":82.4918552,
      "latitude":52.9963237
    },
    "4804":{
      "name":"\u0417\u0435\u043b\u0451\u043d\u0430\u044f \u0420\u043e\u0449\u0430",
      "longitude":82.505602,
      "latitude":53.0632977
    },
    "4805":{
      "name":"\u041f\u0435\u0441\u0447\u0430\u043d\u043e\u0435",
      "longitude":82.506943,
      "latitude":52.789574
    },
    "4806":{
      "name":"\u0414\u0440\u0443\u0436\u0431\u0430",
      "longitude":82.506958,
      "latitude":52.57605
    },
    "4807":{
      "name":"\u042f\u0441\u043d\u0430\u044f \u041f\u043e\u043b\u044f\u043d\u0430",
      "longitude":82.5353063,
      "latitude":52.1078187
    },
    "4808":{
      "name":"\u0411\u0435\u043b\u043e\u0433\u043b\u0430\u0437\u043e\u0432\u043e",
      "longitude":82.5619848,
      "latitude":52.1172881
    },
    "4809":{
      "name":"\u041a\u0430\u0448\u0438\u043d\u043e",
      "longitude":82.564339,
      "latitude":52.370152
    },
    "4810":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u0435\u043b\u044c\u0441\u043a\u043e\u0435",
      "longitude":82.5654853,
      "latitude":52.0437991
    },
    "4811":{
      "name":"\u041a\u043e\u043b\u044b\u0432\u0430\u043d\u044c",
      "longitude":82.569427,
      "latitude":51.317177
    },
    "4812":{
      "name":"\u041a\u043b\u043e\u0447\u043a\u0438",
      "longitude":82.579018,
      "latitude":53.180782
    },
    "4813":{
      "name":"\u0410\u043a\u0438\u043c\u043e\u0432\u043a\u0430",
      "longitude":82.5882543,
      "latitude":51.5862894
    },
    "4814":{
      "name":"\u0422\u0443\u0433\u043e\u0437\u0432\u043e\u043d\u043e\u0432\u043e",
      "longitude":82.600723,
      "latitude":52.074799
    },
    "4815":{
      "name":"\u0428\u0435\u043b\u0430\u0431\u043e\u043b\u0438\u0445\u0430",
      "longitude":82.612091,
      "latitude":53.414413
    },
    "4816":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u042f\u0440",
      "longitude":82.6167233,
      "latitude":52.3859952
    },
    "4817":{
      "name":"\u0421\u0430\u0432\u0438\u043d\u043a\u0430",
      "longitude":82.6183513,
      "latitude":52.6478576
    },
    "4818":{
      "name":"\u041e\u0440\u0451\u043b",
      "longitude":82.6213752,
      "latitude":53.1139577
    },
    "4819":{
      "name":"\u041c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":82.6315072,
      "latitude":53.0325904
    },
    "4820":{
      "name":"\u041a\u043e\u043c\u0430\u0440\u0438\u0445\u0430",
      "longitude":82.6499884,
      "latitude":52.7227644
    },
    "4821":{
      "name":"\u0411\u043e\u0440\u0438\u0445\u0430",
      "longitude":82.6525938,
      "latitude":52.285835
    },
    "4822":{
      "name":"\u0418\u043d\u044f",
      "longitude":82.6713317,
      "latitude":53.5068885
    },
    "4823":{
      "name":"\u0423\u0440\u044e\u043f\u0438\u043d\u043e",
      "longitude":82.6846418,
      "latitude":52.4180832
    },
    "4824":{
      "name":"\u0421\u0443\u0435\u0442\u043a\u0430",
      "longitude":82.6846714,
      "latitude":51.4597953
    },
    "4825":{
      "name":"\u041a\u0430\u0440\u043f\u043e\u0432\u043e \u0412\u0442\u043e\u0440\u043e\u0435",
      "longitude":82.6858061,
      "latitude":51.7162838
    },
    "4826":{
      "name":"\u0417\u0430\u0432\u0435\u0442\u044b \u0418\u043b\u044c\u0438\u0447\u0430",
      "longitude":82.6893785,
      "latitude":52.5092985
    },
    "4827":{
      "name":"\u041d\u043e\u0432\u043e\u043e\u0431\u0438\u043d\u0446\u0435\u0432\u043e",
      "longitude":82.697626,
      "latitude":53.4135952
    },
    "4828":{
      "name":"\u0417\u0438\u043c\u0438\u043d\u043e",
      "longitude":82.70195,
      "latitude":52.949436
    },
    "4829":{
      "name":"\u0421\u0430\u043c\u0441\u043e\u043d\u043e\u0432\u043e",
      "longitude":82.7028682,
      "latitude":52.1286028
    },
    "4830":{
      "name":"\u041a\u043e\u043c\u0430\u0440\u0438\u0445\u0430",
      "longitude":82.713547,
      "latitude":51.929661
    },
    "4831":{
      "name":"\u0410\u043b\u0435\u0439\u0441\u043a\u0438\u0439",
      "longitude":82.7281715,
      "latitude":52.4700092
    },
    "4832":{
      "name":"\u041a\u0438\u0440\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":82.734802,
      "latitude":52.73074
    },
    "4833":{
      "name":"\u0411\u0443\u0440\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":82.7363862,
      "latitude":53.2370229
    },
    "4834":{
      "name":"\u041f\u0430\u0440\u0444\u0451\u043d\u043e\u0432\u043e",
      "longitude":82.737732,
      "latitude":52.806805
    },
    "4835":{
      "name":"\u041c\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":82.7430208,
      "latitude":53.4099734
    },
    "4836":{
      "name":"\u041f\u043b\u043e\u0442\u0430\u0432\u0430",
      "longitude":82.7620872,
      "latitude":52.2880994
    },
    "4837":{
      "name":"\u0421\u043e\u043b\u043d\u0435\u0447\u043d\u044b\u0439",
      "longitude":82.7668712,
      "latitude":52.5130899
    },
    "4838":{
      "name":"\u041b\u0435\u0431\u044f\u0436\u044c\u0435",
      "longitude":82.7818277,
      "latitude":53.1840949
    },
    "4839":{
      "name":"\u0420\u043e\u0433\u043e\u0437\u0438\u0445\u0430",
      "longitude":82.784126,
      "latitude":53.254662
    },
    "4840":{
      "name":"\u0411\u0443\u0433\u0440\u044b\u0448\u0438\u0445\u0430",
      "longitude":82.7889648,
      "latitude":51.2811463
    },
    "4841":{
      "name":"\u0423\u043b\u044c\u044f\u043d\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":82.8080126,
      "latitude":52.8412213
    },
    "4842":{
      "name":"\u0423\u0441\u0442\u044c-\u041f\u043e\u0440\u043e\u0437\u0438\u0445\u0430",
      "longitude":82.8243471,
      "latitude":52.1287714
    },
    "4843":{
      "name":"\u0421\u043e\u0432\u0445\u043e\u0437\u043d\u044b\u0439",
      "longitude":82.8306365,
      "latitude":52.381906
    },
    "4844":{
      "name":"\u0412\u0430\u0432\u0438\u043b\u043e\u043d",
      "longitude":82.8479095,
      "latitude":52.4762329
    },
    "4845":{
      "name":"\u0411\u043e\u0440\u043e\u0432\u0438\u043a\u043e\u0432\u043e",
      "longitude":82.850487,
      "latitude":53.412075
    },
    "4846":{
      "name":"\u0425\u0430\u0440\u043b\u043e\u0432\u043e",
      "longitude":82.8557954,
      "latitude":51.6898971
    },
    "4847":{
      "name":"\u041a\u043e\u0441\u043e\u0431\u043e\u043a\u043e\u0432\u043e",
      "longitude":82.8574893,
      "latitude":52.0558793
    },
    "4848":{
      "name":"\u041a\u043e\u043c\u0441\u043e\u043c\u043e\u043b\u044c\u0441\u043a\u0438\u0439",
      "longitude":82.8586966,
      "latitude":52.8086483
    },
    "4849":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0435\u043f\u0430\u043d\u044e\u0448\u0435\u0432\u043e",
      "longitude":82.8667916,
      "latitude":52.5139286
    },
    "4850":{
      "name":"\u0412\u0435\u0442\u0451\u043b\u043a\u0438",
      "longitude":82.8976825,
      "latitude":52.2198367
    },
    "4851":{
      "name":"\u041a\u043e\u043b\u044b\u0432\u0430\u043d\u0441\u043a\u043e\u0435",
      "longitude":82.900505,
      "latitude":53.031132
    },
    "4852":{
      "name":"\u041b\u0430\u0432\u0440\u0435\u043d\u0442\u044c\u0435\u0432\u043a\u0430",
      "longitude":82.9209787,
      "latitude":52.8567057
    },
    "4853":{
      "name":"\u0410\u0440\u0431\u0443\u0437\u043e\u0432\u043a\u0430",
      "longitude":82.921051,
      "latitude":53.095905
    },
    "4854":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":82.9307234,
      "latitude":52.3869324
    },
    "4855":{
      "name":"\u0420\u0430\u043a\u0438\u0442\u044b",
      "longitude":82.9343749,
      "latitude":52.9745295
    },
    "4856":{
      "name":"\u0423\u0441\u0442\u044c-\u0411\u0435\u043b\u043e\u0435",
      "longitude":82.9357501,
      "latitude":51.4635336
    },
    "4857":{
      "name":"\u0411\u0443\u0440\u0430\u043d\u043e\u0432\u043e",
      "longitude":82.9398326,
      "latitude":52.0201353
    },
    "4858":{
      "name":"\u041c\u0430\u0440\u0430\u043b\u0438\u0445\u0430",
      "longitude":82.942712,
      "latitude":51.6109164
    },
    "4859":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u043a\u0430",
      "longitude":82.9573971,
      "latitude":51.8458744
    },
    "4860":{
      "name":"\u0411\u0435\u0437\u0433\u043e\u043b\u043e\u0441\u043e\u0432\u043e",
      "longitude":82.9631537,
      "latitude":52.5123801
    },
    "4861":{
      "name":"\u041a\u0440\u0443\u0442\u0438\u0445\u0430",
      "longitude":82.9678509,
      "latitude":52.7103949
    },
    "4862":{
      "name":"\u0417\u0435\u043b\u0451\u043d\u044b\u0439",
      "longitude":82.979857,
      "latitude":52.6842483
    },
    "4863":{
      "name":"\u0412\u043e\u0440\u043e\u0431\u044c\u0451\u0432\u043e",
      "longitude":82.9808324,
      "latitude":52.0676227
    },
    "4864":{
      "name":"\u0416\u0443\u043a\u043e\u0432\u043a\u0430",
      "longitude":82.980927,
      "latitude":53.204048
    },
    "4865":{
      "name":"\u0421\u0438\u0434\u043e\u0440\u043e\u0432\u043a\u0430",
      "longitude":82.9896745,
      "latitude":52.9963524
    },
    "4866":{
      "name":"\u041a\u0443\u0439\u0431\u044b\u0448\u0435\u0432\u043e",
      "longitude":82.9961447,
      "latitude":51.5544363
    },
    "4867":{
      "name":"\u0415\u043b\u0443\u043d\u0438\u043d\u043e",
      "longitude":82.99897,
      "latitude":53.439423
    },
    "4868":{
      "name":"\u041f\u043e\u0431\u0435\u0434\u0438\u043c",
      "longitude":83.003659,
      "latitude":52.6632
    },
    "4869":{
      "name":"\u0421\u0438\u0431\u0438\u0440\u0441\u043a\u0438\u0435 \u041e\u0433\u043d\u0438",
      "longitude":83.027946,
      "latitude":53.308922
    },
    "4870":{
      "name":"\u0424\u0443\u043d\u0442\u0438\u043a\u0438",
      "longitude":83.0305231,
      "latitude":52.7828241
    },
    "4871":{
      "name":"\u041a\u043e\u043b\u043f\u0430\u043a\u043e\u0432\u043e",
      "longitude":83.031283,
      "latitude":52.6230928
    },
    "4872":{
      "name":"\u041d\u043e\u0432\u043e\u0431\u0443\u0440\u0430\u043d\u043e\u0432\u043e",
      "longitude":83.0375363,
      "latitude":51.9442748
    },
    "4873":{
      "name":"\u0427\u0430\u044f\u0447\u044c\u0435",
      "longitude":83.0385643,
      "latitude":53.0151296
    },
    "4874":{
      "name":"\u041c\u0430\u043a\u0430\u0440\u044c\u0435\u0432\u043a\u0430",
      "longitude":83.041637,
      "latitude":52.8698966
    },
    "4875":{
      "name":"\u041b\u0430\u0440\u0438\u0447\u0438\u0445\u0430",
      "longitude":83.0422036,
      "latitude":53.7748996
    },
    "4876":{
      "name":"\u0427\u0438\u043d\u0435\u0442\u0430",
      "longitude":83.049416,
      "latitude":51.335373
    },
    "4877":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":83.0500522,
      "latitude":52.8522329
    },
    "4878":{
      "name":"\u0414\u0440\u0443\u0436\u0431\u0430",
      "longitude":83.0555404,
      "latitude":52.6917649
    },
    "4879":{
      "name":"\u041f\u0435\u0440\u0435\u044f\u0441\u043b\u043e\u0432\u043a\u0430",
      "longitude":83.1030406,
      "latitude":52.881204
    },
    "4880":{
      "name":"\u041a\u0430\u0431\u0430\u043d\u043e\u0432\u043e",
      "longitude":83.1095165,
      "latitude":52.0449188
    },
    "4881":{
      "name":"\u0412\u0435\u0440\u0445-\u041a\u0430\u043c\u044b\u0448\u0435\u043d\u043a\u0430",
      "longitude":83.1103115,
      "latitude":51.7897999
    },
    "4882":{
      "name":"\u0428\u0438\u043f\u0438\u0446\u0438\u043d\u043e",
      "longitude":83.1247709,
      "latitude":53.6082804
    },
    "4883":{
      "name":"\u0423\u0441\u0442\u044c-\u041a\u043e\u0437\u043b\u0443\u0445\u0430",
      "longitude":83.1274099,
      "latitude":51.6304835
    },
    "4884":{
      "name":"\u041f\u043e\u043d\u043e\u043c\u0430\u0440\u0451\u0432\u043e",
      "longitude":83.1573287,
      "latitude":52.0728866
    },
    "4885":{
      "name":"\u0423\u0440\u043e\u0436\u0430\u0439\u043d\u044b\u0439",
      "longitude":83.161057,
      "latitude":53.275291
    },
    "4886":{
      "name":"\u041e\u0441\u043a\u043e\u043b\u043a\u043e\u0432\u043e",
      "longitude":83.1611173,
      "latitude":52.3256929
    },
    "4887":{
      "name":"\u0422\u043e\u043b\u0441\u0442\u0430\u044f \u0414\u0443\u0431\u0440\u043e\u0432\u0430",
      "longitude":83.1630709,
      "latitude":52.2601938
    },
    "4888":{
      "name":"\u0411\u0435\u043b\u043e\u044f\u0440\u043e\u0432\u043a\u0430",
      "longitude":83.1683219,
      "latitude":52.7697566
    },
    "4889":{
      "name":"\u041a\u0438\u0440\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":83.170204,
      "latitude":52.554291
    },
    "4890":{
      "name":"\u0427\u0435\u0440\u043d\u043e\u043f\u044f\u0442\u043e\u0432\u043e",
      "longitude":83.1733655,
      "latitude":53.3979724
    },
    "4891":{
      "name":"\u0417\u0438\u043c\u0438\u043d\u043e",
      "longitude":83.1787498,
      "latitude":52.6321005
    },
    "4892":{
      "name":"\u042f\u0437\u043e\u0432\u043e",
      "longitude":83.1807098,
      "latitude":53.592181
    },
    "4893":{
      "name":"\u0421\u0442\u0435\u043f\u043d\u043e\u0439",
      "longitude":83.1928737,
      "latitude":52.158815
    },
    "4894":{
      "name":"\u0423\u0441\u0442\u044c-\u041a\u0430\u043c\u044b\u0448\u0435\u043d\u043a\u0430",
      "longitude":83.1973426,
      "latitude":52.0545191
    },
    "4895":{
      "name":"\u0423\u0441\u0442\u044c-\u0427\u0443\u043c\u044b\u0448",
      "longitude":83.1975719,
      "latitude":53.5627525
    },
    "4896":{
      "name":"\u0415\u043b\u044c\u0446\u043e\u0432\u043a\u0430",
      "longitude":83.1990277,
      "latitude":51.9613553
    },
    "4897":{
      "name":"\u0423\u0441\u0442\u044c-\u041f\u0443\u0441\u0442\u044b\u043d\u043a\u0430",
      "longitude":83.2023475,
      "latitude":51.4727383
    },
    "4898":{
      "name":"\u0427\u0438\u0441\u0442\u044e\u043d\u044c\u043a\u0430",
      "longitude":83.2108276,
      "latitude":52.680959
    },
    "4899":{
      "name":"\u0422\u0440\u0443\u0434",
      "longitude":83.2197864,
      "latitude":52.8773322
    },
    "4900":{
      "name":"\u0428\u0438\u0448\u043a\u0438\u043d\u043e",
      "longitude":83.2215519,
      "latitude":53.6368682
    },
    "4901":{
      "name":"\u0427\u0435\u0440\u0451\u043c\u043d\u043e\u0435",
      "longitude":83.231209,
      "latitude":53.172653
    },
    "4902":{
      "name":"\u041f\u0440\u0443\u0442\u0441\u043a\u043e\u0439",
      "longitude":83.231331,
      "latitude":53.312016
    },
    "4903":{
      "name":"\u0428\u0438\u043b\u043e\u0432\u043e",
      "longitude":83.2559123,
      "latitude":52.9301492
    },
    "4904":{
      "name":"\u041d\u043e\u0432\u043e\u0448\u0438\u043f\u0443\u043d\u043e\u0432\u043e",
      "longitude":83.257103,
      "latitude":51.694641
    },
    "4905":{
      "name":"\u0422\u043e\u043f\u043e\u043b\u044c\u043d\u044b\u0439",
      "longitude":83.2598933,
      "latitude":52.4660004
    },
    "4906":{
      "name":"\u0421\u0430\u0440\u0430\u0438",
      "longitude":83.262833,
      "latitude":53.187981
    },
    "4907":{
      "name":"\u0411\u0430\u0440\u0441\u0443\u043a\u043e\u0432\u043e",
      "longitude":83.2770707,
      "latitude":53.4999006
    },
    "4908":{
      "name":"\u041a\u0430\u0437\u0430\u043d\u0446\u0435\u0432\u043e",
      "longitude":83.287827,
      "latitude":54.024975
    },
    "4909":{
      "name":"\u0427\u0430\u0440\u044b\u0448\u0441\u043a\u043e\u0435",
      "longitude":83.3047963,
      "latitude":52.1561477
    },
    "4910":{
      "name":"\u0423\u0441\u0442\u044c-\u041a\u0430\u043b\u043c\u0430\u043d\u043a\u0430",
      "longitude":83.307526,
      "latitude":52.124252
    },
    "4911":{
      "name":"\u041d\u043e\u0432\u043e\u0442\u0440\u043e\u0435\u043d\u043a\u0430",
      "longitude":83.3232296,
      "latitude":51.8407806
    },
    "4912":{
      "name":"\u041a\u0443\u0440\u043e\u0447\u043a\u0438\u043d\u043e",
      "longitude":83.3271122,
      "latitude":53.8728968
    },
    "4913":{
      "name":"\u0417\u0430\u0439\u0446\u0435\u0432\u043e",
      "longitude":83.3286164,
      "latitude":53.6888581
    },
    "4914":{
      "name":"\u041d\u043e\u0432\u043e\u0435\u043b\u043e\u0432\u043a\u0430",
      "longitude":83.3311876,
      "latitude":53.9072009
    },
    "4915":{
      "name":"\u0421\u0442\u0443\u043a\u043e\u0432\u043e",
      "longitude":83.337654,
      "latitude":53.208199
    },
    "4916":{
      "name":"\u0420\u0435\u0447\u043a\u0443\u043d\u043e\u0432\u043e",
      "longitude":83.3396013,
      "latitude":53.4975939
    },
    "4917":{
      "name":"\u041a\u0443\u0431\u0430\u043d\u043a\u0430",
      "longitude":83.35717,
      "latitude":52.824207
    },
    "4918":{
      "name":"\u041f\u0430\u043d\u0444\u0438\u043b\u043e\u0432\u043e",
      "longitude":83.3621789,
      "latitude":53.1510434
    },
    "4919":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u0430\u043b\u043c\u0430\u043d\u043a\u0430",
      "longitude":83.3641674,
      "latitude":51.9552251
    },
    "4920":{
      "name":"\u0428\u0430\u0445\u0438",
      "longitude":83.36454,
      "latitude":53.335144
    },
    "4921":{
      "name":"\u0420\u043e\u043c\u0430\u043d\u043e\u0432\u043e",
      "longitude":83.3648374,
      "latitude":52.4166674
    },
    "4922":{
      "name":"\u041c\u0430\u0440\u0430\u043b\u0438\u0445\u0430",
      "longitude":83.3654831,
      "latitude":51.6980393
    },
    "4923":{
      "name":"\u041d\u043e\u0432\u044b\u0439 \u0427\u0430\u0440\u044b\u0448",
      "longitude":83.3664342,
      "latitude":52.1749125
    },
    "4924":{
      "name":"\u041d\u043e\u0432\u043e\u0440\u043e\u043c\u0430\u043d\u043e\u0432\u043e",
      "longitude":83.3682817,
      "latitude":53.0990513
    },
    "4925":{
      "name":"\u0410\u043b\u0442\u0430\u0439",
      "longitude":83.3759309,
      "latitude":53.0067101
    },
    "4926":{
      "name":"\u041d\u0438\u0436\u043d\u044f\u044f \u0413\u0443\u0441\u0438\u0445\u0430",
      "longitude":83.3781003,
      "latitude":52.2981915
    },
    "4927":{
      "name":"\u0425\u0430\u0431\u0430\u0437\u0438\u043d\u043e",
      "longitude":83.3799099,
      "latitude":52.7432968
    },
    "4928":{
      "name":"\u041a\u043e\u043c\u0441\u043e\u043c\u043e\u043b\u044c\u0441\u043a\u0438\u0439",
      "longitude":83.381635,
      "latitude":53.267728
    },
    "4929":{
      "name":"\u041f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":83.3853201,
      "latitude":52.7146376
    },
    "4930":{
      "name":"\u041a\u043b\u044e\u0447\u0438",
      "longitude":83.3902246,
      "latitude":52.6172966
    },
    "4931":{
      "name":"\u0423\u0441\u0442\u044c-\u0416\u0443\u0440\u0430\u0432\u043b\u0438\u0445\u0430",
      "longitude":83.3908843,
      "latitude":52.221937
    },
    "4932":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u041c\u0430\u0439",
      "longitude":83.3951371,
      "latitude":51.7259681
    },
    "4933":{
      "name":"\u0423\u0441\u0442\u044c-\u0422\u0443\u043b\u0430\u0442\u0438\u043d\u043a\u0430",
      "longitude":83.3958466,
      "latitude":51.416413
    },
    "4934":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":83.4013782,
      "latitude":51.5722856
    },
    "4935":{
      "name":"\u041a\u0443\u043b\u0438\u043a\u043e\u0432\u043e",
      "longitude":83.4073399,
      "latitude":53.7107905
    },
    "4936":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u043a\u0430",
      "longitude":83.4085353,
      "latitude":53.3819288
    },
    "4937":{
      "name":"\u0429\u0435\u0431\u043d\u044e\u0445\u0430",
      "longitude":83.4178337,
      "latitude":51.4708474
    },
    "4938":{
      "name":"\u0422\u0443\u043b\u0430\u0442\u0430",
      "longitude":83.4244949,
      "latitude":51.3133521
    },
    "4939":{
      "name":"\u0414\u043e\u043b\u0438\u043d\u0441\u043a\u043e\u0435",
      "longitude":83.4281373,
      "latitude":51.3852294
    },
    "4940":{
      "name":"\u041d\u043e\u0432\u044b\u0435 \u0417\u043e\u0440\u0438",
      "longitude":83.4363429,
      "latitude":53.2419264
    },
    "4941":{
      "name":"\u041c\u0430\u044f\u043a",
      "longitude":83.4379413,
      "latitude":51.6138164
    },
    "4942":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u043c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":83.4429987,
      "latitude":51.6056681
    },
    "4943":{
      "name":"\u0411\u0440\u0443\u0441\u0435\u043d\u0446\u0435\u0432\u043e",
      "longitude":83.448824,
      "latitude":52.4406888
    },
    "4944":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u043f\u0435\u0440\u0443\u043d\u043e\u0432\u043e",
      "longitude":83.4631188,
      "latitude":53.7730278
    },
    "4945":{
      "name":"\u0417\u0438\u043c\u0430\u0440\u0438",
      "longitude":83.465675,
      "latitude":53.186638
    },
    "4946":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u044f\u0440\u043a\u0430",
      "longitude":83.466691,
      "latitude":52.7542685
    },
    "4947":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u044f\u0440\u043a\u0430",
      "longitude":83.474901,
      "latitude":52.2262419
    },
    "4948":{
      "name":"\u041d\u043e\u0432\u043e\u043c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":83.4763746,
      "latitude":53.3483871
    },
    "4949":{
      "name":"\u041a\u0430\u0440\u0430\u0441\u0435\u0432\u043e",
      "longitude":83.4894363,
      "latitude":52.7891732
    },
    "4950":{
      "name":"\u041a\u0430\u0448\u043a\u0430\u0440\u0430\u0433\u0430\u0438\u0445\u0430",
      "longitude":83.4929678,
      "latitude":53.732774
    },
    "4951":{
      "name":"\u041f\u0440\u0438\u043e\u0437\u0451\u0440\u043d\u044b\u0439",
      "longitude":83.4935749,
      "latitude":52.1640357
    },
    "4952":{
      "name":"\u041d\u043e\u0432\u043e\u043f\u0435\u0440\u0443\u043d\u043e\u0432\u043e",
      "longitude":83.4949377,
      "latitude":53.8808575
    },
    "4953":{
      "name":"\u041c\u0430\u0440\u0430\u043b\u044c\u0438 \u0420\u043e\u0436\u043a\u0438",
      "longitude":83.4993221,
      "latitude":51.7297675
    },
    "4954":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0435 \u041e\u0440\u043b\u044b",
      "longitude":83.4998462,
      "latitude":51.5950606
    },
    "4955":{
      "name":"\u0412\u043e\u0441\u0442\u043e\u0447\u043d\u044b\u0439",
      "longitude":83.5072186,
      "latitude":52.0510125
    },
    "4956":{
      "name":"\u041b\u0435\u0441\u043d\u043e\u0439",
      "longitude":83.5112895,
      "latitude":53.2671617
    },
    "4957":{
      "name":"\u041b\u0443\u0448\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":83.5169974,
      "latitude":54.0132748
    },
    "4958":{
      "name":"\u0422\u0440\u043e\u0438\u0446\u043a\u043e\u0435",
      "longitude":83.5179509,
      "latitude":52.3754857
    },
    "4959":{
      "name":"\u041d\u0430\u0443\u0447\u043d\u044b\u0439 \u0413\u043e\u0440\u043e\u0434\u043e\u043a",
      "longitude":83.519699,
      "latitude":53.420643
    },
    "4960":{
      "name":"\u041a\u043e\u0448\u0435\u043b\u0435\u0432\u043e",
      "longitude":83.5303497,
      "latitude":53.9654841
    },
    "4961":{
      "name":"\u041e\u0433\u043d\u0438",
      "longitude":83.530942,
      "latitude":51.9088514
    },
    "4962":{
      "name":"\u041a\u0430\u043b\u043c\u0430\u043d\u043a\u0430",
      "longitude":83.533943,
      "latitude":52.899948
    },
    "4963":{
      "name":"\u0427\u0435\u0440\u043d\u0438\u0446\u043a",
      "longitude":83.553078,
      "latitude":53.215336
    },
    "4964":{
      "name":"\u0427\u0430\u0440\u044b\u0448\u0441\u043a\u043e\u0435",
      "longitude":83.5541995,
      "latitude":51.3975548
    },
    "4965":{
      "name":"\u0422\u0440\u043e\u0438\u0446\u043a",
      "longitude":83.55793,
      "latitude":52.8831253
    },
    "4966":{
      "name":"\u041d\u0430\u0443\u043c\u043e\u0432\u043e",
      "longitude":83.5769524,
      "latitude":53.7790176
    },
    "4967":{
      "name":"\u0413\u043e\u043d\u044c\u0431\u0430",
      "longitude":83.577713,
      "latitude":53.415703
    },
    "4968":{
      "name":"\u0412\u043b\u0430\u0441\u0438\u0445\u0430",
      "longitude":83.5778361,
      "latitude":53.2982076
    },
    "4969":{
      "name":"\u041c\u043e\u0445\u043d\u0430\u0442\u0443\u0448\u043a\u0430",
      "longitude":83.580376,
      "latitude":53.229877
    },
    "4970":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u041f\u0430\u0440\u0442\u0438\u0437\u0430\u043d",
      "longitude":83.5805919,
      "latitude":51.3758587
    },
    "4971":{
      "name":"\u0423\u0441\u0442\u044c-\u0410\u043b\u0435\u0439\u043a\u0430",
      "longitude":83.583595,
      "latitude":52.82312
    },
    "4972":{
      "name":"\u041a\u0430\u043b\u0438\u0441\u0442\u0440\u0430\u0442\u0438\u0445\u0430",
      "longitude":83.5875263,
      "latitude":52.986416
    },
    "4973":{
      "name":"\u0411\u0443\u0440\u0430\u043d\u043e\u0432\u043e",
      "longitude":83.596123,
      "latitude":53.048225
    },
    "4974":{
      "name":"\u041a\u043e\u043c\u0435\u043d\u0434\u0430\u043d\u0442\u043a\u0430",
      "longitude":83.5978512,
      "latitude":51.3340902
    },
    "4975":{
      "name":"\u0415\u043b\u0431\u0430\u043d\u043a\u0430",
      "longitude":83.6046782,
      "latitude":52.2290516
    },
    "4976":{
      "name":"\u041f\u0440\u0438\u0433\u043e\u0440\u043e\u0434\u043d\u044b\u0439",
      "longitude":83.604713,
      "latitude":53.299572
    },
    "4977":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u041c\u0430\u0440\u0430\u043b\u0438\u0445\u0430",
      "longitude":83.6056785,
      "latitude":51.7741881
    },
    "4978":{
      "name":"\u041a\u0430\u0437\u0451\u043d\u043d\u0430\u044f \u0417\u0430\u0438\u043c\u043a\u0430",
      "longitude":83.606987,
      "latitude":53.403141
    },
    "4979":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u043a\u0430",
      "longitude":83.612995,
      "latitude":51.2728704
    },
    "4980":{
      "name":"\u0426\u0435\u043d\u0442\u0440\u0430\u043b\u044c\u043d\u044b\u0439",
      "longitude":83.6146953,
      "latitude":53.2202173
    },
    "4981":{
      "name":"\u042f\u0433\u043e\u0434\u043d\u043e\u0435",
      "longitude":83.6148297,
      "latitude":53.2277295
    },
    "4982":{
      "name":"\u0410\u043d\u0438\u0441\u0438\u043c\u043e\u0432\u043e",
      "longitude":83.6210242,
      "latitude":54.0225536
    },
    "4983":{
      "name":"\u0412\u044f\u0442\u043a\u0438\u043d\u043e",
      "longitude":83.6183814472223,
      "latitude":52.51924260075863
    },
    "4984":{
      "name":"\u041b\u0443\u0433\u043e\u0432\u043e\u0435",
      "longitude":83.6229418,
      "latitude":53.7972912
    },
    "4985":{
      "name":"\u0412\u043e\u043b\u043e\u0434\u0430\u0440\u043a\u0430",
      "longitude":83.62368,
      "latitude":52.715099
    },
    "4986":{
      "name":"\u0411\u0435\u043b\u043e\u0432\u043e",
      "longitude":83.62694467798536,
      "latitude":52.621850105788866
    },
    "4987":{
      "name":"\u0428\u0430\u0434\u0440\u0438\u043d\u043e",
      "longitude":83.6334795,
      "latitude":53.1131307
    },
    "4988":{
      "name":"\u0421\u0440\u0435\u0434\u043d\u0435\u0441\u0438\u0431\u0438\u0440\u0441\u043a\u0438\u0439",
      "longitude":83.6441486,
      "latitude":53.7434119
    },
    "4989":{
      "name":"\u0411\u043e\u0440\u0437\u043e\u0432\u0430\u044f \u0417\u0430\u0438\u043c\u043a\u0430",
      "longitude":83.656456,
      "latitude":53.290306
    },
    "4990":{
      "name":"\u041b\u0435\u0431\u044f\u0436\u044c\u0435",
      "longitude":83.6566112,
      "latitude":53.2422958
    },
    "4991":{
      "name":"\u041a\u043e\u043b\u043e\u0432\u044b\u0439 \u041c\u044b\u0441",
      "longitude":83.656787,
      "latitude":52.2499636
    },
    "4992":{
      "name":"\u0423\u0441\u0442\u044c-\u0427\u0430\u0440\u044b\u0448\u0441\u043a\u0430\u044f \u041f\u0440\u0438\u0441\u0442\u0430\u043d\u044c",
      "longitude":83.667618,
      "latitude":52.391582
    },
    "4993":{
      "name":"\u0417\u0430\u0431\u0440\u043e\u0434\u0438\u043d\u043e",
      "longitude":83.6691513,
      "latitude":53.8015976
    },
    "4994":{
      "name":"\u041b\u0438\u0442\u0432\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":83.6748238,
      "latitude":53.6947037
    },
    "4995":{
      "name":"\u0421\u0432\u0430\u043b\u043e\u0432\u043a\u0430",
      "longitude":83.6757097,
      "latitude":51.4910457
    },
    "4996":{
      "name":"\u0422\u0430\u0441\u043a\u0430\u0435\u0432\u043e",
      "longitude":83.6832385,
      "latitude":53.8557819
    },
    "4997":{
      "name":"\u041f\u043e\u043b\u0437\u0443\u043d\u043e\u0432\u043e",
      "longitude":83.6909529,
      "latitude":53.2984507
    },
    "4998":{
      "name":"\u0421\u0438\u0431\u0438\u0440\u0441\u043a\u0430\u044f \u0434\u043e\u043b\u0438\u043d\u0430",
      "longitude":83.6941296,
      "latitude":53.2223271
    },
    "4999":{
      "name":"\u041e\u0437\u0451\u0440\u043a\u0438",
      "longitude":83.6959955,
      "latitude":53.6669984
    },
    "5000":{
      "name":"\u0411\u0435\u043b\u044c\u043c\u0435\u0441\u0451\u0432\u043e",
      "longitude":83.6993759,
      "latitude":53.1983475
    },
    "5001":{
      "name":"\u0421\u0430\u0434\u043e\u0432\u043e\u0434\u043e\u0432",
      "longitude":83.7060846,
      "latitude":53.2432055
    },
    "5002":{
      "name":"\u041a\u043e\u0440\u043e\u0431\u0435\u0439\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":83.7075659,
      "latitude":52.187144
    },
    "5003":{
      "name":"\u041e\u0437\u0451\u0440\u043a\u0438",
      "longitude":83.714438,
      "latitude":53.6285789
    },
    "5004":{
      "name":"\u041b\u0435\u0441\u043d\u0430\u044f \u041f\u043e\u043b\u044f\u043d\u0430",
      "longitude":83.7162729,
      "latitude":53.5716493
    },
    "5005":{
      "name":"\u041f\u043b\u043e\u0434\u043e\u043f\u0438\u0442\u043e\u043c\u043d\u0438\u043a",
      "longitude":83.7341544,
      "latitude":53.2591324
    },
    "5006":{
      "name":"\u041d\u043e\u0432\u043e\u0442\u0440\u043e\u0438\u0446\u043a",
      "longitude":83.73568,
      "latitude":53.901283
    },
    "5007":{
      "name":"\u0412\u044b\u043f\u043e\u043b\u0437\u043e\u0432\u043e",
      "longitude":83.7409019,
      "latitude":53.8420895
    },
    "5008":{
      "name":"\u0421\u0435\u043d\u0442\u0435\u043b\u0435\u043a",
      "longitude":83.7525877,
      "latitude":51.20391
    },
    "5009":{
      "name":"\u041d\u0438\u0436\u043d\u0435\u043e\u0437\u0435\u0440\u043d\u043e\u0435",
      "longitude":83.7540829,
      "latitude":52.220515
    },
    "5010":{
      "name":"\u041a\u043b\u0435\u043f\u0438\u043a\u043e\u0432\u043e",
      "longitude":83.758202,
      "latitude":52.539997
    },
    "5011":{
      "name":"\u0420\u043e\u0433\u0443\u043b\u0438\u0447\u043d\u044b\u0439",
      "longitude":83.760287,
      "latitude":53.6522058
    },
    "5012":{
      "name":"\u041a\u0430\u043c\u044b\u0448\u0435\u043d\u043a\u0430",
      "longitude":83.7604487,
      "latitude":52.6057424
    },
    "5013":{
      "name":"\u0421\u0438\u0431\u0438\u0440\u0441\u043a\u0438\u0439",
      "longitude":83.766159,
      "latitude":53.579979
    },
    "5014":{
      "name":"\u0427\u0430\u0443\u0437\u043e\u0432\u043e",
      "longitude":83.7664569,
      "latitude":52.7370057
    },
    "5015":{
      "name":"\u041f\u043e\u0432\u0430\u043b\u0438\u0445\u0430",
      "longitude":83.768364,
      "latitude":53.512199
    },
    "5016":{
      "name":"\u0412\u0435\u0440\u0445-\u0421\u043b\u044e\u0434\u044f\u043d\u043a\u0430",
      "longitude":83.77862,
      "latitude":51.7906901
    },
    "5017":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u0434\u0430\u0440\u0441\u043a\u043e\u0435",
      "longitude":83.7981911,
      "latitude":52.1157976
    },
    "5018":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":83.79861,
      "latitude":51.9573419
    },
    "5019":{
      "name":"\u0417\u0430\u0433\u0430\u0439\u043d\u043e\u0432\u043e",
      "longitude":83.8184074,
      "latitude":54.067081
    },
    "5020":{
      "name":"\u0412\u043e\u0441\u0442\u043e\u0447\u043d\u044b\u0439",
      "longitude":83.8245548,
      "latitude":53.7311898
    },
    "5021":{
      "name":"\u041c\u0430\u043b\u044b\u0439 \u0411\u0430\u0449\u0435\u043b\u0430\u043a",
      "longitude":83.8271137,
      "latitude":51.4911502
    },
    "5022":{
      "name":"\u041a\u0430\u0437\u0430\u0447\u0438\u0439",
      "longitude":83.840508,
      "latitude":53.5316437
    },
    "5023":{
      "name":"\u0420\u0430\u0441\u0441\u043a\u0430\u0437\u0438\u0445\u0430",
      "longitude":83.841705,
      "latitude":53.08984
    },
    "5024":{
      "name":"\u0411\u043e\u0440\u043e\u0432\u0438\u0445\u0430",
      "longitude":83.842514,
      "latitude":53.506401
    },
    "5025":{
      "name":"\u041e\u043a\u0442\u044f\u0431\u0440\u044c\u0441\u043a\u043e\u0435",
      "longitude":83.8449403,
      "latitude":53.5699706
    },
    "5026":{
      "name":"\u0427\u0435\u043a\u0430\u043d\u0438\u0445\u0430",
      "longitude":83.8505582,
      "latitude":52.3663201
    },
    "5027":{
      "name":"\u041f\u043e\u0434\u0441\u043e\u0431\u043d\u043e\u0435",
      "longitude":83.8642454,
      "latitude":53.5756989
    },
    "5028":{
      "name":"\u0417\u0443\u0434\u0438\u043b\u043e\u0432\u043e",
      "longitude":83.882668,
      "latitude":53.47662
    },
    "5029":{
      "name":"\u0411\u043e\u0431\u0440\u043e\u0432\u043a\u0430",
      "longitude":83.884911,
      "latitude":53.172817
    },
    "5030":{
      "name":"\u0418\u043d\u044e\u0448\u043e\u0432\u043e",
      "longitude":83.8989675,
      "latitude":53.9288552
    },
    "5031":{
      "name":"\u0411\u0435\u043b\u043e\u044f\u0440\u0441\u043a",
      "longitude":83.904831,
      "latitude":53.453388
    },
    "5032":{
      "name":"\u0427\u0438\u0441\u0442\u044b\u0435 \u041f\u0440\u0443\u0434\u044b",
      "longitude":83.9284142,
      "latitude":53.3154707
    },
    "5033":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u0440\u0430\u044e\u0448\u043a\u0438\u043d\u043e",
      "longitude":83.9409639,
      "latitude":53.771522
    },
    "5034":{
      "name":"\u0424\u0438\u0440\u0441\u043e\u0432\u043e",
      "longitude":83.955177,
      "latitude":53.317245
    },
    "5035":{
      "name":"\u0428\u0430\u0434\u0440\u0438\u043d\u0446\u0435\u0432\u043e",
      "longitude":83.9626408,
      "latitude":53.9455536
    },
    "5036":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":83.9648558,
      "latitude":51.6747271
    },
    "5037":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u0411\u0430\u0449\u0435\u043b\u0430\u043a",
      "longitude":83.972635,
      "latitude":51.5362606
    },
    "5038":{
      "name":"\u0421\u0430\u043d\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":83.972717,
      "latitude":53.354343
    },
    "5039":{
      "name":"\u041b\u0438\u0441\u0442\u0432\u044f\u043d\u043a\u0430",
      "longitude":83.9732993,
      "latitude":52.755417
    },
    "5040":{
      "name":"\u0410\u043d\u0442\u043e\u043d\u044c\u0435\u0432\u043a\u0430",
      "longitude":83.9736616,
      "latitude":51.9959625
    },
    "5041":{
      "name":"\u041b\u0435\u0441\u043d\u043e\u0439",
      "longitude":83.9737015,
      "latitude":53.2437117
    },
    "5042":{
      "name":"\u0421\u0435\u0432\u0435\u0440\u043d\u044b\u0439",
      "longitude":83.9875447,
      "latitude":53.8308719
    },
    "5043":{
      "name":"\u0421\u043e\u043b\u043d\u0435\u0447\u043d\u043e\u0435",
      "longitude":83.9953458,
      "latitude":53.393218
    },
    "5044":{
      "name":"\u0411\u0430\u0436\u0435\u0432\u043e",
      "longitude":83.9958345,
      "latitude":53.416476
    },
    "5045":{
      "name":"\u041d\u043e\u0432\u044b\u0439",
      "longitude":83.9989541,
      "latitude":53.3848473
    },
    "5046":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u043a\u0430",
      "longitude":83.999664,
      "latitude":53.406292
    },
    "5047":{
      "name":"\u0418\u043b\u044c\u0438\u0447\u0430",
      "longitude":84.0151156,
      "latitude":53.5523141
    },
    "5048":{
      "name":"\u0410\u043a\u0443\u043b\u043e\u0432\u043e",
      "longitude":84.0219641,
      "latitude":53.9175092
    },
    "5049":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u043c\u0430\u0439\u0441\u043a\u043e\u0435",
      "longitude":84.0307415,
      "latitude":53.7274811
    },
    "5050":{
      "name":"\u0421\u043e\u0441\u043d\u043e\u0432\u043a\u0430",
      "longitude":84.0310129,
      "latitude":53.121701
    },
    "5051":{
      "name":"\u0421\u0438\u0431\u0438\u0440\u044f\u0447\u0438\u0445\u0430",
      "longitude":84.044876,
      "latitude":51.756664
    },
    "5052":{
      "name":"\u0411\u0435\u0440\u0435\u0437\u043e\u0432\u043a\u0430",
      "longitude":84.0510571,
      "latitude":51.838031
    },
    "5053":{
      "name":"\u041d\u043e\u0432\u043e\u043e\u0431\u0438\u043d\u043a\u0430",
      "longitude":84.0567358,
      "latitude":52.2318401
    },
    "5054":{
      "name":"\u0427\u0435\u0440\u0432\u044f\u043d\u043a\u0430",
      "longitude":84.073459,
      "latitude":52.6007019
    },
    "5055":{
      "name":"\u0438\u043c\u0435\u043d\u0438 \u041a\u0430\u043b\u0438\u043d\u0438\u043d\u0430",
      "longitude":84.0808026,
      "latitude":52.1306152
    },
    "5056":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0435 \u041e\u0440\u043b\u044b",
      "longitude":84.0825267,
      "latitude":52.1470143
    },
    "5057":{
      "name":"\u041d\u043e\u0432\u043e\u043f\u043e\u0432\u0430\u043b\u0438\u0445\u0430",
      "longitude":84.0899574,
      "latitude":53.7280663
    },
    "5058":{
      "name":"\u0422\u0430\u043b\u044c\u043c\u0435\u043d\u043a\u0430",
      "longitude":84.1144491,
      "latitude":51.6335404
    },
    "5059":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":84.1174863,
      "latitude":52.0547069
    },
    "5060":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":84.1253012,
      "latitude":52.1906713
    },
    "5061":{
      "name":"\u0421\u043e\u043b\u043e\u0432\u044c\u0438\u0445\u0430",
      "longitude":84.1266397,
      "latitude":51.9641471
    },
    "5062":{
      "name":"\u041f\u0440\u0430\u0432\u0434\u0430",
      "longitude":84.128471,
      "latitude":53.4356
    },
    "5063":{
      "name":"\u0417\u0435\u043b\u0435\u043d\u044b\u0439 \u0414\u043e\u043b",
      "longitude":84.1333214,
      "latitude":52.1183842
    },
    "5064":{
      "name":"\u0421\u043e\u0440\u043e\u0447\u0438\u0439 \u041b\u043e\u0433",
      "longitude":84.1450397,
      "latitude":53.5747164
    },
    "5065":{
      "name":"\u0410\u043d\u0443\u0439\u0441\u043a\u0438\u0439",
      "longitude":84.1663489,
      "latitude":51.7400107
    },
    "5066":{
      "name":"\u0411\u0430\u044e\u043d\u043e\u0432\u0441\u043a\u0438\u0435 \u041a\u043b\u044e\u0447\u0438",
      "longitude":84.1962172,
      "latitude":53.3324596
    },
    "5067":{
      "name":"\u041b\u043e\u0433\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":84.1980171,
      "latitude":53.498537
    },
    "5068":{
      "name":"\u042e\u0440\u0442\u043d\u043e\u0435",
      "longitude":84.2268113,
      "latitude":51.8154246
    },
    "5069":{
      "name":"\u0416\u0443\u0440\u0430\u0432\u043b\u0438\u0445\u0430",
      "longitude":84.2354715,
      "latitude":53.7838051
    },
    "5070":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u041a\u0430\u043b\u0442\u0430\u0439",
      "longitude":84.259311,
      "latitude":54.1293822
    },
    "5071":{
      "name":"\u041f\u0430\u0443\u0442\u043e\u0432\u043e",
      "longitude":84.2655419,
      "latitude":52.2140019
    },
    "5072":{
      "name":"\u0412\u0435\u0440\u0445-\u041e\u0437\u0451\u0440\u043d\u043e\u0435",
      "longitude":84.2778026,
      "latitude":52.329377
    },
    "5073":{
      "name":"\u0422\u0435\u043b\u0435\u0436\u0438\u0445\u0430",
      "longitude":84.280411,
      "latitude":51.530369
    },
    "5074":{
      "name":"\u041a\u0443\u043b\u0438\u0447\u044c\u0435",
      "longitude":84.2898495,
      "latitude":53.0515584
    },
    "5075":{
      "name":"\u0427\u0435\u0440\u0451\u043c\u0443\u0448\u043a\u0438\u043d\u043e",
      "longitude":84.2902284,
      "latitude":54.0102841
    },
    "5076":{
      "name":"\u0414\u0443\u043c\u0447\u0435\u0432\u043e",
      "longitude":84.2911325,
      "latitude":53.9571112
    },
    "5077":{
      "name":"\u0427\u0435\u0440\u0435\u043c\u0448\u0430\u043d\u043a\u0430",
      "longitude":84.2918917,
      "latitude":51.7508364
    },
    "5078":{
      "name":"\u041e\u0437\u0435\u0440\u043e-\u041f\u0435\u0442\u0440\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":84.2969052,
      "latitude":52.9442087
    },
    "5079":{
      "name":"\u041d\u043e\u0432\u043e\u0431\u0435\u0440\u0451\u0437\u043e\u0432\u043a\u0430",
      "longitude":84.3020943,
      "latitude":53.748849
    },
    "5080":{
      "name":"\u0416\u0438\u043b\u0438\u043d\u043e",
      "longitude":84.3105087,
      "latitude":53.405993
    },
    "5081":{
      "name":"\u0421\u043e\u043b\u043e\u043d\u0435\u0448\u043d\u043e\u0435",
      "longitude":84.318352,
      "latitude":51.655628
    },
    "5082":{
      "name":"\u0423\u043a\u0440\u0430\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":84.336355,
      "latitude":53.308261
    },
    "5083":{
      "name":"\u041e\u0437\u0435\u0440\u043e-\u041a\u0440\u0430\u0441\u0438\u043b\u043e\u0432\u043e",
      "longitude":84.3676913,
      "latitude":53.1755051
    },
    "5084":{
      "name":"\u041c\u043d\u043e\u0433\u043e\u043e\u0437\u0451\u0440\u043d\u044b\u0439",
      "longitude":84.376038,
      "latitude":52.736439
    },
    "5085":{
      "name":"\u041a\u0430\u043c\u044b\u0448\u0435\u043d\u043a\u0430",
      "longitude":84.3883498,
      "latitude":52.0071568
    },
    "5086":{
      "name":"\u0418\u0441\u043a\u0440\u0430",
      "longitude":84.4014019,
      "latitude":51.5627569
    },
    "5087":{
      "name":"\u041c\u0430\u043b\u0430\u0445\u043e\u0432\u043e",
      "longitude":84.4031928,
      "latitude":53.3545832
    },
    "5088":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u043c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":84.4100027,
      "latitude":51.7945264
    },
    "5089":{
      "name":"\u041b\u044e\u0442\u0430\u0435\u0432\u043e",
      "longitude":84.4213128,
      "latitude":51.8829064
    },
    "5090":{
      "name":"\u0417\u0430\u0432\u043e\u0434\u0441\u043a\u043e\u0435",
      "longitude":84.422505,
      "latitude":53.0694874
    },
    "5091":{
      "name":"\u041a\u043e\u043d\u0442\u043e\u0448\u0438\u043d\u043e",
      "longitude":84.4272891,
      "latitude":53.2219828
    },
    "5092":{
      "name":"\u041d\u043e\u0432\u043e\u043f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":84.4459053,
      "latitude":52.2204665
    },
    "5093":{
      "name":"\u0411\u043e\u0440\u043e\u0432\u043b\u044f\u043d\u043a\u0430",
      "longitude":84.4459172,
      "latitude":52.6340372
    },
    "5094":{
      "name":"\u041f\u0440\u0438\u043e\u0431\u0441\u043a\u043e\u0435",
      "longitude":84.4555196,
      "latitude":52.3464203
    },
    "5095":{
      "name":"\u041c\u0435\u0434\u0432\u0435\u0434\u0435\u0432\u043a\u0430",
      "longitude":84.4654674,
      "latitude":51.733429
    },
    "5096":{
      "name":"\u0410\u043a\u0443\u0442\u0438\u0445\u0430",
      "longitude":84.4664873,
      "latitude":52.433505
    },
    "5097":{
      "name":"\u0422\u043e\u043f\u043e\u043b\u044c\u043d\u043e\u0435",
      "longitude":84.499418,
      "latitude":51.5081241
    },
    "5098":{
      "name":"\u041d\u043e\u0432\u043e\u043c\u043e\u043d\u043e\u0448\u043a\u0438\u043d\u043e",
      "longitude":84.5013926,
      "latitude":53.6138983
    },
    "5099":{
      "name":"\u0413\u043b\u0443\u0448\u0438\u043d\u043a\u0430",
      "longitude":84.5074242,
      "latitude":53.4553304
    },
    "5100":{
      "name":"\u0428\u043f\u0430\u0433\u0438\u043d\u043e",
      "longitude":84.5221955,
      "latitude":53.5473335
    },
    "5101":{
      "name":"\u0417\u0430\u0433\u0430\u0439\u043d\u043e\u0432\u043e",
      "longitude":84.5353287,
      "latitude":52.8667786
    },
    "5102":{
      "name":"\u0428\u0430\u0442\u0443\u043d\u043e\u0432\u043e",
      "longitude":84.5355409,
      "latitude":53.8994153
    },
    "5103":{
      "name":"\u0422\u0443\u043d\u0434\u0440\u0438\u0445\u0430",
      "longitude":84.5450531,
      "latitude":53.9947846
    },
    "5104":{
      "name":"\u041f\u0435\u0441\u044c\u044f\u043d\u043a\u0430",
      "longitude":84.5493628,
      "latitude":53.1164945
    },
    "5105":{
      "name":"\u041a\u0430\u0440\u043f\u043e\u0432\u043e",
      "longitude":84.5591623,
      "latitude":51.8513549
    },
    "5106":{
      "name":"\u0428\u043f\u0430\u0433\u0438\u043d\u043e",
      "longitude":84.5596349,
      "latitude":53.5870526
    },
    "5107":{
      "name":"\u041c\u0430\u0442\u0432\u0435\u0435\u0432\u043a\u0430",
      "longitude":84.5699149,
      "latitude":51.7286606
    },
    "5108":{
      "name":"\u041a\u043e\u0441\u0438\u0445\u0430",
      "longitude":84.5795068,
      "latitude":53.3619517
    },
    "5109":{
      "name":"\u0412\u0435\u0440\u0445-\u0410\u043d\u0443\u0439\u0441\u043a\u043e\u0435",
      "longitude":84.5895996,
      "latitude":52.2098519
    },
    "5110":{
      "name":"\u041d\u0430\u043b\u043e\u0431\u0438\u0445\u0430",
      "longitude":84.5956933,
      "latitude":53.1995353
    },
    "5111":{
      "name":"\u0422\u044e\u043c\u0435\u043d\u044c",
      "longitude":84.5957319,
      "latitude":52.9370532
    },
    "5112":{
      "name":"\u0423\u0442\u043a\u0443\u043b\u044c",
      "longitude":84.6026186,
      "latitude":52.7188925
    },
    "5113":{
      "name":"\u0421\u0440\u0435\u0434\u043d\u0435\u043a\u0440\u0430\u0441\u0438\u043b\u043e\u0432\u043e",
      "longitude":84.6029693,
      "latitude":53.794963
    },
    "5114":{
      "name":"\u0412\u0435\u0440\u0448\u0438\u043d\u0438\u043d\u043e",
      "longitude":84.6091259,
      "latitude":52.7287726
    },
    "5115":{
      "name":"\u0421\u0442\u0435\u043f\u043d\u043e\u0435",
      "longitude":84.6180307,
      "latitude":51.5034851
    },
    "5116":{
      "name":"\u041f\u043e\u043b\u043a\u043e\u0432\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":84.627693,
      "latitude":53.215885
    },
    "5117":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u0432\u043a\u0430",
      "longitude":84.6309019,
      "latitude":53.0737161
    },
    "5118":{
      "name":"\u0425\u043b\u0435\u0431\u043e\u0440\u043e\u0431\u043d\u043e\u0435",
      "longitude":84.63549,
      "latitude":52.213215
    },
    "5119":{
      "name":"\u0421\u043e\u043b\u043e\u043d\u043e\u0432\u043a\u0430",
      "longitude":84.6359506,
      "latitude":52.0064471
    },
    "5120":{
      "name":"\u0411\u0435\u043b\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":84.6385405,
      "latitude":52.892681
    },
    "5121":{
      "name":"\u0422\u0443\u043c\u0430\u043d\u043e\u0432\u043e",
      "longitude":84.645287,
      "latitude":51.595627
    },
    "5122":{
      "name":"\u0412\u0435\u0440\u0445-\u0416\u0438\u043b\u0438\u043d\u043e",
      "longitude":84.6505573,
      "latitude":53.4914841
    },
    "5123":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u0413\u043e\u0440\u043e\u0434\u043e\u043a",
      "longitude":84.6609982,
      "latitude":51.9814093
    },
    "5124":{
      "name":"\u0421\u043c\u043e\u043b\u0435\u043d\u0441\u043a\u0438\u0439",
      "longitude":84.6680511,
      "latitude":52.2133804
    },
    "5125":{
      "name":"\u0413\u043e\u0440\u0434\u0435\u0435\u0432\u0441\u043a\u0438\u0439",
      "longitude":84.6798254,
      "latitude":53.1116519
    },
    "5126":{
      "name":"\u0412\u0435\u0440\u0448\u0438\u043d\u0438\u043d\u043e",
      "longitude":84.6831899,
      "latitude":52.7242835
    },
    "5127":{
      "name":"\u041e\u043a\u0442\u044f\u0431\u0440\u044c\u0441\u043a\u0438\u0439",
      "longitude":84.6839452,
      "latitude":53.1215487
    },
    "5128":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u0416\u0438\u0437\u043d\u044c",
      "longitude":84.6915018,
      "latitude":51.7008443
    },
    "5129":{
      "name":"\u0411\u043e\u0440\u043e\u0432\u043b\u044f\u043d\u0441\u043a\u0438\u0439",
      "longitude":84.6983117,
      "latitude":52.8643528
    },
    "5130":{
      "name":"\u0411\u0435\u043b\u043e\u0435",
      "longitude":84.716931,
      "latitude":52.9204275
    },
    "5131":{
      "name":"\u041a\u043e\u043c\u0430\u0440\u043e\u0432\u043e",
      "longitude":84.7310761,
      "latitude":52.5629158
    },
    "5132":{
      "name":"\u0417\u0435\u043b\u0451\u043d\u0430\u044f \u041f\u043e\u043b\u044f\u043d\u0430",
      "longitude":84.7380842,
      "latitude":52.8827405
    },
    "5133":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u043e\u043f\u044b\u043b\u043e\u0432\u043e",
      "longitude":84.742401,
      "latitude":53.67725
    },
    "5134":{
      "name":"\u041f\u043b\u043e\u0442\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":84.745853,
      "latitude":53.4146649
    },
    "5135":{
      "name":"\u0427\u0435\u0440\u043d\u043e\u0432\u0430\u044f",
      "longitude":84.753891,
      "latitude":51.96505
    },
    "5136":{
      "name":"\u0423\u0441\u0442\u044c-\u0410\u043d\u0443\u0439",
      "longitude":84.7576856,
      "latitude":52.3893726
    },
    "5137":{
      "name":"\u0421\u0442\u0435\u043f\u043d\u043e\u0439",
      "longitude":84.7619452,
      "latitude":52.8668763
    },
    "5138":{
      "name":"\u041f\u0435\u0449\u0435\u0440\u043a\u0430",
      "longitude":84.7711542,
      "latitude":54.0943477
    },
    "5139":{
      "name":"\u0421\u044b\u0447\u0451\u0432\u043a\u0430",
      "longitude":84.771422,
      "latitude":52.052718
    },
    "5140":{
      "name":"\u041a\u0430\u0440\u043a\u0430\u0432\u0438\u043d\u043e",
      "longitude":84.7819764,
      "latitude":53.3429378
    },
    "5141":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u0420\u0435\u0447\u043a\u0430",
      "longitude":84.790115,
      "latitude":53.027809
    },
    "5142":{
      "name":"\u0421\u043e\u043a\u043e\u043b\u043e\u0432\u043e",
      "longitude":84.790535,
      "latitude":52.534126
    },
    "5143":{
      "name":"\u042e\u0436\u043d\u044b\u0439",
      "longitude":84.7997973,
      "latitude":52.1436155
    },
    "5144":{
      "name":"\u041f\u043b\u0435\u0448\u043a\u043e\u0432\u043e",
      "longitude":84.7998068,
      "latitude":52.7458412
    },
    "5145":{
      "name":"\u0413\u043e\u043d\u043e\u0448\u0438\u0445\u0430",
      "longitude":84.8076355,
      "latitude":53.7680774
    },
    "5146":{
      "name":"\u041a\u0438\u043f\u0435\u0448\u0438\u043d\u043e",
      "longitude":84.811057,
      "latitude":52.9411874
    },
    "5147":{
      "name":"\u0412\u0435\u0440\u0445-\u041a\u0430\u043c\u044b\u0448\u0435\u043d\u043a\u0430",
      "longitude":84.816528,
      "latitude":53.597847
    },
    "5148":{
      "name":"\u0411\u0430\u0442\u0443\u043d\u043d\u044b\u0439",
      "longitude":84.8194827,
      "latitude":53.6645569
    },
    "5149":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u0442\u044b\u0440\u044b\u0448\u043a\u0438\u043d\u043e",
      "longitude":84.826584,
      "latitude":52.349709
    },
    "5150":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":84.85994,
      "latitude":52.658848
    },
    "5151":{
      "name":"\u0410\u043d\u0443\u0439\u0441\u043a\u043e\u0435",
      "longitude":84.860649,
      "latitude":52.302773
    },
    "5152":{
      "name":"\u0421\u0430\u0432\u0438\u043d\u043e\u0432\u043e",
      "longitude":84.8607536,
      "latitude":52.5177145
    },
    "5153":{
      "name":"\u0411\u0435\u043b\u043e\u043a\u0443\u0440\u0438\u0445\u0430-2",
      "longitude":84.8744003,
      "latitude":51.9499271
    },
    "5154":{
      "name":"\u041f\u0435\u0441\u0447\u0430\u043d\u043e\u0435",
      "longitude":84.8799229,
      "latitude":52.3925431
    },
    "5155":{
      "name":"\u0421\u0442\u0435\u043f\u043d\u043e\u0435",
      "longitude":84.8982616,
      "latitude":52.1891467
    },
    "5156":{
      "name":"\u041d\u043e\u0432\u043e\u0442\u044b\u0440\u044b\u0448\u043a\u0438\u043d\u043e",
      "longitude":84.8991221,
      "latitude":52.0821446
    },
    "5157":{
      "name":"\u0417\u0430\u0440\u0435\u0447\u043d\u044b\u0439",
      "longitude":84.900893,
      "latitude":52.356392
    },
    "5158":{
      "name":"\u041d\u043e\u0432\u043e\u0437\u044b\u0440\u044f\u043d\u043e\u0432\u043e",
      "longitude":84.9012604,
      "latitude":53.8102564
    },
    "5159":{
      "name":"\u0424\u043e\u043c\u0438\u043d\u0441\u043a\u043e\u0435",
      "longitude":84.906876,
      "latitude":52.453457
    },
    "5160":{
      "name":"\u041a\u0443\u044f\u0433\u0430\u043d",
      "longitude":84.9081276,
      "latitude":51.6995982
    },
    "5161":{
      "name":"\u0425\u0430\u0439\u0440\u044e\u0437\u043e\u0432\u043a\u0430",
      "longitude":84.9187259,
      "latitude":52.9579917
    },
    "5162":{
      "name":"\u0413\u0440\u0438\u0448\u0438\u043d\u043e",
      "longitude":84.919289,
      "latitude":53.586498
    },
    "5163":{
      "name":"\u0411\u0443\u043b\u0430\u043d\u0438\u0445\u0430",
      "longitude":84.928841,
      "latitude":52.802433
    },
    "5164":{
      "name":"\u0417\u043e\u043d\u0430\u043b\u044c\u043d\u043e\u0435",
      "longitude":84.934296,
      "latitude":52.664467
    },
    "5165":{
      "name":"\u041a\u043b\u044e\u043a\u0432\u0435\u043d\u043d\u044b\u0439",
      "longitude":84.9449897,
      "latitude":53.1749153
    },
    "5166":{
      "name":"\u041d\u0430\u0431\u0435\u0440\u0435\u0436\u043d\u044b\u0439",
      "longitude":84.9501998,
      "latitude":52.3631023
    },
    "5167":{
      "name":"\u041d\u043e\u0432\u043e\u0435\u043b\u043e\u0432\u043a\u0430",
      "longitude":84.9502285,
      "latitude":53.0557983
    },
    "5168":{
      "name":"\u0413\u043e\u0440\u0434\u0435\u0435\u0432\u043a\u0430",
      "longitude":84.9505954,
      "latitude":53.0816435
    },
    "5169":{
      "name":"\u041e\u0434\u0438\u043d\u0446\u043e\u0432\u043a\u0430",
      "longitude":84.955467,
      "latitude":52.438225
    },
    "5170":{
      "name":"\u041a\u043e\u0440\u0434\u043e\u043d",
      "longitude":84.9644754,
      "latitude":54.1856606
    },
    "5171":{
      "name":"\u041b\u0438\u043d\u0435\u0432\u0441\u043a\u0438\u0439",
      "longitude":84.9735449,
      "latitude":52.365333
    },
    "5172":{
      "name":"\u041b\u043e\u0441\u0438\u0445\u0430",
      "longitude":84.9739661,
      "latitude":53.3884958
    },
    "5173":{
      "name":"\u0412\u043e\u0441\u043a\u0440\u0435\u0441\u0435\u043d\u043a\u0430",
      "longitude":84.999397,
      "latitude":53.908535
    },
    "5174":{
      "name":"\u0411\u043e\u0440\u0438\u0441\u043e\u0432\u043e",
      "longitude":85.0041641,
      "latitude":54.0322008
    },
    "5175":{
      "name":"\u041e\u043a\u0442\u044f\u0431\u0440\u044c\u0441\u043a\u0438\u0439",
      "longitude":85.0069522,
      "latitude":52.7348139
    },
    "5176":{
      "name":"\u0427\u0435\u0440\u0432\u043e\u0432\u043e",
      "longitude":85.0084582,
      "latitude":53.4835458
    },
    "5177":{
      "name":"\u0422\u043e\u0443\u0440\u0430\u043a",
      "longitude":85.0099786,
      "latitude":51.578559
    },
    "5178":{
      "name":"\u0421\u0430\u0444\u043e\u043d\u043e\u0432\u043a\u0430",
      "longitude":85.0174946,
      "latitude":52.5456986
    },
    "5179":{
      "name":"\u0412\u0435\u0440\u0445-\u041e\u0431\u0441\u043a\u0438\u0439",
      "longitude":85.0186052,
      "latitude":52.4180192
    },
    "5180":{
      "name":"\u041c\u0438\u0440\u043d\u044b\u0439",
      "longitude":85.0207341,
      "latitude":52.5712527
    },
    "5181":{
      "name":"\u041a\u0438\u0440\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":85.0257146,
      "latitude":52.2903418
    },
    "5182":{
      "name":"\u0422\u043e\u0447\u0438\u043b\u044c\u043d\u043e\u0435",
      "longitude":85.0306148,
      "latitude":52.1585602
    },
    "5183":{
      "name":"\u0423\u0441\u0442\u044c-\u0413\u0430\u0432\u0440\u0438\u043b\u043e\u0432\u043a\u0430",
      "longitude":85.0316433,
      "latitude":52.9397518
    },
    "5184":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":85.045222,
      "latitude":52.225389
    },
    "5185":{
      "name":"\u0423\u0441\u0442\u044c-\u041a\u0430\u0442\u0443\u043d\u044c",
      "longitude":85.0537861,
      "latitude":52.4171009
    },
    "5186":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u0427\u0435\u043c\u0440\u043e\u0432\u043a\u0430",
      "longitude":85.0571429,
      "latitude":52.5993871
    },
    "5187":{
      "name":"\u041a\u0443\u044f\u0447\u0430",
      "longitude":85.073143,
      "latitude":51.671593
    },
    "5188":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u0431\u0435\u043b\u043e\u043a\u0443\u0440\u0438\u0445\u0430",
      "longitude":85.0778216,
      "latitude":52.0528084
    },
    "5189":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u0434\u0440\u0430\u0447\u0435\u043d\u0438\u043d\u043e",
      "longitude":85.0817241,
      "latitude":53.6836544
    },
    "5190":{
      "name":"\u041a\u043e\u043c\u0430\u0440\u0441\u043a\u043e\u0435",
      "longitude":85.0831402,
      "latitude":53.6422837
    },
    "5191":{
      "name":"\u0428\u0443\u0431\u0451\u043d\u043a\u0430",
      "longitude":85.1042589,
      "latitude":52.6557267
    },
    "5192":{
      "name":"\u041a\u0430\u0442\u0443\u043d\u0441\u043a\u043e\u0435",
      "longitude":85.115991,
      "latitude":52.4123953
    },
    "5193":{
      "name":"\u041d\u043e\u0432\u043e\u0434\u0440\u0430\u0447\u0451\u043d\u0438\u043d\u043e",
      "longitude":85.122269,
      "latitude":53.796196
    },
    "5194":{
      "name":"\u0415\u043b\u044c\u0446\u043e\u0432\u043a\u0430",
      "longitude":85.127296,
      "latitude":53.058872
    },
    "5195":{
      "name":"\u041f\u043e\u0440\u043e\u0448\u0438\u043d\u043e",
      "longitude":85.1439035,
      "latitude":53.2300429
    },
    "5196":{
      "name":"\u0423\u0441\u0442\u044c-\u041a\u0430\u0442\u0443\u043d\u044c",
      "longitude":85.1667003,
      "latitude":52.4556184
    },
    "5197":{
      "name":"\u041b\u0443\u0433\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":85.1690395,
      "latitude":52.7631736
    },
    "5198":{
      "name":"\u0417\u0430\u0440\u044f",
      "longitude":85.175362,
      "latitude":52.59655
    },
    "5199":{
      "name":"\u0425\u043c\u0435\u043b\u0451\u0432\u043a\u0430",
      "longitude":85.183655,
      "latitude":53.952503
    },
    "5200":{
      "name":"\u0421\u0442\u0430\u0440\u0430\u044f \u0427\u0435\u043c\u0440\u043e\u0432\u043a\u0430",
      "longitude":85.1876155,
      "latitude":52.659671
    },
    "5201":{
      "name":"\u041d\u0430\u0433\u043e\u0440\u043d\u044b\u0439",
      "longitude":85.1944974,
      "latitude":52.5527565
    },
    "5202":{
      "name":"\u0421\u043c\u0430\u0437\u043d\u0435\u0432\u043e",
      "longitude":85.202171,
      "latitude":53.840645
    },
    "5203":{
      "name":"\u041e\u0437\u0451\u0440\u043d\u043e\u0435",
      "longitude":85.2041512,
      "latitude":53.6760851
    },
    "5204":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u043c\u0430\u0439\u0441\u043a\u043e\u0435",
      "longitude":85.2142057,
      "latitude":52.2885488
    },
    "5205":{
      "name":"\u042f\u043d\u043e\u0432\u043e",
      "longitude":85.21788,
      "latitude":53.901333
    },
    "5206":{
      "name":"\u041c\u0430\u043a\u0430\u0440\u044c\u0435\u0432\u043a\u0430",
      "longitude":85.2295768,
      "latitude":51.9865166
    },
    "5207":{
      "name":"\u0415\u0440\u0435\u043c\u0438\u043d\u043e",
      "longitude":85.2354865,
      "latitude":53.1619308
    },
    "5208":{
      "name":"\u0420\u043e\u0441\u0441\u043e\u0448\u0438",
      "longitude":85.2390117,
      "latitude":52.0921651
    },
    "5209":{
      "name":"\u0414\u043c\u0438\u0442\u0440\u043e-\u0422\u0438\u0442\u043e\u0432\u043e",
      "longitude":85.2418208,
      "latitude":53.5833694
    },
    "5210":{
      "name":"\u041f\u0440\u0438\u0433\u043e\u0440\u043e\u0434\u043d\u044b\u0439",
      "longitude":85.243912,
      "latitude":52.573414
    },
    "5211":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u043c\u0430\u0439\u0441\u043a\u043e\u0435",
      "longitude":85.2527815,
      "latitude":52.5901124
    },
    "5212":{
      "name":"\u041a\u043e\u043b\u0431\u0430\u043d\u044b",
      "longitude":85.2532596,
      "latitude":52.1641413
    },
    "5213":{
      "name":"\u041b\u0435\u0441\u043d\u043e\u0435",
      "longitude":85.256966,
      "latitude":52.465542
    },
    "5214":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u044c\u0441\u043a\u043e\u0435",
      "longitude":85.261841,
      "latitude":52.215286
    },
    "5215":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u0422\u0430\u0440\u0430\u0431\u0430",
      "longitude":85.2810988,
      "latitude":53.383929
    },
    "5216":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u044f\u0440\u044b",
      "longitude":85.2916557,
      "latitude":53.1627055
    },
    "5217":{
      "name":"\u0410\u043c\u0443\u0440\u0441\u043a\u0438\u0439",
      "longitude":85.3036363,
      "latitude":52.4776113
    },
    "5218":{
      "name":"\u0428\u0443\u043b\u044c\u0433\u0438\u043d\u043a\u0430",
      "longitude":85.3097876,
      "latitude":52.4370233
    },
    "5219":{
      "name":"\u0412\u0435\u0440\u0445-\u0428\u0443\u0431\u0438\u043d\u043a\u0430",
      "longitude":85.3116742,
      "latitude":52.9421007
    },
    "5220":{
      "name":"\u0411\u043e\u0440\u043e\u0432\u043e\u0439",
      "longitude":85.3119923,
      "latitude":52.5737754
    },
    "5221":{
      "name":"\u041e\u043a\u0442\u044f\u0431\u0440\u044c\u0441\u043a\u0438\u0439",
      "longitude":85.3303997,
      "latitude":53.2862648
    },
    "5222":{
      "name":"\u0413\u043b\u0438\u043d\u043a\u0430",
      "longitude":85.3355535,
      "latitude":52.1992842
    },
    "5223":{
      "name":"\u0413\u043e\u0440\u043d\u043e\u0432\u043e\u0435",
      "longitude":85.3376954,
      "latitude":53.0742569
    },
    "5224":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u042f\u0440",
      "longitude":85.3411494,
      "latitude":52.3558394
    },
    "5225":{
      "name":"\u041c\u0430\u043b\u043e\u0443\u0433\u0440\u0435\u043d\u0435\u0432\u043e",
      "longitude":85.347351,
      "latitude":52.562
    },
    "5226":{
      "name":"\u0412\u043e\u0441\u0442\u043e\u0447\u043d\u044b\u0439",
      "longitude":85.3537656,
      "latitude":52.6369072
    },
    "5227":{
      "name":"\u0421\u0430\u0440\u0430\u0441\u0430",
      "longitude":85.3554246,
      "latitude":51.8715471
    },
    "5228":{
      "name":"\u0411\u0435\u043b\u043e\u0435",
      "longitude":85.3567283,
      "latitude":51.6223327
    },
    "5229":{
      "name":"\u0423\u0433\u0440\u0435\u043d\u0435\u0432\u043a\u0430",
      "longitude":85.3572874,
      "latitude":52.5499509
    },
    "5230":{
      "name":"\u0421\u0432\u0435\u0440\u0447\u043a\u043e\u0432\u043e",
      "longitude":85.3622374,
      "latitude":52.7766406
    },
    "5231":{
      "name":"\u0421\u043e\u0441\u043d\u043e\u0432\u043a\u0430",
      "longitude":85.372711,
      "latitude":53.88018
    },
    "5232":{
      "name":"\u041d\u0438\u0436\u043d\u0435\u043a\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":85.3786286,
      "latitude":52.0399756
    },
    "5233":{
      "name":"\u0421\u0443\u0445\u0430\u044f \u0427\u0435\u043c\u0440\u043e\u0432\u043a\u0430",
      "longitude":85.3797748,
      "latitude":52.7229723
    },
    "5234":{
      "name":"\u0425\u043e\u043c\u0443\u0442\u0438\u043d\u043e",
      "longitude":85.4075141,
      "latitude":53.1620947
    },
    "5235":{
      "name":"\u0421\u0435\u043c\u0435\u043d\u043e\u0432\u043e\u0434",
      "longitude":85.4201525,
      "latitude":52.5489707
    },
    "5236":{
      "name":"\u0417\u044b\u0440\u044f\u043d\u043e\u0432\u043a\u0430",
      "longitude":85.4207556,
      "latitude":53.7813738
    },
    "5237":{
      "name":"\u0412\u0435\u0440\u0445-\u041a\u0430\u0442\u0443\u043d\u0441\u043a\u043e\u0435",
      "longitude":85.4243749,
      "latitude":52.4515934
    },
    "5238":{
      "name":"\u0413\u043e\u043b\u0443\u0445\u0430",
      "longitude":85.429787,
      "latitude":53.845795
    },
    "5239":{
      "name":"\u042f\u0441\u043d\u0430\u044f \u041f\u043e\u043b\u044f\u043d\u0430",
      "longitude":85.4319163,
      "latitude":52.6814216
    },
    "5240":{
      "name":"\u0421\u043e\u0441\u043d\u043e\u0432\u044b\u0439 \u041b\u043e\u0433",
      "longitude":85.4385701,
      "latitude":53.3293616
    },
    "5241":{
      "name":"\u041b\u043e\u0436\u043a\u0438\u043d\u043e",
      "longitude":85.441424,
      "latitude":52.8349374
    },
    "5242":{
      "name":"\u041a\u044b\u0442\u043c\u0430\u043d\u043e\u0432\u043e",
      "longitude":85.450447,
      "latitude":53.459545
    },
    "5243":{
      "name":"\u0421\u0435\u0442\u043e\u0432\u043a\u0430",
      "longitude":85.467493,
      "latitude":52.1998228
    },
    "5244":{
      "name":"\u0422\u044f\u0445\u0442\u0430",
      "longitude":85.4735413,
      "latitude":53.576144
    },
    "5245":{
      "name":"\u0422\u044f\u0433\u0443\u043d",
      "longitude":85.4756995,
      "latitude":53.4703207
    },
    "5246":{
      "name":"\u0421\u0442\u0430\u0440\u0430\u044f \u0422\u0430\u0440\u0430\u0431\u0430",
      "longitude":85.4864064,
      "latitude":53.3996706
    },
    "5247":{
      "name":"\u0427\u0443\u0439\u0441\u043a\u0438\u0439",
      "longitude":85.4903889,
      "latitude":52.4414288
    },
    "5248":{
      "name":"\u0415\u043d\u0438\u0441\u0435\u0439\u0441\u043a\u043e\u0435",
      "longitude":85.4940737,
      "latitude":52.5780959
    },
    "5249":{
      "name":"\u041c\u0430\u0440\u0443\u0448\u043a\u0430",
      "longitude":85.5028394,
      "latitude":52.8786482
    },
    "5250":{
      "name":"\u041c\u0430\u043b\u043e\u0435\u043d\u0438\u0441\u0435\u0439\u0441\u043a\u043e\u0435",
      "longitude":85.502853,
      "latitude":52.567955
    },
    "5251":{
      "name":"\u0416\u0443\u043b\u0430\u043d\u0438\u0445\u0430",
      "longitude":85.508255,
      "latitude":53.786808
    },
    "5252":{
      "name":"\u0414\u0440\u0443\u0436\u0431\u0430",
      "longitude":85.521656,
      "latitude":52.8996201
    },
    "5253":{
      "name":"\u0421\u0432\u0435\u0442\u043b\u043e\u043e\u0437\u0451\u0440\u0441\u043a\u043e\u0435",
      "longitude":85.5224499,
      "latitude":52.527213
    },
    "5254":{
      "name":"\u041a\u043e\u043a\u0448\u0438",
      "longitude":85.5342685,
      "latitude":52.3809471
    },
    "5255":{
      "name":"\u0421\u0443\u043d\u0433\u0430\u0439",
      "longitude":85.5417848,
      "latitude":53.6499586
    },
    "5256":{
      "name":"\u0420\u0443\u043f\u043e\u0441\u043e\u0432\u043e",
      "longitude":85.5595586,
      "latitude":52.9560771
    },
    "5257":{
      "name":"\u0412\u043e\u0435\u0432\u043e\u0434\u0441\u043a\u043e\u0435",
      "longitude":85.6031371,
      "latitude":52.7929067
    },
    "5258":{
      "name":"\u0421\u0435\u043c\u0451\u043d\u043e-\u041a\u0440\u0430\u0441\u0438\u043b\u043e\u0432\u043e",
      "longitude":85.6093153,
      "latitude":53.5593876
    },
    "5259":{
      "name":"\u0421\u0435\u043c\u0438\u043b\u0435\u0442\u043a\u0430",
      "longitude":85.6154787,
      "latitude":52.302418
    },
    "5260":{
      "name":"\u041f\u043e\u043b\u043e\u0432\u0438\u043d\u043a\u0430",
      "longitude":85.6183833,
      "latitude":52.1883531
    },
    "5261":{
      "name":"\u041a\u043e\u043b\u043e\u0432\u043e",
      "longitude":85.6225032,
      "latitude":52.0883681
    },
    "5262":{
      "name":"\u0421\u0442\u0430\u043d-\u0411\u0435\u0445\u0442\u0435\u043c\u0438\u0440",
      "longitude":85.62426,
      "latitude":52.600708
    },
    "5263":{
      "name":"\u0412\u0435\u0440\u0445-\u041c\u0430\u0440\u0443\u0448\u043a\u0430",
      "longitude":85.6260223,
      "latitude":52.9181019
    },
    "5264":{
      "name":"\u0423\u0440\u043e\u0436\u0430\u0439\u043d\u043e\u0435",
      "longitude":85.647911,
      "latitude":52.305332
    },
    "5265":{
      "name":"\u0422\u044f\u0433\u0443\u043d",
      "longitude":85.658531,
      "latitude":53.950409
    },
    "5266":{
      "name":"\u0412\u0435\u0440\u0445-\u0410\u044f",
      "longitude":85.6644348,
      "latitude":51.9581062
    },
    "5267":{
      "name":"\u0422\u0430\u043b\u0438\u0446\u0430",
      "longitude":85.6712543,
      "latitude":52.3907957
    },
    "5268":{
      "name":"\u0421\u0440\u043e\u0441\u0442\u043a\u0438",
      "longitude":85.7060495,
      "latitude":52.4209605
    },
    "5269":{
      "name":"\u041d\u0438\u0436\u043d\u0435\u043a\u0430\u044f\u043d\u0447\u0430",
      "longitude":85.7109847,
      "latitude":51.8675348
    },
    "5270":{
      "name":"\u0415\u043b\u0430\u043d\u0434\u0430",
      "longitude":85.7225775,
      "latitude":53.1886923
    },
    "5271":{
      "name":"\u0423\u0441\u044f\u0442\u0441\u043a\u043e\u0435",
      "longitude":85.7541038,
      "latitude":52.5661635
    },
    "5272":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0435\u0443\u0433\u0440\u0435\u043d\u0435\u0432\u043e",
      "longitude":85.7565173,
      "latitude":52.6073922
    },
    "5273":{
      "name":"\u0423\u0441\u0442\u044e\u0431\u0430",
      "longitude":85.7587216,
      "latitude":51.8764414
    },
    "5274":{
      "name":"\u0422\u0438\u0442\u043e\u0432\u043e",
      "longitude":85.7596169,
      "latitude":53.4154868
    },
    "5275":{
      "name":"\u0411\u043e\u0447\u043a\u0430\u0440\u0438",
      "longitude":85.7727873,
      "latitude":52.8875901
    },
    "5276":{
      "name":"\u0412\u0435\u0440\u0445-\u042f\u043c\u0438\u043d\u0441\u043a\u043e\u0435",
      "longitude":85.8010174,
      "latitude":52.993801
    },
    "5277":{
      "name":"\u0428\u0435\u0431\u0430\u043b\u0438\u043d\u043e",
      "longitude":85.8048173,
      "latitude":52.7171509
    },
    "5278":{
      "name":"\u0410\u044f",
      "longitude":85.80687,
      "latitude":51.953049
    },
    "5279":{
      "name":"\u041d\u043e\u0432\u043e\u0438\u0443\u0448\u0438\u043d\u043e",
      "longitude":85.8086075,
      "latitude":53.6359177
    },
    "5280":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u043a\u0430",
      "longitude":85.822594,
      "latitude":52.353035
    },
    "5281":{
      "name":"\u0411\u044b\u0441\u0442\u0440\u044f\u043d\u043a\u0430",
      "longitude":85.8313865,
      "latitude":52.2853349
    },
    "5282":{
      "name":"\u0410\u043d\u0442\u0438\u043f\u0438\u043d\u043e",
      "longitude":85.843048,
      "latitude":53.297543
    },
    "5283":{
      "name":"\u0428\u0430\u043b\u0430\u043f",
      "longitude":85.8458525,
      "latitude":53.1170948
    },
    "5284":{
      "name":"\u041a\u0430\u0442\u0443\u043d\u044c",
      "longitude":85.8511328,
      "latitude":51.9162409
    },
    "5285":{
      "name":"\u0428\u0443\u043b\u044c\u0433\u0438\u043d \u041b\u043e\u0433",
      "longitude":85.853218,
      "latitude":52.170986
    },
    "5286":{
      "name":"\u041a\u043e\u043b\u043e\u043d\u043a\u043e\u0432\u043e",
      "longitude":85.8683419,
      "latitude":53.3303324
    },
    "5287":{
      "name":"\u0421\u0442\u0430\u0440\u0430\u044f \u0421\u0443\u0440\u0442\u0430\u0439\u043a\u0430",
      "longitude":85.8761243,
      "latitude":52.2305674
    },
    "5288":{
      "name":"\u0410\u043b\u0430\u043c\u0431\u0430\u0439",
      "longitude":85.889252,
      "latitude":54.032581
    },
    "5289":{
      "name":"\u0428\u0430\u0434\u0440\u0438\u043d\u043e",
      "longitude":85.8923742,
      "latitude":52.8556009
    },
    "5290":{
      "name":"\u0421\u0442\u0430\u0440\u044b\u0439 \u0422\u043e\u0433\u0443\u043b",
      "longitude":85.903373,
      "latitude":53.4251161
    },
    "5291":{
      "name":"\u041f\u043b\u0430\u0442\u043e\u0432\u043e",
      "longitude":85.905228,
      "latitude":52.072865
    },
    "5292":{
      "name":"\u041c\u0430\u0440\u0442\u044b\u043d\u043e\u0432\u043e",
      "longitude":85.9106275,
      "latitude":53.2615329
    },
    "5293":{
      "name":"\u0412\u0435\u0440\u0445-\u0411\u0435\u0445\u0442\u0435\u043c\u0438\u0440",
      "longitude":85.9111242,
      "latitude":52.7690288
    },
    "5294":{
      "name":"\u0422\u043e\u0433\u0443\u043b",
      "longitude":85.913284,
      "latitude":53.462803
    },
    "5295":{
      "name":"\u041b\u044c\u043d\u043e\u0437\u0430\u0432\u043e\u0434",
      "longitude":85.9531665,
      "latitude":53.4557892
    },
    "5296":{
      "name":"\u041d\u043e\u0432\u0438\u043a\u043e\u0432\u043e",
      "longitude":85.9595767,
      "latitude":52.6211277
    },
    "5297":{
      "name":"\u0421\u043e\u0443\u0441\u043a\u0430\u043d\u0438\u0445\u0430",
      "longitude":85.962456,
      "latitude":52.564526
    },
    "5298":{
      "name":"\u0423\u0441\u0442\u044c-\u0418\u0448\u0430",
      "longitude":85.9647982,
      "latitude":52.1787095
    },
    "5299":{
      "name":"\u0423\u043a\u0441\u0443\u043d\u0430\u0439",
      "longitude":86.0114414,
      "latitude":53.4959336
    },
    "5300":{
      "name":"\u0421\u0442\u0435\u043f\u044c-\u0427\u0443\u043c\u044b\u0448",
      "longitude":86.0212658,
      "latitude":53.1190597
    },
    "5301":{
      "name":"\u0422\u0430\u043b\u044b\u0439",
      "longitude":86.0454337,
      "latitude":52.3198117
    },
    "5302":{
      "name":"\u041f\u043e\u0431\u0435\u0434\u0430",
      "longitude":86.0476091,
      "latitude":53.1229493
    },
    "5303":{
      "name":"\u041a\u0430\u0440\u0430\u0433\u0443\u0436",
      "longitude":86.07766,
      "latitude":52.140865
    },
    "5304":{
      "name":"\u041e\u0432\u0441\u044f\u043d\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":86.0844161,
      "latitude":52.9276128
    },
    "5305":{
      "name":"\u0422\u043e\u043f\u0442\u0443\u0448\u043a\u0430",
      "longitude":86.098,
      "latitude":53.373035
    },
    "5306":{
      "name":"\u041b\u0435\u0431\u044f\u0436\u044c\u0435",
      "longitude":86.1302149,
      "latitude":52.5955507
    },
    "5307":{
      "name":"\u0427\u0435\u0440\u0435\u043c\u0448\u0430\u043d\u043a\u0430",
      "longitude":86.1552611,
      "latitude":53.198321
    },
    "5308":{
      "name":"\u041d\u043e\u0432\u043e\u0437\u044b\u043a\u043e\u0432\u043e",
      "longitude":86.1869638,
      "latitude":52.1583942
    },
    "5309":{
      "name":"\u0412\u0435\u0440\u0445-\u041a\u043e\u043f\u0442\u0435\u043b\u043a\u0430",
      "longitude":86.1934193,
      "latitude":53.4670083
    },
    "5310":{
      "name":"\u041d\u0435\u043d\u0438\u043d\u043a\u0430",
      "longitude":86.197098,
      "latitude":52.672928
    },
    "5311":{
      "name":"\u041b\u043e\u043a\u043e\u0442\u044c",
      "longitude":86.2141011,
      "latitude":53.0507518
    },
    "5312":{
      "name":"\u041a\u0430\u0440\u0430\u0431\u0438\u043d\u043a\u0430",
      "longitude":86.246065,
      "latitude":52.683705
    },
    "5313":{
      "name":"\u041f\u043e\u043f\u043e\u0432\u0438\u0447\u0438",
      "longitude":86.2637561,
      "latitude":53.0053669
    },
    "5314":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":86.3162656,
      "latitude":53.3576556
    },
    "5315":{
      "name":"\u0411\u0435\u0440\u0435\u0437\u043e\u0432\u043e",
      "longitude":86.3219666,
      "latitude":52.8825536
    },
    "5316":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u0410\u0436\u0438\u043d\u043a\u0430",
      "longitude":86.3243973,
      "latitude":52.5509036
    },
    "5317":{
      "name":"\u0423\u0441\u0442\u044c-\u041a\u0430\u0436\u0430",
      "longitude":86.338402,
      "latitude":52.544403
    },
    "5318":{
      "name":"\u0438\u043c\u0435\u043d\u0438 \u0424\u0440\u0443\u043d\u0437\u0435",
      "longitude":86.3405155,
      "latitude":52.5853639
    },
    "5319":{
      "name":"\u041a\u0430\u0440\u0430\u0433\u0430\u043d",
      "longitude":86.3442311,
      "latitude":52.8029444
    },
    "5320":{
      "name":"\u041d\u0438\u0436\u043d\u044f\u044f \u041d\u0435\u043d\u0438\u043d\u043a\u0430",
      "longitude":86.4002447,
      "latitude":52.7330084
    },
    "5321":{
      "name":"\u0412\u0435\u0440\u0445-\u041d\u0435\u043d\u044f",
      "longitude":86.4273893,
      "latitude":53.0744334
    },
    "5322":{
      "name":"\u041f\u0443\u0448\u0442\u0443\u043b\u0438\u043c",
      "longitude":86.4304676,
      "latitude":53.2034
    },
    "5323":{
      "name":"\u0410\u043a\u0430\u0442\u044c\u0435\u0432\u043e",
      "longitude":86.4641104,
      "latitude":52.774131
    },
    "5324":{
      "name":"\u0421\u043e\u043b\u0442\u043e\u043d",
      "longitude":86.4763899,
      "latitude":52.8376309
    },
    "5325":{
      "name":"\u0422\u043e\u0441\u0442\u043e\u043a",
      "longitude":86.5254175,
      "latitude":52.7466842
    },
    "5326":{
      "name":"\u0423\u0440\u0443\u043d\u0441\u043a",
      "longitude":86.5337088,
      "latitude":52.8867566
    },
    "5327":{
      "name":"\u041c\u0430\u043a\u0430\u0440\u044c\u0435\u0432\u043a\u0430",
      "longitude":86.5430727,
      "latitude":52.992604
    },
    "5328":{
      "name":"\u0428\u0430\u0442\u043e\u0431\u0430\u043b",
      "longitude":86.558702,
      "latitude":52.8575743
    },
    "5329":{
      "name":"\u0421\u0430\u0439\u0434\u044b\u043f",
      "longitude":86.5738065,
      "latitude":52.5738353
    },
    "5330":{
      "name":"\u0418\u0437\u043b\u0430\u043f",
      "longitude":86.619682,
      "latitude":52.907101
    },
    "5331":{
      "name":"\u0421\u0443\u0437\u043e\u043f",
      "longitude":86.6338219,
      "latitude":52.7775882
    },
    "5332":{
      "name":"\u0423\u0441\u0442\u044c-\u041a\u0443\u044e\u0442",
      "longitude":86.6420624,
      "latitude":52.5268445
    },
    "5333":{
      "name":"\u0421\u0430\u044f\u043d\u044b",
      "longitude":99.674812,
      "latitude":52.689281
    },
    "5334":{
      "name":"\u041e\u0440\u043b\u0438\u043a",
      "longitude":99.826981,
      "latitude":52.513195
    },
    "5335":{
      "name":"\u0425\u0443\u0436\u0438\u0440",
      "longitude":99.858368,
      "latitude":52.795006
    },
    "5336":{
      "name":"\u0421\u043e\u0440\u043e\u043a",
      "longitude":100.1711285,
      "latitude":52.3252047
    },
    "5337":{
      "name":"\u041c\u043e\u043d\u0434\u044b",
      "longitude":100.996269,
      "latitude":51.675842
    },
    "5338":{
      "name":"\u0425\u043e\u0439\u0442\u043e-\u0413\u043e\u043b",
      "longitude":101.5208392,
      "latitude":51.7038673
    },
    "5339":{
      "name":"\u0422\u0443\u0440\u0430\u043d",
      "longitude":101.65976,
      "latitude":51.635654
    },
    "5340":{
      "name":"\u041d\u0438\u043b\u043e\u0432\u043a\u0430",
      "longitude":101.679334,
      "latitude":51.6916828
    },
    "5341":{
      "name":"\u0428\u0438\u043c\u043a\u0438",
      "longitude":102.0074832,
      "latitude":51.670117
    },
    "5342":{
      "name":"\u0425\u0443\u0436\u0438\u0440\u044b",
      "longitude":102.092522,
      "latitude":51.678772
    },
    "5343":{
      "name":"\u0425\u0430\u0440\u0431\u044f\u0442\u044b",
      "longitude":102.282265,
      "latitude":51.668316
    },
    "5344":{
      "name":"\u0422\u0430\u0433\u0430\u0440\u0445\u0430\u0439",
      "longitude":102.395447,
      "latitude":51.879887
    },
    "5345":{
      "name":"\u041e\u0445\u043e\u0440-\u0428\u0438\u0431\u0438\u0440\u044c",
      "longitude":102.4158631,
      "latitude":51.6734181
    },
    "5346":{
      "name":"\u0412\u044b\u0448\u043a\u0430",
      "longitude":102.4259123,
      "latitude":51.7133087
    },
    "5347":{
      "name":"\u0410\u0440\u0448\u0430\u043d",
      "longitude":102.4359887,
      "latitude":51.9077929
    },
    "5348":{
      "name":"\u0416\u0435\u043c\u0447\u0443\u0433",
      "longitude":102.45755,
      "latitude":51.691154
    },
    "5349":{
      "name":"\u0425\u0443\u0440\u0430\u0439-\u0425\u043e\u0431\u043e\u043a",
      "longitude":102.477531,
      "latitude":51.855469
    },
    "5350":{
      "name":"\u0422\u0430\u043b\u043e\u0435",
      "longitude":102.478821,
      "latitude":51.821896
    },
    "5351":{
      "name":"\u0422\u0430\u0431\u0430\u043b\u0430\u043d\u0433\u0443\u0442",
      "longitude":102.500481,
      "latitude":51.789162
    },
    "5352":{
      "name":"\u0413\u0430\u043b\u0431\u0430\u0439",
      "longitude":102.54026,
      "latitude":51.792042
    },
    "5353":{
      "name":"\u0422\u0443\u043d\u043a\u0430",
      "longitude":102.540329,
      "latitude":51.751225
    },
    "5354":{
      "name":"\u0417\u0430\u043a\u0442\u0443\u0439",
      "longitude":102.639572,
      "latitude":51.69466
    },
    "5355":{
      "name":"\u0423\u0442\u0430\u0442\u0430",
      "longitude":102.787628,
      "latitude":50.829422
    },
    "5356":{
      "name":"\u0421\u0430\u043d\u0430\u0433\u0430",
      "longitude":102.808083,
      "latitude":50.73077
    },
    "5357":{
      "name":"\u0417\u0443\u043d-\u041c\u0443\u0440\u0438\u043d\u043e",
      "longitude":102.882423,
      "latitude":51.748123
    },
    "5358":{
      "name":"\u0414\u0430\u043b\u0430\u0445\u0430\u0439",
      "longitude":102.895653,
      "latitude":50.899265
    },
    "5359":{
      "name":"\u0415\u043d\u0433\u043e\u0440\u0431\u043e\u0439",
      "longitude":102.919342,
      "latitude":50.509827
    },
    "5360":{
      "name":"\u0414\u0430\u043b\u0430\u0445\u0430\u0439",
      "longitude":103.0077858,
      "latitude":51.8109178
    },
    "5361":{
      "name":"\u0422\u043e\u0440\u044b",
      "longitude":103.012886,
      "latitude":51.789459
    },
    "5362":{
      "name":"\u0425\u043e\u043d\u0433\u043e\u0434\u043e\u0440\u044b",
      "longitude":103.044014,
      "latitude":51.832207
    },
    "5363":{
      "name":"\u0428\u0430\u0440\u0430-\u0410\u0437\u0430\u0440\u0433\u0430",
      "longitude":103.049568,
      "latitude":50.484043
    },
    "5364":{
      "name":"\u041d\u0443\u0440\u0442\u0430",
      "longitude":103.131111,
      "latitude":50.390629
    },
    "5365":{
      "name":"\u0428\u0443\u043b\u0443\u0442\u0430",
      "longitude":103.135857,
      "latitude":51.798878
    },
    "5366":{
      "name":"\u0426\u0430\u0433\u0430\u043d-\u041c\u043e\u0440\u0438\u043d",
      "longitude":103.20594,
      "latitude":50.733791
    },
    "5367":{
      "name":"\u0425\u0443\u0436\u0438\u0440",
      "longitude":103.2696602,
      "latitude":50.4241054
    },
    "5368":{
      "name":"\u0414\u0430\u0440\u0445\u0438\u043d\u0442\u0443\u0439",
      "longitude":103.312462,
      "latitude":50.586243
    },
    "5369":{
      "name":"\u0425\u043e\u043b\u0442\u043e\u0441\u043e\u043d",
      "longitude":103.314537,
      "latitude":50.295387
    },
    "5370":{
      "name":"\u0414\u0443\u0442\u0443\u043b\u0443\u0440",
      "longitude":103.377121,
      "latitude":50.440159
    },
    "5371":{
      "name":"\u0411\u043e\u0440\u0442\u043e\u0439",
      "longitude":103.386574,
      "latitude":50.682362
    },
    "5372":{
      "name":"\u0423\u043b\u0435\u043d\u0442\u0443\u0439",
      "longitude":103.424103,
      "latitude":50.497402
    },
    "5373":{
      "name":"\u041c\u044b\u043b\u0430",
      "longitude":103.435387,
      "latitude":50.736561
    },
    "5374":{
      "name":"\u0411\u0430\u044f\u043d\u0433\u043e\u043b",
      "longitude":103.4718804,
      "latitude":50.6994187
    },
    "5375":{
      "name":"\u0415\u0445\u044d-\u0426\u0430\u043a\u0438\u0440",
      "longitude":103.51519,
      "latitude":50.474442
    },
    "5376":{
      "name":"\u0426\u0430\u043a\u0438\u0440",
      "longitude":103.585991,
      "latitude":50.442059
    },
    "5377":{
      "name":"\u0411\u0443\u0440\u0433\u0443\u0439",
      "longitude":103.785416,
      "latitude":50.459564
    },
    "5378":{
      "name":"\u0425\u0430\u043c\u043d\u0435\u0439",
      "longitude":103.868935,
      "latitude":50.403336
    },
    "5379":{
      "name":"\u0425\u0443\u0440\u0442\u0430\u0433\u0430",
      "longitude":103.939133,
      "latitude":50.446724
    },
    "5380":{
      "name":"\u0423\u0441\u0442\u044c-\u0411\u0443\u0440\u0433\u0430\u043b\u0442\u0430\u0439",
      "longitude":104.10231,
      "latitude":50.416595
    },
    "5381":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":104.1530024,
      "latitude":50.4085862
    },
    "5382":{
      "name":"\u0423\u043b\u0435\u043a\u0447\u0438\u043d",
      "longitude":104.2928897,
      "latitude":50.4737275
    },
    "5383":{
      "name":"\u0425\u0430\u0440\u0430\u0446\u0430\u0439",
      "longitude":104.479805,
      "latitude":50.481766
    },
    "5384":{
      "name":"\u041d\u0430\u0440\u044b\u043d",
      "longitude":104.560135,
      "latitude":50.533981
    },
    "5385":{
      "name":"\u0410\u0440\u043c\u0430\u043a",
      "longitude":104.595497,
      "latitude":50.60461
    },
    "5386":{
      "name":"\u0410\u043b\u0446\u0430\u043a",
      "longitude":104.616661,
      "latitude":50.670326
    },
    "5387":{
      "name":"\u0412\u044b\u0434\u0440\u0438\u043d\u043e",
      "longitude":104.642586,
      "latitude":51.463425
    },
    "5388":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u0422\u043e\u0440\u0435\u0439",
      "longitude":104.814331,
      "latitude":50.651093
    },
    "5389":{
      "name":"\u0423\u043b\u0437\u0430\u0440",
      "longitude":104.817039,
      "latitude":50.757633
    },
    "5390":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0439 \u0422\u043e\u0440\u0435\u0439",
      "longitude":104.823601,
      "latitude":50.531189
    },
    "5391":{
      "name":"\u041e\u0451\u0440",
      "longitude":104.992043,
      "latitude":50.540775
    },
    "5392":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u0411\u0443\u0440\u0433\u0430\u043b\u0442\u0430\u0439",
      "longitude":105.062981,
      "latitude":50.615269
    },
    "5393":{
      "name":"\u0416\u0435\u043b\u0442\u0443\u0440\u0430",
      "longitude":105.09848,
      "latitude":50.472591
    },
    "5394":{
      "name":"\u0422\u0430\u043d\u0445\u043e\u0439",
      "longitude":105.115158,
      "latitude":51.554321
    },
    "5395":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0439 \u0411\u0443\u0440\u0433\u0430\u043b\u0442\u0430\u0439",
      "longitude":105.127441,
      "latitude":50.564514
    },
    "5396":{
      "name":"\u041c\u0430\u043b\u044b\u0439 \u041d\u0430\u0440\u044b\u043d",
      "longitude":105.134415,
      "latitude":50.660587
    },
    "5397":{
      "name":"\u0413\u044d\u0433\u044d\u0442\u0443\u0439",
      "longitude":105.220314,
      "latitude":50.646439
    },
    "5398":{
      "name":"\u041f\u0435\u0440\u0435\u0451\u043c\u043d\u0430\u044f",
      "longitude":105.248184,
      "latitude":51.580219
    },
    "5399":{
      "name":"\u0411\u0443\u043b\u044b\u043a",
      "longitude":105.264618,
      "latitude":50.599087
    },
    "5400":{
      "name":"\u0426\u0430\u0433\u0430\u0442\u0443\u0439",
      "longitude":105.305283,
      "latitude":50.730831
    },
    "5401":{
      "name":"\u0414\u044d\u0434\u044d-\u0418\u0447\u0451\u0442\u0443\u0439",
      "longitude":105.431458,
      "latitude":50.73431
    },
    "5402":{
      "name":"\u0414\u043e\u0434\u043e-\u0418\u0447\u0451\u0442\u0443\u0439",
      "longitude":105.457726,
      "latitude":50.634872
    },
    "5403":{
      "name":"\u0422\u0430\u0441\u0430\u0440\u0445\u0430\u0439",
      "longitude":105.562477,
      "latitude":50.527126
    },
    "5404":{
      "name":"\u041c\u0438\u0448\u0438\u0445\u0430",
      "longitude":105.5924,
      "latitude":51.652851
    },
    "5405":{
      "name":"\u0411\u043e\u0446\u0438\u0439",
      "longitude":105.652,
      "latitude":50.474224
    },
    "5406":{
      "name":"\u0411\u0435\u043b\u043e\u043e\u0437\u0451\u0440\u0441\u043a",
      "longitude":105.70797,
      "latitude":50.650749
    },
    "5407":{
      "name":"\u0422\u0430\u0451\u0436\u043d\u044b\u0439",
      "longitude":105.7172738,
      "latitude":51.2008844
    },
    "5408":{
      "name":"\u0418\u043d\u0437\u0430\u0433\u0430\u0442\u0443\u0439",
      "longitude":105.749313,
      "latitude":50.833057
    },
    "5409":{
      "name":"\u041a\u043b\u044e\u0435\u0432\u043a\u0430",
      "longitude":105.7630645,
      "latitude":51.6871559
    },
    "5410":{
      "name":"\u0422\u0430\u0448\u0438\u0440",
      "longitude":105.8189209,
      "latitude":50.9816995
    },
    "5411":{
      "name":"\u0401\u043d\u0445\u043e\u0440",
      "longitude":105.8269197,
      "latitude":50.5165393
    },
    "5412":{
      "name":"\u0411\u043e\u0440\u0433\u043e\u0439",
      "longitude":105.8382808,
      "latitude":50.7508942
    },
    "5413":{
      "name":"\u0426\u0430\u0433\u0430\u043d-\u0423\u0441\u0443\u043d",
      "longitude":106.03179989666407,
      "latitude":50.43663787148324
    },
    "5414":{
      "name":"\u0411\u043e\u044f\u0440\u0441\u043a\u0438\u0439",
      "longitude":106.0636577,
      "latitude":51.8421252
    },
    "5415":{
      "name":"\u0414\u044b\u0440\u0435\u0441\u0442\u0443\u0439",
      "longitude":106.070374,
      "latitude":50.654648
    },
    "5416":{
      "name":"\u0425\u043e\u0440\u043e\u043d\u0445\u043e\u0439",
      "longitude":106.15006746009506,
      "latitude":50.47351837953504
    },
    "5417":{
      "name":"\u0414\u0436\u0438\u0434\u0430",
      "longitude":106.1779843,
      "latitude":50.6850918
    },
    "5418":{
      "name":"\u041f\u043e\u0441\u043e\u043b\u044c\u0441\u043a\u043e\u0435",
      "longitude":106.1824899,
      "latitude":52.0195317
    },
    "5419":{
      "name":"\u0422\u0435\u043c\u043d\u0438\u043a",
      "longitude":106.1876899,
      "latitude":51.0047803
    },
    "5420":{
      "name":"\u0417\u0430\u0440\u0443\u0431\u0438\u043d\u043e",
      "longitude":106.191193,
      "latitude":50.580193
    },
    "5421":{
      "name":"\u0421\u0435\u043b\u0435\u043d\u0434\u0443\u043c\u0430",
      "longitude":106.237724,
      "latitude":50.918308
    },
    "5422":{
      "name":"\u0411\u0438\u043b\u044e\u0442\u0430\u0439",
      "longitude":106.2411748,
      "latitude":50.8784884
    },
    "5423":{
      "name":"\u0413\u0443\u0441\u0438\u043d\u043e\u0435 \u041e\u0437\u0435\u0440\u043e",
      "longitude":106.2693474,
      "latitude":51.1226088
    },
    "5424":{
      "name":"\u0423\u0441\u0442\u044c-\u041a\u044f\u0445\u0442\u0430",
      "longitude":106.27425823493292,
      "latitude":50.517904491753214
    },
    "5425":{
      "name":"\u0418\u0441\u0442\u043e\u043c\u0438\u043d\u043e",
      "longitude":106.299133,
      "latitude":52.132286
    },
    "5426":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u0420\u0435\u0447\u043a\u0430",
      "longitude":106.308098,
      "latitude":51.972809
    },
    "5427":{
      "name":"\u0415\u0445\u044d-\u0426\u0430\u0433\u0430\u043d",
      "longitude":106.3402723,
      "latitude":51.0021428
    },
    "5428":{
      "name":"\u041f\u043e\u0441\u043e\u043b\u044c\u0441\u043a\u0430\u044f",
      "longitude":106.344971,
      "latitude":51.966225
    },
    "5429":{
      "name":"\u0411\u0430\u0440\u0430\u0442\u044b",
      "longitude":106.370672,
      "latitude":51.2456563
    },
    "5430":{
      "name":"\u0421\u0442\u0435\u043f\u043d\u043e\u0439 \u0414\u0432\u043e\u0440\u0435\u0446",
      "longitude":106.395073,
      "latitude":52.174042
    },
    "5431":{
      "name":"\u0413\u043e\u0440\u043d\u044b\u0439",
      "longitude":106.406624,
      "latitude":51.974152
    },
    "5432":{
      "name":"\u0420\u0430\u043d\u0436\u0443\u0440\u043e\u0432\u043e",
      "longitude":106.422646,
      "latitude":52.175598
    },
    "5433":{
      "name":"\u0421\u0443\u0431\u0443\u043a\u0442\u0443\u0439",
      "longitude":106.423889,
      "latitude":50.563324
    },
    "5434":{
      "name":"\u041d\u0443\u0440-\u0422\u0443\u0445\u0443\u043c",
      "longitude":106.4406535,
      "latitude":50.8087719
    },
    "5435":{
      "name":"\u0428\u0438\u0433\u0430\u0435\u0432\u043e",
      "longitude":106.473465,
      "latitude":52.181915
    },
    "5436":{
      "name":"\u0422\u0432\u043e\u0440\u043e\u0433\u043e\u0432\u043e",
      "longitude":106.486511,
      "latitude":52.170654
    },
    "5437":{
      "name":"\u042f\u0433\u043e\u0434\u043d\u043e\u0435",
      "longitude":106.5069446,
      "latitude":51.402058
    },
    "5438":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0435 \u041a\u043e\u043b\u0451\u0441\u043e\u0432\u043e",
      "longitude":106.5513902,
      "latitude":52.1085971
    },
    "5439":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u042f\u0440",
      "longitude":106.584106,
      "latitude":52.174881
    },
    "5440":{
      "name":"\u0422\u043e\u0445\u043e\u0439",
      "longitude":106.6108694,
      "latitude":51.3666249
    },
    "5441":{
      "name":"\u0422\u0438\u043c\u043b\u044e\u0439",
      "longitude":106.6149232,
      "latitude":52.0058461
    },
    "5442":{
      "name":"\u041a\u043e\u0440\u0441\u0430\u043a\u043e\u0432\u043e",
      "longitude":106.623436,
      "latitude":52.250771
    },
    "5443":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u0435\u043b\u0435\u043d\u0433\u0438\u043d\u0441\u043a",
      "longitude":106.635719,
      "latitude":51.091698
    },
    "5444":{
      "name":"\u041a\u0443\u0434\u0430\u0440\u0430",
      "longitude":106.654633,
      "latitude":52.227524
    },
    "5445":{
      "name":"\u0416\u0430\u0440\u0433\u0430\u043b\u0430\u043d\u0442\u0430",
      "longitude":106.6662628,
      "latitude":51.4096655
    },
    "5446":{
      "name":"\u0415\u043b\u0430\u043d\u044c",
      "longitude":106.6864843,
      "latitude":52.0011917
    },
    "5447":{
      "name":"\u041d\u044e\u043a\u0438",
      "longitude":106.704414,
      "latitude":52.030079
    },
    "5448":{
      "name":"\u041a\u0438\u0440\u0430\u043d",
      "longitude":106.709686,
      "latitude":50.340645
    },
    "5449":{
      "name":"\u0428\u0435\u0440\u0433\u0438\u043d\u043e",
      "longitude":106.734932,
      "latitude":52.115253
    },
    "5450":{
      "name":"\u0411\u0435\u0440\u0435\u0433\u043e\u0432\u0430\u044f",
      "longitude":106.735741,
      "latitude":52.02375
    },
    "5451":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u041b\u0443\u0433",
      "longitude":106.777397,
      "latitude":50.611816
    },
    "5452":{
      "name":"\u0423\u0441\u0442\u044c-\u041a\u0438\u0440\u0430\u043d",
      "longitude":106.81411,
      "latitude":50.418205
    },
    "5453":{
      "name":"\u041e\u0439\u043c\u0443\u0440",
      "longitude":106.837959,
      "latitude":52.327579
    },
    "5454":{
      "name":"\u0425\u0430\u0440\u0433\u0430\u043d\u0430",
      "longitude":106.846489,
      "latitude":51.503948
    },
    "5455":{
      "name":"\u0411\u0440\u044f\u043d\u0441\u043a",
      "longitude":106.8535062,
      "latitude":52.0298571
    },
    "5456":{
      "name":"\u0414\u044d\u0434\u044d-\u0421\u0443\u0442\u043e\u0439",
      "longitude":106.8557738,
      "latitude":51.2649773
    },
    "5457":{
      "name":"\u0414\u0443\u0440\u0435\u043d\u044b",
      "longitude":106.88298,
      "latitude":50.317299
    },
    "5458":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0439 \u0423\u0431\u0443\u043a\u0443\u043d",
      "longitude":106.89843,
      "latitude":51.518169
    },
    "5459":{
      "name":"\u0422\u0440\u0435\u0441\u043a\u043e\u0432\u043e",
      "longitude":106.8989549,
      "latitude":52.0589343
    },
    "5460":{
      "name":"\u041f\u043e\u0434\u0433\u043e\u0440\u043d\u043e\u0435",
      "longitude":106.916374,
      "latitude":50.548458
    },
    "5461":{
      "name":"\u0427\u0438\u043a\u043e\u0439",
      "longitude":106.9166254,
      "latitude":50.2702533
    },
    "5462":{
      "name":"\u0421\u0440\u0435\u0434\u043d\u0438\u0439 \u0425\u0430\u0440\u043b\u0443\u043d",
      "longitude":106.918648,
      "latitude":50.63747
    },
    "5463":{
      "name":"\u041c\u0443\u0440\u043e\u0447\u0438",
      "longitude":106.932709,
      "latitude":50.359058
    },
    "5464":{
      "name":"\u0425\u0443\u0440\u0430\u043c\u0448\u0430",
      "longitude":106.993614,
      "latitude":51.632217
    },
    "5465":{
      "name":"\u0425\u0430\u0440\u0438\u0442\u043e\u043d\u043e\u0432\u043e",
      "longitude":106.997392,
      "latitude":51.2238722
    },
    "5466":{
      "name":"\u041a\u043e\u043a\u043e\u0440\u0438\u043d\u043e",
      "longitude":106.998001,
      "latitude":51.613701
    },
    "5467":{
      "name":"\u0417\u0443\u0440\u0433\u0430\u043d-\u0414\u044d\u0431\u044d",
      "longitude":107.0191072,
      "latitude":51.0726835
    },
    "5468":{
      "name":"\u041c\u043e\u0441\u0442\u043e\u0432\u043a\u0430",
      "longitude":107.029778,
      "latitude":52.092648
    },
    "5469":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u041a\u0443\u0434\u0430\u0440\u0430",
      "longitude":107.048866,
      "latitude":50.201969
    },
    "5470":{
      "name":"\u041e\u0440\u043e\u043d\u0433\u043e\u0439",
      "longitude":107.0489826,
      "latitude":51.5295656
    },
    "5471":{
      "name":"\u041e\u0440\u043e\u043d\u0433\u043e\u0439",
      "longitude":107.066025,
      "latitude":51.519352
    },
    "5472":{
      "name":"\u0423\u0441\u0442\u044c-\u0410\u043b\u0442\u0430\u0448\u0430",
      "longitude":107.0668291,
      "latitude":51.0354026
    },
    "5473":{
      "name":"\u0422\u0430\u043b\u043e\u0432\u043a\u0430",
      "longitude":107.074493,
      "latitude":52.112545
    },
    "5474":{
      "name":"\u041e\u043a\u0442\u044f\u0431\u0440\u044c\u0441\u043a\u0438\u0439",
      "longitude":107.074997,
      "latitude":50.219467
    },
    "5475":{
      "name":"\u041f\u043e\u0434\u043b\u043e\u043f\u0430\u0442\u043a\u0438",
      "longitude":107.093254,
      "latitude":50.916386
    },
    "5476":{
      "name":"\u0422\u043e\u043f\u043a\u0430",
      "longitude":107.100426,
      "latitude":50.459927
    },
    "5477":{
      "name":"\u0411\u0438\u043b\u044e\u0442\u0430\u0439",
      "longitude":107.10125,
      "latitude":50.777397
    },
    "5478":{
      "name":"\u041e\u043a\u0438\u043d\u043e-\u041a\u043b\u044e\u0447\u0438",
      "longitude":107.103737,
      "latitude":50.598442
    },
    "5479":{
      "name":"\u0421\u0443\u0445\u0430\u044f",
      "longitude":107.10936,
      "latitude":52.543064
    },
    "5480":{
      "name":"\u041a\u0430\u043b\u0451\u043d\u043e\u0432\u043e",
      "longitude":107.114639,
      "latitude":51.757214
    },
    "5481":{
      "name":"\u0425\u043e\u043b\u043e\u0439",
      "longitude":107.117599,
      "latitude":50.221127
    },
    "5482":{
      "name":"\u0422\u0430\u043b\u043e\u0432\u043a\u0430",
      "longitude":107.1384982,
      "latitude":52.116731
    },
    "5483":{
      "name":"\u0411\u0430\u043b\u0442\u0430",
      "longitude":107.1483292,
      "latitude":51.0745494
    },
    "5484":{
      "name":"\u0423\u043d\u0433\u0443\u0440\u043a\u0443\u0439",
      "longitude":107.151711,
      "latitude":50.302639
    },
    "5485":{
      "name":"\u0417\u0430\u0440\u0435\u0447\u044c\u0435",
      "longitude":107.151871,
      "latitude":52.549824
    },
    "5486":{
      "name":"\u042d\u043d\u0445\u044d-\u0422\u0430\u043b\u0430",
      "longitude":107.157898,
      "latitude":50.218628
    },
    "5487":{
      "name":"\u041a\u043b\u044e\u0447\u0438",
      "longitude":107.175659,
      "latitude":51.687954
    },
    "5488":{
      "name":"\u0411\u0430\u0440\u044b\u043a\u0438\u043d\u043e",
      "longitude":107.1955151,
      "latitude":51.2373824
    },
    "5489":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u044f\u044f \u0418\u0432\u043e\u043b\u0433\u0430",
      "longitude":107.1989046,
      "latitude":51.7550808
    },
    "5490":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0439 \u0416\u0438\u0440\u0438\u043c",
      "longitude":107.20505,
      "latitude":51.4247011
    },
    "5491":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u0416\u0438\u0440\u0438\u043c",
      "longitude":107.216187,
      "latitude":51.31813
    },
    "5492":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":107.236664,
      "latitude":50.183418
    },
    "5493":{
      "name":"\u0413\u0430\u043d\u0437\u0443\u0440\u0438\u043d\u043e",
      "longitude":107.242538,
      "latitude":51.518803
    },
    "5494":{
      "name":"\u0426\u043e\u043b\u0433\u0430",
      "longitude":107.244598,
      "latitude":51.080124
    },
    "5495":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u041c\u0430\u043d\u0433\u0438\u0440\u0442\u0443\u0439",
      "longitude":107.251854,
      "latitude":50.670444
    },
    "5496":{
      "name":"\u0423\u0431\u0443\u0440-\u041a\u0438\u0440\u0435\u0442\u044c",
      "longitude":107.258438,
      "latitude":50.288216
    },
    "5497":{
      "name":"\u0411\u0430\u0440\u044b\u043a\u0438\u043d\u043e-\u041a\u043b\u044e\u0447\u0438",
      "longitude":107.2672961,
      "latitude":51.2595249
    },
    "5498":{
      "name":"\u0418\u043b\u044c\u0438\u043d\u043a\u0430",
      "longitude":107.272003,
      "latitude":52.119793
    },
    "5499":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u044f\u0440\u043e\u0432\u043e",
      "longitude":107.285545,
      "latitude":51.790604
    },
    "5500":{
      "name":"\u041f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":107.291466,
      "latitude":52.15263
    },
    "5501":{
      "name":"\u0425\u0430\u043d\u0434\u0430\u0433\u0430\u0442\u0430\u0439",
      "longitude":107.318031,
      "latitude":51.274067
    },
    "5502":{
      "name":"\u0425\u0443\u0442\u043e\u0440",
      "longitude":107.321449,
      "latitude":50.022892
    },
    "5503":{
      "name":"\u0428\u0430\u0437\u0430\u0433\u0430\u0439",
      "longitude":107.334991,
      "latitude":50.268673
    },
    "5504":{
      "name":"\u0428\u0430\u0440\u0430\u0433\u043e\u043b",
      "longitude":107.344147,
      "latitude":50.019894
    },
    "5505":{
      "name":"\u0415\u043b\u0430\u043d\u044c",
      "longitude":107.346626,
      "latitude":50.539051
    },
    "5506":{
      "name":"\u0428\u0430\u043b\u0443\u0442\u0430",
      "longitude":107.355385,
      "latitude":51.611179
    },
    "5507":{
      "name":"\u041a\u043e\u043b\u043e\u0431\u043a\u0438",
      "longitude":107.371475,
      "latitude":51.649315
    },
    "5508":{
      "name":"\u0421\u043e\u043b\u043e\u043d\u0446\u044b",
      "longitude":107.3922194,
      "latitude":51.6181698
    },
    "5509":{
      "name":"\u041a\u0443\u0434\u0430\u0440\u0430-\u0421\u043e\u043c\u043e\u043d",
      "longitude":107.396545,
      "latitude":50.160885
    },
    "5510":{
      "name":"\u0422\u0430\u043c\u0438\u0440",
      "longitude":107.407196,
      "latitude":50.260761
    },
    "5511":{
      "name":"\u0413\u0443\u0440\u0443\u043b\u044c\u0431\u0430",
      "longitude":107.412086,
      "latitude":51.82708
    },
    "5512":{
      "name":"\u041d\u0438\u0436\u043d\u044f\u044f \u0418\u0432\u043e\u043b\u0433\u0430",
      "longitude":107.419205,
      "latitude":51.772587
    },
    "5513":{
      "name":"\u0421\u0443\u0434\u0443\u0442\u0443\u0439",
      "longitude":107.419655,
      "latitude":50.681767
    },
    "5514":{
      "name":"\u0425\u043e\u0439\u0442\u043e\u0431\u044d\u0435",
      "longitude":107.434479,
      "latitude":51.789959
    },
    "5515":{
      "name":"\u0422\u0430\u0442\u0430\u0443\u0440\u043e\u0432\u043e",
      "longitude":107.439743,
      "latitude":52.142399
    },
    "5516":{
      "name":"\u0410\u0440\u0430-\u0410\u043b\u0446\u0430\u0433\u0430\u0442",
      "longitude":107.440125,
      "latitude":50.129166
    },
    "5517":{
      "name":"\u0414\u0443\u043d\u0434\u0430-\u041a\u0438\u0440\u0435\u0442\u044c",
      "longitude":107.453964,
      "latitude":50.58305
    },
    "5518":{
      "name":"\u0414\u0435\u0441\u044f\u0442\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":107.457198,
      "latitude":51.4187896
    },
    "5519":{
      "name":"\u041d\u0443\u0440-\u0421\u0435\u043b\u0435\u043d\u0438\u0435",
      "longitude":107.457397,
      "latitude":51.773335
    },
    "5520":{
      "name":"\u041f\u0435\u0441\u0442\u0435\u0440\u0435\u0432\u043e",
      "longitude":107.459862,
      "latitude":51.500313
    },
    "5521":{
      "name":"\u041f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":107.46434,
      "latitude":50.708485
    },
    "5522":{
      "name":"\u0421\u0443\u0436\u0430",
      "longitude":107.469131,
      "latitude":51.775017
    },
    "5523":{
      "name":"\u0412\u043e\u0437\u043d\u0435\u0441\u0435\u043d\u043e\u0432\u043a\u0430",
      "longitude":107.471817,
      "latitude":51.711491
    },
    "5524":{
      "name":"\u041e\u0448\u0443\u0440\u043a\u043e\u0432\u043e",
      "longitude":107.475189,
      "latitude":51.960983
    },
    "5525":{
      "name":"\u0415\u043b\u043e\u0432\u043a\u0430",
      "longitude":107.478363,
      "latitude":52.063599
    },
    "5526":{
      "name":"\u0421\u043e\u0442\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":107.478722,
      "latitude":51.877777
    },
    "5527":{
      "name":"\u041a\u043e\u043c\u0430",
      "longitude":107.479446,
      "latitude":52.160664
    },
    "5528":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u0435 \u0422\u0430\u0442\u0430\u0443\u0440\u043e\u0432\u043e",
      "longitude":107.47963,
      "latitude":52.094852
    },
    "5529":{
      "name":"\u0418\u0442\u0430\u043d\u0446\u0430",
      "longitude":107.508362,
      "latitude":52.167706
    },
    "5530":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0439 \u0421\u0430\u044f\u043d\u0442\u0443\u0439",
      "longitude":107.519447,
      "latitude":51.74041
    },
    "5531":{
      "name":"\u0421\u0430\u0445\u0430\u0440\u043d\u044b\u0439 \u0417\u0430\u0432\u043e\u0434",
      "longitude":107.5196487,
      "latitude":50.6282153
    },
    "5532":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u043f\u0430\u0432\u043b\u043e\u0432\u043a\u0430",
      "longitude":107.530609,
      "latitude":50.691586
    },
    "5533":{
      "name":"\u041f\u043e\u0441\u0435\u043b\u044c\u0435",
      "longitude":107.5409769,
      "latitude":51.8120495
    },
    "5534":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u0421\u0430\u044f\u043d\u0442\u0443\u0439",
      "longitude":107.543956,
      "latitude":51.6370309
    },
    "5535":{
      "name":"\u0411\u0430\u0440",
      "longitude":107.559753,
      "latitude":51.299713
    },
    "5536":{
      "name":"\u0414\u0443\u043d\u0433\u0443\u0439",
      "longitude":107.569557,
      "latitude":50.146259
    },
    "5537":{
      "name":"\u0425\u043e\u0448\u0443\u043d-\u0423\u0437\u0443\u0440",
      "longitude":107.58638,
      "latitude":51.245445
    },
    "5538":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u041a\u0443\u043d\u0430\u043b\u0435\u0439",
      "longitude":107.6114178,
      "latitude":51.4315795
    },
    "5539":{
      "name":"\u0423\u043b\u0430\u0434\u044b\u0439",
      "longitude":107.641151,
      "latitude":50.176033
    },
    "5540":{
      "name":"\u0428\u0430\u0440\u0430\u043b\u0434\u0430\u0439",
      "longitude":107.645836,
      "latitude":51.026192
    },
    "5541":{
      "name":"\u041d\u0430\u0434\u0435\u0438\u043d\u043e",
      "longitude":107.6670075,
      "latitude":51.5482014
    },
    "5542":{
      "name":"\u0423\u0441\u0442\u044c-\u0414\u0443\u043d\u0433\u0443\u0439",
      "longitude":107.674736,
      "latitude":49.990116
    },
    "5543":{
      "name":"\u0418\u0440\u043a\u0438\u043b\u0438\u043a",
      "longitude":107.678703,
      "latitude":52.193424
    },
    "5544":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u0440\u0435\u0442\u0435\u043d\u043a\u0430",
      "longitude":107.683357,
      "latitude":50.723751
    },
    "5545":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u041a\u0443\u0434\u0430\u0440\u0430",
      "longitude":107.687492,
      "latitude":50.187901
    },
    "5546":{
      "name":"\u041c\u043e\u0442\u043d\u044f",
      "longitude":107.707466,
      "latitude":50.673435
    },
    "5547":{
      "name":"\u041a\u0430\u0440\u044b\u043c\u0441\u043a",
      "longitude":107.708984,
      "latitude":52.254539
    },
    "5548":{
      "name":"\u0413\u0443\u0442\u0430\u0439",
      "longitude":107.752548,
      "latitude":50.73877
    },
    "5549":{
      "name":"\u041a\u0443\u0439\u0442\u0443\u043d",
      "longitude":107.7578035,
      "latitude":51.5278511
    },
    "5550":{
      "name":"\u041d\u043e\u0432\u044b\u0439 \u0417\u0430\u0433\u0430\u043d",
      "longitude":107.761734,
      "latitude":51.026928
    },
    "5551":{
      "name":"\u0421\u0442\u0430\u0440\u044b\u0439 \u0417\u0430\u0433\u0430\u043d",
      "longitude":107.780502,
      "latitude":51.029869
    },
    "5552":{
      "name":"\u041a\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":107.781303,
      "latitude":51.282265
    },
    "5553":{
      "name":"\u0417\u044b\u0440\u044f\u043d\u0441\u043a",
      "longitude":107.783318,
      "latitude":52.263954
    },
    "5554":{
      "name":"\u0413\u0430\u043b\u0442\u0430\u0439",
      "longitude":107.790413,
      "latitude":51.232864
    },
    "5555":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u0441\u043a\u0438\u0439",
      "longitude":107.7985166,
      "latitude":51.6542558
    },
    "5556":{
      "name":"\u042d\u0440\u0445\u0438\u0440\u0438\u043a",
      "longitude":107.818504,
      "latitude":51.89085
    },
    "5557":{
      "name":"\u041c\u0430\u043b\u044b\u0439 \u041a\u0443\u043d\u0430\u043b\u0435\u0439",
      "longitude":107.823738,
      "latitude":50.605015
    },
    "5558":{
      "name":"\u0428\u0438\u0431\u0435\u0440\u0442\u0443\u0439",
      "longitude":107.867897,
      "latitude":50.795963
    },
    "5559":{
      "name":"\u041d\u0435\u0441\u0442\u0435\u0440\u043e\u0432\u043e",
      "longitude":107.8828993,
      "latitude":52.3693299
    },
    "5560":{
      "name":"\u041f\u043e\u0441\u0435\u043b\u044c\u0435",
      "longitude":107.894424,
      "latitude":50.614098
    },
    "5561":{
      "name":"\u0421\u043b\u043e\u0431\u043e\u0434\u0430",
      "longitude":107.904434,
      "latitude":50.617062
    },
    "5562":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u0421\u0443\u0442\u0430\u0439",
      "longitude":107.904495,
      "latitude":51.313541
    },
    "5563":{
      "name":"\u041d\u0430\u0440\u0441\u0430\u0442\u0430",
      "longitude":107.904854,
      "latitude":51.26424
    },
    "5564":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0435 \u0422\u0430\u043b\u044c\u0446\u044b",
      "longitude":107.910263,
      "latitude":51.886768
    },
    "5565":{
      "name":"\u0411\u0443\u0439",
      "longitude":107.970512,
      "latitude":50.642532
    },
    "5566":{
      "name":"\u0413\u0440\u0435\u043c\u044f\u0447\u0438\u043d\u0441\u043a",
      "longitude":107.971176,
      "latitude":52.799362
    },
    "5567":{
      "name":"\u0425\u0430\u0440\u0430\u0448\u0438\u0431\u0438\u0440\u044c",
      "longitude":107.991783,
      "latitude":51.099144
    },
    "5568":{
      "name":"\u0423\u0437\u043a\u0438\u0439 \u041b\u0443\u0433",
      "longitude":108.0219133,
      "latitude":50.7033223
    },
    "5569":{
      "name":"\u0411\u043e\u043c",
      "longitude":108.02552,
      "latitude":51.224827
    },
    "5570":{
      "name":"\u041a\u0438\u043a\u0430",
      "longitude":108.027718,
      "latitude":52.497925
    },
    "5571":{
      "name":"\u041a\u043e\u0442\u043e\u043a\u0435\u043b\u044c",
      "longitude":108.072578,
      "latitude":52.758728
    },
    "5572":{
      "name":"\u0425\u0430\u0438\u043c",
      "longitude":108.0842612,
      "latitude":52.6025516
    },
    "5573":{
      "name":"\u0422\u0443\u0433\u043d\u0443\u0439",
      "longitude":108.1105296,
      "latitude":51.2144688
    },
    "5574":{
      "name":"\u0421\u0442\u0430\u0440\u0430\u044f \u0411\u0440\u044f\u043d\u044c",
      "longitude":108.130577,
      "latitude":51.581264
    },
    "5575":{
      "name":"\u0423\u0441\u0442\u044c-\u0411\u0440\u044f\u043d\u044c",
      "longitude":108.138893,
      "latitude":51.940559
    },
    "5576":{
      "name":"\u042f\u0440\u0446\u044b",
      "longitude":108.1405871,
      "latitude":52.8775842
    },
    "5577":{
      "name":"\u0428\u0430\u043d\u0430\u0433\u0430",
      "longitude":108.149254,
      "latitude":50.829391
    },
    "5578":{
      "name":"\u041f\u043e\u0442\u0430\u043d\u0438\u043d\u043e",
      "longitude":108.152191,
      "latitude":50.807877
    },
    "5579":{
      "name":"\u0418\u0441\u0442\u043e\u043a",
      "longitude":108.207367,
      "latitude":52.866684
    },
    "5580":{
      "name":"\u0425\u043e\u043d\u0445\u043e\u043b\u043e\u0439",
      "longitude":108.232208,
      "latitude":51.128002
    },
    "5581":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u0411\u0440\u044f\u043d\u044c",
      "longitude":108.25206,
      "latitude":51.708385
    },
    "5582":{
      "name":"\u0425\u043e\u043d\u0445\u043e\u043b\u043e\u0439",
      "longitude":108.253525,
      "latitude":50.868675
    },
    "5583":{
      "name":"\u041d\u0430\u0440\u044b\u043d-\u0410\u0446\u0430\u0433\u0430\u0442",
      "longitude":108.289345,
      "latitude":52.004139
    },
    "5584":{
      "name":"\u0413\u043e\u0440\u044f\u0447\u0438\u043d\u0441\u043a",
      "longitude":108.299103,
      "latitude":52.984402
    },
    "5585":{
      "name":"\u0411\u0435\u0437\u044b\u043c\u044f\u043d\u043a\u0430",
      "longitude":108.3113876,
      "latitude":53.0721731
    },
    "5586":{
      "name":"\u0428\u0430\u0431\u0443\u0440",
      "longitude":108.317177,
      "latitude":51.480755
    },
    "5587":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u044c\u0441\u043a",
      "longitude":108.323303,
      "latitude":51.189163
    },
    "5588":{
      "name":"\u041a\u0443\u0441\u043e\u0442\u044b",
      "longitude":108.347549,
      "latitude":51.351307
    },
    "5589":{
      "name":"\u0427\u0435\u043b\u0443\u0442\u0430\u0439 (3 \u043a\u043c)",
      "longitude":108.364433,
      "latitude":51.75695
    },
    "5590":{
      "name":"\u0427\u0435\u043b\u0443\u0442\u0430\u0439",
      "longitude":108.387619,
      "latitude":51.759365
    },
    "5591":{
      "name":"\u0422\u0430\u0442\u0430\u0440\u0441\u043a\u0438\u0439 \u041a\u043b\u044e\u0447",
      "longitude":108.395462,
      "latitude":51.686924
    },
    "5592":{
      "name":"\u0421\u043e\u0431\u043e\u043b\u0438\u0445\u0430",
      "longitude":108.3957087,
      "latitude":52.9238976
    },
    "5593":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u043c\u0430\u0435\u0432\u043a\u0430",
      "longitude":108.402435,
      "latitude":52.033733
    },
    "5594":{
      "name":"\u0427\u0435\u043b\u0443\u0442\u0430\u0439 (24 \u043a\u043c)",
      "longitude":108.415993,
      "latitude":51.586323
    },
    "5595":{
      "name":"\u041a\u0430\u0442\u043a\u043e\u0432\u043e",
      "longitude":108.4271016,
      "latitude":53.1674947
    },
    "5596":{
      "name":"\u0421\u0430\u0433\u0430\u043d-\u041d\u0443\u0440",
      "longitude":108.433006,
      "latitude":51.346027
    },
    "5597":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u041a\u0443\u0440\u0431\u0430",
      "longitude":108.511749,
      "latitude":52.040569
    },
    "5598":{
      "name":"\u0421\u0442\u0430\u0440\u0430\u044f \u041a\u0443\u0440\u0431\u0430",
      "longitude":108.518158,
      "latitude":52.004593
    },
    "5599":{
      "name":"\u0418\u043b\u044c\u043a\u0430",
      "longitude":108.524963,
      "latitude":51.721405
    },
    "5600":{
      "name":"\u0423\u043d\u044d\u0433\u044d\u0442\u044d\u0439",
      "longitude":108.563324,
      "latitude":52.09647
    },
    "5601":{
      "name":"\u0410\u043d\u0433\u0438\u0440",
      "longitude":108.599022,
      "latitude":52.218689
    },
    "5602":{
      "name":"\u0417\u043e\u043b\u043e\u0442\u043e\u0439 \u041a\u043b\u044e\u0447",
      "longitude":108.6553756,
      "latitude":52.9873668
    },
    "5603":{
      "name":"\u041d\u043e\u0432\u043e\u0438\u043b\u044c\u0438\u043d\u0441\u043a",
      "longitude":108.705711,
      "latitude":51.686081
    },
    "5604":{
      "name":"\u0414\u0430\u0440\u0445\u0438\u0442\u0430",
      "longitude":108.7327897,
      "latitude":51.6736648
    },
    "5605":{
      "name":"\u041c\u0430\u043a\u0441\u0438\u043c\u0438\u0445\u0430",
      "longitude":108.7455709,
      "latitude":53.265578
    },
    "5606":{
      "name":"\u0413\u043e\u0440\u0445\u043e\u043d",
      "longitude":108.785286,
      "latitude":51.556644
    },
    "5607":{
      "name":"\u0425\u0430\u0441\u0443\u0440\u0442\u0430",
      "longitude":108.871712,
      "latitude":52.291492
    },
    "5608":{
      "name":"\u0422\u0430\u0448\u0435\u043b\u0430\u043d",
      "longitude":108.895187,
      "latitude":51.686447
    },
    "5609":{
      "name":"\u0422\u044d\u0433\u0434\u0430",
      "longitude":108.9238466,
      "latitude":52.397002
    },
    "5610":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0435 \u0422\u0430\u043b\u044c\u0446\u044b",
      "longitude":108.9404978,
      "latitude":52.0386567
    },
    "5611":{
      "name":"\u0411\u0430\u0440\u0443\u043d-\u0425\u0430\u0441\u0443\u0440\u0442\u0430",
      "longitude":109.0243799,
      "latitude":52.148094
    },
    "5612":{
      "name":"\u041d\u0430\u0440\u044b\u043d",
      "longitude":109.077393,
      "latitude":51.71299
    },
    "5613":{
      "name":"\u041c\u0430\u043a\u0430\u0440\u0438\u043d\u0438\u043d\u043e",
      "longitude":109.115707,
      "latitude":53.442318
    },
    "5614":{
      "name":"\u0411\u0430\u0439\u043a\u0430\u043b\u044c\u0441\u043a\u043e\u0435",
      "longitude":109.191711,
      "latitude":55.355587
    },
    "5615":{
      "name":"\u0423\u0434\u0438\u043d\u0441\u043a",
      "longitude":109.2071355,
      "latitude":52.1390784
    },
    "5616":{
      "name":"\u0422\u043e\u0445\u043e\u0440\u044e\u043a\u0442\u0430",
      "longitude":109.2921163,
      "latitude":52.5616106
    },
    "5617":{
      "name":"\u0410\u0434\u0430\u043c\u043e\u0432\u043e",
      "longitude":109.298813,
      "latitude":53.479801
    },
    "5618":{
      "name":"\u0425\u0430\u0440\u0430-\u041a\u0443\u0442\u0443\u043b",
      "longitude":109.31263,
      "latitude":51.763203
    },
    "5619":{
      "name":"\u0411\u0430\u044f\u043d-\u0413\u043e\u043b",
      "longitude":109.3354524,
      "latitude":52.1703649
    },
    "5620":{
      "name":"\u0421\u0430\u043d\u043d\u043e\u043c\u044b\u0441\u043a",
      "longitude":109.4056114,
      "latitude":52.120736
    },
    "5621":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u0438\u0436\u0438\u043d\u0433\u0438\u043d\u0441\u043a",
      "longitude":109.601974,
      "latitude":51.617409
    },
    "5622":{
      "name":"\u041a\u0443\u043b\u044c\u0441\u043a\u0438\u0439 \u0421\u0442\u0430\u043d\u043e\u043a",
      "longitude":109.6166795,
      "latitude":52.1673407
    },
    "5623":{
      "name":"\u041a\u0443\u043b\u044c\u0441\u043a",
      "longitude":109.6218134,
      "latitude":52.1320702
    },
    "5624":{
      "name":"\u042d\u0434\u044d\u0440\u043c\u044d\u0433",
      "longitude":109.663696,
      "latitude":51.693615
    },
    "5625":{
      "name":"\u0414\u0443\u0448\u043a\u0430\u0447\u0430\u043d",
      "longitude":109.6713241,
      "latitude":55.8483247
    },
    "5626":{
      "name":"\u0425\u0443\u0434\u0430\u043d\u0430\u0439 \u0423\u0440\u0442\u043e\u043e",
      "longitude":109.75296,
      "latitude":52.047531
    },
    "5627":{
      "name":"\u0425\u043e\u043b\u043e\u0434\u043d\u0430\u044f",
      "longitude":109.759132,
      "latitude":55.880745
    },
    "5628":{
      "name":"\u0423\u0441\u0442\u044c-\u041e\u0440\u043e\u0442",
      "longitude":109.776495,
      "latitude":51.9799302
    },
    "5629":{
      "name":"\u0427\u0438\u0442\u043a\u0430\u043d",
      "longitude":109.779701,
      "latitude":53.497463
    },
    "5630":{
      "name":"\u0421\u0443\u0445\u0430\u044f",
      "longitude":109.8138449,
      "latitude":53.7480335
    },
    "5631":{
      "name":"\u0423\u0440\u043e",
      "longitude":109.842751,
      "latitude":53.545662
    },
    "5632":{
      "name":"\u0410\u043b\u0430\u043d",
      "longitude":109.8662294,
      "latitude":52.3143357
    },
    "5633":{
      "name":"\u0414\u0443\u0448\u0435\u043b\u0430\u043d",
      "longitude":109.88784,
      "latitude":53.59811
    },
    "5634":{
      "name":"\u0423\u043b\u044e\u043d",
      "longitude":109.916534,
      "latitude":53.82806
    },
    "5635":{
      "name":"\u0423\u043b\u044e\u043a\u0447\u0438\u043a\u0430\u043d",
      "longitude":109.954613,
      "latitude":53.870804
    },
    "5636":{
      "name":"\u0421\u0443\u0432\u043e",
      "longitude":110.009094,
      "latitude":53.658157
    },
    "5637":{
      "name":"\u041e\u043d\u0438\u043d\u043e\u0431\u043e\u0440\u0441\u043a",
      "longitude":110.0258474,
      "latitude":52.2555016
    },
    "5638":{
      "name":"\u0418\u043d\u043d\u043e\u043a\u0435\u043d\u0442\u044c\u0435\u0432\u043a\u0430",
      "longitude":110.032654,
      "latitude":51.919857
    },
    "5639":{
      "name":"\u0417\u0443\u043d-\u0425\u0443\u0440\u0430\u0439",
      "longitude":110.0547948,
      "latitude":52.166575
    },
    "5640":{
      "name":"\u0411\u043e\u0434\u043e\u043d",
      "longitude":110.087944,
      "latitude":53.708672
    },
    "5641":{
      "name":"\u042d\u043b\u044d\u0441\u0443\u043d",
      "longitude":110.095154,
      "latitude":54.031956
    },
    "5642":{
      "name":"\u0425\u0438\u043b\u0433\u0430\u043d\u0430",
      "longitude":110.095589,
      "latitude":53.915867
    },
    "5643":{
      "name":"\u041a\u0438\u0447\u0435\u0440\u0430",
      "longitude":110.0967229,
      "latitude":55.9291144
    },
    "5644":{
      "name":"\u0411\u0443\u043b\u0443\u043c",
      "longitude":110.1112136,
      "latitude":52.2840875
    },
    "5645":{
      "name":"\u0423\u043b\u0437\u044b\u0442\u044d",
      "longitude":110.124809,
      "latitude":51.914886
    },
    "5646":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u044f\u044f \u0417\u0430\u0438\u043c\u043a\u0430",
      "longitude":110.1432245,
      "latitude":55.8483447
    },
    "5647":{
      "name":"\u0411\u0430\u0440\u0430\u0433\u0445\u0430\u043d",
      "longitude":110.161133,
      "latitude":54.153732
    },
    "5648":{
      "name":"\u0421\u0443\u043b\u0445\u0430\u0440\u0430",
      "longitude":110.164162,
      "latitude":51.748878
    },
    "5649":{
      "name":"\u0411\u043e\u0440\u043e\u0433\u043e\u043b",
      "longitude":110.171616,
      "latitude":53.902241
    },
    "5650":{
      "name":"\u0418\u043d\u0430",
      "longitude":110.229416,
      "latitude":53.741516
    },
    "5651":{
      "name":"\u042e\u0431\u0438\u043b\u0435\u0439\u043d\u044b\u0439",
      "longitude":110.233978,
      "latitude":53.726833
    },
    "5652":{
      "name":"\u0410\u0448\u0430\u043d\u0433\u0430",
      "longitude":110.263364,
      "latitude":52.3685037
    },
    "5653":{
      "name":"\u0411\u0430\u044f\u043d\u0433\u043e\u043b",
      "longitude":110.27079,
      "latitude":53.772358
    },
    "5654":{
      "name":"\u041c\u043e\u0433\u0441\u043e\u0445\u043e\u043d",
      "longitude":110.32296,
      "latitude":51.885738
    },
    "5655":{
      "name":"\u0410\u043c\u0433\u0430\u043b\u0430\u043d\u0442\u0430",
      "longitude":110.384671,
      "latitude":52.398587
    },
    "5656":{
      "name":"\u0421\u0430\u0445\u0443\u043b\u0438",
      "longitude":110.406509,
      "latitude":54.42178
    },
    "5657":{
      "name":"\u041c\u043e\u0433\u043e\u0439\u0442\u043e",
      "longitude":110.459793,
      "latitude":54.380943
    },
    "5658":{
      "name":"\u0413\u0435\u043e\u0440\u0433\u0438\u0435\u0432\u0441\u043a\u043e\u0435",
      "longitude":110.4602188,
      "latitude":52.3420625
    },
    "5659":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":110.4729268,
      "latitude":51.8926342
    },
    "5660":{
      "name":"\u0428\u0430\u043c\u0430\u043d\u043a\u0430",
      "longitude":110.479706,
      "latitude":54.468693
    },
    "5661":{
      "name":"\u0427\u0435\u0441\u0430\u043d",
      "longitude":110.512238,
      "latitude":51.965553
    },
    "5662":{
      "name":"\u0423\u043b\u044c\u0434\u0443\u0440\u0433\u0430",
      "longitude":110.538643,
      "latitude":52.224075
    },
    "5663":{
      "name":"\u0422\u0443\u0436\u0438\u043d\u043a\u0430",
      "longitude":110.551155,
      "latitude":52.306725
    },
    "5664":{
      "name":"\u0411\u0443\u043b\u0430\u043a",
      "longitude":110.559837,
      "latitude":51.96843
    },
    "5665":{
      "name":"\u0423\u0441\u0442\u044c-\u042d\u0433\u0438\u0442\u0430",
      "longitude":110.613312,
      "latitude":52.331894
    },
    "5666":{
      "name":"\u0410\u0440\u0433\u0430\u0434\u0430",
      "longitude":110.686356,
      "latitude":54.24345
    },
    "5667":{
      "name":"\u041f\u043e\u043f\u0435\u0440\u0435\u0447\u043d\u043e\u0435",
      "longitude":110.714485,
      "latitude":52.385723
    },
    "5668":{
      "name":"\u0417\u0430\u0433\u0443\u0441\u0442\u0430\u0439",
      "longitude":110.7296494,
      "latitude":51.9768394
    },
    "5669":{
      "name":"\u0410\u0440\u0437\u0433\u0443\u043d",
      "longitude":110.7388008,
      "latitude":54.3787096
    },
    "5670":{
      "name":"\u042d\u0433\u0438\u0442\u0430",
      "longitude":110.739716,
      "latitude":52.425529
    },
    "5671":{
      "name":"\u041c\u043e\u0436\u0430\u0439\u043a\u0430",
      "longitude":110.788643,
      "latitude":52.411976
    },
    "5672":{
      "name":"\u041c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":110.79847,
      "latitude":54.59771
    },
    "5673":{
      "name":"\u0410\u043b\u043b\u0430",
      "longitude":110.819496,
      "latitude":54.688992
    },
    "5674":{
      "name":"\u0425\u0443\u0440\u0442\u044d\u0439",
      "longitude":110.83062,
      "latitude":51.944
    },
    "5675":{
      "name":"\u0423\u043b\u0437\u044b\u0442\u044d",
      "longitude":110.863312,
      "latitude":52.463268
    },
    "5676":{
      "name":"\u0425\u0430\u043d\u0433\u0438\u0440",
      "longitude":110.895836,
      "latitude":52.362011
    },
    "5677":{
      "name":"\u0410\u043d\u0433\u043e\u044f",
      "longitude":110.9086188,
      "latitude":56.0096307
    },
    "5678":{
      "name":"\u0423\u043b\u044e\u043d\u0445\u0430\u043d",
      "longitude":111.068787,
      "latitude":54.864628
    },
    "5679":{
      "name":"\u041a\u043e\u043c\u0441\u043e\u043c\u043e\u043b\u044c\u0441\u043a\u043e\u0435",
      "longitude":111.092712,
      "latitude":52.480686
    },
    "5680":{
      "name":"\u041a\u0443\u043c\u043e\u0440\u0430",
      "longitude":111.2080512,
      "latitude":55.8855127
    },
    "5681":{
      "name":"\u0413\u043e\u043d\u0434\u0430",
      "longitude":111.2427782,
      "latitude":52.5316763
    },
    "5682":{
      "name":"\u0423\u043a\u044b\u0440",
      "longitude":111.409233,
      "latitude":52.527592
    },
    "5683":{
      "name":"\u0413\u0430\u0440\u0430\u043c",
      "longitude":111.443138,
      "latitude":52.574688
    },
    "5684":{
      "name":"\u0422\u0443\u043b\u0434\u0443\u043d",
      "longitude":111.580276,
      "latitude":52.686157
    },
    "5685":{
      "name":"\u0423\u043e\u044f\u043d",
      "longitude":111.6170654,
      "latitude":56.1304568
    },
    "5686":{
      "name":"\u041e\u0437\u0451\u0440\u043d\u044b\u0439",
      "longitude":111.697098,
      "latitude":52.929913
    },
    "5687":{
      "name":"\u0428\u0438\u0440\u0438\u043d\u0433\u0430",
      "longitude":111.704887,
      "latitude":52.679123
    },
    "5688":{
      "name":"\u0414\u043e\u043c\u043d\u0430",
      "longitude":111.709663,
      "latitude":52.562286
    },
    "5689":{
      "name":"\u0413\u0443\u043d\u0434\u0430",
      "longitude":111.727547,
      "latitude":52.780231
    },
    "5690":{
      "name":"\u0423\u0441\u0442\u044c-\u0414\u0436\u0438\u043b\u0438\u043d\u0434\u0430",
      "longitude":111.945831,
      "latitude":53.666039
    },
    "5691":{
      "name":"\u0418\u0441\u0438\u043d\u0433\u0430",
      "longitude":111.9981977,
      "latitude":52.9116499
    },
    "5692":{
      "name":"\u0412\u0430\u0440\u0432\u0430\u0440\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":112.3606879,
      "latitude":54.3198077
    },
    "5693":{
      "name":"\u0420\u043e\u043c\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":112.769127,
      "latitude":53.214626
    },
    "5694":{
      "name":"\u042f\u043d\u0447\u0443\u043a\u0430\u043d",
      "longitude":112.813866,
      "latitude":56.257603
    },
    "5695":{
      "name":"\u0426\u0435\u043b\u0438\u043d\u043d\u044b\u0439",
      "longitude":112.863136,
      "latitude":52.603809
    },
    "5696":{
      "name":"\u0421\u0435\u0432\u0435\u0440\u043d\u044b\u0439",
      "longitude":113.275597,
      "latitude":54.352127
    },
    "5697":{
      "name":"\u0422\u0435\u043b\u0435\u043c\u0431\u0430",
      "longitude":113.285942,
      "latitude":52.740528
    },
    "5698":{
      "name":"\u0426\u0438\u043f\u0438\u043a\u0430\u043d",
      "longitude":113.351906,
      "latitude":54.920952
    },
    "5699":{
      "name":"\u041c\u0430\u043b\u044b\u0439 \u0410\u043c\u0430\u043b\u0430\u0442",
      "longitude":113.443184,
      "latitude":54.297546
    },
    "5700":{
      "name":"\u041c\u0430\u043b\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":113.550804,
      "latitude":54.399708
    },
    "5701":{
      "name":"\u0421\u0435\u0432\u0435\u0440\u043e\u043c\u0443\u0439\u0441\u043a",
      "longitude":113.574615,
      "latitude":56.172134
    },
    "5702":{
      "name":"\u0423\u0430\u043a\u0438\u0442",
      "longitude":113.636932,
      "latitude":55.482956
    },
    "5703":{
      "name":"\u041c\u043e\u043d\u0433\u043e\u0439",
      "longitude":113.822762,
      "latitude":53.968586
    },
    "5704":{
      "name":"\u0420\u043e\u0441\u0441\u043e\u0448\u0438\u043d\u043e",
      "longitude":114.29586,
      "latitude":54.291264
    },
    "5705":{
      "name":"\u0423\u0441\u0442\u044c-\u041c\u0443\u044f",
      "longitude":115.629074,
      "latitude":56.4149883
    },
    "5706":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u0434\u0430\u0440\u043a\u0430",
      "longitude":74.024382021174,
      "latitude":54.25023292418337
    },
    "5707":{
      "name":"\u0423\u0421\u0422\u042c-\u041a\u0410\u041d",
      "longitude":84.765213,
      "latitude":50.932003
    },
    "5708":{
      "name":"\u0423\u0421\u0422\u042c-\u041a\u041e\u041a\u0421\u0410",
      "longitude":85.6155842,
      "latitude":50.2695927
    },
    "5709":{
      "name":"\u0428\u0415\u0411\u0410\u041b\u0418\u041d\u041e",
      "longitude":85.6794538,
      "latitude":51.291774
    },
    "5710":{
      "name":"\u041c\u0410\u0419\u041c\u0410",
      "longitude":85.898743,
      "latitude":52.004684
    },
    "5711":{
      "name":"\u0413\u041e\u0420\u041d\u041e-\u0410\u041b\u0422\u0410\u0419\u0421\u041a",
      "longitude":85.96418,
      "latitude":51.957775
    },
    "5712":{
      "name":"\u0427\u0415\u041c\u0410\u041b",
      "longitude":86.003571,
      "latitude":51.406906
    },
    "5713":{
      "name":"\u041e\u041d\u0413\u0423\u0414\u0410\u0419",
      "longitude":86.1415132,
      "latitude":50.7454021
    },
    "5714":{
      "name":"\u0427\u041e\u042f",
      "longitude":86.545723,
      "latitude":52.005322
    },
    "5715":{
      "name":"\u0422\u0423\u0420\u041e\u0427\u0410\u041a",
      "longitude":87.117538,
      "latitude":52.259956
    },
    "5716":{
      "name":"\u0423\u041b\u0410\u0413\u0410\u041d",
      "longitude":87.956268,
      "latitude":50.632076
    },
    "5717":{
      "name":"\u041a\u041e\u0428-\u0410\u0413\u0410\u0427",
      "longitude":88.6628218,
      "latitude":49.9947055
    },
    "5718":{
      "name":"\u0414\u0423\u0414\u0418\u041d\u041a\u0410",
      "longitude":86.175072,
      "latitude":69.406067
    },
    "5719":{
      "name":"\u0418\u0413\u0410\u0420\u041a\u0410",
      "longitude":86.569756,
      "latitude":67.467216
    },
    "5720":{
      "name":"\u0422\u0423\u0420\u0423\u0425\u0410\u041d\u0421\u041a",
      "longitude":87.960815,
      "latitude":65.795441
    },
    "5721":{
      "name":"\u0414\u0423\u0411\u0418\u041d\u0418\u041d\u041e",
      "longitude":89.082672,
      "latitude":55.622734
    },
    "5722":{
      "name":"\u0428\u0410\u0420\u042b\u041f\u041e\u0412\u041e",
      "longitude":89.186432,
      "latitude":55.535503
    },
    "5723":{
      "name":"\u0422\u042e\u0425\u0422\u0415\u0422",
      "longitude":89.311485,
      "latitude":56.539837
    },
    "5724":{
      "name":"\u0411\u041e\u0413\u041e\u0422\u041e\u041b",
      "longitude":89.531639,
      "latitude":56.211464
    },
    "5725":{
      "name":"\u0421\u041e\u041b\u041d\u0415\u0427\u041d\u042b\u0419",
      "longitude":89.825737,
      "latitude":55.283451
    },
    "5726":{
      "name":"\u0423\u0416\u0423\u0420",
      "longitude":89.831192,
      "latitude":55.30901
    },
    "5727":{
      "name":"\u041d\u0410\u0417\u0410\u0420\u041e\u0412\u041e",
      "longitude":90.418503,
      "latitude":56.011593
    },
    "5728":{
      "name":"\u041d\u041e\u0412\u041e\u0411\u0418\u0420\u0418\u041b\u042e\u0421\u0421\u042b",
      "longitude":90.685806,
      "latitude":56.95171
    },
    "5729":{
      "name":"\u041d\u041e\u0412\u041e\u0421\u0415\u041b\u041e\u0412\u041e",
      "longitude":90.967201,
      "latitude":55.005177
    },
    "5730":{
      "name":"\u041a\u041e\u0417\u0423\u041b\u042c\u041a\u0410",
      "longitude":91.391975,
      "latitude":56.165138
    },
    "5731":{
      "name":"\u041a\u0420\u0410\u0421\u041d\u041e\u0422\u0423\u0420\u0410\u041d\u0421\u041a",
      "longitude":91.567825,
      "latitude":54.316296
    },
    "5732":{
      "name":"\u0411\u0410\u041b\u0410\u0425\u0422\u0410",
      "longitude":91.615273,
      "latitude":55.383221
    },
    "5733":{
      "name":"\u041c\u0418\u041d\u0423\u0421\u0418\u041d\u0421\u041a",
      "longitude":91.67984438607313,
      "latitude":53.69819970055898
    },
    "5734":{
      "name":"\u0428\u0423\u0428\u0415\u041d\u0421\u041a\u041e\u0415",
      "longitude":91.945374,
      "latitude":53.32782
    },
    "5735":{
      "name":"\u0418\u0414\u0420\u0418\u041d\u0421\u041a\u041e\u0415",
      "longitude":92.133156,
      "latitude":54.370876
    },
    "5736":{
      "name":"\u0415\u041d\u0418\u0421\u0415\u0419\u0421\u041a",
      "longitude":92.1748169,
      "latitude":58.4532212
    },
    "5737":{
      "name":"\u041a\u0415\u0414\u0420\u041e\u0412\u042b\u0419",
      "longitude":92.323425,
      "latitude":56.23724
    },
    "5738":{
      "name":"\u0414\u0418\u0412\u041d\u041e\u0413\u041e\u0420\u0421\u041a",
      "longitude":92.37542,
      "latitude":55.959644
    },
    "5739":{
      "name":"\u0415\u0420\u041c\u0410\u041a\u041e\u0412\u0421\u041a\u041e\u0415",
      "longitude":92.396088,
      "latitude":53.278046
    },
    "5740":{
      "name":"\u041b\u0415\u0421\u041e\u0421\u0418\u0411\u0418\u0420\u0421\u041a",
      "longitude":92.48597,
      "latitude":58.223511
    },
    "5741":{
      "name":"\u041a\u0423\u0420\u0410\u0413\u0418\u041d\u041e",
      "longitude":92.680222,
      "latitude":53.888092
    },
    "5742":{
      "name":"\u0415\u041c\u0415\u041b\u042c\u042f\u041d\u041e\u0412\u041e",
      "longitude":92.688454,
      "latitude":56.167255
    },
    "5743":{
      "name":"\u041a\u0410\u0420\u0410\u0422\u0423\u0417\u0421\u041a\u041e\u0415",
      "longitude":92.868996,
      "latitude":53.600666
    },
    "5744":{
      "name":"\u0421\u0422\u0420\u0415\u041b\u041a\u0410",
      "longitude":93.031731,
      "latitude":58.080124
    },
    "5745":{
      "name":"\u0421\u0415\u0412\u0415\u0420\u041e-\u0415\u041d\u0418\u0421\u0415\u0419\u0421\u041a\u0418\u0419",
      "longitude":93.032997,
      "latitude":60.374702
    },
    "5746":{
      "name":"\u0411\u0415\u0420\u0401\u0417\u041e\u0412\u041a\u0410",
      "longitude":93.133194,
      "latitude":56.038422
    },
    "5747":{
      "name":"\u0411\u041e\u041b\u042c\u0428\u0410\u042f \u041c\u0423\u0420\u0422\u0410",
      "longitude":93.138016,
      "latitude":56.909847
    },
    "5748":{
      "name":"\u041a\u0420\u0410\u0421\u041d\u041e\u041a\u0410\u041c\u0415\u041d\u0421\u041a",
      "longitude":93.253105,
      "latitude":54.338135
    },
    "5749":{
      "name":"\u0421\u0423\u0425\u041e\u0411\u0423\u0417\u0418\u041c\u0421\u041a\u041e\u0415",
      "longitude":93.27816,
      "latitude":56.499783
    },
    "5750":{
      "name":"\u041a\u0410\u0417\u0410\u0427\u0418\u041d\u0421\u041a\u041e\u0415",
      "longitude":93.281029,
      "latitude":57.694408
    },
    "5751":{
      "name":"\u0421\u041e\u0421\u041d\u041e\u0412\u041e\u0411\u041e\u0420\u0421\u041a",
      "longitude":93.33873,
      "latitude":56.121494
    },
    "5752":{
      "name":"\u0416\u0415\u041b\u0415\u0417\u041d\u041e\u0413\u041e\u0420\u0421\u041a",
      "longitude":93.53286,
      "latitude":56.250938
    },
    "5753":{
      "name":"\u0423\u042f\u0420",
      "longitude":94.327774,
      "latitude":55.809986
    },
    "5754":{
      "name":"\u0417\u0415\u041b\u0415\u041d\u041e\u0413\u041e\u0420\u0421\u041a",
      "longitude":94.589279,
      "latitude":56.11356
    },
    "5755":{
      "name":"\u041c\u041e\u0422\u042b\u0413\u0418\u041d\u041e",
      "longitude":94.694298,
      "latitude":58.184208
    },
    "5756":{
      "name":"\u0417\u0410\u041e\u0417\u0401\u0420\u041d\u042b\u0419",
      "longitude":94.708107,
      "latitude":55.965401
    },
    "5757":{
      "name":"\u0421\u0410\u042f\u041d\u0421\u041a\u0418\u0419",
      "longitude":94.708382,
      "latitude":55.551285
    },
    "5758":{
      "name":"\u0411\u041e\u0420\u041e\u0414\u0418\u041d\u041e",
      "longitude":94.8945997,
      "latitude":55.8992103
    },
    "5759":{
      "name":"\u0422\u0410\u0421\u0415\u0415\u0412\u041e",
      "longitude":94.898598,
      "latitude":57.216042
    },
    "5760":{
      "name":"\u0410\u0413\u0418\u041d\u0421\u041a\u041e\u0415",
      "longitude":94.906372,
      "latitude":55.258972
    },
    "5761":{
      "name":"\u0414\u0417\u0415\u0420\u0416\u0418\u041d\u0421\u041a\u041e\u0415",
      "longitude":95.22139,
      "latitude":56.838005
    },
    "5762":{
      "name":"\u0418\u0420\u0411\u0415\u0419\u0421\u041a\u041e\u0415",
      "longitude":95.456528,
      "latitude":55.644501
    },
    "5763":{
      "name":"\u0418\u041b\u0410\u041d\u0421\u041a\u0418\u0419",
      "longitude":96.06694,
      "latitude":56.23806
    },
    "5764":{
      "name":"\u0410\u0411\u0410\u041d",
      "longitude":96.067764,
      "latitude":56.67667
    },
    "5765":{
      "name":"\u041d\u0418\u0416\u041d\u0418\u0419 \u0418\u041d\u0413\u0410\u0428",
      "longitude":96.544518,
      "latitude":56.203602
    },
    "5766":{
      "name":"\u041d\u0418\u0416\u041d\u042f\u042f \u041f\u041e\u0419\u041c\u0410",
      "longitude":97.20192,
      "latitude":56.163059
    },
    "5767":{
      "name":"\u0411\u041e\u0413\u0423\u0427\u0410\u041d\u042b",
      "longitude":97.461578,
      "latitude":58.382816
    },
    "5768":{
      "name":"\u041a\u041e\u0414\u0418\u041d\u0421\u041a",
      "longitude":99.182915,
      "latitude":58.596329
    },
    "5769":{
      "name":"\u0422\u0423\u0420\u0410",
      "longitude":100.2169635,
      "latitude":64.2741955
    },
    "5770":{
      "name":"\u0412\u0410\u041d\u0410\u0412\u0410\u0420\u0410",
      "longitude":102.28093,
      "latitude":60.345203
    },
    "5771":{
      "name":"\u0425\u0410\u0422\u0410\u041d\u0413\u0410",
      "longitude":102.474266,
      "latitude":71.980072
    },
    "5772":{
      "name":"\u041c\u0423\u0413\u0423\u0420-\u0410\u041a\u0421\u042b",
      "longitude":90.441721,
      "latitude":50.3800035
    },
    "5773":{
      "name":"\u041a\u042b\u0417\u042b\u041b-\u041c\u0410\u0416\u0410\u041b\u042b\u041a",
      "longitude":90.5814803,
      "latitude":51.1454611
    },
    "5774":{
      "name":"\u0410\u041a-\u0414\u041e\u0412\u0423\u0420\u0410\u041a",
      "longitude":90.5999914,
      "latitude":51.174081
    },
    "5775":{
      "name":"\u0427\u0410\u0414\u0410\u041d",
      "longitude":91.582817,
      "latitude":51.286018
    },
    "5776":{
      "name":"\u0428\u0410\u0413\u041e\u041d\u0410\u0420",
      "longitude":92.9194074,
      "latitude":51.538721
    },
    "5777":{
      "name":"\u0425\u041e\u0412\u0423-\u0410\u041a\u0421\u042b",
      "longitude":93.715744,
      "latitude":51.131943
    },
    "5778":{
      "name":"\u0422\u0423\u0420\u0410\u041d",
      "longitude":93.9186434,
      "latitude":52.1458093
    },
    "5779":{
      "name":"\u041a\u0410\u0410-\u0425\u0415\u041c",
      "longitude":94.563721,
      "latitude":51.696541
    },
    "5780":{
      "name":"\u0421\u0410\u0420\u042b\u0413-\u0421\u0415\u041f",
      "longitude":95.554681,
      "latitude":51.492626
    },
    "5781":{
      "name":"\u042e\u0420\u0413\u0410",
      "longitude":84.934799,
      "latitude":55.7136
    },
    "5782":{
      "name":"\u042f\u0428\u041a\u0418\u041d\u041e",
      "longitude":85.427689,
      "latitude":55.873089
    },
    "5783":{
      "name":"\u0422\u041e\u041f\u041a\u0418",
      "longitude":85.6228741,
      "latitude":55.2751962
    },
    "5784":{
      "name":"\u0422\u0410\u0419\u0413\u0410",
      "longitude":85.631325,
      "latitude":56.065071
    },
    "5785":{
      "name":"\u041f\u0420\u041e\u041c\u042b\u0428\u041b\u0415\u041d\u041d\u0410\u042f",
      "longitude":85.637863,
      "latitude":54.918507
    },
    "5786":{
      "name":"\u0421\u0410\u041b\u0410\u0418\u0420",
      "longitude":85.798386,
      "latitude":54.232521
    },
    "5787":{
      "name":"\u0413\u0423\u0420\u042c\u0415\u0412\u0421\u041a",
      "longitude":85.931091,
      "latitude":54.284954
    },
    "5788":{
      "name":"\u0410\u041d\u0416\u0415\u0420\u041e-\u0421\u0423\u0414\u0416\u0415\u041d\u0421\u041a",
      "longitude":86.019356,
      "latitude":56.077808
    },
    "5789":{
      "name":"\u0411\u0410\u0427\u0410\u0422\u0421\u041a\u0418\u0419",
      "longitude":86.104759,
      "latitude":54.283138
    },
    "5790":{
      "name":"\u0420\u0423\u0414\u041d\u0418\u0427\u041d\u042b\u0419",
      "longitude":86.246651,
      "latitude":56.083324
    },
    "5791":{
      "name":"\u0411\u0415\u0420\u0401\u0417\u041e\u0412\u0421\u041a\u0418\u0419",
      "longitude":86.274529,
      "latitude":55.669926
    },
    "5792":{
      "name":"\u041f\u041e\u041b\u042b\u0421\u0410\u0415\u0412\u041e",
      "longitude":86.276024,
      "latitude":54.603142
    },
    "5793":{
      "name":"\u041d\u041e\u0412\u042b\u0419 \u0413\u041e\u0420\u041e\u0414\u041e\u041a",
      "longitude":86.296219,
      "latitude":54.306171
    },
    "5794":{
      "name":"\u0411\u0415\u041b\u041e\u0412\u041e",
      "longitude":86.303429,
      "latitude":54.419323
    },
    "5795":{
      "name":"\u0413\u0420\u0410\u041c\u041e\u0422\u0415\u0418\u041d\u041e",
      "longitude":86.380737,
      "latitude":54.53487
    },
    "5796":{
      "name":"\u0418\u041d\u0421\u041a\u041e\u0419",
      "longitude":86.441681,
      "latitude":54.432644
    },
    "5797":{
      "name":"\u041a\u0420\u0410\u0421\u041d\u041e\u0411\u0420\u041e\u0414\u0421\u041a\u0418\u0419",
      "longitude":86.448097,
      "latitude":54.157387
    },
    "5798":{
      "name":"\u042f\u042f",
      "longitude":86.451111,
      "latitude":56.202641
    },
    "5799":{
      "name":"\u0418\u0416\u041c\u041e\u0420\u0421\u041a\u0418\u0419",
      "longitude":86.637169,
      "latitude":56.192169
    },
    "5800":{
      "name":"\u041a\u0420\u0410\u041f\u0418\u0412\u0418\u041d\u0421\u041a\u0418\u0419",
      "longitude":86.805855,
      "latitude":55.003925
    },
    "5801":{
      "name":"\u0417\u0415\u041b\u0415\u041d\u041e\u0413\u041e\u0420\u0421\u041a\u0418\u0419",
      "longitude":86.952477,
      "latitude":55.004623
    },
    "5802":{
      "name":"\u041c\u0423\u041d\u0414\u042b\u0411\u0410\u0428",
      "longitude":87.276199,
      "latitude":53.210381
    },
    "5803":{
      "name":"\u041a\u0410\u041b\u0422\u0410\u041d",
      "longitude":87.286179,
      "latitude":53.519459
    },
    "5804":{
      "name":"\u041e\u0421\u0418\u041d\u041d\u0418\u041a\u0418",
      "longitude":87.332893,
      "latitude":53.606995
    },
    "5805":{
      "name":"\u0422\u0415\u041c\u0418\u0420\u0422\u0410\u0423",
      "longitude":87.458092,
      "latitude":53.138775
    },
    "5806":{
      "name":"\u041a\u0410\u0417",
      "longitude":87.554047,
      "latitude":53.112923
    },
    "5807":{
      "name":"\u041c\u0410\u0420\u0418\u0418\u041d\u0421\u041a",
      "longitude":87.751259,
      "latitude":56.206299
    },
    "5808":{
      "name":"\u041c\u042b\u0421\u041a\u0418",
      "longitude":87.800316,
      "latitude":53.71386
    },
    "5809":{
      "name":"\u0422\u0410\u0428\u0422\u0410\u0413\u041e\u041b",
      "longitude":87.848267,
      "latitude":52.759403
    },
    "5810":{
      "name":"\u0428\u0415\u0420\u0415\u0413\u0415\u0428",
      "longitude":87.977333,
      "latitude":52.926311
    },
    "5811":{
      "name":"\u0422\u0418\u0421\u0423\u041b\u042c",
      "longitude":88.3130216,
      "latitude":55.763851
    },
    "5812":{
      "name":"\u0422\u042f\u0416\u0418\u041d\u0421\u041a\u0418\u0419",
      "longitude":88.517235,
      "latitude":56.113953
    },
    "5813":{
      "name":"\u041a\u041e\u041f\u042c\u0401\u0412\u041e",
      "longitude":89.826622,
      "latitude":54.992966
    },
    "5814":{
      "name":"\u0422\u0410\u0428\u0422\u042b\u041f",
      "longitude":89.891724,
      "latitude":52.79586
    },
    "5815":{
      "name":"\u0428\u0418\u0420\u0410",
      "longitude":89.962891,
      "latitude":54.48764
    },
    "5816":{
      "name":"\u0410\u0411\u0410\u0417\u0410",
      "longitude":90.101159,
      "latitude":52.6510546
    },
    "5817":{
      "name":"\u0421\u041e\u0420\u0421\u041a",
      "longitude":90.246948,
      "latitude":53.995647
    },
    "5818":{
      "name":"\u0410\u0421\u041a\u0418\u0417",
      "longitude":90.436188,
      "latitude":53.135597
    },
    "5819":{
      "name":"\u0410\u0421\u041a\u0418\u0417",
      "longitude":90.530022,
      "latitude":53.132652
    },
    "5820":{
      "name":"\u0411\u041e\u0413\u0420\u0410\u0414",
      "longitude":90.856026,
      "latitude":54.21806
    },
    "5821":{
      "name":"\u0411\u0415\u042f",
      "longitude":90.921989,
      "latitude":53.046246
    },
    "5822":{
      "name":"\u0427\u0415\u0420\u041d\u041e\u0413\u041e\u0420\u0421\u041a",
      "longitude":91.31321,
      "latitude":53.828236
    },
    "5823":{
      "name":"\u0423\u0421\u0422\u042c-\u0410\u0411\u0410\u041a\u0410\u041d",
      "longitude":91.381294,
      "latitude":53.844601
    },
    "5824":{
      "name":"\u0411\u0415\u041b\u042b\u0419 \u042f\u0420",
      "longitude":91.382362,
      "latitude":53.596436
    },
    "5825":{
      "name":"\u0421\u0410\u042f\u041d\u041e\u0413\u041e\u0420\u0421\u041a",
      "longitude":91.4114,
      "latitude":53.089386
    },
    "5826":{
      "name":"\u0427\u0415\u0420\u0401\u041c\u0423\u0428\u041a\u0418",
      "longitude":91.42038,
      "latitude":52.848377
    },
    "5827":{
      "name":"\u041c\u0410\u0419\u041d\u0410",
      "longitude":91.487083,
      "latitude":52.998306
    },
    "5828":{
      "name":"\u041f\u0415\u0422\u0420\u041e\u0412\u0421\u041a-\u0417\u0410\u0411\u0410\u0419\u041a\u0410\u041b\u042c\u0421\u041a\u0418\u0419",
      "longitude":108.854485,
      "latitude":51.275215
    },
    "5829":{
      "name":"\u0411\u0410\u041b\u042f\u0413\u0410",
      "longitude":108.908714,
      "latitude":51.158348
    },
    "5830":{
      "name":"\u0422\u0410\u0420\u0411\u0410\u0413\u0410\u0422\u0410\u0419",
      "longitude":109.09938,
      "latitude":51.178032
    },
    "5831":{
      "name":"\u041d\u041e\u0412\u041e\u041f\u0410\u0412\u041b\u041e\u0412\u041a\u0410",
      "longitude":109.224709,
      "latitude":51.214764
    },
    "5832":{
      "name":"\u0425\u0418\u041b\u041e\u041a",
      "longitude":110.4579749,
      "latitude":51.3628436
    },
    "5833":{
      "name":"\u041c\u041e\u0413\u0417\u041e\u041d",
      "longitude":111.97103,
      "latitude":51.7411577
    },
    "5834":{
      "name":"\u0413\u041e\u0420\u041d\u042b\u0419",
      "longitude":113.033165,
      "latitude":51.55468
    },
    "5835":{
      "name":"\u0414\u0420\u041e\u0412\u042f\u041d\u0410\u042f",
      "longitude":113.047455,
      "latitude":51.580357
    },
    "5836":{
      "name":"\u0410\u0422\u0410\u041c\u0410\u041d\u041e\u0412\u041a\u0410",
      "longitude":113.649384,
      "latitude":51.918083
    },
    "5837":{
      "name":"\u041a\u0423\u0420\u041e\u0420\u0422-\u0414\u0410\u0420\u0410\u0421\u0423\u041d",
      "longitude":113.714195,
      "latitude":51.204155
    },
    "5838":{
      "name":"\u041d\u041e\u0412\u041e\u041a\u0420\u0423\u0427\u0418\u041d\u0418\u041d\u0421\u041a\u0418\u0419",
      "longitude":113.792671,
      "latitude":51.774662
    },
    "5839":{
      "name":"\u0414\u0410\u0420\u0410\u0421\u0423\u041d",
      "longitude":113.984253,
      "latitude":51.663696
    },
    "5840":{
      "name":"\u041a\u0410\u0420\u042b\u041c\u0421\u041a\u041e\u0415",
      "longitude":114.34063,
      "latitude":51.623402
    },
    "5841":{
      "name":"\u0410\u0413\u0418\u041d\u0421\u041a\u041e\u0415",
      "longitude":114.544266,
      "latitude":51.107189
    },
    "5842":{
      "name":"\u041c\u041e\u0413\u041e\u0419\u0422\u0423\u0419",
      "longitude":114.930435,
      "latitude":51.282913
    },
    "5843":{
      "name":"\u0412\u0415\u0420\u0428\u0418\u041d\u041e-\u0414\u0410\u0420\u0410\u0421\u0423\u041d\u0421\u041a\u0418\u0419",
      "longitude":115.550949,
      "latitude":52.365974
    },
    "5844":{
      "name":"\u041e\u041b\u041e\u0412\u042f\u041d\u041d\u0410\u042f",
      "longitude":115.586937,
      "latitude":50.943687
    },
    "5845":{
      "name":"\u041f\u0415\u0420\u0412\u041e\u041c\u0410\u0419\u0421\u041a\u0418\u0419",
      "longitude":115.638283,
      "latitude":51.669296
    },
    "5846":{
      "name":"\u042f\u0421\u041d\u041e\u0413\u041e\u0420\u0421\u041a",
      "longitude":115.699043,
      "latitude":50.876667
    },
    "5847":{
      "name":"\u0428\u0418\u041b\u041a\u0410",
      "longitude":116.025894,
      "latitude":51.851639
    },
    "5848":{
      "name":"\u0425\u041e\u041b\u0411\u041e\u041d",
      "longitude":116.251968,
      "latitude":51.900475
    },
    "5849":{
      "name":"\u0428\u0415\u0420\u041b\u041e\u0412\u0410\u042f \u0413\u041e\u0420\u0410",
      "longitude":116.312912,
      "latitude":50.52816
    },
    "5850":{
      "name":"\u0411\u041e\u0420\u0417\u042f",
      "longitude":116.533562,
      "latitude":50.385109
    },
    "5851":{
      "name":"\u041d\u0415\u0420\u0427\u0418\u041d\u0421\u041a",
      "longitude":116.588341,
      "latitude":51.97694
    },
    "5852":{
      "name":"\u041f\u0420\u0418\u0418\u0421\u041a\u041e\u0412\u042b\u0419",
      "longitude":116.617645,
      "latitude":51.917625
    },
    "5853":{
      "name":"\u0411\u0410\u041b\u0415\u0419",
      "longitude":116.646042,
      "latitude":51.578789
    },
    "5854":{
      "name":"\u0411\u0423\u041a\u0410\u0427\u0410\u0427\u0410",
      "longitude":116.91169,
      "latitude":52.988396
    },
    "5855":{
      "name":"\u0427\u0415\u0420\u041d\u042b\u0428\u0415\u0412\u0421\u041a",
      "longitude":117.01371,
      "latitude":52.514069
    },
    "5856":{
      "name":"\u0416\u0418\u0420\u0415\u041a\u0415\u041d",
      "longitude":117.286469,
      "latitude":52.821419
    },
    "5857":{
      "name":"\u0417\u0410\u0411\u0410\u0419\u041a\u0410\u041b\u042c\u0421\u041a",
      "longitude":117.329025,
      "latitude":49.644653
    },
    "5858":{
      "name":"\u0410\u041a\u0421\u0401\u041d\u041e\u0412\u041e-\u0417\u0418\u041b\u041e\u0412\u0421\u041a\u041e\u0415",
      "longitude":117.509735,
      "latitude":53.068661
    },
    "5859":{
      "name":"\u041a\u041e\u041a\u0423\u0419",
      "longitude":117.550705,
      "latitude":52.204762
    },
    "5860":{
      "name":"\u0421\u0420\u0415\u0422\u0415\u041d\u0421\u041a",
      "longitude":117.695541,
      "latitude":52.243191
    },
    "5861":{
      "name":"\u041a\u0420\u0410\u0421\u041d\u041e\u041a\u0410\u041c\u0415\u041d\u0421\u041a",
      "longitude":118.041344,
      "latitude":50.096992
    },
    "5862":{
      "name":"\u041d\u041e\u0412\u0410\u042f \u0427\u0410\u0420\u0410",
      "longitude":118.26881495406487,
      "latitude":56.78914811883326
    },
    "5863":{
      "name":"\u041a\u0421\u0415\u041d\u042c\u0415\u0412\u041a\u0410",
      "longitude":118.734123,
      "latitude":53.559807
    },
    "5864":{
      "name":"\u041f\u0420\u0418\u0410\u0420\u0413\u0423\u041d\u0421\u041a",
      "longitude":119.090134,
      "latitude":50.365902
    },
    "5865":{
      "name":"\u041c\u041e\u0413\u041e\u0427\u0410",
      "longitude":119.7648554,
      "latitude":53.7335417
    },
    "5866":{
      "name":"\u0410\u041c\u0410\u0417\u0410\u0420",
      "longitude":120.878082,
      "latitude":53.860237
    },
    "5867":{
      "name":"\u0423\u0421\u0422\u042c-\u0418\u0428\u0418\u041c",
      "longitude":71.169968,
      "latitude":57.693462
    },
    "5868":{
      "name":"\u0418\u0421\u0418\u041b\u042c\u041a\u0423\u041b\u042c",
      "longitude":71.259987,
      "latitude":54.904892
    },
    "5869":{
      "name":"\u041d\u0410\u0417\u042b\u0412\u0410\u0415\u0412\u0421\u041a",
      "longitude":71.349365,
      "latitude":55.564896
    },
    "5870":{
      "name":"\u041a\u0420\u0423\u0422\u0418\u041d\u041a\u0410",
      "longitude":71.511307,
      "latitude":56.006351
    },
    "5871":{
      "name":"\u041f\u041e\u041b\u0422\u0410\u0412\u041a\u0410",
      "longitude":71.760139,
      "latitude":54.363895
    },
    "5872":{
      "name":"\u041c\u041e\u0421\u041a\u0410\u041b\u0415\u041d\u041a\u0418",
      "longitude":71.92588,
      "latitude":54.939468
    },
    "5873":{
      "name":"\u0422\u042e\u041a\u0410\u041b\u0418\u041d\u0421\u041a",
      "longitude":72.196617,
      "latitude":55.870556
    },
    "5874":{
      "name":"\u0428\u0415\u0420\u0411\u0410\u041a\u0423\u041b\u042c",
      "longitude":72.392822,
      "latitude":54.631046
    },
    "5875":{
      "name":"\u0422\u0415\u0412\u0420\u0418\u0417",
      "longitude":72.398911,
      "latitude":57.513668
    },
    "5876":{
      "name":"\u0411\u041e\u041b\u042c\u0428\u0418\u0415 \u0423\u041a\u0418",
      "longitude":72.625717,
      "latitude":56.949043
    },
    "5877":{
      "name":"\u041c\u0410\u0420\u042c\u042f\u041d\u041e\u0412\u041a\u0410",
      "longitude":72.637947,
      "latitude":54.960659
    },
    "5878":{
      "name":"\u041b\u042e\u0411\u0418\u041d\u0421\u041a\u0418\u0419",
      "longitude":72.699005,
      "latitude":55.156715
    },
    "5879":{
      "name":"\u041e\u0414\u0415\u0421\u0421\u041a\u041e\u0415",
      "longitude":72.965538,
      "latitude":54.20969
    },
    "5880":{
      "name":"\u0410\u0417\u041e\u0412\u041e",
      "longitude":73.026871,
      "latitude":54.70385
    },
    "5881":{
      "name":"\u0421\u0410\u0420\u0413\u0410\u0422\u0421\u041a\u041e\u0415",
      "longitude":73.490257,
      "latitude":55.603386
    },
    "5882":{
      "name":"\u041f\u0410\u0412\u041b\u041e\u0413\u0420\u0410\u0414\u041a\u0410",
      "longitude":73.556488,
      "latitude":54.205006
    },
    "5883":{
      "name":"\u041a\u041e\u041b\u041e\u0421\u041e\u0412\u041a\u0410",
      "longitude":73.606575,
      "latitude":56.467625
    },
    "5884":{
      "name":"\u0422\u0410\u0412\u0420\u0418\u0427\u0415\u0421\u041a\u041e\u0415",
      "longitude":73.637436,
      "latitude":54.586674
    },
    "5885":{
      "name":"\u0417\u041d\u0410\u041c\u0415\u041d\u0421\u041a\u041e\u0415",
      "longitude":73.821983,
      "latitude":57.127403
    },
    "5886":{
      "name":"\u0420\u0423\u0421\u0421\u041a\u0410\u042f \u041f\u041e\u041b\u042f\u041d\u0410",
      "longitude":73.882103,
      "latitude":53.780357
    },
    "5887":{
      "name":"\u041a\u041e\u0420\u041c\u0418\u041b\u041e\u0412\u041a\u0410",
      "longitude":74.092224,
      "latitude":55.002613
    },
    "5888":{
      "name":"\u0413\u041e\u0420\u042c\u041a\u041e\u0412\u0421\u041a\u041e\u0415",
      "longitude":74.362556,
      "latitude":55.371033
    },
    "5889":{
      "name":"\u0422\u0410\u0420\u0410",
      "longitude":74.3698652,
      "latitude":56.902587
    },
    "5890":{
      "name":"\u041a\u0410\u041b\u0410\u0427\u0418\u041d\u0421\u041a",
      "longitude":74.582428,
      "latitude":55.049091
    },
    "5891":{
      "name":"\u0411\u041e\u041b\u042c\u0428\u0415\u0420\u0415\u0427\u042c\u0415",
      "longitude":74.639519,
      "latitude":56.094585
    },
    "5892":{
      "name":"\u041d\u041e\u0412\u041e\u0412\u0410\u0420\u0428\u0410\u0412\u041a\u0410",
      "longitude":74.696037,
      "latitude":54.170616
    },
    "5893":{
      "name":"\u0427\u0415\u0420\u041b\u0410\u041a",
      "longitude":74.7974987,
      "latitude":54.154067
    },
    "5894":{
      "name":"\u041d\u0418\u0416\u041d\u042f\u042f \u041e\u041c\u041a\u0410",
      "longitude":74.938004,
      "latitude":55.43359
    },
    "5895":{
      "name":"\u041e\u041a\u041e\u041d\u0415\u0428\u041d\u0418\u041a\u041e\u0412\u041e",
      "longitude":75.082306,
      "latitude":54.839363
    },
    "5896":{
      "name":"\u041c\u0423\u0420\u041e\u041c\u0426\u0415\u0412\u041e",
      "longitude":75.237198,
      "latitude":56.369392
    },
    "5897":{
      "name":"\u0421\u0415\u0414\u0415\u041b\u042c\u041d\u0418\u041a\u041e\u0412\u041e",
      "longitude":75.306061,
      "latitude":56.945618
    },
    "5898":{
      "name":"\u0421\u0422\u0420\u0415\u0416\u0415\u0412\u041e\u0419",
      "longitude":77.600807,
      "latitude":60.732758
    },
    "5899":{
      "name":"\u0410\u041b\u0415\u041a\u0421\u0410\u041d\u0414\u0420\u041e\u0412\u0421\u041a\u041e\u0415",
      "longitude":77.865845,
      "latitude":60.431446
    },
    "5900":{
      "name":"\u041a\u0415\u0414\u0420\u041e\u0412\u042b\u0419",
      "longitude":79.570801,
      "latitude":57.56192
    },
    "5901":{
      "name":"\u041a\u0410\u0420\u0413\u0410\u0421\u041e\u041a",
      "longitude":80.867546,
      "latitude":59.057003
    },
    "5902":{
      "name":"\u041f\u0410\u0420\u0410\u0411\u0415\u041b\u042c",
      "longitude":81.501793,
      "latitude":58.713741
    },
    "5903":{
      "name":"\u0411\u0410\u041a\u0427\u0410\u0420",
      "longitude":82.066872,
      "latitude":57.020538
    },
    "5904":{
      "name":"\u041f\u041e\u0414\u0413\u041e\u0420\u041d\u041e\u0415",
      "longitude":82.641541,
      "latitude":57.793751
    },
    "5905":{
      "name":"\u041a\u041e\u041b\u041f\u0410\u0428\u0415\u0412\u041e",
      "longitude":82.903557,
      "latitude":58.313667
    },
    "5906":{
      "name":"\u041c\u041e\u041b\u0427\u0410\u041d\u041e\u0412\u041e",
      "longitude":83.7605958,
      "latitude":57.5812043
    },
    "5907":{
      "name":"\u041a\u0420\u0418\u0412\u041e\u0428\u0415\u0418\u041d\u041e",
      "longitude":83.930153,
      "latitude":57.343742
    },
    "5908":{
      "name":"\u041a\u041e\u0416\u0415\u0412\u041d\u0418\u041a\u041e\u0412\u041e",
      "longitude":83.976387,
      "latitude":56.260132
    },
    "5909":{
      "name":"\u041c\u0415\u041b\u042c\u041d\u0418\u041a\u041e\u0412\u041e",
      "longitude":84.090408,
      "latitude":56.554417
    },
    "5910":{
      "name":"\u0421\u0410\u041c\u0423\u0421\u042c",
      "longitude":84.69873,
      "latitude":56.743713
    },
    "5911":{
      "name":"\u0417\u041e\u041d\u0410\u041b\u042c\u041d\u0410\u042f \u0421\u0422\u0410\u041d\u0426\u0418\u042f",
      "longitude":85.022102,
      "latitude":56.426922
    },
    "5912":{
      "name":"\u0411\u0415\u041b\u042b\u0419 \u042f\u0420",
      "longitude":85.036476,
      "latitude":58.444763
    },
    "5913":{
      "name":"\u0421\u0412\u0415\u0422\u041b\u042b\u0419",
      "longitude":85.103523,
      "latitude":56.578079
    },
    "5914":{
      "name":"\u0410\u0421\u0418\u041d\u041e",
      "longitude":86.14167,
      "latitude":56.999187
    },
    "5915":{
      "name":"\u041f\u0415\u0420\u0412\u041e\u041c\u0410\u0419\u0421\u041a\u041e\u0415",
      "longitude":86.226082,
      "latitude":57.070614
    },
    "5916":{
      "name":"\u0417\u042b\u0420\u042f\u041d\u0421\u041a\u041e\u0415",
      "longitude":86.621178,
      "latitude":56.834206
    },
    "5917":{
      "name":"\u0422\u0415\u0413\u0423\u041b\u042c\u0414\u0415\u0422",
      "longitude":88.167168,
      "latitude":57.306404
    },
    "5918":{
      "name":"\u0423\u0421\u0422\u042c-\u0422\u0410\u0420\u041a\u0410",
      "longitude":75.706017,
      "latitude":55.563934
    },
    "5919":{
      "name":"\u0422\u0410\u0422\u0410\u0420\u0421\u041a",
      "longitude":75.962196,
      "latitude":55.216961
    },
    "5920":{
      "name":"\u0427\u0418\u0421\u0422\u041e\u041e\u0417\u0401\u0420\u041d\u041e\u0415",
      "longitude":76.582344,
      "latitude":54.712204
    },
    "5921":{
      "name":"\u041a\u042b\u0428\u0422\u041e\u0412\u041a\u0410",
      "longitude":76.624588,
      "latitude":56.55957
    },
    "5922":{
      "name":"\u0412\u0415\u041d\u0413\u0415\u0420\u041e\u0412\u041e",
      "longitude":76.739029,
      "latitude":55.681034
    },
    "5923":{
      "name":"\u0427\u0410\u041d\u042b",
      "longitude":76.759605,
      "latitude":55.308064
    },
    "5924":{
      "name":"\u041a\u0423\u041f\u0418\u041d\u041e",
      "longitude":77.30854,
      "latitude":54.364929
    },
    "5925":{
      "name":"\u0411\u0410\u0413\u0410\u041d",
      "longitude":77.671883,
      "latitude":54.096813
    },
    "5926":{
      "name":"\u041a\u0410\u0420\u0410\u0421\u0423\u041a",
      "longitude":78.032372,
      "latitude":53.73447
    },
    "5927":{
      "name":"\u041a\u0423\u0419\u0411\u042b\u0428\u0415\u0412",
      "longitude":78.3222294,
      "latitude":55.4454258
    },
    "5928":{
      "name":"\u0411\u0410\u0420\u0410\u0411\u0418\u041d\u0421\u041a",
      "longitude":78.347816,
      "latitude":55.351784
    },
    "5929":{
      "name":"\u0421\u0415\u0412\u0415\u0420\u041d\u041e\u0415",
      "longitude":78.364952,
      "latitude":56.350143
    },
    "5930":{
      "name":"\u0417\u0414\u0412\u0418\u041d\u0421\u041a",
      "longitude":78.667595,
      "latitude":54.703968
    },
    "5931":{
      "name":"\u041a\u0420\u0410\u0421\u041d\u041e\u0417\u0401\u0420\u0421\u041a\u041e\u0415",
      "longitude":79.228577,
      "latitude":53.984768
    },
    "5932":{
      "name":"\u0414\u041e\u0412\u041e\u041b\u042c\u041d\u041e\u0415",
      "longitude":79.667091,
      "latitude":54.495785
    },
    "5933":{
      "name":"\u0423\u0411\u0418\u041d\u0421\u041a\u041e\u0415",
      "longitude":79.679375,
      "latitude":55.306721
    },
    "5934":{
      "name":"\u041a\u0410\u0420\u0413\u0410\u0422",
      "longitude":80.2828252,
      "latitude":55.1929899
    },
    "5935":{
      "name":"\u041a\u041e\u0427\u041a\u0418",
      "longitude":80.487846,
      "latitude":54.334766
    },
    "5936":{
      "name":"\u0427\u0423\u041b\u042b\u041c",
      "longitude":80.970459,
      "latitude":55.09
    },
    "5937":{
      "name":"\u041e\u0420\u0414\u042b\u041d\u0421\u041a\u041e\u0415",
      "longitude":81.904022,
      "latitude":54.366676
    },
    "5938":{
      "name":"\u041a\u041e\u0427\u0415\u041d\u0401\u0412\u041e",
      "longitude":82.207718,
      "latitude":55.021442
    },
    "5939":{
      "name":"\u0421\u0423\u0417\u0423\u041d",
      "longitude":82.316231,
      "latitude":53.783924
    },
    "5940":{
      "name":"\u041a\u0420\u0418\u0412\u041e\u0414\u0410\u041d\u041e\u0412\u041a\u0410",
      "longitude":82.6440062,
      "latitude":55.0859006
    },
    "5941":{
      "name":"\u041e\u0411\u042c",
      "longitude":82.6933946,
      "latitude":54.9951335
    },
    "5942":{
      "name":"\u041a\u041e\u041b\u042b\u0412\u0410\u041d\u042c",
      "longitude":82.7433464,
      "latitude":55.3068791
    },
    "5943":{
      "name":"\u041a\u0420\u0410\u0421\u041d\u041e\u041e\u0411\u0421\u041a",
      "longitude":82.9905861,
      "latitude":54.9211081
    },
    "5944":{
      "name":"\u041a\u041e\u041b\u042c\u0426\u041e\u0412\u041e",
      "longitude":83.187139,
      "latitude":54.9367736
    },
    "5945":{
      "name":"\u0418\u0421\u041a\u0418\u0422\u0418\u041c",
      "longitude":83.3035676,
      "latitude":54.6426269
    },
    "5946":{
      "name":"\u041f\u041e\u0421\u0415\u0412\u041d\u0410\u042f",
      "longitude":83.329704,
      "latitude":54.300575
    },
    "5947":{
      "name":"\u0427\u0415\u0420\u0415\u041f\u0410\u041d\u041e\u0412\u041e",
      "longitude":83.370468,
      "latitude":54.226101
    },
    "5948":{
      "name":"\u041b\u0418\u041d\u0401\u0412\u041e",
      "longitude":83.379074,
      "latitude":54.456459
    },
    "5949":{
      "name":"\u041c\u041e\u0428\u041a\u041e\u0412\u041e",
      "longitude":83.611855,
      "latitude":55.304806
    },
    "5950":{
      "name":"\u0421\u0422\u0410\u041d\u0426\u0418\u041e\u041d\u041d\u041e-\u041e\u042f\u0428\u0418\u041d\u0421\u041a\u0418\u0419",
      "longitude":83.82135,
      "latitude":55.465
    },
    "5951":{
      "name":"\u041c\u0410\u0421\u041b\u042f\u041d\u0418\u041d\u041e",
      "longitude":84.21067,
      "latitude":54.345501
    },
    "5952":{
      "name":"\u0411\u041e\u041b\u041e\u0422\u041d\u041e\u0415",
      "longitude":84.38855,
      "latitude":55.671566
    },
    "5953":{
      "name":"\u0422\u041e\u0413\u0423\u0427\u0418\u041d",
      "longitude":84.402458,
      "latitude":55.23769
    },
    "5954":{
      "name":"\u0411\u0418\u0420\u042e\u0421\u0418\u041d\u0421\u041a",
      "longitude":97.824509,
      "latitude":55.964275
    },
    "5955":{
      "name":"\u0422\u0410\u0419\u0428\u0415\u0422",
      "longitude":98.005096,
      "latitude":55.941296
    },
    "5956":{
      "name":"\u0410\u041b\u0417\u0410\u041c\u0410\u0419",
      "longitude":98.665497,
      "latitude":55.554932
    },
    "5957":{
      "name":"\u041d\u0418\u0416\u041d\u0415\u0423\u0414\u0418\u041d\u0421\u041a",
      "longitude":99.0311721,
      "latitude":54.9075638
    },
    "5958":{
      "name":"\u041e\u041a\u0422\u042f\u0411\u0420\u042c\u0421\u041a\u0418\u0419",
      "longitude":99.4161715,
      "latitude":56.0724249
    },
    "5959":{
      "name":"\u041b\u0415\u0421\u041e\u0413\u041e\u0420\u0421\u041a",
      "longitude":99.5145428,
      "latitude":56.0508793
    },
    "5960":{
      "name":"\u0427\u0423\u041d\u0421\u041a\u0418\u0419",
      "longitude":99.633705,
      "latitude":56.091248
    },
    "5961":{
      "name":"\u0422\u0423\u041b\u0423\u041d",
      "longitude":100.579216,
      "latitude":54.562096
    },
    "5962":{
      "name":"\u0412\u0418\u0425\u041e\u0420\u0415\u0412\u041a\u0410",
      "longitude":101.171951,
      "latitude":56.124722
    },
    "5963":{
      "name":"\u041a\u0423\u0419\u0422\u0423\u041d",
      "longitude":101.506195,
      "latitude":54.344154
    },
    "5964":{
      "name":"\u0417\u0418\u041c\u0410",
      "longitude":102.052727,
      "latitude":53.928402
    },
    "5965":{
      "name":"\u0421\u0410\u042f\u041d\u0421\u041a",
      "longitude":102.169525,
      "latitude":54.108418
    },
    "5966":{
      "name":"\u0417\u0410\u041b\u0410\u0420\u0418",
      "longitude":102.515991,
      "latitude":53.566238
    },
    "5967":{
      "name":"\u041d\u041e\u0412\u041e\u041d\u0423\u041a\u0423\u0422\u0421\u041a\u0418\u0419",
      "longitude":102.711548,
      "latitude":53.700245
    },
    "5968":{
      "name":"\u0423\u0421\u0422\u042c-\u0418\u041b\u0418\u041c\u0421\u041a",
      "longitude":102.734192,
      "latitude":57.959473
    },
    "5969":{
      "name":"\u0416\u0415\u041b\u0415\u0417\u041d\u041e\u0414\u041e\u0420\u041e\u0416\u041d\u042b\u0419",
      "longitude":102.775116,
      "latitude":57.908489
    },
    "5970":{
      "name":"\u041a\u0423\u0422\u0423\u041b\u0418\u041a",
      "longitude":102.7949052,
      "latitude":53.3494147
    },
    "5971":{
      "name":"\u0423\u0421\u0422\u042c-\u0423\u0414\u0410",
      "longitude":103.028229,
      "latitude":54.174809
    },
    "5972":{
      "name":"\u0411\u0410\u041b\u0410\u0413\u0410\u041d\u0421\u041a",
      "longitude":103.054024,
      "latitude":54.006798
    },
    "5973":{
      "name":"\u0427\u0415\u0420\u0415\u041c\u0425\u041e\u0412\u041e",
      "longitude":103.070145,
      "latitude":53.148434
    },
    "5974":{
      "name":"\u041c\u0418\u0428\u0415\u041b\u0401\u0412\u041a\u0410",
      "longitude":103.184097,
      "latitude":52.865021
    },
    "5975":{
      "name":"\u041c\u0418\u0425\u0410\u0419\u041b\u041e\u0412\u041a\u0410",
      "longitude":103.288483,
      "latitude":52.960114
    },
    "5976":{
      "name":"\u0421\u0412\u0418\u0420\u0421\u041a",
      "longitude":103.342331,
      "latitude":53.066269
    },
    "5977":{
      "name":"\u0421\u0420\u0415\u0414\u041d\u0418\u0419",
      "longitude":103.48864,
      "latitude":52.882076
    },
    "5978":{
      "name":"\u0411\u0415\u041b\u041e\u0420\u0415\u0427\u0415\u041d\u0421\u041a\u0418\u0419",
      "longitude":103.525436,
      "latitude":52.814842
    },
    "5979":{
      "name":"\u0423\u0421\u041e\u041b\u042c\u0415-\u0421\u0418\u0411\u0418\u0420\u0421\u041a\u041e\u0415",
      "longitude":103.662079,
      "latitude":52.75116
    },
    "5980":{
      "name":"\u0422\u0415\u041b\u042c\u041c\u0410",
      "longitude":103.715691,
      "latitude":52.695877
    },
    "5981":{
      "name":"\u0421\u041b\u042e\u0414\u042f\u041d\u041a\u0410",
      "longitude":103.719292,
      "latitude":51.656769
    },
    "5982":{
      "name":"\u0411\u041e\u0425\u0410\u041d",
      "longitude":103.766212,
      "latitude":53.153561
    },
    "5983":{
      "name":"\u041e\u0421\u0410",
      "longitude":103.877457,
      "latitude":53.388348
    },
    "5984":{
      "name":"\u041d\u041e\u0412\u0410\u042f \u0418\u0413\u0418\u0420\u041c\u0410",
      "longitude":103.936913,
      "latitude":57.136955
    },
    "5985":{
      "name":"\u041c\u0415\u0413\u0415\u0422",
      "longitude":104.057907,
      "latitude":52.420177
    },
    "5986":{
      "name":"\u0411\u041e\u041b\u042c\u0428\u041e\u0419 \u041b\u0423\u0413",
      "longitude":104.091927,
      "latitude":52.077904
    },
    "5987":{
      "name":"\u0428\u0415\u041b\u0415\u0425\u041e\u0412",
      "longitude":104.094986,
      "latitude":52.211098
    },
    "5988":{
      "name":"\u0416\u0415\u041b\u0415\u0417\u041d\u041e\u0413\u041e\u0420\u0421\u041a-\u0418\u041b\u0418\u041c\u0421\u041a\u0418\u0419",
      "longitude":104.12294,
      "latitude":56.577915
    },
    "5989":{
      "name":"\u0411\u0410\u0419\u041a\u0410\u041b\u042c\u0421\u041a",
      "longitude":104.149071,
      "latitude":51.522598
    },
    "5990":{
      "name":"\u041c\u0410\u0420\u041a\u041e\u0412\u0410",
      "longitude":104.205444,
      "latitude":52.213161
    },
    "5991":{
      "name":"\u0423\u0421\u0422\u042c-\u041e\u0420\u0414\u042b\u041d\u0421\u041a\u0418\u0419",
      "longitude":104.745331,
      "latitude":52.80574
    },
    "5992":{
      "name":"\u0416\u0418\u0413\u0410\u041b\u041e\u0412\u041e",
      "longitude":105.15229,
      "latitude":54.812668
    },
    "5993":{
      "name":"\u0411\u0410\u042f\u041d\u0414\u0410\u0419",
      "longitude":105.517876,
      "latitude":53.067226
    },
    "5994":{
      "name":"\u0423\u0421\u0422\u042c-\u041a\u0423\u0422",
      "longitude":105.7464937,
      "latitude":56.7803671
    },
    "5995":{
      "name":"\u041a\u0410\u0427\u0423\u0413",
      "longitude":105.885147,
      "latitude":53.960819
    },
    "5996":{
      "name":"\u0415\u041b\u0410\u041d\u0426\u042b",
      "longitude":106.404564,
      "latitude":52.799557
    },
    "5997":{
      "name":"\u041c\u0410\u0413\u0418\u0421\u0422\u0420\u0410\u041b\u042c\u041d\u042b\u0419",
      "longitude":107.452629,
      "latitude":56.176498
    },
    "5998":{
      "name":"\u041a\u0418\u0420\u0415\u041d\u0421\u041a",
      "longitude":108.116295,
      "latitude":57.776356
    },
    "5999":{
      "name":"\u041c\u0410\u041c\u0410",
      "longitude":112.903419,
      "latitude":58.310555
    },
    "6000":{
      "name":"\u0411\u041e\u0414\u0410\u0419\u0411\u041e",
      "longitude":114.2038284,
      "latitude":57.8500317
    },
    "6001":{
      "name":"\u042f\u0420\u041e\u0412\u041e\u0415",
      "longitude":78.563568,
      "latitude":52.919704
    },
    "6002":{
      "name":"\u0421\u041b\u0410\u0412\u0413\u041e\u0420\u041e\u0414",
      "longitude":78.646251,
      "latitude":52.9892428
    },
    "6003":{
      "name":"\u041a\u0423\u041b\u0423\u041d\u0414\u0410",
      "longitude":78.935448,
      "latitude":52.566559
    },
    "6004":{
      "name":"\u041a\u041b\u042e\u0427\u0418",
      "longitude":79.171432,
      "latitude":52.254906
    },
    "6005":{
      "name":"\u041c\u0418\u0425\u0410\u0419\u041b\u041e\u0412\u0421\u041a\u041e\u0415",
      "longitude":79.7193176,
      "latitude":51.8212486
    },
    "6006":{
      "name":"\u0421\u0422\u0415\u041f\u041d\u041e\u0415 \u041e\u0417\u0415\u0420\u041e",
      "longitude":79.855957,
      "latitude":52.77866
    },
    "6007":{
      "name":"\u0411\u041b\u0410\u0413\u041e\u0412\u0415\u0429\u0415\u041d\u041a\u0410",
      "longitude":79.8705683,
      "latitude":52.830602
    },
    "6008":{
      "name":"\u0420\u041e\u0414\u0418\u041d\u041e",
      "longitude":80.203499,
      "latitude":52.499649
    },
    "6009":{
      "name":"\u041f\u0410\u041d\u041a\u0420\u0423\u0428\u0418\u0425\u0410",
      "longitude":80.3462286,
      "latitude":53.8327381
    },
    "6010":{
      "name":"\u0412\u041e\u041b\u0427\u0418\u0425\u0410",
      "longitude":80.3649718,
      "latitude":52.0171227
    },
    "6011":{
      "name":"\u0411\u0410\u0415\u0412\u041e",
      "longitude":80.773415,
      "latitude":53.274986
    },
    "6012":{
      "name":"\u041d\u041e\u0412\u041e\u0415\u0413\u041e\u0420\u042c\u0415\u0412\u0421\u041a\u041e\u0415",
      "longitude":80.892517,
      "latitude":51.75893
    },
    "6013":{
      "name":"\u0420\u041e\u041c\u0410\u041d\u041e\u0412\u041e",
      "longitude":81.226359,
      "latitude":52.6187229
    },
    "6014":{
      "name":"\u041a\u0410\u041c\u0415\u041d\u042c-\u041d\u0410-\u041e\u0411\u0418",
      "longitude":81.348503,
      "latitude":53.789753
    },
    "6015":{
      "name":"\u041d\u041e\u0412\u0418\u0427\u0418\u0425\u0410",
      "longitude":81.394028,
      "latitude":52.210251
    },
    "6016":{
      "name":"\u0413\u041e\u0420\u041d\u042f\u041a",
      "longitude":81.475204,
      "latitude":50.993965
    },
    "6017":{
      "name":"\u0422\u042e\u041c\u0415\u041d\u0426\u0415\u0412\u041e",
      "longitude":81.497551,
      "latitude":53.319839
    },
    "6018":{
      "name":"\u041c\u0410\u041c\u041e\u041d\u0422\u041e\u0412\u041e",
      "longitude":81.631264,
      "latitude":52.706684
    },
    "6019":{
      "name":"\u041f\u041e\u0421\u041f\u0415\u041b\u0418\u0425\u0410",
      "longitude":81.824982,
      "latitude":51.991352
    },
    "6020":{
      "name":"\u0417\u041c\u0415\u0418\u041d\u041e\u0413\u041e\u0420\u0421\u041a",
      "longitude":82.186234,
      "latitude":51.158436
    },
    "6021":{
      "name":"\u0428\u0418\u041f\u0423\u041d\u041e\u0412\u041e",
      "longitude":82.261627,
      "latitude":52.218868
    },
    "6022":{
      "name":"\u041a\u0423\u0420\u042c\u042f",
      "longitude":82.2887814,
      "latitude":51.6002902
    },
    "6023":{
      "name":"\u041a\u0420\u0410\u0421\u041d\u041e\u0429\u0401\u041a\u041e\u0412\u041e",
      "longitude":82.730652,
      "latitude":51.669357
    },
    "6024":{
      "name":"\u041f\u0410\u0412\u041b\u041e\u0412\u0421\u041a",
      "longitude":82.989059,
      "latitude":53.316284
    },
    "6025":{
      "name":"\u0422\u041e\u041f\u0427\u0418\u0425\u0410",
      "longitude":83.115343,
      "latitude":52.8175669
    },
    "6026":{
      "name":"\u0422\u0410\u041b\u042c\u041c\u0415\u041d\u041a\u0410",
      "longitude":83.55323158247458,
      "latitude":53.81320614277048
    },
    "6027":{
      "name":"\u042e\u0416\u041d\u042b\u0419",
      "longitude":83.693886,
      "latitude":53.254749
    },
    "6028":{
      "name":"\u0421\u0418\u0411\u0418\u0420\u0421\u041a\u0418\u0419",
      "longitude":83.838425,
      "latitude":53.557068
    },
    "6029":{
      "name":"\u041d\u041e\u0412\u041e\u0410\u041b\u0422\u0410\u0419\u0421\u041a",
      "longitude":83.939407,
      "latitude":53.393341
    },
    "6030":{
      "name":"\u041f\u0415\u0422\u0420\u041e\u041f\u0410\u0412\u041b\u041e\u0412\u0421\u041a\u041e\u0415",
      "longitude":84.108116,
      "latitude":52.069763
    },
    "6031":{
      "name":"\u0411\u042b\u0421\u0422\u0420\u042b\u0419 \u0418\u0421\u0422\u041e\u041a",
      "longitude":84.386986,
      "latitude":52.372765
    },
    "6032":{
      "name":"\u0422\u0420\u041e\u0418\u0426\u041a\u041e\u0415",
      "longitude":84.677628,
      "latitude":52.981388
    },
    "6033":{
      "name":"\u0417\u0410\u041b\u0415\u0421\u041e\u0412\u041e",
      "longitude":84.736046,
      "latitude":53.995155
    },
    "6034":{
      "name":"\u0417\u0410\u0420\u0418\u041d\u0421\u041a",
      "longitude":84.926712,
      "latitude":53.703606
    },
    "6035":{
      "name":"\u0411\u0415\u041b\u041e\u041a\u0423\u0420\u0418\u0425\u0410",
      "longitude":84.99321,
      "latitude":51.999195
    },
    "6036":{
      "name":"\u0421\u041c\u041e\u041b\u0415\u041d\u0421\u041a\u041e\u0415",
      "longitude":85.079384,
      "latitude":52.305302
    },
    "6037":{
      "name":"\u0410\u041b\u0422\u0410\u0419\u0421\u041a\u041e\u0415",
      "longitude":85.336746,
      "latitude":51.945145
    },
    "6038":{
      "name":"\u0421\u041e\u0412\u0415\u0422\u0421\u041a\u041e\u0415",
      "longitude":85.409721,
      "latitude":52.282604
    },
    "6039":{
      "name":"\u0426\u0415\u041b\u0418\u041d\u041d\u041e\u0415",
      "longitude":85.661758,
      "latitude":53.078262
    },
    "6040":{
      "name":"\u041a\u0420\u0410\u0421\u041d\u041e\u0413\u041e\u0420\u0421\u041a\u041e\u0415",
      "longitude":86.195274,
      "latitude":52.296341
    },
    "6041":{
      "name":"\u0415\u041b\u042c\u0426\u041e\u0412\u041a\u0410",
      "longitude":86.26545,
      "latitude":53.256676
    },
    "6042":{
      "name":"\u041a\u042b\u0420\u0415\u041d",
      "longitude":102.132912,
      "latitude":51.682404
    },
    "6043":{
      "name":"\u0417\u0410\u041a\u0410\u041c\u0415\u041d\u0421\u041a",
      "longitude":103.291527,
      "latitude":50.377804
    },
    "6044":{
      "name":"\u041f\u0415\u0422\u0420\u041e\u041f\u0410\u0412\u041b\u041e\u0412\u041a\u0410",
      "longitude":105.319412,
      "latitude":50.61087
    },
    "6045":{
      "name":"\u0411\u0410\u0411\u0423\u0428\u041a\u0418\u041d",
      "longitude":105.8635328,
      "latitude":51.7161749
    },
    "6046":{
      "name":"\u041d\u0410\u0423\u0428\u041a\u0418",
      "longitude":106.10303316334138,
      "latitude":50.38860642093917
    },
    "6047":{
      "name":"\u041a\u042f\u0425\u0422\u0410",
      "longitude":106.44915,
      "latitude":50.353176
    },
    "6048":{
      "name":"\u0413\u0423\u0421\u0418\u041d\u041e\u041e\u0417\u0401\u0420\u0421\u041a",
      "longitude":106.527008,
      "latitude":51.289516
    },
    "6049":{
      "name":"\u041a\u0410\u041c\u0415\u041d\u0421\u041a",
      "longitude":106.583969,
      "latitude":51.983513
    },
    "6050":{
      "name":"\u041a\u0410\u0411\u0410\u041d\u0421\u041a",
      "longitude":106.65432,
      "latitude":52.055408
    },
    "6051":{
      "name":"\u0421\u0415\u041b\u0415\u041d\u0413\u0418\u041d\u0421\u041a",
      "longitude":106.867599,
      "latitude":52.007378
    },
    "6052":{
      "name":"\u0418\u0412\u041e\u041b\u0413\u0418\u041d\u0421\u041a",
      "longitude":107.281174,
      "latitude":51.745052
    },
    "6053":{
      "name":"\u0422\u0410\u0420\u0411\u0410\u0413\u0410\u0422\u0410\u0419",
      "longitude":107.357605,
      "latitude":51.48373
    },
    "6054":{
      "name":"\u0411\u0418\u0427\u0423\u0420\u0410",
      "longitude":107.599274,
      "latitude":50.588627
    },
    "6055":{
      "name":"\u0422\u0423\u0420\u0423\u041d\u0422\u0410\u0415\u0412\u041e",
      "longitude":107.635689,
      "latitude":52.201256
    },
    "6056":{
      "name":"\u041c\u0423\u0425\u041e\u0420\u0428\u0418\u0411\u0418\u0420\u042c",
      "longitude":107.828537,
      "latitude":51.046997
    },
    "6057":{
      "name":"\u041e\u041d\u041e\u0425\u041e\u0419",
      "longitude":108.051399,
      "latitude":51.923122
    },
    "6058":{
      "name":"\u0422\u0423\u0420\u041a\u0410",
      "longitude":108.222,
      "latitude":52.950695
    },
    "6059":{
      "name":"\u0417\u0410\u0418\u0413\u0420\u0410\u0415\u0412\u041e",
      "longitude":108.270615,
      "latitude":51.834293
    },
    "6060":{
      "name":"\u0423\u0421\u0422\u042c-\u0411\u0410\u0420\u0413\u0423\u0417\u0418\u041d",
      "longitude":109.032768,
      "latitude":53.40831
    },
    "6061":{
      "name":"\u0421\u0415\u0412\u0415\u0420\u041e\u0411\u0410\u0419\u041a\u0410\u041b\u042c\u0421\u041a",
      "longitude":109.335648,
      "latitude":55.635967
    },
    "6062":{
      "name":"\u041d\u0418\u0416\u041d\u0415\u0410\u041d\u0413\u0410\u0420\u0421\u041a",
      "longitude":109.571762,
      "latitude":55.783573
    },
    "6063":{
      "name":"\u0411\u0410\u0420\u0413\u0423\u0417\u0418\u041d",
      "longitude":109.632744,
      "latitude":53.617638
    },
    "6064":{
      "name":"\u0425\u041e\u0420\u0418\u041d\u0421\u041a",
      "longitude":109.77964,
      "latitude":52.161251
    },
    "6065":{
      "name":"\u041a\u0418\u0416\u0418\u041d\u0413\u0410",
      "longitude":109.913147,
      "latitude":51.84956
    },
    "6066":{
      "name":"\u041a\u0423\u0420\u0423\u041c\u041a\u0410\u041d",
      "longitude":110.323257,
      "latitude":54.326336
    },
    "6067":{
      "name":"\u0421\u041e\u0421\u041d\u041e\u0412\u041e-\u041e\u0417\u0401\u0420\u0421\u041a\u041e\u0415",
      "longitude":111.53992352668712,
      "latitude":52.52346321236894
    },
    "6068":{
      "name":"\u041d\u041e\u0412\u042b\u0419 \u0423\u041e\u042f\u041d",
      "longitude":111.730103,
      "latitude":56.146828
    },
    "6069":{
      "name":"\u0411\u0410\u0413\u0414\u0410\u0420\u0418\u041d",
      "longitude":113.590469,
      "latitude":54.443378
    },
    "6070":{
      "name":"\u0422\u0410\u041a\u0421\u0418\u041c\u041e",
      "longitude":114.837982,
      "latitude":56.355515
    },
    "6071":{
      "name":"\u0410\u041b\u0415\u0419\u0421\u041a",
      "longitude":82.77372868639358,
      "latitude":52.49349394782733
    },
    "6072":{
      "name":"\u0412\u043b\u0430\u0434\u0438\u043c\u0438\u0440\u043e\u0432\u043a\u0430",
      "longitude":84.207543,
      "latitude":51.0481225
    },
    "6073":{
      "name":"\u0421\u0430\u043d\u0430\u0440\u043e\u0432\u043a\u0430",
      "longitude":84.3917584,
      "latitude":51.0660173
    },
    "6074":{
      "name":"\u041a\u0443\u0440\u0434\u044e\u043c",
      "longitude":84.5709274,
      "latitude":50.4007987
    },
    "6075":{
      "name":"\u041a\u0430\u0440\u0430\u043a\u043e\u043b",
      "longitude":84.5811855,
      "latitude":51.2905332
    },
    "6076":{
      "name":"\u0423\u043b\u0443\u0436\u0430\u0439",
      "longitude":84.605212,
      "latitude":50.5468373
    },
    "6077":{
      "name":"\u0412\u0435\u0440\u0445-\u041c\u0443\u0442\u0430",
      "longitude":84.6755847,
      "latitude":51.1943485
    },
    "6078":{
      "name":"\u0421\u043e\u0443\u0437\u0430\u0440",
      "longitude":84.860115,
      "latitude":50.4455779
    },
    "6079":{
      "name":"\u041c\u0430\u0440\u0438\u0438\u043d\u0441\u043a",
      "longitude":84.9642861,
      "latitude":51.4059888
    },
    "6080":{
      "name":"\u0410\u0431\u0430\u0439",
      "longitude":85.055294,
      "latitude":50.433946
    },
    "6081":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u042f\u0431\u043e\u0433\u0430\u043d",
      "longitude":85.2330852,
      "latitude":50.9270464
    },
    "6082":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u044f\u0440\u043a\u0430",
      "longitude":85.2707234,
      "latitude":50.3103763
    },
    "6083":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u044f\u0440\u043a\u0430",
      "longitude":85.2929634,
      "latitude":50.3169886
    },
    "6084":{
      "name":"\u041a\u0443\u043a\u0443\u044f",
      "longitude":85.30198,
      "latitude":51.4593876
    },
    "6085":{
      "name":"\u041c\u043e\u0433\u0443\u0442\u0430",
      "longitude":85.4206984,
      "latitude":51.540112
    },
    "6086":{
      "name":"\u0421\u0438\u043d\u0438\u0439 \u042f\u0440",
      "longitude":85.4435145,
      "latitude":50.3001317
    },
    "6087":{
      "name":"\u041c\u0430\u0440\u0430\u043b\u043e\u0432\u043e\u0434\u043a\u0430",
      "longitude":85.4618614,
      "latitude":50.1172602
    },
    "6088":{
      "name":"\u0412\u043b\u0430\u0441\u044c\u0435\u0432\u043e",
      "longitude":85.514689,
      "latitude":50.2847213
    },
    "6089":{
      "name":"\u0421\u0430\u0445\u0441\u0430\u0431\u0430\u0439",
      "longitude":85.516238,
      "latitude":50.1969672
    },
    "6090":{
      "name":"\u0411\u0430\u0440\u043b\u0430\u043a",
      "longitude":85.5565031,
      "latitude":51.4945224
    },
    "6091":{
      "name":"\u0422\u043e\u043f\u0443\u0447\u0430\u044f",
      "longitude":85.587173,
      "latitude":51.126633
    },
    "6092":{
      "name":"\u0410\u0440\u0431\u0430\u0439\u0442\u0430",
      "longitude":85.6109495,
      "latitude":51.328116
    },
    "6093":{
      "name":"\u041a\u0438\u0441\u043a\u0430",
      "longitude":86.487228,
      "latitude":52.05994
    },
    "6094":{
      "name":"\u041a\u0443\u043c\u0430\u043b\u044b\u0440",
      "longitude":85.6207145,
      "latitude":51.2062536
    },
    "6095":{
      "name":"\u0413\u0430\u0433\u0430\u0440\u043a\u0430",
      "longitude":85.6830486,
      "latitude":50.2288086
    },
    "6096":{
      "name":"\u0418\u0437\u0432\u0435\u0441\u0442\u043a\u043e\u0432\u044b\u0439",
      "longitude":85.728821,
      "latitude":51.75573
    },
    "6097":{
      "name":"\u041a\u0430\u0441\u0442\u0430\u0445\u0442\u0430",
      "longitude":85.736462,
      "latitude":50.3237086
    },
    "6098":{
      "name":"\u041a\u0430\u043c\u0430\u0439",
      "longitude":85.7536533,
      "latitude":51.5069767
    },
    "6099":{
      "name":"\u041a\u0443\u0440\u0443\u043d\u0434\u0430",
      "longitude":85.7652532,
      "latitude":50.3241124
    },
    "6100":{
      "name":"\u0422\u0443\u0440\u0431\u0430\u0437\u0430 \u00ab\u042e\u043d\u043e\u0441\u0442\u044c\u00bb",
      "longitude":85.8001061,
      "latitude":51.8760603
    },
    "6101":{
      "name":"\u0412\u0435\u0440\u0445-\u0410\u043d\u043e\u0441",
      "longitude":85.8199308,
      "latitude":51.4475827
    },
    "6102":{
      "name":"\u041a\u0430\u0440\u044b\u043c",
      "longitude":85.830376,
      "latitude":51.743603
    },
    "6103":{
      "name":"\u041d\u0435\u0444\u0442\u0435\u0431\u0430\u0437\u0430",
      "longitude":85.8325074,
      "latitude":50.85278
    },
    "6104":{
      "name":"\u041c\u0430\u0440\u0430\u043b\u044c\u043d\u0438\u043a 1",
      "longitude":85.8934441,
      "latitude":50.1019742
    },
    "6105":{
      "name":"\u0422\u0443\u0440\u0431\u0430\u0437\u0430 \"\u041a\u0430\u0442\u0443\u043d\u044c\"",
      "longitude":85.909028,
      "latitude":51.54534
    },
    "6106":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0439 \u0423\u0439\u043c\u043e\u043d",
      "longitude":85.9298658,
      "latitude":50.2023886
    },
    "6107":{
      "name":"\u041f\u043e\u043b\u0435\u0432\u043e\u0434\u043a\u0430",
      "longitude":85.9942581,
      "latitude":50.2282213
    },
    "6108":{
      "name":"\u041c\u0430\u0440\u0433\u0430\u043b\u0430",
      "longitude":86.0014486,
      "latitude":50.2570346
    },
    "6109":{
      "name":"\u0410\u043a-\u041a\u043e\u0431\u0430",
      "longitude":86.022215,
      "latitude":50.1618664
    },
    "6110":{
      "name":"\u041c\u0430\u0440\u0430\u043b\u044c\u043d\u0438\u043a 2",
      "longitude":86.0454774,
      "latitude":50.222005
    },
    "6111":{
      "name":"\u0423\u043b\u0430\u043b\u0443\u0448\u043a\u0430",
      "longitude":86.079437,
      "latitude":51.941471
    },
    "6112":{
      "name":"\u041a\u0443\u0442\u0430\u0448",
      "longitude":86.1067766,
      "latitude":51.8759471
    },
    "6113":{
      "name":"\u0423\u043e\u0436\u0430\u043d",
      "longitude":86.1482109,
      "latitude":51.32174
    },
    "6114":{
      "name":"\u0421\u0440\u0435\u0434\u043d\u0438\u0439 \u0421\u0430\u0439\u0434\u044b\u0441",
      "longitude":86.1523653,
      "latitude":51.7634912
    },
    "6115":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u0421\u0430\u0439\u0434\u044b\u0441",
      "longitude":86.2029697,
      "latitude":51.7636832
    },
    "6116":{
      "name":"\u0423\u0440\u043b\u0443-\u0410\u0441\u043f\u0430\u043a",
      "longitude":86.210564,
      "latitude":51.686428
    },
    "6117":{
      "name":"\u0423\u043b\u0438\u0442\u0430",
      "longitude":86.2120155,
      "latitude":50.7107956
    },
    "6118":{
      "name":"\u041a\u0430\u0440\u0430\u043a\u043e\u043b",
      "longitude":86.247406,
      "latitude":51.457432
    },
    "6119":{
      "name":"\u0421\u0430\u043b\u0433\u0430\u043d\u0434\u0430",
      "longitude":86.3221929,
      "latitude":51.853461
    },
    "6120":{
      "name":"\u041a\u0430\u0440\u0430-\u0422\u043e\u0440\u0431\u043e\u043a",
      "longitude":86.3423488,
      "latitude":51.8037834
    },
    "6121":{
      "name":"\u041a\u0430\u044f\u043d\u0447\u0430",
      "longitude":86.4216509,
      "latitude":50.812738
    },
    "6122":{
      "name":"\u0422\u0443\u043d\u044c\u0436\u0430",
      "longitude":86.4634131,
      "latitude":52.0081419
    },
    "6123":{
      "name":"\u0413\u0443\u0441\u0435\u0432\u043a\u0430",
      "longitude":86.5371024,
      "latitude":52.0224955
    },
    "6124":{
      "name":"\u0411\u0438\u0436\u0435\u043b\u044c\u0431\u0438\u043a",
      "longitude":86.5590799,
      "latitude":51.6256432
    },
    "6125":{
      "name":"\u041c\u0430\u043b\u044b\u0439 \u042f\u043b\u043e\u043c\u0430\u043d",
      "longitude":86.5763746,
      "latitude":50.4988477
    },
    "6126":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u044c\u0441\u043a\u043e\u0435",
      "longitude":86.6003674,
      "latitude":51.7816078
    },
    "6127":{
      "name":"\u0421\u043e\u0432\u0435\u0442\u0441\u043a\u043e\u0435",
      "longitude":86.615822,
      "latitude":52.034634
    },
    "6128":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u0418\u043d\u044f",
      "longitude":86.6675238,
      "latitude":50.4522613
    },
    "6129":{
      "name":"\u0418\u0448\u0438\u043d\u0441\u043a",
      "longitude":86.6722707,
      "latitude":52.0309842
    },
    "6130":{
      "name":"\u0427\u0443\u0439\u043e\u0437\u044b",
      "longitude":86.7042027,
      "latitude":50.4067022
    },
    "6131":{
      "name":"\u041a\u0443\u0437\u044f",
      "longitude":86.7218501,
      "latitude":51.760492
    },
    "6132":{
      "name":"\u041a\u0430\u043d\u0430\u0447\u0430\u043a",
      "longitude":86.7263845,
      "latitude":52.4565328
    },
    "6133":{
      "name":"\u041f\u0440\u0438\u044e\u0442 \u00ab\u0410\u043b\u044c\u0431\u0430\u0433\u0430\u043d\u00bb",
      "longitude":86.7979398,
      "latitude":51.420006
    },
    "6134":{
      "name":"\u0428\u0443\u043d\u0430\u0440\u0430\u043a",
      "longitude":86.8125065,
      "latitude":52.4569493
    },
    "6135":{
      "name":"\u0414\u0430\u0439\u0431\u043e\u0432\u043e",
      "longitude":86.9016374,
      "latitude":52.3738718
    },
    "6136":{
      "name":"\u0423\u0434\u0430\u043b\u043e\u0432\u043a\u0430",
      "longitude":86.9438431,
      "latitude":52.3546698
    },
    "6137":{
      "name":"\u0423\u0441\u0442\u044c-\u041b\u0435\u0431\u0435\u0434\u044c",
      "longitude":87.0284297,
      "latitude":52.2805161
    },
    "6138":{
      "name":"\u0410\u043a\u0431\u043e\u043c",
      "longitude":87.0319948,
      "latitude":50.3705012
    },
    "6139":{
      "name":"\u0411\u0435\u043b\u044b\u0439 \u0411\u043e\u043c",
      "longitude":87.0377744,
      "latitude":50.3676723
    },
    "6140":{
      "name":"\u0421\u044e\u0440\u044f",
      "longitude":87.051527,
      "latitude":51.900651
    },
    "6141":{
      "name":"\u0410\u0440\u043a\u044b\u0442",
      "longitude":87.0558572,
      "latitude":49.8620325
    },
    "6142":{
      "name":"\u041e\u0433\u043d\u0438",
      "longitude":87.0771525,
      "latitude":52.1301522
    },
    "6143":{
      "name":"\u0421\u0430\u043d\u044c\u043a\u0438\u043d \u0410\u0438\u043b",
      "longitude":87.104103,
      "latitude":52.187553
    },
    "6144":{
      "name":"\u041b\u0435\u0431\u0435\u0434\u0441\u043a\u043e\u0435",
      "longitude":87.115508,
      "latitude":52.2988835
    },
    "6145":{
      "name":"\u0422\u0443\u043b\u043e\u0439",
      "longitude":87.12291,
      "latitude":52.004948
    },
    "6146":{
      "name":"\u0421\u0442\u0430\u0440\u044b\u0439 \u041a\u0435\u0431\u0435\u0437\u0435\u043d\u044c",
      "longitude":87.1255813,
      "latitude":51.9128738
    },
    "6147":{
      "name":"\u0421\u0442\u0440\u0435\u0442\u0438\u043d\u043a\u0430",
      "longitude":87.2364639,
      "latitude":52.2508996
    },
    "6148":{
      "name":"\u0421\u043e\u0432\u0435\u0442\u0441\u043a\u0438\u0439 \u0411\u0430\u0439\u0433\u043e\u043b",
      "longitude":87.4427856,
      "latitude":52.2061453
    },
    "6149":{
      "name":"\u0410\u043a-\u0410\u043b\u0430\u0445\u0438\u043d\u0441\u043a\u0430\u044f \u0437\u0430\u0441\u0442\u0430\u0432\u0430",
      "longitude":87.488345,
      "latitude":49.2719567
    },
    "6150":{
      "name":"\u0427\u0443\u0439\u043a\u0430",
      "longitude":87.5092008,
      "latitude":51.9688843
    },
    "6151":{
      "name":"\u0418\u0442\u043a\u0443\u0447",
      "longitude":87.5308,
      "latitude":52.090164
    },
    "6152":{
      "name":"\u042f\u0439\u043b\u044e",
      "longitude":87.6068427,
      "latitude":51.7704618
    },
    "6153":{
      "name":"\u0411\u0438\u0439\u043a\u0430",
      "longitude":87.65784,
      "latitude":51.9275918
    },
    "6154":{
      "name":"\u0421\u0443\u0440\u0430\u043d\u0430\u0448",
      "longitude":87.7592838,
      "latitude":52.290952
    },
    "6155":{
      "name":"\u041a\u043e\u043a-\u041f\u0430\u0448",
      "longitude":87.7665863,
      "latitude":51.1829991
    },
    "6156":{
      "name":"\u0411\u0435\u043b\u0435",
      "longitude":87.7964299,
      "latitude":51.4199827
    },
    "6157":{
      "name":"\u041a\u0430\u0440\u0430-\u041a\u0443\u0434\u044e\u0440",
      "longitude":87.828419,
      "latitude":50.6692899
    },
    "6158":{
      "name":"\u041a\u043e\u043e",
      "longitude":87.8967958,
      "latitude":51.0995575
    },
    "6159":{
      "name":"\u0422\u0451\u043f\u043b\u044b\u0439 \u041a\u043b\u044e\u0447",
      "longitude":88.0537572,
      "latitude":49.4587445
    },
    "6160":{
      "name":"\u0422\u0430\u043b\u043e\u043d",
      "longitude":88.3632036,
      "latitude":52.3400971
    },
    "6161":{
      "name":"\u0427\u043e\u0434\u0440\u043e",
      "longitude":88.5355959,
      "latitude":50.8292563
    },
    "6162":{
      "name":"\u0410\u043a\u0442\u0430\u043b",
      "longitude":88.8693558,
      "latitude":49.9216378
    },
    "6163":{
      "name":"\u0423\u0437\u0443\u043d\u0442\u0430\u043b",
      "longitude":89.1026822,
      "latitude":49.9921542
    },
    "6164":{
      "name":"\u043f\u043e\u043b\u044f\u0440\u043d\u0430\u044f \u0441\u0442\u0430\u043d\u0446\u0438\u044f \u0412\u0438\u0437\u0435",
      "longitude":77.018227,
      "latitude":79.4886179
    },
    "6165":{
      "name":"\u0421\u043e\u0441\u043d\u043e\u0432\u0430\u044f",
      "longitude":78.6283438,
      "latitude":72.3647613
    },
    "6166":{
      "name":"\u041b\u0435\u0441\u043a\u0438\u043d\u043e",
      "longitude":79.5,
      "latitude":72.316667
    },
    "6167":{
      "name":"\u041c\u043e\u043d\u043e\u0443\u0447\u0438",
      "longitude":80.6668738,
      "latitude":71.4976695
    },
    "6168":{
      "name":"\u042f\u0440-\u041f\u0430\u043d-\u0422\u044b-\u042f",
      "longitude":80.833333,
      "latitude":70.166667
    },
    "6169":{
      "name":"\u0420\u0430\u0433\u043e\u0437\u0438\u043d\u043a\u0430",
      "longitude":80.833333,
      "latitude":72.7
    },
    "6170":{
      "name":"\u0417\u044b\u0440\u044f\u043d\u043a\u0430",
      "longitude":81.3448144,
      "latitude":72.3508982
    },
    "6171":{
      "name":"\u0414\u0435\u0440\u044f\u0431\u0438\u043d\u043e",
      "longitude":82.3223539,
      "latitude":70.6927412
    },
    "6172":{
      "name":"\u041c\u0435\u0441\u0441\u043e\u044f\u0445\u0430",
      "longitude":82.4882521,
      "latitude":69.1290921
    },
    "6173":{
      "name":"\u041f\u043e\u043b\u0438\u043a\u0430\u0440\u043f\u043e\u0432\u0441\u043a",
      "longitude":82.670733,
      "latitude":70.4059221
    },
    "6174":{
      "name":"\u041c\u0438\u0440\u043e\u043d\u043e\u0432\u0441\u043a\u0430\u044f",
      "longitude":82.6763774,
      "latitude":71.9217006
    },
    "6175":{
      "name":"\u0421\u043e\u043f\u043a\u0430\u0440\u0433\u0430",
      "longitude":82.6897219,
      "latitude":71.885833
    },
    "6176":{
      "name":"\u042f\u043a\u043e\u0432\u043b\u0435\u0432\u043a\u0430",
      "longitude":83.350625,
      "latitude":71.03722
    },
    "6177":{
      "name":"\u0412\u043e\u0440\u043e\u043d\u0446\u043e\u0432\u043e",
      "longitude":83.562149,
      "latitude":71.697632
    },
    "6178":{
      "name":"\u0411\u0430\u0439\u043a\u0430\u043b\u043e\u0432\u0441\u043a",
      "longitude":83.622917,
      "latitude":70.694962
    },
    "6179":{
      "name":"\u0412\u0430\u043d\u043a\u043e\u0440",
      "longitude":83.6381227,
      "latitude":67.8079514
    },
    "6180":{
      "name":"\u0421\u043e\u0432\u0435\u0442\u0441\u043a\u0430\u044f \u0420\u0435\u0447\u043a\u0430",
      "longitude":83.716108,
      "latitude":66.7451224
    },
    "6181":{
      "name":"\u041c\u0443\u043d\u0433\u0443\u0439",
      "longitude":83.768608,
      "latitude":70.431259
    },
    "6182":{
      "name":"\u041a\u0430\u0437\u0430\u043d\u0446\u0435\u0432\u043e",
      "longitude":83.771301,
      "latitude":69.83802
    },
    "6183":{
      "name":"\u042f\u043d\u043e\u0432 \u0421\u0442\u0430\u043d",
      "longitude":84.325371,
      "latitude":65.978188
    },
    "6184":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u044f\u044f \u0411\u0430\u0438\u0445\u0430",
      "longitude":84.8666669,
      "latitude":65.6
    },
    "6185":{
      "name":"\u041c\u0430\u043a\u0430\u0440\u043e\u0432\u0430",
      "longitude":85.1331828,
      "latitude":73.7043414
    },
    "6186":{
      "name":"\u041c\u0430\u043a\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":85.502915,
      "latitude":66.8823484
    },
    "6187":{
      "name":"\u041c\u0430\u0442\u044b\u043b\u044c\u043a\u0430",
      "longitude":85.75,
      "latitude":63.366667
    },
    "6188":{
      "name":"\u0424\u0430\u043a\u0442\u043e\u0440\u0438\u044f \u041d\u0430\u043b\u0438\u043c\u044c\u0435",
      "longitude":85.7752428,
      "latitude":63.840465
    },
    "6189":{
      "name":"\u041b\u0435\u0432\u0438\u043d\u0441\u043a\u0438\u0435 \u041f\u0435\u0441\u043a\u0438",
      "longitude":86.007385,
      "latitude":69.469955
    },
    "6190":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u044c\u0441\u043a",
      "longitude":86.1171287,
      "latitude":69.0189249
    },
    "6191":{
      "name":"\u0415\u0440\u043c\u0430\u043a\u043e\u0432\u043e",
      "longitude":86.189491,
      "latitude":66.585167
    },
    "6192":{
      "name":"\u041f\u043b\u0430\u0445\u0438\u043d\u043e",
      "longitude":86.4106246,
      "latitude":67.9353935
    },
    "6193":{
      "name":"\u0410\u0433\u0430\u043f\u0438\u0442\u043e\u0432\u043e",
      "longitude":86.45,
      "latitude":68.033333
    },
    "6194":{
      "name":"\u041a\u043e\u043d\u0434\u044b\u043b\u044c",
      "longitude":86.583333,
      "latitude":64.666667
    },
    "6195":{
      "name":"\u0425\u0430\u043d\u0442\u0430\u0439\u043a\u0430",
      "longitude":86.6231273,
      "latitude":68.2623341
    },
    "6196":{
      "name":"\u041f\u0443\u0440\u0430",
      "longitude":86.6872649,
      "latitude":73.1492856
    },
    "6197":{
      "name":"\u041d\u0438\u0436\u043d\u044f\u044f \u0411\u0430\u0438\u0445\u0430",
      "longitude":86.7,
      "latitude":64.716667
    },
    "6198":{
      "name":"\u041a\u0430\u0440\u0430\u0441\u0438\u043d\u043e",
      "longitude":86.7107345,
      "latitude":66.8842589
    },
    "6199":{
      "name":"\u041c\u044b\u0441 \u0412\u0445\u043e\u0434\u043d\u043e\u0439",
      "longitude":86.7455639,
      "latitude":73.8332603
    },
    "6200":{
      "name":"\u0421\u0438\u0433\u043e\u0432\u043e",
      "longitude":87.054173,
      "latitude":62.7293394
    },
    "6201":{
      "name":"\u041a\u0443\u0440\u0435\u0439\u043a\u0430",
      "longitude":87.1715206,
      "latitude":66.4668701
    },
    "6202":{
      "name":"\u0410\u043d\u0433\u0443\u0442\u0438\u0445\u0430",
      "longitude":87.236191,
      "latitude":66.117599
    },
    "6203":{
      "name":"\u041a\u0430\u043d\u0433\u043e\u0442\u043e\u0432\u043e",
      "longitude":87.2822415,
      "latitude":63.4328263
    },
    "6204":{
      "name":"\u0421\u0443\u0440\u0433\u0443\u0442\u0438\u0445\u0430",
      "longitude":87.343086,
      "latitude":63.850521
    },
    "6205":{
      "name":"\u0413\u043e\u0440\u043e\u0448\u0438\u0445\u0430",
      "longitude":87.5046351,
      "latitude":66.3944162
    },
    "6206":{
      "name":"\u0411\u0440\u0443\u0441\u043e\u0432\u043e",
      "longitude":87.5254773,
      "latitude":60.5833658
    },
    "6207":{
      "name":"\u0411\u0430\u043a\u043b\u0430\u043d\u0438\u0445\u0430",
      "longitude":87.5478102,
      "latitude":64.4452077
    },
    "6208":{
      "name":"\u0412\u0435\u0440\u0435\u0449\u0430\u0433\u0438\u043d\u043e",
      "longitude":87.5747825,
      "latitude":64.2390089
    },
    "6209":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u0442\u0443\u0440\u0443\u0445\u0430\u043d\u0441\u043a",
      "longitude":87.575241,
      "latitude":65.914963
    },
    "6210":{
      "name":"\u0410\u043b\u0438\u043d\u0441\u043a\u043e\u0435",
      "longitude":87.6046181,
      "latitude":63.301299
    },
    "6211":{
      "name":"\u0421\u0435\u043b\u0438\u0432\u0430\u043d\u0438\u0445\u0430",
      "longitude":87.8769,
      "latitude":65.865379
    },
    "6212":{
      "name":"\u041e\u0431\u044a\u0435\u0434\u0438\u043d\u0451\u043d\u043d\u044b\u0439",
      "longitude":87.9161051,
      "latitude":63.1063177
    },
    "6213":{
      "name":"\u041a\u043e\u0441\u0442\u0438\u043d\u043e",
      "longitude":87.9792056,
      "latitude":65.3227606
    },
    "6214":{
      "name":"\u0421\u0442\u0430\u043d\u043e\u0432\u0438\u0449\u0435 \u0412\u0435\u0434\u0435\u043d\u0441\u043a\u043e\u0435",
      "longitude":88.3999999,
      "latitude":70.1
    },
    "6215":{
      "name":"\u0410\u0439\u0434\u0430\u0440\u0430",
      "longitude":88.4038577,
      "latitude":58.5272946
    },
    "6216":{
      "name":"\u041c\u0430\u0434\u0443\u0439\u043a\u0430",
      "longitude":88.4297519,
      "latitude":66.64955
    },
    "6217":{
      "name":"\u0427\u0443\u043b\u043a\u043e\u0432\u043e",
      "longitude":88.4392355,
      "latitude":62.7734764
    },
    "6218":{
      "name":"\u041a\u0443\u0440\u044c\u044f",
      "longitude":88.55,
      "latitude":70.25
    },
    "6219":{
      "name":"\u041a\u0438\u0440\u0433\u0438\u0441\u0443\u043b\u044c",
      "longitude":88.583824,
      "latitude":55.390541
    },
    "6220":{
      "name":"\u042e\u0444\u0435\u0440\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":88.656441,
      "latitude":55.293358
    },
    "6221":{
      "name":"\u0415\u0434\u0435\u0442",
      "longitude":88.70166,
      "latitude":55.522533
    },
    "6222":{
      "name":"\u0420\u0443\u0431\u0438\u043d\u043e",
      "longitude":88.737961,
      "latitude":57.129593
    },
    "6223":{
      "name":"\u0418\u0437\u043e\u0442\u043e\u0432\u043e",
      "longitude":88.76973,
      "latitude":56.670399
    },
    "6224":{
      "name":"\u0427\u0435\u0440\u043a\u0430\u0441\u0441\u043a",
      "longitude":88.861946,
      "latitude":57.122189
    },
    "6225":{
      "name":"\u0421\u043e\u0440\u043e\u043a\u0438\u043d\u043e",
      "longitude":88.863472,
      "latitude":55.515175
    },
    "6226":{
      "name":"\u0417\u0430\u043e\u0441\u0442\u0440\u043e\u0432\u043a\u0430",
      "longitude":88.8668823,
      "latitude":70.5004551
    },
    "6227":{
      "name":"\u0411\u0430\u0437\u044b\u0440",
      "longitude":88.951172,
      "latitude":55.410969
    },
    "6228":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":88.954018,
      "latitude":56.692223
    },
    "6229":{
      "name":"\u0427\u0451\u0440\u043d\u0430\u044f",
      "longitude":88.9681031,
      "latitude":70.5171939
    },
    "6230":{
      "name":"\u0411\u0430\u0445\u0442\u0430",
      "longitude":89.003975,
      "latitude":62.464687
    },
    "6231":{
      "name":"\u0421\u0443\u0445\u0430\u043d\u043e\u0432\u043e",
      "longitude":89.0121859,
      "latitude":58.3606259
    },
    "6232":{
      "name":"\u041c\u0438\u0440\u043d\u043e\u0435",
      "longitude":89.015572,
      "latitude":62.297314
    },
    "6233":{
      "name":"\u0421\u0435\u0432\u0435\u0440\u043d\u0430\u044f \u0420\u0435\u0447\u043a\u0430",
      "longitude":89.0666669,
      "latitude":65.933333
    },
    "6234":{
      "name":"\u041f\u043e\u0442\u0430\u043d\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":89.0712517,
      "latitude":59.3635008
    },
    "6235":{
      "name":"\u041b\u0438\u043d\u0435\u0432\u043e",
      "longitude":89.0850874,
      "latitude":55.3843983
    },
    "6236":{
      "name":"\u0421\u043f\u043b\u0430\u0432\u043d\u043e\u0439",
      "longitude":89.086296,
      "latitude":57.008183
    },
    "6237":{
      "name":"\u041b\u0443\u0433\u043e\u0432\u0430\u0442\u043a\u0430",
      "longitude":89.0960628,
      "latitude":59.08965
    },
    "6238":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":89.09716,
      "latitude":56.568264
    },
    "6239":{
      "name":"\u0423\u0441\u0442\u044c-\u041f\u0430\u0440\u043d\u0430\u044f",
      "longitude":89.132088,
      "latitude":55.410786
    },
    "6240":{
      "name":"\u0412\u043e\u043b\u044b\u043d\u043a\u0430",
      "longitude":89.157761,
      "latitude":56.3713
    },
    "6241":{
      "name":"\u0420\u043e\u043c\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":89.158012,
      "latitude":56.437157
    },
    "6242":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u044c\u0441\u043a",
      "longitude":89.160515,
      "latitude":55.696865
    },
    "6243":{
      "name":"\u041e\u0441\u043a\u0430\u0440\u043e\u0432\u043a\u0430",
      "longitude":89.175179,
      "latitude":56.432411
    },
    "6244":{
      "name":"\u041b\u0435\u0431\u0435\u0434\u044c",
      "longitude":89.184847,
      "latitude":62.0900233
    },
    "6245":{
      "name":"\u0423\u0441\u0442\u044c-\u0422\u043e\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":89.187943,
      "latitude":56.680962
    },
    "6246":{
      "name":"\u0422\u0443\u0437\u043b\u0443\u043a\u043e\u0432\u043a\u0430",
      "longitude":89.1968,
      "latitude":56.201591
    },
    "6247":{
      "name":"\u0414\u043c\u0438\u0442\u0440\u0438\u0435\u0432\u043a\u0430",
      "longitude":89.215904,
      "latitude":56.181992
    },
    "6248":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u043a\u0430",
      "longitude":89.217407,
      "latitude":56.390244
    },
    "6249":{
      "name":"\u041a\u043e\u0441\u044b\u0435 \u041b\u043e\u0436\u043a\u0438",
      "longitude":89.218155,
      "latitude":55.377697
    },
    "6250":{
      "name":"\u0421\u043a\u0432\u043e\u0440\u0446\u043e\u0432\u043e",
      "longitude":89.218193,
      "latitude":55.632961
    },
    "6251":{
      "name":"\u0421\u043e\u043b\u043e\u0432\u044c\u0451\u0432\u043a\u0430",
      "longitude":89.226501,
      "latitude":56.575649
    },
    "6252":{
      "name":"\u0421\u0430\u0440\u0442\u0430\u0447\u0443\u043b\u044c",
      "longitude":89.22718,
      "latitude":55.252319
    },
    "6253":{
      "name":"\u0411\u0435\u043b\u043e\u0433\u043e\u0440\u043a\u0430",
      "longitude":89.227203,
      "latitude":56.710186
    },
    "6254":{
      "name":"\u0423\u0441\u0442\u044c-\u0427\u0443\u043b\u044c\u0441\u043a",
      "longitude":89.233955,
      "latitude":57.27644
    },
    "6255":{
      "name":"\u041f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":89.241714,
      "latitude":56.538124
    },
    "6256":{
      "name":"\u041b\u0435\u0431\u0435\u0434\u0435\u0432\u043a\u0430",
      "longitude":89.248993,
      "latitude":56.275288
    },
    "6257":{
      "name":"\u0410\u0433\u0430\u043f\u0430",
      "longitude":89.25,
      "latitude":71.45
    },
    "6258":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u0441\u043a\u0438\u0439 \u0428\u043b\u044e\u0437",
      "longitude":89.2898685,
      "latitude":59.4297436
    },
    "6259":{
      "name":"\u041a\u043e\u043b\u043e\u043a\u043e\u043b\u044c\u043d\u044b\u0439 \u042f\u0440",
      "longitude":89.297103,
      "latitude":60.948485
    },
    "6260":{
      "name":"\u041b\u044c\u0432\u043e\u0432\u043a\u0430",
      "longitude":89.297218,
      "latitude":56.219959
    },
    "6261":{
      "name":"\u041f\u0443\u0437\u0430\u043d\u043e\u0432\u043e",
      "longitude":89.312782,
      "latitude":56.429058
    },
    "6262":{
      "name":"\u041f\u0430\u0441\u0435\u0447\u043d\u043e\u0435",
      "longitude":89.314064,
      "latitude":57.436478
    },
    "6263":{
      "name":"\u0425\u043e\u0445\u043b\u043e\u0432\u043a\u0430",
      "longitude":89.316452,
      "latitude":56.594463
    },
    "6264":{
      "name":"\u042f\u043a\u0448\u0430",
      "longitude":89.3275194,
      "latitude":59.0436617
    },
    "6265":{
      "name":"\u041a\u043e\u043c\u0441\u0430",
      "longitude":89.3332206,
      "latitude":61.841454
    },
    "6266":{
      "name":"\u0420\u043e\u0441\u0438\u043d\u043a\u0430",
      "longitude":89.338181,
      "latitude":55.691448
    },
    "6267":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u041a\u043e\u0441\u0443\u043b\u044c",
      "longitude":89.339592,
      "latitude":56.084087
    },
    "6268":{
      "name":"\u0413\u0435\u043e\u0440\u0433\u0438\u0435\u0432\u043a\u0430",
      "longitude":89.348022,
      "latitude":56.393684
    },
    "6269":{
      "name":"\u0415\u0440\u0448\u043e\u0432\u043e",
      "longitude":89.392662,
      "latitude":55.947575
    },
    "6270":{
      "name":"\u0411\u0435\u0437\u0440\u0443\u0447\u0435\u0439\u043a\u0430",
      "longitude":89.414299,
      "latitude":56.607788
    },
    "6271":{
      "name":"\u041a\u043e\u0441\u043e\u043d\u0433\u043e\u043b\u044c",
      "longitude":89.424019,
      "latitude":55.635288
    },
    "6272":{
      "name":"\u0428\u0443\u0448\u044c",
      "longitude":89.424835,
      "latitude":55.670078
    },
    "6273":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":89.447495,
      "latitude":56.302322
    },
    "6274":{
      "name":"\u0412\u0438\u0448\u043d\u044f\u043a\u043e\u0432\u043e-\u041a\u0430\u0442\u0435\u044e\u043b",
      "longitude":89.457848,
      "latitude":56.308685
    },
    "6275":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":89.45842,
      "latitude":56.511295
    },
    "6276":{
      "name":"\u0418\u043d\u0434\u044b\u0433\u0438\u043d\u043e",
      "longitude":89.4698283,
      "latitude":61.1156189
    },
    "6277":{
      "name":"\u041b\u043e\u0441\u0438\u043d\u043e\u0431\u043e\u0440\u0441\u043a\u043e\u0435",
      "longitude":89.4704499,
      "latitude":58.4570087
    },
    "6278":{
      "name":"\u041b\u0430\u0440\u043d\u0435\u0432\u043a\u0430",
      "longitude":89.48674,
      "latitude":56.521336
    },
    "6279":{
      "name":"\u0427\u0438\u0441\u0442\u044b\u0439 \u0420\u0443\u0447\u0435\u0439",
      "longitude":89.50029,
      "latitude":56.635063
    },
    "6280":{
      "name":"\u0413\u043b\u0438\u043d\u043a\u0430",
      "longitude":89.522835,
      "latitude":55.769402
    },
    "6281":{
      "name":"\u0441\u0442\u0430\u043d\u0446\u0438\u044f \u0411\u0435\u043b\u043e\u043e\u0437\u0451\u0440\u043a\u0430",
      "longitude":89.5398874,
      "latitude":55.6964897
    },
    "6282":{
      "name":"\u0412\u0430\u0441\u0438\u043b\u044c\u0435\u0432\u043a\u0430",
      "longitude":89.553261,
      "latitude":56.52467
    },
    "6283":{
      "name":"\u0411\u043e\u0433\u043e\u0442\u043e\u043b\u044c\u0441\u043a\u0438\u0439 \u0417\u0430\u0432\u043e\u0434",
      "longitude":89.560219,
      "latitude":56.120888
    },
    "6284":{
      "name":"\u041c\u043e\u0436\u0430\u0440\u044b",
      "longitude":89.589012,
      "latitude":55.503826
    },
    "6285":{
      "name":"\u0428\u0443\u043b\u0434\u0430\u0442",
      "longitude":89.595734,
      "latitude":56.383949
    },
    "6286":{
      "name":"\u0418\u043c\u0430\u043d\u0433\u0434\u0430 \u0420\u0443\u0434\u043d\u0430\u044f",
      "longitude":89.607,
      "latitude":69.1062
    },
    "6287":{
      "name":"\u0413\u0443\u0434\u043a\u043e\u0432\u043e",
      "longitude":89.610802,
      "latitude":55.893585
    },
    "6288":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u0435 \u041e\u0437\u0435\u0440\u043e",
      "longitude":89.618881,
      "latitude":55.343021
    },
    "6289":{
      "name":"\u041b\u043e\u0437\u043d\u044f\u043a\u0438",
      "longitude":89.622231,
      "latitude":56.252655
    },
    "6290":{
      "name":"\u041a\u0440\u0443\u0442\u043e\u044f\u0440\u0441\u043a\u0438\u0439",
      "longitude":89.624985,
      "latitude":55.722755
    },
    "6291":{
      "name":"\u041a\u043e\u0440\u043d\u0438\u043b\u043e\u0432\u043e",
      "longitude":89.639183,
      "latitude":55.560318
    },
    "6292":{
      "name":"\u0411\u0430\u0438\u0442",
      "longitude":89.642395,
      "latitude":55.426765
    },
    "6293":{
      "name":"\u0411\u0443\u043b\u0430\u0442\u043e\u0432\u043e",
      "longitude":89.649681,
      "latitude":56.417549
    },
    "6294":{
      "name":"\u0428\u0443\u043b\u0434\u0430\u0442",
      "longitude":89.654091,
      "latitude":56.236656
    },
    "6295":{
      "name":"\u041a\u0443\u043b\u0438\u043a\u043e\u0432\u043a\u0430",
      "longitude":89.656334,
      "latitude":56.543457
    },
    "6296":{
      "name":"\u041a\u0430\u043c\u044b\u0448\u0442\u0430",
      "longitude":89.672951,
      "latitude":55.052593
    },
    "6297":{
      "name":"\u041a\u0443\u043b\u0438\u0447\u043a\u0430",
      "longitude":89.67691,
      "latitude":55.9902
    },
    "6298":{
      "name":"\u0421\u043e\u043b\u0431\u0430\u0442\u0441\u043a\u0438\u0439",
      "longitude":89.718842,
      "latitude":55.174152
    },
    "6299":{
      "name":"\u0413\u043e\u0440\u0431\u044b",
      "longitude":89.730804,
      "latitude":55.765022
    },
    "6300":{
      "name":"\u041d\u043e\u0432\u043e\u043f\u0435\u0442\u0440\u043e\u0432\u043a\u0430",
      "longitude":89.731277,
      "latitude":56.429729
    },
    "6301":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":89.749756,
      "latitude":55.802021
    },
    "6302":{
      "name":"\u0418\u043a\u043e\u043d",
      "longitude":89.75,
      "latitude":70.416667
    },
    "6303":{
      "name":"\u041a\u043e\u0441\u043e\u0433\u043e\u043b\u044c",
      "longitude":89.750244,
      "latitude":55.569962
    },
    "6304":{
      "name":"\u0421\u0443\u043c\u0430\u0440\u043e\u043a\u043e\u0432\u043e",
      "longitude":89.7522487,
      "latitude":61.6588196
    },
    "6305":{
      "name":"\u041f\u0430\u0432\u043b\u043e\u0432\u043a\u0430",
      "longitude":89.752785,
      "latitude":56.321842
    },
    "6306":{
      "name":"\u0421\u043e\u0441\u043d\u043e\u0432\u043a\u0430",
      "longitude":89.762428,
      "latitude":55.381687
    },
    "6307":{
      "name":"\u0421\u044e\u0442\u0438\u043a",
      "longitude":89.76609,
      "latitude":55.896492
    },
    "6308":{
      "name":"\u0412\u0430\u0433\u0438\u043d\u043e",
      "longitude":89.772102,
      "latitude":56.208103
    },
    "6309":{
      "name":"\u041e\u0440\u0433\u0430",
      "longitude":89.779404,
      "latitude":56.153389
    },
    "6310":{
      "name":"\u041a\u0443\u0442\u0443\u0437\u043e\u0432\u043a\u0430",
      "longitude":89.780479,
      "latitude":55.127594
    },
    "6311":{
      "name":"\u0421\u0443\u0445\u0430\u044f \u0414\u043e\u043b\u0438\u043d\u0430",
      "longitude":89.783333,
      "latitude":55.236187
    },
    "6312":{
      "name":"\u0427\u0438\u043d\u0434\u0430\u0442",
      "longitude":89.785667,
      "latitude":56.557655
    },
    "6313":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u044c\u0441\u043a",
      "longitude":89.788528,
      "latitude":56.550442
    },
    "6314":{
      "name":"\u0418\u043b\u044c\u0438\u043d\u043a\u0430",
      "longitude":89.79953,
      "latitude":56.364883
    },
    "6315":{
      "name":"\u041f\u0442\u0438\u0446\u0435\u0442\u043e\u0432\u0430\u0440\u043d\u043e\u0439 \u0444\u0435\u0440\u043c\u044b",
      "longitude":89.807266,
      "latitude":56.190407
    },
    "6316":{
      "name":"\u0411\u0435\u043b\u0430\u044f \u0420\u043e\u0449\u0430",
      "longitude":89.838203,
      "latitude":55.497066
    },
    "6317":{
      "name":"\u0411\u0435\u0440\u0435\u0437\u043d\u044f\u043a\u0438",
      "longitude":89.8442,
      "latitude":55.7243
    },
    "6318":{
      "name":"\u0420\u0430\u0437\u0433\u0443\u043b\u044f\u0435\u0432\u043a\u0430",
      "longitude":89.845978,
      "latitude":56.271221
    },
    "6319":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u0421\u043e\u043a\u0441\u0430",
      "longitude":89.846268,
      "latitude":55.679012
    },
    "6320":{
      "name":"\u0423\u0447\u0443\u043c",
      "longitude":89.846619,
      "latitude":55.152122
    },
    "6321":{
      "name":"\u041d\u043e\u0432\u043e\u043d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":89.863068,
      "latitude":55.877045
    },
    "6322":{
      "name":"\u0417\u0430\u0445\u0430\u0440\u0438\u043d\u043a\u0430",
      "longitude":89.864639,
      "latitude":56.023869
    },
    "6323":{
      "name":"\u041a\u0440\u0435\u0441\u0442\u044b",
      "longitude":89.866667,
      "latitude":70.75
    },
    "6324":{
      "name":"\u041c\u0430\u0440\u044c\u044f\u0441\u043e\u0432\u043e",
      "longitude":89.879745,
      "latitude":55.450954
    },
    "6325":{
      "name":"\u0413\u043d\u0435\u0442\u043e\u0432\u043e",
      "longitude":89.882271,
      "latitude":56.283981
    },
    "6326":{
      "name":"\u041a\u0430\u0440\u0433\u0430\u043b\u0430",
      "longitude":89.889366,
      "latitude":55.774643
    },
    "6327":{
      "name":"\u0414\u043c\u0438\u0442\u0440\u0438\u0435\u0432\u043a\u0430",
      "longitude":89.913033,
      "latitude":56.389912
    },
    "6328":{
      "name":"\u041e\u0442\u0434\u0435\u043b\u0435\u043d\u0438\u0435 \u0411\u0440\u0438\u0433\u0430\u0434\u044b \u2116 2",
      "longitude":89.924225,
      "latitude":55.516335
    },
    "6329":{
      "name":"\u0411\u043e\u0440",
      "longitude":89.941971,
      "latitude":57.489506
    },
    "6330":{
      "name":"\u0417\u0435\u043b\u0451\u043d\u0430\u044f \u0413\u043e\u0440\u043a\u0430",
      "longitude":89.947655,
      "latitude":55.894279
    },
    "6331":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":89.95295,
      "latitude":55.622517
    },
    "6332":{
      "name":"\u0428\u0438\u043f\u0438\u043b\u043e\u0432\u043a\u0430",
      "longitude":89.976173,
      "latitude":55.77779
    },
    "6333":{
      "name":"\u041a\u043e\u0440\u043e\u0431\u0435\u0439\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":90.00238,
      "latitude":56.3773
    },
    "6334":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u0430\u044f \u0420\u043e\u0449\u0430",
      "longitude":90.016327,
      "latitude":55.722034
    },
    "6335":{
      "name":"\u0421\u0442\u0430\u043d \u0410\u0431\u0430\u0433\u0430\u043b\u0430\u0445",
      "longitude":90.016667,
      "latitude":70.416667
    },
    "6336":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u0421\u043e\u0441\u043d\u043e\u0432\u043a\u0430",
      "longitude":90.033401,
      "latitude":55.678028
    },
    "6337":{
      "name":"\u0410\u043d\u0434\u0440\u043e\u043d\u043e\u0432\u043e",
      "longitude":90.037498,
      "latitude":55.555569
    },
    "6338":{
      "name":"\u041f\u0440\u043e\u0433\u0440\u0435\u0441\u0441",
      "longitude":90.04689,
      "latitude":55.834908
    },
    "6339":{
      "name":"\u0417\u0430\u0440\u044f\u043d\u043a\u0430",
      "longitude":90.057556,
      "latitude":55.894855
    },
    "6340":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u0432\u043a\u0430",
      "longitude":90.060486,
      "latitude":55.84948
    },
    "6341":{
      "name":"\u0421\u043e\u043f\u043a\u0430",
      "longitude":90.065323,
      "latitude":57.469418
    },
    "6342":{
      "name":"\u0421\u043b\u0430\u0431\u0446\u043e\u0432\u043a\u0430",
      "longitude":90.065445,
      "latitude":56.455276
    },
    "6343":{
      "name":"\u041d\u0438\u043a\u0443\u043b\u0438\u043d\u043e",
      "longitude":90.0754254,
      "latitude":60.4074204
    },
    "6344":{
      "name":"\u0417\u0435\u043b\u0435\u043d\u0446\u044b",
      "longitude":90.078438,
      "latitude":56.458763
    },
    "6345":{
      "name":"\u0421\u0443\u0445\u043e\u0440\u0435\u0447\u0435\u043d\u0441\u043a\u0438\u0439",
      "longitude":90.084839,
      "latitude":55.595936
    },
    "6346":{
      "name":"\u0413\u043b\u044f\u0434\u0435\u043d\u044c",
      "longitude":90.089516,
      "latitude":55.721622
    },
    "6347":{
      "name":"\u041a\u0430\u0441\u043e\u0432\u043e",
      "longitude":90.1048202,
      "latitude":59.8000897
    },
    "6348":{
      "name":"\u0421\u0447\u0430\u0441\u0442\u043b\u0438\u0432\u043e\u0435",
      "longitude":90.1113146,
      "latitude":56.5354932
    },
    "6349":{
      "name":"\u041f\u043e\u0434\u043a\u0430\u043c\u0435\u043d\u043d\u0430\u044f \u0422\u0443\u043d\u0433\u0443\u0441\u043a\u0430",
      "longitude":90.130028,
      "latitude":61.599873
    },
    "6350":{
      "name":"\u0421\u0442\u0435\u043f\u043d\u043e\u043e\u0437\u0435\u0440\u043a\u0430",
      "longitude":90.136139,
      "latitude":55.737614
    },
    "6351":{
      "name":"\u041d\u043e\u0432\u043e\u0440\u0430\u043a\u0438\u0442\u043a\u0430",
      "longitude":90.147705,
      "latitude":55.585773
    },
    "6352":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":90.153152,
      "latitude":56.447563
    },
    "6353":{
      "name":"\u0411\u043e\u0433\u0430\u0442\u043e\u0435",
      "longitude":90.157501,
      "latitude":56.5544063
    },
    "6354":{
      "name":"\u041b\u043e\u043f\u0430\u0442\u043a\u0430",
      "longitude":90.167465,
      "latitude":55.322323
    },
    "6355":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u041a\u0443\u0437\u0443\u0440\u0431\u0430",
      "longitude":90.18515,
      "latitude":55.2593
    },
    "6356":{
      "name":"\u041a\u0440\u0435\u0449\u0435\u043d\u043a\u0430",
      "longitude":90.185524,
      "latitude":56.431168
    },
    "6357":{
      "name":"\u0422\u0435\u0440\u0435\u0445\u0442\u0430",
      "longitude":90.195152,
      "latitude":55.431801
    },
    "6358":{
      "name":"\u0413\u043e\u043b\u0443\u0431\u043a\u0438",
      "longitude":90.196167,
      "latitude":55.787117
    },
    "6359":{
      "name":"\u0421\u0435\u0440\u0435\u0436",
      "longitude":90.197723,
      "latitude":55.860466
    },
    "6360":{
      "name":"\u041c\u0435\u043b\u0435\u0446\u043a",
      "longitude":90.20916,
      "latitude":57.418152
    },
    "6361":{
      "name":"\u0427\u0435\u0440\u043d\u043e\u043e\u0437\u0435\u0440\u0441\u043a",
      "longitude":90.213638,
      "latitude":55.183632
    },
    "6362":{
      "name":"\u0423\u0448\u043a\u0430\u043d\u043a\u0430",
      "longitude":90.222672,
      "latitude":55.571255
    },
    "6363":{
      "name":"\u041d\u0430\u0431\u0435\u0440\u0435\u0436\u043d\u0430\u044f",
      "longitude":90.228714,
      "latitude":55.534081
    },
    "6364":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":90.2292051,
      "latitude":57.1075152
    },
    "6365":{
      "name":"\u041c\u0443\u0441\u043b\u0438\u043d\u043a\u0430",
      "longitude":90.233032,
      "latitude":57.166336
    },
    "6366":{
      "name":"\u0411\u0438\u043a\u0442\u0438\u043c\u0438\u0440\u043e\u0432\u043a\u0430",
      "longitude":90.235161,
      "latitude":57.201191
    },
    "6367":{
      "name":"\u0411\u043e\u0440\u0446\u044b",
      "longitude":90.243172,
      "latitude":56.390678
    },
    "6368":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u044f\u044f \u0427\u0443\u043b\u044b\u043c\u043a\u0430",
      "longitude":90.248695,
      "latitude":56.06242
    },
    "6369":{
      "name":"\u0429\u0435\u043b\u0435\u0432\u043e",
      "longitude":90.253639,
      "latitude":57.384087
    },
    "6370":{
      "name":"\u0417\u0435\u0440\u0446\u0430\u043b\u044b",
      "longitude":90.262749,
      "latitude":56.271999
    },
    "6371":{
      "name":"\u0421\u0442\u0430\u043d \u0421\u0430\u043c\u043e\u0435\u0434\u0441\u043a\u0430\u044f \u0420\u0435\u0447\u043a\u0430",
      "longitude":90.2686249,
      "latitude":70.4833811
    },
    "6372":{
      "name":"\u0412\u043e\u0440\u043e\u0436\u0435\u0439\u043a\u0430",
      "longitude":90.2741232,
      "latitude":58.2144775
    },
    "6373":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0439 \u0410\u0434\u0430\u0434\u044b\u043c",
      "longitude":90.287003,
      "latitude":55.917126
    },
    "6374":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u0430\u044f \u0417\u0430\u0440\u044f",
      "longitude":90.2899059,
      "latitude":56.4821279
    },
    "6375":{
      "name":"\u0421\u0430\u0445\u0430\u0440\u043d\u043e\u0435",
      "longitude":90.293709,
      "latitude":56.804871
    },
    "6376":{
      "name":"\u0411\u0443\u0433\u0430\u0440\u0438\u043a\u0442\u0430",
      "longitude":90.313251,
      "latitude":64.9200898
    },
    "6377":{
      "name":"\u0427\u0435\u0440\u0434\u044b\u043d\u044c",
      "longitude":90.326851,
      "latitude":55.870857
    },
    "6378":{
      "name":"\u041a\u0440\u0430\u0435\u0432\u0430\u044f",
      "longitude":90.3311531,
      "latitude":56.5531132
    },
    "6379":{
      "name":"\u0417\u0430\u0432\u043e\u0440\u043a\u0438",
      "longitude":90.332703,
      "latitude":56.118137
    },
    "6380":{
      "name":"\u0427\u0443\u043b\u044b\u043c\u043a\u0430",
      "longitude":90.337898,
      "latitude":56.076283
    },
    "6381":{
      "name":"\u0411\u0435\u043b\u043e\u043f\u043e\u043b\u044c\u0441\u043a",
      "longitude":90.350815,
      "latitude":55.144505
    },
    "6382":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0439 \u0422\u0443\u043d\u0443\u0439",
      "longitude":90.354248,
      "latitude":57.101017
    },
    "6383":{
      "name":"\u041f\u043e\u0434\u043a\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":90.376442,
      "latitude":57.31736
    },
    "6384":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u0433\u043e\u0440\u0441\u043a\u0438\u0439",
      "longitude":90.38031,
      "latitude":55.622471
    },
    "6385":{
      "name":"\u0422\u0430\u0430\u0447\u0435\u043a",
      "longitude":90.394409,
      "latitude":56.844086
    },
    "6386":{
      "name":"\u0423\u043b\u0443\u0439",
      "longitude":90.406914,
      "latitude":56.145401
    },
    "6387":{
      "name":"\u0423\u0441\u0442\u044c-\u0411\u0435\u0440\u0435\u0437\u043e\u0432\u043a\u0430",
      "longitude":90.408696,
      "latitude":55.7929457
    },
    "6388":{
      "name":"\u041f\u0440\u043e\u043c\u0431\u043e\u0440",
      "longitude":90.408745,
      "latitude":57.327839
    },
    "6389":{
      "name":"\u041d\u0430\u0433\u043e\u0440\u043d\u043e\u0432\u043e",
      "longitude":90.416924,
      "latitude":56.40591
    },
    "6390":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u0432\u043a\u0430",
      "longitude":90.4282329,
      "latitude":56.427353
    },
    "6391":{
      "name":"\u041a\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":90.431244,
      "latitude":56.166142
    },
    "6392":{
      "name":"\u041d\u0430\u0433\u043e\u0440\u043d\u043e\u0432\u043e",
      "longitude":90.435936,
      "latitude":56.28368
    },
    "6393":{
      "name":"\u041a\u0430\u0440\u0430\u0431\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":90.4396083,
      "latitude":56.750154
    },
    "6394":{
      "name":"\u041a\u0443\u0440\u0431\u0430\u0442\u043e\u0432\u043e",
      "longitude":90.442276,
      "latitude":56.352295
    },
    "6395":{
      "name":"\u041f\u0430\u0440\u0438\u043b\u043e\u0432\u043e",
      "longitude":90.445198,
      "latitude":55.157791
    },
    "6396":{
      "name":"\u0421\u043e\u0441\u043d\u043e\u0432\u043e\u0435 \u041e\u0437\u0435\u0440\u043e",
      "longitude":90.450043,
      "latitude":56.306805
    },
    "6397":{
      "name":"\u0415\u043b\u044c\u043d\u0438\u0447\u043d\u0430\u044f",
      "longitude":90.452759,
      "latitude":55.33213
    },
    "6398":{
      "name":"\u041c\u043e\u043d\u0430\u0441\u0442\u044b\u0440\u043a\u0430",
      "longitude":90.460999,
      "latitude":56.873474
    },
    "6399":{
      "name":"\u0421\u0438\u043c\u043e\u043d\u043e\u0432\u043e",
      "longitude":90.4618158,
      "latitude":56.5084148
    },
    "6400":{
      "name":"\u041d\u0430\u043f\u0430\u0440\u0438\u043d\u043e",
      "longitude":90.4653201,
      "latitude":60.1485342
    },
    "6401":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0439 \u0422\u044e\u0445\u0442\u0435\u0442",
      "longitude":90.468613,
      "latitude":56.93259
    },
    "6402":{
      "name":"\u041a\u043e\u0441\u0442\u0435\u043d\u044c\u043a\u0438",
      "longitude":90.472801,
      "latitude":56.075085
    },
    "6403":{
      "name":"\u0423\u0441\u0442\u044c-\u0422\u0435\u0440\u0435\u044f",
      "longitude":90.4824014,
      "latitude":73.2575608
    },
    "6404":{
      "name":"\u0418\u0433\u0438\u043d\u043a\u0430",
      "longitude":90.488472,
      "latitude":56.346355
    },
    "6405":{
      "name":"\u041a\u043b\u0438\u043c\u043e\u0432\u043a\u0430",
      "longitude":90.4907242,
      "latitude":56.653024
    },
    "6406":{
      "name":"\u0421\u0435\u043a\u0440\u0435\u0442\u0430\u0440\u043a\u0430",
      "longitude":90.4928988,
      "latitude":56.4576375
    },
    "6407":{
      "name":"\u0418\u0448\u0438\u043c\u043a\u0430",
      "longitude":90.5044795,
      "latitude":56.772013
    },
    "6408":{
      "name":"\u0418\u0441\u0430\u043a\u043e\u0432\u043a\u0430",
      "longitude":90.518044,
      "latitude":57.322464
    },
    "6409":{
      "name":"\u0412\u043b\u0430\u0434\u0438\u043c\u0438\u0440\u043e\u0432\u043a\u0430",
      "longitude":90.525528,
      "latitude":56.019482
    },
    "6410":{
      "name":"\u0421\u0435\u0440\u0435\u0443\u043b\u044c",
      "longitude":90.541275,
      "latitude":55.791061
    },
    "6411":{
      "name":"\u0411\u0438\u0440\u0438\u043b\u044e\u0441\u0441\u044b",
      "longitude":90.555061,
      "latitude":57.119896
    },
    "6412":{
      "name":"\u0414\u043e\u0440\u043e\u0445\u0442\u0430",
      "longitude":90.570572,
      "latitude":57.143837
    },
    "6413":{
      "name":"\u0424\u043e\u043c\u043a\u0430",
      "longitude":90.573784,
      "latitude":60.036057
    },
    "6414":{
      "name":"\u0422\u0438\u0445\u0438\u0439 \u0420\u0443\u0447\u0435\u0439",
      "longitude":90.5837207,
      "latitude":56.6287456
    },
    "6415":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u0418\u043c\u044b\u0448",
      "longitude":90.617104,
      "latitude":55.141556
    },
    "6416":{
      "name":"\u0428\u043f\u0430\u0433\u0438\u043d\u043e-1",
      "longitude":90.620621,
      "latitude":57.214169
    },
    "6417":{
      "name":"\u0421\u0430\u0440\u043e\u0441\u0435\u043a\u0430",
      "longitude":90.622993,
      "latitude":56.309826
    },
    "6418":{
      "name":"\u041e\u0440\u043b\u043e\u0432\u043a\u0430",
      "longitude":90.626648,
      "latitude":56.239712
    },
    "6419":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u041b\u0443\u0433",
      "longitude":90.6303135,
      "latitude":56.706923
    },
    "6420":{
      "name":"\u041d\u043e\u0432\u043e\u0430\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":90.633209,
      "latitude":55.587627
    },
    "6421":{
      "name":"\u041b\u0430\u0434\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":90.634895,
      "latitude":56.06414
    },
    "6422":{
      "name":"\u0418\u043b\u044c\u0438\u043d\u043a\u0430",
      "longitude":90.641182,
      "latitude":56.296459
    },
    "6423":{
      "name":"\u0422\u0430\u043b\u044c\u043d\u0438\u043a\u0438",
      "longitude":90.643387,
      "latitude":55.277599
    },
    "6424":{
      "name":"\u041d\u0438\u0436\u043d\u0435\u0448\u0430\u0434\u0440\u0438\u043d\u043e",
      "longitude":90.6449528,
      "latitude":59.9173436
    },
    "6425":{
      "name":"\u041a\u0443\u043c\u044b\u0440\u044b",
      "longitude":90.6449891,
      "latitude":56.7464614
    },
    "6426":{
      "name":"\u0428\u0443\u0442\u043e\u0447\u043a\u0438\u043d\u043e",
      "longitude":90.650482,
      "latitude":56.861656
    },
    "6427":{
      "name":"\u0422\u0438\u043c\u043e\u043d\u0438\u043d\u043e",
      "longitude":90.655151,
      "latitude":56.366398
    },
    "6428":{
      "name":"\u0425\u043e\u043b\u043c\u0430",
      "longitude":90.658119,
      "latitude":55.804779
    },
    "6429":{
      "name":"\u0428\u043f\u0430\u0433\u0438\u043d\u043e-2",
      "longitude":90.660873,
      "latitude":57.221912
    },
    "6430":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u0435\u043b\u044b",
      "longitude":90.667641,
      "latitude":56.8249985
    },
    "6431":{
      "name":"\u0421\u0442\u0430\u0440\u0430\u044f \u0415\u043b\u043e\u0432\u043a\u0430",
      "longitude":90.670532,
      "latitude":56.893341
    },
    "6432":{
      "name":"\u041a\u0430\u0440\u0435\u043b\u0438\u043d\u043e",
      "longitude":90.682312,
      "latitude":55.141933
    },
    "6433":{
      "name":"\u0422\u0443\u0440\u0435\u0446\u043a",
      "longitude":90.6913183,
      "latitude":56.5747896
    },
    "6434":{
      "name":"\u0413\u0440\u0438\u0431\u043d\u043e\u0439",
      "longitude":90.696899,
      "latitude":56.325001
    },
    "6435":{
      "name":"\u0411\u0430\u0436\u0435\u043d\u043e\u0432\u043a\u0430",
      "longitude":90.703817,
      "latitude":56.6755485
    },
    "6436":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u0418\u043b\u044c\u0438\u043d\u043a\u0430",
      "longitude":90.717178,
      "latitude":56.074642
    },
    "6437":{
      "name":"\u041b\u0435\u0441\u043d\u044b\u0435 \u041f\u043e\u043b\u044f\u043d\u044b",
      "longitude":90.718735,
      "latitude":55.922626
    },
    "6438":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u041f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":90.723183,
      "latitude":56.228798
    },
    "6439":{
      "name":"\u0411\u0430\u0440\u0430\u0431\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":90.737671,
      "latitude":56.118301
    },
    "6440":{
      "name":"\u0422\u0438\u043c\u043e\u043d\u0438\u043d\u043e",
      "longitude":90.745728,
      "latitude":56.401443
    },
    "6441":{
      "name":"\u042f\u0440\u043b\u044b\u043a\u043e\u0432\u043e",
      "longitude":90.76181,
      "latitude":56.008904
    },
    "6442":{
      "name":"\u041a\u0430\u043d\u0430\u0448",
      "longitude":90.766502,
      "latitude":55.702415
    },
    "6443":{
      "name":"\u041f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":90.773308,
      "latitude":56.314991
    },
    "6444":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":90.777599,
      "latitude":56.5323612
    },
    "6445":{
      "name":"\u041c\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":90.79615,
      "latitude":55.735962
    },
    "6446":{
      "name":"\u0422\u0443\u043a\u0430\u0439",
      "longitude":90.821213,
      "latitude":55.399433
    },
    "6447":{
      "name":"\u041a\u043e\u0437\u043b\u043e\u0432\u043a\u0430",
      "longitude":90.826729,
      "latitude":56.378525
    },
    "6448":{
      "name":"\u041c\u043e\u0433\u0443\u0447\u0438\u0439",
      "longitude":90.835358,
      "latitude":55.26252
    },
    "6449":{
      "name":"\u0421\u0435\u0440\u0433\u0435\u0435\u0432\u043e",
      "longitude":90.8370203,
      "latitude":59.6640043
    },
    "6450":{
      "name":"\u041f\u043b\u043e\u0442\u0431\u0438\u0449\u0435",
      "longitude":90.843102,
      "latitude":56.044987
    },
    "6451":{
      "name":"\u0415\u043b\u0433\u0430",
      "longitude":90.8449055,
      "latitude":56.7974608
    },
    "6452":{
      "name":"\u0410\u0435\u0448\u043a\u0430",
      "longitude":90.8474827,
      "latitude":54.9222047
    },
    "6453":{
      "name":"\u041a\u0430\u043c\u0447\u0430\u0442\u043a\u0430",
      "longitude":90.863197,
      "latitude":55.119869
    },
    "6454":{
      "name":"\u0422\u0443\u043b\u0430\u0442",
      "longitude":90.864014,
      "latitude":56.491009
    },
    "6455":{
      "name":"\u041d\u043e\u0432\u043e\u0442\u0440\u043e\u0438\u0446\u043a",
      "longitude":90.8723304,
      "latitude":55.3649435
    },
    "6456":{
      "name":"\u0421\u043a\u043e\u0440\u043e\u0431\u043e\u0433\u0430\u0442\u043e\u0432\u043e",
      "longitude":90.873825,
      "latitude":55.757595
    },
    "6457":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u0436\u0438\u043b\u043e\u0432\u043e",
      "longitude":90.88253,
      "latitude":55.829437
    },
    "6458":{
      "name":"\u0421\u043e\u0441\u043d\u043e\u0432\u043a\u0430",
      "longitude":90.884254,
      "latitude":57.229549
    },
    "6459":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u0421\u043e\u0441\u043d\u043e\u0432\u043a\u0430",
      "longitude":90.886208,
      "latitude":55.954903
    },
    "6460":{
      "name":"\u0427\u0435\u0440\u0435\u043c\u0448\u0430\u043d\u043a\u0430",
      "longitude":90.8968822,
      "latitude":56.6478688
    },
    "6461":{
      "name":"\u0422\u0440\u043e\u0438\u0446\u043a",
      "longitude":90.9072252,
      "latitude":56.7624578
    },
    "6462":{
      "name":"\u041a\u044b\u0437\u044b\u043a\u0447\u0443\u043b\u044c",
      "longitude":90.91539,
      "latitude":55.525482
    },
    "6463":{
      "name":"\u0411\u043e\u0440\u043e\u0432\u043a\u0430",
      "longitude":90.915634,
      "latitude":56.31879
    },
    "6464":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":90.918816,
      "latitude":56.829227
    },
    "6465":{
      "name":"\u041d\u0430\u0437\u0438\u043c\u043e\u0432\u043e",
      "longitude":90.931118,
      "latitude":59.5127058
    },
    "6466":{
      "name":"\u0418\u0437\u044b\u043a\u0447\u0443\u043b\u044c",
      "longitude":90.9348346,
      "latitude":56.5443386
    },
    "6467":{
      "name":"\u041e\u043b\u044c\u0445\u043e\u0432\u043a\u0430",
      "longitude":90.965744,
      "latitude":56.406078
    },
    "6468":{
      "name":"\u041f\u0440\u0438\u043c\u043e\u0440\u0441\u043a\u0438\u0439",
      "longitude":90.982521,
      "latitude":54.75108
    },
    "6469":{
      "name":"\u0423\u0432\u0430\u043b\u044b",
      "longitude":90.992584,
      "latitude":55.112152
    },
    "6470":{
      "name":"\u0417\u0435\u043b\u0435\u043d\u043e\u0431\u043e\u0440\u0441\u043a",
      "longitude":90.992813,
      "latitude":54.900875
    },
    "6471":{
      "name":"\u0411\u0430\u043b\u0434\u0430\u0448\u0442\u044b\u043a",
      "longitude":90.993866,
      "latitude":55.405151
    },
    "6472":{
      "name":"\u0422\u0430\u0435\u0436\u043a\u0430",
      "longitude":91.0094003,
      "latitude":56.6234297
    },
    "6473":{
      "name":"\u0421\u0442\u0430\u0440\u0430\u044f \u0427\u0451\u0440\u043d\u0430\u044f",
      "longitude":91.024277,
      "latitude":56.275761
    },
    "6474":{
      "name":"\u0425\u043e\u043b\u043e\u0434\u043d\u044b\u0439 \u041a\u043b\u044e\u0447",
      "longitude":91.03479,
      "latitude":55.501404
    },
    "6475":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u0432\u043a\u0430",
      "longitude":91.039932,
      "latitude":56.873997
    },
    "6476":{
      "name":"\u041a\u0440\u044e\u043a\u043e\u0432\u043e",
      "longitude":91.040154,
      "latitude":55.358871
    },
    "6477":{
      "name":"\u0412\u043e\u043b\u044c\u043d\u044b\u0439",
      "longitude":91.040794,
      "latitude":55.269238
    },
    "6478":{
      "name":"\u0421\u0435\u043b\u0435\u0434\u043a\u043e\u0432\u043e",
      "longitude":91.041176,
      "latitude":55.893631
    },
    "6479":{
      "name":"\u0421\u0442\u0430\u0440\u0430\u044f",
      "longitude":91.048653,
      "latitude":55.158302
    },
    "6480":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u042f\u0440",
      "longitude":91.050804,
      "latitude":55.987534
    },
    "6481":{
      "name":"\u042f\u043a\u0443\u0448\u0435\u0432\u043e",
      "longitude":91.055603,
      "latitude":55.191948
    },
    "6482":{
      "name":"\u0422\u0430\u0431\u0430\u0436\u0430\u043a",
      "longitude":91.079956,
      "latitude":54.810879
    },
    "6483":{
      "name":"\u041d\u0438\u043a\u0438\u0444\u043e\u0440\u043e\u0432\u043a\u0430",
      "longitude":91.082504,
      "latitude":57.092522
    },
    "6484":{
      "name":"\u041a\u0438\u0437\u044b\u043b\u043a\u0430",
      "longitude":91.087654,
      "latitude":55.589966
    },
    "6485":{
      "name":"\u0422\u0435\u0441\u044c",
      "longitude":91.088997,
      "latitude":54.744198
    },
    "6486":{
      "name":"\u041c\u0435\u0434\u0432\u0435\u0436\u0438\u0439 \u042f\u0440",
      "longitude":91.0957466,
      "latitude":70.535327
    },
    "6487":{
      "name":"\u0410\u043c\u043c\u0430\u043b\u0430",
      "longitude":91.098251,
      "latitude":55.797478
    },
    "6488":{
      "name":"\u0418\u043b\u044c\u0442\u044e\u043a\u043e\u0432\u043e",
      "longitude":91.098854,
      "latitude":55.213848
    },
    "6489":{
      "name":"\u041f\u043e\u0441\u0442\u043e\u0439\u043a\u0430",
      "longitude":91.117851,
      "latitude":56.238033
    },
    "6490":{
      "name":"\u0413\u043b\u0443\u0448\u043a\u043e\u0432\u043e",
      "longitude":91.12825,
      "latitude":56.04604
    },
    "6491":{
      "name":"\u0411\u0435\u043b\u043e\u0432\u043a\u0430",
      "longitude":91.1380558,
      "latitude":56.7834858
    },
    "6492":{
      "name":"\u0422\u043e\u0439\u043b\u0443\u043a",
      "longitude":91.14888,
      "latitude":55.471592
    },
    "6493":{
      "name":"\u041a\u043b\u044e\u0447\u0438",
      "longitude":91.151321,
      "latitude":55.357048
    },
    "6494":{
      "name":"\u041a\u0443\u0440\u0431\u0430\u0442\u043e\u0432\u043e",
      "longitude":91.16423,
      "latitude":55.578747
    },
    "6495":{
      "name":"\u0422\u0430\u043b\u044c\u0446\u044b",
      "longitude":91.164322,
      "latitude":54.893154
    },
    "6496":{
      "name":"\u041f\u0440\u0435\u0434\u0433\u043e\u0440\u044c\u0435",
      "longitude":91.166344,
      "latitude":56.244411
    },
    "6497":{
      "name":"\u041a\u0443\u043b\u043b\u043e\u0433",
      "longitude":91.18232,
      "latitude":54.815712
    },
    "6498":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u044b\u0439",
      "longitude":91.20977,
      "latitude":55.189945
    },
    "6499":{
      "name":"\u041d\u0438\u0447\u043a\u043e\u0432\u043e",
      "longitude":91.214554,
      "latitude":56.071327
    },
    "6500":{
      "name":"\u0428\u0430\u0440\u044b\u043f\u043e\u0432\u043a\u0430",
      "longitude":91.2213909,
      "latitude":56.800167
    },
    "6501":{
      "name":"\u041b\u0435\u0432\u043e\u044f\u043c\u043d\u043e\u0435",
      "longitude":91.22699,
      "latitude":56.321175
    },
    "6502":{
      "name":"\u041d\u043e\u0433\u0438\u043d\u0441\u043a",
      "longitude":91.244591,
      "latitude":64.485275
    },
    "6503":{
      "name":"\u0428\u0443\u0448\u043a\u043e\u0432\u043e",
      "longitude":91.249115,
      "latitude":56.202995
    },
    "6504":{
      "name":"\u0421\u043e\u0431\u043e\u043b\u0435\u0432\u043a\u0430",
      "longitude":91.255707,
      "latitude":56.148846
    },
    "6505":{
      "name":"\u0414\u0438\u0432\u043d\u044b\u0439",
      "longitude":91.266174,
      "latitude":55.094547
    },
    "6506":{
      "name":"\u0413\u043b\u0430\u0434\u043a\u0438\u0439 \u041c\u044b\u0441",
      "longitude":91.271881,
      "latitude":55.485416
    },
    "6507":{
      "name":"\u0427\u0451\u0440\u043d\u0430\u044f \u041a\u043e\u043c\u0430",
      "longitude":91.274117,
      "latitude":54.931484
    },
    "6508":{
      "name":"\u041c\u0430\u043b\u0438\u043d\u043e\u0433\u043e\u0440\u043a\u0430",
      "longitude":91.278214,
      "latitude":56.188015
    },
    "6509":{
      "name":"\u041c\u0430\u043b\u044c\u0444\u0438\u043d\u043e",
      "longitude":91.280807,
      "latitude":56.069744
    },
    "6510":{
      "name":"\u0417\u0430\u0433\u0430\u0439\u043d\u043e\u0432\u043e",
      "longitude":91.290565,
      "latitude":55.859188
    },
    "6511":{
      "name":"\u041a\u0438\u043f\u0440\u0435\u0439\u043d\u044b\u0439",
      "longitude":91.298737,
      "latitude":56.885429
    },
    "6512":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u0414\u043e\u0440\u043e\u0433\u0430",
      "longitude":91.304512,
      "latitude":56.153461
    },
    "6513":{
      "name":"\u041a\u043e\u043b\u043c\u043e\u0433\u043e\u0440\u043e\u0432\u043e",
      "longitude":91.314972,
      "latitude":59.262726
    },
    "6514":{
      "name":"\u0411\u0435\u0441\u043a\u0438\u0448",
      "longitude":91.315132,
      "latitude":54.901943
    },
    "6515":{
      "name":"\u041a\u0443\u0440\u0433\u0430\u043d\u044b",
      "longitude":91.315178,
      "latitude":55.181683
    },
    "6516":{
      "name":"\u0421\u0442\u0430\u0440\u0430\u044f \u041a\u043e\u0437\u0443\u043b\u044c\u043a\u0430",
      "longitude":91.33255,
      "latitude":56.207573
    },
    "6517":{
      "name":"\u0423\u0433\u043e\u043b\u044c\u043d\u044b\u0439",
      "longitude":91.3347824,
      "latitude":55.3776762
    },
    "6518":{
      "name":"\u0423\u043b\u0430\u043d\u043e\u0432\u043e",
      "longitude":91.348503,
      "latitude":56.91848
    },
    "6519":{
      "name":"\u0415\u043d\u0438\u0441\u0435\u0439",
      "longitude":91.354843,
      "latitude":55.03751
    },
    "6520":{
      "name":"\u0423\u044f\u0440",
      "longitude":91.3605578,
      "latitude":54.621801
    },
    "6521":{
      "name":"\u041c\u0430\u043b\u0438\u043d\u043e\u0433\u043e\u0440\u043a\u0430",
      "longitude":91.370354,
      "latitude":56.144539
    },
    "6522":{
      "name":"\u0422\u0440\u044f\u0441\u0443\u0447\u0430\u044f",
      "longitude":91.381721,
      "latitude":55.55912
    },
    "6523":{
      "name":"\u041c\u0430\u0440\u044c\u044f\u0441\u043e\u0432\u043e",
      "longitude":91.452286,
      "latitude":55.322777
    },
    "6524":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u0425\u0443\u0442\u043e\u0440",
      "longitude":91.4552325,
      "latitude":53.0416706
    },
    "6525":{
      "name":"\u0422\u0430\u0439\u0433\u0430",
      "longitude":91.465576,
      "latitude":56.217304
    },
    "6526":{
      "name":"\u041a\u0435\u043c\u0447\u0443\u0433",
      "longitude":91.472061,
      "latitude":57.023518
    },
    "6527":{
      "name":"\u0428\u0430\u0440\u043b\u043e\u0432\u043a\u0430",
      "longitude":91.474319,
      "latitude":56.117031
    },
    "6528":{
      "name":"\u041c\u0435\u043d\u0434\u0435\u043b\u044c\u0441\u043a\u0438\u0439",
      "longitude":91.478111,
      "latitude":57.097839
    },
    "6529":{
      "name":"\u0421\u0430\u044f\u043d\u0441\u043a",
      "longitude":91.4804592,
      "latitude":53.1406535
    },
    "6530":{
      "name":"\u041a\u043e\u043c\u0430\u0440\u043a\u043e\u0432\u043e",
      "longitude":91.4885706,
      "latitude":53.7738176
    },
    "6531":{
      "name":"\u041b\u043e\u043c\u043e\u043d\u043e\u0441\u043e\u0432\u043e",
      "longitude":91.4905787,
      "latitude":75.6334185
    },
    "6532":{
      "name":"\u0413\u0430\u043d\u0438\u043d\u0430 \u0413\u0430\u0440\u044c",
      "longitude":91.500618,
      "latitude":57.065361
    },
    "6533":{
      "name":"\u0411\u0435\u0437\u044a\u044f\u0437\u044b\u043a\u043e\u0432\u043e",
      "longitude":91.500626,
      "latitude":55.287468
    },
    "6534":{
      "name":"\u0413\u043e\u043b\u0443\u0431\u0430\u044f",
      "longitude":91.5079806,
      "latitude":52.9773072
    },
    "6535":{
      "name":"\u0422\u0430\u043b\u043e\u0432\u0430\u044f",
      "longitude":91.5257616,
      "latitude":55.3450638
    },
    "6536":{
      "name":"\u041a\u0443\u0440\u0442\u0430\u043a",
      "longitude":91.535423,
      "latitude":55.148136
    },
    "6537":{
      "name":"\u0427\u0435\u0441\u043d\u043e\u043a\u0438",
      "longitude":91.539452,
      "latitude":55.20525
    },
    "6538":{
      "name":"\u0421\u0430\u0440\u0443\u0448\u043a\u0430",
      "longitude":91.5468576,
      "latitude":54.5005922
    },
    "6539":{
      "name":"\u041c\u0430\u043b\u044b\u0439 \u041a\u0430\u0439\u0434\u0430\u0442",
      "longitude":91.560883,
      "latitude":55.97282
    },
    "6540":{
      "name":"\u041c\u0430\u043b\u044b\u0435 \u0421\u044b\u0440\u044b",
      "longitude":91.56562,
      "latitude":55.499996
    },
    "6541":{
      "name":"\u0412\u0438\u043b\u0435\u043d\u043a\u0430",
      "longitude":91.565697,
      "latitude":55.598637
    },
    "6542":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u041a\u0435\u043c\u0447\u0443\u0433",
      "longitude":91.59021,
      "latitude":56.186325
    },
    "6543":{
      "name":"\u0410\u043b\u0433\u0430\u0448\u0442\u044b\u043a",
      "longitude":91.6077784,
      "latitude":54.6547067
    },
    "6544":{
      "name":"\u041a\u0430\u0440\u0430-\u0411\u0435\u043b\u043b\u044b\u043a",
      "longitude":91.6099953,
      "latitude":54.5838989
    },
    "6545":{
      "name":"\u0423\u0437\u0430",
      "longitude":91.6230563,
      "latitude":54.436944
    },
    "6546":{
      "name":"\u0428\u0430\u0440\u044b\u043f",
      "longitude":91.6244082,
      "latitude":53.099455
    },
    "6547":{
      "name":"\u042f\u043c\u0441\u043a\u0430\u044f",
      "longitude":91.630806,
      "latitude":55.234749
    },
    "6548":{
      "name":"\u041b\u0438\u0441\u0442\u0432\u044f\u0433\u043e\u0432\u043e",
      "longitude":91.6478271,
      "latitude":53.9825664
    },
    "6549":{
      "name":"\u041a\u0440\u0438\u0432\u0438\u043d\u0441\u043a\u043e\u0435",
      "longitude":91.6534738,
      "latitude":53.5647149
    },
    "6550":{
      "name":"\u041c\u043e\u0436\u0430\u0440\u0441\u043a\u0438\u0439",
      "longitude":91.655739,
      "latitude":56.187244
    },
    "6551":{
      "name":"\u041c\u0430\u043b\u044b\u0435 \u0420\u0443\u0447\u044c\u0438",
      "longitude":91.671448,
      "latitude":56.05711
    },
    "6552":{
      "name":"\u0418\u0436\u0443\u043b\u044c\u0441\u043a\u043e\u0435",
      "longitude":91.683533,
      "latitude":55.193241
    },
    "6553":{
      "name":"\u041d\u043e\u0432\u043e\u043f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":91.6859422,
      "latitude":53.1452992
    },
    "6554":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u0438\u0431\u0438\u0440\u0441\u043a\u0438\u0439",
      "longitude":91.695984,
      "latitude":56.07225
    },
    "6555":{
      "name":"\u0427\u0430\u0439\u0434\u0430",
      "longitude":91.6996091,
      "latitude":57.4346527
    },
    "6556":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u0422\u0443\u043c\u043d\u0430",
      "longitude":91.73494,
      "latitude":55.32523
    },
    "6557":{
      "name":"\u0411\u0435\u043b\u043e\u0437\u0435\u0440\u043e\u0432\u043a\u0430",
      "longitude":91.7439925,
      "latitude":53.1002867
    },
    "6558":{
      "name":"\u0421\u0435\u0440\u0433\u0438\u043d\u043e",
      "longitude":91.766243,
      "latitude":56.069118
    },
    "6559":{
      "name":"\u041c\u043e\u0438\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":91.771896,
      "latitude":54.171982
    },
    "6560":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":91.782623,
      "latitude":54.630161
    },
    "6561":{
      "name":"\u0422\u0430\u0433\u0430\u0440\u0441\u043a\u0438\u0439",
      "longitude":91.806885,
      "latitude":53.642185
    },
    "6562":{
      "name":"\u041b\u0435\u043d\u0441\u043a",
      "longitude":91.8160846,
      "latitude":53.0473405
    },
    "6563":{
      "name":"\u0422\u0443\u0440\u0443\u0445\u0430\u043d\u043a\u0430",
      "longitude":91.8383298,
      "latitude":57.5907301
    },
    "6564":{
      "name":"\u0421\u043e\u043b\u0434\u0430\u0442\u043e\u0432\u043e",
      "longitude":91.841976,
      "latitude":53.6562751
    },
    "6565":{
      "name":"\u042f\u043b\u0430\u043d\u044c",
      "longitude":91.8427149,
      "latitude":58.3539836
    },
    "6566":{
      "name":"\u0414\u0438\u0441\u0441\u043e\u0441",
      "longitude":91.8508858,
      "latitude":54.0729662
    },
    "6567":{
      "name":"\u041e\u0433\u043e\u043d\u044c\u043a\u0438",
      "longitude":91.8536153,
      "latitude":55.4688863
    },
    "6568":{
      "name":"\u0410\u043d\u0446\u0438\u0444\u0435\u0440\u043e\u0432\u043e",
      "longitude":91.8622253,
      "latitude":58.8724802
    },
    "6569":{
      "name":"\u041c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":91.8656082,
      "latitude":53.0325172
    },
    "6570":{
      "name":"\u041e\u043a\u0442\u044f\u0431\u0440\u044c\u0441\u043a\u0438\u0439",
      "longitude":91.8661384,
      "latitude":54.3905922
    },
    "6571":{
      "name":"\u0411\u0430\u0434\u0430\u043b\u043e\u0436\u043d\u0430\u044f",
      "longitude":91.870941,
      "latitude":56.077538
    },
    "6572":{
      "name":"\u0418\u043d\u043d\u043e\u043a\u0435\u043d\u0442\u044c\u0435\u0432\u043a\u0430",
      "longitude":91.8804757,
      "latitude":54.7825714
    },
    "6573":{
      "name":"\u041e\u043c\u0441\u043a\u0438\u0439",
      "longitude":91.8920322,
      "latitude":57.5951021
    },
    "6574":{
      "name":"\u041c\u0430\u0441\u043b\u0435\u043d\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":91.8922036,
      "latitude":58.1880628
    },
    "6575":{
      "name":"\u0421\u0443\u0445\u043e\u0435 \u041e\u0437\u0435\u0440\u043e",
      "longitude":91.8948882,
      "latitude":53.60641
    },
    "6576":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u041a\u0435\u0442\u044c",
      "longitude":91.8993536,
      "latitude":57.593354
    },
    "6577":{
      "name":"\u041d\u043e\u0432\u044b\u0439 \u0418\u0441\u043b\u0430\u043c",
      "longitude":91.9133635,
      "latitude":57.5352793
    },
    "6578":{
      "name":"\u041a\u043e\u043b\u0434\u044b\u0431\u0430\u0439",
      "longitude":91.9175683,
      "latitude":54.5909806
    },
    "6579":{
      "name":"\u041a\u0443\u0442\u0443\u0436\u0435\u043a\u043e\u0432\u043e",
      "longitude":91.9272801,
      "latitude":53.589162
    },
    "6580":{
      "name":"\u0422\u0451\u043f\u043b\u044b\u0439 \u041a\u043b\u044e\u0447",
      "longitude":91.9358311,
      "latitude":54.2474039
    },
    "6581":{
      "name":"\u041c\u0430\u043b\u044b\u0439 \u0422\u0435\u043b\u0435\u043a",
      "longitude":91.9410195,
      "latitude":54.3327327
    },
    "6582":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":91.9454584,
      "latitude":56.5484605
    },
    "6583":{
      "name":"\u041c\u0430\u0440\u0438\u043b\u043e\u0432\u0446\u0435\u0432\u0430",
      "longitude":91.9500492,
      "latitude":58.2671824
    },
    "6584":{
      "name":"\u0422\u0440\u0443\u0434",
      "longitude":91.9506058,
      "latitude":53.1587704
    },
    "6585":{
      "name":"\u041d\u043e\u0432\u043e\u043c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":91.9512729,
      "latitude":57.4759137
    },
    "6586":{
      "name":"\u0438\u043c\u0435\u043d\u0438 \u041a\u0440\u0443\u043f\u0441\u043a\u043e\u0439",
      "longitude":91.9558382,
      "latitude":53.6938634
    },
    "6587":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u041a\u043b\u044e\u0447",
      "longitude":91.960953,
      "latitude":55.446392
    },
    "6588":{
      "name":"\u0428\u0430\u0434\u0440\u0438\u043d\u043e",
      "longitude":91.9625772,
      "latitude":54.6983898
    },
    "6589":{
      "name":"\u0414\u0430\u0443\u0440\u0441\u043a\u043e\u0435",
      "longitude":91.966011,
      "latitude":55.224712
    },
    "6590":{
      "name":"\u041a\u043e\u0432\u0440\u0438\u0433\u0430",
      "longitude":91.9719611,
      "latitude":57.6146319
    },
    "6591":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":91.97276,
      "latitude":54.7798441
    },
    "6592":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u043f\u0430\u0432\u043b\u043e\u0432\u043a\u0430",
      "longitude":91.9742978,
      "latitude":56.5721701
    },
    "6593":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u044f\u044f \u0411\u0438\u0440\u044e\u0441\u0430",
      "longitude":91.9746279,
      "latitude":55.9235338
    },
    "6594":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":91.9814107,
      "latitude":56.6269936
    },
    "6595":{
      "name":"\u041c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":91.9864996,
      "latitude":54.485515
    },
    "6596":{
      "name":"\u0412\u043e\u0441\u0442\u043e\u0447\u043d\u0430\u044f",
      "longitude":92.0001079,
      "latitude":75.4999394
    },
    "6597":{
      "name":"\u0415\u0440\u043c\u043e\u043b\u0430\u0435\u0432\u043e",
      "longitude":92.006875,
      "latitude":53.2357285
    },
    "6598":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u044c\u0441\u043a",
      "longitude":92.0196574,
      "latitude":57.3156315
    },
    "6599":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0435\u043a\u0435\u043c\u0441\u043a\u043e\u0435",
      "longitude":92.0213696,
      "latitude":58.02021
    },
    "6600":{
      "name":"\u041f\u0440\u0438\u0433\u043e\u0440\u043e\u0434\u043d\u044b\u0439",
      "longitude":92.0300642,
      "latitude":53.5493656
    },
    "6601":{
      "name":"\u041a\u0435\u0434\u0440\u043e\u0432\u0430\u044f",
      "longitude":92.0341719,
      "latitude":54.1760308
    },
    "6602":{
      "name":"\u041b\u044b\u0442\u043a\u0438\u043d\u043e",
      "longitude":92.0362941,
      "latitude":53.5015686
    },
    "6603":{
      "name":"\u041d\u043e\u0432\u043e\u0438\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":92.0382009,
      "latitude":54.0582138
    },
    "6604":{
      "name":"\u0428\u0430\u0434\u0440\u0438\u043d\u043e",
      "longitude":92.045572,
      "latitude":58.5608231
    },
    "6605":{
      "name":"\u041d\u043e\u0432\u043e\u0442\u0440\u043e\u0438\u0446\u043a\u0430\u044f",
      "longitude":92.0525749,
      "latitude":57.6277023
    },
    "6606":{
      "name":"\u041a\u043e\u0437\u043b\u043e\u0432\u043e",
      "longitude":92.0542028,
      "latitude":53.3965487
    },
    "6607":{
      "name":"\u041a\u043e\u043d\u044b\u0433\u0438\u043d\u043e",
      "longitude":92.0548682,
      "latitude":53.6911989
    },
    "6608":{
      "name":"\u041f\u0430\u0440\u0448\u0438\u043d\u043e",
      "longitude":92.0684548,
      "latitude":58.6832805
    },
    "6609":{
      "name":"\u0412\u043e\u0437\u043d\u0435\u0441\u0435\u043d\u043a\u0430",
      "longitude":92.0697261,
      "latitude":53.1048977
    },
    "6610":{
      "name":"\u041d\u043e\u0432\u044b\u0439 \u0422\u0438\u043c\u0435\u0440\u0448\u0438\u043a",
      "longitude":92.0757641,
      "latitude":57.5955902
    },
    "6611":{
      "name":"\u0429\u0435\u0442\u0438\u043d\u043a\u0438\u043d\u0430",
      "longitude":92.087662,
      "latitude":55.35466
    },
    "6612":{
      "name":"\u0411\u043e\u0440\u043a\u0438",
      "longitude":92.1035689,
      "latitude":58.4842663
    },
    "6613":{
      "name":"\u041a\u043e\u0440\u043d\u0438\u043b\u043e\u0432\u043e",
      "longitude":92.105391,
      "latitude":53.2776776
    },
    "6614":{
      "name":"\u0412\u043e\u0437\u043d\u0435\u0441\u0435\u043d\u043a\u0430",
      "longitude":92.105811,
      "latitude":54.7693647
    },
    "6615":{
      "name":"\u0410\u043b\u0433\u0430\u0439\u0441\u043a",
      "longitude":92.1097153,
      "latitude":57.2870174
    },
    "6616":{
      "name":"\u0415\u0440\u043a\u0430\u043b\u043e\u0432\u043e",
      "longitude":92.1195303,
      "latitude":58.5173754
    },
    "6617":{
      "name":"\u0414\u0436\u0438\u0440\u0438\u043c",
      "longitude":92.1268642,
      "latitude":54.0184604
    },
    "6618":{
      "name":"\u041a\u043e\u0440\u043e\u043b\u0435\u0432\u043a\u0430",
      "longitude":92.1435965,
      "latitude":54.7431904
    },
    "6619":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u0430\u044f",
      "longitude":92.145218,
      "latitude":54.956154
    },
    "6620":{
      "name":"\u0413\u043e\u0440\u0441\u043a\u0430\u044f",
      "longitude":92.1477062,
      "latitude":58.4123378
    },
    "6621":{
      "name":"\u0418\u043b\u044c\u0438\u043d\u043a\u0430",
      "longitude":92.1489445,
      "latitude":53.9025566
    },
    "6622":{
      "name":"\u041c\u0430\u043b\u044b\u0439 \u041a\u0435\u043c\u0447\u0443\u0433",
      "longitude":92.1512109,
      "latitude":56.2317345
    },
    "6623":{
      "name":"\u041f\u0438\u0440\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":92.1578196,
      "latitude":57.7808216
    },
    "6624":{
      "name":"\u0411\u0435\u043b\u044c\u0441\u043a\u043e\u0435",
      "longitude":92.1677037,
      "latitude":57.8208784
    },
    "6625":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u043f\u0430\u0432\u043b\u043e\u0432\u043a\u0430",
      "longitude":92.1688366,
      "latitude":57.5652255
    },
    "6626":{
      "name":"\u041a\u044b\u0437\u044b\u043a\u0443\u043b\u044c\u0441\u043a\u0438\u0439",
      "longitude":92.1764939,
      "latitude":53.7221806
    },
    "6627":{
      "name":"\u0412\u043e\u0441\u0442\u043e\u0447\u043d\u044b\u0439",
      "longitude":92.1799934,
      "latitude":54.3627466
    },
    "6628":{
      "name":"\u0418\u0437\u0432\u0435\u0441\u0442\u043a\u043e\u0432\u044b\u0439",
      "longitude":92.1932042,
      "latitude":56.0949012
    },
    "6629":{
      "name":"\u041c\u0430\u043b\u044b\u0439 \u041a\u044b\u0437\u044b\u043a\u0443\u043b\u044c",
      "longitude":92.2178428,
      "latitude":53.7692904
    },
    "6630":{
      "name":"\u0428\u0443\u043c\u0431\u0430\u0448",
      "longitude":92.2215254,
      "latitude":57.3736627
    },
    "6631":{
      "name":"\u0422\u0443\u043d\u0433\u0443\u0441\u044b \u041f\u0435\u0440\u0432\u044b\u0435",
      "longitude":92.233333,
      "latitude":70.6
    },
    "6632":{
      "name":"\u041d\u043e\u0432\u044b\u0439 \u0421\u0430\u0442\u044b\u0448",
      "longitude":92.2336526,
      "latitude":57.8669932
    },
    "6633":{
      "name":"\u041a\u0443\u0440\u0435\u043d\u043d\u0430\u044f \u041e\u0448\u043c\u0430",
      "longitude":92.2368169,
      "latitude":57.823598
    },
    "6634":{
      "name":"\u0423\u0441\u0442\u044c-\u0428\u0443\u0448\u044c",
      "longitude":92.2411723,
      "latitude":53.906557
    },
    "6635":{
      "name":"\u041c\u0435\u043d\u0437\u043e\u0442",
      "longitude":92.2431501,
      "latitude":54.5603021
    },
    "6636":{
      "name":"\u0425\u043c\u0435\u043b\u044c\u043d\u0438\u043a\u0438",
      "longitude":92.2567885,
      "latitude":55.9162545
    },
    "6637":{
      "name":"\u041f\u0440\u0443\u0442\u043e\u0432\u0430\u044f",
      "longitude":92.2718568,
      "latitude":58.3910247
    },
    "6638":{
      "name":"\u0421\u0440\u0435\u0434\u043d\u044f\u044f \u0421\u0430\u043b\u0431\u0430",
      "longitude":92.3068683,
      "latitude":54.1881528
    },
    "6639":{
      "name":"\u0414\u043e\u043b\u0433\u043e\u0432\u043e",
      "longitude":92.3142419,
      "latitude":57.7328359
    },
    "6640":{
      "name":"\u0412\u0430\u0441\u0438\u043b\u044c\u0435\u0432\u043a\u0430",
      "longitude":92.3348028,
      "latitude":54.5475255
    },
    "6641":{
      "name":"\u0416\u0435\u0440\u043b\u044b\u043a",
      "longitude":92.3389145,
      "latitude":53.7726496
    },
    "6642":{
      "name":"\u0428\u0430\u0433\u0438\u0440\u0438\u0441\u043b\u0430\u043c",
      "longitude":92.343025,
      "latitude":57.5042746
    },
    "6643":{
      "name":"\u041c\u0430\u0439\u0441\u043a\u043e\u0435 \u0423\u0442\u0440\u043e",
      "longitude":92.346472,
      "latitude":53.6964315
    },
    "6644":{
      "name":"\u0421\u043c\u043e\u043b\u0435\u043d\u043a\u0430",
      "longitude":92.348396,
      "latitude":55.235294
    },
    "6645":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0435\u0431\u0435\u043b\u044c\u0441\u043a",
      "longitude":92.3537362,
      "latitude":58.1007
    },
    "6646":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u0418\u0434\u0440\u0430",
      "longitude":92.3618833,
      "latitude":54.356093
    },
    "6647":{
      "name":"\u0412\u0435\u0441\u0451\u043b\u044b\u0435 \u041a\u043b\u044e\u0447\u0438",
      "longitude":92.3678409,
      "latitude":53.4485935
    },
    "6648":{
      "name":"\u0415\u043b\u0435\u043d\u0438\u043d\u0441\u043a",
      "longitude":92.3772959,
      "latitude":54.506034
    },
    "6649":{
      "name":"\u041a\u0435\u043c\u0441\u043a\u0438\u0439",
      "longitude":92.380554,
      "latitude":57.9422667
    },
    "6650":{
      "name":"\u041a\u0443\u0437\u044c\u043c\u043e\u0432\u043a\u0430",
      "longitude":92.3833329,
      "latitude":62.983333
    },
    "6651":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u0415\u043b\u043e\u0432\u0430\u044f",
      "longitude":92.3860212,
      "latitude":56.1267121
    },
    "6652":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":92.386714,
      "latitude":57.954109
    },
    "6653":{
      "name":"\u0417\u0430\u0440\u0435\u0447\u043d\u044b\u0439",
      "longitude":92.3869901,
      "latitude":54.05342
    },
    "6654":{
      "name":"\u0424\u0438\u043b\u0438\u043f\u043f\u043e\u0432\u043a\u0430",
      "longitude":92.397333,
      "latitude":57.939855
    },
    "6655":{
      "name":"\u041a\u043e\u043c\u0441\u043e\u043c\u043e\u043b\u044c\u0441\u043a\u0438\u0439",
      "longitude":92.3999209,
      "latitude":54.2897022
    },
    "6656":{
      "name":"\u0421\u043d\u0435\u0436\u043d\u0438\u0446\u0430",
      "longitude":92.4062462,
      "latitude":56.0920192
    },
    "6657":{
      "name":"\u041c\u0435\u0434\u0432\u0435\u0434\u0430",
      "longitude":92.4070841,
      "latitude":56.5085984
    },
    "6658":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u0420\u0435\u0447\u043a\u0430",
      "longitude":92.416367,
      "latitude":53.037533
    },
    "6659":{
      "name":"\u0411\u0430\u0445\u0442\u0430",
      "longitude":92.4168302,
      "latitude":55.7393108
    },
    "6660":{
      "name":"\u0410\u0434\u0440\u0438\u0445\u0430",
      "longitude":92.4184443,
      "latitude":54.4243631
    },
    "6661":{
      "name":"\u042e\u0436\u0430\u043a\u043e\u0432\u043e",
      "longitude":92.4231715,
      "latitude":58.3619288
    },
    "6662":{
      "name":"\u0413\u043b\u0430\u0434\u043a\u043e\u0435",
      "longitude":92.4278557,
      "latitude":56.3560154
    },
    "6663":{
      "name":"\u0421\u0443\u0445\u0430\u044f",
      "longitude":92.4373493,
      "latitude":56.2164429
    },
    "6664":{
      "name":"\u041d\u043e\u0432\u043e\u043d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u0441\u043a\u043e\u0435",
      "longitude":92.4381897,
      "latitude":57.8712736
    },
    "6665":{
      "name":"\u0411\u0430\u0439\u043a\u0430\u043b",
      "longitude":92.4383768,
      "latitude":58.337994
    },
    "6666":{
      "name":"\u0417\u0435\u0437\u0435\u0437\u0438\u043d\u043e",
      "longitude":92.442711,
      "latitude":54.562466
    },
    "6667":{
      "name":"\u0412\u043e\u043b\u043e\u043a\u043e\u0432\u043e\u0435",
      "longitude":92.4458731,
      "latitude":57.6579231
    },
    "6668":{
      "name":"\u041f\u0435\u0441\u043e\u0447\u043d\u044b\u0439",
      "longitude":92.4490648,
      "latitude":53.267245
    },
    "6669":{
      "name":"\u041a\u0430\u043c\u0435\u043d\u0441\u043a",
      "longitude":92.4656772,
      "latitude":58.3432814
    },
    "6670":{
      "name":"\u0425\u043e\u043b\u043c\u043e\u0432\u0430\u044f",
      "longitude":92.4690898,
      "latitude":57.6505273
    },
    "6671":{
      "name":"\u0418\u0433\u043d\u0430\u0442\u043e\u0432\u043e",
      "longitude":92.4691201,
      "latitude":57.616889
    },
    "6672":{
      "name":"\u041f\u0440\u0443\u0434\u043d\u044b\u0439",
      "longitude":92.4758386,
      "latitude":53.9991774
    },
    "6673":{
      "name":"\u0423\u0441\u043a\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":92.4782396,
      "latitude":57.5675345
    },
    "6674":{
      "name":"\u041f\u043e\u0434\u043e\u043b\u043a\u0430",
      "longitude":92.4884132,
      "latitude":56.3367388
    },
    "6675":{
      "name":"\u0420\u0430\u043c\u0435\u043d\u0441\u043a\u043e\u0435",
      "longitude":92.5026233,
      "latitude":57.5838437
    },
    "6676":{
      "name":"\u041a\u0443\u0440\u0442\u044e\u043b",
      "longitude":92.522133,
      "latitude":55.03817
    },
    "6677":{
      "name":"\u0412\u0435\u0447\u0435\u0440\u043d\u0438\u0446\u044b",
      "longitude":92.5327944,
      "latitude":56.3253933
    },
    "6678":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u0421\u0443\u044d\u0442\u0443\u043a",
      "longitude":92.534996,
      "latitude":53.462536
    },
    "6679":{
      "name":"\u0417\u0430\u0433\u043e\u0440\u044c\u0435",
      "longitude":92.535659,
      "latitude":54.1086878
    },
    "6680":{
      "name":"\u0422\u044b\u0436\u043d\u043e\u0432\u043a\u0430",
      "longitude":92.5395049,
      "latitude":56.4324369
    },
    "6681":{
      "name":"\u041f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":92.5484247,
      "latitude":56.4887161
    },
    "6682":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u0428\u0443\u0448\u044c",
      "longitude":92.5523627,
      "latitude":54.156854
    },
    "6683":{
      "name":"\u0422\u0443\u0431\u0430",
      "longitude":92.5621638,
      "latitude":53.8231503
    },
    "6684":{
      "name":"\u0420\u0443\u0434\u0438\u043a\u043e\u0432\u043a\u0430",
      "longitude":92.56308,
      "latitude":58.195572
    },
    "6685":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u043c\u043e\u043b\u0438\u043d\u043e",
      "longitude":92.5690113,
      "latitude":53.5618136
    },
    "6686":{
      "name":"\u0411\u043e\u0433\u0434\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":92.5951352,
      "latitude":57.7981526
    },
    "6687":{
      "name":"\u0422\u0430\u0433\u0430\u0448\u0435\u0442",
      "longitude":92.602056,
      "latitude":54.1880659
    },
    "6688":{
      "name":"\u0420\u0430\u0441\u043a\u0430\u0442\u044b",
      "longitude":92.6025993,
      "latitude":56.2993956
    },
    "6689":{
      "name":"\u041c\u0443\u0436\u0438\u0447\u043a\u0438\u043d\u043e",
      "longitude":92.6067453,
      "latitude":56.2606381
    },
    "6690":{
      "name":"\u0411\u043e\u0440\u043b\u043e\u043a",
      "longitude":92.6155599,
      "latitude":56.3465109
    },
    "6691":{
      "name":"\u0421\u0443\u0432\u043e\u0440\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":92.6221542,
      "latitude":60.5818838
    },
    "6692":{
      "name":"\u041f\u0430\u043d\u0438\u0446\u0430",
      "longitude":92.633333,
      "latitude":62.966667
    },
    "6693":{
      "name":"\u041c\u0430\u043b\u044b\u0435 \u041a\u043d\u044b\u0448\u0438",
      "longitude":92.6378946,
      "latitude":54.323073
    },
    "6694":{
      "name":"\u0427\u0443\u0431\u0447\u0438\u043a\u043e\u0432\u043e",
      "longitude":92.6457454,
      "latitude":53.5404442
    },
    "6695":{
      "name":"\u0429\u0435\u043b\u043a\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":92.6556774,
      "latitude":57.4971448
    },
    "6696":{
      "name":"\u0413\u0430\u043c\u0443\u0440\u0438\u043d\u043e",
      "longitude":92.6557841,
      "latitude":57.3971962
    },
    "6697":{
      "name":"\u0422\u044e\u043b\u044e\u043f\u0442\u0430",
      "longitude":92.658806,
      "latitude":55.103237
    },
    "6698":{
      "name":"\u042f\u0441\u043d\u0430\u044f \u041f\u043e\u043b\u044f\u043d\u0430",
      "longitude":92.6594958,
      "latitude":56.3107505
    },
    "6699":{
      "name":"\u041a\u0443\u0440\u043a\u0438\u043d\u043e",
      "longitude":92.6619062,
      "latitude":53.4915615
    },
    "6700":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u0435 \u0417\u043d\u0430\u043c\u044f",
      "longitude":92.6647254,
      "latitude":56.4457819
    },
    "6701":{
      "name":"\u041a\u043b\u044e\u0447\u0438",
      "longitude":92.6942977,
      "latitude":53.6076283
    },
    "6702":{
      "name":"\u041d\u0438\u0436\u043d\u044f\u044f \u0411\u0443\u043b\u0430\u043d\u043a\u0430",
      "longitude":92.709976,
      "latitude":53.350697
    },
    "6703":{
      "name":"\u041b\u0435\u043d\u0438\u043d\u043a\u0430",
      "longitude":92.710281,
      "latitude":56.597301
    },
    "6704":{
      "name":"\u0423\u0441\u0442\u044c-\u0417\u043e\u043b\u043e\u0442\u0430\u044f",
      "longitude":92.7201865,
      "latitude":52.0907215
    },
    "6705":{
      "name":"\u0413\u043b\u044f\u0434\u0435\u043d",
      "longitude":92.7325995,
      "latitude":56.3670087
    },
    "6706":{
      "name":"\u041f\u0440\u043e\u0441\u0442\u043e\u0440",
      "longitude":92.7613381,
      "latitude":56.3137744
    },
    "6707":{
      "name":"\u041f\u043b\u043e\u0441\u043a\u043e\u0435",
      "longitude":92.7643262,
      "latitude":56.3064199
    },
    "6708":{
      "name":"\u0421\u043e\u0442\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":92.7650158,
      "latitude":58.0690268
    },
    "6709":{
      "name":"\u0428\u0430\u043b\u0430\u0433\u0438\u043d\u043e",
      "longitude":92.7683224,
      "latitude":53.5254372
    },
    "6710":{
      "name":"\u041f\u043e\u043d\u0430\u0447\u0435\u0432\u043e",
      "longitude":92.7780343,
      "latitude":54.124129
    },
    "6711":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u044f\u044f \u0411\u0443\u043b\u0430\u043d\u043a\u0430",
      "longitude":92.779182,
      "latitude":53.377396
    },
    "6712":{
      "name":"\u0415\u043d\u0442\u0430\u0443\u043b\u044c",
      "longitude":92.7917055,
      "latitude":56.9060002
    },
    "6713":{
      "name":"\u0427\u0443\u043c\u043d\u0438\u0446\u0430",
      "longitude":92.7925062,
      "latitude":57.6342967
    },
    "6714":{
      "name":"\u041e\u0431\u044a\u0435\u0434\u0438\u043d\u0435\u043d\u0438\u0435",
      "longitude":92.7943685,
      "latitude":56.3063605
    },
    "6715":{
      "name":"\u0414\u043e\u043b\u0433\u0430\u043d\u044b",
      "longitude":92.7999999,
      "latitude":70.666667
    },
    "6716":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u041a\u0435\u0431\u0435\u0436",
      "longitude":92.8125188,
      "latitude":53.2434874
    },
    "6717":{
      "name":"\u0428\u043e\u0448\u043a\u0438\u043d\u043e",
      "longitude":92.816055,
      "latitude":56.583721
    },
    "6718":{
      "name":"\u0423\u0440\u0430\u043b\u044c\u0441\u043a\u0430\u044f",
      "longitude":92.8170915,
      "latitude":54.0420889
    },
    "6719":{
      "name":"\u041d\u0438\u0436\u043d\u044f\u044f \u0411\u044b\u0441\u0442\u0440\u0430\u044f",
      "longitude":92.8180195,
      "latitude":54.2186832
    },
    "6720":{
      "name":"\u0411\u0443\u043b\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":92.8196699,
      "latitude":56.4798744
    },
    "6721":{
      "name":"\u0421\u043c\u043e\u0440\u043e\u0434\u0438\u043d\u043a\u0430",
      "longitude":92.8288586,
      "latitude":58.1355752
    },
    "6722":{
      "name":"\u041a\u0430\u0437\u0430\u043d\u043a\u0430",
      "longitude":92.8313124,
      "latitude":57.0281638
    },
    "6723":{
      "name":"\u0427\u0435\u0440\u043d\u0438\u0433\u043e\u0432\u043a\u0430",
      "longitude":92.8343416,
      "latitude":53.2712703
    },
    "6724":{
      "name":"\u041f\u043e\u0434\u0433\u043e\u0440\u043d\u044b\u0439",
      "longitude":92.8497047,
      "latitude":53.8483708
    },
    "6725":{
      "name":"\u0422\u043e\u043c\u0438\u043b\u043e\u0432\u043a\u0430",
      "longitude":92.8595798,
      "latitude":57.5445066
    },
    "6726":{
      "name":"\u0417\u0430\u043c\u044f\u0442\u0438\u043d\u043e",
      "longitude":92.8778517,
      "latitude":56.1794314
    },
    "6727":{
      "name":"\u041a\u0435\u043c\u0441\u043a\u043e\u0435",
      "longitude":92.8933264,
      "latitude":57.394479
    },
    "6728":{
      "name":"\u0425\u043c\u0435\u043b\u0451\u0432\u043e",
      "longitude":92.8943397,
      "latitude":56.8166811
    },
    "6729":{
      "name":"\u0418\u0440\u0431\u0430",
      "longitude":92.9051275,
      "latitude":53.9744136
    },
    "6730":{
      "name":"\u0427\u0451\u0440\u043d\u0430\u044f \u0420\u0435\u0447\u043a\u0430",
      "longitude":92.9090698,
      "latitude":53.146725
    },
    "6731":{
      "name":"\u0423\u0441\u0442\u044c-\u0422\u0443\u043d\u0433\u0443\u0441\u043a\u0430",
      "longitude":92.9149302,
      "latitude":58.1188968
    },
    "6732":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":92.925063,
      "latitude":56.8959009
    },
    "6733":{
      "name":"\u041a\u0440\u0443\u0442\u043e\u0439 \u041b\u043e\u0433",
      "longitude":92.9393189,
      "latitude":58.0409772
    },
    "6734":{
      "name":"\u041f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":92.9509914,
      "latitude":53.1859639
    },
    "6735":{
      "name":"\u0428\u0438\u0440\u043e\u043a\u0438\u0439 \u041b\u043e\u0433",
      "longitude":92.9598537,
      "latitude":58.0740506
    },
    "6736":{
      "name":"\u0421\u0440\u0435\u0434\u043d\u0438\u0439 \u041a\u0443\u0436\u0435\u0431\u0430\u0440",
      "longitude":92.9708971,
      "latitude":53.4878241
    },
    "6737":{
      "name":"\u041a\u0430\u0440\u0433\u0438\u043d\u043e",
      "longitude":92.974804,
      "latitude":58.0038755
    },
    "6738":{
      "name":"\u0415\u043d\u0430\u0448\u0438\u043c\u043e",
      "longitude":92.9755523,
      "latitude":60.2520955
    },
    "6739":{
      "name":"\u041a\u043d\u044f\u0437\u0435\u0432\u043a\u0430",
      "longitude":92.977272,
      "latitude":56.636398
    },
    "6740":{
      "name":"\u041f\u0440\u0438\u0434\u043e\u0440\u043e\u0436\u043d\u044b\u0439",
      "longitude":92.9790492,
      "latitude":56.2266741
    },
    "6741":{
      "name":"\u0423\u0440\u043c\u0430\u043d",
      "longitude":92.980743,
      "latitude":55.551231
    },
    "6742":{
      "name":"\u041f\u043e\u0433\u043e\u0440\u0435\u043b\u043a\u0430",
      "longitude":92.9869328,
      "latitude":56.3406185
    },
    "6743":{
      "name":"\u0420\u043e\u0434\u043d\u0438\u043a\u043e\u0432\u044b\u0439",
      "longitude":92.9920362,
      "latitude":56.4163237
    },
    "6744":{
      "name":"\u0422\u0430\u043b\u043e\u0432\u043a\u0430",
      "longitude":92.998849,
      "latitude":53.3596014
    },
    "6745":{
      "name":"\u0411\u0435\u0440\u0435\u0442\u044c",
      "longitude":93.00235,
      "latitude":55.691589
    },
    "6746":{
      "name":"\u0421\u0430\u0432\u0438\u043d\u043e",
      "longitude":93.0033684,
      "latitude":58.014125
    },
    "6747":{
      "name":"\u041d\u043e\u0432\u043e\u0442\u0440\u043e\u0438\u0446\u043a\u043e\u0435",
      "longitude":93.024109,
      "latitude":56.660069
    },
    "6748":{
      "name":"\u0421\u0443\u0445\u0430\u043d\u043e\u0432\u043e",
      "longitude":93.0326459,
      "latitude":56.3445877
    },
    "6749":{
      "name":"\u0412\u0435\u0440\u0445\u043e\u0431\u0440\u043e\u0434\u043e\u0432\u043e",
      "longitude":93.0330108,
      "latitude":56.830077
    },
    "6750":{
      "name":"\u0423\u0441\u0442\u044c-\u0410\u043d\u0433\u0430\u0440\u0441\u043a",
      "longitude":93.0429397,
      "latitude":58.1042399
    },
    "6751":{
      "name":"\u041a\u0443\u0440\u043e\u043c\u0431\u0430",
      "longitude":93.0479335,
      "latitude":61.0782748
    },
    "6752":{
      "name":"\u0411\u0440\u043e\u0434",
      "longitude":93.071671,
      "latitude":55.662899
    },
    "6753":{
      "name":"\u0428\u0435\u0441\u0442\u0430\u043a\u043e\u0432\u043e",
      "longitude":93.074417,
      "latitude":56.640129
    },
    "6754":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u041a\u043e\u0440\u0434\u043e\u043d",
      "longitude":93.0762468,
      "latitude":54.0684127
    },
    "6755":{
      "name":"\u0427\u0435\u0440\u043d\u044f\u0435\u0432\u043a\u0430",
      "longitude":93.0974453,
      "latitude":57.2390026
    },
    "6756":{
      "name":"\u0412\u0435\u0440\u0445-\u041f\u043e\u0434\u044a\u0451\u043c\u043d\u0430\u044f",
      "longitude":93.1066536,
      "latitude":56.780574
    },
    "6757":{
      "name":"\u041b\u0443\u043a\u0438\u043d\u043e",
      "longitude":93.108688,
      "latitude":55.945705
    },
    "6758":{
      "name":"\u0427\u0435\u0440\u0432\u0438\u0437\u044e\u043b\u044c",
      "longitude":93.1240254,
      "latitude":53.217734
    },
    "6759":{
      "name":"\u0418\u0440\u043a\u0443\u0442\u0441\u043a\u043e\u0435",
      "longitude":93.1245498,
      "latitude":56.3760469
    },
    "6760":{
      "name":"\u041c\u0438\u043d\u0436\u0443\u043b\u044c",
      "longitude":93.1368924,
      "latitude":56.2710906
    },
    "6761":{
      "name":"\u0411\u043e\u0431\u0440\u043e\u0432\u043a\u0430",
      "longitude":93.1422564,
      "latitude":57.3211077
    },
    "6762":{
      "name":"\u0410\u043d\u0434\u0440\u0435\u0435\u0432 \u041a\u043b\u044e\u0447",
      "longitude":93.1537197,
      "latitude":54.0639387
    },
    "6763":{
      "name":"\u041c\u0430\u043b\u043e\u0440\u043e\u0441\u0441\u0438\u0439\u043a\u0430",
      "longitude":93.1715499,
      "latitude":57.0927011
    },
    "6764":{
      "name":"\u041e\u0440\u043b\u043e\u0432\u043a\u0430",
      "longitude":93.1890152,
      "latitude":57.2635199
    },
    "6765":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0435 \u041a\u0443\u0440\u044f\u0442\u044b",
      "longitude":93.1934687,
      "latitude":53.7337027
    },
    "6766":{
      "name":"\u0411\u0435\u0440\u0435\u0437\u043d\u044f\u043a\u0438",
      "longitude":93.1947043,
      "latitude":57.5587229
    },
    "6767":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":93.2018746,
      "latitude":53.4414605
    },
    "6768":{
      "name":"\u041a\u043e\u0432\u0440\u0438\u0433\u0438\u043d\u043e",
      "longitude":93.209106,
      "latitude":56.622837
    },
    "6769":{
      "name":"\u0421\u0432\u0438\u0449\u0435\u0432\u043e",
      "longitude":93.212807,
      "latitude":55.884613
    },
    "6770":{
      "name":"\u0422\u0430\u0442\u0430\u0440\u0441\u043a\u0430\u044f",
      "longitude":93.2155857,
      "latitude":56.3152205
    },
    "6771":{
      "name":"\u041c\u0430\u0440\u0430\u043b\u0441\u043e\u0432\u0445\u043e\u0437",
      "longitude":93.2200685,
      "latitude":52.2356329
    },
    "6772":{
      "name":"\u0412\u043e\u0434\u043e\u0440\u0435\u0437\u043e\u0432\u043e",
      "longitude":93.233228,
      "latitude":57.5874693
    },
    "6773":{
      "name":"\u0425\u0443\u0434\u043e\u043d\u043e\u0433\u043e\u0432\u043e",
      "longitude":93.2333961,
      "latitude":56.1650844
    },
    "6774":{
      "name":"\u041c\u0430\u0433\u0430\u043d\u0441\u043a\u0438\u0439",
      "longitude":93.23452,
      "latitude":55.873116
    },
    "6775":{
      "name":"\u0417\u044b\u0440\u044f\u043d\u043a\u0430",
      "longitude":93.242226,
      "latitude":57.731316
    },
    "6776":{
      "name":"\u0421\u0435\u0440\u0435\u0431\u0440\u044f\u043a\u043e\u0432\u043e",
      "longitude":93.2492239,
      "latitude":56.2136788
    },
    "6777":{
      "name":"\u041a\u0443\u0440\u0431\u0430\u0442\u043e\u0432\u043e",
      "longitude":93.2505634,
      "latitude":57.7429113
    },
    "6778":{
      "name":"\u0422\u0430\u0440\u0442\u0430\u0437\u044f\u043a",
      "longitude":93.2543581,
      "latitude":54.1273688
    },
    "6779":{
      "name":"\u041b\u043e\u043f\u0430\u0442\u0438\u043d\u043e",
      "longitude":93.25457,
      "latitude":55.955997
    },
    "6780":{
      "name":"\u0413\u0430\u0432\u0430\u043d\u044c",
      "longitude":93.2587793,
      "latitude":57.7576667
    },
    "6781":{
      "name":"\u041d\u0438\u0436\u043d\u0435\u0435 \u041a\u043e\u043c\u0430\u0440\u043e\u0432\u043e",
      "longitude":93.2632639,
      "latitude":56.8848665
    },
    "6782":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u044f\u044f \u041c\u0443\u043b\u044c\u0433\u0430",
      "longitude":93.2657555,
      "latitude":54.1681759
    },
    "6783":{
      "name":"\u041f\u0438\u043e\u043d\u0435\u0440\u0441\u043a",
      "longitude":93.2678657,
      "latitude":54.315384
    },
    "6784":{
      "name":"\u041f\u043e\u0440\u043e\u0433",
      "longitude":93.2684345,
      "latitude":57.4541484
    },
    "6785":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u0430\u044f \u0421\u0438\u0431\u0438\u0440\u044c",
      "longitude":93.27063,
      "latitude":55.931656
    },
    "6786":{
      "name":"\u041a\u0430\u0440\u044b\u043c\u0441\u043a\u0430\u044f",
      "longitude":93.2865352,
      "latitude":56.336036
    },
    "6787":{
      "name":"\u0415\u0441\u0430\u0443\u043b\u043e\u0432\u043a\u0430",
      "longitude":93.286888,
      "latitude":56.100647
    },
    "6788":{
      "name":"\u0416\u0438\u0441\u0442\u044b\u043a",
      "longitude":93.288963,
      "latitude":55.712189
    },
    "6789":{
      "name":"\u0423\u0441\u0442\u044c-\u041a\u0430\u0441\u043f\u0430",
      "longitude":93.2891168,
      "latitude":54.1924645
    },
    "6790":{
      "name":"\u0421\u0430\u043c\u043a\u043e\u0432\u043e",
      "longitude":93.2931413,
      "latitude":57.6033124
    },
    "6791":{
      "name":"\u0416\u0435\u0440\u0436\u0443\u043b",
      "longitude":93.2956494,
      "latitude":55.4013499
    },
    "6792":{
      "name":"\u042f\u0437\u0430\u0435\u0432\u043a\u0430",
      "longitude":93.298309,
      "latitude":57.324158
    },
    "6793":{
      "name":"\u041f\u043e\u0434\u043f\u043e\u0440\u043e\u0436\u044c\u0435",
      "longitude":93.3026075,
      "latitude":57.5280824
    },
    "6794":{
      "name":"\u041b\u0443\u0433\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":93.3038656,
      "latitude":57.3039884
    },
    "6795":{
      "name":"\u041c\u0443\u0440\u0430\u0442\u043e\u0432\u043e",
      "longitude":93.3059775,
      "latitude":57.1884257
    },
    "6796":{
      "name":"\u0411\u0443\u0437\u0443\u043d\u043e\u0432\u043e",
      "longitude":93.3244975,
      "latitude":56.7012277
    },
    "6797":{
      "name":"\u041c\u0438\u043d\u0441\u043a",
      "longitude":93.3343983,
      "latitude":57.099061
    },
    "6798":{
      "name":"\u0422\u0430\u0442\u0430\u0440\u043a\u0430",
      "longitude":93.351791,
      "latitude":58.189266
    },
    "6799":{
      "name":"\u0414\u0436\u043e\u0442\u043a\u0430",
      "longitude":93.3550968,
      "latitude":54.6708157
    },
    "6800":{
      "name":"\u041c\u0430\u043b\u044b\u0439 \u0423\u043d\u0433\u0443\u0442",
      "longitude":93.3592153,
      "latitude":55.4452674
    },
    "6801":{
      "name":"\u0411\u0435\u0440\u0435\u0433\u043e\u0432\u0430\u044f-\u041f\u043e\u0434\u044a\u0451\u043c\u043d\u0430\u044f",
      "longitude":93.3767118,
      "latitude":56.9124075
    },
    "6802":{
      "name":"\u041a\u043e\u0440\u0434\u043e\u043d",
      "longitude":93.3770227,
      "latitude":68.4407563
    },
    "6803":{
      "name":"\u041a\u0443\u0432\u0430\u0440\u0448\u0438\u043d\u043e",
      "longitude":93.3772702,
      "latitude":56.2461369
    },
    "6804":{
      "name":"\u0422\u043e\u043b\u0441\u0442\u043e\u043c\u044b\u0441\u043e\u0432\u043e",
      "longitude":93.377778,
      "latitude":56.415791
    },
    "6805":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u044f\u044f \u0411\u0430\u0437\u0430\u0438\u0445\u0430",
      "longitude":93.386009,
      "latitude":55.689137
    },
    "6806":{
      "name":"\u0410\u043d\u0430\u0441\u0442\u0430\u0441\u0438\u043d\u043e",
      "longitude":93.3920342,
      "latitude":55.1242796
    },
    "6807":{
      "name":"\u0421\u043e\u0440\u043e\u043a\u0438\u043d\u043e",
      "longitude":93.3926631,
      "latitude":55.8825752
    },
    "6808":{
      "name":"\u0422\u0430\u0433\u0435\u043d\u0430\u0440\u0441\u043a\u043e\u0435",
      "longitude":93.4,
      "latitude":70.833333
    },
    "6809":{
      "name":"\u0411\u0430\u0440\u0430\u0431\u0430\u043d\u043e\u0432\u043e",
      "longitude":93.423683,
      "latitude":56.286957
    },
    "6810":{
      "name":"\u0412\u0435\u043b\u044c\u043c\u043e",
      "longitude":93.4258598,
      "latitude":61.0177997
    },
    "6811":{
      "name":"\u0421\u0430\u043c\u0430\u0440\u043a\u0430",
      "longitude":93.430001,
      "latitude":55.8842204
    },
    "6812":{
      "name":"\u0414\u0436\u0435\u0431\u044c",
      "longitude":93.4313816,
      "latitude":54.4866885
    },
    "6813":{
      "name":"\u041c\u0430\u0440\u0430\u043b\u044c\u0441\u043a\u0438\u0439",
      "longitude":93.4555359,
      "latitude":52.255909
    },
    "6814":{
      "name":"\u041f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":93.4565884,
      "latitude":57.1584142
    },
    "6815":{
      "name":"\u041a\u0438\u0437\u0435\u043d\u0436\u0443\u043b\u044c",
      "longitude":93.4570277,
      "latitude":55.7727367
    },
    "6816":{
      "name":"\u041f\u0440\u0430\u0432\u044b\u0439",
      "longitude":93.4752039,
      "latitude":55.8632398
    },
    "6817":{
      "name":"\u041d\u043e\u0432\u043e\u0435\u0440\u0443\u0434\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":93.4843041,
      "latitude":59.7833367
    },
    "6818":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u0435\u043b\u044c\u0441\u043a",
      "longitude":93.4875775,
      "latitude":55.829796
    },
    "6819":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u041a\u0443\u0441\u043a\u0443\u043d\u043a\u0430",
      "longitude":93.489906,
      "latitude":55.965443
    },
    "6820":{
      "name":"\u0421\u043f\u0438\u0440\u0438\u043d\u043e",
      "longitude":93.4954481,
      "latitude":55.100278
    },
    "6821":{
      "name":"\u041c\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":93.4985152,
      "latitude":53.7900457
    },
    "6822":{
      "name":"\u0410\u0433\u0430\u0442\u0430",
      "longitude":93.5005345,
      "latitude":66.9334292
    },
    "6823":{
      "name":"\u0411\u0435\u0440\u0435\u0433 \u0422\u0430\u0441\u043a\u0438\u043d\u043e",
      "longitude":93.5233252,
      "latitude":56.7950731
    },
    "6824":{
      "name":"\u041d\u043e\u0432\u043e\u0432\u0430\u0441\u0438\u043b\u044c\u0435\u0432\u043a\u0430",
      "longitude":93.5272083,
      "latitude":55.2590616
    },
    "6825":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0435\u0448\u0430\u043b\u0438\u043d\u0441\u043a\u043e\u0435",
      "longitude":93.5427043,
      "latitude":55.6889054
    },
    "6826":{
      "name":"\u0427\u0438\u0441\u0442\u043e\u043f\u043e\u043b\u043a\u0430",
      "longitude":93.5550798,
      "latitude":57.482922
    },
    "6827":{
      "name":"\u041c\u0430\u043b\u043e\u0435 \u041d\u0430\u0445\u0432\u0430\u043b\u044c\u0441\u043a\u043e\u0435",
      "longitude":93.563611,
      "latitude":56.7074659
    },
    "6828":{
      "name":"\u041a\u043e\u0437\u044c\u043c\u043e-\u0414\u0435\u043c\u044c\u044f\u043d\u043e\u0432\u043a\u0430",
      "longitude":93.5663667,
      "latitude":57.1384017
    },
    "6829":{
      "name":"\u041a\u0435\u043a\u0443\u0440",
      "longitude":93.5762719,
      "latitude":56.6166475
    },
    "6830":{
      "name":"\u041a\u0443\u0441\u043a\u0443\u043d",
      "longitude":93.57962,
      "latitude":55.95187
    },
    "6831":{
      "name":"\u0422\u0440\u043e\u0438\u0446\u043a\u043e\u0435",
      "longitude":93.5801593,
      "latitude":57.0763463
    },
    "6832":{
      "name":"\u041d\u043e\u0432\u043e\u0430\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":93.6011073,
      "latitude":55.4955834
    },
    "6833":{
      "name":"\u041a\u0443\u0431\u0435\u0438\u043d\u043a\u0430",
      "longitude":93.6178233,
      "latitude":55.6560855
    },
    "6834":{
      "name":"\u0414\u0435\u043c\u0435\u043d\u0442\u044c\u0435\u0432\u043a\u0430",
      "longitude":93.6186758,
      "latitude":57.6186492
    },
    "6835":{
      "name":"\u0417\u043e\u043b\u043e\u0442\u043e\u0439 \u041a\u043b\u044e\u0447",
      "longitude":93.6260837,
      "latitude":57.3652305
    },
    "6836":{
      "name":"\u0428\u0438\u0440\u043e\u043a\u043e\u0432\u043e",
      "longitude":93.6372066,
      "latitude":57.579123
    },
    "6837":{
      "name":"\u041f\u0438\u043c\u0438\u044f",
      "longitude":93.6422717,
      "latitude":55.3640343
    },
    "6838":{
      "name":"\u0420\u0443\u0447\u0435\u0439\u043a\u0438",
      "longitude":93.6658932,
      "latitude":55.8589655
    },
    "6839":{
      "name":"\u0416\u0430\u0439\u043c\u0430",
      "longitude":93.6739349,
      "latitude":54.83853
    },
    "6840":{
      "name":"\u0416\u0430\u0439\u043c\u0430",
      "longitude":93.6823486,
      "latitude":54.8462313
    },
    "6841":{
      "name":"\u0410\u0431\u0430\u043a\u0448\u0438\u043d\u043e",
      "longitude":93.6895483,
      "latitude":56.5729919
    },
    "6842":{
      "name":"\u0418\u0441\u0442\u043e\u043a",
      "longitude":93.7021433,
      "latitude":56.602612
    },
    "6843":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u0411\u0430\u043b\u0447\u0443\u0433",
      "longitude":93.7133064,
      "latitude":56.4535723
    },
    "6844":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u041a\u0430\u043c\u0430\u0440\u0447\u0430\u0433\u0430",
      "longitude":93.7212317,
      "latitude":55.7993065
    },
    "6845":{
      "name":"\u0421\u043e\u0441\u043d\u043e\u0432\u043a\u0430",
      "longitude":93.776085,
      "latitude":55.636353
    },
    "6846":{
      "name":"\u041d\u043e\u0432\u043e\u043c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":93.7770436,
      "latitude":55.5639774
    },
    "6847":{
      "name":"\u041c\u0435\u0436\u0442\u0430\u043b\u043e\u0432\u043a\u0430",
      "longitude":93.7983421,
      "latitude":57.3261307
    },
    "6848":{
      "name":"\u041a\u0438\u0440\u0437\u0430",
      "longitude":93.7989024,
      "latitude":55.111211
    },
    "6849":{
      "name":"\u0421\u0435\u0440\u0433\u0435\u0435\u0432\u043a\u0430",
      "longitude":93.7997556,
      "latitude":55.9273381
    },
    "6850":{
      "name":"\u0423\u0441\u0442\u044c-\u041a\u0430\u043d",
      "longitude":93.8010254,
      "latitude":56.5133832
    },
    "6851":{
      "name":"\u0421\u0440\u0435\u0434\u043d\u044f\u044f \u0428\u0438\u043b\u043a\u0430",
      "longitude":93.8055846,
      "latitude":57.3474647
    },
    "6852":{
      "name":"\u041f\u0438\u0442-\u0413\u043e\u0440\u043e\u0434\u043e\u043a",
      "longitude":93.819572,
      "latitude":59.304657
    },
    "6853":{
      "name":"\u041f\u0438\u043d\u0447\u0438\u043d\u043e",
      "longitude":93.8236009,
      "latitude":55.848499
    },
    "6854":{
      "name":"\u0422\u0438\u043d\u0433\u0438\u043d\u043e",
      "longitude":93.8266462,
      "latitude":55.8888765
    },
    "6855":{
      "name":"\u0421\u0443\u0433\u0440\u0438\u0441\u0442\u043e\u0435",
      "longitude":93.8523717,
      "latitude":55.5773457
    },
    "6856":{
      "name":"\u041e\u0441\u0442\u0440\u043e\u0432\u043a\u0438",
      "longitude":93.8640057,
      "latitude":55.5367408
    },
    "6857":{
      "name":"\u041f\u043e\u0434\u043f\u043e\u0440\u043e\u0433",
      "longitude":93.8900261,
      "latitude":56.4591888
    },
    "6858":{
      "name":"\u0411\u0435\u043b\u043e\u0433\u043e\u0440\u043a\u0430",
      "longitude":93.918322,
      "latitude":55.714444
    },
    "6859":{
      "name":"\u0425\u0432\u043e\u0439\u043d\u044b\u0439",
      "longitude":93.9238452,
      "latitude":55.9850907
    },
    "6860":{
      "name":"\u0416\u0430\u043d\u0434\u0430\u0442",
      "longitude":93.9289398,
      "latitude":55.8891064
    },
    "6861":{
      "name":"\u041f\u043e\u043a\u043e\u0441\u043d\u043e\u0435",
      "longitude":93.9454015,
      "latitude":55.5869317
    },
    "6862":{
      "name":"\u0422\u0443\u043d\u0433\u0443\u0441\u044b",
      "longitude":93.966667,
      "latitude":70.683333
    },
    "6863":{
      "name":"\u0425\u0430\u0431\u0430\u0439\u0434\u0430\u043a",
      "longitude":93.991554,
      "latitude":54.946812
    },
    "6864":{
      "name":"\u041d\u043e\u0432\u043e\u0433\u0435\u043e\u0440\u0433\u0438\u0435\u0432\u043a\u0430",
      "longitude":94.0010053,
      "latitude":55.6249546
    },
    "6865":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u044c\u0441\u043a\u043e\u0435",
      "longitude":94.0309725,
      "latitude":55.8985009
    },
    "6866":{
      "name":"\u0422\u0438\u0431\u0435\u0440\u043a\u0443\u043b\u044c",
      "longitude":94.0312557,
      "latitude":53.9073563
    },
    "6867":{
      "name":"\u0411\u0443\u043b\u0430\u0442\u043d\u043e\u0432\u043a\u0430",
      "longitude":94.0435981,
      "latitude":55.435328
    },
    "6868":{
      "name":"\u041a\u043e\u0439",
      "longitude":94.059402,
      "latitude":55.095379
    },
    "6869":{
      "name":"\u0420\u0435\u0447\u043a\u0430",
      "longitude":94.0652244,
      "latitude":56.0282601
    },
    "6870":{
      "name":"\u041c\u0430\u043b\u044b\u0439 \u0418\u043c\u0431\u0435\u0436",
      "longitude":94.0674223,
      "latitude":55.5361001
    },
    "6871":{
      "name":"\u041b\u0443\u043a\u043e\u0432\u043e",
      "longitude":94.0704728,
      "latitude":55.7960559
    },
    "6872":{
      "name":"\u041a\u0430\u043d\u0434\u0430\u043a\u0438",
      "longitude":94.0812778,
      "latitude":58.0059204
    },
    "6873":{
      "name":"\u0425\u0430\u0439\u0434\u0430\u043a",
      "longitude":94.0848906,
      "latitude":55.467579
    },
    "6874":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":94.088354,
      "latitude":54.9415856
    },
    "6875":{
      "name":"\u041a\u0430\u0437\u044b\u0440",
      "longitude":94.0906266,
      "latitude":53.7031519
    },
    "6876":{
      "name":"\u041a\u0435\u0440\u0430\u043c\u0438\u0447\u0435\u0441\u043a\u0438\u0439",
      "longitude":94.1075177,
      "latitude":55.9567363
    },
    "6877":{
      "name":"\u041d\u043e\u0432\u043e\u043c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":94.1076813,
      "latitude":55.7790301
    },
    "6878":{
      "name":"\u0411\u0430\u043b\u0430\u0439\u0441\u043a\u0438\u0439 \u041a\u043e\u0441\u043e\u0433\u043e\u0440",
      "longitude":94.110881,
      "latitude":55.8311321
    },
    "6879":{
      "name":"\u041c\u0430\u0440\u044c\u0435\u0432\u043a\u0430",
      "longitude":94.1455344,
      "latitude":55.853177
    },
    "6880":{
      "name":"\u0421\u0435\u043c\u0435\u043d\u043e\u0432\u043a\u0430",
      "longitude":94.1681763,
      "latitude":55.70149
    },
    "6881":{
      "name":"\u041a\u0430\u043c\u0435\u043d\u043d\u043e-\u0413\u043e\u0440\u043d\u043e\u0432\u043a\u0430",
      "longitude":94.1856069,
      "latitude":55.8851621
    },
    "6882":{
      "name":"\u0421\u043b\u044e\u0434\u0440\u0443\u0434\u043d\u0438\u043a",
      "longitude":94.1887086,
      "latitude":57.9888346
    },
    "6883":{
      "name":"\u0410\u0441\u0430\u0444\u044c\u0435\u0432\u043a\u0430",
      "longitude":94.1973494,
      "latitude":55.3894254
    },
    "6884":{
      "name":"\u0427\u0438\u0441\u0442\u044f\u043a\u0438",
      "longitude":94.20777,
      "latitude":57.9160567
    },
    "6885":{
      "name":"\u041a\u0443\u0442\u0443\u0440\u0447\u0438\u043d",
      "longitude":94.2159827,
      "latitude":54.9368562
    },
    "6886":{
      "name":"\u0410\u0440\u0433\u0430\u0437\u0430",
      "longitude":94.2285632,
      "latitude":55.2729904
    },
    "6887":{
      "name":"\u042f\u043b\u0430\u0439",
      "longitude":94.2417192,
      "latitude":57.1418093
    },
    "6888":{
      "name":"\u041b\u0435\u0442\u043e\u0432\u044c\u0435",
      "longitude":94.2499999,
      "latitude":71.333333
    },
    "6889":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u044c\u0441\u043a",
      "longitude":94.25242,
      "latitude":57.8826884
    },
    "6890":{
      "name":"\u0438\u043c\u0435\u043d\u0438 \u041a\u0440\u0430\u0432\u0447\u0435\u043d\u043a\u043e",
      "longitude":94.2717821,
      "latitude":55.3051158
    },
    "6891":{
      "name":"\u041d\u043e\u0439",
      "longitude":94.2885322,
      "latitude":55.5442978
    },
    "6892":{
      "name":"\u0412\u0430\u0439\u0432\u0438\u0434\u0430",
      "longitude":94.3266698,
      "latitude":60.8292554
    },
    "6893":{
      "name":"\u041d\u043e\u0432\u043e\u043f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":94.3331518,
      "latitude":55.3861884
    },
    "6894":{
      "name":"\u041b\u0443\u043a\u0430\u0448\u0438\u043d\u043e",
      "longitude":94.369676,
      "latitude":57.1282084
    },
    "6895":{
      "name":"\u041d\u043e\u0432\u043e\u043d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":94.371738,
      "latitude":55.627713
    },
    "6896":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":94.3859063,
      "latitude":55.7127857
    },
    "6897":{
      "name":"\u041a\u0440\u0435\u0441\u0442\u044c\u044f\u043d\u0441\u043a\u043e\u0435",
      "longitude":94.3902356,
      "latitude":55.4602477
    },
    "6898":{
      "name":"\u041a\u043e\u0440\u0441\u0430\u043a\u043e\u0432\u043e",
      "longitude":94.3926114,
      "latitude":57.0830668
    },
    "6899":{
      "name":"\u0411\u0443\u0433\u0430\u0440\u0438\u0445\u0442\u0430",
      "longitude":94.4,
      "latitude":59.733333
    },
    "6900":{
      "name":"\u0410\u043b\u0434\u0430\u0440\u0430\u043a",
      "longitude":94.4199302,
      "latitude":55.2518177
    },
    "6901":{
      "name":"\u041a\u043e\u043d\u043e\u043a",
      "longitude":94.4466968,
      "latitude":55.3185469
    },
    "6902":{
      "name":"\u041a\u0443\u0437\u044c\u043c\u0438\u043d\u043a\u0430",
      "longitude":94.4479884,
      "latitude":55.7153104
    },
    "6903":{
      "name":"\u0412\u0435\u0440\u0445-\u041a\u0430\u043d\u0430\u0440\u0430\u0439",
      "longitude":94.464039,
      "latitude":56.9849557
    },
    "6904":{
      "name":"\u041a\u043e\u043d\u043e\u043a",
      "longitude":94.492009,
      "latitude":55.4510664
    },
    "6905":{
      "name":"\u0418\u0432\u0430\u0448\u0438\u0445\u0430",
      "longitude":94.4935811,
      "latitude":55.1859626
    },
    "6906":{
      "name":"\u0412\u0430\u0445\u0440\u0443\u0448\u0435\u0432\u043e",
      "longitude":94.5051885,
      "latitude":57.2255096
    },
    "6907":{
      "name":"\u0418\u0441\u043a\u0440\u0430",
      "longitude":94.5072766,
      "latitude":56.0711686
    },
    "6908":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u041f\u0440\u0438\u043b\u0443\u043a\u0430",
      "longitude":94.5100403,
      "latitude":56.0095766
    },
    "6909":{
      "name":"\u041d\u043e\u0432\u043e\u0430\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":94.5134928,
      "latitude":55.8639618
    },
    "6910":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u041f\u0435\u0447\u0435\u0440\u0430",
      "longitude":94.5220143,
      "latitude":56.0509381
    },
    "6911":{
      "name":"\u0421\u0442\u0440\u0443\u043a\u043e\u0432\u043e",
      "longitude":94.5252755,
      "latitude":56.9896887
    },
    "6912":{
      "name":"\u0414\u0430\u043d\u0438\u043b\u043a\u0438",
      "longitude":94.5339839,
      "latitude":57.3009739
    },
    "6913":{
      "name":"\u0412\u043e\u0440\u043e\u043d\u0438\u043d\u043e",
      "longitude":94.5451522,
      "latitude":55.6703674
    },
    "6914":{
      "name":"\u041f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":94.5488377,
      "latitude":55.7227226
    },
    "6915":{
      "name":"\u041d\u043e\u0432\u043e\u043c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":94.5589143,
      "latitude":55.2852876
    },
    "6916":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u0451\u043b\u043e\u0432\u043e",
      "longitude":94.5690076,
      "latitude":55.4879156
    },
    "6917":{
      "name":"\u0411\u0430\u0442\u043e\u0432",
      "longitude":94.5902188,
      "latitude":56.8347421
    },
    "6918":{
      "name":"\u0422\u0430\u0442\u044c\u044f\u043d\u043e\u0432\u043a\u0430",
      "longitude":94.5993006,
      "latitude":55.8095121
    },
    "6919":{
      "name":"\u0423\u0441\u0442\u044c\u0435",
      "longitude":94.6170064,
      "latitude":57.7760851
    },
    "6920":{
      "name":"\u041f\u0430\u0448\u0438\u043d\u043e",
      "longitude":94.6198993,
      "latitude":58.1344588
    },
    "6921":{
      "name":"\u041a\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":94.6274175,
      "latitude":55.5300672
    },
    "6922":{
      "name":"\u041e\u0440\u043b\u043e\u0432\u043a\u0430",
      "longitude":94.6335105,
      "latitude":55.2305096
    },
    "6923":{
      "name":"\u0411\u0430\u0440\u0442\u0430\u043d\u0430\u0441",
      "longitude":94.6611732,
      "latitude":57.2575
    },
    "6924":{
      "name":"\u0412\u043b\u0430\u0441\u0442\u044c \u0422\u0440\u0443\u0434\u0430",
      "longitude":94.6703014,
      "latitude":55.8805572
    },
    "6925":{
      "name":"\u041a\u0430\u0440\u043b\u044b\u043a",
      "longitude":94.6713634,
      "latitude":55.1311103
    },
    "6926":{
      "name":"\u0428\u0443\u0434\u0440\u043e\u0432\u043e",
      "longitude":94.6747799,
      "latitude":55.3311178
    },
    "6927":{
      "name":"\u0410\u0432\u0434\u0438\u043d\u043a\u0430",
      "longitude":94.6769783,
      "latitude":55.7562213
    },
    "6928":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u0410\u0433\u0430\u0448\u0443\u043b",
      "longitude":94.6848458,
      "latitude":55.4503455
    },
    "6929":{
      "name":"\u041a\u043e\u043b\u043e\u043c\u0430",
      "longitude":94.716667,
      "latitude":70.25
    },
    "6930":{
      "name":"\u0421\u0440\u0435\u0434\u043d\u0435\u0435",
      "longitude":94.7216811,
      "latitude":57.6048614
    },
    "6931":{
      "name":"\u0422\u043e\u0447\u0438\u043b\u044c\u043d\u043e\u0435",
      "longitude":94.7225007,
      "latitude":55.8692262
    },
    "6932":{
      "name":"\u0417\u0435\u043b\u0435\u043d\u0438\u043d\u043e",
      "longitude":94.7329685,
      "latitude":55.1777531
    },
    "6933":{
      "name":"\u0421\u043d\u0435\u0433\u0438\u0440\u0435\u0432\u043a\u0430",
      "longitude":94.7351561,
      "latitude":55.5962032
    },
    "6934":{
      "name":"\u041a\u0430\u0440\u0430\u0443\u043b\u044c\u043d\u043e\u0435",
      "longitude":94.7365846,
      "latitude":57.0802179
    },
    "6935":{
      "name":"\u041a\u0430\u043d\u0430\u0440\u0430\u0439",
      "longitude":94.7373215,
      "latitude":56.9507318
    },
    "6936":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":94.7509282,
      "latitude":55.1190177
    },
    "6937":{
      "name":"\u0413\u043b\u0443\u0431\u043e\u043a\u043e\u0432\u043e",
      "longitude":94.7602573,
      "latitude":55.8586778
    },
    "6938":{
      "name":"\u0420\u0435\u0448\u0430\u044e\u0449\u0438\u0439",
      "longitude":94.7688765,
      "latitude":58.1982127
    },
    "6939":{
      "name":"\u041b\u0443\u0436\u043a\u0438",
      "longitude":94.7696,
      "latitude":57.309465
    },
    "6940":{
      "name":"\u0421\u043e\u0432\u0445\u043e\u0437\u043d\u044b\u0439",
      "longitude":94.7714081,
      "latitude":55.5028335
    },
    "6941":{
      "name":"\u041a\u0438\u0440\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":94.772586,
      "latitude":58.9118409
    },
    "6942":{
      "name":"\u0411\u0443\u0440\u043c\u0430\u043a\u0438\u043d\u043e",
      "longitude":94.7815851,
      "latitude":57.0118448
    },
    "6943":{
      "name":"\u041f\u0430\u043f\u0438\u043a\u043e\u0432\u043e",
      "longitude":94.7820894,
      "latitude":55.3777823
    },
    "6944":{
      "name":"\u041d\u043e\u0432\u044b\u0439",
      "longitude":94.785576,
      "latitude":56.7314167
    },
    "6945":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u0421\u0442\u0435\u043f\u044c",
      "longitude":94.7910913,
      "latitude":56.8832944
    },
    "6946":{
      "name":"\u041d\u043e\u0432\u043e\u0431\u043e\u0440\u043e\u0434\u0438\u043d\u043a\u0430",
      "longitude":94.7944752,
      "latitude":57.0579727
    },
    "6947":{
      "name":"\u041c\u0443\u0440\u043c\u0430",
      "longitude":94.7992104,
      "latitude":57.2835572
    },
    "6948":{
      "name":"\u0411\u0443\u0440\u043e\u0432\u043e\u0439",
      "longitude":94.8112305,
      "latitude":57.2791135
    },
    "6949":{
      "name":"\u0411\u043b\u0430\u0433\u043e\u0434\u0430\u0442\u043a\u0430",
      "longitude":94.8259704,
      "latitude":55.4907797
    },
    "6950":{
      "name":"\u0410\u0431\u0430\u043b\u0430\u043a\u043e\u0432\u043e",
      "longitude":94.8314962,
      "latitude":55.066632
    },
    "6951":{
      "name":"\u041a\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":94.8493591,
      "latitude":55.5334734
    },
    "6952":{
      "name":"\u041f\u0430\u0439\u0442\u0443\u0440\u043c\u0430",
      "longitude":94.8516784,
      "latitude":71.6196753
    },
    "6953":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u043f\u0430\u0432\u043b\u043e\u0432\u043a\u0430",
      "longitude":94.8607694,
      "latitude":55.180044
    },
    "6954":{
      "name":"\u0412\u044f\u0442\u043a\u0430",
      "longitude":94.8688614,
      "latitude":55.3473477
    },
    "6955":{
      "name":"\u0427\u0443\u0440\u0438\u043d\u043e\u0432\u043e",
      "longitude":94.8739189,
      "latitude":55.6550895
    },
    "6956":{
      "name":"\u041f\u0430\u0432\u043b\u043e\u0432\u043a\u0430",
      "longitude":94.8778716,
      "latitude":55.2429779
    },
    "6957":{
      "name":"\u0413\u043c\u0438\u0440\u044f\u043d\u043a\u0430",
      "longitude":94.8792647,
      "latitude":56.0057522
    },
    "6958":{
      "name":"\u0422\u0435\u043c\u0431\u0435\u043d\u0447\u0438",
      "longitude":94.883333,
      "latitude":66.9
    },
    "6959":{
      "name":"\u0413\u043b\u0438\u043d\u043d\u0430\u044f",
      "longitude":94.884105,
      "latitude":57.2646487
    },
    "6960":{
      "name":"\u041c\u0438\u0445\u0430\u043b\u0435\u0432\u043a\u0430",
      "longitude":94.8957914,
      "latitude":55.9526839
    },
    "6961":{
      "name":"\u0423\u0441\u0442\u044c-\u041a\u0430\u0437\u0430\u0447\u043a\u0430",
      "longitude":94.8972212,
      "latitude":56.160597
    },
    "6962":{
      "name":"\u041c\u0430\u043a\u0430\u0440\u043e\u0432\u043e",
      "longitude":94.8985716,
      "latitude":56.8174131
    },
    "6963":{
      "name":"\u041b\u044c\u043d\u043e\u0437\u0430\u0432\u043e\u0434\u0430",
      "longitude":94.9060533,
      "latitude":55.2802699
    },
    "6964":{
      "name":"\u041b\u043e\u0437\u043e\u0432\u0430\u044f",
      "longitude":94.9111523,
      "latitude":55.7784069
    },
    "6965":{
      "name":"\u0427\u0435\u0440\u0435\u043c\u0448\u0430\u043d\u043a\u0430",
      "longitude":94.9454609,
      "latitude":56.1330532
    },
    "6966":{
      "name":"\u0421\u043e\u043b\u043e\u0432\u044c\u0451\u0432\u043a\u0430",
      "longitude":94.946701,
      "latitude":55.7068401
    },
    "6967":{
      "name":"\u0423\u043d\u0435\u0440\u0447\u0438\u043a",
      "longitude":94.9543239,
      "latitude":55.5812393
    },
    "6968":{
      "name":"\u0421\u043e\u043b\u043e\u043d\u0435\u0447\u043d\u043e\u0435",
      "longitude":94.9582725,
      "latitude":55.8299876
    },
    "6969":{
      "name":"\u0411\u043e\u0440\u043a\u0438",
      "longitude":94.9596678,
      "latitude":56.9700347
    },
    "6970":{
      "name":"\u0417\u0430\u043b\u0435\u0441\u043d\u044b\u0439",
      "longitude":94.9649269,
      "latitude":56.4999808
    },
    "6971":{
      "name":"\u041a\u0443\u0440\u044b\u0448",
      "longitude":94.9717381,
      "latitude":56.6100816
    },
    "6972":{
      "name":"\u0412\u043e\u0441\u043a\u0440\u0435\u0441\u0435\u043d\u043a\u0430",
      "longitude":94.9746731,
      "latitude":55.9456693
    },
    "6973":{
      "name":"\u0423\u0441\u0442\u044c-\u041d\u0430\u043c\u0430\u043a\u0430\u043d",
      "longitude":94.976735,
      "latitude":70.6147648
    },
    "6974":{
      "name":"\u0426\u0430\u043f\u043a\u0430-\u041b\u0430\u0439\u0434\u0430",
      "longitude":94.983333,
      "latitude":70.416667
    },
    "6975":{
      "name":"\u0411\u0430\u043a\u0447\u0435\u0442",
      "longitude":94.9899172,
      "latitude":57.0566245
    },
    "6976":{
      "name":"\u041a\u0430\u043c\u0435\u043d\u044c",
      "longitude":95.0,
      "latitude":70.666667
    },
    "6977":{
      "name":"\u0411\u0430\u043b\u0430\u0433\u0430\u043d",
      "longitude":95.0018854,
      "latitude":70.5331774
    },
    "6978":{
      "name":"\u041a\u043e\u043d\u0434\u0440\u0430\u0442\u044c\u0435\u0432\u043e",
      "longitude":95.0086058,
      "latitude":56.8491873
    },
    "6979":{
      "name":"\u041d\u0438\u0437\u0438\u043d\u043a\u0430",
      "longitude":95.0234424,
      "latitude":55.8090762
    },
    "6980":{
      "name":"\u0422\u0443\u043b\u044c\u0441\u043a\u043e\u0435",
      "longitude":95.029851,
      "latitude":55.8327568
    },
    "6981":{
      "name":"\u041a\u043e\u043c\u0430\u0440\u043e\u0432\u043e",
      "longitude":95.0348759,
      "latitude":56.1880221
    },
    "6982":{
      "name":"\u0417\u0430\u0433\u043e\u0440\u0441\u043a\u0438\u0439",
      "longitude":95.0435882,
      "latitude":56.1092165
    },
    "6983":{
      "name":"\u0429\u0435\u043a\u0430\u0442\u0443\u0440\u043e\u0432\u043e",
      "longitude":95.0451422,
      "latitude":57.1876285
    },
    "6984":{
      "name":"\u041c\u0435\u0436\u0434\u0443\u0440\u0435\u0447\u043a\u0430",
      "longitude":95.0553796,
      "latitude":55.2784426
    },
    "6985":{
      "name":"\u0427\u0443\u0440\u044e\u043a\u043e\u0432\u043e",
      "longitude":95.0571136,
      "latitude":56.6298911
    },
    "6986":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":95.0579662,
      "latitude":56.0498322
    },
    "6987":{
      "name":"\u0412\u043e\u0437\u043d\u0435\u0441\u0435\u043d\u043a\u0430",
      "longitude":95.058016,
      "latitude":56.656907
    },
    "6988":{
      "name":"\u0410\u043b\u0435\u0448\u0438\u043d\u043e",
      "longitude":95.0595073,
      "latitude":56.2588738
    },
    "6989":{
      "name":"\u0421\u043a\u0430\u043a\u0430\u043b\u044c\u043d\u0430\u044f",
      "longitude":95.0599002,
      "latitude":57.1385862
    },
    "6990":{
      "name":"\u0410\u043b\u0435\u0433\u0430",
      "longitude":95.0907423,
      "latitude":56.4225179
    },
    "6991":{
      "name":"\u041b\u044e\u0431\u0430\u0432\u0430",
      "longitude":95.0969264,
      "latitude":56.3815561
    },
    "6992":{
      "name":"\u0421\u043f\u0430\u0441\u043e\u0432\u043a\u0430",
      "longitude":95.0981176,
      "latitude":56.0497127
    },
    "6993":{
      "name":"\u041a\u043e\u043b\u043e\u043d",
      "longitude":95.1078032,
      "latitude":57.017268
    },
    "6994":{
      "name":"\u0412\u0435\u0440\u0445\u043e\u0432\u0430\u044f",
      "longitude":95.1109842,
      "latitude":55.8945276
    },
    "6995":{
      "name":"\u041a\u0430\u043d-\u041e\u043a\u043b\u0435\u0440",
      "longitude":95.114989,
      "latitude":55.04016
    },
    "6996":{
      "name":"\u0422\u043e\u043f\u043e\u043b",
      "longitude":95.1197416,
      "latitude":56.9424053
    },
    "6997":{
      "name":"\u0418\u0432\u0430\u043d\u0442\u0430\u0439",
      "longitude":95.131984,
      "latitude":56.5262272
    },
    "6998":{
      "name":"\u041a\u0430\u043d",
      "longitude":95.1335016,
      "latitude":55.1600242
    },
    "6999":{
      "name":"\u0423\u0441\u0442\u044c-\u0410\u043d\u0436\u0430",
      "longitude":95.1347522,
      "latitude":55.3429547
    },
    "7000":{
      "name":"\u0420\u044f\u0431\u0438\u043d\u043a\u0438",
      "longitude":95.1500661,
      "latitude":56.0095262
    },
    "7001":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":95.1534028,
      "latitude":55.7005822
    },
    "7002":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":95.1586351,
      "latitude":56.5725986
    },
    "7003":{
      "name":"\u041b\u043e\u0449\u0438\u043d\u043a\u0430",
      "longitude":95.1611395,
      "latitude":55.7616062
    },
    "7004":{
      "name":"\u041e\u0440\u0435\u0448\u043d\u0438\u043a\u0438",
      "longitude":95.163182,
      "latitude":56.0603942
    },
    "7005":{
      "name":"\u0427\u0430\u0440\u0433\u0430",
      "longitude":95.1693033,
      "latitude":55.3834227
    },
    "7006":{
      "name":"\u0411\u0443\u0440\u043d\u044b\u0439",
      "longitude":95.1829426,
      "latitude":57.7597435
    },
    "7007":{
      "name":"\u0428\u0430\u043c\u044b",
      "longitude":95.1921819,
      "latitude":55.1488717
    },
    "7008":{
      "name":"\u041f\u0435\u0442\u0440\u0443\u0448\u043a\u0438",
      "longitude":95.230045,
      "latitude":56.1299814
    },
    "7009":{
      "name":"\u041a\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":95.2404494,
      "latitude":55.8414965
    },
    "7010":{
      "name":"\u0421\u0435\u0432\u0435\u0440\u043e-\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":95.2512401,
      "latitude":56.5285615
    },
    "7011":{
      "name":"\u041a\u0430\u043f\u0438\u0442\u043e\u043d\u043e\u0432\u043e",
      "longitude":95.2713445,
      "latitude":55.132414
    },
    "7012":{
      "name":"\u0421\u0442\u0430\u0440\u0430\u044f \u0421\u043e\u043b\u044f\u043d\u043a\u0430",
      "longitude":95.2772242,
      "latitude":56.0408495
    },
    "7013":{
      "name":"\u0421\u0443\u0445\u043e-\u0415\u0440\u0448\u0430",
      "longitude":95.306116,
      "latitude":56.5822034
    },
    "7014":{
      "name":"\u041e\u0432\u0440\u0430\u0436\u043d\u0430\u044f",
      "longitude":95.3071629,
      "latitude":56.0213
    },
    "7015":{
      "name":"\u041a\u0435\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":95.3106212,
      "latitude":56.8594556
    },
    "7016":{
      "name":"\u041c\u043e\u043a\u0440\u044b\u0439 \u0415\u043b\u044c\u043d\u0438\u043a",
      "longitude":95.3126192,
      "latitude":56.7172329
    },
    "7017":{
      "name":"\u041d\u043e\u0432\u043e\u0442\u0440\u043e\u0438\u0446\u043a",
      "longitude":95.3267337,
      "latitude":55.4577742
    },
    "7018":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":95.3294571,
      "latitude":56.1984964
    },
    "7019":{
      "name":"\u0425\u0430\u0440\u044c\u043a\u043e\u0432\u043a\u0430",
      "longitude":95.3382381,
      "latitude":56.9512876
    },
    "7020":{
      "name":"\u0427\u0435\u043c\u0443\u0440\u0430\u0439",
      "longitude":95.342222,
      "latitude":56.9065077
    },
    "7021":{
      "name":"\u041f\u0440\u0435\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043a\u0430",
      "longitude":95.3431017,
      "latitude":55.8003081
    },
    "7022":{
      "name":"\u041b\u0430\u0442\u044b\u043d\u0446\u0435\u0432\u043e",
      "longitude":95.3567502,
      "latitude":55.7261067
    },
    "7023":{
      "name":"\u0417\u0430\u0432\u0438\u0440\u043e\u0432\u043a\u0430",
      "longitude":95.3576396,
      "latitude":55.9702583
    },
    "7024":{
      "name":"\u041a\u043e\u0437\u044b\u043b\u0430",
      "longitude":95.3721875,
      "latitude":55.5777438
    },
    "7025":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":95.3738834,
      "latitude":56.6199934
    },
    "7026":{
      "name":"\u0420\u0430\u043a\u0438\u0442\u043e\u0432\u043a\u0430",
      "longitude":95.377351,
      "latitude":55.8197708
    },
    "7027":{
      "name":"\u041c\u0430\u043b\u044b\u0439 \u0418\u0440\u0431\u0435\u0439",
      "longitude":95.3774288,
      "latitude":55.6378353
    },
    "7028":{
      "name":"\u0421\u0435\u0440\u0433\u0435\u0435\u0432\u043a\u0430",
      "longitude":95.3836563,
      "latitude":55.4804774
    },
    "7029":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":95.3850101,
      "latitude":56.5455659
    },
    "7030":{
      "name":"\u0411\u0435\u043b\u043e\u044f\u0440\u0441\u043a",
      "longitude":95.4103377,
      "latitude":56.2567112
    },
    "7031":{
      "name":"\u0421\u0435\u043c\u0435\u043d\u043e\u0432\u043a\u0430",
      "longitude":95.4141767,
      "latitude":56.8390495
    },
    "7032":{
      "name":"\u041a\u0440\u0443\u0433\u043b\u043e\u0432\u043e",
      "longitude":95.4179085,
      "latitude":56.3352706
    },
    "7033":{
      "name":"\u041b\u0435\u043e\u043d\u0442\u044c\u0435\u0432\u043a\u0430",
      "longitude":95.4245722,
      "latitude":56.4541419
    },
    "7034":{
      "name":"\u0410\u043b\u044c\u0433\u0438\u043d\u043a\u0430",
      "longitude":95.4291383,
      "latitude":55.4978937
    },
    "7035":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u0423\u0440\u044f",
      "longitude":95.4308088,
      "latitude":56.1164278
    },
    "7036":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u0422\u0430\u043d\u0430\u0439",
      "longitude":95.4325597,
      "latitude":56.7221812
    },
    "7037":{
      "name":"\u041d\u043e\u0432\u043e\u0430\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":95.4501416,
      "latitude":55.4785036
    },
    "7038":{
      "name":"\u041a\u0440\u0443\u0442\u0430\u044f \u0413\u043e\u0440\u043a\u0430",
      "longitude":95.4778082,
      "latitude":56.1648049
    },
    "7039":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u0432\u043a\u0430",
      "longitude":95.4880511,
      "latitude":56.5943839
    },
    "7040":{
      "name":"\u0411\u0443\u0438\u043d\u043a\u0430",
      "longitude":95.4927718,
      "latitude":55.3054967
    },
    "7041":{
      "name":"\u0422\u0430\u043b\u043e\u0432\u0430\u044f",
      "longitude":95.4931451,
      "latitude":56.8060855
    },
    "7042":{
      "name":"\u0423\u0441\u0442\u044c-\u041a\u0430\u0439\u0442\u044b\u043c",
      "longitude":95.4982134,
      "latitude":57.3945956
    },
    "7043":{
      "name":"\u041a\u043e\u0447\u0438\u0445\u0430",
      "longitude":95.5,
      "latitude":70.566667
    },
    "7044":{
      "name":"\u041f\u043e\u043b\u044c\u043d\u043e\u0435",
      "longitude":95.5006277,
      "latitude":56.211266
    },
    "7045":{
      "name":"\u0427\u0438\u0441\u043a\u043e\u0432\u043e",
      "longitude":95.5058659,
      "latitude":64.0508709
    },
    "7046":{
      "name":"\u0417\u0435\u043b\u0451\u043d\u0430\u044f \u0414\u0443\u0431\u0440\u0430\u0432\u0430",
      "longitude":95.530756,
      "latitude":55.9136157
    },
    "7047":{
      "name":"\u041d\u0438\u0436\u043d\u0435\u0438\u0441\u0442\u043e\u043a\u0438\u043d\u043e",
      "longitude":95.5399124,
      "latitude":55.5729892
    },
    "7048":{
      "name":"\u0410\u0448\u043f\u0430\u0442\u0441\u043a",
      "longitude":95.5428327,
      "latitude":56.6847783
    },
    "7049":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u043a\u0430",
      "longitude":95.5431059,
      "latitude":55.445825
    },
    "7050":{
      "name":"\u041c\u0430\u043d\u043a\u0443\u0440",
      "longitude":95.55,
      "latitude":62.816667
    },
    "7051":{
      "name":"\u0410\u0440\u0445\u0430\u043d\u0433\u0435\u043b\u044c\u0441\u043a\u043e\u0435",
      "longitude":95.5524587,
      "latitude":56.5424566
    },
    "7052":{
      "name":"\u041f\u043b\u0438\u0442\u043d\u0430\u044f",
      "longitude":95.5569508,
      "latitude":56.7452762
    },
    "7053":{
      "name":"\u0410\u0441\u0430\u043d\u0441\u043a",
      "longitude":95.5631284,
      "latitude":57.0406931
    },
    "7054":{
      "name":"\u041f\u043e\u0434\u043e\u044f\u0439\u0441\u043a",
      "longitude":95.5662438,
      "latitude":56.2437251
    },
    "7055":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u043f\u043e\u043b\u044f\u043d\u0441\u043a",
      "longitude":95.567056,
      "latitude":56.1787936
    },
    "7056":{
      "name":"\u0414\u043e\u0440\u043e\u0436\u043d\u044b\u0439",
      "longitude":95.572778,
      "latitude":56.0498108
    },
    "7057":{
      "name":"\u041b\u0435\u0432\u043e\u0431\u0435\u0440\u0435\u0436\u043d\u043e\u0435",
      "longitude":95.5840037,
      "latitude":56.235908
    },
    "7058":{
      "name":"\u0417\u0435\u043b\u0451\u043d\u0430\u044f \u0421\u043b\u043e\u0431\u043e\u0434\u0430",
      "longitude":95.5946466,
      "latitude":55.444456
    },
    "7059":{
      "name":"\u041c\u0430\u043b\u044b\u0435 \u041f\u0440\u0443\u0434\u044b",
      "longitude":95.5948408,
      "latitude":56.1050525
    },
    "7060":{
      "name":"\u041a\u043e\u0440\u043e\u0441\u0442\u0435\u043b\u0435\u0432\u043e",
      "longitude":95.6119751,
      "latitude":55.6724377
    },
    "7061":{
      "name":"\u041e\u0440\u043b\u043e\u0432\u043a\u0430",
      "longitude":95.6189142,
      "latitude":55.8657253
    },
    "7062":{
      "name":"\u041a\u0430\u0440\u044c\u0435\u0440\u043d\u044b\u0439",
      "longitude":95.6403265,
      "latitude":56.2473942
    },
    "7063":{
      "name":"\u0425\u043e\u043c\u0443\u0442\u043e\u0432\u043e",
      "longitude":95.6715837,
      "latitude":55.7218462
    },
    "7064":{
      "name":"\u0420\u043e\u0436\u0434\u0435\u0441\u0442\u0432\u0435\u043d\u043a\u0430",
      "longitude":95.6728579,
      "latitude":55.3638088
    },
    "7065":{
      "name":"\u0422\u0430\u0433\u0430\u0448\u0438",
      "longitude":95.6827307,
      "latitude":56.5155165
    },
    "7066":{
      "name":"\u0411\u044b\u0441\u0442\u0440\u043e\u0432\u043a\u0430",
      "longitude":95.6976627,
      "latitude":56.9769577
    },
    "7067":{
      "name":"\u041d\u043e\u0448\u0438\u043d\u043e",
      "longitude":95.721275,
      "latitude":56.607788
    },
    "7068":{
      "name":"\u0412\u0430\u0441\u0438\u043b\u044c\u0435\u0432\u043a\u0430",
      "longitude":95.7274849,
      "latitude":55.4875453
    },
    "7069":{
      "name":"\u041f\u0440\u0438\u043b\u0443\u043a\u0438",
      "longitude":95.7291657,
      "latitude":57.7514304
    },
    "7070":{
      "name":"\u041a\u0443\u0440\u044b\u0448-\u041f\u043e\u043f\u043e\u0432\u0438\u0447\u0438",
      "longitude":95.7584217,
      "latitude":56.3430716
    },
    "7071":{
      "name":"\u0411\u043e\u0433\u0430\u0447\u0435\u0432\u043e",
      "longitude":95.7751042,
      "latitude":55.3804906
    },
    "7072":{
      "name":"\u041c\u0430\u0447\u0438\u043d\u043e",
      "longitude":95.7766947,
      "latitude":56.5626705
    },
    "7073":{
      "name":"\u0413\u0440\u0435\u043c\u0443\u0447\u0430\u044f \u041f\u0430\u0434\u044c",
      "longitude":95.7803034,
      "latitude":56.4408079
    },
    "7074":{
      "name":"\u041f\u043e\u0434\u044a\u044f\u043d\u0434\u0430",
      "longitude":95.7939647,
      "latitude":55.7971138
    },
    "7075":{
      "name":"\u041c\u0430\u043b\u043a\u0430\u0441",
      "longitude":95.8134826,
      "latitude":56.9208045
    },
    "7076":{
      "name":"\u0421\u0442\u0440\u0435\u043b\u043a\u0430",
      "longitude":95.8150645,
      "latitude":55.5468534
    },
    "7077":{
      "name":"\u041c\u0430\u0442\u0432\u0435\u0435\u0432\u043a\u0430",
      "longitude":95.8181194,
      "latitude":56.7885472
    },
    "7078":{
      "name":"\u041b\u0443\u0433\u043e\u0432\u0430\u044f",
      "longitude":95.8223224,
      "latitude":57.3761965
    },
    "7079":{
      "name":"\u0412\u043e\u0441\u0442\u043e\u043a",
      "longitude":95.8229173,
      "latitude":56.9515545
    },
    "7080":{
      "name":"\u0410\u0433\u0443\u043b",
      "longitude":95.8327678,
      "latitude":55.7531052
    },
    "7081":{
      "name":"\u041b\u043e\u0432\u0430\u0442\u044c",
      "longitude":95.8379075,
      "latitude":56.2442053
    },
    "7082":{
      "name":"\u0422\u0440\u043e\u0438\u0446\u043a",
      "longitude":95.8404723,
      "latitude":56.7433233
    },
    "7083":{
      "name":"\u041a\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":95.8522063,
      "latitude":58.5512596
    },
    "7084":{
      "name":"\u0418\u043b\u044c\u0438\u043d\u043e-\u041f\u043e\u0441\u0430\u0434\u0441\u043a\u043e\u0435",
      "longitude":95.8569528,
      "latitude":55.4568117
    },
    "7085":{
      "name":"\u0421\u0440\u0435\u0434\u043d\u0438\u0435 \u041c\u0430\u043d\u0433\u0430\u0440\u0435\u043a\u0438",
      "longitude":95.8668202,
      "latitude":56.7330443
    },
    "7086":{
      "name":"\u041a\u0443\u043d\u0433\u0443\u043b",
      "longitude":95.8747923,
      "latitude":56.8183356
    },
    "7087":{
      "name":"\u0421\u0442\u0435\u0440\u043b\u0438\u0442\u0430\u043c\u0430\u043a",
      "longitude":95.8819335,
      "latitude":56.6693506
    },
    "7088":{
      "name":"\u041f\u0440\u043e\u043a\u043e\u043f\u044c\u0435\u0432\u043a\u0430",
      "longitude":95.8862293,
      "latitude":55.7538769
    },
    "7089":{
      "name":"\u0411\u043e\u0433\u0434\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":95.8900113,
      "latitude":56.4614938
    },
    "7090":{
      "name":"\u041c\u0438\u043d\u0443\u0448\u043a\u0430",
      "longitude":95.8924517,
      "latitude":55.3999836
    },
    "7091":{
      "name":"\u0414\u043e\u043b\u0436\u0435\u043d\u043e\u0432\u043a\u0430",
      "longitude":95.8985203,
      "latitude":56.6858692
    },
    "7092":{
      "name":"\u041e\u0433\u0443\u0440\u0446\u044b",
      "longitude":95.9047563,
      "latitude":56.5337045
    },
    "7093":{
      "name":"\u0423\u0441\u043f\u0435\u043d\u043a\u0430",
      "longitude":95.9285755,
      "latitude":56.5835253
    },
    "7094":{
      "name":"\u0421\u0443\u0437\u0434\u0430\u043b\u0435\u0432\u043e",
      "longitude":95.9317948,
      "latitude":56.8401334
    },
    "7095":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u0435\u043c\u0435\u043d\u043e\u0432\u043a\u0430",
      "longitude":95.942428,
      "latitude":56.4083218
    },
    "7096":{
      "name":"\u0422\u0451\u043f\u043b\u044b\u0435 \u041a\u043b\u044e\u0447\u0438",
      "longitude":95.9496549,
      "latitude":56.2788004
    },
    "7097":{
      "name":"\u0428\u0438\u0432\u0435\u0440\u0430",
      "longitude":95.9556472,
      "latitude":57.3774813
    },
    "7098":{
      "name":"\u041d\u043e\u0432\u043e\u0433\u0435\u043e\u0440\u0433\u0438\u0435\u0432\u043a\u0430",
      "longitude":95.9926912,
      "latitude":56.3698954
    },
    "7099":{
      "name":"\u0427\u0438\u0433\u0430\u0448\u0435\u0442",
      "longitude":95.9972735,
      "latitude":57.3892251
    },
    "7100":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u0425\u043b\u0435\u0431\u043e\u0440\u043e\u0431",
      "longitude":96.0204644,
      "latitude":56.2903981
    },
    "7101":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":96.020651,
      "latitude":56.7355443
    },
    "7102":{
      "name":"\u041d\u043e\u0432\u043e\u043c\u0430\u0440\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":96.0251452,
      "latitude":55.4463641
    },
    "7103":{
      "name":"\u0412\u043e\u0440\u043e\u0431\u044c\u0435\u0432\u043a\u0430",
      "longitude":96.028271,
      "latitude":56.7227839
    },
    "7104":{
      "name":"\u0427\u0435\u0440\u043d\u0438\u0433\u043e\u0432\u043a\u0430",
      "longitude":96.0296339,
      "latitude":56.3102763
    },
    "7105":{
      "name":"\u041c\u0438\u043b\u0435\u0445\u0438\u043d\u043e",
      "longitude":96.0303393,
      "latitude":56.2273989
    },
    "7106":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u0438\u043d\u043a\u0430",
      "longitude":96.0593476,
      "latitude":56.4085135
    },
    "7107":{
      "name":"\u0414\u0430\u043b\u0430\u0439-\u041e\u0442\u0440\u0435\u0437",
      "longitude":96.0610379,
      "latitude":56.3068176
    },
    "7108":{
      "name":"\u042f\u0433\u043d\u044f\u043d\u0434\u0430",
      "longitude":96.066667,
      "latitude":59.9
    },
    "7109":{
      "name":"\u0413\u043e\u0440\u043e\u0434\u043e\u043a",
      "longitude":96.0812,
      "latitude":56.947063
    },
    "7110":{
      "name":"\u041f\u0430\u0439\u0442\u0443\u0440\u043c\u0430",
      "longitude":96.083333,
      "latitude":71.116667
    },
    "7111":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u042f\u0440",
      "longitude":96.1041379,
      "latitude":56.5409683
    },
    "7112":{
      "name":"\u0413\u0430\u0433\u0430\u0440\u0438\u043d\u0430",
      "longitude":96.1126828,
      "latitude":56.7288107
    },
    "7113":{
      "name":"\u0422\u0430\u0440\u0430\u043a\u0430",
      "longitude":96.15876,
      "latitude":56.430748
    },
    "7114":{
      "name":"\u0417\u0438\u043c\u043d\u0438\u043a",
      "longitude":96.1631179,
      "latitude":56.784444
    },
    "7115":{
      "name":"\u0411\u0435\u043b\u043e\u0433\u043b\u0438\u043d\u043d\u0430\u044f",
      "longitude":96.1669716,
      "latitude":56.6266646
    },
    "7116":{
      "name":"\u041d\u043e\u0432\u043e\u0433\u0435\u043e\u0440\u0433\u0438\u0435\u0432\u043a\u0430",
      "longitude":96.1729006,
      "latitude":56.7734974
    },
    "7117":{
      "name":"\u0422\u0430\u043c\u0430\u043b\u0430",
      "longitude":96.1749014,
      "latitude":56.293963
    },
    "7118":{
      "name":"\u0422\u0440\u043e\u0438\u0446\u043a",
      "longitude":96.1792465,
      "latitude":55.9558738
    },
    "7119":{
      "name":"\u041a\u0430\u044f\u043a",
      "longitude":103.2322599,
      "latitude":71.5103917
    },
    "7120":{
      "name":"\u0413\u0430\u0432\u0440\u0438\u043b\u043e\u0432\u043a\u0430",
      "longitude":96.1833696,
      "latitude":55.996408
    },
    "7121":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u0438\u0435\u0432\u043b\u044f\u043d\u043a\u0430",
      "longitude":96.212,
      "latitude":56.5607678
    },
    "7122":{
      "name":"\u041a\u0430\u043d\u0430\u0440\u0430\u0439",
      "longitude":96.2141282,
      "latitude":56.7166775
    },
    "7123":{
      "name":"\u041a\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":96.217705,
      "latitude":56.881924
    },
    "7124":{
      "name":"\u0411\u0435\u043b\u0430\u044f \u0422\u0430\u0435\u0436\u043a\u0430",
      "longitude":96.229019,
      "latitude":56.908485
    },
    "7125":{
      "name":"\u0410\u0431\u0430\u043a\u0443\u043c\u043e\u0432\u043a\u0430",
      "longitude":96.2314241,
      "latitude":55.7357597
    },
    "7126":{
      "name":"\u041d\u043e\u0432\u043e\u043d\u0438\u043a\u043e\u043b\u044c\u0441\u043a",
      "longitude":96.2388055,
      "latitude":56.3832866
    },
    "7127":{
      "name":"\u0418\u043b\u044c\u0438\u043d\u043a\u0430",
      "longitude":96.2609389,
      "latitude":56.4578495
    },
    "7128":{
      "name":"\u0422\u0443\u043b\u0435\u043d\u044c",
      "longitude":96.2693828,
      "latitude":57.3885841
    },
    "7129":{
      "name":"\u0411\u043e\u0440\u043a\u0438",
      "longitude":96.2865911,
      "latitude":56.6501403
    },
    "7130":{
      "name":"\u0412\u044b\u0441\u043e\u043a\u043e\u0433\u043e\u0440\u043e\u0434\u0435\u0446\u043a",
      "longitude":96.2932942,
      "latitude":56.7105125
    },
    "7131":{
      "name":"\u0420\u043e\u0441\u043b\u044f\u043a\u0438",
      "longitude":96.2969827,
      "latitude":55.7132627
    },
    "7132":{
      "name":"\u0412\u0435\u0440\u0445-\u0410\u0442\u0438\u043d\u044b",
      "longitude":96.2973601,
      "latitude":55.9116381
    },
    "7133":{
      "name":"\u041f\u043e\u0441\u043a\u043e\u0442\u0438\u043d\u043e",
      "longitude":96.3004446,
      "latitude":56.4731908
    },
    "7134":{
      "name":"\u0421\u0435\u043d\u043d\u043e\u0435",
      "longitude":96.3314433,
      "latitude":56.6145792
    },
    "7135":{
      "name":"\u041a\u043e\u0445\u0430",
      "longitude":96.3413472,
      "latitude":56.3489532
    },
    "7136":{
      "name":"\u041b\u043e\u0431\u0430\u0447\u0435\u0432\u043a\u0430",
      "longitude":96.3554214,
      "latitude":55.8343029
    },
    "7137":{
      "name":"\u0412\u043e\u0437\u0434\u0432\u0438\u0436\u0435\u043d\u043a\u0430",
      "longitude":96.3559196,
      "latitude":56.4819049
    },
    "7138":{
      "name":"\u041a\u043e\u043f\u0435\u0439\u043a\u0430",
      "longitude":96.3739014,
      "latitude":56.2945551
    },
    "7139":{
      "name":"\u0421\u0443\u043b\u0435\u043c\u043a\u0430",
      "longitude":96.395098,
      "latitude":56.1640401
    },
    "7140":{
      "name":"\u0422\u0451\u043f\u043b\u044b\u0439 \u041a\u043b\u044e\u0447",
      "longitude":96.410416,
      "latitude":56.863655
    },
    "7141":{
      "name":"\u041e\u0437\u0435\u0440\u043d\u044b\u0439",
      "longitude":96.4112275,
      "latitude":57.054275
    },
    "7142":{
      "name":"\u041d\u043e\u0432\u043e\u0440\u043e\u0436\u0434\u0435\u0441\u0442\u0432\u0435\u043d\u043a\u0430",
      "longitude":96.4203986,
      "latitude":56.4352066
    },
    "7143":{
      "name":"\u0422\u0443\u0433\u0443\u0448\u0430",
      "longitude":96.4381608,
      "latitude":55.9530716
    },
    "7144":{
      "name":"\u0415\u0440\u043c\u0430\u043a\u043e\u0432\u043a\u0430",
      "longitude":96.4467949,
      "latitude":56.8074486
    },
    "7145":{
      "name":"\u0411\u0430\u0439\u043a\u0430\u043b\u043e\u0432\u043e",
      "longitude":96.4801823,
      "latitude":56.4543805
    },
    "7146":{
      "name":"\u0422\u0443\u043c\u0438\u0445\u0430",
      "longitude":96.4936319,
      "latitude":55.7596383
    },
    "7147":{
      "name":"\u0411\u0438\u0440\u044e\u0441\u0430",
      "longitude":96.4945089,
      "latitude":57.1656066
    },
    "7148":{
      "name":"\u042d\u0441\u0442\u043e\u043d\u0438\u044f",
      "longitude":96.4987629,
      "latitude":56.3984817
    },
    "7149":{
      "name":"\u041d\u043e\u0432\u044b\u0439 \u041b\u043e\u043a\u0430\u0442\u0443\u0439",
      "longitude":96.4999997,
      "latitude":56.0143113
    },
    "7150":{
      "name":"\u041b\u043e\u043a\u0430\u0442\u0443\u0439",
      "longitude":96.5051139,
      "latitude":56.0233297
    },
    "7151":{
      "name":"\u041f\u0443\u0448\u043a\u0438\u043d\u043e",
      "longitude":96.5140641,
      "latitude":56.7079865
    },
    "7152":{
      "name":"\u0415\u0433\u043e\u0440\u043e\u0432\u043a\u0430",
      "longitude":96.5159493,
      "latitude":55.8748261
    },
    "7153":{
      "name":"\u041c\u0430\u043a\u0441\u0430\u043a\u043e\u0432\u043a\u0430",
      "longitude":96.5162753,
      "latitude":56.2639834
    },
    "7154":{
      "name":"\u0413\u043e\u0440\u0435\u043b\u044b\u0439 \u0411\u043e\u0440\u043e\u043a",
      "longitude":96.538365,
      "latitude":56.3495734
    },
    "7155":{
      "name":"\u041d\u043e\u0432\u043e\u0432\u043e\u0437\u0434\u0432\u0438\u0436\u0435\u043d\u043a\u0430",
      "longitude":96.5629227,
      "latitude":56.4647923
    },
    "7156":{
      "name":"\u0420\u0443\u0434\u043e\u0432\u043a\u0430",
      "longitude":96.5663642,
      "latitude":56.3310169
    },
    "7157":{
      "name":"\u041f\u0435\u0440\u043c\u044f\u043a\u043e\u0432\u043e",
      "longitude":96.5740445,
      "latitude":56.048056
    },
    "7158":{
      "name":"\u041a\u043b\u0438\u043c\u0435\u043d\u0442\u044c\u0435\u0432\u043a\u0430",
      "longitude":96.5888317,
      "latitude":56.0578846
    },
    "7159":{
      "name":"\u041f\u043b\u0430\u0445\u0438\u043d\u043e",
      "longitude":96.589153,
      "latitude":57.2878002
    },
    "7160":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u041f\u043e\u0439\u043c\u0430",
      "longitude":96.5921835,
      "latitude":56.1781693
    },
    "7161":{
      "name":"\u0412\u0435\u0440\u0445-\u0422\u0443\u0433\u0443\u0448\u0430",
      "longitude":96.5958057,
      "latitude":55.8826899
    },
    "7162":{
      "name":"\u041f\u0435\u0440\u0432\u0430\u044f \u0420\u0430\u0441\u0441\u043e\u0445\u0430",
      "longitude":96.5996074,
      "latitude":71.1997307
    },
    "7163":{
      "name":"\u0421\u0442\u0430\u0440\u0430\u044f \u041f\u043e\u0439\u043c\u0430",
      "longitude":96.6381423,
      "latitude":56.1876401
    },
    "7164":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":96.6422034,
      "latitude":56.3456472
    },
    "7165":{
      "name":"\u0420\u043e\u043c\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":96.6554299,
      "latitude":56.4272352
    },
    "7166":{
      "name":"\u0417\u0443\u0431\u0435\u043d\u043a\u0438\u043d\u043e",
      "longitude":96.6965368,
      "latitude":56.2788309
    },
    "7167":{
      "name":"\u0428\u0430\u0440\u0431\u044b\u0448",
      "longitude":96.7132241,
      "latitude":56.1744459
    },
    "7168":{
      "name":"\u041e\u0448\u0430\u0440\u043e\u0432\u043e",
      "longitude":96.758056,
      "latitude":56.2772189
    },
    "7169":{
      "name":"\u041f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":96.7668262,
      "latitude":56.4235511
    },
    "7170":{
      "name":"\u0421\u043b\u0430\u0432\u044f\u043d\u043a\u0430",
      "longitude":96.7824858,
      "latitude":61.0226694
    },
    "7171":{
      "name":"\u0420\u043e\u0436\u0434\u0435\u0441\u0442\u0432\u0435\u043d\u043a\u0430",
      "longitude":96.7924564,
      "latitude":56.271414
    },
    "7172":{
      "name":"\u041b\u0430\u0437\u0430\u0440\u0435\u0432\u043e",
      "longitude":96.7996677,
      "latitude":56.8241139
    },
    "7173":{
      "name":"\u0418\u0440\u043a\u0438\u043d\u0435\u0435\u0432\u043e",
      "longitude":96.8126794,
      "latitude":58.494867
    },
    "7174":{
      "name":"\u0423\u0441\u043f\u0435\u043d\u043a\u0430",
      "longitude":96.842159,
      "latitude":56.380833
    },
    "7175":{
      "name":"\u0424\u043e\u043a\u0438\u043d\u043e",
      "longitude":96.8607069,
      "latitude":56.3390185
    },
    "7176":{
      "name":"\u041f\u0435\u044f",
      "longitude":96.8790861,
      "latitude":57.1751857
    },
    "7177":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":96.9785986,
      "latitude":56.3769257
    },
    "7178":{
      "name":"\u0411\u043e\u0433\u0430\u043d\u0438\u0434\u0430",
      "longitude":96.9999999,
      "latitude":71.366667
    },
    "7179":{
      "name":"\u0414\u043e\u0433\u0430\u0434\u0430\u0435\u0432\u043e",
      "longitude":97.0466134,
      "latitude":56.1402147
    },
    "7180":{
      "name":"\u0415\u043b\u0438\u0437\u0430\u0432\u0435\u0442\u043a\u0430",
      "longitude":97.0507437,
      "latitude":56.1355457
    },
    "7181":{
      "name":"\u042f\u0440\u043a\u0438",
      "longitude":97.0976002,
      "latitude":58.3950467
    },
    "7182":{
      "name":"\u0411\u043e\u0440\u0437\u043e\u0432\u043e",
      "longitude":97.1357452,
      "latitude":57.1186593
    },
    "7183":{
      "name":"\u0421\u0430\u0433\u044b\u0440",
      "longitude":103.316667,
      "latitude":72.483333
    },
    "7184":{
      "name":"\u0411\u0435\u0434\u043e\u0431\u0430",
      "longitude":97.2031688,
      "latitude":58.8039324
    },
    "7185":{
      "name":"\u0418\u043b\u044c\u0438\u043d\u043a\u0430",
      "longitude":97.2321157,
      "latitude":56.3135954
    },
    "7186":{
      "name":"\u041f\u0440\u043e\u0445\u043b\u0430\u0434\u043d\u044b\u0439",
      "longitude":97.2879148,
      "latitude":56.2483507
    },
    "7187":{
      "name":"\u041b\u044e\u0447\u0430",
      "longitude":97.3038205,
      "latitude":60.1817431
    },
    "7188":{
      "name":"\u041a\u043b\u044e\u0447\u0438",
      "longitude":97.3688244,
      "latitude":56.1208345
    },
    "7189":{
      "name":"\u0423\u0441\u0442\u044c-\u041f\u0430\u043d\u0430\u043a\u0430\u0447\u0435\u0442",
      "longitude":97.3813239,
      "latitude":56.8849135
    },
    "7190":{
      "name":"\u041b\u0435\u0431\u044f\u0436\u044c\u0435",
      "longitude":97.3978936,
      "latitude":56.3631477
    },
    "7191":{
      "name":"\u0425\u0438\u043d\u0434\u0438\u0447\u0435\u0442",
      "longitude":97.4298905,
      "latitude":57.004109
    },
    "7192":{
      "name":"\u042e\u0436\u043d\u0430\u044f \u0422\u0443\u043d\u0433\u0443\u0441\u043a\u0430",
      "longitude":97.4393041,
      "latitude":56.4881349
    },
    "7193":{
      "name":"\u0411\u043e\u044f\u0440\u043a\u0430",
      "longitude":97.5034416,
      "latitude":70.768189
    },
    "7194":{
      "name":"\u041c\u0430\u043b\u0435\u0435\u0432\u043e",
      "longitude":97.5356499,
      "latitude":57.4318245
    },
    "7195":{
      "name":"\u0421\u043e\u0441\u043d\u043e\u0432\u043a\u0430",
      "longitude":97.5436189,
      "latitude":56.4545918
    },
    "7196":{
      "name":"\u041b\u0430\u043f\u0438\u043d\u043e",
      "longitude":97.6136393,
      "latitude":56.9562288
    },
    "7197":{
      "name":"\u041a\u0435\u0434\u0440\u043e\u0432\u044b\u0439",
      "longitude":97.6963972,
      "latitude":56.5479582
    },
    "7198":{
      "name":"\u0413\u043b\u0438\u043d\u043d\u044b\u0439",
      "longitude":97.708759,
      "latitude":56.7816034
    },
    "7199":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0435\u0435 \u0427\u0443\u043d\u043a\u0443",
      "longitude":97.7656784,
      "latitude":61.8061599
    },
    "7200":{
      "name":"\u0411\u0435\u043b\u0435\u043d\u044c\u043a\u0438\u0439",
      "longitude":97.9833329,
      "latitude":71.216667
    },
    "7201":{
      "name":"\u041a\u0430\u0440\u0433\u043e",
      "longitude":97.9967109,
      "latitude":71.2002772
    },
    "7202":{
      "name":"\u0417\u0430\u0438\u043c\u043a\u0430",
      "longitude":98.0456888,
      "latitude":58.4025227
    },
    "7203":{
      "name":"\u041a\u043e\u0440\u0434\u0430",
      "longitude":98.116667,
      "latitude":61.416667
    },
    "7204":{
      "name":"\u041c\u0435\u0437\u0435\u043d\u0441\u043a\u0438\u0439",
      "longitude":98.266667,
      "latitude":71.3
    },
    "7205":{
      "name":"\u0411\u0443\u0440\u0443\u043d\u0433\u0434\u0430",
      "longitude":98.3665319,
      "latitude":65.0654384
    },
    "7206":{
      "name":"\u0413\u043e\u043b\u044c\u0442\u044f\u0432\u0438\u043d\u043e",
      "longitude":98.4366053,
      "latitude":58.4331467
    },
    "7207":{
      "name":"\u041f\u043e\u0434\u0445\u0440\u0435\u0431\u0435\u0442\u043d\u044b\u0439",
      "longitude":98.5838902,
      "latitude":71.4831678
    },
    "7208":{
      "name":"\u041b\u0435\u043d\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":98.7201357,
      "latitude":58.8059788
    },
    "7209":{
      "name":"\u041a\u043b\u0438\u043c\u0438\u043d\u043e",
      "longitude":98.7446255,
      "latitude":58.6402581
    },
    "7210":{
      "name":"\u0422\u0435\u043c\u0431\u0435\u043d\u0447\u0438",
      "longitude":98.8471181,
      "latitude":64.9496315
    },
    "7211":{
      "name":"\u0427\u0430\u0434\u043e\u0431\u0435\u0446",
      "longitude":98.8597093,
      "latitude":58.660253
    },
    "7212":{
      "name":"\u0421\u044b\u0440\u043e\u043c\u043e\u043b\u043e\u0442\u043e\u0432\u043e",
      "longitude":98.9359275,
      "latitude":58.6701147
    },
    "7213":{
      "name":"\u042e\u0440\u043e\u0445\u0442\u0430",
      "longitude":98.9875443,
      "latitude":58.9534056
    },
    "7214":{
      "name":"\u0411\u0438\u0434\u0435\u044f",
      "longitude":99.1964441,
      "latitude":57.9166861
    },
    "7215":{
      "name":"\u041e\u0441\u043a\u043e\u0431\u0430",
      "longitude":100.4756027,
      "latitude":60.2649181
    },
    "7216":{
      "name":"\u0413\u0443\u043b\u0438-\u0426\u0435\u043d\u0442\u0440\u0430\u043b\u044c\u043d\u043e\u0435",
      "longitude":100.6,
      "latitude":71.0
    },
    "7217":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u0427\u0438\u0440\u0438\u043d\u0434\u0430",
      "longitude":100.6344394,
      "latitude":67.016427
    },
    "7218":{
      "name":"\u0427\u0435\u043c\u0431\u0430",
      "longitude":100.7158596,
      "latitude":57.8566039
    },
    "7219":{
      "name":"\u041a\u0430\u0440\u0430\u043c\u044b\u0448\u0435\u0432\u043e",
      "longitude":100.9193385,
      "latitude":57.5773146
    },
    "7220":{
      "name":"\u041a\u0435\u0440\u0431\u043e",
      "longitude":101.0995036,
      "latitude":62.7368295
    },
    "7221":{
      "name":"\u0412\u043e\u0435\u0432\u043e\u043b\u0438",
      "longitude":101.3,
      "latitude":65.9
    },
    "7222":{
      "name":"\u041c\u0443\u0440\u0443\u043a\u0442\u0430",
      "longitude":102.0130009,
      "latitude":67.7687674
    },
    "7223":{
      "name":"\u0416\u0434\u0430\u043d\u0438\u0445\u0430",
      "longitude":102.8673775,
      "latitude":72.1709816
    },
    "7224":{
      "name":"\u0427\u0443\u044e\u043d\u0433\u043e",
      "longitude":103.832348,
      "latitude":62.5643413
    },
    "7225":{
      "name":"\u0423\u0433\u043e\u044f\u043d",
      "longitude":104.0732417,
      "latitude":59.0969057
    },
    "7226":{
      "name":"\u041a\u0438\u0440\u0431\u0435\u0439",
      "longitude":104.4794157,
      "latitude":69.1197977
    },
    "7227":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u0440\u044b\u0431\u043d\u043e\u0435",
      "longitude":104.811477,
      "latitude":72.7543804
    },
    "7228":{
      "name":"\u0410\u044f\u043d",
      "longitude":105.666667,
      "latitude":61.75
    },
    "7229":{
      "name":"\u041f\u043e\u043a\u0443\u0441\u0430\u0433\u044b\u0440",
      "longitude":105.916667,
      "latitude":73.666667
    },
    "7230":{
      "name":"\u041d\u043e\u0432\u044b\u0439",
      "longitude":107.3254238,
      "latitude":72.9645565
    },
    "7231":{
      "name":"\u0413\u0443\u0441\u0438\u0445\u0430",
      "longitude":107.5,
      "latitude":73.65
    },
    "7232":{
      "name":"\u041a\u043e\u0441\u0438\u0441\u0442\u044b\u0439",
      "longitude":109.7789548,
      "latitude":73.6935383
    },
    "7233":{
      "name":"\u0418\u043b\u044c\u044f",
      "longitude":110.1334351,
      "latitude":73.5595306
    },
    "7234":{
      "name":"\u0423\u0433\u043e\u043b\u044c\u043d\u044b\u0439",
      "longitude":110.1735603,
      "latitude":73.5414262
    },
    "7235":{
      "name":"\u041a\u043e\u0436\u0435\u0432\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":110.3,
      "latitude":73.55
    },
    "7236":{
      "name":"\u0410\u043d\u0430\u0431\u044b\u0440\u043a\u0430",
      "longitude":110.8,
      "latitude":72.166667
    },
    "7237":{
      "name":"\u041d\u043e\u0440\u0434\u0432\u0438\u043a",
      "longitude":111.5333329,
      "latitude":74.033333
    },
    "7238":{
      "name":"\u0428\u0438\u0432\u0438\u043b\u0438\u0433",
      "longitude":89.9199132,
      "latitude":50.9918749
    },
    "7239":{
      "name":"\u0425\u0438\u043d\u0434\u0438\u043a\u0442\u0438\u0433-\u0425\u043e\u043b\u044c",
      "longitude":89.9277601,
      "latitude":50.3443245
    },
    "7240":{
      "name":"\u042d\u044d\u0440-\u0425\u0430\u0432\u0430\u043a",
      "longitude":90.2606267,
      "latitude":51.0109326
    },
    "7241":{
      "name":"\u0410\u043a-\u0421\u0443\u0433",
      "longitude":90.478141,
      "latitude":51.3857657
    },
    "7242":{
      "name":"\u041a\u0438\u0440\u0441\u0430\u0440\u0430\u0439",
      "longitude":91.8148471,
      "latitude":51.3754037
    },
    "7243":{
      "name":"\u0425\u0443\u0440\u044d",
      "longitude":93.1570702,
      "latitude":51.078268
    },
    "7244":{
      "name":"\u0427\u043a\u0430\u043b\u043e\u0432\u043a\u0430",
      "longitude":93.5070574,
      "latitude":52.0275263
    },
    "7245":{
      "name":"\u041a\u0430\u044a\u043a",
      "longitude":93.5194731,
      "latitude":51.3425793
    },
    "7246":{
      "name":"\u041a\u0430\u0440\u0430-\u0422\u0430\u043b",
      "longitude":93.5381866,
      "latitude":51.6573081
    },
    "7247":{
      "name":"\u041e\u0442\u0442\u0443\u043a-\u0414\u0430\u0448",
      "longitude":93.6006442,
      "latitude":51.5660532
    },
    "7248":{
      "name":"\u0428\u0438\u0432\u0438\u043b\u0438\u0433",
      "longitude":93.7104046,
      "latitude":52.2398849
    },
    "7249":{
      "name":"\u0414\u0435\u0441\u043f\u0435\u043d",
      "longitude":93.7846647,
      "latitude":50.7992547
    },
    "7250":{
      "name":"\u041b\u0435\u043d\u0438\u043d\u043a\u0430",
      "longitude":93.8752053,
      "latitude":51.9903052
    },
    "7251":{
      "name":"\u0411\u0438\u043b\u0435\u043b\u0438\u0433",
      "longitude":93.8794007,
      "latitude":52.2732863
    },
    "7252":{
      "name":"\u0412\u0430\u0432\u0438\u043b\u0438\u043d\u0441\u043a\u0438\u0439 \u0437\u0430\u0442\u043e\u043d",
      "longitude":94.4463063,
      "latitude":51.7606657
    },
    "7253":{
      "name":"\u0423\u0441\u0442\u044c-\u0425\u0430\u0434\u044b\u043d",
      "longitude":94.568761,
      "latitude":51.288216
    },
    "7254":{
      "name":"\u041e\u043a\u0442\u044f\u0431\u0440\u044c\u0441\u043a\u0438\u0439",
      "longitude":94.6939405,
      "latitude":53.1746181
    },
    "7255":{
      "name":"\u0421\u0435\u0432\u0438",
      "longitude":94.9264865,
      "latitude":52.489418
    },
    "7256":{
      "name":"\u041c\u0430\u0440\u0430\u0447\u0435\u0432\u043a\u0430",
      "longitude":95.0043647,
      "latitude":50.9409379
    },
    "7257":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u044f\u0440\u043e\u0432\u043a\u0430",
      "longitude":95.0479523,
      "latitude":51.0016375
    },
    "7258":{
      "name":"\u041a\u0443\u0440\u0430\u043d",
      "longitude":95.2724868,
      "latitude":50.7958609
    },
    "7259":{
      "name":"\u0411\u0430\u0439-\u0421\u043e\u043e\u0442",
      "longitude":95.3156444,
      "latitude":51.7499553
    },
    "7260":{
      "name":"\u0422\u0430\u0440\u0434\u0430\u043d",
      "longitude":95.3268616,
      "latitude":51.7078829
    },
    "7261":{
      "name":"\u041c\u0435\u0440\u0433\u0435\u043d",
      "longitude":95.5663186,
      "latitude":51.5113124
    },
    "7262":{
      "name":"\u0410\u0432\u044b\u0439\u0433\u0430\u043d",
      "longitude":95.5926481,
      "latitude":51.3204989
    },
    "7263":{
      "name":"\u0411\u0435\u043b\u044c\u0431\u0435\u0439",
      "longitude":95.7707928,
      "latitude":51.2865241
    },
    "7264":{
      "name":"\u0423\u0441\u0442\u044c-\u0421\u0438\u0437\u0438\u043c",
      "longitude":95.904065,
      "latitude":51.3257084
    },
    "7265":{
      "name":"\u042d\u0440\u0436\u0435\u0439",
      "longitude":95.9339671,
      "latitude":51.3380002
    },
    "7266":{
      "name":"\u041a\u044b\u0437\u044b\u043b-\u0422\u0430\u0448\u0442\u044b\u0433",
      "longitude":96.0110271,
      "latitude":52.0262574
    },
    "7267":{
      "name":"\u0428\u0443\u0439",
      "longitude":96.0441761,
      "latitude":51.3749787
    },
    "7268":{
      "name":"\u0423\u0436\u0435\u043f",
      "longitude":96.2435472,
      "latitude":51.3400023
    },
    "7269":{
      "name":"\u0423\u0441\u0442\u044c-\u0423\u0436\u0435\u043f",
      "longitude":96.2546187,
      "latitude":51.3294147
    },
    "7270":{
      "name":"\u0423\u043b\u0443\u0433-\u0422\u0430\u043d\u0437\u0435\u043a",
      "longitude":96.277844,
      "latitude":50.6274209
    },
    "7271":{
      "name":"\u0410\u043a-\u0421\u0443\u0433",
      "longitude":96.4687597,
      "latitude":53.4384202
    },
    "7272":{
      "name":"\u0411\u0430\u044f\u043d\u043a\u043e\u043b\u044c",
      "longitude":96.6398956,
      "latitude":50.5073917
    },
    "7273":{
      "name":"\u041a\u0430\u0440\u0430-\u0411\u0435\u043b\u044c\u0434\u044b\u0440",
      "longitude":96.7054333,
      "latitude":51.1320983
    },
    "7274":{
      "name":"\u0410\u0440\u044b\u0441\u043a\u0430\u043d",
      "longitude":96.7070766,
      "latitude":53.4557266
    },
    "7275":{
      "name":"\u041a\u0430\u0442\u0430\u0437\u044b",
      "longitude":96.9018443,
      "latitude":51.1876568
    },
    "7276":{
      "name":"\u0411\u0435\u043b\u0434\u0438\u0440",
      "longitude":96.9468639,
      "latitude":50.5040435
    },
    "7277":{
      "name":"\u041a\u044b\u0431\u044b\u0433-\u0410\u0434\u0430",
      "longitude":96.9667115,
      "latitude":50.5067503
    },
    "7278":{
      "name":"\u0422\u0430\u0441\u0442\u044b\u0433",
      "longitude":97.1100734,
      "latitude":49.9494705
    },
    "7279":{
      "name":"\u0427\u0438\u0440\u0433\u0430\u043b\u0430\u043d\u0434\u044b",
      "longitude":97.2023901,
      "latitude":50.5833638
    },
    "7280":{
      "name":"\u042d\u043c\u0438",
      "longitude":97.6861401,
      "latitude":50.6356281
    },
    "7281":{
      "name":"\u0423\u0441\u0442\u044c-\u041e\u0442\u0442\u0443\u043a-\u0414\u0430\u0448",
      "longitude":97.7657014,
      "latitude":50.5732256
    },
    "7282":{
      "name":"\u0423\u0448-\u0411\u0435\u043b\u0434\u0438\u0440",
      "longitude":98.0534747,
      "latitude":51.4717472
    },
    "7283":{
      "name":"\u0422\u0430\u0440\u044b\u0441",
      "longitude":98.1955881,
      "latitude":50.3722971
    },
    "7284":{
      "name":"\u0427\u043e\u0439\u0433\u0430\u043d",
      "longitude":98.7918229,
      "latitude":52.5841545
    },
    "7285":{
      "name":"\u042f\u0441\u043d\u0430\u044f \u041f\u043e\u043b\u044f\u043d\u0430",
      "longitude":84.5367416,
      "latitude":56.0381752
    },
    "7286":{
      "name":"\u041a\u043e\u0436\u0435\u0432\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":84.6203407,
      "latitude":56.0111228
    },
    "7287":{
      "name":"139 \u043a\u043c",
      "longitude":84.6243805,
      "latitude":55.7088769
    },
    "7288":{
      "name":"\u0417\u0435\u043b\u0451\u043d\u0430\u044f \u0413\u043e\u0440\u043a\u0430",
      "longitude":84.6409053,
      "latitude":55.7048716
    },
    "7289":{
      "name":"\u0411\u0436\u0438\u0446\u043a\u0430\u044f",
      "longitude":84.6433915,
      "latitude":55.7191378
    },
    "7290":{
      "name":"\u0422\u0430\u0441\u043a\u0430\u0435\u0432\u043e",
      "longitude":84.652754,
      "latitude":55.7003128
    },
    "7291":{
      "name":"\u0410\u043b\u0430\u0431\u0443\u0447\u0438\u043d\u043a\u0430",
      "longitude":84.6611594,
      "latitude":55.9538636
    },
    "7292":{
      "name":"\u041a\u043b\u0435\u043d\u043e\u0432\u043a\u0430",
      "longitude":84.662862,
      "latitude":55.6848677
    },
    "7293":{
      "name":"\u0427\u0443\u0442\u043e\u0432\u043a\u0430",
      "longitude":84.6827709,
      "latitude":55.9386883
    },
    "7294":{
      "name":"\u0428\u0438\u0442\u0438\u043a\u043e\u0432\u043e",
      "longitude":84.6844328,
      "latitude":55.7466896
    },
    "7295":{
      "name":"\u0427\u0430\u0445\u043b\u043e\u0432\u043e",
      "longitude":84.707169,
      "latitude":55.790062
    },
    "7296":{
      "name":"\u0412\u0430\u0441\u0438\u043b\u044c\u0435\u0432\u043a\u0430",
      "longitude":84.7185414,
      "latitude":55.4003202
    },
    "7297":{
      "name":"14 \u043a\u043c",
      "longitude":84.7542718,
      "latitude":55.6142189
    },
    "7298":{
      "name":"31 \u043a\u043c",
      "longitude":84.7580133,
      "latitude":55.4703705
    },
    "7299":{
      "name":"\u042e\u043b\u044c\u044f\u043d\u043e\u0432\u043a\u0430",
      "longitude":84.7607818,
      "latitude":55.4352919
    },
    "7300":{
      "name":"\u0411\u043b\u043e\u043a-\u041f\u043e\u0441\u0442 149 \u043a\u043c",
      "longitude":84.7803021,
      "latitude":55.7037142
    },
    "7301":{
      "name":"\u0424\u0438\u043b\u043e\u043d\u043e\u0432\u043e",
      "longitude":84.7839975,
      "latitude":55.8675405
    },
    "7302":{
      "name":"23 \u043a\u043c",
      "longitude":84.7857931,
      "latitude":55.5347956
    },
    "7303":{
      "name":"\u041c\u0438\u043b\u044e\u0442\u0438\u043d\u043e",
      "longitude":84.789246,
      "latitude":55.899033
    },
    "7304":{
      "name":"\u041f\u0440\u0438\u0440\u0435\u0447\u044c\u0435",
      "longitude":84.8006811,
      "latitude":55.8915125
    },
    "7305":{
      "name":"\u041b\u043e\u0433\u043e\u0432\u043e\u0439",
      "longitude":84.8160524,
      "latitude":55.5591572
    },
    "7306":{
      "name":"\u0421\u0442\u0430\u0440\u044b\u0439 \u0428\u0430\u043b\u0430\u0439",
      "longitude":84.8558784,
      "latitude":55.6124229
    },
    "7307":{
      "name":"\u041b\u044e\u0431\u0430\u0440\u043e\u0432\u043a\u0430",
      "longitude":84.8801653,
      "latitude":55.5105046
    },
    "7308":{
      "name":"\u041d\u043e\u0432\u043e\u044f\u0433\u043e\u0434\u043d\u043e\u0435",
      "longitude":84.8812649,
      "latitude":55.6744746
    },
    "7309":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u0423\u043b\u0443\u0441",
      "longitude":84.8971718,
      "latitude":55.5738443
    },
    "7310":{
      "name":"\u0410\u043b\u0430\u0435\u0432\u043e",
      "longitude":84.9009298,
      "latitude":56.1528315
    },
    "7311":{
      "name":"\u0427\u0451\u0440\u043d\u044b\u0439 \u041f\u0430\u0434\u0443\u043d",
      "longitude":84.9144227,
      "latitude":55.3896037
    },
    "7312":{
      "name":"\u0421\u043e\u0441\u043d\u043e\u0432\u044b\u0439 \u041e\u0441\u0442\u0440\u043e\u0433",
      "longitude":84.922638,
      "latitude":56.009197
    },
    "7313":{
      "name":"46 \u043a\u043c",
      "longitude":84.9452708,
      "latitude":55.4255192
    },
    "7314":{
      "name":"\u0413\u043b\u0438\u043d\u043a\u043e\u0432\u043a\u0430",
      "longitude":84.9463376,
      "latitude":55.4184675
    },
    "7315":{
      "name":"\u041a\u0430\u0438\u043f",
      "longitude":84.9502677,
      "latitude":55.5364115
    },
    "7316":{
      "name":"\u041c\u043e\u0445\u043e\u0432\u043e",
      "longitude":84.9503543,
      "latitude":55.8376384
    },
    "7317":{
      "name":"\u042e\u0440\u0442\u044b-\u041a\u043e\u043d\u0441\u0442\u0430\u043d\u0442\u0438\u043d\u043e\u0432\u044b",
      "longitude":84.957237,
      "latitude":56.066563
    },
    "7318":{
      "name":"\u0422\u0443\u0442\u0430\u043b\u044c\u0441\u043a\u0438\u0439 \u0421\u0430\u043d\u0430\u0442\u043e\u0440\u0438\u0439",
      "longitude":84.9678936,
      "latitude":55.7266015
    },
    "7319":{
      "name":"\u041e\u0441\u043e\u0430\u0432\u0438\u0430\u0445\u0438\u043c",
      "longitude":84.9717475,
      "latitude":55.7215913
    },
    "7320":{
      "name":"\u041c\u0430\u0440\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":84.9752247,
      "latitude":55.5411981
    },
    "7321":{
      "name":"\u041b\u0435\u0432\u043e\u0441\u043e\u0441\u043d\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":84.9784935,
      "latitude":55.2157723
    },
    "7322":{
      "name":"\u0423\u0441\u0442\u044c-\u0421\u043e\u0441\u043d\u043e\u0432\u043a\u0430",
      "longitude":84.981209,
      "latitude":56.082417
    },
    "7323":{
      "name":"\u0421\u043b\u0430\u043d\u0446\u0435\u0432\u044b\u0439 \u0420\u0443\u0434\u043d\u0438\u043a",
      "longitude":84.9872583,
      "latitude":55.7105394
    },
    "7324":{
      "name":"\u0418\u0442\u043a\u0430\u0440\u0430",
      "longitude":84.988632,
      "latitude":55.954056
    },
    "7325":{
      "name":"\u041a\u0430\u043d\u0430\u0448",
      "longitude":86.331604,
      "latitude":54.082134
    },
    "7326":{
      "name":"\u0414\u0435\u043d\u0438\u0441\u043e\u0432\u043a\u0430",
      "longitude":85.0025263,
      "latitude":54.9543101
    },
    "7327":{
      "name":"\u0420\u043e\u043c\u0430\u043d\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":85.0054045,
      "latitude":55.2741312
    },
    "7328":{
      "name":"\u041a\u043e\u043a\u0443\u0439",
      "longitude":85.0171138,
      "latitude":55.3324924
    },
    "7329":{
      "name":"\u041a\u0443\u043b\u0430\u043a\u043e\u0432\u043e",
      "longitude":85.022942,
      "latitude":55.890938
    },
    "7330":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u043e",
      "longitude":85.0453625,
      "latitude":55.1759167
    },
    "7331":{
      "name":"54 \u043a\u043c",
      "longitude":85.0522672,
      "latitude":55.4649334
    },
    "7332":{
      "name":"\u041a\u0430\u0442\u043a\u043e\u0432\u043e",
      "longitude":85.0560746,
      "latitude":55.145199
    },
    "7333":{
      "name":"\u0411\u0430\u0440\u0445\u0430\u0442\u043e\u0432\u043e",
      "longitude":85.0605046,
      "latitude":55.3607171
    },
    "7334":{
      "name":"\u041a\u043e\u0441\u043e\u0433\u043e\u0440\u043e\u0432\u043e",
      "longitude":85.091364,
      "latitude":56.1467106
    },
    "7335":{
      "name":"\u041e\u043a\u0442\u044f\u0431\u0440\u044c\u0441\u043a\u0438\u0439",
      "longitude":85.1110942,
      "latitude":55.7782445
    },
    "7336":{
      "name":"\u041a\u0430\u043b\u0442\u044b\u0448\u0438\u043d\u043e",
      "longitude":85.1195991,
      "latitude":54.8316016
    },
    "7337":{
      "name":"\u0422\u0430\u0439\u0433\u0438\u043d\u0441\u043a\u0438\u0439 \u041b\u0435\u0441\u043f\u0440\u043e\u043c\u0445\u043e\u0437",
      "longitude":85.121239,
      "latitude":54.50742
    },
    "7338":{
      "name":"\u0414\u0430\u0443\u0440\u043e\u0432\u043a\u0430",
      "longitude":85.1269,
      "latitude":55.912239
    },
    "7339":{
      "name":"\u0412\u0435\u0440\u0445-\u0418\u0442\u043a\u0430\u0440\u0430",
      "longitude":85.1329727,
      "latitude":55.9824392
    },
    "7340":{
      "name":"\u041b\u0438\u0441\u0442\u0432\u044f\u043d\u043a\u0430",
      "longitude":85.1334026,
      "latitude":55.4228336
    },
    "7341":{
      "name":"\u0418\u0432\u0430\u043d-\u0411\u0440\u043e\u0434",
      "longitude":85.1404048,
      "latitude":54.6101269
    },
    "7342":{
      "name":"64 \u043a\u043c",
      "longitude":85.1689122,
      "latitude":55.4175664
    },
    "7343":{
      "name":"\u041c\u0435\u043b\u043a\u043e\u0432\u043e",
      "longitude":85.1763334,
      "latitude":56.0265267
    },
    "7344":{
      "name":"\u041a\u043e\u043c\u0441\u043e\u043c\u043e\u043b\u044c\u0441\u043a\u0438\u0439",
      "longitude":85.178166,
      "latitude":55.3777319
    },
    "7345":{
      "name":"\u041b\u0443\u043a\u043e\u0448\u043a\u0438\u043d\u043e",
      "longitude":85.1971119,
      "latitude":55.2698626
    },
    "7346":{
      "name":"\u0421\u0440\u0435\u0434\u043d\u0435\u0431\u0435\u0440\u0435\u0437\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":85.1993862,
      "latitude":55.2021468
    },
    "7347":{
      "name":"\u0428\u0438\u043f\u0438\u0446\u0438\u043d\u043e",
      "longitude":85.2009759,
      "latitude":54.9029983
    },
    "7348":{
      "name":"\u0422\u0430\u043b\u044c\u043c\u0435\u043d\u043a\u0430",
      "longitude":85.2016842,
      "latitude":55.80269
    },
    "7349":{
      "name":"\u041d\u0438\u0436\u043d\u044f\u044f \u0422\u0430\u0439\u043c\u0435\u043d\u043a\u0430",
      "longitude":85.2153681,
      "latitude":55.6678555
    },
    "7350":{
      "name":"\u041a\u0430\u043b\u0435\u043d\u043e\u0432\u043e",
      "longitude":85.2212735,
      "latitude":55.7939517
    },
    "7351":{
      "name":"\u0411\u0430\u043b\u0430\u0445\u043d\u0438\u043d\u043e",
      "longitude":85.2244976,
      "latitude":55.9065852
    },
    "7352":{
      "name":"\u041d\u0438\u0436\u043d\u0435\u0448\u0443\u0431\u0438\u043d\u043e",
      "longitude":85.2429103,
      "latitude":56.0070209
    },
    "7353":{
      "name":"\u041a\u043e\u0437\u043b\u043e\u0432\u043e",
      "longitude":85.2550788,
      "latitude":55.2363397
    },
    "7354":{
      "name":"\u0427\u0430\u0449\u0430",
      "longitude":85.258416,
      "latitude":55.4066663
    },
    "7355":{
      "name":"\u0422\u044b\u0445\u0442\u0430",
      "longitude":85.2599506,
      "latitude":55.1290421
    },
    "7356":{
      "name":"\u041a\u0440\u044b\u043b\u043e\u0432\u043e",
      "longitude":85.2617284,
      "latitude":55.6599343
    },
    "7357":{
      "name":"\u041a\u043e\u0440\u0447\u0443\u0433\u0430\u043d\u043e\u0432\u043e",
      "longitude":85.263687,
      "latitude":55.8007708
    },
    "7358":{
      "name":"\u041c\u0438\u0442\u0440\u043e\u0444\u0430\u043d\u043e\u0432\u043e",
      "longitude":85.2949025,
      "latitude":55.6468792
    },
    "7359":{
      "name":"\u0422\u0430\u0440\u0441\u044c\u043c\u0430",
      "longitude":85.304863,
      "latitude":54.988678
    },
    "7360":{
      "name":"79 \u043a\u043c",
      "longitude":85.3152471,
      "latitude":55.3144155
    },
    "7361":{
      "name":"\u0414\u043c\u0438\u0442\u0440\u0438\u0435\u0432\u043a\u0430",
      "longitude":85.325363,
      "latitude":54.466717
    },
    "7362":{
      "name":"\u0421\u0435\u0432\u0435\u0440\u043d\u0430\u044f",
      "longitude":85.3253675,
      "latitude":56.0403556
    },
    "7363":{
      "name":"\u0412\u0435\u0440\u0445-\u041c\u043e\u0441\u0442\u043e\u0432\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":85.3274535,
      "latitude":55.4470602
    },
    "7364":{
      "name":"\u0425\u0440\u0435\u0441\u0442\u0438\u043d\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":85.328201,
      "latitude":54.572857
    },
    "7365":{
      "name":"\u0410\u043f\u0440\u0435\u043b\u044c\u043a\u0430",
      "longitude":85.330414,
      "latitude":54.523952
    },
    "7366":{
      "name":"\u0421\u0438\u043c\u0430\u043d\u043e\u0432\u043e",
      "longitude":85.3373712,
      "latitude":55.386857
    },
    "7367":{
      "name":"\u041a\u0430\u0441\u0438\u043c\u043e\u0432\u043a\u0430",
      "longitude":85.3408462,
      "latitude":54.7424004
    },
    "7368":{
      "name":"\u0421\u0430\u0440\u0430\u0441\u0435\u0442",
      "longitude":88.7467655,
      "latitude":52.8561495
    },
    "7369":{
      "name":"\u042e\u0440\u043c\u0430\u043d\u043e\u0432\u043e",
      "longitude":85.3444289,
      "latitude":55.5478834
    },
    "7370":{
      "name":"\u0425\u0430\u0440\u044c\u043a\u043e\u0432 \u041b\u043e\u0433",
      "longitude":85.357368,
      "latitude":54.550129
    },
    "7371":{
      "name":"\u041c\u0430\u0441\u043b\u0438\u0445\u0430",
      "longitude":85.362289,
      "latitude":54.440079
    },
    "7372":{
      "name":"\u041a\u043b\u044e\u0447\u0435\u0432\u043e\u0439",
      "longitude":85.3678472,
      "latitude":55.3230127
    },
    "7373":{
      "name":"\u0417\u0430\u0440\u044f",
      "longitude":85.385178,
      "latitude":54.472733
    },
    "7374":{
      "name":"210 \u043a\u043c",
      "longitude":85.3874179,
      "latitude":54.947425
    },
    "7375":{
      "name":"\u042e\u0440\u044c\u0435\u0432\u043a\u0430",
      "longitude":85.3971046,
      "latitude":55.2439071
    },
    "7376":{
      "name":"\u041a\u0438\u0440\u043e\u0432\u043e",
      "longitude":85.4148713,
      "latitude":55.6983119
    },
    "7377":{
      "name":"\u0411\u043e\u0440\u043c\u043e\u0442\u043e\u0432\u043e",
      "longitude":85.4292755,
      "latitude":54.9448043
    },
    "7378":{
      "name":"\u0425\u043e\u0440\u043e\u0448\u0435\u0431\u043e\u0440\u043a\u0430",
      "longitude":85.4294584,
      "latitude":55.5178413
    },
    "7379":{
      "name":"\u0421\u0443\u0440\u0430\u043d\u043e\u0432\u043e",
      "longitude":85.4377795,
      "latitude":56.1704416
    },
    "7380":{
      "name":"\u0420\u0430\u043d\u043d\u0438\u0439",
      "longitude":85.4407868,
      "latitude":54.8880507
    },
    "7381":{
      "name":"\u0425\u043e\u043f\u043a\u0438\u043d\u043e",
      "longitude":85.4433989,
      "latitude":55.9414464
    },
    "7382":{
      "name":"\u041f\u043e\u0434\u043a\u043e\u043f\u0435\u043d\u043d\u0430\u044f",
      "longitude":85.450554,
      "latitude":54.459839
    },
    "7383":{
      "name":"\u041f\u0430\u0440\u0445\u0430\u0435\u0432\u043a\u0430",
      "longitude":85.4647345,
      "latitude":54.6987189
    },
    "7384":{
      "name":"\u041a\u043e\u043f\u044b\u043b\u043e\u0432\u043e",
      "longitude":85.4747291,
      "latitude":55.6562016
    },
    "7385":{
      "name":"\u041d\u0438\u0436\u043d\u0435\u044f\u0448\u043a\u0438\u043d\u043e",
      "longitude":85.4790659,
      "latitude":55.8278418
    },
    "7386":{
      "name":"96 \u043a\u043c",
      "longitude":85.4903377,
      "latitude":55.2506052
    },
    "7387":{
      "name":"\u0422\u0435\u0440\u0435\u0445\u0438\u043d\u043e",
      "longitude":85.4951218,
      "latitude":55.346763
    },
    "7388":{
      "name":"\u041a\u043e\u043b\u043c\u0430\u043a\u043e\u0432\u043e",
      "longitude":85.4961782,
      "latitude":55.6918613
    },
    "7389":{
      "name":"\u041f\u0443\u0448\u043a\u0438\u043d\u043e",
      "longitude":85.4985642,
      "latitude":54.7758092
    },
    "7390":{
      "name":"\u0421\u043e\u043b\u043e\u043c\u0438\u043d\u043e",
      "longitude":85.501122,
      "latitude":55.304981
    },
    "7391":{
      "name":"\u0426\u044b\u043f\u0438\u043d\u043e",
      "longitude":85.5038493,
      "latitude":55.1423843
    },
    "7392":{
      "name":"\u041f\u043e\u0434\u043a\u043e\u043f\u0435\u043d\u043d\u0430\u044f",
      "longitude":85.5143556,
      "latitude":55.0216642
    },
    "7393":{
      "name":"\u041d\u043e\u0432\u044b\u0439 \u0418\u0441\u0442\u043e\u043a",
      "longitude":85.5491481,
      "latitude":54.9486149
    },
    "7394":{
      "name":"\u0421\u0438\u043d\u0435\u0440\u0435\u0447\u043a\u0430",
      "longitude":85.5502469,
      "latitude":55.7216989
    },
    "7395":{
      "name":"\u041a\u043e\u043b\u0431\u0438\u0445\u0430",
      "longitude":85.5595392,
      "latitude":55.6740703
    },
    "7396":{
      "name":"\u041a\u043e\u0447\u043a\u0443\u0440\u043e\u0432\u043a\u0430",
      "longitude":85.566208,
      "latitude":54.395863
    },
    "7397":{
      "name":"\u041f\u043e\u043d\u0442\u0440\u044f\u0436\u043a\u0430",
      "longitude":85.572716,
      "latitude":54.39864
    },
    "7398":{
      "name":"\u0411\u0443\u0440\u0443\u0445\u0438\u043d\u043e",
      "longitude":85.5746342,
      "latitude":55.13058
    },
    "7399":{
      "name":"\u041c\u043e\u0440\u043a\u043e\u0432\u043a\u0438\u043d\u043e",
      "longitude":85.6178998,
      "latitude":55.7063484
    },
    "7400":{
      "name":"\u0414\u0440\u0443\u0436\u043d\u044b\u0439",
      "longitude":85.620277,
      "latitude":54.664204
    },
    "7401":{
      "name":"\u041c\u0435\u0434\u044b\u043d\u0438\u043d\u043e",
      "longitude":85.6233187,
      "latitude":55.5524664
    },
    "7402":{
      "name":"\u041f\u0438\u0441\u0430\u043d\u0430\u044f",
      "longitude":85.629982,
      "latitude":55.66119
    },
    "7403":{
      "name":"\u041a\u043e\u0440\u043d\u0438\u043b\u043e\u0432\u043a\u0430",
      "longitude":85.6351002,
      "latitude":55.129827
    },
    "7404":{
      "name":"\u041e\u0441\u0438\u043d\u043e\u0432\u0430\u044f \u0413\u0440\u0438\u0432\u0430",
      "longitude":85.6371235,
      "latitude":55.1869918
    },
    "7405":{
      "name":"\u041c\u0438\u043d\u0438\u0447\u0435\u0432\u043e",
      "longitude":85.6506948,
      "latitude":55.7331806
    },
    "7406":{
      "name":"\u041a\u043e\u0440\u0431\u0435\u043b\u043a\u0438\u043d\u043e",
      "longitude":85.656083,
      "latitude":55.0463621
    },
    "7407":{
      "name":"\u041f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":85.66848,
      "latitude":54.552456
    },
    "7408":{
      "name":"\u041f\u0435\u0447\u0451\u0440\u043a\u0438\u043d\u043e",
      "longitude":85.690002,
      "latitude":54.420929
    },
    "7409":{
      "name":"\u0423\u0441\u0442\u044c-\u0421\u0442\u0440\u0435\u043b\u0438\u043d\u0430",
      "longitude":85.6955141,
      "latitude":55.6127466
    },
    "7410":{
      "name":"\u0417\u043d\u0430\u043c\u0435\u043d\u0441\u043a\u0438\u0439",
      "longitude":85.6968745,
      "latitude":55.1935397
    },
    "7411":{
      "name":"\u0422\u043e\u0440\u043e\u043f\u043e\u0432\u043e",
      "longitude":85.69973,
      "latitude":54.681923
    },
    "7412":{
      "name":"\u041f\u043e\u0440\u0442\u043d\u044f\u0433\u0438\u043d\u043e",
      "longitude":85.7034505,
      "latitude":54.9664938
    },
    "7413":{
      "name":"\u0427\u0443\u0432\u0430\u0448-\u041f\u0430\u0439",
      "longitude":85.704651,
      "latitude":54.327705
    },
    "7414":{
      "name":"\u042e\u0436\u043d\u044b\u0439",
      "longitude":85.717598,
      "latitude":54.586262
    },
    "7415":{
      "name":"115 \u043a\u043c",
      "longitude":85.7320822,
      "latitude":55.2473647
    },
    "7416":{
      "name":"\u0417\u0430\u0440\u0435\u0447\u043d\u044b\u0439",
      "longitude":85.734322,
      "latitude":54.273495
    },
    "7417":{
      "name":"\u041e\u0440\u043b\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":85.736137,
      "latitude":54.795639
    },
    "7418":{
      "name":"\u041f\u0435\u0449\u0435\u0440\u043a\u0430",
      "longitude":85.73893,
      "latitude":55.620872
    },
    "7419":{
      "name":"\u0414\u0435\u0434\u044e\u0435\u0432\u043e",
      "longitude":85.7408832,
      "latitude":55.3642128
    },
    "7420":{
      "name":"123 \u043a\u043c",
      "longitude":85.7424251,
      "latitude":55.182837
    },
    "7421":{
      "name":"13 \u043a\u043c",
      "longitude":85.7527091,
      "latitude":55.3372184
    },
    "7422":{
      "name":"\u0414\u0435\u0434\u044e\u0435\u0432\u043e",
      "longitude":85.7580068,
      "latitude":55.3394407
    },
    "7423":{
      "name":"\u0418\u0437\u0432\u0435\u0441\u0442\u043a\u043e\u0432\u044b\u0439",
      "longitude":85.761322,
      "latitude":55.597027
    },
    "7424":{
      "name":"\u041a\u0430\u043c\u0435\u043d\u0443\u0448\u043a\u0430",
      "longitude":85.767845,
      "latitude":54.300526
    },
    "7425":{
      "name":"239 \u043a\u043c",
      "longitude":85.7743467,
      "latitude":54.8756604
    },
    "7426":{
      "name":"\u0421\u0430\u043b\u0430\u0438\u0440\u0441\u043a\u0438\u0439 \u0414\u043e\u043c \u041e\u0442\u0434\u044b\u0445\u0430",
      "longitude":85.783859,
      "latitude":54.276772
    },
    "7427":{
      "name":"\u041d\u043e\u0432\u043e\u043f\u043e\u0434\u0438\u043a\u043e\u0432\u043e",
      "longitude":85.784195,
      "latitude":55.680389
    },
    "7428":{
      "name":"\u0423\u043d\u044c\u0433\u0430",
      "longitude":85.7867246,
      "latitude":55.215061
    },
    "7429":{
      "name":"\u041f\u043e\u0434\u043e\u043d\u0438\u043d\u043e",
      "longitude":85.7927137,
      "latitude":55.5765474
    },
    "7430":{
      "name":"130 \u043a\u043c",
      "longitude":85.7987114,
      "latitude":55.1393723
    },
    "7431":{
      "name":"\u041a\u0430\u0440\u044c\u0435\u0440 (\u0411\u0435\u043b\u0430\u044f \u0413\u043b\u0438\u043d\u043a\u0430)",
      "longitude":85.808708,
      "latitude":54.715122
    },
    "7432":{
      "name":"\u041a\u0430\u043c\u0435\u043d\u043d\u044b\u0439 \u0411\u0440\u043e\u0434",
      "longitude":85.808853,
      "latitude":55.981026
    },
    "7433":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":85.8112728,
      "latitude":56.274266
    },
    "7434":{
      "name":"\u0421\u043e\u043a\u043e\u043b\u043e\u0432\u043a\u0430",
      "longitude":85.818161,
      "latitude":54.701107
    },
    "7435":{
      "name":"\u041e\u043a\u0442\u044f\u0431\u0440\u044c\u0441\u043a\u0438\u0439",
      "longitude":85.8194603,
      "latitude":54.9798227
    },
    "7436":{
      "name":"\u041a\u0440\u0443\u0442\u043e\u0432\u043a\u0430",
      "longitude":85.821121,
      "latitude":55.980465
    },
    "7437":{
      "name":"\u0421\u0435\u043c\u0451\u043d\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":85.826683,
      "latitude":55.4846
    },
    "7438":{
      "name":"\u041f\u043e\u0434\u044a\u044f\u043a\u043e\u0432\u043e",
      "longitude":85.828003,
      "latitude":55.565578
    },
    "7439":{
      "name":"\u0413\u0430\u0432\u0440\u0438\u043b\u043e\u0432\u043a\u0430",
      "longitude":85.834839,
      "latitude":54.26075
    },
    "7440":{
      "name":"\u041f\u0438\u0445\u0442\u0430\u0447",
      "longitude":85.8421375,
      "latitude":56.0516213
    },
    "7441":{
      "name":"\u041c\u043e\u0441\u0442\u043e\u0432\u0430\u044f",
      "longitude":85.845612,
      "latitude":54.462322
    },
    "7442":{
      "name":"137 \u043a\u043c",
      "longitude":85.8478087,
      "latitude":55.0921099
    },
    "7443":{
      "name":"\u0423\u0448\u0430\u043a\u043e\u0432\u043e",
      "longitude":85.8565115,
      "latitude":54.9298911
    },
    "7444":{
      "name":"\u0411\u0443\u0440\u0435\u043d\u0438\u0447\u0435\u0432\u043e",
      "longitude":85.869865,
      "latitude":55.357933
    },
    "7445":{
      "name":"\u041d\u0438\u0437\u043e\u0432\u043a\u0430",
      "longitude":85.871193,
      "latitude":55.957508
    },
    "7446":{
      "name":"\u0414\u0435\u0433\u0442\u044f\u0440\u0451\u0432\u043a\u0430",
      "longitude":85.873489,
      "latitude":54.456318
    },
    "7447":{
      "name":"\u0420\u0430\u043a\u0438\u0442\u043d\u044b\u0439",
      "longitude":85.875061,
      "latitude":54.698624
    },
    "7448":{
      "name":"\u041d\u043e\u0432\u043e\u043d\u0438\u043a\u043e\u043b\u044c\u0441\u043a\u043e\u0435",
      "longitude":85.8789575,
      "latitude":56.3557551
    },
    "7449":{
      "name":"\u041a\u0440\u0451\u043a\u043e\u0432\u043e",
      "longitude":85.879263,
      "latitude":55.5179779
    },
    "7450":{
      "name":"\u041a\u043e\u043d\u0442\u0440\u043e\u043b\u044c\u043d\u0430\u044f",
      "longitude":85.880206,
      "latitude":54.8605124
    },
    "7451":{
      "name":"\u0421\u043e\u0431\u043e\u043b\u0438\u043d\u043a\u0430",
      "longitude":85.887037,
      "latitude":56.2684964
    },
    "7452":{
      "name":"\u0421\u0442\u0430\u0440\u0430\u044f \u0411\u0430\u043b\u0430\u0445\u043e\u043d\u043a\u0430",
      "longitude":85.896172,
      "latitude":55.538322
    },
    "7453":{
      "name":"\u0423\u0441\u0442\u044c-\u041a\u0430\u043d\u0434\u0430",
      "longitude":85.90062,
      "latitude":54.444176
    },
    "7454":{
      "name":"\u041d\u0430\u0433\u043e\u0440\u043d\u044b\u0439",
      "longitude":85.9020438,
      "latitude":55.0634539
    },
    "7455":{
      "name":"\u041d\u0430\u0437\u0430\u0440\u043e\u0432\u043a\u0430",
      "longitude":85.9065694,
      "latitude":56.2398637
    },
    "7456":{
      "name":"\u0415\u043c\u0435\u043b\u044c\u044f\u043d\u043e\u0432\u043a\u0430",
      "longitude":85.9101322,
      "latitude":56.379339
    },
    "7457":{
      "name":"\u0412\u043e\u0441\u0445\u043e\u0434",
      "longitude":85.9115527,
      "latitude":55.0492523
    },
    "7458":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u043c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":85.9147889,
      "latitude":54.9817067
    },
    "7459":{
      "name":"\u0414\u0435\u043d\u0438\u0441\u043e\u0432\u043e",
      "longitude":85.932663,
      "latitude":55.473503
    },
    "7460":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":85.944794,
      "latitude":54.552559
    },
    "7461":{
      "name":"251 \u043a\u043c",
      "longitude":85.9516963,
      "latitude":54.8487034
    },
    "7462":{
      "name":"\u041f\u043e\u0434\u0441\u043e\u0431\u043d\u044b\u0439",
      "longitude":85.9543378,
      "latitude":56.2007532
    },
    "7463":{
      "name":"\u0412\u043e\u0442\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":85.966942,
      "latitude":55.851952
    },
    "7464":{
      "name":"\u0421\u0443\u0442\u0443\u043d\u043a\u0438\u043d \u0411\u0440\u043e\u0434",
      "longitude":85.972107,
      "latitude":55.579975
    },
    "7465":{
      "name":"\u0422\u0430\u0440\u0430\u0431\u0430\u0440\u0438\u043d\u043e",
      "longitude":85.9751527,
      "latitude":54.859168
    },
    "7466":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u0430\u044f \u0413\u043e\u0440\u043a\u0430",
      "longitude":85.976868,
      "latitude":54.700314
    },
    "7467":{
      "name":"\u0411\u0440\u044f\u043d\u0441\u043a\u0438\u0439 (157 \u043a\u043c)",
      "longitude":85.9795455,
      "latitude":54.9519272
    },
    "7468":{
      "name":"\u0417\u0430\u0440\u044f",
      "longitude":85.983818,
      "latitude":55.197262
    },
    "7469":{
      "name":"\u0421\u0430\u0440\u0430\u0442\u043e\u0432\u043a\u0430",
      "longitude":85.990501,
      "latitude":54.44611
    },
    "7470":{
      "name":"\u0426\u0432\u0435\u0442\u0443\u0449\u0438\u0439",
      "longitude":85.9910074,
      "latitude":54.8967557
    },
    "7471":{
      "name":"\u041f\u0438\u043d\u0438\u0433\u0438\u043d\u043e",
      "longitude":85.9936908,
      "latitude":55.0853918
    },
    "7472":{
      "name":"\u041a\u043b\u0438\u043d\u0446\u043e\u0432\u043a\u0430",
      "longitude":85.994148,
      "latitude":55.924213
    },
    "7473":{
      "name":"\u0421\u043e\u043b\u043d\u0435\u0447\u043d\u044b\u0439",
      "longitude":85.995392,
      "latitude":55.540253
    },
    "7474":{
      "name":"\u0421\u0442\u0440\u043e\u0438\u0442\u0435\u043b\u044c\u043d\u044b\u0439",
      "longitude":86.006935,
      "latitude":54.843193
    },
    "7475":{
      "name":"\u0421\u043e\u0441\u043d\u043e\u0432\u043a\u0430-2",
      "longitude":86.008919,
      "latitude":55.842335
    },
    "7476":{
      "name":"\u0423\u0441\u0442\u044e\u0436\u0430\u043d\u0438\u043d\u043e",
      "longitude":86.011665,
      "latitude":54.505615
    },
    "7477":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u0411\u0430\u043b\u0430\u0445\u043e\u043d\u043a\u0430",
      "longitude":86.02169,
      "latitude":55.605988
    },
    "7478":{
      "name":"\u041d\u0435\u043f\u0440\u0435\u0440\u044b\u0432\u043a\u0430",
      "longitude":86.021751,
      "latitude":54.752808
    },
    "7479":{
      "name":"\u0428\u043a\u043e\u043b\u044c\u043d\u044b\u0439",
      "longitude":86.027245,
      "latitude":54.783966
    },
    "7480":{
      "name":"\u0420\u043e\u0434\u043d\u0438\u043a\u043e\u0432\u044b\u0439",
      "longitude":86.033966,
      "latitude":54.401543
    },
    "7481":{
      "name":"\u0421\u0430\u043f\u043e\u0433\u043e\u0432\u043e",
      "longitude":86.038712,
      "latitude":54.728531
    },
    "7482":{
      "name":"\u0412\u043e\u0441\u043a\u0440\u0435\u0441\u0435\u043d\u043a\u0430 (\u0421\u0443\u0440\u043e\u0432\u043a\u0430)",
      "longitude":86.0409567,
      "latitude":56.2576402
    },
    "7483":{
      "name":"\u041c\u0430\u043c\u0430\u0435\u0432\u0441\u043a\u0438\u0439",
      "longitude":86.048058,
      "latitude":55.246929
    },
    "7484":{
      "name":"3-\u0439 \u0421\u043a\u043b\u0430\u0434",
      "longitude":86.0495508,
      "latitude":56.020188
    },
    "7485":{
      "name":"\u0420\u043e\u0432\u0435\u043d\u0441\u043a\u0438\u0439",
      "longitude":86.052246,
      "latitude":55.810474
    },
    "7486":{
      "name":"\u0422\u0440\u0435\u043a\u0438\u043d\u043e",
      "longitude":86.064186,
      "latitude":54.83046
    },
    "7487":{
      "name":"\u0422\u0435\u0440\u0435\u043d\u0442\u044c\u0435\u0432\u043a\u0430",
      "longitude":86.0678339,
      "latitude":56.0000012
    },
    "7488":{
      "name":"\u0428\u0430\u043d\u0434\u0430",
      "longitude":86.067863,
      "latitude":54.310856
    },
    "7489":{
      "name":"\u041f\u0440\u0438\u0432\u043e\u043b\u044c\u043d\u044b\u0439",
      "longitude":86.069267,
      "latitude":55.49799
    },
    "7490":{
      "name":"20 \u043a\u043c",
      "longitude":86.074532,
      "latitude":54.318306
    },
    "7491":{
      "name":"\u0425\u043c\u0435\u043b\u0451\u0432\u043e",
      "longitude":86.075111,
      "latitude":54.721439
    },
    "7492":{
      "name":"\u041f\u043b\u043e\u0442\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":86.0768514,
      "latitude":55.0236505
    },
    "7493":{
      "name":"\u041d\u043e\u0432\u043e\u0438\u043b\u044c\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":86.080284,
      "latitude":54.713676
    },
    "7494":{
      "name":"\u0413\u043e\u0440\u043d\u044f\u043a",
      "longitude":86.081047,
      "latitude":54.660366
    },
    "7495":{
      "name":"\u041f\u0430\u0432\u043b\u043e\u0432\u043a\u0430",
      "longitude":86.08329,
      "latitude":54.500946
    },
    "7496":{
      "name":"168 \u043a\u043c",
      "longitude":86.087995,
      "latitude":54.8907612
    },
    "7497":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":86.090752,
      "latitude":54.825195
    },
    "7498":{
      "name":"326-\u0433\u043e \u041a\u0432\u0430\u0440\u0442\u0430\u043b\u0430",
      "longitude":86.0918472,
      "latitude":56.019812
    },
    "7499":{
      "name":"\u041c\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":86.092403,
      "latitude":56.3234832
    },
    "7500":{
      "name":"\u0421\u043e\u043b\u043d\u0435\u0447\u043d\u044b\u0439",
      "longitude":86.093971,
      "latitude":54.636742
    },
    "7501":{
      "name":"\u041a\u0430\u043c\u0435\u043d\u043d\u044b\u0439 \u041a\u043b\u044e\u0447",
      "longitude":86.096268,
      "latitude":54.093002
    },
    "7502":{
      "name":"\u041c\u0430\u0440\u0443\u0447\u0430\u043a",
      "longitude":86.097954,
      "latitude":55.148537
    },
    "7503":{
      "name":"169 \u043a\u043c",
      "longitude":86.100586,
      "latitude":54.877815
    },
    "7504":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u0430\u043c\u044b\u0448\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":86.100929,
      "latitude":54.651913
    },
    "7505":{
      "name":"\u041a\u043e\u0437\u043b\u044b",
      "longitude":86.1015665,
      "latitude":55.9959933
    },
    "7506":{
      "name":"\u0421\u043e\u0441\u043d\u043e\u0432\u043a\u0430",
      "longitude":86.101791,
      "latitude":55.745918
    },
    "7507":{
      "name":"\u0420\u0443\u0441\u0441\u043a\u043e-\u0423\u0440\u0441\u043a\u0438\u0439",
      "longitude":86.105553,
      "latitude":54.513912
    },
    "7508":{
      "name":"\u0418\u043d\u0434\u0443\u0441\u0442\u0440\u0438\u044f",
      "longitude":86.1066774,
      "latitude":54.6205877
    },
    "7509":{
      "name":"\u0415\u0433\u043e\u0437\u043e\u0432\u043e",
      "longitude":86.11013,
      "latitude":54.714176
    },
    "7510":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u0442\u0440\u043e\u0439\u043a\u0430",
      "longitude":86.110724,
      "latitude":56.1782233
    },
    "7511":{
      "name":"\u0414\u0430\u043d\u043a\u043e\u0432\u043a\u0430",
      "longitude":86.1129366,
      "latitude":56.3002919
    },
    "7512":{
      "name":"\u0420\u0430\u0441\u043a\u0430\u0442\u0438\u0445\u0430",
      "longitude":86.125099,
      "latitude":54.794586
    },
    "7513":{
      "name":"\u0421\u044b\u0440\u043e\u043c\u043e\u043b\u043e\u0442\u043d\u0430\u044f",
      "longitude":86.1257178,
      "latitude":55.0712839
    },
    "7514":{
      "name":"\u0410\u0440\u0441\u0435\u043d\u0442\u044c\u0435\u0432\u043a\u0430",
      "longitude":86.142174,
      "latitude":55.749191
    },
    "7515":{
      "name":"\u041e\u0431\u044a\u0435\u043a\u0442 1200",
      "longitude":86.1471783,
      "latitude":55.4121506
    },
    "7516":{
      "name":"\u041f\u043e\u0440\u0435\u0447\u044c\u0435",
      "longitude":86.157982,
      "latitude":54.561771
    },
    "7517":{
      "name":"\u041c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":86.163198,
      "latitude":56.1804581
    },
    "7518":{
      "name":"\u0414\u043e\u043d\u0441\u043a\u043e\u0439",
      "longitude":86.1643513,
      "latitude":55.8970204
    },
    "7519":{
      "name":"\u041e\u0441\u0435\u043b\u043a\u0438",
      "longitude":86.1643705,
      "latitude":54.069589
    },
    "7520":{
      "name":"\u041d\u043e\u0432\u043e\u0431\u0430\u0440\u0430\u0447\u0430\u0442\u044b",
      "longitude":86.1695268,
      "latitude":55.044323
    },
    "7521":{
      "name":"\u041a\u0430\u0431\u0430\u043d\u043e\u0432\u043e",
      "longitude":86.170723,
      "latitude":54.984852
    },
    "7522":{
      "name":"\u041d\u043e\u0432\u043e\u0440\u043e\u0441\u0441\u0438\u0439\u043a\u0430",
      "longitude":86.179169,
      "latitude":54.447235
    },
    "7523":{
      "name":"\u0427\u0438\u043d\u0434\u0430\u0442\u0441\u043a\u0438\u0439",
      "longitude":86.1822718,
      "latitude":56.1308662
    },
    "7524":{
      "name":"189 \u043a\u043c",
      "longitude":86.186646,
      "latitude":54.74794
    },
    "7525":{
      "name":"\u041c\u0435\u0434\u0432\u0435\u0434\u0447\u0438\u043a\u043e\u0432\u043e",
      "longitude":86.1886841,
      "latitude":56.529997
    },
    "7526":{
      "name":"\u0415\u043b\u043e\u0432\u043a\u0430",
      "longitude":86.192955,
      "latitude":54.100811
    },
    "7527":{
      "name":"\u0421\u043e\u043b\u043e\u043d\u0435\u0447\u043d\u0430\u044f",
      "longitude":86.194786,
      "latitude":55.413376
    },
    "7528":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u0430\u044f \u041f\u043e\u043b\u044f\u043d\u0430",
      "longitude":86.195526,
      "latitude":54.734562
    },
    "7529":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u043a\u0430",
      "longitude":86.201866,
      "latitude":54.830971
    },
    "7530":{
      "name":"\u041a\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":86.209732,
      "latitude":54.497223
    },
    "7531":{
      "name":"\u041b\u0430\u043f\u0448\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":86.210541,
      "latitude":54.722595
    },
    "7532":{
      "name":"\u0412\u0435\u0440\u0445\u043e\u0432\u0441\u043a\u0430\u044f",
      "longitude":86.214035,
      "latitude":54.364315
    },
    "7533":{
      "name":"\u0414\u0443\u0431\u0440\u043e\u0432\u043e",
      "longitude":86.2268904,
      "latitude":54.1493765
    },
    "7534":{
      "name":"\u041f\u0443\u0433\u0430\u0447\u0438",
      "longitude":86.235413,
      "latitude":55.278584
    },
    "7535":{
      "name":"\u0416\u0443\u0440\u0433\u0430\u0432\u0430\u043d\u044c",
      "longitude":86.236557,
      "latitude":55.348118
    },
    "7536":{
      "name":"\u041f\u0440\u043e\u0435\u043a\u0442\u043d\u0430\u044f",
      "longitude":86.237427,
      "latitude":54.545017
    },
    "7537":{
      "name":"\u041d\u0438\u0436\u0435\u0433\u043e\u0440\u043e\u0434\u043a\u0430",
      "longitude":86.249176,
      "latitude":54.679626
    },
    "7538":{
      "name":"\u0411\u0443\u0441\u043a\u0443\u0441\u043a\u0430\u043d",
      "longitude":86.249878,
      "latitude":54.195042
    },
    "7539":{
      "name":"\u0414\u0438\u043c\u0438\u0442\u0440\u043e\u0432\u043e",
      "longitude":86.2502089,
      "latitude":56.4642309
    },
    "7540":{
      "name":"\u041e\u043a\u0442\u044f\u0431\u0440\u044c\u0441\u043a\u0438\u0439",
      "longitude":86.256317,
      "latitude":54.375324
    },
    "7541":{
      "name":"\u0410\u043d\u0442\u043e\u043d\u043e\u0432\u043a\u0430",
      "longitude":86.2638464,
      "latitude":56.1077074
    },
    "7542":{
      "name":"\u041a\u0430\u0440\u0430-\u0427\u0443\u043c\u044b\u0448",
      "longitude":86.275734,
      "latitude":54.086823
    },
    "7543":{
      "name":"\u041c\u0430\u043b\u044c\u0446\u0435\u0432\u043e",
      "longitude":86.2767495,
      "latitude":56.1745421
    },
    "7544":{
      "name":"\u0410\u0440\u0442\u044b\u0448\u0442\u0430",
      "longitude":86.277489,
      "latitude":54.176342
    },
    "7545":{
      "name":"\u0421\u0442\u0430\u043d\u0446\u0438\u043e\u043d\u043d\u044b\u0439",
      "longitude":86.2786929,
      "latitude":55.7117769
    },
    "7546":{
      "name":"\u0421\u043c\u0438\u0440\u043d\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":86.304306,
      "latitude":55.110683
    },
    "7547":{
      "name":"\u0422\u0438\u0445\u0435\u0435\u0432\u043a\u0430",
      "longitude":86.313483,
      "latitude":56.4808119
    },
    "7548":{
      "name":"\u0412\u043e\u0437\u043d\u0435\u0441\u0435\u043d\u043a\u0430",
      "longitude":86.313614,
      "latitude":55.402966
    },
    "7549":{
      "name":"\u041c\u0435\u0440\u0435\u0442\u044c",
      "longitude":86.317162,
      "latitude":54.50079
    },
    "7550":{
      "name":"\u041e\u0437\u0435\u0440\u043e\u0432\u043a\u0430",
      "longitude":86.324707,
      "latitude":54.778606
    },
    "7551":{
      "name":"\u0448\u0430\u0445\u0442\u044b \u2116 5",
      "longitude":86.3251989,
      "latitude":54.5385909
    },
    "7552":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":86.331375,
      "latitude":55.356632
    },
    "7553":{
      "name":"\u0422\u044b\u0440\u0433\u0430\u043d",
      "longitude":86.343231,
      "latitude":54.132484
    },
    "7554":{
      "name":"\u041c\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":86.350571,
      "latitude":55.362995
    },
    "7555":{
      "name":"\u0422\u0435\u0431\u0435\u043d\u044c\u043a\u043e\u0432\u043a\u0430",
      "longitude":86.360123,
      "latitude":55.36134
    },
    "7556":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u043a\u0430",
      "longitude":86.3627455,
      "latitude":53.9250549
    },
    "7557":{
      "name":"\u041e\u0441\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":86.36335,
      "latitude":54.453457
    },
    "7558":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":86.365829,
      "latitude":55.276508
    },
    "7559":{
      "name":"\u041e\u043b\u044c\u0433\u043e\u0432\u043a\u0430",
      "longitude":86.367233,
      "latitude":56.555408
    },
    "7560":{
      "name":"\u0412\u0435\u0440\u0445-\u0412\u0435\u043b\u0438\u043a\u043e\u0441\u0435\u043b\u044c\u0441\u043a\u043e\u0435",
      "longitude":86.3673971,
      "latitude":56.4240327
    },
    "7561":{
      "name":"\u0418\u043b\u0438\u043d\u0434\u0435\u0435\u0432\u043a\u0430",
      "longitude":86.368797,
      "latitude":55.34227
    },
    "7562":{
      "name":"\u041e\u043b\u044c\u0433\u043e\u0432\u043a\u0430",
      "longitude":86.3703806,
      "latitude":56.2292856
    },
    "7563":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":86.374565,
      "latitude":53.980251
    },
    "7564":{
      "name":"\u0423\u0440\u043c\u0430\u043d\u0430\u0439",
      "longitude":86.375145,
      "latitude":55.284245
    },
    "7565":{
      "name":"\u041b\u044f\u043f\u043a\u0438",
      "longitude":86.379044,
      "latitude":55.178596
    },
    "7566":{
      "name":"\u0418\u043d\u0447\u0435\u043d\u043a\u043e\u0432\u043e",
      "longitude":86.383568,
      "latitude":54.059406
    },
    "7567":{
      "name":"\u0414\u043c\u0438\u0442\u0440\u0438\u0435\u0432\u043a\u0430",
      "longitude":86.384834,
      "latitude":55.618992
    },
    "7568":{
      "name":"\u041a\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":86.386246,
      "latitude":54.098442
    },
    "7569":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":86.3875427,
      "latitude":53.9474738
    },
    "7570":{
      "name":"\u0438\u043c\u0435\u043d\u0438 \u0418\u043b\u044c\u0438\u0447\u0430",
      "longitude":86.389099,
      "latitude":54.312168
    },
    "7571":{
      "name":"\u041c\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":86.390839,
      "latitude":54.005478
    },
    "7572":{
      "name":"\u0410\u0440\u044b\u0448\u0435\u0432\u043e",
      "longitude":86.3933036,
      "latitude":56.3141567
    },
    "7573":{
      "name":"\u0417\u043e\u043b\u043e\u0442\u0430\u0440\u0451\u0432\u0441\u043a\u0438\u0439",
      "longitude":86.395485,
      "latitude":54.71553
    },
    "7574":{
      "name":"\u0423\u043f\u043e\u0440\u043e\u0432\u043a\u0430",
      "longitude":86.396965,
      "latitude":55.254364
    },
    "7575":{
      "name":"\u0427\u0435\u0441\u043d\u043e\u043a\u043e\u0432\u043e",
      "longitude":86.401558,
      "latitude":54.819347
    },
    "7576":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u043f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":86.406174,
      "latitude":56.501717
    },
    "7577":{
      "name":"\u041f\u0430\u043d\u0438\u043d\u0441\u043a",
      "longitude":86.410538,
      "latitude":55.323605
    },
    "7578":{
      "name":"\u0421\u0430\u0440\u0430\u043f\u043a\u0438",
      "longitude":86.410881,
      "latitude":55.068214
    },
    "7579":{
      "name":"\u041d\u0430\u0448\u0430 \u0420\u043e\u0434\u0438\u043d\u0430",
      "longitude":86.4119912,
      "latitude":56.1788345
    },
    "7580":{
      "name":"\u0421\u0435\u043c\u0451\u043d\u043e\u0432\u043e",
      "longitude":86.418968,
      "latitude":54.900879
    },
    "7581":{
      "name":"\u0411\u0435\u0440\u0434\u043e\u0432\u043a\u0430",
      "longitude":86.443817,
      "latitude":55.556263
    },
    "7582":{
      "name":"\u041c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":86.4483425,
      "latitude":56.0631725
    },
    "7583":{
      "name":"\u0418\u0433\u0430\u043d\u0438\u043d\u043e",
      "longitude":86.451042,
      "latitude":54.008224
    },
    "7584":{
      "name":"\u041c\u0430\u043b\u044c\u0446\u0435\u0432\u043e",
      "longitude":86.4521212,
      "latitude":56.1194504
    },
    "7585":{
      "name":"\u041d\u043e\u0432\u043e\u043f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":86.457855,
      "latitude":54.659309
    },
    "7586":{
      "name":"\u0418\u043d\u0447\u0435\u043d\u043a\u043e\u0432\u043e",
      "longitude":86.466339,
      "latitude":54.071568
    },
    "7587":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u0430\u044f \u0413\u043e\u0440\u043a\u0430",
      "longitude":86.468414,
      "latitude":53.856632
    },
    "7588":{
      "name":"\u041b\u0435\u043d\u0438\u043d\u043a\u0430",
      "longitude":86.47187,
      "latitude":54.913464
    },
    "7589":{
      "name":"\u041b\u0438\u0442\u0432\u0438\u043d\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":86.472603,
      "latitude":54.70351
    },
    "7590":{
      "name":"\u0411\u0435\u0440\u0434\u044e\u0433\u0438\u043d\u043e",
      "longitude":86.476547,
      "latitude":54.868237
    },
    "7591":{
      "name":"\u0421\u0442\u0435\u043f\u043d\u043e\u0439",
      "longitude":86.477898,
      "latitude":54.307652
    },
    "7592":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u0430\u044f \u041f\u043e\u043b\u044f\u043d\u0430",
      "longitude":86.48246,
      "latitude":53.91338
    },
    "7593":{
      "name":"\u0417\u043e\u043b\u0445",
      "longitude":86.49498,
      "latitude":53.874142
    },
    "7594":{
      "name":"\u041f\u043e\u043d\u043e\u043c\u0430\u0440\u0435\u0432\u043a\u0430",
      "longitude":86.4968644,
      "latitude":56.1234678
    },
    "7595":{
      "name":"\u042e\u0433\u043e-\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":86.500748,
      "latitude":55.653996
    },
    "7596":{
      "name":"\u0423\u0433\u043b\u0435\u0440\u043e\u0434",
      "longitude":86.501671,
      "latitude":54.093014
    },
    "7597":{
      "name":"\u0412\u043e\u0441\u043a\u0440\u0435\u0441\u0435\u043d\u043a\u0430",
      "longitude":86.502167,
      "latitude":55.208824
    },
    "7598":{
      "name":"\u0417\u0430\u0440\u044f",
      "longitude":86.514969,
      "latitude":54.528042
    },
    "7599":{
      "name":"\u0427\u0438\u0441\u0442\u0443\u0433\u0430\u0448",
      "longitude":86.516953,
      "latitude":53.830463
    },
    "7600":{
      "name":"\u0426\u0435\u043d\u0442\u0440\u0430\u043b\u044c\u043d\u044b\u0439",
      "longitude":86.523453,
      "latitude":53.951107
    },
    "7601":{
      "name":"\u0425\u0430\u0445\u0430\u043b\u0438\u043d\u043e",
      "longitude":86.525948,
      "latitude":54.475731
    },
    "7602":{
      "name":"\u041c\u0430\u043a\u0441\u0438\u043c\u043e\u0432\u043e",
      "longitude":86.532585,
      "latitude":54.829113
    },
    "7603":{
      "name":"\u041a\u0430\u0440\u0430-\u0427\u0443\u043c\u044b\u0448",
      "longitude":86.534645,
      "latitude":53.781498
    },
    "7604":{
      "name":"\u041a\u0430\u043c\u0435\u0448\u0435\u043a",
      "longitude":86.541008,
      "latitude":54.428291
    },
    "7605":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":86.552849,
      "latitude":56.217026
    },
    "7606":{
      "name":"\u041d\u043e\u0432\u043e\u043f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":86.561127,
      "latitude":56.545685
    },
    "7607":{
      "name":"\u0410\u0437\u0430\u043d\u043e\u0432\u043e",
      "longitude":86.570381,
      "latitude":56.112835
    },
    "7608":{
      "name":"\u041e\u043a\u0442\u044f\u0431\u0440\u0438\u043d\u043a\u0430",
      "longitude":86.5721948,
      "latitude":54.0362387
    },
    "7609":{
      "name":"\u0423\u0441\u043f\u0435\u043d\u043a\u0430",
      "longitude":86.596245,
      "latitude":55.717182
    },
    "7610":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u0441\u0435\u0440\u0433\u0435\u0435\u0432\u043a\u0430",
      "longitude":86.598915,
      "latitude":54.094997
    },
    "7611":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0439 \u0422\u0435\u0440\u0435\u0448",
      "longitude":86.60408,
      "latitude":53.72345
    },
    "7612":{
      "name":"\u0414\u043e\u043b\u0433\u043e\u043f\u043e\u043b\u043e\u0432\u043e",
      "longitude":86.60762,
      "latitude":54.77478
    },
    "7613":{
      "name":"\u041d\u0438\u0436\u0435\u0433\u043e\u0440\u043e\u0434\u043a\u0430",
      "longitude":86.608009,
      "latitude":56.409424
    },
    "7614":{
      "name":"\u0417\u0430\u0434\u0443\u0431\u0440\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":86.611259,
      "latitude":54.432007
    },
    "7615":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":86.618401,
      "latitude":54.37719
    },
    "7616":{
      "name":"\u0422\u0430\u0439\u0431\u0438\u043d\u043a\u0430",
      "longitude":86.624199,
      "latitude":53.931644
    },
    "7617":{
      "name":"\u0412\u0435\u0440\u0445-\u0422\u0435\u0440\u0435\u0448",
      "longitude":86.624275,
      "latitude":53.745571
    },
    "7618":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":86.644394,
      "latitude":55.001457
    },
    "7619":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":86.651443,
      "latitude":54.196156
    },
    "7620":{
      "name":"\u041d\u0438\u0436\u043d\u044f\u044f \u0421\u0443\u0435\u0442\u0430",
      "longitude":86.652046,
      "latitude":55.526588
    },
    "7621":{
      "name":"\u0413\u043b\u0443\u0445\u0430\u0440\u0438\u043d\u043a\u0430",
      "longitude":86.65435,
      "latitude":55.76796
    },
    "7622":{
      "name":"\u0423\u0441\u043a\u0430\u0442",
      "longitude":86.6647781,
      "latitude":54.0888064
    },
    "7623":{
      "name":"\u041d\u043e\u0432\u043e\u043e\u0440\u043b\u043e\u0432\u043a\u0430",
      "longitude":86.677124,
      "latitude":56.565548
    },
    "7624":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u0425\u043e\u043b\u043c",
      "longitude":86.678986,
      "latitude":53.631226
    },
    "7625":{
      "name":"\u0410\u043d\u0442\u043e\u043d\u043e\u0432\u043a\u0430",
      "longitude":86.680717,
      "latitude":54.251328
    },
    "7626":{
      "name":"\u041a\u0443\u0442\u043e\u043d\u043e\u0432\u043e",
      "longitude":86.688599,
      "latitude":54.094521
    },
    "7627":{
      "name":"\u0422\u0430\u043b\u043e\u0432\u0430\u044f",
      "longitude":86.708221,
      "latitude":53.683647
    },
    "7628":{
      "name":"\u041b\u0443\u043a\u044c\u044f\u043d\u043e\u0432\u043a\u0430",
      "longitude":86.709221,
      "latitude":54.220104
    },
    "7629":{
      "name":"\u041d\u043e\u0432\u043e\u0434\u0443\u0431\u0440\u043e\u0432\u043a\u0430",
      "longitude":86.717278,
      "latitude":54.370323
    },
    "7630":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":86.723236,
      "latitude":55.140297
    },
    "7631":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0435\u043a\u0438\u0442\u0430\u0442\u0441\u043a\u0438\u0439",
      "longitude":86.731377,
      "latitude":55.841335
    },
    "7632":{
      "name":"\u041d\u043e\u0432\u044b\u0439 \u041f\u0443\u0442\u044c",
      "longitude":86.735893,
      "latitude":53.717159
    },
    "7633":{
      "name":"\u041d\u043e\u0432\u043e\u0440\u043e\u0436\u0434\u0435\u0441\u0442\u0432\u0435\u043d\u0441\u043a\u043e\u0435",
      "longitude":86.747742,
      "latitude":53.767906
    },
    "7634":{
      "name":"\u041a\u043e\u043c\u0430\u0440\u043e\u0432\u043a\u0430",
      "longitude":86.751488,
      "latitude":55.158268
    },
    "7635":{
      "name":"\u041c\u0430\u044f\u043a\u043e\u0432\u043a\u0430",
      "longitude":86.765625,
      "latitude":54.005802
    },
    "7636":{
      "name":"\u041a\u043e\u0442\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":86.769432,
      "latitude":56.37178
    },
    "7637":{
      "name":"\u0417\u043c\u0435\u0438\u043d\u043a\u0430",
      "longitude":86.774567,
      "latitude":55.095875
    },
    "7638":{
      "name":"\u041f\u043e\u043f\u0435\u0440\u0435\u0447\u043d\u043e\u0435",
      "longitude":86.787529,
      "latitude":54.872429
    },
    "7639":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u0417\u043b\u0430\u0442\u043e\u0433\u043e\u0440\u043a\u0430",
      "longitude":86.791428,
      "latitude":55.81657
    },
    "7640":{
      "name":"\u0411\u0435\u043d\u0436\u0435\u0440\u0435\u043f 2-\u0439",
      "longitude":86.795395,
      "latitude":53.262932
    },
    "7641":{
      "name":"\u041c\u043e\u0441\u0442\u043e\u0432\u0430\u044f",
      "longitude":86.799026,
      "latitude":53.462486
    },
    "7642":{
      "name":"\u041f\u0443\u0448\u043a\u0438\u043d\u043e",
      "longitude":86.800369,
      "latitude":54.191242
    },
    "7643":{
      "name":"\u0415\u0433\u0443\u043b\u0442\u044b\u0441",
      "longitude":86.805946,
      "latitude":54.022526
    },
    "7644":{
      "name":"\u0427\u0430\u043f\u0430\u0435\u0432\u0441\u043a\u0438\u0439",
      "longitude":86.806892,
      "latitude":54.140015
    },
    "7645":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u0417\u043b\u0430\u0442\u043e\u0433\u043e\u0440\u043a\u0430",
      "longitude":86.81488,
      "latitude":55.849461
    },
    "7646":{
      "name":"\u0422\u0438\u0445\u0435\u0435\u0432\u043a\u0430",
      "longitude":86.816063,
      "latitude":55.737011
    },
    "7647":{
      "name":"\u041d\u043e\u0432\u043e\u0445\u0443\u0434\u044f\u043a\u043e\u0432\u043e",
      "longitude":86.8246,
      "latitude":54.508743
    },
    "7648":{
      "name":"\u0418\u0432\u0435\u0440\u043a\u0430",
      "longitude":86.826958,
      "latitude":55.943478
    },
    "7649":{
      "name":"\u0423\u0441\u043a\u0430\u0442\u0441\u043a\u0438\u0439",
      "longitude":86.829109,
      "latitude":54.100632
    },
    "7650":{
      "name":"\u041b\u043e\u043c\u0430\u0447\u0451\u0432\u043a\u0430",
      "longitude":86.835274,
      "latitude":56.137012
    },
    "7651":{
      "name":"\u0410\u043f\u0430\u043d\u0430\u0441",
      "longitude":86.836967,
      "latitude":53.531898
    },
    "7652":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":86.838959,
      "latitude":53.561771
    },
    "7653":{
      "name":"\u041b\u0438\u0441\u0442\u0432\u044f\u043d\u043a\u0430",
      "longitude":86.840584,
      "latitude":56.010967
    },
    "7654":{
      "name":"\u041c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":86.847122,
      "latitude":54.301121
    },
    "7655":{
      "name":"\u0425\u043b\u0435\u0431\u043e\u0437\u0430\u0432\u043e\u0434\u0430",
      "longitude":86.8564318,
      "latitude":54.0015681
    },
    "7656":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u043c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":86.861053,
      "latitude":53.935207
    },
    "7657":{
      "name":"\u0410\u043d\u0430\u043d\u044c\u0438\u043d\u043e",
      "longitude":86.866562,
      "latitude":53.573742
    },
    "7658":{
      "name":"\u041a\u043b\u044e\u0447\u0438",
      "longitude":86.874184,
      "latitude":53.964291
    },
    "7659":{
      "name":"\u0424\u043e\u043c\u0438\u0445\u0430",
      "longitude":86.876816,
      "latitude":55.032959
    },
    "7660":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u041f\u0435\u0441\u0447\u0430\u043d\u043a\u0430",
      "longitude":86.877815,
      "latitude":56.235176
    },
    "7661":{
      "name":"\u041c\u0430\u0442\u044e\u0448\u0438\u043d\u043e",
      "longitude":86.885094,
      "latitude":53.746452
    },
    "7662":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u0430\u044f \u0422\u0430\u0439\u0433\u0430",
      "longitude":86.885147,
      "latitude":55.902504
    },
    "7663":{
      "name":"\u0428\u0430\u0440\u043e\u0432\u043e",
      "longitude":86.88961,
      "latitude":53.309799
    },
    "7664":{
      "name":"\u041c\u0443\u043d\u0430\u0439",
      "longitude":86.9067,
      "latitude":53.215073
    },
    "7665":{
      "name":"\u0418\u0432\u0435\u0440\u043a\u0430",
      "longitude":86.906998,
      "latitude":56.155556
    },
    "7666":{
      "name":"\u041b\u0435\u0432\u0430\u0448\u043e\u0432\u043a\u0430",
      "longitude":86.912651,
      "latitude":56.535812
    },
    "7667":{
      "name":"\u0423\u0440\u043d\u0430\u0441",
      "longitude":86.926323,
      "latitude":53.237438
    },
    "7668":{
      "name":"\u0420\u044f\u043c\u043e\u0432\u0430\u044f",
      "longitude":86.929298,
      "latitude":54.560814
    },
    "7669":{
      "name":"\u041a\u0430\u043d\u0434\u0430\u043b\u0435\u043f",
      "longitude":86.929749,
      "latitude":53.273609
    },
    "7670":{
      "name":"\u041d\u043e\u0432\u044b\u0439 \u0423\u0440\u0430\u043b",
      "longitude":86.933632,
      "latitude":53.596649
    },
    "7671":{
      "name":"75-\u0439 \u041f\u0438\u043a\u0435\u0442",
      "longitude":86.938774,
      "latitude":53.738247
    },
    "7672":{
      "name":"\u0412\u0435\u0440\u0445-\u041a\u0438\u043d\u0435\u0440\u043a\u0438",
      "longitude":86.941864,
      "latitude":53.580894
    },
    "7673":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u0430\u044f \u0420\u0435\u0447\u043a\u0430",
      "longitude":86.943767,
      "latitude":52.84432
    },
    "7674":{
      "name":"\u041e\u0441\u0442\u0440\u043e\u0432\u043a\u0430",
      "longitude":86.945908,
      "latitude":56.377693
    },
    "7675":{
      "name":"\u0422\u044b\u0445\u0442\u0430",
      "longitude":86.949242,
      "latitude":54.31834
    },
    "7676":{
      "name":"\u041e\u043a\u0442\u044f\u0431\u0440\u044c",
      "longitude":86.950226,
      "latitude":54.174789
    },
    "7677":{
      "name":"\u0422\u0438\u0445\u043e\u043d\u043e\u0432\u043a\u0430",
      "longitude":86.960693,
      "latitude":54.130859
    },
    "7678":{
      "name":"360 \u043a\u043c",
      "longitude":86.97007,
      "latitude":53.783794
    },
    "7679":{
      "name":"\u042e\u0436\u043d\u044b\u0439",
      "longitude":86.971382,
      "latitude":53.683422
    },
    "7680":{
      "name":"\u041a\u0430\u043b\u043c\u044b\u043a\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":86.979248,
      "latitude":53.628208
    },
    "7681":{
      "name":"\u0421\u043c\u0435\u0442\u0430\u043d\u0438\u043d\u043e",
      "longitude":86.979515,
      "latitude":53.874916
    },
    "7682":{
      "name":"\u0421\u0435\u0440\u043f \u0438 \u041c\u043e\u043b\u043e\u0442",
      "longitude":86.981598,
      "latitude":54.074429
    },
    "7683":{
      "name":"324 \u043a\u043c",
      "longitude":86.982079,
      "latitude":56.162239
    },
    "7684":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u0421\u0443\u043b\u0430\u0433\u0430",
      "longitude":86.994362,
      "latitude":53.089993
    },
    "7685":{
      "name":"\u0412\u044f\u0437\u0435\u043c\u043a\u0430",
      "longitude":87.004524,
      "latitude":55.857639
    },
    "7686":{
      "name":"\u041b\u0435\u043d\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":87.00547,
      "latitude":53.685181
    },
    "7687":{
      "name":"\u0428\u0430\u0440\u0430\u043f",
      "longitude":87.006256,
      "latitude":53.828575
    },
    "7688":{
      "name":"\u0412\u0435\u0441\u0451\u043b\u044b\u0439",
      "longitude":87.007149,
      "latitude":54.052818
    },
    "7689":{
      "name":"\u0417\u0430\u0433\u043e\u0440\u0441\u043a\u0438\u0435 \u0443\u0441\u0430\u0434\u044c\u0431\u044b",
      "longitude":87.0083842,
      "latitude":53.765899
    },
    "7690":{
      "name":"\u042e\u043b\u0430",
      "longitude":87.0084,
      "latitude":53.287758
    },
    "7691":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":87.008667,
      "latitude":53.627708
    },
    "7692":{
      "name":"\u041b\u0443\u0433\u043e\u0432\u0441\u043a\u043e\u0439",
      "longitude":87.0107576,
      "latitude":52.7831669
    },
    "7693":{
      "name":"\u041f\u043e\u0434\u0433\u043e\u0440\u043d\u044b\u0439",
      "longitude":87.0149,
      "latitude":53.81424
    },
    "7694":{
      "name":"\u0413\u043b\u0443\u0445\u043e\u0432\u043a\u0430",
      "longitude":87.015518,
      "latitude":53.769428
    },
    "7695":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":87.016281,
      "latitude":53.784615
    },
    "7696":{
      "name":"\u041a\u0430\u043b\u0438\u043d\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":87.018044,
      "latitude":53.616302
    },
    "7697":{
      "name":"\u041c\u0443\u0440\u044e\u043a",
      "longitude":87.0224161,
      "latitude":55.545175
    },
    "7698":{
      "name":"\u0412\u043e\u0441\u0442\u043e\u0447\u043d\u044b\u0439",
      "longitude":87.0294256,
      "latitude":53.9273395
    },
    "7699":{
      "name":"\u0423\u0447\u0443\u043b",
      "longitude":87.029869,
      "latitude":53.608017
    },
    "7700":{
      "name":"\u041a\u0438\u0440\u0437\u0430\u0432\u043e\u0434\u0441\u043a\u0438\u0439",
      "longitude":87.0435406,
      "latitude":53.7206962
    },
    "7701":{
      "name":"\u041a\u0438\u043b\u0438\u043d\u0441\u043a",
      "longitude":87.043999,
      "latitude":53.333309
    },
    "7702":{
      "name":"\u0427\u0438\u0433\u0438\u0440\u044c",
      "longitude":87.044502,
      "latitude":54.514072
    },
    "7703":{
      "name":"\u041f\u0443\u0448\u043a\u0438\u043d\u043e",
      "longitude":87.056068,
      "latitude":53.677898
    },
    "7704":{
      "name":"\u041f\u043e\u0434\u0433\u043e\u0440\u043d\u0430\u044f",
      "longitude":87.057953,
      "latitude":53.433304
    },
    "7705":{
      "name":"\u041d\u043e\u0432\u044b\u0439",
      "longitude":87.05806,
      "latitude":53.701309
    },
    "7706":{
      "name":"\u041a\u0440\u0430\u0441\u0438\u043d\u0441\u043a",
      "longitude":87.059692,
      "latitude":53.633381
    },
    "7707":{
      "name":"\u0421\u0430\u043b\u0442\u044b\u043c\u0430\u043a\u043e\u0432\u043e",
      "longitude":87.063148,
      "latitude":54.823547
    },
    "7708":{
      "name":"\u0422\u0443\u043d\u0434\u0430",
      "longitude":87.06765,
      "latitude":56.02095
    },
    "7709":{
      "name":"3669 \u043a\u043c",
      "longitude":87.074623,
      "latitude":56.159607
    },
    "7710":{
      "name":"\u0411\u0435\u043b\u043e\u0440\u0443\u0441",
      "longitude":87.075829,
      "latitude":53.497353
    },
    "7711":{
      "name":"\u041a\u044b\u0440\u0433\u0430\u0439",
      "longitude":87.078911,
      "latitude":54.269878
    },
    "7712":{
      "name":"\u042e\u0440\u044c\u0435\u0432\u043a\u0430",
      "longitude":87.080025,
      "latitude":53.566113
    },
    "7713":{
      "name":"\u041c\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":87.086754,
      "latitude":53.550957
    },
    "7714":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u0422\u0430\u043b\u0434\u0430",
      "longitude":87.089432,
      "latitude":54.129871
    },
    "7715":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0435 \u041a\u0438\u043d\u0435\u0440\u043a\u0438",
      "longitude":87.10276,
      "latitude":53.530182
    },
    "7716":{
      "name":"\u0411\u0430\u0437\u0430\u0440\u043d\u044b\u0439",
      "longitude":87.1048579,
      "latitude":52.77414
    },
    "7717":{
      "name":"\u041c\u0438\u0442\u0438\u043d\u043e",
      "longitude":87.109283,
      "latitude":53.825256
    },
    "7718":{
      "name":"\u0413\u0430\u0432\u0440\u0438\u043b\u043e\u0432\u043a\u0430",
      "longitude":87.118553,
      "latitude":53.61726
    },
    "7719":{
      "name":"\u0413\u0430\u0432\u0440\u0438\u043b\u043e\u0432\u043a\u0430",
      "longitude":87.12529,
      "latitude":53.392586
    },
    "7720":{
      "name":"\u041a\u0430\u0440\u0430\u0433\u043e\u043b",
      "longitude":87.125938,
      "latitude":52.778378
    },
    "7721":{
      "name":"\u0422\u0430\u0433\u0430\u0440\u044b\u0448",
      "longitude":87.131142,
      "latitude":54.014194
    },
    "7722":{
      "name":"\u0428\u0430\u0440\u0442\u043e\u043d\u043a\u0430",
      "longitude":87.137444,
      "latitude":53.254383
    },
    "7723":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u0442\u0440\u043e\u0439\u043a\u0430",
      "longitude":87.1482083,
      "latitude":53.2859445
    },
    "7724":{
      "name":"\u0420\u044f\u0431\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":87.148567,
      "latitude":53.456062
    },
    "7725":{
      "name":"\u0422\u0430\u0440\u0433\u0430\u0439",
      "longitude":87.150703,
      "latitude":53.567108
    },
    "7726":{
      "name":"\u0411\u0430\u043b\u043b\u0430\u0441\u0442\u043d\u044b\u0439 \u041a\u0430\u0440\u044c\u0435\u0440",
      "longitude":87.15477,
      "latitude":53.304092
    },
    "7727":{
      "name":"\u041a\u0443\u0440\u044c\u044f",
      "longitude":87.15992,
      "latitude":53.310429
    },
    "7728":{
      "name":"\u041a\u0440\u0443\u0442\u0430\u044f",
      "longitude":87.163803,
      "latitude":53.285923
    },
    "7729":{
      "name":"\u041a\u043b\u044e\u0447\u0438",
      "longitude":87.167099,
      "latitude":53.549343
    },
    "7730":{
      "name":"\u041f\u0440\u0430\u0432\u0434\u0438\u043d\u043a\u0430",
      "longitude":87.171402,
      "latitude":56.328552
    },
    "7731":{
      "name":"\u0411\u0443\u043a\u0438\u043d\u043e",
      "longitude":87.1796952,
      "latitude":53.6830489
    },
    "7732":{
      "name":"\u041b\u0435\u0442\u044f\u0436\u043a\u0430",
      "longitude":87.187469,
      "latitude":55.991966
    },
    "7733":{
      "name":"\u041e\u0441\u043c\u0430\u043d",
      "longitude":87.192383,
      "latitude":53.285042
    },
    "7734":{
      "name":"\u0421\u043c\u0438\u0440\u043d\u043e\u0432\u043a\u0430",
      "longitude":87.196106,
      "latitude":53.661396
    },
    "7735":{
      "name":"\u0422\u0430\u0439\u043b\u0435\u043f",
      "longitude":87.20665,
      "latitude":53.444622
    },
    "7736":{
      "name":"\u0422\u0443\u0439\u043b\u0430",
      "longitude":87.210487,
      "latitude":56.604694
    },
    "7737":{
      "name":"\u0423\u0441\u0442\u044c-\u0422\u0430\u043b\u0430",
      "longitude":87.210823,
      "latitude":53.277893
    },
    "7738":{
      "name":"\u0417\u0435\u043d\u043a\u0438\u043d\u043e",
      "longitude":87.215469,
      "latitude":56.49107
    },
    "7739":{
      "name":"\u0418\u0433\u0430\u043d\u0438\u043d\u043e",
      "longitude":87.22316,
      "latitude":53.993893
    },
    "7740":{
      "name":"\u0417\u0430\u0439\u0446\u0435\u0432\u043e",
      "longitude":87.2373937,
      "latitude":52.6296699
    },
    "7741":{
      "name":"\u0428\u043e\u0440\u043e\u0445\u043e\u0432\u043e",
      "longitude":87.242859,
      "latitude":53.934383
    },
    "7742":{
      "name":"\u041c\u0430\u043b\u044b\u0448\u0435\u0432 \u041b\u043e\u0433",
      "longitude":87.2429921,
      "latitude":53.5422836
    },
    "7743":{
      "name":"\u041c\u0443\u0440\u0430\u0442\u043e\u0432\u043e",
      "longitude":87.245712,
      "latitude":53.680695
    },
    "7744":{
      "name":"\u0416\u0435\u0440\u043d\u043e\u0432\u043e",
      "longitude":87.249168,
      "latitude":54.171185
    },
    "7745":{
      "name":"\u041a\u0443\u043b\u044c\u0447\u0430\u043d\u044b",
      "longitude":87.250687,
      "latitude":53.620171
    },
    "7746":{
      "name":"\u041a\u0430\u043c\u044b\u0448\u0435\u043d\u043a\u0430",
      "longitude":87.253891,
      "latitude":56.106659
    },
    "7747":{
      "name":"\u041f\u043e\u0434\u0441\u0442\u0440\u0435\u043b\u043a\u0430",
      "longitude":87.260544,
      "latitude":53.355209
    },
    "7748":{
      "name":"\u041a\u0430\u0440\u0447\u0430\u0433\u043e\u043b",
      "longitude":87.2642881,
      "latitude":53.4055741
    },
    "7749":{
      "name":"\u041f\u043e\u0434\u043a\u0430\u0442\u0443\u043d\u044c",
      "longitude":87.2700189,
      "latitude":53.2765382
    },
    "7750":{
      "name":"\u041d\u043e\u0432\u044b\u0439 \u041f\u0443\u043d\u043a\u0442",
      "longitude":87.2744683,
      "latitude":53.3914166
    },
    "7751":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u041a\u0430\u043b\u0442\u0430\u043d",
      "longitude":87.274635,
      "latitude":53.492195
    },
    "7752":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u0429\u0435\u0434\u0440\u0443\u0445\u0430",
      "longitude":87.277657,
      "latitude":53.873432
    },
    "7753":{
      "name":"\u0424\u0451\u0434\u043e\u0440\u043e\u0432\u043a\u0430",
      "longitude":87.279839,
      "latitude":53.578087
    },
    "7754":{
      "name":"\u0428\u0443\u0448\u0442\u0430\u043b\u0435\u043f",
      "longitude":87.280998,
      "latitude":53.567406
    },
    "7755":{
      "name":"\u0417\u0435\u043b\u0451\u043d\u044b\u0439 \u041b\u0443\u0433",
      "longitude":87.302467,
      "latitude":53.478233
    },
    "7756":{
      "name":"\u041f\u043e\u0434\u043a\u043e\u0440\u0447\u0438\u044f\u043a",
      "longitude":87.30352,
      "latitude":53.436646
    },
    "7757":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430 1-\u044f",
      "longitude":87.311577,
      "latitude":56.283016
    },
    "7758":{
      "name":"\u041c\u043e\u043a\u0440\u043e\u0443\u0441\u043e\u0432\u043e",
      "longitude":87.312881,
      "latitude":53.937881
    },
    "7759":{
      "name":"\u041a\u0435\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":87.3147287,
      "latitude":53.127062
    },
    "7760":{
      "name":"\u0423\u0441\u043a\u043e\u0432\u043e",
      "longitude":87.323135,
      "latitude":54.102093
    },
    "7761":{
      "name":"\u0411\u0430\u0440\u0434\u0438\u043d\u0430",
      "longitude":87.3428213,
      "latitude":53.9372583
    },
    "7762":{
      "name":"\u0422\u0430\u0451\u0436\u043d\u043e-\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":87.350288,
      "latitude":56.570442
    },
    "7763":{
      "name":"\u0421\u0443\u0445\u0430\u0440\u0438\u043d\u043a\u0430",
      "longitude":87.3532491,
      "latitude":53.1324864
    },
    "7764":{
      "name":"\u041e\u0441\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":87.361237,
      "latitude":54.275356
    },
    "7765":{
      "name":"\u042e\u0440\u043a\u043e\u0432\u043e",
      "longitude":87.363487,
      "latitude":53.510937
    },
    "7766":{
      "name":"\u0412\u0435\u0440\u0445-\u0422\u0435\u0448",
      "longitude":87.3644259,
      "latitude":53.3794527
    },
    "7767":{
      "name":"\u0422\u0435\u043b\u044c\u0431\u0435\u0441",
      "longitude":87.370018,
      "latitude":53.229645
    },
    "7768":{
      "name":"\u0423\u0447\u0443\u043b\u0435\u043d",
      "longitude":87.380386,
      "latitude":53.144222
    },
    "7769":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u0432\u043a\u0430",
      "longitude":87.391266,
      "latitude":56.21656
    },
    "7770":{
      "name":"\u0412\u0435\u0441\u0435\u043b\u0430\u044f \u0413\u0440\u0438\u0432\u0430",
      "longitude":87.3912997,
      "latitude":52.978193
    },
    "7771":{
      "name":"\u0411\u043e\u0440\u043e\u0432\u043e\u0439",
      "longitude":87.3945453,
      "latitude":55.9131419
    },
    "7772":{
      "name":"\u041a\u043e\u043c\u0438\u0441\u0441\u0430\u0440\u043e\u0432\u043a\u0430",
      "longitude":87.405167,
      "latitude":56.102806
    },
    "7773":{
      "name":"\u041a\u0443\u0440\u0435\u0439\u043d\u043e\u0435",
      "longitude":87.4142043,
      "latitude":53.8544485
    },
    "7774":{
      "name":"\u0415\u0441\u0430\u0443\u043b\u043a\u0430",
      "longitude":87.43853,
      "latitude":53.897438
    },
    "7775":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u041a\u0430\u043b\u0442\u0430\u043d",
      "longitude":87.44072,
      "latitude":53.609699
    },
    "7776":{
      "name":"\u0417\u0430\u0431\u043e\u0440\u044c\u0435",
      "longitude":87.446175,
      "latitude":56.549126
    },
    "7777":{
      "name":"517 \u043a\u043c",
      "longitude":87.446251,
      "latitude":52.9751964
    },
    "7778":{
      "name":"\u042e\u0440\u044c\u0435\u0432\u043a\u0430",
      "longitude":87.448402,
      "latitude":56.228794
    },
    "7779":{
      "name":"\u0427\u0451\u0440\u043d\u044b\u0439 \u041a\u0430\u043b\u0442\u0430\u043d",
      "longitude":87.45031,
      "latitude":53.520149
    },
    "7780":{
      "name":"\u0423\u0441\u0442\u044c-\u041d\u0430\u0440\u044b\u043a",
      "longitude":87.452477,
      "latitude":54.335739
    },
    "7781":{
      "name":"\u0415\u0440\u0443\u043d\u0430\u043a\u043e\u0432\u043e",
      "longitude":87.453751,
      "latitude":54.082523
    },
    "7782":{
      "name":"\u041f\u0435\u0442\u0443\u0445\u043e\u0432 \u041b\u043e\u0433",
      "longitude":87.459946,
      "latitude":52.9842
    },
    "7783":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u0430\u0431\u0430\u0448\u0435\u0432\u043e",
      "longitude":87.466736,
      "latitude":53.823566
    },
    "7784":{
      "name":"\u041a\u0435\u0440\u0435\u0433\u0435\u0448",
      "longitude":87.471069,
      "latitude":53.904888
    },
    "7785":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u0430\u044f \u0413\u0440\u0438\u0432\u0430",
      "longitude":87.482925,
      "latitude":53.678314
    },
    "7786":{
      "name":"527 \u043a\u043c",
      "longitude":87.4968135,
      "latitude":52.9177416
    },
    "7787":{
      "name":"\u0427\u0438\u0441\u0442\u0430\u044f \u0413\u0440\u0438\u0432\u0430",
      "longitude":87.49752,
      "latitude":54.031353
    },
    "7788":{
      "name":"\u0411\u043e\u0431\u0440\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":87.49752,
      "latitude":56.15889
    },
    "7789":{
      "name":"\u0422\u043e\u043d\u043d\u0435\u043b\u044c",
      "longitude":87.502075,
      "latitude":53.901798
    },
    "7790":{
      "name":"\u041a\u0430\u0439\u0434\u0443\u043b\u044b",
      "longitude":87.503563,
      "latitude":56.279125
    },
    "7791":{
      "name":"\u041a\u0430\u0437\u0430\u043d\u043a\u0430-20",
      "longitude":87.5101981,
      "latitude":55.6493324
    },
    "7792":{
      "name":"\u0422\u0435\u043d\u0435\u0448",
      "longitude":87.5123828,
      "latitude":53.0918027
    },
    "7793":{
      "name":"\u041a\u0430\u043c\u0435\u043d\u043d\u044b\u0439 \u041a\u0430\u0440\u044c\u0435\u0440",
      "longitude":87.5130166,
      "latitude":52.9989987
    },
    "7794":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u043f\u0430\u0432\u043b\u043e\u0432\u043a\u0430",
      "longitude":87.5134068,
      "latitude":55.9708074
    },
    "7795":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u0437\u043d\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":87.51976,
      "latitude":54.122925
    },
    "7796":{
      "name":"\u041a\u043b\u0435\u043f\u043e\u0447\u043d\u044b\u0439",
      "longitude":87.521626,
      "latitude":52.924145
    },
    "7797":{
      "name":"\u042f\u0447\u043c\u0435\u043d\u044e\u0445\u0430",
      "longitude":87.523636,
      "latitude":54.493626
    },
    "7798":{
      "name":"\u0410\u043d\u0442\u0438\u0431\u0435\u0441\u0441\u043a\u0430\u044f",
      "longitude":87.524162,
      "latitude":56.170158
    },
    "7799":{
      "name":"\u041c\u0435\u0434\u0432\u0435\u0436\u043a\u0430",
      "longitude":87.527512,
      "latitude":54.81311
    },
    "7800":{
      "name":"\u041f\u043e\u0434\u044a\u0435\u043b\u044c\u043d\u0438\u043a\u0438",
      "longitude":87.529686,
      "latitude":56.229656
    },
    "7801":{
      "name":"\u041c\u0430\u043b\u044c\u043a\u043e\u0432\u043a\u0430",
      "longitude":87.555618,
      "latitude":56.132313
    },
    "7802":{
      "name":"\u0423\u0441\u0442\u044c-\u0410\u0441\u043a\u0430\u0440\u043b\u044b",
      "longitude":87.557938,
      "latitude":54.192741
    },
    "7803":{
      "name":"\u0423\u0432\u0430\u043b",
      "longitude":87.573906,
      "latitude":54.115757
    },
    "7804":{
      "name":"\u0411\u0435\u0440\u0435\u043d\u0437\u0430\u0441",
      "longitude":87.581139,
      "latitude":53.679562
    },
    "7805":{
      "name":"\u0427\u0435\u0440\u0435\u043c\u0437\u0430",
      "longitude":87.584732,
      "latitude":53.759632
    },
    "7806":{
      "name":"534 \u043a\u043c",
      "longitude":87.5950572,
      "latitude":52.9298413
    },
    "7807":{
      "name":"\u0412\u0435\u0440\u0445-\u041f\u043e\u0434\u043e\u0431\u0430\u0441",
      "longitude":87.597176,
      "latitude":53.70377
    },
    "7808":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u0430\u0437\u0430\u043d\u043a\u0430",
      "longitude":87.5975999,
      "latitude":56.1083394
    },
    "7809":{
      "name":"\u041c\u0443\u0442\u043d\u044b\u0439",
      "longitude":87.613754,
      "latitude":54.352303
    },
    "7810":{
      "name":"\u0420\u0430\u0437\u0434\u043e\u043b\u044c\u043d\u043e\u0435",
      "longitude":87.619743,
      "latitude":56.124729
    },
    "7811":{
      "name":"\u041a\u0430\u043b\u0438\u043d\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":87.624748,
      "latitude":56.188171
    },
    "7812":{
      "name":"538 \u043a\u043c",
      "longitude":87.6374802,
      "latitude":52.9233085
    },
    "7813":{
      "name":"\u041a\u043e\u043b\u044c\u0447\u0435\u0437\u0430\u0441",
      "longitude":87.6405733,
      "latitude":53.7947312
    },
    "7814":{
      "name":"\u0422\u0443\u0440\u043b\u0430",
      "longitude":87.6483051,
      "latitude":52.7146511
    },
    "7815":{
      "name":"\u0426\u0435\u043d\u0442\u0440\u0430\u043b\u044c\u043d\u044b\u0439",
      "longitude":87.6713041,
      "latitude":53.0352192
    },
    "7816":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u044b\u0439",
      "longitude":87.6813811,
      "latitude":53.4059631
    },
    "7817":{
      "name":"\u041f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":87.6820341,
      "latitude":55.9634327
    },
    "7818":{
      "name":"\u0417\u0430\u0440\u0435\u0447\u043d\u044b\u0439",
      "longitude":87.686172,
      "latitude":56.267818
    },
    "7819":{
      "name":"\u041a\u0430\u0440\u0430\u0447\u0430\u0440\u043e\u0432\u043e",
      "longitude":87.6888884,
      "latitude":55.7454149
    },
    "7820":{
      "name":"\u0422\u0430\u0440\u043b\u0430\u0448\u043a\u0430",
      "longitude":87.7063909,
      "latitude":52.7260787
    },
    "7821":{
      "name":"\u0411\u0430\u043b\u0431\u044b\u043d\u044c",
      "longitude":87.7120209,
      "latitude":53.770202
    },
    "7822":{
      "name":"\u041e\u0440\u043b\u043e\u0432\u043e-\u0420\u043e\u0437\u043e\u0432\u043e",
      "longitude":87.715421,
      "latitude":56.0544568
    },
    "7823":{
      "name":"\u0427\u0443\u0430\u0437\u0430\u0441",
      "longitude":87.726936,
      "latitude":53.491512
    },
    "7824":{
      "name":"\u042e\u0434\u0438\u043d\u043e",
      "longitude":87.7279246,
      "latitude":52.6068763
    },
    "7825":{
      "name":"\u0423\u0441\u0442\u044c-\u0423\u0440\u0443\u0448",
      "longitude":87.73093,
      "latitude":52.7393001
    },
    "7826":{
      "name":"\u041d\u043e\u0432\u043e\u0438\u0432\u0430\u043d\u043e\u0432\u0441\u043a\u0438\u0439 3-\u0439",
      "longitude":87.7333681,
      "latitude":55.8516177
    },
    "7827":{
      "name":"545 \u043a\u043c",
      "longitude":87.7349183,
      "latitude":52.927664
    },
    "7828":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0439 \u0421\u043e\u043a\u043e\u043b",
      "longitude":87.7396417,
      "latitude":52.6212279
    },
    "7829":{
      "name":"\u0413\u0430\u0431\u043e\u0432\u0441\u043a",
      "longitude":87.7488047,
      "latitude":52.6147921
    },
    "7830":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":87.7626887,
      "latitude":55.8857671
    },
    "7831":{
      "name":"\u0423\u0441\u0442\u044c-\u041c\u0440\u0430\u0441\u0441\u043a\u0438\u0439",
      "longitude":87.7819976,
      "latitude":53.7593725
    },
    "7832":{
      "name":"3-\u0439",
      "longitude":87.7928848,
      "latitude":55.9762881
    },
    "7833":{
      "name":"\u0410\u043a\u043a\u043e\u043b\u044c",
      "longitude":87.7933716,
      "latitude":53.7476143
    },
    "7834":{
      "name":"\u041a\u0438\u043b\u0438\u043d\u0441\u043a",
      "longitude":87.793877,
      "latitude":52.522236
    },
    "7835":{
      "name":"\u041a\u0430\u043c\u0435\u0448\u0435\u043a",
      "longitude":87.7938834,
      "latitude":53.5744182
    },
    "7836":{
      "name":"2-\u0439",
      "longitude":87.8018857,
      "latitude":56.0172393
    },
    "7837":{
      "name":"4-\u0439",
      "longitude":87.8055805,
      "latitude":55.9365092
    },
    "7838":{
      "name":"\u042f\u043a\u0443\u043d\u0438\u043d\u0441\u043a",
      "longitude":87.8079872,
      "latitude":52.5273276
    },
    "7839":{
      "name":"\u041c\u0430\u043a\u0430\u0440\u0438\u0445\u0430",
      "longitude":87.808052,
      "latitude":54.2066
    },
    "7840":{
      "name":"\u0417\u0430\u0433\u0430\u0434\u043d\u043e\u0435",
      "longitude":87.815773,
      "latitude":54.150238
    },
    "7841":{
      "name":"\u0427\u0443\u0432\u0430\u0448\u043a\u0430",
      "longitude":87.8184293,
      "latitude":53.5979026
    },
    "7842":{
      "name":"\u0421\u0435\u043b\u044c\u0445\u043e\u0437",
      "longitude":87.8223896,
      "latitude":53.7955497
    },
    "7843":{
      "name":"\u041d\u043e\u0432\u043e\u0438\u0432\u0430\u043d\u043e\u0432\u0441\u043a\u0438\u0439 2-\u0439",
      "longitude":87.8231559,
      "latitude":55.8933036
    },
    "7844":{
      "name":"\u0422\u043e\u043f\u043e\u043b\u0451\u043a",
      "longitude":87.8262399,
      "latitude":53.72074
    },
    "7845":{
      "name":"\u0422\u0443\u0442\u0443\u044f\u0441",
      "longitude":87.8376159,
      "latitude":53.8089681
    },
    "7846":{
      "name":"10-\u0439 \u0440\u0430\u0437\u044a\u0435\u0437\u0434",
      "longitude":87.844727,
      "latitude":56.146488
    },
    "7847":{
      "name":"\u041a\u0430\u0437\u0430\u0441",
      "longitude":87.8455209,
      "latitude":53.6062736
    },
    "7848":{
      "name":"\u0422\u043e\u0437",
      "longitude":87.8478713,
      "latitude":53.4598815
    },
    "7849":{
      "name":"\u041d\u043e\u0432\u043e\u0438\u0432\u0430\u043d\u043e\u0432\u0441\u043a\u0438\u0439 4-\u0439",
      "longitude":87.8504822,
      "latitude":55.8035211
    },
    "7850":{
      "name":"\u0427\u0443\u0448\u043b\u0430",
      "longitude":87.8600854,
      "latitude":52.7068746
    },
    "7851":{
      "name":"\u0420\u0430\u0435\u0432\u043a\u0430",
      "longitude":87.875587,
      "latitude":56.172642
    },
    "7852":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":87.9007051,
      "latitude":55.9100031
    },
    "7853":{
      "name":"\u041f\u0440\u0438\u043c\u0435\u0442\u043a\u0438\u043d\u043e",
      "longitude":87.902634,
      "latitude":56.201378
    },
    "7854":{
      "name":"\u0410\u043a\u0441\u0430\u0441",
      "longitude":87.904205,
      "latitude":53.863789
    },
    "7855":{
      "name":"\u0421\u043e\u043a\u0443\u0448\u0442\u0430",
      "longitude":87.9104084,
      "latitude":52.6706035
    },
    "7856":{
      "name":"\u041c\u0438\u043b\u0435\u0445\u0438\u043d\u043e",
      "longitude":87.927895,
      "latitude":56.325851
    },
    "7857":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u041d\u0430\u0442\u0430\u043b\u044c\u0435\u0432\u043a\u0430",
      "longitude":87.933135,
      "latitude":55.5160221
    },
    "7858":{
      "name":"\u0428\u0435\u0441\u0442\u0430\u043a\u043e\u0432\u043e",
      "longitude":87.9608896,
      "latitude":55.8950163
    },
    "7859":{
      "name":"\u0412\u0435\u0440\u0445-\u041a\u043e\u0447\u0443\u0440\u0430",
      "longitude":87.9715609,
      "latitude":52.6565748
    },
    "7860":{
      "name":"\u041d\u043e\u0432\u043e\u0438\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":87.9978513,
      "latitude":55.7895322
    },
    "7861":{
      "name":"\u0422\u043e\u043d\u0433\u0443\u043b",
      "longitude":88.008392,
      "latitude":56.574001
    },
    "7862":{
      "name":"\u0427\u0438\u0441\u0442\u043e\u043f\u043e\u043b\u044c\u0441\u043a\u0438\u0439",
      "longitude":88.013786,
      "latitude":56.087006
    },
    "7863":{
      "name":"\u041c\u0430\u043b\u044b\u0439 \u041b\u0430\u0431\u044b\u0448",
      "longitude":88.0493536,
      "latitude":52.6305405
    },
    "7864":{
      "name":"\u0427\u0443\u043b\u0435\u0448",
      "longitude":88.049698,
      "latitude":52.541859
    },
    "7865":{
      "name":"\u041a\u0443\u0440\u043a\u0443\u043b\u0438",
      "longitude":88.054054,
      "latitude":56.410046
    },
    "7866":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u041b\u0430\u0431\u044b\u0448",
      "longitude":88.0609615,
      "latitude":52.6074618
    },
    "7867":{
      "name":"\u041a\u043e\u043d\u0441\u0442\u0430\u043d\u0442\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":88.066742,
      "latitude":56.127384
    },
    "7868":{
      "name":"\u0422\u0430\u0435\u043d\u0437\u0430",
      "longitude":88.0828697,
      "latitude":52.9391524
    },
    "7869":{
      "name":"\u041c\u043e\u0441\u043a\u043e\u0432\u043a\u0430",
      "longitude":88.0872918,
      "latitude":55.3664769
    },
    "7870":{
      "name":"\u0420\u0430\u0441\u043f\u0430\u0434\u043d\u044b\u0439",
      "longitude":88.1029487,
      "latitude":53.7659509
    },
    "7871":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u044f\u044f \u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":88.1064092,
      "latitude":52.812543
    },
    "7872":{
      "name":"\u041d\u043e\u0432\u044b\u0439 \u0411\u0435\u0440\u0438\u043a\u0443\u043b\u044c",
      "longitude":88.1326055,
      "latitude":55.4865624
    },
    "7873":{
      "name":"\u0421\u0430\u0439\u0437\u0430\u043a",
      "longitude":88.1369831,
      "latitude":52.6565821
    },
    "7874":{
      "name":"\u041a\u0430\u0440\u0431\u0430\u043b\u044b\u043a",
      "longitude":88.1508309,
      "latitude":52.6884832
    },
    "7875":{
      "name":"\u0423\u0437\u0443\u043d\u0433\u043e\u043b",
      "longitude":88.1677227,
      "latitude":52.6459071
    },
    "7876":{
      "name":"\u0414\u0436\u0435\u043b\u0441\u0430\u0439",
      "longitude":88.1722544,
      "latitude":52.7935352
    },
    "7877":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0435 \u041a\u0438\u0447\u0438",
      "longitude":88.1724041,
      "latitude":52.752763
    },
    "7878":{
      "name":"\u0420\u0443\u0431\u0438\u043d\u043e",
      "longitude":88.17263,
      "latitude":56.359596
    },
    "7879":{
      "name":"\u0421\u0440\u0435\u0434\u043d\u0438\u0435 \u041a\u0438\u0447\u0438",
      "longitude":88.195229,
      "latitude":52.744408
    },
    "7880":{
      "name":"\u0424\u0451\u0434\u043e\u0440\u043e\u0432\u043a\u0430",
      "longitude":88.195786,
      "latitude":56.270966
    },
    "7881":{
      "name":"\u041c\u0430\u043b\u044b\u0439 \u041c\u0430\u0439\u0437\u0430\u0441",
      "longitude":88.2116559,
      "latitude":53.4892927
    },
    "7882":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":88.215645,
      "latitude":56.129879
    },
    "7883":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0435 \u041a\u0438\u0447\u0438",
      "longitude":88.2203161,
      "latitude":52.7572227
    },
    "7884":{
      "name":"\u0417\u043d\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":88.229675,
      "latitude":56.058052
    },
    "7885":{
      "name":"3747 \u043a\u043c",
      "longitude":88.230682,
      "latitude":56.175644
    },
    "7886":{
      "name":"\u0421\u0443\u0435\u0442\u0430",
      "longitude":88.2375455,
      "latitude":53.0357957
    },
    "7887":{
      "name":"\u041f\u0443\u0442\u044f\u0442\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":88.2670164,
      "latitude":55.998405
    },
    "7888":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u0422\u0430\u0439\u043c\u0435\u0442",
      "longitude":88.2690882,
      "latitude":52.4852546
    },
    "7889":{
      "name":"\u0421\u0440\u0435\u0434\u043d\u044f\u044f \u041f\u0443\u0440\u043b\u0430",
      "longitude":88.2694387,
      "latitude":52.7967213
    },
    "7890":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u041d\u044b\u043c\u0437\u0430\u0441",
      "longitude":88.2750876,
      "latitude":52.7022005
    },
    "7891":{
      "name":"\u0420\u0436\u0430\u0432\u0447\u0438\u043a",
      "longitude":88.2754899,
      "latitude":55.6930679
    },
    "7892":{
      "name":"\u0421\u043c\u044b\u0447\u043a\u0430",
      "longitude":88.2872724,
      "latitude":55.6868027
    },
    "7893":{
      "name":"\u0410\u0432\u0435\u0440\u044c\u044f\u043d\u043e\u0432\u043a\u0430",
      "longitude":88.2893323,
      "latitude":56.1656505
    },
    "7894":{
      "name":"\u0423\u0437\u0443\u043d\u0433\u043e\u043b",
      "longitude":88.2993627,
      "latitude":52.6547954
    },
    "7895":{
      "name":"\u0421\u0432\u044f\u0442\u043e\u0433\u043e\u0440\u043a\u0430",
      "longitude":88.305481,
      "latitude":56.234749
    },
    "7896":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u0411\u0435\u0440\u0447\u0438\u043a\u0443\u043b\u044c",
      "longitude":88.3058118,
      "latitude":55.6368384
    },
    "7897":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0439 \u041d\u044b\u043c\u0437\u0430\u0441",
      "longitude":88.3061209,
      "latitude":52.6999491
    },
    "7898":{
      "name":"\u0422\u0443\u043d\u0434\u0438\u043d\u043a\u0430",
      "longitude":88.311539,
      "latitude":56.540356
    },
    "7899":{
      "name":"\u0411\u0435\u043b\u043a\u0430",
      "longitude":88.312309,
      "latitude":52.6533203
    },
    "7900":{
      "name":"\u0423\u0441\u0442\u044c-\u041a\u0430\u0440\u0430\u0433\u043e\u043b",
      "longitude":88.3148037,
      "latitude":52.7615494
    },
    "7901":{
      "name":"\u0423\u0441\u0442\u044c-\u041a\u0435\u0437\u0435\u0441",
      "longitude":88.317909,
      "latitude":52.803837
    },
    "7902":{
      "name":"\u0417\u0430\u0440\u044f",
      "longitude":88.3190298,
      "latitude":56.0413872
    },
    "7903":{
      "name":"\u0421\u0442\u0443\u0434\u0451\u043d\u044b\u0439 \u041f\u043b\u0451\u0441",
      "longitude":88.3243359,
      "latitude":53.6641043
    },
    "7904":{
      "name":"\u041a\u043b\u044e\u0447\u0435\u0432\u0430\u044f",
      "longitude":88.3324193,
      "latitude":56.1676576
    },
    "7905":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0439 \u0410\u043b\u0437\u0430\u043a",
      "longitude":88.3426762,
      "latitude":52.7095663
    },
    "7906":{
      "name":"\u041f\u0430\u0440\u0443\u0448\u043a\u0430",
      "longitude":88.3443143,
      "latitude":53.1662822
    },
    "7907":{
      "name":"\u041f\u0440\u043e\u043a\u043e\u043f\u044c\u0435\u0432\u043e",
      "longitude":88.3454924,
      "latitude":56.3671501
    },
    "7908":{
      "name":"\u0421\u0440\u0435\u0434\u043d\u0438\u0439 \u0427\u0438\u043b\u0435\u0439",
      "longitude":88.3615874,
      "latitude":53.1228826
    },
    "7909":{
      "name":"\u0427\u0438\u043b\u0438\u0441\u0443-\u0410\u043d\u0437\u0430\u0441",
      "longitude":88.3623481,
      "latitude":52.6847621
    },
    "7910":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u0410\u043b\u0437\u0430\u043a",
      "longitude":88.371888,
      "latitude":52.7021642
    },
    "7911":{
      "name":"\u0421\u0442\u043e\u043b\u044f\u0440\u043e\u0432\u043a\u0430",
      "longitude":88.373756,
      "latitude":56.604305
    },
    "7912":{
      "name":"\u0423\u0441\u0442\u044c-\u0410\u0437\u0430\u0441",
      "longitude":88.3899063,
      "latitude":52.9275863
    },
    "7913":{
      "name":"\u0423\u0441\u0442\u044c-\u041f\u044b\u0437\u0430\u0441",
      "longitude":88.4054063,
      "latitude":52.8317937
    },
    "7914":{
      "name":"\u041a\u043e\u043d\u0434\u0440\u0430\u0448\u043a\u0430",
      "longitude":88.408637,
      "latitude":55.7229773
    },
    "7915":{
      "name":"\u0417\u0430-\u041c\u0440\u0430\u0441\u0441\u0443",
      "longitude":88.4124979,
      "latitude":53.0405744
    },
    "7916":{
      "name":"\u0414\u0430\u043b\u044c\u043d\u0438\u0439 \u041a\u0435\u0437\u0435\u043a",
      "longitude":88.4142224,
      "latitude":53.0904211
    },
    "7917":{
      "name":"\u0423\u0441\u0442\u044c-\u0410\u043d\u0437\u0430\u0441",
      "longitude":88.415085,
      "latitude":53.052124
    },
    "7918":{
      "name":"3755 \u043a\u043c",
      "longitude":88.4160807,
      "latitude":56.1083103
    },
    "7919":{
      "name":"\u041e\u043a\u0442\u044f\u0431\u0440\u044c\u0441\u043a\u0438\u0439",
      "longitude":88.4170484,
      "latitude":56.1674664
    },
    "7920":{
      "name":"\u041f\u043e\u0447\u0430\u0435\u0432\u043a\u0430",
      "longitude":88.4185934,
      "latitude":56.1354353
    },
    "7921":{
      "name":"\u0413\u043e\u0440\u043e\u0434\u043e\u043a",
      "longitude":88.4210065,
      "latitude":55.5902413
    },
    "7922":{
      "name":"\u0427\u0430\u0437\u044b-\u0411\u0443\u043a",
      "longitude":88.422008,
      "latitude":53.0067272
    },
    "7923":{
      "name":"\u041d\u043e\u0432\u044b\u0439",
      "longitude":88.4231668,
      "latitude":52.8289984
    },
    "7924":{
      "name":"\u0422\u0451\u043f\u043b\u0430\u044f \u0420\u0435\u0447\u043a\u0430",
      "longitude":88.4282228,
      "latitude":56.3005957
    },
    "7925":{
      "name":"\u0411\u043b\u0438\u0436\u043d\u0438\u0439 \u041a\u0435\u0437\u0435\u043a",
      "longitude":88.43391,
      "latitude":53.0872449
    },
    "7926":{
      "name":"\u0422\u0430\u0441\u043a\u0430",
      "longitude":88.4366252,
      "latitude":52.8300311
    },
    "7927":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u0410\u043d\u0437\u0430\u0441",
      "longitude":88.4394792,
      "latitude":53.0570747
    },
    "7928":{
      "name":"\u0421\u0430\u043d\u0434\u0430\u0439\u043a\u0430",
      "longitude":88.4598312,
      "latitude":56.3352385
    },
    "7929":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u0411\u0443\u0433\u0437\u0430\u0441",
      "longitude":88.4664309,
      "latitude":52.6500722
    },
    "7930":{
      "name":"\u0411\u0430\u0439\u043b\u0430",
      "longitude":88.5025358,
      "latitude":55.7427914
    },
    "7931":{
      "name":"\u041f\u0430\u0440\u043b\u0430\u0433\u043e\u043b",
      "longitude":88.509363,
      "latitude":52.8280615
    },
    "7932":{
      "name":"\u0411\u0430\u0440\u0441\u0443\u043a",
      "longitude":88.5121885,
      "latitude":53.6541528
    },
    "7933":{
      "name":"\u041a\u0430\u043c\u0437\u0430\u0441",
      "longitude":88.5153258,
      "latitude":52.4255183
    },
    "7934":{
      "name":"\u041c\u0440\u0430\u0441\u0441\u0443",
      "longitude":88.5168287,
      "latitude":52.2960208
    },
    "7935":{
      "name":"\u0421\u0440\u0435\u0434\u043d\u0438\u0439 \u0411\u0443\u0433\u0437\u0430\u0441",
      "longitude":88.5229811,
      "latitude":52.6654454
    },
    "7936":{
      "name":"\u0423\u0447\u0430\u0441",
      "longitude":88.5253819,
      "latitude":53.1909767
    },
    "7937":{
      "name":"\u042f\u043a\u043e\u0432\u043b\u0435\u0432\u043a\u0430",
      "longitude":88.5280955,
      "latitude":55.3458288
    },
    "7938":{
      "name":"\u041a\u0430\u043c\u044b\u0448\u043b\u043e\u0432\u043a\u0430",
      "longitude":88.5334348,
      "latitude":55.9739183
    },
    "7939":{
      "name":"\u041a\u043e\u043b\u0445\u043e\u0437\u043d\u044b\u0439 \u041a\u0430\u0440\u0447\u0438\u0442",
      "longitude":88.540466,
      "latitude":52.8047977
    },
    "7940":{
      "name":"\u042d\u043b\u044c\u0431\u0435\u0437\u0430",
      "longitude":88.5553184,
      "latitude":52.6659749
    },
    "7941":{
      "name":"\u041a\u0430\u0439\u0447\u0430\u043a",
      "longitude":88.560729,
      "latitude":55.732354
    },
    "7942":{
      "name":"\u0421\u0442\u0430\u0440\u044b\u0439 \u0422\u044f\u0436\u0438\u043d",
      "longitude":88.5668209,
      "latitude":56.1386874
    },
    "7943":{
      "name":"\u041a\u0430\u043c\u0435\u043d\u044c-\u0421\u0430\u0434\u0430\u0442",
      "longitude":88.5669589,
      "latitude":55.3810204
    },
    "7944":{
      "name":"\u0410\u043d\u0442\u043e\u043d\u043e\u0432\u043e",
      "longitude":88.5784101,
      "latitude":55.8165467
    },
    "7945":{
      "name":"\u0422\u0440\u0435\u0445\u0440\u0435\u0447\u044c\u0435",
      "longitude":88.5979148,
      "latitude":53.2065349
    },
    "7946":{
      "name":"\u0411\u043e\u0440\u0438\u0441\u043e\u0433\u043b\u0435\u0431\u0441\u043a\u043e\u0435",
      "longitude":88.6338567,
      "latitude":56.1967969
    },
    "7947":{
      "name":"\u0421\u043e\u043b\u0434\u0430\u0442\u043a\u0438\u043d\u043e",
      "longitude":88.634436,
      "latitude":55.4807626
    },
    "7948":{
      "name":"\u041a\u0438\u043d\u0436\u0438\u0440",
      "longitude":88.642502,
      "latitude":55.519669
    },
    "7949":{
      "name":"\u0423\u0441\u0442\u044c-\u0411\u0430\u0440\u0430\u043d\u0434\u0430\u0442",
      "longitude":88.6851835,
      "latitude":55.821634
    },
    "7950":{
      "name":"\u0421\u043b\u0438\u0432\u0435\u043d\u044c",
      "longitude":88.7087925,
      "latitude":53.6728917
    },
    "7951":{
      "name":"\u0418\u043b\u044c\u0438\u043d\u043a\u0430",
      "longitude":88.7168488,
      "latitude":53.1602034
    },
    "7952":{
      "name":"\u0412\u043e\u0437\u043d\u0435\u0441\u0435\u043d\u043a\u0430",
      "longitude":88.7171058,
      "latitude":55.7692924
    },
    "7953":{
      "name":"\u041a\u0430\u043d\u0442\u0443\u0441",
      "longitude":88.7340234,
      "latitude":52.8138372
    },
    "7954":{
      "name":"\u041d\u043e\u0432\u043e\u0433\u0435\u043e\u0440\u0433\u0438\u0435\u0432\u043a\u0430",
      "longitude":88.7414193,
      "latitude":55.6160254
    },
    "7955":{
      "name":"\u0411\u043e\u0440\u043e\u043a\u043e\u0432\u043a\u0430",
      "longitude":88.7696409,
      "latitude":56.1304609
    },
    "7956":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u041e\u0440\u0442\u043e\u043d",
      "longitude":88.7814186,
      "latitude":53.2331479
    },
    "7957":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u041f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":88.7940168,
      "latitude":55.9045032
    },
    "7958":{
      "name":"\u0421\u0435\u043d\u0437\u0430\u0441",
      "longitude":88.8222125,
      "latitude":52.9349493
    },
    "7959":{
      "name":"\u041b\u0443\u0436\u0431\u0430",
      "longitude":88.8761535,
      "latitude":53.6596653
    },
    "7960":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0435\u043f\u0438\u0447\u0443\u0433\u0438\u043d\u043e",
      "longitude":88.8834524,
      "latitude":55.6583425
    },
    "7961":{
      "name":"\u041d\u043e\u0432\u043e\u0442\u0440\u043e\u0438\u0446\u043a",
      "longitude":88.8836455,
      "latitude":56.0936831
    },
    "7962":{
      "name":"\u0411\u0435\u043b\u044f\u043a\u043e\u0432\u043a\u0430",
      "longitude":88.8958209,
      "latitude":56.2745918
    },
    "7963":{
      "name":"\u0410\u043c\u0437\u0430\u0441",
      "longitude":88.8962463,
      "latitude":53.6593101
    },
    "7964":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":88.9304876,
      "latitude":55.9561437
    },
    "7965":{
      "name":"\u0418\u0437\u044b\u043d\u0434\u0430\u0435\u0432\u043e",
      "longitude":89.1879796,
      "latitude":55.7496515
    },
    "7966":{
      "name":"\u041d\u043e\u0432\u043e\u043f\u0440\u0435\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043a\u0430",
      "longitude":89.2281484,
      "latitude":55.8807274
    },
    "7967":{
      "name":"\u041c\u0430\u043a\u0430\u0440\u043e\u0432\u043e",
      "longitude":89.2302706,
      "latitude":56.0137493
    },
    "7968":{
      "name":"\u0427\u0435\u0440\u043d\u044b\u0448\u043e\u0432\u043e",
      "longitude":89.2564725,
      "latitude":55.951723
    },
    "7969":{
      "name":"\u041b\u0435\u0441\u043d\u043e\u0439",
      "longitude":88.6697423,
      "latitude":55.2730329
    },
    "7970":{
      "name":"\u0413\u043b\u0430\u0432\u0441\u0442\u0430\u043d",
      "longitude":88.7543842,
      "latitude":54.6526265
    },
    "7971":{
      "name":"\u041a\u0430\u043b\u0442\u0430\u0441",
      "longitude":88.997314,
      "latitude":53.587757
    },
    "7972":{
      "name":"\u0427\u0430\u0440\u044b\u0448",
      "longitude":89.034348,
      "latitude":53.479504
    },
    "7973":{
      "name":"\u041d\u0435\u043e\u0436\u0438\u0434\u0430\u043d\u043d\u044b\u0439",
      "longitude":89.083923,
      "latitude":53.351364
    },
    "7974":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":89.127396,
      "latitude":53.36351
    },
    "7975":{
      "name":"\u0427\u0435\u0431\u0430\u043a\u0438",
      "longitude":89.217361,
      "latitude":54.55563
    },
    "7976":{
      "name":"\u0428\u043e\u0440\u0430",
      "longitude":89.279358,
      "latitude":53.421432
    },
    "7977":{
      "name":"\u041a\u0438\u0440\u043e\u0432\u043e",
      "longitude":89.284851,
      "latitude":54.696934
    },
    "7978":{
      "name":"\u0410\u0433\u0430\u0441\u043a\u044b\u0440",
      "longitude":89.315318,
      "latitude":54.9680447
    },
    "7979":{
      "name":"\u041c\u0438\u0440\u043d\u044b\u0439",
      "longitude":89.3233313,
      "latitude":54.3228136
    },
    "7980":{
      "name":"\u0428\u043e\u0440\u0430",
      "longitude":89.348602,
      "latitude":53.320553
    },
    "7981":{
      "name":"\u0422\u0430\u043b\u043a\u0438\u043d \u041a\u043b\u044e\u0447",
      "longitude":89.425819,
      "latitude":54.728886
    },
    "7982":{
      "name":"\u041a\u0430\u0437\u044b\u043d\u0435\u0442",
      "longitude":89.429314,
      "latitude":53.436852
    },
    "7983":{
      "name":"\u0422\u043b\u0430\u0447\u0435\u043a",
      "longitude":89.435086,
      "latitude":52.7436746
    },
    "7984":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u0421\u044b\u044f",
      "longitude":89.438622,
      "latitude":54.404625
    },
    "7985":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0439 \u041c\u0430\u0442\u0443\u0440",
      "longitude":89.455315,
      "latitude":52.63007
    },
    "7986":{
      "name":"\u041a\u0430\u0448\u043f\u0430\u0440",
      "longitude":89.4673836,
      "latitude":53.9283736
    },
    "7987":{
      "name":"\u041a\u043e\u0441\u0442\u0438\u043d\u043e",
      "longitude":89.4986277,
      "latitude":55.0304633
    },
    "7988":{
      "name":"\u0422\u0443\u0437\u0443\u043a\u0441\u0443",
      "longitude":89.526863,
      "latitude":53.374004
    },
    "7989":{
      "name":"\u041c\u0435\u043d\u0434\u043e\u043b\u044c",
      "longitude":89.52729,
      "latitude":54.204075
    },
    "7990":{
      "name":"\u0422\u0440\u043e\u0448\u043a\u0438\u043d",
      "longitude":89.54862,
      "latitude":54.5463
    },
    "7991":{
      "name":"\u041a\u044b\u0437\u044b\u043b\u0441\u0443\u0433",
      "longitude":89.552806,
      "latitude":52.7852684
    },
    "7992":{
      "name":"\u042f\u0441\u043d\u0430\u044f \u041f\u043e\u043b\u044f\u043d\u0430",
      "longitude":89.57885,
      "latitude":53.465694
    },
    "7993":{
      "name":"\u0423\u0441\u0442\u044c-\u0422\u0443\u043d\u0433\u0443\u0436\u0443\u043b\u044c",
      "longitude":89.5876726,
      "latitude":54.2392287
    },
    "7994":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u0411\u043e\u0440",
      "longitude":89.590431,
      "latitude":52.817318
    },
    "7995":{
      "name":"\u0410\u043b\u0430-\u0422\u0430\u0443",
      "longitude":89.608055,
      "latitude":53.456882
    },
    "7996":{
      "name":"\u041f\u043e\u0434\u043b\u0438\u0441\u0442\u0432\u0435\u043d\u043a\u0438",
      "longitude":89.636139,
      "latitude":54.755875
    },
    "7997":{
      "name":"\u0428\u0435\u043f\u0447\u0443\u043b",
      "longitude":89.63678,
      "latitude":52.668823
    },
    "7998":{
      "name":"\u0422\u043e\u043f\u0430\u043d\u043e\u0432",
      "longitude":89.658127,
      "latitude":54.54211
    },
    "7999":{
      "name":"\u0423\u043b\u0435\u043d\u044c",
      "longitude":89.695244,
      "latitude":54.085293
    },
    "8000":{
      "name":"\u041d\u0430\u043d\u0445\u0447\u0443\u043b",
      "longitude":89.713036,
      "latitude":53.440434
    },
    "8001":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0435 \u0421\u0438\u0440\u044b",
      "longitude":89.718689,
      "latitude":52.771538
    },
    "8002":{
      "name":"\u0418\u043d\u0438\u0447\u0443\u043b",
      "longitude":89.7219289,
      "latitude":52.6904553
    },
    "8003":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u044f\u044f \u0422\u0451\u044f",
      "longitude":89.731819,
      "latitude":52.992466
    },
    "8004":{
      "name":"\u041a\u0430\u0433\u0430\u0435\u0432\u043e",
      "longitude":89.743431,
      "latitude":54.951187
    },
    "8005":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u041a\u0443\u0440\u043b\u0443\u0433\u0430\u0448",
      "longitude":89.749428,
      "latitude":52.826225
    },
    "8006":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u041e\u043d",
      "longitude":89.7562528,
      "latitude":52.0679176
    },
    "8007":{
      "name":"\u0423\u0441\u0442\u044c-\u0424\u044b\u0440\u043a\u0430\u043b",
      "longitude":89.756821,
      "latitude":54.634243
    },
    "8008":{
      "name":"\u041a\u043e\u0436\u0443\u0445\u043e\u0432\u043e",
      "longitude":89.7972398,
      "latitude":54.890993
    },
    "8009":{
      "name":"\u0422\u044e\u0440\u0442-\u0422\u0430\u0441",
      "longitude":89.80114,
      "latitude":53.097439
    },
    "8010":{
      "name":"\u0425\u0430\u0431\u0437\u0430\u0441",
      "longitude":89.801788,
      "latitude":53.380711
    },
    "8011":{
      "name":"\u041b\u044b\u0440\u0441\u044b",
      "longitude":89.804825,
      "latitude":53.017529
    },
    "8012":{
      "name":"\u041c\u0430\u0440\u0447\u0435\u043b\u0433\u0430\u0448",
      "longitude":89.820465,
      "latitude":54.499043
    },
    "8013":{
      "name":"\u041c\u0430\u043b\u044b\u0439 \u0410\u043d\u0437\u0430\u0441",
      "longitude":89.820618,
      "latitude":52.391609
    },
    "8014":{
      "name":"\u041a\u0443\u0431\u0430\u0439\u043a\u0430",
      "longitude":89.824867,
      "latitude":52.330372
    },
    "8015":{
      "name":"\u041a\u043e\u043b\u0442\u0430\u0440\u043e\u0432",
      "longitude":89.8350188,
      "latitude":54.0609752
    },
    "8016":{
      "name":"\u041c\u0430\u043b\u044b\u0439 \u0421\u044e\u0442\u0438\u043a",
      "longitude":89.837372,
      "latitude":54.952328
    },
    "8017":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u0421\u044e\u0442\u0438\u043a",
      "longitude":89.866722,
      "latitude":55.017849
    },
    "8018":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u0422\u0443\u0438\u043c",
      "longitude":89.8702,
      "latitude":54.2194564
    },
    "8019":{
      "name":"\u041a\u0430\u0440\u0442\u043e\u0435\u0432",
      "longitude":89.879379,
      "latitude":53.077721
    },
    "8020":{
      "name":"\u0418\u043b\u0438\u043c\u043e\u0440\u043e\u0432",
      "longitude":89.913063,
      "latitude":52.987068
    },
    "8021":{
      "name":"\u0422\u0443\u043f\u0438\u043a",
      "longitude":89.9352607,
      "latitude":54.385736
    },
    "8022":{
      "name":"\u041a\u0430\u0440\u0442\u0443\u0437\u043e\u0432",
      "longitude":89.973434,
      "latitude":53.079796
    },
    "8023":{
      "name":"\u042e\u0433\u0430\u0447\u0438",
      "longitude":89.977058,
      "latitude":53.26017
    },
    "8024":{
      "name":"\u041f\u043e\u043b\u0438\u0442\u043e\u0432",
      "longitude":89.98835,
      "latitude":52.97197
    },
    "8025":{
      "name":"\u0423\u043b\u0443\u0433-\u041a\u0438\u0447\u0438\u0433",
      "longitude":90.003723,
      "latitude":53.247353
    },
    "8026":{
      "name":"\u0421\u0440\u0435\u0434\u043d\u0438\u0439 \u041a\u0438\u0441\u0430\u0447",
      "longitude":90.0136943,
      "latitude":53.8914614
    },
    "8027":{
      "name":"\u0422\u0438\u0441\u0438\u043d",
      "longitude":90.0336038,
      "latitude":54.2837504
    },
    "8028":{
      "name":"\u0427\u0438\u043b\u0430\u043d\u044b",
      "longitude":90.0410113,
      "latitude":52.814927
    },
    "8029":{
      "name":"\u041c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":90.058838,
      "latitude":53.579044
    },
    "8030":{
      "name":"\u0427\u0430\u043b\u0433\u044b\u0441\u0442\u0430\u0433",
      "longitude":90.059761,
      "latitude":54.316822
    },
    "8031":{
      "name":"\u041f\u0435\u0447\u0435\u0433\u043e\u043b",
      "longitude":90.084808,
      "latitude":52.862087
    },
    "8032":{
      "name":"\u041a\u0430\u0437\u0430\u043d\u043e\u0432\u0441\u043a\u0430\u044f",
      "longitude":90.099457,
      "latitude":53.190193
    },
    "8033":{
      "name":"\u041a\u0430\u0440\u0430\u0433\u0430\u0439",
      "longitude":90.111229,
      "latitude":52.845657
    },
    "8034":{
      "name":"\u0410\u043d\u0447\u044b\u043b-\u0427\u043e\u043d",
      "longitude":90.11293,
      "latitude":53.209892
    },
    "8035":{
      "name":"\u041f\u0435\u0447\u0435\u043d\u044c",
      "longitude":90.144012,
      "latitude":52.869278
    },
    "8036":{
      "name":"\u0410\u0431\u0440\u0430\u043c\u043e\u0432",
      "longitude":90.148636,
      "latitude":52.986187
    },
    "8037":{
      "name":"\u0410\u0445-\u0425\u043e\u043b",
      "longitude":90.174919,
      "latitude":53.584946
    },
    "8038":{
      "name":"\u0413\u043e\u0440\u044e\u043d\u043e\u0432\u043e",
      "longitude":90.178291,
      "latitude":55.050758
    },
    "8039":{
      "name":"\u041a\u043e\u0433\u0443\u043d\u0435\u043a",
      "longitude":90.210083,
      "latitude":54.958847
    },
    "8040":{
      "name":"\u041a\u043e\u043d\u0433\u0430\u0440\u043e\u0432\u043e",
      "longitude":90.222046,
      "latitude":55.100449
    },
    "8041":{
      "name":"\u0411\u0435\u0439\u043a\u0430",
      "longitude":90.241112,
      "latitude":53.245506
    },
    "8042":{
      "name":"\u041f\u0435\u0440\u0435\u0432\u043e\u0437\u043d\u043e\u0435",
      "longitude":90.253525,
      "latitude":52.863453
    },
    "8043":{
      "name":"\u0421\u0430\u0440\u0442\u0430\u043a",
      "longitude":90.257149,
      "latitude":52.822403
    },
    "8044":{
      "name":"\u041a\u0438\u0440\u043e\u0432\u043e",
      "longitude":90.258598,
      "latitude":52.727383
    },
    "8045":{
      "name":"\u0425\u0430\u0440\u0430\u0447\u0443\u043b",
      "longitude":90.2688532,
      "latitude":52.7114697
    },
    "8046":{
      "name":"\u041a\u0430\u0442\u044e\u0448\u043a\u0438\u043d\u043e",
      "longitude":90.273872,
      "latitude":54.301155
    },
    "8047":{
      "name":"\u0411\u0435\u0439\u043a\u0430",
      "longitude":90.2951426,
      "latitude":53.6694179
    },
    "8048":{
      "name":"\u0411\u044b\u0440\u0433\u0430\u043d\u043e\u0432",
      "longitude":90.298882,
      "latitude":52.995983
    },
    "8049":{
      "name":"\u0421\u043e\u0440\u0441\u043a\u0438\u0439 \u043f\u043e\u0434\u0445\u043e\u0437",
      "longitude":90.3033944,
      "latitude":53.985754
    },
    "8050":{
      "name":"\u0423\u0441\u0442\u044c-\u0421\u043e\u0441",
      "longitude":90.308006,
      "latitude":52.942356
    },
    "8051":{
      "name":"\u0422\u0443\u043c\u0430\u043d\u043d\u043e\u0435",
      "longitude":90.3302406,
      "latitude":54.0880602
    },
    "8052":{
      "name":"\u0410\u043d\u0445\u0430\u043a\u043e\u0432",
      "longitude":90.331635,
      "latitude":53.015266
    },
    "8053":{
      "name":"\u0423\u0439\u0431\u0430\u0442",
      "longitude":90.364342,
      "latitude":53.723888
    },
    "8054":{
      "name":"\u0423\u0441\u0442\u044c-\u0411\u0430\u0437\u0430",
      "longitude":90.387146,
      "latitude":53.161095
    },
    "8055":{
      "name":"\u041a\u0430\u043c\u044b\u0448\u0442\u0430",
      "longitude":90.393158,
      "latitude":53.562008
    },
    "8056":{
      "name":"\u041c\u043e\u043d\u0430\u0441\u0442\u044b\u0440\u0451\u0432\u043e",
      "longitude":90.405281,
      "latitude":55.037579
    },
    "8057":{
      "name":"\u041c\u0430\u0442\u043a\u0435\u0447\u0438\u043a",
      "longitude":90.430641,
      "latitude":53.009174
    },
    "8058":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u041a\u043b\u044e\u0447",
      "longitude":90.435257,
      "latitude":52.868286
    },
    "8059":{
      "name":"\u041c\u0430\u043b\u044b\u0439 \u041c\u043e\u043d\u043e\u043a",
      "longitude":90.436874,
      "latitude":52.839417
    },
    "8060":{
      "name":"\u0426\u0432\u0435\u0442\u043d\u043e\u0433\u043e\u0440\u0441\u043a",
      "longitude":90.4529879,
      "latitude":54.2404552
    },
    "8061":{
      "name":"\u0414\u0430\u0432\u044b\u0434\u043a\u043e\u0432\u043e",
      "longitude":90.5045666,
      "latitude":54.1256628
    },
    "8062":{
      "name":"\u0413\u0430\u043b\u044c\u0434\u0436\u0430",
      "longitude":90.510803,
      "latitude":54.388008
    },
    "8063":{
      "name":"\u0410\u0435\u0432",
      "longitude":90.513519,
      "latitude":53.608967
    },
    "8064":{
      "name":"\u0421\u044b\u0440\u044b",
      "longitude":90.525391,
      "latitude":53.346909
    },
    "8065":{
      "name":"\u0421\u0442\u0430\u0440\u044b\u0439 \u0411\u043e\u0440\u0435\u0446",
      "longitude":90.5377048,
      "latitude":54.4639938
    },
    "8066":{
      "name":"\u0423\u0441\u0442\u044c-\u0422\u0430\u0431\u0430\u0442",
      "longitude":90.550201,
      "latitude":53.077885
    },
    "8067":{
      "name":"\u0427\u0435\u0440\u0442\u044b\u043a\u043e\u0432\u0441\u043a\u0430\u044f",
      "longitude":90.56234,
      "latitude":53.162018
    },
    "8068":{
      "name":"\u0411\u043e\u0433\u0434\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":90.567238,
      "latitude":52.934128
    },
    "8069":{
      "name":"\u0412\u0435\u0440\u0445-\u041a\u0438\u043d\u0434\u0438\u0440\u043b\u0430",
      "longitude":90.599449,
      "latitude":52.947819
    },
    "8070":{
      "name":"\u041a\u0430\u043c\u044b\u0437\u044f\u043a",
      "longitude":90.599831,
      "latitude":53.854214
    },
    "8071":{
      "name":"\u041a\u0430\u0440\u0430\u0441\u0443\u043a",
      "longitude":90.6082544,
      "latitude":54.3080385
    },
    "8072":{
      "name":"\u0423\u0441\u0442\u044c-\u041a\u0438\u043d\u0434\u0438\u0440\u043b\u0430",
      "longitude":90.639862,
      "latitude":53.03561
    },
    "8073":{
      "name":"\u0411\u0435\u0439-\u0411\u0443\u043b\u0443\u043a",
      "longitude":90.676445,
      "latitude":54.544304
    },
    "8074":{
      "name":"\u0411\u0430\u0437\u0430\u043d\u0434\u0430\u0438\u0445\u0430",
      "longitude":90.684799,
      "latitude":54.835247
    },
    "8075":{
      "name":"\u041a\u0430\u043c\u044b\u0448\u0442\u0430",
      "longitude":90.692787,
      "latitude":53.263935
    },
    "8076":{
      "name":"\u041a\u0430\u043c\u044b\u0448\u043e\u0432\u0430\u044f",
      "longitude":90.693909,
      "latitude":53.787285
    },
    "8077":{
      "name":"\u0411\u0435\u043b\u0451\u043b\u0438\u043a",
      "longitude":90.7395696,
      "latitude":54.1475849
    },
    "8078":{
      "name":"\u041a\u0430\u043f\u0447\u0430\u043b\u044b",
      "longitude":90.739761,
      "latitude":53.617256
    },
    "8079":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u044f\u044f \u0415\u0440\u0431\u0430",
      "longitude":90.7565644,
      "latitude":54.319591
    },
    "8080":{
      "name":"\u0423\u0442\u044b",
      "longitude":90.789787,
      "latitude":53.074848
    },
    "8081":{
      "name":"\u0423\u0439\u0442\u0430\u043a",
      "longitude":90.791222,
      "latitude":53.353123
    },
    "8082":{
      "name":"\u0411\u043e\u0440\u043e\u0437\u0434\u0430",
      "longitude":90.801331,
      "latitude":54.538177
    },
    "8083":{
      "name":"\u0427\u0430\u043f\u0442\u044b\u043a\u043e\u0432",
      "longitude":90.806023,
      "latitude":53.239292
    },
    "8084":{
      "name":"\u0421\u0430\u043b\u0431\u044b\u043a",
      "longitude":90.879089,
      "latitude":53.869347
    },
    "8085":{
      "name":"\u0425\u0430\u043d\u043a\u0443\u043b\u044c",
      "longitude":90.893661,
      "latitude":53.397945
    },
    "8086":{
      "name":"\u0421\u0430\u0444\u044c\u044f\u043d\u043e\u0432",
      "longitude":90.894012,
      "latitude":53.359089
    },
    "8087":{
      "name":"\u0418\u043c\u0435\u043d\u0438 \u0418\u043b\u044c\u0438\u0447\u0430",
      "longitude":90.938179,
      "latitude":53.516308
    },
    "8088":{
      "name":"\u0422\u0430\u0451\u0436\u043d\u0430\u044f",
      "longitude":90.958694,
      "latitude":54.14888
    },
    "8089":{
      "name":"\u0414\u0435\u0445\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":90.990471,
      "latitude":53.000221
    },
    "8090":{
      "name":"\u0427\u0435\u0440\u0435\u043c\u0443\u0448\u043a\u0430",
      "longitude":90.998116,
      "latitude":54.463284
    },
    "8091":{
      "name":"\u041a\u0438\u0440\u0431\u0430",
      "longitude":91.0053821,
      "latitude":53.461212
    },
    "8092":{
      "name":"\u041e\u0440\u043e\u0441\u0438\u0442\u0435\u043b\u044c\u043d\u044b\u0439",
      "longitude":91.039368,
      "latitude":53.577324
    },
    "8093":{
      "name":"\u0422\u0440\u043e\u044f\u043a\u043e\u0432",
      "longitude":91.048271,
      "latitude":53.465939
    },
    "8094":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u041a\u0430\u0442\u0430\u043c\u043e\u0440",
      "longitude":91.067444,
      "latitude":53.02232
    },
    "8095":{
      "name":"\u0422\u0443\u0442\u0430\u0442\u0447\u0438\u043a\u043e\u0432",
      "longitude":91.0716381,
      "latitude":53.5056525
    },
    "8096":{
      "name":"\u0425\u043e\u043d\u044b\u0445",
      "longitude":91.080215,
      "latitude":53.544334
    },
    "8097":{
      "name":"\u0425\u044b\u0437\u044b\u043b-\u0421\u0430\u043b\u0434\u0430",
      "longitude":91.122215,
      "latitude":53.430347
    },
    "8098":{
      "name":"\u0428\u0443\u0440\u044b\u0448\u0435\u0432",
      "longitude":91.1233731,
      "latitude":53.515058
    },
    "8099":{
      "name":"\u041f\u043e\u043b\u0438\u043d\u0434\u0435\u0439\u043a\u0430",
      "longitude":91.127769,
      "latitude":54.217598
    },
    "8100":{
      "name":"\u0422\u0438\u0433\u0435\u0439",
      "longitude":91.128113,
      "latitude":53.594555
    },
    "8101":{
      "name":"\u0423\u0441\u0442\u044c-\u0415\u0440\u0431\u0430",
      "longitude":91.163239,
      "latitude":54.445271
    },
    "8102":{
      "name":"\u0417\u0430\u0440\u044f",
      "longitude":91.175575,
      "latitude":53.730602
    },
    "8103":{
      "name":"\u041a\u043e\u0432\u044b\u043b\u044c\u043d\u0430\u044f",
      "longitude":91.187637,
      "latitude":53.904263
    },
    "8104":{
      "name":"\u041a\u043b\u0438\u043c\u0430\u043d\u0438\u0445\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":91.1969576,
      "latitude":54.5061298
    },
    "8105":{
      "name":"\u0411\u0430\u0438\u043d\u043e\u0432",
      "longitude":91.202888,
      "latitude":53.551006
    },
    "8106":{
      "name":"\u0421\u0430\u0445\u0430\u0440\u043d\u044b\u0439",
      "longitude":91.2678144,
      "latitude":53.653544
    },
    "8107":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u041a\u0430\u043c\u0435\u043d\u044c",
      "longitude":91.273468,
      "latitude":54.094357
    },
    "8108":{
      "name":"\u0410\u0431\u0430\u043a\u0430\u043d\u043e-\u041f\u0435\u0440\u0435\u0432\u043e\u0437",
      "longitude":91.317566,
      "latitude":54.274975
    },
    "8109":{
      "name":"\u0421\u043c\u0438\u0440\u043d\u043e\u0432\u043a\u0430",
      "longitude":91.370293,
      "latitude":53.381248
    },
    "8110":{
      "name":"\u0414\u043c\u0438\u0442\u0440\u0438\u0435\u0432\u043a\u0430",
      "longitude":91.395142,
      "latitude":53.268856
    },
    "8111":{
      "name":"\u041c\u043e\u0445\u043e\u0432",
      "longitude":91.410286,
      "latitude":53.926334
    },
    "8112":{
      "name":"\u0413\u0435\u0440\u0430\u0441\u0438\u043c\u043e\u0432\u043e",
      "longitude":91.560707,
      "latitude":53.326355
    },
    "8113":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u043a\u0430",
      "longitude":91.650589,
      "latitude":53.407681
    },
    "8114":{
      "name":"\u041c\u043e\u043d\u0430\u0441\u0442\u044b\u0440\u043a\u0430",
      "longitude":91.759247,
      "latitude":53.212826
    },
    "8115":{
      "name":"\u0416\u0438\u043d\u0434\u043e 2-\u0435",
      "longitude":107.9660796,
      "latitude":49.9450115
    },
    "8116":{
      "name":"\u0421\u0440\u0435\u0434\u043d\u0438\u0439 \u0428\u0435\u0440\u0433\u043e\u043b\u044c\u0434\u0436\u0438\u043d",
      "longitude":108.2781349,
      "latitude":50.1630994
    },
    "8117":{
      "name":"\u0415\u0433\u043e\u0440\u043a\u0438\u043d\u043e",
      "longitude":115.428886,
      "latitude":52.4549647
    },
    "8118":{
      "name":"\u041a\u0443\u043a\u0443\u043d",
      "longitude":108.9130876,
      "latitude":50.9770632
    },
    "8119":{
      "name":"\u041b\u0435\u0441\u043e\u0443\u0447\u0430\u0441\u0442\u043e\u043a \u041a\u0430\u0442\u0430\u043d\u0433\u0430\u0440",
      "longitude":109.0003044,
      "latitude":51.0013565
    },
    "8120":{
      "name":"\u041c\u0443\u0445\u043e\u0440-\u0428\u0438\u0431\u0438\u0440\u043a\u0430",
      "longitude":109.695877,
      "latitude":51.342682
    },
    "8121":{
      "name":"\u041c\u043e\u0433\u0437\u043e\u043d",
      "longitude":109.8331972,
      "latitude":50.5840755
    },
    "8122":{
      "name":"\u0414\u0443\u0442\u044b\u0439",
      "longitude":110.784645,
      "latitude":50.99258
    },
    "8123":{
      "name":"\u0411\u0443\u043a\u0443\u043a\u0443\u043d",
      "longitude":111.1316534,
      "latitude":49.4538536
    },
    "8124":{
      "name":"\u0421\u0430\u0440\u0430\u043d\u0442\u0443\u0439",
      "longitude":111.2932553,
      "latitude":51.6250135
    },
    "8125":{
      "name":"\u0422\u0430\u0439\u0434\u0443\u0442",
      "longitude":111.426466,
      "latitude":51.6381902
    },
    "8126":{
      "name":"3",
      "longitude":117.0826195,
      "latitude":52.0717326
    },
    "8127":{
      "name":"\u0423\u043b\u0451\u0442\u043a\u0430",
      "longitude":111.7964396,
      "latitude":51.6958101
    },
    "8128":{
      "name":"\u0423\u0441\u0442\u044c\u0435",
      "longitude":111.9323617,
      "latitude":49.9701165
    },
    "8129":{
      "name":"\u041a\u0430\u0440\u044b\u043c\u043a\u0430",
      "longitude":112.56103,
      "latitude":51.38589
    },
    "8130":{
      "name":"\u041f\u0440\u0435\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043a\u0430",
      "longitude":112.8286857,
      "latitude":52.2183348
    },
    "8131":{
      "name":"\u041a\u0443\u043a\u0430",
      "longitude":112.9308259,
      "latitude":51.7951998
    },
    "8132":{
      "name":"\u0422\u0430\u0441\u0435\u0439",
      "longitude":112.955688,
      "latitude":52.215809
    },
    "8133":{
      "name":"\u0425\u0432\u043e\u0439\u043d\u044b\u0439",
      "longitude":112.9878242,
      "latitude":51.6799891
    },
    "8134":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u0430\u044f \u0420\u0435\u0447\u043a\u0430",
      "longitude":113.0579134,
      "latitude":51.6406489
    },
    "8135":{
      "name":"\u0414\u043e\u0440\u043e\u0436\u043d\u043e\u0435",
      "longitude":113.1778264,
      "latitude":50.3158896
    },
    "8136":{
      "name":"\u0417\u044b\u043a\u043e\u0432\u043e",
      "longitude":113.2023791,
      "latitude":52.0229421
    },
    "8137":{
      "name":"\u0427\u042d\u0421",
      "longitude":113.2188134,
      "latitude":52.0056533
    },
    "8138":{
      "name":"\u041d\u0430\u043a\u043b\u043e\u043d\u043d\u044b\u0439",
      "longitude":113.2233195,
      "latitude":51.9895617
    },
    "8139":{
      "name":"\u0427\u0435\u0440\u043d\u043e\u0432\u0441\u043a\u0430\u044f",
      "longitude":113.2280907,
      "latitude":51.9701091
    },
    "8140":{
      "name":"\u0427\u0435\u0440\u043d\u043e\u0432\u043e",
      "longitude":113.245715,
      "latitude":51.9551671
    },
    "8141":{
      "name":"\u0421\u0438\u0431\u0438\u0440\u0441\u043a\u0438\u0439",
      "longitude":113.2586819,
      "latitude":51.9963002
    },
    "8142":{
      "name":"\u041c\u0443\u0445\u043e\u0440-\u041a\u043e\u043d\u0434\u0443\u0439",
      "longitude":113.274818,
      "latitude":52.416309
    },
    "8143":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u044f\u044f \u0421\u0430\u043b\u0438\u044f",
      "longitude":113.281532,
      "latitude":51.1998842
    },
    "8144":{
      "name":"\u0422\u0430\u043a\u0435\u0447\u0430",
      "longitude":113.2956292,
      "latitude":50.4687685
    },
    "8145":{
      "name":"\u041a\u0443\u0442\u0443\u0437\u043e\u0432\u043a\u0430",
      "longitude":113.3086998,
      "latitude":52.083183
    },
    "8146":{
      "name":"\u041b\u0435\u0441\u043e\u0443\u0447\u0430\u0441\u0442\u043e\u043a \u0412\u0435\u0440\u0445-\u041d\u0430\u0440\u044b\u043c",
      "longitude":113.4212755,
      "latitude":51.5566405
    },
    "8147":{
      "name":"\u041f\u0440\u043e\u0442\u0438\u0432\u043e\u0447\u0443\u043c\u043d\u0430\u044f \u0421\u0442\u0430\u043d\u0446\u0438\u044f",
      "longitude":113.4360662,
      "latitude":52.1147653
    },
    "8148":{
      "name":"\u042d\u0431\u044d\u0440-\u0410\u043b\u0445\u0430\u043d\u0430\u0439",
      "longitude":113.5061388,
      "latitude":50.8142271
    },
    "8149":{
      "name":"\u041c\u043e\u043b\u043e\u043a\u043e\u0432\u043a\u0430",
      "longitude":113.528452,
      "latitude":51.901391
    },
    "8150":{
      "name":"\u0420\u0443\u0447\u0435\u0439\u043a\u0438",
      "longitude":113.5375113,
      "latitude":52.2763735
    },
    "8151":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u0430\u0437\u0430\u0447\u0438\u043d\u0441\u043a",
      "longitude":113.543633,
      "latitude":50.4095238
    },
    "8152":{
      "name":"\u0410\u0432\u0434\u0435\u0439",
      "longitude":113.636063,
      "latitude":52.37207
    },
    "8153":{
      "name":"\u041a\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":113.6613596,
      "latitude":51.8734346
    },
    "8154":{
      "name":"\u041f\u043e\u0434\u0432\u043e\u043b\u043e\u043a",
      "longitude":113.68042,
      "latitude":52.421185
    },
    "8155":{
      "name":"\u041a\u0443\u043c\u0430\u0445\u0442\u0430",
      "longitude":113.7370606,
      "latitude":51.3591428
    },
    "8156":{
      "name":"\u0414\u043e\u043c \u0418\u043d\u0432\u0430\u043b\u0438\u0434\u043e\u0432",
      "longitude":114.0232916,
      "latitude":51.8018551
    },
    "8157":{
      "name":"\u042e\u043c\u0443\u0440\u0447\u0435\u043d",
      "longitude":114.033638,
      "latitude":53.613205
    },
    "8158":{
      "name":"\u041b\u0435\u0441\u043e\u0437\u0430\u0432\u043e\u0434",
      "longitude":114.0610807,
      "latitude":51.3947029
    },
    "8159":{
      "name":"\u041f\u0443\u043d\u0446\u0443\u043a",
      "longitude":114.2908043,
      "latitude":51.0793983
    },
    "8160":{
      "name":"\u0417\u0443\u0431\u043a\u043e\u0432\u0449\u0438\u043d\u0430",
      "longitude":114.3977222,
      "latitude":51.500546
    },
    "8161":{
      "name":"\u0411\u0430\u044f\u043d-\u0411\u0443\u043b\u0430\u043a",
      "longitude":114.4025856,
      "latitude":50.6376865
    },
    "8162":{
      "name":"\u0411\u0443\u043b\u0430\u043a\u0442\u0443\u0439",
      "longitude":114.4394787,
      "latitude":51.0698354
    },
    "8163":{
      "name":"\u0422\u0430\u0440\u0441\u043a\u0430\u044f",
      "longitude":114.5009403,
      "latitude":51.6325398
    },
    "8164":{
      "name":"\u0421\u0435\u0434\u043b\u043e\u0432\u0430\u044f",
      "longitude":114.5392983,
      "latitude":51.48087
    },
    "8165":{
      "name":"\u0425\u0443\u0441\u0430\u0442\u0443\u0439",
      "longitude":114.6090069,
      "latitude":51.0993807
    },
    "8166":{
      "name":"\u041f\u0435\u0440\u0435\u0432\u0430\u043b",
      "longitude":114.6108667,
      "latitude":51.4682294
    },
    "8167":{
      "name":"\u0440\u0430\u0437\u044a\u0435\u0437\u0434 67",
      "longitude":114.655212,
      "latitude":51.465279
    },
    "8168":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u042f\u0440",
      "longitude":114.6736517,
      "latitude":53.9170857
    },
    "8169":{
      "name":"\u0423\u0441\u0442\u044c-\u041d\u0430\u0446\u0438\u0433\u0443\u043d",
      "longitude":114.6905434,
      "latitude":51.6777144
    },
    "8170":{
      "name":"\u0411\u0443\u0440\u044f\u0442\u0441\u043a\u0430\u044f",
      "longitude":114.701561,
      "latitude":51.450928
    },
    "8171":{
      "name":"\u0440\u0430\u0437\u044a\u0435\u0437\u0434 69",
      "longitude":114.848251,
      "latitude":51.369385
    },
    "8172":{
      "name":"\u0414\u044d\u043b\u0431\u044d\u0440\u0445\u044d\u0439",
      "longitude":114.8688902,
      "latitude":50.9359123
    },
    "8173":{
      "name":"\u0417\u0430\u043d\u0442\u0430",
      "longitude":114.9688517,
      "latitude":50.8612441
    },
    "8174":{
      "name":"\u041e\u0441\u0442\u0440\u0435\u0447\u043d\u0430\u044f",
      "longitude":115.0518776,
      "latitude":51.2090539
    },
    "8175":{
      "name":"\u0426\u0443\u0433\u043e\u043b",
      "longitude":115.0753698,
      "latitude":50.8183388
    },
    "8176":{
      "name":"\u0423\u043b\u044c\u0434\u0443\u0440\u0433\u0430",
      "longitude":115.11871,
      "latitude":52.53995
    },
    "8177":{
      "name":"\u0425\u0443\u043b\u0443\u0433\u043b\u0438",
      "longitude":115.1538889,
      "latitude":54.003333
    },
    "8178":{
      "name":"71 \u0440\u0430\u0437\u044a\u0435\u0437\u0434",
      "longitude":115.1965698,
      "latitude":51.0941467
    },
    "8179":{
      "name":"\u0417\u0443\u0431\u0430\u0440\u0435\u0432\u043e",
      "longitude":115.2686495,
      "latitude":51.7850042
    },
    "8180":{
      "name":"\u041a\u0443\u0440\u0438\u043b\u044c\u0436\u0430",
      "longitude":115.3034104,
      "latitude":50.8303058
    },
    "8181":{
      "name":"\u0411\u0443\u043b\u0430\u043a",
      "longitude":115.3398759,
      "latitude":51.0355458
    },
    "8182":{
      "name":"\u0411\u0438\u043b\u044c\u0447\u0438\u0440",
      "longitude":115.3456544,
      "latitude":51.4474599
    },
    "8183":{
      "name":"\u0423\u043d\u0435\u043d\u043a\u0435\u0440",
      "longitude":115.3564409,
      "latitude":51.7753459
    },
    "8184":{
      "name":"\u0421\u0432\u0435\u0442\u043b\u044b\u0439",
      "longitude":115.415985,
      "latitude":52.419918
    },
    "8185":{
      "name":"\u041a\u044b\u044d\u043a\u0435\u043d",
      "longitude":115.42228,
      "latitude":52.0624725
    },
    "8186":{
      "name":"\u0422\u043e\u0440\u0433\u0430",
      "longitude":115.5899917,
      "latitude":52.1849623
    },
    "8187":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u044f\u0440\u043e\u0432\u043e",
      "longitude":115.5909757,
      "latitude":51.7682613
    },
    "8188":{
      "name":"\u0422\u043e\u043f\u043e\u043b\u0451\u0432\u043a\u0430",
      "longitude":115.606339,
      "latitude":50.90403
    },
    "8189":{
      "name":"\u0417\u0443\u043d\u043e\u0440",
      "longitude":115.62795,
      "latitude":51.11112
    },
    "8190":{
      "name":"\u0426\u0430\u0433\u0430\u043a\u0448\u0438\u043d\u043e",
      "longitude":115.6733784,
      "latitude":52.2259695
    },
    "8191":{
      "name":"\u0415\u0440\u0430\u043c\u0430",
      "longitude":115.7311495,
      "latitude":51.0963713
    },
    "8192":{
      "name":"\u0410\u043a\u0438\u043c\u0430",
      "longitude":115.7363052,
      "latitude":53.0506978
    },
    "8193":{
      "name":"\u0425\u0430\u043b\u0442\u0443\u0439",
      "longitude":115.7589683,
      "latitude":52.2694105
    },
    "8194":{
      "name":"\u041e\u043d\u043e\u043d",
      "longitude":115.8064833,
      "latitude":51.7146003
    },
    "8195":{
      "name":"\u041a\u043e\u043a\u0443\u0439-\u041a\u043e\u043c\u043e\u0433\u043e\u0440\u0446\u0435\u0432\u043e",
      "longitude":115.8619,
      "latitude":51.93424
    },
    "8196":{
      "name":"\u041a\u043e\u043a\u0430\u0440\u0435\u0432\u043a\u0430",
      "longitude":115.916667,
      "latitude":55.583333
    },
    "8197":{
      "name":"\u041c\u0430\u044f\u043a",
      "longitude":116.108656,
      "latitude":50.7801981
    },
    "8198":{
      "name":"\u0412\u043e\u043b\u043e\u0447\u0430\u0435\u0432\u043a\u0430",
      "longitude":116.29145,
      "latitude":51.71563
    },
    "8199":{
      "name":"\u0410\u043f\u0440\u0435\u043b\u043a\u043e\u0432\u043e",
      "longitude":116.3586108,
      "latitude":51.853005
    },
    "8200":{
      "name":"\u0417\u0443\u043d-\u0422\u043e\u0440\u0435\u0439",
      "longitude":116.4643083,
      "latitude":50.4355575
    },
    "8201":{
      "name":"\u0417\u0435\u043b\u0451\u043d\u043e\u0435 \u041e\u0437\u0435\u0440\u043e",
      "longitude":116.579042,
      "latitude":53.676004
    },
    "8202":{
      "name":"\u0428\u0430\u0445\u0430\u043b\u0438\u043d\u043e\u0440",
      "longitude":116.7328776,
      "latitude":49.9070852
    },
    "8203":{
      "name":"\u041a\u0430\u043b\u0430\u043a\u0430\u043d",
      "longitude":116.765175,
      "latitude":55.124744
    },
    "8204":{
      "name":"\u0411\u043e\u0440\u0449\u043e\u0432\u043a\u0430",
      "longitude":116.8317325,
      "latitude":51.9691635
    },
    "8205":{
      "name":"\u041d\u0430\u043b\u0433\u0435\u043a\u0430\u043d",
      "longitude":116.8513434,
      "latitude":52.7654084
    },
    "8206":{
      "name":"\u0421\u0435\u043c\u0438\u043e\u0437\u0451\u0440\u044c\u0435",
      "longitude":116.8919426,
      "latitude":50.0403168
    },
    "8207":{
      "name":"\u0420\u0443\u0434\u043d\u0438\u043a \u0416\u0435\u0442\u043a\u043e\u0432\u043e",
      "longitude":116.9159654,
      "latitude":51.3088469
    },
    "8208":{
      "name":"\u0428\u0435\u043c\u0435\u0442\u043e\u0432\u043e",
      "longitude":116.9495273,
      "latitude":51.9988271
    },
    "8209":{
      "name":"\u041e\u043b\u0434\u043e\u043d\u0434\u0430",
      "longitude":116.9517646,
      "latitude":50.8867426
    },
    "8210":{
      "name":"\u0428\u0430\u043f\u043a\u0430",
      "longitude":117.0338714,
      "latitude":52.1630328
    },
    "8211":{
      "name":"\u0410\u043b\u0435\u0443\u0440",
      "longitude":117.1093753,
      "latitude":52.5631267
    },
    "8212":{
      "name":"\u041f\u0435\u0440\u0435\u0432\u0430\u043b\u044c\u043d\u043e\u0435",
      "longitude":117.216667,
      "latitude":56.583333
    },
    "8213":{
      "name":"\u041c\u0430\u0446\u0438\u0435\u0432\u0441\u043a\u0430\u044f",
      "longitude":117.2758413,
      "latitude":49.7255399
    },
    "8214":{
      "name":"\u041a\u043e\u0432\u0435\u043a\u0442\u0430",
      "longitude":117.2978875,
      "latitude":52.9156638
    },
    "8215":{
      "name":"\u041a\u043e\u0434\u0430\u0440",
      "longitude":117.305278,
      "latitude":56.595556
    },
    "8216":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u0411\u0443\u043b\u044c\u0447\u0443\u0442",
      "longitude":117.3666669,
      "latitude":56.516667
    },
    "8217":{
      "name":"\u0410\u0440\u0447\u0438\u043a\u043e\u0439",
      "longitude":117.4007063,
      "latitude":53.0358366
    },
    "8218":{
      "name":"\u0420\u044b\u0431\u0430\u0442\u0441\u043a\u043e\u0435",
      "longitude":117.5,
      "latitude":57.733333
    },
    "8219":{
      "name":"\u041e\u0437\u0451\u0440\u043d\u0430\u044f",
      "longitude":117.5686157,
      "latitude":52.8161552
    },
    "8220":{
      "name":"\u0410\u0440\u0430\u043c\u043e\u0433\u043e\u0439\u0442\u0443\u0439",
      "longitude":117.609512,
      "latitude":50.381798
    },
    "8221":{
      "name":"\u041d\u0438\u0447\u0430\u0442\u043a\u0430",
      "longitude":117.666667,
      "latitude":57.833333
    },
    "8222":{
      "name":"\u0421\u044b\u0440\u044b\u0433\u0438\u0447\u0438",
      "longitude":117.6673739,
      "latitude":53.845264
    },
    "8223":{
      "name":"\u0421\u0438\u0432\u0430\u0447\u0438",
      "longitude":117.6863053,
      "latitude":51.4688195
    },
    "8224":{
      "name":"\u0420\u044b\u0431\u0430\u0442\u0441\u043a\u043e\u0435",
      "longitude":117.6999999,
      "latitude":57.85
    },
    "8225":{
      "name":"\u0417\u0443\u0434\u044b\u0440\u0430",
      "longitude":117.7950934,
      "latitude":53.1047663
    },
    "8226":{
      "name":"\u0418\u043c\u0430\u043d\u0434\u0430\u043d-\u041c\u0430\u043a\u0438\u0442",
      "longitude":117.8,
      "latitude":54.1
    },
    "8227":{
      "name":"\u0410\u043d\u0442\u0438\u043f\u0435\u043d\u043a\u043e",
      "longitude":118.05,
      "latitude":54.283333
    },
    "8228":{
      "name":"\u041f\u0443\u0440\u0438",
      "longitude":118.0628856,
      "latitude":50.7867969
    },
    "8229":{
      "name":"\u0411\u0435\u0440\u0435\u0437\u043e\u0432\u043a\u0430",
      "longitude":118.1057685,
      "latitude":50.7244509
    },
    "8230":{
      "name":"\u042f\u0431\u043b\u043e\u043d\u043e\u0432\u044b\u0439",
      "longitude":118.2507,
      "latitude":55.1579
    },
    "8231":{
      "name":"\u041d\u0430\u043d\u0430\u0433\u0440\u044b",
      "longitude":118.2956917,
      "latitude":53.2389053
    },
    "8232":{
      "name":"\u0413\u044b\u0440\u044b\u043d\u043a\u0438\u043d\u0430 \u0418\u043b\u044c\u0438",
      "longitude":118.3,
      "latitude":57.916667
    },
    "8233":{
      "name":"\u0423\u0434\u043e\u043a\u0430\u043d",
      "longitude":118.308495,
      "latitude":56.751884
    },
    "8234":{
      "name":"\u041f\u0430\u0432\u043b\u043e\u0432\u0430",
      "longitude":118.4666669,
      "latitude":57.766667
    },
    "8235":{
      "name":"\u0422\u0451\u043c\u043d\u0430\u044f",
      "longitude":118.5191987,
      "latitude":53.3956816
    },
    "8236":{
      "name":"\u041a\u0435\u043d\u0434\u0430\u0433\u0438\u0440\u044b",
      "longitude":118.5401862,
      "latitude":53.45526
    },
    "8237":{
      "name":"\u0414\u043e\u043c \u041e\u0442\u0434\u044b\u0445\u0430 \u0427\u0430\u043b\u0431\u0443\u0447\u0438",
      "longitude":118.646611,
      "latitude":52.4597779
    },
    "8238":{
      "name":"\u0427\u0438\u043d\u0430",
      "longitude":118.6759584,
      "latitude":56.487024
    },
    "8239":{
      "name":"\u0413\u043e\u0440\u044c\u043a\u0438\u0439",
      "longitude":118.6811063,
      "latitude":53.5411507
    },
    "8240":{
      "name":"\u041d\u043e\u0440\u0438\u043d\u0441\u043a",
      "longitude":119.0346258,
      "latitude":50.6661799
    },
    "8241":{
      "name":"\u0412\u0435\u0440\u0435\u044f",
      "longitude":119.1178978,
      "latitude":50.5900814
    },
    "8242":{
      "name":"\u041a\u0438\u0441\u043b\u044b\u0439 \u041a\u043b\u044e\u0447",
      "longitude":119.1297061,
      "latitude":53.7063543
    },
    "8243":{
      "name":"\u0421\u043c\u0438\u0440\u043d\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":119.2081403,
      "latitude":51.1470105
    },
    "8244":{
      "name":"\u0417\u0430\u043f\u043e\u043a\u0440\u043e\u0432\u0441\u043a\u0438\u0439 \u0440\u0443\u0434\u043d\u0438\u043a",
      "longitude":119.2735618,
      "latitude":50.7742116
    },
    "8245":{
      "name":"\u0410\u0440\u0442\u0435\u0443\u0448\u043a\u0430",
      "longitude":119.2874555,
      "latitude":53.7787779
    },
    "8246":{
      "name":"\u0411\u0443\u0433\u0443\u0442\u0443\u0439",
      "longitude":119.291805,
      "latitude":50.9598449
    },
    "8247":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u0441\u043a\u0438\u0439 \u0423\u0447\u0430\u0441\u0442\u043e\u043a",
      "longitude":119.3659663,
      "latitude":51.0939076
    },
    "8248":{
      "name":"\u0412\u043e\u0440\u043e\u0431\u044c\u0435\u0432\u043a\u0430",
      "longitude":119.3896431,
      "latitude":50.9536226
    },
    "8249":{
      "name":"\u041f\u0435\u043d\u044c\u043a\u043e\u0432\u0430\u044f",
      "longitude":119.4071728,
      "latitude":53.8135532
    },
    "8250":{
      "name":"\u041c\u043e\u0442\u043e\u0433\u043e\u0440\u0441\u043a",
      "longitude":119.5109389,
      "latitude":51.7268835
    },
    "8251":{
      "name":"\u041f\u0430\u0432\u043b\u043e\u0432\u043a\u0430",
      "longitude":119.5156643,
      "latitude":51.3620243
    },
    "8252":{
      "name":"\u0411\u043b\u0430\u0433\u043e\u0434\u0430\u0442\u0441\u043a",
      "longitude":119.5516136,
      "latitude":51.232263
    },
    "8253":{
      "name":"\u0412\u043e\u0437\u0434\u0432\u0438\u0436\u0435\u043d\u043a\u0430",
      "longitude":119.5541268,
      "latitude":51.2879173
    },
    "8254":{
      "name":"\u0425\u0430\u0439\u043a\u0430\u043d",
      "longitude":119.597198,
      "latitude":52.0610743
    },
    "8255":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u044c\u0441\u043a\u043e\u0435",
      "longitude":119.6571658,
      "latitude":51.3567466
    },
    "8256":{
      "name":"\u0420\u0430\u0437\u0434\u043e\u043b\u044c\u043d\u043e\u0435",
      "longitude":119.6635061,
      "latitude":53.8057294
    },
    "8257":{
      "name":"\u0424\u043b\u043e\u0440\u043e\u0432\u043a\u0430",
      "longitude":119.783333,
      "latitude":55.1
    },
    "8258":{
      "name":"\u0411\u0443\u0434\u044e\u043c\u043a\u0430\u043d",
      "longitude":119.842236,
      "latitude":52.6379106
    },
    "8259":{
      "name":"\u0410\u0440\u0433\u0443\u043d\u0441\u043a\u0438\u0435-\u041a\u043b\u044e\u0447\u0438",
      "longitude":119.9314917,
      "latitude":51.3988028
    },
    "8260":{
      "name":"\u0423\u0440\u044e\u043f\u0438\u043d\u043e",
      "longitude":120.0171398,
      "latitude":52.7611157
    },
    "8261":{
      "name":"\u0417\u0430\u043f\u0438\u0441\u0438\u043d\u0430",
      "longitude":120.2586796,
      "latitude":51.7480892
    },
    "8262":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u044f\u044f \u0412\u0435\u0440\u0435\u044f",
      "longitude":120.3127735,
      "latitude":51.7872586
    },
    "8263":{
      "name":"\u041d\u0438\u0436. \u0412\u0435\u0440\u0435\u044f",
      "longitude":120.5634504,
      "latitude":51.9299485
    },
    "8264":{
      "name":"\u0422\u0435\u0442\u0451\u0440\u043a\u0438\u043d \u041a\u043b\u044e\u0447",
      "longitude":120.6162699,
      "latitude":53.742597
    },
    "8265":{
      "name":"\u0413\u0435\u0440\u043c\u0430\u043d\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":120.7827934,
      "latitude":53.846946
    },
    "8266":{
      "name":"\u041a\u0440\u0430\u0441\u0430\u0432\u043a\u0430",
      "longitude":120.9898559,
      "latitude":53.8910909
    },
    "8267":{
      "name":"\u041a\u043e\u043b\u043e\u043a\u043e\u043b\u044c\u043d\u044b\u0439",
      "longitude":121.138444,
      "latitude":53.9411015
    },
    "8268":{
      "name":"\u041f\u043e\u0442\u0430\u0439\u043a\u0430",
      "longitude":121.2377914,
      "latitude":53.9762591
    },
    "8269":{
      "name":"\u0427\u0438\u0447\u0430\u0442\u043a\u0430",
      "longitude":121.2991626,
      "latitude":54.0401328
    },
    "8270":{
      "name":"\u0423\u0441\u0442\u044c-\u0421\u0442\u0440\u0435\u043b\u043a\u0430",
      "longitude":121.3864139,
      "latitude":53.322161
    },
    "8271":{
      "name":"\u0416\u0430\u043d\u043d\u0430",
      "longitude":121.40567,
      "latitude":54.053177
    },
    "8272":{
      "name":"\u041f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":121.5360538,
      "latitude":53.3434383
    },
    "8273":{
      "name":"\u041c\u0430\u043b\u043e\u043a\u043e\u0432\u0430\u043b\u0438",
      "longitude":121.5466646,
      "latitude":54.1092745
    },
    "8274":{
      "name":"\u0423\u0442\u0435\u043d\u0438",
      "longitude":121.637722,
      "latitude":54.0615072
    },
    "8275":{
      "name":"\u041a\u0430\u0439\u043d\u0430\u0443\u043b",
      "longitude":70.4346899,
      "latitude":57.9208478
    },
    "8276":{
      "name":"\u0411\u0430\u043a\u0448\u0435\u0435\u0432\u043e",
      "longitude":70.4958757,
      "latitude":57.9141276
    },
    "8277":{
      "name":"\u0412\u0435\u0442\u043b\u0438\u043d\u043a\u0430",
      "longitude":70.5165503,
      "latitude":55.3616059
    },
    "8278":{
      "name":"\u041d\u043e\u0441\u043e\u0432\u043a\u0430",
      "longitude":70.5495837,
      "latitude":55.3172992
    },
    "8279":{
      "name":"\u0411\u0443\u0437\u0430\u043d",
      "longitude":70.5764567,
      "latitude":55.6924049
    },
    "8280":{
      "name":"\u0422\u0443\u043f\u0438\u0446\u044b\u043d\u043e",
      "longitude":70.5879749,
      "latitude":55.4486173
    },
    "8281":{
      "name":"\u0413\u043e\u043b\u0443\u0431\u043a\u0438",
      "longitude":70.670486,
      "latitude":55.299606
    },
    "8282":{
      "name":"\u0421\u0442\u0440\u0443\u043d\u043a\u0438\u043d\u043e",
      "longitude":70.6775118,
      "latitude":55.8525384
    },
    "8283":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u044f\u0440\u043a\u0430",
      "longitude":70.6846845,
      "latitude":57.2423915
    },
    "8284":{
      "name":"\u0421\u0430\u0443\u0440\u0433\u0430\u0447\u0438",
      "longitude":70.696992,
      "latitude":57.7666759
    },
    "8285":{
      "name":"\u041c\u0430\u0440\u0438\u0438\u043d\u043a\u0430",
      "longitude":70.6975654,
      "latitude":55.6807673
    },
    "8286":{
      "name":"\u041a\u0430\u043b\u043c\u0430\u0446\u043a\u043e\u0435",
      "longitude":70.7340157,
      "latitude":55.4691941
    },
    "8287":{
      "name":"\u0423\u0433\u0443\u0442",
      "longitude":70.7354746,
      "latitude":57.3529437
    },
    "8288":{
      "name":"\u0411\u0435\u0440\u0435\u0437\u044f\u043d\u043a\u0430",
      "longitude":70.7476777,
      "latitude":57.793222
    },
    "8289":{
      "name":"\u0415\u043b\u0438\u0437\u0430\u0432\u0435\u0442\u0438\u043d\u043a\u0430",
      "longitude":70.7741688,
      "latitude":55.611295
    },
    "8290":{
      "name":"\u041a\u043e\u043b\u043f\u0430\u043a\u043e\u0432\u043e",
      "longitude":70.7796866,
      "latitude":57.3832831
    },
    "8291":{
      "name":"\u041a\u043e\u0442\u0438\u043d\u043e",
      "longitude":70.8083264,
      "latitude":55.7645135
    },
    "8292":{
      "name":"\u0425\u0443\u0442\u043e\u0440",
      "longitude":70.8188213,
      "latitude":57.7164588
    },
    "8293":{
      "name":"\u041e\u0441\u0438\u043d\u043e\u0432\u043e",
      "longitude":70.8329238,
      "latitude":55.4629999
    },
    "8294":{
      "name":"\u0411\u043e\u0440\u043a\u0438",
      "longitude":70.8562747,
      "latitude":57.7931708
    },
    "8295":{
      "name":"\u041a\u0430\u0431\u0430\u043d\u043e\u0432\u043e",
      "longitude":70.8735445,
      "latitude":55.3354152
    },
    "8296":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u0418\u0433\u0438\u0437\u0430",
      "longitude":70.8747362,
      "latitude":57.4460747
    },
    "8297":{
      "name":"\u0421\u043e\u043a\u043e\u043b\u043e\u0432\u043a\u0430",
      "longitude":70.9024006,
      "latitude":55.4722584
    },
    "8298":{
      "name":"\u0415\u043b\u0430\u043d\u043a\u0430",
      "longitude":70.9072815,
      "latitude":57.812422
    },
    "8299":{
      "name":"\u2116 45",
      "longitude":70.9090951,
      "latitude":55.7227218
    },
    "8300":{
      "name":"\u0417\u0430\u0442\u043e\u043d",
      "longitude":70.9118299,
      "latitude":57.7516234
    },
    "8301":{
      "name":"\u041a\u0443\u0448\u043c\u0430",
      "longitude":70.9135114,
      "latitude":57.490399
    },
    "8302":{
      "name":"\u041a\u043e\u043b\u043e\u0434\u0446\u044b",
      "longitude":70.9364807,
      "latitude":56.0060625
    },
    "8303":{
      "name":"\u041a\u0430\u0440\u0430\u0443\u043b\u044c\u043d\u043e\u0435",
      "longitude":70.9387965,
      "latitude":55.8322063
    },
    "8304":{
      "name":"\u0413\u0443\u043b\u044f\u0439-\u041f\u043e\u043b\u0435",
      "longitude":70.9389274,
      "latitude":56.2694167
    },
    "8305":{
      "name":"\u0415\u043c\u043e\u043d\u0442\u0430\u0435\u0432\u043e",
      "longitude":70.9535582,
      "latitude":55.1455351
    },
    "8306":{
      "name":"\u0420\u044b\u0431\u044c\u0435",
      "longitude":70.9819558,
      "latitude":55.4487867
    },
    "8307":{
      "name":"\u0411\u043e\u0441\u0442\u0430\u043d\u0434\u044b\u043a",
      "longitude":71.0103825,
      "latitude":55.6707973
    },
    "8308":{
      "name":"\u042e\u043d\u0438\u043d\u043e",
      "longitude":71.0127637,
      "latitude":54.9053712
    },
    "8309":{
      "name":"\u041b\u0435\u0431\u044f\u0436\u044c\u0435",
      "longitude":71.0156584,
      "latitude":55.2335685
    },
    "8310":{
      "name":"\u0421\u0442\u0430\u0445\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":71.029715,
      "latitude":56.2889288
    },
    "8311":{
      "name":"\u0420\u0435\u0434\u043a\u043e\u0435",
      "longitude":71.0468626,
      "latitude":55.7654359
    },
    "8312":{
      "name":"\u041e\u043b\u044c\u0433\u0438\u043d\u043e",
      "longitude":71.046867,
      "latitude":56.241136
    },
    "8313":{
      "name":"\u2116 46",
      "longitude":71.0572712,
      "latitude":55.6695004
    },
    "8314":{
      "name":"\u0411\u0430\u0442\u0430\u0440\u0435\u0435\u0432\u043a\u0430",
      "longitude":71.0614301,
      "latitude":55.5246053
    },
    "8315":{
      "name":"\u0421\u0442\u0430\u043d\u043a\u0435\u0432\u0438\u0447\u0438",
      "longitude":71.0706566,
      "latitude":55.7877079
    },
    "8316":{
      "name":"\u0410\u0442\u0435\u0440\u0438\u043d\u043a\u0438",
      "longitude":71.0755397,
      "latitude":57.5221788
    },
    "8317":{
      "name":"\u0415\u043a\u0430\u0442\u0435\u0440\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":71.0828927,
      "latitude":57.781734
    },
    "8318":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u042f\u0440",
      "longitude":71.0918343,
      "latitude":56.3861652
    },
    "8319":{
      "name":"\u0421\u044b\u0440\u044c\u0435\u0432\u043a\u0430",
      "longitude":71.0989182,
      "latitude":55.541262
    },
    "8320":{
      "name":"\u0421\u0432\u0435\u0442\u0438\u043b\u043e\u0432\u043a\u0430",
      "longitude":71.117203,
      "latitude":54.289738
    },
    "8321":{
      "name":"\u041a\u043e\u0437\u0443\u043b\u0438\u043d\u043e",
      "longitude":71.1343256,
      "latitude":56.3123235
    },
    "8322":{
      "name":"\u0411\u0430\u0439\u044b\u043c\u0431\u0435\u0442",
      "longitude":71.1412254,
      "latitude":55.6221145
    },
    "8323":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u0410\u0448\u0435\u0432\u0430\u043d\u043a\u0430",
      "longitude":71.1445215,
      "latitude":57.6407595
    },
    "8324":{
      "name":"\u042f\u0441\u0442\u0440\u0435\u0431",
      "longitude":71.1494101,
      "latitude":55.8900483
    },
    "8325":{
      "name":"\u041c\u043e\u0445\u043e\u0432\u043e\u0435",
      "longitude":71.1682985,
      "latitude":55.112319
    },
    "8326":{
      "name":"\u0421\u043e\u0441\u043d\u043e\u0432\u043a\u0430",
      "longitude":71.1698522,
      "latitude":55.1191359
    },
    "8327":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u042f\u043c\u0430\u043d",
      "longitude":71.1841881,
      "latitude":56.0081739
    },
    "8328":{
      "name":"\u0414\u0443\u0440\u0431\u0435\u0442",
      "longitude":71.1967805,
      "latitude":55.3287034
    },
    "8329":{
      "name":"\u041f\u0430\u043c\u044f\u0442\u044c \u0421\u0432\u043e\u0431\u043e\u0434\u044b",
      "longitude":71.2072558,
      "latitude":54.961314
    },
    "8330":{
      "name":"\u041d\u043e\u0432\u043e\u043b\u043e\u0441\u0435\u0432\u043e",
      "longitude":71.2077512,
      "latitude":55.1423806
    },
    "8331":{
      "name":"\u0413\u0440\u0430\u043a\u043e\u0432\u043a\u0430",
      "longitude":71.2181232,
      "latitude":57.574313
    },
    "8332":{
      "name":"\u0428\u0438\u0440\u044f\u0435\u0432\u043e",
      "longitude":71.2183922,
      "latitude":56.1830533
    },
    "8333":{
      "name":"\u041a\u0443\u043b\u044c\u0442\u0436\u0443\u0433\u0443\u0442",
      "longitude":71.2190696,
      "latitude":55.2331015
    },
    "8334":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":71.2252255,
      "latitude":55.5849402
    },
    "8335":{
      "name":"\u0415\u0440\u0435\u043c\u0438\u043d\u0441\u043a\u0430\u044f \u0411\u0430\u0437\u0430",
      "longitude":71.2293049,
      "latitude":55.635012
    },
    "8336":{
      "name":"\u041e\u0440\u043b\u043e\u0432\u043a\u0430",
      "longitude":71.2354568,
      "latitude":54.5861782
    },
    "8337":{
      "name":"\u041b\u0435\u0442\u043d\u0438\u0435",
      "longitude":71.2388558,
      "latitude":57.6798929
    },
    "8338":{
      "name":"\u0422\u0440\u043e\u0438\u0446\u043a",
      "longitude":71.2392914,
      "latitude":56.4575611
    },
    "8339":{
      "name":"\u0411\u043e\u0440\u043e\u0434\u0438\u043d\u043a\u0430",
      "longitude":71.2393465,
      "latitude":54.3120774
    },
    "8340":{
      "name":"\u041d\u043e\u0432\u043e\u043f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":71.2427246,
      "latitude":56.0138358
    },
    "8341":{
      "name":"\u041c\u0435\u0447\u0435\u0431\u0438\u043b\u043e\u0432\u043e",
      "longitude":71.2437867,
      "latitude":54.440215
    },
    "8342":{
      "name":"\u041e\u043b\u044c\u0432\u0438\u043e\u043f\u043e\u043b\u044c",
      "longitude":71.2540194,
      "latitude":54.5152234
    },
    "8343":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u044f\u0440\u043a\u0430",
      "longitude":71.2578453,
      "latitude":57.7312034
    },
    "8344":{
      "name":"\u0413\u0430\u0433\u0430\u0440\u0438\u043d\u043a\u0430",
      "longitude":71.2620302,
      "latitude":55.5257787
    },
    "8345":{
      "name":"\u0424\u0440\u0435\u0433\u0430\u043d\u043a\u0430",
      "longitude":71.2715969,
      "latitude":57.6587571
    },
    "8346":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u043d\u0430\u0437\u044b\u0432\u0430\u0435\u0432\u043a\u0430",
      "longitude":71.2830392,
      "latitude":55.4737944
    },
    "8347":{
      "name":"\u041a\u0430\u043c\u0447\u0430\u0442\u043a\u0430",
      "longitude":71.2882389,
      "latitude":56.3686457
    },
    "8348":{
      "name":"\u041a\u043e\u0440\u0434\u043e\u043d \u2116 1",
      "longitude":71.2888371,
      "latitude":55.1029418
    },
    "8349":{
      "name":"\u2116 12",
      "longitude":71.296792,
      "latitude":55.0567701
    },
    "8350":{
      "name":"\u041d\u0430\u0445\u0438\u043c\u043e\u0432\u043a\u0430",
      "longitude":71.3008241,
      "latitude":55.3222503
    },
    "8351":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u0421\u0430\u0444\u043e\u043d\u0438\u0445\u0430",
      "longitude":71.301033,
      "latitude":55.767647
    },
    "8352":{
      "name":"\u041e\u043c\u0430\u0440",
      "longitude":71.3028438,
      "latitude":54.8125244
    },
    "8353":{
      "name":"\u041c\u0430\u0439\u043a\u0430",
      "longitude":71.3082646,
      "latitude":55.9122716
    },
    "8354":{
      "name":"\u0411\u043e\u0433\u043e\u0441\u043b\u043e\u0432\u043a\u0430",
      "longitude":71.3191237,
      "latitude":55.6507567
    },
    "8355":{
      "name":"\u041d\u043e\u0447\u043a\u0430",
      "longitude":71.3213699,
      "latitude":54.7128224
    },
    "8356":{
      "name":"\u041d\u043e\u0432\u043e\u0432\u043e\u0441\u043a\u0440\u0435\u0441\u0435\u043d\u043a\u0430",
      "longitude":71.328172,
      "latitude":55.4845811
    },
    "8357":{
      "name":"\u041d\u043e\u0432\u043e\u043e\u0441\u0438\u043d\u043e\u0432\u043e",
      "longitude":71.3380458,
      "latitude":55.8470439
    },
    "8358":{
      "name":"\u0411\u0435\u0436\u0435\u0432\u043a\u0430",
      "longitude":71.3452267,
      "latitude":54.2342638
    },
    "8359":{
      "name":"\u041b\u0443\u043a\u0435\u0440\u044c\u0438\u043d\u043e",
      "longitude":71.3771723,
      "latitude":55.2188068
    },
    "8360":{
      "name":"\u0414\u043b\u0438\u043d\u043d\u043e\u0435",
      "longitude":71.3785019,
      "latitude":54.215491
    },
    "8361":{
      "name":"\u042d\u0431\u0430\u0440\u0433\u0443\u043b\u044c",
      "longitude":71.3850394,
      "latitude":57.6880845
    },
    "8362":{
      "name":"\u041b\u0435\u0431\u0435\u0434\u043a\u0438",
      "longitude":71.3866363,
      "latitude":55.5229289
    },
    "8363":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u0422\u0430\u0432\u0430",
      "longitude":71.3878068,
      "latitude":57.4980717
    },
    "8364":{
      "name":"\u042e\u0436\u043d\u044b\u0439",
      "longitude":71.3879574,
      "latitude":54.8826259
    },
    "8365":{
      "name":"\u0421\u043c\u0435\u043b\u043e\u0435",
      "longitude":71.412028,
      "latitude":54.4962658
    },
    "8366":{
      "name":"\u041d\u043e\u0432\u043e\u0442\u0440\u043e\u0438\u0446\u043a",
      "longitude":71.4244807,
      "latitude":54.1965352
    },
    "8367":{
      "name":"\u041e\u0437\u0435\u0440\u043e \u041a\u0430\u043c\u044b\u0441\u043b\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":71.4309388,
      "latitude":54.9212102
    },
    "8368":{
      "name":"\u0421\u0430\u043c\u0430\u0440\u043e\u0432\u043a\u0430",
      "longitude":71.448889,
      "latitude":55.8242256
    },
    "8369":{
      "name":"\u0414\u0435\u043c\u044c\u044f\u043d\u043e\u0432\u043a\u0430",
      "longitude":71.4618885,
      "latitude":55.5556215
    },
    "8370":{
      "name":"\u0423\u043b\u0435\u043d\u0434\u044b\u043a\u0443\u043b\u044c",
      "longitude":71.4646529,
      "latitude":54.7966651
    },
    "8371":{
      "name":"\u0415\u0432\u0441\u044e\u043a\u0438",
      "longitude":71.4690551,
      "latitude":55.168937
    },
    "8372":{
      "name":"\u041d\u043e\u0432\u043e\u043f\u0435\u0442\u0440\u043e\u0433\u0440\u0430\u0434",
      "longitude":71.4731535,
      "latitude":54.7565029
    },
    "8373":{
      "name":"\u0418\u043a",
      "longitude":71.4793087,
      "latitude":56.0438052
    },
    "8374":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u0421\u0430\u0444\u043e\u043d\u0438\u0445\u0430",
      "longitude":71.4898194,
      "latitude":55.7157626
    },
    "8375":{
      "name":"\u041a\u0430\u0431\u0430\u043d\u044c\u0435",
      "longitude":71.4926747,
      "latitude":56.1463851
    },
    "8376":{
      "name":"\u041a\u0440\u044b\u043c",
      "longitude":71.4948438,
      "latitude":54.2286511
    },
    "8377":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u041f\u0430\u0445\u0430\u0440\u044c",
      "longitude":71.5027811,
      "latitude":56.0921056
    },
    "8378":{
      "name":"\u2116 48",
      "longitude":71.5296178,
      "latitude":55.5063617
    },
    "8379":{
      "name":"\u0421\u0435\u0432\u0435\u0440\u043d\u044b\u0439",
      "longitude":71.5311345,
      "latitude":55.0311031
    },
    "8380":{
      "name":"2779 \u043a\u043c",
      "longitude":71.5342527,
      "latitude":54.9228629
    },
    "8381":{
      "name":"\u0428\u0430\u0440\u043e\u0432\u043a\u0430",
      "longitude":71.5392942,
      "latitude":54.5762693
    },
    "8382":{
      "name":"\u0429\u0435\u0433\u043b\u043e\u0432\u043a\u0430",
      "longitude":71.5492094,
      "latitude":54.2854839
    },
    "8383":{
      "name":"\u0421\u0443\u043b\u0443-\u0422\u0435\u0440\u0435\u043a",
      "longitude":71.5548279,
      "latitude":55.6543643
    },
    "8384":{
      "name":"\u041a\u043e\u0437\u043b\u043e\u0432\u043a\u0430",
      "longitude":71.5553984,
      "latitude":55.7364641
    },
    "8385":{
      "name":"\u041a\u0430\u0440\u0430\u043d-\u0413\u0430\u0440\u0430\u043b",
      "longitude":71.5607398,
      "latitude":55.7630869
    },
    "8386":{
      "name":"\u041a\u0438\u0440\u0435\u0439",
      "longitude":71.5619348,
      "latitude":55.665757
    },
    "8387":{
      "name":"\u041d\u043e\u0432\u043e\u0442\u0438\u043c\u043e\u0444\u0435\u0435\u0432\u043a\u0430",
      "longitude":71.5664477,
      "latitude":54.3454741
    },
    "8388":{
      "name":"\u0425\u043c\u0430\u0440\u043e\u0432\u043a\u0430",
      "longitude":71.568454,
      "latitude":54.5427411
    },
    "8389":{
      "name":"\u0423\u0432\u0430\u043b\u044c\u043d\u043e\u0435",
      "longitude":71.5802419,
      "latitude":54.4423902
    },
    "8390":{
      "name":"\u0411\u0435\u043b\u043e\u0442\u0443\u0440\u043a\u043e\u0432\u043a\u0430",
      "longitude":71.5834567,
      "latitude":54.515985
    },
    "8391":{
      "name":"\u0413\u043e\u0440\u044c\u043a\u043e\u0435",
      "longitude":71.5846095,
      "latitude":56.2741304
    },
    "8392":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":71.585464,
      "latitude":54.907059
    },
    "8393":{
      "name":"\u0427\u0438\u043a\u0438\u0448\u0435\u0432\u043e",
      "longitude":71.5885871,
      "latitude":55.9057001
    },
    "8394":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u0432\u043e\u0437\u043d\u0435\u0441\u0435\u043d\u043a\u0430",
      "longitude":71.5957981,
      "latitude":54.7840831
    },
    "8395":{
      "name":"\u0427\u0435\u043b\u0434\u0430\u043a",
      "longitude":71.5963353,
      "latitude":56.3322647
    },
    "8396":{
      "name":"\u041a\u0443\u0445\u0430\u0440\u0435\u0432\u043e",
      "longitude":71.6107746,
      "latitude":54.9282068
    },
    "8397":{
      "name":"\u041d\u043e\u0432\u0433\u043e\u0440\u043e\u0434\u0446\u0435\u0432\u043e",
      "longitude":71.6187572,
      "latitude":55.9390581
    },
    "8398":{
      "name":"\u0410\u043d\u0434\u0440\u044e\u0448\u0435\u0432\u043a\u0430",
      "longitude":71.6197931,
      "latitude":54.2223088
    },
    "8399":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":71.62323,
      "latitude":55.028698
    },
    "8400":{
      "name":"\u0412\u0430\u0441\u044e\u0442\u0438\u043d\u043e",
      "longitude":71.6236043,
      "latitude":54.820744
    },
    "8401":{
      "name":"\u0423\u0440\u0430\u0448",
      "longitude":71.6255597,
      "latitude":57.6067328
    },
    "8402":{
      "name":"\u041a\u0430\u043b\u0430\u0447\u0438\u043a\u0438",
      "longitude":71.6355917,
      "latitude":56.0516022
    },
    "8403":{
      "name":"\u0421\u043f\u0430\u0441\u0441\u043a",
      "longitude":71.6357371,
      "latitude":55.3982762
    },
    "8404":{
      "name":"\u0427\u0443\u043c\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":71.6405904,
      "latitude":55.9610747
    },
    "8405":{
      "name":"\u041a\u0441\u0435\u043d\u044c\u0435\u0432\u043a\u0430",
      "longitude":71.643913,
      "latitude":54.716583
    },
    "8406":{
      "name":"\u041a\u043e\u0447\u043a\u043e\u0432\u0430\u0442\u043a\u0430",
      "longitude":71.649368,
      "latitude":55.507423
    },
    "8407":{
      "name":"\u0421\u0438\u043d\u0433\u0443\u043b\u044c",
      "longitude":71.6580086,
      "latitude":56.2462351
    },
    "8408":{
      "name":"\u0423\u0441\u0442\u044c-\u041a\u0438\u0442\u0435\u0440\u043c\u0430",
      "longitude":71.6732146,
      "latitude":56.0805977
    },
    "8409":{
      "name":"\u041d\u043e\u0432\u043e\u0430\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":71.679504,
      "latitude":54.85873
    },
    "8410":{
      "name":"\u0413\u0430\u0440\u043a\u0443\u0448\u0438\u043d\u043e",
      "longitude":71.6801284,
      "latitude":54.9046593
    },
    "8411":{
      "name":"\u042f\u0441\u043d\u0430\u044f \u041f\u043e\u043b\u044f\u043d\u0430",
      "longitude":71.6884367,
      "latitude":54.7941784
    },
    "8412":{
      "name":"\u041a\u043e\u043d\u0441\u0442\u0430\u043d\u0442\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":71.7152632,
      "latitude":55.2266182
    },
    "8413":{
      "name":"\u0427\u0435\u0440\u043d\u044f\u0435\u0432\u043a\u0430",
      "longitude":71.7153763,
      "latitude":55.6738743
    },
    "8414":{
      "name":"\u041f\u0443\u0448\u043a\u0438\u043d\u043e",
      "longitude":71.7225735,
      "latitude":55.8172055
    },
    "8415":{
      "name":"\u0438\u043c\u0435\u043d\u0438 \u041c\u0430\u043a\u0441\u0438\u043c\u0430 \u0413\u043e\u0440\u044c\u043a\u043e\u0433\u043e",
      "longitude":71.7287331,
      "latitude":56.1957619
    },
    "8416":{
      "name":"\u041f\u043b\u0430\u0442\u043e\u0432\u043e",
      "longitude":71.7288943,
      "latitude":54.4876924
    },
    "8417":{
      "name":"\u0427\u0438\u0441\u0442\u043e\u043f\u043e\u043b\u044c\u0435",
      "longitude":71.7319054,
      "latitude":54.9103403
    },
    "8418":{
      "name":"\u0422\u0443\u043c\u0431\u0430",
      "longitude":71.733292,
      "latitude":54.734543
    },
    "8419":{
      "name":"\u0412\u044f\u0442\u043a\u0430",
      "longitude":71.739059,
      "latitude":57.697456
    },
    "8420":{
      "name":"\u041d\u0438\u043a\u043e\u043f\u043e\u043b\u044c",
      "longitude":71.745442,
      "latitude":54.1517778
    },
    "8421":{
      "name":"\u041f\u0440\u043e\u043b\u0435\u0442\u0430\u0440\u0441\u043a\u0438\u0439",
      "longitude":71.7612459,
      "latitude":55.022817
    },
    "8422":{
      "name":"\u041c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":71.7706947,
      "latitude":55.1154963
    },
    "8423":{
      "name":"\u0421\u0430\u043b\u0442\u0430\u0438\u043c",
      "longitude":71.788078,
      "latitude":56.049709
    },
    "8424":{
      "name":"\u0413\u0440\u044f\u0437\u043d\u043e\u0432\u043a\u0430",
      "longitude":71.792694,
      "latitude":54.888664
    },
    "8425":{
      "name":"\u0411\u0435\u0440\u0435\u0437\u043e\u0432\u043e",
      "longitude":71.7963925,
      "latitude":56.11283
    },
    "8426":{
      "name":"2595 \u043a\u043c",
      "longitude":71.8019584,
      "latitude":55.4224179
    },
    "8427":{
      "name":"\u0427\u0435\u0440\u043d\u043e\u043c\u043e\u0440\u043a\u0430",
      "longitude":71.8094639,
      "latitude":54.3803906
    },
    "8428":{
      "name":"\u041c\u0430\u043b\u0430\u0445\u043e\u0432\u043e",
      "longitude":71.8172011,
      "latitude":54.3629988
    },
    "8429":{
      "name":"\u041a\u043e\u043b\u043e\u043c\u0435\u043d\u043a\u0430",
      "longitude":71.8277724,
      "latitude":56.303866
    },
    "8430":{
      "name":"\u041c\u0438\u043b\u044e\u0442\u0438\u043d\u043e",
      "longitude":71.835756,
      "latitude":55.5074645
    },
    "8431":{
      "name":"2798 \u043a\u043c",
      "longitude":71.83591,
      "latitude":54.9332324
    },
    "8432":{
      "name":"\u0411\u0435\u043b\u044c\u0434\u0435\u0436 \u2116 7",
      "longitude":71.8361966,
      "latitude":54.4197929
    },
    "8433":{
      "name":"\u041a\u043e\u043b\u043c\u0430\u043a\u043e\u0432\u043e",
      "longitude":71.8380505,
      "latitude":55.9180828
    },
    "8434":{
      "name":"\u0414\u0440\u0430\u0433\u0443\u043d\u043a\u0430",
      "longitude":71.8402573,
      "latitude":55.3162535
    },
    "8435":{
      "name":"\u041a\u0437\u044b\u043b \u0410\u0433\u0430\u0448",
      "longitude":71.8433378,
      "latitude":54.7121342
    },
    "8436":{
      "name":"\u0428\u0430\u0445\u043e\u0432\u043e",
      "longitude":71.8486654,
      "latitude":54.4574554
    },
    "8437":{
      "name":"\u0418\u043d\u0441\u0430\u0440\u043a\u0430",
      "longitude":71.8549652,
      "latitude":54.8098734
    },
    "8438":{
      "name":"\u041c\u044b\u0441\u044b",
      "longitude":71.8613754,
      "latitude":56.1916877
    },
    "8439":{
      "name":"\u041a\u0430\u043b\u0443\u0433\u0438\u043d\u043e",
      "longitude":71.8669528,
      "latitude":56.0548311
    },
    "8440":{
      "name":"\u041a\u0438\u043f\u043e-\u041a\u0443\u043b\u0430\u0440\u044b",
      "longitude":71.8678587,
      "latitude":57.533488
    },
    "8441":{
      "name":"\u041d\u0430\u0434\u0435\u0436\u0434\u043e\u0432\u043a\u0430",
      "longitude":71.8705813,
      "latitude":54.9081657
    },
    "8442":{
      "name":"\u041f\u043e\u0434\u0434\u043e\u043b",
      "longitude":71.8707142,
      "latitude":57.4930057
    },
    "8443":{
      "name":"\u0417\u0430\u043e\u0437\u0435\u0440\u043d\u0430\u044f",
      "longitude":71.8762548,
      "latitude":56.3922192
    },
    "8444":{
      "name":"\u0410\u0437\u044b",
      "longitude":71.8801425,
      "latitude":57.4883234
    },
    "8445":{
      "name":"\u041e\u0448\u0438\u0440\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":71.8884821,
      "latitude":55.3938491
    },
    "8446":{
      "name":"\u0420\u043e\u0441\u0442\u043e\u0432\u043a\u0430",
      "longitude":71.889716,
      "latitude":55.3836674
    },
    "8447":{
      "name":"\u0427\u0435\u0431\u0430\u0447\u0438\u0445\u0430",
      "longitude":71.8987119,
      "latitude":57.1931406
    },
    "8448":{
      "name":"\u0424\u0451\u0434\u043e\u0440\u043e\u0432\u043a\u0430",
      "longitude":71.9101364,
      "latitude":54.8941334
    },
    "8449":{
      "name":"\u0413\u043e\u043b\u044c\u0431\u0448\u0442\u0430\u0434\u0442",
      "longitude":71.913055,
      "latitude":54.922203
    },
    "8450":{
      "name":"\u0412\u0438\u043d\u043e\u0433\u0440\u0430\u0434\u043e\u0432\u043a\u0430",
      "longitude":71.9183483,
      "latitude":55.0837695
    },
    "8451":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u0426\u0432\u0435\u0442",
      "longitude":71.9213952,
      "latitude":55.0574976
    },
    "8452":{
      "name":"\u0421\u0442\u0430\u0440\u0438\u0447\u044c\u0435",
      "longitude":71.9220621,
      "latitude":56.2950023
    },
    "8453":{
      "name":"\u041b\u0438\u0434\u0438\u043d\u043a\u0430",
      "longitude":71.9227543,
      "latitude":55.661144
    },
    "8454":{
      "name":"\u0411\u0440\u043e\u0434\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":71.9253394,
      "latitude":57.5920184
    },
    "8455":{
      "name":"\u041b\u0443\u0437\u0438\u043d\u043e",
      "longitude":71.9270721,
      "latitude":55.1723865
    },
    "8456":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u0424\u043b\u0430\u0433",
      "longitude":71.9334214,
      "latitude":54.8728046
    },
    "8457":{
      "name":"\u041a\u043b\u0438\u043c\u0438\u043d\u043e",
      "longitude":71.9381041,
      "latitude":55.8455
    },
    "8458":{
      "name":"\u041b\u0435\u0441\u043a\u0438",
      "longitude":71.9400475,
      "latitude":55.4423839
    },
    "8459":{
      "name":"\u0424\u0435\u0434\u043e\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":71.9453019,
      "latitude":55.7859709
    },
    "8460":{
      "name":"\u041a\u043e\u043c\u0430\u0440\u043e\u0432\u043a\u0430",
      "longitude":71.9501402,
      "latitude":57.5351376
    },
    "8461":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u043f\u0443\u0442\u0438\u043b\u043e\u0432\u043a\u0430",
      "longitude":71.9519673,
      "latitude":54.41612
    },
    "8462":{
      "name":"\u0413\u043e\u0441\u0442\u0438\u043b\u043e\u0432\u043a\u0430",
      "longitude":71.9581039,
      "latitude":54.3538948
    },
    "8463":{
      "name":"\u041e\u0431\u043d\u043e\u0432\u043b\u0435\u043d\u0438\u0435",
      "longitude":71.9662381,
      "latitude":55.0582176
    },
    "8464":{
      "name":"\u041c\u0430\u043b\u044b\u0435 \u041a\u0443\u043b\u0430\u0440\u044b",
      "longitude":71.9779577,
      "latitude":57.538
    },
    "8465":{
      "name":"\u0418\u043b\u0435\u0443\u0448",
      "longitude":71.9786047,
      "latitude":54.8002554
    },
    "8466":{
      "name":"\u0420\u043e\u043c\u0430\u0434\u0430\u043d",
      "longitude":71.9790638,
      "latitude":54.7424166
    },
    "8467":{
      "name":"\u0427\u0430\u0433\u0438\u043d\u043e",
      "longitude":71.9829648,
      "latitude":56.4518397
    },
    "8468":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u043e\u043b\u043e\u043c\u0437\u0438\u043d\u043e",
      "longitude":71.9850935,
      "latitude":54.3523821
    },
    "8469":{
      "name":"\u0423\u0441\u0442\u044c-\u041b\u043e\u0433\u0430\u0442\u043a\u0430",
      "longitude":71.9868375,
      "latitude":56.2219328
    },
    "8470":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u0435\u0440\u0433\u0435\u0435\u0432\u043a\u0430",
      "longitude":71.9880927,
      "latitude":54.45876
    },
    "8471":{
      "name":"\u0421\u0435\u043b\u0438\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":72.0075393,
      "latitude":54.6159422
    },
    "8472":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u0441\u043a\u0438\u0439",
      "longitude":72.0080942,
      "latitude":55.3277768
    },
    "8473":{
      "name":"\u0425\u0430\u0440\u043b\u043e\u0432\u043a\u0430",
      "longitude":72.0147045,
      "latitude":55.1176662
    },
    "8474":{
      "name":"\u0421\u0442\u0435\u043f\u043e\u043a",
      "longitude":72.0158629,
      "latitude":54.8420941
    },
    "8475":{
      "name":"\u0428\u0435\u0444\u0435\u0440",
      "longitude":72.018295,
      "latitude":55.00568
    },
    "8476":{
      "name":"\u0413\u0443\u0431\u0435\u0440\u043d\u0441\u043a\u043e\u0435",
      "longitude":72.0219869,
      "latitude":55.0670371
    },
    "8477":{
      "name":"\u041a\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":72.0261711,
      "latitude":54.3805663
    },
    "8478":{
      "name":"\u041f\u0438\u0442\u043e\u043c\u043d\u0438\u043a",
      "longitude":72.048264,
      "latitude":54.801926
    },
    "8479":{
      "name":"\u041c\u0438\u0440\u043d\u043e\u0435 \u041f\u043e\u043b\u0435",
      "longitude":72.0533605,
      "latitude":55.0289758
    },
    "8480":{
      "name":"\u0427\u0435\u0440\u043d\u043e\u0443\u0441\u043e\u0432\u043e",
      "longitude":72.0617975,
      "latitude":55.7256555
    },
    "8481":{
      "name":"\u041a\u043e\u0440\u043e\u043b\u0438",
      "longitude":72.063516,
      "latitude":55.5815821
    },
    "8482":{
      "name":"\u0421\u0442\u0430\u0440\u044b\u0439 \u041a\u043e\u043d\u043a\u0443\u043b\u044c",
      "longitude":72.070684,
      "latitude":56.0983331
    },
    "8483":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":72.074221,
      "latitude":55.6447994
    },
    "8484":{
      "name":"\u0415\u043b\u0438\u0437\u0430\u0432\u0435\u0442\u0438\u043d\u043e",
      "longitude":72.0754994,
      "latitude":54.4986923
    },
    "8485":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u0427\u0435\u0440\u043d\u043e\u043e\u0441\u0442\u0440\u043e\u0432\u043a\u0430",
      "longitude":72.0769434,
      "latitude":55.2929113
    },
    "8486":{
      "name":"\u0414\u043e\u043b\u0433\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":72.0769774,
      "latitude":55.509769
    },
    "8487":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u0441\u043a\u043e\u0435 \u041b\u0435\u0441\u043d\u0438\u0447\u0435\u0441\u0442\u0432\u043e",
      "longitude":72.080483,
      "latitude":55.3249517
    },
    "8488":{
      "name":"\u0414\u0430\u0447\u043d\u043e\u0435",
      "longitude":72.0806543,
      "latitude":54.809942
    },
    "8489":{
      "name":"\u041d\u043e\u0432\u044b\u0439 \u041a\u043e\u043d\u043a\u0443\u043b\u044c",
      "longitude":72.089638,
      "latitude":56.086456
    },
    "8490":{
      "name":"\u041f\u0443\u0442\u0438\u043b\u043e\u0432\u043a\u0430",
      "longitude":72.0962639,
      "latitude":54.5554834
    },
    "8491":{
      "name":"\u041b\u0430\u043f\u0442\u0435\u0432\u043e",
      "longitude":72.0987815,
      "latitude":56.0060611
    },
    "8492":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u0432\u043a\u0430",
      "longitude":72.0994878,
      "latitude":55.7805978
    },
    "8493":{
      "name":"\u0422\u0430\u0442\u044c\u044f\u043d\u043e\u0432\u043a\u0430",
      "longitude":72.1187102,
      "latitude":54.7173675
    },
    "8494":{
      "name":"\u041f\u043e\u043c\u0443\u0440\u0438\u043d\u043e",
      "longitude":72.1190429,
      "latitude":54.9452972
    },
    "8495":{
      "name":"\u0421\u043b\u0430\u0432\u044f\u043d\u0441\u043a\u043e\u0435",
      "longitude":72.1295739,
      "latitude":54.4739216
    },
    "8496":{
      "name":"\u0429\u0443\u0447\u044c\u0435",
      "longitude":72.1310644,
      "latitude":55.4281803
    },
    "8497":{
      "name":"\u0427\u0430\u0439\u043a\u0438\u043d\u043e",
      "longitude":72.1311309,
      "latitude":55.7005284
    },
    "8498":{
      "name":"\u041a\u043e\u043b\u044c\u043a\u0443\u043b\u044c",
      "longitude":72.1394873,
      "latitude":56.2373033
    },
    "8499":{
      "name":"\u041e\u0441\u0442\u0440\u043e\u0432\u043d\u0430\u044f",
      "longitude":72.1429563,
      "latitude":56.3485963
    },
    "8500":{
      "name":"\u041b\u0443\u0433\u043e\u0432\u0430\u044f",
      "longitude":72.1431702,
      "latitude":56.1901049
    },
    "8501":{
      "name":"\u0412\u0442\u043e\u0440\u0430\u044f \u041f\u044f\u0442\u0438\u043b\u0435\u0442\u043a\u0430",
      "longitude":72.1591149,
      "latitude":55.8601428
    },
    "8502":{
      "name":"\u0424\u043e\u0440\u043f\u043e\u0441\u0442",
      "longitude":72.1609956,
      "latitude":56.7832622
    },
    "8503":{
      "name":"\u0427\u0430\u0449\u0438\u043d\u043e",
      "longitude":72.1648858,
      "latitude":55.933828
    },
    "8504":{
      "name":"\u0421\u043e\u0441\u043d\u043e\u0432\u044b\u0439",
      "longitude":72.1704383,
      "latitude":57.6511493
    },
    "8505":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u0412\u043e\u0441\u0442\u043e\u043a",
      "longitude":72.1736963,
      "latitude":54.4384241
    },
    "8506":{
      "name":"\u0415\u0440\u043c\u043e\u043b\u0438\u043d\u043e",
      "longitude":72.1792452,
      "latitude":55.6608253
    },
    "8507":{
      "name":"\u0417\u043e\u0442\u0438\u043d\u043e",
      "longitude":72.1795541,
      "latitude":55.9884994
    },
    "8508":{
      "name":"\u041b\u0435\u0441\u043d\u043e\u0433\u043e\u0440\u0441\u043a\u0438\u0439",
      "longitude":72.1889184,
      "latitude":54.8473597
    },
    "8509":{
      "name":"\u041e\u0440\u043b\u043e\u0432\u043e-\u041a\u0443\u043a\u0443\u0448\u043a\u0438\u043d\u043e",
      "longitude":72.1942529,
      "latitude":55.7626348
    },
    "8510":{
      "name":"\u0413\u043e\u043b\u0443\u0431\u043a\u0438",
      "longitude":72.1946049,
      "latitude":55.4134645
    },
    "8511":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u043c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":72.1952491,
      "latitude":55.4481884
    },
    "8512":{
      "name":"\u0411\u043e\u0440\u044f\u0442\u0438\u043d\u043e",
      "longitude":72.1990456,
      "latitude":55.2786845
    },
    "8513":{
      "name":"\u0428\u0443\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":72.2156892,
      "latitude":55.1915766
    },
    "8514":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u043c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":72.2170993,
      "latitude":56.0154117
    },
    "8515":{
      "name":"\u0421\u043f\u0430\u0440\u0442\u0430\u043a",
      "longitude":72.2234567,
      "latitude":55.0293337
    },
    "8516":{
      "name":"\u0421\u043e\u043a\u043e\u043b\u043e\u0432\u043a\u0430",
      "longitude":72.2252961,
      "latitude":56.1225835
    },
    "8517":{
      "name":"\u0420\u044f\u0431\u0438\u043d\u043a\u0430",
      "longitude":72.2273493,
      "latitude":55.0651447
    },
    "8518":{
      "name":"\u0421\u043b\u0430\u0432\u044f\u043d\u043a\u0430",
      "longitude":72.2278779,
      "latitude":54.434146
    },
    "8519":{
      "name":"\u0412\u0435\u0440\u0431\u043e\u0432\u043a\u0430",
      "longitude":72.2375346,
      "latitude":54.5881648
    },
    "8520":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0435-\u0412\u0430\u0441\u0438\u043b\u044c\u0435\u0432\u043a\u0430",
      "longitude":72.2474612,
      "latitude":54.6512578
    },
    "8521":{
      "name":"\u0422\u043e\u043a\u0430\u0440\u0435\u0432\u043e",
      "longitude":72.2748409,
      "latitude":55.5464626
    },
    "8522":{
      "name":"\u0411\u0430\u043b\u0430\u0448\u043e\u0432\u043a\u0430",
      "longitude":72.2811126,
      "latitude":55.2265881
    },
    "8523":{
      "name":"\u041b\u0435\u0441\u043d\u043e\u0439",
      "longitude":72.2861804,
      "latitude":55.135868
    },
    "8524":{
      "name":"\u041d\u0435\u0439\u0434\u043e\u0440\u0444",
      "longitude":72.292061,
      "latitude":54.849197
    },
    "8525":{
      "name":"\u041f\u043e\u043b\u0443\u044f\u043d\u043e\u0432\u043a\u0430",
      "longitude":72.2932442,
      "latitude":57.5156708
    },
    "8526":{
      "name":"\u0413\u0443\u0440\u043a\u043e\u0432\u043e",
      "longitude":72.2987597,
      "latitude":56.2624288
    },
    "8527":{
      "name":"\u0438\u043c\u0435\u043d\u0438 \u0427\u0430\u043f\u0430\u0435\u0432\u0430",
      "longitude":72.3086665,
      "latitude":54.9906677
    },
    "8528":{
      "name":"\u042e\u0436\u043d\u044b\u0439",
      "longitude":72.316581,
      "latitude":55.0534281
    },
    "8529":{
      "name":"\u041c\u043e\u043a\u0448\u0438\u043d\u043e",
      "longitude":72.3166417,
      "latitude":55.3478348
    },
    "8530":{
      "name":"\u0412\u043b\u0430\u0434\u0438\u043c\u0438\u0440\u043e\u0432\u043a\u0430",
      "longitude":72.318126,
      "latitude":55.4523821
    },
    "8531":{
      "name":"\u041a\u0443\u043c\u044b\u0440\u0430",
      "longitude":72.3207049,
      "latitude":56.2009658
    },
    "8532":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u0428\u0430\u0440",
      "longitude":72.3236955,
      "latitude":55.8574646
    },
    "8533":{
      "name":"\u041f\u043e\u0431\u0435\u0434\u0430",
      "longitude":72.3337894,
      "latitude":54.8427165
    },
    "8534":{
      "name":"\u0420\u0430\u0439\u043d\u0444\u0435\u043b\u044c\u0434",
      "longitude":72.352577,
      "latitude":54.940254
    },
    "8535":{
      "name":"\u0413\u043e\u0440\u043e\u0434\u043a\u0438",
      "longitude":72.3526171,
      "latitude":56.1406787
    },
    "8536":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u0438\u0435\u0432\u0441\u043a\u0438\u0439",
      "longitude":72.3581314,
      "latitude":55.2590424
    },
    "8537":{
      "name":"\u0421\u043b\u0430\u0432\u0438\u043d\u043a\u0430",
      "longitude":72.3619911,
      "latitude":55.2539036
    },
    "8538":{
      "name":"\u0411\u043e\u0433\u043e\u0440\u043e\u0434\u0441\u043a",
      "longitude":72.3742793,
      "latitude":55.5940336
    },
    "8539":{
      "name":"\u041a\u0430\u043f\u0443\u0441\u0442\u0438\u043d\u043e",
      "longitude":72.3777559,
      "latitude":55.4227302
    },
    "8540":{
      "name":"\u041a\u043e\u0448\u043a\u0443\u043b\u044c",
      "longitude":72.3790253,
      "latitude":56.0170059
    },
    "8541":{
      "name":"\u0428\u0430\u0445\u0430\u0442",
      "longitude":72.3820871,
      "latitude":54.377564
    },
    "8542":{
      "name":"\u0421\u0435\u0440\u0433\u0435\u0435\u0432\u043a\u0430",
      "longitude":72.3832797,
      "latitude":55.7495927
    },
    "8543":{
      "name":"\u0418\u043b\u044c\u0438\u043d\u043a\u0430",
      "longitude":72.4009442,
      "latitude":55.640594
    },
    "8544":{
      "name":"\u041e\u0448\u0430",
      "longitude":72.4114909,
      "latitude":56.157456
    },
    "8545":{
      "name":"\u0421\u0443\u0431\u0431\u043e\u0442\u0438\u043d\u043a\u0430",
      "longitude":72.4116771,
      "latitude":55.3747563
    },
    "8546":{
      "name":"\u0421\u0430\u0440\u044b\u0431\u0430\u043b\u044b",
      "longitude":72.4122186,
      "latitude":56.2655193
    },
    "8547":{
      "name":"\u0411\u043e\u0431\u0440\u043e\u0432\u0438\u0446\u0430",
      "longitude":72.4127771,
      "latitude":54.0885341
    },
    "8548":{
      "name":"\u041a\u0440\u0443\u0448\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":72.4218142,
      "latitude":54.3084229
    },
    "8549":{
      "name":"2640 \u043a\u043c",
      "longitude":72.4292942,
      "latitude":55.2352376
    },
    "8550":{
      "name":"\u041a\u043e\u043d\u043e\u0432\u0430\u043b\u0438\u0445\u0430",
      "longitude":72.4395505,
      "latitude":56.8444011
    },
    "8551":{
      "name":"\u0422\u0430\u0442\u044c\u044f\u043d\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":72.4408033,
      "latitude":54.9542432
    },
    "8552":{
      "name":"\u0422\u0430\u0442\u044c\u044f\u043d\u043e\u0432\u0441\u043a\u0438\u0439 \u041a\u043e\u0440\u0434\u043e\u043d",
      "longitude":72.4439136,
      "latitude":54.9660811
    },
    "8553":{
      "name":"\u0414\u0443\u0431\u0440\u043e\u0432\u043a\u0430",
      "longitude":72.4443551,
      "latitude":54.4979433
    },
    "8554":{
      "name":"\u0420\u0435\u0448\u0435\u0442\u0438\u043d\u043e",
      "longitude":72.4462115,
      "latitude":56.9247424
    },
    "8555":{
      "name":"\u0413\u0440\u0438\u0431\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":72.450394,
      "latitude":54.876423
    },
    "8556":{
      "name":"\u041a\u0443\u0441\u043a\u0443\u043d\u044b",
      "longitude":72.4558631,
      "latitude":57.5202382
    },
    "8557":{
      "name":"\u042e\u0436\u043d\u043e\u0435",
      "longitude":72.4598802,
      "latitude":54.5776679
    },
    "8558":{
      "name":"\u041e\u0445\u0440\u043e\u0432\u043a\u0430",
      "longitude":72.466393,
      "latitude":54.950638
    },
    "8559":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043e-\u0421\u0435\u0440\u0433\u0438\u0435\u0432\u043a\u0430",
      "longitude":72.4763554,
      "latitude":56.1476793
    },
    "8560":{
      "name":"\u041c\u0430\u043b\u044b\u0439 \u0422\u0435\u0432\u0440\u0438\u0437",
      "longitude":72.4777514,
      "latitude":57.4509636
    },
    "8561":{
      "name":"\u041a\u0430\u0441\u043f\u0438\u043b\u044c",
      "longitude":72.4888098,
      "latitude":55.7607233
    },
    "8562":{
      "name":"\u041a\u0443\u0434\u0443\u043a-\u0427\u0438\u043b\u0438\u043a",
      "longitude":72.4949676,
      "latitude":54.3738101
    },
    "8563":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u041e\u043a\u0443\u043d\u0451\u0432\u043a\u0430",
      "longitude":72.5079682,
      "latitude":55.5199897
    },
    "8564":{
      "name":"\u041c\u0430\u043b\u043e\u043c\u043e\u0433\u0438\u043b\u044c\u043d\u043e\u0435",
      "longitude":72.5111521,
      "latitude":55.3615822
    },
    "8565":{
      "name":"\u0412\u044b\u0431\u043e\u0440\u043d\u0435\u043d\u043e\u0432\u043a\u0430",
      "longitude":72.5153206,
      "latitude":55.1890723
    },
    "8566":{
      "name":"\u0412\u0438\u0448\u043d\u0435\u0432\u043a\u0430",
      "longitude":72.5169952,
      "latitude":54.7712699
    },
    "8567":{
      "name":"\u041a\u0430\u043d\u0430\u043a\u043e\u0432\u043a\u0430",
      "longitude":72.5205315,
      "latitude":55.3106477
    },
    "8568":{
      "name":"\u0413\u0435\u043e\u0440\u0433\u0438\u0435\u0432\u043a\u0430",
      "longitude":72.5210488,
      "latitude":55.9633863
    },
    "8569":{
      "name":"\u0427\u0435\u0431\u0443\u0440\u0435\u043d\u043a\u0438",
      "longitude":72.5216277,
      "latitude":54.884896
    },
    "8570":{
      "name":"2647 \u043a\u043c",
      "longitude":72.5246039,
      "latitude":55.2035743
    },
    "8571":{
      "name":"\u0428\u0438\u043f\u0430\u0447\u0438",
      "longitude":72.5314856,
      "latitude":55.8485366
    },
    "8572":{
      "name":"\u041f\u043e\u043c\u043e\u0433\u0430\u0435\u0432\u043a\u0430",
      "longitude":72.538231,
      "latitude":55.216728
    },
    "8573":{
      "name":"\u0420\u0430\u0441\u0441\u0432\u0435\u0442",
      "longitude":72.5555066,
      "latitude":55.4815389
    },
    "8574":{
      "name":"\u0417\u0430\u043b\u0435\u0441\u043d\u0430\u044f",
      "longitude":72.5727716,
      "latitude":55.6684506
    },
    "8575":{
      "name":"\u0427\u0430\u0434\u0441\u043a",
      "longitude":72.57354,
      "latitude":54.327946
    },
    "8576":{
      "name":"\u042f\u0431\u043b\u043e\u043d\u043e\u0432\u043a\u0430",
      "longitude":72.57399,
      "latitude":54.394123
    },
    "8577":{
      "name":"\u0410\u043d\u0434\u0440\u0435\u0435\u0432\u043a\u0430",
      "longitude":72.5794798,
      "latitude":55.3175518
    },
    "8578":{
      "name":"\u041a\u043e\u043a\u0447\u0438\u043d\u0441\u043a",
      "longitude":72.583054,
      "latitude":54.363205
    },
    "8579":{
      "name":"\u041f\u0440\u0438\u043e\u0437\u0435\u0440\u043a\u0430",
      "longitude":72.5859886,
      "latitude":56.1077142
    },
    "8580":{
      "name":"\u0427\u0443\u043b\u043a\u043e\u0432\u043e",
      "longitude":72.5896085,
      "latitude":55.1549966
    },
    "8581":{
      "name":"\u041a\u043e\u043c\u0441\u043e\u043c\u043e\u043b\u044c\u0441\u043a\u043e\u0435",
      "longitude":72.59348,
      "latitude":54.574028
    },
    "8582":{
      "name":"\u0410\u0441\u0442\u0440\u0430\u0445\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":72.5986584,
      "latitude":55.263848
    },
    "8583":{
      "name":"\u0412\u043e\u0441\u0442\u043e\u0447\u043d\u044b\u0439",
      "longitude":72.609895,
      "latitude":55.9914886
    },
    "8584":{
      "name":"\u0411\u0438\u0447\u0438\u043b\u0438",
      "longitude":72.6134954,
      "latitude":57.5788432
    },
    "8585":{
      "name":"\u0411\u0430\u0431\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":72.6161588,
      "latitude":55.2274013
    },
    "8586":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0435\u043c\u043e\u0433\u0438\u043b\u044c\u043d\u043e\u0435",
      "longitude":72.6171209,
      "latitude":55.3978256
    },
    "8587":{
      "name":"\u0423\u043a\u0438",
      "longitude":72.621138,
      "latitude":56.989353
    },
    "8588":{
      "name":"\u0422\u0430\u0440\u043b\u044b\u043a",
      "longitude":72.6276351,
      "latitude":55.5247463
    },
    "8589":{
      "name":"\u0413\u0443\u0440\u043e\u0432\u043a\u0430",
      "longitude":72.630592,
      "latitude":55.591984
    },
    "8590":{
      "name":"\u0412\u043e\u0437\u043d\u0435\u0441\u0435\u043d\u043a\u0430",
      "longitude":72.6525453,
      "latitude":57.5181059
    },
    "8591":{
      "name":"\u0424\u0438\u043b\u0430\u0442\u043e\u0432\u043a\u0430",
      "longitude":72.6544229,
      "latitude":55.2155903
    },
    "8592":{
      "name":"\u041c\u0430\u0441\u043b\u044f\u043d\u043e\u0432\u043a\u0430",
      "longitude":72.6599781,
      "latitude":55.2001491
    },
    "8593":{
      "name":"\u041e\u0431\u0440\u043e\u0441\u043a\u0438\u043d\u043e",
      "longitude":72.6620261,
      "latitude":55.5503596
    },
    "8594":{
      "name":"\u0422\u0430\u0440\u043d\u0430\u043b\u044b",
      "longitude":72.6727386,
      "latitude":54.595438
    },
    "8595":{
      "name":"\u041a\u043e\u0447\u043a\u0438",
      "longitude":72.675285,
      "latitude":55.088432
    },
    "8596":{
      "name":"\u041f\u0435\u0441\u0442\u0440\u043e\u0432\u043a\u0430",
      "longitude":72.6838309,
      "latitude":55.4820099
    },
    "8597":{
      "name":"\u0413\u0440\u043e\u043c\u043e\u0433\u043b\u0430\u0441\u043e\u0432\u043e",
      "longitude":72.6855442,
      "latitude":53.9722229
    },
    "8598":{
      "name":"\u041a\u0430\u0440\u0430\u0433\u0430\u0448",
      "longitude":72.6869569,
      "latitude":54.4093017
    },
    "8599":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u0421\u0442\u0435\u043f\u043d\u0438\u043d\u043a\u0430",
      "longitude":72.696701,
      "latitude":55.052715
    },
    "8600":{
      "name":"\u0417\u0435\u043b\u0451\u043d\u0430\u044f \u0414\u043e\u043b\u0438\u043d\u0430",
      "longitude":72.7116158,
      "latitude":54.7743577
    },
    "8601":{
      "name":"\u0411\u0435\u043b\u044f\u0435\u0432\u043a\u0430",
      "longitude":72.712151,
      "latitude":55.236404
    },
    "8602":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":72.7132437,
      "latitude":54.8065201
    },
    "8603":{
      "name":"\u041a\u043e\u0439\u0447\u0443\u0431\u0430\u0439",
      "longitude":72.7149637,
      "latitude":54.7194543
    },
    "8604":{
      "name":"\u041e\u0440\u043b\u043e\u0432\u043a\u0430",
      "longitude":72.7371546,
      "latitude":55.8994714
    },
    "8605":{
      "name":"\u0412\u043e\u0441\u0442\u043e\u0447\u043d\u044b\u0439",
      "longitude":72.7386925,
      "latitude":55.140771
    },
    "8606":{
      "name":"\u041a\u0430\u0440\u0431\u0430\u0438\u043d\u043e\u0432\u043e",
      "longitude":72.7392506,
      "latitude":56.1907411
    },
    "8607":{
      "name":"\u0411\u0430\u0440\u0441\u0443\u043a\u043e\u0432\u043a\u0430",
      "longitude":72.7429889,
      "latitude":55.2268791
    },
    "8608":{
      "name":"\u041d\u043e\u0432\u043e\u0435 \u041f\u043e\u043b\u0435",
      "longitude":72.753731,
      "latitude":55.087337
    },
    "8609":{
      "name":"\u0427\u0443\u0433\u0443\u043d\u043b\u044b",
      "longitude":72.7541955,
      "latitude":56.5253665
    },
    "8610":{
      "name":"\u041f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":72.7613744,
      "latitude":55.1782651
    },
    "8611":{
      "name":"2857 \u043a\u043c",
      "longitude":72.7664652,
      "latitude":54.9604463
    },
    "8612":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0435 \u0423\u043a\u0438",
      "longitude":72.7734374,
      "latitude":56.7753232
    },
    "8613":{
      "name":"\u041a\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":72.7753684,
      "latitude":55.3781187
    },
    "8614":{
      "name":"\u041f\u043e\u0441\u043f\u0435\u043b\u043e\u0432\u043e",
      "longitude":72.7777194,
      "latitude":56.8819136
    },
    "8615":{
      "name":"\u0411\u0430\u0441\u043b\u044b",
      "longitude":72.7811457,
      "latitude":57.0093305
    },
    "8616":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u043e\u043b\u0434\u0430\u0442\u043a\u0430",
      "longitude":72.7849311,
      "latitude":55.8295746
    },
    "8617":{
      "name":"\u041c\u0438\u0440\u043e\u043d\u0435\u043d\u043e\u0432\u043a\u0430",
      "longitude":72.7850305,
      "latitude":55.1170374
    },
    "8618":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":72.7873428,
      "latitude":55.4993176
    },
    "8619":{
      "name":"\u0411\u044b\u0441\u0442\u0440\u0443\u0445\u0430",
      "longitude":72.7925701,
      "latitude":55.420569
    },
    "8620":{
      "name":"\u041e\u0445\u043e\u0442\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":72.8017398,
      "latitude":55.9423809
    },
    "8621":{
      "name":"\u041f\u0430\u0432\u043b\u043e\u0432\u043a\u0430",
      "longitude":72.8098031,
      "latitude":55.5721623
    },
    "8622":{
      "name":"\u0421\u0430\u0432\u0438\u043d\u043e\u0432\u043e",
      "longitude":72.8153331,
      "latitude":56.2000365
    },
    "8623":{
      "name":"\u0412\u0435\u0434\u0435\u043d\u0438\u043d\u043e",
      "longitude":72.8183733,
      "latitude":56.029408
    },
    "8624":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u0418\u0441\u043a\u0430\u043a",
      "longitude":72.8197947,
      "latitude":54.7273897
    },
    "8625":{
      "name":"\u0421\u0442\u0435\u043f\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":72.8347721,
      "latitude":55.4250334
    },
    "8626":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":72.8384044,
      "latitude":55.6197603
    },
    "8627":{
      "name":"\u0414\u043e\u0440\u043e\u043d\u0438\u043d\u043e",
      "longitude":72.8430337,
      "latitude":57.4626107
    },
    "8628":{
      "name":"\u0410\u043b\u043e\u043d\u0441\u043a\u0438\u0439",
      "longitude":72.8594493,
      "latitude":54.9622014
    },
    "8629":{
      "name":"\u0420\u0443\u0441\u043b\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":72.860294,
      "latitude":54.6763314
    },
    "8630":{
      "name":"2672 \u043a\u043c",
      "longitude":72.876656,
      "latitude":55.0917223
    },
    "8631":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":72.891914,
      "latitude":54.984215
    },
    "8632":{
      "name":"\u041a\u0430\u0439\u0433\u0430\u0440\u043b\u044b",
      "longitude":72.900005,
      "latitude":57.4561842
    },
    "8633":{
      "name":"\u0413\u043b\u0435\u0431\u043e\u0432\u043a\u0430",
      "longitude":72.9004648,
      "latitude":55.7235544
    },
    "8634":{
      "name":"\u0422\u0438\u0448\u0430\u043d\u043a\u0430",
      "longitude":72.9032531,
      "latitude":54.3135424
    },
    "8635":{
      "name":"\u042f\u0433\u043e\u0434\u043d\u043e\u0435",
      "longitude":72.915421,
      "latitude":54.675053
    },
    "8636":{
      "name":"\u0421\u043b\u0430\u0432\u0433\u043e\u0440\u043e\u0434\u043a\u0430",
      "longitude":72.9275457,
      "latitude":54.1143679
    },
    "8637":{
      "name":"\u0416\u0443\u0440\u0430\u0432\u043b\u0451\u0432\u043a\u0430",
      "longitude":72.9379376,
      "latitude":56.0449385
    },
    "8638":{
      "name":"\u041d\u0430\u0433\u043e\u0440\u043d\u043e-\u0410\u0435\u0432\u0441\u043a",
      "longitude":72.9410914,
      "latitude":57.3978517
    },
    "8639":{
      "name":"\u041b\u0435\u0441\u043d\u043e\u0435",
      "longitude":72.947783,
      "latitude":54.5546734
    },
    "8640":{
      "name":"\u041f\u043b\u043e\u0441\u043a\u043e\u0435",
      "longitude":72.9637627,
      "latitude":55.8437084
    },
    "8641":{
      "name":"\u041c\u0435\u0440\u043a\u0443\u0442\u043b\u044b",
      "longitude":72.9706014,
      "latitude":56.0899724
    },
    "8642":{
      "name":"\u0411\u043b\u0438\u0436\u043d\u044f\u044f \u0420\u043e\u0449\u0430",
      "longitude":72.9714774,
      "latitude":54.8976628
    },
    "8643":{
      "name":"\u0411\u0430\u0440\u0441\u0443\u043a\u043e\u0432\u043a\u0430",
      "longitude":72.974182,
      "latitude":54.621357
    },
    "8644":{
      "name":"\u041d\u043e\u0432\u043e\u043f\u0430\u0432\u043b\u043e\u0432\u043a\u0430",
      "longitude":72.9904071,
      "latitude":54.2857162
    },
    "8645":{
      "name":"\u0427\u0435\u0440\u0434\u044b\u043d\u0446\u0435\u0432\u043e",
      "longitude":72.993378,
      "latitude":56.299655
    },
    "8646":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u041a\u0430\u0437\u0430\u043d\u043a\u0430",
      "longitude":73.0143601,
      "latitude":56.0241362
    },
    "8647":{
      "name":"\u041f\u0435\u0442\u0440\u0443\u0448\u0435\u043d\u043a\u043e",
      "longitude":73.0174053,
      "latitude":55.0375004
    },
    "8648":{
      "name":"\u042e\u0436\u043d\u043e\u0435",
      "longitude":73.0260459,
      "latitude":54.632178
    },
    "8649":{
      "name":"\u0422\u0443\u043b\u0443\u043c\u0431\u0430\u0439",
      "longitude":73.0261814,
      "latitude":54.8375027
    },
    "8650":{
      "name":"\u0422\u0430\u043c\u0431\u043e\u0432\u043a\u0430",
      "longitude":73.0311659,
      "latitude":55.4733641
    },
    "8651":{
      "name":"\u041b\u0443\u0437\u0438\u043d\u043e",
      "longitude":73.041374,
      "latitude":54.953907
    },
    "8652":{
      "name":"\u041a\u0443\u0442\u0443\u043c\u0431\u0435\u0442",
      "longitude":73.0446963,
      "latitude":54.4864302
    },
    "8653":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":73.0797773,
      "latitude":56.2202263
    },
    "8654":{
      "name":"\u0427\u0430\u0443\u043d\u0438\u043d\u043e",
      "longitude":73.07993,
      "latitude":57.1452905
    },
    "8655":{
      "name":"\u0413\u0430\u043b\u0438\u0446\u044b\u043d\u043e",
      "longitude":73.0835725,
      "latitude":55.8594488
    },
    "8656":{
      "name":"\u041a\u0443\u0440\u0442\u0430\u0439\u043b\u044b",
      "longitude":73.0869112,
      "latitude":55.9118885
    },
    "8657":{
      "name":"\u0421\u0430\u0440\u0430\u0442",
      "longitude":73.0889466,
      "latitude":54.3658051
    },
    "8658":{
      "name":"\u0411\u0435\u0440\u0434\u044f\u043d\u043a\u0430",
      "longitude":73.101356,
      "latitude":54.6397197
    },
    "8659":{
      "name":"\u0412\u043e\u0440\u043e\u043d\u043a\u043e\u0432\u043e",
      "longitude":73.1307596,
      "latitude":54.5568408
    },
    "8660":{
      "name":"\u0411\u0430\u0438\u0440\u043e\u0432\u043e",
      "longitude":73.1373873,
      "latitude":56.0667187
    },
    "8661":{
      "name":"\u041a\u0440\u0443\u0442\u043e\u0431\u0435\u0440\u0435\u0436\u043d\u044b\u0439",
      "longitude":73.139603,
      "latitude":55.0417793
    },
    "8662":{
      "name":"\u0417\u0435\u043b\u0451\u043d\u0430\u044f",
      "longitude":73.1418329,
      "latitude":56.3543529
    },
    "8663":{
      "name":"\u041d\u043e\u0432\u0438\u043d\u043a\u0430",
      "longitude":73.142792,
      "latitude":54.76091
    },
    "8664":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0435\u0448\u0438\u043f\u0438\u0446\u044b\u043d\u043e",
      "longitude":73.1620593,
      "latitude":55.7320821
    },
    "8665":{
      "name":"\u0412\u0438\u0448\u043d\u0435\u0432\u043e\u0435",
      "longitude":73.1684199,
      "latitude":56.5701719
    },
    "8666":{
      "name":"\u041f\u0435\u0441\u0447\u0430\u043d\u043a\u0430",
      "longitude":73.1727796,
      "latitude":54.3388682
    },
    "8667":{
      "name":"\u041c\u0430\u043b\u043e\u043a\u0443\u043b\u0430\u0447\u044c\u0435",
      "longitude":73.1795203,
      "latitude":55.2633827
    },
    "8668":{
      "name":"\u041d\u043e\u0432\u043e\u043f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":73.1834388,
      "latitude":55.5786473
    },
    "8669":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":73.1858283,
      "latitude":55.6805424
    },
    "8670":{
      "name":"\u0417\u0435\u043b\u0451\u043d\u043e\u0435 \u041f\u043e\u043b\u0435",
      "longitude":73.204483,
      "latitude":54.933781
    },
    "8671":{
      "name":"\u041b\u0443\u0433\u043e\u0432\u0430\u044f",
      "longitude":73.236959,
      "latitude":55.240011
    },
    "8672":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":73.237411,
      "latitude":56.243366
    },
    "8673":{
      "name":"\u0421\u0430\u0434\u043e\u0432\u043e\u0435",
      "longitude":73.2466872,
      "latitude":54.6447591
    },
    "8674":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0435\u043a\u0443\u043b\u0430\u0447\u044c\u0435",
      "longitude":73.255215,
      "latitude":55.2119601
    },
    "8675":{
      "name":"\u0414\u0443\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":73.2569108,
      "latitude":53.9662757
    },
    "8676":{
      "name":"\u0424\u0451\u0434\u043e\u0440\u043e\u0432\u043a\u0430",
      "longitude":73.2583242,
      "latitude":57.5902943
    },
    "8677":{
      "name":"\u0418\u043d\u0434\u0435\u0440\u044b",
      "longitude":73.2637407,
      "latitude":55.857588
    },
    "8678":{
      "name":"\u0411\u0430\u043b\u0430\u043d\u0433\u0443\u043b\u044c",
      "longitude":73.2665618,
      "latitude":55.8048082
    },
    "8679":{
      "name":"\u0410\u043d\u0434\u0440\u0435\u0435\u0432\u043a\u0430",
      "longitude":73.2727776,
      "latitude":54.3916462
    },
    "8680":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":73.2796677,
      "latitude":56.2165629
    },
    "8681":{
      "name":"\u0410\u043a\u0441\u0435\u043d\u043e\u0432\u043e",
      "longitude":73.2812466,
      "latitude":55.5727353
    },
    "8682":{
      "name":"\u0410\u0432\u044f\u043a",
      "longitude":73.2864207,
      "latitude":57.1316659
    },
    "8683":{
      "name":"\u0423\u0440\u0443\u0441\u043e\u0432\u043e",
      "longitude":73.2930247,
      "latitude":55.6565905
    },
    "8684":{
      "name":"\u041c\u0443\u0440\u0442\u0443\u043a",
      "longitude":73.3057577,
      "latitude":54.5278027
    },
    "8685":{
      "name":"\u0411\u0435\u0441\u0441\u0430\u0440\u0430\u0431\u043a\u0430",
      "longitude":73.3076412,
      "latitude":53.6127998
    },
    "8686":{
      "name":"\u0411\u0435\u0441\u043f\u0430\u043b\u043e\u0432\u043e",
      "longitude":73.3124907,
      "latitude":55.9476281
    },
    "8687":{
      "name":"\u041a\u043e\u0445\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":73.322726,
      "latitude":54.2740707
    },
    "8688":{
      "name":"\u041d\u043e\u0432\u043e\u0442\u0440\u043e\u0438\u0446\u043a",
      "longitude":73.3289048,
      "latitude":56.4124173
    },
    "8689":{
      "name":"\u041a\u0430\u043b\u043c\u0430\u043a\u0443\u043b\u044c",
      "longitude":73.3336405,
      "latitude":56.0336414
    },
    "8690":{
      "name":"\u0422\u0430\u0431\u043e\u0440\u044b",
      "longitude":73.3356384,
      "latitude":57.348507
    },
    "8691":{
      "name":"\u0424\u0430\u0434\u0438\u043d\u043e",
      "longitude":73.3402577,
      "latitude":54.7854882
    },
    "8692":{
      "name":"\u041f\u043b\u0430\u0445\u0438\u043d\u043e",
      "longitude":73.3568094,
      "latitude":56.3245091
    },
    "8693":{
      "name":"\u0417\u0435\u043b\u0435\u043d\u043e\u0432\u043a\u0430",
      "longitude":73.3701663,
      "latitude":55.1423265
    },
    "8694":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":73.3719663,
      "latitude":55.3222006
    },
    "8695":{
      "name":"\u0422\u0443\u0437\u0430\u043a\u043b\u044b",
      "longitude":73.3720508,
      "latitude":57.2507808
    },
    "8696":{
      "name":"\u041d\u0438\u0436\u043d\u044f\u044f \u0411\u0438\u0442\u0438\u044f",
      "longitude":73.3810929,
      "latitude":55.4848201
    },
    "8697":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u043a\u0430",
      "longitude":73.4076039,
      "latitude":54.4806059
    },
    "8698":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":73.4093173,
      "latitude":55.9066273
    },
    "8699":{
      "name":"\u041a\u0430\u043b\u0430\u0447\u0451\u0432\u043a\u0430",
      "longitude":73.4122138,
      "latitude":55.5285827
    },
    "8700":{
      "name":"\u0420\u0430\u043a\u0438\u0442\u0438\u043d\u043a\u0430",
      "longitude":73.4187504,
      "latitude":55.0994179
    },
    "8701":{
      "name":"\u041d\u0430\u0437\u0430\u0440\u043e\u0432\u043a\u0430",
      "longitude":73.4366301,
      "latitude":54.1690581
    },
    "8702":{
      "name":"\u0410\u0439\u043b\u0438\u043d\u043a\u0430",
      "longitude":73.4368578,
      "latitude":57.3538411
    },
    "8703":{
      "name":"\u0411\u0435\u0440\u0434\u043e\u0432\u043a\u0430",
      "longitude":73.4375485,
      "latitude":54.1989211
    },
    "8704":{
      "name":"\u041b\u0438\u043f\u043e\u0432\u043a\u0430",
      "longitude":73.4480873,
      "latitude":57.2328926
    },
    "8705":{
      "name":"\u0414\u0443\u0431\u0440\u0430\u0432\u0430",
      "longitude":73.4515478,
      "latitude":56.4617374
    },
    "8706":{
      "name":"\u0427\u0435\u0440\u043d\u043e\u0443\u0441\u043e\u0432\u043a\u0430",
      "longitude":73.4542815,
      "latitude":53.5707097
    },
    "8707":{
      "name":"\u0414\u0430\u0432\u044b\u0434\u043e\u0432\u043a\u0430",
      "longitude":73.4548002,
      "latitude":55.1506157
    },
    "8708":{
      "name":"\u041a\u0430\u0440\u043c\u0430\u043d\u043e\u0432\u043e",
      "longitude":73.4567967,
      "latitude":55.8111028
    },
    "8709":{
      "name":"\u0421\u0442\u0435\u043f\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":73.4575405,
      "latitude":53.8355273
    },
    "8710":{
      "name":"\u0421\u0438\u0431\u043a\u043e\u043c\u043c\u0443\u043d\u0430",
      "longitude":73.468843,
      "latitude":54.7995626
    },
    "8711":{
      "name":"\u0418\u043d\u0442\u0435\u043d\u0438\u0441",
      "longitude":73.4898877,
      "latitude":55.7752009
    },
    "8712":{
      "name":"\u0421\u0442\u0435\u043f\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":73.4956901,
      "latitude":55.7151299
    },
    "8713":{
      "name":"\u041a\u0432\u0430\u0448\u043d\u0438\u043d\u043e",
      "longitude":73.500391,
      "latitude":56.4121643
    },
    "8714":{
      "name":"\u041c\u0430\u043b\u0430\u0445\u043e\u0432\u043e",
      "longitude":73.5031551,
      "latitude":55.2531414
    },
    "8715":{
      "name":"\u041a\u043b\u0430\u0441\u0441\u0438\u043d\u043e",
      "longitude":73.503632,
      "latitude":55.31234
    },
    "8716":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u0435\u043b\u0435\u0446\u043a",
      "longitude":73.5113995,
      "latitude":54.6798341
    },
    "8717":{
      "name":"\u041b\u0435\u0432\u043e\u0431\u0435\u0440\u0435\u0436\u043d\u044b\u0439",
      "longitude":73.5301087,
      "latitude":55.009265
    },
    "8718":{
      "name":"\u041b\u0430\u043f\u0438\u043d\u043e",
      "longitude":73.5409532,
      "latitude":54.5789045
    },
    "8719":{
      "name":"\u0422\u043e\u0433\u0443\u043d\u0430\u0441",
      "longitude":73.5536859,
      "latitude":53.7734392
    },
    "8720":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u0430\u043d\u0436\u0430\u0440\u043e\u0432\u0441\u043a\u0438\u0439 \u0440\u0430\u0437\u044a\u0435\u0437\u0434",
      "longitude":73.5555902,
      "latitude":53.6999512
    },
    "8721":{
      "name":"\u041f\u0430\u0434\u044c",
      "longitude":73.5565291,
      "latitude":54.8078175
    },
    "8722":{
      "name":"\u041e\u0441\u0438\u043f\u043e\u0432\u043a\u0430",
      "longitude":73.55748,
      "latitude":55.406075
    },
    "8723":{
      "name":"\u041d\u0438\u043a\u043e\u043d\u043e\u0432\u043a\u0430",
      "longitude":73.5581674,
      "latitude":55.3711682
    },
    "8724":{
      "name":"\u041a\u043e\u0442\u043e\u0432\u0449\u0438\u043a\u043e\u0432\u043e",
      "longitude":73.5582514,
      "latitude":56.9333371
    },
    "8725":{
      "name":"\u041c\u0430\u043b\u043e\u0431\u0443\u0442\u0430\u043a\u043e\u0432\u043e",
      "longitude":73.5615246,
      "latitude":57.2143465
    },
    "8726":{
      "name":"\u041b\u043e\u0431\u043a\u043e\u0432\u043e",
      "longitude":73.5652609,
      "latitude":54.7021794
    },
    "8727":{
      "name":"\u041a\u0443\u0448\u0430\u0439\u043b\u044b",
      "longitude":73.567688,
      "latitude":55.6067871
    },
    "8728":{
      "name":"\u041a\u043e\u0433\u043e\u0442\u043e\u0432\u043e",
      "longitude":73.5722923,
      "latitude":56.5288891
    },
    "8729":{
      "name":"\u0416\u0443\u043a\u043e\u0432\u043a\u0430",
      "longitude":73.5749112,
      "latitude":53.5869797
    },
    "8730":{
      "name":"\u041e\u0440\u043b\u043e\u0432\u043a\u0430",
      "longitude":73.5817342,
      "latitude":55.9079217
    },
    "8731":{
      "name":"\u0428\u0430\u0440\u0430\u043f\u043e\u0432\u043e",
      "longitude":73.5866145,
      "latitude":56.0804674
    },
    "8732":{
      "name":"\u0417\u0430\u0433\u043e\u0442\u0437\u0435\u0440\u043d\u043e",
      "longitude":73.5926647,
      "latitude":55.6018315
    },
    "8733":{
      "name":"\u041b\u0430\u0440\u0438\u043e\u043d\u043e\u0432\u043a\u0430",
      "longitude":73.5951458,
      "latitude":57.4846057
    },
    "8734":{
      "name":"\u041c\u0430\u043b\u043e\u0447\u0435\u0440\u0435\u0434\u043e\u0432\u043e",
      "longitude":73.6021987,
      "latitude":57.2024419
    },
    "8735":{
      "name":"\u041a\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":73.6149278,
      "latitude":55.2029965
    },
    "8736":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u0438\u043d\u043e",
      "longitude":73.6208739,
      "latitude":56.9712432
    },
    "8737":{
      "name":"\u041c\u0430\u043a\u0441\u0438\u043c\u043e\u0432\u043a\u0430",
      "longitude":73.631607,
      "latitude":55.45787
    },
    "8738":{
      "name":"\u0427\u0443\u0447\u043a\u0438\u043d\u043e",
      "longitude":73.637268,
      "latitude":55.419403
    },
    "8739":{
      "name":"\u041a\u0440\u0443\u043f\u044f\u043d\u043a\u0430",
      "longitude":73.6394959,
      "latitude":55.5973633
    },
    "8740":{
      "name":"\u0412\u043b\u0430\u0434\u0438\u043c\u0438\u0440\u043e\u0432\u043a\u0430",
      "longitude":73.640518,
      "latitude":56.140335
    },
    "8741":{
      "name":"\u041f\u0430\u043b\u044c\u0446\u0435\u0432\u043a\u0430",
      "longitude":73.6420649,
      "latitude":54.4822423
    },
    "8742":{
      "name":"18 \u041f\u0430\u0440\u0442\u0441\u044a\u0435\u0437\u0434",
      "longitude":73.643478,
      "latitude":55.114075
    },
    "8743":{
      "name":"\u0413\u0443\u0441\u0442\u0430\u0444\u044c\u0435\u0432\u043e",
      "longitude":73.6550236,
      "latitude":54.9533765
    },
    "8744":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u043a\u0430",
      "longitude":73.6562896,
      "latitude":54.8571398
    },
    "8745":{
      "name":"\u0413\u043e\u043d\u0447\u0430\u0440\u043e\u0432\u043a\u0430",
      "longitude":73.6575518,
      "latitude":54.4267849
    },
    "8746":{
      "name":"\u041d\u043e\u0432\u043e\u0442\u0435\u043b\u0435\u0433\u0438\u043d\u043e",
      "longitude":73.6598938,
      "latitude":54.6476697
    },
    "8747":{
      "name":"\u0425\u0430\u043b\u0434\u0435\u0435\u0432\u043a\u0430",
      "longitude":73.6604686,
      "latitude":55.3276606
    },
    "8748":{
      "name":"\u041a\u043e\u043d\u0434\u0440\u0430\u0448\u0438\u043d\u043e",
      "longitude":73.661348,
      "latitude":57.1514226
    },
    "8749":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u043a\u0430",
      "longitude":73.6613827,
      "latitude":55.4939983
    },
    "8750":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u044c\u0441\u043a",
      "longitude":73.6690738,
      "latitude":57.0606819
    },
    "8751":{
      "name":"\u0414\u0443\u0431\u0440\u043e\u0432\u043a\u0430",
      "longitude":73.6727451,
      "latitude":55.5124277
    },
    "8752":{
      "name":"\u0422\u0440\u0435\u0449\u0435\u0442\u043a\u0438\u043d\u043e",
      "longitude":73.674271,
      "latitude":56.4713683
    },
    "8753":{
      "name":"\u041f\u0443\u0448\u043a\u0430\u0440\u0435\u0432\u043e",
      "longitude":73.6777424,
      "latitude":57.1393155
    },
    "8754":{
      "name":"\u0427\u0435\u0440\u043d\u0430\u043b\u044b",
      "longitude":74.1736882,
      "latitude":56.3226739
    },
    "8755":{
      "name":"\u041c\u0430\u043a\u0441\u0438\u043c \u0413\u043e\u0440\u044c\u043a\u0438\u0439",
      "longitude":73.6835448,
      "latitude":57.2550153
    },
    "8756":{
      "name":"\u042f\u0440\u043c\u043e\u043a\u043b\u0435\u0435\u0432\u043a\u0430",
      "longitude":73.6862843,
      "latitude":54.3340278
    },
    "8757":{
      "name":"\u042f\u043a\u0443\u0448\u0438\u043d\u043e",
      "longitude":73.7014131,
      "latitude":57.1654238
    },
    "8758":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u043e\u0440\u043e\u043b\u0451\u0432\u043a\u0430",
      "longitude":73.7038023,
      "latitude":55.3933058
    },
    "8759":{
      "name":"\u0422\u0440\u0443\u0441\u043e\u0432\u043a\u0430",
      "longitude":73.708803,
      "latitude":55.242726
    },
    "8760":{
      "name":"\u0422\u0440\u0430\u0432\u043a\u0438\u043d\u043e",
      "longitude":73.7088105,
      "latitude":54.976621
    },
    "8761":{
      "name":"\u0423\u0441\u0442\u044c-\u0417\u0430\u043e\u0441\u0442\u0440\u043e\u0432\u0441\u043a\u043e\u0435 \u041b\u0435\u0441\u043d\u0438\u0447\u0435\u0441",
      "longitude":73.7098017,
      "latitude":54.7576328
    },
    "8762":{
      "name":"2733 \u043a\u043c",
      "longitude":73.7104259,
      "latitude":54.9578754
    },
    "8763":{
      "name":"\u0422\u0430\u043c-\u0427\u0438\u043b\u0438\u043a",
      "longitude":73.7121965,
      "latitude":53.7350158
    },
    "8764":{
      "name":"\u0421\u0430\u0444\u043e\u043d\u043e\u0432\u043e",
      "longitude":73.7208504,
      "latitude":56.1860781
    },
    "8765":{
      "name":"\u0423\u0441\u0442\u044c-\u0422\u0430\u043c\u0430\u043a",
      "longitude":73.7267841,
      "latitude":57.2473941
    },
    "8766":{
      "name":"\u041f\u043e\u0433\u0440\u0430\u043d\u0438\u0447\u043d\u043e\u0435",
      "longitude":73.7303383,
      "latitude":53.8362414
    },
    "8767":{
      "name":"\u041a\u0430\u0437\u044b\u0440\u043b\u044b",
      "longitude":73.7314557,
      "latitude":55.8323093
    },
    "8768":{
      "name":"\u0422\u043e\u0441\u043a\u0438\u043d\u043e",
      "longitude":73.7372077,
      "latitude":56.62207
    },
    "8769":{
      "name":"\u0411\u043e\u0433\u043e\u0447\u0430\u043d\u043e\u0432\u043e",
      "longitude":73.7424435,
      "latitude":57.162547
    },
    "8770":{
      "name":"\u0427\u0435\u0447\u0435\u043d\u0435\u0432\u043e",
      "longitude":73.7457497,
      "latitude":56.8743065
    },
    "8771":{
      "name":"\u041d\u043e\u0432\u043e\u043e\u0431\u043e\u043b\u043e\u043d\u044c",
      "longitude":73.7509069,
      "latitude":55.5874189
    },
    "8772":{
      "name":"\u0410\u043d\u0434\u0440\u0438\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":73.7524644,
      "latitude":53.805253
    },
    "8773":{
      "name":"\u0413\u043e\u0440\u044c\u043a\u043e\u0435",
      "longitude":73.7617988,
      "latitude":56.0100456
    },
    "8774":{
      "name":"2737 \u043a\u043c",
      "longitude":73.7636858,
      "latitude":54.9645746
    },
    "8775":{
      "name":"\u0412\u043f\u0435\u0440\u0435\u0434",
      "longitude":73.763821,
      "latitude":55.0898296
    },
    "8776":{
      "name":"\u0427\u0435\u0440\u043d\u044b\u0448\u0435\u0435\u0432\u043a\u0430",
      "longitude":73.7667227,
      "latitude":55.532859
    },
    "8777":{
      "name":"\u0415\u0433\u043e\u0440\u044c\u0435\u0432\u043a\u0430",
      "longitude":73.7698741,
      "latitude":55.1693145
    },
    "8778":{
      "name":"\u0417\u0435\u043b\u0451\u043d\u0430\u044f \u0420\u043e\u0449\u0430",
      "longitude":73.7728306,
      "latitude":54.9275446
    },
    "8779":{
      "name":"\u042f\u043b\u0430\u043d\u043a\u0443\u043b\u044c",
      "longitude":73.7764229,
      "latitude":56.1144986
    },
    "8780":{
      "name":"\u041d\u0438\u0432\u0430",
      "longitude":73.7812887,
      "latitude":54.7516814
    },
    "8781":{
      "name":"\u041a\u0438\u0440\u0438\u043b\u043b\u0438\u043d\u043e",
      "longitude":73.7827239,
      "latitude":56.8845326
    },
    "8782":{
      "name":"\u041a\u0430\u0439\u0434\u0430\u0443\u043b",
      "longitude":73.7875352,
      "latitude":54.1348671
    },
    "8783":{
      "name":"\u041e\u0437\u0451\u0440\u043d\u043e\u0435",
      "longitude":73.7885511,
      "latitude":53.9264369
    },
    "8784":{
      "name":"\u0429\u0435\u0440\u0431\u0430\u043a\u043e\u0432\u043e",
      "longitude":73.7906992,
      "latitude":57.0689109
    },
    "8785":{
      "name":"\u0421\u043e\u043b\u0434\u0430\u0442\u043a\u0430",
      "longitude":73.7917159,
      "latitude":57.1495482
    },
    "8786":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":73.7920689,
      "latitude":55.5028225
    },
    "8787":{
      "name":"\u0421\u0438\u0431\u041d\u0418\u0412\u0418",
      "longitude":73.7924932,
      "latitude":55.0771597
    },
    "8788":{
      "name":"\u0420\u0430\u0437\u0432\u044f\u0437\u043a\u0430",
      "longitude":73.7945552,
      "latitude":54.9821851
    },
    "8789":{
      "name":"\u0412\u043e\u0440\u043e\u043d\u043e\u0432\u043a\u0430",
      "longitude":73.7978063,
      "latitude":56.4573594
    },
    "8790":{
      "name":"\u041a\u0440\u0443\u0442\u0438\u0445\u0430",
      "longitude":73.8050028,
      "latitude":55.5998041
    },
    "8791":{
      "name":"\u041d\u0435\u0432\u043e\u043b\u044c\u043d\u043e\u0435",
      "longitude":73.8069657,
      "latitude":53.7257936
    },
    "8792":{
      "name":"\u041d\u043e\u0432\u043e\u0438\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":73.81005,
      "latitude":53.7931777
    },
    "8793":{
      "name":"\u0417\u0430\u0433\u043e\u0442\u0437\u0435\u0440\u043d\u043e (\u041f\u0440\u0438\u0441\u0442\u0430\u043d\u044c)",
      "longitude":73.8132652,
      "latitude":57.1504302
    },
    "8794":{
      "name":"\u041f\u0440\u0443\u0434\u043a\u0438",
      "longitude":73.8157157,
      "latitude":55.030271
    },
    "8795":{
      "name":"\u0422\u0438\u043c\u0438\u043d\u043e",
      "longitude":73.8287951,
      "latitude":56.9415182
    },
    "8796":{
      "name":"\u041d\u043e\u0432\u043e\u043b\u044e\u0431\u043b\u0438\u043d\u043a\u0430",
      "longitude":74.1736592,
      "latitude":54.1406376
    },
    "8797":{
      "name":"\u0421\u0442\u0435\u043f\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":73.8305264,
      "latitude":55.207208
    },
    "8798":{
      "name":"\u0410\u043a\u0441\u0430\u043a\u043e\u0432\u043a\u0430",
      "longitude":73.8429024,
      "latitude":54.9136717
    },
    "8799":{
      "name":"\u041a\u043e\u043d\u0441\u0442\u0430\u043d\u0442\u0438\u043d\u043e\u0433\u0440\u0430\u0434\u043a\u0430",
      "longitude":73.8472486,
      "latitude":54.2004865
    },
    "8800":{
      "name":"\u0421\u044b\u0440\u043e\u043f\u044f\u0442\u0441\u043a\u0430\u044f",
      "longitude":73.84903,
      "latitude":55.039452
    },
    "8801":{
      "name":"\u0410\u0433\u0430\u0444\u043e\u043d\u043e\u0432\u043a\u0430",
      "longitude":73.862755,
      "latitude":55.525421
    },
    "8802":{
      "name":"\u0421\u044b\u0440\u043e\u043f\u044f\u0442\u0441\u043a\u043e\u0435",
      "longitude":73.864838,
      "latitude":54.975552
    },
    "8803":{
      "name":"\u0420\u0443\u0441\u0441\u043a\u0430\u044f \u041f\u043e\u043b\u044f\u043d\u0430",
      "longitude":73.8716552,
      "latitude":53.7563372
    },
    "8804":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0435\u043d\u043a\u043e",
      "longitude":73.8719225,
      "latitude":54.7942562
    },
    "8805":{
      "name":"\u041d\u043e\u0432\u0430\u044f",
      "longitude":73.891784,
      "latitude":54.842881
    },
    "8806":{
      "name":"\u0420\u0443\u0441\u0438\u043d\u043e\u0432\u043e",
      "longitude":73.9068611,
      "latitude":55.8871891
    },
    "8807":{
      "name":"\u0421\u043e\u0441\u043d\u043e\u0432\u043a\u0430",
      "longitude":73.9070321,
      "latitude":55.637082
    },
    "8808":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u041a\u043e\u0432\u0430",
      "longitude":73.9100406,
      "latitude":57.1695206
    },
    "8809":{
      "name":"\u041a\u0430\u043c\u044b\u0448\u0438\u043d\u043e",
      "longitude":73.9175269,
      "latitude":54.1428311
    },
    "8810":{
      "name":"\u0422\u043e\u043f\u043e\u043b\u044c\u043a\u0438",
      "longitude":73.918985,
      "latitude":54.3968751
    },
    "8811":{
      "name":"\u0428\u043a\u0443\u043d\u043e\u0432\u043e",
      "longitude":73.9289504,
      "latitude":56.8296842
    },
    "8812":{
      "name":"\u0411\u0443\u0437\u0430\u043d",
      "longitude":73.936813,
      "latitude":53.93095
    },
    "8813":{
      "name":"\u041a\u0438\u0440\u0438\u0431\u0430\u0439",
      "longitude":73.9446094,
      "latitude":54.2845935
    },
    "8814":{
      "name":"\u041a\u0430\u0431\u0443\u0440\u043b\u044b",
      "longitude":73.9449188,
      "latitude":56.2082154
    },
    "8815":{
      "name":"\u0421\u043c\u0438\u0440\u043d\u043e\u0432\u043a\u0430",
      "longitude":73.9481523,
      "latitude":54.7770608
    },
    "8816":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0435\u0442\u0435\u0440\u0435\u0445\u0438\u043d\u043e",
      "longitude":73.9485914,
      "latitude":56.6084843
    },
    "8817":{
      "name":"\u0421\u0442\u0430\u043d\u043a\u0435\u0435\u0432\u043a\u0430",
      "longitude":73.9509995,
      "latitude":54.9289383
    },
    "8818":{
      "name":"\u0427\u0435\u0440\u043d\u043e\u0432\u043e",
      "longitude":73.9513459,
      "latitude":55.8423071
    },
    "8819":{
      "name":"\u041a\u0443\u0431\u0440\u0438\u043d\u043e",
      "longitude":73.9524434,
      "latitude":56.8643439
    },
    "8820":{
      "name":"\u0427\u0438\u0441\u0442\u043e\u043e\u0437\u0451\u0440\u044c\u0435",
      "longitude":73.9566674,
      "latitude":55.8072078
    },
    "8821":{
      "name":"\u041a\u043e\u0440\u043d\u0438\u043b\u043e\u0432\u043a\u0430",
      "longitude":73.9583772,
      "latitude":55.0233761
    },
    "8822":{
      "name":"\u0421\u043e\u043b\u043e\u043d\u043e\u0432\u043a\u0430",
      "longitude":73.9667855,
      "latitude":54.5831193
    },
    "8823":{
      "name":"\u0411\u0430\u0439\u043a\u0430\u043b",
      "longitude":73.966881,
      "latitude":55.09428
    },
    "8824":{
      "name":"\u0414\u0443\u0431\u0440\u043e\u0432\u043a\u0430",
      "longitude":73.9682161,
      "latitude":55.1450474
    },
    "8825":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":73.985104,
      "latitude":56.8840898
    },
    "8826":{
      "name":"\u0427\u0435\u0440\u043d\u043e\u043e\u0437\u0451\u0440\u044c\u0435",
      "longitude":73.9866818,
      "latitude":55.7422712
    },
    "8827":{
      "name":"\u0410\u043a\u0441\u0435\u043d\u043e\u0432\u043a\u0430",
      "longitude":73.9972539,
      "latitude":55.4506656
    },
    "8828":{
      "name":"\u041a\u043e\u043d\u043e\u0432\u0430\u043b\u043e\u0432\u043e",
      "longitude":74.0007646,
      "latitude":56.8066988
    },
    "8829":{
      "name":"\u041c\u0430\u043b\u044b\u0435 \u0422\u0443\u0440\u0430\u043b\u044b",
      "longitude":74.0045978,
      "latitude":56.736327
    },
    "8830":{
      "name":"\u0423\u0432\u0430\u0440\u043e\u0432\u043a\u0430",
      "longitude":74.0080399,
      "latitude":56.0066386
    },
    "8831":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u0434\u0430\u0440\u043a\u0430",
      "longitude":74.0224153,
      "latitude":54.251924
    },
    "8832":{
      "name":"\u0421\u0435\u0432\u0435\u0440\u043d\u0430\u044f",
      "longitude":74.0357143,
      "latitude":55.5764036
    },
    "8833":{
      "name":"\u041f\u043b\u043e\u0442\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":74.0398182,
      "latitude":56.3569136
    },
    "8834":{
      "name":"\u041c\u0438\u0445\u0435\u0435\u0432\u043a\u0430",
      "longitude":74.0403082,
      "latitude":55.1110144
    },
    "8835":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u0414\u0435\u0440\u0435\u0432\u043d\u044f",
      "longitude":74.0433421,
      "latitude":54.9787357
    },
    "8836":{
      "name":"\u0420\u043e\u0437\u043e\u0432\u043a\u0430",
      "longitude":74.0444856,
      "latitude":53.8483412
    },
    "8837":{
      "name":"\u0412\u043e\u043b\u043e\u0442\u043e\u0432\u043a\u0430",
      "longitude":74.0459422,
      "latitude":53.812178
    },
    "8838":{
      "name":"\u041a\u043e\u043c\u0441\u043e\u043c\u043e\u043b",
      "longitude":74.045946,
      "latitude":54.6455773
    },
    "8839":{
      "name":"\u041f\u043e\u043c\u043e\u0440\u0446\u0435\u0432\u043e",
      "longitude":74.051181,
      "latitude":56.6522899
    },
    "8840":{
      "name":"\u041c\u0430\u043c\u0435\u0448\u0435\u0432\u043e",
      "longitude":74.0545954,
      "latitude":57.0933602
    },
    "8841":{
      "name":"\u0421\u0430\u043b\u0442\u044b\u043a\u043e\u0432\u043a\u0430",
      "longitude":74.0637443,
      "latitude":54.9090423
    },
    "8842":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0435 \u041e\u0437\u0435\u0440\u043e",
      "longitude":74.0662769,
      "latitude":55.2495674
    },
    "8843":{
      "name":"\u0421\u0432\u0438\u0434\u0435\u0440\u0441\u043a",
      "longitude":74.0685004,
      "latitude":56.6742756
    },
    "8844":{
      "name":"\u041c\u044f\u0441\u043d\u0438\u043a\u0438",
      "longitude":74.0814219,
      "latitude":56.2608217
    },
    "8845":{
      "name":"\u0421\u043f\u0430\u0439\u043a\u0430",
      "longitude":74.0922126,
      "latitude":54.715241
    },
    "8846":{
      "name":"\u041d\u0438\u043a\u0438\u0442\u0438\u043d\u043e",
      "longitude":74.0942919,
      "latitude":55.0322407
    },
    "8847":{
      "name":"\u041a\u0430\u0440\u0430\u043a\u0443\u043b\u044c",
      "longitude":74.0956932,
      "latitude":56.3171489
    },
    "8848":{
      "name":"\u041a\u0443\u0440\u043c\u0430\u043d\u043e\u0432\u043e",
      "longitude":74.098016,
      "latitude":57.0197041
    },
    "8849":{
      "name":"\u0421\u043e\u0441\u043d\u043e\u0432\u043a\u0430",
      "longitude":74.1011628,
      "latitude":54.497044
    },
    "8850":{
      "name":"\u0421\u0438\u0431\u0438\u043b\u044f\u043a\u043e\u0432\u043e",
      "longitude":74.1044723,
      "latitude":57.0341891
    },
    "8851":{
      "name":"\u042e\u0440\u043b\u0430\u0433\u0438\u043d\u043e",
      "longitude":74.1044988,
      "latitude":56.9978442
    },
    "8852":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0438\u0435 \u041a\u0443\u0447\u043a\u0438",
      "longitude":74.1102487,
      "latitude":56.7131314
    },
    "8853":{
      "name":"\u0421\u0443\u0445\u043e\u043a\u0430\u0440\u0430\u0441\u0443\u043a",
      "longitude":74.113686,
      "latitude":56.0835434
    },
    "8854":{
      "name":"\u041f\u044f\u0442\u0438\u043b\u0435\u0442\u043a\u0430",
      "longitude":74.115321,
      "latitude":57.1319213
    },
    "8855":{
      "name":"\u041a\u043e\u043f\u0435\u0439\u043a\u0438\u043d\u043e",
      "longitude":74.1200787,
      "latitude":56.9812223
    },
    "8856":{
      "name":"\u041b\u044e\u0431\u0438\u043c\u043e\u0432\u043e",
      "longitude":74.1237666,
      "latitude":56.7028264
    },
    "8857":{
      "name":"\u041d\u043e\u0432\u043e\u0440\u043e\u0441\u0441\u0438\u0439\u043a\u0430",
      "longitude":74.1255673,
      "latitude":54.8390925
    },
    "8858":{
      "name":"\u041e\u0442\u0434\u0435\u043b\u0435\u043d\u0438\u0435 \u2116 4 \u041e\u043f\u044b\u0442\u043d\u043e\u0433\u043e \u0425\u043e\u0437\u044f",
      "longitude":74.1417909,
      "latitude":54.2984185
    },
    "8859":{
      "name":"\u0421\u0430\u0440\u0430\u0442\u043e\u0432\u043e",
      "longitude":74.1480447,
      "latitude":55.7015585
    },
    "8860":{
      "name":"\u0421\u043f\u0430\u0441\u0441\u043a\u043e\u0435",
      "longitude":74.1550607,
      "latitude":55.2157108
    },
    "8861":{
      "name":"\u041a\u0443\u0439\u0433\u0430\u043b\u044b",
      "longitude":74.1600423,
      "latitude":56.2197297
    },
    "8862":{
      "name":"\u0418\u0441\u0430\u0435\u0432\u043a\u0430",
      "longitude":74.1616318,
      "latitude":55.3054178
    },
    "8863":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u0432\u043e",
      "longitude":74.1760327,
      "latitude":56.9560822
    },
    "8864":{
      "name":"\u0412\u044f\u0436\u0435\u0432\u043a\u0430",
      "longitude":74.17896,
      "latitude":55.3808911
    },
    "8865":{
      "name":"\u0423\u0441\u0442\u044e\u0433\u043e\u0432\u043e",
      "longitude":74.1848145,
      "latitude":56.5775488
    },
    "8866":{
      "name":"\u0422\u0438\u043c\u0438\u0440\u043a\u0430",
      "longitude":74.1976267,
      "latitude":57.2059813
    },
    "8867":{
      "name":"\u0421\u0430\u043c\u0430\u0440\u0438\u043d\u043a\u0430",
      "longitude":74.2000143,
      "latitude":55.0506391
    },
    "8868":{
      "name":"\u0418\u0433\u043d\u0430\u0442\u044c\u0435\u0432\u043e",
      "longitude":74.2023866,
      "latitude":55.0574249
    },
    "8869":{
      "name":"\u0417\u043e\u043b\u043e\u0442\u0443\u0445\u0438\u043d\u043e",
      "longitude":74.2129895,
      "latitude":54.2077815
    },
    "8870":{
      "name":"\u0421\u0435\u0438\u0442\u043e\u0432\u043e",
      "longitude":74.214554,
      "latitude":56.9986987
    },
    "8871":{
      "name":"\u0414\u043e\u0431\u0440\u043e\u043b\u044e\u0431\u043e\u0432\u043a\u0430",
      "longitude":74.2195309,
      "latitude":56.1202242
    },
    "8872":{
      "name":"2767 \u043a\u043c",
      "longitude":74.2286448,
      "latitude":55.0115052
    },
    "8873":{
      "name":"\u041c\u043e\u0445\u043e\u0432\u043e\u0435 \u041e\u0437\u0435\u0440\u043e",
      "longitude":74.2298354,
      "latitude":55.9311853
    },
    "8874":{
      "name":"\u041b\u043e\u0441\u043a\u0443\u0442\u043e\u0432\u043e",
      "longitude":74.230639,
      "latitude":56.8719578
    },
    "8875":{
      "name":"\u0417\u043e\u0442\u0438\u043d\u043e",
      "longitude":74.2386674,
      "latitude":55.0689399
    },
    "8876":{
      "name":"\u0421\u043e\u0433\u0440\u0430",
      "longitude":74.2403393,
      "latitude":55.7125465
    },
    "8877":{
      "name":"1-\u044f \u0424\u043e\u043c\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":74.2598837,
      "latitude":54.832271
    },
    "8878":{
      "name":"\u041d\u043e\u0432\u043e\u044e\u0440\u044c\u0435\u0432\u043e",
      "longitude":74.2630931,
      "latitude":55.2429333
    },
    "8879":{
      "name":"\u041a\u043e\u043b\u044c\u0446\u043e\u0432\u043e",
      "longitude":74.276195,
      "latitude":55.1545612
    },
    "8880":{
      "name":"\u041a\u0440\u0443\u0433\u043b\u043e\u0432\u043e",
      "longitude":74.2782922,
      "latitude":55.1341414
    },
    "8881":{
      "name":"\u041a\u0430\u0440\u0430\u0442\u0430\u043b",
      "longitude":74.2843972,
      "latitude":53.9923207
    },
    "8882":{
      "name":"2771 \u043a\u043c",
      "longitude":74.2874807,
      "latitude":55.0153176
    },
    "8883":{
      "name":"\u0411\u043e\u0440\u043e\u0432\u044f\u043d\u043a\u0430",
      "longitude":74.2887062,
      "latitude":55.7337577
    },
    "8884":{
      "name":"\u0410\u044d\u0440\u043e\u043f\u043e\u0440\u0442",
      "longitude":74.2887865,
      "latitude":56.9049183
    },
    "8885":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u0430\u044f \u0422\u0443\u043b\u0430",
      "longitude":74.2949224,
      "latitude":54.6422345
    },
    "8886":{
      "name":"\u0413\u0440\u0438\u043d\u0435\u0432\u0438\u0447\u0438",
      "longitude":74.299711,
      "latitude":57.3016821
    },
    "8887":{
      "name":"\u041f\u0440\u0438\u0433\u043e\u0440\u043e\u0434\u043d\u043e\u0435 \u0422\u0430\u0440\u0441\u043a\u043e\u0435 \u041b\u0435\u0441\u043d\u0438\u0447",
      "longitude":74.304038,
      "latitude":56.8894671
    },
    "8888":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":74.3046273,
      "latitude":54.9137531
    },
    "8889":{
      "name":"\u041a\u043e\u0448\u043a\u0443\u043b\u044c",
      "longitude":74.3046364,
      "latitude":56.4998757
    },
    "8890":{
      "name":"\u041f\u043e\u0431\u0435\u0434\u0430",
      "longitude":74.3111998,
      "latitude":54.5032132
    },
    "8891":{
      "name":"\u041c\u0438\u043b\u0438\u043d\u043e",
      "longitude":74.3245896,
      "latitude":55.8432485
    },
    "8892":{
      "name":"\u0422\u0443\u0441\u043a\u0430\u0437\u0430\u043d\u044c",
      "longitude":74.3286633,
      "latitude":56.3694119
    },
    "8893":{
      "name":"\u041a\u0440\u0430\u043f\u0438\u0432\u043a\u0430",
      "longitude":74.3316582,
      "latitude":57.0823298
    },
    "8894":{
      "name":"\u041a\u0430\u0440\u0430\u0441\u0451\u0432\u043e",
      "longitude":74.332675,
      "latitude":55.3111173
    },
    "8895":{
      "name":"\u041f\u043e\u0434\u043e\u043b\u044c\u0441\u043a",
      "longitude":74.3474203,
      "latitude":55.5184318
    },
    "8896":{
      "name":"\u041e\u0441\u043e\u043a\u0438\u043d\u043e",
      "longitude":74.3573382,
      "latitude":55.0242153
    },
    "8897":{
      "name":"\u041e\u0441\u043e\u043a\u0438\u043d\u043e",
      "longitude":74.3578513,
      "latitude":55.0230685
    },
    "8898":{
      "name":"\u0411\u0430\u043b\u0430\u043d\u0434\u0438\u043d\u043e",
      "longitude":74.3622407,
      "latitude":54.4231346
    },
    "8899":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":74.5283844,
      "latitude":56.3683799
    },
    "8900":{
      "name":"\u0415\u0444\u0438\u043c\u043e\u0432\u043a\u0430",
      "longitude":74.3637663,
      "latitude":54.7579033
    },
    "8901":{
      "name":"\u0418\u0448\u0435\u0435\u0432\u043e",
      "longitude":74.3669638,
      "latitude":57.0799333
    },
    "8902":{
      "name":"\u0410\u0440\u0445\u0438\u043f\u043e\u0432\u043a\u0430",
      "longitude":74.3733012,
      "latitude":55.0602556
    },
    "8903":{
      "name":"\u0411\u044b\u0433\u0430\u043d",
      "longitude":74.377571,
      "latitude":57.269791
    },
    "8904":{
      "name":"\u0420\u043e\u0441\u0442\u043e\u0432\u043a\u0430",
      "longitude":74.3814185,
      "latitude":55.8012721
    },
    "8905":{
      "name":"\u041a\u0438\u0440\u0441\u0430\u043d\u043e\u0432\u043e",
      "longitude":74.3877412,
      "latitude":55.2658277
    },
    "8906":{
      "name":"\u041c\u043e\u043b\u043e\u0434\u0451\u0436\u043d\u043e\u0435",
      "longitude":74.392986,
      "latitude":54.0495347
    },
    "8907":{
      "name":"\u0413\u043e\u043b\u0443\u0431\u043e\u0432\u043a\u0430",
      "longitude":74.3993673,
      "latitude":53.4950108
    },
    "8908":{
      "name":"\u0421\u0442\u0435\u043f\u043d\u043e\u0435",
      "longitude":74.400963,
      "latitude":53.7883525
    },
    "8909":{
      "name":"\u041d\u0435\u0442\u0435\u0441\u043e\u0432\u043e",
      "longitude":74.4080995,
      "latitude":54.2341235
    },
    "8910":{
      "name":"\u041d\u043e\u0432\u043e\u0438\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":74.4107121,
      "latitude":54.3898775
    },
    "8911":{
      "name":"\u041a\u043e\u0440\u0448\u0443\u043d\u043e\u0432\u043e",
      "longitude":74.4151293,
      "latitude":56.449317
    },
    "8912":{
      "name":"\u0421\u043e\u0432\u0435\u0442\u0441\u043a\u0430\u044f \u041a\u0440\u0435\u0441\u0442\u044c\u044f\u043d\u043a\u0430",
      "longitude":74.4157243,
      "latitude":56.6968457
    },
    "8913":{
      "name":"\u0421\u043e\u0441\u043d\u0438\u043d\u043e",
      "longitude":74.4169431,
      "latitude":55.4344721
    },
    "8914":{
      "name":"\u0418\u0441\u0430\u043a\u043e\u0432\u043a\u0430",
      "longitude":74.4207243,
      "latitude":55.7453635
    },
    "8915":{
      "name":"\u0422\u0438\u043c\u0448\u0438\u043d\u044f\u043a\u043e\u0432\u043e",
      "longitude":74.4407666,
      "latitude":56.9413059
    },
    "8916":{
      "name":"\u041b\u044e\u0431\u043e\u0432\u043a\u0430",
      "longitude":74.444901,
      "latitude":54.160095
    },
    "8917":{
      "name":"\u042f\u043a\u043e\u0432\u043b\u0435\u0432\u043a\u0430",
      "longitude":74.4528312,
      "latitude":55.3996996
    },
    "8918":{
      "name":"\u041b\u044e\u0431\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":74.4529199,
      "latitude":54.1493763
    },
    "8919":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u041e\u0432\u0446\u0435\u0432\u043e\u0434",
      "longitude":74.4544157,
      "latitude":54.5780832
    },
    "8920":{
      "name":"\u0412\u0435\u0441\u0451\u043b\u044b\u0439",
      "longitude":74.4556241,
      "latitude":55.3058138
    },
    "8921":{
      "name":"\u041b\u043e\u0433\u0443\u043d\u043e\u0432\u043a\u0430",
      "longitude":74.4569127,
      "latitude":53.8634132
    },
    "8922":{
      "name":"\u041a\u0443\u043b\u0438\u043a\u043e\u0432\u043e",
      "longitude":74.4595933,
      "latitude":55.0630865
    },
    "8923":{
      "name":"\u041d\u0435\u0440\u043f\u0438\u043d\u0441\u043a\u0438\u0439 \u041a\u043e\u0440\u0434\u043e\u043d",
      "longitude":74.4598264,
      "latitude":56.9510658
    },
    "8924":{
      "name":"\u0413\u043e\u0440\u043e\u0448\u0438\u043d\u043e",
      "longitude":74.4683811,
      "latitude":54.8798459
    },
    "8925":{
      "name":"2783 \u043a\u043c",
      "longitude":74.470954,
      "latitude":55.0337684
    },
    "8926":{
      "name":"\u041e\u0441\u0438\u0445\u0438\u043d\u043e",
      "longitude":74.4710581,
      "latitude":56.1147894
    },
    "8927":{
      "name":"\u041f\u0438\u0445\u0442\u043e\u0432\u043e\u0435",
      "longitude":74.4836513,
      "latitude":57.467347
    },
    "8928":{
      "name":"\u041a\u0440\u0438\u0432\u043e\u0434\u0430\u043d\u043e\u0432\u043e",
      "longitude":74.487263,
      "latitude":56.1737924
    },
    "8929":{
      "name":"\u041a\u0440\u0443\u043f\u0441\u043a\u043e\u0435",
      "longitude":74.4911056,
      "latitude":54.4666948
    },
    "8930":{
      "name":"\u041d\u043e\u0432\u043e\u0438\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":74.4991821,
      "latitude":55.565715
    },
    "8931":{
      "name":"\u0410\u0440\u0445\u0430\u043d\u0433\u0435\u043b\u043a\u0430",
      "longitude":74.5075083,
      "latitude":55.0678892
    },
    "8932":{
      "name":"\u0411\u0435\u0449\u0430\u0443\u043b",
      "longitude":74.512016,
      "latitude":55.831635
    },
    "8933":{
      "name":"\u041a\u043e\u0440\u0435\u043d\u0435\u0432\u043e",
      "longitude":74.515646,
      "latitude":56.7510991
    },
    "8934":{
      "name":"\u0416\u0430\u0440\u0430\u0433\u0430\u0447",
      "longitude":74.5156733,
      "latitude":54.3662037
    },
    "8935":{
      "name":"\u0415\u0440\u043c\u0430\u043a",
      "longitude":74.5164882,
      "latitude":55.1776577
    },
    "8936":{
      "name":"\u0411\u043e\u0440\u043e\u0434\u0438\u0445\u0438\u043d\u043e",
      "longitude":74.5166476,
      "latitude":56.741001
    },
    "8937":{
      "name":"2786 \u043a\u043c",
      "longitude":74.5178871,
      "latitude":55.0383206
    },
    "8938":{
      "name":"\u041a\u0438\u0431\u0435\u0440-\u0421\u043f\u0430\u0441\u0441\u043a\u043e\u0435",
      "longitude":74.5190125,
      "latitude":55.2031779
    },
    "8939":{
      "name":"\u0411\u043b\u0430\u0433\u043e\u0432\u0435\u0449\u0435\u043d\u043a\u0430",
      "longitude":74.5267263,
      "latitude":54.7387326
    },
    "8940":{
      "name":"\u0427\u0443\u043b\u0438\u043d\u043e",
      "longitude":74.5353164,
      "latitude":55.297949
    },
    "8941":{
      "name":"\u0420\u043e\u0436\u0434\u0435\u0441\u0442\u0432\u0435\u043d\u043a\u0430",
      "longitude":74.5429083,
      "latitude":55.5533918
    },
    "8942":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0435\u043c\u0443\u0440\u043b\u044b",
      "longitude":74.5510481,
      "latitude":55.9299703
    },
    "8943":{
      "name":"\u041b\u0435\u0441\u043d\u043e\u0439",
      "longitude":74.5514784,
      "latitude":55.5887455
    },
    "8944":{
      "name":"\u0421\u0438\u0434\u043e\u0440\u043e\u0432\u043a\u0430",
      "longitude":74.556853,
      "latitude":55.7212165
    },
    "8945":{
      "name":"\u0411\u0435\u0437\u044b\u043c\u044f\u043d\u043d\u0430\u044f",
      "longitude":74.5581348,
      "latitude":56.1330307
    },
    "8946":{
      "name":"\u041a\u0430\u043b\u0430\u0447\u0438\u043d\u0441\u043a\u0430\u044f",
      "longitude":74.5691311,
      "latitude":55.2564239
    },
    "8947":{
      "name":"\u041c\u043e\u0438\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":74.5706908,
      "latitude":53.9331617
    },
    "8948":{
      "name":"\u0421\u0435\u043a\u043c\u0435\u043d\u0435\u0432\u043e",
      "longitude":74.5717008,
      "latitude":56.6108666
    },
    "8949":{
      "name":"\u0411\u0435\u0440\u043d\u044f\u0436\u043a\u0430",
      "longitude":74.5729369,
      "latitude":56.6232882
    },
    "8950":{
      "name":"\u041a\u0438\u0440\u0441\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":74.5746647,
      "latitude":56.0416453
    },
    "8951":{
      "name":"\u0420\u043e\u0437\u0435\u043d\u0442\u0430\u043b\u044c",
      "longitude":74.591141,
      "latitude":54.61356
    },
    "8952":{
      "name":"\u0410\u0442\u0430\u0447\u043a\u0430",
      "longitude":74.593212,
      "latitude":56.7932054
    },
    "8953":{
      "name":"\u041d\u043e\u0432\u043e\u0435 \u0421\u0435\u043b\u043e",
      "longitude":74.594113,
      "latitude":54.9704455
    },
    "8954":{
      "name":"\u041f\u0438\u0447\u0443\u0433\u0438\u043d\u043e",
      "longitude":74.5953692,
      "latitude":53.7635395
    },
    "8955":{
      "name":"\u0421\u0438\u0434\u043e\u0440\u043e\u0432\u043a\u0430",
      "longitude":74.6010801,
      "latitude":57.0098162
    },
    "8956":{
      "name":"\u0425\u0443\u0442\u043e\u0440\u0430",
      "longitude":74.6066748,
      "latitude":55.8782017
    },
    "8957":{
      "name":"\u041a\u0438\u0440\u0433\u0430\u043f",
      "longitude":74.6149022,
      "latitude":56.7191244
    },
    "8958":{
      "name":"\u0422\u0430\u043b\u0430\u043f\u043a\u0435\u0440",
      "longitude":74.6198378,
      "latitude":54.0614687
    },
    "8959":{
      "name":"\u0420\u0430\u0441\u0441\u043e\u0445\u0438\u043d\u043e",
      "longitude":74.6205928,
      "latitude":54.241355
    },
    "8960":{
      "name":"\u041d\u043e\u0432\u043e\u043c\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":74.6206405,
      "latitude":55.8192803
    },
    "8961":{
      "name":"\u0411\u044b\u0437\u043e\u0432\u043a\u0430",
      "longitude":74.626191,
      "latitude":56.206908
    },
    "8962":{
      "name":"\u041a\u0430\u0431\u0443\u0440\u043b\u044b",
      "longitude":74.6314862,
      "latitude":55.3735605
    },
    "8963":{
      "name":"\u0422\u0435\u0440\u0435\u0445\u043e\u0432\u043e",
      "longitude":74.6325488,
      "latitude":56.5526327
    },
    "8964":{
      "name":"\u041f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":74.632899,
      "latitude":55.7849752
    },
    "8965":{
      "name":"\u0413\u0443\u0449\u0438\u043d\u043e",
      "longitude":74.6434522,
      "latitude":56.0137392
    },
    "8966":{
      "name":"\u041a\u044b\u0437\u044b\u043b\u0442\u0430\u043d",
      "longitude":74.6509983,
      "latitude":53.8305554
    },
    "8967":{
      "name":"\u0428\u0443\u0435\u0432\u043e",
      "longitude":74.6547254,
      "latitude":56.5283654
    },
    "8968":{
      "name":"\u0412\u043e\u0441\u043a\u0440\u0435\u0441\u0435\u043d\u043a\u0430",
      "longitude":74.6569731,
      "latitude":54.6038049
    },
    "8969":{
      "name":"\u041f\u0430\u0432\u043b\u043e\u0432\u043a\u0430",
      "longitude":74.6571961,
      "latitude":54.8406878
    },
    "8970":{
      "name":"\u041a\u043e\u0447\u043a\u043e\u0432\u0430\u0442\u043e\u0435",
      "longitude":74.6604283,
      "latitude":54.7517355
    },
    "8971":{
      "name":"\u041a\u0438\u043a\u0441\u044b",
      "longitude":74.6609466,
      "latitude":57.3315929
    },
    "8972":{
      "name":"\u041a\u043e\u043b\u0431\u044b\u0448\u0435\u0432\u043e",
      "longitude":74.6667662,
      "latitude":56.4535749
    },
    "8973":{
      "name":"\u041b\u044e\u0431\u0438\u043c\u043e\u0432\u043a\u0430",
      "longitude":74.6729246,
      "latitude":55.5058567
    },
    "8974":{
      "name":"\u041f\u043b\u0430\u0442\u043e\u043d\u043e\u0432\u043a\u0430",
      "longitude":74.6739021,
      "latitude":53.8795231
    },
    "8975":{
      "name":"\u041f\u043e\u0434\u043b\u0435\u0441\u043d\u043e\u0435",
      "longitude":74.6747443,
      "latitude":54.354481
    },
    "8976":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0435\u043c\u0438\u0442\u044c\u043a\u0438\u043d\u043e",
      "longitude":74.6748182,
      "latitude":55.3023807
    },
    "8977":{
      "name":"\u0421\u0443\u0432\u043e\u0440\u043e\u0432\u043a\u0430",
      "longitude":74.6806492,
      "latitude":54.473346
    },
    "8978":{
      "name":"\u041f\u0443\u0441\u0442\u044b\u043d\u043d\u043e\u0435",
      "longitude":74.6834391,
      "latitude":55.9390554
    },
    "8979":{
      "name":"\u041c\u0435\u0448\u043a\u043e\u0432\u043e",
      "longitude":74.6851226,
      "latitude":56.4061093
    },
    "8980":{
      "name":"\u041d\u043e\u0432\u043e\u0433\u0440\u0430\u0434\u043a\u0430",
      "longitude":74.6862393,
      "latitude":54.6164108
    },
    "8981":{
      "name":"\u0411\u043e\u0431\u0440\u043e\u0432\u043a\u0430",
      "longitude":74.6894105,
      "latitude":57.1493578
    },
    "8982":{
      "name":"\u041e\u0442\u0440\u0430\u0434\u043d\u043e\u0432\u043a\u0430",
      "longitude":74.6947027,
      "latitude":55.8002716
    },
    "8983":{
      "name":"2797 \u043a\u043c",
      "longitude":74.696414,
      "latitude":55.058866
    },
    "8984":{
      "name":"\u0425\u043b\u0435\u0431\u043e\u043f\u0440\u0438\u0435\u043c\u043d\u044b\u0439 \u041f\u0443\u043d\u043a\u0442",
      "longitude":74.7001487,
      "latitude":56.3343211
    },
    "8985":{
      "name":"\u0411\u043e\u0440\u0438\u0441\u043e\u0432\u043a\u0430",
      "longitude":74.7144658,
      "latitude":55.8793755
    },
    "8986":{
      "name":"\u041b\u0430\u0432\u0440\u0438\u043d\u043e",
      "longitude":74.73661,
      "latitude":55.3849393
    },
    "8987":{
      "name":"\u0420\u043e\u0434\u043d\u0438\u0447\u043a\u0438",
      "longitude":74.7422166,
      "latitude":57.0537245
    },
    "8988":{
      "name":"\u0411\u0435\u0448\u043c\u0435\u0442\u043e\u0432\u043a\u0430",
      "longitude":74.745178,
      "latitude":56.774837
    },
    "8989":{
      "name":"\u0417\u0435\u043d\u043a\u0443\u043b\u044c",
      "longitude":74.7509513,
      "latitude":55.4922423
    },
    "8990":{
      "name":"\u0427\u0435\u043f\u043b\u044f\u0440\u043e\u0432\u043e",
      "longitude":74.753702,
      "latitude":56.5832816
    },
    "8991":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":74.7567276,
      "latitude":57.3470263
    },
    "8992":{
      "name":"\u041a\u0430\u0447\u0435\u0441\u043e\u0432\u043e",
      "longitude":74.758324,
      "latitude":56.0427442
    },
    "8993":{
      "name":"\u0411\u0430\u0440\u044b\u0448\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":74.7615418,
      "latitude":55.7339331
    },
    "8994":{
      "name":"\u041d\u043e\u0432\u043e\u0435\u0440\u043c\u0430\u043a\u043e\u0432\u043a\u0430",
      "longitude":74.7636919,
      "latitude":57.0487936
    },
    "8995":{
      "name":"\u0415\u043b\u0438\u0437\u0430\u0432\u0435\u0442\u0438\u043d\u043e",
      "longitude":74.765102,
      "latitude":54.8758309
    },
    "8996":{
      "name":"\u0421\u0435\u0432\u0435\u0440\u043d\u043e\u0435",
      "longitude":74.7702223,
      "latitude":54.5043147
    },
    "8997":{
      "name":"\u0422\u0430\u0432\u043e\u043b\u0436\u0430\u043d\u043a\u0430",
      "longitude":74.779442,
      "latitude":55.093967
    },
    "8998":{
      "name":"\u0421\u0435\u0442\u043a\u0443\u043b\u043e\u0432\u043a\u0430",
      "longitude":74.8009759,
      "latitude":56.2736738
    },
    "8999":{
      "name":"\u041c\u0430\u0448\u043a\u0430\u043d\u043a\u0430",
      "longitude":74.804212,
      "latitude":56.7216173
    },
    "9000":{
      "name":"\u0422\u0430\u043d\u0430\u0442\u043e\u0432\u043e",
      "longitude":74.805091,
      "latitude":56.3729688
    },
    "9001":{
      "name":"\u0412\u0430\u043b\u0435\u0440\u0438\u043d\u043e",
      "longitude":74.8082993,
      "latitude":55.0729496
    },
    "9002":{
      "name":"\u041f\u0443\u0433\u0430\u0447\u0435\u0432\u043a\u0430",
      "longitude":74.8193467,
      "latitude":55.3668969
    },
    "9003":{
      "name":"\u041a\u0430\u043c\u044b\u0448\u0438\u043d\u043a\u0430",
      "longitude":74.819469,
      "latitude":55.4417583
    },
    "9004":{
      "name":"\u041f\u0440\u0438\u0434\u043e\u0440\u043e\u0436\u043d\u043e\u0435",
      "longitude":74.8197738,
      "latitude":55.405377
    },
    "9005":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":74.8203275,
      "latitude":56.540131
    },
    "9006":{
      "name":"\u0423\u0440\u0430\u0437\u0430\u0439",
      "longitude":74.8264946,
      "latitude":56.8152124
    },
    "9007":{
      "name":"\u042f\u0441\u043d\u0430\u044f \u041f\u043e\u043b\u044f\u043d\u0430",
      "longitude":74.834503,
      "latitude":55.106297
    },
    "9008":{
      "name":"\u041a\u0443\u0440\u043b\u044f\u043d\u043e-\u0414\u0443\u0431\u043e\u0432\u043a\u0430",
      "longitude":74.8347441,
      "latitude":57.1748137
    },
    "9009":{
      "name":"\u041c\u043e\u0438\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":74.8377086,
      "latitude":55.8889582
    },
    "9010":{
      "name":"\u041a\u0438\u0440\u044c\u044f\u043d\u043e\u0432\u043a\u0430",
      "longitude":74.8418517,
      "latitude":54.3989065
    },
    "9011":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":74.8430567,
      "latitude":55.8083421
    },
    "9012":{
      "name":"\u0421\u0438\u0431\u0438\u0440\u0441\u043a\u043e\u0435",
      "longitude":74.8520159,
      "latitude":54.0105256
    },
    "9013":{
      "name":"\u041c\u0435\u0436\u0435\u0432\u043d\u0430\u044f",
      "longitude":74.8551715,
      "latitude":57.0921268
    },
    "9014":{
      "name":"\u0410\u0447\u0430\u0438\u0440\u043a\u0430",
      "longitude":74.8567454,
      "latitude":55.5347547
    },
    "9015":{
      "name":"\u0418\u0437\u043c\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":74.8583477,
      "latitude":55.2520986
    },
    "9016":{
      "name":"\u0418\u043d\u0446\u0438\u0441\u0441",
      "longitude":74.861488,
      "latitude":56.494766
    },
    "9017":{
      "name":"\u041e\u0437\u0435\u0440\u043d\u043e\u0435",
      "longitude":74.861584,
      "latitude":55.6839176
    },
    "9018":{
      "name":"\u0421\u0442\u0435\u043a\u043b\u044f\u043d\u043a\u0430",
      "longitude":74.8749936,
      "latitude":54.5743641
    },
    "9019":{
      "name":"\u041a\u0430\u043c\u044b\u0448\u0438\u043d\u043e-\u0412\u043e\u0440\u043e\u043d\u0435\u0436\u0441\u043a\u043e\u0435",
      "longitude":74.8753091,
      "latitude":55.9647525
    },
    "9020":{
      "name":"\u041a\u0430\u043c\u044b\u0448\u0438\u043d\u043e",
      "longitude":74.8804342,
      "latitude":54.6940395
    },
    "9021":{
      "name":"\u0421\u0435\u0440\u0433\u0435\u0435\u0432\u043a\u0430",
      "longitude":74.8816953,
      "latitude":54.9852032
    },
    "9022":{
      "name":"\u041f\u0440\u043e\u0431\u0443\u0436\u0434\u0435\u043d\u0438\u0435",
      "longitude":74.8830437,
      "latitude":54.3350515
    },
    "9023":{
      "name":"\u0418\u0437\u043c\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":74.8871651,
      "latitude":55.2593955
    },
    "9024":{
      "name":"\u0411\u043e\u0433\u043e\u043c\u0435\u043b\u044c",
      "longitude":74.8909513,
      "latitude":57.0263217
    },
    "9025":{
      "name":"\u041a\u0440\u0443\u0442\u044b\u0435 \u041b\u0443\u043a\u0438",
      "longitude":74.8940078,
      "latitude":55.1474123
    },
    "9026":{
      "name":"\u041e\u043b\u044c\u0445\u043e\u0432\u043a\u0430",
      "longitude":74.8961536,
      "latitude":54.7840072
    },
    "9027":{
      "name":"\u041e\u043a\u0443\u043d\u0435\u0432\u043e",
      "longitude":74.904457,
      "latitude":56.443054
    },
    "9028":{
      "name":"\u0412\u043e\u0441\u043a\u0440\u0435\u0441\u0435\u043d\u043a\u0430",
      "longitude":74.9101154,
      "latitude":55.7775878
    },
    "9029":{
      "name":"\u041a\u0438\u0440\u044c\u044f\u043d\u043e\u0432\u043a\u0430",
      "longitude":74.9118637,
      "latitude":55.1865472
    },
    "9030":{
      "name":"\u041d\u043e\u0432\u043e\u0440\u043e\u0436\u0434\u0435\u0441\u0442\u0432\u0435\u043d\u043a\u0430",
      "longitude":74.913747,
      "latitude":56.2009156
    },
    "9031":{
      "name":"2812 \u043a\u043c",
      "longitude":74.9138839,
      "latitude":55.0862731
    },
    "9032":{
      "name":"\u0426\u0435\u043b\u0438\u043d\u043d\u043e\u0435",
      "longitude":74.9206668,
      "latitude":54.1381944
    },
    "9033":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u043a\u0430",
      "longitude":74.9238325,
      "latitude":54.8606756
    },
    "9034":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":74.9311805,
      "latitude":56.7284588
    },
    "9035":{
      "name":"\u041d\u0438\u0436\u043d\u044f\u044f \u041e\u043c\u043a\u0430",
      "longitude":74.9436733,
      "latitude":55.4148363
    },
    "9036":{
      "name":"\u0421\u043f\u0435\u0440\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":74.9562118,
      "latitude":56.122234
    },
    "9037":{
      "name":"\u0412\u043e\u043b\u0447\u0438\u043d\u043e",
      "longitude":74.9577853,
      "latitude":54.798658
    },
    "9038":{
      "name":"\u041b\u0435\u0441\u043d\u0430\u044f \u0411\u0430\u0437\u0430",
      "longitude":74.9607049,
      "latitude":54.1462526
    },
    "9039":{
      "name":"\u0417\u0430\u0445\u0430\u0440\u043e\u0432\u043a\u0430",
      "longitude":74.973144,
      "latitude":56.0149141
    },
    "9040":{
      "name":"\u0421\u043b\u043e\u0431\u043e\u0434\u043a\u0430",
      "longitude":74.9753518,
      "latitude":55.3849667
    },
    "9041":{
      "name":"\u0423\u0441\u0442\u044c-\u0418\u043d\u0446\u044b",
      "longitude":74.9759163,
      "latitude":57.0030342
    },
    "9042":{
      "name":"\u0421\u0442\u0430\u0440\u0430\u044f \u0420\u0438\u0433\u0430",
      "longitude":74.9764069,
      "latitude":55.1933647
    },
    "9043":{
      "name":"\u0412\u0438\u0448\u043d\u0435\u0432\u043a\u0430",
      "longitude":74.9771847,
      "latitude":55.4463732
    },
    "9044":{
      "name":"\u0412\u0438\u043d\u043e\u0433\u0440\u0430\u0434\u043e\u0432\u043a\u0430",
      "longitude":74.9780699,
      "latitude":55.5256544
    },
    "9045":{
      "name":"\u0423\u0434\u0430\u0447\u043d\u0430\u044f",
      "longitude":74.9809561,
      "latitude":55.6463642
    },
    "9046":{
      "name":"\u041d\u0435\u043a\u0440\u0430\u0441\u043e\u0432\u043a\u0430",
      "longitude":74.9856445,
      "latitude":55.6991278
    },
    "9047":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":74.9867168,
      "latitude":54.9458934
    },
    "9048":{
      "name":"\u0421\u0442\u0440\u0435\u043b\u044c\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":74.9882232,
      "latitude":54.7505823
    },
    "9049":{
      "name":"\u041e\u043b\u044c\u0433\u043e\u0432\u043a\u0430",
      "longitude":74.9967866,
      "latitude":54.3576405
    },
    "9050":{
      "name":"\u0421\u0442\u0430\u0440\u044b\u0439 \u0420\u0435\u0432\u0435\u043b\u044c",
      "longitude":75.001404,
      "latitude":55.193592
    },
    "9051":{
      "name":"\u0412\u0430\u0441\u044c\u043a\u043e\u0432\u043a\u0430",
      "longitude":75.0035778,
      "latitude":54.4437448
    },
    "9052":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0435\u043d\u0438\u043a\u043e\u043b\u044c\u0441\u043a",
      "longitude":75.0054143,
      "latitude":56.1408039
    },
    "9053":{
      "name":"\u0418\u043b\u044e\u0448\u043a\u0438\u043d\u043e",
      "longitude":75.0079942,
      "latitude":55.098465
    },
    "9054":{
      "name":"\u041c\u0430\u043b\u043e\u043d\u0438\u043a\u043e\u043b\u044c\u0441\u043a",
      "longitude":75.0092272,
      "latitude":56.1781137
    },
    "9055":{
      "name":"\u0420\u043e\u0436\u0434\u0435\u0441\u0442\u0432\u0435\u043d\u043a\u0430",
      "longitude":75.0093424,
      "latitude":54.6141613
    },
    "9056":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u043f\u0430\u0432\u043b\u043e\u0432\u043a\u0430",
      "longitude":75.0229999,
      "latitude":55.8175339
    },
    "9057":{
      "name":"\u0421\u043e\u043b\u043e\u0432\u044c\u0451\u0432\u043a\u0430",
      "longitude":75.0269245,
      "latitude":54.9915955
    },
    "9058":{
      "name":"\u041a\u043e\u043f\u044c\u0435\u0432\u043e",
      "longitude":75.0305635,
      "latitude":55.9271147
    },
    "9059":{
      "name":"\u041b\u043e\u043a\u0442\u0438",
      "longitude":75.0337242,
      "latitude":55.2287064
    },
    "9060":{
      "name":"\u0418\u043b\u044e\u0448\u043a\u0438\u043d\u0441\u043a\u0430\u044f",
      "longitude":75.044719,
      "latitude":55.1083789
    },
    "9061":{
      "name":"\u041b\u043e\u043a\u0442\u0438",
      "longitude":75.0474669,
      "latitude":55.2329918
    },
    "9062":{
      "name":"\u041e\u043b\u044c\u0445\u043e\u0432\u043a\u0430",
      "longitude":75.0504031,
      "latitude":53.8824462
    },
    "9063":{
      "name":"\u0412\u043e\u0441\u043a\u0440\u0435\u0441\u0435\u043d\u043a\u0430",
      "longitude":75.051768,
      "latitude":55.4661415
    },
    "9064":{
      "name":"\u041c\u0438\u0440\u0433\u043e\u0440\u043e\u0434\u043a\u0430",
      "longitude":75.0703178,
      "latitude":54.9317039
    },
    "9065":{
      "name":"\u041d\u0430\u0440\u043e\u0434\u043d\u043e\u0435 \u0411\u0435\u0440\u0435\u0433\u043e\u0432\u043e\u0435",
      "longitude":75.0735458,
      "latitude":53.9193791
    },
    "9066":{
      "name":"\u0420\u0430\u0434\u0438\u0449\u0435\u0432\u043e",
      "longitude":75.0739028,
      "latitude":55.8777262
    },
    "9067":{
      "name":"\u041f\u043e\u043b\u0442\u0430\u0432\u043a\u0430",
      "longitude":75.0746282,
      "latitude":55.2968386
    },
    "9068":{
      "name":"\u041a\u0438\u0440\u0448\u043e\u0432\u043a\u0430",
      "longitude":75.0779893,
      "latitude":55.4628729
    },
    "9069":{
      "name":"\u041a\u043e\u0441\u0442\u044f\u043a\u043e\u0432\u043a\u0430",
      "longitude":75.0797272,
      "latitude":54.7047604
    },
    "9070":{
      "name":"\u0415\u043f\u0430\u043d\u0447\u0438\u043d\u043e",
      "longitude":75.081991,
      "latitude":55.6024636
    },
    "9071":{
      "name":"\u0410\u043d\u0434\u0440\u0435\u0435\u0432\u043a\u0430",
      "longitude":75.0843036,
      "latitude":54.5367814
    },
    "9072":{
      "name":"\u0418\u0433\u043e\u0440\u0435\u0432\u043a\u0430",
      "longitude":75.094091,
      "latitude":56.5704262
    },
    "9073":{
      "name":"\u041f\u0440\u0435\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043a\u0430",
      "longitude":75.1013762,
      "latitude":54.3113202
    },
    "9074":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u0432\u043a\u0430",
      "longitude":75.1071823,
      "latitude":57.4116095
    },
    "9075":{
      "name":"\u0427\u0435\u0440\u043b\u0430\u043a",
      "longitude":75.1143702,
      "latitude":53.8811911
    },
    "9076":{
      "name":"\u0421\u044b\u0449\u0438\u043a\u043e\u0432\u043e",
      "longitude":75.120821,
      "latitude":56.9760521
    },
    "9077":{
      "name":"\u041d\u0430\u0440\u043e\u0434\u043d\u043e\u0435 \u0421\u0442\u0435\u043f\u043d\u043e\u0435",
      "longitude":75.1250382,
      "latitude":53.908723
    },
    "9078":{
      "name":"\u041a\u043e\u0440\u043e\u043b\u0435\u043d\u043a\u0430",
      "longitude":75.1305684,
      "latitude":57.0092366
    },
    "9079":{
      "name":"2826 \u043a\u043c",
      "longitude":75.1314308,
      "latitude":55.1130804
    },
    "9080":{
      "name":"\u041f\u0430\u0432\u043b\u043e\u0432\u043a\u0430",
      "longitude":75.1423732,
      "latitude":56.7945299
    },
    "9081":{
      "name":"\u0415\u0440\u043c\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":75.1467373,
      "latitude":55.0812907
    },
    "9082":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":75.1531315,
      "latitude":56.840711
    },
    "9083":{
      "name":"\u0425\u043e\u043c\u0443\u0442\u0438\u043d\u043a\u0430",
      "longitude":75.1544269,
      "latitude":55.5045514
    },
    "9084":{
      "name":"\u041b\u0438\u043b\u0435\u0439\u043a\u0430",
      "longitude":75.1603619,
      "latitude":57.0533992
    },
    "9085":{
      "name":"\u042e\u0440\u0442\u043e-\u0423\u0439\u0441\u043a",
      "longitude":75.1737764,
      "latitude":56.9630229
    },
    "9086":{
      "name":"\u041d\u043e\u0432\u044b\u0439 \u0420\u0435\u0432\u0435\u043b\u044c",
      "longitude":75.176048,
      "latitude":55.140919
    },
    "9087":{
      "name":"\u041a\u0438\u0440\u0438\u043b\u043b\u043e\u0432\u043a\u0430",
      "longitude":75.1814242,
      "latitude":54.6476784
    },
    "9088":{
      "name":"\u041a\u0430\u0440\u0430\u043a\u043b\u0438\u043d\u043a\u0430",
      "longitude":75.187174,
      "latitude":56.6511931
    },
    "9089":{
      "name":"\u0420\u044f\u0437\u0430\u043d\u043a\u0430",
      "longitude":75.1899608,
      "latitude":55.5283113
    },
    "9090":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":75.1942705,
      "latitude":54.7297439
    },
    "9091":{
      "name":"\u0412\u044f\u0442\u043a\u0430-1",
      "longitude":75.2025422,
      "latitude":56.6489712
    },
    "9092":{
      "name":"\u041c\u0435\u0434\u0432\u0435\u0436\u044c\u044f \u0413\u0440\u0438\u0432\u0430",
      "longitude":75.2123154,
      "latitude":55.2572654
    },
    "9093":{
      "name":"\u042d\u0441\u0442\u043e\u043d\u043a\u0430",
      "longitude":75.2229191,
      "latitude":57.072173
    },
    "9094":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":75.22921,
      "latitude":56.613354
    },
    "9095":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":75.2465592,
      "latitude":54.148541
    },
    "9096":{
      "name":"\u0425\u043c\u0435\u043b\u0435\u0432\u043a\u0430",
      "longitude":75.2674459,
      "latitude":56.8208455
    },
    "9097":{
      "name":"\u0410\u043d\u0434\u0440\u0435\u0435\u0432\u043a\u0430",
      "longitude":75.2761371,
      "latitude":56.8732366
    },
    "9098":{
      "name":"\u0412\u0430\u0441\u0438\u043b\u044c\u0435\u0432\u043a\u0430",
      "longitude":75.2852636,
      "latitude":54.893386
    },
    "9099":{
      "name":"\u041f\u043e\u0433\u0440\u0430\u043d\u0438\u0447\u043d\u043e-\u0413\u0440\u0438\u0433\u043e\u0440\u044c\u0435\u0432\u043a\u0430",
      "longitude":75.2912059,
      "latitude":54.1042133
    },
    "9100":{
      "name":"\u041e\u0440\u043b\u043e\u0432\u043a\u0430",
      "longitude":75.2920925,
      "latitude":54.7297439
    },
    "9101":{
      "name":"\u041f\u0440\u0435\u0441\u043d\u043e\u0432\u043a\u0430",
      "longitude":75.2949726,
      "latitude":54.8047452
    },
    "9102":{
      "name":"\u041c\u0430\u0440\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":75.3116958,
      "latitude":54.5678747
    },
    "9103":{
      "name":"\u041f\u0430\u0432\u043b\u043e\u0432\u043a\u0430",
      "longitude":75.3182364,
      "latitude":56.3157854
    },
    "9104":{
      "name":"\u041a\u0443\u0437\u043d\u0435\u0446\u043e\u0432\u043a\u0430",
      "longitude":75.3269664,
      "latitude":53.9732136
    },
    "9105":{
      "name":"\u0421\u0442\u0440\u0435\u0442\u0435\u043d\u043a\u0430",
      "longitude":75.3337824,
      "latitude":54.4055216
    },
    "9106":{
      "name":"\u0414\u0435\u043d\u0438\u0441\u043e\u0432\u043a\u0430",
      "longitude":75.3367614,
      "latitude":56.9675292
    },
    "9107":{
      "name":"\u0427\u0435\u0440\u0442\u0430\u043b\u044b",
      "longitude":75.386948,
      "latitude":56.355225
    },
    "9108":{
      "name":"\u0422\u0430\u043c\u0431\u043e\u0432\u043a\u0430",
      "longitude":75.3883568,
      "latitude":56.8813948
    },
    "9109":{
      "name":"\u0411\u043e\u0433\u0434\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":75.3908226,
      "latitude":56.9421412
    },
    "9110":{
      "name":"\u041a\u043e\u0437\u0438\u043d\u043a\u0430",
      "longitude":75.4121923,
      "latitude":54.1405112
    },
    "9111":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":75.4473957,
      "latitude":54.7698414
    },
    "9112":{
      "name":"\u041f\u043b\u043e\u0442\u0431\u0438\u0449\u0435",
      "longitude":75.4786693,
      "latitude":56.3789593
    },
    "9113":{
      "name":"\u041b\u0435\u043d\u0438\u043d\u0441\u043a",
      "longitude":75.4917742,
      "latitude":54.5380372
    },
    "9114":{
      "name":"\u0422\u0430\u0440\u043c\u0430\u043a\u043b\u0430",
      "longitude":75.5276665,
      "latitude":56.5017174
    },
    "9115":{
      "name":"\u042f\u0437\u043e\u0432\u043e",
      "longitude":75.5429375,
      "latitude":54.7621865
    },
    "9116":{
      "name":"\u041a\u0443\u0440\u043d\u0435\u0432\u043e",
      "longitude":75.5653133,
      "latitude":56.3009092
    },
    "9117":{
      "name":"\u0421\u0430\u043c\u043e\u0445\u0432\u0430\u043b\u043e\u0432\u043e",
      "longitude":75.5730356,
      "latitude":56.3438705
    },
    "9118":{
      "name":"\u041d\u0430\u0434\u0435\u0436\u0434\u0438\u043d\u043a\u0430",
      "longitude":75.6568734,
      "latitude":56.4109129
    },
    "9119":{
      "name":"\u0427\u0438\u043d\u044f\u043d\u0438\u043d\u043e",
      "longitude":75.6664056,
      "latitude":56.358627
    },
    "9120":{
      "name":"\u041d\u043e\u0432\u043e\u0430\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":75.6813304,
      "latitude":56.8625406
    },
    "9121":{
      "name":"\u041b\u044e\u0431\u0438\u043c\u043e\u0432\u043a\u0430",
      "longitude":75.7040046,
      "latitude":56.3150644
    },
    "9122":{
      "name":"\u041a\u0430\u0437\u0430\u043d\u043a\u0430",
      "longitude":75.7202826,
      "latitude":56.517189
    },
    "9123":{
      "name":"\u041b\u044c\u043d\u043e\u0437\u0430\u0432\u043e\u0434",
      "longitude":75.8052531,
      "latitude":56.4185276
    },
    "9124":{
      "name":"\u041c\u0430\u043b\u0438\u043d\u043a\u0438\u043d\u043e",
      "longitude":75.8205438,
      "latitude":56.4855593
    },
    "9125":{
      "name":"\u041a\u043e\u043b\u043e\u0431\u043e\u0432\u043e",
      "longitude":75.8322592,
      "latitude":56.5099799
    },
    "9126":{
      "name":"\u041d\u0435\u0436\u0434\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":75.8833096,
      "latitude":56.9753417
    },
    "9127":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0435\u043a\u0440\u0430\u0441\u043d\u043e\u044f\u0440\u043a\u0430",
      "longitude":75.9279435,
      "latitude":56.408315
    },
    "9128":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":75.93154,
      "latitude":56.5475636
    },
    "9129":{
      "name":"\u0421\u043e\u043b\u043e\u0432\u044c\u0451\u0432\u043a\u0430",
      "longitude":75.962565,
      "latitude":57.0724818
    },
    "9130":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u043f\u0430\u0432\u043b\u043e\u0432\u043a\u0430",
      "longitude":75.9752123,
      "latitude":56.9536855
    },
    "9131":{
      "name":"\u0423\u0441\u043f\u0435\u043d\u043a\u0430",
      "longitude":76.0014073,
      "latitude":57.0924278
    },
    "9132":{
      "name":"\u042e\u0434\u0438\u043d\u043a\u0430",
      "longitude":76.0350361,
      "latitude":56.4488617
    },
    "9133":{
      "name":"\u0415\u043b\u0438\u0437\u0430\u0440\u043e\u0432\u043e",
      "longitude":76.0483792,
      "latitude":56.9392266
    },
    "9134":{
      "name":"\u0413\u0443\u0437\u0435\u043d\u0435\u0432\u043e",
      "longitude":76.0827537,
      "latitude":56.4415975
    },
    "9135":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u043c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":75.8112246,
      "latitude":59.1921037
    },
    "9136":{
      "name":"\u041f\u0438\u043e\u043d\u0435\u0440\u043d\u044b\u0439",
      "longitude":76.2448136,
      "latitude":59.1677108
    },
    "9137":{
      "name":"\u0418\u0433\u043e\u043b\u044c\u0441\u043a\u043e-\u0422\u0430\u043b\u043e\u0432\u0441\u043a\u043e\u0435 \u043c\u0435\u0441\u0442\u043e\u0440\u043e",
      "longitude":76.4187602,
      "latitude":57.7452386
    },
    "9138":{
      "name":"\u0410\u0439\u043f\u043e\u043b\u043e\u0432\u043e",
      "longitude":76.6020084,
      "latitude":58.723735
    },
    "9139":{
      "name":"\u041b\u043e\u043c\u043e\u0432\u043e\u0435 \u043c\u0435\u0441\u0442\u043e\u0440\u043e\u0436\u0434\u0435\u043d\u0438\u0435",
      "longitude":77.0425109,
      "latitude":59.2656949
    },
    "9140":{
      "name":"\u041c\u0430\u0442\u044e\u0448\u043a\u0438\u043d\u043e\u0441\u043a\u0430\u044f",
      "longitude":77.066667,
      "latitude":59.933333
    },
    "9141":{
      "name":"\u0421\u0432\u0435\u0442\u043b\u0430\u044f \u041f\u0440\u043e\u0442\u043e\u043a\u0430",
      "longitude":77.179581,
      "latitude":60.685032
    },
    "9142":{
      "name":"\u041c\u0435\u0434\u0432\u0435\u0434\u0435\u0432\u043e",
      "longitude":77.3548334,
      "latitude":60.6143848
    },
    "9143":{
      "name":"\u041b\u0430\u0440\u0438\u043d\u043e",
      "longitude":77.6746784,
      "latitude":60.5239092
    },
    "9144":{
      "name":"\u0422\u043e\u043f\u043e\u043b\u0435\u0432\u043a\u0430",
      "longitude":78.2648105,
      "latitude":60.4484708
    },
    "9145":{
      "name":"\u041b\u0430\u0432\u0440\u043e\u0432\u043a\u0430",
      "longitude":78.362258,
      "latitude":57.454686
    },
    "9146":{
      "name":"\u0411\u043e\u0447\u043a\u0430\u0440\u0451\u0432\u043a\u0430",
      "longitude":78.3666669,
      "latitude":57.433333
    },
    "9147":{
      "name":"\u041f\u043e\u0433\u043e\u0440\u0435\u043b\u043e\u0432\u043e",
      "longitude":78.433333,
      "latitude":57.466667
    },
    "9148":{
      "name":"\u041c\u044b\u043b\u044c\u0434\u0436\u0438\u043d\u0441\u043a\u043e\u0435 \u043c\u0435\u0441\u0442\u043e\u0440\u043e\u0436\u0434\u0435\u043d\u0438",
      "longitude":78.4589748,
      "latitude":58.7722015
    },
    "9149":{
      "name":"\u041f\u044b\u0440\u0447\u0438\u043d\u043e",
      "longitude":79.1242761,
      "latitude":59.7026323
    },
    "9150":{
      "name":"\u041a\u0430\u043b\u0438\u043d\u0438\u043d\u0441\u043a",
      "longitude":79.40696,
      "latitude":57.551144
    },
    "9151":{
      "name":"\u041b\u0443\u0448\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":79.4298524,
      "latitude":57.5598776
    },
    "9152":{
      "name":"\u041e\u0441\u0442\u0430\u043d\u0438\u043d\u043e",
      "longitude":79.4674682,
      "latitude":57.5755512
    },
    "9153":{
      "name":"\u0413\u043e\u043d\u043e\u0445\u043e\u0432\u043e",
      "longitude":79.5092169,
      "latitude":57.5788731
    },
    "9154":{
      "name":"\u0420\u043e\u0433\u0430\u043b\u0435\u0432\u043e",
      "longitude":79.6097961,
      "latitude":57.496075
    },
    "9155":{
      "name":"\u0423\u0441\u0442\u044c-\u0427\u0438\u0436\u0430\u043f\u043a\u0430",
      "longitude":79.612854,
      "latitude":58.998795
    },
    "9156":{
      "name":"\u0422\u0430\u0432\u0430\u043d\u0433\u0430",
      "longitude":79.7369745,
      "latitude":57.4973231
    },
    "9157":{
      "name":"\u041d\u0430\u0443\u043d\u0430\u043a",
      "longitude":80.129143,
      "latitude":58.971134
    },
    "9158":{
      "name":"\u041e\u0441\u0438\u043f\u043e\u0432\u043e",
      "longitude":80.1778344,
      "latitude":57.8391412
    },
    "9159":{
      "name":"\u041a\u0430\u0437\u0430\u043b\u044c\u0446\u0435\u0432\u043e",
      "longitude":80.5364111,
      "latitude":59.2512155
    },
    "9160":{
      "name":"\u0422\u0430\u0440\u0441\u043a",
      "longitude":80.5898519,
      "latitude":58.2947782
    },
    "9161":{
      "name":"\u0423\u0441\u0442\u044c-\u0427\u0443\u0437\u0438\u043a",
      "longitude":80.597641,
      "latitude":58.050331
    },
    "9162":{
      "name":"\u0427\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":80.6128617,
      "latitude":58.462538
    },
    "9163":{
      "name":"\u041d\u043e\u0432\u0438\u043a\u043e\u0432\u043e",
      "longitude":80.6312621,
      "latitude":58.2040373
    },
    "9164":{
      "name":"\u0421\u0435\u043d\u044c\u043a\u0438\u043d\u043e",
      "longitude":80.6731491,
      "latitude":58.5041576
    },
    "9165":{
      "name":"5 \u043a\u043c",
      "longitude":80.803177,
      "latitude":59.063667
    },
    "9166":{
      "name":"\u0413\u0440\u0435\u0431\u0435\u043d\u0449\u0438\u043a\u043e\u0432\u043e",
      "longitude":80.911642,
      "latitude":57.3981846
    },
    "9167":{
      "name":"\u0412\u0435\u0441\u0435\u043b\u044b\u0439",
      "longitude":80.9212043,
      "latitude":56.8781745
    },
    "9168":{
      "name":"\u0426\u0435\u043d\u0442\u0440\u0430\u043b\u044c\u043d\u044b\u0439",
      "longitude":80.9761945,
      "latitude":57.4844826
    },
    "9169":{
      "name":"\u041a\u0451\u043d\u0433\u0430",
      "longitude":80.976501,
      "latitude":57.428196
    },
    "9170":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u0411\u0443\u0440\u043a\u0430",
      "longitude":81.057152,
      "latitude":56.915192
    },
    "9171":{
      "name":"\u041d\u0435\u043b\u044c\u043c\u0430\u0447",
      "longitude":81.097771,
      "latitude":58.681053
    },
    "9172":{
      "name":"\u0411\u0435\u043b\u043a\u0430",
      "longitude":81.102556,
      "latitude":58.5904565
    },
    "9173":{
      "name":"\u041a\u0435\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":81.242922,
      "latitude":57.1230403
    },
    "9174":{
      "name":"\u0412\u043e\u0441\u0442\u043e\u043a",
      "longitude":81.275253,
      "latitude":59.166855
    },
    "9175":{
      "name":"\u0425\u043e\u0445\u043b\u043e\u0432\u043a\u0430",
      "longitude":81.3633184,
      "latitude":57.2015444
    },
    "9176":{
      "name":"\u0417\u0430\u043e\u0437\u0435\u0440\u043e",
      "longitude":81.4270483,
      "latitude":58.704259
    },
    "9177":{
      "name":"\u0413\u043e\u043b\u0435\u0449\u0438\u0445\u0438\u043d\u043e",
      "longitude":81.4497272,
      "latitude":58.7223879
    },
    "9178":{
      "name":"\u0412\u044f\u043b\u043e\u0432\u043e",
      "longitude":81.457787,
      "latitude":58.7156913
    },
    "9179":{
      "name":"\u041f\u0435\u0440\u0435\u043c\u0438\u0442\u0438\u043d\u043e",
      "longitude":81.5393433,
      "latitude":58.6694331
    },
    "9180":{
      "name":"\u0410\u043d\u0434\u0430\u0440\u043c\u0430",
      "longitude":81.7009928,
      "latitude":56.9142786
    },
    "9181":{
      "name":"\u0410\u043b\u0430\u0442\u0430\u0435\u0432\u043e",
      "longitude":81.7496044,
      "latitude":58.8282516
    },
    "9182":{
      "name":"\u0411\u043e\u0433\u0430\u0442\u044b\u0440\u0451\u0432\u043a\u0430",
      "longitude":81.753853,
      "latitude":56.980011
    },
    "9183":{
      "name":"\u0421\u0432\u0435\u0442\u043b\u043e\u0437\u0435\u043b\u0451\u043d\u043e\u0435",
      "longitude":81.7664641,
      "latitude":57.3764901
    },
    "9184":{
      "name":"\u041d\u0438\u0436\u043d\u044f\u044f \u0427\u0438\u0433\u0430\u0440\u0430",
      "longitude":81.783768,
      "latitude":58.5744788
    },
    "9185":{
      "name":"\u041f\u0430\u043d\u044b\u0447\u0435\u0432\u043e",
      "longitude":81.794205,
      "latitude":57.053921
    },
    "9186":{
      "name":"\u041f\u0447\u0451\u043b\u043a\u0430",
      "longitude":81.917793,
      "latitude":57.222813
    },
    "9187":{
      "name":"\u0425\u0443\u0442\u043e\u0440\u0441\u043a\u043e\u0435",
      "longitude":81.924065,
      "latitude":57.268841
    },
    "9188":{
      "name":"\u0427\u0435\u0440\u0435\u043c\u0445\u043e\u0432\u043e",
      "longitude":81.9633036,
      "latitude":57.4961961
    },
    "9189":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u0413\u0430\u043b\u043a\u0430",
      "longitude":81.969589,
      "latitude":56.930569
    },
    "9190":{
      "name":"\u0427\u0435\u0440\u043d\u044b\u0448\u0435\u0432\u043a\u0430",
      "longitude":81.9925461,
      "latitude":57.0013872
    },
    "9191":{
      "name":"\u0411\u0443\u043d\u0434\u044e\u0440",
      "longitude":81.99884,
      "latitude":57.546528
    },
    "9192":{
      "name":"\u0411\u0430\u0441\u043c\u0430\u0441\u043e\u0432\u043e",
      "longitude":82.0443947,
      "latitude":58.6367769
    },
    "9193":{
      "name":"\u0412\u0435\u0441\u0451\u043b\u043e\u0435",
      "longitude":82.1162014,
      "latitude":57.5644983
    },
    "9194":{
      "name":"\u042e\u0440\u0442\u044b",
      "longitude":82.1683499,
      "latitude":58.4923919
    },
    "9195":{
      "name":"\u0421\u0443\u0445\u043e\u0435",
      "longitude":82.177742,
      "latitude":57.111458
    },
    "9196":{
      "name":"\u041f\u043e\u0434\u043e\u043b\u044c\u0441\u043a",
      "longitude":82.1825676,
      "latitude":57.2533955
    },
    "9197":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u043c\u0430\u0439\u0441\u043a",
      "longitude":82.250275,
      "latitude":56.982708
    },
    "9198":{
      "name":"\u041b\u043e\u0441\u044c-\u0413\u043e\u0440\u0430",
      "longitude":82.2733039,
      "latitude":57.5243845
    },
    "9199":{
      "name":"\u041a\u0443\u0437\u043d\u0435\u0446\u043e\u0432\u043a\u0430",
      "longitude":82.2846706,
      "latitude":56.917925
    },
    "9200":{
      "name":"\u041d\u0438\u0436\u043d\u044f\u044f \u0422\u0438\u0433\u0430",
      "longitude":82.3060744,
      "latitude":57.5688782
    },
    "9201":{
      "name":"\u041c\u043e\u0441\u0442\u043e\u0432\u0430\u044f",
      "longitude":82.3156734,
      "latitude":57.5984001
    },
    "9202":{
      "name":"\u0427\u0443\u043c\u0430\u043a\u0430\u0435\u0432\u043a\u0430",
      "longitude":82.331314,
      "latitude":57.044056
    },
    "9203":{
      "name":"\u0417\u0430\u0439\u043a\u0438\u043d\u043e",
      "longitude":82.455381,
      "latitude":58.6370376
    },
    "9204":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u043f\u0430\u0432\u043b\u043e\u0432\u043a\u0430",
      "longitude":82.479809,
      "latitude":58.3337665
    },
    "9205":{
      "name":"\u041f\u043e\u043b\u044b\u043d\u044f\u043d\u043a\u0430",
      "longitude":82.509056,
      "latitude":56.952286
    },
    "9206":{
      "name":"\u0421\u0432\u0435\u0442\u043b\u044f\u043d\u043a\u0430",
      "longitude":82.5558585,
      "latitude":57.8618433
    },
    "9207":{
      "name":"\u0413\u0432\u043e\u0437\u0434\u0435\u0432\u043a\u0430",
      "longitude":82.5605744,
      "latitude":57.9555299
    },
    "9208":{
      "name":"\u041a\u043b\u044e\u043a\u0432\u0438\u043d\u043a\u0430",
      "longitude":82.5702386,
      "latitude":58.1613627
    },
    "9209":{
      "name":"\u0410\u043d\u0434\u0440\u0435\u0435\u0432\u043a\u0430",
      "longitude":82.6026715,
      "latitude":58.0690756
    },
    "9210":{
      "name":"\u0422\u0440\u0443\u0434\u043e\u0432\u043e\u0439",
      "longitude":82.6368706,
      "latitude":57.8168266
    },
    "9211":{
      "name":"\u0422\u043e\u0438\u043d\u043a\u0430",
      "longitude":82.6726092,
      "latitude":58.0331304
    },
    "9212":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u043c\u0430\u0439\u043a\u0430",
      "longitude":82.705224,
      "latitude":58.1151574
    },
    "9213":{
      "name":"\u041a\u0430\u0440\u0430\u043c\u0437\u0438\u043d\u043a\u0430",
      "longitude":82.7292888,
      "latitude":58.0292907
    },
    "9214":{
      "name":"\u041d\u044e\u043b\u044c\u044f\u0434\u0440\u043e\u0432\u043e",
      "longitude":84.583333,
      "latitude":60.416667
    },
    "9215":{
      "name":"\u041c\u0430\u0442\u044e\u0448\u043a\u0438\u043d\u043e",
      "longitude":82.7771384,
      "latitude":58.1646915
    },
    "9216":{
      "name":"\u041a\u043e\u043c\u0430\u0440\u043e\u0432\u043e",
      "longitude":82.7960806,
      "latitude":58.4567936
    },
    "9217":{
      "name":"\u0421\u0435\u0432\u0435\u0440",
      "longitude":82.813095,
      "latitude":58.440559
    },
    "9218":{
      "name":"\u0412\u043e\u043b\u043a\u043e\u0432\u043e",
      "longitude":82.8886896,
      "latitude":58.391193
    },
    "9219":{
      "name":"\u041a\u0430\u043d\u0430\u043d\u0430\u043a",
      "longitude":82.905278,
      "latitude":60.044722
    },
    "9220":{
      "name":"\u0411\u043e\u0440\u043e\u0434\u0438\u043d\u0441\u043a",
      "longitude":82.929184,
      "latitude":57.023602
    },
    "9221":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u043a\u043e\u0440\u043e\u0442\u043a\u0438\u043d\u043e",
      "longitude":82.9714344,
      "latitude":58.0312238
    },
    "9222":{
      "name":"\u041d\u043e\u0432\u043e\u0438\u043b\u044c\u0438\u043d\u043a\u0430",
      "longitude":83.0077585,
      "latitude":58.2227623
    },
    "9223":{
      "name":"\u0412\u0430\u0441\u0438\u043b\u044c\u0435\u0432\u043a\u0430",
      "longitude":83.082787,
      "latitude":57.8268834
    },
    "9224":{
      "name":"\u041d\u043e\u0432\u043e\u0430\u0431\u0440\u0430\u043c\u043a\u0438\u043d\u043e",
      "longitude":83.1040139,
      "latitude":57.9261779
    },
    "9225":{
      "name":"\u041c\u0430\u043b\u044b\u0439 \u041a\u043e\u043c\u043f\u0430\u0441",
      "longitude":83.145,
      "latitude":60.058333
    },
    "9226":{
      "name":"\u0422\u0438\u0441\u043a\u0438\u043d\u043e",
      "longitude":83.1830521,
      "latitude":58.0842829
    },
    "9227":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u043e\u043d\u0434\u0440\u043e\u0432\u043e",
      "longitude":83.2000911,
      "latitude":58.0535112
    },
    "9228":{
      "name":"\u0410\u043f\u0442\u0430\u043b\u0430",
      "longitude":83.222237,
      "latitude":56.174774
    },
    "9229":{
      "name":"\u041a\u043e\u043b\u043e\u043c\u0438\u043d\u043e",
      "longitude":83.3138547,
      "latitude":57.8241109
    },
    "9230":{
      "name":"\u041f\u044b\u043b\u044c-\u041a\u0430\u0440\u0430\u043c\u043e",
      "longitude":83.355833,
      "latitude":60.166111
    },
    "9231":{
      "name":"\u0422\u0440\u0435\u0445\u0443\u0441\u0442\u044c\u0435 \u041a\u0430\u043b\u044c\u0434\u0436\u0430",
      "longitude":83.3896039,
      "latitude":58.0191433
    },
    "9232":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u0447\u0435\u0440\u043d\u043e\u0432\u043e",
      "longitude":83.4184108,
      "latitude":56.3443944
    },
    "9233":{
      "name":"\u0412\u043e\u043b\u043a\u043e\u0434\u0430\u0435\u0432\u043a\u0430",
      "longitude":83.4419285,
      "latitude":55.9235968
    },
    "9234":{
      "name":"\u041d\u043e\u0432\u043e\u0434\u0443\u0431\u0440\u043e\u0432\u043a\u0430",
      "longitude":83.4419284,
      "latitude":56.4335264
    },
    "9235":{
      "name":"\u0422\u0438\u043f\u0441\u0438\u043d\u043e",
      "longitude":83.4456349,
      "latitude":58.4382208
    },
    "9236":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u0422\u0430\u0442\u043e\u0448",
      "longitude":83.4689003,
      "latitude":57.6009982
    },
    "9237":{
      "name":"\u041d\u0435\u0444\u0442\u0435\u0431\u0430\u0437\u0430",
      "longitude":83.5044981,
      "latitude":57.7058714
    },
    "9238":{
      "name":"\u0420\u043e\u0434\u0438\u043e\u043d\u043e\u0432\u043a\u0430",
      "longitude":83.5147442,
      "latitude":58.4397329
    },
    "9239":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u044f\u044f \u0423\u0440\u0442\u0430\u043c\u043a\u0430",
      "longitude":83.529541,
      "latitude":56.133076
    },
    "9240":{
      "name":"\u041b\u044b\u043c\u0431\u0435\u043b\u044c-\u041a\u0430\u0440\u0430\u043c\u043e",
      "longitude":83.552778,
      "latitude":60.244722
    },
    "9241":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u044f\u044f \u0424\u0451\u0434\u043e\u0440\u043e\u0432\u043a\u0430",
      "longitude":83.5582002,
      "latitude":57.6246441
    },
    "9242":{
      "name":"\u0411\u0430\u0442\u0443\u0440\u0438\u043d\u043e",
      "longitude":83.564751,
      "latitude":56.496601
    },
    "9243":{
      "name":"\u041c\u0430\u043b\u043e\u0435 \u0411\u0430\u0431\u0430\u0440\u044b\u043a\u0438\u043d\u043e",
      "longitude":83.5648379,
      "latitude":56.5772359
    },
    "9244":{
      "name":"\u0423\u0441\u0442\u044c-\u0420\u0435\u0447\u043a\u0430",
      "longitude":83.5722951,
      "latitude":58.442582
    },
    "9245":{
      "name":"\u0422\u044b\u0437\u044b\u0440\u0430\u0447\u0435\u0432\u043e",
      "longitude":83.581699,
      "latitude":56.7415737
    },
    "9246":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":83.5962573,
      "latitude":57.4422462
    },
    "9247":{
      "name":"\u041a\u0443\u0437\u043d\u0435\u0446\u043e\u0432\u043e",
      "longitude":83.6014018,
      "latitude":56.5998273
    },
    "9248":{
      "name":"\u0412\u0435\u0440\u0445. \u0411\u0440\u043e\u0432\u043a\u0430",
      "longitude":83.6353961,
      "latitude":57.1706646
    },
    "9249":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":83.6382434,
      "latitude":56.8799642
    },
    "9250":{
      "name":"\u0412\u043e\u0437\u043d\u0435\u0441\u0435\u043d\u043a\u0430",
      "longitude":83.647069,
      "latitude":57.0814015
    },
    "9251":{
      "name":"\u0411\u0435\u043b\u043e\u0441\u0442\u043e\u043a",
      "longitude":83.662865,
      "latitude":57.177273
    },
    "9252":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":83.6780055,
      "latitude":56.9287213
    },
    "9253":{
      "name":"\u041a\u0440\u044b\u043b\u043e\u0432\u043a\u0430",
      "longitude":83.6946192,
      "latitude":57.2193981
    },
    "9254":{
      "name":"\u0424\u0435\u0434\u043e\u0440\u0430\u0435\u0432\u043a\u0430",
      "longitude":83.7042429,
      "latitude":56.8682138
    },
    "9255":{
      "name":"\u0415\u043a\u0438\u043c\u043e\u0432\u043e",
      "longitude":83.7623258,
      "latitude":55.9630207
    },
    "9256":{
      "name":"\u041c\u043e\u0445\u043e\u0432\u043e",
      "longitude":83.7868566,
      "latitude":58.4338357
    },
    "9257":{
      "name":"\u042e\u0434\u0438\u043d\u043e",
      "longitude":83.8115091,
      "latitude":58.4425013
    },
    "9258":{
      "name":"\u0422\u0435\u0434\u0435\u043b\u044c-\u041a\u044b\u043d\u0430\u043a",
      "longitude":83.8198758,
      "latitude":60.3194283
    },
    "9259":{
      "name":"\u041d\u0438\u0436\u043d\u044f\u044f \u0424\u0451\u0434\u043e\u0440\u043e\u0432\u043a\u0430",
      "longitude":83.8548494,
      "latitude":57.7046505
    },
    "9260":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u0441\u0430\u0439\u043d\u0430\u043a\u043e\u0432\u043e",
      "longitude":83.8641614,
      "latitude":57.0880165
    },
    "9261":{
      "name":"\u041f\u0435\u0440\u0435\u043b\u044e\u0431\u043a\u0430",
      "longitude":83.9145692,
      "latitude":56.7280682
    },
    "9262":{
      "name":"\u0414\u0435\u0433\u0442\u044f\u0440\u0435\u0432\u043a\u0430",
      "longitude":83.9475692,
      "latitude":56.9451613
    },
    "9263":{
      "name":"\u0420\u0443\u044f\u043d",
      "longitude":83.9561415,
      "latitude":56.1469749
    },
    "9264":{
      "name":"\u041a\u0430\u0439\u0442\u0435\u0441",
      "longitude":83.9590295,
      "latitude":56.7755028
    },
    "9265":{
      "name":"\u0411\u0430\u0440\u0430\u043d\u043e\u0432\u043e",
      "longitude":84.0151503,
      "latitude":57.2821337
    },
    "9266":{
      "name":"\u041c\u043e\u0433\u0438\u043b\u044c\u043d\u0438\u043a\u0438",
      "longitude":84.0418334,
      "latitude":56.1148129
    },
    "9267":{
      "name":"\u0411\u0430\u043b\u0430\u0448\u043e\u0432\u043a\u0430",
      "longitude":84.0531585,
      "latitude":56.8534099
    },
    "9268":{
      "name":"\u0411\u044b\u043b\u0438\u043d\u043e",
      "longitude":84.0634829,
      "latitude":57.2554909
    },
    "9269":{
      "name":"\u041d\u043e\u0432\u043e\u0440\u043e\u0441\u0441\u0438\u0439\u0441\u043a\u0438\u0439",
      "longitude":84.0658615,
      "latitude":56.9826212
    },
    "9270":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u0430\u0437\u0430\u043d\u0441\u043a\u0438\u0439",
      "longitude":84.0885208,
      "latitude":56.9771021
    },
    "9271":{
      "name":"\u0427\u0430\u0433\u0438\u043d\u043e",
      "longitude":84.0906876,
      "latitude":57.180485
    },
    "9272":{
      "name":"\u041a\u0430\u0437\u044b\u0440\u0431\u0430\u043a",
      "longitude":84.1068722,
      "latitude":57.2559212
    },
    "9273":{
      "name":"\u0422\u0430\u0439\u043d\u043e\u0435",
      "longitude":84.1127894,
      "latitude":58.3897918
    },
    "9274":{
      "name":"\u041d\u043e\u0432\u043e\u043f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":84.1190765,
      "latitude":56.9072476
    },
    "9275":{
      "name":"\u0410\u0441\u0442\u0440\u0430\u0445\u0430\u043d\u0446\u0435\u0432\u043e",
      "longitude":84.121819,
      "latitude":56.4574131
    },
    "9276":{
      "name":"\u0421\u0442\u0430\u0440\u0430\u044f \u0428\u0435\u0433\u0430\u0440\u043a\u0430",
      "longitude":84.1546664,
      "latitude":56.5534956
    },
    "9277":{
      "name":"\u041a\u0443\u043b\u043c\u0430\u043d\u044b",
      "longitude":84.2232879,
      "latitude":56.6042721
    },
    "9278":{
      "name":"\u0412\u0430\u043d\u0436\u0438\u043b\u044c-\u041a\u044b\u043d\u0430\u043a",
      "longitude":84.23297,
      "latitude":60.389321
    },
    "9279":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u0430\u044f \u0420\u0435\u0447\u043a\u0430",
      "longitude":84.328758,
      "latitude":56.152927
    },
    "9280":{
      "name":"\u0415\u0440\u0433\u0430\u0439",
      "longitude":84.3304334,
      "latitude":57.3458002
    },
    "9281":{
      "name":"\u041f\u043e\u0437\u0434\u043d\u044f\u043a\u043e\u0432\u043e",
      "longitude":84.3325351,
      "latitude":56.6695108
    },
    "9282":{
      "name":"\u041d\u043e\u0432\u043e\u043d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":84.356793,
      "latitude":56.7699247
    },
    "9283":{
      "name":"\u0421\u0430\u043b\u0442\u0430\u043d\u0430\u043a\u043e\u0432\u043e",
      "longitude":84.38206,
      "latitude":56.9987961
    },
    "9284":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u0438\u0433\u043b\u043e\u0432\u0441\u043a",
      "longitude":84.3922481,
      "latitude":56.9680418
    },
    "9285":{
      "name":"\u0411\u0443\u0433\u0440\u044b",
      "longitude":84.4068878,
      "latitude":57.250663
    },
    "9286":{
      "name":"\u041d\u043e\u0432\u043e\u0438\u0433\u043b\u043e\u0432\u0441\u043a",
      "longitude":84.4148473,
      "latitude":56.9730757
    },
    "9287":{
      "name":"\u041a\u0443\u0440\u043e\u043b\u0438\u043d\u043e",
      "longitude":84.4887584,
      "latitude":58.7208198
    },
    "9288":{
      "name":"86-\u0439 \u043a\u0432\u0430\u0440\u0442\u0430\u043b",
      "longitude":84.552559,
      "latitude":56.373974
    },
    "9289":{
      "name":"\u0413\u043e\u0441\u043a\u043e\u043d\u044e\u0448\u043d\u044f",
      "longitude":84.6511453,
      "latitude":56.218079
    },
    "9290":{
      "name":"\u0423\u0440\u043e\u0447\u0438\u0449\u0435 \u041b\u0435\u0441\u043d\u043e\u0439",
      "longitude":84.6593024,
      "latitude":57.3081683
    },
    "9291":{
      "name":"\u041a\u0438\u0436\u0438\u0440\u043e\u0432\u043e",
      "longitude":84.6906596,
      "latitude":56.7679823
    },
    "9292":{
      "name":"\u0420\u044b\u0431\u0438\u043d\u0441\u043a",
      "longitude":84.7306036,
      "latitude":58.3903666
    },
    "9293":{
      "name":"\u0421\u0435\u043c\u0438\u043e\u0437\u0451\u0440\u043a\u0438",
      "longitude":84.734711,
      "latitude":56.751408
    },
    "9294":{
      "name":"\u041a\u043e\u043b\u043e\u043c\u0438\u043d\u043e",
      "longitude":84.748398,
      "latitude":56.564568
    },
    "9295":{
      "name":"\u0411\u044b\u043a\u043e\u0432\u043e",
      "longitude":84.7593822,
      "latitude":56.5652586
    },
    "9296":{
      "name":"\u0413\u043e\u043b\u043e\u0432\u0438\u043d\u0430",
      "longitude":84.7595829,
      "latitude":56.3847382
    },
    "9297":{
      "name":"\u0412\u043e\u043b\u044c\u043d\u0430\u044f \u0441\u043b\u043e\u0431\u043e\u0434\u0430",
      "longitude":84.7618334,
      "latitude":56.5137531
    },
    "9298":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u0432\u0441\u043a\u0438\u0439 \u0423\u0447\u0430\u0441\u0442\u043e\u043a",
      "longitude":84.792,
      "latitude":56.515442
    },
    "9299":{
      "name":"\u041f\u043e\u043f\u0435\u0440\u0435\u0447\u043a\u0430",
      "longitude":84.8096257,
      "latitude":56.7263711
    },
    "9300":{
      "name":"\u041f\u0440\u0438\u043c\u044b\u043a\u0430\u043d\u044c\u0435",
      "longitude":84.8427552,
      "latitude":56.491039
    },
    "9301":{
      "name":"\u041a\u0430\u0439\u0434\u0430\u043b\u043e\u0432\u043a\u0430",
      "longitude":84.8454417,
      "latitude":56.5001306
    },
    "9302":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u043f\u0430\u0432\u043b\u043e\u0432\u043a\u0430",
      "longitude":84.8596274,
      "latitude":56.8028983
    },
    "9303":{
      "name":"\u041e\u043b\u044c\u0433\u043e-\u0421\u0430\u043f\u0435\u0436\u0435\u043d\u043a\u0430",
      "longitude":84.8634212,
      "latitude":56.94256
    },
    "9304":{
      "name":"\u041b\u0430\u043c\u0435\u0435\u0432\u043a\u0430",
      "longitude":84.8740891,
      "latitude":57.8588902
    },
    "9305":{
      "name":"\u041c\u0435\u0434\u0432\u0435\u0434\u043a\u0430",
      "longitude":84.8821306,
      "latitude":56.1762225
    },
    "9306":{
      "name":"\u041d\u0438\u0431\u0435\u0433\u0430",
      "longitude":84.885941,
      "latitude":58.283829
    },
    "9307":{
      "name":"\u041b\u0435\u0441\u043d\u0430\u044f \u0414\u0430\u0447\u0430",
      "longitude":84.9050754,
      "latitude":56.442338
    },
    "9308":{
      "name":"\u041f\u043e\u043b\u0443\u0434\u0435\u043d\u043e\u0432\u043a\u0430",
      "longitude":84.918716,
      "latitude":58.4398
    },
    "9309":{
      "name":"\u0412\u0435\u0442\u0435\u0440\u0430\u043d-3",
      "longitude":84.9204001,
      "latitude":56.4391699
    },
    "9310":{
      "name":"\u0428\u0442\u0430\u043c\u043e\u0432\u043e",
      "longitude":84.9709652,
      "latitude":56.5743331
    },
    "9311":{
      "name":"\u041a\u0430\u0437\u0430\u043d\u043a\u0430",
      "longitude":84.9747267,
      "latitude":56.3010213
    },
    "9312":{
      "name":"\u0421\u043f\u0443\u0442\u043d\u0438\u043a",
      "longitude":84.9844277,
      "latitude":56.5707372
    },
    "9313":{
      "name":"\u041f\u0438\u0441\u0430\u0440\u0435\u0432\u043e",
      "longitude":85.0151759,
      "latitude":56.395067
    },
    "9314":{
      "name":"\u041f\u0440\u043e\u0441\u0435\u043a\u0438\u043d\u043e",
      "longitude":85.0294037,
      "latitude":56.3815178
    },
    "9315":{
      "name":"\u0413\u0435\u043e\u0440\u0433\u0438\u0435\u0432\u043a\u0430",
      "longitude":85.0406109,
      "latitude":56.7904369
    },
    "9316":{
      "name":"\u041d\u0430\u0434\u0435\u0436\u0434\u0430",
      "longitude":85.05719,
      "latitude":56.730797
    },
    "9317":{
      "name":"\u041a\u0438\u0440\u0433\u0438\u0437\u043a\u0430",
      "longitude":85.0683275,
      "latitude":56.5507733
    },
    "9318":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":85.0770052,
      "latitude":56.7338441
    },
    "9319":{
      "name":"\u0420\u0435\u0436\u0435\u043d\u043a\u0430",
      "longitude":85.1127941,
      "latitude":56.5835815
    },
    "9320":{
      "name":"\u041a\u043e\u043f\u044b\u043b\u043e\u0432\u043e",
      "longitude":85.1253153,
      "latitude":56.5809337
    },
    "9321":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":85.132301,
      "latitude":56.525112
    },
    "9322":{
      "name":"\u0411\u043e\u0431\u0440\u043e\u0432\u043a\u0430",
      "longitude":85.1521179,
      "latitude":56.720905
    },
    "9323":{
      "name":"\u041a\u043e\u043d\u0438\u043d\u0438\u043d\u043e",
      "longitude":85.158211,
      "latitude":56.628941
    },
    "9324":{
      "name":"\u0421\u0430\u043d\u0434\u0436\u0438\u043a",
      "longitude":85.184174,
      "latitude":58.277176
    },
    "9325":{
      "name":"104 \u043a\u043c",
      "longitude":85.1903019,
      "latitude":56.6034955
    },
    "9326":{
      "name":"\u041f\u043e\u0441\u0442\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":85.1943052,
      "latitude":56.6053475
    },
    "9327":{
      "name":"\u042f\u0433\u043e\u0434\u043d\u043e\u0435",
      "longitude":85.1966831,
      "latitude":56.3669239
    },
    "9328":{
      "name":"\u0410\u0432\u0438\u0430\u0442\u043e\u0440-1",
      "longitude":85.2015126,
      "latitude":56.4020108
    },
    "9329":{
      "name":"\u041a\u0430\u0448\u0442\u0430\u043a",
      "longitude":85.2045154,
      "latitude":56.3572051
    },
    "9330":{
      "name":"\u0410\u0432\u0438\u0430\u0442\u043e\u0440-2",
      "longitude":85.2047098,
      "latitude":56.3971304
    },
    "9331":{
      "name":"\u0412\u043e\u0441\u0445\u043e\u0434",
      "longitude":85.2047991,
      "latitude":56.4215211
    },
    "9332":{
      "name":"\u0412\u043e\u0440\u043e\u043d\u043e\u0432\u043e",
      "longitude":85.2132607,
      "latitude":56.340124
    },
    "9333":{
      "name":"\u041a\u0443\u0441\u043a\u043e\u0432\u043e",
      "longitude":85.227486,
      "latitude":56.639107
    },
    "9334":{
      "name":"\u0411\u043e\u0434\u0430\u0436\u043a\u043e\u0432\u043e",
      "longitude":85.2345515,
      "latitude":56.4919087
    },
    "9335":{
      "name":"\u041a\u0430\u0440\u0430\u043a\u043e\u0437\u043e\u0432\u043e",
      "longitude":85.2385387,
      "latitude":57.0061068
    },
    "9336":{
      "name":"\u041f\u043b\u043e\u0442\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":85.244354,
      "latitude":56.385349
    },
    "9337":{
      "name":"\u0421\u0422 \"\u041c\u0430\u044f\u043a\"",
      "longitude":85.2638467,
      "latitude":56.4308015
    },
    "9338":{
      "name":"\u0410\u0440\u043a\u0430\u0448\u0435\u0432\u043e",
      "longitude":85.2654505,
      "latitude":56.4431674
    },
    "9339":{
      "name":"\u041f\u0435\u0442\u0443\u0445\u043e\u0432\u043e",
      "longitude":85.2743624,
      "latitude":56.3514228
    },
    "9340":{
      "name":"\u041c\u043e\u0441\u043a\u0430\u043b\u0438",
      "longitude":85.3385091,
      "latitude":56.7150025
    },
    "9341":{
      "name":"\u0421\u043c\u0435\u043d\u0430",
      "longitude":85.4118542,
      "latitude":56.3732365
    },
    "9342":{
      "name":"\u041c\u0438\u043b\u043e\u043d\u043e\u0432\u043a\u0430",
      "longitude":85.4334757,
      "latitude":56.6700735
    },
    "9343":{
      "name":"26 \u043a\u043c",
      "longitude":85.4357196,
      "latitude":56.2120819
    },
    "9344":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":85.4391406,
      "latitude":56.6961913
    },
    "9345":{
      "name":"41 \u043a\u043c",
      "longitude":85.4414103,
      "latitude":56.3188286
    },
    "9346":{
      "name":"31 \u043a\u043c",
      "longitude":85.4652453,
      "latitude":56.2500579
    },
    "9347":{
      "name":"129 \u043a\u043c",
      "longitude":85.4721703,
      "latitude":56.7468854
    },
    "9348":{
      "name":"\u041e\u043b\u044c\u0433\u043e\u0432\u043a\u0430",
      "longitude":85.488579,
      "latitude":56.8233153
    },
    "9349":{
      "name":"\u0423\u0449\u0435\u0440\u0431",
      "longitude":85.4981921,
      "latitude":56.7431954
    },
    "9350":{
      "name":"\u0421\u0443\u0435\u0442\u0438\u043b\u043e\u0432\u043a\u0430",
      "longitude":85.6510605,
      "latitude":56.5942182
    },
    "9351":{
      "name":"\u041a\u0430\u043c\u0430\u0435\u0432\u043a\u0430",
      "longitude":85.7353228,
      "latitude":56.6572655
    },
    "9352":{
      "name":"\u041a\u043e\u043f\u044b\u043b\u043e\u0432\u043a\u0430",
      "longitude":85.738724,
      "latitude":57.482704
    },
    "9353":{
      "name":"\u041c\u0438\u0442\u0440\u043e\u0444\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":85.7445721,
      "latitude":57.2054912
    },
    "9354":{
      "name":"\u041e\u0441\u043a\u043e\u043b\u043a\u043e\u0432\u043e",
      "longitude":85.7597476,
      "latitude":57.5047034
    },
    "9355":{
      "name":"\u041a\u043e\u043c\u0430\u0440\u043e\u0432\u043a\u0430",
      "longitude":85.7627202,
      "latitude":57.4868919
    },
    "9356":{
      "name":"153 \u043a\u043c",
      "longitude":85.7802482,
      "latitude":56.8784475
    },
    "9357":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":85.780792,
      "latitude":57.275623
    },
    "9358":{
      "name":"\u0421\u043e\u0432\u0445\u043e\u0437\u043d\u044b\u0439",
      "longitude":85.8048393,
      "latitude":57.5730602
    },
    "9359":{
      "name":"\u041e\u0442\u0440\u0430\u0434\u043d\u044b\u0439",
      "longitude":85.8276469,
      "latitude":57.4198403
    },
    "9360":{
      "name":"\u041c\u0438\u043d\u0430\u0435\u0432\u043a\u0430",
      "longitude":85.838058,
      "latitude":57.43354
    },
    "9361":{
      "name":"161 \u043a\u043c",
      "longitude":85.8862702,
      "latitude":56.9092555
    },
    "9362":{
      "name":"\u0412\u043e\u0440\u043e\u043d\u043e-\u041f\u0430\u0448\u043d\u044f",
      "longitude":85.893875,
      "latitude":56.899044
    },
    "9363":{
      "name":"\u041a\u0430\u0440\u0430\u043a\u043e\u043b\u044c",
      "longitude":85.901985,
      "latitude":57.257336
    },
    "9364":{
      "name":"\u041d\u043e\u0432\u043e-\u0422\u0440\u043e\u0438\u0446\u0430",
      "longitude":85.967361,
      "latitude":56.919498
    },
    "9365":{
      "name":"\u0413\u043e\u0440\u044c\u043a\u043e\u0432\u043a\u0430",
      "longitude":85.9767847,
      "latitude":56.7019237
    },
    "9366":{
      "name":"167 \u043a\u043c",
      "longitude":86.0005268,
      "latitude":56.9352909
    },
    "9367":{
      "name":"169 \u043a\u043c",
      "longitude":86.0356744,
      "latitude":56.939159
    },
    "9368":{
      "name":"\u0411\u0430\u043b\u0430\u0433\u0430\u0447\u0435\u0432\u043e",
      "longitude":86.0435729,
      "latitude":57.4189157
    },
    "9369":{
      "name":"\u0421\u043f\u0430\u0441\u043e-\u042f\u0439\u0441\u043a\u043e\u0435",
      "longitude":86.116928,
      "latitude":56.705891
    },
    "9370":{
      "name":"\u0421\u0430\u0445\u0430\u043b\u0438\u043d\u043a\u0430",
      "longitude":86.1179022,
      "latitude":57.2787891
    },
    "9371":{
      "name":"\u0423\u0441\u043c\u0430\u043d\u043a\u0430",
      "longitude":86.1601958,
      "latitude":56.6305224
    },
    "9372":{
      "name":"\u0417\u0430\u0440\u0435\u0447\u043d\u044b\u0439",
      "longitude":86.1718726,
      "latitude":57.1791539
    },
    "9373":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u0442\u0440\u043e\u0439\u043a\u0430",
      "longitude":86.1727839,
      "latitude":56.6230148
    },
    "9374":{
      "name":"\u041a\u0443\u0435\u043d\u0434\u0430\u0442",
      "longitude":86.1815476,
      "latitude":57.114462
    },
    "9375":{
      "name":"\u0411\u043e\u0440\u0438\u0441\u043e\u0432\u0430 \u0413\u043e\u0440\u0430",
      "longitude":86.189466,
      "latitude":57.091415
    },
    "9376":{
      "name":"\u0424\u0435\u043e\u043a\u0442\u0438\u0441\u0442\u043e\u0432\u043a\u0430",
      "longitude":86.200218,
      "latitude":56.966209
    },
    "9377":{
      "name":"\u041c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":86.2234654,
      "latitude":57.1090675
    },
    "9378":{
      "name":"\u041f\u0440\u0438\u0447\u0443\u043b\u044b\u043c\u0441\u043a\u0438\u0439",
      "longitude":86.2460948,
      "latitude":57.0035883
    },
    "9379":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u0432\u0441\u043a",
      "longitude":86.2916941,
      "latitude":57.2087283
    },
    "9380":{
      "name":"\u0412\u0435\u0440\u0445 \u041a\u0443\u0435\u043d\u0434\u0430\u0442",
      "longitude":86.4029307,
      "latitude":57.1456419
    },
    "9381":{
      "name":"\u0424\u0440\u0430\u043d\u0446\u0435\u0432\u043e",
      "longitude":86.4091105,
      "latitude":57.5621624
    },
    "9382":{
      "name":"\u0412\u0430\u0441\u0438\u043b\u044c\u0435\u0432\u043a\u0430",
      "longitude":86.4674541,
      "latitude":56.6051874
    },
    "9383":{
      "name":"\u041a\u0443\u043b\u044c\u0434\u043e\u0440\u0441\u043a",
      "longitude":86.6114563,
      "latitude":56.9647395
    },
    "9384":{
      "name":"\u041b\u0438\u043d\u0434\u0430",
      "longitude":86.6425573,
      "latitude":57.1413298
    },
    "9385":{
      "name":"\u0411\u0438\u0445\u0442\u0443\u043b\u0438\u043d\u043e",
      "longitude":86.7018943,
      "latitude":56.9395681
    },
    "9386":{
      "name":"\u041b\u0438\u043b\u043b\u0438\u0435\u043d\u0433\u043e\u0444\u043a\u0430",
      "longitude":86.7203237,
      "latitude":57.0350849
    },
    "9387":{
      "name":"\u0412\u0430\u043c\u0431\u0430\u043b\u044b",
      "longitude":86.733192,
      "latitude":56.658772
    },
    "9388":{
      "name":"\u0413\u0430\u0433\u0430\u0440\u0438\u043d\u043e",
      "longitude":86.812881,
      "latitude":56.701244
    },
    "9389":{
      "name":"\u041c\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":86.8262028,
      "latitude":57.0240246
    },
    "9390":{
      "name":"\u0422\u0443\u0435\u043d\u0434\u0430\u0442",
      "longitude":86.938705,
      "latitude":56.73307
    },
    "9391":{
      "name":"\u0422\u0443\u043a\u0430\u0439",
      "longitude":87.109802,
      "latitude":56.7389867
    },
    "9392":{
      "name":"\u041e\u0440\u043b\u043e\u0432\u043a\u0430",
      "longitude":87.2906044,
      "latitude":57.0518289
    },
    "9393":{
      "name":"\u0432\u0430\u0445\u0442.\u043f. \u0427\u0443\u0439\u043a\u0430",
      "longitude":87.3753501,
      "latitude":58.0291414
    },
    "9394":{
      "name":"\u0432\u0430\u0445\u0442.\u043f. \u0416\u0430\u0440\u043e\u0432\u043a\u0430",
      "longitude":87.5434066,
      "latitude":58.0392291
    },
    "9395":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u042f\u0440",
      "longitude":87.6157751,
      "latitude":57.2275618
    },
    "9396":{
      "name":"\u0411\u0430\u0439\u0433\u0430\u043b\u044b",
      "longitude":87.8860072,
      "latitude":57.245075
    },
    "9397":{
      "name":"\u041f\u043e\u043a\u0440\u043e\u0432\u0441\u043a\u0438\u0439 \u042f\u0440",
      "longitude":88.2801091,
      "latitude":57.0784204
    },
    "9398":{
      "name":"\u041a\u0443\u044f\u043d\u043e\u0432\u0441\u043a\u0430\u044f \u0413\u0430\u0440\u044c",
      "longitude":88.3586667,
      "latitude":57.3481773
    },
    "9399":{
      "name":"\u041e\u0437\u0451\u0440\u043d\u043e\u0435",
      "longitude":88.6373285,
      "latitude":57.4761177
    },
    "9400":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0435\u0435 \u0421\u043a\u043e\u0431\u043b\u0438\u043d\u043e",
      "longitude":88.6413187,
      "latitude":57.450201
    },
    "9401":{
      "name":"\u041f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":75.134377,
      "latitude":55.70591
    },
    "9402":{
      "name":"\u0421\u0442\u0435\u043f\u0430\u043d\u043e\u0432\u043a\u0430 1-\u044f",
      "longitude":75.192276,
      "latitude":55.393391
    },
    "9403":{
      "name":"\u0420\u043e\u0436\u0434\u0435\u0441\u0442\u0432\u0435\u043d\u043a\u0430",
      "longitude":75.248589,
      "latitude":55.421307
    },
    "9404":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u043e-\u0413\u0430\u0432\u0440\u0438\u043b\u043e\u0432\u043a\u0430",
      "longitude":75.27169,
      "latitude":55.700714
    },
    "9405":{
      "name":"\u0412\u043e\u0437\u0434\u0432\u0438\u0436\u0435\u043d\u043a\u0430",
      "longitude":75.283012,
      "latitude":55.283173
    },
    "9406":{
      "name":"\u0420\u0435\u0437\u0438\u043d\u043e",
      "longitude":75.297737,
      "latitude":55.84584
    },
    "9407":{
      "name":"\u041a\u0443\u0437\u043d\u0435\u0446\u043e\u0432\u043e",
      "longitude":75.354401,
      "latitude":55.190151
    },
    "9408":{
      "name":"\u041c\u043e\u0445\u043e\u0432\u0430\u044f",
      "longitude":75.366081,
      "latitude":54.937073
    },
    "9409":{
      "name":"\u041e\u0441\u0442\u0430\u043d\u043e\u0432\u043e\u0447\u043d\u0430\u044f \u041f\u043b\u0430\u0442\u0444\u043e\u0440\u043c\u0430 \u041b\u0430\u0433",
      "longitude":75.399551,
      "latitude":55.146664
    },
    "9410":{
      "name":"\u0421\u0438\u0431\u0438\u0440\u044f\u043a",
      "longitude":75.399567,
      "latitude":55.148376
    },
    "9411":{
      "name":"\u0414\u043c\u0438\u0442\u0440\u0438\u0435\u0432\u043a\u0430",
      "longitude":75.405731,
      "latitude":55.708115
    },
    "9412":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u043d\u0438\u043a\u043e\u043b\u044c\u0441\u043a",
      "longitude":75.415215,
      "latitude":55.61195
    },
    "9413":{
      "name":"\u041f\u043b\u0430\u0442\u043e\u043d\u043e\u0432\u043a\u0430",
      "longitude":75.431587,
      "latitude":55.160053
    },
    "9414":{
      "name":"\u0417\u0435\u043b\u0451\u043d\u0430\u044f \u0413\u0440\u0438\u0432\u0430",
      "longitude":75.444588,
      "latitude":55.438675
    },
    "9415":{
      "name":"\u0417\u0435\u043b\u0451\u043d\u0430\u044f \u0420\u043e\u0449\u0430",
      "longitude":75.473854,
      "latitude":55.580673
    },
    "9416":{
      "name":"\u0420\u043e\u0437\u0435\u043d\u0442\u0430\u043b\u044c",
      "longitude":75.479279,
      "latitude":55.313221
    },
    "9417":{
      "name":"\u0427\u0438\u043d\u044f\u0432\u0438\u043d\u043e",
      "longitude":75.485817,
      "latitude":55.494972
    },
    "9418":{
      "name":"\u041e\u0441\u0442\u0430\u043d\u043e\u0432\u043e\u0447\u043d\u0430\u044f \u041f\u043b\u0430\u0442\u0444\u043e\u0440\u043c\u0430 2850",
      "longitude":75.499771,
      "latitude":55.159016
    },
    "9419":{
      "name":"\u0421\u0442\u0435\u043f\u0430\u043d\u043e\u0432\u043a\u0430 2-\u044f",
      "longitude":75.512527,
      "latitude":55.228287
    },
    "9420":{
      "name":"\u0412\u0430\u0440\u0432\u0430\u0440\u043e\u0432\u043a\u0430",
      "longitude":75.521095,
      "latitude":54.958565
    },
    "9421":{
      "name":"\u0411\u0435\u0437\u0431\u043e\u0436\u043d\u0438\u043a",
      "longitude":75.527618,
      "latitude":55.179325
    },
    "9422":{
      "name":"\u0412\u043e\u0440\u043e\u0431\u044c\u0451\u0432\u043e",
      "longitude":75.528259,
      "latitude":55.964359
    },
    "9423":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":75.568359,
      "latitude":55.497486
    },
    "9424":{
      "name":"\u041c\u0443\u0440\u0430\u0448\u0438",
      "longitude":75.580727,
      "latitude":55.719433
    },
    "9425":{
      "name":"\u0422\u0430\u0440\u043a\u0430",
      "longitude":75.632019,
      "latitude":55.61182
    },
    "9426":{
      "name":"\u041c\u0430\u043b\u044b\u0439 \u0415\u0440\u043c\u0430\u043a",
      "longitude":75.641731,
      "latitude":55.232536
    },
    "9427":{
      "name":"\u041e\u0437\u0451\u0440\u043d\u044b\u0439",
      "longitude":75.649155,
      "latitude":55.674122
    },
    "9428":{
      "name":"\u0422\u0430\u0439\u043b\u0430\u043a\u043e\u0432\u043e",
      "longitude":75.649651,
      "latitude":55.394276
    },
    "9429":{
      "name":"\u041d\u043e\u0432\u043e\u0442\u0440\u043e\u0438\u0446\u043a",
      "longitude":75.688126,
      "latitude":55.001396
    },
    "9430":{
      "name":"\u0415\u0432\u0433\u0435\u043d\u044c\u0435\u0432\u043a\u0430",
      "longitude":75.691528,
      "latitude":55.085754
    },
    "9431":{
      "name":"\u041e\u0441\u0442\u0430\u043d\u043e\u0432\u043e\u0447\u043d\u0430\u044f \u041f\u043b\u0430\u0442\u0444\u043e\u0440\u043c\u0430 \u0417\u0430\u0431",
      "longitude":75.703598,
      "latitude":55.185402
    },
    "9432":{
      "name":"\u041c\u0430\u0440\u0442\u044b\u043d\u043e\u0432\u043e",
      "longitude":75.7435,
      "latitude":56.061825
    },
    "9433":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u0421\u0442\u0430\u0440\u0438\u043d\u043a\u0430",
      "longitude":75.799927,
      "latitude":54.823059
    },
    "9434":{
      "name":"\u0420\u043e\u0434\u044c\u043a\u0438\u043d\u043e",
      "longitude":75.801201,
      "latitude":55.829128
    },
    "9435":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u043c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":75.804787,
      "latitude":55.111889
    },
    "9436":{
      "name":"\u0413\u043e\u0440\u043e\u0434\u0435\u043d\u043a\u0430",
      "longitude":75.811104,
      "latitude":54.952015
    },
    "9437":{
      "name":"\u0421\u0438\u043b\u0438\u0448",
      "longitude":75.86113,
      "latitude":55.908596
    },
    "9438":{
      "name":"\u041a\u0430\u043c\u044b\u0448\u0438\u043d\u043e",
      "longitude":75.880051,
      "latitude":54.87653
    },
    "9439":{
      "name":"\u0422\u0438\u0445\u043e\u043d\u043e\u0432\u043a\u0430",
      "longitude":75.887329,
      "latitude":55.767265
    },
    "9440":{
      "name":"\u0427\u0435\u0440\u043d\u044b\u0448\u0435\u0432\u0441\u043a\u0438\u0439",
      "longitude":75.897728,
      "latitude":55.034325
    },
    "9441":{
      "name":"\u041d\u043e\u0432\u043e\u0432\u043e\u0437\u043d\u0435\u0441\u0435\u043d\u043a\u0430",
      "longitude":75.911064,
      "latitude":55.360447
    },
    "9442":{
      "name":"\u0412\u043e\u043b\u043e\u0432\u043e",
      "longitude":75.91111,
      "latitude":54.833294
    },
    "9443":{
      "name":"\u0412\u0430\u0445\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":75.911827,
      "latitude":55.0853
    },
    "9444":{
      "name":"\u0413\u0435\u043e\u0440\u0433\u0438\u0435\u0432\u043a\u0430",
      "longitude":75.941765,
      "latitude":54.758839
    },
    "9445":{
      "name":"\u042f\u043c\u0438\u043d\u043a\u0430",
      "longitude":75.955002,
      "latitude":54.710823
    },
    "9446":{
      "name":"\u041a\u0430\u0431\u0430\u043d\u043a\u0430",
      "longitude":75.983902,
      "latitude":55.435982
    },
    "9447":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0435\u043e\u043c\u043a\u0430",
      "longitude":76.006737,
      "latitude":55.504742
    },
    "9448":{
      "name":"\u0427\u0435\u0440\u043d\u0438\u0433\u043e\u0432\u043a\u0430",
      "longitude":76.015091,
      "latitude":56.018742
    },
    "9449":{
      "name":"\u0422\u0440\u0430\u043a\u0442\u043e\u0432\u044b\u0439",
      "longitude":76.0514527,
      "latitude":55.2134709
    },
    "9450":{
      "name":"\u0421\u0442\u0430\u0440\u0430\u044f \u0421\u043a\u0438\u0440\u043b\u0430",
      "longitude":76.062889,
      "latitude":56.474876
    },
    "9451":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u0422\u0430\u0445\u0442\u0430",
      "longitude":76.070938,
      "latitude":54.700794
    },
    "9452":{
      "name":"\u041b\u0435\u0431\u044f\u0436\u044c\u0435",
      "longitude":76.071915,
      "latitude":54.913158
    },
    "9453":{
      "name":"\u041c\u0443\u0445\u0438\u043d\u043e",
      "longitude":76.085068,
      "latitude":54.523529
    },
    "9454":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u0421\u043a\u0438\u0440\u043b\u0430",
      "longitude":76.086357,
      "latitude":56.481216
    },
    "9455":{
      "name":"\u0426\u0432\u0435\u0442\u043d\u043e\u043f\u043e\u043b\u044c\u0435",
      "longitude":76.104591,
      "latitude":54.426094
    },
    "9456":{
      "name":"\u041c\u0438\u0440\u043d\u044b\u0439",
      "longitude":76.137657,
      "latitude":55.998253
    },
    "9457":{
      "name":"\u041c\u0438\u0440\u043e\u043d\u043e\u0432\u043a\u0430",
      "longitude":76.143578,
      "latitude":54.514744
    },
    "9458":{
      "name":"\u041d\u043e\u0432\u043e\u0430\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":76.150276,
      "latitude":55.750656
    },
    "9459":{
      "name":"\u0427\u0430\u043d\u044b-\u0421\u0430\u043a\u0430\u043d",
      "longitude":76.153587,
      "latitude":55.352318
    },
    "9460":{
      "name":"\u0412\u043e\u0441\u043a\u0440\u0435\u0441\u0435\u043d\u043a\u0430",
      "longitude":76.157265,
      "latitude":56.437092
    },
    "9461":{
      "name":"\u041d\u043e\u0432\u043e\u043d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":76.16066,
      "latitude":56.594982
    },
    "9462":{
      "name":"\u041c\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":76.177452,
      "latitude":54.629982
    },
    "9463":{
      "name":"\u0422\u0430\u0440\u044b\u0448\u0442\u0430",
      "longitude":76.178101,
      "latitude":55.24041
    },
    "9464":{
      "name":"\u0411\u0430\u043a\u0435\u0439\u043a\u0430",
      "longitude":76.199715,
      "latitude":56.469975
    },
    "9465":{
      "name":"\u041d\u043e\u0432\u043e\u0430\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":76.212257,
      "latitude":54.98008
    },
    "9466":{
      "name":"\u0411\u043e\u0433\u0434\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":76.216637,
      "latitude":55.317509
    },
    "9467":{
      "name":"\u041c\u0438\u043d\u0438\u043d\u043e",
      "longitude":76.220634,
      "latitude":55.223335
    },
    "9468":{
      "name":"\u0427\u0438\u0447\u043a\u0430\u043d\u043a\u0430",
      "longitude":76.220711,
      "latitude":56.099876
    },
    "9469":{
      "name":"\u041c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":76.225281,
      "latitude":55.887753
    },
    "9470":{
      "name":"\u0410\u043b\u044c\u043c\u0435\u043d\u0435\u0432\u043e",
      "longitude":76.230881,
      "latitude":56.458202
    },
    "9471":{
      "name":"\u0414\u0443\u0431\u0440\u043e\u0432\u0438\u043d\u043e",
      "longitude":76.231003,
      "latitude":55.111233
    },
    "9472":{
      "name":"\u042f\u043d\u0430\u0431\u0438\u043d\u043e",
      "longitude":76.237747,
      "latitude":55.990528
    },
    "9473":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u0422\u0430\u0445\u0442\u0430",
      "longitude":76.253967,
      "latitude":54.59808
    },
    "9474":{
      "name":"\u0414\u0443\u0431\u0440\u043e\u0432\u0438\u043d\u043e",
      "longitude":76.261375,
      "latitude":55.948261
    },
    "9475":{
      "name":"\u041c\u0430\u043b\u0438\u043d\u0438\u043d\u043e",
      "longitude":76.282463,
      "latitude":55.559647
    },
    "9476":{
      "name":"\u041e\u0437\u0451\u0440\u043d\u044b\u0439",
      "longitude":76.291435,
      "latitude":54.833111
    },
    "9477":{
      "name":"\u0422\u0430\u0431\u0443\u043b\u0433\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":76.309418,
      "latitude":54.901474
    },
    "9478":{
      "name":"\u041a\u043e\u043c\u0431\u0430\u0440",
      "longitude":76.314552,
      "latitude":55.466545
    },
    "9479":{
      "name":"\u041a\u0430\u0431\u0430\u043a\u043b\u044b",
      "longitude":76.32959,
      "latitude":55.258686
    },
    "9480":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":76.331108,
      "latitude":55.254478
    },
    "9481":{
      "name":"\u042f\u0434\u0440\u044b\u0448\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":76.333633,
      "latitude":56.484085
    },
    "9482":{
      "name":"\u0427\u0430\u044f\u0447\u044c\u0435",
      "longitude":76.333954,
      "latitude":54.701122
    },
    "9483":{
      "name":"\u041b\u0435\u0431\u044f\u0436\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":76.383004,
      "latitude":54.8150451
    },
    "9484":{
      "name":"\u0422\u044e\u0441\u043c\u0435\u043d\u044c",
      "longitude":76.392197,
      "latitude":55.840179
    },
    "9485":{
      "name":"\u0410\u0445\u0442\u044b\u0440\u043a\u0430",
      "longitude":76.402939,
      "latitude":55.710896
    },
    "9486":{
      "name":"\u0421\u0430\u0434\u043e\u0432\u043a\u0430",
      "longitude":76.418991,
      "latitude":56.473793
    },
    "9487":{
      "name":"\u041d\u043e\u0432\u043e\u0447\u0435\u043a\u0438\u043d\u043e",
      "longitude":76.419273,
      "latitude":56.515991
    },
    "9488":{
      "name":"\u0412\u0430\u0441\u0438\u043b\u044c\u0435\u0432\u043a\u0430",
      "longitude":76.434738,
      "latitude":55.340252
    },
    "9489":{
      "name":"\u0426\u0430\u0440\u0438\u0446\u044b\u043d\u043e",
      "longitude":76.439171,
      "latitude":54.998962
    },
    "9490":{
      "name":"\u0427\u0435\u043a\u0438\u0430\u0443\u043b",
      "longitude":76.460922,
      "latitude":56.482903
    },
    "9491":{
      "name":"2912 \u043a\u043c",
      "longitude":76.465233,
      "latitude":55.271759
    },
    "9492":{
      "name":"\u041f\u043e\u043b\u0442\u0430\u0432\u043a\u0430",
      "longitude":76.470329,
      "latitude":55.125957
    },
    "9493":{
      "name":"\u041f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":76.471138,
      "latitude":54.827507
    },
    "9494":{
      "name":"\u0414\u043e\u0431\u0440\u0438\u043d\u043a\u0430",
      "longitude":76.474136,
      "latitude":55.48941
    },
    "9495":{
      "name":"\u0423\u0437\u0443\u043d\u0433\u0443\u043b\u044c",
      "longitude":76.47464,
      "latitude":55.438496
    },
    "9496":{
      "name":"\u0412\u0435\u0440\u0445-\u0427\u0435\u043a\u0438\u043d\u043e",
      "longitude":76.508545,
      "latitude":56.688965
    },
    "9497":{
      "name":"\u0413\u0430\u0432\u0440\u0438\u043b\u043e\u0432\u043a\u0430",
      "longitude":76.510399,
      "latitude":56.656994
    },
    "9498":{
      "name":"\u042f\u0434\u043a\u0430\u043d",
      "longitude":76.515045,
      "latitude":56.733883
    },
    "9499":{
      "name":"\u0410\u043b\u0444\u0435\u0440\u043e\u0432\u043a\u0430",
      "longitude":76.516861,
      "latitude":54.115234
    },
    "9500":{
      "name":"\u041a\u0430\u0431\u0430\u043a\u043b\u044b",
      "longitude":76.522751,
      "latitude":55.188057
    },
    "9501":{
      "name":"\u0418\u0433\u043d\u0430\u0442\u044c\u0435\u0432\u043a\u0430",
      "longitude":76.533691,
      "latitude":55.610542
    },
    "9502":{
      "name":"\u0422\u0430\u0432\u043e\u043b\u0433\u0430",
      "longitude":76.535683,
      "latitude":56.577084
    },
    "9503":{
      "name":"\u0427\u0435\u0440\u0442\u043e\u043a\u0443\u043b\u0438\u0447",
      "longitude":76.537376,
      "latitude":55.277496
    },
    "9504":{
      "name":"\u041e\u0440\u0430\u0432\u043a\u0430",
      "longitude":76.546814,
      "latitude":55.44458
    },
    "9505":{
      "name":"\u0418\u043b\u044c\u0438\u043d\u043a\u0430",
      "longitude":76.549606,
      "latitude":55.782314
    },
    "9506":{
      "name":"\u041a\u0440\u0443\u0433\u043b\u0435\u043d\u044c\u043a\u0430\u044f",
      "longitude":76.5520381,
      "latitude":55.5562583
    },
    "9507":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u043a\u0430",
      "longitude":76.572517,
      "latitude":54.029724
    },
    "9508":{
      "name":"\u0421\u0435\u0440\u043f \u0438 \u041c\u043e\u043b\u043e\u0442",
      "longitude":76.59996,
      "latitude":55.531467
    },
    "9509":{
      "name":"\u041d\u043e\u0432\u043e\u0430\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":76.605186,
      "latitude":54.78619
    },
    "9510":{
      "name":"\u0417\u0435\u043b\u0435\u043d\u043e\u043f\u043e\u043b\u044c\u0441\u043a\u0438\u0439",
      "longitude":76.611153,
      "latitude":55.052982
    },
    "9511":{
      "name":"\u041e\u043b\u044c\u0445\u043e\u0432\u043a\u0430",
      "longitude":76.622963,
      "latitude":54.748077
    },
    "9512":{
      "name":"\u041f\u0430\u0445\u043e\u043c\u043e\u0432\u043e",
      "longitude":76.63205,
      "latitude":56.428375
    },
    "9513":{
      "name":"\u041d\u043e\u0432\u044b\u0439 \u041a\u043e\u0448\u043a\u0443\u043b\u044c",
      "longitude":76.633995,
      "latitude":54.95583
    },
    "9514":{
      "name":"\u041c\u0438\u0442\u0440\u043e\u0444\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":76.647339,
      "latitude":54.112797
    },
    "9515":{
      "name":"\u041e\u043b\u0442\u0430\u0440\u044c",
      "longitude":76.65287,
      "latitude":54.537159
    },
    "9516":{
      "name":"\u0421\u0430\u0440\u044b\u0431\u0430\u043b\u044b\u043a",
      "longitude":76.654106,
      "latitude":55.262402
    },
    "9517":{
      "name":"\u041a\u0438\u0435\u0432\u043a\u0430",
      "longitude":76.654732,
      "latitude":53.966763
    },
    "9518":{
      "name":"\u0421\u0442\u0430\u0440\u044b\u0439 \u041a\u043e\u0448\u043a\u0443\u043b\u044c",
      "longitude":76.657928,
      "latitude":54.970478
    },
    "9519":{
      "name":"\u041e\u0440\u043b\u043e\u0432\u043a\u0430",
      "longitude":76.660858,
      "latitude":54.481796
    },
    "9520":{
      "name":"\u0411\u0443\u0433\u0440\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":76.664383,
      "latitude":54.395412
    },
    "9521":{
      "name":"\u0410\u0433\u0430\u0447\u0430\u0443\u043b\u043e\u0432\u043e",
      "longitude":76.665619,
      "latitude":56.54158
    },
    "9522":{
      "name":"2926 \u043a\u043c",
      "longitude":76.671631,
      "latitude":55.295223
    },
    "9523":{
      "name":"\u041f\u0435\u0441\u0446\u044b",
      "longitude":76.672287,
      "latitude":55.300392
    },
    "9524":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":76.683456,
      "latitude":55.335461
    },
    "9525":{
      "name":"\u041a\u043e\u0432\u044b\u043b\u044c\u043d\u044b\u0439",
      "longitude":76.6874359,
      "latitude":55.1340506
    },
    "9526":{
      "name":"\u0412\u044f\u0442\u043a\u0430",
      "longitude":76.714569,
      "latitude":56.545013
    },
    "9527":{
      "name":"\u0422\u044b\u043d\u0433\u0438\u0437\u0430",
      "longitude":76.717148,
      "latitude":56.920048
    },
    "9528":{
      "name":"\u0425\u0443\u0434\u044b\u0448\u043a\u0430",
      "longitude":76.729866,
      "latitude":56.640064
    },
    "9529":{
      "name":"\u0421\u0430\u0434\u043e\u0432\u044b\u0439",
      "longitude":76.737915,
      "latitude":54.50774
    },
    "9530":{
      "name":"\u042e\u0434\u0438\u043d\u043e",
      "longitude":76.744698,
      "latitude":54.757961
    },
    "9531":{
      "name":"\u041a\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":76.745491,
      "latitude":55.184456
    },
    "9532":{
      "name":"\u041a\u043e\u0440\u043e\u0432\u0438\u043d\u043a\u0430",
      "longitude":76.764854,
      "latitude":56.54216
    },
    "9533":{
      "name":"\u041c\u0430\u0442\u0432\u0435\u0435\u0432\u043a\u0430",
      "longitude":76.8004226,
      "latitude":55.0442447
    },
    "9534":{
      "name":"\u0421\u0435\u043b\u0438\u0432\u0430\u043d\u043e\u0432\u043e",
      "longitude":76.809006,
      "latitude":53.896217
    },
    "9535":{
      "name":"\u0411\u0435\u043b\u0435\u0445\u0442\u0430",
      "longitude":76.817131,
      "latitude":55.261093
    },
    "9536":{
      "name":"\u0421\u0435\u0432\u0435\u0440",
      "longitude":76.837418,
      "latitude":55.377323
    },
    "9537":{
      "name":"\u041d\u0435\u0444\u0442\u0435\u043f\u0440\u043e\u0432\u043e\u0434",
      "longitude":76.853371,
      "latitude":55.350601
    },
    "9538":{
      "name":"\u041c\u0430\u043c\u0435\u0442\u043a\u0438\u043d\u043e",
      "longitude":76.856606,
      "latitude":55.207874
    },
    "9539":{
      "name":"\u0421\u0442\u0430\u0440\u044b\u0439 \u041c\u0430\u0439\u0437\u0430\u0441",
      "longitude":76.859398,
      "latitude":56.592129
    },
    "9540":{
      "name":"\u041a\u0430\u043c\u044b\u0448\u0438\u043d\u043a\u0430",
      "longitude":76.861397,
      "latitude":56.726513
    },
    "9541":{
      "name":"\u0411\u043e\u0447\u043a\u0430\u0440\u0435\u0432\u043a\u0430",
      "longitude":76.865082,
      "latitude":56.933842
    },
    "9542":{
      "name":"\u042e\u0440\u043a\u0438",
      "longitude":76.871216,
      "latitude":55.056797
    },
    "9543":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":76.874252,
      "latitude":56.72411
    },
    "9544":{
      "name":"\u0428\u043c\u0430\u043a\u043e\u0432\u043a\u0430",
      "longitude":76.876694,
      "latitude":56.556568
    },
    "9545":{
      "name":"\u0422\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":76.884995,
      "latitude":55.464783
    },
    "9546":{
      "name":"\u0427\u0435\u0431\u0430\u043a\u043b\u044b",
      "longitude":76.90873,
      "latitude":54.647518
    },
    "9547":{
      "name":"\u041e\u0440\u043b\u043e\u0432\u043e",
      "longitude":76.916153,
      "latitude":55.776997
    },
    "9548":{
      "name":"\u0412\u0430\u0441\u0438\u043b\u044c\u0435\u0432\u043a\u0430",
      "longitude":76.924164,
      "latitude":54.039989
    },
    "9549":{
      "name":"\u041a\u0438\u0440\u0437\u0430\u0432\u043e\u0434",
      "longitude":76.930824,
      "latitude":55.342072
    },
    "9550":{
      "name":"\u0411\u0435\u0441\u043f\u0430\u043b\u043e\u0432\u043a\u0430",
      "longitude":76.933937,
      "latitude":56.779259
    },
    "9551":{
      "name":"\u041e\u0440\u043b\u043e\u0432\u043a\u0430",
      "longitude":76.934868,
      "latitude":54.312923
    },
    "9552":{
      "name":"\u0411\u0443\u0440\u0441\u044f\u043d\u0438\u043d\u043e",
      "longitude":76.954742,
      "latitude":55.883488
    },
    "9553":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u044f\u0440\u043a\u0430",
      "longitude":76.959137,
      "latitude":55.7533
    },
    "9554":{
      "name":"\u0427\u0435\u0440\u043d\u0438\u0433\u043e\u0432\u043a\u0430",
      "longitude":76.959396,
      "latitude":55.032192
    },
    "9555":{
      "name":"\u041a\u043e\u0437\u043b\u043e\u0432\u043a\u0430",
      "longitude":76.969604,
      "latitude":55.608578
    },
    "9556":{
      "name":"\u041d\u043e\u0447\u043a\u0430",
      "longitude":76.974533,
      "latitude":55.814159
    },
    "9557":{
      "name":"\u0411\u043b\u044e\u0434\u0446\u044b",
      "longitude":76.994354,
      "latitude":54.948029
    },
    "9558":{
      "name":"\u0413\u0440\u0438\u0433\u043e\u0440\u044c\u0435\u0432\u043a\u0430",
      "longitude":77.001144,
      "latitude":55.85043
    },
    "9559":{
      "name":"\u0411\u0440\u043e\u0432\u043d\u0438\u0447\u0438",
      "longitude":77.00341,
      "latitude":55.92498
    },
    "9560":{
      "name":"\u041f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":77.01355,
      "latitude":54.436005
    },
    "9561":{
      "name":"\u041e\u043b\u044c\u0433\u0438\u043d\u043e",
      "longitude":77.015923,
      "latitude":55.971031
    },
    "9562":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":77.019653,
      "latitude":56.810169
    },
    "9563":{
      "name":"\u0424\u0435\u0434\u043e\u0441\u044c\u0435\u0432\u043a\u0430",
      "longitude":77.020546,
      "latitude":54.176254
    },
    "9564":{
      "name":"\u041a\u0430\u043d\u0430\u0432\u044b",
      "longitude":77.023521,
      "latitude":54.690323
    },
    "9565":{
      "name":"\u041a\u043e\u0437\u043b\u043e\u0432\u043a\u0430",
      "longitude":77.025963,
      "latitude":56.789669
    },
    "9566":{
      "name":"\u0421\u043f\u0430\u0441\u0441\u043a",
      "longitude":77.030457,
      "latitude":54.078785
    },
    "9567":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":77.044189,
      "latitude":56.581299
    },
    "9568":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u043f\u0430\u0432\u043b\u043e\u0432\u043a\u0430",
      "longitude":77.06356,
      "latitude":53.910324
    },
    "9569":{
      "name":"\u0410\u043d\u0438\u043a\u0438\u043d\u043e",
      "longitude":77.083511,
      "latitude":56.805183
    },
    "9570":{
      "name":"\u0413\u0435\u043e\u0440\u0433\u0438\u0435\u0432\u043a\u0430",
      "longitude":77.092056,
      "latitude":56.006912
    },
    "9571":{
      "name":"\u0411\u0438\u0448\u0431\u0443\u0433\u0430",
      "longitude":77.103439,
      "latitude":55.231308
    },
    "9572":{
      "name":"\u0411\u0435\u0440\u0435\u0441\u0442\u044f\u043d\u043a\u0430",
      "longitude":77.109833,
      "latitude":56.656303
    },
    "9573":{
      "name":"\u0417\u0435\u043d\u043a\u0438\u043d\u043e",
      "longitude":77.120537,
      "latitude":55.024097
    },
    "9574":{
      "name":"\u041a\u0443\u043b\u0438\u043a\u043e\u0432\u043a\u0430",
      "longitude":77.15139,
      "latitude":54.506477
    },
    "9575":{
      "name":"\u0423\u043a\u0440\u0430\u0438\u043d\u043a\u0430",
      "longitude":77.154922,
      "latitude":54.133984
    },
    "9576":{
      "name":"\u041f\u0438\u0442\u043e\u043c\u043d\u0438\u043a",
      "longitude":77.156006,
      "latitude":54.347511
    },
    "9577":{
      "name":"\u041a\u043e\u0448\u043a\u0443\u043b\u044c",
      "longitude":77.158821,
      "latitude":55.365917
    },
    "9578":{
      "name":"\u0427\u0438\u0441\u0442\u043e\u0435 \u041e\u0437\u0435\u0440\u043e",
      "longitude":77.165207,
      "latitude":55.659012
    },
    "9579":{
      "name":"\u0413\u0440\u0443\u0448\u0435\u0432\u043a\u0430",
      "longitude":77.176933,
      "latitude":53.91843
    },
    "9580":{
      "name":"\u0422\u0435\u0440\u0435\u043d\u0433\u0443\u043b\u044c",
      "longitude":77.1781971,
      "latitude":53.769072
    },
    "9581":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":77.179436,
      "latitude":54.440311
    },
    "9582":{
      "name":"\u0421\u0430\u0440\u0430\u0442\u043e\u0432\u043a\u0430",
      "longitude":77.181526,
      "latitude":53.745758
    },
    "9583":{
      "name":"\u0410\u043f\u043e\u043b\u0438\u0445\u0430",
      "longitude":77.181961,
      "latitude":54.069885
    },
    "9584":{
      "name":"\u041a\u043e\u043c\u0430\u0440\u043e\u0432\u043a\u0430",
      "longitude":77.196152,
      "latitude":56.57505
    },
    "9585":{
      "name":"\u0412\u0435\u0441\u0451\u043b\u044b\u0439 \u041a\u0443\u0442",
      "longitude":77.211929,
      "latitude":54.176548
    },
    "9586":{
      "name":"\u0414\u0432\u0443\u043e\u0437\u0435\u0440\u043d\u044b\u0439",
      "longitude":77.212151,
      "latitude":55.090893
    },
    "9587":{
      "name":"\u041c\u0435\u0436\u0433\u0440\u0438\u0432\u043d\u044b\u0439",
      "longitude":77.212212,
      "latitude":55.400608
    },
    "9588":{
      "name":"\u041f\u043e\u0434\u043e\u043b\u044c\u0441\u043a",
      "longitude":77.22599,
      "latitude":53.956589
    },
    "9589":{
      "name":"\u041c\u0430\u0440\u0438\u0438\u043d\u043a\u0430",
      "longitude":77.229683,
      "latitude":55.971729
    },
    "9590":{
      "name":"\u0414\u0440\u0443\u0436\u0438\u043d\u0438\u043d\u043e",
      "longitude":77.248703,
      "latitude":54.61832
    },
    "9591":{
      "name":"\u0427\u0435\u0440\u043d\u0430\u043a\u043e\u0432\u043a\u0430",
      "longitude":77.258224,
      "latitude":56.572678
    },
    "9592":{
      "name":"\u0412\u043e\u0440\u043e\u043d\u043e\u0432\u043e",
      "longitude":77.267845,
      "latitude":56.162884
    },
    "9593":{
      "name":"\u0423\u0441\u043f\u0435\u043d\u043a\u0430",
      "longitude":77.271111,
      "latitude":54.064171
    },
    "9594":{
      "name":"\u0421\u0435\u0440\u0433\u0435\u0435\u0432\u043a\u0430",
      "longitude":77.275055,
      "latitude":54.480846
    },
    "9595":{
      "name":"\u0420\u043e\u043c\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":77.278709,
      "latitude":53.859112
    },
    "9596":{
      "name":"\u041c\u043e\u0440\u0435\u0432\u043a\u0430",
      "longitude":77.286385,
      "latitude":54.238823
    },
    "9597":{
      "name":"\u041e\u0441\u0442\u0430\u043d\u043e\u0432\u043e\u0447\u043d\u0430\u044f \u041f\u043b\u0430\u0442\u0444\u043e\u0440\u043c\u0430 2966",
      "longitude":77.28759,
      "latitude":55.355782
    },
    "9598":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":77.287994,
      "latitude":54.452724
    },
    "9599":{
      "name":"\u0422\u0430\u0439\u043b\u0430\u043a\u043e\u0432\u043e",
      "longitude":77.294281,
      "latitude":55.496334
    },
    "9600":{
      "name":"\u0422\u044e\u043c\u0435\u043d\u043a\u0430",
      "longitude":77.301384,
      "latitude":54.722485
    },
    "9601":{
      "name":"\u0411\u043e\u0433\u043e\u0441\u043b\u043e\u0432\u043a\u0430",
      "longitude":77.30188,
      "latitude":53.686256
    },
    "9602":{
      "name":"\u0410\u044f\u043b\u0443",
      "longitude":77.301895,
      "latitude":55.170204
    },
    "9603":{
      "name":"III \u0418\u043d\u0442\u0435\u0440\u043d\u0430\u0446\u0438\u043e\u043d\u0430\u043b",
      "longitude":77.305206,
      "latitude":53.752346
    },
    "9604":{
      "name":"\u041d\u043e\u0432\u043e\u044f\u0431\u043b\u043e\u043d\u043e\u0432\u043a\u0430",
      "longitude":77.311028,
      "latitude":54.880627
    },
    "9605":{
      "name":"\u041a\u0443\u0440\u0441\u043a\u0438\u0439",
      "longitude":77.330734,
      "latitude":53.803959
    },
    "9606":{
      "name":"\u0423\u043b\u0443\u0446\u043a",
      "longitude":77.342354,
      "latitude":56.188484
    },
    "9607":{
      "name":"\u041d\u043e\u0432\u043e\u0430\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":77.346085,
      "latitude":55.120167
    },
    "9608":{
      "name":"\u0421\u043b\u0430\u0432\u044f\u043d\u043a\u0430",
      "longitude":77.347,
      "latitude":54.136059
    },
    "9609":{
      "name":"\u041f\u043e\u043d\u044c\u043a\u0438\u043d\u043e",
      "longitude":77.361191,
      "latitude":56.601971
    },
    "9610":{
      "name":"\u0421\u043e\u043b\u043e\u0432\u044c\u0451\u0432\u043a\u0430",
      "longitude":77.367729,
      "latitude":53.938618
    },
    "9611":{
      "name":"\u041e\u0441\u0442\u0430\u043d\u043e\u0432\u043e\u0447\u043d\u0430\u044f \u041f\u043b\u0430\u0442\u0444\u043e\u0440\u043c\u0430 142 \u043a",
      "longitude":77.371552,
      "latitude":54.281372
    },
    "9612":{
      "name":"\u041d\u043e\u0432\u043e\u0432\u0430\u0441\u0438\u043b\u044c\u0435\u0432\u0441\u043a\u0438\u0439",
      "longitude":77.373436,
      "latitude":55.043331
    },
    "9613":{
      "name":"\u0427\u0443\u0440\u044b\u043c",
      "longitude":77.376068,
      "latitude":55.396038
    },
    "9614":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u0430\u0440\u0430\u0441\u0443\u043a",
      "longitude":77.385506,
      "latitude":53.594589
    },
    "9615":{
      "name":"\u0422\u0430\u043d\u0447\u0438\u043a",
      "longitude":77.388405,
      "latitude":55.329929
    },
    "9616":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e-\u041d\u0435\u0432\u0441\u043a\u0438\u0439",
      "longitude":77.392738,
      "latitude":54.020546
    },
    "9617":{
      "name":"\u042f\u0447\u0430",
      "longitude":77.397034,
      "latitude":55.621048
    },
    "9618":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0439 \u0411\u0430\u0433\u0430\u043d",
      "longitude":77.40136,
      "latitude":54.086639
    },
    "9619":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u043c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":77.425499,
      "latitude":54.150032
    },
    "9620":{
      "name":"\u0418\u0441\u043a\u0440\u0430",
      "longitude":77.426544,
      "latitude":54.430435
    },
    "9621":{
      "name":"\u041e\u0431\u0433\u043e\u043d\u043d\u044b\u0439 \u041f\u0443\u043d\u043a\u0442 \u0420\u0430\u0439\u043e\u043d\u043d\u0430\u044f",
      "longitude":77.430077,
      "latitude":53.782181
    },
    "9622":{
      "name":"\u041c\u0430\u043b\u044c\u043a\u043e\u0432\u043e",
      "longitude":77.445335,
      "latitude":54.582111
    },
    "9623":{
      "name":"\u041a\u0430\u0437\u0430\u0440\u043c\u0430 150 \u043a\u043c",
      "longitude":77.450775,
      "latitude":54.230797
    },
    "9624":{
      "name":"\u0428\u0435\u0439\u043d\u0444\u0435\u043b\u044c\u0434",
      "longitude":77.451599,
      "latitude":53.679932
    },
    "9625":{
      "name":"\u0422\u0438\u043c\u043e\u0444\u0435\u0435\u0432\u043a\u0430",
      "longitude":77.459404,
      "latitude":56.1492
    },
    "9626":{
      "name":"151 \u043a\u043c",
      "longitude":77.4644118,
      "latitude":54.223598
    },
    "9627":{
      "name":"\u0421\u0435\u0440\u0433\u0438\u043d\u043e",
      "longitude":77.502121,
      "latitude":55.473053
    },
    "9628":{
      "name":"\u0417\u0430\u043b\u0438\u0432\u043d\u043e\u0439 \u041b\u0443\u0433",
      "longitude":77.508789,
      "latitude":55.651829
    },
    "9629":{
      "name":"\u0412\u043e\u0434\u0438\u043d\u043e",
      "longitude":77.512711,
      "latitude":54.020096
    },
    "9630":{
      "name":"\u041c\u0430\u043a\u0430\u0440\u043e\u0432\u043a\u0430",
      "longitude":77.5149,
      "latitude":56.632576
    },
    "9631":{
      "name":"\u0414\u0435\u043c\u0438\u0434\u043e\u0432\u043a\u0430",
      "longitude":77.519371,
      "latitude":53.535912
    },
    "9632":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u0425\u0443\u0442\u043e\u0440",
      "longitude":77.527771,
      "latitude":54.459072
    },
    "9633":{
      "name":"\u041d\u0430\u0437\u0430\u0440\u043e\u0432\u043e",
      "longitude":77.551079,
      "latitude":55.666454
    },
    "9634":{
      "name":"\u0410\u043d\u0442\u043e\u0448\u043a\u0438\u043d\u043e",
      "longitude":77.558159,
      "latitude":55.54488
    },
    "9635":{
      "name":"\u042f\u0441\u043d\u0430\u044f \u041f\u043e\u043b\u044f\u043d\u0430",
      "longitude":77.576012,
      "latitude":53.995941
    },
    "9636":{
      "name":"\u041f\u0443\u0447\u0438\u043d\u043d\u043e\u0435",
      "longitude":77.582077,
      "latitude":53.76392
    },
    "9637":{
      "name":"\u041b\u0443\u0433\u0430\u043d\u0441\u043a",
      "longitude":77.599037,
      "latitude":53.622169
    },
    "9638":{
      "name":"\u0422\u044b\u0447\u043a\u0438\u043d\u043e",
      "longitude":77.607452,
      "latitude":56.196781
    },
    "9639":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u043c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":77.633446,
      "latitude":53.458889
    },
    "9640":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430 2-\u044f",
      "longitude":77.638176,
      "latitude":55.846142
    },
    "9641":{
      "name":"\u041c\u0435\u0434\u0432\u0435\u0434\u043a\u0438\u043d\u043e",
      "longitude":77.638298,
      "latitude":55.599941
    },
    "9642":{
      "name":"\u041b\u0435\u043d\u0438\u043d\u0441\u043a\u043e\u0435",
      "longitude":77.642868,
      "latitude":53.954166
    },
    "9643":{
      "name":"\u041f\u0440\u0438\u043e\u043c\u0441\u043a\u0438\u0439",
      "longitude":77.6508483,
      "latitude":55.4081422
    },
    "9644":{
      "name":"\u041e\u0441\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":77.654236,
      "latitude":53.69001
    },
    "9645":{
      "name":"\u0411\u0430\u0441\u043a\u043e\u0432\u043e",
      "longitude":77.654884,
      "latitude":54.463062
    },
    "9646":{
      "name":"\u041a\u0430\u0440\u0430\u0441\u0438",
      "longitude":77.656296,
      "latitude":54.072723
    },
    "9647":{
      "name":"\u0428\u0430\u0433\u0438\u0440",
      "longitude":77.659882,
      "latitude":55.797153
    },
    "9648":{
      "name":"\u0411\u043e\u0447\u0430\u043d\u0438\u0445\u0430",
      "longitude":77.672806,
      "latitude":54.18409
    },
    "9649":{
      "name":"\u041d\u043e\u0432\u043e\u043d\u0438\u043a\u043e\u043b\u044c\u0441\u043a\u043e\u0435",
      "longitude":77.679092,
      "latitude":56.222008
    },
    "9650":{
      "name":"\u0422\u0430\u0433\u0430\u043d\u043e\u0432\u043e",
      "longitude":77.693771,
      "latitude":55.680664
    },
    "9651":{
      "name":"\u0413\u043d\u0435\u0434\u0443\u0445\u0438\u043d\u043e",
      "longitude":77.699135,
      "latitude":54.163223
    },
    "9652":{
      "name":"\u041a\u0443\u0441\u0433\u0430\u043d",
      "longitude":77.7061,
      "latitude":53.790558
    },
    "9653":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0438\u0435 \u041a\u0443\u043b\u0438\u043a\u0438",
      "longitude":77.71698,
      "latitude":56.28093
    },
    "9654":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":77.730072,
      "latitude":56.315224
    },
    "9655":{
      "name":"\u0422\u043e\u043a\u043f\u0430\u043d",
      "longitude":77.761642,
      "latitude":53.498245
    },
    "9656":{
      "name":"\u0412\u043e\u0441\u043a\u0440\u0435\u0441\u0435\u043d\u043a\u0430",
      "longitude":77.762703,
      "latitude":53.90657
    },
    "9657":{
      "name":"\u041e\u0441\u0442\u0430\u043d\u043e\u0432\u043e\u0447\u043d\u0430\u044f \u041f\u043b\u0430\u0442\u0444\u043e\u0440\u043c\u0430 2997",
      "longitude":77.764702,
      "latitude":55.356998
    },
    "9658":{
      "name":"\u0423\u0441\u0442\u044c-\u0423\u0440\u0433\u0443\u043b\u044c\u043a\u0430",
      "longitude":77.788223,
      "latitude":56.33218
    },
    "9659":{
      "name":"\u0411\u0435\u043a\u0442\u0430\u0448",
      "longitude":77.8050191,
      "latitude":55.7953241
    },
    "9660":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u0430\u0437\u0430\u0440\u0438\u043d\u043e",
      "longitude":77.812523,
      "latitude":54.371193
    },
    "9661":{
      "name":"\u0411\u0435\u0445\u0442\u0435\u043d\u044c",
      "longitude":77.814507,
      "latitude":54.849083
    },
    "9662":{
      "name":"\u042f\u0440\u043a\u043e\u0432\u043e",
      "longitude":77.818817,
      "latitude":55.649158
    },
    "9663":{
      "name":"\u0417\u0430\u0431\u043e\u0435\u0432\u043a\u0430",
      "longitude":77.838127,
      "latitude":56.333271
    },
    "9664":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u041a\u0443\u0442",
      "longitude":77.856667,
      "latitude":54.246662
    },
    "9665":{
      "name":"\u0410\u043d\u0438\u0441\u0438\u043c\u043e\u0432\u043a\u0430",
      "longitude":77.859779,
      "latitude":53.41354
    },
    "9666":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u0430\u043c\u0435\u043d\u0435\u0432\u043e",
      "longitude":77.904564,
      "latitude":55.548458
    },
    "9667":{
      "name":"\u041e\u0441\u0438\u043d\u0446\u0435\u0432\u043e",
      "longitude":77.905632,
      "latitude":55.40955
    },
    "9668":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430 1-\u044f",
      "longitude":77.905754,
      "latitude":55.705143
    },
    "9669":{
      "name":"\u0427\u0435\u0440\u043d\u043e\u0437\u0435\u0440\u043a\u0430",
      "longitude":77.934227,
      "latitude":53.829453
    },
    "9670":{
      "name":"\u041e\u0441\u0442\u0430\u043d\u043e\u0432\u043e\u0447\u043d\u0430\u044f \u041f\u043b\u043e\u0449\u0430\u0434\u043a\u0430 206 \u043a\u043c",
      "longitude":77.941147,
      "latitude":53.831409
    },
    "9671":{
      "name":"\u0415\u0444\u0440\u0435\u043c\u043e\u0432\u043a\u0430",
      "longitude":77.946259,
      "latitude":55.956306
    },
    "9672":{
      "name":"\u0412\u043b\u0430\u0434\u0438\u043c\u0438\u0440\u043e\u0432\u043a\u0430",
      "longitude":77.948326,
      "latitude":54.163395
    },
    "9673":{
      "name":"\u041d\u043e\u0432\u043e\u0442\u0430\u043d\u0434\u043e\u0432\u043e",
      "longitude":77.952988,
      "latitude":55.094765
    },
    "9674":{
      "name":"\u041e\u0441\u043e\u043b\u043e\u0434\u0438\u043d\u043e",
      "longitude":77.956596,
      "latitude":53.779228
    },
    "9675":{
      "name":"\u041d\u043e\u0432\u043e\u0433\u0440\u0435\u0431\u0435\u043d\u0449\u0438\u043a\u043e\u0432\u043e",
      "longitude":77.967499,
      "latitude":55.6688
    },
    "9676":{
      "name":"\u0413\u043e\u0440\u043d\u043e\u0441\u0442\u0430\u043b\u0438\u0445\u0430",
      "longitude":77.976143,
      "latitude":54.468975
    },
    "9677":{
      "name":"\u041a\u0430\u0432\u043a\u0430\u0437\u0441\u043a\u043e\u0435",
      "longitude":77.986908,
      "latitude":53.959908
    },
    "9678":{
      "name":"\u0422\u0440\u043e\u0438\u0446\u043a\u043e\u0435",
      "longitude":77.990845,
      "latitude":53.99807
    },
    "9679":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u044f\u0440\u043a\u043e\u0432\u043e",
      "longitude":77.99501,
      "latitude":54.882946
    },
    "9680":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u0441\u0435\u043b\u044c\u0441\u043a\u0438\u0439",
      "longitude":78.010223,
      "latitude":53.708202
    },
    "9681":{
      "name":"\u041a\u0440\u0443\u0433\u043b\u043e\u043e\u0437\u0451\u0440\u043a\u0430",
      "longitude":78.015923,
      "latitude":55.225613
    },
    "9682":{
      "name":"\u042f\u0433\u043e\u0434\u043d\u044b\u0439",
      "longitude":78.017059,
      "latitude":53.76292
    },
    "9683":{
      "name":"\u0427\u0438\u0441\u0442\u043e\u043e\u0437\u0435\u0440\u043a\u0430",
      "longitude":78.018501,
      "latitude":54.787857
    },
    "9684":{
      "name":"\u041e\u0441\u0438\u043d\u043d\u0438\u043a\u0438",
      "longitude":78.024185,
      "latitude":54.20406
    },
    "9685":{
      "name":"\u041c\u0430\u043d\u0433\u0430\u0437\u0435\u0440\u043a\u0430",
      "longitude":78.024643,
      "latitude":55.509621
    },
    "9686":{
      "name":"\u041c\u0430\u0440\u043a\u043e\u0432\u043e",
      "longitude":78.034943,
      "latitude":55.397602
    },
    "9687":{
      "name":"\u041e\u0437\u0435\u0440\u043d\u044b\u0439",
      "longitude":78.041108,
      "latitude":55.6063556
    },
    "9688":{
      "name":"\u0413\u043e\u0440\u043e\u0434\u0438\u0449\u0435",
      "longitude":78.047958,
      "latitude":54.637531
    },
    "9689":{
      "name":"\u0417\u0435\u043b\u0451\u043d\u044b\u0439 \u041b\u0443\u0433",
      "longitude":78.04924,
      "latitude":54.034332
    },
    "9690":{
      "name":"\u041c\u0438\u0440\u043d\u044b\u0439",
      "longitude":78.050591,
      "latitude":55.684864
    },
    "9691":{
      "name":"\u042f\u0440\u043e\u043a",
      "longitude":78.055222,
      "latitude":53.768444
    },
    "9692":{
      "name":"\u041c\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":78.055977,
      "latitude":56.396725
    },
    "9693":{
      "name":"\u041e\u0441\u0442\u0430\u043d\u043e\u0432\u043e\u0447\u043d\u0430\u044f \u041f\u043b\u0430\u0442\u0444\u043e\u0440\u043c\u0430 3017",
      "longitude":78.074364,
      "latitude":55.335678
    },
    "9694":{
      "name":"\u0423\u0441\u0442\u044c-\u0422\u0430\u043d\u0434\u043e\u0432\u043a\u0430",
      "longitude":78.080795,
      "latitude":55.006767
    },
    "9695":{
      "name":"\u0423\u0440\u0433\u0443\u043b\u044c",
      "longitude":78.083176,
      "latitude":56.695309
    },
    "9696":{
      "name":"\u041a\u0430\u0440\u0430\u0447\u0438\u043b\u0438\u043a",
      "longitude":78.08474,
      "latitude":53.622635
    },
    "9697":{
      "name":"\u041d\u043e\u0432\u043e\u043c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":78.091011,
      "latitude":54.745502
    },
    "9698":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u0433\u0440\u0435\u0431\u0435\u043d\u0449\u0438\u043a\u043e\u0432\u043e",
      "longitude":78.094139,
      "latitude":55.440559
    },
    "9699":{
      "name":"\u0411\u0440\u043e\u043d\u0437\u043e\u0432\u043a\u0430",
      "longitude":78.107613,
      "latitude":53.950466
    },
    "9700":{
      "name":"\u0421\u0442\u0435\u043f\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":78.115097,
      "latitude":55.794178
    },
    "9701":{
      "name":"\u041e\u0441\u0442\u0430\u043d\u043e\u0432\u043e\u0447\u043d\u0430\u044f \u041f\u043b\u0430\u0442\u0444\u043e\u0440\u043c\u0430 3020",
      "longitude":78.124146,
      "latitude":55.331879
    },
    "9702":{
      "name":"\u0423\u0434\u0430\u0440\u043d\u0438\u043a",
      "longitude":78.130394,
      "latitude":56.379856
    },
    "9703":{
      "name":"\u0422\u0430\u043d\u0434\u043e\u0432",
      "longitude":78.140656,
      "latitude":55.161213
    },
    "9704":{
      "name":"\u041a\u0430\u0437\u0430\u0442\u043e\u0432\u043e",
      "longitude":78.140953,
      "latitude":55.652992
    },
    "9705":{
      "name":"\u0428\u0438\u0440\u043e\u043a\u0430\u044f \u041a\u0443\u0440\u044c\u044f",
      "longitude":78.142319,
      "latitude":54.56995
    },
    "9706":{
      "name":"\u041a\u0430\u0432\u043a\u0443\u0439",
      "longitude":78.159012,
      "latitude":53.649128
    },
    "9707":{
      "name":"\u041e\u0441\u0442\u0430\u043d\u043e\u0432\u043e\u0447\u043d\u0430\u044f \u041f\u043b\u0430\u0442\u0444\u043e\u0440\u043c\u0430 3023",
      "longitude":78.170486,
      "latitude":55.339588
    },
    "9708":{
      "name":"\u0416\u0443\u0440\u0430\u0432\u043b\u0435\u0432\u043a\u0430",
      "longitude":78.181244,
      "latitude":55.602814
    },
    "9709":{
      "name":"\u0427\u0435\u0431\u0430\u0447\u044c\u0435",
      "longitude":78.195496,
      "latitude":53.736301
    },
    "9710":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0438\u0435 \u041b\u0443\u043a\u0438",
      "longitude":78.203194,
      "latitude":54.040051
    },
    "9711":{
      "name":"\u041a\u0443\u0447\u0443\u0433\u0443\u0440",
      "longitude":78.213242,
      "latitude":53.995731
    },
    "9712":{
      "name":"\u041e\u0431\u0433\u043e\u043d\u043d\u044b\u0439 \u041f\u0443\u043d\u043a\u0442 \u0427\u0435\u0431\u0430\u0447\u0438\u0439",
      "longitude":78.214592,
      "latitude":53.758038
    },
    "9713":{
      "name":"\u041d\u043e\u0432\u043e\u0430\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":78.217712,
      "latitude":54.727821
    },
    "9714":{
      "name":"\u0412\u0435\u0441\u0451\u043b\u0430\u044f",
      "longitude":78.224602,
      "latitude":56.606434
    },
    "9715":{
      "name":"\u0418\u0432\u0443\u0448\u043a\u0430",
      "longitude":78.224854,
      "latitude":55.542126
    },
    "9716":{
      "name":"\u0414\u0443\u043d\u0430\u0435\u0432\u043a\u0430",
      "longitude":78.225616,
      "latitude":55.220062
    },
    "9717":{
      "name":"\u041d\u0438\u0436\u043d\u0435\u0431\u0430\u044f\u043d\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":78.237671,
      "latitude":53.860062
    },
    "9718":{
      "name":"\u0411\u0435\u0440\u0433\u0443\u043b\u044c",
      "longitude":78.258331,
      "latitude":55.607029
    },
    "9719":{
      "name":"\u041a\u0430\u0440\u0430\u0441\u0430\u0440\u0442",
      "longitude":78.261238,
      "latitude":53.624016
    },
    "9720":{
      "name":"\u041c\u0430\u043c\u043e\u043d",
      "longitude":78.262474,
      "latitude":54.442963
    },
    "9721":{
      "name":"\u0413\u043e\u043b\u043e\u0432\u0430\u043d\u043e\u0432\u043e",
      "longitude":78.270508,
      "latitude":54.985821
    },
    "9722":{
      "name":"\u0421\u0438\u0437\u0435\u0432\u043e",
      "longitude":78.273209,
      "latitude":54.897358
    },
    "9723":{
      "name":"\u0421\u0442\u0435\u043a\u043b\u044f\u043d\u043d\u044b\u0439",
      "longitude":78.278206,
      "latitude":53.757694
    },
    "9724":{
      "name":"\u041c\u0430\u043b\u044b\u0435 \u041a\u0430\u0439\u043b\u044b",
      "longitude":78.283661,
      "latitude":55.419395
    },
    "9725":{
      "name":"\u041e\u0441\u0442\u0430\u043d\u043e\u0432\u043e\u0447\u043d\u0430\u044f \u041f\u043b\u043e\u0449\u0430\u0434\u043a\u0430 391 \u043a\u043c",
      "longitude":78.286911,
      "latitude":53.756035
    },
    "9726":{
      "name":"\u0417\u0430\u0440\u0435\u0447\u043d\u044b\u0439",
      "longitude":78.289137,
      "latitude":55.4709493
    },
    "9727":{
      "name":"\u041a\u043e\u0440\u0434\u043e\u043d",
      "longitude":78.293442,
      "latitude":56.614075
    },
    "9728":{
      "name":"\u0421\u0432\u0435\u0442\u043b\u043e\u0435",
      "longitude":78.296608,
      "latitude":54.491657
    },
    "9729":{
      "name":"\u041d\u0435\u043c\u043a\u0438",
      "longitude":78.317337,
      "latitude":54.31348
    },
    "9730":{
      "name":"\u0422\u043e\u043a\u0430\u0440\u0435\u0432\u043a\u0430",
      "longitude":78.345856,
      "latitude":53.594345
    },
    "9731":{
      "name":"\u0413\u0440\u0430\u043c\u043e\u0442\u0438\u043d\u043e",
      "longitude":78.35257,
      "latitude":53.745838
    },
    "9732":{
      "name":"\u0413\u043e\u0440\u043a\u0430",
      "longitude":78.356316,
      "latitude":55.406998
    },
    "9733":{
      "name":"\u0429\u0435\u043b\u0447\u0438\u0445\u0430",
      "longitude":78.38829,
      "latitude":54.664314
    },
    "9734":{
      "name":"\u041e\u0437\u0435\u0440\u044f\u043d\u043a\u0430",
      "longitude":78.394798,
      "latitude":53.621639
    },
    "9735":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u041a\u0443\u0440\u044c\u044f",
      "longitude":78.398613,
      "latitude":53.843384
    },
    "9736":{
      "name":"\u0412\u0430\u0433\u0430\u043d\u043e\u0432\u043e",
      "longitude":78.402603,
      "latitude":55.872227
    },
    "9737":{
      "name":"\u041f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":78.412079,
      "latitude":54.114002
    },
    "9738":{
      "name":"\u041d\u0430\u0434\u0435\u0436\u0434\u0438\u043d\u043a\u0430",
      "longitude":78.425438,
      "latitude":56.772854
    },
    "9739":{
      "name":"\u041c\u0430\u043b\u0438\u043d\u0438\u043d\u043e",
      "longitude":78.436401,
      "latitude":55.468014
    },
    "9740":{
      "name":"\u0410\u043d\u0433\u0430\u043d",
      "longitude":78.45118,
      "latitude":55.64389
    },
    "9741":{
      "name":"\u041f\u0430\u0442\u0440\u0443\u0448\u0435\u0432\u043e",
      "longitude":78.45153,
      "latitude":55.575287
    },
    "9742":{
      "name":"\u041d\u043e\u0432\u043e\u0433\u0443\u0442\u043e\u0432\u043e",
      "longitude":78.460533,
      "latitude":55.308029
    },
    "9743":{
      "name":"\u0421\u0430\u0440\u0442\u0430\u043a\u043e\u0432\u043e",
      "longitude":78.475235,
      "latitude":55.457317
    },
    "9744":{
      "name":"\u041a\u0440\u044b\u043b\u043e\u0432\u043a\u0430",
      "longitude":78.483849,
      "latitude":54.025089
    },
    "9745":{
      "name":"\u041a\u0430\u0440\u043c\u044b\u0448\u0430\u043a",
      "longitude":78.510201,
      "latitude":55.18119
    },
    "9746":{
      "name":"\u041f\u043e\u043c\u0435\u043b\u044c\u0446\u0435\u0432\u043e",
      "longitude":78.51355,
      "latitude":55.463673
    },
    "9747":{
      "name":"\u041d\u043e\u0432\u043e\u0433\u0440\u0435\u0431\u0435\u043d\u0449\u0438\u043a\u043e\u0432\u043e",
      "longitude":78.516525,
      "latitude":54.901154
    },
    "9748":{
      "name":"\u041d\u0435\u0441\u0442\u0435\u0440\u043e\u0432\u043a\u0430",
      "longitude":78.529671,
      "latitude":53.784161
    },
    "9749":{
      "name":"\u041e\u0441\u0442\u0430\u043d\u043e\u0432\u043e\u0447\u043d\u0430\u044f \u041f\u043b\u0430\u0442\u0444\u043e\u0440\u043c\u0430 3046",
      "longitude":78.530144,
      "latitude":55.359028
    },
    "9750":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":78.560341,
      "latitude":54.568199
    },
    "9751":{
      "name":"\u0421\u0432\u043e\u0431\u043e\u0434\u043d\u044b\u0439 \u0422\u0440\u0443\u0434",
      "longitude":78.567085,
      "latitude":53.662048
    },
    "9752":{
      "name":"\u0427\u0438\u0447\u0430",
      "longitude":78.579536,
      "latitude":54.745514
    },
    "9753":{
      "name":"\u0411\u0443\u0440\u0443\u043d\u0434\u0443\u043a\u043e\u0432\u043e",
      "longitude":78.580544,
      "latitude":55.495972
    },
    "9754":{
      "name":"\u0418\u0447\u043a\u0430\u043b\u0430",
      "longitude":78.582069,
      "latitude":56.62888
    },
    "9755":{
      "name":"\u0410\u043a\u043a\u0443\u043b\u044c",
      "longitude":78.588257,
      "latitude":55.63324
    },
    "9756":{
      "name":"\u041c\u0430\u043b\u043e\u043a\u0430\u0440\u0430\u0433\u0430\u0435\u0432\u043a\u0430",
      "longitude":78.591698,
      "latitude":56.647511
    },
    "9757":{
      "name":"\u0410\u0440\u0438\u0441\u043e\u0432\u043e",
      "longitude":78.627556,
      "latitude":55.273441
    },
    "9758":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u043f\u0430\u0432\u043b\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":78.642738,
      "latitude":54.919403
    },
    "9759":{
      "name":"\u0427\u0443\u043a\u043b\u0430\u0439\u0434\u0430",
      "longitude":78.643784,
      "latitude":55.499615
    },
    "9760":{
      "name":"\u0410\u0431\u0430\u043a\u0443\u043c\u043e\u0432\u043e",
      "longitude":78.645348,
      "latitude":55.191761
    },
    "9761":{
      "name":"\u041c\u043e\u0440\u043e\u0437\u043e\u0432\u043a\u0430",
      "longitude":78.649918,
      "latitude":55.425728
    },
    "9762":{
      "name":"\u0411\u0430\u0440\u043b\u0430\u043a\u0443\u043b\u044c",
      "longitude":78.668205,
      "latitude":54.306973
    },
    "9763":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u0438\u0435\u0432\u043a\u0430",
      "longitude":78.669472,
      "latitude":55.579308
    },
    "9764":{
      "name":"\u041d\u043e\u0432\u043e\u043f\u043e\u043a\u0440\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":78.696655,
      "latitude":54.22139
    },
    "9765":{
      "name":"\u0421\u0443\u0440\u0433\u0443\u0442\u044b",
      "longitude":78.716995,
      "latitude":56.062714
    },
    "9766":{
      "name":"\u041d\u043e\u0432\u043e\u043f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":78.740005,
      "latitude":56.290577
    },
    "9767":{
      "name":"\u0423\u0441\u043f\u0435\u043d\u0441\u043a\u0438\u0439",
      "longitude":78.740089,
      "latitude":53.657196
    },
    "9768":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u042f\u0440",
      "longitude":78.741219,
      "latitude":55.020565
    },
    "9769":{
      "name":"\u041c\u0430\u043b\u044b\u0448\u0435\u0432\u043e",
      "longitude":78.752159,
      "latitude":54.980942
    },
    "9770":{
      "name":"\u0422\u0440\u0443\u043d\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":78.752945,
      "latitude":55.343151
    },
    "9771":{
      "name":"\u0420\u044f\u043c\u0441\u043a\u043e\u0439",
      "longitude":78.787758,
      "latitude":54.28968
    },
    "9772":{
      "name":"\u041e\u0441\u0438\u043d\u043d\u0438\u043a\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":78.79557,
      "latitude":53.890572
    },
    "9773":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u043e\u0442\u043e\u0432\u043e",
      "longitude":78.810822,
      "latitude":54.551765
    },
    "9774":{
      "name":"\u041f\u0435\u043d\u0437\u0438\u043d\u043e",
      "longitude":78.813477,
      "latitude":55.287228
    },
    "9775":{
      "name":"\u0413\u043e\u0440\u044c\u043a\u043e\u0435 \u041e\u0437\u0435\u0440\u043e",
      "longitude":78.815598,
      "latitude":54.879601
    },
    "9776":{
      "name":"\u0412\u0438\u0448\u043d\u044f\u043a\u0438",
      "longitude":78.829483,
      "latitude":55.531284
    },
    "9777":{
      "name":"\u041f\u0430\u0432\u043b\u043e\u0432\u043a\u0430",
      "longitude":78.835594,
      "latitude":55.53933
    },
    "9778":{
      "name":"\u041d\u043e\u0432\u043e\u0430\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":78.837326,
      "latitude":55.676636
    },
    "9779":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":78.842796,
      "latitude":56.346252
    },
    "9780":{
      "name":"\u041e\u0441\u0438\u043d\u043e\u0432\u043e",
      "longitude":78.842896,
      "latitude":55.463005
    },
    "9781":{
      "name":"\u0425\u0430\u043f\u043e\u0432\u043e",
      "longitude":78.845253,
      "latitude":54.712902
    },
    "9782":{
      "name":"\u0414\u043c\u0438\u0442\u0440\u0438\u0435\u0432\u0441\u043a\u0438\u0439",
      "longitude":78.850739,
      "latitude":55.406418
    },
    "9783":{
      "name":"\u041d\u043e\u0432\u043e\u0449\u0435\u0440\u0431\u0430\u043a\u0438",
      "longitude":78.892815,
      "latitude":54.941647
    },
    "9784":{
      "name":"\u0421\u0442\u0430\u0440\u044b\u0439 \u041a\u0430\u0440\u0430\u043f\u0443\u0437",
      "longitude":78.90519,
      "latitude":55.067001
    },
    "9785":{
      "name":"\u041e\u0441\u0442\u0430\u043d\u043e\u0432\u043e\u0447\u043d\u0430\u044f \u041f\u043b\u0430\u0442\u0444\u043e\u0440\u043c\u0430 3071",
      "longitude":78.916733,
      "latitude":55.34465
    },
    "9786":{
      "name":"\u0415\u043f\u0430\u043d\u0435\u0448\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":78.918709,
      "latitude":55.643097
    },
    "9787":{
      "name":"\u0420\u0430\u043a\u0438\u0442\u043d\u0438\u043a\u0438",
      "longitude":78.921211,
      "latitude":55.350056
    },
    "9788":{
      "name":"\u041d\u043e\u0432\u043e\u0433\u043e\u0440\u043d\u043e\u0441\u0442\u0430\u043b\u0435\u0432\u043e",
      "longitude":78.923653,
      "latitude":54.378296
    },
    "9789":{
      "name":"\u0410\u043b\u0435\u0448\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":78.943741,
      "latitude":56.339302
    },
    "9790":{
      "name":"\u0415\u043b\u0438\u0437\u0430\u0432\u0435\u0442\u0438\u043d\u043a\u0430",
      "longitude":78.973412,
      "latitude":55.654449
    },
    "9791":{
      "name":"\u0411\u0435\u0440\u0435\u0436\u043a\u0438",
      "longitude":78.979401,
      "latitude":54.756916
    },
    "9792":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u0432\u043a\u0430",
      "longitude":79.000275,
      "latitude":55.484035
    },
    "9793":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430 2-\u044f",
      "longitude":79.014717,
      "latitude":55.18631
    },
    "9794":{
      "name":"\u0413\u0430\u043d\u0438\u043d\u043e",
      "longitude":79.020302,
      "latitude":53.759064
    },
    "9795":{
      "name":"\u0413\u0440\u0438\u0432\u0435\u043d\u0441\u043a\u0438\u0439",
      "longitude":79.032288,
      "latitude":54.955467
    },
    "9796":{
      "name":"\u041d\u043e\u0432\u044b\u0439 \u041a\u0430\u0440\u0430\u043f\u0443\u0437",
      "longitude":79.089844,
      "latitude":55.133221
    },
    "9797":{
      "name":"\u0414\u0440\u0443\u0436\u043d\u044b\u0439",
      "longitude":79.095459,
      "latitude":54.43375
    },
    "9798":{
      "name":"\u0423\u0433\u0443\u0440\u043c\u0430\u043d\u0441\u043a\u0438\u0439",
      "longitude":79.110863,
      "latitude":55.68951
    },
    "9799":{
      "name":"\u041f\u0430\u043b\u043a\u0438\u043d \u0412\u043e\u0434\u043e\u043f\u043e\u0439",
      "longitude":79.112587,
      "latitude":53.816578
    },
    "9800":{
      "name":"\u0416\u0434\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":79.143188,
      "latitude":55.378922
    },
    "9801":{
      "name":"\u041d\u043e\u0432\u043e\u043b\u043e\u0431\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":79.147041,
      "latitude":53.842232
    },
    "9802":{
      "name":"\u0410\u043d\u0434\u0440\u0435\u0435\u0432\u043a\u0430",
      "longitude":79.148392,
      "latitude":55.709122
    },
    "9803":{
      "name":"\u0413\u0430\u043d\u0434\u0438\u0447\u0438",
      "longitude":79.174881,
      "latitude":55.040562
    },
    "9804":{
      "name":"\u0411\u0435\u043b\u043e\u043e\u0437\u0435\u0440\u043d\u044b\u0439",
      "longitude":79.183792,
      "latitude":55.155941
    },
    "9805":{
      "name":"\u0418\u043b\u044c\u0438\u043d\u043a\u0430",
      "longitude":79.184761,
      "latitude":55.502914
    },
    "9806":{
      "name":"\u041a\u0430\u0440\u0435\u0432\u0441\u043a\u0438\u0439",
      "longitude":79.193771,
      "latitude":54.298725
    },
    "9807":{
      "name":"\u0421\u0435\u0440\u0433\u0438\u0435\u0432\u043a\u0430",
      "longitude":79.219955,
      "latitude":55.73613
    },
    "9808":{
      "name":"\u041b\u0435\u043d\u0438\u043d\u0433\u0440\u0430\u0434\u0441\u043a\u0438\u0439",
      "longitude":79.236702,
      "latitude":54.129108
    },
    "9809":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":79.255577,
      "latitude":55.649551
    },
    "9810":{
      "name":"\u0413\u043e\u043b\u0443\u0431\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":79.272072,
      "latitude":53.703159
    },
    "9811":{
      "name":"\u041a\u043e\u043b\u043c\u0430\u043a\u043e\u0432\u043e",
      "longitude":79.275902,
      "latitude":55.434338
    },
    "9812":{
      "name":"\u041a\u0430\u043b\u0438\u043d\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":79.28511,
      "latitude":53.767273
    },
    "9813":{
      "name":"\u0411\u0435\u043b\u043e\u043b\u0435\u0431\u044f\u0436\u0438\u0439",
      "longitude":79.289856,
      "latitude":54.981464
    },
    "9814":{
      "name":"\u0421\u0443\u0445\u043e\u0434\u043e\u043b\u044c\u0435",
      "longitude":79.319244,
      "latitude":55.04636
    },
    "9815":{
      "name":"\u041a\u043b\u0443\u0431\u043d\u0438\u0447\u043d\u0430\u044f",
      "longitude":79.338905,
      "latitude":55.323067
    },
    "9816":{
      "name":"\u041a\u043b\u0443\u0431\u043d\u0438\u0447\u043d\u044b\u0439",
      "longitude":79.350998,
      "latitude":55.330067
    },
    "9817":{
      "name":"\u041a\u0440\u0430\u0441\u0438\u043a\u043e\u0432\u043e",
      "longitude":79.351974,
      "latitude":55.906281
    },
    "9818":{
      "name":"\u041f\u043e\u0434\u043b\u0435\u0441\u043d\u044b\u0439",
      "longitude":79.382889,
      "latitude":55.289211
    },
    "9819":{
      "name":"\u0428\u0443\u0448\u043a\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":79.387894,
      "latitude":55.388069
    },
    "9820":{
      "name":"\u0417\u0443\u0435\u0432\u0441\u043a\u0438\u0439",
      "longitude":79.391129,
      "latitude":53.758366
    },
    "9821":{
      "name":"\u041f\u043b\u0435\u0445\u0430\u043d\u043e\u0432\u043e",
      "longitude":79.429359,
      "latitude":54.36208
    },
    "9822":{
      "name":"\u041b\u0443\u0433\u043e\u0432\u043e\u0439",
      "longitude":79.435349,
      "latitude":54.097656
    },
    "9823":{
      "name":"\u0423\u0441\u043f\u0435\u043d\u0441\u043a\u0438\u0439",
      "longitude":79.435738,
      "latitude":53.930779
    },
    "9824":{
      "name":"\u041a\u0441\u0435\u043d\u044c\u0435\u0432\u043a\u0430",
      "longitude":79.438141,
      "latitude":55.440708
    },
    "9825":{
      "name":"\u041a\u0438\u0440\u0438\u043b\u043b\u043e\u0432\u043a\u0430",
      "longitude":79.460876,
      "latitude":55.12022
    },
    "9826":{
      "name":"\u041a\u0440\u043e\u0442\u043e\u0432\u043e",
      "longitude":79.462044,
      "latitude":54.769531
    },
    "9827":{
      "name":"\u0426\u0435\u043d\u0442\u0440\u0430\u043b\u044c\u043d\u044b\u0439",
      "longitude":79.47274,
      "latitude":53.750866
    },
    "9828":{
      "name":"\u0415\u043b\u0430\u043d\u043a\u0430",
      "longitude":79.49588,
      "latitude":55.82782
    },
    "9829":{
      "name":"\u0415\u0436\u0443\u043b\u0430",
      "longitude":79.50882,
      "latitude":55.699974
    },
    "9830":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u041a\u0430\u0447\u0435\u043c\u043a\u0430",
      "longitude":79.52298,
      "latitude":55.397732
    },
    "9831":{
      "name":"\u041d\u043e\u0432\u043e\u0431\u043e\u0440\u043e\u0434\u0438\u043d\u043e",
      "longitude":79.531471,
      "latitude":55.511761
    },
    "9832":{
      "name":"\u0423\u0440\u043e\u0436\u0430\u0439\u043d\u044b\u0439",
      "longitude":79.532356,
      "latitude":53.79451
    },
    "9833":{
      "name":"\u0426\u0435\u043b\u0438\u043d\u043d\u044b\u0439",
      "longitude":79.536957,
      "latitude":53.75066
    },
    "9834":{
      "name":"\u0425\u0440\u043e\u043c\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":79.54306,
      "latitude":54.79192
    },
    "9835":{
      "name":"\u041b\u0435\u0431\u0435\u0434\u0438\u043d\u043a\u0430",
      "longitude":79.552071,
      "latitude":55.596191
    },
    "9836":{
      "name":"\u0421\u0442\u0435\u043f\u043d\u043e\u0439",
      "longitude":79.578636,
      "latitude":53.922436
    },
    "9837":{
      "name":"\u0410\u0441\u0435\u043d\u043a\u0440\u0438\u0442\u043e\u0432\u043e",
      "longitude":79.58094,
      "latitude":55.239681
    },
    "9838":{
      "name":"\u041a\u043e\u043c\u0435\u043d\u0434\u0430\u043d\u0442\u043a\u0430",
      "longitude":79.627762,
      "latitude":54.603741
    },
    "9839":{
      "name":"\u0417\u0435\u043b\u0451\u043d\u0430\u044f \u0420\u043e\u0449\u0430",
      "longitude":79.647575,
      "latitude":53.903896
    },
    "9840":{
      "name":"\u0410\u0442\u043a\u0443\u043b\u044c",
      "longitude":79.655182,
      "latitude":54.971306
    },
    "9841":{
      "name":"\u041d\u043e\u0432\u043e\u0434\u043e\u0432\u043e\u043b\u0435\u043d\u0441\u043a\u0438\u0439",
      "longitude":79.671005,
      "latitude":54.581715
    },
    "9842":{
      "name":"\u041a\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":79.675919,
      "latitude":55.144539
    },
    "9843":{
      "name":"\u0420\u0435\u0432\u0443\u043d\u043a\u0430",
      "longitude":79.686958,
      "latitude":55.703434
    },
    "9844":{
      "name":"\u0411\u0435\u0441\u043f\u044f\u0442\u044b\u0439",
      "longitude":79.696709,
      "latitude":54.185463
    },
    "9845":{
      "name":"\u0411\u0440\u044f\u043d\u0441\u043a\u0438\u0439",
      "longitude":79.745583,
      "latitude":54.208271
    },
    "9846":{
      "name":"\u041e\u0440\u043b\u043e\u0432\u043a\u0430",
      "longitude":79.754173,
      "latitude":55.295883
    },
    "9847":{
      "name":"\u041f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":79.760963,
      "latitude":54.36541
    },
    "9848":{
      "name":"\u0425\u0430\u0431\u0430\u0440\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":79.764671,
      "latitude":53.846436
    },
    "9849":{
      "name":"\u0411\u0430\u0433\u0430\u043d",
      "longitude":79.7743,
      "latitude":54.511185
    },
    "9850":{
      "name":"\u041a\u0440\u0435\u0449\u0435\u043d\u0441\u043a\u0438\u0439",
      "longitude":79.778122,
      "latitude":55.404881
    },
    "9851":{
      "name":"\u041c\u043e\u0441\u043a\u043e\u0432\u043a\u0430",
      "longitude":79.794975,
      "latitude":55.247791
    },
    "9852":{
      "name":"\u0410\u0447\u0435\u043a\u0430\u043d\u043a\u0430",
      "longitude":79.795174,
      "latitude":55.519703
    },
    "9853":{
      "name":"\u0425\u0435\u0440\u0441\u043e\u043d\u043a\u0430",
      "longitude":79.799683,
      "latitude":55.055027
    },
    "9854":{
      "name":"\u0426\u0435\u043b\u0438\u043d\u043d\u044b\u0439",
      "longitude":79.821953,
      "latitude":54.178032
    },
    "9855":{
      "name":"\u0417\u0430\u0440\u0435\u0447\u043d\u043e\u0443\u0431\u0438\u043d\u0441\u043a\u0430\u044f",
      "longitude":79.89006,
      "latitude":55.529381
    },
    "9856":{
      "name":"\u0421\u043e\u043b\u043e\u043d\u0446\u043e\u0432\u044b\u0439",
      "longitude":79.902443,
      "latitude":54.808773
    },
    "9857":{
      "name":"\u0418\u0432\u0430\u043d\u043a\u0438\u043d\u043e",
      "longitude":79.915459,
      "latitude":54.890182
    },
    "9858":{
      "name":"\u0421\u0430\u0440\u044b\u0431\u0430\u043b\u044b\u043a",
      "longitude":79.952744,
      "latitude":54.750668
    },
    "9859":{
      "name":"\u0424\u0438\u043b\u0438\u043d\u043e",
      "longitude":79.954002,
      "latitude":55.285664
    },
    "9860":{
      "name":"\u0420\u043e\u0436\u0434\u0435\u0441\u0442\u0432\u0435\u043d\u0441\u043a\u0438\u0439",
      "longitude":79.985756,
      "latitude":54.021843
    },
    "9861":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u043c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":79.996246,
      "latitude":55.098671
    },
    "9862":{
      "name":"\u0411\u0435\u0440\u043a\u0443\u0442\u044b",
      "longitude":79.99929,
      "latitude":55.182129
    },
    "9863":{
      "name":"\u0413\u0440\u0443\u0437\u0434\u0435\u0432\u043a\u0430",
      "longitude":80.006363,
      "latitude":55.254131
    },
    "9864":{
      "name":"\u0411\u0435\u0437\u043d\u043e\u0433\u043e\u0435",
      "longitude":80.039284,
      "latitude":54.404057
    },
    "9865":{
      "name":"\u041a\u0430\u0437\u0430\u0440\u043c\u0430 3144 \u043a\u043c",
      "longitude":80.050713,
      "latitude":55.243355
    },
    "9866":{
      "name":"\u0417\u0435\u043c\u0438\u0440\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":80.066071,
      "latitude":53.997253
    },
    "9867":{
      "name":"\u0411\u0435\u0437\u043b\u044e\u0434\u043d\u044b\u0439",
      "longitude":80.0662008,
      "latitude":55.2293953
    },
    "9868":{
      "name":"\u041b\u0438\u0441\u044c\u0438 \u041d\u043e\u0440\u043a\u0438",
      "longitude":80.08741,
      "latitude":55.871311
    },
    "9869":{
      "name":"\u0414\u0430\u043d\u0438\u043b\u043e\u0432\u0441\u043a\u0430\u044f \u0424\u0435\u0440\u043c\u0430",
      "longitude":80.117798,
      "latitude":54.717278
    },
    "9870":{
      "name":"\u041b\u0435\u0431\u0435\u0434\u0435\u0432\u0441\u043a\u0438\u0439",
      "longitude":80.150917,
      "latitude":55.230385
    },
    "9871":{
      "name":"\u0411\u0430\u0440\u0430\u043d\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":80.175125,
      "latitude":54.928192
    },
    "9872":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u043c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":80.184593,
      "latitude":55.042706
    },
    "9873":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u0441\u043a\u0438\u0439",
      "longitude":80.211914,
      "latitude":54.129246
    },
    "9874":{
      "name":"\u0423\u0441\u0442\u044c-\u0421\u0443\u043c\u044b",
      "longitude":80.251602,
      "latitude":54.847485
    },
    "9875":{
      "name":"\u041c\u043e\u0441\u043a\u0432\u0438\u043d\u043a\u0430",
      "longitude":80.257523,
      "latitude":54.737225
    },
    "9876":{
      "name":"\u0427\u0435\u0440\u043d\u044f\u0432\u0441\u043a\u0438\u0439",
      "longitude":80.257607,
      "latitude":55.033329
    },
    "9877":{
      "name":"\u041c\u043e\u0441\u043a\u0432\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":80.301247,
      "latitude":54.702415
    },
    "9878":{
      "name":"\u0422\u0440\u0435\u0442\u044c\u044f\u043a\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":80.312057,
      "latitude":55.427532
    },
    "9879":{
      "name":"\u0428\u0438\u0431\u0430\u043a\u0438",
      "longitude":80.345703,
      "latitude":55.321091
    },
    "9880":{
      "name":"\u0421\u043e\u0432\u0435\u0442\u0441\u043a\u0438\u0439",
      "longitude":80.395729,
      "latitude":54.201122
    },
    "9881":{
      "name":"\u0413\u043e\u043b\u0443\u0431\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":80.4078424,
      "latitude":54.9922637
    },
    "9882":{
      "name":"\u041c\u0430\u044f\u043a",
      "longitude":80.411316,
      "latitude":54.439945
    },
    "9883":{
      "name":"\u0422\u0435\u0440\u0435\u043d\u0438\u043d\u043e",
      "longitude":80.41655,
      "latitude":55.342621
    },
    "9884":{
      "name":"\u0421\u0430\u043f\u043e\u0436\u043a\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":80.426682,
      "latitude":54.529354
    },
    "9885":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u0433\u0440\u0430\u0434\u0441\u043a\u0438\u0439",
      "longitude":80.431549,
      "latitude":55.057476
    },
    "9886":{
      "name":"\u041a\u0443\u0431\u0430\u043d\u0441\u043a\u0438\u0439",
      "longitude":80.443336,
      "latitude":55.107586
    },
    "9887":{
      "name":"\u0411\u043b\u043e\u043a\u043f\u043e\u0441\u0442 \u041a\u0430\u043f\u0440\u0430\u043b\u043e\u0432\u043e",
      "longitude":80.452049,
      "latitude":55.16489
    },
    "9888":{
      "name":"\u041c\u0435\u0434\u044f\u043a\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":80.50177,
      "latitude":55.531528
    },
    "9889":{
      "name":"\u041f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":80.519638,
      "latitude":54.117241
    },
    "9890":{
      "name":"\u0421\u0430\u0440\u044b\u043a\u0430\u043c\u044b\u0448\u043a\u0430",
      "longitude":80.572731,
      "latitude":54.740864
    },
    "9891":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":80.578346,
      "latitude":54.573231
    },
    "9892":{
      "name":"\u0420\u043e\u0432\u0435\u043d\u0441\u043a\u0438\u0439",
      "longitude":80.582222,
      "latitude":55.426914
    },
    "9893":{
      "name":"\u041c\u0430\u043b\u043e\u0441\u0443\u043c\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":80.595306,
      "latitude":54.791084
    },
    "9894":{
      "name":"\u0421\u0443\u0432\u043e\u0440\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":80.618675,
      "latitude":55.137371
    },
    "9895":{
      "name":"\u041f\u0440\u0435\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u0441\u043a\u0438\u0439",
      "longitude":80.622757,
      "latitude":54.989391
    },
    "9896":{
      "name":"\u0417\u0443\u0431\u0430\u0440\u0438",
      "longitude":80.629318,
      "latitude":54.939266
    },
    "9897":{
      "name":"\u041d\u043e\u0432\u044b\u0439 \u0412\u043e\u043a\u0437\u0430\u043b",
      "longitude":80.647202,
      "latitude":54.520721
    },
    "9898":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u0432\u043a\u0430",
      "longitude":80.660805,
      "latitude":55.197617
    },
    "9899":{
      "name":"\u0417\u0438\u043c\u043e\u0432\u043a\u0430",
      "longitude":80.705986,
      "latitude":54.706379
    },
    "9900":{
      "name":"\u041a\u043d\u044f\u0437\u0435\u0432\u0441\u043a\u0438\u0439",
      "longitude":80.754959,
      "latitude":54.889412
    },
    "9901":{
      "name":"3192 \u043a\u043c",
      "longitude":80.777939,
      "latitude":55.120724
    },
    "9902":{
      "name":"\u041a\u0430\u044f\u043a",
      "longitude":80.79615,
      "latitude":55.03167
    },
    "9903":{
      "name":"\u041d\u0430\u0442\u0430\u043b\u044c\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":80.84967,
      "latitude":55.309105
    },
    "9904":{
      "name":"\u0412\u0430\u043d\u0438\u0447\u043a\u0438\u043d\u043e",
      "longitude":80.850349,
      "latitude":54.917686
    },
    "9905":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":80.853195,
      "latitude":54.56879
    },
    "9906":{
      "name":"\u0427\u0443\u0432\u0430\u0448\u043a\u0438\u043d\u043e",
      "longitude":80.910042,
      "latitude":55.201969
    },
    "9907":{
      "name":"\u0412\u0430\u0441\u0438\u043b\u044c\u0435\u0432\u0441\u043a\u0438\u0439",
      "longitude":80.9616547,
      "latitude":55.2777965
    },
    "9908":{
      "name":"\u0421\u0438\u043d\u0435\u043b\u044c\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":80.988068,
      "latitude":54.75647
    },
    "9909":{
      "name":"\u0428\u0435\u0440\u0441\u0442\u043e\u0431\u0438\u0442\u043e\u0432\u043e",
      "longitude":80.998077,
      "latitude":54.977886
    },
    "9910":{
      "name":"\u0411\u043e\u0447\u0438\u043d\u043e",
      "longitude":81.004303,
      "latitude":55.286251
    },
    "9911":{
      "name":"\u0412\u043e\u043b\u043a\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":81.041374,
      "latitude":54.88467
    },
    "9912":{
      "name":"\u0414\u0443\u0431\u0440\u0430\u0432\u0430",
      "longitude":81.05275,
      "latitude":55.328453
    },
    "9913":{
      "name":"\u0424\u0438\u043b\u0438\u043c\u043e\u043d\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":81.071777,
      "latitude":54.93045
    },
    "9914":{
      "name":"\u0417\u0430\u043b\u0435\u0441\u043d\u044b\u0439",
      "longitude":81.092453,
      "latitude":55.011929
    },
    "9915":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u0423\u0436\u0430\u043d\u0438\u0445\u0430",
      "longitude":81.094566,
      "latitude":54.741592
    },
    "9916":{
      "name":"\u0421\u043d\u0435\u0436\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":81.166824,
      "latitude":54.877995
    },
    "9917":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u0443\u0437\u044c\u043c\u0438\u043d\u043a\u0430",
      "longitude":81.169373,
      "latitude":54.132153
    },
    "9918":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0435\u0434\u043e\u0440\u043e\u0436\u043d\u043e\u0435",
      "longitude":81.217461,
      "latitude":55.088871
    },
    "9919":{
      "name":"\u041a\u0443\u0437\u043d\u0435\u0446\u043a\u0438\u0439",
      "longitude":81.304688,
      "latitude":55.178265
    },
    "9920":{
      "name":"\u041a\u0430\u0441\u044c\u043a\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":81.325012,
      "latitude":55.396568
    },
    "9921":{
      "name":"\u0421\u0440\u0435\u0434\u043d\u0438\u0439 \u0410\u043b\u0435\u0443\u0441",
      "longitude":81.351761,
      "latitude":54.187954
    },
    "9922":{
      "name":"\u0418\u043b\u044e\u0448\u0438\u043d\u043e",
      "longitude":81.38224,
      "latitude":55.023476
    },
    "9923":{
      "name":"\u0417\u044b\u0440\u044f\u043d\u043a\u0430",
      "longitude":81.388756,
      "latitude":54.574684
    },
    "9924":{
      "name":"\u041f\u0443\u0448\u043a\u0430\u0440\u0451\u0432\u043e",
      "longitude":81.389671,
      "latitude":54.177399
    },
    "9925":{
      "name":"\u0421\u0438\u0434\u043e\u0440\u043a\u0438\u043d\u043e",
      "longitude":81.397842,
      "latitude":54.862995
    },
    "9926":{
      "name":"\u0411\u043e\u0433\u043e\u0442\u043e\u043b\u044c\u0441\u043a\u0438\u0439",
      "longitude":81.409294,
      "latitude":54.731052
    },
    "9927":{
      "name":"\u0410\u043d\u0442\u043e\u043d\u043e\u0432\u043e",
      "longitude":81.412224,
      "latitude":54.094025
    },
    "9928":{
      "name":"\u0421\u0435\u043a\u0442\u044b",
      "longitude":81.43087,
      "latitude":55.144337
    },
    "9929":{
      "name":"\u041c\u0430\u043b\u043e\u043d\u0438\u043a\u043e\u043b\u044c\u0441\u043a\u043e\u0435",
      "longitude":81.433716,
      "latitude":54.612495
    },
    "9930":{
      "name":"\u0422\u0438\u0445\u043e\u043c\u0438\u0440\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":81.438164,
      "latitude":55.08147
    },
    "9931":{
      "name":"\u0423\u0441\u0442\u044c-\u0410\u043b\u0435\u0443\u0441",
      "longitude":81.448334,
      "latitude":54.099041
    },
    "9932":{
      "name":"\u041d\u043e\u0432\u043e\u0440\u043e\u0436\u0434\u0435\u0441\u0442\u0432\u0435\u043d\u0441\u043a\u0438\u0439",
      "longitude":81.452492,
      "latitude":54.79422
    },
    "9933":{
      "name":"\u0427\u0435\u0440\u0435\u043c\u0448\u0430\u043d\u043a\u0430",
      "longitude":81.501518,
      "latitude":54.218037
    },
    "9934":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u041f\u043e\u043b\u044f\u043d\u0430",
      "longitude":81.535187,
      "latitude":55.184643
    },
    "9935":{
      "name":"\u041c\u0438\u043b\u043e\u0432\u0430\u043d\u043e\u0432\u043e",
      "longitude":81.552834,
      "latitude":54.09317
    },
    "9936":{
      "name":"\u0421\u0435\u0432\u0430\u0441\u0442\u044c\u044f\u043d\u043e\u0432\u043a\u0430",
      "longitude":81.563408,
      "latitude":55.090515
    },
    "9937":{
      "name":"\u041f\u043e\u043a\u0440\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":81.595726,
      "latitude":54.639557
    },
    "9938":{
      "name":"\u041d\u043e\u0432\u043e\u0440\u043e\u0449\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":81.614433,
      "latitude":55.208664
    },
    "9939":{
      "name":"\u0411\u043e\u0440\u0438\u0441\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":81.615097,
      "latitude":54.532993
    },
    "9940":{
      "name":"\u0410\u043d\u0442\u0438\u043f\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":81.623398,
      "latitude":54.970196
    },
    "9941":{
      "name":"\u041a\u0430\u0437\u0430\u043d\u043a\u0430",
      "longitude":81.665161,
      "latitude":54.794914
    },
    "9942":{
      "name":"\u041b\u0435\u0441\u043d\u043e\u0439",
      "longitude":81.695518,
      "latitude":54.742428
    },
    "9943":{
      "name":"\u0411\u0443\u0433\u0440\u0438\u043d\u0441\u043a\u0430\u044f \u0420\u043e\u0449\u0430",
      "longitude":81.702301,
      "latitude":54.472813
    },
    "9944":{
      "name":"\u0410\u0431\u0440\u0430\u0448\u0438\u043d\u043e",
      "longitude":81.71566,
      "latitude":54.238159
    },
    "9945":{
      "name":"\u0411\u0435\u0440\u0435\u0437\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":81.738472,
      "latitude":54.723602
    },
    "9946":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":81.775055,
      "latitude":55.124928
    },
    "9947":{
      "name":"\u0412\u043b\u0430\u0434\u0438\u0441\u043b\u0430\u0432\u0441\u043a\u0438\u0439",
      "longitude":81.786766,
      "latitude":55.257309
    },
    "9948":{
      "name":"\u041e\u043b\u044c\u0448\u0430\u043d\u0441\u043a\u0438\u0439",
      "longitude":81.795837,
      "latitude":55.013729
    },
    "9949":{
      "name":"\u0422\u0430\u0440\u0430\u0434\u0430\u043d\u043e\u0432\u043e",
      "longitude":81.8150248,
      "latitude":53.8117827
    },
    "9950":{
      "name":"\u041c\u0430\u0441\u043b\u043e\u0432\u043e",
      "longitude":81.843254,
      "latitude":54.865856
    },
    "9951":{
      "name":"\u0421\u0442\u0443\u0434\u0435\u043d\u043a\u0438\u043d\u043e",
      "longitude":81.843384,
      "latitude":55.169094
    },
    "9952":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u041a\u0440\u0443\u0442\u0438\u0448\u043a\u0430",
      "longitude":81.867722,
      "latitude":54.062683
    },
    "9953":{
      "name":"\u0417\u043e\u0440\u0438\u043d\u043e",
      "longitude":81.897278,
      "latitude":53.74995
    },
    "9954":{
      "name":"\u0415\u0440\u043c\u0438\u043b\u043e\u0432\u043a\u0430",
      "longitude":81.937386,
      "latitude":55.307846
    },
    "9955":{
      "name":"\u041a\u043e\u0437\u043b\u043e\u0432\u043e",
      "longitude":81.950272,
      "latitude":54.907032
    },
    "9956":{
      "name":"\u041c\u0430\u043b\u044b\u0439 \u0427\u0438\u043a",
      "longitude":81.966866,
      "latitude":54.692085
    },
    "9957":{
      "name":"\u041c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":81.99456,
      "latitude":54.887589
    },
    "9958":{
      "name":"\u041f\u043e\u0440\u043e\u0442\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":82.001457,
      "latitude":53.745422
    },
    "9959":{
      "name":"\u041c\u0430\u043b\u043e\u0440\u0435\u0447\u0435\u043d\u043a\u0430",
      "longitude":82.006744,
      "latitude":54.845009
    },
    "9960":{
      "name":"\u041e\u0441\u0442\u0430\u043d\u043e\u0432\u043e\u0447\u043d\u0430\u044f \u041f\u043b\u0430\u0442\u0444\u043e\u0440\u043c\u0430 3273",
      "longitude":82.010056,
      "latitude":55.03566
    },
    "9961":{
      "name":"\u0421\u0430\u0440\u0442\u0430\u043a\u043e\u0432\u043e",
      "longitude":82.011536,
      "latitude":54.990059
    },
    "9962":{
      "name":"\u0421\u0435\u043c\u0435\u043d\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":82.056702,
      "latitude":55.159451
    },
    "9963":{
      "name":"\u0411\u0430\u0440\u043c\u0430\u0448\u0435\u0432\u043e",
      "longitude":82.069046,
      "latitude":55.008022
    },
    "9964":{
      "name":"\u041e\u0441\u0442\u0430\u043d\u043e\u0432\u043e\u0447\u043d\u0430\u044f \u041f\u043b\u0430\u0442\u0444\u043e\u0440\u043c\u0430 3277",
      "longitude":82.075974,
      "latitude":55.028103
    },
    "9965":{
      "name":"\u0412\u0434\u043e\u0432\u0438\u043d\u043e",
      "longitude":82.077972,
      "latitude":56.050777
    },
    "9966":{
      "name":"\u041e\u0441\u0442\u0430\u043d\u043e\u0432\u043e\u0447\u043d\u0430\u044f \u041f\u043b\u0430\u0442\u0444\u043e\u0440\u043c\u0430 \u041a\u043b\u044b",
      "longitude":82.078926,
      "latitude":53.810314
    },
    "9967":{
      "name":"\u0421\u0442\u0435\u043f\u043d\u043e\u0439",
      "longitude":82.116524,
      "latitude":54.690392
    },
    "9968":{
      "name":"\u041a\u043e\u043c\u0438\u0445\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":82.120148,
      "latitude":54.772888
    },
    "9969":{
      "name":"\u0415\u0440\u0435\u0441\u0442\u043d\u0430\u044f",
      "longitude":82.131348,
      "latitude":54.380486
    },
    "9970":{
      "name":"\u0410\u0440\u0442\u0430\u043c\u043e\u043d\u043e\u0432\u043e",
      "longitude":82.131783,
      "latitude":54.186726
    },
    "9971":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0439 \u0421\u0443\u0437\u0443\u043d",
      "longitude":82.145599,
      "latitude":53.720684
    },
    "9972":{
      "name":"\u041d\u043e\u0432\u043e\u043e\u0442\u0440\u0443\u0431\u043d\u043e\u0435",
      "longitude":82.146957,
      "latitude":55.128391
    },
    "9973":{
      "name":"\u0412\u0430\u0445\u0440\u0443\u0448\u0435\u0432\u043e",
      "longitude":82.155624,
      "latitude":55.250351
    },
    "9974":{
      "name":"\u0424\u0435\u0434\u043e\u0441\u043e\u0432\u043e",
      "longitude":82.157486,
      "latitude":54.872799
    },
    "9975":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u041a\u0430\u043c\u0435\u0448\u043e\u043a",
      "longitude":82.160873,
      "latitude":53.90786
    },
    "9976":{
      "name":"\u0422\u0440\u043e\u043f\u0438\u043d\u043e",
      "longitude":82.195923,
      "latitude":54.922401
    },
    "9977":{
      "name":"\u041b\u0443\u0448\u043d\u0438\u043a\u0438",
      "longitude":82.209175,
      "latitude":54.053967
    },
    "9978":{
      "name":"\u041a\u043e\u0447\u0435\u0442\u043e\u0432\u043a\u0430",
      "longitude":82.23452,
      "latitude":55.397663
    },
    "9979":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u043c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":82.248177,
      "latitude":55.210861
    },
    "9980":{
      "name":"\u041f\u043e\u043f\u0435\u0440\u0435\u0447\u043d\u043e\u0435",
      "longitude":82.254807,
      "latitude":54.587929
    },
    "9981":{
      "name":"\u0425\u043e\u0445\u043b\u043e\u0432\u043a\u0430",
      "longitude":82.256683,
      "latitude":56.109581
    },
    "9982":{
      "name":"\u0443\u0447\u0430\u0441\u0442\u043e\u043a \u041d\u043e\u0432\u043e\u0441\u0442\u0440\u043e\u0439\u043a\u0430",
      "longitude":82.267044,
      "latitude":53.894806
    },
    "9983":{
      "name":"\u041c\u043e\u043b\u043e\u0442",
      "longitude":82.292595,
      "latitude":55.29818
    },
    "9984":{
      "name":"\u0410\u043d\u0442\u043e\u043d\u043e\u0432\u043a\u0430",
      "longitude":82.298119,
      "latitude":54.827515
    },
    "9985":{
      "name":"\u041a\u0430\u0437\u0430\u043a\u043e\u0432\u043e",
      "longitude":82.298401,
      "latitude":54.948757
    },
    "9986":{
      "name":"\u041f\u0440\u0438\u043e\u0437\u0435\u0440\u043d\u0430\u044f",
      "longitude":82.298744,
      "latitude":54.899082
    },
    "9987":{
      "name":"\u041b\u0430\u043f\u0442\u0435\u0432\u043a\u0430",
      "longitude":82.308846,
      "latitude":55.79385
    },
    "9988":{
      "name":"\u0425\u0430\u0440\u044c\u043a\u043e\u0432\u043a\u0430",
      "longitude":82.316956,
      "latitude":54.109104
    },
    "9989":{
      "name":"\u041e\u0441\u0442\u0430\u043d\u043e\u0432\u043e\u0447\u043d\u0430\u044f \u041f\u043b\u0430\u0442\u0444\u043e\u0440\u043c\u0430 3293",
      "longitude":82.319496,
      "latitude":55.005383
    },
    "9990":{
      "name":"\u0428\u0438\u0433\u0430\u0435\u0432\u043e",
      "longitude":82.319519,
      "latitude":54.248936
    },
    "9991":{
      "name":"\u041a\u0430\u043c\u044b\u0448\u0438\u043d\u043a\u0430",
      "longitude":82.341988,
      "latitude":53.642845
    },
    "9992":{
      "name":"\u041e\u0440\u043b\u043e\u0432\u043a\u0430",
      "longitude":82.422691,
      "latitude":55.818714
    },
    "9993":{
      "name":"\u0428\u0438\u043b\u043e\u0432\u043e",
      "longitude":82.423157,
      "latitude":54.731796
    },
    "9994":{
      "name":"\u0420\u043e\u0436\u0434\u0435\u0441\u0442\u0432\u0435\u043d\u043a\u0430",
      "longitude":82.444183,
      "latitude":54.376579
    },
    "9995":{
      "name":"\u0443\u0447\u0430\u0441\u0442\u043e\u043a \u041d\u0435\u0447\u0443\u043d\u0430\u0435\u0432\u0441\u043a\u0438\u0439",
      "longitude":82.44883,
      "latitude":53.804691
    },
    "9996":{
      "name":"\u041f\u043b\u043e\u0441\u043a\u043e\u0435",
      "longitude":82.451378,
      "latitude":54.210903
    },
    "9997":{
      "name":"\u041a\u0440\u043e\u0442\u043e\u0432\u043e",
      "longitude":82.465401,
      "latitude":53.544064
    },
    "9998":{
      "name":"\u0422\u0430\u0442\u0447\u0438\u0445\u0430",
      "longitude":82.472969,
      "latitude":54.375408
    },
    "9999":{
      "name":"\u0415\u0440\u0448\u043e\u0432\u043a\u0430",
      "longitude":82.482895,
      "latitude":55.835716
    },
    "10000":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u0427\u0435\u0440\u0435\u043c\u0448\u0430\u043d\u043a\u0430",
      "longitude":82.498749,
      "latitude":55.304138
    },
    "10001":{
      "name":"\u041a\u043b\u0438\u0442\u0435\u043d\u043a\u0430",
      "longitude":82.504951,
      "latitude":54.11797
    },
    "10002":{
      "name":"\u0427\u0438\u043a",
      "longitude":82.5114651,
      "latitude":55.0884152
    },
    "10003":{
      "name":"\u041d\u043e\u0432\u043e\u0430\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":82.535347,
      "latitude":56.168526
    },
    "10004":{
      "name":"\u041a\u0440\u043e\u0445\u0430\u043b\u0451\u0432\u043a\u0430",
      "longitude":82.5444071,
      "latitude":55.1460409
    },
    "10005":{
      "name":"\u0424\u0451\u0434\u043e\u0440\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":82.549004,
      "latitude":54.155708
    },
    "10006":{
      "name":"\u041d\u043e\u0432\u043e\u043e\u0441\u0438\u043d\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":82.551086,
      "latitude":53.822308
    },
    "10007":{
      "name":"\u041f\u0440\u043e\u0433\u0440\u0435\u0441\u0441",
      "longitude":82.552589,
      "latitude":54.703613
    },
    "10008":{
      "name":"\u041c\u0430\u043b\u044c\u0447\u0438\u0445\u0430",
      "longitude":82.555786,
      "latitude":55.848804
    },
    "10009":{
      "name":"\u041d\u043e\u0432\u043e\u043e\u0437\u0435\u0440\u043d\u044b\u0439",
      "longitude":82.5585814,
      "latitude":54.9634368
    },
    "10010":{
      "name":"\u041a\u043e\u0440\u0434\u043e\u043d",
      "longitude":82.5740435,
      "latitude":55.145526
    },
    "10011":{
      "name":"\u0414\u0430\u043b\u044c\u043d\u044f\u044f \u041f\u043e\u043b\u044f\u043d\u0430",
      "longitude":82.578308,
      "latitude":56.039837
    },
    "10012":{
      "name":"\u0428\u0438\u043f\u0443\u043d\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":82.593071,
      "latitude":53.965462
    },
    "10013":{
      "name":"\u041a\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":82.614792,
      "latitude":54.385868
    },
    "10014":{
      "name":"\u041f\u0430\u0432\u0438\u043d\u043e",
      "longitude":82.614917,
      "latitude":55.0153017
    },
    "10015":{
      "name":"\u041e\u0437\u0435\u0440\u043a\u0438",
      "longitude":82.636215,
      "latitude":54.509693
    },
    "10016":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":82.637756,
      "latitude":55.910797
    },
    "10017":{
      "name":"\u041c\u0430\u0440\u0447\u0438\u0445\u0430",
      "longitude":82.654015,
      "latitude":55.922035
    },
    "10018":{
      "name":"\u041c\u0430\u043b\u044b\u0439 \u041e\u0451\u0448",
      "longitude":82.6551692,
      "latitude":55.2756392
    },
    "10019":{
      "name":"\u041d\u043e\u0432\u043e\u0435\u043b\u043e\u0432\u043a\u0430",
      "longitude":82.66259,
      "latitude":55.94643
    },
    "10020":{
      "name":"\u0421\u0435\u0432\u0435\u0440\u043d\u044b\u0439",
      "longitude":82.689835,
      "latitude":56.016357
    },
    "10021":{
      "name":"\u0422\u0440\u043e\u043f\u0438\u043d\u043e",
      "longitude":82.695381,
      "latitude":55.533329
    },
    "10022":{
      "name":"\u0412\u043e\u0441\u0445\u043e\u0434",
      "longitude":82.699501,
      "latitude":56.012108
    },
    "10023":{
      "name":"\u0422\u0443\u043b\u0430",
      "longitude":82.700768,
      "latitude":54.592125
    },
    "10024":{
      "name":"\u0421\u0438\u0431\u0438\u0440\u044f\u043a",
      "longitude":82.7304,
      "latitude":54.160465
    },
    "10025":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u0441\u043a\u0438\u0439",
      "longitude":82.73555,
      "latitude":54.305016
    },
    "10026":{
      "name":"\u041c\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":82.73555,
      "latitude":56.028606
    },
    "10027":{
      "name":"\u041f\u0430\u0443\u0442\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":82.756302,
      "latitude":55.568367
    },
    "10028":{
      "name":"\u041f\u0430\u0443\u0442\u043e\u0432\u043e",
      "longitude":82.758049,
      "latitude":55.544334
    },
    "10029":{
      "name":"\u041f\u043e\u0434\u0433\u043e\u0440\u043d\u0430\u044f",
      "longitude":82.763222,
      "latitude":55.327274
    },
    "10030":{
      "name":"\u041a\u0430\u0442\u043a\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":82.772748,
      "latitude":55.173083
    },
    "10031":{
      "name":"\u0412\u043e\u0440\u043e\u0431\u044c\u0435\u0432\u0441\u043a\u0438\u0439",
      "longitude":82.7736398,
      "latitude":55.164444
    },
    "10032":{
      "name":"\u0427\u0430\u0443\u0441",
      "longitude":82.780052,
      "latitude":55.343563
    },
    "10033":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u0412\u043e\u0441\u0442\u043e\u043a",
      "longitude":82.81344,
      "latitude":54.9283501
    },
    "10034":{
      "name":"\u041e\u0445\u043e\u0442\u0445\u043e\u0437\u044f\u0439\u0441\u0442\u0432\u043e",
      "longitude":82.816696,
      "latitude":55.428684
    },
    "10035":{
      "name":"\u041e\u0440\u043b\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":82.844582,
      "latitude":55.577835
    },
    "10036":{
      "name":"\u0421\u0435\u0434\u043e\u0432\u0430 \u0417\u0430\u0438\u043c\u043a\u0430",
      "longitude":82.84922,
      "latitude":55.364975
    },
    "10037":{
      "name":"\u0426\u0435\u043b\u0438\u043d\u043d\u044b\u0439",
      "longitude":82.855972,
      "latitude":54.36953
    },
    "10038":{
      "name":"\u0411\u0438\u0431\u0438\u0445\u0430",
      "longitude":82.865425,
      "latitude":55.325504
    },
    "10039":{
      "name":"\u0412\u0438\u043d\u043e\u0433\u0440\u0430\u0434",
      "longitude":82.876114,
      "latitude":54.017254
    },
    "10040":{
      "name":"\u0417\u0435\u043b\u0451\u043d\u044b\u0439 \u041c\u044b\u0441",
      "longitude":82.890984,
      "latitude":55.295609
    },
    "10041":{
      "name":"\u0411\u043e\u0431\u0440\u043e\u0432\u0438\u0446\u043a\u0438\u0439",
      "longitude":82.900597,
      "latitude":54.290173
    },
    "10042":{
      "name":"\u0411\u043e\u0440\u043e\u0434\u0430\u0432\u043a\u0438\u043d\u043e",
      "longitude":82.908249,
      "latitude":54.488159
    },
    "10043":{
      "name":"\u041e\u043a\u0442\u044f\u0431\u0440\u044c\u0441\u043a\u0438\u0439",
      "longitude":82.908577,
      "latitude":54.443913
    },
    "10044":{
      "name":"\u042e\u0440\u0442-\u041e\u0440\u0430",
      "longitude":82.912888,
      "latitude":55.447243
    },
    "10045":{
      "name":"\u0413\u043e\u043b\u0443\u0431\u043e\u0439 \u0417\u0430\u043b\u0438\u0432",
      "longitude":82.9191027,
      "latitude":54.8421088
    },
    "10046":{
      "name":"\u0413\u0438\u043b\u0435\u0432\u043e",
      "longitude":82.937126,
      "latitude":54.348763
    },
    "10047":{
      "name":"\u0422\u0430\u043b\u043e\u0432\u043a\u0430",
      "longitude":82.949509,
      "latitude":55.584518
    },
    "10048":{
      "name":"\u0427\u0443\u043f\u0438\u043d\u043e",
      "longitude":82.952698,
      "latitude":54.525436
    },
    "10049":{
      "name":"\u0427\u0430\u0449\u0438\u043d\u043e",
      "longitude":82.95488,
      "latitude":54.05946
    },
    "10050":{
      "name":"\u041b\u043e\u043c\u043e\u0432\u0441\u043a\u0430\u044f \u0414\u0430\u0447\u0430",
      "longitude":82.9554528,
      "latitude":55.2132474
    },
    "10051":{
      "name":"\u041f\u0440\u0438\u0441\u0442\u0430\u043d\u044c-\u041f\u043e\u0447\u0442\u0430",
      "longitude":82.975029,
      "latitude":55.454838
    },
    "10052":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u043a\u0430",
      "longitude":82.990913,
      "latitude":54.482376
    },
    "10053":{
      "name":"\u0421\u0430\u043d\u0430\u0442\u043e\u0440\u043d\u044b\u0439",
      "longitude":83.0082382,
      "latitude":54.6996254
    },
    "10054":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u0427\u0435\u0440\u0435\u043c\u0448\u0430\u043d\u043a\u0430",
      "longitude":83.027145,
      "latitude":55.596977
    },
    "10055":{
      "name":"\u0421\u0435\u043c\u0451\u043d\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":83.035828,
      "latitude":54.257362
    },
    "10056":{
      "name":"\u0423\u043a\u0440\u0430\u0438\u043d\u043a\u0430",
      "longitude":83.072693,
      "latitude":54.269684
    },
    "10057":{
      "name":"\u0421\u0435\u0440\u0435\u0434\u0438\u043d\u043e",
      "longitude":83.081398,
      "latitude":55.797413
    },
    "10058":{
      "name":"\u0420\u0430\u0437\u0434\u043e\u043b\u044c\u043d\u044b\u0439",
      "longitude":83.086639,
      "latitude":54.483959
    },
    "10059":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":83.088356,
      "latitude":54.428677
    },
    "10060":{
      "name":"\u0417\u043e\u043d\u0430\u043b\u044c\u043d\u044b\u0439",
      "longitude":83.1041255,
      "latitude":54.7732541
    },
    "10061":{
      "name":"\u0423\u0441\u0442\u044c-\u0422\u043e\u044f",
      "longitude":83.108345,
      "latitude":56.069923
    },
    "10062":{
      "name":"\u0420\u044f\u0431\u0447\u0438\u043d\u043a\u0430",
      "longitude":83.1097829,
      "latitude":54.6157107
    },
    "10063":{
      "name":"\u041a\u0430\u0440\u0430\u0433\u0443\u0436\u0435\u0432\u043e",
      "longitude":83.12355,
      "latitude":54.151638
    },
    "10064":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u042f\u0440",
      "longitude":83.136559,
      "latitude":55.511944
    },
    "10065":{
      "name":"\u0411\u043e\u0431\u0440\u043e\u0432\u0438\u0447\u0438\u043d\u0441\u043a",
      "longitude":83.137207,
      "latitude":55.974319
    },
    "10066":{
      "name":"\u0421\u0432\u0435\u0442\u043b\u044b\u0439",
      "longitude":83.1460009,
      "latitude":55.1945394
    },
    "10067":{
      "name":"\u041d\u043e\u0432\u043e\u043b\u0435\u0431\u0435\u0434\u0435\u0432\u043a\u0430",
      "longitude":83.148613,
      "latitude":54.461216
    },
    "10068":{
      "name":"\u041a\u0440\u0443\u0442\u043e\u0431\u043e\u0440\u043a\u0430",
      "longitude":83.182739,
      "latitude":55.530884
    },
    "10069":{
      "name":"\u041b\u043e\u043a\u0442\u0438",
      "longitude":83.1838105,
      "latitude":55.268401
    },
    "10070":{
      "name":"\u0420\u0435\u043c\u0435\u0441\u043b\u0435\u043d\u043d\u044b\u0439",
      "longitude":83.1894718,
      "latitude":54.9795926
    },
    "10071":{
      "name":"\u041a\u0430\u0437\u0430\u0440\u043c\u0430 45 \u043a\u043c",
      "longitude":83.1930531,
      "latitude":54.7229367
    },
    "10072":{
      "name":"\u041b\u043e\u0436\u043e\u043a",
      "longitude":83.1984235,
      "latitude":54.8420705
    },
    "10073":{
      "name":"\u0428\u0430\u0434\u0440\u0438\u0445\u0430",
      "longitude":83.1985417,
      "latitude":54.8135367
    },
    "10074":{
      "name":"\u0412\u0435\u0440\u0445-\u0422\u043e\u044f",
      "longitude":83.200302,
      "latitude":55.882481
    },
    "10075":{
      "name":"\u0421\u0435\u043b\u044c\u0441\u043a\u0430\u044f",
      "longitude":83.2026529,
      "latitude":54.7166312
    },
    "10076":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":83.2037622,
      "latitude":55.1658244
    },
    "10077":{
      "name":"\u041e\u0441\u0442\u0430\u043d\u043e\u0432\u043e\u0447\u043d\u0430\u044f \u041f\u043b\u0430\u0442\u0444\u043e\u0440\u043c\u0430 \u0411\u0430\u0440",
      "longitude":83.2122702,
      "latitude":55.1743708
    },
    "10078":{
      "name":"\u0418\u043d\u0441\u043a\u043e\u0439",
      "longitude":83.229607,
      "latitude":54.222004
    },
    "10079":{
      "name":"\u041a\u0430\u043c\u0435\u043d\u0443\u0448\u043a\u0430",
      "longitude":83.2314747,
      "latitude":54.8419284
    },
    "10080":{
      "name":"\u0422\u0430\u0441\u043a\u0430\u0435\u0432\u043e",
      "longitude":83.23497,
      "latitude":54.507427
    },
    "10081":{
      "name":"\u0412\u043e\u0440\u043e\u0431\u044c\u0438",
      "longitude":83.239182,
      "latitude":55.909027
    },
    "10082":{
      "name":"\u041a\u043e\u043c\u0430\u0440\u043e\u0432\u043a\u0430",
      "longitude":83.2399876,
      "latitude":55.0393847
    },
    "10083":{
      "name":"\u0418\u0437\u043e\u0432\u043a\u0430",
      "longitude":83.243805,
      "latitude":55.780582
    },
    "10084":{
      "name":"\u041c\u0435\u0436\u0434\u0443\u0440\u0435\u0447\u044c\u0435",
      "longitude":83.2562801,
      "latitude":54.9642502
    },
    "10085":{
      "name":"\u041e\u0441\u0442\u0430\u043d\u043e\u0432\u043e\u0447\u043d\u0430\u044f \u041f\u043b\u0430\u0442\u0444\u043e\u0440\u043c\u0430 \u0424\u0435\u0440",
      "longitude":83.2583809,
      "latitude":55.168551
    },
    "10086":{
      "name":"\u0416\u0435\u0440\u0435\u0431\u0446\u043e\u0432\u043e",
      "longitude":83.2651862,
      "latitude":55.1025232
    },
    "10087":{
      "name":"\u0427\u0451\u0440\u043d\u044b\u0439 \u041c\u044b\u0441",
      "longitude":83.267014,
      "latitude":55.51601
    },
    "10088":{
      "name":"\u041a\u043b\u044e\u0447\u0438",
      "longitude":83.2720454,
      "latitude":54.847538
    },
    "10089":{
      "name":"\u0421\u043e\u0432\u0445\u043e\u0437\u043d\u0430\u044f",
      "longitude":83.2884867,
      "latitude":54.9792084
    },
    "10090":{
      "name":"\u0415\u043b\u043e\u0432\u043a\u0438\u043d\u043e",
      "longitude":83.295723,
      "latitude":54.099228
    },
    "10091":{
      "name":"\u0411\u0430\u0440\u0438\u043d\u043e\u0432\u043e",
      "longitude":83.301201,
      "latitude":54.174141
    },
    "10092":{
      "name":"\u041c\u043e\u0441\u0442\u043e\u0432\u0430\u044f",
      "longitude":83.3061313,
      "latitude":55.0658363
    },
    "10093":{
      "name":"\u041f\u0440\u0438\u0433\u043e\u0440\u043e\u0434\u043d\u044b\u0439",
      "longitude":83.321358,
      "latitude":54.219685
    },
    "10094":{
      "name":"\u041e\u0442\u0432\u0430\u0436\u043d\u044b\u0439",
      "longitude":83.329308,
      "latitude":54.191383
    },
    "10095":{
      "name":"\u041b\u043e\u0433\u043e\u0432\u043e\u0439",
      "longitude":83.3530615,
      "latitude":54.6711566
    },
    "10096":{
      "name":"\u0428\u0443\u0440\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":83.3587314,
      "latitude":55.2085503
    },
    "10097":{
      "name":"\u0413\u0435\u043e\u0434\u0435\u0437\u0438\u0447\u0435\u0441\u043a\u0430\u044f",
      "longitude":83.3665655,
      "latitude":54.996844
    },
    "10098":{
      "name":"\u041c\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":83.3746201,
      "latitude":54.9606204
    },
    "10099":{
      "name":"\u041f\u0438\u043e\u043d\u0435\u0440\u0441\u043a\u0438\u0439",
      "longitude":83.3875678,
      "latitude":55.0109428
    },
    "10100":{
      "name":"\u0429\u0443\u043a\u0438\u043d\u043e",
      "longitude":83.390762,
      "latitude":55.672382
    },
    "10101":{
      "name":"\u0421\u043f\u0443\u0442\u043d\u0438\u043a",
      "longitude":83.41169,
      "latitude":54.204372
    },
    "10102":{
      "name":"\u0428\u043c\u0430\u043a\u043e\u0432\u043e",
      "longitude":83.413528,
      "latitude":55.031124
    },
    "10103":{
      "name":"\u0418\u0441\u043a\u0440\u0430",
      "longitude":83.418274,
      "latitude":54.163151
    },
    "10104":{
      "name":"\u041e\u0440\u0441\u043a",
      "longitude":83.43309,
      "latitude":55.208012
    },
    "10105":{
      "name":"\u041d\u043e\u0432\u044b\u0439 \u041f\u043e\u0440\u043e\u0441",
      "longitude":83.441971,
      "latitude":55.316265
    },
    "10106":{
      "name":"\u0421\u0443\u0448\u0437\u0430\u0432\u043e\u0434",
      "longitude":83.445839,
      "latitude":54.172798
    },
    "10107":{
      "name":"\u041c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":83.449509,
      "latitude":55.244011
    },
    "10108":{
      "name":"\u0417\u0430\u043f\u0440\u0443\u0434\u043d\u044b\u0439",
      "longitude":83.450089,
      "latitude":54.369205
    },
    "10109":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":83.459015,
      "latitude":55.074139
    },
    "10110":{
      "name":"\u041a\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":83.459023,
      "latitude":54.712795
    },
    "10111":{
      "name":"\u0420\u043e\u043c\u0430\u043d\u043e\u0432\u043e",
      "longitude":83.46312,
      "latitude":54.194756
    },
    "10112":{
      "name":"\u041a\u0430\u0437\u0430\u043d\u043a\u0430",
      "longitude":83.4771599,
      "latitude":55.6678899
    },
    "10113":{
      "name":"\u042f\u0440\u0441\u043a\u043e\u0435",
      "longitude":83.479431,
      "latitude":55.099091
    },
    "10114":{
      "name":"\u0411\u0435\u0437\u043c\u0435\u043d\u043e\u0432\u043e",
      "longitude":83.480446,
      "latitude":54.123405
    },
    "10115":{
      "name":"\u0414\u0437\u0435\u0440\u0436\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":83.481567,
      "latitude":54.914063
    },
    "10116":{
      "name":"\u0421\u0442\u0430\u0440\u044b\u0439 \u041f\u043e\u0440\u043e\u0441",
      "longitude":83.4830511,
      "latitude":55.4203267
    },
    "10117":{
      "name":"\u041a\u043e\u0448\u0435\u0432\u043e",
      "longitude":83.492638,
      "latitude":55.256912
    },
    "10118":{
      "name":"\u041a\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":83.512054,
      "latitude":55.114853
    },
    "10119":{
      "name":"\u0423\u043c\u043d\u0430",
      "longitude":83.517822,
      "latitude":55.602768
    },
    "10120":{
      "name":"\u041f\u0443\u0441\u0442\u044b\u043d\u043a\u0430",
      "longitude":83.518898,
      "latitude":55.093586
    },
    "10121":{
      "name":"\u0412\u044b\u0441\u043e\u043a\u0430\u044f \u041f\u043e\u043b\u044f\u043d\u0430",
      "longitude":83.526718,
      "latitude":54.331814
    },
    "10122":{
      "name":"\u041f\u0430\u0440\u043e\u0432\u043e\u0437\u043d\u044b\u0439",
      "longitude":83.5307545,
      "latitude":55.0940862
    },
    "10123":{
      "name":"\u0414\u0443\u0431\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":83.544426,
      "latitude":54.836926
    },
    "10124":{
      "name":"\u042e\u0440\u0442-\u0410\u043a\u0431\u0430\u043b\u044b\u043a",
      "longitude":83.563278,
      "latitude":55.657207
    },
    "10125":{
      "name":"\u041d\u043e\u0432\u043e\u043c\u043e\u0442\u043a\u043e\u0432\u043e",
      "longitude":83.569618,
      "latitude":55.117443
    },
    "10126":{
      "name":"\u041a\u0443\u0437\u043d\u0435\u0446\u043e\u0432\u043a\u0430",
      "longitude":83.583603,
      "latitude":55.442875
    },
    "10127":{
      "name":"\u0415\u043b\u0431\u0430\u0448\u0438",
      "longitude":83.597435,
      "latitude":54.736195
    },
    "10128":{
      "name":"\u0421\u0430\u0440\u0430\u0447\u0435\u0432\u043a\u0430",
      "longitude":83.599739,
      "latitude":55.506248
    },
    "10129":{
      "name":"\u0425\u0430\u0440\u0438\u043d\u043e",
      "longitude":83.609215,
      "latitude":54.617702
    },
    "10130":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":83.611679,
      "latitude":54.896091
    },
    "10131":{
      "name":"\u041f\u0430\u0434\u0443\u043d",
      "longitude":83.614151,
      "latitude":54.344215
    },
    "10132":{
      "name":"\u041b\u0438\u0445\u0430\u043d\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":83.627029,
      "latitude":54.298553
    },
    "10133":{
      "name":"\u0423\u043c\u0440\u0435\u0432\u0430",
      "longitude":83.629333,
      "latitude":55.546612
    },
    "10134":{
      "name":"\u0428\u0443\u043c\u0438\u0445\u0430",
      "longitude":83.647934,
      "latitude":55.601086
    },
    "10135":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u041e\u043a\u0442\u044f\u0431\u0440\u044c",
      "longitude":83.660667,
      "latitude":55.14307
    },
    "10136":{
      "name":"\u041a\u0430\u043c\u0435\u043d\u044c",
      "longitude":83.66938,
      "latitude":55.626583
    },
    "10137":{
      "name":"\u0411\u043e\u0440\u043e\u0432\u0443\u0448\u043a\u0430",
      "longitude":83.676964,
      "latitude":55.121128
    },
    "10138":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u043b\u043e\u0431\u043e\u0434\u043a\u0430",
      "longitude":83.679939,
      "latitude":55.30687
    },
    "10139":{
      "name":"\u041d\u043e\u0432\u043e\u0448\u043c\u0430\u043a\u043e\u0432\u043e",
      "longitude":83.690384,
      "latitude":54.235203
    },
    "10140":{
      "name":"\u041a\u0438\u0442\u0435\u0440\u043d\u044f",
      "longitude":83.691093,
      "latitude":54.843586
    },
    "10141":{
      "name":"\u0414\u0435\u0432\u043a\u0438\u043d\u043e",
      "longitude":83.696487,
      "latitude":54.615974
    },
    "10142":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u0431\u0438\u0431\u0435\u0435\u0432\u043e",
      "longitude":83.701424,
      "latitude":55.710899
    },
    "10143":{
      "name":"\u041a\u0443\u0432\u0448\u0438\u043d\u043a\u0430",
      "longitude":83.7179734,
      "latitude":55.1385207
    },
    "10144":{
      "name":"\u041f\u043e\u0440\u043e\u0441",
      "longitude":83.720406,
      "latitude":55.359623
    },
    "10145":{
      "name":"\u0422\u0430\u0442\u0430\u0440\u043a\u0430",
      "longitude":83.7314,
      "latitude":54.187412
    },
    "10146":{
      "name":"\u0421\u0430\u043c\u0430\u0440\u0441\u043a\u0438\u0439",
      "longitude":83.735825,
      "latitude":55.084675
    },
    "10147":{
      "name":"\u0410\u043f\u043b\u0430\u043a\u0441\u0438\u043d\u043e",
      "longitude":83.741875,
      "latitude":54.941048
    },
    "10148":{
      "name":"\u0412\u0435\u0440\u0445-\u0411\u0430\u043b\u0442\u0430",
      "longitude":83.761444,
      "latitude":55.335285
    },
    "10149":{
      "name":"\u0422\u0430\u0441\u0438\u043d\u043e",
      "longitude":83.7695617,
      "latitude":55.4115616
    },
    "10150":{
      "name":"\u041d\u043e\u0432\u043e\u0430\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":83.76976,
      "latitude":55.390987
    },
    "10151":{
      "name":"\u0418\u043d\u0441\u043a\u043e\u0439",
      "longitude":83.779388,
      "latitude":55.146816
    },
    "10152":{
      "name":"\u0423\u0441\u0442\u044c-\u0422\u0443\u043b\u0430",
      "longitude":83.782089,
      "latitude":55.781696
    },
    "10153":{
      "name":"\u041f\u0435\u0440\u043c\u0441\u043a\u0438\u0439",
      "longitude":83.78698,
      "latitude":55.036983
    },
    "10154":{
      "name":"\u0412\u043e\u0440\u043e\u043d\u043e\u0432\u043e",
      "longitude":83.78804,
      "latitude":55.481075
    },
    "10155":{
      "name":"\u041b\u044c\u043d\u043e\u0437\u0430\u0432\u043e\u0434",
      "longitude":83.803169,
      "latitude":55.157246
    },
    "10156":{
      "name":"\u042f\u0441\u043d\u0430\u044f \u041f\u043e\u043b\u044f\u043d\u0430",
      "longitude":83.83783,
      "latitude":54.262775
    },
    "10157":{
      "name":"\u041c\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":83.855446,
      "latitude":54.66098
    },
    "10158":{
      "name":"\u041f\u0440\u044f\u043c\u0441\u043a\u043e\u0435",
      "longitude":83.855469,
      "latitude":54.322701
    },
    "10159":{
      "name":"\u0415\u0440\u043c\u0430\u0447\u0438\u0445\u0430",
      "longitude":83.865929,
      "latitude":55.109436
    },
    "10160":{
      "name":"\u0418\u0437\u044b\u043d\u0441\u043a\u0438\u0439",
      "longitude":83.866707,
      "latitude":55.181465
    },
    "10161":{
      "name":"\u0421\u0435\u043c\u0451\u043d\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":83.870583,
      "latitude":55.049664
    },
    "10162":{
      "name":"\u041a\u0430\u043b\u0430\u0433\u0430\u043d\u043e\u0432\u043e",
      "longitude":83.873169,
      "latitude":55.192513
    },
    "10163":{
      "name":"\u041d\u0430\u043b\u0435\u0442\u0438\u0445\u0430",
      "longitude":83.89328,
      "latitude":54.947227
    },
    "10164":{
      "name":"\u042d\u0441\u0442\u043e\u043d\u043a\u0430",
      "longitude":83.89875,
      "latitude":55.58894
    },
    "10165":{
      "name":"\u0438\u043c\u0435\u043d\u0438 \u0422\u0435\u043b\u044c\u043c\u0430\u043d\u0430",
      "longitude":83.9138743,
      "latitude":55.5792699
    },
    "10166":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u0441\u043e\u0441\u0435\u0434\u043e\u0432\u043e",
      "longitude":83.92234,
      "latitude":54.597141
    },
    "10167":{
      "name":"\u041a\u0443\u0431\u043e\u0432\u043e",
      "longitude":83.9236442,
      "latitude":55.5042693
    },
    "10168":{
      "name":"\u0412\u043e\u0437\u043d\u0435\u0441\u0435\u043d\u043a\u0430",
      "longitude":83.926765,
      "latitude":55.621494
    },
    "10169":{
      "name":"\u0411\u0430\u0440\u0441\u0443\u043a\u043e\u0432\u043e",
      "longitude":83.936424,
      "latitude":54.389957
    },
    "10170":{
      "name":"\u0411\u0443\u0440\u043b\u0438\u0445\u0430",
      "longitude":83.945679,
      "latitude":55.532059
    },
    "10171":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u043f\u0430\u0432\u043b\u043e\u0432\u043a\u0430",
      "longitude":83.955185,
      "latitude":54.28368
    },
    "10172":{
      "name":"\u041c\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":83.968086,
      "latitude":55.628246
    },
    "10173":{
      "name":"\u041e\u0441\u0442\u0430\u043d\u043e\u0432\u043e\u0447\u043d\u0430\u044f \u041f\u043b\u0430\u0442\u0444\u043e\u0440\u043c\u0430 \u041e\u0442\u0433",
      "longitude":83.974884,
      "latitude":55.207306
    },
    "10174":{
      "name":"\u041a\u0438\u043d\u0442\u0435\u0440\u0435\u043f",
      "longitude":83.987175,
      "latitude":54.480469
    },
    "10175":{
      "name":"\u041d\u0430\u0441\u043e\u043d\u043e\u0432\u043e",
      "longitude":83.992363,
      "latitude":55.81929
    },
    "10176":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u044c\u0441\u043a\u0438\u0439",
      "longitude":83.992561,
      "latitude":55.103745
    },
    "10177":{
      "name":"\u0418\u0437\u044b\u043d\u0441\u043a\u0438\u0439",
      "longitude":83.993073,
      "latitude":55.179623
    },
    "10178":{
      "name":"\u0413\u043b\u044f\u0434\u0435\u043d\u044c",
      "longitude":84.009361,
      "latitude":55.262276
    },
    "10179":{
      "name":"\u0413\u043e\u0440\u043d",
      "longitude":84.0216898,
      "latitude":55.5450709
    },
    "10180":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u041f\u043e\u043b\u044f\u043d\u0430",
      "longitude":84.024986,
      "latitude":55.807278
    },
    "10181":{
      "name":"\u041a\u0430\u043d\u0430\u0440\u0431\u0443\u0433\u0430",
      "longitude":84.034569,
      "latitude":55.252838
    },
    "10182":{
      "name":"\u0421\u0438\u0431\u0438\u0440\u044f\u043a",
      "longitude":84.070526,
      "latitude":55.424374
    },
    "10183":{
      "name":"\u0417\u0435\u043b\u0451\u043d\u0430\u044f \u0413\u043e\u0440\u043a\u0430",
      "longitude":84.071518,
      "latitude":55.441982
    },
    "10184":{
      "name":"\u0422\u0430\u0433\u0430\u043d\u0430\u0439",
      "longitude":84.079437,
      "latitude":55.558369
    },
    "10185":{
      "name":"\u041c\u0443\u0440\u043b\u044b\u0442\u043a\u0438\u043d\u043e",
      "longitude":84.080078,
      "latitude":55.234627
    },
    "10186":{
      "name":"\u0415\u043b\u0442\u044b\u0448\u0435\u0432\u043e",
      "longitude":84.091187,
      "latitude":55.364685
    },
    "10187":{
      "name":"\u0411\u043e\u0440\u043e\u0432\u043b\u044f\u043d\u043a\u0430",
      "longitude":84.112122,
      "latitude":55.018082
    },
    "10188":{
      "name":"\u0420\u043e\u0436\u043d\u0435\u0432\u0441\u043a\u0438\u0439 \u0411\u043e\u0440",
      "longitude":84.115791,
      "latitude":55.248352
    },
    "10189":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u0415\u043b\u0431\u0430\u043a",
      "longitude":84.144577,
      "latitude":55.709202
    },
    "10190":{
      "name":"\u041a\u043e\u0437\u043b\u043e\u0432\u043a\u0430",
      "longitude":84.181808,
      "latitude":55.859039
    },
    "10191":{
      "name":"\u0421\u0442\u0430\u0440\u044b\u0439 \u0415\u043b\u0431\u0430\u043a",
      "longitude":84.185074,
      "latitude":55.714878
    },
    "10192":{
      "name":"\u0411\u0440\u0443\u0441\u044f\u043d\u043a\u0430",
      "longitude":84.19574,
      "latitude":55.207188
    },
    "10193":{
      "name":"\u041c\u0435\u0437\u0435\u043d\u0438\u0445\u0430",
      "longitude":84.199623,
      "latitude":55.243973
    },
    "10194":{
      "name":"\u041f\u0440\u044f\u043c\u0443\u0448\u043a\u0430",
      "longitude":84.202759,
      "latitude":55.106358
    },
    "10195":{
      "name":"\u041c\u0435\u0437\u0435\u043d\u0438\u0445\u0430",
      "longitude":84.2034,
      "latitude":55.274872
    },
    "10196":{
      "name":"\u0427\u0430\u0445\u043b\u043e\u0432\u043e",
      "longitude":84.225449,
      "latitude":55.611641
    },
    "10197":{
      "name":"\u041a\u043e\u0432\u0430\u043b\u0435\u0432\u043a\u0430",
      "longitude":84.228813,
      "latitude":55.293816
    },
    "10198":{
      "name":"\u041a\u0438\u0435\u0432\u043a\u0430",
      "longitude":84.23291,
      "latitude":55.606346
    },
    "10199":{
      "name":"\u0428\u0443\u0431\u043a\u0438\u043d\u043e",
      "longitude":84.241058,
      "latitude":55.078049
    },
    "10200":{
      "name":"\u041a\u0430\u0434\u043d\u0438\u0445\u0430",
      "longitude":84.242332,
      "latitude":55.022289
    },
    "10201":{
      "name":"\u0412\u0435\u0440\u0445-\u0427\u0435\u043c\u0441\u043a\u043e\u0439",
      "longitude":84.245827,
      "latitude":54.866344
    },
    "10202":{
      "name":"\u041b\u0435\u0431\u044f\u0436\u044c\u0435",
      "longitude":84.248177,
      "latitude":55.564484
    },
    "10203":{
      "name":"\u0417\u0432\u0435\u0440\u043e\u0431\u043e\u0439\u043a\u0430",
      "longitude":84.278397,
      "latitude":55.162365
    },
    "10204":{
      "name":"\u041c\u0430\u0440\u0430\u0439",
      "longitude":84.286827,
      "latitude":54.98489
    },
    "10205":{
      "name":"\u041a\u0443\u0441\u0442\u043e\u0432\u043e",
      "longitude":84.290115,
      "latitude":55.94006
    },
    "10206":{
      "name":"\u041a\u0438\u0441\u0435\u043b\u0435\u0432\u043a\u0430",
      "longitude":84.293968,
      "latitude":55.637901
    },
    "10207":{
      "name":"\u041f\u0440\u0430\u0432\u044b\u0439 \u041a\u0443\u0440\u0443\u043d\u0434\u0443\u0441",
      "longitude":84.305977,
      "latitude":54.992092
    },
    "10208":{
      "name":"\u0422\u0435\u0440\u0441\u043a",
      "longitude":84.311348,
      "latitude":55.531048
    },
    "10209":{
      "name":"\u0420\u044b\u0431\u043a\u0438\u043d\u0441\u043a",
      "longitude":84.330109,
      "latitude":55.881107
    },
    "10210":{
      "name":"\u0412\u0438\u0442\u0435\u0431\u0441\u043a",
      "longitude":84.356964,
      "latitude":55.739655
    },
    "10211":{
      "name":"\u041c\u0430\u043d\u0443\u0439\u043b\u043e\u0432\u043e",
      "longitude":84.401199,
      "latitude":55.588371
    },
    "10212":{
      "name":"\u0412\u0435\u0440\u0445\u043e\u0442\u0443\u0440\u043e\u0432\u043a\u0430",
      "longitude":84.404984,
      "latitude":55.509537
    },
    "10213":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u0437\u043d\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":84.41114,
      "latitude":55.844646
    },
    "10214":{
      "name":"\u041a\u0430\u043d\u0434\u0435\u0440\u0435\u043f",
      "longitude":84.413353,
      "latitude":55.803062
    },
    "10215":{
      "name":"\u0421\u0430\u0431\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":84.425964,
      "latitude":55.618011
    },
    "10216":{
      "name":"\u0421\u0435\u0440\u0435\u0431\u0440\u0435\u043d\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":84.43985,
      "latitude":54.364918
    },
    "10217":{
      "name":"\u0414\u043e\u043b\u0433\u043e\u0432\u043e",
      "longitude":84.453659,
      "latitude":55.440716
    },
    "10218":{
      "name":"\u0412\u044b\u0441\u043e\u043a\u0430\u044f \u0413\u0440\u0438\u0432\u0430",
      "longitude":84.457436,
      "latitude":55.118587
    },
    "10219":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u042f\u0440",
      "longitude":84.467674,
      "latitude":55.197895
    },
    "10220":{
      "name":"\u041e\u0441\u0442\u0430\u043d\u0438\u043d\u043e",
      "longitude":84.469841,
      "latitude":55.351444
    },
    "10221":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":84.476234,
      "latitude":55.529449
    },
    "10222":{
      "name":"\u0414\u0435\u0432\u0438\u043d\u043e",
      "longitude":84.488197,
      "latitude":55.181267
    },
    "10223":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u0412\u044b\u0441\u0435\u043b\u043e\u043a",
      "longitude":84.510277,
      "latitude":55.427464
    },
    "10224":{
      "name":"\u0412\u043e\u0440\u043e\u0431\u044c\u0435\u0432\u0430 \u0417\u0430\u0438\u043c\u043a\u0430",
      "longitude":84.511086,
      "latitude":54.230888
    },
    "10225":{
      "name":"\u0418\u043d\u0441\u043a\u043e\u0439",
      "longitude":84.511894,
      "latitude":55.227158
    },
    "10226":{
      "name":"\u041f\u044f\u0442\u0438\u043b\u0435\u0442\u043a\u0430",
      "longitude":84.519966,
      "latitude":54.97036
    },
    "10227":{
      "name":"\u0422\u0430\u0441\u043a\u0430\u0435\u0432\u043e",
      "longitude":84.525192,
      "latitude":55.648197
    },
    "10228":{
      "name":"\u041d\u043e\u0432\u043e\u0430\u0431\u044b\u0448\u0435\u0432\u043e",
      "longitude":84.525223,
      "latitude":54.890839
    },
    "10229":{
      "name":"\u041e\u0441\u0442\u0430\u043d\u043e\u0432\u043e\u0447\u043d\u0430\u044f \u041f\u043b\u0430\u0442\u0444\u043e\u0440\u043c\u0430 \u0422\u044b\u043d",
      "longitude":84.527168,
      "latitude":55.692932
    },
    "10230":{
      "name":"\u0413\u0430\u0440\u0435\u0432\u043a\u0430",
      "longitude":84.538177,
      "latitude":55.118771
    },
    "10231":{
      "name":"\u0414\u0440\u0435\u0441\u0432\u044f\u043d\u043a\u0430",
      "longitude":84.543533,
      "latitude":54.198959
    },
    "10232":{
      "name":"\u041e\u0441\u0442\u0430\u043d\u043e\u0432\u043e\u0447\u043d\u0430\u044f \u041f\u043b\u0430\u0442\u0444\u043e\u0440\u043c\u0430 141 \u043a",
      "longitude":84.563248,
      "latitude":55.161388
    },
    "10233":{
      "name":"\u0418\u0437\u044b\u043b\u044b",
      "longitude":84.573685,
      "latitude":55.169727
    },
    "10234":{
      "name":"\u041d\u043e\u0432\u043e\u043b\u0443\u0448\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":84.593781,
      "latitude":54.518761
    },
    "10235":{
      "name":"\u0417\u0430\u0433\u043e\u0440\u0430",
      "longitude":84.604095,
      "latitude":54.302391
    },
    "10236":{
      "name":"\u0413\u0440\u0430\u043d\u0438\u0442",
      "longitude":84.607079,
      "latitude":55.144867
    },
    "10237":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u0433\u0443\u0442\u043e\u0432\u043e",
      "longitude":84.61235,
      "latitude":54.742737
    },
    "10238":{
      "name":"\u0412\u0435\u0440\u0445-\u0410\u0447\u0438\u043d\u043e",
      "longitude":84.620308,
      "latitude":55.444454
    },
    "10239":{
      "name":"\u0414\u043e\u0440\u043e\u043d\u0438\u043d\u043e",
      "longitude":84.622658,
      "latitude":54.97813
    },
    "10240":{
      "name":"\u041a\u0443\u0441\u043a\u043e\u0432\u043e",
      "longitude":84.627724,
      "latitude":55.209141
    },
    "10241":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u043a\u0430",
      "longitude":84.633545,
      "latitude":55.581833
    },
    "10242":{
      "name":"\u0413\u043e\u043b\u043e\u043c\u044b\u0441\u043a\u0438\u043d\u043e",
      "longitude":84.642738,
      "latitude":55.031071
    },
    "10243":{
      "name":"\u041e\u0441\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":84.666283,
      "latitude":55.321152
    },
    "10244":{
      "name":"\u0415\u043b\u0444\u0438\u043c\u043e\u0432\u043e",
      "longitude":84.68219,
      "latitude":55.630417
    },
    "10245":{
      "name":"\u0416\u0435\u0440\u043d\u043e\u0432\u043a\u0430",
      "longitude":84.68914,
      "latitude":54.333786
    },
    "10246":{
      "name":"\u041d\u0438\u0437\u043e\u0432\u043a\u0430",
      "longitude":84.70636,
      "latitude":55.095036
    },
    "10247":{
      "name":"\u0411\u043e\u0440\u043e\u0432\u0430\u044f",
      "longitude":84.721504,
      "latitude":55.240841
    },
    "10248":{
      "name":"\u041f\u0440\u0430\u0432\u043e\u0441\u043e\u0441\u043d\u043e\u0432\u043a\u0430",
      "longitude":84.722847,
      "latitude":55.551094
    },
    "10249":{
      "name":"\u0418\u0437\u044b\u043b\u0438\u043d\u043a\u0430",
      "longitude":84.728981,
      "latitude":55.108696
    },
    "10250":{
      "name":"\u041a\u043e\u043d\u0435\u0432\u043e",
      "longitude":84.73214,
      "latitude":54.83606
    },
    "10251":{
      "name":"\u041a\u0430\u0440\u043c\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":84.732971,
      "latitude":55.483105
    },
    "10252":{
      "name":"\u041d\u043e\u0432\u043e\u0438\u0437\u044b\u043b\u0438\u043d\u043a\u0430",
      "longitude":84.741165,
      "latitude":55.11655
    },
    "10253":{
      "name":"\u041f\u0435\u0442\u0443\u0445\u043e\u0432\u043a\u0430",
      "longitude":84.749168,
      "latitude":55.109173
    },
    "10254":{
      "name":"\u041f\u0435\u0442\u0435\u043d\u0438",
      "longitude":84.754677,
      "latitude":54.419987
    },
    "10255":{
      "name":"\u041d\u0438\u0436\u043d\u044f\u044f \u041c\u0430\u0442\u0440\u0435\u043d\u043a\u0430",
      "longitude":84.761885,
      "latitude":54.4642764
    },
    "10256":{
      "name":"\u0421\u043c\u0438\u0440\u043d\u043e\u0432\u043a\u0430",
      "longitude":84.766762,
      "latitude":54.974007
    },
    "10257":{
      "name":"\u0421\u0430\u043b\u0430\u043c\u0430\u0442\u043e\u0432\u043e",
      "longitude":84.773354,
      "latitude":55.158062
    },
    "10258":{
      "name":"\u041a\u0443\u0441\u043c\u0435\u043d\u044c",
      "longitude":84.791382,
      "latitude":55.257622
    },
    "10259":{
      "name":"\u0427\u0443\u0434\u0438\u043d\u043e\u0432\u043e",
      "longitude":84.823166,
      "latitude":54.340221
    },
    "10260":{
      "name":"\u041a\u0443\u0447\u0430\u043d\u0438\u0445\u0430",
      "longitude":84.850616,
      "latitude":55.078781
    },
    "10261":{
      "name":"\u041c\u043e\u043a\u0440\u0443\u0448\u0438\u043d\u043e",
      "longitude":84.865623,
      "latitude":54.749607
    },
    "10262":{
      "name":"\u041f\u0440\u0438\u0434\u043e\u043b\u0438\u043d\u043d\u044b\u0439",
      "longitude":84.866493,
      "latitude":54.936897
    },
    "10263":{
      "name":"\u0420\u0430\u0437\u043b\u0438\u0432\u044b",
      "longitude":84.87104,
      "latitude":55.176399
    },
    "10264":{
      "name":"\u0420\u043e\u0434\u043d\u0438\u043a\u0438",
      "longitude":84.903214,
      "latitude":55.125057
    },
    "10265":{
      "name":"\u041a\u043e\u043b\u0442\u044b\u0440\u0430\u043a",
      "longitude":84.915924,
      "latitude":54.788818
    },
    "10266":{
      "name":"2-\u0439 \u0421\u0430\u0440\u0430\u043d\u0447\u0435\u0442",
      "longitude":97.2153163,
      "latitude":55.8184801
    },
    "10267":{
      "name":"1-\u0439 \u0421\u0430\u0440\u0430\u043d\u0447\u0435\u0442",
      "longitude":97.2472191,
      "latitude":55.8074912
    },
    "10268":{
      "name":"\u0422\u0438\u043d\u0441\u043a\u0430\u044f \u0414\u0430\u0447\u0430",
      "longitude":97.2951133,
      "latitude":56.0021467
    },
    "10269":{
      "name":"\u0422\u0443\u043c\u0430\u043d\u0448\u0435\u0442",
      "longitude":97.347061,
      "latitude":55.825123
    },
    "10270":{
      "name":"\u0422\u043e\u0447\u0438\u043b\u044c\u043d\u044b\u0439",
      "longitude":97.428978,
      "latitude":56.081242
    },
    "10271":{
      "name":"\u041a\u0430\u043c\u044b\u0448\u043b\u0435\u0435\u0432\u043a\u0430",
      "longitude":97.432419,
      "latitude":55.832367
    },
    "10272":{
      "name":"\u0422\u0443\u043c\u0430\u043d\u0448\u0435\u0442",
      "longitude":97.4480746,
      "latitude":55.8809284
    },
    "10273":{
      "name":"\u0417\u044b\u0440\u044f\u043d\u043e\u0432\u043a\u0430",
      "longitude":97.462952,
      "latitude":55.912384
    },
    "10274":{
      "name":"\u0427\u0435\u0440\u0435\u043c\u0448\u0430\u043d\u043a\u0430",
      "longitude":97.47953,
      "latitude":56.095951
    },
    "10275":{
      "name":"\u0422\u0440\u043e\u0438\u0446\u043a",
      "longitude":97.548882,
      "latitude":55.918934
    },
    "10276":{
      "name":"\u041f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":97.552643,
      "latitude":55.84724
    },
    "10277":{
      "name":"\u0413\u0435\u043e\u0440\u0433\u0438\u0435\u0432\u043a\u0430",
      "longitude":97.623764,
      "latitude":55.519894
    },
    "10278":{
      "name":"\u0417\u0430\u043f\u0430\u043d\u044c",
      "longitude":97.629181,
      "latitude":55.969841
    },
    "10279":{
      "name":"\u0418\u043d\u0433\u0430\u0448\u0435\u0442",
      "longitude":97.632088,
      "latitude":55.695488
    },
    "10280":{
      "name":"\u0427\u0435\u0440\u043c\u0430\u043d\u0447\u0435\u0442",
      "longitude":97.6847,
      "latitude":56.875633
    },
    "10281":{
      "name":"\u0410\u0432\u0434\u044e\u0448\u0438\u043d\u043e",
      "longitude":97.700935,
      "latitude":55.915237
    },
    "10282":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u0448\u0435\u043b\u0435\u0445\u043e\u0432\u0430",
      "longitude":97.716347,
      "latitude":55.705635
    },
    "10283":{
      "name":"\u0415\u043d\u0438\u0441\u0435\u0439\u043a\u0430",
      "longitude":97.734428,
      "latitude":55.974667
    },
    "10284":{
      "name":"\u0415\u043b\u043e\u0432\u0430\u044f",
      "longitude":97.770955,
      "latitude":56.0484082
    },
    "10285":{
      "name":"\u0411\u043b\u0430\u0433\u043e\u0434\u0430\u0442\u0441\u043a\u043e\u0435",
      "longitude":97.784157,
      "latitude":55.555103
    },
    "10286":{
      "name":"\u041f\u043e\u0439\u043c\u0430",
      "longitude":97.7869308,
      "latitude":56.8834713
    },
    "10287":{
      "name":"\u0421\u0430\u0444\u0440\u043e\u043d\u043e\u0432\u043a\u0430",
      "longitude":97.8132862,
      "latitude":55.8848272
    },
    "10288":{
      "name":"\u041a\u043e\u043d\u0442\u043e\u0440\u043a\u0430",
      "longitude":97.862007,
      "latitude":56.027317
    },
    "10289":{
      "name":"\u0421\u0435\u0440\u0435\u0431\u0440\u043e\u0432\u043e",
      "longitude":97.864296,
      "latitude":55.412247
    },
    "10290":{
      "name":"\u0421\u0435\u0440\u0430\u0444\u0438\u043c\u043e\u0432\u043a\u0430",
      "longitude":97.954544,
      "latitude":55.839527
    },
    "10291":{
      "name":"\u041a\u043e\u043b\u0442\u043e\u0448\u0438",
      "longitude":98.012985,
      "latitude":55.480694
    },
    "10292":{
      "name":"\u0421\u0430\u0444\u0440\u043e\u043d\u043e\u0432\u043a\u0430",
      "longitude":98.016212,
      "latitude":56.011478
    },
    "10293":{
      "name":"\u041d\u043e\u0432\u043e\u0442\u0440\u0435\u043c\u0438\u043d\u043e",
      "longitude":98.06765,
      "latitude":56.726151
    },
    "10294":{
      "name":"\u041d\u043e\u0432\u044b\u0439 \u0410\u043a\u0443\u043b\u044c\u0448\u0435\u0442",
      "longitude":98.0765,
      "latitude":55.91095
    },
    "10295":{
      "name":"\u0421\u0438\u043d\u044f\u043a\u0438\u043d\u0430",
      "longitude":98.082596,
      "latitude":56.086689
    },
    "10296":{
      "name":"\u0410\u043a\u0443\u043b\u044c\u0448\u0435\u0442",
      "longitude":98.107697,
      "latitude":55.957447
    },
    "10297":{
      "name":"\u0411\u0430\u0439\u0440\u043e\u043d\u043e\u0432\u043a\u0430",
      "longitude":98.109871,
      "latitude":55.889973
    },
    "10298":{
      "name":"\u041f\u0430\u0440\u0438\u0436\u0441\u043a\u0430\u044f \u041a\u043e\u043c\u043c\u0443\u043d\u0430",
      "longitude":98.120651,
      "latitude":55.940441
    },
    "10299":{
      "name":"\u041a\u043e\u043d\u043e\u0432\u0430\u043b\u043e\u0432\u0430",
      "longitude":98.169472,
      "latitude":56.100056
    },
    "10300":{
      "name":"\u041a\u043e\u043d\u0434\u0440\u0430\u0442\u044c\u0435\u0432\u043e",
      "longitude":98.184692,
      "latitude":57.349693
    },
    "10301":{
      "name":"\u042f\u0433\u0430",
      "longitude":98.227989,
      "latitude":54.705292
    },
    "10302":{
      "name":"\u041d\u0438\u0436\u043d\u044f\u044f \u0413\u043e\u0433\u043e\u043b\u0435\u0432\u043a\u0430",
      "longitude":98.242889,
      "latitude":56.049362
    },
    "10303":{
      "name":"\u041d\u043e\u0432\u043e\u0448\u0435\u043b\u0435\u0445\u043e\u0432\u0430",
      "longitude":98.253906,
      "latitude":55.730427
    },
    "10304":{
      "name":"\u0422\u0440\u0430\u043a\u0442-\u0423\u0436\u0435\u0442",
      "longitude":98.255348,
      "latitude":56.261097
    },
    "10305":{
      "name":"\u0420\u044b\u0431\u0438\u043d\u0441\u043a",
      "longitude":98.264153,
      "latitude":56.097095
    },
    "10306":{
      "name":"\u0411\u043e\u0440\u043e\u043a",
      "longitude":98.278542,
      "latitude":56.111729
    },
    "10307":{
      "name":"\u041a\u043e\u0441\u0442\u043e\u043c\u0430\u0440\u043e\u0432\u043e",
      "longitude":98.284622,
      "latitude":56.103729
    },
    "10308":{
      "name":"\u0422\u0440\u0430\u043a\u0442-\u041a\u0430\u0432\u043a\u0430\u0437",
      "longitude":98.321045,
      "latitude":56.302139
    },
    "10309":{
      "name":"\u042f\u043a\u043e\u0432\u0441\u043a\u0430\u044f",
      "longitude":98.39669,
      "latitude":56.448917
    },
    "10310":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432 \u041c\u044b\u0441",
      "longitude":98.408821,
      "latitude":56.511032
    },
    "10311":{
      "name":"\u0428\u0435\u043c\u044f\u043a\u0438\u043d\u0430",
      "longitude":98.425705,
      "latitude":56.508018
    },
    "10312":{
      "name":"\u0422\u043e\u043f\u043e\u0440\u043e\u043a",
      "longitude":98.4276223,
      "latitude":56.1432452
    },
    "10313":{
      "name":"\u0428\u0435\u0432\u0447\u0435\u043d\u043a\u043e",
      "longitude":98.437012,
      "latitude":56.13599
    },
    "10314":{
      "name":"\u041e\u0431\u043b\u0435\u043f\u0438\u0445\u0430",
      "longitude":98.452464,
      "latitude":55.6661383
    },
    "10315":{
      "name":"\u041a\u043e\u0440\u043e\u043b\u0435\u043d\u043a\u043e",
      "longitude":98.4604803,
      "latitude":56.1100667
    },
    "10316":{
      "name":"\u041a\u043e\u0441\u043e\u0439 \u0411\u0440\u043e\u0434",
      "longitude":98.574013,
      "latitude":55.447365
    },
    "10317":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u0430\u044f \u041a\u0430\u0432\u0430\u043b\u0435\u0440\u0438\u044f",
      "longitude":98.613548,
      "latitude":55.707863
    },
    "10318":{
      "name":"\u041c\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":98.621239,
      "latitude":56.151157
    },
    "10319":{
      "name":"\u0410\u043b\u0433\u0430\u0448\u0435\u0442",
      "longitude":98.621658,
      "latitude":55.465275
    },
    "10320":{
      "name":"\u0411\u0443\u0440\u0430\u043a\u043e\u0432\u0430",
      "longitude":98.658951,
      "latitude":55.731411
    },
    "10321":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u0438\u0435\u0432\u0441\u043a",
      "longitude":98.66993,
      "latitude":55.669235
    },
    "10322":{
      "name":"\u0417\u0430\u0433\u043e\u0440\u044c\u0435",
      "longitude":98.680138,
      "latitude":55.299088
    },
    "10323":{
      "name":"\u041c\u0430\u0440\u0430",
      "longitude":98.847221,
      "latitude":55.001808
    },
    "10324":{
      "name":"\u041d\u043e\u0432\u043e\u0435 \u0421\u0435\u043b\u043e",
      "longitude":98.851837,
      "latitude":54.901459
    },
    "10325":{
      "name":"\u041d\u0430\u0433\u043e\u0440\u043d\u044b\u0439",
      "longitude":98.8670109,
      "latitude":56.1888669
    },
    "10326":{
      "name":"\u041d\u0435\u0432\u0430\u043d\u043a\u0430",
      "longitude":98.91655,
      "latitude":56.490799
    },
    "10327":{
      "name":"\u0423\u0432\u0430\u0442",
      "longitude":98.951187,
      "latitude":54.866322
    },
    "10328":{
      "name":"\u041c\u0443\u043a\u0441\u0443\u0442",
      "longitude":98.974861,
      "latitude":54.843304
    },
    "10329":{
      "name":"\u0422\u0430\u0451\u0436\u043d\u044b\u0439",
      "longitude":98.996772,
      "latitude":55.6548236
    },
    "10330":{
      "name":"\u041c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":99.012962,
      "latitude":54.828018
    },
    "10331":{
      "name":"\u0412\u044b\u0434\u0440\u0438\u043d\u043e",
      "longitude":99.030891,
      "latitude":56.837303
    },
    "10332":{
      "name":"\u0428\u0432\u0430\u0439\u043a\u0438\u043d\u0430",
      "longitude":99.034286,
      "latitude":54.815659
    },
    "10333":{
      "name":"\u0412\u043e\u0434\u043e\u043f\u0430\u0434\u043d\u044b\u0439",
      "longitude":99.034752,
      "latitude":55.046936
    },
    "10334":{
      "name":"\u0427\u0430\u043b\u043e\u0442\u044b",
      "longitude":99.083466,
      "latitude":54.650822
    },
    "10335":{
      "name":"\u0413\u0430\u043d\u044c\u043a\u0438\u043d\u0430",
      "longitude":99.103798,
      "latitude":56.321266
    },
    "10336":{
      "name":"\u0410\u0431\u0430\u043b\u0430\u043a\u043e\u0432\u043e",
      "longitude":99.113609,
      "latitude":54.743614
    },
    "10337":{
      "name":"\u0413\u0440\u043e\u0434\u0438\u043d\u0441\u043a",
      "longitude":99.131134,
      "latitude":55.675735
    },
    "10338":{
      "name":"\u0428\u0443\u043c",
      "longitude":99.132774,
      "latitude":54.80904
    },
    "10339":{
      "name":"\u041a\u0435\u0434\u0440\u043e\u0432\u044b\u0439",
      "longitude":99.1492619,
      "latitude":56.1618688
    },
    "10340":{
      "name":"\u0418\u0433\u043d\u0438\u0442",
      "longitude":99.1547538,
      "latitude":55.1415848
    },
    "10341":{
      "name":"\u041d\u043e\u0432\u043e\u0433\u0440\u043e\u0434\u0438\u043d\u0441\u043a",
      "longitude":99.167381,
      "latitude":55.679031
    },
    "10342":{
      "name":"\u041a\u0443\u0448\u0443\u043d",
      "longitude":99.192574,
      "latitude":54.63773
    },
    "10343":{
      "name":"\u0422\u0430\u0445\u0442\u0430\u043c\u0430\u0439",
      "longitude":99.199394,
      "latitude":56.244576
    },
    "10344":{
      "name":"\u041a\u0430\u043a\u0441\u0430\u0442",
      "longitude":99.203163,
      "latitude":54.970436
    },
    "10345":{
      "name":"\u0411\u0430\u043b\u0442\u0443\u0440\u0438\u043d\u043e",
      "longitude":99.240562,
      "latitude":56.190815
    },
    "10346":{
      "name":"\u0423\u043a-\u0411\u0430\u0434\u0430\u0440\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":99.247215,
      "latitude":55.087173
    },
    "10347":{
      "name":"\u0423\u043a\u0430\u0440",
      "longitude":99.263123,
      "latitude":55.061707
    },
    "10348":{
      "name":"\u041f\u0440\u0438\u0432\u043e\u043b\u044c\u043d\u043e\u0435",
      "longitude":99.264214,
      "latitude":54.561237
    },
    "10349":{
      "name":"\u041f\u0443\u0448\u043a\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":99.269783,
      "latitude":54.543167
    },
    "10350":{
      "name":"\u041a\u0438\u0440\u0435\u0439-\u041c\u0443\u043a\u0441\u0443\u0442",
      "longitude":99.307434,
      "latitude":54.630692
    },
    "10351":{
      "name":"\u041d\u043e\u0432\u043e\u0447\u0443\u043d\u043a\u0430",
      "longitude":99.311272,
      "latitude":56.140976
    },
    "10352":{
      "name":"\u0425\u0438\u043d\u0433\u0443\u0439",
      "longitude":99.341057,
      "latitude":54.7925
    },
    "10353":{
      "name":"\u041a\u0430\u0442\u044b\u043d",
      "longitude":99.34832,
      "latitude":54.436962
    },
    "10354":{
      "name":"\u0427\u0435\u0440\u0435\u043c\u0448\u0430\u043d\u043a\u0430",
      "longitude":99.352219,
      "latitude":55.374809
    },
    "10355":{
      "name":"\u041a\u0430\u0437\u0430\u0447\u044c\u044f \u0411\u0430\u0434\u0430\u0440\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":99.376198,
      "latitude":55.139317
    },
    "10356":{
      "name":"\u0428\u0438\u043f\u0438\u0446\u0438\u043d\u0430",
      "longitude":99.376297,
      "latitude":55.213688
    },
    "10357":{
      "name":"\u0417\u0435\u043d\u0446\u043e\u0432\u0430",
      "longitude":99.381592,
      "latitude":55.366596
    },
    "10358":{
      "name":"\u0422\u043e\u043d\u0438",
      "longitude":99.400803,
      "latitude":55.548939
    },
    "10359":{
      "name":"\u041a\u0443\u0440\u0433\u0430\u0442\u0435\u0439",
      "longitude":99.429543,
      "latitude":54.376617
    },
    "10360":{
      "name":"\u0423\u0441\u0442\u044c-\u041a\u0430\u0434\u0443\u0439",
      "longitude":99.43158,
      "latitude":55.148724
    },
    "10361":{
      "name":"\u0411\u043e\u0440\u043e\u0432\u0438\u043d\u043e\u043a",
      "longitude":99.432426,
      "latitude":55.590633
    },
    "10362":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u0425\u0438\u043d\u0433\u0443\u0439",
      "longitude":99.441895,
      "latitude":54.795174
    },
    "10363":{
      "name":"\u0412\u043e\u043b\u0447\u0438\u0439 \u0411\u0440\u043e\u0434",
      "longitude":99.451019,
      "latitude":54.451843
    },
    "10364":{
      "name":"\u041f\u0440\u0438\u0443\u0434\u0438\u043d\u0441\u043a",
      "longitude":99.454376,
      "latitude":55.727455
    },
    "10365":{
      "name":"\u041b\u0435\u0441\u043d\u043e\u0439",
      "longitude":99.484779,
      "latitude":55.043766
    },
    "10366":{
      "name":"\u041a\u0430\u0434\u0443\u0439",
      "longitude":99.499039,
      "latitude":54.743546
    },
    "10367":{
      "name":"\u0411\u0430\u0435\u0440",
      "longitude":99.512947,
      "latitude":55.765179
    },
    "10368":{
      "name":"\u041c\u0443\u043d\u0442\u0443\u0431\u0443\u043b\u0443\u043a",
      "longitude":99.532997,
      "latitude":54.424789
    },
    "10369":{
      "name":"\u041f\u0438\u0442\u0430\u0435\u0432\u0430",
      "longitude":99.536926,
      "latitude":55.91534
    },
    "10370":{
      "name":"\u041e\u043a\u0442\u044f\u0431\u0440\u044c\u0441\u043a\u0438\u0439",
      "longitude":99.547699,
      "latitude":55.308846
    },
    "10371":{
      "name":"\u0411\u0430\u044f\u043d\u0434\u0430",
      "longitude":99.56501,
      "latitude":55.994942
    },
    "10372":{
      "name":"\u041e\u043a\u0440\u0430\u0438\u043d\u0430",
      "longitude":99.566833,
      "latitude":55.939053
    },
    "10373":{
      "name":"\u041e\u0440\u0438\u043a",
      "longitude":99.568848,
      "latitude":54.313023
    },
    "10374":{
      "name":"\u0411\u043e\u0440\u043e\u0434\u0438\u043d\u0441\u043a",
      "longitude":99.572952,
      "latitude":54.359295
    },
    "10375":{
      "name":"\u041c\u0438\u0440\u043e\u043d\u043e\u0432\u043e",
      "longitude":99.5881406,
      "latitude":56.0663941
    },
    "10376":{
      "name":"\u0423\u0442",
      "longitude":99.683655,
      "latitude":54.274632
    },
    "10377":{
      "name":"\u0423\u043d\u0433\u0443\u0434\u0443\u043b",
      "longitude":99.689453,
      "latitude":54.303593
    },
    "10378":{
      "name":"\u042e\u0440\u0442\u044b \u041a\u0430\u0440\u0430\u0433\u043e\u0437\u0441\u043a\u0438\u0435",
      "longitude":99.7,
      "latitude":53.333333
    },
    "10379":{
      "name":"\u041a\u0430\u0434\u0443\u0439",
      "longitude":99.708717,
      "latitude":54.777901
    },
    "10380":{
      "name":"\u0422\u0430\u0440\u0435\u044f",
      "longitude":99.719086,
      "latitude":55.869652
    },
    "10381":{
      "name":"\u0422\u0430\u043b\u044b\u0439 \u041a\u043b\u044e\u0447",
      "longitude":99.72683,
      "latitude":54.627491
    },
    "10382":{
      "name":"\u041a\u0443\u043b\u0438\u0448",
      "longitude":99.737823,
      "latitude":55.841419
    },
    "10383":{
      "name":"\u0413\u0430\u043b\u0434\u0443\u043d",
      "longitude":99.801567,
      "latitude":54.213516
    },
    "10384":{
      "name":"\u041c\u0438\u043b\u043b\u0435\u0440\u043e\u0432\u0430",
      "longitude":99.814293,
      "latitude":54.372585
    },
    "10385":{
      "name":"\u0417\u0430\u0445\u0430\u0440\u043e\u0432\u043a\u0430",
      "longitude":99.833992,
      "latitude":56.152042
    },
    "10386":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u041e\u0434\u0435\u0440",
      "longitude":99.835632,
      "latitude":54.261604
    },
    "10387":{
      "name":"\u041c\u0430\u0440\u0433\u0430",
      "longitude":99.844017,
      "latitude":54.599422
    },
    "10388":{
      "name":"\u0413\u0430\u0440\u0431\u0430\u043a\u0430\u0440\u0430\u0439",
      "longitude":99.871368,
      "latitude":54.160454
    },
    "10389":{
      "name":"\u0412\u0438\u043b\u0435\u043d\u0441\u043a",
      "longitude":99.889809,
      "latitude":54.547966
    },
    "10390":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0435\u0432\u0435\u0440\u0441\u0442\u043e\u0432\u0441\u043a",
      "longitude":99.898636,
      "latitude":54.693539
    },
    "10391":{
      "name":"\u0415\u043b\u0430\u043d\u044c",
      "longitude":99.91938,
      "latitude":56.184799
    },
    "10392":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u0411\u0443\u0440\u0431\u0443\u043a",
      "longitude":99.922409,
      "latitude":54.32098
    },
    "10393":{
      "name":"\u0412\u0430\u0440\u044f\u0433",
      "longitude":99.975555,
      "latitude":54.638256
    },
    "10394":{
      "name":"\u0427\u0443\u043a\u0448\u0430",
      "longitude":100.050964,
      "latitude":56.131393
    },
    "10395":{
      "name":"\u041a\u0438\u043b\u0438\u043c",
      "longitude":100.051834,
      "latitude":54.700779
    },
    "10396":{
      "name":"\u0410\u0432\u0435\u0440\u044c\u044f\u043d\u043e\u0432\u043a\u0430",
      "longitude":100.075195,
      "latitude":54.568951
    },
    "10397":{
      "name":"\u042e\u0436\u043d\u044b\u0439 \u041a\u0430\u0434\u0443\u0439",
      "longitude":100.082527,
      "latitude":54.664642
    },
    "10398":{
      "name":"\u0421\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u041a\u0430\u0434\u0443\u0439",
      "longitude":100.095871,
      "latitude":54.672676
    },
    "10399":{
      "name":"\u0418\u043a\u0435\u0439\u0441\u043a\u0438\u0439",
      "longitude":100.100136,
      "latitude":54.205296
    },
    "10400":{
      "name":"\u041a\u043b\u044e\u0447\u0435\u0432\u043e\u0439",
      "longitude":100.166466,
      "latitude":54.601017
    },
    "10401":{
      "name":"\u0425\u0430\u0440\u0430\u043c\u0430\u043d\u0443\u0442",
      "longitude":100.193466,
      "latitude":54.493889
    },
    "10402":{
      "name":"\u0425\u0430\u0440\u0430\u043d\u0442\u0435\u0439",
      "longitude":100.21312,
      "latitude":54.169605
    },
    "10403":{
      "name":"\u0422\u0440\u0430\u043a\u0442\u043e\u0432\u043e-\u041a\u0443\u0440\u0437\u0430\u043d",
      "longitude":100.213501,
      "latitude":54.613617
    },
    "10404":{
      "name":"\u0412\u043e\u0437\u043d\u0435\u0441\u0435\u043d\u0441\u043a",
      "longitude":100.246887,
      "latitude":54.193176
    },
    "10405":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":100.382164,
      "latitude":54.478458
    },
    "10406":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u0432\u0441\u043a",
      "longitude":100.400932,
      "latitude":54.365112
    },
    "10407":{
      "name":"\u0422\u0430\u043b\u0445\u0430\u043d",
      "longitude":100.421967,
      "latitude":54.240234
    },
    "10408":{
      "name":"\u041c\u0430\u043b\u044b\u0439 \u0423\u0442\u0430\u0439\u0447\u0438\u043a",
      "longitude":100.423386,
      "latitude":54.638378
    },
    "10409":{
      "name":"\u0422\u0430\u0440\u0435\u044f",
      "longitude":100.4299138,
      "latitude":56.248668
    },
    "10410":{
      "name":"\u0418\u043d\u0433\u0443\u0442",
      "longitude":100.435081,
      "latitude":54.177273
    },
    "10411":{
      "name":"\u041e\u0434\u043e\u043d",
      "longitude":100.482246,
      "latitude":54.186092
    },
    "10412":{
      "name":"\u041b\u0443\u0433\u043e\u0432\u043e\u0439",
      "longitude":100.486504,
      "latitude":55.251637
    },
    "10413":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u0414\u0435\u0440\u0435\u0432\u043d\u044f",
      "longitude":100.505623,
      "latitude":54.561401
    },
    "10414":{
      "name":"\u0417\u0430\u0443\u0441\u0430\u0435\u0432\u0430",
      "longitude":100.514862,
      "latitude":54.630154
    },
    "10415":{
      "name":"\u041a\u0430\u0440\u0430\u0439",
      "longitude":100.524841,
      "latitude":55.195087
    },
    "10416":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u041c\u0430\u043d\u0443\u0442",
      "longitude":100.543335,
      "latitude":54.446026
    },
    "10417":{
      "name":"\u041a\u0430\u0437\u0430\u043a\u043e\u0432\u0430",
      "longitude":100.549194,
      "latitude":54.518162
    },
    "10418":{
      "name":"\u041f\u0430\u0432\u043b\u043e\u0432\u043a\u0430",
      "longitude":100.555244,
      "latitude":54.845585
    },
    "10419":{
      "name":"\u041a\u0440\u0438\u0432\u0443\u0448\u0430",
      "longitude":100.577019,
      "latitude":54.086033
    },
    "10420":{
      "name":"\u0410\u043d\u0433\u0443\u0439",
      "longitude":100.581528,
      "latitude":54.939884
    },
    "10421":{
      "name":"\u0410\u043d\u0433\u0443\u0439\u0441\u043a\u0438\u0439",
      "longitude":100.586311,
      "latitude":54.927391
    },
    "10422":{
      "name":"\u0427\u0438\u0441\u0442\u044f\u043a\u043e\u0432\u043e",
      "longitude":100.599152,
      "latitude":55.112038
    },
    "10423":{
      "name":"\u0417\u0430\u0431\u043e\u0440",
      "longitude":100.62648,
      "latitude":54.36401
    },
    "10424":{
      "name":"\u0415\u0432\u0434\u043e\u043a\u0438\u043c\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":100.665489,
      "latitude":54.247047
    },
    "10425":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u043e\u0437\u0451\u0440\u0441\u043a\u0438\u0439",
      "longitude":100.6838,
      "latitude":54.242184
    },
    "10426":{
      "name":"\u041d\u0438\u0440\u0433\u0438\u0442",
      "longitude":100.689575,
      "latitude":54.828915
    },
    "10427":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u041e\u043a\u0442\u044f\u0431\u0440\u044c",
      "longitude":100.699005,
      "latitude":54.3437
    },
    "10428":{
      "name":"\u0410\u043d\u0434\u0440\u0435\u0435\u0432\u043a\u0430",
      "longitude":100.702904,
      "latitude":54.735641
    },
    "10429":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":100.707039,
      "latitude":54.791859
    },
    "10430":{
      "name":"\u0418\u043d\u043d\u043e\u043a\u0435\u043d\u0442\u044c\u0435\u0432\u0441\u043a\u0438\u0439",
      "longitude":100.724411,
      "latitude":54.598717
    },
    "10431":{
      "name":"\u0411\u0443\u0441\u043b\u0430\u0439\u043a\u0430 \u0410\u043d\u0433\u0443\u0439\u0441\u043a\u0430\u044f",
      "longitude":100.744629,
      "latitude":54.940365
    },
    "10432":{
      "name":"\u041d\u044e\u0440\u0430",
      "longitude":100.765305,
      "latitude":54.539886
    },
    "10433":{
      "name":"\u0410\u0437\u0435\u0439",
      "longitude":100.790657,
      "latitude":54.451416
    },
    "10434":{
      "name":"\u041a\u043e\u0432\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":100.864021,
      "latitude":56.980762
    },
    "10435":{
      "name":"\u0411\u0443\u043b\u0430\u043a",
      "longitude":100.88662,
      "latitude":55.103394
    },
    "10436":{
      "name":"\u041e\u043a\u0442\u044f\u0431\u0440\u044c\u0441\u043a\u0438\u0439-1",
      "longitude":100.908539,
      "latitude":54.83902
    },
    "10437":{
      "name":"\u0423\u0442\u0430\u043b\u0430\u0439",
      "longitude":100.908562,
      "latitude":54.338737
    },
    "10438":{
      "name":"\u041f\u0430\u0431\u0435\u0440\u0435\u0433\u0430",
      "longitude":100.925003,
      "latitude":54.840668
    },
    "10439":{
      "name":"\u0412\u043e\u0440\u043e\u0431\u044c\u0451\u0432\u043e",
      "longitude":100.962708,
      "latitude":55.424686
    },
    "10440":{
      "name":"\u0411\u043e\u0440\u043e\u0431\u0438\u043d\u043e",
      "longitude":100.976776,
      "latitude":54.882648
    },
    "10441":{
      "name":"\u0425\u0430\u0440\u0433\u0430\u0436\u0438\u043d",
      "longitude":100.99794,
      "latitude":54.285519
    },
    "10442":{
      "name":"\u0417\u0430\u0440\u0431\u044c",
      "longitude":101.035347,
      "latitude":55.446613
    },
    "10443":{
      "name":"\u041d\u043e\u0432\u043e\u0442\u0440\u043e\u0438\u0446\u043a",
      "longitude":101.049141,
      "latitude":54.456211
    },
    "10444":{
      "name":"\u0422\u0440\u0430\u043a\u0442\u043e\u0432\u0430\u044f",
      "longitude":101.060585,
      "latitude":54.483204
    },
    "10445":{
      "name":"\u0422\u0430\u0433\u0430\u043d",
      "longitude":101.152267,
      "latitude":54.296242
    },
    "10446":{
      "name":"\u0411\u0430\u0434\u0430",
      "longitude":101.153107,
      "latitude":55.39954
    },
    "10447":{
      "name":"\u0428\u0438\u0440\u043e\u043a\u0438\u0435 \u041a\u043e\u0447\u043a\u0438",
      "longitude":101.174149,
      "latitude":54.527527
    },
    "10448":{
      "name":"\u041b\u0435\u0432\u044b\u0439 \u0421\u0430\u0440\u0430\u043c",
      "longitude":101.182594,
      "latitude":53.341228
    },
    "10449":{
      "name":"\u041f\u0440\u0430\u0432\u044b\u0439 \u0421\u0430\u0440\u0430\u043c",
      "longitude":101.198044,
      "latitude":53.3307435
    },
    "10450":{
      "name":"\u041c\u0430\u043b\u043e\u0439",
      "longitude":101.2001388,
      "latitude":54.5953908
    },
    "10451":{
      "name":"\u041a\u0430\u0440\u0430\u043d\u0446\u0430\u0439",
      "longitude":101.225937,
      "latitude":54.133457
    },
    "10452":{
      "name":"\u041c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":101.240677,
      "latitude":54.526031
    },
    "10453":{
      "name":"\u0411\u0430\u0445\u0432\u0430\u043b\u043e\u0432\u043e",
      "longitude":101.2711068,
      "latitude":53.3825503
    },
    "10454":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e-\u041d\u0435\u0432\u0441\u043a\u0438\u0439 \u0417\u0430\u0432\u043e\u0434",
      "longitude":101.280388,
      "latitude":54.571571
    },
    "10455":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e-\u041d\u0435\u0432\u0441\u043a\u0430\u044f \u0421\u0442\u0430\u043d\u0438\u0446\u0430",
      "longitude":101.285957,
      "latitude":54.293442
    },
    "10456":{
      "name":"\u041f\u0440\u0438\u0434\u043e\u0440\u043e\u0436\u043d\u044b\u0439",
      "longitude":101.294266,
      "latitude":56.69463
    },
    "10457":{
      "name":"\u041c\u0438\u043d\u0433\u0430\u0442\u0443\u0439",
      "longitude":101.3011589,
      "latitude":54.4329589
    },
    "10458":{
      "name":"\u0425\u0430\u0445\u0430\u0440\u0435\u0439",
      "longitude":101.316368,
      "latitude":55.254723
    },
    "10459":{
      "name":"\u0422\u043e\u0431\u0438\u043d\u043e",
      "longitude":101.320404,
      "latitude":54.454689
    },
    "10460":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0435\u043e\u043a\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":101.322006,
      "latitude":53.465218
    },
    "10461":{
      "name":"3-\u044f \u0421\u0442\u0430\u043d\u0438\u0446\u0430",
      "longitude":101.3377606,
      "latitude":54.2113228
    },
    "10462":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":101.3647326,
      "latitude":53.9592983
    },
    "10463":{
      "name":"\u0415\u043b\u0430\u043d\u0441\u043a\u0438\u0439",
      "longitude":101.367355,
      "latitude":54.349987
    },
    "10464":{
      "name":"\u0423\u0447\u0430\u0441\u0442\u043e\u043a \u041c\u0435\u0436\u0434\u0443\u0433\u0440\u0430\u043d\u043a\u0438",
      "longitude":101.3702792,
      "latitude":53.8572881
    },
    "10465":{
      "name":"\u0418\u043b\u0438",
      "longitude":101.372971,
      "latitude":54.171131
    },
    "10466":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u041a\u043e\u0447\u0435\u0440\u043c\u0430",
      "longitude":101.381607,
      "latitude":54.502792
    },
    "10467":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u0430\u0434\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":101.395744,
      "latitude":54.76125
    },
    "10468":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u0429\u0435\u043b\u044c\u0431\u0435\u0439",
      "longitude":101.403282,
      "latitude":53.706738
    },
    "10469":{
      "name":"\u0422\u0430\u0451\u0436\u043d\u044b\u0439",
      "longitude":101.4135243,
      "latitude":53.3414052
    },
    "10470":{
      "name":"\u041f\u043e\u043b\u0442\u0430\u0432\u0430",
      "longitude":101.415695,
      "latitude":54.093952
    },
    "10471":{
      "name":"\u0410\u043f\u0440\u0430\u043a\u0441\u0438\u043d\u0430",
      "longitude":101.420685,
      "latitude":54.101894
    },
    "10472":{
      "name":"\u0423\u0440\u0443\u043d\u043a\u0443\u0439",
      "longitude":101.445625,
      "latitude":53.953472
    },
    "10473":{
      "name":"\u041c\u0435\u043d\u044c\u0447\u0443\u043a\u043e\u0432\u0430",
      "longitude":101.452621,
      "latitude":54.046192
    },
    "10474":{
      "name":"\u0420\u043e\u043c\u043e\u0434\u0430\u043d\u043e\u0432\u0430",
      "longitude":101.472382,
      "latitude":54.056156
    },
    "10475":{
      "name":"\u0421\u0443\u043b\u043a\u0435\u0442",
      "longitude":101.475433,
      "latitude":54.44239
    },
    "10476":{
      "name":"\u0411\u0440\u043e\u0434\u044b",
      "longitude":101.501877,
      "latitude":54.613197
    },
    "10477":{
      "name":"\u0410\u0440\u0448\u0430\u043d",
      "longitude":101.503944,
      "latitude":54.195034
    },
    "10478":{
      "name":"\u041d\u043e\u0432\u044b\u0435 \u0411\u0440\u043e\u0434\u044b",
      "longitude":101.514984,
      "latitude":54.700153
    },
    "10479":{
      "name":"\u0410\u043d\u0447\u0438\u0440\u0438\u043a\u043e\u0432\u0430",
      "longitude":101.515022,
      "latitude":56.468918
    },
    "10480":{
      "name":"\u0411\u043e\u0440\u043e\u0432\u043e\u0435",
      "longitude":101.521263,
      "latitude":54.033924
    },
    "10481":{
      "name":"\u0425\u0430\u043d\u0445\u0430\u0442\u0443\u0439",
      "longitude":101.526291,
      "latitude":54.127464
    },
    "10482":{
      "name":"\u0425\u043e\u0440-\u0411\u0443\u0442\u044b\u0440\u0438\u043d\u0430",
      "longitude":101.528381,
      "latitude":53.342407
    },
    "10483":{
      "name":"\u041d\u043e\u0432\u043e\u043d\u0438\u043a\u043e\u043b\u044c\u0441\u043a",
      "longitude":101.530396,
      "latitude":53.765518
    },
    "10484":{
      "name":"\u0411\u0443\u0437\u0443\u043b\u0443\u043a",
      "longitude":101.549126,
      "latitude":54.667225
    },
    "10485":{
      "name":"\u0410\u0445\u0442\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":101.554955,
      "latitude":54.238392
    },
    "10486":{
      "name":"\u041e\u0441\u0438\u043f\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":101.556244,
      "latitude":53.520653
    },
    "10487":{
      "name":"\u0427\u0435\u0440\u0435\u043c\u0448\u0430\u043d\u043a\u0430",
      "longitude":101.575195,
      "latitude":55.654045
    },
    "10488":{
      "name":"\u0425\u0430\u0440\u0430\u0433\u0443\u043d",
      "longitude":101.575935,
      "latitude":53.352978
    },
    "10489":{
      "name":"\u041e\u043a\u0438\u043d\u0441\u043a\u0438\u0435 \u0421\u0430\u0447\u043a\u0438",
      "longitude":101.597336,
      "latitude":53.481647
    },
    "10490":{
      "name":"\u041a\u043b\u044e\u0447\u0438",
      "longitude":101.603363,
      "latitude":54.405045
    },
    "10491":{
      "name":"\u0418\u0433\u043d\u0430\u0439",
      "longitude":101.620148,
      "latitude":53.792133
    },
    "10492":{
      "name":"1-\u0439 \u0423\u0441\u043f\u0435\u043d\u0441\u043a\u0438\u0439",
      "longitude":101.6380905,
      "latitude":53.6119385
    },
    "10493":{
      "name":"\u0422\u0438\u0445\u043e\u0440\u0443\u0442",
      "longitude":101.646721,
      "latitude":54.146709
    },
    "10494":{
      "name":"\u0411\u0440\u0430\u0442\u0441\u043a\u0430\u044f \u0415\u043b\u0430\u043d\u044c",
      "longitude":101.6665484,
      "latitude":55.9588386
    },
    "10495":{
      "name":"\u0421\u0440\u0435\u0434\u043d\u0435\u043f\u0438\u0445\u0442\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":101.6730504,
      "latitude":53.3815548
    },
    "10496":{
      "name":"\u0414\u0430\u0433\u043d\u0438\u043a",
      "longitude":101.673529,
      "latitude":53.354412
    },
    "10497":{
      "name":"\u0428\u0430\u0440\u0430\u0433\u0443\u043b-\u0421\u0430\u0447\u043a\u0438",
      "longitude":101.675972,
      "latitude":53.432133
    },
    "10498":{
      "name":"\u041e\u043a\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":101.687538,
      "latitude":54.617882
    },
    "10499":{
      "name":"\u0421\u0442\u0438\u0431\u0443\u0442\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":101.689461,
      "latitude":53.863331
    },
    "10500":{
      "name":"3-\u0439 \u0423\u0441\u043f\u0435\u043d\u0441\u043a\u0438\u0439",
      "longitude":101.691279,
      "latitude":53.6443198
    },
    "10501":{
      "name":"\u041f\u0438\u0445\u0442\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":101.7005,
      "latitude":53.399895
    },
    "10502":{
      "name":"\u041b\u0438\u0441\u0442\u0432\u044f\u043d\u043a\u0430",
      "longitude":101.739296,
      "latitude":54.235649
    },
    "10503":{
      "name":"\u041d\u043e\u0432\u043e\u043c\u0435\u0442\u0435\u043b\u043a\u0438\u043d\u0430",
      "longitude":101.743912,
      "latitude":53.312866
    },
    "10504":{
      "name":"\u0421\u043e\u043b\u043e\u0433\u0443\u0431\u043e\u0432\u043e",
      "longitude":101.753662,
      "latitude":53.811142
    },
    "10505":{
      "name":"\u0425\u0430\u0438\u0445\u0442\u0430",
      "longitude":101.763046,
      "latitude":54.3494
    },
    "10506":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u044f\u044f \u0417\u0438\u043c\u0430",
      "longitude":101.781921,
      "latitude":53.797085
    },
    "10507":{
      "name":"\u041e\u043a\u0442\u044f\u0431\u0440\u044c\u0441\u043a\u0438\u0439",
      "longitude":101.783661,
      "latitude":54.093563
    },
    "10508":{
      "name":"\u0414\u0443\u0431\u044b\u043d\u0438\u043d\u043e",
      "longitude":101.79187,
      "latitude":56.608471
    },
    "10509":{
      "name":"\u0413\u043e\u0440\u043e\u0434\u043e\u043a",
      "longitude":101.7993119,
      "latitude":52.9871371
    },
    "10510":{
      "name":"\u0421\u0442\u0435\u043f\u043d\u043e\u0439",
      "longitude":101.822083,
      "latitude":54.189667
    },
    "10511":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u0435 \u041c\u0430\u044f",
      "longitude":101.8234096,
      "latitude":53.5597567
    },
    "10512":{
      "name":"\u0421\u043e\u0441\u043d\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":101.824966,
      "latitude":54.279831
    },
    "10513":{
      "name":"\u041a\u0438\u043c\u0438\u043b\u044c\u0442\u0435\u0439",
      "longitude":101.8422936,
      "latitude":54.1360273
    },
    "10514":{
      "name":"\u0427\u0435\u0440\u043d\u0443\u0448\u043a\u0430 1-\u044f",
      "longitude":101.845268,
      "latitude":52.971775
    },
    "10515":{
      "name":"\u0425\u0430\u0440\u0447\u0435\u0432",
      "longitude":101.86969,
      "latitude":54.227409
    },
    "10516":{
      "name":"\u0424\u0435\u043e\u0444\u0430\u043d\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":101.8722624,
      "latitude":54.1288524
    },
    "10517":{
      "name":"\u0411\u0435\u0440\u0435\u0437\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":101.876732,
      "latitude":54.402893
    },
    "10518":{
      "name":"\u0418\u0441\u0430\u043a\u043e\u0432\u043a\u0430",
      "longitude":101.877159,
      "latitude":53.303047
    },
    "10519":{
      "name":"\u0427\u0435\u0440\u043d\u0443\u0448\u043a\u0430 2-\u044f",
      "longitude":101.897408,
      "latitude":52.967487
    },
    "10520":{
      "name":"\u0422\u0440\u0430\u043a\u0442\u043e\u0432\u044b\u0439",
      "longitude":101.901108,
      "latitude":53.872238
    },
    "10521":{
      "name":"\u041c\u043e\u0441\u0442\u043e\u0432\u043a\u0430",
      "longitude":101.9425223,
      "latitude":53.4064493
    },
    "10522":{
      "name":"\u0417\u043e\u0431\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":101.951706,
      "latitude":54.94186
    },
    "10523":{
      "name":"\u0418\u043d\u0433\u0430",
      "longitude":101.95668,
      "latitude":52.971191
    },
    "10524":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439",
      "longitude":101.9571202,
      "latitude":53.4588115
    },
    "10525":{
      "name":"\u0411\u043b\u0430\u0433\u043e\u0434\u0430\u0442\u043d\u044b\u0439",
      "longitude":101.9623418,
      "latitude":53.5049407
    },
    "10526":{
      "name":"\u041f\u0435\u0440\u0435\u0432\u043e\u0437",
      "longitude":101.9630506,
      "latitude":54.0402574
    },
    "10527":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0439 \u0425\u0430\u0437\u0430\u043d",
      "longitude":101.964157,
      "latitude":53.837257
    },
    "10528":{
      "name":"\u041a\u0443\u0441\u0442\u043e\u0432\u0430",
      "longitude":101.98774,
      "latitude":53.860069
    },
    "10529":{
      "name":"\u0427\u0435\u043b\u044f\u0431\u0430",
      "longitude":101.990804,
      "latitude":53.9575485
    },
    "10530":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u041a\u0430\u0434\u0430",
      "longitude":101.996002,
      "latitude":54.518814
    },
    "10531":{
      "name":"\u041f\u043e\u043b\u043a\u043e\u0432\u043d\u0438\u043a\u043e\u0432\u0430",
      "longitude":102.00071,
      "latitude":53.847881
    },
    "10532":{
      "name":"\u041c\u0443\u0440\u0443\u0439",
      "longitude":102.015732,
      "latitude":53.345314
    },
    "10533":{
      "name":"\u0414\u043c\u0438\u0442\u0440\u0438\u0435\u0432\u043a\u0430",
      "longitude":102.039162,
      "latitude":53.382992
    },
    "10534":{
      "name":"\u0411\u0435\u0440\u0435\u0437\u043a\u0438\u043d\u0430",
      "longitude":102.043983,
      "latitude":53.528061
    },
    "10535":{
      "name":"\u0417\u0430\u0432\u0430\u043b\u044c",
      "longitude":102.052055,
      "latitude":54.685749
    },
    "10536":{
      "name":"\u041f\u043e\u0434\u044a\u0432\u044b\u0435\u0437\u0434\u043d\u044b\u0439",
      "longitude":102.053894,
      "latitude":56.29422
    },
    "10537":{
      "name":"\u0427\u0430\u0434\u0430\u043d\u043e\u0432\u0430",
      "longitude":102.053947,
      "latitude":53.367447
    },
    "10538":{
      "name":"\u0429\u0435\u0440\u0431\u0430\u043a\u043e\u0432\u0430",
      "longitude":102.057526,
      "latitude":53.412792
    },
    "10539":{
      "name":"\u0423\u0440\u0433\u0430\u043d\u0442\u0443\u0439",
      "longitude":102.081184,
      "latitude":52.750591
    },
    "10540":{
      "name":"\u041f\u043e\u0434\u0433\u043e\u0440\u043d\u0430\u044f",
      "longitude":102.090225,
      "latitude":54.002068
    },
    "10541":{
      "name":"\u0417\u0430\u0431\u043b\u0430\u0433\u0430\u0440",
      "longitude":102.109741,
      "latitude":53.436672
    },
    "10542":{
      "name":"\u041e\u043a\u0430 2-\u044f",
      "longitude":102.1154258,
      "latitude":53.8791218
    },
    "10543":{
      "name":"\u0425\u0430\u043b\u0442\u044b",
      "longitude":102.1262252,
      "latitude":53.3470711
    },
    "10544":{
      "name":"\u041c\u0430\u0440\u0438\u0438\u043d\u0441\u043a",
      "longitude":102.127197,
      "latitude":53.259811
    },
    "10545":{
      "name":"\u0416\u0438\u0437\u043d\u0435\u0432\u043a\u0430",
      "longitude":102.132164,
      "latitude":53.306511
    },
    "10546":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u043c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":102.137146,
      "latitude":55.690174
    },
    "10547":{
      "name":"\u0411\u0443\u0440\u0438\u043d\u0441\u043a\u0430\u044f \u0434\u0430\u0447\u0430",
      "longitude":102.137772,
      "latitude":54.068336
    },
    "10548":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u0441\u043a\u0438\u0439",
      "longitude":102.1428199,
      "latitude":53.6331203
    },
    "10549":{
      "name":"\u041d\u0430\u0433\u0438\u0448\u043a\u0438\u043d\u0430",
      "longitude":102.143623,
      "latitude":53.816269
    },
    "10550":{
      "name":"\u041d\u0438\u0436\u043d\u0435\u0447\u0438\u0440\u043a\u0438\u043d\u0430",
      "longitude":102.14463,
      "latitude":53.901035
    },
    "10551":{
      "name":"\u0417\u0430\u043c\u0430\u0437\u0447\u0438\u043a\u043e\u0432\u0430",
      "longitude":102.144768,
      "latitude":53.482235
    },
    "10552":{
      "name":"\u0425\u0430\u043d\u0434\u0430\u0433\u0430\u0439",
      "longitude":102.148262,
      "latitude":53.133171
    },
    "10553":{
      "name":"\u041a\u0438\u0440\u0445\u0430\u0439",
      "longitude":102.1488595,
      "latitude":53.3399307
    },
    "10554":{
      "name":"\u0428\u0430\u0431\u0430\u043b\u0438\u043d\u0430",
      "longitude":102.159348,
      "latitude":53.515007
    },
    "10555":{
      "name":"\u041c\u044f\u0433\u0447\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":102.1720467,
      "latitude":53.3172386
    },
    "10556":{
      "name":"\u0412\u044b\u0441\u043e\u0442\u0441\u043a\u0430\u044f",
      "longitude":102.187126,
      "latitude":53.277512
    },
    "10557":{
      "name":"\u041c\u0430\u0440\u0434\u0430\u0439",
      "longitude":102.189781,
      "latitude":53.302574
    },
    "10558":{
      "name":"\u041a\u0443\u043d\u0434\u0443\u043b\u0443\u043d",
      "longitude":102.199982,
      "latitude":54.315151
    },
    "10559":{
      "name":"\u0418\u043d\u0434\u043e\u043d",
      "longitude":102.2141405,
      "latitude":53.0696366
    },
    "10560":{
      "name":"\u041c\u043e\u043b\u044c\u0442\u0430",
      "longitude":102.232864,
      "latitude":54.081158
    },
    "10561":{
      "name":"\u0429\u0435\u0433\u043b\u0430\u0435\u0432\u0430",
      "longitude":102.2342522,
      "latitude":53.735637
    },
    "10562":{
      "name":"\u041e\u043a\u0442\u044f\u0431\u0440\u044c\u0441\u043a",
      "longitude":102.244614,
      "latitude":55.262569
    },
    "10563":{
      "name":"\u0414\u0435\u043b\u044e\u0440",
      "longitude":102.244835,
      "latitude":53.750965
    },
    "10564":{
      "name":"\u0427\u0443\u0445\u043b\u0438\u043d\u0441\u043a\u0430\u044f",
      "longitude":102.2472,
      "latitude":53.268372
    },
    "10565":{
      "name":"\u041f\u0430\u0448\u0435\u043d\u043d\u044b\u0439",
      "longitude":102.252579,
      "latitude":56.44001
    },
    "10566":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u0411\u0440\u043e\u0434",
      "longitude":102.254097,
      "latitude":53.061203
    },
    "10567":{
      "name":"\u0413\u043b\u0438\u043d\u043a\u0438",
      "longitude":102.257591,
      "latitude":53.859516
    },
    "10568":{
      "name":"\u0425\u0430\u043b\u0442\u044b",
      "longitude":102.258507,
      "latitude":53.262123
    },
    "10569":{
      "name":"\u0427\u0435\u0440\u0435\u043c\u0448\u0430\u043d\u043a\u0430",
      "longitude":102.265625,
      "latitude":54.209644
    },
    "10570":{
      "name":"\u041a\u0430\u0440\u0430\u0442\u0430\u0435\u0432\u0430",
      "longitude":102.267998,
      "latitude":53.350101
    },
    "10571":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0435\u0440\u0430\u0441\u0442\u044f\u0433\u0430\u0435\u0432\u0441\u043a\u0438\u0439",
      "longitude":102.275917,
      "latitude":53.899078
    },
    "10572":{
      "name":"\u041c\u0430\u043d\u0434\u0430\u0433\u0430\u0439",
      "longitude":102.289268,
      "latitude":52.969288
    },
    "10573":{
      "name":"\u0415\u043b\u043e\u0442\u044b",
      "longitude":102.292549,
      "latitude":52.95433
    },
    "10574":{
      "name":"\u0411\u0430\u0442\u0430\u043b\u0430\u0435\u0432\u0430",
      "longitude":102.295631,
      "latitude":53.032677
    },
    "10575":{
      "name":"\u041a\u043b\u044e\u0447\u0438",
      "longitude":102.3001872,
      "latitude":53.2314758
    },
    "10576":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u044f\u044f \u0418\u0440\u0435\u0442\u044c",
      "longitude":102.307106,
      "latitude":52.966759
    },
    "10577":{
      "name":"\u041f\u043e\u043b\u0435\u0436\u0430\u0435\u0432\u0430",
      "longitude":102.32579,
      "latitude":52.967854
    },
    "10578":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0435\u043b\u0438\u0445\u0430\u0447\u0435\u0432\u0441\u043a\u0438\u0439",
      "longitude":102.326027,
      "latitude":54.018089
    },
    "10579":{
      "name":"\u0416\u0430\u043b\u0433\u0430\u0439",
      "longitude":102.329163,
      "latitude":53.137096
    },
    "10580":{
      "name":"\u0428\u0430\u043b\u043e\u0442\u044b",
      "longitude":102.3292941,
      "latitude":53.1684328
    },
    "10581":{
      "name":"\u0411\u043e\u0434\u043e\u0440\u043e\u0439",
      "longitude":102.3314633,
      "latitude":54.0834519
    },
    "10582":{
      "name":"\u0421\u0435\u043d\u043d\u0430\u044f \u041f\u0430\u0434\u044c",
      "longitude":102.331642,
      "latitude":53.558926
    },
    "10583":{
      "name":"\u0422\u0440\u0443\u0436\u0435\u043d\u0438\u043a",
      "longitude":102.333008,
      "latitude":52.971378
    },
    "10584":{
      "name":"\u041c\u0430\u043c\u0443\u0440\u043a\u043e\u0432\u0430",
      "longitude":102.337181,
      "latitude":53.665199
    },
    "10585":{
      "name":"\u0420\u043e\u043c\u0430\u043d\u043e\u0432\u0430",
      "longitude":102.367905,
      "latitude":53.511253
    },
    "10586":{
      "name":"\u042e\u043b\u0438\u043d\u0441\u043a",
      "longitude":102.385971,
      "latitude":52.738857
    },
    "10587":{
      "name":"\u041c\u0435\u0439\u0435\u0440\u043e\u0432\u043a\u0430",
      "longitude":102.4065591,
      "latitude":53.7135889
    },
    "10588":{
      "name":"\u041a\u0438\u0440\u043a\u0435\u0439",
      "longitude":102.4080579,
      "latitude":53.2389399
    },
    "10589":{
      "name":"\u0425\u0430\u043b\u044f\u0440\u0442\u044b",
      "longitude":102.409027,
      "latitude":53.615215
    },
    "10590":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u041a\u0430\u0440\u043b\u0443\u043a",
      "longitude":102.413826,
      "latitude":53.484398
    },
    "10591":{
      "name":"\u0412\u0435\u0440\u0448\u0438\u043d\u0430",
      "longitude":102.418365,
      "latitude":53.29903
    },
    "10592":{
      "name":"\u041d\u0435\u0432\u0438\u0434\u0438\u043c\u043e\u0432\u0430",
      "longitude":102.4226159,
      "latitude":52.9848335
    },
    "10593":{
      "name":"\u041a\u0443\u0440\u043a\u0430\u0442",
      "longitude":102.425301,
      "latitude":53.172375
    },
    "10594":{
      "name":"\u0411\u0430\u0434\u0430\u0440\u043c\u0430",
      "longitude":102.425644,
      "latitude":57.753654
    },
    "10595":{
      "name":"\u0418\u043b\u0433\u0430\u043d\u0441\u043a\u043e\u0435",
      "longitude":102.427956,
      "latitude":53.557461
    },
    "10596":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0435\u0432\u043e\u0440\u043e\u043d\u0435\u0436\u0441\u043a\u0438\u0439",
      "longitude":102.443588,
      "latitude":53.943573
    },
    "10597":{
      "name":"\u0425\u043e\u043b\u044b",
      "longitude":102.4437497,
      "latitude":53.9288192
    },
    "10598":{
      "name":"\u0413\u0443\u0441\u0435\u0432\u0430",
      "longitude":102.447746,
      "latitude":52.9734079
    },
    "10599":{
      "name":"\u0425\u0432\u043e\u0439\u043d\u044b\u0439",
      "longitude":102.449493,
      "latitude":55.266296
    },
    "10600":{
      "name":"\u0422\u0443\u043d\u0433\u0443\u0441\u044b",
      "longitude":102.450188,
      "latitude":52.788048
    },
    "10601":{
      "name":"\u041b\u0435\u043d\u0434\u0435\u043d\u0435\u0432\u0430",
      "longitude":102.453041,
      "latitude":53.500443
    },
    "10602":{
      "name":"\u0417\u0430\u0432\u0438\u0434\u043d\u0430\u044f",
      "longitude":102.4613593,
      "latitude":53.2948859
    },
    "10603":{
      "name":"\u041a\u043e\u0440\u0441\u0443\u043d\u0433\u0430\u0439",
      "longitude":102.468636,
      "latitude":53.722786
    },
    "10604":{
      "name":"\u041c\u043e\u0441\u043a\u043e\u0432\u0441\u043a\u0430\u044f",
      "longitude":102.4752901,
      "latitude":53.5586382
    },
    "10605":{
      "name":"\u0428\u0430\u0441\u0442\u0438\u043d\u0430",
      "longitude":102.486549,
      "latitude":53.356461
    },
    "10606":{
      "name":"\u041c\u0438\u043d\u0435\u0435\u0432\u0430",
      "longitude":102.496414,
      "latitude":53.509533
    },
    "10607":{
      "name":"\u0423\u043b\u0437\u0435\u0442",
      "longitude":102.505318,
      "latitude":53.110191
    },
    "10608":{
      "name":"\u0411\u0443\u0445\u0430\u0440\u043e\u0432\u0430",
      "longitude":102.510834,
      "latitude":53.419163
    },
    "10609":{
      "name":"\u041a\u0443\u043a\u0443\u043d\u0443\u0440",
      "longitude":102.512939,
      "latitude":53.184536
    },
    "10610":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0435\u0431\u0435\u043b\u044c\u0441\u043a",
      "longitude":102.519325,
      "latitude":52.922215
    },
    "10611":{
      "name":"\u0428\u0435\u0441\u0442\u0430\u043a\u043e\u0432\u0430",
      "longitude":102.520546,
      "latitude":52.962868
    },
    "10612":{
      "name":"\u041f\u0430\u0442\u043e\u0447\u043d\u044b\u0439",
      "longitude":102.521133,
      "latitude":52.958202
    },
    "10613":{
      "name":"\u0413\u043e\u0442\u043e\u043b",
      "longitude":102.536591,
      "latitude":53.19035
    },
    "10614":{
      "name":"\u0420\u0435\u043c\u0435\u0437\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":102.5402771,
      "latitude":53.3948932
    },
    "10615":{
      "name":"\u0417\u0430\u0434\u043e\u043d\u043e\u0432\u0441\u043a\u0430\u044f",
      "longitude":102.54879,
      "latitude":53.93734
    },
    "10616":{
      "name":"\u041f\u043e\u0431\u0435\u0434\u0438\u043d\u0441\u043a\u0430\u044f",
      "longitude":102.561516,
      "latitude":53.954311
    },
    "10617":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u0435 \u041f\u043e\u043b\u0435",
      "longitude":102.567749,
      "latitude":53.617596
    },
    "10618":{
      "name":"\u0410\u043d\u0443\u0447\u0438\u043d\u0441\u043a",
      "longitude":102.586273,
      "latitude":54.055298
    },
    "10619":{
      "name":"\u0422\u0443\u043d\u0433\u0443\u0439",
      "longitude":102.590042,
      "latitude":53.570805
    },
    "10620":{
      "name":"\u0423\u043d\u043a\u0443\u0440\u043b\u0438\u043a",
      "longitude":102.5901254,
      "latitude":53.6516894
    },
    "10621":{
      "name":"\u041c\u0430\u043b\u043e\u043b\u0443\u0447\u0438\u043d\u0441\u043a",
      "longitude":102.59391,
      "latitude":53.214455
    },
    "10622":{
      "name":"\u0417\u0430\u043d\u0438\u043d\u0430",
      "longitude":102.6054167,
      "latitude":53.422602
    },
    "10623":{
      "name":"\u0411\u0443\u0440\u043a\u043e\u0432\u0430",
      "longitude":102.612799,
      "latitude":53.0244649
    },
    "10624":{
      "name":"\u0415\u0439",
      "longitude":102.613876,
      "latitude":53.826893
    },
    "10625":{
      "name":"\u041c\u043e\u0442\u043e-\u0411\u043e\u0434\u0430\u0440\u044b",
      "longitude":102.6195705,
      "latitude":52.6427214
    },
    "10626":{
      "name":"\u0410\u043b\u0437\u043e\u0431\u0435\u0439",
      "longitude":102.6284284,
      "latitude":53.1150989
    },
    "10627":{
      "name":"\u041d\u0430\u0439\u043c\u043e\u0434\u0430\u0439",
      "longitude":102.631668,
      "latitude":53.66227
    },
    "10628":{
      "name":"\u0425\u043e\u0442\u0445\u043e\u0440",
      "longitude":102.636436,
      "latitude":53.474728
    },
    "10629":{
      "name":"\u0417\u0430\u0440\u0435\u0447\u043d\u043e\u0435",
      "longitude":102.6386252,
      "latitude":53.1654039
    },
    "10630":{
      "name":"\u0428\u0430\u043f\u0448\u0430\u043b\u0442\u0443\u0439",
      "longitude":102.639084,
      "latitude":53.300816
    },
    "10631":{
      "name":"\u0412\u0430\u0441\u0438\u043b\u044c\u0435\u0432\u0441\u043a\u043e\u0435",
      "longitude":102.639709,
      "latitude":53.893345
    },
    "10632":{
      "name":"\u0411\u0430\u0436\u0435\u0439",
      "longitude":102.640823,
      "latitude":52.974976
    },
    "10633":{
      "name":"\u0411\u0430\u0433\u0430\u043d\u0442\u0443\u0439",
      "longitude":102.643181,
      "latitude":53.592407
    },
    "10634":{
      "name":"\u0413\u043e\u0440\u044f\u0447\u0438\u0439 \u041a\u043b\u044e\u0447",
      "longitude":102.64418,
      "latitude":53.487434
    },
    "10635":{
      "name":"\u0413\u043e\u043b\u043e\u0432\u0438\u043d\u0441\u043a\u043e\u0435",
      "longitude":102.6682441,
      "latitude":53.4298862
    },
    "10636":{
      "name":"\u0425\u0438\u0433\u0438\u043d\u0441\u043a\u0430\u044f",
      "longitude":102.6793511,
      "latitude":53.123151
    },
    "10637":{
      "name":"\u0414\u0430\u0431\u0430\u0434\u044b",
      "longitude":102.688812,
      "latitude":52.09409
    },
    "10638":{
      "name":"\u0423\u0433\u043e\u043b\u044c\u043d\u0430\u044f",
      "longitude":102.708176,
      "latitude":53.286957
    },
    "10639":{
      "name":"\u0411\u0435\u043b\u044b\u0435 \u041a\u043b\u044e\u0447\u0438",
      "longitude":102.709946,
      "latitude":52.540768
    },
    "10640":{
      "name":"\u0425\u0430\u043b\u0442\u0430",
      "longitude":102.7113521,
      "latitude":53.0512361
    },
    "10641":{
      "name":"\u041a\u043e\u0440\u0445\u043e\u0432\u0441\u043a\u0430\u044f",
      "longitude":102.7125753,
      "latitude":53.3915663
    },
    "10642":{
      "name":"\u0428\u0443\u043b\u044c\u0433\u0438\u043d\u0430",
      "longitude":102.7252098,
      "latitude":53.3959043
    },
    "10643":{
      "name":"\u0421\u0440\u0435\u0434\u043d\u044f\u044f",
      "longitude":102.732819,
      "latitude":52.956364
    },
    "10644":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u0435\u043b\u043e\u0432\u0430",
      "longitude":102.742096,
      "latitude":53.582581
    },
    "10645":{
      "name":"\u041a\u0443\u0439\u0442\u0430",
      "longitude":102.7544912,
      "latitude":53.1848093
    },
    "10646":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u0430",
      "longitude":102.7555764,
      "latitude":53.3209225
    },
    "10647":{
      "name":"\u0410\u0440\u0448\u0430\u043d",
      "longitude":102.7556953,
      "latitude":53.138077
    },
    "10648":{
      "name":"\u0421\u0430\u0433\u0430\u043d-\u0416\u0430\u043b\u0433\u0430\u0439",
      "longitude":102.7589491,
      "latitude":53.6056711
    },
    "10649":{
      "name":"\u0428\u0435\u043b\u0435\u043c\u0438\u043d\u0430",
      "longitude":102.7607045,
      "latitude":53.4380039
    },
    "10650":{
      "name":"\u0420\u0443\u0441\u0441\u043a\u0430\u044f \u0410\u043b\u0430\u0440\u044c",
      "longitude":102.769096,
      "latitude":52.946625
    },
    "10651":{
      "name":"\u041c\u0430\u043b\u044b\u0439 \u041a\u0443\u0442\u0443\u043b\u0438\u043a",
      "longitude":102.7768698,
      "latitude":53.3947738
    },
    "10652":{
      "name":"\u0413\u0435\u0440\u0430\u0441\u0438\u043c\u043e\u0432\u0430",
      "longitude":102.783691,
      "latitude":53.004093
    },
    "10653":{
      "name":"\u041e\u043c\u0443\u043b\u0451\u0432\u043a\u0430",
      "longitude":102.7883784,
      "latitude":53.2566732
    },
    "10654":{
      "name":"\u0416\u0435\u0440\u043d\u0430\u043a\u043e\u0432\u0430",
      "longitude":102.792641,
      "latitude":52.987511
    },
    "10655":{
      "name":"\u0422\u044e\u043c\u0435\u043d\u044c",
      "longitude":102.795113,
      "latitude":52.936672
    },
    "10656":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u0415\u0440\u043c\u0430",
      "longitude":102.7966209,
      "latitude":53.4475
    },
    "10657":{
      "name":"\u041d\u0430\u0440\u0435\u043d\u044b",
      "longitude":102.79998,
      "latitude":53.22863
    },
    "10658":{
      "name":"\u041f\u043e\u043c\u043e\u0440\u0446\u0435\u0432\u0430",
      "longitude":102.802681,
      "latitude":52.818783
    },
    "10659":{
      "name":"\u0427\u0438\u0447\u0438\u043a\u043e\u0432\u0441\u043a\u0430\u044f",
      "longitude":102.80574,
      "latitude":53.589432
    },
    "10660":{
      "name":"\u0428\u0430\u0445\u043e\u0432\u0441\u043a\u0430\u044f",
      "longitude":102.8075869,
      "latitude":53.5261463
    },
    "10661":{
      "name":"\u0413\u0430\u0432\u0440\u0438\u043b\u043e\u0432\u0441\u043a\u0430\u044f",
      "longitude":102.819336,
      "latitude":52.979469
    },
    "10662":{
      "name":"\u0422\u0443\u0448\u0430\u043c\u0430",
      "longitude":102.822609,
      "latitude":58.326633
    },
    "10663":{
      "name":"\u0413\u044b\u043c\u044b\u043b\u044c",
      "longitude":102.824478,
      "latitude":52.926414
    },
    "10664":{
      "name":"\u041c\u0430\u043a\u0430\u0440\u044c\u0435\u0432\u0441\u043a\u0430\u044f",
      "longitude":102.828659,
      "latitude":53.565823
    },
    "10665":{
      "name":"\u041c\u0430\u043b\u043e\u043c\u043e\u043b\u0435\u0432\u0430",
      "longitude":102.8319419,
      "latitude":53.4012274
    },
    "10666":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u041b\u0435\u043d\u0441\u043a\u0430\u044f",
      "longitude":102.834732,
      "latitude":52.984283
    },
    "10667":{
      "name":"\u0417\u0430\u044f\u0440\u0441\u043a",
      "longitude":102.835823,
      "latitude":56.192467
    },
    "10668":{
      "name":"\u041a\u0438\u0440\u044e\u0448\u0438\u043d\u0430",
      "longitude":102.8367477,
      "latitude":53.4458165
    },
    "10669":{
      "name":"\u0425\u043e\u0440\u044c\u043a\u0438",
      "longitude":102.838196,
      "latitude":53.033203
    },
    "10670":{
      "name":"\u0422\u043e\u043f\u043a\u0430",
      "longitude":102.838669,
      "latitude":52.938568
    },
    "10671":{
      "name":"\u041f\u0440\u0438\u043c\u043e\u0440\u0441\u043a\u0438\u0439",
      "longitude":102.83989,
      "latitude":54.283966
    },
    "10672":{
      "name":"\u041c\u043e\u0433\u043e\u0439",
      "longitude":102.8427769,
      "latitude":53.382151
    },
    "10673":{
      "name":"\u0421\u0430\u0440\u0430\u043f\u0443\u043b\u043e\u0432\u0430",
      "longitude":102.853935,
      "latitude":53.001606
    },
    "10674":{
      "name":"\u0422\u044e\u0442\u0440\u0438\u043d\u0430",
      "longitude":102.8588564,
      "latitude":53.3506582
    },
    "10675":{
      "name":"\u041a\u0430\u0442\u043e\u043c",
      "longitude":102.860016,
      "latitude":53.157703
    },
    "10676":{
      "name":"\u0422\u0430\u0440\u0431\u0430\u0436\u0438",
      "longitude":102.875923,
      "latitude":52.9772
    },
    "10677":{
      "name":"\u0411\u0435\u0440\u0435\u0441\u0442\u0435\u043d\u043d\u0438\u043a\u043e\u0432\u0430",
      "longitude":102.8768748,
      "latitude":53.3002657
    },
    "10678":{
      "name":"\u0422\u0430\u0431\u0443\u043a",
      "longitude":102.880531,
      "latitude":53.035736
    },
    "10679":{
      "name":"\u0417\u0443\u043d\u0433\u0430\u0440",
      "longitude":102.883171,
      "latitude":54.029808
    },
    "10680":{
      "name":"\u041d\u0438\u0436\u043d\u044f\u044f \u0418\u0440\u0435\u0442\u044c",
      "longitude":102.8994876,
      "latitude":52.7234455
    },
    "10681":{
      "name":"\u0421\u0430\u0432\u0438\u043d\u0441\u043a\u0430\u044f",
      "longitude":102.904686,
      "latitude":52.957706
    },
    "10682":{
      "name":"\u041a\u0438\u0440\u0438\u043b\u043b\u043e\u0432\u0441\u043a\u0430\u044f",
      "longitude":102.905342,
      "latitude":53.510387
    },
    "10683":{
      "name":"\u042e\u0436\u043d\u044b\u0439",
      "longitude":102.913055,
      "latitude":55.839672
    },
    "10684":{
      "name":"\u0422\u0430\u0440\u0430\u0441\u043e\u0432\u0441\u043a",
      "longitude":102.914307,
      "latitude":54.375881
    },
    "10685":{
      "name":"\u0418\u0441\u0430\u043a\u043e\u0432\u0430",
      "longitude":102.916763,
      "latitude":52.982544
    },
    "10686":{
      "name":"\u0421\u0443\u0442\u0443\u043f\u043e\u0432\u0430",
      "longitude":102.91861,
      "latitude":52.962654
    },
    "10687":{
      "name":"\u0428\u0430\u043c\u0430\u043d\u0430\u0435\u0432\u0430",
      "longitude":102.921967,
      "latitude":53.173092
    },
    "10688":{
      "name":"\u0422\u0440\u0430\u043a\u0442\u043e\u0432\u0430\u044f",
      "longitude":102.925385,
      "latitude":53.219044
    },
    "10689":{
      "name":"\u0425\u0430\u043c\u0445\u0430\u0440",
      "longitude":102.9304441,
      "latitude":53.7336902
    },
    "10690":{
      "name":"\u041a\u0438\u0440\u0437\u0430\u0432\u043e\u0434",
      "longitude":102.931175,
      "latitude":53.224152
    },
    "10691":{
      "name":"\u0417\u0430\u0445\u043e\u0434\u044b",
      "longitude":102.931877,
      "latitude":53.839355
    },
    "10692":{
      "name":"\u0427\u0435\u0440\u043d\u0443\u0445\u0438\u043d\u0430",
      "longitude":102.941589,
      "latitude":53.053169
    },
    "10693":{
      "name":"\u0417\u0430\u0431\u0438\u0442\u0443\u0439",
      "longitude":102.942337,
      "latitude":53.158718
    },
    "10694":{
      "name":"\u041f\u0440\u043e\u0442\u0430\u0441\u043e\u0432\u0430",
      "longitude":102.955574,
      "latitude":53.00301
    },
    "10695":{
      "name":"\u0414\u0443\u0442\u0430",
      "longitude":102.9578754,
      "latitude":53.4219308
    },
    "10696":{
      "name":"\u041c\u043e\u0442\u043e\u0432\u0430",
      "longitude":102.9580742,
      "latitude":52.8830909
    },
    "10697":{
      "name":"\u041e\u0434\u0438\u0441\u0430",
      "longitude":102.9611183,
      "latitude":54.0101933
    },
    "10698":{
      "name":"\u041c\u0430\u043d\u0438\u043d\u0441\u043a",
      "longitude":102.965965,
      "latitude":52.392372
    },
    "10699":{
      "name":"\u041a\u0435\u0434\u0440\u043e\u0432\u044b\u0439",
      "longitude":102.968613,
      "latitude":57.413582
    },
    "10700":{
      "name":"\u0413\u0440\u043e\u043c\u043e\u0432\u0430",
      "longitude":102.972832,
      "latitude":53.184383
    },
    "10701":{
      "name":"\u0411\u0435\u043b\u044c\u043a\u043e\u0432\u0430",
      "longitude":102.975555,
      "latitude":52.986816
    },
    "10702":{
      "name":"\u0425\u0443\u0440\u0443\u0439",
      "longitude":102.978493,
      "latitude":53.377472
    },
    "10703":{
      "name":"\u041c\u0443\u0442\u043e\u0432\u043a\u0430",
      "longitude":102.983368,
      "latitude":52.782837
    },
    "10704":{
      "name":"\u041c\u0443\u0440\u0430\u0442\u043e\u0432\u0430",
      "longitude":102.990509,
      "latitude":53.214321
    },
    "10705":{
      "name":"\u0428\u0430\u043b\u043e\u0442\u044b",
      "longitude":102.991463,
      "latitude":53.585693
    },
    "10706":{
      "name":"\u0418\u0441\u043a\u0440\u0430",
      "longitude":102.995285,
      "latitude":53.035511
    },
    "10707":{
      "name":"\u0415\u043b\u0430\u043d\u044c",
      "longitude":103.014915,
      "latitude":52.935112
    },
    "10708":{
      "name":"\u0421\u0442\u0443\u043f\u0438\u043d\u0430",
      "longitude":103.0156931,
      "latitude":53.1848944
    },
    "10709":{
      "name":"\u041b\u043e\u0445\u043e\u0432\u0430",
      "longitude":103.024246,
      "latitude":52.824799
    },
    "10710":{
      "name":"\u0421\u0442\u0435\u043f\u043d\u043e\u0435",
      "longitude":103.0255949,
      "latitude":53.7870227
    },
    "10711":{
      "name":"\u041c\u0438\u043d\u0434\u0435\u0439 2",
      "longitude":103.0357234,
      "latitude":56.2079974
    },
    "10712":{
      "name":"\u041a\u0435\u0440\u0431\u0443\u043b\u0430\u043a",
      "longitude":103.039299,
      "latitude":53.277264
    },
    "10713":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u0449\u0438\u043d\u0430",
      "longitude":103.039558,
      "latitude":54.200684
    },
    "10714":{
      "name":"\u0421\u0430\u0433\u0430\u043d-\u0416\u0430\u043b\u0433\u0430\u0439",
      "longitude":103.04567,
      "latitude":53.52673
    },
    "10715":{
      "name":"\u0414\u0440\u0443\u0436\u043d\u044b\u0439",
      "longitude":103.046529,
      "latitude":53.8778291
    },
    "10716":{
      "name":"\u041a\u043b\u044e\u0447\u0438",
      "longitude":103.050072,
      "latitude":52.949631
    },
    "10717":{
      "name":"\u041c\u043e\u043b\u044c\u0442\u0430",
      "longitude":103.0530177,
      "latitude":53.3648886
    },
    "10718":{
      "name":"\u041c\u0438\u043d\u0434\u0435\u0439 1",
      "longitude":103.057388,
      "latitude":56.243103
    },
    "10719":{
      "name":"\u041a\u043e\u043c\u0430\u0440\u043e\u0432\u0430",
      "longitude":103.060837,
      "latitude":52.906158
    },
    "10720":{
      "name":"\u0422\u0430\u0448\u043b\u044b\u043a\u043e\u0432\u0430",
      "longitude":103.085503,
      "latitude":53.892475
    },
    "10721":{
      "name":"\u041a\u0443\u043d\u0434\u0443\u043b\u0443\u043d",
      "longitude":103.0919382,
      "latitude":53.2782277
    },
    "10722":{
      "name":"\u0416\u043b\u043e\u0431\u0438\u043d\u0430",
      "longitude":103.092422,
      "latitude":53.504257
    },
    "10723":{
      "name":"\u0410\u0440\u0433\u0430\u043b\u0435\u0439",
      "longitude":103.0989326,
      "latitude":53.4283177
    },
    "10724":{
      "name":"\u0421\u0440\u0435\u0434\u043d\u0438\u0439 \u0411\u0443\u043b\u0430\u0439",
      "longitude":103.123451,
      "latitude":52.970848
    },
    "10725":{
      "name":"\u0417\u0430\u043c\u043e\u0440\u0441\u043a\u0430\u044f",
      "longitude":103.156204,
      "latitude":53.004105
    },
    "10726":{
      "name":"\u041f\u0430\u0440\u0448\u0435\u0432\u043d\u0438\u043a\u043e\u0432\u0430",
      "longitude":103.157738,
      "latitude":53.036182
    },
    "10727":{
      "name":"\u0428\u0443\u0431\u0438\u043d\u0430",
      "longitude":103.190056,
      "latitude":53.231365
    },
    "10728":{
      "name":"\u0421\u0442\u0430\u0440\u044b\u0439 \u041a\u0443\u0442\u0443\u0433\u0443\u043d",
      "longitude":103.190552,
      "latitude":53.255249
    },
    "10729":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u0427\u0435\u0440\u0435\u043c\u0448\u0430\u043d\u043a\u0430",
      "longitude":103.194969,
      "latitude":52.425785
    },
    "10730":{
      "name":"\u041a\u0430\u0441\u044c\u044f\u043d\u043e\u0432\u043a\u0430",
      "longitude":103.201721,
      "latitude":53.041908
    },
    "10731":{
      "name":"\u0410\u043f\u0445\u0430\u0439\u0442\u0430",
      "longitude":103.2139413,
      "latitude":53.4128624
    },
    "10732":{
      "name":"\u0427\u0438\u0441\u0442\u044b\u0439",
      "longitude":103.214317,
      "latitude":55.473217
    },
    "10733":{
      "name":"\u0423\u043d\u0434\u044d\u0440-\u0425\u0443\u0430\u043d",
      "longitude":103.214516,
      "latitude":53.464535
    },
    "10734":{
      "name":"\u0410\u0440\u0430\u043d\u0441\u0430\u0445\u043e\u0439",
      "longitude":103.215714,
      "latitude":52.631859
    },
    "10735":{
      "name":"\u0425\u043e\u0434\u0430\u0440\u0435\u0439",
      "longitude":103.217575,
      "latitude":52.260616
    },
    "10736":{
      "name":"\u0412\u0438\u0442\u0443\u0445",
      "longitude":103.218407,
      "latitude":52.996758
    },
    "10737":{
      "name":"\u0411\u0430\u043b\u0443\u0445\u0430\u0440\u044c",
      "longitude":103.251099,
      "latitude":53.239262
    },
    "10738":{
      "name":"\u0417\u0430\u043d\u0433\u0435\u0439",
      "longitude":103.2744542,
      "latitude":53.3930658
    },
    "10739":{
      "name":"\u0413\u043b\u0443\u0431\u043e\u043a\u0438\u0439 \u041b\u043e\u0433",
      "longitude":103.287773,
      "latitude":52.9023183
    },
    "10740":{
      "name":"\u041f\u043e\u0437\u0434\u0435\u0435\u0432\u0430",
      "longitude":103.288826,
      "latitude":53.197159
    },
    "10741":{
      "name":"\u041a\u0430\u0440\u0434\u0430",
      "longitude":103.292587,
      "latitude":54.997169
    },
    "10742":{
      "name":"\u0421\u0443\u0431\u0431\u043e\u0442\u0438\u043d\u0430",
      "longitude":103.297997,
      "latitude":52.94508
    },
    "10743":{
      "name":"\u0427\u0435\u043c\u043e\u0434\u0430\u0440\u0438\u0445\u0430",
      "longitude":103.299683,
      "latitude":53.146633
    },
    "10744":{
      "name":"\u0411\u0430\u043b\u0442\u0443\u0439",
      "longitude":103.3187554,
      "latitude":53.3231837
    },
    "10745":{
      "name":"\u0411\u043e\u0440\u0438\u0441\u043e\u0432\u0430",
      "longitude":103.323654,
      "latitude":52.440147
    },
    "10746":{
      "name":"\u0411\u044b\u043a\u043e\u0432\u043e",
      "longitude":103.324142,
      "latitude":53.504524
    },
    "10747":{
      "name":"\u041c\u043e\u043b\u043e\u0447\u043d\u043e\u0435",
      "longitude":103.344666,
      "latitude":53.05405
    },
    "10748":{
      "name":"\u0421\u043e\u0445\u0430\u0442\u044b\u0439",
      "longitude":103.345078,
      "latitude":56.428856
    },
    "10749":{
      "name":"\u0411\u0430\u0440\u0445\u0430\u0442\u043e\u0432\u0430",
      "longitude":103.35289,
      "latitude":53.007992
    },
    "10750":{
      "name":"\u041c\u0430\u0445\u043e\u043d\u044c\u043a\u0438\u043d\u0430",
      "longitude":103.390718,
      "latitude":53.084347
    },
    "10751":{
      "name":"\u0425\u0430\u043b\u044e\u0442\u044b",
      "longitude":103.392502,
      "latitude":53.835644
    },
    "10752":{
      "name":"\u041a\u0430\u043b\u0430\u0448\u043d\u0438\u043a\u043e\u0432\u0430",
      "longitude":103.4015337,
      "latitude":53.0773597
    },
    "10753":{
      "name":"\u0423\u0433\u043e\u043b\u044c\u043d\u0430\u044f",
      "longitude":103.405098,
      "latitude":53.217884
    },
    "10754":{
      "name":"\u042f\u0441\u0430\u0447\u043d\u0430\u044f \u0425\u0430\u0439\u0440\u044e\u0437\u043e\u0432\u043a\u0430",
      "longitude":103.415581,
      "latitude":53.844574
    },
    "10755":{
      "name":"\u0411\u0435\u043b\u043e\u0433\u043e\u0440\u0441\u043a",
      "longitude":103.425163,
      "latitude":52.841877
    },
    "10756":{
      "name":"\u0422\u0443\u0448\u0430\u043c\u0430",
      "longitude":103.4313461,
      "latitude":57.5791324
    },
    "10757":{
      "name":"\u0415\u0440\u0448\u043e\u0432\u043a\u0430",
      "longitude":103.436066,
      "latitude":52.701618
    },
    "10758":{
      "name":"\u0421\u043a\u043b\u044f\u043d\u043a\u0430",
      "longitude":103.438248,
      "latitude":53.154816
    },
    "10759":{
      "name":"\u0421\u0430\u043d\u043d\u043e\u043b\u044b\u0436\u043d\u044b\u0439",
      "longitude":103.440292,
      "latitude":52.717453
    },
    "10760":{
      "name":"\u0414\u043e\u043b\u0433\u0430\u043d\u043e\u0432\u0430",
      "longitude":103.444115,
      "latitude":53.797272
    },
    "10761":{
      "name":"\u0413\u0440\u044f\u0437\u043d\u0430\u044f",
      "longitude":103.451515,
      "latitude":53.034412
    },
    "10762":{
      "name":"\u041e\u0437\u0451\u0440\u043d\u044b\u0439",
      "longitude":103.456604,
      "latitude":52.713291
    },
    "10763":{
      "name":"\u0421\u0430\u043f\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":103.470337,
      "latitude":52.660225
    },
    "10764":{
      "name":"\u041c\u0430\u043a\u0430\u0440\u043e\u0432\u0441\u043a\u0430\u044f",
      "longitude":103.470833,
      "latitude":53.19244
    },
    "10765":{
      "name":"\u0427\u0435\u0440\u043d\u0438\u0433\u043e\u0432\u0441\u043a\u0430\u044f",
      "longitude":103.472206,
      "latitude":53.28381
    },
    "10766":{
      "name":"\u0411\u0430\u0440\u0430\u043d\u043e\u0432\u0430",
      "longitude":103.474197,
      "latitude":53.700699
    },
    "10767":{
      "name":"\u0414\u043e\u043d\u0441\u043a\u0430\u044f",
      "longitude":103.476006,
      "latitude":53.407673
    },
    "10768":{
      "name":"\u041c\u0443\u0442\u0438\u043d\u043e\u0432\u0430",
      "longitude":103.49205,
      "latitude":53.38414
    },
    "10769":{
      "name":"\u0412\u0430\u043d\u0442\u0435\u0435\u0432\u0441\u043a\u0430\u044f",
      "longitude":103.4928324,
      "latitude":53.2001298
    },
    "10770":{
      "name":"\u0421\u0442\u0435\u043f\u043d\u043e\u0439",
      "longitude":103.4955852,
      "latitude":52.8932557
    },
    "10771":{
      "name":"\u0411\u0430\u0439\u0445\u0430\u043d\u043e\u0432\u0430",
      "longitude":103.499641,
      "latitude":53.262943
    },
    "10772":{
      "name":"\u0413\u0440\u0435\u0447\u0435\u0445\u0430\u043d",
      "longitude":103.5006824,
      "latitude":53.1414642
    },
    "10773":{
      "name":"\u041a\u0430\u0440\u0442\u044b\u0433\u0435\u0439",
      "longitude":103.510094,
      "latitude":53.438709
    },
    "10774":{
      "name":"\u042f\u043a\u0438\u043c\u043e\u0432\u043a\u0430",
      "longitude":103.510948,
      "latitude":52.397514
    },
    "10775":{
      "name":"\u0422\u044b\u0440\u0433\u0443\u0440",
      "longitude":103.512711,
      "latitude":53.12114
    },
    "10776":{
      "name":"\u041a\u0440\u044e\u043a\u043e\u0432\u0430",
      "longitude":103.520866,
      "latitude":53.322071
    },
    "10777":{
      "name":"\u0427\u0435\u0431\u043e\u0433\u043e\u0440\u044b",
      "longitude":103.523926,
      "latitude":52.413273
    },
    "10778":{
      "name":"\u0411\u044b\u0440\u0433\u0430\u0437\u043e\u0432\u0430",
      "longitude":103.533302,
      "latitude":53.043262
    },
    "10779":{
      "name":"\u0422\u0430\u0433\u0430\u0439",
      "longitude":103.5381293,
      "latitude":53.7238467
    },
    "10780":{
      "name":"\u041f\u0430\u0448\u043a\u043e\u0432\u0430",
      "longitude":103.5426662,
      "latitude":53.1902399
    },
    "10781":{
      "name":"\u042f\u0433\u0430\u0442\u044b",
      "longitude":103.542801,
      "latitude":52.246979
    },
    "10782":{
      "name":"\u0415\u0440\u0448\u043e\u0432\u0430",
      "longitude":103.54496,
      "latitude":53.337616
    },
    "10783":{
      "name":"\u0426\u0435\u043b\u043e\u0442\u044b",
      "longitude":103.546547,
      "latitude":52.479012
    },
    "10784":{
      "name":"\u0428\u0430\u0440\u0430\u0433\u0443\u043d",
      "longitude":103.56179,
      "latitude":53.067135
    },
    "10785":{
      "name":"\u041b\u043e\u0433\u0430\u043d\u043e\u0432\u0430",
      "longitude":103.563957,
      "latitude":53.289295
    },
    "10786":{
      "name":"\u041a\u043b\u044e\u0447\u0435\u0432\u0430\u044f",
      "longitude":103.572968,
      "latitude":52.587139
    },
    "10787":{
      "name":"\u0411\u0430\u0442\u0445\u0430\u0439",
      "longitude":103.5790431,
      "latitude":53.725784
    },
    "10788":{
      "name":"\u0411\u0443\u0440\u0435\u0442\u044c",
      "longitude":103.5828659,
      "latitude":53.0250481
    },
    "10789":{
      "name":"\u041a\u0443\u043b\u0430\u043a\u043e\u0432\u0430",
      "longitude":103.585434,
      "latitude":52.973942
    },
    "10790":{
      "name":"\u0422\u044b\u043c\u044b\u0440\u0435\u0439",
      "longitude":103.609146,
      "latitude":53.287788
    },
    "10791":{
      "name":"\u0411\u0430\u0434\u0430\u0439",
      "longitude":103.610146,
      "latitude":52.876877
    },
    "10792":{
      "name":"\u0423\u043b\u0435\u0439",
      "longitude":103.6134776,
      "latitude":53.6004512
    },
    "10793":{
      "name":"\u041a\u0430\u0440\u0430\u043d\u0442\u0438\u043d",
      "longitude":103.6167459,
      "latitude":51.7413365
    },
    "10794":{
      "name":"\u0410\u0440\u0445\u0438\u0435\u0440\u0435\u0435\u0432\u043a\u0430",
      "longitude":103.626183,
      "latitude":52.455685
    },
    "10795":{
      "name":"\u0413\u0440\u0435\u0447\u0435\u0445\u0430\u043d",
      "longitude":103.628868,
      "latitude":53.231853
    },
    "10796":{
      "name":"\u041d\u0438\u0437\u043e\u0432\u0446\u0435\u0432\u0430",
      "longitude":103.639999,
      "latitude":52.505478
    },
    "10797":{
      "name":"\u0427\u0451\u0440\u043d\u0430\u044f",
      "longitude":103.641609,
      "latitude":56.41468
    },
    "10798":{
      "name":"\u0417\u0432\u0451\u0437\u0434\u043e\u0447\u043a\u0430",
      "longitude":103.649178,
      "latitude":52.349003
    },
    "10799":{
      "name":"\u041a\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":103.657791,
      "latitude":52.472832
    },
    "10800":{
      "name":"\u0423\u0441\u0442\u044c-\u041c\u0430\u043b\u043e\u0439",
      "longitude":103.661064,
      "latitude":53.949001
    },
    "10801":{
      "name":"\u0412\u0435\u0440\u0431\u043d\u044b\u0439",
      "longitude":103.6693508,
      "latitude":51.7147646
    },
    "10802":{
      "name":"\u0428\u0438\u043f\u043d\u044f\u0433\u043e\u0432\u043a\u0430",
      "longitude":103.671181,
      "latitude":52.98642
    },
    "10803":{
      "name":"\u0411\u0443\u0440\u0443\u043d\u0434\u0443\u0439\u0441\u043a\u0438\u0439",
      "longitude":103.671623,
      "latitude":54.223129
    },
    "10804":{
      "name":"\u041d\u043e\u0432\u044b\u0439 \u0410\u043b\u0435\u043d\u0434\u0430\u0440\u044c",
      "longitude":103.672386,
      "latitude":53.108624
    },
    "10805":{
      "name":"\u041d\u043e\u0432\u043e\u044f\u0441\u0430\u0447\u043d\u0430\u044f",
      "longitude":103.675797,
      "latitude":52.46032
    },
    "10806":{
      "name":"120 \u043a\u043c",
      "longitude":103.6777994,
      "latitude":51.7089233
    },
    "10807":{
      "name":"\u0416\u0434\u0430\u043d\u043e\u0432\u043e",
      "longitude":103.7021629,
      "latitude":53.5456122
    },
    "10808":{
      "name":"\u041a\u0443\u0439\u0442\u0443\u043d",
      "longitude":103.713844,
      "latitude":52.114933
    },
    "10809":{
      "name":"\u0422\u044e\u043c\u0435\u043d\u0441\u043a",
      "longitude":103.71521,
      "latitude":52.616749
    },
    "10810":{
      "name":"\u0425\u0430\u0439\u0433\u0430",
      "longitude":103.7264626,
      "latitude":53.7001698
    },
    "10811":{
      "name":"\u0423\u0441\u043e\u043b\u044c\u0435-\u0416\u0438\u043b\u043a\u0438\u043d\u043e",
      "longitude":103.737366,
      "latitude":52.735786
    },
    "10812":{
      "name":"\u0421\u0442\u0430\u0440\u0430\u044f \u042f\u0441\u0430\u0447\u043d\u0430\u044f",
      "longitude":103.7396856,
      "latitude":52.4871303
    },
    "10813":{
      "name":"\u0417\u0430\u0445\u0430\u0440\u043e\u0432\u0441\u043a\u0430\u044f",
      "longitude":103.746941,
      "latitude":52.9678
    },
    "10814":{
      "name":"\u041c\u043e\u0433\u043e\u043b\u044e\u0442",
      "longitude":104.1448346,
      "latitude":53.3409445
    },
    "10815":{
      "name":"\u0425\u043e\u043d\u0437\u043e\u0439",
      "longitude":104.411407,
      "latitude":53.228916
    },
    "10816":{
      "name":"\u0417\u0430\u0433\u043b\u0438\u043a",
      "longitude":103.752129,
      "latitude":53.173809
    },
    "10817":{
      "name":"\u0428\u0438\u0440\u043e\u043a\u0430\u044f",
      "longitude":103.757973,
      "latitude":51.728828
    },
    "10818":{
      "name":"\u0413\u0440\u0435\u0445\u043d\u0435\u0432\u043a\u0430",
      "longitude":103.766289,
      "latitude":52.900745
    },
    "10819":{
      "name":"\u0410\u0431\u0440\u0430\u043c\u043e\u0432\u043a\u0430",
      "longitude":103.7801871,
      "latitude":53.3910577
    },
    "10820":{
      "name":"\u041a\u043b\u044e\u0447\u0438",
      "longitude":103.784721,
      "latitude":52.813622
    },
    "10821":{
      "name":"\u0425\u0435\u0440\u0435\u0442\u0438\u043d",
      "longitude":103.798737,
      "latitude":53.159729
    },
    "10822":{
      "name":"\u041a\u0438\u0442\u043e\u0439",
      "longitude":103.8013441,
      "latitude":52.5278946
    },
    "10823":{
      "name":"\u0410\u043d\u0434\u0440\u0438\u044f\u043d\u043e\u0432\u0441\u043a\u0430\u044f",
      "longitude":103.811142,
      "latitude":51.800522
    },
    "10824":{
      "name":"\u0413\u0440\u0430\u043c\u0430\u0442\u0443\u0445\u0430",
      "longitude":103.813423,
      "latitude":51.949066
    },
    "10825":{
      "name":"\u0411\u0443\u0440\u043e\u0432\u0449\u0438\u043d\u0430",
      "longitude":103.81356,
      "latitude":51.623898
    },
    "10826":{
      "name":"\u0411\u0443\u043b\u0430\u043a",
      "longitude":103.815857,
      "latitude":53.256596
    },
    "10827":{
      "name":"\u0428\u0443\u043d\u0442\u0430",
      "longitude":103.820534,
      "latitude":53.158108
    },
    "10828":{
      "name":"\u0410\u043d\u0433\u0430\u0441\u043e\u043b\u044c\u0441\u043a\u0430\u044f",
      "longitude":103.828896,
      "latitude":51.731991
    },
    "10829":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u0413\u043b\u0443\u0431\u043e\u043a\u0430\u044f",
      "longitude":103.84462,
      "latitude":51.893906
    },
    "10830":{
      "name":"\u0425\u0443\u0437\u0438\u043d\u043e",
      "longitude":103.844757,
      "latitude":51.869587
    },
    "10831":{
      "name":"\u041c\u0443\u0440\u0430\u0432\u0435\u0439",
      "longitude":103.850212,
      "latitude":51.611317
    },
    "10832":{
      "name":"\u041d\u0430\u0431\u0435\u0440\u0435\u0436\u043d\u044b\u0439",
      "longitude":103.8549628,
      "latitude":52.6110107
    },
    "10833":{
      "name":"\u0413\u043b\u0443\u0431\u043e\u043a\u0430\u044f",
      "longitude":103.856781,
      "latitude":51.877705
    },
    "10834":{
      "name":"\u041c\u0430\u043b\u0430\u0445\u0430\u043d\u043e\u0432\u0430",
      "longitude":103.8601416,
      "latitude":53.4049334
    },
    "10835":{
      "name":"\u0421\u0430\u043d\u0430\u0442\u043e\u0440\u043d\u044b\u0439",
      "longitude":103.881691,
      "latitude":51.94577
    },
    "10836":{
      "name":"\u0418\u0441\u0442\u043e\u0447\u043d\u0438\u043a",
      "longitude":103.884773,
      "latitude":51.902668
    },
    "10837":{
      "name":"\u0420\u043e\u0434\u043d\u0438\u043a\u043e\u0432\u044b\u0439",
      "longitude":103.888603,
      "latitude":51.92485
    },
    "10838":{
      "name":"\u0417\u0430\u0432\u0435\u0434\u0435\u043d\u0438\u0435",
      "longitude":103.890518,
      "latitude":53.053471
    },
    "10839":{
      "name":"\u041c\u0430\u043d\u0433\u0443\u0442\u0430\u0439",
      "longitude":103.904648,
      "latitude":51.602367
    },
    "10840":{
      "name":"\u0421\u0435\u043b\u0435\u0437\u043d\u0435\u0432\u043e",
      "longitude":103.9095296,
      "latitude":56.3951155
    },
    "10841":{
      "name":"\u041a\u043b\u044e\u0447\u0435\u0432\u0430\u044f",
      "longitude":103.923378,
      "latitude":52.380039
    },
    "10842":{
      "name":"\u0413\u043e\u0440\u0445\u043e\u043d",
      "longitude":103.9380594,
      "latitude":53.7227362
    },
    "10843":{
      "name":"\u0417\u0432\u0435\u0440\u0435\u0432\u043e",
      "longitude":103.942101,
      "latitude":52.390945
    },
    "10844":{
      "name":"\u0421\u0435\u043b\u0435\u0437\u043d\u0435\u0432\u0441\u043a\u0438\u0439",
      "longitude":103.947517,
      "latitude":56.441521
    },
    "10845":{
      "name":"\u0421\u0443\u0445\u043e\u0432\u0441\u043a\u0430\u044f \u0441\u0442",
      "longitude":103.948158,
      "latitude":52.499023
    },
    "10846":{
      "name":"\u0411\u0430\u0440\u0434\u0430",
      "longitude":104.4101094,
      "latitude":52.831539
    },
    "10847":{
      "name":"\u0421\u0442\u0435\u043a\u043b\u044f\u043d\u043a\u0430",
      "longitude":103.96846,
      "latitude":52.399529
    },
    "10848":{
      "name":"\u0415\u043b\u043e\u0432\u043a\u0430",
      "longitude":103.968941,
      "latitude":52.701557
    },
    "10849":{
      "name":"\u0428\u0430\u0440\u0430\u0436\u0430\u043b\u0433\u0430\u0439",
      "longitude":103.97068,
      "latitude":51.749588
    },
    "10850":{
      "name":"\u0420\u0443\u0441\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":103.974335,
      "latitude":53.133175
    },
    "10851":{
      "name":"\u041f\u0438\u043e\u043d\u0435\u0440\u0441\u043a",
      "longitude":103.977707,
      "latitude":52.240063
    },
    "10852":{
      "name":"\u0422\u0430\u0431\u0430\u0442\u0430\u0439",
      "longitude":103.9864953,
      "latitude":53.4809335
    },
    "10853":{
      "name":"\u0422\u0440\u0443\u0434\u043d\u044b\u0439",
      "longitude":103.989891,
      "latitude":51.989185
    },
    "10854":{
      "name":"\u0422\u0430\u0451\u0436\u043d\u044b\u0439",
      "longitude":103.994774,
      "latitude":51.996342
    },
    "10855":{
      "name":"\u0411\u043e\u0440\u043e\u0445\u0430\u043b",
      "longitude":103.9993034,
      "latitude":53.7213116
    },
    "10856":{
      "name":"\u041e\u0440\u0435\u0445\u043e\u0432\u043e",
      "longitude":104.0001237,
      "latitude":51.5602195
    },
    "10857":{
      "name":"\u0421\u0442\u0435\u043f\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":104.001053,
      "latitude":52.78503
    },
    "10858":{
      "name":"\u041e\u0433\u043e\u043d\u044c\u043a\u0438",
      "longitude":104.015717,
      "latitude":52.011509
    },
    "10859":{
      "name":"\u041d\u043e\u0432\u043e\u0432\u043e\u0441\u043a\u0440\u0435\u0441\u0435\u043d\u043a\u0430",
      "longitude":104.017502,
      "latitude":53.149685
    },
    "10860":{
      "name":"\u041f\u044b\u043b\u043e\u0432\u043a\u0430",
      "longitude":104.0187001,
      "latitude":51.7574744
    },
    "10861":{
      "name":"\u0411\u044b\u043a\u043e\u0432\u0430",
      "longitude":104.022629,
      "latitude":52.736679
    },
    "10862":{
      "name":"\u041f\u0440\u043e\u0445\u043e\u0440\u043e\u0432\u043a\u0430",
      "longitude":104.0389223,
      "latitude":53.3501031
    },
    "10863":{
      "name":"\u042f\u0433\u043e\u0434\u043d\u044b\u0439",
      "longitude":104.05439,
      "latitude":52.008812
    },
    "10864":{
      "name":"\u0427\u0443\u043f\u0440\u043e\u0432\u043a\u0430",
      "longitude":104.0579416,
      "latitude":53.3052436
    },
    "10865":{
      "name":"\u041a\u041f \u0421\u043e\u043b\u043d\u0435\u0447\u043d\u044b\u0439",
      "longitude":104.0596758,
      "latitude":52.219608
    },
    "10866":{
      "name":"\u0416\u041a \u0421\u0432\u0435\u0442\u043b\u044b\u0439",
      "longitude":104.0670357,
      "latitude":52.218269
    },
    "10867":{
      "name":"\u041b\u0435\u0442\u043d\u044f\u044f",
      "longitude":104.067406,
      "latitude":52.149956
    },
    "10868":{
      "name":"\u041c\u0430\u043d\u044c\u043a\u043e\u0432\u0430",
      "longitude":104.068695,
      "latitude":53.132427
    },
    "10869":{
      "name":"\u0423\u0434\u0430\u0440\u043d\u0438\u043a",
      "longitude":104.069862,
      "latitude":52.432449
    },
    "10870":{
      "name":"\u0414\u0430\u0447\u043d\u0430\u044f",
      "longitude":104.073227,
      "latitude":52.126995
    },
    "10871":{
      "name":"\u0420\u0430\u0441\u0441\u043e\u0445\u0430",
      "longitude":104.083878,
      "latitude":52.027695
    },
    "10872":{
      "name":"\u041e\u0440\u043b\u0451\u043d\u043e\u043a",
      "longitude":104.084824,
      "latitude":52.010841
    },
    "10873":{
      "name":"\u0411\u0430\u0431\u0445\u0430",
      "longitude":104.087044,
      "latitude":51.53326
    },
    "10874":{
      "name":"\u0412\u0434\u043e\u0432\u0438\u043d\u0430",
      "longitude":104.09639,
      "latitude":52.361027
    },
    "10875":{
      "name":"\u0411\u0430\u043a\u043b\u0430\u043d\u044c",
      "longitude":104.101501,
      "latitude":51.760277
    },
    "10876":{
      "name":"\u0423\u0441\u0442\u044c-\u0423\u043a\u044b\u0440",
      "longitude":104.106743,
      "latitude":53.131775
    },
    "10877":{
      "name":"\u041c\u0430\u0440\u043a\u043e\u0432\u043a\u0430",
      "longitude":104.1155948,
      "latitude":53.2857659
    },
    "10878":{
      "name":"\u041b\u0430\u0432\u0440\u0435\u043d\u0442\u044c\u0435\u0432\u0441\u043a\u0430\u044f",
      "longitude":104.1315,
      "latitude":53.172691
    },
    "10879":{
      "name":"\u0421\u0435\u0432\u0435\u0440\u043d\u044b\u0439",
      "longitude":104.139924,
      "latitude":53.5783553
    },
    "10880":{
      "name":"\u0425\u043e\u0440\u0433\u0435\u043b\u043e\u043a",
      "longitude":104.149567,
      "latitude":53.133686
    },
    "10881":{
      "name":"\u0422\u0438\u0445\u043e\u043d\u043e\u0432\u0430 \u041f\u0430\u0434\u044c",
      "longitude":104.154175,
      "latitude":52.632343
    },
    "10882":{
      "name":"\u0425\u0430\u0439\u0440\u044e\u0437\u043e\u0432\u043a\u0430",
      "longitude":104.184364,
      "latitude":52.40361
    },
    "10883":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u0433\u0440\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":104.186127,
      "latitude":53.067299
    },
    "10884":{
      "name":"\u0411\u0443\u0445\u0443\u043d",
      "longitude":104.18644,
      "latitude":52.897614
    },
    "10885":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u041a\u0435\u0442",
      "longitude":104.197525,
      "latitude":52.961758
    },
    "10886":{
      "name":"\u0422\u0430\u0447\u0438\u0433\u0438\u0440",
      "longitude":104.19812,
      "latitude":53.146126
    },
    "10887":{
      "name":"\u0410\u043d\u0433\u0430\u0440\u0430",
      "longitude":104.225784,
      "latitude":52.388618
    },
    "10888":{
      "name":"\u0428\u043e\u0442\u043e\u0439",
      "longitude":104.2484113,
      "latitude":53.4357068
    },
    "10889":{
      "name":"\u041e\u043d\u0433\u043e\u0441\u043e\u0440",
      "longitude":104.2500202,
      "latitude":53.3928097
    },
    "10890":{
      "name":"\u0422\u0430\u0439\u0442\u0443\u0440\u0430",
      "longitude":104.264236,
      "latitude":52.553776
    },
    "10891":{
      "name":"\u0413\u043b\u0430\u0437\u0443\u043d\u043e\u0432\u0430",
      "longitude":104.2644897,
      "latitude":52.3858006
    },
    "10892":{
      "name":"\u0427\u0438\u043b\u0438\u043c",
      "longitude":104.276924,
      "latitude":53.112045
    },
    "10893":{
      "name":"\u0425\u0430\u0440\u0430\u0433\u0443\u043d",
      "longitude":104.304497,
      "latitude":53.170628
    },
    "10894":{
      "name":"\u041f\u0430\u0440\u0430\u043c\u043e\u043d\u043e\u0432\u043a\u0430",
      "longitude":104.3049029,
      "latitude":53.059039
    },
    "10895":{
      "name":"\u041f\u0430\u0440\u0444\u0451\u043d\u043e\u0432\u043a\u0430",
      "longitude":104.3110828,
      "latitude":52.3378349
    },
    "10896":{
      "name":"\u0411\u0430\u043b\u044b\u0445\u0442\u0430",
      "longitude":104.311867,
      "latitude":54.46809
    },
    "10897":{
      "name":"\u0420\u044f\u0437\u0430\u043d\u043e\u0432\u0449\u0438\u043d\u0430",
      "longitude":104.328781,
      "latitude":52.716187
    },
    "10898":{
      "name":"\u041f\u043e\u043b\u043e\u0432\u0438\u043d\u043d\u0430\u044f",
      "longitude":104.355522,
      "latitude":51.799435
    },
    "10899":{
      "name":"\u0413\u0440\u0430\u043d\u0438\u0447\u043d\u0430\u044f",
      "longitude":104.365662,
      "latitude":53.13092
    },
    "10900":{
      "name":"\u0411\u0430\u0437\u043e\u0439",
      "longitude":104.391129,
      "latitude":53.107239
    },
    "10901":{
      "name":"\u041c\u0438\u0448\u043e\u043d\u043a\u043e\u0432\u0430",
      "longitude":104.394431,
      "latitude":52.6555484
    },
    "10902":{
      "name":"\u041f\u043e\u043d\u043e\u043c\u0430\u0440\u0451\u0432\u043a\u0430",
      "longitude":104.397247,
      "latitude":51.804283
    },
    "10903":{
      "name":"\u041a\u0438\u0440\u044c\u044f\u043d\u043e\u0432\u0441\u043a\u0430\u044f \u041a\u043e\u043d\u0442\u043e\u0440\u0430",
      "longitude":104.4,
      "latitude":58.583333
    },
    "10904":{
      "name":"\u0417\u044b\u043a\u043e\u0432\u0430",
      "longitude":104.408363,
      "latitude":52.58812
    },
    "10905":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":104.4143541,
      "latitude":51.8015477
    },
    "10906":{
      "name":"\u041d\u043e\u0432\u043e\u0433\u0440\u0443\u0434\u0438\u043d\u0438\u043d\u0430",
      "longitude":104.414925,
      "latitude":52.149414
    },
    "10907":{
      "name":"\u041a\u0430\u0440\u0441\u0442\u043e\u0432\u0430\u044f",
      "longitude":104.4214674,
      "latitude":56.7070302
    },
    "10908":{
      "name":"\u041d\u0430\u0448\u0430\u0442\u0430",
      "longitude":104.430008,
      "latitude":53.241943
    },
    "10909":{
      "name":"\u041a\u0443\u0434\u0430\u0440\u0435\u0439\u043a\u0430",
      "longitude":104.433006,
      "latitude":52.863224
    },
    "10910":{
      "name":"\u0412\u0435\u0441\u0435\u043b\u0430\u044f \u041f\u043e\u043b\u044f\u043d\u0430",
      "longitude":104.442062,
      "latitude":53.135448
    },
    "10911":{
      "name":"\u0422\u0443\u0440\u0441\u043a\u0430\u044f",
      "longitude":104.442192,
      "latitude":52.532795
    },
    "10912":{
      "name":"\u041f\u0430\u043d\u044c\u043a\u043e\u0432\u043a\u0430 1-\u044f",
      "longitude":104.452454,
      "latitude":51.477505
    },
    "10913":{
      "name":"\u0422\u0430\u043b\u044c\u043a\u0430",
      "longitude":104.455269,
      "latitude":52.452271
    },
    "10914":{
      "name":"\u0428\u0443\u043c\u0438\u0445\u0430",
      "longitude":104.46476,
      "latitude":51.800293
    },
    "10915":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u043c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":104.472609,
      "latitude":52.2583464
    },
    "10916":{
      "name":"\u0418\u0434\u0430",
      "longitude":104.496986,
      "latitude":53.307117
    },
    "10917":{
      "name":"\u041f\u0430\u043d\u044c\u043a\u043e\u0432\u043a\u0430 2-\u044f",
      "longitude":104.508347,
      "latitude":51.456238
    },
    "10918":{
      "name":"\u0411\u0430\u0442\u0445\u0430\u0439",
      "longitude":104.5109958,
      "latitude":52.8791502
    },
    "10919":{
      "name":"\u041c\u0430\u043a\u0441\u0438\u043c\u043e\u0432\u0449\u0438\u043d\u0430",
      "longitude":104.518906,
      "latitude":52.610821
    },
    "10920":{
      "name":"\u0423\u043b\u0430\u043d\u043e\u0432\u043e",
      "longitude":104.52211,
      "latitude":51.796822
    },
    "10921":{
      "name":"\u0422\u044b\u043f\u0442\u0430",
      "longitude":104.533646,
      "latitude":54.5784
    },
    "10922":{
      "name":"\u0422\u043e\u043b\u043e\u0434\u043e\u0439",
      "longitude":104.5572749,
      "latitude":52.8030781
    },
    "10923":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u044f\u044f \u0418\u0434\u044b\u0433\u0430",
      "longitude":104.562065,
      "latitude":52.921959
    },
    "10924":{
      "name":"\u041b\u0435\u0431\u0435\u0434\u0438\u043d\u043a\u0430",
      "longitude":104.56897,
      "latitude":52.15332
    },
    "10925":{
      "name":"\u0417\u0430\u0434\u044b",
      "longitude":104.570099,
      "latitude":52.765961
    },
    "10926":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043a\u0430",
      "longitude":104.579682,
      "latitude":52.0661461
    },
    "10927":{
      "name":"\u0414\u043e\u0440\u043e\u0436\u043d\u044b\u0439",
      "longitude":104.587189,
      "latitude":52.08847
    },
    "10928":{
      "name":"\u0411\u0443\u0440\u0434\u0443\u0433\u0443\u0437",
      "longitude":104.60302,
      "latitude":52.051693
    },
    "10929":{
      "name":"\u041a\u0430\u0448\u0442\u0430\u043a",
      "longitude":104.607292,
      "latitude":52.573181
    },
    "10930":{
      "name":"\u0421\u043e\u043b\u044f\u043d\u043a\u0430",
      "longitude":104.6194767,
      "latitude":52.6610209
    },
    "10931":{
      "name":"\u0411\u0443\u0442\u044b\u0440\u043a\u0438",
      "longitude":104.6267027,
      "latitude":52.0404681
    },
    "10932":{
      "name":"\u0411\u0430\u0439\u0434\u043e\u043d\u043e\u0432\u043e",
      "longitude":104.638863,
      "latitude":54.260197
    },
    "10933":{
      "name":"\u0422\u0430\u043b\u044c\u0446\u044b",
      "longitude":104.669983,
      "latitude":51.99081
    },
    "10934":{
      "name":"\u041f\u0443\u043b\u044f\u0435\u0432\u0449\u0438\u043d\u0430",
      "longitude":104.67247,
      "latitude":54.639889
    },
    "10935":{
      "name":"\u0411\u0430\u0442\u0445\u0430\u0439",
      "longitude":104.677315,
      "latitude":52.69175
    },
    "10936":{
      "name":"\u0411\u0430\u0447\u0430\u0439",
      "longitude":104.678917,
      "latitude":54.233788
    },
    "10937":{
      "name":"\u0420\u0443\u0434\u043e\u0432\u0449\u0438\u043d\u0430",
      "longitude":104.698135,
      "latitude":52.610096
    },
    "10938":{
      "name":"\u0411\u0443\u0440\u0433\u0430\u0437",
      "longitude":104.704567,
      "latitude":52.543217
    },
    "10939":{
      "name":"\u0411\u0443\u0442\u044b\u0440\u0438\u043d\u0430",
      "longitude":104.709419,
      "latitude":54.419914
    },
    "10940":{
      "name":"\u041c\u0443\u0440\u0438\u043d\u043e",
      "longitude":104.719009,
      "latitude":52.67165
    },
    "10941":{
      "name":"\u041c\u0435\u0440\u0437\u043b\u043e\u0442\u043d\u0430\u044f",
      "longitude":104.721519,
      "latitude":56.761459
    },
    "10942":{
      "name":"\u041f\u043e\u043b\u0438\u0432\u0430\u043d\u0438\u0445\u0430",
      "longitude":104.730507,
      "latitude":52.270481
    },
    "10943":{
      "name":"\u0417\u0430\u0445\u0430\u0440\u043e\u0432\u0430",
      "longitude":104.734138,
      "latitude":54.361092
    },
    "10944":{
      "name":"\u041a\u0430\u0439\u0434\u0430\u043a\u0430\u043d",
      "longitude":104.761459,
      "latitude":54.481903
    },
    "10945":{
      "name":"\u041a\u043e\u043d\u0441\u0442\u0430\u043d\u0442\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":104.769241,
      "latitude":54.674652
    },
    "10946":{
      "name":"\u041a\u0430\u0447\u0435\u043d\u044c",
      "longitude":104.769951,
      "latitude":54.613625
    },
    "10947":{
      "name":"\u0410\u043d\u0433\u0430\u0440\u0441\u043a\u0438\u0435 \u0425\u0443\u0442\u043e\u0440\u0430",
      "longitude":104.785126,
      "latitude":51.927151
    },
    "10948":{
      "name":"\u0427\u0438\u0447\u0435\u043a",
      "longitude":104.797333,
      "latitude":54.530457
    },
    "10949":{
      "name":"\u0417\u0443\u0440\u0446\u0430\u0433\u0430\u043d",
      "longitude":104.8046755,
      "latitude":53.0766251
    },
    "10950":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u041a\u0443\u0440\u0430",
      "longitude":104.8222703,
      "latitude":52.8283259
    },
    "10951":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430",
      "longitude":104.824692,
      "latitude":51.893936
    },
    "10952":{
      "name":"\u0414\u043e\u0431\u0440\u043e\u043b\u0451\u0442",
      "longitude":104.831131,
      "latitude":52.25209
    },
    "10953":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u041a\u0443\u0440\u0430",
      "longitude":104.847565,
      "latitude":52.736904
    },
    "10954":{
      "name":"\u0427\u0435\u0440\u0435\u043c\u0448\u0430\u043d\u043a\u0430",
      "longitude":104.863457,
      "latitude":52.024384
    },
    "10955":{
      "name":"\u041a\u043e\u043c\u043e\u0439",
      "longitude":104.888306,
      "latitude":52.712006
    },
    "10956":{
      "name":"\u0421\u0435\u0440\u0430\u0444\u0438\u043c\u043e\u0432\u0441\u043a",
      "longitude":104.890717,
      "latitude":53.145092
    },
    "10957":{
      "name":"\u041a\u0430\u0439\u043c\u043e\u043d\u043e\u0432\u043e",
      "longitude":104.894005,
      "latitude":56.838364
    },
    "10958":{
      "name":"\u0428\u0435\u0434\u043e\u0439",
      "longitude":104.9057255,
      "latitude":53.0427586
    },
    "10959":{
      "name":"\u041d\u0438\u0436\u043d\u044f\u044f \u0421\u043b\u043e\u0431\u043e\u0434\u0430",
      "longitude":104.91658,
      "latitude":54.736523
    },
    "10960":{
      "name":"\u0411\u0443\u0445\u0442\u0443\u043c\u0443\u0440",
      "longitude":104.942383,
      "latitude":53.24638
    },
    "10961":{
      "name":"\u041e\u0440\u0434\u044b\u043d\u0441\u043a\u0438\u0439",
      "longitude":104.9538346,
      "latitude":52.8817012
    },
    "10962":{
      "name":"\u0422\u0438\u043c\u043e\u0448\u0438\u043d\u0441\u043a",
      "longitude":104.955963,
      "latitude":53.274044
    },
    "10963":{
      "name":"\u0418\u0440\u0445\u0438\u043f\u0448\u0438\u043d",
      "longitude":104.9751252,
      "latitude":53.0874883
    },
    "10964":{
      "name":"\u0411\u0430\u044f\u043d\u0433\u0430\u0437\u0443\u0439",
      "longitude":104.981659,
      "latitude":52.989971
    },
    "10965":{
      "name":"\u0413\u0443\u0448\u0438\u0442",
      "longitude":104.9884848,
      "latitude":52.8839751
    },
    "10966":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0439 \u041a\u0443\u043a\u0443\u0442",
      "longitude":104.9944589,
      "latitude":52.7523407
    },
    "10967":{
      "name":"\u041c\u0430\u043a\u0441\u0438\u043c\u043e\u0432\u043e",
      "longitude":105.008194,
      "latitude":57.123947
    },
    "10968":{
      "name":"\u0418\u0448\u0438\u043d\u044b",
      "longitude":105.00885,
      "latitude":52.813992
    },
    "10969":{
      "name":"\u0421\u0430\u0433\u0430\u0440\u0443\u043a",
      "longitude":105.025482,
      "latitude":52.790321
    },
    "10970":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u042f\u0440",
      "longitude":105.047554,
      "latitude":52.542862
    },
    "10971":{
      "name":"\u0411\u043e\u0431\u0440\u043e\u0432\u043a\u0430",
      "longitude":105.05114,
      "latitude":57.19698
    },
    "10972":{
      "name":"\u041e\u043d\u0433\u043e\u0439",
      "longitude":105.05941,
      "latitude":53.039875
    },
    "10973":{
      "name":"\u041c\u043e\u043b\u043e\u0434\u0451\u0436\u043d\u044b\u0439",
      "longitude":105.068153,
      "latitude":55.055824
    },
    "10974":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0438\u0435 \u041a\u043e\u0442\u044b",
      "longitude":105.074036,
      "latitude":51.904469
    },
    "10975":{
      "name":"\u0422\u043e\u0442\u043e\u0445\u043e\u043d",
      "longitude":105.091255,
      "latitude":52.798767
    },
    "10976":{
      "name":"\u0422\u0438\u0445\u0438\u0439 \u041f\u043b\u0435\u0441",
      "longitude":105.1013182,
      "latitude":54.8241076
    },
    "10977":{
      "name":"\u0428\u043e\u0445\u0442\u043e\u0439",
      "longitude":105.112839,
      "latitude":52.810005
    },
    "10978":{
      "name":"\u041a\u043e\u043a\u043e\u0440\u0438\u043d\u0430",
      "longitude":105.159531,
      "latitude":53.084949
    },
    "10979":{
      "name":"\u041d\u0430\u0443\u043c\u043e\u0432\u043a\u0430",
      "longitude":105.1610292,
      "latitude":52.8412208
    },
    "10980":{
      "name":"\u0417\u0430\u043f\u043b\u0435\u0441\u043a\u0438\u043d\u0430",
      "longitude":105.176003,
      "latitude":54.381969
    },
    "10981":{
      "name":"\u0411\u0430\u043b\u0430\u0445\u043d\u044f",
      "longitude":105.196373,
      "latitude":54.818481
    },
    "10982":{
      "name":"\u0428\u0435\u0440\u0442\u043e\u0439",
      "longitude":105.196693,
      "latitude":53.33503
    },
    "10983":{
      "name":"\u041c\u0443\u0440\u043e\u043c\u0446\u043e\u0432\u043a\u0430",
      "longitude":105.2090518,
      "latitude":53.2019757
    },
    "10984":{
      "name":"\u0418\u0433\u0436\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":105.21199,
      "latitude":54.723999
    },
    "10985":{
      "name":"\u0422\u0435\u0442\u0435\u0440\u0435",
      "longitude":105.216667,
      "latitude":59.65
    },
    "10986":{
      "name":"\u0412\u043e\u0440\u043e\u0431\u044c\u0451\u0432\u0430",
      "longitude":105.222626,
      "latitude":54.581215
    },
    "10987":{
      "name":"\u0413\u043e\u043b\u043e\u0432\u043d\u043e\u0432\u043a\u0430",
      "longitude":105.22345,
      "latitude":54.769165
    },
    "10988":{
      "name":"\u041f\u043e\u043d\u043e\u043c\u0430\u0440\u0451\u0432\u0430",
      "longitude":105.226166,
      "latitude":54.659454
    },
    "10989":{
      "name":"\u041e\u0440\u043b\u043e\u0432\u043a\u0430",
      "longitude":105.227371,
      "latitude":54.807945
    },
    "10990":{
      "name":"\u0413\u0440\u0443\u0437\u043d\u043e\u0432\u043a\u0430",
      "longitude":105.228233,
      "latitude":55.143711
    },
    "10991":{
      "name":"\u041a\u0443\u0437\u043d\u0435\u0446\u043e\u0432\u043a\u0430",
      "longitude":105.231323,
      "latitude":54.797855
    },
    "10992":{
      "name":"\u0421\u043e\u043b\u043d\u043e\u043f\u0435\u0447\u043d\u043e\u0435",
      "longitude":105.2376496,
      "latitude":52.2990657
    },
    "10993":{
      "name":"\u041d\u044b\u0433\u0435\u0439",
      "longitude":105.25444,
      "latitude":52.845791
    },
    "10994":{
      "name":"\u041c\u0430\u0440\u0430\u043b\u0442\u0443\u0439",
      "longitude":105.267822,
      "latitude":52.997944
    },
    "10995":{
      "name":"\u0425\u0430\u043d\u0434\u0430\u0431\u0430\u0439",
      "longitude":105.271889,
      "latitude":52.864983
    },
    "10996":{
      "name":"\u0418\u0434\u044b\u0433\u0435\u0439",
      "longitude":105.273338,
      "latitude":53.007427
    },
    "10997":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0439 \u041a\u043e\u0447\u0435\u0440\u0433\u0430\u0442",
      "longitude":105.274467,
      "latitude":52.138443
    },
    "10998":{
      "name":"\u041c\u043e\u043b\u043e\u0439",
      "longitude":105.2899347,
      "latitude":53.036449
    },
    "10999":{
      "name":"\u0425\u0438\u043d\u0435\u0439",
      "longitude":105.298622,
      "latitude":52.862106
    },
    "11000":{
      "name":"\u041c\u0430\u0433\u0434\u0430\u043d",
      "longitude":105.307922,
      "latitude":53.609154
    },
    "11001":{
      "name":"\u0425\u0443\u0442\u044b",
      "longitude":105.325409,
      "latitude":53.233097
    },
    "11002":{
      "name":"\u0418\u0445\u0438\u043d\u0430\u0433\u0443\u0439",
      "longitude":105.329033,
      "latitude":53.732746
    },
    "11003":{
      "name":"\u041d\u0443\u0445\u0443-\u041d\u0443\u0440",
      "longitude":105.340981,
      "latitude":53.149879
    },
    "11004":{
      "name":"\u042f\u043a\u0438\u043c\u043e\u0432\u043a\u0430",
      "longitude":105.363892,
      "latitude":54.823067
    },
    "11005":{
      "name":"\u041a\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":105.368584,
      "latitude":52.999207
    },
    "11006":{
      "name":"\u0411\u0430\u0445\u0430\u0439 1-\u0439",
      "longitude":105.375237,
      "latitude":52.922722
    },
    "11007":{
      "name":"\u0422\u044b\u043f\u043a\u044b\u0441\u044b\u0440",
      "longitude":105.379875,
      "latitude":53.062092
    },
    "11008":{
      "name":"\u0422\u044e\u043c\u0435\u043d\u0446\u0435\u0432\u0430",
      "longitude":105.381737,
      "latitude":54.28809
    },
    "11009":{
      "name":"\u0413\u043e\u0433\u043e\u043d",
      "longitude":105.397232,
      "latitude":53.924072
    },
    "11010":{
      "name":"\u0416\u0438\u0442\u043e\u0432\u0430",
      "longitude":105.416389,
      "latitude":53.947651
    },
    "11011":{
      "name":"\u0415\u043b\u0435\u043d\u0438\u043d\u0441\u043a",
      "longitude":105.424187,
      "latitude":53.198189
    },
    "11012":{
      "name":"\u041e\u0431\u0445\u043e\u0439",
      "longitude":105.436508,
      "latitude":53.973171
    },
    "11013":{
      "name":"\u0411\u0443\u043b\u0443\u043d\u0447\u0443\u043a",
      "longitude":105.4369161,
      "latitude":52.3992984
    },
    "11014":{
      "name":"\u0428\u0435\u043c\u0435\u0442\u043e\u0432\u0430",
      "longitude":105.455391,
      "latitude":54.014606
    },
    "11015":{
      "name":"\u041a\u043e\u0437\u043b\u043e\u0432\u043e",
      "longitude":105.455566,
      "latitude":54.210457
    },
    "11016":{
      "name":"\u0411\u0430\u0445\u0430\u0439 2-\u0439",
      "longitude":105.456924,
      "latitude":52.957951
    },
    "11017":{
      "name":"\u0425\u0430\u0431\u0430\u0440\u0434\u0438\u043d\u0430",
      "longitude":105.473213,
      "latitude":54.047047
    },
    "11018":{
      "name":"\u041a\u043e\u043d\u043e\u0448\u0430\u043d\u043e\u0432\u043e",
      "longitude":105.4784238,
      "latitude":55.3575157
    },
    "11019":{
      "name":"\u0425\u043e\u0431\u0430\u043d\u043e\u0432\u0430",
      "longitude":105.478722,
      "latitude":54.033672
    },
    "11020":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0435\u0434\u0432\u043e\u0440\u043e\u0432\u0430",
      "longitude":105.485603,
      "latitude":54.067432
    },
    "11021":{
      "name":"\u0413\u0440\u0435\u0445\u043e\u0432\u0430",
      "longitude":105.48658,
      "latitude":54.868763
    },
    "11022":{
      "name":"\u0423\u0441\u0442\u044c-\u0422\u0430\u043b\u044c\u043c\u0430",
      "longitude":105.488266,
      "latitude":54.025482
    },
    "11023":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":105.493774,
      "latitude":54.074791
    },
    "11024":{
      "name":"\u0411\u043e\u0445\u043e\u043b\u0434\u043e\u0439",
      "longitude":105.494209,
      "latitude":52.981331
    },
    "11025":{
      "name":"\u0422\u0430\u043b\u044c\u043c\u0430",
      "longitude":105.509926,
      "latitude":54.012833
    },
    "11026":{
      "name":"\u0412\u0435\u0440\u0448\u0438\u043d\u0438\u043d\u0441\u043a",
      "longitude":105.510979,
      "latitude":53.222527
    },
    "11027":{
      "name":"\u0427\u0435\u043b\u043f\u0430\u043d\u043e\u0432\u0430",
      "longitude":105.518272,
      "latitude":54.090004
    },
    "11028":{
      "name":"\u041a\u0443\u043d\u0438\u0446\u044b\u043d\u0430",
      "longitude":105.521812,
      "latitude":54.145706
    },
    "11029":{
      "name":"\u0413\u043e\u043b\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":105.5223802,
      "latitude":55.4908903
    },
    "11030":{
      "name":"\u0422\u043e\u043b\u043c\u0430\u0447\u0435\u0432\u0430",
      "longitude":105.534912,
      "latitude":54.096447
    },
    "11031":{
      "name":"\u0420\u0435\u043c\u0438\u0437\u043e\u0432\u0430",
      "longitude":105.537514,
      "latitude":54.126072
    },
    "11032":{
      "name":"\u0428\u0435\u0445\u0430\u0440\u0433\u0443\u043d",
      "longitude":105.548676,
      "latitude":53.097778
    },
    "11033":{
      "name":"\u041c\u0438\u043b\u044c\u0437\u0430\u043d",
      "longitude":105.570778,
      "latitude":53.065311
    },
    "11034":{
      "name":"\u041c\u0430\u044f\u043a",
      "longitude":105.583961,
      "latitude":53.153229
    },
    "11035":{
      "name":"\u041a\u0430\u0440\u0442\u0443\u0445\u0430\u0439",
      "longitude":105.58786,
      "latitude":54.037762
    },
    "11036":{
      "name":"\u0428\u0430\u043c\u0430\u043d\u043a\u0430",
      "longitude":105.600281,
      "latitude":53.125973
    },
    "11037":{
      "name":"\u0428\u0438\u0448\u043a\u0438\u043d\u0430",
      "longitude":105.653259,
      "latitude":54.017719
    },
    "11038":{
      "name":"\u0417\u0430\u043d\u0433\u0443\u0442",
      "longitude":105.666595,
      "latitude":53.129242
    },
    "11039":{
      "name":"\u041a\u0435\u043b\u043e\u0440\u0430",
      "longitude":105.684189,
      "latitude":54.663277
    },
    "11040":{
      "name":"\u0422\u0430\u0440\u0430\u0441\u043e\u0432\u043e",
      "longitude":105.689484,
      "latitude":56.147907
    },
    "11041":{
      "name":"\u0422\u0443\u0445\u0443\u043c",
      "longitude":105.714439,
      "latitude":53.42202
    },
    "11042":{
      "name":"\u0422\u043e\u043b\u0441\u0442\u043e\u0432\u043a\u0430",
      "longitude":105.719666,
      "latitude":53.052189
    },
    "11043":{
      "name":"\u0423\u043b\u0430\u043d",
      "longitude":105.727997,
      "latitude":53.2379
    },
    "11044":{
      "name":"\u041a\u0438\u0441\u0442\u0435\u043d\u0435\u0432\u0430",
      "longitude":105.743958,
      "latitude":53.978622
    },
    "11045":{
      "name":"\u0421\u043a\u043e\u043a\u043d\u0438\u043d\u0430",
      "longitude":105.7591537,
      "latitude":56.301985599999995
    },
    "11046":{
      "name":"\u041c\u0438\u043d\u0433\u0430\u043d",
      "longitude":105.760246,
      "latitude":56.993031
    },
    "11047":{
      "name":"\u0422\u0443\u0440\u0443\u043a\u0430",
      "longitude":105.764114,
      "latitude":56.678326
    },
    "11048":{
      "name":"\u041c\u0430\u043b\u0430\u043d",
      "longitude":105.774178,
      "latitude":53.454491
    },
    "11049":{
      "name":"\u041d\u0430\u0433\u0430\u0442\u0430\u0439",
      "longitude":105.779678,
      "latitude":53.470154
    },
    "11050":{
      "name":"\u0421\u0442\u0430\u0440\u044b\u0439 \u0425\u043e\u0433\u043e\u0442",
      "longitude":105.787666,
      "latitude":53.292793
    },
    "11051":{
      "name":"\u041b\u0435\u0441\u043d\u043e\u0439",
      "longitude":105.816116,
      "latitude":53.986618
    },
    "11052":{
      "name":"\u0425\u0430\u0440\u0430\u0433\u0443\u043d",
      "longitude":105.816223,
      "latitude":53.1278
    },
    "11053":{
      "name":"\u041a\u0443\u0440\u0442\u0443\u043d",
      "longitude":105.81739,
      "latitude":52.614548
    },
    "11054":{
      "name":"\u041b\u0438\u0434\u0438\u043d\u0441\u043a\u0430\u044f",
      "longitude":105.820457,
      "latitude":53.083069
    },
    "11055":{
      "name":"\u0425\u0430\u043d\u0434\u0430\u0433\u0430\u0439",
      "longitude":105.851768,
      "latitude":53.165306
    },
    "11056":{
      "name":"\u0425\u043e\u0442\u043e\u0433\u043e\u0440",
      "longitude":105.853951,
      "latitude":53.330597
    },
    "11057":{
      "name":"\u0422\u043e\u043a\u043c\u0430",
      "longitude":105.85569,
      "latitude":58.251884
    },
    "11058":{
      "name":"\u041e\u0440\u043b\u0438\u043d\u0433\u0430",
      "longitude":105.855743,
      "latitude":56.045906
    },
    "11059":{
      "name":"\u0416\u0435\u043c\u0447\u0443\u0433\u043e\u0432\u0430",
      "longitude":105.85656,
      "latitude":56.06522
    },
    "11060":{
      "name":"\u0421\u0443\u0442\u0430\u0439",
      "longitude":105.888382,
      "latitude":53.910667
    },
    "11061":{
      "name":"\u0422\u0438\u043c\u0438\u0440\u044f\u0437\u0435\u0432\u0430",
      "longitude":105.8897028,
      "latitude":53.917489
    },
    "11062":{
      "name":"\u0411\u043e\u0441\u043e\u0433\u043e\u043b",
      "longitude":105.90567,
      "latitude":53.877029
    },
    "11063":{
      "name":"\u0428\u0438\u0442\u0445\u0443\u043b\u0443\u043d",
      "longitude":105.944481,
      "latitude":53.326366
    },
    "11064":{
      "name":"\u0414\u0443\u0445\u043e\u0432\u0449\u0438\u043d\u0430",
      "longitude":105.9729433,
      "latitude":53.2092596
    },
    "11065":{
      "name":"\u0418\u0441\u0435\u0442\u044c",
      "longitude":105.982056,
      "latitude":53.846863
    },
    "11066":{
      "name":"\u0417\u0443\u0435\u0432\u0430",
      "longitude":105.983833,
      "latitude":53.54504
    },
    "11067":{
      "name":"\u041f\u043e\u043b\u043e\u0441\u043a\u043e\u0432\u0430",
      "longitude":105.994934,
      "latitude":53.523987
    },
    "11068":{
      "name":"\u041b\u0438\u0442\u0432\u0438\u043d\u043e\u0432\u0430",
      "longitude":105.995102,
      "latitude":53.619198
    },
    "11069":{
      "name":"\u0410\u043b\u0430\u0433\u0443\u0439",
      "longitude":105.995491,
      "latitude":52.778355
    },
    "11070":{
      "name":"\u041a\u0430\u0439\u0437\u0430\u0440\u0430\u043d",
      "longitude":106.000816,
      "latitude":53.303265
    },
    "11071":{
      "name":"\u041d\u043e\u0432\u043e\u0445\u0430\u0440\u0431\u0430\u0442\u043e\u0432\u0430",
      "longitude":106.013138,
      "latitude":53.768723
    },
    "11072":{
      "name":"\u0411\u043e\u044f\u0440\u0441\u043a",
      "longitude":106.020378,
      "latitude":56.338928
    },
    "11073":{
      "name":"\u0425\u0430\u043b\u044c\u0441\u043a",
      "longitude":106.040764,
      "latitude":53.802177
    },
    "11074":{
      "name":"\u041c\u0430\u043b\u044b\u0435 \u0413\u043e\u043b\u044b",
      "longitude":106.050735,
      "latitude":53.92931
    },
    "11075":{
      "name":"\u0427\u0435\u043f\u0442\u044b\u0445\u043e\u0439",
      "longitude":106.059326,
      "latitude":53.952778
    },
    "11076":{
      "name":"\u0421\u0443\u0445\u0430\u043d\u0430\u0439 \u0411\u0430\u0439\u0431\u0435\u0442",
      "longitude":106.059761,
      "latitude":53.933899
    },
    "11077":{
      "name":"\u041a\u043e\u043f\u0446\u044b\u0433\u0430\u0439",
      "longitude":106.072098,
      "latitude":53.390591
    },
    "11078":{
      "name":"\u041a\u043e\u0441\u0430\u044f \u0421\u0442\u0435\u043f\u044c",
      "longitude":106.078957,
      "latitude":52.84499
    },
    "11079":{
      "name":"\u041a\u043e\u043f\u044b\u043b\u043e\u0432\u0430",
      "longitude":106.080818,
      "latitude":53.360798
    },
    "11080":{
      "name":"\u0411\u0430\u0433\u0430\u043d\u0442\u0430",
      "longitude":106.093864,
      "latitude":53.097713
    },
    "11081":{
      "name":"\u0425\u043e\u043c\u043e\u043a\u0430\u0448\u0435\u0432\u043e",
      "longitude":106.1,
      "latitude":60.316667
    },
    "11082":{
      "name":"\u0428\u0435\u0438\u043d\u0430",
      "longitude":106.128227,
      "latitude":54.090252
    },
    "11083":{
      "name":"\u041a\u0443\u044f\u0434\u0430",
      "longitude":106.130318,
      "latitude":52.558411
    },
    "11084":{
      "name":"\u0429\u0430\u043f\u043e\u0432\u0430",
      "longitude":106.139915,
      "latitude":53.990536
    },
    "11085":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u041a\u043e\u0441\u043e\u0433\u043e\u043b",
      "longitude":106.154503,
      "latitude":53.84235
    },
    "11086":{
      "name":"\u0420\u044b\u043a\u043e\u0432\u0430",
      "longitude":106.176842,
      "latitude":53.972485
    },
    "11087":{
      "name":"\u041a\u043e\u0440\u0441\u0443\u043a\u043e\u0432\u0430",
      "longitude":106.213089,
      "latitude":53.745628
    },
    "11088":{
      "name":"\u0422\u0430\u043b\u043e\u0432\u043a\u0430",
      "longitude":106.225426,
      "latitude":52.676414
    },
    "11089":{
      "name":"\u042e\u0448\u0438\u043d\u0430",
      "longitude":106.231598,
      "latitude":53.877907
    },
    "11090":{
      "name":"\u0425\u043e\u043c\u043e\u043a\u0430\u0448\u0435\u0432\u043e",
      "longitude":106.2499999,
      "latitude":60.5
    },
    "11091":{
      "name":"\u041e\u043c\u043e\u043b\u043e\u0439",
      "longitude":106.269035,
      "latitude":56.463757
    },
    "11092":{
      "name":"\u041c\u0430\u043a\u0440\u0443\u0448\u0438\u043d\u0430",
      "longitude":106.281792,
      "latitude":53.87986
    },
    "11093":{
      "name":"\u0427\u0435\u043c\u044f\u043a\u0438\u043d\u0430",
      "longitude":106.287842,
      "latitude":53.857151
    },
    "11094":{
      "name":"\u0410\u0446\u0438\u043a\u044f\u043a",
      "longitude":106.306778,
      "latitude":54.187958
    },
    "11095":{
      "name":"\u041f\u043e\u043f\u043e\u0432\u0430",
      "longitude":106.30864,
      "latitude":52.742584
    },
    "11096":{
      "name":"\u041a\u0443\u043a\u0443\u0439",
      "longitude":106.31205,
      "latitude":53.870716
    },
    "11097":{
      "name":"\u0422\u0430\u0440\u0430\u0439",
      "longitude":106.315292,
      "latitude":54.019707
    },
    "11098":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u0432\u0430",
      "longitude":106.318718,
      "latitude":52.756321
    },
    "11099":{
      "name":"\u0422\u044b\u0440\u0433\u0430\u043d",
      "longitude":106.341606,
      "latitude":52.758919
    },
    "11100":{
      "name":"\u0418\u043a\u0430",
      "longitude":106.346397,
      "latitude":59.310707
    },
    "11101":{
      "name":"\u0411\u0443\u0440\u0435\u0434\u0430\u0439",
      "longitude":106.359543,
      "latitude":54.171753
    },
    "11102":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u0422\u0430\u0440\u0435\u043b\u044c",
      "longitude":106.364998,
      "latitude":53.836967
    },
    "11103":{
      "name":"\u041f\u043e\u0434\u043a\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":106.365067,
      "latitude":53.849751
    },
    "11104":{
      "name":"\u041d\u0430\u0440\u0438\u043d-\u041a\u0443\u043d\u0442\u0430",
      "longitude":106.377373,
      "latitude":52.760536
    },
    "11105":{
      "name":"\u0411\u043e\u043b\u043e\u0442\u043e",
      "longitude":106.397453,
      "latitude":53.91671
    },
    "11106":{
      "name":"\u041c\u044b\u0441",
      "longitude":106.398819,
      "latitude":54.021576
    },
    "11107":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u0423\u043b\u0443\u043d",
      "longitude":106.417358,
      "latitude":54.208332
    },
    "11108":{
      "name":"\u0414\u0443\u0440\u0443\u0442\u0443\u0439",
      "longitude":106.427864,
      "latitude":54.030964
    },
    "11109":{
      "name":"\u0411\u043e\u0440\u0441\u043e\u0439",
      "longitude":106.452034,
      "latitude":52.831348
    },
    "11110":{
      "name":"\u0417\u0430\u0433\u0443\u043b\u0430\u043d",
      "longitude":106.457481,
      "latitude":54.06913
    },
    "11111":{
      "name":"\u0425\u0443\u0440\u0430\u0439-\u041d\u0443\u0440",
      "longitude":106.46637,
      "latitude":52.809517
    },
    "11112":{
      "name":"\u041c\u0443\u0445\u043e\u0440-\u0411\u0443\u043b\u044b\u043a",
      "longitude":106.468399,
      "latitude":52.854527
    },
    "11113":{
      "name":"\u041a\u0443\u0437\u043d\u0435\u0446\u044b",
      "longitude":106.468788,
      "latitude":54.049866
    },
    "11114":{
      "name":"\u0425\u0430\u043b\u0445\u0430-\u0423\u0437\u0443\u0440",
      "longitude":106.486176,
      "latitude":52.860077
    },
    "11115":{
      "name":"\u0425\u0430\u0440\u0445\u0430\u0442\u0430\u0439",
      "longitude":106.496681,
      "latitude":52.871494
    },
    "11116":{
      "name":"\u0422\u043e\u043d\u0442\u0430",
      "longitude":106.502785,
      "latitude":52.880096
    },
    "11117":{
      "name":"\u042f\u043b\u0433\u0430-\u0423\u0437\u0443\u0440",
      "longitude":106.509369,
      "latitude":52.800365
    },
    "11118":{
      "name":"\u0411\u0443\u0442\u0443\u0445\u0435\u0439",
      "longitude":106.512222,
      "latitude":52.89732
    },
    "11119":{
      "name":"\u0422\u0430\u044e\u0440\u0430",
      "longitude":106.548279,
      "latitude":57.001175
    },
    "11120":{
      "name":"\u042e\u0445\u0442\u0430",
      "longitude":106.6046764,
      "latitude":54.2844065
    },
    "11121":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u0451\u043b\u043e\u0432\u0430",
      "longitude":106.630432,
      "latitude":57.007923
    },
    "11122":{
      "name":"\u041a\u0443\u0447\u0443\u043b\u0433\u0430",
      "longitude":106.673454,
      "latitude":52.983562
    },
    "11123":{
      "name":"\u0422\u0435\u0442\u0435\u044f",
      "longitude":106.702499,
      "latitude":60.98027
    },
    "11124":{
      "name":"\u0423\u043b\u0430\u043d-\u041d\u0443\u0440",
      "longitude":106.720009,
      "latitude":52.870754
    },
    "11125":{
      "name":"\u0428\u0438\u0434\u0430",
      "longitude":106.780098,
      "latitude":53.057846
    },
    "11126":{
      "name":"\u0428\u0435\u0432\u044b\u043a\u0430\u043d",
      "longitude":106.790451,
      "latitude":54.350842
    },
    "11127":{
      "name":"\u041a\u0443\u0440\u043a\u0443\u0442",
      "longitude":106.827408,
      "latitude":53.027637
    },
    "11128":{
      "name":"\u0421\u0430\u0440\u043c\u0430",
      "longitude":106.834381,
      "latitude":53.101704
    },
    "11129":{
      "name":"\u0421\u0430\u0445\u044e\u0440\u0442\u0430",
      "longitude":106.883255,
      "latitude":53.017082
    },
    "11130":{
      "name":"\u041d\u0430\u0437\u0430\u0440\u043e\u0432\u043e",
      "longitude":106.904518,
      "latitude":57.173164
    },
    "11131":{
      "name":"\u041a\u0443\u0440\u043c\u0430",
      "longitude":106.965897,
      "latitude":53.179916
    },
    "11132":{
      "name":"\u0427\u0430\u043d\u0447\u0443\u0440",
      "longitude":106.990303,
      "latitude":53.825939
    },
    "11133":{
      "name":"\u0411\u0443\u0440",
      "longitude":106.993828,
      "latitude":58.812283
    },
    "11134":{
      "name":"\u041c\u0430\u0440\u043a\u043e\u0432\u043e",
      "longitude":107.056519,
      "latitude":57.328968
    },
    "11135":{
      "name":"\u0413\u043b\u0443\u0445\u043e\u0432\u0430",
      "longitude":107.09021,
      "latitude":57.324921
    },
    "11136":{
      "name":"\u0412\u0435\u0440\u0448\u0438\u043d\u0430 \u0425\u0430\u043d\u0434\u044b",
      "longitude":107.119263,
      "latitude":55.927639
    },
    "11137":{
      "name":"\u0422\u044b\u0440\u043a\u0430",
      "longitude":107.137001,
      "latitude":54.508305
    },
    "11138":{
      "name":"\u042f\u043b\u0433\u0430",
      "longitude":107.185242,
      "latitude":53.138893
    },
    "11139":{
      "name":"\u0422\u0438\u0440\u0430",
      "longitude":107.220734,
      "latitude":57.27446
    },
    "11140":{
      "name":"\u0422\u043e\u043a\u0438\u044f",
      "longitude":107.2327155,
      "latitude":62.2124975
    },
    "11141":{
      "name":"\u0427\u0438\u043d\u043e\u043d\u0433\u0430",
      "longitude":107.28389,
      "latitude":54.618156
    },
    "11142":{
      "name":"\u041c\u0430\u043b\u044b\u0439 \u0425\u0443\u0436\u0438\u0440",
      "longitude":107.287125,
      "latitude":53.1772
    },
    "11143":{
      "name":"\u0423\u043b\u044c\u043a\u0430\u043d",
      "longitude":107.3222623,
      "latitude":57.2430164
    },
    "11144":{
      "name":"\u0425\u0430\u0440\u0430\u043d\u0446\u044b",
      "longitude":107.419411,
      "latitude":53.221867
    },
    "11145":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u044f\u0440\u043e\u0432\u043e",
      "longitude":107.455292,
      "latitude":57.337029
    },
    "11146":{
      "name":"\u041c\u043e\u0441\u0442\u043e\u0432\u0430\u044f",
      "longitude":107.478279,
      "latitude":56.219849
    },
    "11147":{
      "name":"\u0421\u0435\u0434\u0430\u043d\u043a\u0438\u043d\u0430",
      "longitude":107.481339,
      "latitude":56.18483
    },
    "11148":{
      "name":"\u0417\u0430\u043c\u0430",
      "longitude":107.509056,
      "latitude":53.461468
    },
    "11149":{
      "name":"\u0423\u043b\u0430\u043d-\u0425\u0443\u0448\u0438\u043d",
      "longitude":107.5276885,
      "latitude":53.2554932
    },
    "11150":{
      "name":"\u041f\u0435\u0441\u0447\u0430\u043d\u0430\u044f",
      "longitude":107.589195,
      "latitude":53.287479
    },
    "11151":{
      "name":"\u0418\u043d\u0430\u0440\u0438\u0433\u0434\u0430",
      "longitude":107.646202,
      "latitude":63.1777
    },
    "11152":{
      "name":"\u0420\u044b\u0431\u043d\u044b\u0439 \u0423\u044f\u043d",
      "longitude":107.6900151,
      "latitude":54.785925
    },
    "11153":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u0435\u043b\u043e\u0432\u043e",
      "longitude":107.699066,
      "latitude":56.057766
    },
    "11154":{
      "name":"\u041a\u043e\u043d\u0435\u0446 \u041b\u0443\u0433",
      "longitude":107.7090944,
      "latitude":56.0212521
    },
    "11155":{
      "name":"\u0423\u0441\u044b\u043a",
      "longitude":107.718498,
      "latitude":53.349152
    },
    "11156":{
      "name":"\u041e\u0441\u0438\u043d\u043e\u0432\u043e",
      "longitude":107.725342,
      "latitude":56.442142
    },
    "11157":{
      "name":"\u0412\u0435\u0440\u0445\u043e\u043b\u0443\u0433\u0441\u043a",
      "longitude":107.730927,
      "latitude":57.461403
    },
    "11158":{
      "name":"\u0423\u0437\u0443\u0440\u044b",
      "longitude":107.740532,
      "latitude":53.322834
    },
    "11159":{
      "name":"\u0415\u0440\u0435\u043c\u0430",
      "longitude":107.763794,
      "latitude":60.366081
    },
    "11160":{
      "name":"\u042e\u0445\u0442\u0430",
      "longitude":107.772171,
      "latitude":55.896793
    },
    "11161":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0435\u043a\u0430\u0440\u0435\u043b\u0438\u043d\u0430",
      "longitude":107.779236,
      "latitude":57.870625
    },
    "11162":{
      "name":"\u041a\u043e\u0447\u0435\u0440\u0438\u043a\u043e\u0432\u0430",
      "longitude":107.780983,
      "latitude":53.743221
    },
    "11163":{
      "name":"\u0411\u0430\u043b\u044b\u0448\u0435\u0432\u0430",
      "longitude":107.796463,
      "latitude":57.483444
    },
    "11164":{
      "name":"\u0415\u0440\u043c\u0430\u043a\u0438",
      "longitude":107.818321,
      "latitude":56.625477
    },
    "11165":{
      "name":"\u0422\u0430\u0440\u0430\u0441\u043e\u0432\u043e",
      "longitude":107.819107,
      "latitude":55.860291
    },
    "11166":{
      "name":"\u041a\u0430\u0440\u043d\u0430\u0443\u0445\u043e\u0432\u0430",
      "longitude":107.831971,
      "latitude":56.4798001
    },
    "11167":{
      "name":"\u0417\u0430\u0431\u043e\u0440\u044c\u0435",
      "longitude":107.8507648,
      "latitude":57.5946476
    },
    "11168":{
      "name":"\u0421\u043a\u043e\u0431\u0435\u043b\u044c\u0441\u043a\u0430\u044f",
      "longitude":107.882492,
      "latitude":57.511627
    },
    "11169":{
      "name":"\u041f\u0430\u0448\u043d\u044f",
      "longitude":107.8923108,
      "latitude":57.5586354
    },
    "11170":{
      "name":"\u041a\u043e\u0440\u043e\u0442\u043a\u043e\u0432\u043e",
      "longitude":107.907349,
      "latitude":56.697445
    },
    "11171":{
      "name":"\u041f\u043e\u043f\u0435\u0440\u0435\u0447\u043d\u0430\u044f",
      "longitude":107.934486,
      "latitude":56.728104
    },
    "11172":{
      "name":"\u0423\u0441\u0442\u044c-\u041a\u0438\u0440\u0435\u043d\u0433\u0430",
      "longitude":107.971619,
      "latitude":57.41296
    },
    "11173":{
      "name":"\u041e\u0441\u044c\u043a\u0438\u043d\u043e",
      "longitude":107.984222,
      "latitude":60.810665
    },
    "11174":{
      "name":"\u0411\u043e\u0440",
      "longitude":108.021622,
      "latitude":57.735802
    },
    "11175":{
      "name":"\u0421\u0442\u0430\u0440\u0430\u044f \u0414\u0435\u0440\u0435\u0432\u043d\u044f",
      "longitude":108.021996,
      "latitude":57.729488
    },
    "11176":{
      "name":"\u0425\u0430\u0431\u0430\u0440\u043e\u0432\u0430",
      "longitude":108.038155,
      "latitude":57.770603
    },
    "11177":{
      "name":"\u041a\u043e\u043c\u043c\u0443\u043d\u0430",
      "longitude":108.041461,
      "latitude":57.7377395
    },
    "11178":{
      "name":"\u041c\u043e\u0433\u0430",
      "longitude":108.042503,
      "latitude":60.103386
    },
    "11179":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0435-\u041a\u0430\u043b\u0438\u043d\u0438\u043d\u0430",
      "longitude":108.11927,
      "latitude":59.896675
    },
    "11180":{
      "name":"\u0421\u0438\u0434\u043e\u0440\u043e\u0432\u0430",
      "longitude":108.130196,
      "latitude":57.761753
    },
    "11181":{
      "name":"\u041d\u0438\u0436\u043d\u0435\u043c\u0430\u0440\u0442\u044b\u043d\u043e\u0432\u043e",
      "longitude":108.1761646,
      "latitude":56.9206256
    },
    "11182":{
      "name":"\u0425\u0430\u043c\u0430\u043a\u0430\u0440",
      "longitude":108.181274,
      "latitude":61.991501
    },
    "11183":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u044c\u0441\u043a",
      "longitude":108.190254,
      "latitude":57.766136
    },
    "11184":{
      "name":"\u041a\u0443\u0442\u0438\u043c\u0430",
      "longitude":108.233528,
      "latitude":57.163082
    },
    "11185":{
      "name":"\u0417\u043c\u0435\u0438\u043d\u043e\u0432\u043e",
      "longitude":108.307373,
      "latitude":57.778202
    },
    "11186":{
      "name":"\u0421\u043e\u0441\u043d\u0438\u043d\u043e",
      "longitude":108.366667,
      "latitude":58.783333
    },
    "11187":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":108.3823587,
      "latitude":57.8552158
    },
    "11188":{
      "name":"\u0412\u043e\u0440\u043e\u043d\u0435\u0436\u0441\u043a\u0438\u0439",
      "longitude":108.395889,
      "latitude":57.866863
    },
    "11189":{
      "name":"\u041d\u0430\u043a\u0430\u043d\u043d\u043e",
      "longitude":108.452057,
      "latitude":62.9007
    },
    "11190":{
      "name":"\u0421\u0430\u043b\u0442\u044b\u043a\u043e\u0432\u0430",
      "longitude":108.47908,
      "latitude":57.946499
    },
    "11191":{
      "name":"\u041f\u043e\u0434\u044a\u0435\u043b\u044c\u043d\u0438\u043a",
      "longitude":108.554375,
      "latitude":57.989712
    },
    "11192":{
      "name":"\u041d\u0438\u043a\u0443\u043b\u0438\u043d\u0430",
      "longitude":108.594398,
      "latitude":57.988884
    },
    "11193":{
      "name":"\u0411\u0430\u043d\u0449\u0438\u043a\u043e\u0432\u043e",
      "longitude":108.620132,
      "latitude":58.021782
    },
    "11194":{
      "name":"\u0427\u0435\u0447\u0443\u0439\u0441\u043a",
      "longitude":108.708015,
      "latitude":58.0728
    },
    "11195":{
      "name":"\u0412\u0438\u0448\u043d\u044f\u043a\u043e\u0432\u0430",
      "longitude":108.860237,
      "latitude":58.133228
    },
    "11196":{
      "name":"\u041e\u0440\u043b\u043e\u0432\u0430",
      "longitude":109.105042,
      "latitude":58.279102
    },
    "11197":{
      "name":"\u0421\u043f\u043e\u043b\u043e\u0448\u0438\u043d\u043e",
      "longitude":109.114922,
      "latitude":58.260986
    },
    "11198":{
      "name":"\u0417\u043e\u043b\u043e\u0442\u043e\u0439",
      "longitude":109.236778,
      "latitude":58.225655
    },
    "11199":{
      "name":"\u0428\u0435\u043d\u0430\u0440\u0430",
      "longitude":109.3,
      "latitude":59.716667
    },
    "11200":{
      "name":"\u0418\u043d\u0435\u043b\u0430",
      "longitude":109.3333329,
      "latitude":59.883333
    },
    "11201":{
      "name":"\u041a\u043e\u0440\u0435\u043a",
      "longitude":109.3579019,
      "latitude":60.27471
    },
    "11202":{
      "name":"\u041a\u043e\u043d\u0434\u0440\u0430\u0442\u044c\u0435\u0432\u0430",
      "longitude":109.433333,
      "latitude":61.883333
    },
    "11203":{
      "name":"\u041c\u0438\u0440\u043e\u043d\u043e\u0432\u043e",
      "longitude":109.641029,
      "latitude":58.301914
    },
    "11204":{
      "name":"\u0414\u0430\u0440\u044c\u0438\u043d\u0430",
      "longitude":109.657852,
      "latitude":58.316414
    },
    "11205":{
      "name":"\u041c\u0430\u0440\u0445\u0430\u044f",
      "longitude":109.683333,
      "latitude":61.983333
    },
    "11206":{
      "name":"\u0418\u0447\u0435\u0440\u0430",
      "longitude":109.775314,
      "latitude":58.511806
    },
    "11207":{
      "name":"\u041c\u0443\u0442\u0438\u043d\u0430",
      "longitude":110.034752,
      "latitude":58.627182
    },
    "11208":{
      "name":"\u0427\u0430\u0441\u0442\u044b\u0445",
      "longitude":110.8509901,
      "latitude":58.6404921
    },
    "11209":{
      "name":"\u0427\u0430\u0439\u043a\u0430",
      "longitude":111.4818857,
      "latitude":59.0001456
    },
    "11210":{
      "name":"\u0421\u0430\u0434\u043a\u0438",
      "longitude":111.952187,
      "latitude":59.200512
    },
    "11211":{
      "name":"\u0427\u0443\u044f",
      "longitude":112.427834,
      "latitude":59.266373
    },
    "11212":{
      "name":"\u0421\u043b\u044e\u0434\u044f\u043d\u043a\u0430",
      "longitude":112.770447,
      "latitude":57.971142
    },
    "11213":{
      "name":"\u0417\u0430\u0440\u044f",
      "longitude":112.928894,
      "latitude":58.298077
    },
    "11214":{
      "name":"\u0412\u043e\u0440\u043e\u043d\u0446\u043e\u0432\u043a\u0430",
      "longitude":112.954536,
      "latitude":58.722614
    },
    "11215":{
      "name":"\u0422\u0435\u0442\u0435\u0440\u0438\u043d\u0441\u043a",
      "longitude":112.966072,
      "latitude":58.287895
    },
    "11216":{
      "name":"\u041a\u043e\u043b\u043e\u0442\u043e\u0432\u043a\u0430",
      "longitude":113.201347,
      "latitude":58.215435
    },
    "11217":{
      "name":"\u041c\u0443\u0441\u043a\u043e\u0432\u0438\u0442",
      "longitude":113.287155,
      "latitude":58.213455
    },
    "11218":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u0421\u0435\u0432\u0435\u0440\u043d\u044b\u0439",
      "longitude":113.36628,
      "latitude":58.193153
    },
    "11219":{
      "name":"\u041a\u044f\u0445\u0442\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":114.235512,
      "latitude":57.944382
    },
    "11220":{
      "name":"\u0412\u0430\u0441\u0438\u043b\u044c\u0435\u0432\u0441\u043a\u0438\u0439",
      "longitude":114.331573,
      "latitude":58.14225
    },
    "11221":{
      "name":"\u0410\u043f\u0440\u0435\u043b\u044c\u0441\u043a",
      "longitude":114.587051,
      "latitude":58.18882
    },
    "11222":{
      "name":"\u0410\u043d\u0434\u0440\u0435\u0435\u0432\u0441\u043a\u0438\u0439",
      "longitude":114.8333329,
      "latitude":59.483333
    },
    "11223":{
      "name":"\u041d\u0435\u0440\u043f\u043e",
      "longitude":115.318947,
      "latitude":57.473873
    },
    "11224":{
      "name":"\u0427\u0435\u0440\u0432\u043e\u043d\u043d\u044b\u0439",
      "longitude":115.683333,
      "latitude":59.616667
    },
    "11225":{
      "name":"\u0421\u0432\u0435\u0442\u043b\u044b\u0439",
      "longitude":115.9658186,
      "latitude":58.4370311
    },
    "11226":{
      "name":"\u041c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":116.133333,
      "latitude":59.616667
    },
    "11227":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u043a\u0430",
      "longitude":116.1499999,
      "latitude":57.766667
    },
    "11228":{
      "name":"\u0421\u0442\u0430\u0440\u0430\u044f \u0411\u0435\u0440\u0451\u0437\u043e\u0432\u0441\u043a\u0430\u044f",
      "longitude":116.2,
      "latitude":57.733333
    },
    "11229":{
      "name":"\u041e\u0440\u043e\u043d",
      "longitude":116.4505559,
      "latitude":57.189722
    },
    "11230":{
      "name":"\u0421\u0438\u0441\u043a\u043e\u0432\u043e",
      "longitude":116.466667,
      "latitude":57.416667
    },
    "11231":{
      "name":"\u0411\u0430\u0437\u043d\u044b\u0439",
      "longitude":116.616667,
      "latitude":57.416667
    },
    "11232":{
      "name":"\u041f\u0430\u0442\u043e\u043c",
      "longitude":116.897797,
      "latitude":60.07719
    },
    "11233":{
      "name":"Molvo",
      "longitude":116.9816494,
      "latitude":59.2391075
    },
    "11234":{
      "name":"\u0412\u043e\u0441\u043a\u0440\u0435\u0441\u0435\u043d\u0441\u043a\u0438\u0439",
      "longitude":117.2,
      "latitude":59.45
    },
    "11235":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u0432\u043a\u0430",
      "longitude":78.0570508,
      "latitude":53.3637627
    },
    "11236":{
      "name":"\u0411\u0438\u0433\u0435\u043b\u044c\u0434\u044b",
      "longitude":78.136777,
      "latitude":53.4581837
    },
    "11237":{
      "name":"\u0427\u0435\u0440\u043d\u0430\u0432\u043a\u0430",
      "longitude":78.1572238,
      "latitude":53.1725792
    },
    "11238":{
      "name":"\u041c\u0438\u0440\u043d\u044b\u0439",
      "longitude":78.2312924,
      "latitude":53.4168367
    },
    "11239":{
      "name":"\u0426\u0432\u0435\u0442\u043e\u043f\u043e\u043b\u044c",
      "longitude":78.2433435,
      "latitude":53.1970587
    },
    "11240":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u043c\u0430\u0439\u0441\u043a\u043e\u0435",
      "longitude":78.2517899,
      "latitude":53.3551118
    },
    "11241":{
      "name":"\u041a\u0438\u043d\u0435\u0440\u0430\u043b",
      "longitude":78.2805793,
      "latitude":53.4586068
    },
    "11242":{
      "name":"\u041f\u0430\u0432\u043b\u043e\u0432\u043a\u0430",
      "longitude":78.389185,
      "latitude":52.9403033
    },
    "11243":{
      "name":"\u0420\u0430\u0439\u0433\u043e\u0440\u043e\u0434",
      "longitude":78.4042514,
      "latitude":52.8630395
    },
    "11244":{
      "name":"\u0410\u0441\u044f\u043c\u043e\u0432\u043a\u0430",
      "longitude":78.4714955,
      "latitude":53.2670918
    },
    "11245":{
      "name":"\u0410\u0439\u043d\u0430\u043a",
      "longitude":78.475436,
      "latitude":53.1823828
    },
    "11246":{
      "name":"\u0415\u043a\u0430\u0442\u0435\u0440\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":78.4967319,
      "latitude":52.8550208
    },
    "11247":{
      "name":"\u0411\u0443\u0440\u043b\u0438\u043d\u043a\u0430",
      "longitude":78.4967794,
      "latitude":53.1960626
    },
    "11248":{
      "name":"\u0411\u0430\u043b\u043b\u0430\u0441\u0442\u043d\u044b\u0439 \u041a\u0430\u0440\u044c\u0435\u0440",
      "longitude":78.5165054,
      "latitude":53.1308048
    },
    "11249":{
      "name":"\u041d\u043e\u0432\u043e\u0430\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":78.5800569,
      "latitude":53.3870859
    },
    "11250":{
      "name":"\u041e\u0440\u043b\u043e\u0432\u043a\u0430",
      "longitude":78.5958464,
      "latitude":52.6128065
    },
    "11251":{
      "name":"\u041d\u043e\u0432\u043e\u0437\u043d\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":78.6261097,
      "latitude":52.575891
    },
    "11252":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u043f\u0435\u0441\u0447\u0430\u043d\u043e\u0435",
      "longitude":78.6413084,
      "latitude":53.4033861
    },
    "11253":{
      "name":"\u0420\u043e\u0436\u043a\u043e\u0432\u043a\u0430",
      "longitude":78.6820969,
      "latitude":53.4660047
    },
    "11254":{
      "name":"\u041a\u0443\u0430\u0442\u043e\u0432\u043a\u0430",
      "longitude":78.6947544,
      "latitude":52.8768795
    },
    "11255":{
      "name":"\u041d\u043e\u0432\u043e\u043f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":78.7081023,
      "latitude":52.482224
    },
    "11256":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u0438\u0435\u0432\u043a\u0430",
      "longitude":78.7190119,
      "latitude":52.7348373
    },
    "11257":{
      "name":"\u041f\u043e\u043f\u0430\u0441\u043d\u043e\u0435",
      "longitude":78.7202105,
      "latitude":52.4677542
    },
    "11258":{
      "name":"\u0422\u0440\u043e\u0438\u0446\u043a",
      "longitude":78.7734836,
      "latitude":52.6205636
    },
    "11259":{
      "name":"\u041c\u0430\u043a\u0441\u0438\u043c\u043e\u0432\u043a\u0430",
      "longitude":78.7741396,
      "latitude":53.089848
    },
    "11260":{
      "name":"\u0410\u043d\u0434\u0440\u0435\u0435\u0432\u043a\u0430",
      "longitude":78.7776569,
      "latitude":53.1023179
    },
    "11261":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u043e\u0432\u0445\u043e\u0437\u043d\u044b\u0439",
      "longitude":78.8389206,
      "latitude":52.6689723
    },
    "11262":{
      "name":"\u042d\u0441\u0442\u043b\u0430\u043d\u044c",
      "longitude":78.84166,
      "latitude":52.519375
    },
    "11263":{
      "name":"\u0412\u043e\u043b\u0447\u0438\u0439 \u0420\u0430\u043a\u0438\u0442",
      "longitude":78.8442146,
      "latitude":53.3748786
    },
    "11264":{
      "name":"\u042f\u043c\u0431\u043e\u0440",
      "longitude":78.8678981,
      "latitude":52.7365748
    },
    "11265":{
      "name":"\u041a\u0430\u043d\u043d\u0430",
      "longitude":78.873352,
      "latitude":52.893448
    },
    "11266":{
      "name":"\u0412\u0435\u0441\u0451\u043b\u043e\u0435",
      "longitude":78.8796659,
      "latitude":53.0551909
    },
    "11267":{
      "name":"\u0412\u043e\u0441\u043a\u0440\u0435\u0441\u0435\u043d\u043e\u0432\u043a\u0430",
      "longitude":78.8824697,
      "latitude":52.4277281
    },
    "11268":{
      "name":"\u041a\u0440\u043e\u0442\u043e\u0432\u043a\u0430",
      "longitude":78.9007476,
      "latitude":52.5828195
    },
    "11269":{
      "name":"\u041a\u0438\u0440\u0438\u043b\u043b\u043e\u0432\u043a\u0430",
      "longitude":78.9137399,
      "latitude":53.4664315
    },
    "11270":{
      "name":"\u041a\u0430\u0440\u043f\u0438\u043b\u043e\u0432\u043a\u0430",
      "longitude":78.970642,
      "latitude":52.911505
    },
    "11271":{
      "name":"\u0413\u043e\u0440\u043e\u0434\u0435\u0446\u043a\u0438\u0439",
      "longitude":78.9792245,
      "latitude":52.707901
    },
    "11272":{
      "name":"\u041c\u0438\u0440\u043d\u044b\u0439",
      "longitude":79.0520621,
      "latitude":52.4708681
    },
    "11273":{
      "name":"\u0413\u0435\u043e\u0440\u0433\u0438\u0435\u0432\u043a\u0430",
      "longitude":79.0563863,
      "latitude":53.0106599
    },
    "11274":{
      "name":"\u041f\u043b\u0430\u0442\u043e\u0432\u043a\u0430",
      "longitude":79.0571805,
      "latitude":52.3523643
    },
    "11275":{
      "name":"\u0412\u043b\u0430\u0434\u0438\u043c\u0438\u0440\u043e\u0432\u043a\u0430",
      "longitude":79.0774291,
      "latitude":53.0962003
    },
    "11276":{
      "name":"\u041a\u0438\u0440\u0435\u0439",
      "longitude":79.0827203,
      "latitude":52.5178009
    },
    "11277":{
      "name":"\u0415\u0440\u043c\u0430\u043a\u043e\u0432\u043a\u0430",
      "longitude":79.0953807,
      "latitude":52.8368498
    },
    "11278":{
      "name":"\u0417\u0435\u043b\u0451\u043d\u0430\u044f \u0420\u043e\u0449\u0430",
      "longitude":79.1120272,
      "latitude":53.1865776
    },
    "11279":{
      "name":"\u041a\u0438\u043b\u044c\u0442\u044b",
      "longitude":79.124396,
      "latitude":52.6163967
    },
    "11280":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":79.126602,
      "latitude":52.948376
    },
    "11281":{
      "name":"\u041b\u0435\u0441\u043d\u043e\u0435",
      "longitude":79.143639,
      "latitude":53.351631
    },
    "11282":{
      "name":"\u041d\u043e\u0432\u043e\u0440\u043e\u0441\u0441\u0438\u0439\u043a\u0430",
      "longitude":79.1562464,
      "latitude":52.7862928
    },
    "11283":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":79.167542,
      "latitude":53.307957
    },
    "11284":{
      "name":"\u0411\u043e\u0441\u043b\u0430\u0432\u0438\u043d\u043e",
      "longitude":79.190598,
      "latitude":52.844044
    },
    "11285":{
      "name":"\u041d\u043e\u0432\u043e\u0432\u043e\u0437\u043d\u0435\u0441\u0435\u043d\u043a\u0430",
      "longitude":79.1960888,
      "latitude":52.1918075
    },
    "11286":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u0430\u0440\u043c\u0435\u0439\u0441\u043a\u0438\u0439",
      "longitude":79.21891,
      "latitude":53.245193
    },
    "11287":{
      "name":"\u041d\u0435\u0432\u043e\u0434\u043d\u043e\u0435",
      "longitude":79.2306141,
      "latitude":51.9590185
    },
    "11288":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u0430\u044f \u0421\u043b\u043e\u0431\u043e\u0434\u0430",
      "longitude":79.2337262,
      "latitude":52.6778582
    },
    "11289":{
      "name":"24 \u043a\u043c",
      "longitude":79.2484088,
      "latitude":52.6491793
    },
    "11290":{
      "name":"\u0411\u0435\u043b\u043e\u0446\u0435\u0440\u043a\u043e\u0432\u043a\u0430",
      "longitude":79.2495212,
      "latitude":52.7275762
    },
    "11291":{
      "name":"\u0414\u0430\u043d\u0438\u043b\u043e\u0432\u043a\u0430",
      "longitude":79.2817903,
      "latitude":53.1320603
    },
    "11292":{
      "name":"\u0414\u0432\u043e\u0440\u0441\u043a\u043e\u0435",
      "longitude":79.29641,
      "latitude":53.29903
    },
    "11293":{
      "name":"\u0421\u0435\u0440\u0433\u0435\u0435\u0432\u043a\u0430",
      "longitude":79.3141418,
      "latitude":52.6526342
    },
    "11294":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u0432\u043a\u0430",
      "longitude":79.3348483,
      "latitude":52.4578841
    },
    "11295":{
      "name":"\u041e\u0437\u0451\u0440\u043d\u043e\u0435",
      "longitude":79.3385503,
      "latitude":52.5148592
    },
    "11296":{
      "name":"\u0418\u0440\u043a\u0443\u0442\u0441\u043a\u0438\u0439",
      "longitude":79.3710331,
      "latitude":51.9514015
    },
    "11297":{
      "name":"\u041c\u0430\u043a\u0430\u0440\u043e\u0432\u043a\u0430",
      "longitude":79.420067,
      "latitude":52.293591
    },
    "11298":{
      "name":"\u0412\u043e\u0441\u0445\u043e\u0434",
      "longitude":79.4607255,
      "latitude":53.5244066
    },
    "11299":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":79.472383,
      "latitude":53.6220348
    },
    "11300":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":79.4739643,
      "latitude":51.9429891
    },
    "11301":{
      "name":"\u0414\u043e\u0431\u0440\u043e\u0432\u043a\u0430",
      "longitude":79.5189762,
      "latitude":53.3079568
    },
    "11302":{
      "name":"\u042f\u0433\u043e\u0442\u0438\u043d\u0441\u043a\u0430\u044f",
      "longitude":79.523993,
      "latitude":52.7250925
    },
    "11303":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u043a\u0430",
      "longitude":79.538605,
      "latitude":53.474827
    },
    "11304":{
      "name":"\u0421\u043b\u0430\u0432\u0430",
      "longitude":79.5658392,
      "latitude":52.385656
    },
    "11305":{
      "name":"\u0417\u0430\u043f\u0430\u0434\u043d\u044b\u0439 \u0423\u0433\u043e\u043b",
      "longitude":79.57146,
      "latitude":52.1305022
    },
    "11306":{
      "name":"\u041f\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":79.5998457,
      "latitude":53.2634059
    },
    "11307":{
      "name":"\u0415\u043a\u0430\u0442\u0435\u0440\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":79.610916,
      "latitude":52.567303
    },
    "11308":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u042f\u0440",
      "longitude":79.6116002,
      "latitude":52.4635686
    },
    "11309":{
      "name":"\u041a\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":79.6463319,
      "latitude":53.7035417
    },
    "11310":{
      "name":"\u0425\u0430\u0431\u0430\u0440\u044b",
      "longitude":79.678224,
      "latitude":53.7636479
    },
    "11311":{
      "name":"\u0411\u0430\u0439\u0433\u0430\u043c\u0443\u0442",
      "longitude":79.7008503,
      "latitude":52.6414194
    },
    "11312":{
      "name":"\u041c\u043e\u0441\u043a\u043e\u0432\u043a\u0430",
      "longitude":79.7867613,
      "latitude":53.4329183
    },
    "11313":{
      "name":"\u0426\u0438\u0431\u0435\u0440\u043c\u0430\u043d\u043e\u0432\u043e",
      "longitude":79.8152935,
      "latitude":53.3024217
    },
    "11314":{
      "name":"\u0421\u0438\u0431\u0438\u0440\u0441\u043a\u0438\u0439 \u0413\u0438\u0433\u0430\u043d\u0442",
      "longitude":79.8290105,
      "latitude":53.2371841
    },
    "11315":{
      "name":"\u0422\u0430\u043b\u044b",
      "longitude":82.0286938,
      "latitude":52.3081458
    },
    "11316":{
      "name":"\u0411\u043e\u0440-\u041a\u043e\u0441\u043e\u0431\u0443\u043b\u0430\u0442",
      "longitude":79.8293048,
      "latitude":51.4142744
    },
    "11317":{
      "name":"\u0422\u0438\u0437\u0435\u043a",
      "longitude":79.8465219,
      "latitude":52.5918641
    },
    "11318":{
      "name":"\u0423\u0440\u044b\u0432\u0430\u0435\u0432\u043e",
      "longitude":79.8563404,
      "latitude":53.7634213
    },
    "11319":{
      "name":"\u0417\u0430\u0440\u044f",
      "longitude":79.8904867,
      "latitude":53.7630729
    },
    "11320":{
      "name":"\u0412\u043e\u0441\u0442\u043e\u0447\u043d\u044b\u0439",
      "longitude":79.9205391,
      "latitude":53.5724894
    },
    "11321":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":79.9396658,
      "latitude":53.0371023
    },
    "11322":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":79.9536384,
      "latitude":53.5070029
    },
    "11323":{
      "name":"\u0411\u0435\u0440\u0435\u0433\u043e\u0432\u043e\u0439",
      "longitude":79.9958874,
      "latitude":53.2707837
    },
    "11324":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u0441\u043a\u0438\u0439",
      "longitude":80.0260671,
      "latitude":53.9253108
    },
    "11325":{
      "name":"\u0421\u0443\u0445\u043e\u0439 \u0420\u0430\u043a\u0438\u0442",
      "longitude":80.0615044,
      "latitude":52.8963333
    },
    "11326":{
      "name":"\u0422\u043e\u043f\u043e\u043b\u0438\u043d\u0441\u043a\u0438\u0439 \u041b\u0435\u0441\u0445\u043e\u0437",
      "longitude":80.0837721,
      "latitude":50.9378231
    },
    "11327":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u043a\u0430",
      "longitude":80.0854047,
      "latitude":53.183128
    },
    "11328":{
      "name":"\u041b\u0435\u0431\u0435\u0434\u0438\u0445\u0430",
      "longitude":80.1100164,
      "latitude":53.6203567
    },
    "11329":{
      "name":"\u041b\u044f\u043f\u0443\u043d\u043e\u0432\u043e",
      "longitude":80.1379785,
      "latitude":51.2909435
    },
    "11330":{
      "name":"\u041b\u0435\u043d\u0441\u043a\u0438\u0439",
      "longitude":80.1401723,
      "latitude":54.0082909
    },
    "11331":{
      "name":"\u0423\u043a\u0440\u0430\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":80.1548061,
      "latitude":53.2313654
    },
    "11332":{
      "name":"\u0414\u043e\u0431\u0440\u043e\u0432\u043e\u043b\u044c\u0441\u043a\u0438\u0439",
      "longitude":80.1586526,
      "latitude":53.2066937
    },
    "11333":{
      "name":"\u041d\u043e\u0432\u043e\u0442\u044e\u043c\u0435\u043d\u0446\u0435\u0432\u043e",
      "longitude":80.2031457,
      "latitude":53.0661033
    },
    "11334":{
      "name":"\u0413\u043b\u044f\u0434\u0435\u043d\u044c-4",
      "longitude":80.2073747,
      "latitude":52.7560501
    },
    "11335":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u0430\u0440\u043c\u0435\u0439\u0441\u043a\u0438\u0439",
      "longitude":80.2253765,
      "latitude":53.5721313
    },
    "11336":{
      "name":"\u041d\u0435\u0444\u0442\u0435\u0431\u0430\u0437\u0430",
      "longitude":80.2295617,
      "latitude":53.7502622
    },
    "11337":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":80.2460926,
      "latitude":54.0170531
    },
    "11338":{
      "name":"\u041f\u0430\u043d\u043a\u0440\u0443\u0448\u0438\u0445\u0430",
      "longitude":80.2603313,
      "latitude":53.7582492
    },
    "11339":{
      "name":"\u0413\u043e\u0440\u044c\u043a\u043e\u0435",
      "longitude":80.2679256,
      "latitude":51.179072
    },
    "11340":{
      "name":"\u041a\u0443\u0440\u0433\u0430\u043d",
      "longitude":80.288719,
      "latitude":53.100853
    },
    "11341":{
      "name":"\u041f\u043b\u043e\u0434\u043e\u0441\u043e\u0432\u0445\u043e\u0437",
      "longitude":80.2948973,
      "latitude":51.9947821
    },
    "11342":{
      "name":"\u0425\u043e\u0440\u043e\u0448\u0430\u0432\u043a\u0430",
      "longitude":80.2976727,
      "latitude":52.8742546
    },
    "11343":{
      "name":"\u041f\u0435\u0440\u0432\u044b\u0435 \u041a\u043e\u0440\u043e\u0441\u0442\u0435\u043b\u0438",
      "longitude":80.3285858,
      "latitude":51.223337
    },
    "11344":{
      "name":"\u0428\u0443\u0431\u0438\u043d\u043a\u0430",
      "longitude":80.3436457,
      "latitude":52.7661066
    },
    "11345":{
      "name":"\u0411\u0438\u0440\u044e\u0447\u0438\u0439",
      "longitude":80.3448374,
      "latitude":53.6657399
    },
    "11346":{
      "name":"\u0423\u0441\u0442\u044c-\u041a\u043e\u0440\u043c\u0438\u0445\u0430",
      "longitude":80.3551556,
      "latitude":51.8265918
    },
    "11347":{
      "name":"\u041f\u0430\u0432\u043b\u043e\u0432\u043a\u0430",
      "longitude":80.3787002,
      "latitude":53.2342031
    },
    "11348":{
      "name":"\u0414\u043c\u0438\u0442\u0440\u0438\u0435\u0432\u043a\u0430",
      "longitude":80.4211184,
      "latitude":53.0433618
    },
    "11349":{
      "name":"\u041a\u044b\u0437\u044b\u043b\u0442\u0443",
      "longitude":80.4263657,
      "latitude":53.9923298
    },
    "11350":{
      "name":"\u0417\u0430\u0440\u0435\u0447\u043d\u044b\u0439",
      "longitude":80.4349355,
      "latitude":53.8138122
    },
    "11351":{
      "name":"\u0427\u0443\u043c\u0430\u043d\u043a\u0430",
      "longitude":80.4659965,
      "latitude":53.5115579
    },
    "11352":{
      "name":"\u0427\u0435\u0440\u043d\u043e\u043a\u043e\u0440\u043e\u0432\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":80.4712469,
      "latitude":51.6163348
    },
    "11353":{
      "name":"\u041a\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":80.480431,
      "latitude":52.849228
    },
    "11354":{
      "name":"\u041f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":80.4911349,
      "latitude":53.1289519
    },
    "11355":{
      "name":"\u041f\u0430\u0432\u043b\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":80.5101381,
      "latitude":53.6394751
    },
    "11356":{
      "name":"\u0413\u0430\u043d\u0451\u043d\u043e\u043a",
      "longitude":80.5112325,
      "latitude":53.5712899
    },
    "11357":{
      "name":"\u041a\u043e\u0440\u043c\u0438\u0445\u0430",
      "longitude":80.5364715,
      "latitude":51.6954364
    },
    "11358":{
      "name":"\u0420\u0430\u0437\u0434\u043e\u043b\u044c\u043d\u044b\u0439",
      "longitude":80.557051,
      "latitude":53.6143289
    },
    "11359":{
      "name":"\u041a\u043e\u043d\u0451\u0432\u043e",
      "longitude":80.5599192,
      "latitude":53.8699469
    },
    "11360":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u0443\u043b\u0438\u043a\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":80.5694718,
      "latitude":52.9942968
    },
    "11361":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":80.585754,
      "latitude":52.90575
    },
    "11362":{
      "name":"\u0417\u0435\u043b\u0451\u043d\u0430\u044f \u0414\u0443\u0431\u0440\u0430\u0432\u0430",
      "longitude":80.5902526,
      "latitude":52.4888392
    },
    "11363":{
      "name":"\u0420\u0435\u0447\u043a\u0430-\u041a\u043e\u0440\u043c\u0438\u0445\u0430",
      "longitude":80.6129163,
      "latitude":51.820004
    },
    "11364":{
      "name":"\u0420\u044b\u0431\u043d\u044b\u0435 \u0411\u043e\u0440\u043a\u0438",
      "longitude":80.6165096,
      "latitude":53.1951857
    },
    "11365":{
      "name":"\u041c\u043e\u0441\u043a\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":80.631162,
      "latitude":54.0072026
    },
    "11366":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u043e\u0432\u0435\u0442\u0441\u043a\u0438\u0439",
      "longitude":80.6367936,
      "latitude":51.8269502
    },
    "11367":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u043c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":80.6509353,
      "latitude":53.728
    },
    "11368":{
      "name":"\u0421\u0432\u0435\u0442\u043e\u0432\u0441\u043a\u0430\u044f",
      "longitude":80.6589404,
      "latitude":53.7188112
    },
    "11369":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":80.6852715,
      "latitude":52.688952
    },
    "11370":{
      "name":"\u0417\u0435\u043b\u0451\u043d\u0430\u044f \u0414\u0443\u0431\u0440\u0430\u0432\u0430",
      "longitude":80.708838,
      "latitude":53.6826027
    },
    "11371":{
      "name":"\u0421\u043e\u0431\u043e\u043b\u0438",
      "longitude":80.7303153,
      "latitude":53.0966803
    },
    "11372":{
      "name":"\u0411\u043e\u0440\u0438\u0441\u043e\u0432\u043a\u0430",
      "longitude":80.7773088,
      "latitude":51.5580151
    },
    "11373":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u0434\u0443\u0431\u0440\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":80.7853669,
      "latitude":52.915269
    },
    "11374":{
      "name":"\u0422\u0430\u043c\u0431\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":80.8899181,
      "latitude":53.7150386
    },
    "11375":{
      "name":"\u0414\u043e\u043b\u0438\u043d\u043e",
      "longitude":80.9097172,
      "latitude":51.4890641
    },
    "11376":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u043c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":80.9191697,
      "latitude":52.7727531
    },
    "11377":{
      "name":"\u041f\u0435\u0442\u0443\u0445\u043e\u0432 \u041b\u043e\u0433",
      "longitude":80.9511953,
      "latitude":51.8247655
    },
    "11378":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u0440\u044f\u0436\u0441\u043a\u0438\u0439",
      "longitude":80.9668369,
      "latitude":53.9259509
    },
    "11379":{
      "name":"\u041a\u0430\u043f\u0443\u0441\u0442\u0438\u043d\u043a\u0430",
      "longitude":80.9936329,
      "latitude":53.3183713
    },
    "11380":{
      "name":"\u0416\u0443\u0440\u0430\u0432\u043b\u0438",
      "longitude":80.999599,
      "latitude":52.7446842
    },
    "11381":{
      "name":"\u041d\u043e\u0432\u043e\u0434\u0443\u0431\u0440\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":81.0335007,
      "latitude":53.7853933
    },
    "11382":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u0414\u0443\u0431\u0440\u0430\u0432\u0430",
      "longitude":81.0337451,
      "latitude":53.712283
    },
    "11383":{
      "name":"\u0412\u0435\u0441\u0451\u043b\u0430\u044f \u0414\u0443\u0431\u0440\u0430\u0432\u0430",
      "longitude":81.0353517,
      "latitude":52.2658202
    },
    "11384":{
      "name":"\u041f\u0435\u0441\u0447\u0430\u043d\u044b\u0439 \u0411\u043e\u0440\u043e\u043a",
      "longitude":81.060529,
      "latitude":51.6490588
    },
    "11385":{
      "name":"\u041d\u043e\u0432\u043e\u0434\u0443\u0431\u0440\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":81.0615812,
      "latitude":53.7156358
    },
    "11386":{
      "name":"\u0416\u0435\u0440\u043d\u043e\u0432\u0446\u044b",
      "longitude":81.0830874,
      "latitude":51.9361344
    },
    "11387":{
      "name":"\u041f\u0435\u0441\u0447\u0430\u043d\u044b\u0439",
      "longitude":81.0877367,
      "latitude":51.632393
    },
    "11388":{
      "name":"538 \u043a\u043c",
      "longitude":81.0887012,
      "latitude":51.2535039
    },
    "11389":{
      "name":"\u0420\u0430\u0434\u043e\u0441\u0442\u043d\u044b\u0439",
      "longitude":81.0921407,
      "latitude":53.9489051
    },
    "11390":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u043e\u0439 \u041b\u043e\u0433",
      "longitude":81.0931544,
      "latitude":53.8805421
    },
    "11391":{
      "name":"543 \u043a\u043c",
      "longitude":81.1017992,
      "latitude":51.215741
    },
    "11392":{
      "name":"\u0417\u0435\u0440\u043d\u043e",
      "longitude":81.106854,
      "latitude":51.3622727
    },
    "11393":{
      "name":"\u0421\u0430\u0444\u0440\u043e\u043d\u043e\u0432\u043e",
      "longitude":81.1105358,
      "latitude":53.1919533
    },
    "11394":{
      "name":"\u0421\u0438\u0431\u0438\u0440\u044c",
      "longitude":81.1137156,
      "latitude":51.6897369
    },
    "11395":{
      "name":"\u041a\u043e\u043b\u043e\u0441",
      "longitude":81.1371544,
      "latitude":51.3921495
    },
    "11396":{
      "name":"519 \u043a\u043c",
      "longitude":81.1497694,
      "latitude":51.4252045
    },
    "11397":{
      "name":"512 \u043a\u043c",
      "longitude":81.1773391,
      "latitude":51.4784097
    },
    "11398":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":81.1894451,
      "latitude":51.850412
    },
    "11399":{
      "name":"\u041d\u043e\u0432\u043e\u043c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":81.203225,
      "latitude":51.1424873
    },
    "11400":{
      "name":"\u041f\u043e\u0434\u0432\u0435\u0442\u0440\u0435\u043d\u043d\u043e-\u0422\u0435\u043b\u0435\u0443\u0442\u0441\u043a\u043e\u0435",
      "longitude":81.2080807,
      "latitude":53.4784921
    },
    "11401":{
      "name":"\u041d\u043e\u0432\u043e\u043c\u0430\u0442\u0432\u0435\u0435\u0432\u043a\u0430",
      "longitude":81.2128801,
      "latitude":51.3274634
    },
    "11402":{
      "name":"\u041a\u0430\u0440\u0430\u0441\u0438",
      "longitude":81.2322804,
      "latitude":53.8360903
    },
    "11403":{
      "name":"\u0418\u043b\u044c\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":81.232717,
      "latitude":52.379888
    },
    "11404":{
      "name":"\u0414\u043e\u0431\u0440\u0430\u044f \u0412\u043e\u043b\u044f",
      "longitude":81.2384314,
      "latitude":52.9019096
    },
    "11405":{
      "name":"\u0422\u0440\u0430\u043a\u0442\u043e\u0440\u043d\u044b\u0439",
      "longitude":81.2445666,
      "latitude":51.5783461
    },
    "11406":{
      "name":"\u041e\u0432\u0435\u0447\u043a\u0438\u043d\u043e",
      "longitude":81.2487102,
      "latitude":52.9698231
    },
    "11407":{
      "name":"498 \u043a\u043c",
      "longitude":81.2544896,
      "latitude":51.5955861
    },
    "11408":{
      "name":"\u041c\u0438\u0440\u043d\u044b\u0439",
      "longitude":81.2670594,
      "latitude":51.7847925
    },
    "11409":{
      "name":"\u041c\u0430\u0441\u043b\u044f\u0445\u0430",
      "longitude":81.267998,
      "latitude":54.053089
    },
    "11410":{
      "name":"\u041d\u043e\u0432\u043e\u0443\u0432\u0430\u043b\u044c\u0441\u043a\u0438\u0439",
      "longitude":81.2808792,
      "latitude":53.8579499
    },
    "11411":{
      "name":"\u041f\u0430\u043c\u044f\u0442\u044c \u041a\u043e\u043c\u043c\u0443\u043d\u0430\u0440\u043e\u0432",
      "longitude":81.2967858,
      "latitude":52.7295433
    },
    "11412":{
      "name":"\u0421\u043e\u043a\u043e\u043b\u043e\u0432\u043e",
      "longitude":81.3101283,
      "latitude":53.9948279
    },
    "11413":{
      "name":"\u0421\u0430\u043c\u0430\u0440\u0441\u043a\u0438\u0439",
      "longitude":81.3345378,
      "latitude":53.518847
    },
    "11414":{
      "name":"\u041c\u0430\u043b\u0435\u0442\u0438\u043d\u043e",
      "longitude":81.4052835,
      "latitude":54.0411052
    },
    "11415":{
      "name":"\u0413\u043e\u043d\u043e\u0445\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":81.4480435,
      "latitude":52.9726599
    },
    "11416":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u044f\u0440\u043a\u0430",
      "longitude":81.457033,
      "latitude":52.0888709
    },
    "11417":{
      "name":"\u0410\u043b\u0435\u0439\u043d\u0438\u043a\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":81.4616903,
      "latitude":51.9353732
    },
    "11418":{
      "name":"\u041a\u043b\u044e\u0447\u0438",
      "longitude":81.4824063,
      "latitude":53.9650763
    },
    "11419":{
      "name":"\u041b\u0430\u0442\u043a\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":81.5162746,
      "latitude":53.169767
    },
    "11420":{
      "name":"\u041f\u043b\u043e\u0442\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":81.517925,
      "latitude":53.54395
    },
    "11421":{
      "name":"VI \u041a\u043e\u043d\u0433\u0440\u0435\u0441\u0441\u0430 \u041a\u043e\u043c\u0438\u043d\u0442\u0435\u0440\u043d\u0430",
      "longitude":81.525658,
      "latitude":51.3115651
    },
    "11422":{
      "name":"\u041c\u044b\u0441\u043a\u0438",
      "longitude":81.5385243,
      "latitude":53.6899686
    },
    "11423":{
      "name":"\u041c\u0438\u0440\u043d\u044b\u0439",
      "longitude":81.5538561,
      "latitude":51.0587118
    },
    "11424":{
      "name":"\u041c\u0430\u043c\u043e\u043d\u0442\u043e\u0432\u043e",
      "longitude":81.5582739,
      "latitude":52.1537689
    },
    "11425":{
      "name":"\u041a\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":81.5734873,
      "latitude":53.4652693
    },
    "11426":{
      "name":"3 \u0418\u043d\u0442\u0435\u0440\u043d\u0430\u0446\u0438\u043e\u043d\u0430\u043b",
      "longitude":81.5950925,
      "latitude":53.8804474
    },
    "11427":{
      "name":"\u0420\u0430\u0437\u0434\u043e\u043b\u044c\u043d\u043e\u0435",
      "longitude":81.6141885,
      "latitude":50.8662122
    },
    "11428":{
      "name":"\u0420\u043e\u0434\u0438\u043d\u0430",
      "longitude":81.6150483,
      "latitude":53.8011741
    },
    "11429":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":81.6277938,
      "latitude":52.2586249
    },
    "11430":{
      "name":"\u0421\u0442\u0435\u043f\u043d\u043e\u0439",
      "longitude":81.6346126,
      "latitude":50.9996427
    },
    "11431":{
      "name":"\u041d\u043e\u0432\u044b\u0439 \u041c\u0438\u0440",
      "longitude":81.6419082,
      "latitude":51.7326015
    },
    "11432":{
      "name":"\u041d\u0430\u0437\u0430\u0440\u043e\u0432\u043a\u0430",
      "longitude":81.6718708,
      "latitude":51.425607
    },
    "11433":{
      "name":"\u0414\u0443\u0445\u043e\u0432\u0430\u044f",
      "longitude":81.6925207,
      "latitude":53.7997672
    },
    "11434":{
      "name":"\u0411\u043b\u0430\u0433\u043e\u0434\u0430\u0442\u043d\u044b\u0439",
      "longitude":81.6926385,
      "latitude":51.6411468
    },
    "11435":{
      "name":"\u041f\u0430\u0432\u043b\u043e\u0432\u043a\u0430",
      "longitude":81.7072752,
      "latitude":51.1587061
    },
    "11436":{
      "name":"\u0412\u043e\u0437\u043d\u0435\u0441\u0435\u043d\u0441\u043a\u0438\u0439",
      "longitude":81.7084798,
      "latitude":52.8388484
    },
    "11437":{
      "name":"\u041d\u0435\u0432\u0441\u043a\u0438\u0439",
      "longitude":81.7106114,
      "latitude":52.2971168
    },
    "11438":{
      "name":"\u0422\u0443\u0448\u043a\u0430\u043d\u0438\u0445\u0430",
      "longitude":81.7127201,
      "latitude":51.2596996
    },
    "11439":{
      "name":"\u041a\u0443\u0447\u0435\u0440\u043e\u0432\u043a\u0430",
      "longitude":81.7250216,
      "latitude":50.9039043
    },
    "11440":{
      "name":"\u0427\u0435\u0431\u0443\u0440\u0438\u0445\u0430",
      "longitude":81.7506033,
      "latitude":51.5083193
    },
    "11441":{
      "name":"\u0425\u043e\u0434\u0430\u0435\u0432\u0441\u043a\u0438\u0439",
      "longitude":81.7579746,
      "latitude":51.648837
    },
    "11442":{
      "name":"\u041c\u0435\u0436\u0434\u0443\u0440\u0435\u0447\u044c\u0435",
      "longitude":81.7625498,
      "latitude":51.1031336
    },
    "11443":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":81.7729002,
      "latitude":53.9208216
    },
    "11444":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u043a\u0430",
      "longitude":81.776123,
      "latitude":52.198547
    },
    "11445":{
      "name":"\u0412\u0430\u0440\u0448\u0430\u0432\u0430",
      "longitude":81.7789551,
      "latitude":51.4254994
    },
    "11446":{
      "name":"\u0421\u0442\u0435\u043f\u043d\u043e\u0431\u0443\u0433\u0440\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":81.7811629,
      "latitude":51.5721843
    },
    "11447":{
      "name":"\u041e\u0442\u0440\u0430\u0434\u0430",
      "longitude":81.791946,
      "latitude":51.303757
    },
    "11448":{
      "name":"\u0410\u043d\u0442\u043e\u0448\u0438\u0445\u0430",
      "longitude":81.8035422,
      "latitude":50.9001668
    },
    "11449":{
      "name":"\u0411\u043e\u0440\u043e\u043a",
      "longitude":81.8056796,
      "latitude":52.0611806
    },
    "11450":{
      "name":"\u041b\u043e\u043a\u043e\u0442\u043e\u043a",
      "longitude":81.8209825,
      "latitude":51.2557166
    },
    "11451":{
      "name":"\u0411\u043e\u0440\u043a\u043e\u0432\u043e",
      "longitude":81.8304104,
      "latitude":52.7390925
    },
    "11452":{
      "name":"\u0410\u0440\u0442\u0430\u043c\u043e\u043d\u043e\u0432\u043e",
      "longitude":81.852981,
      "latitude":52.2916201
    },
    "11453":{
      "name":"\u041f\u043e\u0442\u0435\u0440\u044f\u0435\u0432\u043a\u0430",
      "longitude":81.8623266,
      "latitude":52.9938633
    },
    "11454":{
      "name":"\u0422\u0443\u043b\u0430\u0439",
      "longitude":81.8778225,
      "latitude":53.1212893
    },
    "11455":{
      "name":"\u041f\u043e\u0434\u0441\u0442\u0435\u043f\u043d\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":81.9002817,
      "latitude":52.9878678
    },
    "11456":{
      "name":"\u041f\u0440\u0435\u0434\u0433\u043e\u0440\u043d\u044b\u0439",
      "longitude":81.9004729,
      "latitude":51.231652
    },
    "11457":{
      "name":"\u0425\u043b\u043e\u043f\u0443\u043d\u043e\u0432\u043e",
      "longitude":81.9899654,
      "latitude":52.0664106
    },
    "11458":{
      "name":"\u0412\u043e\u0440\u043e\u043d\u0435\u0436",
      "longitude":82.0108354,
      "latitude":51.1912316
    },
    "11459":{
      "name":"\u041e\u0431\u044a\u0435\u0437\u0434\u043d\u043e\u0435",
      "longitude":82.0374288,
      "latitude":52.4329428
    },
    "11460":{
      "name":"\u041c\u0438\u0440\u043d\u044b\u0439",
      "longitude":82.0437891,
      "latitude":52.0301096
    },
    "11461":{
      "name":"\u0423\u0442\u043a\u0430",
      "longitude":82.0535983,
      "latitude":51.3340291
    },
    "11462":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u0443\u0437\u043d\u0435\u0446\u043e\u0432\u043a\u0430",
      "longitude":82.0606897,
      "latitude":51.231386
    },
    "11463":{
      "name":"\u0427\u0435\u043a\u0430\u043d\u043e\u0432\u043e",
      "longitude":82.0650687,
      "latitude":51.1018029
    },
    "11464":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u043a\u0430",
      "longitude":82.083809,
      "latitude":51.146622
    },
    "11465":{
      "name":"\u0413\u043e\u0440\u043d\u043e\u0432\u043a\u0430",
      "longitude":82.095118,
      "latitude":51.5054902
    },
    "11466":{
      "name":"\u041f\u0430\u043d\u043e\u0432\u043e",
      "longitude":82.1236892,
      "latitude":53.0035704
    },
    "11467":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":82.1356884,
      "latitude":51.4791391
    },
    "11468":{
      "name":"\u041d\u043e\u0432\u043e\u0445\u0430\u0440\u044c\u043a\u043e\u0432\u043a\u0430",
      "longitude":82.1516237,
      "latitude":51.299448
    },
    "11469":{
      "name":"\u041a\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":82.157,
      "latitude":52.1196208
    },
    "11470":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u0433\u0432\u0430\u0440\u0434\u0435\u0439\u0441\u043a\u0438\u0439",
      "longitude":82.179378,
      "latitude":51.2109086
    },
    "11471":{
      "name":"\u041c\u0430\u0439\u0441\u043a\u043e\u0435 \u0423\u0442\u0440\u043e",
      "longitude":82.1804045,
      "latitude":52.3073283
    },
    "11472":{
      "name":"\u0417\u0430\u0449\u0438\u0442\u0430",
      "longitude":82.1891546,
      "latitude":52.0146939
    },
    "11473":{
      "name":"\u0421\u0432\u0435\u0442\u043b\u0430\u044f \u0417\u0430\u0440\u044f",
      "longitude":82.1935592,
      "latitude":50.8363916
    },
    "11474":{
      "name":"\u041b\u0435\u0441\u043d\u043e\u0439",
      "longitude":82.2387318,
      "latitude":53.0186094
    },
    "11475":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u043a\u0430",
      "longitude":82.2498507,
      "latitude":52.4387637
    },
    "11476":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u0437\u043d\u0430\u043c\u0435\u043d\u0441\u043a\u0438\u0439",
      "longitude":82.2646576,
      "latitude":51.6566182
    },
    "11477":{
      "name":"\u0420\u044f\u0437\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":82.2695066,
      "latitude":51.0553715
    },
    "11478":{
      "name":"\u041d\u043e\u0432\u043e\u0437\u043d\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":82.2796467,
      "latitude":51.6622799
    },
    "11479":{
      "name":"\u0411\u043e\u0440\u043e\u0432\u043b\u044f\u043d\u043a\u0430",
      "longitude":82.2952143,
      "latitude":50.8261156
    },
    "11480":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":82.3040311,
      "latitude":52.566
    },
    "11481":{
      "name":"\u041b\u0443\u0433\u043e\u0432\u043e\u0435",
      "longitude":82.3150232,
      "latitude":53.4680939
    },
    "11482":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u0435 \u0420\u0430\u0437\u0434\u043e\u043b\u044c\u0435",
      "longitude":82.3354821,
      "latitude":50.9126346
    },
    "11483":{
      "name":"\u0420\u0443\u0447\u044c\u0451\u0432\u043e",
      "longitude":82.3425799,
      "latitude":51.4030919
    },
    "11484":{
      "name":"\u0421\u0435\u0440\u0435\u0431\u0440\u0435\u043d\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":82.3453456,
      "latitude":52.7269439
    },
    "11485":{
      "name":"\u0427\u0435\u0440\u043d\u044b\u0448\u0435\u0432\u0441\u043a\u0438\u0439",
      "longitude":82.3525147,
      "latitude":52.6161499
    },
    "11486":{
      "name":"\u041b\u0430\u0437\u0443\u0440\u043a\u0430",
      "longitude":82.3801831,
      "latitude":51.092639
    },
    "11487":{
      "name":"\u041a\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":82.3802209,
      "latitude":51.3250812
    },
    "11488":{
      "name":"\u0420\u0443\u0434\u043e\u0432\u043e\u0437\u043e\u0432\u043e",
      "longitude":82.38646,
      "latitude":51.3668812
    },
    "11489":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":82.4013681,
      "latitude":50.9247047
    },
    "11490":{
      "name":"\u0427\u0430\u044f\u0447\u0438\u0439",
      "longitude":82.4212243,
      "latitude":52.1262092
    },
    "11491":{
      "name":"\u041a\u0430\u043b\u043c\u0430\u0446\u043a\u0438\u0439",
      "longitude":82.4609228,
      "latitude":51.734231
    },
    "11492":{
      "name":"\u0414\u0430\u043b\u044c\u043d\u0438\u0439",
      "longitude":82.4658535,
      "latitude":53.021973
    },
    "11493":{
      "name":"\u0421\u0438\u0431\u0438\u0440\u043a\u0430",
      "longitude":82.5007199,
      "latitude":53.4449253
    },
    "11494":{
      "name":"\u041f\u043e\u0434\u0437\u0430\u0439\u043c\u0438\u0449\u0435",
      "longitude":82.5169677,
      "latitude":51.7055145
    },
    "11495":{
      "name":"\u042f\u0437\u0435\u0432\u043a\u0430-\u0421\u0438\u0431\u0438\u0440\u0441\u043a\u0430\u044f",
      "longitude":82.5294702,
      "latitude":52.3655317
    },
    "11496":{
      "name":"\u041f\u043e\u0434\u0445\u043e\u0437",
      "longitude":82.5366142,
      "latitude":51.3320679
    },
    "11497":{
      "name":"\u041c\u0443\u0440\u0437\u0438\u043d\u043a\u0430",
      "longitude":82.5500716,
      "latitude":51.6273478
    },
    "11498":{
      "name":"\u042d\u0441\u0442\u043e\u043d\u0438\u044f",
      "longitude":82.5501275,
      "latitude":51.8979902
    },
    "11499":{
      "name":"\u0421\u0435\u043c\u0438\u043b\u0435\u0442\u043a\u0430",
      "longitude":82.571106,
      "latitude":52.1888239
    },
    "11500":{
      "name":"\u0427\u0430\u0440\u044b\u0448\u0441\u043a\u0438\u0439",
      "longitude":82.6056363,
      "latitude":51.6851323
    },
    "11501":{
      "name":"\u0414\u0440\u0443\u0436\u0431\u0430",
      "longitude":82.6234991,
      "latitude":52.2220258
    },
    "11502":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u043c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":82.6256571,
      "latitude":52.4901625
    },
    "11503":{
      "name":"\u0438\u043c\u0435\u043d\u0438 8 \u041c\u0430\u0440\u0442\u0430",
      "longitude":82.6332796,
      "latitude":51.3020274
    },
    "11504":{
      "name":"\u041a\u0430\u0440\u043f\u043e\u0432\u043e \u041f\u0435\u0440\u0432\u043e\u0435",
      "longitude":82.6442693,
      "latitude":51.7168241
    },
    "11505":{
      "name":"363 \u043a\u043c",
      "longitude":82.6645442,
      "latitude":52.4233929
    },
    "11506":{
      "name":"\u0417\u0430\u0441\u0443\u0440\u044c\u0435",
      "longitude":82.6654805,
      "latitude":51.7347233
    },
    "11507":{
      "name":"\u0420\u0430\u043a\u0438\u0442\u044b",
      "longitude":82.6815725,
      "latitude":53.0615045
    },
    "11508":{
      "name":"\u0422\u0440\u043e\u0438\u0446\u043a\u0438\u0439",
      "longitude":82.6922278,
      "latitude":52.5940713
    },
    "11509":{
      "name":"\u041c\u0430\u043c\u043e\u043d\u0442\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":82.70565,
      "latitude":52.322765
    },
    "11510":{
      "name":"\u041f\u043e\u0434\u043f\u0430\u043b\u0430\u0442\u0446\u044b",
      "longitude":82.7188188,
      "latitude":51.2408032
    },
    "11511":{
      "name":"\u041c\u043e\u043b\u043e\u0434\u0451\u0436\u043d\u044b\u0439",
      "longitude":82.738356,
      "latitude":53.0562821
    },
    "11512":{
      "name":"\u0421\u0435\u043c\u0451\u043d\u043e\u0432\u043a\u0430",
      "longitude":82.7398608,
      "latitude":51.5670059
    },
    "11513":{
      "name":"\u041c\u0430\u043b\u0430\u0445\u043e\u0432\u043e",
      "longitude":82.7551932,
      "latitude":52.4117834
    },
    "11514":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u043e\u0434\u0443\u0431\u0440\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":82.7612985,
      "latitude":52.6862879
    },
    "11515":{
      "name":"\u041e\u043a\u0442\u044f\u0431\u0440\u044c\u0441\u043a\u0438\u0439",
      "longitude":82.7617632,
      "latitude":52.3431379
    },
    "11516":{
      "name":"\u0410\u0432\u0435\u0440\u0435\u043d\u043a\u0430",
      "longitude":82.7668302,
      "latitude":51.4814134
    },
    "11517":{
      "name":"\u0417\u0435\u043b\u0451\u043d\u0430\u044f \u041f\u043e\u043b\u044f\u043d\u0430",
      "longitude":82.7728582,
      "latitude":52.4347078
    },
    "11518":{
      "name":"\u0422\u0430\u043b\u0438\u043d\u0430",
      "longitude":82.774002,
      "latitude":52.2038313
    },
    "11519":{
      "name":"\u0427\u0443\u043f\u0438\u043d\u043e",
      "longitude":82.7929017,
      "latitude":52.1214208
    },
    "11520":{
      "name":"\u0420\u044f\u043c\u044b",
      "longitude":82.8055259,
      "latitude":53.8029034
    },
    "11521":{
      "name":"\u0438\u043c\u0435\u043d\u0438 \u041c\u0430\u043c\u043e\u043d\u0442\u043e\u0432\u0430",
      "longitude":82.805576,
      "latitude":53.0940281
    },
    "11522":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u0430\u044f \u0414\u0443\u0431\u0440\u0430\u0432\u0430",
      "longitude":82.826118,
      "latitude":53.278534
    },
    "11523":{
      "name":"\u0410\u043d\u0434\u0440\u0435\u0435\u0432\u0441\u043a\u0438\u0439",
      "longitude":82.8292431,
      "latitude":51.1022534
    },
    "11524":{
      "name":"\u041d\u043e\u0432\u043e\u043d\u0438\u043a\u043e\u043b\u044c\u0441\u043a\u0438\u0439",
      "longitude":82.8393397,
      "latitude":52.7643176
    },
    "11525":{
      "name":"347 \u043a\u043c",
      "longitude":82.8442123,
      "latitude":52.5184878
    },
    "11526":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u0421\u0443\u0435\u0442\u043a\u0430",
      "longitude":82.8462617,
      "latitude":51.6080323
    },
    "11527":{
      "name":"\u0414\u0443\u0431\u0440\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":82.8517074,
      "latitude":52.6537639
    },
    "11528":{
      "name":"\u041a\u043e\u043d\u0434\u0440\u0430\u0442\u044c\u0435\u0432\u0441\u043a\u0438\u0439",
      "longitude":82.8635456,
      "latitude":52.7102957
    },
    "11529":{
      "name":"\u0423\u0441\u0442\u044c-\u0415\u0440\u043c\u0438\u043b\u0438\u0445\u0430",
      "longitude":82.8801263,
      "latitude":52.0198884
    },
    "11530":{
      "name":"\u0423\u0441\u043f\u0435\u043d\u043e\u0432\u043a\u0430",
      "longitude":82.8960167,
      "latitude":52.5199071
    },
    "11531":{
      "name":"\u0421\u043e\u0432\u0435\u0442\u0441\u043a\u0438\u0439",
      "longitude":82.9027779,
      "latitude":53.1505064
    },
    "11532":{
      "name":"\u0410\u0440\u0431\u0443\u0437\u043e\u0432\u043a\u0430",
      "longitude":82.9527456,
      "latitude":53.0549773
    },
    "11533":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u043e\u043b\u043f\u0430\u043a\u043e\u0432\u043e",
      "longitude":82.9721303,
      "latitude":52.5692436
    },
    "11534":{
      "name":"\u0421\u0430\u043d\u0434\u0430\u043b\u043e\u0432\u043e",
      "longitude":83.0039388,
      "latitude":53.7465323
    },
    "11535":{
      "name":"\u0422\u0438\u0433\u0435\u0440\u0435\u043a",
      "longitude":83.03015,
      "latitude":51.1453134
    },
    "11536":{
      "name":"\u0423\u0440\u0436\u0443\u043c",
      "longitude":83.031685,
      "latitude":52.239819
    },
    "11537":{
      "name":"\u0417\u0430\u043f\u0430\u0434\u043d\u044b\u0439",
      "longitude":83.0546927,
      "latitude":52.1300456
    },
    "11538":{
      "name":"\u041e\u0437\u0451\u0440\u043d\u044b\u0439",
      "longitude":83.0586788,
      "latitude":53.2216701
    },
    "11539":{
      "name":"\u0421\u0442\u0435\u043f\u043d\u043e\u0439",
      "longitude":83.0660778,
      "latitude":52.7203112
    },
    "11540":{
      "name":"\u0417\u043e\u043b\u043e\u0442\u0443\u0448\u043a\u0430",
      "longitude":83.0714579,
      "latitude":51.5541196
    },
    "11541":{
      "name":"\u0422\u0430\u043b\u044b\u0439 \u041a\u043b\u044e\u0447",
      "longitude":83.0750791,
      "latitude":51.2829328
    },
    "11542":{
      "name":"\u041d\u043e\u0432\u043e\u0431\u0430\u0440\u043d\u0430\u0443\u043b\u043a\u0430",
      "longitude":83.0762671,
      "latitude":53.0367048
    },
    "11543":{
      "name":"\u041f\u0440\u0438\u044f\u0442\u0435\u043b\u044c\u0441\u043a\u0438\u0439",
      "longitude":83.0895722,
      "latitude":52.2162537
    },
    "11544":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u041c\u0430\u0439",
      "longitude":83.104424,
      "latitude":53.3389531
    },
    "11545":{
      "name":"\u0427\u0435\u0440\u0451\u043c\u043d\u043e-\u041f\u043e\u0434\u0433\u043e\u0440\u043d\u043e\u0435",
      "longitude":83.111397,
      "latitude":53.451694
    },
    "11546":{
      "name":"\u0423\u0441\u0442\u044c-\u0427\u0430\u0433\u044b\u0440\u043a\u0430",
      "longitude":83.1311332,
      "latitude":51.4306782
    },
    "11547":{
      "name":"\u041a\u0440\u0443\u0442\u043e\u0439 \u041b\u043e\u0433",
      "longitude":83.1386872,
      "latitude":52.5147794
    },
    "11548":{
      "name":"\u0421\u043e\u043b\u043e\u043d\u043e\u0432\u043a\u0430",
      "longitude":83.172432,
      "latitude":53.146366
    },
    "11549":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":83.1820613,
      "latitude":53.0099671
    },
    "11550":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u0417\u0430\u0440\u044f",
      "longitude":83.1873023,
      "latitude":53.8805415
    },
    "11551":{
      "name":"\u0423\u0441\u0442\u044c-\u0418\u043e\u043d\u044b\u0448",
      "longitude":83.1891101,
      "latitude":51.1088288
    },
    "11552":{
      "name":"\u0421\u0430\u0434\u043e\u0432\u044b\u0439",
      "longitude":83.1976506,
      "latitude":52.5340433
    },
    "11553":{
      "name":"\u0413\u0435\u043d\u0435\u0440\u0430\u043b\u043a\u0430",
      "longitude":83.2185379,
      "latitude":51.2639
    },
    "11554":{
      "name":"\u041a\u0440\u0443\u0433\u043b\u043e\u0435",
      "longitude":83.2187352,
      "latitude":53.7693204
    },
    "11555":{
      "name":"\u041a\u0430\u0441\u043c\u0430\u043b\u0430",
      "longitude":83.2455381,
      "latitude":53.4412535
    },
    "11556":{
      "name":"\u0415\u0440\u043c\u0430\u0447\u0438\u0445\u0430",
      "longitude":83.2461602,
      "latitude":51.8406146
    },
    "11557":{
      "name":"\u0421\u043e\u043b\u043e\u043d\u0446\u043e\u0432\u044b\u0439",
      "longitude":83.260882,
      "latitude":52.868466
    },
    "11558":{
      "name":"\u041d\u0430\u0433\u043e\u0440\u043d\u044b\u0439",
      "longitude":83.2623919,
      "latitude":53.4336445
    },
    "11559":{
      "name":"\u0416\u0434\u0430\u043d\u043e\u0432\u043e",
      "longitude":83.2732875,
      "latitude":52.9426772
    },
    "11560":{
      "name":"\u0425\u0430\u0440\u044c\u043a\u043e\u0432\u043e",
      "longitude":83.2844409,
      "latitude":53.4227471
    },
    "11561":{
      "name":"\u0410\u043b\u0435\u0448\u0438\u0445\u0430",
      "longitude":83.2855353,
      "latitude":51.7800668
    },
    "11562":{
      "name":"290 \u043a\u043c",
      "longitude":83.2861247,
      "latitude":52.9270737
    },
    "11563":{
      "name":"\u0414\u0440\u0443\u0436\u0431\u0430",
      "longitude":83.2972481,
      "latitude":52.2384487
    },
    "11564":{
      "name":"\u0428\u0438\u043b\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":83.3088038,
      "latitude":52.9520881
    },
    "11565":{
      "name":"\u041e\u0442\u0434\u0430\u043b\u0435\u043d\u043d\u044b\u0439",
      "longitude":83.315916,
      "latitude":52.3041268
    },
    "11566":{
      "name":"\u0420\u0430\u0441\u0441\u0432\u0435\u0442",
      "longitude":83.3426893,
      "latitude":53.856446
    },
    "11567":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0435\u0435\u0432\u043a\u0430",
      "longitude":83.3488089,
      "latitude":51.1388737
    },
    "11568":{
      "name":"\u041b\u043e\u0433\u043e\u0432\u0441\u043a\u043e\u0439",
      "longitude":83.3660199,
      "latitude":52.8560178
    },
    "11569":{
      "name":"\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":83.4004797,
      "latitude":53.0480963
    },
    "11570":{
      "name":"\u0412\u043e\u0440\u043e\u043d\u0435\u0436\u0441\u043a\u0430\u044f-\u041c\u043e\u043b\u043e\u0434\u0451\u0436\u043d\u0430\u044f",
      "longitude":83.4083025,
      "latitude":53.770865
    },
    "11571":{
      "name":"\u041e\u0437\u0435\u0440\u043a\u0438",
      "longitude":83.4300697,
      "latitude":51.515296
    },
    "11572":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u0428\u0442\u0430\u0431\u043a\u0430",
      "longitude":83.4355518,
      "latitude":53.2650219
    },
    "11573":{
      "name":"\u041c\u043e\u0445\u043e\u0432\u043e\u0435",
      "longitude":83.4417627,
      "latitude":53.2539441
    },
    "11574":{
      "name":"260 \u043a\u043c",
      "longitude":83.454032,
      "latitude":53.1586942
    },
    "11575":{
      "name":"\u041f\u0435\u0440\u0443\u043d\u043e\u0432\u043e",
      "longitude":83.4615428,
      "latitude":53.9117102
    },
    "11576":{
      "name":"\u041f\u0435\u0442\u043b\u0438\u0445\u0430",
      "longitude":83.4627597,
      "latitude":52.3091404
    },
    "11577":{
      "name":"\u0417\u0438\u043c\u0430\u0440\u0438",
      "longitude":83.4638347,
      "latitude":53.1648432
    },
    "11578":{
      "name":"\u041f\u0440\u0443\u0434\u0441\u043a\u043e\u0439",
      "longitude":83.4798076,
      "latitude":53.1622316
    },
    "11579":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u0411\u043e\u0435\u0446",
      "longitude":83.4852608,
      "latitude":53.8681933
    },
    "11580":{
      "name":"\u041c\u0430\u0439\u043e\u0440\u043a\u0430",
      "longitude":83.5096565,
      "latitude":51.2368518
    },
    "11581":{
      "name":"\u041d\u043e\u0432\u044b\u0439",
      "longitude":83.5247394,
      "latitude":53.1726798
    },
    "11582":{
      "name":"\u0416\u0435\u043b\u0435\u0437\u043d\u043e\u0434\u043e\u0440\u043e\u0436\u043d\u0430\u044f \u041a\u0430\u0437\u0430\u0440\u043c\u0430 253",
      "longitude":83.5324255,
      "latitude":53.1944425
    },
    "11583":{
      "name":"\u041d\u0430\u0433\u043e\u0440\u043d\u044b\u0439",
      "longitude":83.5505994,
      "latitude":52.7965661
    },
    "11584":{
      "name":"\u0423\u0441\u0442\u044c-\u041f\u0438\u0445\u0442\u043e\u0432\u043a\u0430",
      "longitude":83.5651379,
      "latitude":51.699504
    },
    "11585":{
      "name":"\u0416\u0435\u043b\u0435\u0437\u043d\u043e\u0434\u043e\u0440\u043e\u0436\u043d\u0430\u044f \u041a\u0430\u0437\u0430\u0440\u043c\u0430 250",
      "longitude":83.5764367,
      "latitude":53.2094512
    },
    "11586":{
      "name":"\u0417\u0435\u043c\u043b\u044f\u043d\u0443\u0445\u0430",
      "longitude":83.5837753,
      "latitude":53.4038599
    },
    "11587":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u0430\u043b\u0435\u0439\u043a\u0430",
      "longitude":83.6101258,
      "latitude":52.8232159
    },
    "11588":{
      "name":"\u0421\u043e\u0441\u043d\u043e\u0432\u043a\u0430",
      "longitude":83.6115682,
      "latitude":51.5588089
    },
    "11589":{
      "name":"\u0412\u043b\u0430\u0441\u0438\u0445\u0430",
      "longitude":83.6219214,
      "latitude":53.2907708
    },
    "11590":{
      "name":"\u0427\u0430\u0439\u043d\u043e\u0435",
      "longitude":83.6267884,
      "latitude":51.625499
    },
    "11591":{
      "name":"\u0416\u0435\u043b\u0435\u0437\u043d\u043e\u0434\u043e\u0440\u043e\u0436\u043d\u0430\u044f \u041a\u0430\u0437\u0430\u0440\u043c\u0430 242",
      "longitude":83.6536563,
      "latitude":53.2581444
    },
    "11592":{
      "name":"\u0421\u043b\u044e\u0434\u044f\u043d\u043a\u0430",
      "longitude":83.658524,
      "latitude":51.883095
    },
    "11593":{
      "name":"\u041f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":83.6717981,
      "latitude":51.1300632
    },
    "11594":{
      "name":"\u0411\u0435\u0441\u043f\u0430\u043b\u043e\u0432\u043e",
      "longitude":83.6889147,
      "latitude":52.3132102
    },
    "11595":{
      "name":"\u041a\u043e\u043d\u044e\u0445\u0438",
      "longitude":83.6941878,
      "latitude":53.1689411
    },
    "11596":{
      "name":"\u041a\u0438\u0441\u043b\u0443\u0445\u0430",
      "longitude":83.710869,
      "latitude":53.498688
    },
    "11597":{
      "name":"\u041f\u043e\u043d\u043e\u043c\u0430\u0440\u0435\u0432\u043a\u0430",
      "longitude":83.7159729,
      "latitude":53.2554771
    },
    "11598":{
      "name":"\u041a\u043e\u0441\u0442\u044f\u043a\u0438",
      "longitude":83.7409314,
      "latitude":53.5551517
    },
    "11599":{
      "name":"\u0426\u0430\u043f\u043b\u0438\u043d\u043e",
      "longitude":83.7506877,
      "latitude":53.574968
    },
    "11600":{
      "name":"\u0423\u0441\u0442\u044c-\u0427\u0430\u0440\u044b\u0448",
      "longitude":83.7511055,
      "latitude":52.3325958
    },
    "11601":{
      "name":"\u0412\u0430\u0441\u0438\u043b\u044c\u0435\u0432\u043a\u0430",
      "longitude":83.7511445,
      "latitude":51.9343244
    },
    "11602":{
      "name":"\u0411\u043e\u0440\u043e\u0432\u043b\u044f\u043d\u043a\u0430",
      "longitude":83.7566489,
      "latitude":51.4059254
    },
    "11603":{
      "name":"193 \u043a\u043c",
      "longitude":83.7979872,
      "latitude":53.5490339
    },
    "11604":{
      "name":"\u041c\u0438\u0442\u044e\u0448\u043e\u0432\u043e",
      "longitude":83.8034443,
      "latitude":53.9216363
    },
    "11605":{
      "name":"\u0410\u0431\u0430",
      "longitude":83.8095036,
      "latitude":51.2967414
    },
    "11606":{
      "name":"\u041b\u0435\u0441\u043d\u043e\u0439",
      "longitude":83.8130906,
      "latitude":53.5312964
    },
    "11607":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":83.8239195,
      "latitude":51.5422779
    },
    "11608":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u0420\u0435\u0447\u043a\u0430",
      "longitude":83.8288325,
      "latitude":52.9938762
    },
    "11609":{
      "name":"\u041d\u0438\u0436\u043d\u044f\u044f \u041f\u0435\u0442\u0440\u043e\u0432\u043a\u0430",
      "longitude":83.8485023,
      "latitude":52.9145957
    },
    "11610":{
      "name":"\u041c\u0430\u0448\u0435\u043d\u043a\u0430",
      "longitude":83.8594972,
      "latitude":51.2559553
    },
    "11611":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u043a\u0440\u0430\u0439\u0447\u0438\u043a\u043e\u0432\u043e",
      "longitude":83.8996134,
      "latitude":53.9009792
    },
    "11612":{
      "name":"\u0421\u0442\u0430\u043d\u0446\u0438\u044f \u0411\u043e\u0440\u043e\u0432\u0438\u0445\u0430",
      "longitude":83.9141155,
      "latitude":53.4798312
    },
    "11613":{
      "name":"\u0413\u043e\u043b\u044b\u0448\u0435\u0432\u043e",
      "longitude":83.9223982,
      "latitude":53.6798421
    },
    "11614":{
      "name":"\u0422\u043e\u043a\u0430\u0440\u0451\u0432\u043e",
      "longitude":83.9467276,
      "latitude":53.4490803
    },
    "11615":{
      "name":"\u0412\u043e\u043b\u0433\u0430",
      "longitude":83.989685,
      "latitude":53.6302348
    },
    "11616":{
      "name":"\u0412\u0438\u0434\u043e\u043d\u043e\u0432\u043e",
      "longitude":84.060815,
      "latitude":53.9801757
    },
    "11617":{
      "name":"\u0421\u043e\u043b\u0434\u0430\u0442\u043e\u0432\u043e",
      "longitude":84.0725437,
      "latitude":52.3393005
    },
    "11618":{
      "name":"\u041f\u0443\u0440\u044b\u0441\u0435\u0432\u043e",
      "longitude":84.078087,
      "latitude":53.933342
    },
    "11619":{
      "name":"\u041f\u0430\u0440\u0442\u0438\u0437\u0430\u043d\u0441\u043a\u0438\u0439",
      "longitude":84.0792256,
      "latitude":51.7123843
    },
    "11620":{
      "name":"\u0422\u0430\u043b\u043e\u0432\u043a\u0430",
      "longitude":84.1274296,
      "latitude":53.7625635
    },
    "11621":{
      "name":"\u041b\u043e\u0441\u0438\u0445\u0430",
      "longitude":84.1288153,
      "latitude":53.3253421
    },
    "11622":{
      "name":"\u0421\u0430\u0434\u043e\u0432\u044b\u0439",
      "longitude":84.1297256,
      "latitude":51.7444913
    },
    "11623":{
      "name":"\u041f\u043e\u043a\u0440\u043e\u0432\u043a\u0430",
      "longitude":84.1353615,
      "latitude":53.3374406
    },
    "11624":{
      "name":"\u041b\u0435\u0431\u044f\u0436\u044c\u0435",
      "longitude":84.1392426,
      "latitude":53.8361966
    },
    "11625":{
      "name":"\u0423\u0442\u043a\u0438\u043d\u043e",
      "longitude":84.1419925,
      "latitude":52.5773048
    },
    "11626":{
      "name":"\u041a\u0430\u043c\u044b\u0448\u0435\u043d\u043a\u0430",
      "longitude":84.1539008,
      "latitude":53.976899
    },
    "11627":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u0412\u043e\u0441\u0442\u043e\u043a",
      "longitude":84.1556158,
      "latitude":52.1911688
    },
    "11628":{
      "name":"\u041c\u0430\u043b\u044b\u0439 \u041a\u0430\u043b\u0442\u0430\u0439",
      "longitude":84.1721691,
      "latitude":53.993682
    },
    "11629":{
      "name":"\u0411\u0435\u0448\u0435\u043d\u0446\u0435\u0432\u043e",
      "longitude":84.1817882,
      "latitude":53.518571
    },
    "11630":{
      "name":"\u041d\u043e\u0432\u044b\u0439 \u041c\u0438\u0440",
      "longitude":84.1904613,
      "latitude":53.4782512
    },
    "11631":{
      "name":"\u041a\u0430\u043b\u0438\u043d\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":84.1985511,
      "latitude":51.783361
    },
    "11632":{
      "name":"\u0421\u0442\u0435\u043f\u043d\u043e\u0439",
      "longitude":84.2053462,
      "latitude":53.6618667
    },
    "11633":{
      "name":"\u041d\u043e\u0433\u0438\u043d\u043e",
      "longitude":84.2252008,
      "latitude":53.9555465
    },
    "11634":{
      "name":"\u0412\u043e\u0441\u0445\u043e\u0434",
      "longitude":84.274002,
      "latitude":53.991505
    },
    "11635":{
      "name":"\u0422\u0430\u043b\u0438\u0446\u0430",
      "longitude":84.3052028,
      "latitude":54.1016784
    },
    "11636":{
      "name":"\u0411\u0430\u044e\u043d\u043e\u0432\u043e",
      "longitude":84.3177592,
      "latitude":53.2850381
    },
    "11637":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u043e\u043f\u044b\u043b\u043e\u0432\u043e",
      "longitude":84.3420761,
      "latitude":53.5038576
    },
    "11638":{
      "name":"\u0418\u043d\u044e\u0448\u043e\u0432\u043e",
      "longitude":84.344128,
      "latitude":53.6364157
    },
    "11639":{
      "name":"\u0413\u043e\u043b\u0443\u0431\u0446\u043e\u0432\u043e",
      "longitude":84.3464452,
      "latitude":53.5184733
    },
    "11640":{
      "name":"\u0412\u043e\u0441\u0445\u043e\u0434",
      "longitude":84.3613002,
      "latitude":53.3431325
    },
    "11641":{
      "name":"\u0420\u043e\u043c\u0430\u043d\u043e\u0432\u043e",
      "longitude":84.3723035,
      "latitude":53.2497507
    },
    "11642":{
      "name":"\u041b\u043e\u0433\u043e\u0432\u043e\u0435",
      "longitude":84.3743485,
      "latitude":53.2870201
    },
    "11643":{
      "name":"\u0413\u043e\u043b\u0443\u0431\u0446\u043e\u0432\u043e",
      "longitude":84.3810101,
      "latitude":53.5654038
    },
    "11644":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u041f\u043e\u0432\u0430\u043b\u0438\u0445\u0430",
      "longitude":84.3901233,
      "latitude":53.7524231
    },
    "11645":{
      "name":"\u0415\u043b\u0438\u043d\u043e\u0432\u043e",
      "longitude":84.3988777,
      "latitude":51.4063509
    },
    "11646":{
      "name":"\u0420\u044b\u0431\u043d\u043e\u0435",
      "longitude":84.4118547,
      "latitude":51.3829815
    },
    "11647":{
      "name":"\u041d\u043e\u0432\u043e\u0447\u0435\u0441\u043d\u043e\u043a\u043e\u0432\u043a\u0430",
      "longitude":84.4137429,
      "latitude":53.5000895
    },
    "11648":{
      "name":"\u0417\u0430\u0445\u0430\u0440\u043e\u0432\u043e",
      "longitude":84.4232258,
      "latitude":53.9710231
    },
    "11649":{
      "name":"\u0411\u0435\u0440\u0435\u0437\u043e\u0432\u043e",
      "longitude":84.4245804,
      "latitude":51.9444062
    },
    "11650":{
      "name":"\u042e\u0436\u0430\u043a\u043e\u0432\u043e",
      "longitude":84.4642567,
      "latitude":52.7950071
    },
    "11651":{
      "name":"\u041b\u0435\u0441\u043d\u043e\u0439",
      "longitude":84.4836432,
      "latitude":52.8452972
    },
    "11652":{
      "name":"\u041f\u0443\u0441\u0442\u044b\u043d\u044c",
      "longitude":84.4893074,
      "latitude":53.3554224
    },
    "11653":{
      "name":"\u041e\u0432\u0447\u0438\u043d\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":84.498962,
      "latitude":53.21521
    },
    "11654":{
      "name":"\u0411\u0430\u0440\u0441\u0443\u043a\u043e\u0432\u043e",
      "longitude":84.515613,
      "latitude":51.6160516
    },
    "11655":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u043c\u0430\u0439\u0441\u043a\u0438\u0439",
      "longitude":84.5283333,
      "latitude":52.1777453
    },
    "11656":{
      "name":"\u041b\u0435\u043d\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":84.5295573,
      "latitude":52.7620628
    },
    "11657":{
      "name":"\u041a\u043e\u043c\u0441\u043e\u043c\u043e\u043b\u044c\u0441\u043a\u0438\u0439",
      "longitude":84.5404764,
      "latitude":51.7958358
    },
    "11658":{
      "name":"\u041a\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":84.5589678,
      "latitude":53.8590668
    },
    "11659":{
      "name":"\u041a\u043e\u043c\u0441\u043e\u043c\u043e\u043b\u0435\u0446",
      "longitude":84.5607127,
      "latitude":53.1625293
    },
    "11660":{
      "name":"\u0417\u0430\u043f\u043b\u044b\u0432\u0438\u043d\u043e",
      "longitude":84.5737854,
      "latitude":53.938391
    },
    "11661":{
      "name":"\u0423\u0441\u0442\u044c-\u041a\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":84.5981907,
      "latitude":53.9578131
    },
    "11662":{
      "name":"\u0422\u043e\u0433-\u0410\u043b\u0442\u0430\u0439",
      "longitude":84.6097557,
      "latitude":51.442939
    },
    "11663":{
      "name":"\u0417\u0435\u043b\u0451\u043d\u0430\u044f \u0420\u043e\u0449\u0430",
      "longitude":84.6196772,
      "latitude":53.1596556
    },
    "11664":{
      "name":"\u0413\u0443\u043d\u0438\u0445\u0430",
      "longitude":84.6519905,
      "latitude":54.1986074
    },
    "11665":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u0422\u0438\u0445\u0430\u044f",
      "longitude":84.6648532,
      "latitude":51.791105
    },
    "11666":{
      "name":"\u0421\u043c\u0438\u0440\u043d\u043e\u0432\u043e",
      "longitude":84.671127,
      "latitude":53.692829
    },
    "11667":{
      "name":"\u0417\u0430\u0433\u043e\u043d\u043d\u044b\u0439",
      "longitude":84.6744465,
      "latitude":53.5946329
    },
    "11668":{
      "name":"\u041b\u0443\u0447\u0435\u0432\u043e\u0435",
      "longitude":84.6748212,
      "latitude":53.3272678
    },
    "11669":{
      "name":"\u0417\u0430\u0433\u0430\u0439\u043d\u043e\u0432\u043e",
      "longitude":84.678165,
      "latitude":52.8931673
    },
    "11670":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u0433\u043b\u0443\u0448\u0438\u043d\u043a\u0430",
      "longitude":84.6914246,
      "latitude":53.7921306
    },
    "11671":{
      "name":"\u0418\u043d\u0434\u0435\u0439\u043a\u0430",
      "longitude":84.7079543,
      "latitude":53.2126374
    },
    "11672":{
      "name":"\u0427\u0435\u0433\u043e\u043d",
      "longitude":84.7083171,
      "latitude":51.4631561
    },
    "11673":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u0440\u0430\u0441\u0438\u043b\u043e\u0432\u043e",
      "longitude":84.7228446,
      "latitude":53.7702849
    },
    "11674":{
      "name":"\u041c\u0443\u0440\u0430\u0432\u0435\u0439",
      "longitude":84.7279927,
      "latitude":53.8949038
    },
    "11675":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u043c\u043e\u043b\u0435\u043d\u043a\u0430",
      "longitude":84.7330979,
      "latitude":52.2357485
    },
    "11676":{
      "name":"\u0414\u0451\u043c\u0438\u043d\u043e",
      "longitude":84.742744,
      "latitude":51.56279
    },
    "11677":{
      "name":"\u0411\u0443\u043b\u0430\u0442\u043e\u0432\u043e",
      "longitude":84.7524509,
      "latitude":51.7478172
    },
    "11678":{
      "name":"\u0412\u0435\u0440\u0445-\u0411\u043e\u0431\u0440\u043e\u0432\u043a\u0430",
      "longitude":84.7760943,
      "latitude":53.1877075
    },
    "11679":{
      "name":"\u041a\u0430\u0437\u0430\u043d\u043a\u0430",
      "longitude":84.7903013,
      "latitude":51.6730251
    },
    "11680":{
      "name":"\u0421\u0442\u0430\u0440\u043e\u043a\u043e\u043f\u044b\u043b\u043e\u0432\u043e",
      "longitude":84.797791,
      "latitude":53.7962013
    },
    "11681":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u0430\u044f \u0420\u043e\u0449\u0430",
      "longitude":84.8032116,
      "latitude":52.6782198
    },
    "11682":{
      "name":"\u0411\u0430\u0442\u0443\u043d\u043d\u0430\u044f",
      "longitude":84.8097109,
      "latitude":53.6554166
    },
    "11683":{
      "name":"\u0411\u0443\u043b\u0430\u043d\u0438\u0445\u0430",
      "longitude":84.814128,
      "latitude":52.7923661
    },
    "11684":{
      "name":"\u041d\u043e\u0432\u043e\u0437\u044b\u0440\u044f\u043d\u043a\u0430",
      "longitude":84.8242463,
      "latitude":53.4328743
    },
    "11685":{
      "name":"\u041f\u0430\u0440\u0438\u0436\u0441\u043a\u0430\u044f \u041a\u043e\u043c\u043c\u0443\u043d\u0430",
      "longitude":84.8415171,
      "latitude":52.8067327
    },
    "11686":{
      "name":"\u041f\u0440\u043e\u043b\u0435\u0442\u0430\u0440\u0441\u043a\u0430\u044f \u041a\u0440\u0435\u043f\u043e\u0441\u0442\u044c",
      "longitude":84.8546439,
      "latitude":54.0119066
    },
    "11687":{
      "name":"\u0423\u0442\u043a\u0443\u043b\u044c",
      "longitude":84.8561974,
      "latitude":52.7404841
    },
    "11688":{
      "name":"\u0421\u043e\u0445\u0430\u0440\u0435\u0432\u043e",
      "longitude":84.8571701,
      "latitude":53.3097829
    },
    "11689":{
      "name":"\u041e\u043c\u0443\u0442\u043d\u0430\u044f",
      "longitude":84.8648079,
      "latitude":53.6399752
    },
    "11690":{
      "name":"\u0416\u0430\u0432\u043e\u0440\u043e\u043d\u043a\u043e\u0432\u043e",
      "longitude":84.8890368,
      "latitude":52.5061932
    },
    "11691":{
      "name":"\u0421\u0432\u0435\u043a\u043b\u043e\u0432\u0438\u0447\u043d\u044b\u0439",
      "longitude":84.8926101,
      "latitude":52.7273449
    },
    "11692":{
      "name":"\u0417\u0443\u0434\u0438\u043b\u043e\u0432\u043e",
      "longitude":84.895137,
      "latitude":53.5472706
    },
    "11693":{
      "name":"\u0423\u0440\u043e\u0436\u0430\u0439\u043d\u044b\u0439",
      "longitude":84.9241536,
      "latitude":52.7113578
    },
    "11694":{
      "name":"\u0412\u043e\u0441\u0445\u043e\u0434",
      "longitude":84.9576934,
      "latitude":52.7253302
    },
    "11695":{
      "name":"\u041c\u043e\u043b\u043e\u0447\u043d\u044b\u0439",
      "longitude":84.9737939,
      "latitude":52.4117251
    },
    "11696":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u044c\u0441\u043a\u043e\u0435",
      "longitude":84.9871189,
      "latitude":51.795309
    },
    "11697":{
      "name":"\u0420\u0435\u0447\u043d\u043e\u0439",
      "longitude":84.9926297,
      "latitude":52.3110847
    },
    "11698":{
      "name":"\u041c\u0430\u0442\u043e\u0447\u043d\u044b\u0439",
      "longitude":84.9975658,
      "latitude":52.4232626
    },
    "11699":{
      "name":"\u0428\u0438\u0440\u043e\u043a\u0438\u0439 \u041b\u0443\u0433",
      "longitude":85.0018765,
      "latitude":53.861428
    },
    "11700":{
      "name":"\u0420\u0430\u0437\u0434\u043e\u043b\u044c\u043d\u044b\u0439",
      "longitude":85.0100514,
      "latitude":52.3018094
    },
    "11701":{
      "name":"\u0424\u0438\u043b\u0430\u0442\u043e\u0432\u043e",
      "longitude":85.013049,
      "latitude":53.2898569
    },
    "11702":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u044c\u0441\u043a\u0438\u0439",
      "longitude":85.0207104,
      "latitude":54.055883
    },
    "11703":{
      "name":"\u041a\u043e\u043a\u043e\u0440\u0441\u043a\u0438\u0439",
      "longitude":85.0360601,
      "latitude":53.7486263
    },
    "11704":{
      "name":"\u041c\u0438\u0445\u0430\u0439\u043b\u043e\u0432\u043a\u0430",
      "longitude":85.0404083,
      "latitude":52.2813765
    },
    "11705":{
      "name":"\u041a\u0438\u0440\u043f\u0438\u0447\u043d\u044b\u0439",
      "longitude":85.040814,
      "latitude":52.4180294
    },
    "11706":{
      "name":"\u0414\u0430\u043d\u0438\u043b\u043e\u0432\u043a\u0430",
      "longitude":85.0551063,
      "latitude":51.976779
    },
    "11707":{
      "name":"\u041d\u0435\u0444\u0442\u0435\u0431\u0430\u0437\u0430",
      "longitude":85.0791702,
      "latitude":52.4249707
    },
    "11708":{
      "name":"\u0422\u0430\u043b\u0434\u0438\u043d\u043a\u0430",
      "longitude":85.0839588,
      "latitude":53.1318429
    },
    "11709":{
      "name":"\u041d\u043e\u0432\u043e\u043a\u044b\u0442\u043c\u0430\u043d\u043e\u0432\u043e",
      "longitude":85.089569,
      "latitude":53.333858
    },
    "11710":{
      "name":"\u0418\u043a\u043e\u043d\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":85.0907851,
      "latitude":52.4319595
    },
    "11711":{
      "name":"\u0417\u0430\u043b\u0435\u0441\u0438\u0445\u0430",
      "longitude":85.1074539,
      "latitude":53.8838976
    },
    "11712":{
      "name":"\u0410\u0432\u0434\u0435\u0435\u0432\u0441\u043a\u0430\u044f \u0411\u0430\u0437\u0430",
      "longitude":85.1120881,
      "latitude":53.8397974
    },
    "11713":{
      "name":"\u041c\u0435\u0436\u0434\u0443\u0440\u0435\u0447\u044c\u0435",
      "longitude":85.1243526,
      "latitude":52.4246112
    },
    "11714":{
      "name":"\u041d\u043e\u0432\u044b\u0439 \u0411\u044b\u0442",
      "longitude":85.1295644,
      "latitude":52.7202044
    },
    "11715":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u041c\u0430\u044f\u043a",
      "longitude":85.1432201,
      "latitude":52.3811683
    },
    "11716":{
      "name":"\u041a\u0430\u043c\u0435\u043d\u0443\u0448\u043a\u0430",
      "longitude":85.1445973,
      "latitude":53.906089
    },
    "11717":{
      "name":"\u041d\u043e\u0432\u043e\u0434\u0440\u0435\u0441\u0432\u044f\u043d\u043a\u0430",
      "longitude":85.1769018,
      "latitude":53.9878354
    },
    "11718":{
      "name":"\u0421\u0442\u0443\u0434\u0435\u043d\u0447\u0435\u0441\u043a\u0438\u0439",
      "longitude":85.2032026,
      "latitude":52.6063768
    },
    "11719":{
      "name":"\u041a\u0430\u0437\u0430\u043d\u0446\u0435\u0432\u043e",
      "longitude":85.203888,
      "latitude":53.861374
    },
    "11720":{
      "name":"\u0417\u043c\u0430\u0437\u043d\u0435\u0432\u043e",
      "longitude":85.2159767,
      "latitude":53.8086923
    },
    "11721":{
      "name":"\u041b\u0430\u0440\u0438\u043e\u043d\u043e\u0432\u043e",
      "longitude":85.248915,
      "latitude":53.6140477
    },
    "11722":{
      "name":"\u0410\u0444\u043e\u043d\u0438\u043d\u043e",
      "longitude":85.2500329,
      "latitude":53.7721458
    },
    "11723":{
      "name":"\u0417\u0430\u0440\u0435\u0447\u043d\u044b\u0439",
      "longitude":85.2624105,
      "latitude":52.4519929
    },
    "11724":{
      "name":"\u041a\u043b\u0430\u0431\u0443\u043a\u043e\u0432\u043a\u0430",
      "longitude":85.2625483,
      "latitude":54.0698833
    },
    "11725":{
      "name":"\u042f\u0433\u043e\u0434\u043d\u044b\u0439",
      "longitude":85.27185,
      "latitude":52.6349797
    },
    "11726":{
      "name":"\u0427\u0435\u0440\u043a\u0430\u0441\u043e\u0432\u043e",
      "longitude":85.2776902,
      "latitude":53.2595792
    },
    "11727":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u041e\u043a\u0442\u044f\u0431\u0440\u044c",
      "longitude":85.2978381,
      "latitude":52.6910747
    },
    "11728":{
      "name":"\u041f\u0443\u0442\u044c \u041b\u0435\u043d\u0438\u043d\u0438\u0437\u043c\u0430",
      "longitude":85.3016202,
      "latitude":52.8206812
    },
    "11729":{
      "name":"\u041b\u0435\u043d\u0438\u043d\u0441\u043a\u043e\u0435",
      "longitude":85.3034977,
      "latitude":52.2903667
    },
    "11730":{
      "name":"\u0417\u0430\u0440\u0435\u0447\u043d\u043e\u0435",
      "longitude":85.3252199,
      "latitude":53.5877016
    },
    "11731":{
      "name":"\u0421\u043e\u043b\u043d\u0435\u0447\u043d\u0430\u044f \u041f\u043e\u043b\u044f\u043d\u0430",
      "longitude":85.3300642,
      "latitude":52.5441554
    },
    "11732":{
      "name":"\u0413\u043e\u0440\u044e\u0448\u0438\u043d\u043e",
      "longitude":85.330399,
      "latitude":53.883808
    },
    "11733":{
      "name":"\u041a\u0430\u043b\u0438\u043d\u043e\u0432\u0441\u043a\u0438\u0439",
      "longitude":85.3402419,
      "latitude":53.5401952
    },
    "11734":{
      "name":"\u041f\u0435\u0442\u0440\u0443\u0448\u0438\u0445\u0430",
      "longitude":85.3421536,
      "latitude":53.497934
    },
    "11735":{
      "name":"\u0426\u0435\u043b\u0438\u043d\u043d\u044b\u0439",
      "longitude":85.3424924,
      "latitude":53.2664237
    },
    "11736":{
      "name":"\u0420\u0443\u0434\u043d\u0438\u043a",
      "longitude":85.3451056,
      "latitude":51.8488658
    },
    "11737":{
      "name":"\u0421\u043e\u0441\u043d\u043e\u0432\u043a\u0430",
      "longitude":85.3549947,
      "latitude":52.4400687
    },
    "11738":{
      "name":"\u0411\u043e\u043b\u044c\u0448\u0430\u044f \u041a\u044b\u0440\u043a\u044b\u043b\u0430",
      "longitude":85.3581535,
      "latitude":51.7618888
    },
    "11739":{
      "name":"\u041a\u0443\u0440\u044c\u044f",
      "longitude":85.362574,
      "latitude":53.4743569
    },
    "11740":{
      "name":"\u041f\u0440\u043e\u043b\u0435\u0442\u0430\u0440\u043a\u0430",
      "longitude":85.3639089,
      "latitude":51.7962401
    },
    "11741":{
      "name":"\u041a\u043e\u043c\u0430\u0440",
      "longitude":85.3888935,
      "latitude":51.7108298
    },
    "11742":{
      "name":"\u0411\u0443\u043b\u0443\u0445\u0442\u0430",
      "longitude":85.4004708,
      "latitude":51.5924501
    },
    "11743":{
      "name":"\u0411\u0435\u0441\u043f\u0430\u043b\u043e\u0432\u043e",
      "longitude":85.4011219,
      "latitude":53.4835249
    },
    "11744":{
      "name":"\u041c\u0430\u043b\u0438\u043d\u043e\u0432\u043a\u0430",
      "longitude":85.403145,
      "latitude":53.913544
    },
    "11745":{
      "name":"\u0411\u0430\u0441\u0430\u0440\u0433\u0438\u043d\u043e",
      "longitude":85.423317,
      "latitude":51.734386
    },
    "11746":{
      "name":"\u041c\u043e\u0441\u0442\u043e\u0432\u043e\u0439",
      "longitude":85.4255275,
      "latitude":53.75904
    },
    "11747":{
      "name":"\u041c\u0438\u0440\u043e\u043d\u043e\u0432\u043a\u0430",
      "longitude":85.435844,
      "latitude":53.804764
    },
    "11748":{
      "name":"\u041a\u044b\u0442\u043c\u0430\u043d\u0443\u0448\u043a\u0430",
      "longitude":85.4458903,
      "latitude":53.4732235
    },
    "11749":{
      "name":"\u0427\u0435\u0440\u0435\u043c\u0448\u0430\u043d\u043a\u0430",
      "longitude":85.4469341,
      "latitude":51.7566906
    },
    "11750":{
      "name":"\u0411\u0435\u0440\u0451\u0437\u043e\u0432\u0430\u044f \u0413\u043e\u0440\u043a\u0430",
      "longitude":85.4633474,
      "latitude":52.7198081
    },
    "11751":{
      "name":"\u0411\u043e\u0440\u043e\u0432\u043b\u044f\u043d\u043a\u0430",
      "longitude":85.470154,
      "latitude":53.875896
    },
    "11752":{
      "name":"\u0423\u0441\u0442\u044c-\u0411\u043e\u0440\u043e\u0443\u0439\u0441\u043a",
      "longitude":85.4742373,
      "latitude":53.6606342
    },
    "11753":{
      "name":"\u0417\u0430\u043e\u0437\u0451\u0440\u043d\u044b\u0439",
      "longitude":85.4835163,
      "latitude":52.5338984
    },
    "11754":{
      "name":"\u041c\u0438\u0448\u0438\u0445\u0430",
      "longitude":85.5548179,
      "latitude":53.7415554
    },
    "11755":{
      "name":"\u0410\u043d\u0430\u0442\u043e\u043b\u0438\u044f",
      "longitude":85.5580004,
      "latitude":53.8966235
    },
    "11756":{
      "name":"\u041f\u043e\u043b\u0435\u0432\u043e\u0434\u043a\u0430",
      "longitude":85.5655491,
      "latitude":52.4297524
    },
    "11757":{
      "name":"\u0423\u043b\u0443\u0441-\u0422\u0430\u0440\u0430\u0431\u0430",
      "longitude":85.5786903,
      "latitude":53.4047298
    },
    "11758":{
      "name":"\u041a\u0430\u0440\u0430\u0441\u0443\u043a",
      "longitude":85.5871515,
      "latitude":52.3858431
    },
    "11759":{
      "name":"\u0412\u0440\u0443\u0431\u043b\u0451\u0432\u0441\u043a\u0438\u0439",
      "longitude":85.6074303,
      "latitude":53.7719582
    },
    "11760":{
      "name":"\u042f\u0441\u0430\u0448\u0438\u043d\u043e",
      "longitude":85.6086743,
      "latitude":53.4450634
    },
    "11761":{
      "name":"\u0423\u0441\u043a\u043e\u0432\u043e",
      "longitude":85.6138696,
      "latitude":53.7041671
    },
    "11762":{
      "name":"\u041d\u043e\u0432\u043e\u043e\u0437\u0451\u0440\u043d\u043e\u0435",
      "longitude":85.618011,
      "latitude":53.476639
    },
    "11763":{
      "name":"\u0421\u0442\u0435\u043f\u043d\u043e\u0439",
      "longitude":85.6430817,
      "latitude":52.7467722
    },
    "11764":{
      "name":"\u041a\u043b\u044e\u0447\u0438",
      "longitude":85.6455509,
      "latitude":52.590735
    },
    "11765":{
      "name":"\u041e\u0442\u0440\u0430\u0434\u043d\u043e\u0435",
      "longitude":85.6565338,
      "latitude":53.6849216
    },
    "11766":{
      "name":"\u041f\u0440\u0435\u0434\u0433\u043e\u0440\u043d\u044b\u0439",
      "longitude":85.6665343,
      "latitude":52.4900095
    },
    "11767":{
      "name":"\u041d\u043e\u0432\u043e\u0434\u0443\u043f\u043b\u0438\u043d\u043a\u0430",
      "longitude":85.6744496,
      "latitude":53.4523927
    },
    "11768":{
      "name":"\u041b\u0435\u0431\u0435\u0434\u0438\u043d\u044b\u0439",
      "longitude":85.6751485,
      "latitude":52.3030888
    },
    "11769":{
      "name":"\u041d\u043e\u0432\u043e\u0445\u043c\u0435\u043b\u0451\u0432\u043a\u0430",
      "longitude":85.6928788,
      "latitude":53.6175355
    },
    "11770":{
      "name":"\u041c\u0430\u043b\u044c\u0446\u0435\u0432\u0430 \u041a\u0443\u0440\u044c\u044f",
      "longitude":85.6961902,
      "latitude":52.5791913
    },
    "11771":{
      "name":"\u041a\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":85.7122065,
      "latitude":53.5397251
    },
    "11772":{
      "name":"\u041e\u0431\u0440\u0430\u0437\u0446\u043e\u0432\u043a\u0430",
      "longitude":85.7923389,
      "latitude":52.383579
    },
    "11773":{
      "name":"\u0411\u0443\u0440\u0430\u043d\u043e\u0432\u043e",
      "longitude":85.8025123,
      "latitude":53.387079
    },
    "11774":{
      "name":"\u0425\u0443\u0442\u043e\u0440\u043a\u0438",
      "longitude":85.8030902,
      "latitude":52.2624879
    },
    "11775":{
      "name":"\u0411\u0435\u0445\u0442\u0435\u043c\u0438\u0440-\u0410\u043d\u0438\u043a\u0438\u043d\u043e",
      "longitude":85.8033982,
      "latitude":52.6539311
    },
    "11776":{
      "name":"\u0410\u043a\u0441\u0451\u043d\u043e\u0432\u043e",
      "longitude":85.8775717,
      "latitude":53.2636777
    },
    "11777":{
      "name":"\u041c\u043e\u0441\u0442 \u0418\u0448\u0430",
      "longitude":85.8848497,
      "latitude":52.2066131
    },
    "11778":{
      "name":"\u0414\u043e\u043b\u0438\u043d\u0430 \u0421\u0432\u043e\u0431\u043e\u0434\u044b",
      "longitude":85.9244005,
      "latitude":52.1189722
    },
    "11779":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u0421\u0443\u0440\u0442\u0430\u0439\u043a\u0430",
      "longitude":85.9552256,
      "latitude":52.2236578
    },
    "11780":{
      "name":"\u0411\u0440\u0430\u0433\u0438\u043d\u043e",
      "longitude":85.9659254,
      "latitude":53.2161377
    },
    "11781":{
      "name":"\u041c\u043d\u043e\u0433\u043e\u043f\u043e\u043b\u044c\u043d\u043e\u0435",
      "longitude":85.9702702,
      "latitude":52.4046334
    },
    "11782":{
      "name":"\u0428\u0443\u043c\u0438\u0445\u0430",
      "longitude":85.9967619,
      "latitude":53.6189635
    },
    "11783":{
      "name":"\u041f\u0440\u043e\u043c\u044b\u0448\u043b\u0435\u043d\u043d\u044b\u0439",
      "longitude":86.0035542,
      "latitude":52.6129258
    },
    "11784":{
      "name":"\u0413\u043e\u0440\u043d\u044b\u0439",
      "longitude":86.0695748,
      "latitude":52.1608945
    },
    "11785":{
      "name":"\u041a\u0430\u043c\u0435\u043d\u043a\u0430",
      "longitude":86.0790075,
      "latitude":52.4751494
    },
    "11786":{
      "name":"\u0427\u0435\u0441\u043d\u043e\u043a\u043e\u0432\u043e",
      "longitude":86.0990412,
      "latitude":53.0798932
    },
    "11787":{
      "name":"\u041c\u0430\u043d\u0443\u0438\u043b\u044c\u0441\u043a\u043e\u0435",
      "longitude":86.1214924,
      "latitude":52.3076674
    },
    "11788":{
      "name":"\u041b\u0443\u0433\u043e\u0432\u043e\u0435",
      "longitude":86.1333455,
      "latitude":52.343557
    },
    "11789":{
      "name":"\u0412\u0435\u0440\u0445-\u041a\u0430\u0436\u0430",
      "longitude":86.157275,
      "latitude":52.3982196
    },
    "11790":{
      "name":"\u0423\u0436\u043b\u0435\u043f",
      "longitude":86.1947463,
      "latitude":52.2500807
    },
    "11791":{
      "name":"\u041f\u0438\u043b\u044c\u043d\u043e",
      "longitude":86.2307885,
      "latitude":52.4830478
    },
    "11792":{
      "name":"\u0415\u0433\u043e\u043d\u0430",
      "longitude":86.2458244,
      "latitude":52.3329612
    },
    "11793":{
      "name":"\u041a\u0443\u0440\u043b\u0435\u043a",
      "longitude":86.254746,
      "latitude":52.2131709
    },
    "11794":{
      "name":"\u0418\u0440\u0442\u044b\u0448\u043a\u0438\u043d\u043e",
      "longitude":86.2800661,
      "latitude":52.4105737
    },
    "11795":{
      "name":"\u041a\u0430\u0440\u0430\u0433\u0430\u0439\u043a\u0430",
      "longitude":86.3042414,
      "latitude":52.2509076
    },
    "11796":{
      "name":"\u0427\u0430\u043f\u0448\u0430",
      "longitude":86.3062339,
      "latitude":52.3633391
    },
    "11797":{
      "name":"\u0422\u0430\u0439\u043d\u0430",
      "longitude":86.3449571,
      "latitude":52.1864505
    },
    "11798":{
      "name":"\u0410\u043d\u0430\u043c\u0430\u0441",
      "longitude":86.3638284,
      "latitude":53.1201956
    },
    "11799":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":86.3908377,
      "latitude":52.2217474
    },
    "11800":{
      "name":"\u041a\u0430\u0436\u0430",
      "longitude":86.3919176,
      "latitude":52.4568284
    },
    "11801":{
      "name":"\u0421\u0442\u0430\u0440\u0430\u044f \u0410\u0436\u0438\u043d\u043a\u0430",
      "longitude":86.3931155,
      "latitude":52.6411513
    },
    "11802":{
      "name":"\u0411\u0435\u0434\u0440\u0435\u043f",
      "longitude":86.4202348,
      "latitude":53.3483608
    },
    "11803":{
      "name":"\u041a\u0430\u043b\u0442\u044b\u043a",
      "longitude":86.4316866,
      "latitude":53.2308555
    },
    "11804":{
      "name":"\u041c\u0430\u043a\u0430\u0440\u044c\u0435\u0432\u0441\u043a\u043e\u0435",
      "longitude":86.4572712,
      "latitude":52.5524587
    },
    "11805":{
      "name":"\u0427\u0438\u0441\u0442\u0430\u044f \u0413\u0440\u0438\u0432\u0430",
      "longitude":86.4596663,
      "latitude":53.1921807
    },
    "11806":{
      "name":"\u041a\u0430\u043b\u0442\u0430\u0448",
      "longitude":86.4691043,
      "latitude":52.3570398
    },
    "11807":{
      "name":"\u041a\u0430\u0440\u0430\u043a\u0430\u043d",
      "longitude":86.4748141,
      "latitude":52.9654851
    },
    "11808":{
      "name":"\u0422\u0440\u043e\u0438\u0446\u043a",
      "longitude":86.5023131,
      "latitude":53.15418
    },
    "11809":{
      "name":"\u0421\u043e\u0441\u043d\u043e\u0432\u043a\u0430",
      "longitude":86.5434452,
      "latitude":52.578042
    },
    "11810":{
      "name":"\u041a\u0438\u0447\u0435\u043a",
      "longitude":86.5500358,
      "latitude":52.759056
    },
    "11811":{
      "name":"\u0411\u0430\u043b\u044b\u043a\u0441\u0430",
      "longitude":86.5585339,
      "latitude":52.5447623
    },
    "11812":{
      "name":"\u041f\u043e\u0441\u043b\u0435\u0434\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":86.567533,
      "latitude":53.1925591
    },
    "11813":{
      "name":"\u0411\u0430\u0445\u0442\u0430",
      "longitude":86.5838653,
      "latitude":53.1544601
    },
    "11814":{
      "name":"\u0412\u044f\u0442\u0441\u043a",
      "longitude":86.5847601,
      "latitude":53.2659909
    },
    "11815":{
      "name":"\u041a\u0430\u0437\u0430\u043d\u0441\u043a",
      "longitude":86.6109757,
      "latitude":53.2236066
    },
    "11816":{
      "name":"\u041a\u0435\u0434\u0440\u043e\u0432\u043a\u0430",
      "longitude":86.6548,
      "latitude":53.0531099
    },
    "11817":{
      "name":"\u0412\u043e\u0437\u043d\u0435\u0441\u0435\u043d\u043a\u0430",
      "longitude":86.697641,
      "latitude":52.7879352
    },
    "11818":{
      "name":"\u041d\u043e\u0432\u043e\u0442\u0440\u043e\u0438\u0446\u043a",
      "longitude":86.740118,
      "latitude":52.7906161
    },
    "11819":{
      "name":"\u0428\u0430\u0431\u0443\u0440\u043e\u0432\u043e",
      "longitude":86.8025769,
      "latitude":52.7991213
    },
    "11820":{
      "name":"\u0410\u0444\u043e\u043d\u0438\u043d\u043e",
      "longitude":86.9009504,
      "latitude":53.0021835
    },
    "11821":{
      "name":"\u0428\u0430\u0441\u043d\u0443\u0440",
      "longitude":99.504456,
      "latitude":52.671234
    },
    "11822":{
      "name":"\u0428\u0430\u0440\u0437\u0430",
      "longitude":99.51252,
      "latitude":52.711807
    },
    "11823":{
      "name":"\u0411\u0430\u043b\u0430\u043a\u0442\u0430",
      "longitude":99.6996991,
      "latitude":52.4937706
    },
    "11824":{
      "name":"\u0425\u0430\u0440\u0430-\u0425\u0443\u0436\u0438\u0440",
      "longitude":99.7162188,
      "latitude":52.6045265
    },
    "11825":{
      "name":"\u0425\u0443\u0440\u0433\u0430",
      "longitude":99.901367,
      "latitude":52.374924
    },
    "11826":{
      "name":"\u0421\u0443\u0431\u0430\u0440\u044f",
      "longitude":99.9360025,
      "latitude":52.1146647
    },
    "11827":{
      "name":"\u0414\u0435\u0431\u0433\u044d\u043a",
      "longitude":100.0069853,
      "latitude":52.8239718
    },
    "11828":{
      "name":"\u0410\u043b\u0430\u0433-\u0428\u0443\u043b\u0443\u043d",
      "longitude":100.111954,
      "latitude":52.830215
    },
    "11829":{
      "name":"\u0411\u043e\u043a\u0441\u043e\u043d",
      "longitude":100.330078,
      "latitude":52.162697
    },
    "11830":{
      "name":"\u0411\u043e\u0442\u043e\u0433\u043e\u043b",
      "longitude":100.738121,
      "latitude":52.371872
    },
    "11831":{
      "name":"\u0417\u0443\u043d-\u0425\u043e\u043b\u0431\u0430",
      "longitude":100.9588261,
      "latitude":52.1614133
    },
    "11832":{
      "name":"\u0421\u0430\u043c\u0430\u0440\u0442\u0430",
      "longitude":101.139145,
      "latitude":52.102329
    },
    "11833":{
      "name":"\u043f\u043e\u0441\u0435\u043b\u043e\u043a \u041e\u0441\u043f\u0438\u043d",
      "longitude":101.3702336,
      "latitude":52.1550161
    },
    "11834":{
      "name":"\u041c\u043e\u0439\u0433\u043e\u0442\u044b",
      "longitude":101.3959099,
      "latitude":51.6476682
    },
    "11835":{
      "name":"\u041c\u043e\u0433\u043e\u0439-\u0413\u043e\u0440\u0445\u043e\u043d",
      "longitude":102.07856,
      "latitude":51.672119
    },
    "11836":{
      "name":"\u0415\u043d\u0433\u043e\u0440\u0433\u0430",
      "longitude":102.103737,
      "latitude":51.77108
    },
    "11837":{
      "name":"\u041d\u0443\u0433\u0430\u043d",
      "longitude":102.197929,
      "latitude":51.692787
    },
    "11838":{
      "name":"\u0423\u043b\u0431\u0443\u0433\u0430\u0439",
      "longitude":102.315483,
      "latitude":51.803612
    },
    "11839":{
      "name":"\u041c\u0430\u043b\u044b\u0439 \u0416\u0435\u043c\u0447\u0443\u0433",
      "longitude":102.361504,
      "latitude":51.686485
    },
    "11840":{
      "name":"\u0423\u043b\u0430\u043d-\u0413\u043e\u0440\u0445\u043e\u043d",
      "longitude":102.520821,
      "latitude":51.670242
    },
    "11841":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u044c\u0441\u043a",
      "longitude":102.574982,
      "latitude":51.730904
    },
    "11842":{
      "name":"\u0410\u0445\u0430\u043b\u0438\u043a",
      "longitude":102.675667,
      "latitude":51.787308
    },
    "11843":{
      "name":"\u0415\u043b\u043e\u0432\u043a\u0430",
      "longitude":102.75528,
      "latitude":51.759392
    },
    "11844":{
      "name":"\u0428\u0430\u043d\u0430\u0439",
      "longitude":102.857224,
      "latitude":51.751968
    },
    "11845":{
      "name":"\u0413\u0443\u0436\u0438\u0440\u044b",
      "longitude":102.893463,
      "latitude":51.791492
    },
    "11846":{
      "name":"\u0425\u0430\u0441\u0443\u0440\u0430",
      "longitude":103.285698,
      "latitude":50.32552
    },
    "11847":{
      "name":"\u0412\u044b\u0434\u0440\u0438\u043d\u043e",
      "longitude":104.643913,
      "latitude":51.445446
    },
    "11848":{
      "name":"\u0425\u0443\u043b\u0434\u0430\u0442",
      "longitude":104.68969,
      "latitude":50.489239
    },
    "11849":{
      "name":"\u0422\u043e\u043b\u0431\u0430\u0437\u0438\u0445\u0430",
      "longitude":104.692703,
      "latitude":51.445496
    },
    "11850":{
      "name":"\u041f\u043e\u0434\u0445\u0443\u043b\u0434\u043e\u0447\u0438",
      "longitude":104.718689,
      "latitude":50.599716
    },
    "11851":{
      "name":"\u0428\u0430\u0440\u0442\u044b\u043a\u0435\u0439",
      "longitude":104.8024875,
      "latitude":50.5132632
    },
    "11852":{
      "name":"\u0420\u0435\u0447\u043a\u0430 \u0412\u044b\u0434\u0440\u0438\u043d\u043e",
      "longitude":104.847404,
      "latitude":51.486988
    },
    "11853":{
      "name":"\u041a\u0435\u0434\u0440\u043e\u0432\u0430\u044f",
      "longitude":104.929176,
      "latitude":51.512924
    },
    "11854":{
      "name":"\u0421\u0442\u0430\u0440\u044b\u0439 \u0423\u043a\u044b\u0440\u0447\u0435\u043b\u043e\u043d",
      "longitude":104.976425,
      "latitude":50.512009
    },
    "11855":{
      "name":"\u0422\u043e\u0445\u043e\u0439",
      "longitude":105.002258,
      "latitude":50.49749
    },
    "11856":{
      "name":"\u0422\u044d\u043d\u0433\u044d\u0440\u044d\u043a",
      "longitude":105.120102,
      "latitude":50.484383
    },
    "11857":{
      "name":"\u041c\u0435\u043b\u044c\u043d\u0438\u0446\u0430",
      "longitude":105.138992,
      "latitude":50.496494
    },
    "11858":{
      "name":"\u0411\u0430\u044f\u043d",
      "longitude":105.280693,
      "latitude":50.546165
    },
    "11859":{
      "name":"\u041f\u0440\u0438\u0431\u043e\u0439",
      "longitude":105.419754,
      "latitude":51.605858
    },
    "11860":{
      "name":"\u0420\u0435\u0447\u043a\u0430 \u041c\u0438\u0448\u0438\u0445\u0430",
      "longitude":105.532913,
      "latitude":51.641815
    },
    "11861":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u0415\u043d\u0445\u043e\u0440",
      "longitude":105.72435,
      "latitude":50.481651
    },
    "11862":{
      "name":"\u0418\u0432\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":105.728951,
      "latitude":51.683189
    },
    "11863":{
      "name":"\u041d\u044e\u0433\u0443\u0439",
      "longitude":105.755707,
      "latitude":50.52454
    },
    "11864":{
      "name":"\u0423\u0441\u0442\u044c-\u0423\u0440\u043c\u0430",
      "longitude":105.9772085,
      "latitude":51.052671
    },
    "11865":{
      "name":"\u041c\u0430\u043d\u0442\u0443\u0440\u0438\u0445\u0430",
      "longitude":105.9804839,
      "latitude":51.7770346
    },
    "11866":{
      "name":"\u0423\u0434\u0443\u043d\u0433\u0430",
      "longitude":105.9827875,
      "latitude":51.1269595
    },
    "11867":{
      "name":"\u0421\u043e\u0441\u043d\u043e\u0432\u043a\u0430",
      "longitude":106.0102125,
      "latitude":50.8830819
    },
    "11868":{
      "name":"\u0425\u0443\u0436\u0438\u0440",
      "longitude":106.197495,
      "latitude":50.573051
    },
    "11869":{
      "name":"\u0411\u0430\u0439\u043a\u0430\u043b\u044c\u0441\u043a\u0438\u0439 \u041f\u0440\u0438\u0431\u043e\u0439",
      "longitude":106.2014635,
      "latitude":51.9369097
    },
    "11870":{
      "name":"\u0428\u0430\u043d\u0430",
      "longitude":106.2098955,
      "latitude":50.9292768
    },
    "11871":{
      "name":"\u0418\u0441\u0442\u043e\u043a",
      "longitude":106.256203,
      "latitude":52.097443
    },
    "11872":{
      "name":"\u041c\u043e\u0441\u0442 \u0422\u0435\u043c\u043d\u0438\u043a",
      "longitude":106.2568899,
      "latitude":50.9640214
    },
    "11873":{
      "name":"\u0420\u044b\u0431\u0437\u0430\u0432\u043e\u0434",
      "longitude":106.2974508,
      "latitude":51.1056215
    },
    "11874":{
      "name":"\u0414\u044d\u0431\u044d\u043d",
      "longitude":106.3091287,
      "latitude":50.7476336
    },
    "11875":{
      "name":"\u0426\u0430\u0439\u0434\u0430\u043c",
      "longitude":106.3606141,
      "latitude":51.1014194
    },
    "11876":{
      "name":"\u0421\u0443\u0434\u0436\u0430",
      "longitude":106.409247,
      "latitude":50.4676251
    },
    "11877":{
      "name":"\u0417\u0430\u043e\u0437\u0451\u0440\u043d\u044b\u0439",
      "longitude":106.4483999,
      "latitude":51.3229645
    },
    "11878":{
      "name":"\u0411\u043e\u0440\u043a\u0438",
      "longitude":106.474922,
      "latitude":52.156113
    },
    "11879":{
      "name":"\u041a\u0430\u043b\u0438\u043d\u0438\u0448\u043d\u0430",
      "longitude":106.487167,
      "latitude":50.653233
    },
    "11880":{
      "name":"\u041c\u0443\u0440\u0437\u0438\u043d\u043e",
      "longitude":106.489098,
      "latitude":52.186508
    },
    "11881":{
      "name":"\u0417\u0430\u0433\u0443\u0441\u0442\u0430\u0439",
      "longitude":106.489365,
      "latitude":51.325954
    },
    "11882":{
      "name":"\u0415\u043d\u0445\u043e\u0440",
      "longitude":106.4969048,
      "latitude":50.9866289
    },
    "11883":{
      "name":"\u041c\u0430\u043b\u043e\u0435 \u041a\u043e\u043b\u0435\u0441\u043e\u0432\u043e",
      "longitude":106.542473,
      "latitude":52.124516
    },
    "11884":{
      "name":"\u041f\u043e\u043b\u0435\u0432\u043e\u0439",
      "longitude":106.562607,
      "latitude":52.0548332
    },
    "11885":{
      "name":"\u0410\u0440\u0434\u0430\u0441\u0430\u043d",
      "longitude":106.5742635,
      "latitude":51.4378727
    },
    "11886":{
      "name":"\u0411\u0443\u043b\u0430\u043a",
      "longitude":106.5763102,
      "latitude":51.3102368
    },
    "11887":{
      "name":"\u0421\u0443\u043b\u044c\u0444\u0430\u0442",
      "longitude":106.58242,
      "latitude":51.371201
    },
    "11888":{
      "name":"\u0417\u0430\u043a\u0430\u043b\u0442\u0443\u0441",
      "longitude":106.590744,
      "latitude":52.017712
    },
    "11889":{
      "name":"\u041a\u0430\u0440\u0433\u0438\u043d\u043e",
      "longitude":106.5989,
      "latitude":52.08247
    },
    "11890":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u0414\u0435\u0440\u0435\u0432\u043d\u044f",
      "longitude":106.604248,
      "latitude":52.166294
    },
    "11891":{
      "name":"\u0416\u0438\u043b\u0438\u043d\u043e",
      "longitude":106.60817,
      "latitude":52.143757
    },
    "11892":{
      "name":"\u0411\u0443\u0440\u0433\u0430\u0441\u0442\u0430\u0439",
      "longitude":106.6193103,
      "latitude":51.1549097
    },
    "11893":{
      "name":"\u041f\u043e\u0432\u043e\u0440\u043e\u0442",
      "longitude":106.623352,
      "latitude":50.921337
    },
    "11894":{
      "name":"\u0411\u0443\u0440\u0434\u0443\u043d\u044b",
      "longitude":106.630432,
      "latitude":50.404163
    },
    "11895":{
      "name":"\u0425\u0430\u0440\u044c\u044f\u0441\u0442\u0430",
      "longitude":106.63813,
      "latitude":50.720806
    },
    "11896":{
      "name":"\u0420\u043e\u043c\u0430\u043d\u043e\u0432\u043e",
      "longitude":106.663185,
      "latitude":52.110119
    },
    "11897":{
      "name":"\u0428\u0435\u0440\u0430\u0448\u043e\u0432\u043e",
      "longitude":106.697792,
      "latitude":52.256397
    },
    "11898":{
      "name":"\u0425\u0430\u043d\u0434\u0430\u043b\u0430",
      "longitude":106.704033,
      "latitude":52.119949
    },
    "11899":{
      "name":"\u041d\u043e\u0432\u043e\u0434\u0435\u0441\u044f\u0442\u043d\u0438\u043a\u043e\u0432\u043e",
      "longitude":106.7089,
      "latitude":50.783302
    },
    "11900":{
      "name":"\u0411\u044b\u043a\u043e\u0432\u043e",
      "longitude":106.714378,
      "latitude":52.166252
    },
    "11901":{
      "name":"\u0421\u0440\u0435\u0434\u043d\u0438\u0439 \u0423\u0431\u0443\u043a\u0443\u043d",
      "longitude":106.724846,
      "latitude":51.461712
    },
    "11902":{
      "name":"\u0418\u043d\u043a\u0438\u043d\u043e",
      "longitude":106.738068,
      "latitude":52.287975
    },
    "11903":{
      "name":"\u0424\u043e\u0444\u043e\u043d\u043e\u0432\u043e",
      "longitude":106.757515,
      "latitude":52.053116
    },
    "11904":{
      "name":"\u0414\u0443\u0431\u0438\u043d\u0438\u043d\u043e",
      "longitude":106.768303,
      "latitude":52.30302
    },
    "11905":{
      "name":"\u0423\u0431\u0443\u043a\u0443\u043d",
      "longitude":106.8524693,
      "latitude":51.5006804
    },
    "11906":{
      "name":"\u041a\u0443\u0440\u043e\u0440\u0442 \u041a\u0438\u0440\u0430\u043d",
      "longitude":106.855835,
      "latitude":50.329044
    },
    "11907":{
      "name":"\u0425\u0430\u0440\u043b\u0443\u043d",
      "longitude":106.875183,
      "latitude":50.599094
    },
    "11908":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u044c\u0441\u043a",
      "longitude":106.876892,
      "latitude":52.070313
    },
    "11909":{
      "name":"\u0414\u0443\u043b\u0430\u043d",
      "longitude":106.879501,
      "latitude":52.373718
    },
    "11910":{
      "name":"\u0425\u0438\u043b\u0433\u0430\u043d\u0442\u0443\u0439",
      "longitude":106.886116,
      "latitude":50.43578
    },
    "11911":{
      "name":"\u0417\u0430\u043b\u0430\u043d",
      "longitude":106.8902753,
      "latitude":51.0702565
    },
    "11912":{
      "name":"\u041c\u044d\u043d\u0433\u044d\u0439",
      "longitude":106.9219919,
      "latitude":51.0046813
    },
    "11913":{
      "name":"\u0414\u044d\u0431\u044d\u043d",
      "longitude":106.939255,
      "latitude":50.565449
    },
    "11914":{
      "name":"\u0422\u0430\u0440\u0430\u043a\u0430\u043d\u043e\u0432\u043a\u0430",
      "longitude":106.959457,
      "latitude":52.073048
    },
    "11915":{
      "name":"\u0422\u0443\u0445\u0443\u043c",
      "longitude":106.9607445,
      "latitude":50.9541009
    },
    "11916":{
      "name":"\u041d\u043e\u0432\u044b\u0439 \u042d\u043d\u0445\u044d\u043b\u0443\u043a",
      "longitude":106.968124,
      "latitude":52.483749
    },
    "11917":{
      "name":"\u0413\u0438\u043b\u044c\u0431\u0438\u0440\u0430",
      "longitude":106.970848,
      "latitude":51.583202
    },
    "11918":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0435 \u041c\u0443\u0440\u043e\u0447\u0438",
      "longitude":106.9807927,
      "latitude":50.2503863
    },
    "11919":{
      "name":"\u042d\u043d\u0445\u0430\u043b\u0443\u043a",
      "longitude":106.9944407,
      "latitude":52.4970702
    },
    "11920":{
      "name":"\u0411\u0430\u0440\u0443\u043d-\u041e\u0440\u043e\u043d\u0433\u043e\u0439",
      "longitude":107.017113,
      "latitude":51.500885
    },
    "11921":{
      "name":"\u041a\u0438\u0431\u0430\u043b\u0438\u043d\u043e",
      "longitude":107.019562,
      "latitude":51.420845
    },
    "11922":{
      "name":"\u041e\u0440\u043e\u043d\u0433\u043e\u0439",
      "longitude":107.0240778,
      "latitude":51.530604
    },
    "11923":{
      "name":"\u041f\u043e\u043b\u043a\u0430\u043d\u043e\u0432\u043e",
      "longitude":107.036942,
      "latitude":50.31081
    },
    "11924":{
      "name":"\u0427\u0435\u0440\u043d\u043e\u044f\u0440\u043e\u0432\u043e",
      "longitude":107.0563599,
      "latitude":50.9093918
    },
    "11925":{
      "name":"\u0421\u0442\u0430\u0440\u044b\u0435 \u041a\u043b\u044e\u0447\u0438",
      "longitude":107.079689,
      "latitude":50.55904
    },
    "11926":{
      "name":"\u0417\u0443\u043d-\u041e\u0440\u043e\u043d\u0433\u043e\u0439",
      "longitude":107.110703,
      "latitude":51.510494
    },
    "11927":{
      "name":"\u042e\u0433\u043e\u0432\u043e",
      "longitude":107.113129,
      "latitude":52.123421
    },
    "11928":{
      "name":"\u041d\u0438\u0436\u043d\u0438\u0439 \u041c\u0430\u043d\u0433\u0438\u0440\u0442\u0443\u0439",
      "longitude":107.1668373,
      "latitude":50.6802663
    },
    "11929":{
      "name":"\u0422\u0440\u043e\u0438\u0446\u043a\u043e\u0435",
      "longitude":107.1804418,
      "latitude":52.1188641
    },
    "11930":{
      "name":"\u0413\u0430\u043d\u0437\u0443\u0440\u0438\u043d\u043e",
      "longitude":107.187523,
      "latitude":51.515285
    },
    "11931":{
      "name":"\u041b\u0435\u0441\u043e\u0432\u043e\u0437\u043d\u044b\u0439",
      "longitude":107.2488726,
      "latitude":52.116302
    },
    "11932":{
      "name":"\u0425\u0430\u044f\u043d",
      "longitude":107.298531,
      "latitude":50.614624
    },
    "11933":{
      "name":"\u0421\u0435\u043c\u0451\u043d\u043e\u0432\u043a\u0430",
      "longitude":107.347519,
      "latitude":50.157349
    },
    "11934":{
      "name":"\u041a\u0430\u0440\u0434\u043e\u043d",
      "longitude":107.3704908,
      "latitude":51.603292
    },
    "11935":{
      "name":"\u0413\u0430\u0448\u0435\u0439",
      "longitude":107.371536,
      "latitude":51.038345
    },
    "11936":{
      "name":"\u0423\u043b\u0430\u043d-\u0418\u0432\u043e\u043b\u0433\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":107.373772,
      "latitude":51.775795
    },
    "11937":{
      "name":"\u0422\u0430\u043f\u0445\u0430\u0440",
      "longitude":107.378014,
      "latitude":51.730129
    },
    "11938":{
      "name":"\u0411\u0443\u0440\u043d\u0430\u0448\u0435\u0432\u043e",
      "longitude":107.387634,
      "latitude":51.426075
    },
    "11939":{
      "name":"\u0421\u0435\u043b\u0435\u043d\u0433\u0430",
      "longitude":107.412239,
      "latitude":51.631927
    },
    "11940":{
      "name":"\u0425\u0430\u0440\u0430-\u0428\u0438\u0431\u0438\u0440\u044c",
      "longitude":108.452759,
      "latitude":52.0714
    },
    "11941":{
      "name":"\u0421\u0430\u0440\u0430\u0442\u043e\u0432\u043a\u0430",
      "longitude":107.4234072,
      "latitude":51.6530498
    },
    "11942":{
      "name":"\u0425\u0430\u043c\u043d\u0438\u0433\u0430\u0434\u0430\u0439",
      "longitude":107.4308455,
      "latitude":50.1814691
    },
    "11943":{
      "name":"\u0417\u0430\u043d\u0434\u0438\u043d",
      "longitude":107.431702,
      "latitude":51.070744
    },
    "11944":{
      "name":"\u0410\u0440\u0430-\u041a\u0438\u0440\u0435\u0442\u044c",
      "longitude":107.432495,
      "latitude":50.593246
    },
    "11945":{
      "name":"\u0421\u0430\u044f\u043d\u0442\u0443\u0439",
      "longitude":107.4462804,
      "latitude":51.6895725
    },
    "11946":{
      "name":"\u041f\u0435\u0440\u0432\u043e\u043c\u0430\u0439\u0441\u043a\u043e\u0435",
      "longitude":107.450294,
      "latitude":50.11639
    },
    "11947":{
      "name":"\u041e\u0441\u0442\u0440\u043e\u0433",
      "longitude":107.463966,
      "latitude":52.154205
    },
    "11948":{
      "name":"\u0426\u0430\u0433\u0430\u043d-\u0427\u0435\u043b\u0443\u0442\u0430\u0439",
      "longitude":107.470772,
      "latitude":49.992817
    },
    "11949":{
      "name":"\u0421\u0443\u0436\u0430 \u0421\u0435\u0432\u0435\u0440\u043d\u0430\u044f",
      "longitude":107.4923313,
      "latitude":51.7875764
    },
    "11950":{
      "name":"\u0421\u0443\u0445\u043e\u0439 \u0420\u0443\u0447\u0435\u0439",
      "longitude":107.500961,
      "latitude":50.548569
    },
    "11951":{
      "name":"\u0411\u0443\u0440\u0434\u0443\u043a\u043e\u0432\u043e",
      "longitude":107.512222,
      "latitude":52.090405
    },
    "11952":{
      "name":"\u041a\u0443\u0433\u043e\u0442\u044b",
      "longitude":107.518992,
      "latitude":51.0374264
    },
    "11953":{
      "name":"\u041b\u0438\u0441\u0442\u0432\u0435\u043d\u043d\u0438\u0447\u043d\u043e\u0435",
      "longitude":107.530807,
      "latitude":52.167614
    },
    "11954":{
      "name":"\u0410\u043b\u0442\u0430\u0447\u0435\u0439",
      "longitude":107.538376,
      "latitude":50.710106
    },
    "11955":{
      "name":"\u041a\u043b\u043e\u0447\u043d\u0435\u0432\u043e",
      "longitude":107.556122,
      "latitude":52.179874
    },
    "11956":{
      "name":"\u0410\u043d\u0430\u0433\u0443\u0441\u0442\u0430\u0439",
      "longitude":107.578705,
      "latitude":49.987469
    },
    "11957":{
      "name":"\u0417\u0430\u0441\u0443\u0445\u0438\u043d\u043e",
      "longitude":107.601654,
      "latitude":52.198818
    },
    "11958":{
      "name":"\u0425\u0430\u0440\u044c\u044f\u0441\u0442\u043a\u0430",
      "longitude":107.6578668,
      "latitude":51.2524882
    },
    "11959":{
      "name":"\u0425\u0430\u043b\u0437\u0430\u043d\u043e\u0432\u043e",
      "longitude":107.674889,
      "latitude":52.225777
    },
    "11960":{
      "name":"\u0411\u0443\u0440\u043b\u044f",
      "longitude":107.7502946,
      "latitude":52.355382
    },
    "11961":{
      "name":"\u0414\u0430\u0431\u0430\u0442\u0430",
      "longitude":107.846581,
      "latitude":51.904041
    },
    "11962":{
      "name":"\u0411\u0430\u0442\u0443\u0440\u0438\u043d\u043e",
      "longitude":107.8577835,
      "latitude":52.3355902
    },
    "11963":{
      "name":"\u0410\u043d\u0433\u0438\u0440",
      "longitude":107.8638856,
      "latitude":52.2727547
    },
    "11964":{
      "name":"\u041b\u0435\u0441\u043d\u043e\u0439",
      "longitude":107.8970196,
      "latitude":51.717589
    },
    "11965":{
      "name":"\u0413\u0443\u0440\u0443\u043b\u0435\u0432\u043e",
      "longitude":107.9236339,
      "latitude":52.4033198
    },
    "11966":{
      "name":"\u041d\u0430\u0440\u044b\u043d-\u0428\u0438\u0431\u0438\u0440\u044c",
      "longitude":107.929886,
      "latitude":51.927307
    },
    "11967":{
      "name":"\u0423\u0441\u0442\u044c-\u0417\u0430\u0433\u0430\u043d",
      "longitude":107.933617,
      "latitude":50.693653
    },
    "11968":{
      "name":"\u0414\u0430\u0431\u0430\u0442\u0443\u0439",
      "longitude":107.94622,
      "latitude":50.802216
    },
    "11969":{
      "name":"\u041e\u0437\u0451\u0440\u043d\u044b\u0439",
      "longitude":107.9679127,
      "latitude":51.8940134
    },
    "11970":{
      "name":"\u041e\u043d\u043e\u0445\u043e\u0439-\u0428\u0438\u0431\u0438\u0440\u044c",
      "longitude":108.019173,
      "latitude":51.976372
    },
    "11971":{
      "name":"\u0410\u0442\u0445\u0430\u0442\u0430\u0439",
      "longitude":108.048615,
      "latitude":51.538177
    },
    "11972":{
      "name":"\u0410\u043c\u0430\u0433\u0430\u043b\u0430\u043d\u0442\u0443\u0439",
      "longitude":108.050056,
      "latitude":50.825489
    },
    "11973":{
      "name":"\u0421\u0442\u0430\u0440\u044b\u0439 \u041e\u043d\u043e\u0445\u043e\u0439",
      "longitude":108.0511659,
      "latitude":51.9393156
    },
    "11974":{
      "name":"\u0422\u043e\u0434\u043e\u0433\u0442\u043e",
      "longitude":108.052582,
      "latitude":51.846378
    },
    "11975":{
      "name":"\u0427\u0435\u0440\u0451\u043c\u0443\u0448\u043a\u0430",
      "longitude":108.099091,
      "latitude":52.754894
    },
    "11976":{
      "name":"\u041d\u043e\u0432\u043e\u0441\u043f\u0430\u0441\u0441\u043a",
      "longitude":108.1222752,
      "latitude":51.2730988
    },
    "11977":{
      "name":"\u0438\u043c\u0435\u043d\u0438 \u0421\u0435\u0440\u043e\u0432\u0430",
      "longitude":108.131584,
      "latitude":51.926968
    },
    "11978":{
      "name":"\u0414\u043e\u0431\u043e-\u0415\u043d\u0445\u043e\u0440",
      "longitude":108.1597621,
      "latitude":52.0035653
    },
    "11979":{
      "name":"\u0421\u0442\u0435\u043f\u043d\u043e\u0439",
      "longitude":108.216835,
      "latitude":51.219856
    },
    "11980":{
      "name":"\u0428\u0438\u043d\u0435\u0441\u0442\u0443\u0439",
      "longitude":108.238289,
      "latitude":51.342644
    },
    "11981":{
      "name":"\u0425\u043e\u0442\u043e\u0433\u043e\u0440",
      "longitude":108.278358,
      "latitude":52.047039
    },
    "11982":{
      "name":"\u0428\u0443\u043b\u0443\u0442\u0430",
      "longitude":108.370529,
      "latitude":52.083904
    },
    "11983":{
      "name":"\u0422\u0430\u0440\u0431\u0430\u0433\u0430\u0442\u0430\u0439\u043a\u0430",
      "longitude":108.413536,
      "latitude":51.604321
    },
    "11984":{
      "name":"\u041f\u0435\u0442\u0440\u043e\u043f\u0430\u0432\u043b\u043e\u0432\u043a\u0430",
      "longitude":108.485504,
      "latitude":52.041405
    },
    "11985":{
      "name":"\u0428\u044d\u043d\u044d-\u0411\u0443\u0441\u0430",
      "longitude":108.49826,
      "latitude":51.737156
    },
    "11986":{
      "name":"\u0421\u0432\u044f\u0442\u043e\u0439 \u041d\u043e\u0441",
      "longitude":108.524567,
      "latitude":53.497173
    },
    "11987":{
      "name":"\u0423\u0448\u043a\u0430\u043d\u044c\u0438 \u043e\u0441\u0442\u0440\u043e\u0432\u0430",
      "longitude":108.601067,
      "latitude":53.852192
    },
    "11988":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u042f\u0440",
      "longitude":108.6119,
      "latitude":52.208908
    },
    "11989":{
      "name":"\u0414\u043e\u0434\u043e-\u0413\u043e\u043b",
      "longitude":108.7318005,
      "latitude":52.0007059
    },
    "11990":{
      "name":"\u0414\u044d\u0434\u044d-\u0422\u0430\u043b\u0430",
      "longitude":108.794357,
      "latitude":51.585747
    },
    "11991":{
      "name":"\u041b\u0435\u0441\u043e\u0437\u0430\u0432\u043e\u0434\u0441\u043a\u043e\u0439",
      "longitude":108.799446,
      "latitude":51.575596
    },
    "11992":{
      "name":"\u041c\u0443\u0445\u043e\u0440-\u0422\u0430\u043b\u0430",
      "longitude":108.811523,
      "latitude":51.755127
    },
    "11993":{
      "name":"\u041a\u043e\u0441\u0430",
      "longitude":108.866667,
      "latitude":54.783333
    },
    "11994":{
      "name":"\u041a\u0438\u0436\u0430",
      "longitude":108.885178,
      "latitude":51.457695
    },
    "11995":{
      "name":"\u041c\u043e\u043d\u0430\u0445\u043e\u0432\u043e",
      "longitude":109.006493,
      "latitude":53.669369
    },
    "11996":{
      "name":"\u041a\u0430\u0442\u0443\u043d\u044c",
      "longitude":109.024239,
      "latitude":53.677116
    },
    "11997":{
      "name":"\u041a\u0443\u0440\u0431\u0443\u043b\u0438\u043a",
      "longitude":109.0409005,
      "latitude":53.7050899
    },
    "11998":{
      "name":"\u041c\u043e\u0433\u043e\u0439",
      "longitude":109.115849,
      "latitude":52.4604134
    },
    "11999":{
      "name":"\u0425\u0430\u043d\u0434\u0430\u0433\u0430\u0439",
      "longitude":109.1248668,
      "latitude":52.0101333
    },
    "12000":{
      "name":"\u0422\u0430\u0440\u0431\u0430\u0433\u0430\u0442\u0430\u0439",
      "longitude":109.2002131,
      "latitude":52.1131056
    },
    "12001":{
      "name":"\u041e\u0439\u0431\u043e\u043d\u0442",
      "longitude":109.2084397,
      "latitude":52.4983249
    },
    "12002":{
      "name":"\u0427\u0438\u0432\u044b\u0440\u043a\u0443\u0439",
      "longitude":109.220253,
      "latitude":53.825352
    },
    "12003":{
      "name":"\u0413\u0443\u0441\u0438\u0445\u0430",
      "longitude":109.262703,
      "latitude":53.431034
    },
    "12004":{
      "name":"\u0422\u0430\u0440\u0431\u0430\u0433\u0430\u0442\u0430\u0439",
      "longitude":109.281387,
      "latitude":51.758305
    },
    "12005":{
      "name":"\u041d\u0430\u0440\u044b\u043d",
      "longitude":109.3114842,
      "latitude":52.0787209
    },
    "12006":{
      "name":"\u0417\u043e\u0440\u0438\u043d\u043e",
      "longitude":109.365364,
      "latitude":53.508732
    },
    "12007":{
      "name":"\u0416\u0443\u0440\u0430\u0432\u043b\u0438\u0445\u0430",
      "longitude":109.379959,
      "latitude":53.518948
    },
    "12008":{
      "name":"\u041a\u0443\u043e\u0440\u043a\u0430",
      "longitude":109.453224,
      "latitude":51.565628
    },
    "12009":{
      "name":"\u0414\u0430\u0432\u0448\u0430",
      "longitude":109.50502,
      "latitude":54.354969
    },
    "12010":{
      "name":"\u041c\u0430\u043b\u0430\u044f \u041a\u0443\u0440\u0431\u0430",
      "longitude":109.5179328,
      "latitude":52.6531449
    },
    "12011":{
      "name":"\u041e\u0440\u043e\u0442",
      "longitude":109.645958,
      "latitude":51.902046
    },
    "12012":{
      "name":"\u0428\u0430\u043f\u0435\u043d\u044c\u043a\u043e\u0432\u043e",
      "longitude":109.646225,
      "latitude":53.566414
    },
    "12013":{
      "name":"\u041d\u0435\u0441\u0442\u0435\u0440\u0438\u0445\u0430",
      "longitude":109.710335,
      "latitude":53.647678
    },
    "12014":{
      "name":"\u0422\u043e\u043c\u043f\u0430",
      "longitude":109.7281309,
      "latitude":55.1330394
    },
    "12015":{
      "name":"\u041b\u0435\u043e\u043d\u043e\u0432\u043a\u0430",
      "longitude":109.73661,
      "latitude":51.748627
    },
    "12016":{
      "name":"\u0410\u043d\u0438\u043d\u0441\u043a",
      "longitude":109.8435701,
      "latitude":52.1961583
    },
    "12017":{
      "name":"\u041c\u0430\u043b\u043e\u0435 \u0423\u0440\u043e",
      "longitude":109.844955,
      "latitude":53.528339
    },
    "12018":{
      "name":"\u0423\u0448\u0445\u0430\u0439\u0442\u0430",
      "longitude":109.847733,
      "latitude":51.817741
    },
    "12019":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u042f\u0440",
      "longitude":109.900665,
      "latitude":51.920181
    },
    "12020":{
      "name":"\u042f\u0440\u0438\u043a\u0442\u0430",
      "longitude":109.991539,
      "latitude":53.9147
    },
    "12021":{
      "name":"\u041c\u0430\u0439\u043b\u0430",
      "longitude":110.003792,
      "latitude":52.507019
    },
    "12022":{
      "name":"\u0411\u0430\u0445\u043b\u0430\u0439\u0442\u0430",
      "longitude":110.032074,
      "latitude":51.788193
    },
    "12023":{
      "name":"\u0425\u0430\u0440\u0430-\u0423\u0441\u0443\u043d",
      "longitude":110.121513,
      "latitude":53.803982
    },
    "12024":{
      "name":"\u0421\u043e\u0451\u043b",
      "longitude":110.19574,
      "latitude":53.854805
    },
    "12025":{
      "name":"\u0413\u0430\u043b\u0433\u0430\u0442\u0430\u0439",
      "longitude":110.2198701,
      "latitude":54.1982742
    },
    "12026":{
      "name":"\u0425\u043e\u043d\u0445\u0438\u043d\u043e",
      "longitude":110.222878,
      "latitude":54.233227
    },
    "12027":{
      "name":"\u0410\u0440\u0431\u0443\u043d",
      "longitude":110.274467,
      "latitude":54.199024
    },
    "12028":{
      "name":"\u041c\u0443\u0440\u0433\u0443\u043d",
      "longitude":110.3323083,
      "latitude":54.2622003
    },
    "12029":{
      "name":"\u0414\u0437\u0435\u043b\u0438\u043d\u0434\u0430",
      "longitude":110.33638,
      "latitude":55.9354025
    },
    "12030":{
      "name":"\u0423\u0440\u0436\u0438\u043b",
      "longitude":110.348297,
      "latitude":53.828884
    },
    "12031":{
      "name":"\u0423\u043d\u044d\u0433\u044d\u0442\u044d\u0439",
      "longitude":110.3837374,
      "latitude":54.2042564
    },
    "12032":{
      "name":"\u0437\u0430\u0438\u043c\u043a\u0430 \u0425\u0430\u043c\u043d\u0438\u0433\u0430",
      "longitude":110.4447837,
      "latitude":54.114076
    },
    "12033":{
      "name":"\u0437\u0430\u0438\u043c\u043a\u0430 \u0425\u0430\u0434\u044b\u043d \u0411\u043e\u0440\u0438",
      "longitude":110.4481458,
      "latitude":54.1060423
    },
    "12034":{
      "name":"\u0437\u0430\u0438\u043c\u043a\u0430 \u0428\u0443\u043b\u0443\u0443\u0442\u0430",
      "longitude":110.473134,
      "latitude":54.1074312
    },
    "12035":{
      "name":"\u0425\u0430\u0440\u0430\u043c\u043e\u0434\u0443\u043d",
      "longitude":110.503563,
      "latitude":54.20153
    },
    "12036":{
      "name":"\u0411\u0443\u043b\u0430\u0433",
      "longitude":110.513412,
      "latitude":54.244179
    },
    "12037":{
      "name":"\u0437\u0430\u0438\u043c\u043a\u0430 \u0423\u0440\u0442\u043e\u043d\u0445\u043e\u0439",
      "longitude":110.5257673,
      "latitude":54.1343843
    },
    "12038":{
      "name":"\u0437\u0430\u0438\u043c\u043a\u0430 \u0423\u0440\u0442\u043e\u043d\u0445\u043e\u0439 1",
      "longitude":110.5418373,
      "latitude":54.1396128
    },
    "12039":{
      "name":"\u0437\u0430\u0438\u043c\u043a\u0430 \u0423\u0441\u0442\u044c-\u0413\u0430\u0440\u0433\u0430",
      "longitude":110.5484744,
      "latitude":54.4325591
    },
    "12040":{
      "name":"\u0437\u0430\u0438\u043c\u043a\u0430 \u0423\u0440\u0442\u043e\u043d\u0445\u043e\u0439 2",
      "longitude":110.5503397,
      "latitude":54.1521071
    },
    "12041":{
      "name":"\u0422\u043e\u043c\u043e\u043a\u0442\u043e",
      "longitude":110.573845,
      "latitude":54.290272
    },
    "12042":{
      "name":"\u0437\u0430\u0438\u043c\u043a\u0430 \u0425\u0443\u0442\u043e\u0440\u0445\u043e\u0439",
      "longitude":110.5826323,
      "latitude":54.1901989
    },
    "12043":{
      "name":"\u0413\u0430\u0440\u0433\u0430",
      "longitude":110.605782,
      "latitude":54.430023
    },
    "12044":{
      "name":"\u0437\u0430\u0438\u043c\u043a\u0430 \u0418\u043b\u0438\u043a\u0447\u0438\u043d",
      "longitude":110.6238901,
      "latitude":54.1835539
    },
    "12045":{
      "name":"\u0437\u0430\u0438\u043c\u043a\u0430 \u041f\u043b\u0435\u043c\u0444\u0435\u0440\u043c\u0430",
      "longitude":110.6758404,
      "latitude":54.2210561
    },
    "12046":{
      "name":"\u0423\u0433\u043d\u0430\u0441\u0430\u0439",
      "longitude":110.67852,
      "latitude":54.500294
    },
    "12047":{
      "name":"\u0437\u0430\u0438\u043c\u043a\u0430 \u0414\u0443\u0441\u0435\u043d",
      "longitude":110.7020718,
      "latitude":54.2420688
    },
    "12048":{
      "name":"\u043d\u043f \u0412\u0435\u0440\u0445\u043d\u044f\u044f \u0410\u0440\u0433\u0430\u0434\u0430",
      "longitude":110.7102523,
      "latitude":54.2662476
    },
    "12049":{
      "name":"\u0437\u0430\u0438\u043c\u043a\u0430 \u0410\u043c\u0430\u0442\u0445\u0430\u043d",
      "longitude":110.7126359,
      "latitude":54.4068742
    },
    "12050":{
      "name":"\u0422\u0443\u043d\u0433\u044d\u043d",
      "longitude":110.778786,
      "latitude":54.329327
    },
    "12051":{
      "name":"\u041a\u0443\u0440\u043e\u0440\u0442 \u0413\u0430\u0440\u0433\u0438\u043d\u0441\u043a\u0438\u0439",
      "longitude":110.9969625,
      "latitude":54.3191176
    },
    "12052":{
      "name":"\u041a\u0443\u043b\u044c\u043a\u0438\u0441\u043e\u043d",
      "longitude":111.016289,
      "latitude":52.048996
    },
    "12053":{
      "name":"\u042f\u0433\u0434\u044b\u0433",
      "longitude":111.083374,
      "latitude":54.850182
    },
    "12054":{
      "name":"\u0422\u0430\u0437\u0430",
      "longitude":111.1615614,
      "latitude":54.8763212
    },
    "12055":{
      "name":"\u0425\u043e\u0440\u0433\u0430",
      "longitude":111.822983,
      "latitude":52.81937
    },
    "12056":{
      "name":"\u041a\u0430\u0440\u0430\u0444\u0442\u0438\u0442",
      "longitude":111.917686,
      "latitude":54.202862
    },
    "12057":{
      "name":"\u041e\u0440\u043a\u043e\u043b\u0438\u043a\u0430\u043d",
      "longitude":111.9666669,
      "latitude":56.733333
    },
    "12058":{
      "name":"\u041e\u0440\u043e\u0447\u0435\u043d",
      "longitude":112.283333,
      "latitude":55.516667
    },
    "12059":{
      "name":"\u041e\u043a\u0443\u043d\u0435\u0432\u043e",
      "longitude":112.349037,
      "latitude":54.833309
    },
    "12060":{
      "name":"\u0427\u0435\u0440\u0432\u044f\u043a",
      "longitude":112.45,
      "latitude":55.033333
    },
    "12061":{
      "name":"\u041a\u0443\u0440\u043e\u0440\u0442 \u0411\u0430\u0443\u043d\u0442",
      "longitude":112.91172,
      "latitude":55.128201
    },
    "12062":{
      "name":"\u0412\u0435\u0440\u0445\u043d\u0438\u0439 \u0426\u0438\u043f\u0438\u043a\u0430\u043d",
      "longitude":113.066849,
      "latitude":54.836136
    },
    "12063":{
      "name":"\u0411\u0430\u0443\u043d\u0442",
      "longitude":113.123428,
      "latitude":55.250668
    },
    "12064":{
      "name":"\u0422\u0440\u043e\u0438\u0446\u043a\u0438\u0439",
      "longitude":113.156799,
      "latitude":54.587391
    },
    "12065":{
      "name":"\u0423\u0441\u0442\u044c-\u0410\u043d\u0442\u043e\u0441\u0435",
      "longitude":113.197182,
      "latitude":53.964172
    },
    "12066":{
      "name":"\u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u0441\u043a\u0438\u0439",
      "longitude":113.2,
      "latitude":55.016667
    },
    "12067":{
      "name":"\u041d\u0430\u0433\u043e\u0440\u043d\u044b\u0439",
      "longitude":113.316667,
      "latitude":54.95
    },
    "12068":{
      "name":"\u0421\u043e\u043b\u043e\u0432\u044c\u0451\u0432\u0441\u043a\u0438\u0439",
      "longitude":113.35,
      "latitude":54.95
    },
    "12069":{
      "name":"\u0411\u0443\u0441\u0430\u043d\u0438",
      "longitude":113.552376,
      "latitude":55.355125
    },
    "12070":{
      "name":"\u0411\u0430\u0439\u0441\u0430",
      "longitude":113.587959,
      "latitude":53.980415
    },
    "12071":{
      "name":"\u0422\u043e\u0440\u043c",
      "longitude":113.642395,
      "latitude":53.955681
    },
    "12072":{
      "name":"\u0411\u0443\u0433\u0443\u043d\u0434\u0430",
      "longitude":114.223038,
      "latitude":53.756111
    },
    "12073":{
      "name":"\u0422\u0430\u043b\u043e\u0439",
      "longitude":114.383333,
      "latitude":55.05
    },
    "12074":{
      "name":"\u0423\u044f",
      "longitude":114.5038906,
      "latitude":55.5840638
    },
    "12075":{
      "name":"\u0414\u0436\u0443\u043d\u043e\u043a",
      "longitude":114.683333,
      "latitude":55.633333
    },
    "12076":{
      "name":"\u0410\u043c\u0430\u0442\u043a\u0430\u043d",
      "longitude":114.966667,
      "latitude":55.683333
    },
    "12077":{
      "name":"\u0418\u0440\u0430\u043a\u0438\u043d\u0434\u0430",
      "longitude":115.192886,
      "latitude":55.929413
    },
    "12078":{
      "name":"\u0423\u0441\u0442\u044c-\u0422\u0430\u043d\u0430\u043d\u0434\u0430",
      "longitude":115.2361099,
      "latitude":54.657993
    },
    "12079":{
      "name":"\u0418\u0442\u043e\u043a\u0438\u0442",
      "longitude":115.333333,
      "latitude":55.75
    },
    "12080":{
      "name":"\u0428\u0438\u043f\u0438\u0448\u043a\u0430",
      "longitude":115.368333,
      "latitude":54.270833
    },
    "12081":{
      "name":"\u0422\u0438\u043b\u0438\u0448\u043c\u0430",
      "longitude":115.450856,
      "latitude":55.852231
    },
    "12082":{
      "name":"\u0421\u043e\u043b\u043e\u043d\u0446\u043e\u0432\u043e",
      "longitude":115.5999999,
      "latitude":54.416667
    },
    "12083":{
      "name":"\u0411\u0430\u0440\u0433\u0430\u043b\u0438\u043d\u043e",
      "longitude":115.648949,
      "latitude":56.504208
    },
    "12084":{
      "name":"\u041c\u0443\u044f",
      "longitude":115.666389,
      "latitude":56.457352
    },
    "12085":{
      "name":"\u0412\u0438\u0442\u0438\u043c",
      "longitude":115.728104,
      "latitude":56.219364
    },
    "12086":{
      "name":"\u0411\u0430\u043c\u0431\u0443\u0439\u043a\u0430",
      "longitude":115.7964651,
      "latitude":55.7882649
    },
    "12087":{
      "name":"\u041a\u0440\u0430\u0441\u043d\u044b\u0439 \u042f\u0440",
      "longitude":115.8166669,
      "latitude":55.766667
    },
    "12088":{
      "name":"\u041a\u0430\u0440\u0430\u043b\u043e\u043d",
      "longitude":115.8875,
      "latitude":57.0225
    },
    "12089":{
      "name":"\u0421\u043e\u043b\u043d\u0435\u0447\u043d\u0430\u044f",
      "longitude":108.25561738716983,
      "latitude":54.030776123669476
    },
    "12090":{
      "name":"\u0427\u0435\u0440\u043d\u0438\u043b\u044c\u0449\u0438\u043a\u043e\u0432\u043e",
      "longitude":84.7236331848494,
      "latitude":56.67296808786216
    },
    "12091":{
      "name":"\u0427\u0435\u0440\u0451\u043c\u0443\u0445\u043e\u0432\u0441\u043a\u043e\u0435",
      "longitude":73.45491765359326,
      "latitude":54.85009537166474
    },
    "12092":{
      "name":"\u0427\u0435\u0440\u0451\u043c\u0443\u0448\u043a\u0438",
      "longitude":73.40720874842397,
      "latitude":54.84409296141935
    },
    "12093":{
      "name":"\u041d\u043e\u0432\u0430\u044f \u0421\u0442\u0430\u043d\u0438\u0446\u0430",
      "longitude":73.38109731754857,
      "latitude":54.833328376565966
    }
  }
]